// React Vault App removed
window.renderVaultReactApp = function () {
  console.log('Vault is now native Vanilla JS');
};

// Set browser tab title immediately for SEO and display (Helo, not Hello)
if (typeof document !== 'undefined') {
  document.title = 'Helo - Perfect Tool';
}

console.log('👋 Helo App - Modern PM Tool');

// Check if Supabase is loaded
if (!window.supabase) {
  console.error('❌ Supabase not loaded!');
  document.getElementById('root').innerHTML = `
    <div style="
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 100vh;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      background: #f8fafc;
    ">
      <div style="text-align: center; padding: 2rem;">
        <h1 style="color: #ef4444; margin-bottom: 1rem;">❌ Supabase Not Loaded</h1>
        <p style="color: #64748b;">Please refresh the page to try again.</p>
        <button onclick="location.reload()" style="
          background: #ea580c;
          color: white;
          border: none;
          padding: 0.75rem 1.5rem;
          border-radius: 0.5rem;
          cursor: pointer;
          margin-top: 1rem;
        ">
          Refresh Page
        </button>
      </div>
    </div>
  `;
  throw new Error('Supabase not loaded');
}

// Get Supabase credentials
const SUPABASE_URL = window.EXPO_PUBLIC_SUPABASE_URL;
const SUPABASE_ANON_KEY = window.EXPO_PUBLIC_SUPABASE_ANON_KEY;

console.log('🔑 Supabase URL:', SUPABASE_URL ? 'Set' : 'Missing');
console.log('🔑 Supabase Key:', SUPABASE_ANON_KEY ? 'Set' : 'Missing');

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  console.error('❌ Missing Supabase credentials!');
  document.getElementById('root').innerHTML = `
    <div style="
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 100vh;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      background: #f8fafc;
    ">
      <div style="text-align: center; padding: 2rem;">
        <h1 style="color: #ef4444; margin-bottom: 1rem;">❌ Missing Credentials</h1>
        <p style="color: #64748b;">Supabase URL or Key is missing. Please check environment variables.</p>
      </div>
    </div>
  `;
  throw new Error('Missing Supabase credentials');
}

// Create Supabase client
// Enable detectSessionInUrl to handle password reset recovery tokens from URL hash
const supabase = window.supabase.createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true, // Enable to detect password reset tokens in URL
  },
});

console.log('✅ Supabase client created successfully');

// Avatar URL generation (mimics native app's getCachedAvatarUrl)
function getAvatarUrl(avatarPath) {
  if (!avatarPath) return null;

  try {
    // Generate public URL from Supabase Storage (same as native app)
    const { data } = supabase.storage.from('profile-photos').getPublicUrl(avatarPath);
    // Avatar URL generated (logging removed for performance)
    return data.publicUrl;
  } catch (error) {
    console.error('Error getting avatar URL:', error);
    return null;
  }
}

function getAvatarBackgroundColor(name) {
  const colors = [
    '#EF4444', '#F97316', '#F59E0B', '#EAB308', '#84CC16',
    '#22C55E', '#10B981', '#14B8A6', '#06B6D4', '#3B82F6',
    '#6366F1', '#8B5CF6', '#A855F7', '#EC4899', '#F43F5E'
  ];

  if (!name || name.length === 0) {
    return colors[0];
  }

  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return colors[Math.abs(hash) % colors.length];
}

// Format date in local timezone (fixes timezone issues where dates show a day behind)
function formatDateLocal(dateString, options = { month: 'numeric', day: 'numeric', year: 'numeric' }) {
  if (!dateString) return null;

  try {
    // If it's already a Date object, use it
    let date;
    if (dateString instanceof Date) {
      date = dateString;
    } else {
      // Parse date string - handle both ISO format (2025-12-20) and full timestamps
      const dateStr = dateString.toString().trim();

      // If it's a date-only string (YYYY-MM-DD), parse it as local time
      // This prevents timezone issues where "2025-12-20" becomes "2025-12-19" in some timezones
      if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
        const [year, month, day] = dateStr.split('-').map(Number);
        date = new Date(year, month - 1, day); // month is 0-indexed, creates date in local timezone
      } else if (/^\d{4}-\d{2}-\d{2}T/.test(dateStr)) {
        // ISO timestamp - check if it's midnight UTC (likely a date-only value)
        const utcDate = new Date(dateStr);
        // If the time is midnight UTC (00:00:00), treat it as a date-only value
        if (utcDate.getUTCHours() === 0 && utcDate.getUTCMinutes() === 0 && utcDate.getUTCSeconds() === 0) {
          // Convert to local date (not time)
          date = new Date(utcDate.getUTCFullYear(), utcDate.getUTCMonth(), utcDate.getUTCDate());
        } else {
          // It's a real timestamp, use as-is
          date = utcDate;
        }
      } else {
        // Fallback to standard date parsing
        date = new Date(dateString);
      }
    }

    return date.toLocaleDateString('en-US', options);
  } catch (error) {
    console.error('Error formatting date:', error);
    return null;
  }
}

// Convert URLs in text to clickable links
function makeLinksClickable(text) {
  if (!text) return '';

  // URL regex pattern - matches http, https, and common URL patterns
  const urlRegex = /(https?:\/\/[^\s<>"']+|www\.[^\s<>"']+|[a-zA-Z0-9-]+\.[a-zA-Z]{2,}[^\s<>"']*)/g;

  // Split text into parts: URLs and non-URLs
  const parts = [];
  let lastIndex = 0;
  let match;

  // Find all URLs
  while ((match = urlRegex.exec(text)) !== null) {
    // Add text before the URL (escape HTML)
    if (match.index > lastIndex) {
      const beforeText = text.substring(lastIndex, match.index)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
      parts.push({ text: beforeText, isLink: false });
    }

    // Add the URL
    parts.push({ text: match[0], isLink: true });
    lastIndex = match.index + match[0].length;
  }

  // Add remaining text after the last URL (escape HTML)
  if (lastIndex < text.length) {
    const afterText = text.substring(lastIndex)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
    parts.push({ text: afterText, isLink: false });
  }

  // If no URLs found, return escaped text
  if (parts.length === 0) {
    return text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  // Build HTML with clickable links
  return parts.map(part => {
    if (part.isLink) {
      // Ensure URL has protocol
      let href = part.text;
      if (!href.startsWith('http://') && !href.startsWith('https://')) {
        href = 'https://' + href;
      }

      // Escape URL for href attribute
      const escapedHref = href
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');

      // Escape URL text for display
      const escapedText = part.text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');

      return `<a href="${escapedHref}" target="_blank" rel="noopener noreferrer" style="color: #3b82f6; text-decoration: underline; word-break: break-all;">${escapedText}</a>`;
    }
    return part.text;
  }).join('');
}

// Global state
let currentUser = null;
let currentProfile = null;
let currentCompany = null;
// Default screen - will be set based on user role
let currentScreen = 'team'; // Default to team (PM tool), CLIENTs will see 'dashboard'
let salesView = 'contacts'; // 'dashboard' or 'contacts'
let salesDealFilter = 'all'; // 'all' or 'my'
let salesProbabilityFilter = 'all'; // 'all', 'high', 'medium', 'low'
let salesStageFilter = 'all'; // 'all', 'new', 'contacted', 'qualified', etc.
let upcomingRemindersFilter = 'all'; // 'all' or 'my'
let salesDealsView = 'list'; // 'list' or 'kanban'
let reportsDateFilter = 'month'; // 'week', 'month', 'quarter', 'custom'
let reportsCustomStartDate = '';
let reportsCustomEndDate = '';
let showCustomDatePicker = false;
let dashboardRemindersCache = []; // Cache for dashboard reminders
let dashboardAppointmentsCache = []; // Cache for dashboard appointments
let dashboardCacheTimestamp = null; // Timestamp for cache invalidation
const DASHBOARD_CACHE_DURATION = 30000; // Cache for 30 seconds
let selectedChatId = null; // Currently selected chat for viewing messages
let chatMessages = []; // Messages for the selected chat
let chatSearchQuery = ''; // Search query for filtering chats
let chatUnreadCounts = {}; // Map of chat_id to unread message count
let showArchivedChats = false; // Show archived chats filter
let selectedContactId = null; // Currently selected contact ID
let contactSearchQuery = ''; // Search query for filtering contacts
window.contactSearchQuery = ''; // Make globally accessible for inline handlers
let showManageChatModal = false; // Show manage chat modal
let manageChatData = {
  chatName: '',
  selectedProject: null,
  participants: [],
  availableUsers: [],
  availableProjects: [],
  showCreateProject: false,
  newProjectName: '',
  showDeleteConfirm: false,
  deleteConfirmText: '',
  isArchived: false
};
// Make manageChatData accessible globally for inline handlers
window.manageChatData = manageChatData;
let showAddChatModal = false; // Show add chat modal
let addChatData = {
  chatName: '',
  selectedProject: null,
  selectedParticipants: [],
  participantSearchQuery: '',
  projectSearchQuery: '',
  availableProjects: [] // Store available projects
};
// Make addChatData accessible globally for inline handlers
window.addChatData = addChatData;
let salesOpportunities = [];
let resources = [];
let portfolioItems = []; // Items from portfolio_items table
let resourcesTab = 'resources'; // 'resources', 'book-now'
window.resourcesTab = resourcesTab; // Make globally accessible
let services = [];
let showBookNowModal = false;
let bookingServiceType = null; // 'WEBSITE' or 'PHOTO' or 'VIDEO'
let bookingFormData = {
  phoneNumber: '',
  email: '',
  specificService: '',
  additionalNotes: ''
};
window.bookingFormData = bookingFormData; // Make globally accessible
let showChangePasswordModal = false;
let changePasswordData = {
  currentPassword: '',
  newPassword: '',
  confirmPassword: ''
};
let clients = [];
let appointments = [];
let reminders = [];
// Vault state
let vaultFolders = [];
let vaultFiles = [];
let vaultCurrentFolderId = null;
window.vaultCurrentFolderId = null; // Sync for upload button access
window.vaultUploadTargetFolderId = null; // Captured at upload click
let vaultView = 'home'; // 'home', 'recent', 'shared', 'trash'
let vaultViewMode = 'grid'; // 'grid' or 'list'
let vaultSortBy = 'modified'; // 'name' | 'modified' | 'size'
let vaultSortDir = 'desc'; // 'asc' | 'desc'
let vaultQuickStats = {
  recent_uploads: 0,
  active_projects: 0,
  shared_by_me: 0,
  team_spaces: 0
};
let vaultBreadcrumbs = [];
window.showNewFolderModal = false;

// ============================================
// DOCUMENT WIZARD STATE
// ============================================
let docWizardOpen = false;
let docWizardStep = 1; // 1-6
let docWizardData = {
  outputFormat: null,      // 'docx' | 'pdf'
  templateCategory: null,
  templateType: null,
  templateName: null,
  audience: 'Internal Staff',
  tone: 'Formal',
  length: '2-3 pages',
  region: 'US',
  details: {},
  uploadedContent: null,
  uploadedFileName: null,
  generatedOutline: null,
  generatedContent: null,
  tags: '',
  versionNote: ''
};
let docWizardLoading = false;
let docWizardExpandedCategories = {};

// Document Wizard Template Categories
const docWizardTemplateCategories = {
  operations: {
    label: 'Operations',
    icon: 'M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2',
    templates: [
      { id: 'sop', name: 'SOP (Standard Operating Procedure)', description: 'Step-by-step process documentation' },
      { id: 'work_instructions', name: 'Work Instructions', description: 'Shorter task-specific guides' },
      { id: 'checklist', name: 'Checklist', description: 'Opening/closing, weekly tasks' },
      { id: 'training_guide', name: 'Training Guide / Onboarding', description: 'New employee training material' },
      { id: 'job_description', name: 'Role Responsibilities', description: 'Job descriptions and duties' },
      { id: 'internal_policy', name: 'Internal Policy', description: 'Attendance, dress code, etc.' },
      { id: 'incident_report', name: 'Incident Report', description: 'Document workplace incidents' },
      { id: 'meeting_agenda', name: 'Meeting Agenda + Notes', description: 'Structured meeting template' }
    ]
  },
  hr: {
    label: 'HR / People',
    icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z',
    templates: [
      { id: 'employee_handbook', name: 'Employee Handbook Section', description: 'Mini-handbook content' },
      { id: 'performance_review', name: 'Performance Review', description: 'Employee evaluation form' },
      { id: 'disciplinary', name: 'Disciplinary Write-Up', description: 'Document employee issues' },
      { id: 'time_off_policy', name: 'Time-off / Vacation Policy', description: 'Leave policies' },
      { id: 'safety_policy', name: 'Safety Policy', description: 'General workplace safety' }
    ]
  },
  customer: {
    label: 'Customer-facing',
    icon: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4',
    templates: [
      { id: 'contract', name: 'Contract / Service Agreement', description: 'Client agreements' },
      { id: 'terms_conditions', name: 'Terms and Conditions', description: 'Service terms' },
      { id: 'return_policy', name: 'Return / Refund Policy', description: 'Return handling' },
      { id: 'warranty_policy', name: 'Warranty Policy', description: 'Product warranties' },
      { id: 'privacy_policy', name: 'Privacy Policy', description: 'Basic privacy notice' },
      { id: 'intake_form', name: 'Customer Intake Form', description: 'Questionnaire template' },
      { id: 'estimate_template', name: 'Estimate / Quote', description: 'Pricing templates' },
      { id: 'preparation_guide', name: 'Preparation Guide', description: 'How to prepare for service' }
    ]
  },
  sales: {
    label: 'Sales / Marketing',
    icon: 'M13 7h8m0 0v8m0-8l-8 8-4-4-6 6',
    templates: [
      { id: 'sales_script', name: 'Sales Script', description: 'Phone/meeting scripts' },
      { id: 'proposal', name: 'Proposal', description: 'Business proposals' },
      { id: 'case_study', name: 'Case Study', description: 'Success story template' },
      { id: 'partnership', name: 'Partnership Agreement', description: 'Basic partner terms' },
      { id: 'company_overview', name: 'Company Overview', description: 'One-page about us' }
    ]
  },
  compliance: {
    label: 'Compliance / Governance',
    icon: 'M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z',
    templates: [
      { id: 'data_handling', name: 'Data Handling Policy', description: 'Customer info treatment' },
      { id: 'access_control', name: 'Access Control Policy', description: 'Who can see what' },
      { id: 'document_retention', name: 'Document Retention Policy', description: 'Record keeping rules' }
    ]
  },
  other: {
    label: 'Other',
    icon: 'M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z',
    templates: [
      { id: 'custom_chat', name: 'Custom document (chat)', description: 'Chat with AI to build any document—ask questions, get suggestions' }
    ]
  }
};

// Document Wizard Template Fields (dynamic per template)
const docWizardTemplateFields = {
  sop: [
    { id: 'business_name', label: 'Business Name', placeholder: 'Your company name', type: 'text' },
    { id: 'process_name', label: 'Process Name', placeholder: 'e.g., Customer Onboarding', type: 'text' },
    { id: 'who_performs', label: 'Who Performs This', placeholder: 'e.g., Sales team, All employees', type: 'text' },
    { id: 'tools_systems', label: 'Required Tools/Systems', placeholder: 'e.g., CRM, POS system, specific equipment', type: 'textarea' },
    { id: 'steps', label: 'Steps (main actions)', placeholder: 'List the key steps in the process...', type: 'textarea', required: true },
    { id: 'time_estimates', label: 'Time Estimates', placeholder: 'e.g., 30 minutes total, Step 1: 5 min', type: 'text' },
    { id: 'troubleshooting', label: 'What to Do If Something Goes Wrong', placeholder: 'Common issues and how to resolve them', type: 'textarea' },
    { id: 'approval_person', label: 'Approval/Contact Person', placeholder: 'Who to contact for questions', type: 'text' }
  ],
  work_instructions: [
    { id: 'business_name', label: 'Business Name', placeholder: 'Your company name', type: 'text' },
    { id: 'task_name', label: 'Task Name', placeholder: 'e.g., Processing a Return', type: 'text' },
    { id: 'steps', label: 'Step-by-Step Instructions', placeholder: 'List each step clearly...', type: 'textarea', required: true },
    { id: 'safety_notes', label: 'Safety/Quality Notes', placeholder: 'Any warnings or quality checks', type: 'textarea' }
  ],
  checklist: [
    { id: 'business_name', label: 'Business Name', placeholder: 'Your company name', type: 'text' },
    { id: 'checklist_name', label: 'Checklist Name', placeholder: 'e.g., Daily Opening Checklist', type: 'text' },
    { id: 'items', label: 'Checklist Items', placeholder: 'List all items to check...', type: 'textarea', required: true },
    { id: 'frequency', label: 'Frequency', placeholder: 'Daily, Weekly, Monthly', type: 'text' }
  ],
  training_guide: [
    { id: 'business_name', label: 'Business Name', placeholder: 'Your company name', type: 'text' },
    { id: 'role', label: 'Role/Position', placeholder: 'e.g., Customer Service Rep', type: 'text' },
    { id: 'topics', label: 'Topics to Cover', placeholder: 'List training topics...', type: 'textarea', required: true },
    { id: 'duration', label: 'Training Duration', placeholder: 'e.g., 2 weeks, 3 days', type: 'text' },
    { id: 'resources', label: 'Resources/Materials Needed', placeholder: 'What the trainee will need', type: 'textarea' }
  ],
  job_description: [
    { id: 'business_name', label: 'Business Name', placeholder: 'Your company name', type: 'text' },
    { id: 'job_title', label: 'Job Title', placeholder: 'e.g., Operations Manager', type: 'text' },
    { id: 'responsibilities', label: 'Key Responsibilities', placeholder: 'List main duties...', type: 'textarea', required: true },
    { id: 'qualifications', label: 'Qualifications', placeholder: 'Required skills, experience, education', type: 'textarea' },
    { id: 'reports_to', label: 'Reports To', placeholder: 'Direct supervisor/manager', type: 'text' }
  ],
  internal_policy: [
    { id: 'business_name', label: 'Business Name', placeholder: 'Your company name', type: 'text' },
    { id: 'policy_name', label: 'Policy Name', placeholder: 'e.g., Attendance Policy', type: 'text' },
    { id: 'applies_to', label: 'Who This Applies To', placeholder: 'All employees, specific departments', type: 'text' },
    { id: 'rules', label: 'Rules/Guidelines', placeholder: 'What is expected...', type: 'textarea', required: true },
    { id: 'consequences', label: 'Consequences for Violations', placeholder: 'What happens if policy is broken', type: 'textarea' },
    { id: 'exceptions', label: 'Exceptions', placeholder: 'Any special cases', type: 'textarea' }
  ],
  incident_report: [
    { id: 'business_name', label: 'Business Name', placeholder: 'Your company name', type: 'text' },
    { id: 'incident_types', label: 'Types of Incidents Covered', placeholder: 'Workplace injuries, customer complaints, etc.', type: 'textarea' },
    { id: 'required_info', label: 'Information to Collect', placeholder: 'Date, time, witnesses, description, etc.', type: 'textarea', required: true },
    { id: 'reporting_process', label: 'Reporting Process', placeholder: 'Who to notify, timeline', type: 'textarea' }
  ],
  meeting_agenda: [
    { id: 'business_name', label: 'Business Name', placeholder: 'Your company name', type: 'text' },
    { id: 'meeting_type', label: 'Meeting Type', placeholder: 'e.g., Weekly Team Meeting', type: 'text' },
    { id: 'topics', label: 'Standard Topics', placeholder: 'List recurring agenda items...', type: 'textarea', required: true },
    { id: 'duration', label: 'Meeting Duration', placeholder: 'e.g., 30 minutes, 1 hour', type: 'text' }
  ],
  employee_handbook: [
    { id: 'business_name', label: 'Business Name', placeholder: 'Your company name', type: 'text' },
    { id: 'section_topic', label: 'Handbook Section Topic', placeholder: 'e.g., Code of Conduct', type: 'text' },
    { id: 'content', label: 'Key Points to Include', placeholder: 'What should this section cover...', type: 'textarea', required: true },
    { id: 'company_values', label: 'Company Values/Culture', placeholder: 'Core values to reflect', type: 'textarea' }
  ],
  performance_review: [
    { id: 'business_name', label: 'Business Name', placeholder: 'Your company name', type: 'text' },
    { id: 'review_type', label: 'Review Type', placeholder: 'Annual, Quarterly, Probation', type: 'text' },
    { id: 'criteria', label: 'Evaluation Criteria', placeholder: 'What will be assessed...', type: 'textarea', required: true },
    { id: 'rating_scale', label: 'Rating Scale', placeholder: 'e.g., 1-5, Exceeds/Meets/Needs Improvement', type: 'text' }
  ],
  disciplinary: [
    { id: 'business_name', label: 'Business Name', placeholder: 'Your company name', type: 'text' },
    { id: 'violation_types', label: 'Types of Violations', placeholder: 'Attendance, conduct, performance', type: 'textarea' },
    { id: 'progressive_steps', label: 'Progressive Discipline Steps', placeholder: 'Verbal warning, written, suspension, termination', type: 'textarea', required: true }
  ],
  time_off_policy: [
    { id: 'business_name', label: 'Business Name', placeholder: 'Your company name', type: 'text' },
    { id: 'pto_types', label: 'Types of Time Off', placeholder: 'Vacation, sick, personal, holiday', type: 'textarea', required: true },
    { id: 'accrual', label: 'Accrual/Allowance', placeholder: 'How PTO is earned or given', type: 'textarea' },
    { id: 'request_process', label: 'Request Process', placeholder: 'How to request time off', type: 'textarea' }
  ],
  safety_policy: [
    { id: 'business_name', label: 'Business Name', placeholder: 'Your company name', type: 'text' },
    { id: 'hazards', label: 'Workplace Hazards', placeholder: 'Potential risks in your workplace', type: 'textarea' },
    { id: 'safety_rules', label: 'Safety Rules', placeholder: 'Required safety practices...', type: 'textarea', required: true },
    { id: 'emergency_procedures', label: 'Emergency Procedures', placeholder: 'What to do in an emergency', type: 'textarea' }
  ],
  contract: [
    { id: 'business_name', label: 'Business Name', placeholder: 'Your company name', type: 'text' },
    { id: 'service_type', label: 'Type of Service', placeholder: 'What services you provide', type: 'text' },
    { id: 'scope', label: 'Scope of Work', placeholder: 'What is included in the service...', type: 'textarea', required: true },
    { id: 'payment_terms', label: 'Payment Terms', placeholder: 'Pricing, due dates, methods', type: 'textarea' },
    { id: 'cancellation', label: 'Cancellation Policy', placeholder: 'How contracts can be ended', type: 'textarea' },
    { id: 'liability', label: 'Liability/Disclaimers', placeholder: 'Any limitations of liability', type: 'textarea' }
  ],
  terms_conditions: [
    { id: 'business_name', label: 'Business Name', placeholder: 'Your company name', type: 'text' },
    { id: 'service_description', label: 'Service/Product Description', placeholder: 'What you offer', type: 'textarea' },
    { id: 'user_obligations', label: 'Customer Obligations', placeholder: 'What customers must agree to', type: 'textarea', required: true },
    { id: 'limitations', label: 'Limitations', placeholder: 'Service limitations, disclaimers', type: 'textarea' }
  ],
  return_policy: [
    { id: 'business_name', label: 'Business Name', placeholder: 'Your company name', type: 'text' },
    { id: 'return_window', label: 'Return Window', placeholder: 'e.g., 30 days, 14 days', type: 'text' },
    { id: 'conditions', label: 'Return Conditions', placeholder: 'What qualifies for return...', type: 'textarea', required: true },
    { id: 'refund_method', label: 'Refund Method', placeholder: 'Original payment, store credit, exchange', type: 'text' }
  ],
  warranty_policy: [
    { id: 'business_name', label: 'Business Name', placeholder: 'Your company name', type: 'text' },
    { id: 'warranty_period', label: 'Warranty Period', placeholder: 'e.g., 1 year, 90 days', type: 'text' },
    { id: 'coverage', label: 'What Is Covered', placeholder: 'Defects, workmanship, etc.', type: 'textarea', required: true },
    { id: 'exclusions', label: 'Exclusions', placeholder: 'What is NOT covered', type: 'textarea' },
    { id: 'claim_process', label: 'Claim Process', placeholder: 'How to make a warranty claim', type: 'textarea' }
  ],
  privacy_policy: [
    { id: 'business_name', label: 'Business Name', placeholder: 'Your company name', type: 'text' },
    { id: 'data_collected', label: 'Data Collected', placeholder: 'What information you collect', type: 'textarea', required: true },
    { id: 'data_use', label: 'How Data Is Used', placeholder: 'Purpose of collecting data', type: 'textarea' },
    { id: 'data_sharing', label: 'Data Sharing', placeholder: 'Who data is shared with', type: 'textarea' }
  ],
  intake_form: [
    { id: 'business_name', label: 'Business Name', placeholder: 'Your company name', type: 'text' },
    { id: 'service_type', label: 'Service Type', placeholder: 'What service this intake is for', type: 'text' },
    { id: 'questions', label: 'Questions to Ask', placeholder: 'List all questions for the customer...', type: 'textarea', required: true }
  ],
  estimate_template: [
    { id: 'business_name', label: 'Business Name', placeholder: 'Your company name', type: 'text' },
    { id: 'service_type', label: 'Service Type', placeholder: 'What you are quoting for', type: 'text' },
    { id: 'line_items', label: 'Typical Line Items', placeholder: 'Labor, materials, fees to include', type: 'textarea', required: true },
    { id: 'validity', label: 'Quote Validity', placeholder: 'How long the quote is valid', type: 'text' }
  ],
  preparation_guide: [
    { id: 'business_name', label: 'Business Name', placeholder: 'Your company name', type: 'text' },
    { id: 'service_type', label: 'Service/Appointment Type', placeholder: 'What the customer is preparing for', type: 'text' },
    { id: 'prep_steps', label: 'Preparation Steps', placeholder: 'What customers should do before...', type: 'textarea', required: true },
    { id: 'what_to_bring', label: 'What to Bring', placeholder: 'Items or documents needed', type: 'textarea' }
  ],
  sales_script: [
    { id: 'business_name', label: 'Business Name', placeholder: 'Your company name', type: 'text' },
    { id: 'product_service', label: 'Product/Service', placeholder: 'What you are selling', type: 'text' },
    { id: 'key_points', label: 'Key Selling Points', placeholder: 'Main benefits to highlight', type: 'textarea', required: true },
    { id: 'objections', label: 'Common Objections', placeholder: 'Typical concerns and responses', type: 'textarea' },
    { id: 'closing', label: 'Closing Approach', placeholder: 'How to close the sale', type: 'textarea' }
  ],
  proposal: [
    { id: 'business_name', label: 'Business Name', placeholder: 'Your company name', type: 'text' },
    { id: 'client_type', label: 'Client Type', placeholder: 'Who this proposal is for', type: 'text' },
    { id: 'solution', label: 'Proposed Solution', placeholder: 'What you are proposing...', type: 'textarea', required: true },
    { id: 'pricing', label: 'Pricing Structure', placeholder: 'How pricing works', type: 'textarea' },
    { id: 'timeline', label: 'Timeline', placeholder: 'Project timeline', type: 'text' }
  ],
  case_study: [
    { id: 'business_name', label: 'Business Name', placeholder: 'Your company name', type: 'text' },
    { id: 'client_industry', label: 'Client/Industry', placeholder: 'Who the case study is about', type: 'text' },
    { id: 'challenge', label: 'Challenge/Problem', placeholder: 'What problem was solved', type: 'textarea', required: true },
    { id: 'solution', label: 'Solution Provided', placeholder: 'How you helped', type: 'textarea' },
    { id: 'results', label: 'Results/Outcomes', placeholder: 'Measurable results achieved', type: 'textarea' }
  ],
  partnership: [
    { id: 'business_name', label: 'Business Name', placeholder: 'Your company name', type: 'text' },
    { id: 'partner_type', label: 'Partner Type', placeholder: 'Type of partnership', type: 'text' },
    { id: 'terms', label: 'Partnership Terms', placeholder: 'Key terms and responsibilities...', type: 'textarea', required: true },
    { id: 'revenue_sharing', label: 'Revenue/Benefit Sharing', placeholder: 'How benefits are split', type: 'textarea' }
  ],
  company_overview: [
    { id: 'business_name', label: 'Business Name', placeholder: 'Your company name', type: 'text' },
    { id: 'about', label: 'About the Company', placeholder: 'Brief company description', type: 'textarea', required: true },
    { id: 'services', label: 'Services/Products', placeholder: 'What you offer', type: 'textarea' },
    { id: 'differentiators', label: 'What Makes You Different', placeholder: 'Unique selling points', type: 'textarea' },
    { id: 'contact', label: 'Contact Information', placeholder: 'How to reach you', type: 'textarea' }
  ],
  data_handling: [
    { id: 'business_name', label: 'Business Name', placeholder: 'Your company name', type: 'text' },
    { id: 'data_types', label: 'Types of Data Handled', placeholder: 'Customer data, financial data, etc.', type: 'textarea', required: true },
    { id: 'handling_rules', label: 'Handling Rules', placeholder: 'How staff should treat this data', type: 'textarea' },
    { id: 'storage', label: 'Storage Requirements', placeholder: 'Where and how data is stored', type: 'textarea' }
  ],
  access_control: [
    { id: 'business_name', label: 'Business Name', placeholder: 'Your company name', type: 'text' },
    { id: 'systems', label: 'Systems/Areas Covered', placeholder: 'What systems or areas this covers', type: 'textarea' },
    { id: 'access_levels', label: 'Access Levels', placeholder: 'Different levels of access...', type: 'textarea', required: true },
    { id: 'approval_process', label: 'Access Approval Process', placeholder: 'How access is granted', type: 'textarea' }
  ],
  document_retention: [
    { id: 'business_name', label: 'Business Name', placeholder: 'Your company name', type: 'text' },
    { id: 'document_types', label: 'Document Types', placeholder: 'Types of documents covered', type: 'textarea', required: true },
    { id: 'retention_periods', label: 'Retention Periods', placeholder: 'How long each type is kept', type: 'textarea' },
    { id: 'disposal_method', label: 'Disposal Method', placeholder: 'How documents are destroyed', type: 'textarea' }
  ],
  custom_chat: [
    { id: 'business_name', label: 'Business Name', placeholder: 'Your company name', type: 'text' }
  ]
};

// Document Wizard Example Prompts
const docWizardExamplePrompts = {
  sop: {
    business_name: 'Sunrise Coffee Shop',
    process_name: 'Opening Procedures',
    who_performs: 'Opening shift barista',
    tools_systems: 'POS system, espresso machine, refrigerator, cash register',
    steps: '1. Unlock front door and disarm alarm\n2. Turn on lights and HVAC\n3. Start espresso machine warm-up (15 min)\n4. Check and stock pastry case\n5. Count opening cash drawer\n6. Review daily specials\n7. Unlock front door at opening time',
    time_estimates: 'Total: 30 minutes, warm-up: 15 min, cash count: 5 min',
    troubleshooting: 'If espresso machine won\'t start: check water reservoir, check power. If alarm won\'t disarm: call manager immediately',
    approval_person: 'Store Manager - Sarah Johnson'
  },
  contract: {
    business_name: 'Pro Cleaning Services LLC',
    service_type: 'Commercial Cleaning Services',
    scope: 'Weekly office cleaning including:\n- Vacuuming and mopping all floors\n- Cleaning and sanitizing restrooms\n- Emptying trash and recycling\n- Dusting surfaces and wiping desks\n- Kitchen/break room cleaning',
    payment_terms: 'Monthly billing, net 15 days. $500/month for standard package. Late fee: 1.5% after 30 days',
    cancellation: '30 days written notice required. No penalty for cancellation with proper notice',
    liability: 'Insured up to $1M. Not liable for pre-existing damage or items left unsecured'
  },
  internal_policy: {
    business_name: 'TechStart Inc.',
    policy_name: 'Remote Work Policy',
    applies_to: 'All full-time employees after 90-day probation period',
    rules: '- Up to 2 remote days per week\n- Must be available during core hours (10am-3pm)\n- Must use company VPN for all work\n- Video on for all meetings\n- Respond to messages within 1 hour during work hours',
    consequences: 'First violation: verbal warning. Second: written warning. Third: remote privileges revoked for 90 days',
    exceptions: 'Employees with documented medical needs may request additional remote days through HR'
  }
};

let weeklyChampions = [];
let tasks = []; // Initialize tasks array
let projects = []; // Initialize projects array
let pmToolViewMode = 'tasks'; // 'tasks' or 'folders' - toggle between task view and folder view
window.pmToolViewMode = pmToolViewMode;
let showServiceRequestModal = false;
let serviceRequestData = { phone: '', email: '', service: '', notes: '' };
let showProjectTasksModal = false;
let projectTasksModalData = { projectId: null, projectName: '', tasks: [] };
let teamMembers = []; // Initialize team members array
let contacts = []; // Initialize contacts array
let chats = []; // Initialize chats array
let contactDetailTab = 'quickview';
let contactDetailViewTab = 'activity'; // 'activity', 'projects', 'tasks', 'chats', 'opportunities', 'reminders', 'appointments'

// Cache for contact detail data to avoid reloading on tab switch
let cachedContactData = {
  contactId: null,
  appointments: [],
  reminders: [],
  opportunities: [],
  activityLog: [],
  tasks: [],
  projects: [],
  chats: [],
  isClient: false
};

let showAllProjects = false; // Filter projects - false = active only, true = all
let showAllTasks = false; // Filter tasks - false = active only, true = all
let showAddContactModal = false; // Show add contact modal
let showAddOpportunityModal = false; // Show add opportunity modal
let showAllOpportunities = false; // Filter opportunities - false = active only, true = all
let showArchivedOpportunities = false; // Show archived (won/lost/closed) opportunities
let editingOpportunityId = null; // ID of opportunity being edited, null if creating new
let expandedProjects = new Set(); // Set of expanded project IDs
let showAddReminderModal = false; // Show add reminder modal
let editingReminderId = null; // Track which reminder is being edited
let showAllReminders = false; // Filter reminders - false = pending only, true = all
let reminderFormData = {
  title: '',
  description: '',
  priority: 'medium',
  type: 'follow_up',
  due_date: ''
};
// Make it accessible globally for inline handlers
window.reminderFormData = reminderFormData;
let isReminderModalFromCalendar = false; // Track if reminder modal opened from calendar
let selectedReminderContactId = null; // Selected contact for reminder from calendar
window.selectedReminderContactId = selectedReminderContactId;
let reminderContactSearchQuery = ''; // Search query for reminder contact selector
window.reminderContactSearchQuery = reminderContactSearchQuery;

let showAddAppointmentModal = false; // Show add appointment modal
let editingAppointmentId = null; // Track which appointment is being edited
let isAppointmentModalFromCalendar = false; // Track if appointment modal opened from calendar
let selectedAppointmentContactId = null; // Selected contact for appointment from calendar
window.selectedAppointmentContactId = selectedAppointmentContactId;
let appointmentContactSearchQuery = ''; // Search query for appointment contact selector
window.appointmentContactSearchQuery = appointmentContactSearchQuery;
let showScheduleMessageModal = false; // Show schedule message modal
let showFormSubmissionModal = false; // Show form submission creation modal
let showAppointmentDateTimeModal = false; // Show appointment date/time picker modal
let appointmentDateTimeData = { intakeRequestId: null, contactId: null, date: '', time: '' };
let formSubmissionModalData = {
  intakeRequestId: null,
  intakeRequest: null,
  existingContact: null,
  detectedType: null, // 'task', 'appointment', 'sales_opportunity', 'contact'
  currentStep: 'detect', // 'detect', 'create_contact', 'create_record'
  createdContactId: null,
  workspaceProjects: [],
  workspaceTasks: [],
  workspaceChats: [],
  workspaceSalesOpportunities: [],
  editingWorkspaceItem: null, // { type: 'contact'|'sales_opportunity'|'project'|'task'|'chat', id: string }
  initialWorkspaceOpportunityIds: [] // IDs of opportunities that existed when modal opened (so "What would you like to create?" additions don't show in workspace)
};
window.formSubmissionModalData = formSubmissionModalData;
// Service request helpers (Dashboard)
window.openServiceRequestModal = function () { showServiceRequestModal = true; renderPMTool(); };
window.closeServiceRequestModal = function () { showServiceRequestModal = false; serviceRequestData = { phone: '', email: '', service: '', notes: '' }; renderPMTool(); };
window.submitServiceRequest = function () {
  if (!serviceRequestData.phone && !serviceRequestData.email) {
    showNotification('Please provide a phone number or email.', 'warning');
    return;
  }
  showNotification('Service request submitted. We will contact you soon.', 'success');
  window.closeServiceRequestModal();
};
window.viewProjectTasks = function (projectId) {
  const tasksList = Array.isArray(tasks) ? tasks.filter(t => t.project_id === projectId) : [];
  const projectName = (projects || []).find(p => p.id === projectId)?.name
    || (tasksList[0]?.project_name)
    || 'Project Tasks';
  projectTasksModalData = { projectId, projectName, tasks: tasksList };
  showProjectTasksModal = true;
  renderPMTool();
};
// Service request helpers (Dashboard)
window.openServiceRequestModal = function () { showServiceRequestModal = true; renderPMTool(); };
window.closeServiceRequestModal = function () { showServiceRequestModal = false; serviceRequestData = { phone: '', email: '', service: '', notes: '' }; renderPMTool(); };
window.submitServiceRequest = function () {
  if (!serviceRequestData.phone && !serviceRequestData.email) {
    showNotification('Please provide a phone number or email.', 'warning');
    return;
  }
  showNotification('Service request submitted. We will contact you soon.', 'success');
  window.closeServiceRequestModal();
};
let feedbackList = []; // List of feedback items
let feedbackLoading = false; // Loading state for feedback
let showFeedbackModal = false; // Show add feedback modal
let showQuickTasksModal = false; // Show quick tasks modal
let quickTasks = []; // Array of quick tasks (tasks with state = 'DRAFT')
let showDeleteQuickTaskModal = false; // Show delete quick task confirmation modal
let deletingQuickTaskId = null; // Quick task ID being deleted
let feedbackFilter = 'all'; // Filter: 'all', 'in_progress', 'completed'
window.feedbackFilter = feedbackFilter; // Make globally accessible
let feedbackFormData = {
  title: '',
  description: ''
};
window.feedbackFormData = feedbackFormData; // Make globally accessible
let submittingFeedback = false; // Submitting feedback state
window.showScheduleMessageModal = false; // Make globally accessible
let scheduledMessages = []; // Scheduled messages for current chat
let showScheduledMessagesView = false; // Show/hide scheduled messages section
let editingScheduledMessageId = null; // ID of scheduled message being edited
let showMediaRequestModal = false; // Show media request modal
let mediaRequestDescription = ''; // Media request description
let submittingMediaRequest = false; // Submitting media request flag
let scheduledMessageFormData = { text: '', date: '', time: '' }; // Form data for editing scheduled message
let showImageViewerModal = false; // Show image viewer modal
let imageViewerUrl = ''; // URL of image being viewed
// Eva AI state
let evaVisible = false; // Eva bubble visibility
let evaOpen = false; // Eva chat modal open state
let showEvaWelcome = false; // Show Eva welcome message (checked against localStorage)
let evaMessages = []; // Eva chat messages
let evaInputText = ''; // Eva chat input text
let evaLoading = false; // Eva AI loading state
let evaUserContext = null; // Eva user context data
let evaCurrentPage = 'unknown'; // Current page for Eva context
let showAllAppointments = false; // Filter appointments - false = scheduled only, true = all
let showCompanyManagement = false; // Show company management screen
let managementTab = 'members'; // Current tab: 'members', 'clients', 'services'
let editingMemberId = null; // Track which member is being edited
let showAddMemberModal = false; // Show add member modal
let memberSearchQuery = ''; // Search query for members
window.memberSearchQuery = ''; // Make globally accessible for inline handlers
let editingServiceId = null; // Track which service is being edited
let showAddServiceModal = false; // Show add service modal
let serviceSearchQuery = ''; // Search query for services
let clientSearchQuery = ''; // Search query for clients
window.clientSearchQuery = ''; // Make globally accessible for inline handlers
let showAddClientModal = false; // Show add client modal
let addingClientContactId = null; // Contact ID being added as client
let showUpgradeCompanyModal = false; // Show upgrade to company owner modal (admin only)
let upgradingContactId = null; // Contact ID being upgraded to company owner
let upgradingContactProfileId = null; // Profile ID of the contact being upgraded
let showEditContactModal = false; // Show edit contact modal
let editingContactId = null; // Contact ID being edited
let showDeleteContactModal = false; // Show delete contact confirmation modal
let deletingContactId = null; // Contact ID being deleted
let appointmentFormData = {
  title: '',
  appointment_date: '',
  start_time: '',
  duration: '60',
  notes: '',
  assigned_to: ''
};
// Make it accessible globally for inline handlers
window.appointmentFormData = appointmentFormData;
let opportunityFormData = {
  title: '',
  stage: 'new',
  expected_close_date: '',
  amount: '',
  source: 'website',
  chance: 'medium',
  follow_up_date: '',
  follow_up_time: '',
  notes: '',
  archived: false,
  assigned_to: ''
};
// Make it accessible globally for inline handlers
window.opportunityFormData = opportunityFormData;
let isOpportunityModalFromSales = false; // Track if opportunity modal opened from sales page
let selectedOpportunityContactId = null; // Selected contact for opportunity from sales page
window.selectedOpportunityContactId = selectedOpportunityContactId;
let opportunityContactSearchQuery = ''; // Search query for opportunity contact selector
window.opportunityContactSearchQuery = opportunityContactSearchQuery;

// Avatar colors for unique contact avatars
const avatarColors = [
  '#007bff', // Blue
  '#28a745', // Green
  '#dc3545', // Red
  '#fd7e14', // Orange
  '#6f42c1', // Purple
  '#20c997', // Teal
  '#e83e8c', // Pink
  '#17a2b8', // Cyan
  '#ffc107', // Yellow
  '#6c757d', // Gray
];

// Generate avatar color based on name
function getAvatarColor(name) {
  if (!name) return avatarColors[0];

  // Simple hash function to get consistent color for same name
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }

  const index = Math.abs(hash) % avatarColors.length;
  return avatarColors[index];
}
let taskFilters = {
  status: [], // Default: show all tasks (no status filtering)
  priority: []
};
let searchQuery = '';
let showAddTaskModal = false;
let editingTask = null;
let showTaskDetails = null;
let showFiltersModal = false;
let showTaskListModal = false;
let currentPage = { backlog: 0, active: 0, completed: 0 };
let tasksPerPage = 3; // Max tasks visible at once (for scrollable columns)
let teamTab = 'personal'; // 'personal' or 'team'
window.teamTab = teamTab; // Make accessible to inline event handlers
let showAddTaskForm = false;
let showTaskCommentsModal = null;
let taskComments = [];
let taskDetailsComments = []; // Comments for task details modal
let calendarView = 'month'; // 'month', 'week'
let calendarViewMode = 'team'; // 'personal' or 'team' - default to team
let currentCalendarDate = new Date();
let calendarEvents = []; // Combined events from tasks, appointments, reminders, sales
let calendarLoading = false; // Prevent multiple simultaneous loads
let lastCalendarLoadTime = 0;
const CALENDAR_LOAD_THROTTLE_MS = 2000; // Only load calendar events every 2 seconds
let selectedCalendarEvent = null; // Selected event for details modal
let hoveredCalendarEvent = null; // Hovered event for preview tooltip
let checklistItems = []; // Checklist items
let checklistSearchQuery = ''; // Search query for checklist
let showAddChecklistModal = false; // Show add/edit checklist modal
let editingChecklistItem = null; // Currently editing checklist item
let checklistTab = 'team'; // 'team' or 'personal' - which tab is active
window.checklistTab = checklistTab; // Make accessible to inline event handlers
let checklistFormData = {
  title: '',
  description: '',
  category: '',
  color: '#6366f1' // Default purple/indigo
};

// Notification system state
let notifications = []; // All notifications
let unreadNotificationCount = 0; // Count of unread notifications
let showNotificationsPopup = false; // Show/hide notification popup
let notificationSubscription = null; // Real-time subscription
let messageSubscription = null; // Real-time subscription for chat messages

// =============================================================================
// CONTRACTS MODULE STATE
// =============================================================================
let contractsList = []; // All contracts for the company
let contractProducts = []; // Product catalog
let contractClauses = []; // Clause library
let productCategories = []; // Product categories
let selectedCategoryId = null; // Currently selected category for viewing products
let contractsTab = 'inbox'; // 'inbox', 'categories', 'clauses', 'settings'
window.contractsTab = contractsTab;
let companyLogoUrl = null;
let showSettingsConfirmModal = false;
let settingsConfirmAction = null;
let settingsConfirmMessage = '';
let contractsFilter = 'all'; // 'all', 'draft', 'sent', 'viewed', 'signed', 'expired', 'closed', 'voided'
window.contractsFilter = contractsFilter;
let contractsSearchQuery = '';
window.contractsSearchQuery = contractsSearchQuery;
let showNewContractModal = false;
let newContractStep = 1; // 1=client, 2=products, 3=clauses, 4=review
let newContractData = {
  // Step 1 - Client
  contactId: null,
  clientName: '',
  clientEmail: '',
  clientPhone: '',
  clientCompanyName: '',
  effectiveDate: new Date().toISOString().split('T')[0],
  closeDate: '',
  contractName: '',
  // Step 2 - Products
  lineItems: [],
  discountType: null, // 'percentage' or 'fixed'
  discountValue: 0,
  taxRate: 0,
  // Step 3 - Clauses
  selectedClauses: [],
  customNotes: ''
};
window.newContractData = newContractData;
let showProductModal = false;
let editingProductId = null;
let productFormData = {
  name: '',
  sku: '',
  description: '',
  price: 0,
  cost: 0,
  is_recurring: false,
  recurring_interval: 'monthly',
  is_taxable: true, // Default to taxable
  category_id: null
};
window.productFormData = productFormData;
let showCategoryModal = false;
let editingCategoryId = null;
let categoryFormData = {
  name: '',
  description: ''
};
window.categoryFormData = categoryFormData;
let globalTaxRate = 0; // Company default tax rate
let showTaxRateModal = false;
let showClauseModal = false;
let editingClauseId = null;
let clauseFormData = {
  title: '',
  category: 'other',
  body: '',
  is_default: false
};
window.clauseFormData = clauseFormData;
let selectedContractId = null; // Currently viewing/editing contract
let contractViewMode = 'list'; // 'list' or 'detail'
let showContractLink = false; // Show contract link modal
let contractLinkData = { link: '', contractName: '' };
window.contractLinkData = contractLinkData;
let showContractPreview = false; // Show contract preview modal
let showVoidConfirmModal = false; // Show void confirmation modal
let voidContractId = null; // Contract ID to void
let showDeleteConfirmModal = false; // Show delete confirmation modal
let deleteContractId = null; // Contract ID to delete
let deleteConfirmText = ''; // Text input for delete confirmation

// Show day schedule modal
window.showDaySchedule = function (year, month, day) {
  // Hide hover tooltip when clicking
  hideCalendarEventHover();

  const dayDate = new Date(year, month, day);
  selectedDaySchedule = dayDate;
  showDayScheduleModal = true;
  renderPMTool();
};

// Close day schedule modal
window.closeDayScheduleModal = function () {
  showDayScheduleModal = false;
  selectedDaySchedule = null;
  renderPMTool();
};

// Render day schedule modal
function renderDayScheduleModal() {
  if (!showDayScheduleModal || !selectedDaySchedule) return '';

  // Get all events for this day
  const dayEvents = calendarEvents.filter(event => {
    const eventDate = new Date(event.date);
    return eventDate.getFullYear() === selectedDaySchedule.getFullYear() &&
      eventDate.getMonth() === selectedDaySchedule.getMonth() &&
      eventDate.getDate() === selectedDaySchedule.getDate();
  });

  // Sort events chronologically by time
  dayEvents.sort((a, b) => {
    if (a.time && b.time) {
      return a.time.localeCompare(b.time);
    }
    if (a.time) return -1;
    if (b.time) return 1;
    return 0;
  });

  const dayString = selectedDaySchedule.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return `
    <div style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1000;
      padding: 1rem;
    " onclick="closeDayScheduleModal();">
      <div style="
        background: white;
        border-radius: 1rem;
        padding: 2rem;
        max-width: 600px;
        width: 100%;
        max-height: 80vh;
        overflow-y: auto;
      " onclick="event.stopPropagation();">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1.5rem;">
          <h2 style="font-size: 1.5rem; font-weight: 700; color: #0f172a; margin: 0;">${dayString}</h2>
          <button
            onclick="closeDayScheduleModal();"
            style="
              width: 32px;
              height: 32px;
              border: none;
              background: #f1f5f9;
              border-radius: 50%;
              cursor: pointer;
              font-size: 1.25rem;
              color: #64748b;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >×</button>
        </div>
        
        ${dayEvents.length === 0 ? `
          <div style="text-align: center; padding: 2rem; color: #64748b;">
            <p>No events scheduled for this day.</p>
          </div>
        ` : `
          <div style="display: flex; flex-direction: column; gap: 1rem;">
            ${dayEvents.map(event => {
    const getTypeIcon = (type) => {
      const icons = {
        reminder: '🔔',
        appointment: '📅',
        task: '✓',
        sales: '💰',
        timeoff: '🏖️'
      };
      return icons[type] || '📌';
    };

    const getTypeLabel = (type) => {
      const labels = {
        reminder: 'Reminder',
        appointment: 'Appointment',
        task: 'Task',
        sales: 'Sales Opportunity',
        timeoff: 'Time Off'
      };
      return labels[type] || type;
    };

    // Get the actual ID from event (extract from id string or use rawData)
    const getEventId = () => {
      if (event.rawData?.id) return event.rawData.id;
      // Extract ID from prefixed string like "task-123" or "appointment-456"
      const match = event.id.match(/^(task|appointment|reminder)-(.+)$/);
      return match ? match[2] : null;
    };

    // Determine if event is editable (not timeoff)
    const isEditable = event.type !== 'timeoff';
    const eventId = isEditable ? getEventId() : null;

    // Get edit function name based on type
    const getEditFunction = () => {
      if (event.type === 'task') return `editTask('${eventId}')`;
      if (event.type === 'appointment') return `editAppointment('${eventId}')`;
      if (event.type === 'reminder') return `editReminder('${eventId}')`;
      return null;
    };

    const editFunction = getEditFunction();
    const onClickHandler = isEditable && editFunction
      ? `onclick="closeDayScheduleModal(); ${editFunction};"`
      : '';

    return `
                <div 
                  ${onClickHandler}
                  style="
                    border: 1px solid #e5e7eb;
                    border-radius: 0.75rem;
                    padding: 1rem;
                    background: #ffffff;
                    cursor: ${isEditable ? 'pointer' : 'default'};
                    transition: all 0.2s ease;
                  "
                  onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 4px 6px rgba(0,0,0,0.1)';"
                  onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='none';"
                >
                  <div style="display: flex; align-items: start; gap: 1rem;">
                    <div style="
                      width: 40px;
                      height: 40px;
                      border-radius: 0.5rem;
                      background: ${event.color || '#3b82f6'};
                      color: white;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      font-size: 1.25rem;
                      flex-shrink: 0;
                    ">${getTypeIcon(event.type)}</div>
                    <div style="flex: 1;">
                      <div style="font-weight: 600; color: #0f172a; margin-bottom: 0.25rem;">${event.title}</div>
                      ${event.time ? `
                        <div style="font-size: 0.875rem; color: #64748b; margin-bottom: 0.25rem;">
                          ${formatTime(event.time)}
                        </div>
                      ` : ''}
                      ${event.description ? `
                        <div style="font-size: 0.875rem; color: #64748b; margin-top: 0.5rem;">
                          ${event.description}
                        </div>
                      ` : ''}
                      <div style="
                        display: inline-block;
                        margin-top: 0.5rem;
                        padding: 0.25rem 0.75rem;
                        background: ${event.color || '#3b82f6'}20;
                        color: ${event.color || '#3b82f6'};
                        border-radius: 9999px;
                        font-size: 0.75rem;
                        font-weight: 600;
                        text-transform: capitalize;
                      ">${getTypeLabel(event.type)}</div>
                      ${event.employee ? `
                        <div style="font-size: 0.75rem; color: #64748b; margin-top: 0.25rem;">
                          Employee: ${event.employee}
                        </div>
                      ` : ''}
                      ${event.requestType ? `
                        <div style="font-size: 0.75rem; color: #64748b; margin-top: 0.25rem;">
                          Type: ${window.getRequestTypeLabel ? window.getRequestTypeLabel(event.requestType) : event.requestType}
                        </div>
                      ` : ''}
                    </div>
                  </div>
                </div>
              `;
  }).join('')}
          </div>
        `}
      </div>
    </div>
  `;
}

// Close calendar event modal
window.closeCalendarEventModal = function () {
  selectedCalendarEvent = null;
  renderPMTool();
};
let taskCommentCounts = {}; // Store comment counts per task
let replyingTo = null; // Track which comment we're replying to
let replyText = ''; // Store reply text
let searchTimeout = null;

// Time Tracking State Variables
let timeTrackingData = {
  isClockedIn: false,
  isOnBreak: false, // Track if user is currently on break
  breakStartTime: null, // Store break start time for break duration calculation
  currentBreakDuration: '', // Current break duration display
  currentEntryId: null,
  clockInTime: null, // Store clock in time for duration calculation
  currentShiftDuration: '',
  todayHours: 0,
  weekHours: 0,
  monthHours: 0,
  loading: false,
  checkingStatus: false, // Start as false, will be set to true when loading starts
  dataLoaded: false // Track if data has been loaded to prevent re-loading on every render
};
let timeTrackingView = 'main'; // 'main', 'timesheet', 'hourly-rate', 'time-off'
let timeEntries = []; // Timesheet entries
let timesheetStartDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1, 0, 0, 0, 0);
let timesheetEndDate = (function () {
  const now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
})();
let timesheetPayPeriod = 'monthly'; // 'bi-monthly-1', 'bi-monthly-2', 'monthly'
let timesheetPayData = null;
let timesheetSortColumn = 'clock_in_at';
let timesheetSortDirection = 'desc';
let hourlyRates = []; // Hourly rate history
let currentHourlyRate = null; // Current hourly rate for selected employee
let employeeHourlyRates = {}; // Cache of hourly rates per employee: { employeeId: rate }
let showHourlyRateForm = false;
let hourlyRateFormData = { rate: '', employeeId: null };
// Make accessible in HTML context - sync both ways
Object.defineProperty(window, 'hourlyRateFormData', {
  get: () => hourlyRateFormData,
  set: (val) => {
    hourlyRateFormData = val;
  }
});
let timeOffRequests = []; // Time off requests
window.timeOffRequestsMap = {}; // Map of time off requests by ID for easy lookup
let showTimeOffRequestForm = false;
window.showTimeOffRequestForm = false; // Make globally accessible
let timeOffRequestFormData = {
  startDate: '',
  endDate: '',
  requestType: 'VACATION',
  reason: ''
};
window.timeOffRequestFormData = timeOffRequestFormData; // Make globally accessible
let showTimeOffApprovalModal = false;
let selectedTimeOffRequest = null;
let timeOffApprovalData = { rejectionReason: '' };
window.timeOffApprovalData = timeOffApprovalData; // Make globally accessible
window.selectedTimeOffRequest = null; // Make globally accessible
let showTimesheetExportModal = false;
let companyEmployees = null; // List of company employees for filters (null = not loaded yet, [] = loaded but empty)
let companyEmployeesLoading = false; // Flag to track if employees are currently loading
let selectedDaySchedule = null; // Selected day for calendar schedule modal
let showDayScheduleModal = false; // Show day schedule modal
let overtimeRules = null; // Company overtime rules
let showOvertimeRulesModal = false; // Show overtime rules configuration modal
let overtimeRulesFormData = {
  overtime_type: 'WEEKLY',
  weekly_threshold_hours: 40,
  daily_threshold_hours: 8,
  overtime_multiplier: 1.5,
  double_time_threshold: null,
  double_time_multiplier: 2.0
};

// Modern color scheme
const colors = {
  primary: '#00ADB5', // Teal accent
  primaryLight: '#B2E5E8', // Light teal
  primaryDark: '#008B94', // Dark teal
  secondary: '#64748b',
  success: '#10b981', // Green for success
  warning: '#f59e0b', // Orange for warning
  error: '#ef4444', // Red for error
  background: '#F7F8FB', // Very light gray background
  surface: '#ffffff', // White cards
  text: '#0F172A', // Dark slate text
  textSecondary: '#64748b', // Muted gray text
  border: '#E5E7EB' // Light gray borders
};

// ============================================
// TRIAL LOGIC - 60-day free trial per company
// ============================================

/**
 * Checks if a company's 60-day trial has expired.
 * @param {Object} company - The company object with created_at and is_premium fields
 * @returns {boolean} - True if trial expired, false otherwise
 */
function isCompanyTrialExpired(company) {
  // No company means no trial to check (user might not have a company yet)
  if (!company) return false;

  // Premium companies are always unlocked
  if (company.is_premium === true) return false;

  // If company exists but created_at is missing, we might have incomplete data
  // Block access until fresh data loads to prevent showing wrong screen briefly
  if (!company.created_at) return true;

  const createdAt = new Date(company.created_at);
  const now = new Date();
  const trialEndDate = new Date(createdAt);
  trialEndDate.setDate(trialEndDate.getDate() + 60);

  // Trial is expired if current date is >= trial end date
  return now >= trialEndDate;
}

// Calculate days remaining on trial
function getTrialDaysRemaining(company) {
  if (!company) return null;

  // Premium companies don't have a trial
  if (company.is_premium === true) return null;

  if (!company.created_at) return null;

  const createdAt = new Date(company.created_at);
  const now = new Date();
  const trialEndDate = new Date(createdAt);
  trialEndDate.setDate(trialEndDate.getDate() + 60);

  // Calculate days remaining
  const diffTime = trialEndDate - now;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  return diffDays > 0 ? diffDays : 0;
}

/**
 * Renders the trial expired screen, blocking access to the entire app.
 * @param {Object} company - The company object (optional, for displaying company name)
 */
// OLD: Upgrade function - REMOVED (now admin-only, see openUpgradeCompanyModal)
// This function is no longer used since upgrade is admin-only
// Keeping for reference but not called
window.handleUpgradeToCompanyOwner_OLD = async function () {
  try {
    // Show loading state
    const upgradeBtn = document.getElementById('upgrade-to-premium-btn');
    const upgradeError = document.getElementById('upgrade-error');
    const upgradeForm = document.getElementById('upgrade-company-form');

    if (upgradeBtn) {
      upgradeBtn.disabled = true;
      upgradeBtn.textContent = 'Creating Company...';
    }

    if (upgradeError) {
      upgradeError.style.display = 'none';
    }

    // Get form values
    const companyName = document.getElementById('company-name-input')?.value?.trim();
    const companyPhone = document.getElementById('company-phone-input')?.value?.trim() || null;
    const companyCity = document.getElementById('company-city-input')?.value?.trim() || null;
    const companyState = document.getElementById('company-state-input')?.value?.trim() || null;

    if (!companyName) {
      throw new Error('Company name is required');
    }

    // Call RPC function
    const { data, error } = await supabase.rpc('upgrade_to_company_owner', {
      p_company_name: companyName,
      p_company_phone: companyPhone,
      p_company_city: companyCity,
      p_company_state: companyState
    });

    if (error) {
      throw error;
    }

    // Check if already upgraded
    if (data?.error === 'already_upgraded') {
      // User already owns a company, reload data
      await loadUserData();
      // Reload the page to show the app
      window.location.reload();
      return;
    }

    // Check if successful
    if (!data?.success) {
      throw new Error(data?.error || 'Failed to create company');
    }

    // Success! Reload user data and redirect
    console.log('✅ Company created successfully:', data);
    await loadUserData();

    // Show success message briefly, then reload
    if (upgradeBtn) {
      upgradeBtn.textContent = 'Success! Redirecting...';
      upgradeBtn.style.background = '#10b981';
    }

    setTimeout(() => {
      window.location.reload();
    }, 1000);

  } catch (err) {
    console.error('❌ Error upgrading to company owner:', err);
    const upgradeError = document.getElementById('upgrade-error');
    const upgradeBtn = document.getElementById('upgrade-to-premium-btn');

    if (upgradeError) {
      upgradeError.textContent = err.message || 'Failed to create company. Please contact support.';
      upgradeError.style.display = 'block';
    }

    if (upgradeBtn) {
      upgradeBtn.disabled = false;
      upgradeBtn.textContent = 'Upgrade to Premium';
    }
  }
}

window.isMobileDevice = function () {
  if (typeof navigator === 'undefined') return false;
  var ua = navigator.userAgent || '';
  var byUserAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS|FxiOS/i.test(ua);
  var byViewport = typeof window !== 'undefined' && window.innerWidth > 0 && window.innerWidth <= 768;
  var byMediaQuery = typeof window.matchMedia !== 'undefined' && window.matchMedia('(max-width: 768px)').matches;
  return byUserAgent || byViewport || byMediaQuery;
};

window.continueWithWebVersion = function () {
  try {
    if (typeof sessionStorage !== 'undefined') sessionStorage.setItem('helo_use_web_version', '1');
  } catch (e) { }
  if (window.renderPMTool) window.renderPMTool();
};

function renderClientLockedScreen() {
  document.getElementById('root').innerHTML = `
    <div style="
      min-height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
      padding: 1rem;
    ">
      <div style="
        background: white;
        padding: 3rem 2.5rem;
        border-radius: 1rem;
        box-shadow: 0 20px 40px rgba(0,0,0,0.15);
        max-width: 500px;
        width: 100%;
        text-align: center;
      ">
        <!-- Download Icon -->
        <div style="
          width: 80px;
          height: 80px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1.5rem;
          box-shadow: 0 8px 24px rgba(102, 126, 234, 0.3);
        ">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17 10V17C17 18.6569 15.6569 20 14 20H10C8.34315 20 7 18.6569 7 17V10M17 10L12 15M17 10L12 5M12 15L7 10M12 15V5" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        
        <!-- Title -->
        <h1 style="
          color: #0F172A;
          font-size: 1.75rem;
          font-weight: 700;
          margin: 0 0 1rem 0;
          line-height: 1.3;
        ">Download Our Mobile App</h1>
        
        <!-- Message -->
        <p style="
          color: #475569;
          font-size: 1rem;
          line-height: 1.6;
          margin: 0 0 2rem 0;
        ">
          Please download our app on the Play Store or App Store for easier communications.
        </p>

        <!-- Download Buttons -->
        <div style="
          display: flex;
          flex-direction: column;
          gap: 1rem;
          margin-bottom: 1.5rem;
        ">
          <button onclick="window.open('https://play.google.com/store', '_blank')" style="
            width: 100%;
            padding: 1rem 1.5rem;
            background: #0F172A;
            color: white;
            border: none;
            border-radius: 0.75rem;
            font-size: 1rem;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s ease;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 0.75rem;
          " onmouseover="this.style.background='#1e293b'; this.style.transform='translateY(-2px)';" 
             onmouseout="this.style.background='#0F172A'; this.style.transform='translateY(0)';">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 20.5V3.5C3 2.91 3.34 2.39 3.84 2.15L13.69 12L3.84 21.85C3.34 21.6 3 21.09 3 20.5Z" fill="currentColor"/>
              <path d="M16.81 15.12L6.05 21.34L14.54 12.85L16.81 15.12Z" fill="currentColor"/>
              <path d="M16.81 8.88L14.54 11.15L6.05 2.66L16.81 8.88Z" fill="currentColor"/>
              <path d="M20.16 10.81C20.5 11.08 20.75 11.5 20.75 12C20.75 12.5 20.53 12.9 20.18 13.18L17.89 14.5L15.39 12L17.89 9.5L20.16 10.81Z" fill="currentColor"/>
            </svg>
            Download for Android
          </button>
          <button onclick="window.open('https://apps.apple.com', '_blank')" style="
            width: 100%;
            padding: 1rem 1.5rem;
            background: #ffffff;
            color: #0F172A;
            border: 2px solid #e2e8f0;
            border-radius: 0.75rem;
            font-size: 1rem;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s ease;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 0.75rem;
          " onmouseover="this.style.borderColor='#cbd5e1'; this.style.background='#f8fafc'; this.style.transform='translateY(-2px)';" 
             onmouseout="this.style.borderColor='#e2e8f0'; this.style.background='#ffffff'; this.style.transform='translateY(0)';">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18.71 19.5C17.88 20.74 17 21.95 15.66 21.97C14.32 22 13.89 21.18 12.37 21.18C10.84 21.18 10.37 21.95 9.1 22C7.79 22.05 6.8 20.68 5.96 19.47C4.25 17 2.94 12.45 4.7 9.39C5.57 7.87 7.13 6.91 8.82 6.88C10.1 6.86 11.32 7.75 12.11 7.75C12.89 7.75 14.37 6.68 15.92 6.84C16.57 6.87 18.39 7.1 19.56 8.82C19.47 8.88 17.39 10.1 17.41 12.63C17.44 15.65 20.06 16.66 20.09 16.67C20.06 16.74 19.67 18.11 18.71 19.5ZM13 3.5C13.73 2.67 14.94 2.04 15.94 2C16.07 3.17 15.6 4.35 14.9 5.19C14.21 6.04 13.07 6.7 11.95 6.61C11.8 5.46 12.36 4.26 13 3.5Z" fill="currentColor"/>
            </svg>
            Download for iOS
          </button>
        </div>

        <!-- Continue to web - dismiss modal and use web app -->
        <button onclick="window.continueWithWebVersion && window.continueWithWebVersion()" style="
          width: 100%;
          padding: 0.75rem 1.5rem;
          background: #f1f5f9;
          color: #0F172A;
          border: 1px solid #e2e8f0;
          border-radius: 0.75rem;
          font-size: 0.9375rem;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
        " onmouseover="this.style.background='#e2e8f0'; this.style.borderColor='#cbd5e1';" 
           onmouseout="this.style.background='#f1f5f9'; this.style.borderColor='#e2e8f0';">
          Continue to web
        </button>
      </div>
    </div>
  `;
}

function renderTrialExpiredScreen(company) {
  const companyName = 'Helo App';

  // Ensure Material Icons font is available for the sad face icon
  if (!document.querySelector('link[href*="Material+Icons"]')) {
    const materialIconsLink = document.createElement('link');
    materialIconsLink.href = 'https://fonts.googleapis.com/icon?family=Material+Icons';
    materialIconsLink.rel = 'stylesheet';
    document.head.appendChild(materialIconsLink);
  }

  document.getElementById('root').innerHTML = `
    <div style="
      min-height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(135deg, #f59e0b 0%, #dc2626 100%);
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
      padding: 1rem;
    ">
      <div style="
        background: white;
        padding: 2.5rem;
        border-radius: 1rem;
        box-shadow: 0 20px 40px rgba(0,0,0,0.15);
        max-width: 480px;
        width: 100%;
        text-align: center;
      ">
        <!-- Lock Icon -->
        <div style="
          width: 80px;
          height: 80px;
          background: linear-gradient(135deg, #f59e0b 0%, #dc2626 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1.5rem;
        ">
          <span class="material-icons" style="font-size: 44px; color: white;">sentiment_very_dissatisfied</span>
        </div>
        
        <!-- Trial Expired Title -->
        <h1 style="
          color: #0F172A;
          font-size: 1.75rem;
          font-weight: 700;
          margin: 0 0 1rem 0;
        ">Trial Expired</h1>
        
        <!-- Message -->
        <p style="
          color: #475569;
          font-size: 1rem;
          line-height: 1.6;
          margin: 0 0 1.5rem 0;
        ">
          Your 60-day trial for <strong style="color: #0F172A;">${companyName}</strong> is over.
        </p>
        
        <!-- Contact Support -->
        <div style="
          background: #FEF3C7;
          border: 1px solid #FCD34D;
          border-radius: 0.5rem;
          padding: 1rem;
          margin-bottom: 1.5rem;
        ">
          <p style="
            color: #92400E;
            font-size: 0.9375rem;
            margin: 0;
          ">
            If you are having issue contact us at
          </p>
          <a href="mailto:contact@hellohabanero.com" style="
            color: #D97706;
            font-weight: 600;
            font-size: 1rem;
            text-decoration: none;
            display: inline-block;
            margin-top: 0.5rem;
          ">
            contact@hellohabanero.com
          </a>
        </div>
        
        <a href="javascript:void(0)" onclick="startBillingUpgrade()" style="
          display: block;
          width: 100%;
          background: linear-gradient(135deg, #f97316 0%, #ea580c 50%, #dc2626 100%);
          color: white;
          text-align: center;
          padding: 0.85rem 1.25rem;
          border-radius: 0.75rem;
          font-weight: 700;
          letter-spacing: 0.3px;
          text-decoration: none;
          margin-bottom: 1.25rem;
          box-shadow: 0 12px 24px rgba(220, 38, 38, 0.25);
          transition: transform 0.15s ease, box-shadow 0.15s ease;
          cursor: pointer;
        " onmouseover="this.style.transform='translateY(-1px)'; this.style.boxShadow='0 16px 28px rgba(220, 38, 38, 0.3)';"
          onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 12px 24px rgba(220, 38, 38, 0.25)';">
          Upgrade here
        </a>
        
        <!-- Logo -->
        <div style="
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.5rem;
          color: #94A3B8;
          font-size: 0.875rem;
        ">
          <img src="./icons/helo-app-logo.png" alt="Helo App" style="height: 24px; opacity: 0.7;" onerror="this.style.display='none'">
          <span>Helo App</span>
        </div>
      </div>
    </div>
  `;
}

// Clean loading screen shown while session and user data load (replaces white screen)
function renderAppLoadingScreen() {
  const root = document.getElementById('root');
  if (!root) return;
  root.innerHTML = `
    <div style="
      min-height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #F7F8FB;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    ">
      <div style="
        background: #ffffff;
        padding: 2rem 2.5rem;
        border-radius: 1rem;
        box-shadow: 0 4px 24px rgba(0,0,0,0.06);
        text-align: center;
        min-width: 280px;
      ">
        <div style="
          width: 40px;
          height: 40px;
          margin: 0 auto 1.25rem;
          border: 3px solid #E5E7EB;
          border-top-color: #f59e0b;
          border-radius: 50%;
          animation: helo-load-spin 0.9s linear infinite;
        "></div>
        <p style="
          margin: 0;
          color: #64748b;
          font-size: 0.9375rem;
          font-weight: 500;
        ">Loading your workspace…</p>
      </div>
    </div>
    <style>
      @keyframes helo-load-spin {
        to { transform: rotate(360deg); }
      }
    </style>
  `;
}

// Initialize app
async function initApp() {
  try {
    renderAppLoadingScreen();
    // Set page title for browser tab and SEO (Helo, not Hello)
    if (typeof document !== 'undefined' && document.title !== 'Helo - Perfect Tool') {
      document.title = 'Helo - Perfect Tool';
    }
    // Check if we're on the reset-password page
    const currentPath = window.location.pathname;
    if (currentPath === '/reset-password' || currentPath.includes('/reset-password')) {
      // Handle password reset flow
      handlePasswordResetPage();
      return;
    }

    const { data: { session } } = await supabase.auth.getSession();
    if (session?.user) {
      console.log('✅ Session found for user:', session.user.id);

      // Check for pending signup data and complete it
      await checkAndCompletePendingSignup();

      await loadUserData();

      // Verify user has a valid company - if not, they shouldn't access the app
      if (!currentCompany) {
        console.warn('⚠️ User has no company assigned, checking pending signup...');
        const pendingData = localStorage.getItem('pendingSignupData');
        if (pendingData) {
          try {
            const signupData = JSON.parse(pendingData);
            console.log('📝 Attempting to complete account setup...');
            await completeAccountSetup(session.user.id, signupData);
            await loadUserData(); // Reload after setup
          } catch (err) {
            console.error('Failed to complete pending signup:', err);
          }
        }
      }

      // ============================================
      // MOBILE / SMALL VIEWPORT - Recommend native app; user can choose "Continue to web"
      // ============================================
      const userChoseWeb = (function () {
        try {
          return typeof sessionStorage !== 'undefined' && sessionStorage.getItem('helo_use_web_version') === '1';
        } catch (e) { return false; }
      })();
      if (window.isMobileDevice && window.isMobileDevice() && !userChoseWeb) {
        console.log('📱 Small viewport / mobile detected - showing mobile app recommendation');
        renderClientLockedScreen();
        return; // Stop here unless user clicks "Continue to web"
      }

      // ============================================
      // TRIAL CHECK - Block app if trial expired
      // ============================================
      if (isCompanyTrialExpired(currentCompany)) {
        console.log('🔒 Trial expired for company:', currentCompany?.name);
        renderTrialExpiredScreen(currentCompany);
        return; // Stop here - don't render anything else
      }

      // ============================================
      // CHECK FOR GOOGLE CALENDAR OAUTH CALLBACK
      // ============================================
      // If URL has callback_result param, we're coming back from OAuth - show integration screen
      const urlParams = new URLSearchParams(window.location.search);
      const callbackResult = urlParams.get('callback_result');
      const errorParam = urlParams.get('error');
      if (callbackResult || errorParam) {
        currentScreen = 'google-calendar-integration';
      }

      renderPMTool();
    } else {
      renderLogin();
    }
  } catch (error) {
    console.error('Error initializing app:', error);
    renderLogin();
  }
}

// Load user data
async function loadUserData() {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return;

  currentUser = user;

  // Initialize Eva visibility (will be updated after profile loads)
  evaVisible = false;
  showEvaWelcome = false;

  // Load profile WITHOUT join to avoid RLS recursion issues
  // Load company_members separately instead
  const { data: profileData, error: profileError } = await supabase
    .from('profiles')
    .select('*')
    .eq('id', user.id)
    .maybeSingle();

  if (profileError) {
    console.error('❌ Error loading profile:', profileError);
  }

  // Load company_members separately to avoid RLS recursion
  // Note: Users (especially CLIENTs) can belong to multiple companies
  let companyMembersData = [];
  if (profileData) {
    const { data: membersData, error: membersError } = await supabase
      .from('company_members')
      .select('role, company_id')
      .eq('user_id', user.id);

    if (membersError) {
      console.error('❌ Error loading company_members:', membersError);
    } else {
      companyMembersData = membersData || [];
      // Attach to profileData for compatibility
      if (profileData) {
        profileData.company_members = companyMembersData;
      }
    }
  }

  currentProfile = profileData;

  // Set company_role from company_members if available
  if (profileData?.company_members && profileData.company_members.length > 0) {
    // Use the first company membership's role
    currentProfile.company_role = profileData.company_members[0].role;

    // Set default screen to 'dashboard' for CLIENTs
    if (currentProfile.company_role === 'CLIENT' && currentScreen === 'team') {
      currentScreen = 'dashboard';
    }
  }

  // Load company
  // For CLIENT users, company comes from company_members, not profile.company_id
  // Handle multiple company memberships: prefer profile.company_id, then first company_members entry
  let companyIdToLoad = profileData?.company_id;
  if (!companyIdToLoad && companyMembersData.length > 0) {
    // Use the first company membership if profile.company_id is not set
    companyIdToLoad = companyMembersData[0].company_id;
  }

  if (companyIdToLoad) {
    const { data: companyData } = await supabase
      .from('companies')
      .select('*')
      .eq('id', companyIdToLoad)
      .maybeSingle();
    currentCompany = companyData;
    // Store is_hh_client flag for easy access
    if (companyData) {
      currentCompany.is_hh_client = companyData.is_hh_client || false;
      // Load global tax rate from company data
      globalTaxRate = parseFloat(companyData.global_tax_rate || 0);
    }

    // Set Eva visibility based on role and company premium status
    const userRole = profileData?.company_role || profileData?.role || 'USER';
    const isClient = userRole === 'CLIENT';
    const isCompanyMember = ['OWNER', 'MANAGER', 'EMPLOYEE'].includes(userRole);
    const hasCompany = companyIdToLoad != null;
    const isHHAdmin = profileData?.is_hh_admin || false;
    const isCompanyPremium = companyData?.is_premium || false;

    // Eva should ONLY be visible for:
    // 1. HH Admins (full access)
    // 2. Company members (OWNER/MANAGER/EMPLOYEE) with a PREMIUM company
    evaVisible = isHHAdmin || (isCompanyMember && hasCompany && isCompanyPremium);
    // Check if Eva welcome was dismissed today
    const today = new Date().toDateString();
    const dismissedDate = localStorage.getItem('evaWelcomeDismissedDate');
    showEvaWelcome = evaVisible && dismissedDate !== today; // Show welcome message if not dismissed today
  }

  await loadTasks();
  await loadTeamMembers();
  await loadContacts();
  await loadChats();
  await loadSalesOpportunities();
  await loadAppointments();
  await loadReminders();
  await loadWeeklyChampions();
  await loadResources();
  await loadServices();
  await loadPortfolioItems();
  await loadClients();
  await loadNotifications();
  await loadVaultQuickStats();
  setupNotificationSubscription();
}

// ============================================
// VAULT (DOCUMENTS) DATA LOADING
// ============================================

// Load vault quick stats (filtered by user's folder access)
async function loadVaultQuickStats() {
  if (!currentCompany || !currentUser) return;

  try {
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
    const thirtyDaysAgo = new Date();
    thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

    // First, get user's accessible folder IDs (folders they created OR have permission for)
    const [foldersCreated, permissionsResult] = await Promise.all([
      supabase.from('vault_folders').select('id')
        .eq('company_id', currentCompany.id)
        .eq('created_by', currentUser.id)
        .eq('is_deleted', false),
      supabase.from('vault_permissions').select('item_id')
        .eq('company_id', currentCompany.id)
        .eq('item_type', 'folder')
        .eq('user_id', currentUser.id)
    ]);

    const accessibleFolderIds = new Set();
    (foldersCreated.data || []).forEach(f => accessibleFolderIds.add(f.id));
    (permissionsResult.data || []).forEach(p => accessibleFolderIds.add(p.item_id));
    const folderIdArray = Array.from(accessibleFolderIds);

    // Get recent uploads count (only from accessible folders)
    let recentUploadsCount = 0;
    if (folderIdArray.length > 0) {
      const { count } = await supabase.from('vault_files')
        .select('*', { count: 'exact', head: true })
        .eq('company_id', currentCompany.id)
        .eq('is_deleted', false)
        .gte('created_at', sevenDaysAgo.toISOString())
        .in('folder_id', folderIdArray);
      recentUploadsCount = count || 0;
    }
    // Also count root-level files user created
    const { count: rootFilesCount } = await supabase.from('vault_files')
      .select('*', { count: 'exact', head: true })
      .eq('company_id', currentCompany.id)
      .eq('is_deleted', false)
      .is('folder_id', null)
      .eq('created_by', currentUser.id)
      .gte('created_at', sevenDaysAgo.toISOString());
    recentUploadsCount += (rootFilesCount || 0);

    // Active projects count (only folders user has access to)
    const activeProjectsCount = folderIdArray.length;

    // Shared by me count
    const { count: sharedCount } = await supabase.from('vault_permissions')
      .select('*', { count: 'exact', head: true })
      .eq('company_id', currentCompany.id)
      .eq('created_by', currentUser.id);

    vaultQuickStats = {
      recent_uploads: recentUploadsCount,
      active_projects: activeProjectsCount,
      shared_by_me: sharedCount || 0
    };
  } catch (error) {
    console.error('Error loading vault stats:', error);
  }
}

// Load vault folders
async function loadVaultFolders(parentId = null, includeDeleted = false) {
  if (!currentCompany) return [];

  try {
    let query = supabase
      .from('vault_folders')
      .select('*')
      .eq('company_id', currentCompany.id);

    // Use .is() for null checks, .eq() for actual UUIDs
    if (parentId === null || parentId === undefined) {
      query = query.is('parent_id', null);
    } else {
      query = query.eq('parent_id', parentId);
    }

    query = query.order('name', { ascending: true });

    if (!includeDeleted) {
      query = query.eq('is_deleted', false);
    }

    const { data, error } = await query;
    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error('Error loading vault folders:', error);
    return [];
  }
}

// Load vault files
async function loadVaultFiles(folderId = null, includeDeleted = false) {
  if (!currentCompany) return [];

  try {
    let query = supabase
      .from('vault_files')
      .select('*')
      .eq('company_id', currentCompany.id);

    // Use .is() for null checks, .eq() for actual UUIDs
    if (folderId === null || folderId === undefined) {
      query = query.is('folder_id', null);
    } else {
      query = query.eq('folder_id', folderId);
    }

    query = query.order('name', { ascending: true });

    if (!includeDeleted) {
      query = query.eq('is_deleted', false);
    }

    const { data, error } = await query;
    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error('Error loading vault files:', error);
    return [];
  }
}

// Load vault breadcrumbs
async function loadVaultBreadcrumbs(folderId) {
  if (!folderId) {
    vaultBreadcrumbs = [];
    return;
  }

  try {
    const path = [];
    let currentId = folderId;

    while (currentId) {
      const { data } = await supabase
        .from('vault_folders')
        .select('*')
        .eq('id', currentId)
        .single();

      if (!data) break;

      path.unshift(data);
      currentId = data.parent_id;
    }

    vaultBreadcrumbs = path;
  } catch (error) {
    console.error('Error loading breadcrumbs:', error);
    vaultBreadcrumbs = [];
  }
}

// ============================================
// VAULT IMAGE PREVIEW FUNCTIONS
// ============================================

// Check if file is an image
window.isVaultImageFile = function (mimeType) {
  if (!mimeType) return false;
  const imageTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp', 'image/svg+xml', 'image/bmp', 'image/tiff'];
  return imageTypes.some(t => mimeType.toLowerCase().includes(t.split('/')[1])) || mimeType.toLowerCase().startsWith('image/');
};

// Cache for signed URLs (to avoid re-fetching)
window.vaultSignedUrlCache = window.vaultSignedUrlCache || {};

// Prefetch signed URL on hover so PDF opens faster on click (no-op if already cached)
window.prefetchVaultPdfUrl = function (storagePath) {
  if (storagePath && window.getVaultFileSignedUrl) {
    window.getVaultFileSignedUrl(storagePath, 3600).catch(function () { });
  }
};

// Get signed URL for vault file (for image preview) - async version
window.getVaultFileSignedUrl = async function (storagePath, expiresIn = 3600) {
  if (!storagePath) return null;

  // Check cache first
  const cached = window.vaultSignedUrlCache[storagePath];
  if (cached && cached.expiresAt > Date.now()) {
    return cached.url;
  }

  try {
    const { data, error } = await supabase.storage.from('vault').createSignedUrl(storagePath, expiresIn);
    if (error) {
      console.error('Error getting signed URL:', error);
      return null;
    }

    // Cache the URL
    window.vaultSignedUrlCache[storagePath] = {
      url: data.signedUrl,
      expiresAt: Date.now() + (expiresIn * 1000) - 60000 // Expire 1 min early
    };

    return data.signedUrl;
  } catch (e) {
    console.error('Error getting signed URL:', e);
    return null;
  }
};

// Check if file is a PDF
window.isVaultPdfFile = function (mimeType) {
  return mimeType && mimeType.toLowerCase().includes('pdf');
};

// Check if file is a Word document
window.isVaultWordFile = function (mimeType, fileName) {
  if (!mimeType && !fileName) return false;
  const wordMimes = ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
  const wordExts = ['.doc', '.docx'];
  return wordMimes.some(m => (mimeType || '').toLowerCase().includes(m.split('/')[1])) ||
    wordExts.some(ext => (fileName || '').toLowerCase().endsWith(ext));
};

// Check if file is a text file
window.isVaultTextFile = function (mimeType, fileName) {
  if (!mimeType && !fileName) return false;
  const textMimes = ['text/plain', 'text/csv', 'text/markdown'];
  const textExts = ['.txt', '.csv', '.md', '.json', '.xml', '.log'];
  return textMimes.some(m => (mimeType || '').toLowerCase().includes(m.split('/')[1])) ||
    textExts.some(ext => (fileName || '').toLowerCase().endsWith(ext));
};

// Check if file is DOCX or PDF (eligible for "Update document" feature)
window.isVaultDocxOrPdf = function (mimeType, fileName) {
  if (!mimeType && !fileName) return false;
  const n = (fileName || '').toLowerCase();
  const m = (mimeType || '').toLowerCase();
  const isPdf = n.endsWith('.pdf') || m.includes('pdf');
  const isDocx = n.endsWith('.docx') || m.includes('openxmlformats-officedocument.wordprocessingml');
  return isPdf || isDocx;
};

// Format file size
window.formatVaultFileSize = function (bytes) {
  if (!bytes) return '';
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
};

// Create close button for modals (reusable)
window.createVaultCloseButton = function (onClose) {
  return `
    <button onclick="${onClose}" style="position: fixed; top: 20px; right: 20px; background: #1f2937; border: 2px solid #374151; color: white; width: 48px; height: 48px; border-radius: 50%; cursor: pointer; font-size: 24px; display: flex; align-items: center; justify-content: center; z-index: 10004; box-shadow: 0 4px 12px rgba(0,0,0,0.4); transition: all 0.2s;" onmouseover="this.style.background='#374151'; this.style.transform='scale(1.1)'" onmouseout="this.style.background='#1f2937'; this.style.transform='scale(1)'">
      ×
    </button>
  `;
};

// Show image preview modal (async)
window.showVaultImagePreview = async function (file) {
  if (!file || !file.storage_path) return;

  // Show loading state
  const loadingOverlay = document.createElement('div');
  loadingOverlay.id = 'vault-file-loading-overlay';
  loadingOverlay.style.cssText = 'position: fixed; inset: 0; background: rgba(0,0,0,0.85); z-index: 10003; display: flex; align-items: center; justify-content: center;';
  loadingOverlay.innerHTML = '<div style="color: white; font-size: 16px;">Loading image...</div>';
  document.body.appendChild(loadingOverlay);

  const url = await window.getVaultFileSignedUrl(file.storage_path);

  // Remove loading overlay
  loadingOverlay.remove();

  if (!url) {
    if (window.vaultToast) window.vaultToast('Could not load image', 'error');
    return;
  }

  // Create modal overlay
  const overlay = document.createElement('div');
  overlay.id = 'vault-image-preview-overlay';
  overlay.style.cssText = 'position: fixed; inset: 0; background: rgba(0,0,0,0.9); z-index: 10003; display: flex; align-items: center; justify-content: center; padding: 20px;';
  overlay.onclick = function (e) { if (e.target === overlay) overlay.remove(); };

  overlay.innerHTML = `
    ${window.createVaultCloseButton("document.getElementById('vault-image-preview-overlay').remove()")}
    <div style="max-width: 95vw; max-height: 95vh; position: relative; display: flex; flex-direction: column; align-items: center;">
      <img src="${url}" alt="${(file.name || '').replace(/"/g, '&quot;')}" style="max-width: 100%; max-height: calc(95vh - 80px); object-fit: contain; border-radius: 8px; box-shadow: 0 25px 50px -12px rgba(0,0,0,0.5);" onclick="event.stopPropagation();" />
      <div style="text-align: center; margin-top: 16px; color: white; font-size: 14px;">
        <div style="font-weight: 600; font-size: 16px;">${(file.name || '').replace(/</g, '&lt;')}</div>
        <div style="opacity: 0.7; font-size: 13px; margin-top: 6px;">${window.formatVaultFileSize(file.size_bytes)}</div>
      </div>
    </div>
  `;

  document.body.appendChild(overlay);

  // Close on Escape key
  const handleEscape = function (e) {
    if (e.key === 'Escape') {
      overlay.remove();
      document.removeEventListener('keydown', handleEscape);
    }
  };
  document.addEventListener('keydown', handleEscape);
};

// Show PDF preview modal (async) - show modal immediately with loading, then fill iframe when URL is ready
window.showVaultPdfPreview = async function (file) {
  if (!file || !file.storage_path) return;

  var overlay = document.createElement('div');
  overlay.id = 'vault-pdf-preview-overlay';
  overlay.style.cssText = 'position: fixed; inset: 0; background: rgba(0,0,0,0.9); z-index: 10003; display: flex; flex-direction: column; padding: 20px;';
  overlay.innerHTML = `
    ${window.createVaultCloseButton ? window.createVaultCloseButton("document.getElementById('vault-pdf-preview-overlay') && document.getElementById('vault-pdf-preview-overlay').remove()") : ''}
    <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; padding-right: 60px;">
      <div style="color: white;">
        <div style="font-weight: 600; font-size: 18px;">${(file.name || '').replace(/</g, '&lt;')}</div>
        <div style="opacity: 0.7; font-size: 13px; margin-top: 4px;">${window.formatVaultFileSize ? window.formatVaultFileSize(file.size_bytes) : ''}</div>
      </div>
      <div id="vault-pdf-download-wrap" style="display: none; align-items: center; gap: 10px;"></div>
    </div>
    <div id="vault-pdf-iframe-container" style="flex: 1; background: #1e293b; border-radius: 8px; overflow: hidden; display: flex; align-items: center; justify-content: center;">
      <div style="color: #94a3b8; font-size: 15px; display: flex; align-items: center; gap: 12px;" id="vault-pdf-loading-msg">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="animation: spin 1s linear infinite;"><circle cx="12" cy="12" r="10" stroke-opacity="0.3"></circle><path d="M12 2a10 10 0 0 1 10 10" stroke-linecap="round"></path></svg>
        Loading PDF…
      </div>
    </div>
  `;
  document.body.appendChild(overlay);

  var handleEscape = function (e) {
    if (e.key === 'Escape') {
      overlay.remove();
      document.removeEventListener('keydown', handleEscape);
    }
  };
  document.addEventListener('keydown', handleEscape);

  var url = await window.getVaultFileSignedUrl(file.storage_path);
  var container = document.getElementById('vault-pdf-iframe-container');
  var loadingMsg = document.getElementById('vault-pdf-loading-msg');
  var downloadWrap = document.getElementById('vault-pdf-download-wrap');

  if (!url || !container) {
    if (loadingMsg) loadingMsg.innerHTML = '<span style="color: #f87171;">Could not load PDF. Try again or download.</span>';
    if (window.vaultToast) window.vaultToast('Could not load PDF', 'error');
    return;
  }

  if (loadingMsg) loadingMsg.remove();
  var iframe = document.createElement('iframe');
  iframe.src = url + '#toolbar=1&navpanes=1';
  iframe.style.cssText = 'width: 100%; height: 100%; border: none;';
  iframe.title = 'PDF Preview';
  container.appendChild(iframe);

  if (downloadWrap) {
    downloadWrap.style.display = 'flex';
    var a = document.createElement('a');
    a.href = url;
    a.download = (file.name || 'document.pdf').replace(/"/g, '');
    a.style.cssText = 'padding: 10px 20px; background: #f59e0b; color: white; text-decoration: none; border-radius: 8px; font-weight: 500; display: flex; align-items: center; gap: 8px;';
    a.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg> Download';
    a.onclick = function (e) { e.stopPropagation(); };
    downloadWrap.appendChild(a);
  }
};

// Show Word (.docx) preview modal using mammoth.js (client-side conversion; no Microsoft dependency)
window.showVaultWordPreview = async function (file) {
  if (!file || !file.storage_path) return;
  const fileName = (file.name || '').toLowerCase();
  const isDocx = fileName.endsWith('.docx') || (file.mime_type || '').toLowerCase().includes('openxmlformats-officedocument.wordprocessingml');
  if (!isDocx) {
    await window.showVaultDocumentPreview(file);
    return;
  }

  const loadingOverlay = document.createElement('div');
  loadingOverlay.id = 'vault-file-loading-overlay';
  loadingOverlay.style.cssText = 'position: fixed; inset: 0; background: rgba(0,0,0,0.85); z-index: 10003; display: flex; align-items: center; justify-content: center;';
  loadingOverlay.innerHTML = '<div style="color: white; font-size: 16px;">Loading document...</div>';
  document.body.appendChild(loadingOverlay);

  const url = await window.getVaultFileSignedUrl(file.storage_path);
  if (!url) {
    loadingOverlay.remove();
    if (window.vaultToast) window.vaultToast('Could not load file', 'error');
    return;
  }

  let arrayBuffer;
  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error(res.statusText);
    arrayBuffer = await res.arrayBuffer();
  } catch (e) {
    loadingOverlay.remove();
    if (window.vaultToast) window.vaultToast('Could not load file', 'error');
    return;
  }

  if (typeof mammoth === 'undefined') {
    loadingOverlay.remove();
    if (window.vaultToast) window.vaultToast('Word preview not available', 'error');
    await window.showVaultDocumentPreview(file);
    return;
  }

  let htmlContent = '';
  try {
    const result = await mammoth.convertToHtml({ arrayBuffer: arrayBuffer });
    htmlContent = result.value || '';
    if (result.messages && result.messages.length) console.log('Mammoth messages:', result.messages);
  } catch (e) {
    loadingOverlay.remove();
    console.error('Mammoth convert error:', e);
    if (window.vaultToast) window.vaultToast('Could not preview document', 'error');
    await window.showVaultDocumentPreview(file);
    return;
  }

  loadingOverlay.remove();

  const overlay = document.createElement('div');
  overlay.id = 'vault-word-preview-overlay';
  overlay.style.cssText = 'position: fixed; inset: 0; background: rgba(0,0,0,0.9); z-index: 10003; display: flex; flex-direction: column; padding: 20px;';
  overlay.innerHTML = `
    ${window.createVaultCloseButton("document.getElementById('vault-word-preview-overlay').remove()")}
    <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; padding-right: 60px;">
      <div style="color: white;">
        <div style="font-weight: 600; font-size: 18px;">${(file.name || '').replace(/</g, '&lt;')}</div>
        <div style="opacity: 0.7; font-size: 13px; margin-top: 4px;">${window.formatVaultFileSize ? window.formatVaultFileSize(file.size_bytes) : ''}</div>
      </div>
      <div style="display: flex; align-items: center; gap: 10px;">
        <a href="${url}" download="${(file.name || 'document.docx').replace(/"/g, '&quot;')}" style="padding: 10px 20px; background: #f59e0b; color: white; text-decoration: none; border-radius: 8px; font-weight: 500;">Download</a>
      </div>
    </div>
    <div id="vault-word-preview-body" style="flex: 1; overflow: auto; background: #fff; border-radius: 8px; padding: 24px; font-size: 15px; line-height: 1.6; color: #111827;"></div>
  `;
  document.body.appendChild(overlay);

  const bodyEl = document.getElementById('vault-word-preview-body');
  if (bodyEl) {
    bodyEl.innerHTML = htmlContent;
    bodyEl.querySelectorAll('script').forEach(function (s) { s.remove(); });
  }

  const handleEscape = function (e) {
    if (e.key === 'Escape') {
      overlay.remove();
      document.removeEventListener('keydown', handleEscape);
    }
  };
  document.addEventListener('keydown', handleEscape);
};

// Show document preview modal (for Word docs and other files - download only)
window.showVaultDocumentPreview = async function (file) {
  if (!file || !file.storage_path) return;

  // Show loading state
  const loadingOverlay = document.createElement('div');
  loadingOverlay.id = 'vault-file-loading-overlay';
  loadingOverlay.style.cssText = 'position: fixed; inset: 0; background: rgba(0,0,0,0.85); z-index: 10003; display: flex; align-items: center; justify-content: center;';
  loadingOverlay.innerHTML = '<div style="color: white; font-size: 16px;">Loading...</div>';
  document.body.appendChild(loadingOverlay);

  const url = await window.getVaultFileSignedUrl(file.storage_path);

  // Remove loading overlay
  loadingOverlay.remove();

  if (!url) {
    if (window.vaultToast) window.vaultToast('Could not load file', 'error');
    return;
  }

  // Determine icon based on file type
  const isWord = window.isVaultWordFile(file.mime_type, file.name);
  const iconColor = isWord ? '#2563eb' : '#6b7280';
  const iconSvg = isWord
    ? '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><path d="M9 15l2 2 4-4"></path>'
    : '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline>';

  // Create modal overlay
  const overlay = document.createElement('div');
  overlay.id = 'vault-doc-preview-overlay';
  overlay.style.cssText = 'position: fixed; inset: 0; background: rgba(0,0,0,0.9); z-index: 10003; display: flex; align-items: center; justify-content: center; padding: 20px;';
  overlay.onclick = function (e) { if (e.target === overlay) overlay.remove(); };

  overlay.innerHTML = `
    ${window.createVaultCloseButton("document.getElementById('vault-doc-preview-overlay').remove()")}
    <div style="background: white; border-radius: 16px; padding: 48px; max-width: 400px; text-align: center; box-shadow: 0 25px 50px -12px rgba(0,0,0,0.5);" onclick="event.stopPropagation();">
      <div style="width: 80px; height: 80px; margin: 0 auto 24px; background: ${isWord ? '#eff6ff' : '#f3f4f6'}; border-radius: 16px; display: flex; align-items: center; justify-content: center;">
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="${iconColor}" stroke-width="1.5">${iconSvg}</svg>
      </div>
      <div style="font-size: 20px; font-weight: 600; color: #111827; margin-bottom: 8px; word-break: break-word;">${(file.name || '').replace(/</g, '&lt;')}</div>
      <div style="font-size: 14px; color: #6b7280; margin-bottom: 32px;">${window.formatVaultFileSize(file.size_bytes)}${isWord ? ' • Word Document' : ''}</div>
      <a href="${url}" download="${(file.name || 'document').replace(/"/g, '&quot;')}" style="display: inline-flex; align-items: center; gap: 10px; padding: 14px 32px; background: #1f2937; color: white; text-decoration: none; border-radius: 10px; font-weight: 600; font-size: 16px; transition: all 0.2s;" onmouseover="this.style.background='#374151'" onmouseout="this.style.background='#1f2937'">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
        Download File
      </a>
      <div style="margin-top: 16px; font-size: 12px; color: #9ca3af;">Click to download and open in your default application</div>
    </div>
  `;

  document.body.appendChild(overlay);

  // Close on Escape key
  const handleEscape = function (e) {
    if (e.key === 'Escape') {
      overlay.remove();
      document.removeEventListener('keydown', handleEscape);
    }
  };
  document.addEventListener('keydown', handleEscape);
};

// Universal file preview handler - determines which preview to use
window.showVaultFilePreview = async function (file) {
  if (!file) return;

  const mimeType = file.mime_type || '';
  const fileName = (file.name || '').toLowerCase();

  if (window.isVaultImageFile(mimeType)) {
    await window.showVaultImagePreview(file);
  } else if (window.isVaultPdfFile(mimeType)) {
    await window.showVaultPdfPreview(file);
  } else if (window.isVaultWordFile(mimeType, file.name)) {
    if (fileName.endsWith('.docx')) {
      await window.showVaultWordPreview(file);
      return;
    }
    await window.showVaultDocumentPreview(file);
  } else {
    await window.showVaultDocumentPreview(file);
  }
};

// Placeholder version APIs – replace with real DB/storage when you add vault_versions.
window._vaultDocumentVersions = window._vaultDocumentVersions || {}; // fileId -> { current: blob/path, versions: [{ id, timestamp, format, storage_path or blob }] }

window.getLatestDocument = async function (fileId) {
  const { data: row } = await supabase.from('vault_files').select('*').eq('id', fileId).eq('is_deleted', false).single();
  if (!row || !row.storage_path) return null;
  const url = await window.getVaultFileSignedUrl(row.storage_path);
  if (!url) return null;
  const res = await fetch(url);
  if (!res.ok) return null;
  const blob = await res.blob();
  const name = (row.name || '').toLowerCase();
  const format = name.endsWith('.pdf') ? 'pdf' : name.endsWith('.docx') ? 'docx' : 'txt';
  return { file: row, blob, format };
};

window.saveNewLatestVersion = async function (fileId, blob, format, options) {
  const companyId = currentCompany?.id || window.currentCompanyId || localStorage.getItem('selectedCompanyId');
  const userId = currentUser?.id;
  if (!companyId || !userId) throw new Error('Not authenticated');
  const ext = format === 'pdf' ? '.pdf' : '.docx';
  const baseName = (await supabase.from('vault_files').select('name').eq('id', fileId).single()).data?.name?.replace(/\.[^.]+$/, '') || 'document';
  const fileName = baseName + ext;
  const storagePath = `${companyId}/${fileId}_${Date.now()}${ext}`;
  const { error: upErr } = await supabase.storage.from('vault').upload(storagePath, blob, { contentType: format === 'pdf' ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', upsert: false });
  if (upErr) throw upErr;
  const onlyAddToHistory = options && options.onlyAddToHistory;
  if (onlyAddToHistory) return { storage_path: storagePath, name: fileName };
  const { error: dbErr } = await supabase.from('vault_files').update({ name: fileName, storage_path: storagePath, updated_at: new Date().toISOString(), mime_type: format === 'pdf' ? 'application/pdf' : 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', size_bytes: blob.size }).eq('id', fileId);
  if (dbErr) throw dbErr;
  return { storage_path: storagePath, name: fileName };
};

window.listLast3Versions = function (fileId) {
  const v = window._vaultDocumentVersions[fileId];
  return (v && v.versions ? v.versions.slice(0, 3) : []);
};

window.restoreVersion = async function (fileId, versionId) {
  const v = window._vaultDocumentVersions[fileId];
  if (!v || !v.versions) return;
  const ver = v.versions.find(x => x.id === versionId);
  if (!ver || !ver.storage_path) return;
  const url = await window.getVaultFileSignedUrl(ver.storage_path);
  if (!url) return;
  const res = await fetch(url);
  const blob = await res.blob();
  await window.saveNewLatestVersion(fileId, blob, ver.format);
  if (window.vaultToast) window.vaultToast('Version restored.');
  if (window.refreshVaultUI) window.refreshVaultUI();
};

window.viewVersion = async function (fileId, versionId) {
  var v = window._vaultDocumentVersions[fileId];
  if (!v || !v.versions) return;
  var ver = v.versions.find(function (x) { return x.id === versionId; });
  if (!ver || !ver.storage_path) return;
  var url = await window.getVaultFileSignedUrl(ver.storage_path);
  if (!url) return;
  var isPdf = (ver.format || '').toLowerCase() === 'pdf';
  if (isPdf) {
    var overlay = document.createElement('div');
    overlay.id = 'vault-version-view-overlay';
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.9);z-index:10007;display:flex;flex-direction:column;padding:20px;';
    overlay.innerHTML = (window.createVaultCloseButton ? window.createVaultCloseButton("document.getElementById('vault-version-view-overlay').remove();") : '') + '<div style="flex:1;background:#fff;border-radius:8px;overflow:hidden;margin-top:8px;"><iframe id="vault-version-view-iframe" style="width:100%;height:100%;border:none;" title="Version preview"></iframe></div>';
    document.body.appendChild(overlay);
    var iframe = document.getElementById('vault-version-view-iframe');
    if (iframe) iframe.src = url + (url.indexOf('#') !== -1 ? '' : '#toolbar=0');
  } else {
    var overlay = document.createElement('div');
    overlay.id = 'vault-version-view-overlay';
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.9);z-index:10007;display:flex;flex-direction:column;padding:20px;';
    overlay.innerHTML = (window.createVaultCloseButton ? window.createVaultCloseButton("document.getElementById('vault-version-view-overlay').remove();") : '') + '<div style="flex:1;background:#fff;border-radius:8px;overflow:hidden;margin-top:8px;display:flex;flex-direction:column;"><div style="padding:12px 16px;border-bottom:1px solid #e5e7eb;font-weight:600;color:#111;">Version preview</div><div id="vault-version-view-body" style="flex:1;overflow:auto;padding:24px;font-size:14px;line-height:1.6;color:#111;"></div></div>';
    document.body.appendChild(overlay);
    var bodyEl = document.getElementById('vault-version-view-body');
    try {
      var res = await fetch(url);
      var blob = await res.blob();
      var arrayBuffer = await blob.arrayBuffer();
      if (typeof mammoth !== 'undefined' && mammoth.convertToHtml) {
        var mammothResult = await mammoth.convertToHtml({ arrayBuffer: arrayBuffer });
        var html = mammothResult.value || '';
        if (bodyEl) {
          bodyEl.innerHTML = html;
          bodyEl.querySelectorAll('script').forEach(function (s) { s.remove(); });
        }
      } else {
        if (bodyEl) bodyEl.innerHTML = '<p style="color:#6b7280;">Preview not available. <a href="' + url.replace(/"/g, '&quot;') + '" download>Download to view</a>.</p>';
      }
    } catch (err) {
      if (bodyEl) bodyEl.innerHTML = '<p style="color:#dc2626;">Could not load preview. <a href="' + url.replace(/"/g, '&quot;') + '" download>Download to view</a>.</p>';
    }
  }
};

// --- Text extraction and render helpers ---
window.extractTextFromDocx = async function (fileOrBlob) {
  const blob = fileOrBlob && fileOrBlob.blob ? fileOrBlob.blob : fileOrBlob;
  if (!blob) return '';
  const arrayBuffer = await blob.arrayBuffer();
  if (typeof mammoth !== 'undefined' && mammoth.extractRawText) {
    const result = await mammoth.extractRawText({ arrayBuffer: arrayBuffer });
    return (result && result.value) ? result.value : '';
  }
  if (typeof mammoth !== 'undefined' && mammoth.convertToHtml) {
    const result = await mammoth.convertToHtml({ arrayBuffer: arrayBuffer });
    const html = result.value || '';
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.innerText || div.textContent || '';
  }
  return '';
};

window.extractTextFromPdf = async function (fileOrBlob) {
  const blob = fileOrBlob && fileOrBlob.blob ? fileOrBlob.blob : fileOrBlob;
  if (!blob) return '';
  var lib = (typeof pdfjsLib !== 'undefined' ? pdfjsLib : null) || window.pdfjsLib;
  if (lib && lib.getDocument) {
    try {
      if (lib.GlobalWorkerOptions && !lib.GlobalWorkerOptions.workerSrc) {
        lib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
      }
      var arrayBuffer = await blob.arrayBuffer();
      var pdf = await lib.getDocument({ data: arrayBuffer }).promise;
      var text = '';
      for (var i = 1; i <= pdf.numPages; i++) {
        var page = await pdf.getPage(i);
        var content = await page.getTextContent();
        var items = content && content.items;
        if (items && Array.isArray(items)) {
          text += items.map(function (item) { return item && item.str ? item.str : ''; }).join(' ') + '\n';
        }
      }
      return text.trim();
    } catch (e) {
      console.warn('PDF text extraction failed:', e);
      if (window.vaultToast) window.vaultToast('Could not extract PDF text.', 'info');
      return '';
    }
  }
  if (window.vaultToast) window.vaultToast('PDF text extraction requires PDF.js. Load it for full support.', 'info');
  return '';
};

window.applyEditsToText = function (originalText, aiOutput) {
  if (typeof aiOutput === 'string' && aiOutput.trim()) return aiOutput.trim();
  return originalText;
};

// Strip AI preamble from update reply so only the document body is saved (no "Here's what I'll do..." etc.)
// Never return empty if we have substantial content - prefer returning full block over over-stripping.
window.extractDocumentBodyFromUpdateReply = function (rawBlock, fullReply) {
  if (!rawBlock || typeof rawBlock !== 'string') return (fullReply && typeof fullReply === 'string' ? fullReply.trim() : rawBlock) || '';
  var s = rawBlock.trim();
  var lower = s.toLowerCase();
  var candidate = s;
  if (lower.indexOf("here's the updated version") !== -1) {
    var idx = lower.indexOf("here's the updated version");
    candidate = s.slice(idx + "here's the updated version".length).replace(/^[\s:\-\n]+/, '').trim();
    if (candidate.length > 30) s = candidate;
  }
  if (lower.indexOf('updated version:') !== -1 && s.length > 100) {
    var i = lower.indexOf('updated version:');
    candidate = s.slice(i + 'updated version:'.length).replace(/^[\s\n]+/, '').trim();
    if (candidate.length > 30) s = candidate;
  }
  var dashMatch = s.match(/\n\s*---+\s*\n/);
  if (dashMatch) {
    var parts = s.split(dashMatch[0]);
    if (parts.length > 1 && parts[parts.length - 1].trim().length > 20) s = parts[parts.length - 1].trim();
  }
  if (s.startsWith('---')) s = s.replace(/^-+\s*\n?/, '').trim();
  var firstHeading = s.search(/^#\s+/m);
  if (firstHeading !== -1 && firstHeading > 0) {
    candidate = s.slice(firstHeading).trim();
    if (candidate.length > 10) s = candidate;
  }
  s = s.trim();
  if (s.length < 20 && rawBlock.trim().length > 50) return rawBlock.trim();
  return s;
};

// ============================================
// VAULT CRUD FUNCTIONS
// ============================================

// Create folder
window.createVaultFolder = async function (name, parentId = null) {
  if (!currentCompany || !currentUser) {
    alert('Please log in to create folders');
    return;
  }

  if (!name?.trim()) {
    alert('Please enter a folder name');
    return;
  }

  // Show loading state
  const createButton = document.querySelector('#new-folder-modal-overlay button:last-child');
  const originalButtonText = createButton ? createButton.textContent : 'Create';
  if (createButton) {
    createButton.disabled = true;
    createButton.textContent = 'Creating...';
  }

  try {
    console.log('Creating folder:', name.trim(), 'parentId:', parentId);
    const { data, error } = await supabase
      .from('vault_folders')
      .insert({
        company_id: currentCompany.id,
        parent_id: parentId || null,
        name: name.trim(),
        created_by: currentUser.id
      })
      .select()
      .single();

    if (error) {
      console.error('Error creating folder:', error);
      throw error;
    }

    console.log('Folder created successfully:', data);
    window.showNewFolderModal = false;
    // Remove modal immediately
    const modalOverlay = document.getElementById('new-folder-modal-overlay');
    if (modalOverlay) modalOverlay.remove();
    // Re-render in background
    setTimeout(() => {
      window.renderVaultScreen().catch(err => console.error('Error rendering:', err));
    }, 0);
  } catch (error) {
    console.error('Error creating folder:', error);
    alert('Failed to create folder: ' + (error.message || 'Unknown error'));
    // Reset button state
    if (createButton) {
      createButton.disabled = false;
      createButton.textContent = originalButtonText;
    }
  }
};

// Show new folder modal
window.showVaultNewFolderModal = function () {
  window.showNewFolderModal = true;
  // Use setTimeout to prevent blocking and re-render the vault screen
  setTimeout(() => {
    window.renderVaultScreen().catch(err => console.error('Error rendering:', err));
  }, 0);
};

// Upload files
window.uploadVaultFiles = async function (files, folderId = null) {
  console.log('📤 uploadVaultFiles called with folderId:', folderId, 'window.vaultCurrentFolderId:', window.vaultCurrentFolderId, 'window.vaultUploadTargetFolderId:', window.vaultUploadTargetFolderId);

  if (!currentCompany || !currentUser) {
    alert('Please log in to upload files');
    return;
  }

  if (!files || files.length === 0) {
    alert('Please select files to upload');
    return;
  }

  // Use the captured target folder, fallback to passed folderId, fallback to current folder
  const targetFolderId = folderId || window.vaultUploadTargetFolderId || window.vaultCurrentFolderId || null;
  console.log('📤 Final targetFolderId for upload:', targetFolderId);

  // Show loading feedback
  const uploadButton = event?.target?.closest('label') || event?.target;
  const originalText = uploadButton?.textContent;
  if (uploadButton) {
    uploadButton.style.opacity = '0.6';
    uploadButton.style.cursor = 'not-allowed';
  }

  try {
    let successCount = 0;
    let failCount = 0;

    for (const file of files) {
      try {
        const timestamp = Date.now();
        const sanitizedName = file.name.replace(/[^a-zA-Z0-9._-]/g, '_');
        const storagePath = targetFolderId
          ? `${currentCompany.id}/${targetFolderId}/${timestamp}_${sanitizedName}`
          : `${currentCompany.id}/${timestamp}_${sanitizedName}`;

        console.log('📤 Uploading', file.name, 'to storagePath:', storagePath, 'folder_id:', targetFolderId);

        // Upload to storage
        const { error: uploadError } = await supabase.storage
          .from('vault')
          .upload(storagePath, file, {
            contentType: file.type,
            upsert: false
          });

        if (uploadError) {
          console.error('Upload error for', file.name, ':', uploadError);
          failCount++;
          continue;
        }

        // Create database record
        const { error: dbError } = await supabase
          .from('vault_files')
          .insert({
            company_id: currentCompany.id,
            folder_id: targetFolderId,
            name: file.name,
            storage_path: storagePath,
            mime_type: file.type,
            size_bytes: file.size,
            created_by: currentUser.id
          });

        if (dbError) {
          // Clean up storage if DB fails
          await supabase.storage.from('vault').remove([storagePath]);
          console.error('Database error for', file.name, ':', dbError);
          failCount++;
          continue;
        }

        successCount++;
      } catch (fileError) {
        console.error('Error uploading file', file.name, ':', fileError);
        failCount++;
      }
    }

    // Reset button state
    if (uploadButton) {
      uploadButton.style.opacity = '1';
      uploadButton.style.cursor = 'pointer';
    }

    // Show feedback and refresh
    if (successCount > 0) {
      // Clear the target folder after upload
      window.vaultUploadTargetFolderId = null;
      // Refresh the UI to show the new files
      await window.refreshVaultUI();
      if (window.vaultToast) {
        window.vaultToast(`Uploaded ${successCount} file${successCount > 1 ? 's' : ''} successfully`);
      }
      if (failCount > 0) {
        alert(`${failCount} file(s) failed to upload. Check console for details.`);
      }
    } else if (failCount > 0) {
      alert(`Failed to upload ${failCount} file(s). Please check the console for details.`);
    }
  } catch (error) {
    console.error('Error uploading files:', error);
    alert('Failed to upload files: ' + (error.message || 'Unknown error'));
    // Reset button state
    if (uploadButton) {
      uploadButton.style.opacity = '1';
      uploadButton.style.cursor = 'pointer';
    }
  }
};

// Delete item (soft delete)
window.deleteVaultItem = async function (itemType, itemId) {
  if (!currentUser) return;

  try {
    const table = itemType === 'folder' ? 'vault_folders' : 'vault_files';
    const { error } = await supabase
      .from(table)
      .update({
        is_deleted: true,
        deleted_at: new Date().toISOString(),
        deleted_by: currentUser.id
      })
      .eq('id', itemId);

    if (error) throw error;
    await window.renderVaultScreen();
  } catch (error) {
    console.error('Error deleting item:', error);
    alert('Failed to delete: ' + (error.message || 'Unknown error'));
  }
};

// Restore item
window.restoreVaultItem = async function (itemType, itemId) {
  try {
    const table = itemType === 'folder' ? 'vault_folders' : 'vault_files';
    const { error } = await supabase
      .from(table)
      .update({
        is_deleted: false,
        deleted_at: null,
        deleted_by: null
      })
      .eq('id', itemId);

    if (error) throw error;
    await window.renderVaultScreen();
  } catch (error) {
    console.error('Error restoring item:', error);
    alert('Failed to restore: ' + (error.message || 'Unknown error'));
  }
};

// Delete permanently (from trash)
window.deleteVaultItemPermanently = async function (itemType, itemId) {
  const label = itemType === 'folder' ? 'this folder' : 'this file';
  window.vaultConfirm({
    title: 'Permanently delete?',
    message: 'This action cannot be undone. ' + (itemType === 'folder' ? 'The folder and all its contents will be removed forever.' : 'The file will be removed forever.'),
    confirmText: 'Delete forever',
    cancelText: 'Cancel',
    danger: true
  }, async function () {
    try {
      if (itemType === 'folder') {
        const files = await loadVaultFiles(itemId, true);
        for (const file of files) {
          if (file.storage_path) { try { await supabase.storage.from('vault').remove([file.storage_path]); } catch (_) { } }
          await supabase.from('vault_files').delete().eq('id', file.id);
        }
        const subfolders = await loadVaultFolders(itemId, true);
        for (const subfolder of subfolders) {
          await window.deleteVaultItemPermanently('folder', subfolder.id);
        }
        await supabase.from('vault_folders').delete().eq('id', itemId);
      } else {
        const { data: file } = await supabase.from('vault_files').select('storage_path').eq('id', itemId).single();
        if (file?.storage_path) { try { await supabase.storage.from('vault').remove([file.storage_path]); } catch (_) { } }
        await supabase.from('vault_files').delete().eq('id', itemId);
      }
      await window.refreshVaultUI();
      if (window.vaultToast) window.vaultToast('Deleted permanently');
    } catch (error) {
      console.error('Error deleting permanently:', error);
      if (window.vaultToast) window.vaultToast('Failed to delete permanently', 'error');
    }
  });
};

// Navigate to folder
window.navigateVaultFolder = async function (folderId) {
  try {
    vaultCurrentFolderId = folderId === 'null' || folderId === null ? null : folderId;
    // Sync to window so upload button can access it
    window.vaultCurrentFolderId = vaultCurrentFolderId;
    // Switch out of trash/recent/shared view when navigating to a folder
    if (vaultView !== 'home') {
      vaultView = 'home';
    }
    await loadVaultBreadcrumbs(vaultCurrentFolderId);
    // Immediately refresh UI
    await window.refreshVaultUI();
  } catch (error) {
    console.error('Error navigating to folder:', error);
    // Fallback to full render
    if (window.renderPMTool) window.renderPMTool();
  }
};

// Switch vault view
window.switchVaultView = async function (view) {
  try {
    const userRole = currentProfile?.company_role || currentProfile?.role || 'USER';
    const isClient = userRole === 'CLIENT';
    if (isClient && (view === 'trash' || view === 'shared')) {
      view = 'home';
    }
    vaultView = view;
    // When going to trash, always clear folder so we show overall trash (all deleted items)
    if (view === 'trash') {
      vaultCurrentFolderId = null;
      vaultBreadcrumbs = [];
    } else {
      vaultCurrentFolderId = null;
      vaultBreadcrumbs = [];
    }
    // Sync to window so upload button can access it
    window.vaultCurrentFolderId = vaultCurrentFolderId;
    // Immediately refresh UI
    await window.refreshVaultUI();
  } catch (error) {
    console.error('Error switching vault view:', error);
    // Fallback to full render
    if (window.renderPMTool) window.renderPMTool();
  }
};

// Toggle vault view mode (grid/list)
window.setVaultSort = async function (by) {
  vaultSortBy = by || 'modified';
  vaultSortDir = by === 'name' ? 'asc' : 'desc';
  await window.refreshVaultUI();
};

// Vault drag-and-drop: move files/folders into folders (or root)
window.vaultDragStart = function (e, type, id) {
  e.stopPropagation();
  e.dataTransfer.setData('application/json', JSON.stringify({ type: type, id: id }));
  e.dataTransfer.effectAllowed = 'move';
  e.dataTransfer.setData('text/plain', type + ':' + id); // fallback for some browsers
};

window.vaultDropOnFolder = async function (e, targetFolderId) {
  e.preventDefault();
  e.stopPropagation();
  var el = e.currentTarget;
  if (el && el.style) {
    el.style.borderColor = '';
    el.style.backgroundColor = '';
  }
  var raw = e.dataTransfer.getData('application/json');
  if (!raw) raw = e.dataTransfer.getData('text/plain');
  var payload = { type: 'file', id: null };
  try {
    if (raw && raw.indexOf('{') === 0) payload = JSON.parse(raw);
    else if (raw && raw.indexOf(':') !== -1) { var p = raw.split(':'); payload = { type: p[0], id: p[1] }; }
  } catch (_) { }
  if (!payload.id) return;
  await window.vaultMoveByDrag(payload.type, payload.id, targetFolderId === 'root' ? null : targetFolderId);
};

window.vaultMoveByDrag = async function (dragType, dragId, targetFolderId) {
  if (!currentCompany || !currentUser) return;
  try {
    if (dragType === 'folder') {
      if (targetFolderId === dragId) {
        if (window.vaultToast) window.vaultToast('Cannot move a folder into itself', 'error');
        return;
      }
      if (targetFolderId) {
        var currentId = targetFolderId;
        while (currentId) {
          if (currentId === dragId) {
            if (window.vaultToast) window.vaultToast('Cannot move a folder into its own subfolder', 'error');
            return;
          }
          var r = await supabase.from('vault_folders').select('parent_id').eq('id', currentId).maybeSingle();
          currentId = (r.data && r.data.parent_id) ? r.data.parent_id : null;
        }
      }
      var folderUpdate = await supabase.from('vault_folders').update({ parent_id: targetFolderId }).eq('id', dragId).eq('company_id', currentCompany.id).select('id');
      if (folderUpdate.error) throw folderUpdate.error;
      if (window.vaultToast) window.vaultToast('Folder moved');
    } else {
      var fileUpdate = await supabase.from('vault_files').update({ folder_id: targetFolderId }).eq('id', dragId).eq('company_id', currentCompany.id).select('id');
      if (fileUpdate.error) throw fileUpdate.error;
      if (window.vaultToast) window.vaultToast('File moved');
    }
    await window.refreshVaultUI();
  } catch (err) {
    console.error('Vault move error:', err);
    if (window.vaultToast) window.vaultToast('You don\'t have access to move items here', 'error');
  }
};

window.toggleVaultViewMode = async function (mode) {
  try {
    if (mode === null || mode === undefined) {
      // Toggle if no mode specified
      vaultViewMode = vaultViewMode === 'grid' ? 'list' : 'grid';
    } else {
      // Set explicit mode
      vaultViewMode = mode;
    }
    // Immediately refresh UI
    await window.refreshVaultUI();
  } catch (error) {
    console.error('Error toggling view mode:', error);
    // Fallback to full render
    if (window.renderPMTool) window.renderPMTool();
  }
};

// ============================================
// NOTIFICATION SYSTEM
// ============================================

// Load notifications for current user
async function loadNotifications() {
  if (!currentUser?.id) return;

  try {
    const { data, error } = await supabase
      .from('notifications')
      .select('*')
      .eq('user_id', currentUser.id)
      .order('created_at', { ascending: false })
      .limit(100); // Load last 100 notifications

    if (error) throw error;

    notifications = data || [];
    unreadNotificationCount = notifications.filter(n => !n.read_status).length;

    console.log('🔔 Loaded', notifications.length, 'notifications,', unreadNotificationCount, 'unread');
  } catch (error) {
    console.error('Error loading notifications:', error);
    notifications = [];
    unreadNotificationCount = 0;
  }
}

// Setup real-time subscription for notifications
function setupNotificationSubscription() {
  if (!currentUser?.id) return;

  // Unsubscribe from previous subscription if exists
  if (notificationSubscription) {
    supabase.removeChannel(notificationSubscription);
  }

  // Subscribe to new notifications for current user
  notificationSubscription = supabase
    .channel('notifications')
    .on('postgres_changes', {
      event: 'INSERT',
      schema: 'public',
      table: 'notifications',
      filter: `user_id=eq.${currentUser.id}`
    }, (payload) => {
      console.log('🔔 New notification received:', payload.new);
      // Add new notification to the beginning of the array
      notifications.unshift(payload.new);
      if (!payload.new.read_status) {
        unreadNotificationCount++;
      }
      renderPMTool();
    })
    .on('postgres_changes', {
      event: 'UPDATE',
      schema: 'public',
      table: 'notifications',
      filter: `user_id=eq.${currentUser.id}`
    }, (payload) => {
      console.log('🔔 Notification updated:', payload.new);
      // Update notification in array
      const index = notifications.findIndex(n => n.id === payload.new.id);
      if (index !== -1) {
        notifications[index] = payload.new;
        // Recalculate unread count
        unreadNotificationCount = notifications.filter(n => !n.read_status).length;
        renderPMTool();
      }
    })
    .subscribe();
}

// Setup real-time subscription for chat messages
function setupMessageSubscription(chatId) {
  if (!chatId || !currentUser?.id) {
    if (messageSubscription) {
      supabase.removeChannel(messageSubscription);
      messageSubscription = null;
    }
    return;
  }

  // Unsubscribe from previous subscription if exists
  if (messageSubscription) {
    supabase.removeChannel(messageSubscription);
    messageSubscription = null;
  }

  // Subscribe to new messages for the selected chat
  messageSubscription = supabase
    .channel(`chat:${chatId}`)
    .on('postgres_changes', {
      event: 'INSERT',
      schema: 'public',
      table: 'messages',
      filter: `chat_id=eq.${chatId}`
    }, async (payload) => {
      const newMessage = payload.new;

      // Skip messages from current user (already added locally)
      if (newMessage.sender_id === currentUser?.id) {
        return;
      }

      // Skip scheduled messages
      if (newMessage.status === 'scheduled') {
        return;
      }

      // Fetch sender profile
      let senderProfile = null;
      try {
        const { data } = await supabase
          .from('profiles')
          .select('first_name, last_name, avatar_path')
          .eq('id', newMessage.sender_id)
          .single();
        senderProfile = data;
      } catch (error) {
        console.warn('Failed to fetch sender profile:', error);
      }

      // Add message if it doesn't exist
      const messageExists = chatMessages.some(msg => msg.id === newMessage.id);
      if (!messageExists) {
        chatMessages.push({
          ...newMessage,
          profiles: senderProfile || { first_name: '', last_name: '', avatar_path: null }
        });
        await renderPMTool();

        // Auto-scroll to bottom if near bottom
        setTimeout(() => {
          const messagesContainer = document.getElementById('chat-messages-container');
          if (messagesContainer) {
            const isNearBottom = messagesContainer.scrollHeight - messagesContainer.scrollTop - messagesContainer.clientHeight < 100;
            if (isNearBottom) {
              messagesContainer.scrollTop = messagesContainer.scrollHeight;
            }
          }
        }, 100);
      }
    })
    .subscribe();
}

// Mark notification as read and navigate
window.handleNotificationClick = async function (notificationId, linkType, linkId) {
  if (!currentUser?.id) return;

  try {
    // Get the notification object to check type if link info is missing
    const notification = notifications.find(n => n.id === notificationId);
    if (!notification) {
      console.error('Notification not found:', notificationId);
      return;
    }

    // Find all unread notifications of the same type (for grouped notifications)
    const sameTypeUnread = notifications.filter(n =>
      !n.read_status && n.type === notification.type
    );

    // Mark all notifications of the same type as read
    const notificationIdsToMark = sameTypeUnread.map(n => n.id);

    if (notificationIdsToMark.length > 0) {
      const { error } = await supabase
        .from('notifications')
        .update({ read_status: true })
        .in('id', notificationIdsToMark)
        .eq('user_id', currentUser.id);

      if (error) throw error;

      // Update local state
      sameTypeUnread.forEach(n => {
        n.read_status = true;
      });

      // Update unread count
      unreadNotificationCount = Math.max(0, unreadNotificationCount - sameTypeUnread.length);
    }

    // Close popup
    showNotificationsPopup = false;
    window.showNotificationsPopup = false;

    // Use link_type/link_id from notification object if not provided as parameters
    const finalLinkType = linkType || notification.link_type || '';
    const finalLinkId = linkId || notification.link_id || '';

    // Navigate based on link type or notification type
    if (finalLinkType === 'task' && finalLinkId) {
      currentScreen = 'team';
      renderPMTool();
      // Scroll to task if possible
      setTimeout(() => {
        const taskElement = document.querySelector(`[data-task-id="${finalLinkId}"]`);
        if (taskElement) {
          taskElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 500);
    } else if (finalLinkType === 'chat' && finalLinkId) {
      currentScreen = 'chat';
      selectedChatId = finalLinkId;
      renderPMTool();
    } else if (finalLinkType === 'appointment' || finalLinkType === 'reminder' ||
      notification.type?.includes('appointment') || notification.type?.includes('reminder')) {
      currentScreen = 'calendar';
      renderPMTool();
    } else if (finalLinkType === 'time_off' || finalLinkType === 'time_tracking' ||
      notification.type?.includes('time_off') || notification.type?.includes('clock')) {
      currentScreen = 'time-tracking';
      timeTrackingView = 'time-off';
      renderPMTool();
    } else if (notification.type === 'task_assigned' || notification.type === 'task_completed' ||
      notification.type === 'task_overdue') {
      // Task-related notifications go to team page
      currentScreen = 'team';
      renderPMTool();
    } else if (notification.type === 'chat_new' || notification.type === 'chat_message') {
      // Chat notifications - try to get chat_id from metadata
      const chatId = notification.metadata?.chat_id || finalLinkId;
      if (chatId) {
        currentScreen = 'chat';
        selectedChatId = chatId;
        renderPMTool();
      } else {
        currentScreen = 'chat';
        renderPMTool();
      }
    } else if (notification.type === 'service_inquiry') {
      // Service inquiry notifications - check if it's app feedback or regular service inquiry
      const metadata = notification.metadata || {};
      if (metadata.feedback_title) {
        // App feedback notification - navigate to feedback screen
        currentScreen = 'feedback';
        renderPMTool();
      } else {
        // Regular service inquiry - go to chat
        const chatId = metadata.chat_id || finalLinkId;
        if (chatId) {
          currentScreen = 'chat';
          selectedChatId = chatId;
          renderPMTool();
        } else {
          currentScreen = 'chat';
          renderPMTool();
        }
      }
    } else if (finalLinkType === 'form_submission' || notification.type === 'form_submission_new') {
      // Form submission notifications - navigate to intake submissions screen
      currentScreen = 'intake-submissions';
      renderPMTool();
      // Optionally scroll to specific submission if linkId provided
      if (finalLinkId) {
        setTimeout(() => {
          // Reload submissions to ensure the new one is visible
          loadIntakeSubmissions();
        }, 500);
      }
    } else if (finalLinkType === 'contract' || notification.type === 'contract_signed') {
      // Contract notifications - navigate to contracts screen and show contract detail
      currentScreen = 'contracts';
      if (finalLinkId) {
        selectedContractId = finalLinkId;
        contractViewMode = 'detail';
        // Make sure contracts are loaded before viewing
        if (contractsList.length === 0) {
          await loadContracts();
        }
      }
      renderPMTool();
    } else if (finalLinkType === 'sales_opportunity' || finalLinkType === 'opportunity' ||
      notification.type === 'opportunity_created' || notification.type === 'opportunity_won' || notification.type === 'opportunity_lost') {
      // Sales opportunity notifications - navigate to sales page
      currentScreen = 'sales';
      // If linkId is provided, it might be an opportunity ID or contact ID
      // Check metadata for contact_id or use linkId as contact_id
      const metadata = notification.metadata || {};
      const contactId = metadata.contact_id || finalLinkId;
      if (contactId) {
        selectedContactId = contactId;
        // Render the sales page first, then load contact detail
        renderPMTool();
        // Load contact detail view after a short delay to ensure page is rendered
        setTimeout(async () => {
          await updateContactDetailContent();
        }, 100);
      } else {
        // Just navigate to sales page
        renderPMTool();
      }
    } else {
      // Default: just close popup and refresh
      renderPMTool();
    }
  } catch (error) {
    console.error('Error handling notification click:', error);
    window.showNotification('Failed to open notification', 'error');
  }
};

// Get time ago string
function getTimeAgo(date) {
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  const diffDays = Math.floor(diffMs / 86400000);

  if (diffMins < 1) return 'Just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  return date.toLocaleDateString();
}

// Load tasks with proper filtering
async function loadTasks() {
  if (!currentCompany) return;

  const { data: tasksData, error } = await supabase
    .from('tasks')
    .select(`
      *,
      task_assignees(
        user_id,
        profiles(
          id,
          first_name,
          last_name,
          avatar_path
        )
      ),
      contact:contacts!tasks_contact_id_fkey(
        id,
        first_name,
        last_name
      ),
      project:projects!tasks_project_id_fkey(
        id,
        name
      )
    `)
    .eq('company_id', currentCompany.id)
    .order('due_at', { ascending: true, nullsFirst: false });

  if (error) {
    console.error('Error loading tasks:', error);
    return;
  }

  // Process tasks to match expected format
  tasks = (tasksData || []).map(task => ({
    ...task,
    assigned_members: task.task_assignees?.map(assignee => {
      return {
        id: assignee.profiles.id,
        first_name: assignee.profiles.first_name,
        last_name: assignee.profiles.last_name,
        avatar_path: assignee.profiles.avatar_path
      };
    }) || [],
    contact_name: task.contact ? `${task.contact.first_name || ''} ${task.contact.last_name || ''}`.trim() : null,
    project_name: task.project?.name || null
  }));

  console.log('Loaded tasks:', tasks.length);

  // Load comment counts for all tasks
  await loadTaskCommentCounts();
}

// Load comment counts for all tasks
async function loadTaskCommentCounts() {
  if (!tasks.length) return;

  try {
    const taskIds = tasks.map(task => task.id);

    const { data, error } = await supabase
      .from('task_comments')
      .select('task_id')
      .in('task_id', taskIds);

    if (error) {
      console.error('Error loading comment counts:', error);
      return;
    }

    // Count comments per task
    taskCommentCounts = {};
    data.forEach(comment => {
      taskCommentCounts[comment.task_id] = (taskCommentCounts[comment.task_id] || 0) + 1;
    });

    console.log('📊 Comment counts loaded:', taskCommentCounts);
  } catch (error) {
    console.error('Error loading comment counts:', error);
  }
}

// Load team members (all company members except clients) with roles from company_members
async function loadTeamMembers() {
  if (!currentCompany) return;

  // First get company members with roles
  const { data: companyMembersData, error: membersError } = await supabase
    .from('company_members')
    .select(`
      user_id,
      role,
      profiles!company_members_user_id_fkey(*)
    `)
    .eq('company_id', currentCompany.id)
    .neq('role', 'CLIENT');

  if (membersError) {
    console.error('Error loading company members:', membersError);
    teamMembers = [];
    return;
  }

  // Process team members to include role from company_members
  teamMembers = (companyMembersData || [])
    .filter(item => item.profiles) // Filter out any null profiles
    .map(item => ({
      ...item.profiles,
      company_role: item.role || 'EMPLOYEE'
    }))
    .sort((a, b) => {
      // Sort by role: OWNER first, then MANAGER, then EMPLOYEE
      const roleOrder = { 'OWNER': 0, 'MANAGER': 1, 'EMPLOYEE': 2 };
      return (roleOrder[a.company_role] || 99) - (roleOrder[b.company_role] || 99);
    });

  console.log('👥 Loaded team members:', teamMembers.length);
  console.log('👥 Team members with roles:', teamMembers);
}

// Load contacts
async function loadContacts() {
  if (!currentCompany) return;

  // Try RPC function first
  let contactsData = null;
  let error = null;

  try {
    const result = await supabase
      .rpc('get_sales_contacts', {
        p_company_id: currentCompany.id,
        p_search_query: '',
        p_filters: {},
        p_page: 0,
        p_page_size: 100
      });
    contactsData = result.data;
    error = result.error;
  } catch (e) {
    console.warn('RPC call failed, falling back to direct query:', e);
    error = e;
  }

  // If RPC fails, fall back to direct query from contacts table
  if (error) {
    console.warn('Error loading contacts via RPC, using direct query:', error);

    // Load contacts directly from contacts table (including linked via contact_companies)
    // First get contacts from company_id
    const { data: directContactsData, error: directError } = await supabase
      .from('contacts')
      .select(`
        id,
        first_name,
        last_name,
        phone,
        email,
        company_name,
        role_label,
        notes,
        status,
        pipeline_stage,
        tags,
        owner_id,
        profile_id,
        created_at,
        updated_at,
        last_activity_at
      `)
      .eq('company_id', currentCompany.id)
      .order('first_name', { ascending: true })
      .order('last_name', { ascending: true })
      .limit(100);

    // Also get contacts linked via contact_companies junction table
    let linkedContactsData = [];
    try {
      const { data: linkedContacts, error: linkedError } = await supabase
        .from('contact_companies')
        .select(`
          contact_id,
          contacts!contact_companies_contact_id_fkey(
            id,
            first_name,
            last_name,
            phone,
            email,
            company_name,
            role_label,
            notes,
            status,
            pipeline_stage,
            tags,
            owner_id,
            profile_id,
            created_at,
            updated_at,
            last_activity_at
          )
        `)
        .eq('company_id', currentCompany.id);

      if (!linkedError && linkedContacts) {
        linkedContactsData = linkedContacts
          .map(cc => cc.contacts)
          .filter(Boolean)
          .filter(c => !directContactsData?.some(dc => dc.id === c.id)); // Exclude duplicates
      }
    } catch (linkedErr) {
      console.warn('Warning: failed to load linked contacts:', linkedErr);
    }

    // Combine direct and linked contacts, removing duplicates
    const allContactsData = [
      ...(directContactsData || []),
      ...linkedContactsData
    ];

    if (directError) {
      console.error('Error loading contacts directly:', directError);
      contacts = [];
      return;
    }

    // Load owner names
    const ownerIds = [...new Set((allContactsData || []).map(c => c.owner_id).filter(Boolean))];
    let ownerMap = new Map();

    if (ownerIds.length > 0) {
      const { data: profilesData } = await supabase
        .from('profiles')
        .select('id, first_name, last_name')
        .in('id', ownerIds);

      if (profilesData) {
        ownerMap = new Map(profilesData.map(p => [
          p.id,
          `${p.first_name || ''} ${p.last_name || ''}`.trim() || 'Unassigned'
        ]));
      }
    }

    // Map direct query results to expected format
    contacts = (allContactsData || []).map(contact => ({
      id: contact.id,
      first_name: contact.first_name,
      last_name: contact.last_name,
      phone: contact.phone,
      email: contact.email,
      company: contact.company_name,
      company_name: contact.company_name,
      role: contact.role_label,
      role_label: contact.role_label,
      notes: contact.notes || null,
      status: contact.status || 'lead',
      pipeline_stage: contact.pipeline_stage || null,
      tags: contact.tags || [],
      has_open_lead: false, // Can't determine without leads table
      has_upcoming_appt: false, // Can't determine without appointments table
      overdue_count: 0, // Can't determine without reminders table
      contact_profile_id: contact.profile_id || null,
      owner_id: contact.owner_id,
      owner_name: ownerMap.get(contact.owner_id) || 'Unassigned',
      created_at: contact.created_at,
      updated_at: contact.updated_at,
      last_activity: contact.last_activity_at,
      created_by: ownerMap.get(contact.owner_id) || 'Unassigned'
    }));
  } else {
    // Use RPC data
    contacts = (contactsData || []).map(contact => {
      const mappedContact = {
        id: contact.id,
        first_name: contact.first_name,
        last_name: contact.last_name,
        phone: contact.phone,
        email: contact.email,
        company: contact.company_name,
        company_name: contact.company_name,
        role: contact.role_label,
        role_label: contact.role_label,
        notes: contact.notes || null,
        status: contact.contact_status || contact.status || 'lead',
        pipeline_stage: contact.pipeline_stage || null,
        tags: contact.tags || [],
        has_open_lead: contact.has_open_lead || false,
        has_upcoming_appt: contact.has_upcoming_appt || false,
        overdue_count: contact.overdue_count || 0,
        contact_profile_id: contact.contact_profile_id || contact.profile_id || null,
        owner_id: contact.owner_id,
        owner_name: contact.owner_name,
        created_at: contact.created_at,
        updated_at: contact.updated_at,
        last_activity: contact.last_activity,
        created_by: contact.owner_name
      };

      // Debug log to see what we're getting from the RPC
      if (contact.contact_profile_id || contact.profile_id) {
        console.log('📋 [loadContacts] Contact with profile:', {
          name: `${contact.first_name} ${contact.last_name}`,
          contact_id: contact.id,
          contact_profile_id: contact.contact_profile_id,
          profile_id: contact.profile_id,
          mapped_profile_id: mappedContact.contact_profile_id,
          notes_from_rpc: contact.notes,
          notes_mapped: mappedContact.notes
        });
      }

      return mappedContact;
    });

    // If notes are missing from RPC response, load them directly from contacts table
    const contactsWithoutNotes = contacts.filter(c => c.notes === null || c.notes === undefined);
    if (contactsWithoutNotes.length > 0) {
      const contactIds = contactsWithoutNotes.map(c => c.id);
      const { data: notesData, error: notesError } = await supabase
        .from('contacts')
        .select('id, notes')
        .in('id', contactIds);

      if (!notesError && notesData) {
        // Create a map of contact ID to notes
        const notesMap = new Map(notesData.map(item => [item.id, item.notes]));

        // Update contacts with notes
        contacts.forEach(contact => {
          if (notesMap.has(contact.id)) {
            contact.notes = notesMap.get(contact.id);
          }
        });
      }
    }
  }

  console.log('📋 [loadContacts] Loaded', contacts.length, 'contacts');
  console.log('📋 [loadContacts] Contacts with profile_id:', contacts.filter(c => c.contact_profile_id).length);
  console.log('📋 [loadContacts] Contacts with notes:', contacts.filter(c => c.notes).length);
}

// Load chats - only show chats where user is a participant
async function loadChats() {
  if (!currentCompany) {
    console.log('⚠️ Cannot load chats: no currentCompany');
    chats = [];
    return;
  }

  if (!currentUser && !currentProfile) {
    console.log('⚠️ Cannot load chats: no currentUser or currentProfile');
    chats = [];
    return;
  }

  const userId = currentUser?.id || currentProfile?.id;
  if (!userId) {
    console.log('⚠️ Cannot load chats: no user ID');
    chats = [];
    return;
  }

  console.log('🔍 Loading chats for user:', userId, 'company:', currentCompany.id);

  try {
    // First, get chat IDs where the user is a participant, filtered by archive status
    const { data: userChats, error: userChatsError } = await supabase
      .from('chat_participants')
      .select('chat_id, is_archived')
      .eq('user_id', userId)
      .eq('is_archived', showArchivedChats);

    if (userChatsError) {
      console.error('❌ Error fetching user chats:', userChatsError);
      chats = [];
      return;
    }

    console.log('📋 Found', userChats?.length || 0, 'chat participations for user');

    const chatIds = userChats?.map(uc => uc.chat_id) || [];
    if (chatIds.length === 0) {
      console.log('📋 No chats found for user');
      chats = [];
      chatUnreadCounts = {};
      return;
    }

    console.log('📋 Chat IDs:', chatIds);

    // Then get the chats - simplified query without complex joins
    // Don't filter by company_id since user might be participant in chats from other companies
    let chatData = null;
    let error = null;

    const { data: chatDataResult, error: chatError } = await supabase
      .from('chats')
      .select('*')
      .in('id', chatIds)
      .order('last_activity_at', { ascending: false })
      .limit(50);

    if (chatError) {
      console.error('❌ Error loading chats:', chatError);
      chats = [];
      return;
    }

    chatData = chatDataResult;

    console.log('✅ Loaded', chatData?.length || 0, 'chats from database');

    if (!chatData || chatData.length === 0) {
      console.log('⚠️ No chat data returned');
      chats = [];
      chatUnreadCounts = {};
      return;
    }

    // Load participants separately for all chats
    let participantsByChat = {}; // Initialize empty object
    const { data: participantsData, error: participantsError } = await supabase
      .from('chat_participants')
      .select(`
        chat_id,
        user_id,
        profiles!chat_participants_user_id_fkey(
          id,
          first_name,
          last_name,
          avatar_path
        )
      `)
      .in('chat_id', chatIds);

    if (participantsError) {
      console.error('Error loading participants:', participantsError);
      // Try alternative query without join if the first one fails
      // Note: contact_id column may not exist, so we don't select it
      const { data: altParticipantsData } = await supabase
        .from('chat_participants')
        .select('chat_id, user_id')
        .in('chat_id', chatIds);

      if (altParticipantsData) {
        // Load profiles separately
        const userIds = [...new Set(altParticipantsData.map(p => p.user_id).filter(Boolean))];
        const { data: profilesData } = await supabase
          .from('profiles')
          .select('id, first_name, last_name, avatar_path')
          .in('id', userIds);

        const profilesMap = {};
        (profilesData || []).forEach(prof => {
          profilesMap[prof.id] = prof;
        });

        // Combine participants with profiles
        const combinedParticipants = (altParticipantsData || []).map(p => ({
          chat_id: p.chat_id,
          user_id: p.user_id,
          profiles: profilesMap[p.user_id] || null
        }));

        // Group by chat_id
        combinedParticipants.forEach(p => {
          if (!participantsByChat[p.chat_id]) {
            participantsByChat[p.chat_id] = [];
          }
          participantsByChat[p.chat_id].push(p);
        });

        // Use this for mapping
        chats.forEach(chat => {
          chat.participants = (participantsByChat[chat.id] || []).map(p => ({
            id: p.profiles?.id || p.user_id,
            user_id: p.user_id,
            first_name: p.profiles?.first_name || '',
            last_name: p.profiles?.last_name || '',
            avatar_path: p.profiles?.avatar_path
          }));
        });
      }
    } else {
      // Group participants by chat_id
      (participantsData || []).forEach(p => {
        if (!participantsByChat[p.chat_id]) {
          participantsByChat[p.chat_id] = [];
        }
        participantsByChat[p.chat_id].push(p);
      });
    }

    // Map participants to chatData before creating chats array
    // If profiles are missing (due to RLS), load them separately
    const participantUserIds = new Set();
    (chatData || []).forEach(chat => {
      (participantsByChat[chat.id] || []).forEach(p => {
        if (p.user_id) participantUserIds.add(p.user_id);
      });
    });

    // Load all participant profiles separately to handle cross-company users (HH users)
    let profilesMap = {};
    if (participantUserIds.size > 0) {
      const { data: allProfiles, error: profilesError } = await supabase
        .from('profiles')
        .select('id, first_name, last_name, avatar_path, is_hh_admin, company_id')
        .in('id', Array.from(participantUserIds));

      if (!profilesError && allProfiles) {
        allProfiles.forEach(prof => {
          profilesMap[prof.id] = prof;
        });
      }
    }

    // Map participants with fallback to separately loaded profiles
    (chatData || []).forEach(chat => {
      chat.participants = (participantsByChat[chat.id] || []).map(p => {
        const profile = p.profiles || profilesMap[p.user_id];
        return {
          id: profile?.id || p.user_id,
          user_id: p.user_id,
          first_name: profile?.first_name || '',
          last_name: profile?.last_name || '',
          avatar_path: profile?.avatar_path,
          is_hh_admin: profile?.is_hh_admin || false,
          company_id: profile?.company_id
        };
      });
    });

    // Get latest messages for each chat
    const { data: messagesData, error: messagesError } = await supabase
      .from('messages')
      .select(`
        chat_id,
        text,
        created_at,
        sender_id,
        profiles!messages_sender_id_fkey(first_name, last_name)
      `)
      .in('chat_id', chatIds)
      .neq('status', 'scheduled')
      .order('created_at', { ascending: false });

    if (messagesError) {
      console.error('Error loading messages:', messagesError);
    }

    // Get unread counts for each chat
    // Count messages from others that are newer than user's last message in that chat
    chatUnreadCounts = {};

    // Load project and contact info separately to avoid complex joins
    const projectIds = (chatData || []).filter(c => c.project_id).map(c => c.project_id);
    const contactIds = (chatData || []).filter(c => c.contact_id).map(c => c.contact_id);

    let projectsMap = {};
    let contactsMap = {};

    if (projectIds.length > 0) {
      const { data: projectsData } = await supabase
        .from('projects')
        .select(`
          id,
          name,
          contact_id,
          contact:contacts!projects_contact_id_fkey(
            id,
            first_name,
            last_name,
            company_name
          )
        `)
        .in('id', projectIds);

      if (projectsData) {
        projectsData.forEach(p => {
          projectsMap[p.id] = p;
        });
      }
    }

    if (contactIds.length > 0) {
      const { data: contactsData } = await supabase
        .from('contacts')
        .select('id, first_name, last_name, company_name')
        .in('id', contactIds);

      if (contactsData) {
        contactsData.forEach(c => {
          contactsMap[c.id] = c;
        });
      }
    }

    // Get unread counts for each chat using chat_read_status table
    chatUnreadCounts = {};

    // Load read status for all chats
    const { data: readStatusData } = await supabase
      .from('chat_read_status')
      .select('chat_id, last_read_at, last_read_message_id')
      .eq('user_id', userId);

    const readStatusByChat = {};
    (readStatusData || []).forEach(rs => {
      readStatusByChat[rs.chat_id] = rs;
    });

    chats = (chatData || []).map(chat => {
      const chatMessages = messagesData?.filter(msg => msg.chat_id === chat.id) || [];
      const latestMessage = chatMessages[0];

      // Calculate unread count using chat_read_status
      const readStatus = readStatusByChat[chat.id];
      let unreadCount = 0;

      if (readStatus && readStatus.last_read_at) {
        const lastReadTime = new Date(readStatus.last_read_at).getTime();
        // Count messages from others after last read time
        unreadCount = chatMessages.filter(msg =>
          msg.sender_id !== userId &&
          new Date(msg.created_at).getTime() > lastReadTime
        ).length;
      } else if (latestMessage && latestMessage.sender_id !== userId) {
        // No read status - if there are messages from others, count them as unread
        unreadCount = chatMessages.filter(msg => msg.sender_id !== userId).length;
      }

      chatUnreadCounts[chat.id] = unreadCount;

      // Get project and contact info
      const project = chat.project_id ? projectsMap[chat.project_id] : null;
      const contact = chat.contact_id ? contactsMap[chat.contact_id] : null;

      // Get participants for this chat - they should already be mapped to chat.participants
      const participants = chat.participants || participantsByChat?.[chat.id] || [];

      // Determine if chat is associated with a client
      const isClientChat = chat.contact_id || project?.contact_id || contact;
      const clientInfo = contact || project?.contact;

      return {
        id: chat.id,
        title: chat.title || 'Untitled Chat',
        custom_name: chat.custom_name,
        last_message: latestMessage?.text || 'No messages',
        sender_name: latestMessage?.profiles ?
          `${latestMessage.profiles.first_name} ${latestMessage.profiles.last_name}` :
          'Unknown',
        created_at: latestMessage?.created_at || chat.created_at,
        last_activity_at: chat.last_activity_at || chat.created_at,
        participants: (chat.participants && chat.participants.length > 0)
          ? chat.participants
          : (participants || []).map(p => ({
            id: p.profiles?.id || p.user_id,
            first_name: p.profiles?.first_name || '',
            last_name: p.profiles?.last_name || '',
            avatar_path: p.profiles?.avatar_path
          })),
        project: project,
        contact: contact,
        contact_id: chat.contact_id,
        is_client_chat: isClientChat,
        client_name: clientInfo ? `${clientInfo.first_name} ${clientInfo.last_name}` : null,
        client_company: clientInfo?.company_name || project?.contact?.company_name || null
      };
    });

    console.log(`✅ Loaded ${chats.length} chats for user`);
  } catch (error) {
    console.error('Error loading chats:', error);
    chats = [];
  }
}

// Load sales opportunities
async function loadSalesOpportunities() {
  if (!currentCompany) return;

  const { data: salesData, error } = await supabase
    .from('sales_opportunities')
    .select(`
      id,
      title,
      amount,
      stage,
      chance,
      expected_close_date,
      source,
      follow_up_date,
      notes,
      status,
      archived,
      created_at,
      closed_at,
      contact_id,
      assigned_to,
      contact:contacts (
        id,
        first_name,
        last_name,
        phone,
        email,
        company_name,
        role_label
      ),
      assigned_user:profiles!sales_opportunities_assigned_to_fkey (
        id,
        first_name,
        last_name
      )
    `)
    .eq('company_id', currentCompany.id)
    .order('follow_up_date', { ascending: false, nullsFirst: false })
    .order('expected_close_date', { ascending: true, nullsFirst: false });

  if (error) {
    console.error('Error loading sales opportunities:', error);
  }
  salesOpportunities = salesData || [];
}

// Load appointments. viewMode: 'team' = all company, 'personal' = only current user (default).
async function loadAppointments(viewMode) {
  if (!currentCompany || !currentUser) return;

  let query = supabase
    .from('appointments')
    .select(`
      id,
      title,
      appointment_date,
      start_time,
      duration_minutes,
      status,
      assigned_to,
      contact:contacts (
        first_name,
        last_name
      )
    `)
    .eq('company_id', currentCompany.id)
    .order('appointment_date', { ascending: true })
    .order('start_time', { ascending: true });

  if (viewMode === 'personal') {
    query = query.eq('assigned_to', currentUser.id);
  }

  const { data: appointmentsData, error } = await query;

  if (error) {
    console.error('Error loading appointments:', error);
  }
  appointments = appointmentsData || [];
  console.log('📅 Appointments loaded:', appointments.length);
}

// Load reminders for a specific contact (for contact detail view)
async function loadContactReminders(contactId) {
  if (!currentCompany || !contactId) return [];

  const { data: remindersData, error } = await supabase
    .from('reminders')
    .select(`
      id,
      title,
      description,
      due_at,
      priority,
      type,
      status,
      contact_id,
      assigned_to,
      owner_id,
      created_at,
      updated_at,
      owner:profiles!reminders_owner_id_fkey(
        id,
        first_name,
        last_name
      )
    `)
    .eq('contact_id', contactId)
    .eq('company_id', currentCompany.id)
    .order('due_at', { ascending: true });

  if (error) {
    console.error('Error loading contact reminders:', error);
    return [];
  }

  return remindersData || [];
}

// Load appointments for a specific contact (for contact detail view)
async function loadContactAppointments(contactId) {
  if (!currentCompany || !contactId) return [];

  const { data: appointmentsData, error } = await supabase
    .from('appointments')
    .select(`
      *,
      assigned_user:assigned_to (
        first_name,
        last_name
      )
    `)
    .eq('contact_id', contactId)
    .eq('company_id', currentCompany.id)
    .order('appointment_date', { ascending: true })
    .order('start_time', { ascending: true });

  if (error) {
    console.error('Error loading contact appointments:', error);
    return [];
  }

  return appointmentsData || [];
}

// Helper function to create activity log entry automatically
async function createActivityLogEntry(contactId, eventType, title, description, metadata = {}) {
  console.log(`🔄 [Activity Log] Attempting to create entry:`, {
    contactId,
    eventType,
    title,
    currentCompany: currentCompany?.id,
    currentUser: currentUser?.id
  });

  if (!currentCompany || !contactId || !currentUser) {
    console.warn('❌ [Activity Log] Cannot create activity log entry: missing company, contact, or user', {
      hasCompany: !!currentCompany,
      hasContact: !!contactId,
      hasUser: !!currentUser
    });
    return;
  }

  try {
    // Store the actual event type in metadata, use 'contact' as activity_type (which is allowed by DB)
    const insertData = {
      company_id: currentCompany.id,
      contact_id: contactId,
      user_id: currentUser.id,
      activity_type: 'contact', // Use 'contact' as it's allowed by the DB constraint
      title: title,
      description: description || null,
      metadata: {
        ...metadata,
        event_type: eventType // Store the actual event type here
      },
      created_at: new Date().toISOString()
    };

    console.log(`📝 [Activity Log] Inserting into database:`, insertData);

    const { data, error } = await supabase
      .from('activity_log')
      .insert(insertData)
      .select();

    if (error) {
      console.error('❌ [Activity Log] Error creating activity log entry:', error);
    } else {
      console.log(`✅ [Activity Log] Successfully created entry:`, data);
    }
  } catch (error) {
    console.error('❌ [Activity Log] Exception creating activity log entry:', error);
  }
}

async function loadContactActivityLog(contactId) {
  if (!currentCompany || !contactId) return [];

  const allActivities = [];

  // Load manual activity logs
  const { data: activityLogData, error: activityError } = await supabase
    .from('activity_log')
    .select('*')
    .eq('company_id', currentCompany.id)
    .eq('contact_id', contactId)
    .order('created_at', { ascending: false })
    .limit(100);

  console.log(`📝 [Activity Log] Query result:`, {
    data: activityLogData,
    error: activityError,
    contactId,
    companyId: currentCompany.id
  });

  if (!activityError && activityLogData) {
    console.log(`📝 [Activity Log] Found ${activityLogData?.length || 0} activity_log entries for contact ${contactId}`);

    // Load user names separately if needed
    const userIds = [...new Set(activityLogData.map(item => item.user_id).filter(Boolean))];
    let userMap = {};

    if (userIds.length > 0) {
      const { data: usersData } = await supabase
        .from('profiles')
        .select('id, first_name, last_name')
        .in('id', userIds);

      if (usersData) {
        usersData.forEach(user => {
          userMap[user.id] = `${user.first_name || ''} ${user.last_name || ''}`.trim() || 'Team Member';
        });
      }
    }

    activityLogData.forEach(item => {
      // Check for event_type - could be a direct column or in metadata (for legacy entries)
      // Prioritize direct column, then metadata, then default to 'activity' for manual entries
      const eventType = item.event_type || item.metadata?.event_type || 'activity';

      allActivities.push({
        id: `activity_${item.id}`,
        event_type: eventType,
        type: item.activity_type,
        title: item.title,
        description: item.description,
        metadata: item.metadata,
        created_at: item.created_at,
        user_name: userMap[item.user_id] || (item.event_type?.startsWith('contract_') ? 'System' : 'Team Member')
      });
    });
  } else if (activityError) {
    console.error('❌ [Activity Log] Error loading activity_log entries:', activityError);
  }

  // Load tasks for this contact (created + completed) so they show in activity
  const { data: tasksData, error: tasksError } = await supabase
    .from('tasks')
    .select('id, title, state, created_at, due_at')
    .eq('contact_id', contactId)
    .eq('company_id', currentCompany.id)
    .order('created_at', { ascending: false })
    .limit(50);

  if (!tasksError && tasksData && tasksData.length > 0) {
    tasksData.forEach(task => {
      const isCompleted = task.state === 'COMPLETED';
      allActivities.push({
        id: `task_${task.id}`,
        event_type: isCompleted ? 'task_completed' : 'task_created',
        title: isCompleted ? `Completed: ${task.title}` : task.title,
        description: task.due_at ? `Due: ${new Date(task.due_at).toLocaleDateString()}` : null,
        created_at: task.created_at,
        user_name: 'Team Member'
      });
    });
  }

  // Load projects for this contact (contact_id or profile_id)
  const contactForProjects = contacts.find(c => c.id === contactId);
  let projectsQuery = supabase
    .from('projects')
    .select('id, name, created_at, contact_id')
    .eq('company_id', currentCompany.id)
    .order('created_at', { ascending: false })
    .limit(50);
  if (contactForProjects?.profile_id) {
    projectsQuery = projectsQuery.or(`contact_id.eq.${contactId},profile_id.eq.${contactForProjects.profile_id}`);
  } else {
    projectsQuery = projectsQuery.eq('contact_id', contactId);
  }
  const { data: projectsData, error: projectsError } = await projectsQuery;

  if (!projectsError && projectsData && projectsData.length > 0) {
    projectsData.forEach(proj => {
      allActivities.push({
        id: `project_${proj.id}`,
        event_type: 'project_created',
        title: proj.name,
        description: 'Project created',
        created_at: proj.created_at,
        user_name: 'Team Member'
      });
    });
  }

  // Load reminders for this contact
  const { data: remindersData, error: remindersError } = await supabase
    .from('reminders')
    .select('id, title, due_at, status, created_at')
    .eq('contact_id', contactId)
    .eq('company_id', currentCompany.id)
    .order('created_at', { ascending: false })
    .limit(50);

  if (!remindersError && remindersData && remindersData.length > 0) {
    remindersData.forEach(rem => {
      const isCompleted = (rem.status || '').toLowerCase() === 'completed' || (rem.status || '').toLowerCase() === 'done';
      allActivities.push({
        id: `reminder_${rem.id}`,
        event_type: isCompleted ? 'reminder_completed' : 'reminder',
        title: isCompleted ? `Completed: ${rem.title}` : rem.title,
        description: rem.due_at ? `Due: ${new Date(rem.due_at).toLocaleDateString()}` : null,
        created_at: rem.created_at,
        user_name: 'Team Member'
      });
    });
  }

  // Load appointments for this contact
  const { data: appointmentsData, error: appointmentsError } = await supabase
    .from('appointments')
    .select('id, title, appointment_date, start_time, end_time, created_at')
    .eq('contact_id', contactId)
    .eq('company_id', currentCompany.id)
    .order('appointment_date', { ascending: false })
    .order('start_time', { ascending: false })
    .limit(50);

  if (!appointmentsError && appointmentsData && appointmentsData.length > 0) {
    appointmentsData.forEach(apt => {
      const dateStr = apt.appointment_date ? new Date(apt.appointment_date).toLocaleDateString() : '';
      const timeStr = [apt.start_time, apt.end_time].filter(Boolean).join(' – ');
      allActivities.push({
        id: `appointment_${apt.id}`,
        event_type: 'appointment',
        title: apt.title || 'Appointment',
        description: [dateStr, timeStr].filter(Boolean).join(' ') || null,
        created_at: apt.created_at,
        user_name: 'Team Member'
      });
    });
  }

  // Load contracts for this contact (sent, viewed, signed, expired)
  const { data: contractsData, error: contractsError } = await supabase
    .from('contracts')
    .select('id, name, status, created_at, updated_at')
    .eq('contact_id', contactId)
    .order('updated_at', { ascending: false })
    .limit(50);

  if (!contractsError && contractsData && contractsData.length > 0) {
    const statusToEvent = { draft: 'contract_sent', sent: 'contract_sent', viewed: 'contract_viewed', signed: 'contract_signed', expired: 'contract_expired', closed: 'contract_signed', voided: 'contract_expired' };
    contractsData.forEach(c => {
      const eventType = statusToEvent[c.status] || 'contract_sent';
      const dateUsed = (c.updated_at && c.status !== 'draft') ? c.updated_at : c.created_at;
      allActivities.push({
        id: `contract_${c.id}`,
        event_type: eventType,
        title: c.name || 'Contract',
        description: c.status ? `Status: ${c.status}` : null,
        created_at: dateUsed,
        user_name: 'Team Member'
      });
    });
  }

  // Load sales opportunities (won/lost + open) so all deals show in activity
  const { data: opportunitiesData, error: opportunitiesError } = await supabase
    .from('sales_opportunities')
    .select('id, title, amount, stage, closed_at, created_at, contact_id')
    .eq('contact_id', contactId)
    .order('closed_at', { ascending: false, nullsLast: true })
    .order('created_at', { ascending: false })
    .limit(50);

  if (!opportunitiesError && opportunitiesData) {
    opportunitiesData.forEach(opp => {
      if (opp.stage === 'won' || opp.stage === 'lost') {
        const eventType = opp.stage === 'won' ? 'opportunity_won' : 'opportunity_lost';
        allActivities.push({
          id: `opportunity_${opp.id}`,
          event_type: eventType,
          title: opp.stage === 'won' ? `Sale won: ${opp.title}` : `Sale lost: ${opp.title}`,
          description: `Amount: $${opp.amount || 0}`,
          stage: opp.stage,
          created_at: opp.closed_at || opp.created_at,
          user_name: 'Team Member'
        });
      } else {
        allActivities.push({
          id: `opportunity_${opp.id}`,
          event_type: 'opportunity_created',
          title: opp.title,
          description: `Amount: $${opp.amount || 0}`,
          created_at: opp.created_at,
          user_name: 'Team Member'
        });
      }
    });
  }

  // Sort all activities by created_at (most recent first)
  allActivities.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

  console.log(`📊 [Activity Log] Total activities loaded for contact ${contactId}:`, allActivities.length);
  console.log(`📊 [Activity Log] Activity breakdown:`, {
    manual: allActivities.filter(a => a.event_type === 'activity').length,
    tasks: allActivities.filter(a => a.event_type === 'task_completed' || a.event_type === 'task_created').length,
    projects: allActivities.filter(a => a.event_type === 'project_created').length,
    reminders: allActivities.filter(a => (a.event_type || '').startsWith('reminder')).length,
    appointments: allActivities.filter(a => a.event_type === 'appointment').length,
    contracts: allActivities.filter(a => (a.event_type || '').startsWith('contract')).length,
    opportunities: allActivities.filter(a => (a.event_type || '').startsWith('opportunity')).length
  });

  return allActivities.slice(0, 100); // Return top 100 most recent
}

// Load contact-specific tasks
async function loadContactTasks(contactId) {
  if (!currentCompany || !contactId) return [];

  try {
    const { data, error } = await supabase
      .from('tasks')
      .select(`
        *,
        project:projects!tasks_project_id_fkey(
          id,
          name
        ),
        task_assignees(
          user_id,
          profiles!inner(
            id,
            first_name,
            last_name
          )
        )
      `)
      .eq('contact_id', contactId)
      .order('due_at', { nullsLast: true });

    if (error) {
      console.error('Error loading contact tasks:', error);
      return [];
    }

    // Process tasks to include assigned_members and project_name
    const processedTasks = (data || []).map(task => ({
      ...task,
      project_name: task.project?.name || null,
      assigned_members: task.task_assignees?.map(assignee => ({
        id: assignee.profiles.id,
        first_name: assignee.profiles.first_name,
        last_name: assignee.profiles.last_name,
      })) || []
    }));

    return processedTasks;
  } catch (error) {
    console.error('Error loading contact tasks:', error);
    return [];
  }
}

// Load contact-specific projects
async function loadContactProjects(contactId, activeOnly = false) {
  if (!currentCompany) return [];

  try {
    const contact = contactId ? contacts.find(c => c.id === contactId) : null;

    // Build query with tasks - always scope by company for RLS and correct results
    let query = supabase
      .from('projects')
      .select(`
        id,
        name,
        description,
        status,
        progress_percentage,
        start_date,
        due_date,
        created_at,
        tasks!project_id(id, title, state, due_at, priority)
      `)
      .eq('company_id', currentCompany.id)
      .order('created_at', { ascending: false });

    // Filter by active status if requested
    if (activeOnly) {
      query = query.eq('status', 'active');
    }

    // Filter by contact when provided
    if (contactId && contact?.profile_id) {
      query = query.or(`contact_id.eq.${contactId},profile_id.eq.${contact.profile_id}`);
    } else if (contactId) {
      query = query.eq('contact_id', contactId);
    }
    // When no contactId, we return all company projects (for task modal when no contact selected yet)

    const { data, error } = await query;

    if (error) {
      console.error('Error loading contact projects:', error);
      return [];
    }

    // Process projects with task counts
    const processedProjects = (data || []).map(project => ({
      ...project,
      task_count: project.tasks?.length || 0,
      completed_tasks: project.tasks?.filter(t => t.state === 'COMPLETED').length || 0,
    }));

    // If activeOnly is false but we want to filter anyway, filter here
    // Otherwise return all (for contact detail view)
    return processedProjects;
  } catch (error) {
    console.error('Error loading contact projects:', error);
    return [];
  }
}

// Load contact-specific chats
async function loadContactChats(contactId) {
  if (!currentCompany || !contactId) return [];

  try {
    // Find the contact to check if they have a profile
    const contact = contacts.find(c => c.id === contactId);
    if (!contact) {
      console.log('Contact not found:', contactId);
      return [];
    }

    const chatIdsSet = new Set();

    // Get chats where this contact is a participant via user_id (if they have a profile)
    // Note: chat_participants doesn't have a contact_id column, only user_id
    if (contact.contact_profile_id || contact.profile_id) {
      const profileId = contact.contact_profile_id || contact.profile_id;
      const { data: contactChatsByUserId, error: userChatsError } = await supabase
        .from('chat_participants')
        .select('chat_id')
        .eq('user_id', profileId);

      if (userChatsError) {
        console.error('Error loading contact chat participants by user_id:', userChatsError);
      } else {
        (contactChatsByUserId || []).forEach(cp => chatIdsSet.add(cp.chat_id));
      }
    }

    const chatIds = Array.from(chatIdsSet);
    console.log('📋 Found chat IDs for contact:', contactId, chatIds);

    if (chatIds.length === 0) {
      return [];
    }

    // Then get the chats
    const { data: chatsData, error: chatsError } = await supabase
      .from('chats')
      .select('*')
      .in('id', chatIds)
      .eq('company_id', currentCompany.id)
      .order('last_activity_at', { ascending: false });

    if (chatsError) {
      console.error('Error loading contact chats:', chatsError);
      return [];
    }

    console.log('📋 Loaded chats for contact:', chatsData?.length || 0);

    // Get last message for each chat
    const chatsWithMessages = await Promise.all((chatsData || []).map(async (chat) => {
      const { data: lastMessage } = await supabase
        .from('messages')
        .select('text, created_at')
        .eq('chat_id', chat.id)
        .order('created_at', { ascending: false })
        .limit(1)
        .single();

      return {
        ...chat,
        title: chat.custom_name || chat.title || 'Untitled Chat',
        last_message: lastMessage?.text || null,
        created_at: chat.created_at
      };
    }));

    return chatsWithMessages || [];
  } catch (error) {
    console.error('Error loading contact chats:', error);
    return [];
  }
}

// Helper function to detect mobile/tablet devices
function isMobileDevice() {
  return window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

// Function to wrap table in scrollable container for mobile
function wrapTableForMobile(tableHTML) {
  if (isMobileDevice()) {
    return `
      <div style="
        overflow-x: auto;
        overflow-y: hidden;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: thin;
        -ms-overflow-style: -ms-autohiding-scrollbar;
        width: 100%;
      ">
        ${tableHTML}
      </div>
    `;
  }
  return tableHTML;
}

// Function to update contact detail content area only
async function updateContactDetailContent() {
  const contactDetailDiv = document.getElementById('contact-detail-content');
  if (contactDetailDiv && selectedContactId) {
    // Show loading state immediately
    contactDetailDiv.innerHTML = `
      <div style="
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        color: #6c757d;
      ">
        <div style="text-align: center;">
          <div style="font-size: 2rem; margin-bottom: 0.5rem; color: #6c757d;">
            <span class="material-icons" style="font-size: 2rem;">hourglass_empty</span>
          </div>
          <div style="font-size: 0.875rem;">Loading...</div>
        </div>
      </div>
    `;

    // Load and render content
    try {
      contactDetailDiv.innerHTML = await renderContactDetailContent();
    } catch (error) {
      console.error('Error updating contact detail:', error);
      contactDetailDiv.innerHTML = `
        <div style="
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;
          color: #dc3545;
        ">
          <div style="text-align: center;">
            <div style="font-size: 2rem; margin-bottom: 0.5rem; color: #ef4444;">
              <span class="material-icons" style="font-size: 2rem;">error</span>
            </div>
            <div style="font-size: 0.875rem;">Error loading content</div>
          </div>
        </div>
      `;
    }
  }
}

// Function to switch contact detail view tab
window.switchContactDetailViewTab = async function (tab) {
  // Update tab state immediately
  contactDetailViewTab = tab;

  // Update tab buttons visually before loading content
  const contactDetailDiv = document.getElementById('contact-detail-content');
  if (contactDetailDiv) {
    // Update the tab buttons in the header section immediately
    const tabsContainer = contactDetailDiv.querySelector('.contact-tabs-container');
    if (tabsContainer) {
      // Update active tab styling
      const tabButtons = tabsContainer.querySelectorAll('button');
      tabButtons.forEach(btn => {
        const tabId = btn.getAttribute('data-tab-id');
        if (tabId === tab) {
          btn.style.background = '#f59e0b';
          btn.style.color = 'white';
          btn.style.borderColor = '#f59e0b';
          btn.style.fontWeight = '600';
        } else {
          btn.style.background = '#ffffff';
          btn.style.color = '#6c757d';
          btn.style.borderColor = '#e9ecef';
          btn.style.fontWeight = '500';
        }
      });
    }
  }

  // If we have cached data for this contact, just update the tab content (smooth switch)
  if (cachedContactData.contactId === selectedContactId) {
    const tabContentDiv = document.getElementById('contact-tab-content');
    if (tabContentDiv) {
      // Render tab content from cache - no loading state, instant switch
      let tabContentHTML = '';
      switch (tab) {
        case 'activity':
          tabContentHTML = renderActivityTab(cachedContactData.activityLog);
          break;
        case 'projects':
          tabContentHTML = await renderProjectsTab(cachedContactData.projects);
          break;
        case 'tasks':
          tabContentHTML = renderTasksTab(cachedContactData.tasks);
          break;
        case 'chats':
          tabContentHTML = renderChatsTab(cachedContactData.chats);
          break;
        case 'opportunities':
          tabContentHTML = renderOpportunitiesTab(cachedContactData.opportunities);
          break;
        case 'contracts':
          tabContentHTML = await renderContactContractsTab();
          break;
        case 'reminders':
          tabContentHTML = renderRemindersTab(cachedContactData.reminders);
          break;
        case 'appointments':
          tabContentHTML = renderAppointmentsTab(cachedContactData.appointments);
          break;
        default:
          tabContentHTML = renderActivityTab(cachedContactData.activityLog);
      }
      tabContentDiv.innerHTML = tabContentHTML;
      return;
    }
  }

  // Fallback: Full reload if no cache or cache is stale
  await updateContactDetailContent();
}

// Modal functions for adding items
// Show Add Activity Modal
window.showAddActivityModal = function () {
  const contact = contacts.find(c => c.id === selectedContactId);
  if (!contact) {
    alert('No contact selected');
    return;
  }

  const contactName = `${contact.first_name} ${contact.last_name}`;

  // Create modal overlay
  const modalHTML = `
    <div id="add-activity-modal-overlay" style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      z-index: 10000;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem;
    " onclick="if (event.target.id === 'add-activity-modal-overlay') closeAddActivityModal()">
      <div id="add-activity-modal" style="
        background: #ffffff;
        border-radius: 0.75rem;
        width: 100%;
        max-width: 600px;
        max-height: 90vh;
        display: flex;
        flex-direction: column;
        box-shadow: 0 10px 25px rgba(0,0,0,0.2);
      " onclick="event.stopPropagation()">
        <!-- Header -->
        <div style="
          padding: 1rem 1.5rem;
          border-bottom: 1px solid #e9ecef;
          display: flex;
          justify-content: space-between;
          align-items: center;
        ">
          <button onclick="closeAddActivityModal()" style="
            background: transparent;
            border: none;
            color: #6c757d;
            cursor: pointer;
            font-size: 0.875rem;
            padding: 0.25rem 0.5rem;
          ">Cancel</button>
          <h2 style="
            margin: 0;
            font-size: 1.125rem;
            font-weight: 700;
            color: #2c3e50;
          ">Log Client Activity</h2>
          <button id="save-activity-btn" onclick="submitActivity()" style="
            background: #f59e0b;
            color: white;
            border: none;
            padding: 0.5rem 1rem;
            border-radius: 0.375rem;
            cursor: pointer;
            font-size: 0.875rem;
            font-weight: 600;
            opacity: 0.5;
            transition: opacity 0.2s;
          " disabled>Save</button>
        </div>

        <!-- Content -->
        <div style="
          flex: 1;
          overflow-y: auto;
          padding: 1.5rem;
        ">
          <!-- Contact Info -->
          <div style="
            background: #f8f9fa;
            padding: 1rem;
            border-radius: 0.5rem;
            margin-bottom: 1.5rem;
          ">
            <div style="
              font-size: 0.875rem;
              color: #6c757d;
              margin-bottom: 0.25rem;
            ">Contact</div>
            <div style="
              font-size: 1.125rem;
              font-weight: 600;
              color: #2c3e50;
            ">${contactName}</div>
          </div>

          <!-- Contact Method Selection -->
          <div style="margin-bottom: 1.5rem;">
            <label style="
              display: block;
              font-size: 1rem;
              font-weight: 600;
              color: #2c3e50;
              margin-bottom: 0.75rem;
            ">Contact Method *</label>
            <div style="
              display: flex;
              flex-wrap: wrap;
              gap: 0.5rem;
            ">
              <button class="contact-method-btn" data-method="phone" onclick="selectContactMethod('phone')" style="
                display: flex;
                align-items: center;
                gap: 0.5rem;
                padding: 0.75rem 1rem;
                border-radius: 0.5rem;
                border: 2px solid #e9ecef;
                background: #f8f9fa;
                color: #6c757d;
                cursor: pointer;
                font-size: 0.875rem;
                font-weight: 500;
                transition: all 0.2s;
              ">
                <span class="material-icons" style="font-size: 18px;">phone</span>
                Phone
              </button>
              <button class="contact-method-btn" data-method="text" onclick="selectContactMethod('text')" style="
                display: flex;
                align-items: center;
                gap: 0.5rem;
                padding: 0.75rem 1rem;
                border-radius: 0.5rem;
                border: 2px solid #e9ecef;
                background: #f8f9fa;
                color: #6c757d;
                cursor: pointer;
                font-size: 0.875rem;
                font-weight: 500;
                transition: all 0.2s;
              ">
                <span class="material-icons" style="font-size: 18px;">message</span>
                Text
              </button>
              <button class="contact-method-btn" data-method="in_person" onclick="selectContactMethod('in_person')" style="
                display: flex;
                align-items: center;
                gap: 0.5rem;
                padding: 0.75rem 1rem;
                border-radius: 0.5rem;
                border: 2px solid #e9ecef;
                background: #f8f9fa;
                color: #6c757d;
                cursor: pointer;
                font-size: 0.875rem;
                font-weight: 500;
                transition: all 0.2s;
              ">
                <span class="material-icons" style="font-size: 18px;">person</span>
                In Person
              </button>
              <button class="contact-method-btn" data-method="email" onclick="selectContactMethod('email')" style="
                display: flex;
                align-items: center;
                gap: 0.5rem;
                padding: 0.75rem 1rem;
                border-radius: 0.5rem;
                border: 2px solid #e9ecef;
                background: #f8f9fa;
                color: #6c757d;
                cursor: pointer;
                font-size: 0.875rem;
                font-weight: 500;
                transition: all 0.2s;
              ">
                <span class="material-icons" style="font-size: 18px;">email</span>
                Email
              </button>
              <button class="contact-method-btn" data-method="social" onclick="selectContactMethod('social')" style="
                display: flex;
                align-items: center;
                gap: 0.5rem;
                padding: 0.75rem 1rem;
                border-radius: 0.5rem;
                border: 2px solid #e9ecef;
                background: #f8f9fa;
                color: #6c757d;
                cursor: pointer;
                font-size: 0.875rem;
                font-weight: 500;
                transition: all 0.2s;
              ">
                <span class="material-icons" style="font-size: 18px;">share</span>
                Social
              </button>
              <button class="contact-method-btn" data-method="other" onclick="selectContactMethod('other')" style="
                display: flex;
                align-items: center;
                gap: 0.5rem;
                padding: 0.75rem 1rem;
                border-radius: 0.5rem;
                border: 2px solid #e9ecef;
                background: #f8f9fa;
                color: #6c757d;
                cursor: pointer;
                font-size: 0.875rem;
                font-weight: 500;
                transition: all 0.2s;
              ">
                <span class="material-icons" style="font-size: 18px;">more_horiz</span>
                Other
              </button>
            </div>
          </div>

          <!-- Notes Section -->
          <div>
            <label style="
              display: block;
              font-size: 1rem;
              font-weight: 600;
              color: #2c3e50;
              margin-bottom: 0.75rem;
            ">Notes *</label>
            <textarea id="activity-notes" placeholder="Enter activity notes..." style="
              width: 100%;
              min-height: 120px;
              padding: 0.75rem;
              border: 1px solid #e9ecef;
              border-radius: 0.5rem;
              font-size: 0.875rem;
              font-family: inherit;
              resize: vertical;
              background: #f8f9fa;
            " oninput="checkActivityForm()"></textarea>
          </div>
        </div>
      </div>
    </div>
  `;

  // Add modal to body
  document.body.insertAdjacentHTML('beforeend', modalHTML);

  // Store selected method
  window.selectedContactMethod = null;
}

// Close Add Activity Modal
window.closeAddActivityModal = function () {
  const overlay = document.getElementById('add-activity-modal-overlay');
  if (overlay) {
    overlay.remove();
  }
  window.selectedContactMethod = null;
}

// Select Contact Method
window.selectContactMethod = function (method) {
  window.selectedContactMethod = method;

  // Update button styles
  document.querySelectorAll('.contact-method-btn').forEach(btn => {
    const btnMethod = btn.getAttribute('data-method');
    if (btnMethod === method) {
      btn.style.background = '#007bff';
      btn.style.color = 'white';
      btn.style.borderColor = '#007bff';
    } else {
      btn.style.background = '#f8f9fa';
      btn.style.color = '#6c757d';
      btn.style.borderColor = '#e9ecef';
    }
  });

  checkActivityForm();
}

// Check if form is valid
window.checkActivityForm = function () {
  const notes = document.getElementById('activity-notes');
  const saveBtn = document.getElementById('save-activity-btn');

  if (!saveBtn) return;

  const hasMethod = window.selectedContactMethod !== null;
  const hasNotes = notes && notes.value.trim().length > 0;

  if (hasMethod && hasNotes) {
    saveBtn.disabled = false;
    saveBtn.style.opacity = '1';
  } else {
    saveBtn.disabled = true;
    saveBtn.style.opacity = '0.5';
  }
}

// Submit Activity
window.submitActivity = async function () {
  if (!selectedContactId || !currentCompany || !currentUser) {
    alert('Missing required information');
    return;
  }

  const contact = contacts.find(c => c.id === selectedContactId);
  if (!contact) {
    alert('Contact not found');
    return;
  }

  const method = window.selectedContactMethod;
  const notes = document.getElementById('activity-notes')?.value.trim();

  if (!method) {
    alert('Please select a contact method');
    return;
  }

  if (!notes) {
    alert('Please enter activity notes');
    return;
  }

  const contactName = `${contact.first_name} ${contact.last_name}`;
  const methodLabels = {
    'phone': 'Phone',
    'text': 'Text',
    'in_person': 'In Person',
    'email': 'Email',
    'social': 'Social',
    'other': 'Other'
  };

  const methodLabel = methodLabels[method] || method;
  const title = `Client ${methodLabel} Interaction`;

  const saveBtn = document.getElementById('save-activity-btn');
  if (saveBtn) {
    saveBtn.disabled = true;
    saveBtn.textContent = 'Saving...';
  }

  try {
    const { error } = await supabase
      .from('activity_log')
      .insert({
        contact_id: selectedContactId,
        company_id: currentCompany.id,
        user_id: currentUser.id,
        activity_type: 'contact',
        title: title,
        description: notes,
        metadata: {
          contact_method: method,
          contact_name: contactName,
        },
      });

    if (error) {
      console.error('Error creating activity log:', error);
      alert('Failed to log activity. Please try again.');
      if (saveBtn) {
        saveBtn.disabled = false;
        saveBtn.textContent = 'Save';
      }
      return;
    }

    // Close modal
    closeAddActivityModal();

    // Refresh activity log
    await updateContactDetailContent();

    // Show success message briefly
    const contactDetailDiv = document.getElementById('contact-detail-content');
    if (contactDetailDiv) {
      const successMsg = document.createElement('div');
      successMsg.textContent = 'Activity logged successfully!';
      successMsg.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: #28a745;
        color: white;
        padding: 0.75rem 1.5rem;
        border-radius: 0.5rem;
        z-index: 10001;
        box-shadow: 0 4px 6px rgba(0,0,0,0.1);
      `;
      document.body.appendChild(successMsg);
      setTimeout(() => successMsg.remove(), 3000);
    }
  } catch (error) {
    console.error('Error creating activity log:', error);
    alert('Failed to log activity. Please try again.');
    if (saveBtn) {
      saveBtn.disabled = false;
      saveBtn.textContent = 'Save';
    }
  }
}

// Show Add Project modal from PM Tool (with contact selector)
window.showAddProjectModalFromPMTool = function () {
  // Only reset form data if not editing (preserve editingProject if already set)
  const isEditing = window.editingProject ? true : false;
  if (!isEditing) {
    window.editingProject = null;
  }
  // Don't reset tempSelectedContactId here - it's managed by:
  // - closeAddProjectModal: resets to null when modal closes
  // - selectProjectContact: sets to contact ID when contact is selected
  // - Button click: will be null from previous close, or we'll initialize it below if needed
  // - editProject: sets it from project.contact_id
  if (window.tempSelectedContactId === undefined) {
    window.tempSelectedContactId = null;
  }
  window.projectContactSearchQuery = window.projectContactSearchQuery || '';

  // Create modal with contact selector
  const modalHTML = `
    <div id="add-project-modal-overlay" style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      z-index: 100000;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem;
    " onclick="if (event.target.id === 'add-project-modal-overlay') closeAddProjectModal()">
      <div id="add-project-modal" style="
        background: #ffffff;
        border-radius: 0.75rem;
        width: 100%;
        max-width: 600px;
        max-height: 90vh;
        display: flex;
        flex-direction: column;
        box-shadow: 0 10px 25px rgba(0,0,0,0.2);
      " onclick="event.stopPropagation()">
        <!-- Header -->
        <div style="
          padding: 1rem 1.5rem;
          border-bottom: 1px solid #e9ecef;
          display: flex;
          justify-content: space-between;
          align-items: center;
        ">
          <button onclick="closeAddProjectModal(); window.editingProject = null;" style="
            background: transparent;
            border: none;
            color: #6c757d;
            cursor: pointer;
            font-size: 0.875rem;
            padding: 0.25rem 0.5rem;
          ">Cancel</button>
          <h2 style="
            margin: 0;
            font-size: 1.125rem;
            font-weight: 700;
            color: #2c3e50;
          ">${isEditing ? 'Edit Project' : 'Create Project'}</h2>
          <button id="save-project-btn" onclick="submitProjectFromPMTool()" style="
            background: #f59e0b;
            color: white;
            border: none;
            padding: 0.5rem 1rem;
            border-radius: 0.375rem;
            cursor: pointer;
            font-size: 0.875rem;
            font-weight: 600;
          ">${isEditing ? 'Update' : 'Create'}</button>
        </div>

        <!-- Content -->
        <div style="
          flex: 1;
          overflow-y: auto;
          padding: 1.5rem;
        ">
          <!-- Contact Selector -->
          <div style="margin-bottom: 1.5rem;">
            <label style="
              display: block;
              margin-bottom: 0.5rem;
              color: #2c3e50;
              font-weight: 700;
              font-size: 0.875rem;
            ">
              Contact (Optional)
            </label>
            <div style="position: relative;">
              ${window.tempSelectedContactId ? `
                <div style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  padding: 0.75rem;
                  border: 1px solid #e5e7eb;
                  border-radius: 0.5rem;
                  background: #f9fafb;
                ">
                  <span style="color: #2c3e50; font-size: 0.875rem;">
                    ${(() => {
        const contact = contacts.find(c => c.id === window.tempSelectedContactId);
        return contact ? `${contact.first_name || ''} ${contact.last_name || ''}`.trim() || contact.company || 'Selected Contact' : 'Selected Contact';
      })()}
                  </span>
                  <button
                    type="button"
                    onclick="clearProjectContact()"
                    style="
                      background: transparent;
                      border: none;
                      color: #ef4444;
                      cursor: pointer;
                      padding: 0.25rem 0.5rem;
                      font-size: 0.75rem;
                    "
                  >×</button>
                </div>
              ` : `
                <input
                  type="text"
                  id="project-contact-search-input"
                  placeholder="Search contacts..."
                  value="${window.projectContactSearchQuery || ''}"
                  oninput="handleProjectContactSearch(this.value)"
                  style="
                    width: 100%;
                    padding: 0.75rem;
                    border: 1px solid #e5e7eb;
                    border-radius: 0.5rem;
                    font-size: 0.875rem;
                    box-sizing: border-box;
                    transition: border-color 0.2s;
                  "
                  onfocus="this.style.borderColor='#f59e0b'"
                  onblur="this.style.borderColor='#e5e7eb'"
                />
                <div id="project-contact-search-results" style="
                  max-height: 200px;
                  overflow-y: auto;
                  border: 1px solid #e5e7eb;
                  border-radius: 0.5rem;
                  background: #ffffff;
                  margin-top: 0.5rem;
                  display: ${window.projectContactSearchQuery && window.projectContactSearchQuery.trim() ? 'block' : 'none'};
                  position: absolute;
                  width: 100%;
                  z-index: 1000;
                  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
                ">
                  ${contacts.filter(contact =>
        `${contact.first_name || ''} ${contact.last_name || ''} ${contact.company || ''}`.toLowerCase().includes((window.projectContactSearchQuery || '').toLowerCase())
      ).map(contact => `
                    <div
                      onclick="selectProjectContact('${contact.id}')"
                      style="
                        padding: 0.75rem;
                        border-bottom: 1px solid #e9ecef;
                        cursor: pointer;
                        transition: background-color 0.2s;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                      "
                      onmouseover="this.style.backgroundColor='#f8f9fa'"
                      onmouseout="this.style.backgroundColor='transparent'"
                    >
                      <div>
                        <div style="font-weight: 500; color: #2c3e50;">${contact.first_name || ''} ${contact.last_name || ''}</div>
                        ${contact.company ? `<div style="font-size: 0.75rem; color: #6c757d; margin-top: 0.25rem;">${contact.company}</div>` : ''}
                      </div>
                      ${contact.contact_profile_id ? `
                        <span style="background: #ff7f00; color: white; padding: 0.25rem 0.5rem; border-radius: 0.25rem; font-size: 0.75rem; font-weight: 600;">Client</span>
                      ` : ''}
                    </div>
                  `).join('')}
                  ${contacts.filter(contact =>
        `${contact.first_name || ''} ${contact.last_name || ''} ${contact.company || ''}`.toLowerCase().includes((window.projectContactSearchQuery || '').toLowerCase())
      ).length === 0 && window.projectContactSearchQuery && window.projectContactSearchQuery.trim() ? `
                    <div style="padding: 1rem; text-align: center; color: #6c757d; font-size: 0.875rem;">
                      No contacts found matching "${window.projectContactSearchQuery}"
                    </div>
                  ` : ''}
                </div>
              `}
            </div>
          </div>
          
          <!-- Project Name -->
          <div style="margin-bottom: 1.5rem;">
            <label style="
              display: block;
              margin-bottom: 0.5rem;
              color: #2c3e50;
              font-weight: 700;
              font-size: 0.875rem;
            ">
              Project Name *
            </label>
            <input
              type="text"
              id="project-name-input"
              placeholder="Enter project name"
              value="${isEditing && window.editingProject ? (window.editingProject.name || '') : ''}"
              required
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid #e5e7eb;
                border-radius: 0.5rem;
                font-size: 1rem;
                box-sizing: border-box;
              "
              onfocus="this.style.borderColor='#f59e0b'"
              onblur="this.style.borderColor='#e5e7eb'"
            />
          </div>
          
          <!-- Project Description -->
          <div style="margin-bottom: 1.5rem;">
            <label style="
              display: block;
              margin-bottom: 0.5rem;
              color: #2c3e50;
              font-weight: 700;
              font-size: 0.875rem;
            ">
              Description
            </label>
            <textarea
              id="project-description-input"
              placeholder="Enter project description"
              rows="4"
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid #e5e7eb;
                border-radius: 0.5rem;
                font-size: 1rem;
                box-sizing: border-box;
                resize: vertical;
                font-family: inherit;
              "
              onfocus="this.style.borderColor='#f59e0b'"
              onblur="this.style.borderColor='#e5e7eb'"
            >${isEditing && window.editingProject ? (window.editingProject.description || '') : ''}</textarea>
          </div>
        </div>
      </div>
    </div>
  `;

  // Remove existing modal if present
  const existingModal = document.getElementById('add-project-modal-overlay');
  if (existingModal) {
    existingModal.remove();
  }

  // Add modal to body
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = modalHTML;
  const modalElement = tempDiv.firstElementChild;
  document.body.appendChild(modalElement);
};

// Handle project contact search
window.handleProjectContactSearch = function (query) {
  window.projectContactSearchQuery = query || '';
  const resultsDiv = document.getElementById('project-contact-search-results');
  if (resultsDiv) {
    resultsDiv.style.display = query && query.trim() ? 'block' : 'none';

    const filtered = contacts.filter(contact =>
      `${contact.first_name || ''} ${contact.last_name || ''} ${contact.company || ''}`.toLowerCase().includes(query.toLowerCase())
    );

    resultsDiv.innerHTML = filtered.map(contact => `
      <div
        onclick="selectProjectContact('${contact.id}')"
        style="
          padding: 0.75rem;
          border-bottom: 1px solid #e9ecef;
          cursor: pointer;
          transition: background-color 0.2s;
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
        onmouseover="this.style.backgroundColor='#f8f9fa'"
        onmouseout="this.style.backgroundColor='transparent'"
      >
        <div>
          <div style="font-weight: 500; color: #2c3e50;">${contact.first_name || ''} ${contact.last_name || ''}</div>
          ${contact.company ? `<div style="font-size: 0.75rem; color: #6c757d; margin-top: 0.25rem;">${contact.company}</div>` : ''}
        </div>
        ${contact.contact_profile_id ? `
          <span style="background: #ff7f00; color: white; padding: 0.25rem 0.5rem; border-radius: 0.25rem; font-size: 0.75rem; font-weight: 600;">Client</span>
        ` : ''}
      </div>
    `).join('') + (filtered.length === 0 && query.trim() ? `
      <div style="padding: 1rem; text-align: center; color: #6c757d; font-size: 0.875rem;">
        No contacts found matching "${query}"
      </div>
    ` : '');
  }
};

// Select project contact
window.selectProjectContact = function (contactId) {
  window.tempSelectedContactId = contactId;
  window.projectContactSearchQuery = '';

  // Re-render modal
  const existingModal = document.getElementById('add-project-modal-overlay');
  if (existingModal) {
    existingModal.remove();
  }
  showAddProjectModalFromPMTool();
};

// Clear project contact
window.clearProjectContact = function () {
  window.tempSelectedContactId = null;
  window.projectContactSearchQuery = '';

  // Re-render modal
  const existingModal = document.getElementById('add-project-modal-overlay');
  if (existingModal) {
    existingModal.remove();
  }
  showAddProjectModalFromPMTool();
};

// Submit project from PM Tool
window.submitProjectFromPMTool = async function () {
  const nameInput = document.getElementById('project-name-input');
  const descriptionInput = document.getElementById('project-description-input');

  const name = nameInput?.value?.trim() || '';
  const description = descriptionInput?.value?.trim() || '';
  const contactId = window.tempSelectedContactId || null;
  const isEditing = window.editingProject ? true : false;

  if (!name) {
    alert('Please enter a project name');
    return;
  }

  const submitBtn = document.getElementById('save-project-btn');
  if (submitBtn) {
    submitBtn.disabled = true;
    submitBtn.textContent = isEditing ? 'Updating...' : 'Creating...';
  }

  try {
    let data, error;

    if (isEditing && window.editingProject) {
      // Update existing project
      const updateData = {
        name: name,
        description: description || null,
        contact_id: contactId,
        updated_at: new Date().toISOString()
      };

      const result = await supabase
        .from('projects')
        .update(updateData)
        .eq('id', window.editingProject.id)
        .select()
        .single();

      data = result.data;
      error = result.error;
    } else {
      // Create new project
      const result = await supabase
        .from('projects')
        .insert({
          name: name,
          description: description || null,
          company_id: currentCompany.id,
          contact_id: contactId,
          status: 'active',
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString()
        })
        .select()
        .single();

      data = result.data;
      error = result.error;
    }

    if (error) {
      throw error;
    }

    // Close modal
    closeAddProjectModal();
    window.editingProject = null;
    window.tempSelectedContactId = null;
    window.projectContactSearchQuery = '';

    // Refresh PM Tool
    renderPMTool();

    // Show success message
    const successMsg = document.createElement('div');
    successMsg.textContent = isEditing ? 'Project updated successfully!' : 'Project created successfully!';
    successMsg.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #28a745;
      color: white;
      padding: 0.75rem 1.5rem;
      border-radius: 0.5rem;
      z-index: 100001;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
    `;
    document.body.appendChild(successMsg);
    setTimeout(() => successMsg.remove(), 3000);
  } catch (error) {
    console.error(`Error ${isEditing ? 'updating' : 'creating'} project:`, error);
    alert(`Failed to ${isEditing ? 'update' : 'create'} project: ` + (error.message || 'Unknown error'));
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = isEditing ? 'Update' : 'Create';
    }
  }
};

window.showAddProjectModal = function (contactIdOverride = null) {
  // Check if we're in task form context - use task contact if available
  const contactId = contactIdOverride || window.selectedTaskContact || selectedContact || selectedContactId;
  const contact = contacts.find(c => c.id === contactId);
  if (!contact) {
    alert('No contact selected');
    return;
  }

  // Store the contact ID for submitProject to use
  window.tempSelectedContactId = contactId;

  const contactName = `${contact.first_name} ${contact.last_name}`;
  const isEditing = window.editingProject ? true : false;
  const project = window.editingProject || {};

  // Create modal overlay
  const modalHTML = `
    <div id="add-project-modal-overlay" style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      z-index: 100000;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem;
    " onclick="if (event.target.id === 'add-project-modal-overlay') closeAddProjectModal()">
      <div id="add-project-modal" style="
        background: #ffffff;
        border-radius: 0.75rem;
        width: 100%;
        max-width: 600px;
        max-height: 90vh;
        display: flex;
        flex-direction: column;
        box-shadow: 0 10px 25px rgba(0,0,0,0.2);
      " onclick="event.stopPropagation()">
        <!-- Header -->
        <div style="
          padding: 1rem 1.5rem;
          border-bottom: 1px solid #e9ecef;
          display: flex;
          justify-content: space-between;
          align-items: center;
        ">
          <button onclick="closeAddProjectModal(); window.editingProject = null;" style="
            background: transparent;
            border: none;
            color: #6c757d;
            cursor: pointer;
            font-size: 0.875rem;
            padding: 0.25rem 0.5rem;
          ">Cancel</button>
          <h2 style="
            margin: 0;
            font-size: 1.125rem;
            font-weight: 700;
            color: #2c3e50;
          ">${isEditing ? 'Edit Project' : 'Create Project'}</h2>
          <button id="save-project-btn" onclick="submitProject()" style="
            background: #f59e0b;
            color: white;
            border: none;
            padding: 0.5rem 1rem;
            border-radius: 0.375rem;
            cursor: pointer;
            font-size: 0.875rem;
            font-weight: 600;
          ">${isEditing ? 'Update' : 'Create'}</button>
        </div>

        <!-- Content -->
        <div style="
          flex: 1;
          overflow-y: auto;
          padding: 1.5rem;
        ">
          <!-- Contact Info -->
          <div style="
            background: #f8f9fa;
            padding: 1rem;
            border-radius: 0.5rem;
            margin-bottom: 1.5rem;
          ">
            <div style="
              font-size: 0.875rem;
              color: #6c757d;
              margin-bottom: 0.25rem;
            ">Project for:</div>
            <div style="
              font-size: 1.125rem;
              font-weight: 600;
              color: #2c3e50;
            ">${contactName}</div>
          </div>

          <!-- Project Name -->
          <div style="margin-bottom: 1.5rem;">
            <label style="
              display: block;
              font-size: 0.875rem;
              font-weight: 600;
              color: #2c3e50;
              margin-bottom: 0.5rem;
            ">Project Name *</label>
            <input
              type="text"
              id="project-name-input"
              placeholder="Enter project name"
              value="${project.name || ''}"
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid #e9ecef;
                border-radius: 0.5rem;
                font-size: 0.875rem;
                box-sizing: border-box;
                transition: border-color 0.2s;
              "
              onfocus="this.style.borderColor='#007bff'"
              onblur="this.style.borderColor='#e9ecef'"
            />
          </div>

          <!-- Description -->
          <div style="margin-bottom: 1.5rem;">
            <label style="
              display: block;
              font-size: 0.875rem;
              font-weight: 600;
              color: #2c3e50;
              margin-bottom: 0.5rem;
            ">Description</label>
            <textarea
              id="project-description-input"
              placeholder="Enter project description (optional)"
              rows="3"
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid #e9ecef;
                border-radius: 0.5rem;
                font-size: 0.875rem;
                box-sizing: border-box;
                resize: vertical;
                font-family: inherit;
                transition: border-color 0.2s;
              "
              onfocus="this.style.borderColor='#007bff'"
              onblur="this.style.borderColor='#e9ecef'"
            >${project.description || ''}</textarea>
          </div>

          <!-- Due Date -->
          <div style="margin-bottom: 1.5rem;">
            <label style="
              display: block;
              font-size: 0.875rem;
              font-weight: 600;
              color: #2c3e50;
              margin-bottom: 0.5rem;
            ">Due Date</label>
            <input
              type="date"
              id="project-due-date-input"
              value="${project.due_date ? project.due_date.split('T')[0] : ''}"
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid #e9ecef;
                border-radius: 0.5rem;
                font-size: 0.875rem;
                box-sizing: border-box;
                transition: border-color 0.2s;
              "
              onfocus="this.style.borderColor='#007bff'"
              onblur="this.style.borderColor='#e9ecef'"
            />
          </div>

          <!-- Assign Team Members -->
          <div style="margin-bottom: 1.5rem;">
            <label style="
              display: block;
              font-size: 0.875rem;
              font-weight: 600;
              color: #2c3e50;
              margin-bottom: 0.5rem;
            ">Assign Team Members</label>
            <div id="project-team-members-container" style="
              display: flex;
              flex-wrap: wrap;
              gap: 0.5rem;
              padding: 0.75rem;
              border: 1px solid #e9ecef;
              border-radius: 0.5rem;
              min-height: 60px;
              background: #ffffff;
            ">
              ${teamMembers.length === 0 ? `
                <div style="color: #6c757d; font-size: 0.875rem;">No team members available</div>
              ` : teamMembers.map(member => `
                <button
                  type="button"
                  class="project-member-btn"
                  data-member-id="${member.id}"
                  onclick="toggleProjectMember('${member.id}')"
                  style="
                    padding: 0.5rem 1rem;
                    border-radius: 1.5rem;
                    border: 1px solid #e9ecef;
                    background: #f8f9fa;
                    color: #2c3e50;
                    cursor: pointer;
                    font-size: 0.875rem;
                    font-weight: 500;
                    transition: all 0.2s;
                  "
                >
                  ${member.first_name} ${member.last_name}
                </button>
              `).join('')}
            </div>
          </div>
        </div>
      </div>
    </div>
  `;

  document.body.insertAdjacentHTML('beforeend', modalHTML);

  // Focus on project name input
  setTimeout(() => {
    const nameInput = document.getElementById('project-name-input');
    if (nameInput) nameInput.focus();
  }, 100);
}

// Close project modal
window.closeAddProjectModal = function () {
  const modal = document.getElementById('add-project-modal-overlay');
  if (modal) {
    modal.remove();
  }
  // Reset selected members and editing state
  selectedProjectMembers = [];
  window.editingProject = null;
  // Reset temp selected contact ID when closing modal
  window.tempSelectedContactId = null;
  window.projectContactSearchQuery = '';
}

// Edit project function
window.editProject = async function (projectId) {
  console.log('✏️ Edit project:', projectId);

  // Fetch project details
  const { data: project, error } = await supabase
    .from('projects')
    .select('*')
    .eq('id', projectId)
    .single();

  if (error || !project) {
    console.error('Error loading project:', error);
    alert('Failed to load project details');
    return;
  }

  // Set the contact ID from the project so the modal shows the correct contact
  window.tempSelectedContactId = project.contact_id || null;

  // Open the project modal in edit mode
  window.editingProject = project;

  // Use showAddProjectModalFromPMTool which has contact selector support
  showAddProjectModalFromPMTool();
};

// Show delete project confirmation modal
window.showDeleteProjectConfirm = function (projectId) {
  if (!projectId) return;

  // Remove any existing modal
  const existingModal = document.getElementById('delete-project-modal');
  if (existingModal) {
    existingModal.remove();
  }

  const project = projects.find(p => p.id === projectId);
  const projectName = project ? project.name || 'Untitled Project' : 'this project';

  const modal = document.createElement('div');
  modal.id = 'delete-project-modal';
  modal.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10001;
    animation: fadeIn 0.2s ease-out;
  `;

  modal.innerHTML = `
    <div style="
      background: white;
      border-radius: 1rem;
      padding: 0;
      max-width: 400px;
      width: 90%;
      box-shadow: 0 25px 50px rgba(0,0,0,0.25);
      animation: scaleIn 0.2s ease-out;
      overflow: hidden;
    ">
      <!-- Header -->
      <div style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1.25rem 1.5rem;
        border-bottom: 1px solid #E5E7EB;
      ">
        <div style="display: flex; align-items: center; gap: 0.75rem;">
          <span class="material-icons" style="color: #EF4444; font-size: 24px;">warning</span>
          <h3 style="margin: 0; font-size: 1.125rem; font-weight: 600; color: #111827;">Delete Project</h3>
        </div>
        <button 
          onclick="closeDeleteProjectModal()"
          style="
            background: transparent;
            border: none;
            cursor: pointer;
            padding: 0.25rem;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 0.375rem;
            color: #6B7280;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#F3F4F6'; this.style.color='#111827';"
          onmouseout="this.style.background='transparent'; this.style.color='#6B7280';"
        >
          <span class="material-icons" style="font-size: 20px;">close</span>
        </button>
      </div>
      
      <!-- Body -->
      <div style="padding: 1.5rem;">
        <p style="margin: 0; color: #4B5563; font-size: 0.9375rem; line-height: 1.5;">
          Are you sure you want to delete <strong>${projectName}</strong>? This action cannot be undone. Tasks will be preserved but unlinked from this project.
        </p>
      </div>
      
      <!-- Footer -->
      <div style="
        display: flex;
        gap: 0.75rem;
        padding: 1rem 1.5rem;
        background: #F9FAFB;
        border-top: 1px solid #E5E7EB;
        justify-content: flex-end;
      ">
        <button 
          onclick="closeDeleteProjectModal()"
          style="
            padding: 0.75rem 1.5rem;
            background: white;
            border: 1px solid #D1D5DB;
            border-radius: 0.5rem;
            color: #374151;
            font-size: 0.9375rem;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#F9FAFB'; this.style.borderColor='#9CA3AF';"
          onmouseout="this.style.background='white'; this.style.borderColor='#D1D5DB';"
        >
          No
        </button>
        <button 
          onclick="confirmDeleteProject('${projectId}')"
          style="
            padding: 0.75rem 1.5rem;
            background: #EF4444;
            border: none;
            border-radius: 0.5rem;
            color: white;
            font-size: 0.9375rem;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#DC2626';"
          onmouseout="this.style.background='#EF4444';"
        >
          Yes
        </button>
      </div>
    </div>
  `;

  // Add fadeIn and scaleIn animations if they don't exist
  if (!document.getElementById('delete-project-modal-styles')) {
    const style = document.createElement('style');
    style.id = 'delete-project-modal-styles';
    style.textContent = `
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      @keyframes scaleIn {
        from { transform: scale(0.95); opacity: 0; }
        to { transform: scale(1); opacity: 1; }
      }
    `;
    document.head.appendChild(style);
  }

  // Close on backdrop click
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      closeDeleteProjectModal();
    }
  });

  document.body.appendChild(modal);
};

// Close delete project modal
window.closeDeleteProjectModal = function () {
  const modal = document.getElementById('delete-project-modal');
  if (modal) {
    modal.style.opacity = '0';
    setTimeout(() => {
      modal.remove();
    }, 200);
  }
};

// Confirm delete project
window.confirmDeleteProject = async function (projectId) {
  if (!projectId) return;

  const deleteBtn = document.querySelector('#delete-project-modal button[onclick*="confirmDeleteProject"]');
  if (deleteBtn) {
    deleteBtn.disabled = true;
    deleteBtn.innerHTML = '<span class="material-icons" style="font-size: 18px; animation: spin 1s linear infinite; display: inline-block;">refresh</span> Deleting...';
  }

  console.log('🗑️ Deleting project:', projectId);

  try {
    const { error } = await supabase
      .from('projects')
      .delete()
      .eq('id', projectId);

    if (error) throw error;

    console.log('✅ Project deleted successfully');

    closeDeleteProjectModal();
    showNotification('Project deleted successfully', 'success');

    // Refresh the contact detail view
    if (currentScreen === 'sales' && selectedContactId) {
      await updateContactDetailContent();
    } else {
      renderPMTool();
    }
  } catch (error) {
    console.error('Error deleting project:', error);
    closeDeleteProjectModal();
    showNotification('Failed to delete project: ' + (error.message || error), 'error');
  }
};

// Delete project function (shows confirmation modal)
window.deleteProject = function (projectId) {
  if (!projectId) return;
  showDeleteProjectConfirm(projectId);
};


// Toggle show all tasks
window.toggleShowAllTasks = function () {
  showAllTasks = !showAllTasks;
  // Re-render just the tasks tab if we have cached data
  if (currentScreen === 'sales' && selectedContactId && cachedContactData.contactId === selectedContactId) {
    const tabContentDiv = document.getElementById('contact-tab-content');
    if (tabContentDiv && contactDetailViewTab === 'tasks') {
      tabContentDiv.innerHTML = renderTasksTab(cachedContactData.tasks);
      return;
    }
  }
  // Fallback
  if (currentScreen === 'sales' && selectedContactId) {
    updateContactDetailContent();
  } else {
    renderPMTool();
  }
};

// Toggle show all projects
// Toggle PM Tool view between tasks and folders
window.togglePMToolView = function () {
  // Immediate visual feedback - animate the button before re-render
  const btn = document.querySelector('[onclick="togglePMToolView()"]');
  if (btn) {
    btn.style.opacity = '0.5';
    btn.style.pointerEvents = 'none';
    btn.textContent = '...';
  }

  // Update state
  pmToolViewMode = pmToolViewMode === 'tasks' ? 'folders' : 'tasks';
  window.pmToolViewMode = pmToolViewMode;

  // Use requestAnimationFrame to allow browser to paint the button feedback first
  requestAnimationFrame(() => {
    renderPMTool();
  });
};

// Quick Tasks functionality
window.toggleQuickTasksModal = async function () {
  showQuickTasksModal = !showQuickTasksModal;
  if (showQuickTasksModal) {
    await loadQuickTasks();
  }
  renderPMTool();
};

async function loadQuickTasks() {
  if (!currentCompany || !currentUser?.id) {
    quickTasks = [];
    return;
  }

  try {
    // Get all DRAFT tasks for the company, then filter by assignee (since tasks don't have created_by)
    const { data: allDraftTasks, error: tasksError } = await supabase
      .from('tasks')
      .select('*')
      .eq('company_id', currentCompany.id)
      .eq('state', 'DRAFT')
      .order('created_at', { ascending: false });

    if (tasksError) throw tasksError;

    // Get task IDs assigned to current user
    if (allDraftTasks && allDraftTasks.length > 0) {
      const taskIds = allDraftTasks.map(t => t.id);
      const { data: assignments, error: assignError } = await supabase
        .from('task_assignees')
        .select('task_id')
        .in('task_id', taskIds)
        .eq('user_id', currentUser.id);

      if (assignError) throw assignError;

      const assignedTaskIds = new Set((assignments || []).map(a => a.task_id));
      quickTasks = allDraftTasks.filter(task => assignedTaskIds.has(task.id));
    } else {
      quickTasks = [];
    }
  } catch (error) {
    console.error('Error loading quick tasks:', error);
    quickTasks = [];
  }
}

window.createQuickTask = async function (title) {
  if (!title || !title.trim() || !currentCompany || !currentUser?.id) return;

  try {
    const { data, error } = await supabase
      .from('tasks')
      .insert({
        company_id: currentCompany.id,
        title: title.trim(),
        state: 'DRAFT',
        priority: 'LOW'
      })
      .select()
      .single();

    if (error) throw error;

    // Assign to self
    await supabase
      .from('task_assignees')
      .insert({
        task_id: data.id,
        user_id: currentUser.id
      });

    // Reload both quick tasks modal AND main tasks so it appears in PM tool immediately
    await Promise.all([loadQuickTasks(), loadTasks()]);
    renderPMTool();

    // Focus the new task input (not editing inputs)
    setTimeout(() => {
      const newTaskInput = document.getElementById('new-quick-task-input');
      if (newTaskInput) {
        newTaskInput.focus();
      }
    }, 100);
  } catch (error) {
    console.error('Error creating quick task:', error);
    showNotification('Failed to create quick task', 'error');
  }
};

window.updateQuickTaskTitle = async function (taskId, newTitle) {
  if (!taskId || !newTitle || !newTitle.trim()) return;

  try {
    const { error } = await supabase
      .from('tasks')
      .update({ title: newTitle.trim() })
      .eq('id', taskId);

    if (error) throw error;
    await Promise.all([loadQuickTasks(), loadTasks()]);
    renderPMTool();
  } catch (error) {
    console.error('Error updating quick task title:', error);
    showNotification('Failed to update quick task', 'error');
  }
};

// Show delete quick task confirmation modal
window.showDeleteQuickTaskConfirm = function (taskId) {
  if (!taskId) return;

  deletingQuickTaskId = taskId;

  // Remove any existing modal
  const existingModal = document.getElementById('delete-quick-task-modal');
  if (existingModal) {
    existingModal.remove();
  }

  const modal = document.createElement('div');
  modal.id = 'delete-quick-task-modal';
  modal.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10001;
    animation: fadeIn 0.2s ease-out;
  `;

  modal.innerHTML = `
    <div style="
      background: white;
      border-radius: 1rem;
      padding: 0;
      max-width: 400px;
      width: 90%;
      box-shadow: 0 25px 50px rgba(0,0,0,0.25);
      animation: scaleIn 0.2s ease-out;
      overflow: hidden;
    ">
      <!-- Header -->
      <div style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1.25rem 1.5rem;
        border-bottom: 1px solid #E5E7EB;
      ">
        <div style="display: flex; align-items: center; gap: 0.75rem;">
          <span class="material-icons" style="color: #EF4444; font-size: 24px;">warning</span>
          <h3 style="margin: 0; font-size: 1.125rem; font-weight: 600; color: #111827;">Delete Quick Task</h3>
        </div>
        <button 
          onclick="closeDeleteQuickTaskModal()"
          style="
            background: transparent;
            border: none;
            cursor: pointer;
            padding: 0.25rem;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 0.375rem;
            color: #6B7280;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#F3F4F6'; this.style.color='#111827';"
          onmouseout="this.style.background='transparent'; this.style.color='#6B7280';"
        >
          <span class="material-icons" style="font-size: 20px;">close</span>
        </button>
      </div>
      
      <!-- Body -->
      <div style="padding: 1.5rem;">
        <p style="margin: 0; color: #4B5563; font-size: 0.9375rem; line-height: 1.5;">
          Are you sure you want to delete this quick task? This action cannot be undone.
        </p>
      </div>
      
      <!-- Footer -->
      <div style="
        display: flex;
        gap: 0.75rem;
        padding: 1rem 1.5rem;
        background: #F9FAFB;
        border-top: 1px solid #E5E7EB;
        justify-content: flex-end;
      ">
        <button 
          onclick="closeDeleteQuickTaskModal()"
          style="
            padding: 0.75rem 1.5rem;
            background: white;
            border: 1px solid #D1D5DB;
            border-radius: 0.5rem;
            color: #374151;
            font-size: 0.9375rem;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#F9FAFB'; this.style.borderColor='#9CA3AF';"
          onmouseout="this.style.background='white'; this.style.borderColor='#D1D5DB';"
        >
          Cancel
        </button>
        <button 
          onclick="confirmDeleteQuickTask('${taskId}')"
          style="
            padding: 0.75rem 1.5rem;
            background: #EF4444;
            border: none;
            border-radius: 0.5rem;
            color: white;
            font-size: 0.9375rem;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#DC2626';"
          onmouseout="this.style.background='#EF4444';"
        >
          Delete
        </button>
      </div>
    </div>
  `;

  // Add fadeIn and scaleIn animations if they don't exist
  if (!document.getElementById('delete-quick-task-modal-styles')) {
    const style = document.createElement('style');
    style.id = 'delete-quick-task-modal-styles';
    style.textContent = `
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      @keyframes scaleIn {
        from { transform: scale(0.95); opacity: 0; }
        to { transform: scale(1); opacity: 1; }
      }
    `;
    document.head.appendChild(style);
  }

  // Close on backdrop click
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      closeDeleteQuickTaskModal();
    }
  });

  document.body.appendChild(modal);
};

// Close delete quick task modal
window.closeDeleteQuickTaskModal = function () {
  const modal = document.getElementById('delete-quick-task-modal');
  if (modal) {
    modal.style.opacity = '0';
    setTimeout(() => {
      modal.remove();
      deletingQuickTaskId = null;
    }, 200);
  }
};

// Confirm delete quick task
window.confirmDeleteQuickTask = async function (taskId) {
  if (!taskId) taskId = deletingQuickTaskId;
  if (!taskId) return;

  const deleteBtn = document.querySelector('#delete-quick-task-modal button[onclick*="confirmDeleteQuickTask"]');
  if (deleteBtn) {
    deleteBtn.disabled = true;
    deleteBtn.innerHTML = '<span class="material-icons" style="font-size: 18px; animation: spin 1s linear infinite; display: inline-block;">refresh</span> Deleting...';
  }

  try {
    const { error } = await supabase
      .from('tasks')
      .delete()
      .eq('id', taskId)
      .eq('state', 'DRAFT');

    if (error) throw error;

    closeDeleteQuickTaskModal();
    showNotification('Task deleted successfully', 'success');

    await Promise.all([loadQuickTasks(), loadTasks()]);
    renderPMTool();
  } catch (error) {
    console.error('Error deleting quick task:', error);
    closeDeleteQuickTaskModal();
    showNotification('Failed to delete quick task', 'error');
  }
};

// Delete quick task (shows confirmation modal)
window.deleteQuickTask = function (taskId) {
  if (!taskId) return;
  showDeleteQuickTaskConfirm(taskId);
};

// Show delete task from project confirmation modal
window.showDeleteTaskFromProjectConfirm = function (taskId, projectId) {
  if (!taskId) return;

  // Remove any existing modal
  const existingModal = document.getElementById('delete-task-from-project-modal');
  if (existingModal) {
    existingModal.remove();
  }

  const modal = document.createElement('div');
  modal.id = 'delete-task-from-project-modal';
  modal.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10001;
    animation: fadeIn 0.2s ease-out;
  `;

  modal.innerHTML = `
    <div style="
      background: white;
      border-radius: 1rem;
      padding: 0;
      max-width: 400px;
      width: 90%;
      box-shadow: 0 25px 50px rgba(0,0,0,0.25);
      animation: scaleIn 0.2s ease-out;
      overflow: hidden;
    ">
      <!-- Header -->
      <div style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1.25rem 1.5rem;
        border-bottom: 1px solid #E5E7EB;
      ">
        <div style="display: flex; align-items: center; gap: 0.75rem;">
          <span class="material-icons" style="color: #EF4444; font-size: 24px;">warning</span>
          <h3 style="margin: 0; font-size: 1.125rem; font-weight: 600; color: #111827;">Delete Task</h3>
        </div>
        <button 
          onclick="closeDeleteTaskFromProjectModal()"
          style="
            background: transparent;
            border: none;
            cursor: pointer;
            padding: 0.25rem;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 0.375rem;
            color: #6B7280;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#F3F4F6'; this.style.color='#111827';"
          onmouseout="this.style.background='transparent'; this.style.color='#6B7280';"
        >
          <span class="material-icons" style="font-size: 20px;">close</span>
        </button>
      </div>
      
      <!-- Body -->
      <div style="padding: 1.5rem;">
        <p style="margin: 0; color: #4B5563; font-size: 0.9375rem; line-height: 1.5;">
          Are you sure you want to delete this task? This action cannot be undone.
        </p>
      </div>
      
      <!-- Footer -->
      <div style="
        display: flex;
        gap: 0.75rem;
        padding: 1rem 1.5rem;
        background: #F9FAFB;
        border-top: 1px solid #E5E7EB;
        justify-content: flex-end;
      ">
        <button 
          onclick="closeDeleteTaskFromProjectModal()"
          style="
            padding: 0.75rem 1.5rem;
            background: white;
            border: 1px solid #D1D5DB;
            border-radius: 0.5rem;
            color: #374151;
            font-size: 0.9375rem;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#F9FAFB'; this.style.borderColor='#9CA3AF';"
          onmouseout="this.style.background='white'; this.style.borderColor='#D1D5DB';"
        >
          Cancel
        </button>
        <button 
          onclick="confirmDeleteTaskFromProject('${taskId}', '${projectId || ''}')"
          style="
            padding: 0.75rem 1.5rem;
            background: #EF4444;
            border: none;
            border-radius: 0.5rem;
            color: white;
            font-size: 0.9375rem;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#DC2626';"
          onmouseout="this.style.background='#EF4444';"
        >
          Delete
        </button>
      </div>
    </div>
  `;

  // Add fadeIn and scaleIn animations if they don't exist
  if (!document.getElementById('delete-task-from-project-modal-styles')) {
    const style = document.createElement('style');
    style.id = 'delete-task-from-project-modal-styles';
    style.textContent = `
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      @keyframes scaleIn {
        from { transform: scale(0.95); opacity: 0; }
        to { transform: scale(1); opacity: 1; }
      }
    `;
    document.head.appendChild(style);
  }

  // Close on backdrop click
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      closeDeleteTaskFromProjectModal();
    }
  });

  document.body.appendChild(modal);
};

// Close delete task from project modal
window.closeDeleteTaskFromProjectModal = function () {
  const modal = document.getElementById('delete-task-from-project-modal');
  if (modal) {
    modal.style.opacity = '0';
    setTimeout(() => {
      modal.remove();
    }, 200);
  }
};

// Confirm delete task from project
window.confirmDeleteTaskFromProject = async function (taskId, projectId) {
  if (!taskId) return;

  const deleteBtn = document.querySelector('#delete-task-from-project-modal button[onclick*="confirmDeleteTaskFromProject"]');
  if (deleteBtn) {
    deleteBtn.disabled = true;
    deleteBtn.innerHTML = '<span class="material-icons" style="font-size: 18px; animation: spin 1s linear infinite; display: inline-block;">refresh</span> Deleting...';
  }

  try {
    // Delete task assignees first
    await supabase
      .from('task_assignees')
      .delete()
      .eq('task_id', taskId);

    // Delete task clients
    await supabase
      .from('task_clients')
      .delete()
      .eq('task_id', taskId);

    // Delete the task
    const { error } = await supabase
      .from('tasks')
      .delete()
      .eq('id', taskId);

    if (error) throw error;

    closeDeleteTaskFromProjectModal();
    showNotification('Task deleted successfully', 'success');

    // Reload project tasks if projectId is provided
    if (projectId) {
      await loadProjectTasks(projectId);
    } else {
      // Reload all tasks
      await loadTasks();
      renderPMTool();
    }
  } catch (error) {
    console.error('Error deleting task:', error);
    closeDeleteTaskFromProjectModal();
    showNotification('Failed to delete task', 'error');
  }
};

window.editQuickTask = async function (taskId) {
  const quickTask = quickTasks.find(t => t.id === taskId);
  if (!quickTask) {
    console.error('Quick task not found:', taskId);
    return;
  }

  // Close quick tasks modal
  showQuickTasksModal = false;

  // Load task assignees for the quick task if needed
  try {
    const { data: assignees, error } = await supabase
      .from('task_assignees')
      .select('user_id, profiles!inner(id, first_name, last_name, avatar_path)')
      .eq('task_id', quickTask.id);

    if (!error && assignees) {
      quickTask.assigned_members = assignees.map(a => ({
        id: a.profiles.id,
        first_name: a.profiles.first_name,
        last_name: a.profiles.last_name,
        avatar_path: a.profiles.avatar_path
      }));
    }
  } catch (error) {
    console.error('Error loading task assignees:', error);
  }

  // Reset form state to ensure priority buttons work
  window.taskPriority = quickTask.priority || 'LOW';
  window.taskStatus = 'BACKLOG'; // Default to BACKLOG for conversion
  window.selectedTaskService = quickTask.service_id || '';
  window.customTaskServiceName = quickTask.service_name || '';
  window.selectedTaskMembers = [];

  // Set editing task data
  window.editingTaskData = quickTask;
  window.preselectedTaskContactId = quickTask.contact_id || null;
  window.preselectedTaskProjectId = quickTask.project_id || null;

  // Show task modal
  renderTaskModal();
};

window.convertQuickTaskToTask = async function (taskId) {
  if (!taskId) return;

  try {
    // Update task state from DRAFT to BACKLOG
    const { error } = await supabase
      .from('tasks')
      .update({ state: 'BACKLOG' })
      .eq('id', taskId)
      .eq('state', 'DRAFT');

    if (error) throw error;

    await loadQuickTasks();
    await loadTasks(); // Reload regular tasks
    renderPMTool();
    showNotification('Task created successfully', 'success');
  } catch (error) {
    console.error('Error converting quick task to task:', error);
    showNotification('Failed to create task', 'error');
  }
};

function renderQuickTasksModal() {
  const language = getEvaUserLanguage();
  const isSpanish = language === 'es';
  const descriptionText = isSpanish
    ? 'Las tareas rápidas se pueden encontrar en el toggle "personal" dentro de la sección "pendiente".'
    : 'Quick tasks can be found in the "personal" toggle inside the "backlog" section.';

  return `
    <div style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      z-index: 10000;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem;
    " onclick="if (event.target === this) toggleQuickTasksModal()">
      <div style="
        background: white;
        border-radius: 0.75rem;
        width: 100%;
        max-width: 600px;
        max-height: 80vh;
        display: flex;
        flex-direction: column;
        box-shadow: 0 10px 25px rgba(0,0,0,0.2);
      " onclick="event.stopPropagation()">
        <!-- Header -->
        <div style="
          padding: 1.5rem;
          border-bottom: 1px solid #e9ecef;
        ">
          <div style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 0.5rem;
          ">
            <h2 style="margin: 0; font-size: 1.25rem; font-weight: 700; color: #2c3e50;">+ Quick Task</h2>
            <button onclick="toggleQuickTasksModal()" style="
              background: transparent;
              border: none;
              color: #6c757d;
              cursor: pointer;
              font-size: 1.5rem;
              padding: 0.25rem 0.5rem;
              line-height: 1;
            ">×</button>
          </div>
          <p style="
            margin: 0;
            font-size: 0.75rem;
            color: #6c757d;
            text-align: center;
          ">${descriptionText}</p>
        </div>

        <!-- Content -->
        <div style="
          flex: 1;
          overflow-y: auto;
          padding: 1.5rem;
        ">
          <!-- New Quick Task Input (always at top) -->
          <div style="margin-bottom: 1.5rem;">
            <input
              type="text"
              id="new-quick-task-input"
              class="quick-task-title-input"
              placeholder="Type task title and press Enter..."
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid #e2e8f0;
                border-radius: 0.5rem;
                font-size: 1rem;
                outline: none;
              "
              onkeydown="if (event.key === 'Enter') { const title = event.target.value.trim(); if (title) { createQuickTask(title); event.target.value = ''; } }"
            />
          </div>

          <!-- Quick Tasks List -->
          <div style="display: flex; flex-direction: column; gap: 0.75rem;">
            ${quickTasks.length === 0 ? `
              <div style="
                text-align: center;
                padding: 3rem 1rem;
                color: #9ca3af;
              ">
                <p style="margin: 0; font-size: 0.875rem;">No quick tasks yet. Type above to create one!</p>
              </div>
            ` : quickTasks.map((task, index) => `
              <div style="
                display: flex;
                align-items: center;
                gap: 0.75rem;
                padding: 0.75rem;
                background: #f8f9fa;
                border-radius: 0.5rem;
                border: 1px solid #e9ecef;
              ">
                <input
                  type="text"
                  class="quick-task-title-input"
                  value="${(task.title || '').replace(/"/g, '&quot;')}"
                  data-task-id="${task.id}"
                  style="
                    flex: 1;
                    padding: 0.5rem;
                    border: 1px solid transparent;
                    border-radius: 0.375rem;
                    font-size: 0.875rem;
                    background: white;
                    outline: none;
                  "
                  onblur="const taskId = this.getAttribute('data-task-id'); const newTitle = this.value.trim(); if (newTitle && newTitle !== '${(task.title || '').replace(/"/g, '&quot;')}') { updateQuickTaskTitle(taskId, newTitle); }"
                  onkeydown="if (event.key === 'Enter') { this.blur(); }"
                />
                <button
                  onclick="editQuickTask('${task.id}')"
                  style="
                    background: #f59e0b;
                    color: white;
                    border: none;
                    padding: 0.5rem 1rem;
                    border-radius: 0.375rem;
                    cursor: pointer;
                    font-size: 0.875rem;
                    font-weight: 500;
                  "
                >Create</button>
                <button
                  onclick="deleteQuickTask('${task.id}')"
                  style="
                    background: #ef4444;
                    color: white;
                    border: none;
                    padding: 0.5rem 1rem;
                    border-radius: 0.375rem;
                    cursor: pointer;
                    font-size: 0.875rem;
                    font-weight: 500;
                  "
                >Delete</button>
              </div>
            `).join('')}
          </div>
        </div>
      </div>
    </div>
  `;
}

window.toggleShowAllProjects = async function () {
  showAllProjects = !showAllProjects;
  // Re-render just the projects tab if we have cached data
  if ((currentScreen === 'sales' || currentScreen === 'resources') && selectedContactId && cachedContactData.contactId === selectedContactId) {
    const tabContentDiv = document.getElementById('contact-tab-content');
    if (tabContentDiv && contactDetailViewTab === 'projects') {
      tabContentDiv.innerHTML = await renderProjectsTab(cachedContactData.projects);
      return;
    }
  }
  // Fallback to full reload
  if ((currentScreen === 'sales' || currentScreen === 'resources') && selectedContactId) {
    updateContactDetailContent();
  } else {
    renderPMTool();
  }
};

// Toggle project status menu
window.toggleProjectStatusMenu = function (projectId) {
  // Close all other menus first
  document.querySelectorAll('[id^="status-menu-"]').forEach(menu => {
    if (menu.id !== `status-menu-${projectId}`) {
      menu.style.display = 'none';
    }
  });

  const menu = document.getElementById(`status-menu-${projectId}`);
  if (menu) {
    menu.style.display = menu.style.display === 'none' || !menu.style.display ? 'block' : 'none';
  }

  // Close menu when clicking outside
  setTimeout(() => {
    document.addEventListener('click', function closeMenu(e) {
      if (!e.target.closest(`[onclick*="toggleProjectStatusMenu('${projectId}')"]`) &&
        !e.target.closest(`#status-menu-${projectId}`)) {
        const menu = document.getElementById(`status-menu-${projectId}`);
        if (menu) menu.style.display = 'none';
        document.removeEventListener('click', closeMenu);
      }
    });
  }, 0);
};

// Change project status
window.changeProjectStatus = async function (projectId, newStatus) {
  console.log('🔄 Changing project status:', projectId, 'to', newStatus);

  try {
    const { error } = await supabase
      .from('projects')
      .update({ status: newStatus })
      .eq('id', projectId);

    if (error) {
      console.error('Error updating project status:', error);
      alert('Failed to update project status: ' + error.message);
      return;
    }

    console.log('✅ Project status updated successfully');

    // Close the menu
    const menu = document.getElementById(`status-menu-${projectId}`);
    if (menu) menu.style.display = 'none';

    // Refresh the contact detail view
    if (currentScreen === 'sales' && selectedContactId) {
      await updateContactDetailContent();
    } else {
      renderPMTool();
    }

    // Show success message
    const successMsg = document.createElement('div');
    successMsg.textContent = 'Project status updated!';
    successMsg.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #28a745;
      color: white;
      padding: 0.75rem 1.5rem;
      border-radius: 0.5rem;
      z-index: 10001;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
    `;
    document.body.appendChild(successMsg);
    setTimeout(() => successMsg.remove(), 3000);
  } catch (error) {
    console.error('Error updating project status:', error);
    alert('An unexpected error occurred while updating the project status');
  }
};

// Toggle team member selection for project
window.selectedProjectMembers = [];
window.toggleProjectMember = function (memberId) {
  const index = selectedProjectMembers.indexOf(memberId);
  const btn = document.querySelector(`[data-member-id="${memberId}"].project-member-btn`);

  if (index > -1) {
    selectedProjectMembers.splice(index, 1);
    if (btn) {
      btn.style.background = '#f8f9fa';
      btn.style.borderColor = '#e9ecef';
      btn.style.color = '#2c3e50';
    }
  } else {
    selectedProjectMembers.push(memberId);
    if (btn) {
      btn.style.background = '#007bff';
      btn.style.borderColor = '#007bff';
      btn.style.color = '#ffffff';
    }
  }
}

// Submit project
window.submitProject = async function () {
  // Use temp contact ID if set (from task form), otherwise use selectedContactId
  const contactId = window.tempSelectedContactId || selectedContactId;
  const contact = contacts.find(c => c.id === contactId);
  if (!contact) {
    alert('No contact selected');
    return;
  }

  // Clear temp contact ID
  window.tempSelectedContactId = null;

  const nameInput = document.getElementById('project-name-input');
  const descriptionInput = document.getElementById('project-description-input');
  const dueDateInput = document.getElementById('project-due-date-input');

  const name = nameInput?.value?.trim();
  const description = descriptionInput?.value?.trim() || null;
  const dueDate = dueDateInput?.value || null;

  if (!name) {
    alert('Please enter a project name');
    if (nameInput) nameInput.focus();
    return;
  }

  const isEditing = window.editingProject ? true : false;
  const saveBtn = document.getElementById('save-project-btn');
  if (saveBtn) {
    saveBtn.disabled = true;
    saveBtn.textContent = isEditing ? 'Updating...' : 'Creating...';
  }

  try {
    let project;

    if (isEditing) {
      // UPDATE existing project
      const { data, error: projectError } = await supabase
        .from('projects')
        .update({
          name: name,
          description: description,
          due_date: dueDate ? dueDate : null,
        })
        .eq('id', window.editingProject.id)
        .select()
        .single();

      if (projectError) {
        console.error('Error updating project:', projectError);
        alert('Failed to update project: ' + (projectError.message || 'Unknown error'));
        if (saveBtn) {
          saveBtn.disabled = false;
          saveBtn.textContent = 'Update';
        }
        return;
      }

      project = data;
    } else {
      // CREATE new project
      const { data: newProject, error: projectError } = await supabase
        .from('projects')
        .insert({
          name: name,
          description: description,
          company_id: currentCompany.id,
          contact_id: contact.id,
          profile_id: contact.profile_id || null,
          due_date: dueDate ? dueDate : null,
          created_by: currentUser.id,
          status: 'active',
        })
        .select()
        .single();

      if (projectError) {
        console.error('Error creating project:', projectError);
        alert('Failed to create project: ' + (projectError.message || 'Unknown error'));
        if (saveBtn) {
          saveBtn.disabled = false;
          saveBtn.textContent = 'Create';
        }
        return;
      }

      project = newProject;
    }

    // Add project assignees
    if (selectedProjectMembers.length > 0) {
      const { error: assigneesError } = await supabase
        .from('project_assignees')
        .insert(
          selectedProjectMembers.map(userId => ({
            project_id: project.id,
            user_id: userId,
          }))
        );

      if (assigneesError) {
        console.error('Error adding assignees:', assigneesError);
      } else {
        // Send notifications to assigned members
        try {
          const assignerName = `${currentUser.first_name || ''} ${currentUser.last_name || ''}`.trim() || 'Someone';

          for (const userId of selectedProjectMembers) {
            await supabase.from('notifications').insert({
              user_id: userId,
              type: 'project_assigned',
              title: 'Assigned to Project',
              body: `${assignerName} assigned you to project "${project.name}"`,
              data: { project_id: project.id },
            });
          }
        } catch (error) {
          console.warn('Failed to send notifications:', error);
        }
      }
    }

    // Close modal
    closeAddProjectModal();
    window.editingProject = null;

    // Reset selected members
    selectedProjectMembers = [];

    // If we're in task form context, select the newly created project
    const isInTaskForm = window.tempSelectedContactId || window.selectedTaskContact || document.getElementById('add-task-modal');
    if (isInTaskForm && !isEditing) {
      // Select the newly created project in the task form
      window.selectedTaskProject = project.id;
      window.preselectedTaskProjectId = project.id;
      selectedProject = project.id;

      // Display the selected project in the task form
      setTimeout(() => {
        fetchAndDisplaySelectedProject(project.id);

        // Refresh project list to include the new project
        loadContactProjectList();
      }, 100);
    }

    // Clear temp contact ID
    window.tempSelectedContactId = null;

    // Refresh projects tab
    if (currentScreen === 'sales' && selectedContactId) {
      await updateContactDetailContent();
    } else if (isInTaskForm) {
      // Don't re-render if we're in task form - just update the project selection
      // renderPMTool() would close the task modal
    } else {
      renderPMTool();
    }

    // Show success message
    const successMsg = document.createElement('div');
    successMsg.textContent = isEditing ? 'Project updated successfully!' : 'Project created successfully!';
    successMsg.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: #28a745;
        color: white;
        padding: 0.75rem 1.5rem;
        border-radius: 0.5rem;
        z-index: 10001;
        box-shadow: 0 4px 6px rgba(0,0,0,0.1);
      `;
    document.body.appendChild(successMsg);
    setTimeout(() => successMsg.remove(), 3000);
  } catch (error) {
    console.error('Error saving project:', error);
    alert('An unexpected error occurred while saving the project');
    if (saveBtn) {
      saveBtn.disabled = false;
      saveBtn.textContent = isEditing ? 'Update' : 'Create';
    }
  }
};

// Global variables for task modal
window.editingTaskData = null;
window.preselectedTaskContactId = null;
window.preselectedTaskProjectId = null;

window.showAddTaskModal = function (preselectedContactId, preselectedProjectId) {
  console.log('🔍 [Task Modal] showAddTaskModal called with:', { preselectedContactId, preselectedProjectId });
  // Store preselected values
  window.preselectedTaskContactId = preselectedContactId || selectedContactId || null;
  window.preselectedTaskProjectId = preselectedProjectId || null;
  window.editingTaskData = null;
  console.log('🔍 [Task Modal] State set, calling renderTaskModal');

  // Show modal
  renderTaskModal();
}

window.showEditTaskModal = function (taskId) {
  const task = tasks.find(t => t.id === taskId);
  if (!task) {
    alert('Task not found');
    return;
  }

  window.editingTaskData = task;
  window.preselectedTaskContactId = task.contact_id || null;
  window.preselectedTaskProjectId = task.project_id || null;

  renderTaskModal();
}

window.renderTaskModal = async function () {
  console.log('🔍 [Task Modal] renderTaskModal called');
  // Show modal immediately, load projects asynchronously
  // First, remove any existing modal
  const existingModal = document.getElementById('add-task-modal-overlay');
  console.log('🔍 [Task Modal] Existing modal check:', existingModal ? 'found' : 'not found');
  if (existingModal) {
    existingModal.remove();
    console.log('🔍 [Task Modal] Removed existing modal');
  }

  // Initialize state variables - ensure they're set from editing data or preselected values
  console.log('🔍 [Task Modal] Initializing state - editingTaskData:', !!window.editingTaskData);
  if (window.editingTaskData) {
    // When editing, always use the task's contact_id and project_id
    window.selectedTaskContact = window.editingTaskData.contact_id || '';
    window.selectedTaskProject = window.editingTaskData.project_id || '';
    console.log('🔍 [Task Modal] Editing mode - contact:', window.selectedTaskContact, 'project:', window.selectedTaskProject);
  } else {
    // When creating new, use preselected values if available
    if (!window.selectedTaskContact) window.selectedTaskContact = window.preselectedTaskContactId || '';
    if (!window.selectedTaskProject) window.selectedTaskProject = window.preselectedTaskProjectId || '';
    console.log('🔍 [Task Modal] Create mode - contact:', window.selectedTaskContact, 'project:', window.selectedTaskProject);
  }

  // Start loading projects asynchronously (don't wait)
  let allProjects = [];
  const projectsPromise = (async () => {
    try {
      const { data, error } = await supabase
        .from('projects')
        .select('id, name, contact_id, status')
        .eq('company_id', currentCompany.id)
        .eq('status', 'active')
        .order('name');
      if (!error) {
        allProjects = data || [];
      }
    } catch (error) {
      console.error('Error loading projects:', error);
    }
  })();

  // Filter projects based on selected contact - only show active projects
  // Start with empty array, will be populated asynchronously
  let availableProjects = [];

  // Find contact data - first check contacts array, then check form submission modal data
  let selectedContactData = window.selectedTaskContact
    ? contacts.find(c => c.id === window.selectedTaskContact)
    : null;

  // If contact not found in contacts array but we have a preselected contact from form submission
  if (!selectedContactData && window.selectedTaskContact && window.formSubmissionModalData?.existingContact) {
    const formContact = window.formSubmissionModalData.existingContact;
    if (formContact.id === window.selectedTaskContact) {
      // Use contact data from form submission modal
      selectedContactData = {
        id: formContact.id,
        first_name: formContact.first_name || '',
        last_name: formContact.last_name || '',
        company: formContact.company_name || '',
        contact_profile_id: formContact.contact_profile_id || null
      };
    }
  }
  if (!window.taskContactSearchQuery) window.taskContactSearchQuery = '';
  if (!window.taskProjectSearchQuery) window.taskProjectSearchQuery = '';
  if (!window.taskMemberSearchQuery) window.taskMemberSearchQuery = '';
  if (!window.selectedTaskMembers) window.selectedTaskMembers = [];
  if (!window.showCreateProjectInTask) window.showCreateProjectInTask = false;
  if (!window.newProjectNameInTask) window.newProjectNameInTask = '';
  if (!window.newProjectDescriptionInTask) window.newProjectDescriptionInTask = '';
  if (!window.newProjectConfirmedInTask) window.newProjectConfirmedInTask = false;

  // Create modal overlay
  console.log('🔍 [Task Modal] Building modal HTML');
  const modalHTML = `
    <div id="add-task-modal-overlay" style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      z-index: 10000;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem;
    " onclick="if (event.target.id === 'add-task-modal-overlay') closeAddTaskModal()">
      <div id="add-task-modal" style="
        background: #ffffff;
        border-radius: 0.75rem;
        width: 100%;
        max-width: 700px;
        max-height: 90vh;
        display: flex;
        flex-direction: column;
        box-shadow: 0 10px 25px rgba(0,0,0,0.2);
      " onclick="event.stopPropagation()">
        <!-- Header -->
        <div style="
          padding: 1rem 1.5rem;
          border-bottom: 1px solid #e9ecef;
          display: flex;
          justify-content: space-between;
          align-items: center;
          box-shadow: 0 2px 4px rgba(0,0,0,0.05);
        ">
          <button onclick="closeAddTaskModal()" style="
            background: transparent;
            border: none;
            color: #6c757d;
            cursor: pointer;
            font-size: 0.875rem;
            padding: 0.25rem 0.5rem;
          ">Cancel</button>
          <h2 style="
            margin: 0;
            font-size: 1.125rem;
            font-weight: 700;
            color: #2c3e50;
          ">${window.editingTaskData ? 'Edit Task' : 'Create Task'}</h2>
          <button id="create-task-btn" type="button" onclick="submitTask(event)" style="
            background: #f59e0b;
            color: white;
            border: none;
            padding: 0.5rem 1rem;
            border-radius: 0.375rem;
            cursor: pointer;
            font-size: 0.875rem;
            font-weight: 600;
          ">${window.editingTaskData ? 'Update' : 'Create'}</button>
        </div>

        <!-- Content -->
        <div style="
          flex: 1;
          overflow-y: auto;
          overflow-x: hidden;
          padding: 1.5rem;
          scrollbar-width: thin;
          scrollbar-color: #007bff #f8f9fa;
        ">
          <!-- Task Title -->
          <div style="margin-bottom: 1.5rem;">
            <label style="
              display: block;
              font-size: 0.875rem;
              font-weight: 600;
              color: #2c3e50;
              margin-bottom: 0.5rem;
            ">Task Title *</label>
            <div>
              <input
                type="text"
                id="task-title-input"
                placeholder="Enter task title"
                value="${window.editingTaskData?.title || window.tempTaskTitle || ''}"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e9ecef;
                  border-radius: 0.5rem;
                  font-size: 0.875rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s;
                "
                onfocus="this.style.borderColor='#007bff'"
                onblur="this.style.borderColor='#e9ecef'"
              />
            </div>
          </div>

          <!-- Description -->
          <div style="margin-bottom: 1.5rem;">
            <label style="
              display: block;
              font-size: 0.875rem;
              font-weight: 600;
              color: #2c3e50;
              margin-bottom: 0.5rem;
            ">Description *</label>
            <div>
              <textarea
                id="task-description-input"
                placeholder="Enter task description"
                rows="3"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e9ecef;
                  border-radius: 0.5rem;
                  font-size: 0.875rem;
                  box-sizing: border-box;
                  resize: vertical;
                  font-family: inherit;
                  transition: border-color 0.2s;
                "
                onfocus="this.style.borderColor='#007bff'"
                onblur="this.style.borderColor='#e9ecef'"
              >${window.editingTaskData?.description || window.tempTaskDescription || ''}</textarea>
            </div>
          </div>

          <!-- Service -->
          <div style="margin-bottom: 1.5rem;">
            <label style="
              display: block;
              font-size: 0.875rem;
              font-weight: 600;
              color: #2c3e50;
              margin-bottom: 0.5rem;
            ">Service</label>
            <div style="display: flex; flex-wrap: wrap; gap: 0.5rem; margin-bottom: 0.5rem;">
              <button
                type="button"
                class="task-service-btn"
                data-service-id=""
                onclick="selectTaskService('')"
                style="
                  padding: 0.5rem 1rem;
                  border-radius: 1.5rem;
                  border: 1px solid #e9ecef;
                  background: ${window.selectedTaskService === '' ? '#f59e0b' : '#f8f9fa'};
                  color: ${window.selectedTaskService === '' ? 'white' : '#2c3e50'};
                  cursor: pointer;
                  font-size: 0.875rem;
                  font-weight: 500;
                  transition: all 0.2s;
                "
              >
                Other
              </button>
              ${(services || []).map(service => `
                <button
                  type="button"
                  class="task-service-btn"
                  data-service-id="${service.id}"
                  onclick="selectTaskService('${service.id}')"
                  style="
                    padding: 0.5rem 1rem;
                    border-radius: 1.5rem;
                    border: 1px solid #e9ecef;
                    background: ${window.selectedTaskService === service.id ? '#f59e0b' : '#f8f9fa'};
                    color: ${window.selectedTaskService === service.id ? 'white' : '#2c3e50'};
                    cursor: pointer;
                    font-size: 0.875rem;
                    font-weight: 500;
                    transition: all 0.2s;
                  "
                >
                  ${service.name}
                </button>
              `).join('')}
            </div>
            <input
              type="text"
              id="task-custom-service-input"
              placeholder="Enter custom service name"
              value="${window.customTaskServiceName || ''}"
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid #e9ecef;
                border-radius: 0.5rem;
                font-size: 0.875rem;
                box-sizing: border-box;
                display: ${window.selectedTaskService === '' ? 'block' : 'none'};
                transition: border-color 0.2s;
              "
              onfocus="this.style.borderColor='#007bff'"
              onblur="this.style.borderColor='#e9ecef'"
              oninput="window.customTaskServiceName = this.value"
            />
          </div>

          <!-- Priority -->
          <div style="margin-bottom: 1.5rem; display: none;">
            <label style="
              display: block;
              font-size: 0.875rem;
              font-weight: 600;
              color: #2c3e50;
              margin-bottom: 0.5rem;
            ">Priority</label>
            <div style="display: flex; flex-wrap: wrap; gap: 0.5rem;">
              ${['LOW', 'MEDIUM', 'HIGH', 'URGENT'].map(priority => {
    const colors = {
      LOW: '#10b981',
      MEDIUM: '#f59e0b',
      HIGH: '#f97316',
      URGENT: '#dc2626'
    };
    const isSelected = (window.taskPriority || (window.editingTaskData?.priority || 'MEDIUM')) === priority;
    return `
                  <button
                    type="button"
                    onclick="setTaskPriority('${priority}')"
                    style="
                      padding: 0.5rem 1rem;
                      border-radius: 1rem;
                      border: 1px solid ${colors[priority]};
                      background: ${isSelected ? colors[priority] : '#ffffff'};
                      color: ${isSelected ? 'white' : colors[priority]};
                      cursor: pointer;
                      font-size: 0.875rem;
                      font-weight: 500;
                      transition: all 0.2s;
                    "
                  >
                    ${priority}
                  </button>
                `;
  }).join('')}
            </div>
          </div>

          <!-- Due Date -->
          <div style="margin-bottom: 1.5rem;">
            <label style="
              display: block;
              font-size: 0.875rem;
              font-weight: 600;
              color: #2c3e50;
              margin-bottom: 0.5rem;
            ">Due Date</label>
            <input
              type="date"
              id="task-due-date-input"
              value="${window.editingTaskData?.due_at ? new Date(window.editingTaskData.due_at).toISOString().split('T')[0] : ''}"
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid #e9ecef;
                border-radius: 0.5rem;
                font-size: 0.875rem;
                box-sizing: border-box;
                transition: border-color 0.2s;
              "
              onfocus="this.style.borderColor='#007bff'"
              onblur="this.style.borderColor='#e9ecef'"
            />
          </div>

          <!-- Status -->
          <div style="margin-bottom: 1.5rem; display: none;">
            <label style="
              display: block;
              font-size: 0.875rem;
              font-weight: 600;
              color: #2c3e50;
              margin-bottom: 0.5rem;
            ">Status</label>
            <div style="display: flex; flex-wrap: wrap; gap: 0.5rem;">
              ${['BACKLOG', 'ACTIVE', 'COMPLETED'].map(status => {
    const colors = {
      BACKLOG: '#6b7280',
      ACTIVE: '#3b82f6',
      COMPLETED: '#10b981'
    };
    const isSelected = (window.taskStatus || 'BACKLOG') === status || (window.editingTaskData?.state === status);
    return `
                  <button
                    type="button"
                    onclick="setTaskStatus('${status}')"
                    style="
                      padding: 0.5rem 1rem;
                      border-radius: 1rem;
                      border: 1px solid ${colors[status]};
                      background: ${isSelected ? colors[status] : '#ffffff'};
                      color: ${isSelected ? 'white' : colors[status]};
                      cursor: pointer;
                      font-size: 0.875rem;
                      font-weight: 500;
                      transition: all 0.2s;
                    "
                  >
                    ${status}
                  </button>
                `;
  }).join('')}
            </div>
          </div>

          <!-- Assign Team Members -->
          <div style="margin-bottom: 1.5rem;">
            <label style="
              display: block;
              font-size: 0.875rem;
              font-weight: 600;
              color: #2c3e50;
              margin-bottom: 0.5rem;
            ">Assign Team Members</label>
            <input
              type="text"
              id="task-member-search-input"
              placeholder="Search members..."
              value="${window.taskMemberSearchQuery || ''}"
              oninput="handleTaskMemberSearch(this.value)"
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid #e9ecef;
                border-radius: 0.5rem;
                font-size: 0.875rem;
                box-sizing: border-box;
                margin-bottom: 0.5rem;
                transition: border-color 0.2s;
              "
              onfocus="this.style.borderColor='#007bff'; handleTaskMemberSearch('')"
              onblur="this.style.borderColor='#e9ecef'"
            />
            
            <!-- Selected Members Display -->
            <div id="task-selected-members-display" style="
              display: flex;
              flex-wrap: wrap;
              gap: 0.5rem;
              margin-bottom: 0.5rem;
              min-height: 40px;
            ">
              ${(window.selectedTaskMembers || []).map(memberId => {
    const member = teamMembers.find(m => m.id === memberId);
    return member ? `
                  <div style="
                    background: #f59e0b;
                    color: white;
                    padding: 0.5rem 0.75rem;
                    border-radius: 1.5rem;
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    font-size: 0.875rem;
                    font-weight: 500;
                  ">
                    ${member.first_name} ${member.last_name}
                    <button 
                      type="button"
                      onclick="event.preventDefault(); event.stopPropagation(); removeTaskMember('${memberId}', event); return false;"
                      style="
                        background: rgba(255,255,255,0.3);
                        border: none;
                        color: white;
                        cursor: pointer;
                        font-size: 1rem;
                        padding: 0;
                        width: 18px;
                        height: 18px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-radius: 50%;
                      "
                    >×</button>
                  </div>
                ` : '';
  }).join('')}
            </div>
            
            <!-- Member Search Results -->
            <div id="task-member-search-results" style="
              max-height: 200px;
              overflow-y: auto;
              border: 1px solid #e9ecef;
              border-radius: 0.5rem;
              background: #ffffff;
              display: ${window.taskMemberSearchQuery && window.taskMemberSearchQuery.trim() ? 'block' : 'none'};
            ">
              ${teamMembers.filter(member =>
    !window.selectedTaskMembers.includes(member.id) &&
    `${member.first_name} ${member.last_name}`.toLowerCase().includes((window.taskMemberSearchQuery || '').toLowerCase())
  ).map(member => `
                <div
                  onmousedown="event.preventDefault(); addTaskMember('${member.id}')"
                  style="
                    padding: 0.75rem;
                    border-bottom: 1px solid #e9ecef;
                    cursor: pointer;
                    transition: background-color 0.2s;
                  "
                  onmouseover="this.style.backgroundColor='#f8f9fa'"
                  onmouseout="this.style.backgroundColor='transparent'"
                >
                  ${member.first_name} ${member.last_name}
                </div>
              `).join('')}
              ${teamMembers.filter(member =>
    !window.selectedTaskMembers.includes(member.id) &&
    `${member.first_name} ${member.last_name}`.toLowerCase().includes((window.taskMemberSearchQuery || '').toLowerCase())
  ).length === 0 && window.taskMemberSearchQuery && window.taskMemberSearchQuery.trim() ? `
                <div style="padding: 1rem; text-align: center; color: #6c757d; font-size: 0.875rem;">
                  No members found matching "${window.taskMemberSearchQuery}"
                </div>
              ` : ''}
            </div>
          </div>

          <!-- Link to Contact -->
          ${(() => {
      // Hide "Link to Contact" if we're inside a contact
      // Check preselectedTaskContactId first, then selectedContactId on sales screen
      const isInsideContact = window.preselectedTaskContactId || (currentScreen === 'sales' && selectedContactId);
      if (isInsideContact) {
        return ''; // Don't show this section when inside a contact
      }
      return `
          <div style="margin-bottom: 1.5rem;">
            <label style="
              display: block;
              font-size: 0.875rem;
              font-weight: 600;
              color: #2c3e50;
              margin-bottom: 0.5rem;
            ">Link to Contact</label>
            
            ${selectedContactData ? `
              <!-- Selected Contact Badge -->
              <div style="
                background: #f59e0b;
                color: white;
                padding: 0.75rem 1rem;
                border-radius: 1.5rem;
                display: inline-flex;
                align-items: center;
                gap: 0.5rem;
                font-size: 0.875rem;
                font-weight: 500;
              ">
                👤 ${selectedContactData.first_name} ${selectedContactData.last_name}
                ${selectedContactData.company ? ` • ${selectedContactData.company}` : ''}
                ${selectedContactData.contact_profile_id ? ' <span style="background: rgba(255,255,255,0.3); padding: 0.125rem 0.5rem; border-radius: 0.75rem; font-size: 0.75rem;">Client</span>' : ''}
                <button 
                  onclick="clearTaskContact()"
                  style="
                    background: rgba(255,255,255,0.3);
                    border: none;
                    color: white;
                    cursor: pointer;
                    font-size: 1rem;
                    padding: 0;
                    width: 20px;
                    height: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 50%;
                    margin-left: 0.5rem;
                  "
                >×</button>
              </div>
            ` : `
              <!-- Contact Search -->
              <input
                type="text"
                id="task-contact-search-input"
                placeholder="Search contacts..."
                value="${window.taskContactSearchQuery || ''}"
                oninput="handleTaskContactSearch(this.value)"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e9ecef;
                  border-radius: 0.5rem;
                  font-size: 0.875rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s;
                "
                onfocus="this.style.borderColor='#007bff'"
                onblur="this.style.borderColor='#e9ecef'"
              />
              
              <!-- Contact Search Results -->
              <div id="task-contact-search-results" style="
                max-height: 200px;
                overflow-y: auto;
                border: 1px solid #e9ecef;
                border-radius: 0.5rem;
                background: #ffffff;
                margin-top: 0.5rem;
                display: ${window.taskContactSearchQuery && window.taskContactSearchQuery.trim() ? 'block' : 'none'};
              ">
                ${contacts.filter(contact =>
        `${contact.first_name} ${contact.last_name} ${contact.company || ''}`.toLowerCase().includes((window.taskContactSearchQuery || '').toLowerCase())
      ).map(contact => `
                  <div
                    onclick="selectTaskContact('${contact.id}')"
                    style="
                      padding: 0.75rem;
                      border-bottom: 1px solid #e9ecef;
                      cursor: pointer;
                      transition: background-color 0.2s;
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                    "
                    onmouseover="this.style.backgroundColor='#f8f9fa'"
                    onmouseout="this.style.backgroundColor='transparent'"
                  >
                    <div>
                      <div style="font-weight: 500; color: #2c3e50;">${contact.first_name} ${contact.last_name}</div>
                      ${contact.company ? `<div style="font-size: 0.75rem; color: #6c757d; margin-top: 0.25rem;">${contact.company}</div>` : ''}
                    </div>
                    ${contact.contact_profile_id ? `
                      <span style="background: #ff7f00; color: white; padding: 0.25rem 0.5rem; border-radius: 0.25rem; font-size: 0.75rem; font-weight: 600;">Client</span>
                    ` : ''}
                  </div>
                `).join('')}
                ${contacts.filter(contact =>
        `${contact.first_name} ${contact.last_name} ${contact.company || ''}`.toLowerCase().includes((window.taskContactSearchQuery || '').toLowerCase())
      ).length === 0 && window.taskContactSearchQuery && window.taskContactSearchQuery.trim() ? `
                  <div style="padding: 1rem; text-align: center; color: #6c757d; font-size: 0.875rem;">
                    No contacts found matching "${window.taskContactSearchQuery}"
                  </div>
                ` : ''}
              </div>
            `}
          </div>
            `;
    })()}

          <!-- Link to Project -->
          ${(() => {
      // Always show "Link to Project" section - projects will load based on selected contact
      return `
          <div style="margin-bottom: 1.5rem;">
            <div style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 0.5rem;
            ">
              <label style="
                display: block;
                font-size: 0.875rem;
                font-weight: 600;
                color: #2c3e50;
              ">📁 Link to Project</label>
              <button
                type="button"
                onclick="toggleCreateProjectInTask()"
                style="
                  background: ${window.showCreateProjectInTask ? '#f59e0b' : '#e9ecef'};
                  color: ${window.showCreateProjectInTask ? 'white' : '#2c3e50'};
                  border: none;
                  padding: 0.375rem 0.75rem;
                  border-radius: 0.375rem;
                  cursor: pointer;
                  font-size: 0.75rem;
                  font-weight: 600;
                "
              >
                ${window.showCreateProjectInTask ? 'Select Existing' : '+'}
              </button>
            </div>
            
            ${window.showCreateProjectInTask ? `
              <!-- Create New Project -->
              ${window.newProjectConfirmedInTask && window.newProjectNameInTask ? `
                <!-- Confirmed Project -->
                <div style="
                  background: #8B5CF6;
                  color: white;
                  padding: 1rem;
                  border-radius: 0.5rem;
                  margin-bottom: 0.5rem;
                ">
                  <div style="display: flex; justify-content: space-between; align-items: start;">
                    <div>
                      <div style="font-size: 0.75rem; opacity: 0.9; margin-bottom: 0.25rem;">📁 New Project Ready</div>
                      <div style="font-weight: 600; margin-bottom: 0.25rem;">${window.newProjectNameInTask}</div>
                      ${window.newProjectDescriptionInTask ? `<div style="font-size: 0.875rem; opacity: 0.9;">${window.newProjectDescriptionInTask}</div>` : ''}
                      <div style="font-size: 0.75rem; opacity: 0.8; margin-top: 0.5rem; font-style: italic;">Project will be created when task is saved</div>
                    </div>
                    <button
                      onclick="editNewProjectInTask()"
                      style="
                        background: rgba(255,255,255,0.2);
                        border: none;
                        color: white;
                        padding: 0.5rem;
                        border-radius: 0.25rem;
                        cursor: pointer;
                      "
                    >✏️</button>
                  </div>
                </div>
              ` : `
                <!-- Project Creation Form -->
                <div style="
                  background: #f8f9fa;
                  border: 1px solid #e9ecef;
                  border-radius: 0.5rem;
                  padding: 1rem;
                  margin-bottom: 0.5rem;
                ">
                  <div style="font-size: 0.75rem; font-weight: 600; color: #2c3e50; margin-bottom: 0.75rem;">➕ Create New Project</div>
                  <input
                    type="text"
                    id="new-project-name-input"
                    placeholder="Project name *"
                    value="${window.newProjectNameInTask || ''}"
                    oninput="window.newProjectNameInTask = this.value"
                    style="
                      width: 100%;
                      padding: 0.75rem;
                      border: 1px solid #e9ecef;
                      border-radius: 0.5rem;
                      font-size: 0.875rem;
                      box-sizing: border-box;
                      margin-bottom: 0.5rem;
                    "
                  />
                  <textarea
                    id="new-project-description-input"
                    placeholder="Description (optional)"
                    rows="2"
                    value="${window.newProjectDescriptionInTask || ''}"
                    oninput="window.newProjectDescriptionInTask = this.value"
                    style="
                      width: 100%;
                      padding: 0.75rem;
                      border: 1px solid #e9ecef;
                      border-radius: 0.5rem;
                      font-size: 0.875rem;
                      box-sizing: border-box;
                      resize: vertical;
                      font-family: inherit;
                      margin-bottom: 0.5rem;
                    "
                  >${window.newProjectDescriptionInTask || ''}</textarea>
                  <button
                    onclick="confirmNewProjectInTask()"
                    style="
                      background: ${window.newProjectNameInTask && window.newProjectNameInTask.trim() ? '#f59e0b' : '#e9ecef'};
                      color: ${window.newProjectNameInTask && window.newProjectNameInTask.trim() ? 'white' : '#6c757d'};
                      border: none;
                      padding: 0.5rem 1rem;
                      border-radius: 0.375rem;
                      cursor: pointer;
                      font-size: 0.875rem;
                      font-weight: 600;
                      width: 100%;
                    "
                    ${!window.newProjectNameInTask || !window.newProjectNameInTask.trim() ? 'disabled' : ''}
                  >
                    ✓ Confirm Project
                  </button>
                </div>
              `}
            ` : window.selectedTaskProject ? `
              <!-- Selected Project Badge -->
              <div style="
                background: #8B5CF6;
                color: white;
                padding: 0.75rem 1rem;
                border-radius: 1.5rem;
                display: inline-flex;
                align-items: center;
                gap: 0.5rem;
                font-size: 0.875rem;
                font-weight: 500;
              ">
                📁 ${allProjects.find(p => p.id === window.selectedTaskProject)?.name || 'Project'}
                <button 
                  onclick="clearTaskProject()"
                  style="
                    background: rgba(255,255,255,0.3);
                    border: none;
                    color: white;
                    cursor: pointer;
                    font-size: 1rem;
                    padding: 0;
                    width: 20px;
                    height: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 50%;
                    margin-left: 0.5rem;
                  "
                >×</button>
              </div>
            ` : `
              <!-- Project Search -->
              <input
                type="text"
                id="task-project-search-input"
                placeholder="Search projects..."
                value="${window.taskProjectSearchQuery || ''}"
                oninput="handleTaskProjectSearch(this.value)"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e9ecef;
                  border-radius: 0.5rem;
                  font-size: 0.875rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s;
                "
                onfocus="this.style.borderColor='#007bff'"
                onblur="this.style.borderColor='#e9ecef'"
              />
              
              <!-- Project Search Results -->
              <div id="task-project-search-results" style="
                max-height: 200px;
                overflow-y: auto;
                border: 1px solid #e9ecef;
                border-radius: 0.5rem;
                background: #ffffff;
                margin-top: 0.5rem;
                display: ${window.taskProjectSearchQuery && window.taskProjectSearchQuery.trim() ? 'block' : 'none'};
              ">
                ${availableProjects.filter(project =>
        project.name.toLowerCase().includes((window.taskProjectSearchQuery || '').toLowerCase())
      ).map(project => `
                  <div
                    onclick="selectTaskProject('${project.id}')"
                    style="
                      padding: 0.75rem;
                      border-bottom: 1px solid #e9ecef;
                      cursor: pointer;
                      transition: background-color 0.2s;
                      font-weight: 600;
                      color: #2c3e50;
                    "
                    onmouseover="this.style.backgroundColor='#f8f9fa'"
                    onmouseout="this.style.backgroundColor='transparent'"
                  >
                    ${project.name}
                  </div>
                `).join('')}
                ${availableProjects.filter(project =>
        project.name.toLowerCase().includes((window.taskProjectSearchQuery || '').toLowerCase())
      ).length === 0 && window.taskProjectSearchQuery && window.taskProjectSearchQuery.trim() ? `
                  <div style="padding: 1rem; text-align: center; color: #6c757d; font-size: 0.875rem;">
                    No projects found matching "${window.taskProjectSearchQuery}"
                  </div>
                ` : ''}
              </div>
            `}
          </div>
            `;
    })()}
        </div>
      </div>
    </div>
  `;

  console.log('🔍 [Task Modal] Modal HTML length:', modalHTML.length);
  console.log('🔍 [Task Modal] Document body exists:', !!document.body);
  document.body.insertAdjacentHTML('beforeend', modalHTML);
  console.log('🔍 [Task Modal] Modal inserted into DOM');

  // Verify insertion
  const insertedModal = document.getElementById('add-task-modal-overlay');
  console.log('🔍 [Task Modal] Verification - modal in DOM:', !!insertedModal);
  if (!insertedModal) {
    console.error('❌ [Task Modal] ERROR: Modal was not inserted into DOM!');
  }

  // Initialize task form state
  if (!window.selectedTaskService) window.selectedTaskService = window.editingTaskData?.service_id || '';
  // Always set priority from editingTaskData if it exists (to ensure it's set correctly for quick tasks)
  if (window.editingTaskData) {
    window.taskPriority = window.editingTaskData.priority || (window.editingTaskData.state === 'DRAFT' ? 'LOW' : 'MEDIUM');
  } else if (!window.taskPriority) {
    window.taskPriority = 'MEDIUM';
  }
  // If editing a quick task (DRAFT), default to BACKLOG for conversion
  if (!window.taskStatus) window.taskStatus = (window.editingTaskData?.state === 'DRAFT' ? 'BACKLOG' : (window.editingTaskData?.state || 'BACKLOG'));
  // Always initialize selectedTaskMembers - don't check if it exists, always set it
  window.selectedTaskMembers = window.selectedTaskMembers || [];
  if (!window.customTaskServiceName) window.customTaskServiceName = window.editingTaskData?.service_name || '';

  // Pre-select members if editing
  if (window.editingTaskData?.assigned_members) {
    window.selectedTaskMembers = window.editingTaskData.assigned_members.map(m => m.id);
    updateTaskSelectedMembersDisplay();
    updateSelectedMembersDisplayForTask();
  }

  // Initialize project list - always try to load if we have a contact
  setTimeout(() => {
    initializeTaskModalProjectList();
  }, 50);

  // Initialize selected members display after a short delay to ensure DOM is ready
  setTimeout(() => {
    if (window.selectedTaskMembers && window.selectedTaskMembers.length > 0) {
      updateTaskSelectedMembersDisplay();
      updateSelectedMembersDisplayForTask();
    }
  }, 100);

  // Update button styles based on initial selection
  setTimeout(() => {
    if (window.selectedTaskService) {
      selectTaskService(window.selectedTaskService);
    }
    if (window.taskPriority) {
      setTaskPriority(window.taskPriority);
    }
    if (window.taskStatus) {
      setTaskStatus(window.taskStatus);
    }
  }, 150);

  // Focus on title input
  setTimeout(() => {
    const titleInput = document.getElementById('task-title-input');
    if (titleInput) titleInput.focus();
  }, 200);
}

window.closeAddTaskModal = function () {
  const modal = document.getElementById('add-task-modal-overlay');
  if (modal) {
    modal.remove();
  }
  // Reset state
  window.editingTaskData = null;
  window.preselectedTaskContactId = null;
  window.preselectedTaskProjectId = null;
  window.selectedTaskMembers = [];
  window.selectedTaskService = '';
  window.customTaskServiceName = '';
  window.selectedTaskContact = '';
  window.selectedTaskProject = '';
  window.taskContactSearchQuery = '';
  window.taskProjectSearchQuery = '';
  window.taskMemberSearchQuery = '';
  window.showCreateProjectInTask = false;
  window.newProjectNameInTask = '';
  window.newProjectDescriptionInTask = '';
  window.newProjectConfirmedInTask = false;
}

// Handle task member search
window.handleTaskMemberSearch = function (query) {
  window.taskMemberSearchQuery = query;
  const resultsDiv = document.getElementById('task-member-search-results');
  if (resultsDiv) {
    const selected = window.selectedTaskMembers || [];

    if (query && query.trim()) {
      // Filter by search query
      const filtered = teamMembers.filter(member =>
        !selected.includes(member.id) &&
        `${member.first_name} ${member.last_name}`.toLowerCase().includes(query.toLowerCase())
      );

      resultsDiv.innerHTML = filtered.map(member => `
        <div
          onmousedown="event.preventDefault(); addTaskMember('${member.id}')"
          style="
            padding: 0.75rem;
            border-bottom: 1px solid #e9ecef;
            cursor: pointer;
            transition: background-color 0.2s;
          "
          onmouseover="this.style.backgroundColor='#f8f9fa'"
          onmouseout="this.style.backgroundColor='transparent'"
        >
          ${member.first_name} ${member.last_name}
        </div>
      `).join('') + (filtered.length === 0 ? `
        <div style="padding: 1rem; text-align: center; color: #6c757d; font-size: 0.875rem;">
          No members found matching "${query}"
        </div>
      ` : '');
      resultsDiv.style.display = 'block';
    } else {
      // Show all available members when no query
      const availableMembers = teamMembers.filter(member =>
        !selected.includes(member.id)
      );

      resultsDiv.innerHTML = availableMembers.map(member => `
        <div
          onmousedown="event.preventDefault(); addTaskMember('${member.id}')"
          style="
            padding: 0.75rem;
            border-bottom: 1px solid #e9ecef;
            cursor: pointer;
            transition: background-color 0.2s;
          "
          onmouseover="this.style.backgroundColor='#f8f9fa'"
          onmouseout="this.style.backgroundColor='transparent'"
        >
          ${member.first_name} ${member.last_name}
        </div>
      `).join('');
      resultsDiv.style.display = availableMembers.length > 0 ? 'block' : 'none';
    }
  }
}

// Add task member
window.addTaskMember = function (memberId) {
  if (!window.selectedTaskMembers) window.selectedTaskMembers = [];
  if (!window.selectedTaskMembers.includes(memberId)) {
    window.selectedTaskMembers.push(memberId);

    // Update both possible display divs
    updateTaskSelectedMembersDisplay();
    updateSelectedMembersDisplayForTask();

    // Clear search and remove focus immediately
    window.taskMemberSearchQuery = '';
    const searchInput = document.getElementById('task-member-search-input') || document.getElementById('member-search');
    if (searchInput) {
      searchInput.value = '';
      // Remove focus immediately to close dropdown
      setTimeout(() => {
        searchInput.blur();
      }, 0);
    }

    // Hide both possible results divs immediately - use multiple methods to ensure it's hidden
    const taskResultsDiv = document.getElementById('task-member-search-results');
    const memberResultsDiv = document.getElementById('member-search-results');
    if (taskResultsDiv) {
      taskResultsDiv.style.display = 'none';
      taskResultsDiv.style.visibility = 'hidden';
      taskResultsDiv.style.opacity = '0';
      taskResultsDiv.innerHTML = ''; // Clear content too
    }
    if (memberResultsDiv) {
      memberResultsDiv.style.display = 'none';
      memberResultsDiv.style.visibility = 'hidden';
      memberResultsDiv.style.opacity = '0';
      memberResultsDiv.innerHTML = ''; // Clear content too
    }
  }
}

// Update selected members display for task form (using selected-members div)
window.updateSelectedMembersDisplayForTask = function () {
  const selectedDiv = document.getElementById('selected-members');
  if (!selectedDiv) return;

  // Always update - we're in task context if this function is called
  // Initialize if needed
  if (!window.selectedTaskMembers) window.selectedTaskMembers = [];

  // Use window.selectedTaskMembers if available, otherwise fall back to selectedMembers
  const membersToDisplay = (window.selectedTaskMembers && window.selectedTaskMembers.length > 0)
    ? window.selectedTaskMembers
    : (selectedMembers && selectedMembers.length > 0 ? selectedMembers : []);

  // If we found members in selectedMembers but not in window.selectedTaskMembers, sync them
  if (selectedMembers && selectedMembers.length > 0 && (!window.selectedTaskMembers || window.selectedTaskMembers.length === 0)) {
    window.selectedTaskMembers = [...selectedMembers];
    console.log('🔄 Synced selectedMembers to window.selectedTaskMembers:', window.selectedTaskMembers);
  }

  selectedDiv.innerHTML = membersToDisplay.map(memberId => {
    const member = teamMembers.find(m => m.id === memberId);
    if (!member) return '';
    return `
      <div style="
        background: ${colors.primary};
        color: white;
        padding: 0.5rem 0.75rem;
        border-radius: 1.5rem;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        font-size: 0.875rem;
        font-weight: 500;
      ">
        ${member.first_name} ${member.last_name}
        <button type="button" onclick="event.preventDefault(); event.stopPropagation(); removeTaskMember('${memberId}', event); return false;" style="
          background: rgba(255,255,255,0.3);
          border: none;
          color: white;
          cursor: pointer;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0;
          font-size: 1rem;
        ">×</button>
      </div>
    `;
  }).join('');

  // Hide results
  const resultsDiv = document.getElementById('member-search-results');
  if (resultsDiv) resultsDiv.style.display = 'none';
}

// Remove task member
window.removeTaskMember = function (memberId, event) {
  // Prevent form submission and stop event propagation
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  if (!window.selectedTaskMembers) return false;
  const index = window.selectedTaskMembers.indexOf(memberId);
  if (index > -1) {
    window.selectedTaskMembers.splice(index, 1);
    // Update both display functions to ensure UI is synced
    if (typeof updateTaskSelectedMembersDisplay === 'function') {
      updateTaskSelectedMembersDisplay();
    }
    if (typeof updateSelectedMembersDisplayForTask === 'function') {
      updateSelectedMembersDisplayForTask();
    }
  }

  // Return false to ensure form doesn't submit
  return false;
}

// Update selected members display
window.updateTaskSelectedMembersDisplay = function () {
  const displayDiv = document.getElementById('task-selected-members-display');
  if (!displayDiv) return;

  displayDiv.innerHTML = (window.selectedTaskMembers || []).map(memberId => {
    const member = teamMembers.find(m => m.id === memberId);
    return member ? `
      <div style="
        background: #007bff;
        color: white;
        padding: 0.5rem 0.75rem;
        border-radius: 1.5rem;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        font-size: 0.875rem;
        font-weight: 500;
      ">
        ${member.first_name} ${member.last_name}
        <button 
          type="button"
          onclick="event.preventDefault(); event.stopPropagation(); removeTaskMember('${memberId}', event); return false;"
          style="
            background: rgba(255,255,255,0.3);
            border: none;
            color: white;
            cursor: pointer;
            font-size: 1rem;
            padding: 0;
            width: 18px;
            height: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
          "
        >×</button>
      </div>
    ` : '';
  }).join('');
}

// Handle task contact search
// Handle contact search in task modal (renderAddTaskModal)
window.handleContactSearchInTaskModal = function (query) {
  const resultsDiv = document.getElementById('contact-search-results');
  if (resultsDiv) {
    resultsDiv.style.display = query && query.trim() ? 'block' : 'none';

    // Update results dynamically
    const filtered = contacts.filter(contact =>
      `${contact.first_name} ${contact.last_name} ${contact.company || ''}`.toLowerCase().includes(query.toLowerCase())
    );

    resultsDiv.innerHTML = filtered.map(contact => `
      <div
        onclick="selectContact('${contact.id}')"
        style="
          padding: 0.75rem;
          border-bottom: 1px solid #e9ecef;
          cursor: pointer;
          transition: background-color 0.2s;
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
        onmouseover="this.style.backgroundColor='#f8f9fa'"
        onmouseout="this.style.backgroundColor='transparent'"
      >
        <div>
          <div style="font-weight: 500; color: #2c3e50;">${contact.first_name} ${contact.last_name}</div>
          ${contact.company ? `<div style="font-size: 0.75rem; color: #6c757d; margin-top: 0.25rem;">${contact.company}</div>` : ''}
        </div>
        ${contact.contact_profile_id ? `
          <span style="background: #ff7f00; color: white; padding: 0.25rem 0.5rem; border-radius: 0.25rem; font-size: 0.75rem; font-weight: 600;">Client</span>
        ` : ''}
      </div>
    `).join('') + (filtered.length === 0 && query.trim() ? `
      <div style="padding: 1rem; text-align: center; color: #6c757d; font-size: 0.875rem;">
        No contacts found matching "${query}"
      </div>
    ` : '');
  }
}

window.handleTaskContactSearch = function (query) {
  window.taskContactSearchQuery = query;
  const resultsDiv = document.getElementById('task-contact-search-results');
  if (resultsDiv) {
    resultsDiv.style.display = query && query.trim() ? 'block' : 'none';

    // Update results dynamically
    const filtered = contacts.filter(contact =>
      `${contact.first_name} ${contact.last_name} ${contact.company || ''}`.toLowerCase().includes(query.toLowerCase())
    );

    resultsDiv.innerHTML = filtered.map(contact => `
      <div
        onclick="selectTaskContact('${contact.id}')"
        style="
          padding: 0.75rem;
          border-bottom: 1px solid #e9ecef;
          cursor: pointer;
          transition: background-color 0.2s;
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
        onmouseover="this.style.backgroundColor='#f8f9fa'"
        onmouseout="this.style.backgroundColor='transparent'"
      >
        <div>
          <div style="font-weight: 500; color: #2c3e50;">${contact.first_name} ${contact.last_name}</div>
          ${contact.company ? `<div style="font-size: 0.75rem; color: #6c757d; margin-top: 0.25rem;">${contact.company}</div>` : ''}
        </div>
        ${contact.contact_profile_id ? `
          <span style="background: #ff7f00; color: white; padding: 0.25rem 0.5rem; border-radius: 0.25rem; font-size: 0.75rem; font-weight: 600;">Client</span>
        ` : ''}
      </div>
    `).join('') + (filtered.length === 0 && query.trim() ? `
      <div style="padding: 1rem; text-align: center; color: #6c757d; font-size: 0.875rem;">
        No contacts found matching "${query}"
      </div>
    ` : '');
  }
}

// Select task contact
// Handle appointment contact search
window.handleAppointmentContactSearch = function (query) {
  appointmentContactSearchQuery = query || '';
  window.appointmentContactSearchQuery = appointmentContactSearchQuery;
  const resultsDiv = document.getElementById('appointment-contact-search-results');
  if (resultsDiv) {
    resultsDiv.style.display = query && query.trim() ? 'block' : 'none';

    // Update results dynamically
    const filtered = contacts.filter(contact =>
      `${contact.first_name || ''} ${contact.last_name || ''} ${contact.company || ''}`.toLowerCase().includes(query.toLowerCase())
    );

    resultsDiv.innerHTML = filtered.map(contact => `
      <div
        onclick="selectAppointmentContact('${contact.id}')"
        style="
          padding: 0.75rem;
          border-bottom: 1px solid #e9ecef;
          cursor: pointer;
          transition: background-color 0.2s;
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
        onmouseover="this.style.backgroundColor='#f8f9fa'"
        onmouseout="this.style.backgroundColor='transparent'"
      >
        <div>
          <div style="font-weight: 500; color: #2c3e50;">${contact.first_name || ''} ${contact.last_name || ''}</div>
          ${contact.company ? `<div style="font-size: 0.75rem; color: #6c757d; margin-top: 0.25rem;">${contact.company}</div>` : ''}
        </div>
        ${contact.contact_profile_id ? `
          <span style="background: #ff7f00; color: white; padding: 0.25rem 0.5rem; border-radius: 0.25rem; font-size: 0.75rem; font-weight: 600;">Client</span>
        ` : ''}
      </div>
    `).join('') + (filtered.length === 0 && query.trim() ? `
      <div style="padding: 1rem; text-align: center; color: #6c757d; font-size: 0.875rem;">
        No contacts found matching "${query}"
      </div>
    ` : '');
  }
};

// Select appointment contact
window.selectAppointmentContact = function (contactId) {
  selectedAppointmentContactId = contactId;
  window.selectedAppointmentContactId = selectedAppointmentContactId;
  appointmentContactSearchQuery = '';
  window.appointmentContactSearchQuery = appointmentContactSearchQuery;

  // Re-render modal to show selected contact
  const existingModal = document.getElementById('add-appointment-modal');
  if (existingModal) {
    existingModal.remove();
  }
  const modalHTML = renderAddAppointmentModal();
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = modalHTML;
  const modalElement = tempDiv.firstElementChild;
  document.body.appendChild(modalElement);
  setTimeout(() => {
    if (modalElement) {
      modalElement.style.opacity = '1';
    }
  }, 10);
};

// Clear appointment contact
window.clearAppointmentContact = function () {
  selectedAppointmentContactId = null;
  window.selectedAppointmentContactId = selectedAppointmentContactId;
  appointmentContactSearchQuery = '';
  window.appointmentContactSearchQuery = appointmentContactSearchQuery;

  // Re-render modal
  const existingModal = document.getElementById('add-appointment-modal');
  if (existingModal) {
    existingModal.remove();
  }
  const modalHTML = renderAddAppointmentModal();
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = modalHTML;
  const modalElement = tempDiv.firstElementChild;
  document.body.appendChild(modalElement);
  setTimeout(() => {
    if (modalElement) {
      modalElement.style.opacity = '1';
    }
  }, 10);
};

// Handle reminder contact search
window.handleReminderContactSearch = function (query) {
  reminderContactSearchQuery = query || '';
  window.reminderContactSearchQuery = reminderContactSearchQuery;
  const resultsDiv = document.getElementById('reminder-contact-search-results');
  if (resultsDiv) {
    resultsDiv.style.display = query && query.trim() ? 'block' : 'none';

    // Update results dynamically
    const filtered = contacts.filter(contact =>
      `${contact.first_name || ''} ${contact.last_name || ''} ${contact.company || ''}`.toLowerCase().includes(query.toLowerCase())
    );

    resultsDiv.innerHTML = filtered.map(contact => `
      <div
        onclick="selectReminderContact('${contact.id}')"
        style="
          padding: 0.75rem;
          border-bottom: 1px solid #e9ecef;
          cursor: pointer;
          transition: background-color 0.2s;
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
        onmouseover="this.style.backgroundColor='#f8f9fa'"
        onmouseout="this.style.backgroundColor='transparent'"
      >
        <div>
          <div style="font-weight: 500; color: #2c3e50;">${contact.first_name || ''} ${contact.last_name || ''}</div>
          ${contact.company ? `<div style="font-size: 0.75rem; color: #6c757d; margin-top: 0.25rem;">${contact.company}</div>` : ''}
        </div>
        ${contact.contact_profile_id ? `
          <span style="background: #ff7f00; color: white; padding: 0.25rem 0.5rem; border-radius: 0.25rem; font-size: 0.75rem; font-weight: 600;">Client</span>
        ` : ''}
      </div>
    `).join('') + (filtered.length === 0 && query.trim() ? `
      <div style="padding: 1rem; text-align: center; color: #6c757d; font-size: 0.875rem;">
        No contacts found matching "${query}"
      </div>
    ` : '');
  }
};

// Select reminder contact
window.selectReminderContact = function (contactId) {
  selectedReminderContactId = contactId;
  window.selectedReminderContactId = selectedReminderContactId;
  reminderContactSearchQuery = '';
  window.reminderContactSearchQuery = reminderContactSearchQuery;

  // Re-render modal to show selected contact
  const existingModal = document.getElementById('add-reminder-modal');
  if (existingModal) {
    existingModal.remove();
  }
  const modalHTML = renderAddReminderModal();
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = modalHTML;
  const modalElement = tempDiv.firstElementChild;
  document.body.appendChild(modalElement);
  setTimeout(() => {
    if (modalElement) {
      modalElement.style.opacity = '1';
    }
  }, 10);
};

// Clear reminder contact
window.clearReminderContact = function () {
  selectedReminderContactId = null;
  window.selectedReminderContactId = selectedReminderContactId;
  reminderContactSearchQuery = '';
  window.reminderContactSearchQuery = reminderContactSearchQuery;

  // Re-render modal
  const existingModal = document.getElementById('add-reminder-modal');
  if (existingModal) {
    existingModal.remove();
  }
  const modalHTML = renderAddReminderModal();
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = modalHTML;
  const modalElement = tempDiv.firstElementChild;
  document.body.appendChild(modalElement);
  setTimeout(() => {
    if (modalElement) {
      modalElement.style.opacity = '1';
    }
  }, 10);
};

// Handle opportunity contact search
window.handleOpportunityContactSearch = function (query) {
  opportunityContactSearchQuery = query || '';
  window.opportunityContactSearchQuery = opportunityContactSearchQuery;
  const resultsDiv = document.getElementById('opportunity-contact-search-results');
  if (resultsDiv) {
    resultsDiv.style.display = query && query.trim() ? 'block' : 'none';

    // Update results dynamically
    const filtered = contacts.filter(contact =>
      `${contact.first_name || ''} ${contact.last_name || ''} ${contact.company || ''}`.toLowerCase().includes(query.toLowerCase())
    );

    resultsDiv.innerHTML = filtered.map(contact => `
      <div
        onclick="selectOpportunityContact('${contact.id}')"
        style="
          padding: 0.75rem;
          border-bottom: 1px solid #e9ecef;
          cursor: pointer;
          transition: background-color 0.2s;
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
        onmouseover="this.style.backgroundColor='#f8f9fa'"
        onmouseout="this.style.backgroundColor='transparent'"
      >
        <div>
          <div style="font-weight: 500; color: #2c3e50;">${contact.first_name || ''} ${contact.last_name || ''}</div>
          ${contact.company ? `<div style="font-size: 0.75rem; color: #6c757d; margin-top: 0.25rem;">${contact.company}</div>` : ''}
        </div>
        ${contact.contact_profile_id ? `
          <span style="background: #ff7f00; color: white; padding: 0.25rem 0.5rem; border-radius: 0.25rem; font-size: 0.75rem; font-weight: 600;">Client</span>
        ` : ''}
      </div>
    `).join('') + (filtered.length === 0 && query.trim() ? `
      <div style="padding: 1rem; text-align: center; color: #6c757d; font-size: 0.875rem;">
        No contacts found matching "${query}"
      </div>
    ` : '');
  }
};

// Select opportunity contact
window.selectOpportunityContact = function (contactId) {
  selectedOpportunityContactId = contactId;
  window.selectedOpportunityContactId = selectedOpportunityContactId;
  opportunityContactSearchQuery = '';
  window.opportunityContactSearchQuery = opportunityContactSearchQuery;

  // Re-render modal to show selected contact
  const existingModal = document.getElementById('add-opportunity-modal');
  if (existingModal) {
    existingModal.remove();
  }
  const modalHTML = renderAddOpportunityModal();
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = modalHTML;
  const modalElement = tempDiv.firstElementChild;
  document.body.appendChild(modalElement);
  setTimeout(() => {
    if (modalElement) {
      modalElement.style.opacity = '1';
    }
  }, 10);
};

// Clear opportunity contact
window.clearOpportunityContact = function () {
  selectedOpportunityContactId = null;
  window.selectedOpportunityContactId = selectedOpportunityContactId;
  opportunityContactSearchQuery = '';
  window.opportunityContactSearchQuery = opportunityContactSearchQuery;

  // Re-render modal
  const existingModal = document.getElementById('add-opportunity-modal');
  if (existingModal) {
    existingModal.remove();
  }
  const modalHTML = renderAddOpportunityModal();
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = modalHTML;
  const modalElement = tempDiv.firstElementChild;
  document.body.appendChild(modalElement);
  setTimeout(() => {
    if (modalElement) {
      modalElement.style.opacity = '1';
    }
  }, 10);
};

window.selectTaskContact = function (contactId) {
  window.selectedTaskContact = contactId;
  window.taskContactSearchQuery = '';
  window.selectedTaskProject = '';
  window.taskProjectSearchQuery = '';
  window.showCreateProjectInTask = false;
  window.newProjectNameInTask = '';
  window.newProjectDescriptionInTask = '';
  window.newProjectConfirmedInTask = false;

  // Re-render modal to update project list
  const modal = document.getElementById('add-task-modal-overlay');
  if (modal) {
    modal.remove();
    renderTaskModal();
  }
}

// Clear task contact
window.clearTaskContact = function () {
  window.selectedTaskContact = '';
  window.taskContactSearchQuery = '';
  window.selectedTaskProject = '';
  window.taskProjectSearchQuery = '';

  // Re-render modal
  const modal = document.getElementById('add-task-modal-overlay');
  if (modal) {
    modal.remove();
    renderTaskModal();
  }
}

// Handle task project search
window.handleTaskProjectSearch = async function (query) {
  window.taskProjectSearchQuery = query;
  const resultsDiv = document.getElementById('task-project-search-results');
  if (resultsDiv) {
    resultsDiv.style.display = query && query.trim() ? 'block' : 'none';

    // Get available projects (filtered by contact if selected) - only active projects
    let availableProjects = [];
    if (window.selectedTaskContact) {
      // Load projects for selected contact - filter out completed/cancelled
      const projects = await loadContactProjects(window.selectedTaskContact);
      const filtered = projects.filter(project =>
        project.status === 'active' &&
        project.name.toLowerCase().includes(query.toLowerCase())
      );
      updateProjectSearchResults(filtered);
    } else {
      // Load all active projects
      const { data, error } = await supabase
        .from('projects')
        .select('id, name, contact_id, status')
        .eq('company_id', currentCompany.id)
        .eq('status', 'active')
        .order('name');

      if (!error && data) {
        const filtered = data.filter(project =>
          project.name.toLowerCase().includes(query.toLowerCase())
        );
        updateProjectSearchResults(filtered);
      }
    }
  }
}

// Update project search results
window.updateProjectSearchResults = function (filteredProjects) {
  const resultsDiv = document.getElementById('task-project-search-results');
  if (!resultsDiv) return;

  resultsDiv.innerHTML = filteredProjects.map(project => `
    <div
      onclick="selectTaskProject('${project.id}')"
      style="
        padding: 0.75rem;
        border-bottom: 1px solid #e9ecef;
        cursor: pointer;
        transition: background-color 0.2s;
        font-weight: 600;
        color: #2c3e50;
      "
      onmouseover="this.style.backgroundColor='#f8f9fa'"
      onmouseout="this.style.backgroundColor='transparent'"
    >
      ${project.name}
    </div>
  `).join('') + (filteredProjects.length === 0 && window.taskProjectSearchQuery && window.taskProjectSearchQuery.trim() ? `
    <div style="padding: 1rem; text-align: center; color: #6c757d; font-size: 0.875rem;">
      No projects found matching "${window.taskProjectSearchQuery}"
    </div>
  ` : '');
}

// Select task project
window.selectTaskProject = function (projectId) {
  window.selectedTaskProject = projectId;
  window.taskProjectSearchQuery = '';
  window.showCreateProjectInTask = false;

  // Re-render modal to show selected project badge
  const modal = document.getElementById('add-task-modal-overlay');
  if (modal) {
    modal.remove();
    renderTaskModal();
  }
}

// Clear task project
window.clearTaskProject = function () {
  window.selectedTaskProject = '';
  window.taskProjectSearchQuery = '';

  // Re-render modal
  const modal = document.getElementById('add-task-modal-overlay');
  if (modal) {
    modal.remove();
    renderTaskModal();
  }
}

// Toggle create project in task modal
window.toggleCreateProjectInTask = function () {
  window.showCreateProjectInTask = !window.showCreateProjectInTask;
  window.newProjectConfirmedInTask = false;
  window.newProjectNameInTask = '';
  window.newProjectDescriptionInTask = '';

  // Re-render modal
  const modal = document.getElementById('add-task-modal-overlay');
  if (modal) {
    modal.remove();
    renderTaskModal();
  }
}

// Confirm new project in task
window.confirmNewProjectInTask = function () {
  const nameInput = document.getElementById('new-project-name-input');
  const name = nameInput?.value?.trim();

  if (!name) {
    alert('Please enter a project name');
    return;
  }

  // Preserve selected members and contacts before re-rendering
  const preservedMembers = window.selectedTaskMembers ? [...window.selectedTaskMembers] : [];
  const preservedContact = window.selectedTaskContact || '';

  window.newProjectNameInTask = name;
  window.newProjectDescriptionInTask = document.getElementById('new-project-description-input')?.value?.trim() || '';
  window.newProjectConfirmedInTask = true;

  // Re-render modal to show confirmed project
  const modal = document.getElementById('add-task-modal-overlay');
  if (modal) {
    modal.remove();
    renderTaskModal();

    // Restore preserved values after re-render
    setTimeout(() => {
      if (preservedMembers.length > 0) {
        window.selectedTaskMembers = preservedMembers;
        updateTaskSelectedMembersDisplay();
        updateSelectedMembersDisplayForTask();
      }
      if (preservedContact) {
        window.selectedTaskContact = preservedContact;
      }
    }, 100);
  }
}

// Edit new project in task
window.editNewProjectInTask = function () {
  window.newProjectConfirmedInTask = false;

  // Re-render modal
  const modal = document.getElementById('add-task-modal-overlay');
  if (modal) {
    modal.remove();
    renderTaskModal();
  }
}

window.selectTaskService = function (serviceId) {
  window.selectedTaskService = serviceId;

  // Update button styles
  document.querySelectorAll('.task-service-btn').forEach(btn => {
    const btnServiceId = btn.getAttribute('data-service-id') || '';
    if (btnServiceId === serviceId) {
      btn.style.background = '#007bff';
      btn.style.color = 'white';
    } else {
      btn.style.background = '#f8f9fa';
      btn.style.color = '#2c3e50';
    }
  });

  // Show/hide custom service input
  const customInput = document.getElementById('task-custom-service-input');
  if (customInput) {
    customInput.style.display = serviceId === '' ? 'block' : 'none';
  }
}

window.setTaskPriority = function (priority) {
  window.taskPriority = priority;

  // Update button styles
  document.querySelectorAll('[onclick^="setTaskPriority"]').forEach(btn => {
    const btnPriority = btn.textContent.trim();
    if (btnPriority === priority) {
      const colors = {
        LOW: '#10b981',
        MEDIUM: '#f59e0b',
        HIGH: '#f97316',
        URGENT: '#dc2626'
      };
      btn.style.background = colors[priority];
      btn.style.color = 'white';
    } else {
      btn.style.background = '#ffffff';
      const colors = {
        LOW: '#10b981',
        MEDIUM: '#f59e0b',
        HIGH: '#f97316',
        URGENT: '#dc2626'
      };
      btn.style.color = colors[btnPriority] || '#2c3e50';
    }
  });
}

window.setTaskStatus = function (status) {
  window.taskStatus = status;

  // Update button styles
  document.querySelectorAll('[onclick^="setTaskStatus"]').forEach(btn => {
    const btnStatus = btn.textContent.trim();
    if (btnStatus === status) {
      const colors = {
        BACKLOG: '#6b7280',
        ACTIVE: '#3b82f6',
        COMPLETED: '#10b981'
      };
      btn.style.background = colors[status];
      btn.style.color = 'white';
    } else {
      btn.style.background = '#ffffff';
      const colors = {
        BACKLOG: '#6b7280',
        ACTIVE: '#3b82f6',
        COMPLETED: '#10b981'
      };
      btn.style.color = colors[btnStatus] || '#2c3e50';
    }
  });
}

window.toggleTaskMember = function (memberId) {
  if (!window.selectedTaskMembers) window.selectedTaskMembers = [];
  const index = window.selectedTaskMembers.indexOf(memberId);
  const btn = document.querySelector(`[data-member-id="${memberId}"].task-member-btn`);

  if (index > -1) {
    window.selectedTaskMembers.splice(index, 1);
    if (btn) {
      btn.style.background = '#f8f9fa';
      btn.style.borderColor = '#e9ecef';
      btn.style.color = '#2c3e50';
    }
  } else {
    window.selectedTaskMembers.push(memberId);
    if (btn) {
      btn.style.background = '#007bff';
      btn.style.borderColor = '#007bff';
      btn.style.color = '#ffffff';
    }
  }
}

window.submitTask = async function (event) {
  // Prevent any default form submission behavior
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  console.log('🚀 submitTask called - Team members are OPTIONAL');
  console.log('🔍 [Task Modal] submitTask event:', event ? 'present' : 'missing');

  // Find the visible modal to scope queries (avoid reading from hidden modals)
  // Check all overlays and find the one that's actually visible
  const allOverlays = document.querySelectorAll('#add-task-modal-overlay');
  let modalOverlay = null;
  let visibleModal = null;

  for (const overlay of allOverlays) {
    const style = window.getComputedStyle(overlay);
    if (style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0') {
      modalOverlay = overlay;
      visibleModal = overlay.querySelector('#add-task-modal');
      break;
    }
  }

  // Fallback if no visible overlay found
  if (!modalOverlay) {
    modalOverlay = document.getElementById('add-task-modal-overlay');
    visibleModal = modalOverlay ? modalOverlay.querySelector('#add-task-modal') : null;
  }

  console.log('🔍 Modal detection:', {
    foundOverlays: allOverlays.length,
    visibleModal: !!visibleModal,
    isEditing: !!window.editingTaskData,
    editingTaskId: window.editingTaskData?.id
  });

  // Support both ID variations (renderTaskModal uses -input suffix, renderAddTaskModal doesn't)
  // Scope queries to visible modal only
  const titleInput = visibleModal
    ? (visibleModal.querySelector('#task-title-input') || visibleModal.querySelector('#task-title'))
    : (document.getElementById('task-title-input') || document.getElementById('task-title'));
  const descriptionInput = visibleModal
    ? (visibleModal.querySelector('#task-description-input') || visibleModal.querySelector('#task-description'))
    : (document.getElementById('task-description-input') || document.getElementById('task-description'));
  const dueDateInput = visibleModal
    ? (visibleModal.querySelector('#task-due-date-input') || visibleModal.querySelector('#task-due-date'))
    : (document.getElementById('task-due-date-input') || document.getElementById('task-due-date'));
  const customServiceInput = visibleModal
    ? visibleModal.querySelector('#task-custom-service-input')
    : document.getElementById('task-custom-service-input');

  console.log('🔍 [Task Modal] Field elements found:', {
    titleInput: !!titleInput,
    titleInputId: titleInput?.id,
    titleValue: titleInput?.value,
    descriptionInput: !!descriptionInput,
    descriptionInputId: descriptionInput?.id,
    descriptionValue: descriptionInput?.value,
  });

  const title = titleInput?.value?.trim();
  const description = descriptionInput?.value?.trim();

  console.log('🔍 [Task Modal] Field values after trim:', { title, description });
  let dueDate = dueDateInput?.value || null;

  // Convert date string (YYYY-MM-DD) to timestamp at local midnight to avoid timezone issues
  // This ensures web and native apps store dates consistently
  if (dueDate && /^\d{4}-\d{2}-\d{2}$/.test(dueDate)) {
    const dateParts = dueDate.split('-');
    const localDate = new Date(
      parseInt(dateParts[0], 10),
      parseInt(dateParts[1], 10) - 1, // month is 0-indexed
      parseInt(dateParts[2], 10),
      12, 0, 0, 0 // Set to local NOON to avoid timezone date shifts (±12 hours from UTC)
    );
    // Convert to ISO string for database storage
    dueDate = localDate.toISOString();
  }

  // Get contact ID - convert empty string to null
  const contactId = (window.selectedTaskContact && window.selectedTaskContact.trim() !== '')
    ? window.selectedTaskContact
    : (window.preselectedTaskContactId || null);

  console.log('📋 Task form values:', {
    selectedTaskContact: window.selectedTaskContact,
    preselectedTaskContactId: window.preselectedTaskContactId,
    contactId: contactId,
    selectedTaskProject: window.selectedTaskProject,
    selectedTaskMembers: window.selectedTaskMembers
  });

  // Clear previous errors
  if (typeof clearFieldErrors === 'function') {
    clearFieldErrors();
  }

  let hasErrors = false;
  let errorMessage = 'Please fix the following errors:\n';

  if (!title) {
    // Use the titleInput we already found (scoped to visible modal)
    if (titleInput) highlightInvalidField(titleInput.id);
    hasErrors = true;
    errorMessage += '• Task title is required\n';
  }

  if (!description) {
    // Use the descriptionInput we already found (scoped to visible modal)
    if (descriptionInput) highlightInvalidField(descriptionInput.id);
    hasErrors = true;
    errorMessage += '• Task description is required\n';
  }

  // Priority is OPTIONAL - no validation required
  // Just read the priority value for saving, but don't require it
  let selectedPriority = window.taskPriority;
  if (!selectedPriority && window.editingTaskData?.priority) {
    selectedPriority = window.editingTaskData.priority;
  }

  // Team member validation - TEMPORARILY DISABLED for testing
  // Validate at least one team member is selected
  // First check the DOM directly - this is the most reliable
  const selectedMembersDiv = document.getElementById('selected-members') || document.getElementById('task-selected-members-display');
  const hasDisplayedMembers = selectedMembersDiv && selectedMembersDiv.children && selectedMembersDiv.children.length > 0;

  // Extract member IDs from DOM if displayed
  let extractedMemberIds = [];
  if (hasDisplayedMembers) {
    const memberButtons = selectedMembersDiv.querySelectorAll('button[onclick*="removeTaskMember"], button[onclick*="removeMember"]');
    if (memberButtons.length > 0) {
      extractedMemberIds = Array.from(memberButtons).map(btn => {
        const onclick = btn.getAttribute('onclick') || '';
        const match = onclick.match(/remove(?:Task)?Member\(['"]([^'"]+)['"]\)/);
        return match ? match[1] : null;
      }).filter(Boolean);

      // Sync to window.selectedTaskMembers if we found members in DOM
      if (extractedMemberIds.length > 0 && (!window.selectedTaskMembers || window.selectedTaskMembers.length === 0)) {
        window.selectedTaskMembers = [...extractedMemberIds];
        console.log('🔄 Synced members from DOM to state:', window.selectedTaskMembers);
      }
    }
  }

  // Check state variables
  const hasTaskMembers = window.selectedTaskMembers && Array.isArray(window.selectedTaskMembers) && window.selectedTaskMembers.length > 0;
  const hasRegularMembers = selectedMembers && Array.isArray(selectedMembers) && selectedMembers.length > 0;

  // Final check: if any source shows members, we're good
  const hasAnyMembers = hasTaskMembers || hasRegularMembers || hasDisplayedMembers || extractedMemberIds.length > 0;

  console.log('🔍 Member validation check (NOT REQUIRED):', {
    selectedTaskMembers: window.selectedTaskMembers,
    hasTaskMembers: hasTaskMembers,
    selectedMembers: selectedMembers,
    hasRegularMembers: hasRegularMembers,
    hasDisplayedMembers: hasDisplayedMembers,
    extractedMemberIds: extractedMemberIds,
    hasAnyMembers: hasAnyMembers
  });

  // Validate team members are required
  if (!hasAnyMembers) {
    const memberSearch = document.getElementById('member-search') || document.getElementById('task-member-search-input');
    if (memberSearch) {
      highlightInvalidField(memberSearch.id);
      memberSearch.focus();
      // Show dropdown on focus
      if (typeof showMemberDropdown === 'function') {
        showMemberDropdown(memberSearch);
      } else if (typeof handleTaskMemberSearch === 'function') {
        handleTaskMemberSearch('');
      }
    }
    hasErrors = true;
    errorMessage += '• At least one team member must be assigned\n';
  }

  if (hasErrors) {
    // Show custom notification instead of browser alert
    if (typeof showNotification === 'function') {
      showNotification('Please fill out all required fields', 'error');
    }
    // Scroll to first error field
    setTimeout(() => {
      const firstErrorField = document.querySelector('.field-error') ||
        document.querySelector('[style*="border-color: #ef4444"]') ||
        document.querySelector('[style*="border-color: rgb(239, 68, 68)"]');
      if (firstErrorField) {
        firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
    return;
  }

  const saveBtn = document.getElementById('create-task-btn');
  if (saveBtn) {
    saveBtn.disabled = true;
    saveBtn.textContent = window.editingTaskData ? 'Updating...' : 'Creating...';
  }

  try {
    // Create project inline if requested
    // Get project ID - convert empty string to null, check preselected as fallback
    let projectId = (window.selectedTaskProject && window.selectedTaskProject.trim() !== '')
      ? window.selectedTaskProject
      : (window.preselectedTaskProjectId || null);

    console.log('🔍 Project ID resolution:', {
      selectedTaskProject: window.selectedTaskProject,
      preselectedTaskProjectId: window.preselectedTaskProjectId,
      resolvedProjectId: projectId
    });

    if (window.showCreateProjectInTask && window.newProjectConfirmedInTask && window.newProjectNameInTask) {
      const { data: newProject, error: projectError } = await supabase
        .from('projects')
        .insert({
          name: window.newProjectNameInTask.trim(),
          description: window.newProjectDescriptionInTask || null,
          company_id: currentCompany.id,
          contact_id: contactId,
          created_by: currentUser.id,
          status: 'active',
        })
        .select()
        .single();

      if (projectError) {
        console.error('Error creating project:', projectError);
        alert('Failed to create project: ' + (projectError.message || 'Unknown error'));
        if (saveBtn) {
          saveBtn.disabled = false;
          saveBtn.textContent = window.editingTaskData ? 'Update' : 'Create';
        }
        return;
      }

      projectId = newProject.id;
    }

    // Prepare task data
    // Ensure contact_id and project_id are null if empty strings
    // If editing a quick task (DRAFT), default to BACKLOG
    const isQuickTask = window.editingTaskData?.state === 'DRAFT';
    const taskData = {
      title: title,
      description: description,
      priority: selectedPriority || window.taskPriority || (isQuickTask ? 'LOW' : 'MEDIUM'),
      due_at: dueDate ? dueDate : null,
      state: window.taskStatus || 'BACKLOG',
      company_id: currentCompany.id,
      contact_id: (contactId && contactId.trim() !== '') ? contactId : null,
      project_id: (projectId && projectId.trim() !== '') ? projectId : null,
    };

    console.log('💾 Saving task with data:', {
      contact_id: taskData.contact_id,
      project_id: taskData.project_id,
      title: taskData.title,
      selectedTaskContact: window.selectedTaskContact,
      selectedTaskProject: window.selectedTaskProject,
      preselectedTaskContactId: window.preselectedTaskContactId,
      preselectedTaskProjectId: window.preselectedTaskProjectId
    });

    // Handle service assignment (use window vars; fallback to #custom-service-name input for custom name)
    const customNameInput = visibleModal
      ? visibleModal.querySelector('#custom-service-name')
      : document.getElementById('custom-service-name');
    const customServiceNameValue = (window.customTaskServiceName && window.customTaskServiceName.trim())
      ? window.customTaskServiceName.trim()
      : (customNameInput && customNameInput.value ? customNameInput.value.trim() : '');
    if (window.selectedTaskService && window.selectedTaskService !== '') {
      taskData.service_id = window.selectedTaskService;
      taskData.service_name = null;
    } else if (customServiceNameValue) {
      taskData.service_id = null;
      taskData.service_name = customServiceNameValue;
    }

    let taskResult;

    if (window.editingTaskData && window.editingTaskData.id) {
      // UPDATE existing task
      const { data, error: taskError } = await supabase
        .from('tasks')
        .update(taskData)
        .eq('id', window.editingTaskData.id)
        .select()
        .single();

      if (taskError) {
        console.error('Error updating task:', taskError);
        if (typeof showNotification === 'function') {
          showNotification('Failed to update task: ' + (taskError.message || 'Unknown error'), 'error');
        } else {
          alert('Failed to update task: ' + (taskError.message || 'Unknown error'));
        }
        if (saveBtn) {
          saveBtn.disabled = false;
          saveBtn.textContent = 'Update';
        }
        return;
      }

      taskResult = data;

      // Remove existing assignees
      await supabase
        .from('task_assignees')
        .delete()
        .eq('task_id', window.editingTaskData.id);

    } else {
      // CREATE new task
      const { data, error: taskError } = await supabase
        .from('tasks')
        .insert([taskData])
        .select()
        .single();

      if (taskError) {
        console.error('Error creating task:', taskError);
        if (typeof showNotification === 'function') {
          showNotification('Failed to create task: ' + (taskError.message || 'Unknown error'), 'error');
        } else {
          alert('Failed to create task: ' + (taskError.message || 'Unknown error'));
        }
        if (saveBtn) {
          saveBtn.disabled = false;
          saveBtn.textContent = 'Create';
        }
        return;
      }

      taskResult = data;
    }

    // Add task assignees - use whichever has members
    const membersToAssign = (window.selectedTaskMembers && window.selectedTaskMembers.length > 0)
      ? window.selectedTaskMembers
      : (selectedMembers && selectedMembers.length > 0 ? selectedMembers : []);

    console.log('👥 Assigning members:', {
      selectedTaskMembers: window.selectedTaskMembers,
      selectedMembers: selectedMembers,
      membersToAssign: membersToAssign
    });

    if (membersToAssign.length > 0) {
      const assigneesData = membersToAssign.map(userId => ({
        task_id: taskResult.id,
        user_id: userId,
      }));

      const { error: assigneesError } = await supabase
        .from('task_assignees')
        .insert(assigneesData);

      if (assigneesError) {
        console.error('Error assigning team members:', assigneesError);
      } else {
        // Send notifications to assigned members - do this in parallel for better performance
        try {
          const assignerName = `${currentUser.first_name || ''} ${currentUser.last_name || ''}`.trim() || 'Someone';

          // Create all notification promises in parallel
          const notificationPromises = membersToAssign.map(userId =>
            supabase.from('notifications').insert({
              user_id: userId,
              type: 'task_assigned',
              title: 'Assigned to Task',
              body: `${assignerName} assigned you to task "${taskResult.title}"`,
              data: { task_id: taskResult.id },
            })
          );

          // Wait for all notifications to be sent in parallel
          await Promise.all(notificationPromises);
        } catch (error) {
          console.warn('Failed to send notifications:', error);
        }
      }
    }

    // Show success message immediately
    if (typeof showNotification === 'function') {
      showNotification('Task created successfully', 'success');
    }

    // Close modal immediately (don't wait for data refresh)
    closeAddTaskModal();

    // Refresh data in background (non-blocking)
    // This allows the UI to respond immediately while data loads
    Promise.all([
      loadTasks(),
      // If we were editing a quick task (DRAFT state), reload quick tasks to remove it from the list
      window.editingTaskData?.state === 'DRAFT' ? loadQuickTasks() : Promise.resolve()
    ]).then(() => {

      // Close quick tasks modal if open (after loading is done)
      if (window.editingTaskData?.state === 'DRAFT' && showQuickTasksModal) {
        showQuickTasksModal = false;
      }

      // Check if we're viewing a contact detail - stay on that page
      const contactDetailDiv = document.getElementById('contact-detail-content');
      const isViewingContact = contactDetailDiv && (selectedContactId || window.preselectedTaskContactId);

      // Also check if we have a preselected contact (from openTaskModalForContact)
      const wasOpenedFromContact = window.preselectedTaskContactId || (window.selectedTaskContact && window.selectedTaskContact.trim() !== '');

      console.log('📍 Post-save navigation check:', {
        selectedContactId,
        preselectedTaskContactId: window.preselectedTaskContactId,
        selectedTaskContact: window.selectedTaskContact,
        isViewingContact,
        wasOpenedFromContact,
        currentScreen
      });

      if (isViewingContact || wasOpenedFromContact) {
        // If we have selectedContactId, update the contact detail view
        const contactIdToUse = selectedContactId || window.preselectedTaskContactId || window.selectedTaskContact;
        if (contactIdToUse) {
          // Set selectedContactId if not already set
          if (!selectedContactId) {
            selectedContactId = contactIdToUse;
          }
          // Refresh contact detail - this will keep us on the contact page
          updateContactDetailContent().then(() => {
            renderPMTool();
          });
        } else {
          // Fallback: just re-render without switching screens
          renderPMTool();
        }
      } else {
        // Only re-render if we're not viewing a contact detail
        renderPMTool();
      }

      // Clear preselected values after use
      window.preselectedTaskContactId = null;
      window.preselectedTaskProjectId = null;
    }).catch(error => {
      console.error('Error refreshing task data:', error);
      // Still render even if refresh fails
      renderPMTool();
    });

    // Close modal automatically after task creation (skip render since we're already rendering)
    if (showAddTaskForm) {
      toggleAddTaskForm(true);
    }
  } catch (error) {
    console.error('Error saving task:', error);
    alert('An unexpected error occurred while saving the task');
    if (saveBtn) {
      saveBtn.disabled = false;
      saveBtn.textContent = window.editingTaskData ? 'Update' : 'Create';
    }
  }
}

// Load messages for a specific chat
async function loadChatMessages(chatId) {
  if (!currentCompany || !chatId) {
    chatMessages = [];
    return;
  }

  try {
    const { data: messagesData, error } = await supabase
      .from('messages')
      .select(`
        *,
        profiles!messages_sender_id_fkey(
          id,
          first_name,
          last_name,
          avatar_path
        )
      `)
      .eq('chat_id', chatId)
      .neq('status', 'scheduled')
      .order('created_at', { ascending: true })
      .limit(100);

    if (error) {
      console.error('Error loading chat messages:', error);
      chatMessages = [];
      return;
    }

    chatMessages = messagesData || [];
    console.log(`✅ Loaded ${chatMessages.length} messages for chat ${chatId}`);

    // Also load scheduled messages for this chat
    await loadScheduledMessages(chatId);
  } catch (error) {
    console.error('Error loading chat messages:', error);
    chatMessages = [];
  }
}

// Refresh chat messages function
window.refreshChatMessages = async function () {
  if (!selectedChatId) {
    console.warn('No chat selected for refresh');
    return;
  }

  try {
    console.log('🔄 Refreshing chat messages...');
    await loadChatMessages(selectedChatId);
    window.renderPMTool();
    // Scroll to bottom (most recent messages) after refresh
    setTimeout(() => {
      const messagesContainer = document.getElementById('chat-messages-container');
      if (messagesContainer) {
        messagesContainer.scrollTop = messagesContainer.scrollHeight;
      }
    }, 100);
    console.log('✅ Chat messages refreshed successfully');
  } catch (error) {
    console.error('Error refreshing chat messages:', error);
    alert('Failed to refresh messages. Please try again.');
  }
};

// Load scheduled messages for a specific chat
async function loadScheduledMessages(chatId) {
  if (!currentCompany || !chatId) {
    scheduledMessages = [];
    return;
  }

  try {
    const { data: scheduledData, error } = await supabase
      .from('messages')
      .select('*')
      .eq('chat_id', chatId)
      .eq('status', 'scheduled')
      .gte('scheduled_at', new Date().toISOString()) // Only future scheduled messages
      .order('scheduled_at', { ascending: true });

    if (error) {
      console.error('Error loading scheduled messages:', error);
      scheduledMessages = [];
      return;
    }

    scheduledMessages = scheduledData || [];
    console.log(`✅ Loaded ${scheduledMessages.length} scheduled messages for chat ${chatId}`);
  } catch (error) {
    console.error('Error loading scheduled messages:', error);
    scheduledMessages = [];
  }
}

// Open chat from contact detail page
window.openChatFromContact = async function (chatId) {
  // Switch to chat screen
  currentScreen = 'chat';
  selectedChatId = chatId;

  // Reload chats to ensure we have the latest data
  await loadChats();

  // Load messages for this chat
  await loadChatMessages(chatId);
  setupMessageSubscription(chatId);

  // Mark chat as read
  if (currentUser || currentProfile) {
    const userId = currentUser?.id || currentProfile?.id;
    try {
      const { data: latestMessage } = await supabase
        .from('messages')
        .select('id')
        .eq('chat_id', chatId)
        .neq('status', 'scheduled')
        .order('created_at', { ascending: false })
        .limit(1)
        .single();

      await supabase.rpc('upsert_chat_read_status', {
        p_user_id: userId,
        p_chat_id: chatId,
        p_last_read_message_id: latestMessage?.id || null
      });

      chatUnreadCounts[chatId] = 0;
    } catch (e) {
      console.error('Error marking chat as read:', e);
    }
  }

  // Re-render the PM tool with chat selected
  await renderPMTool();

  // Scroll to bottom - force scroll on initial load (like Instagram)
  const scrollToBottom = (force = false) => {
    const messagesContainer = document.getElementById('chat-messages-container');
    if (messagesContainer) {
      // Use requestAnimationFrame for smooth scrolling
      requestAnimationFrame(() => {
        messagesContainer.scrollTop = messagesContainer.scrollHeight;
        // Try again after a short delay to handle async content loading
        setTimeout(() => {
          messagesContainer.scrollTop = messagesContainer.scrollHeight;
        }, 50);
        // Final attempt after render completes
        setTimeout(() => {
          messagesContainer.scrollTop = messagesContainer.scrollHeight;
        }, 200);
      });
    }
  };

  // Force scroll to bottom on initial load (always scroll when opening chat)
  setTimeout(() => scrollToBottom(true), 100);
  setTimeout(() => scrollToBottom(true), 300);
  setTimeout(() => scrollToBottom(true), 500);
  setTimeout(() => scrollToBottom(true), 800);

  // Use MutationObserver to keep scroll at bottom when content changes (like Instagram)
  setTimeout(() => {
    const messagesContainer = document.getElementById('chat-messages-container');
    if (messagesContainer) {
      // Remove any existing observer and clear timeout
      if (window.chatScrollObserver) {
        window.chatScrollObserver.disconnect();
      }
      if (window.chatInitialLoadTimeout) {
        clearTimeout(window.chatInitialLoadTimeout);
        window.chatInitialLoadTimeout = null;
      }

      // Track if this is initial load
      let isInitialLoad = true;
      window.chatInitialLoadTimeout = setTimeout(() => {
        isInitialLoad = false;
        window.chatInitialLoadTimeout = null;
      }, 2000);

      // Create observer to watch for content changes
      window.chatScrollObserver = new MutationObserver(() => {
        if (isInitialLoad) {
          // Always scroll during initial load
          requestAnimationFrame(() => {
            messagesContainer.scrollTop = messagesContainer.scrollHeight;
          });
        } else {
          // After initial load, only auto-scroll if user is near the bottom (within 100px)
          const isNearBottom = messagesContainer.scrollHeight - messagesContainer.scrollTop - messagesContainer.clientHeight < 100;
          if (isNearBottom) {
            requestAnimationFrame(() => {
              messagesContainer.scrollTop = messagesContainer.scrollHeight;
            });
          }
        }
      });

      // Observe changes to the messages container
      window.chatScrollObserver.observe(messagesContainer, {
        childList: true,
        subtree: true
      });
    }
  }, 600);
};

// Select a chat and load its messages
window.selectChat = async function (chatId) {
  const isNewChat = selectedChatId !== chatId;
  const previousChatId = selectedChatId;

  // Clean up previous subscription
  if (messageSubscription) {
    supabase.removeChannel(messageSubscription);
    messageSubscription = null;
  }

  // Save scroll position before changing chat
  let savedScrollPosition = null;
  let wasNearBottom = false;
  const messagesContainer = document.getElementById('chat-messages-container');
  if (messagesContainer) {
    savedScrollPosition = messagesContainer.scrollTop;
    const scrollHeight = messagesContainer.scrollHeight;
    const clientHeight = messagesContainer.clientHeight;
    wasNearBottom = (scrollHeight - savedScrollPosition - clientHeight) < 100;

    // Store in persistent storage
    if (selectedChatId) {
      window.chatScrollPositions[selectedChatId] = {
        position: savedScrollPosition,
        wasNearBottom: wasNearBottom,
        scrollHeight: scrollHeight
      };
    }
  }

  selectedChatId = chatId;
  window.chatScrollRestored = false; // Reset flag
  await loadChatMessages(chatId);
  setupMessageSubscription(chatId);

  // Mark chat as read using chat_read_status table
  if (currentUser || currentProfile) {
    const userId = currentUser?.id || currentProfile?.id;
    try {
      // Get the latest message ID for this chat
      const { data: latestMessage } = await supabase
        .from('messages')
        .select('id')
        .eq('chat_id', chatId)
        .neq('status', 'scheduled')
        .order('created_at', { ascending: false })
        .limit(1)
        .single();

      // Mark chat as read using the RPC function
      const { error } = await supabase.rpc('upsert_chat_read_status', {
        p_user_id: userId,
        p_chat_id: chatId,
        p_last_read_message_id: latestMessage?.id || null
      });

      if (error) {
        console.error('Error marking chat as read:', error);
      } else {
        // Reset unread count for this chat
        chatUnreadCounts[chatId] = 0;
      }
    } catch (error) {
      console.error('Error marking chat as read:', error);
    }
  }

  // Store scroll info for renderPMTool to use
  window.chatScrollInfo = {
    position: savedScrollPosition,
    wasNearBottom: wasNearBottom,
    chatId: chatId,
    isNewChat: isNewChat
  };

  renderPMTool();

  // Scroll logic - scroll to bottom for new chats or if user was at bottom
  setTimeout(() => {
    const messagesContainer = document.getElementById('chat-messages-container');
    if (!messagesContainer) return;

    const scrollToBottom = () => {
      if (messagesContainer) {
        requestAnimationFrame(() => {
          messagesContainer.scrollTop = messagesContainer.scrollHeight;
        });
      }
    };

    // If it's a new chat, always scroll to bottom
    if (isNewChat) {
      scrollToBottom();
      setTimeout(scrollToBottom, 50);
      setTimeout(scrollToBottom, 200);
      setTimeout(() => {
        scrollToBottom();
        window.chatScrollRestored = true;
      }, 500);
    } else if (!isNewChat && savedScrollPosition !== null) {
      // Same chat being re-rendered - preserve scroll position
      if (wasNearBottom) {
        // User was at bottom, scroll to bottom
        scrollToBottom();
        setTimeout(() => {
          scrollToBottom();
          window.chatScrollRestored = true;
        }, 100);
      } else if (savedScrollPosition > 0) {
        // User was scrolled down (not at top), preserve position
        requestAnimationFrame(() => {
          const newScrollHeight = messagesContainer.scrollHeight;
          const stored = window.chatScrollPositions[chatId];
          const oldScrollHeight = stored ? stored.scrollHeight : (savedScrollPosition + messagesContainer.clientHeight);
          if (oldScrollHeight > messagesContainer.clientHeight && newScrollHeight > messagesContainer.clientHeight) {
            const scrollRatio = savedScrollPosition / (oldScrollHeight - messagesContainer.clientHeight);
            const newPosition = scrollRatio * (newScrollHeight - messagesContainer.clientHeight);
            messagesContainer.scrollTop = Math.max(0, Math.min(newPosition, newScrollHeight - messagesContainer.clientHeight));
          } else {
            messagesContainer.scrollTop = Math.min(savedScrollPosition, newScrollHeight - messagesContainer.clientHeight);
          }
          window.chatScrollRestored = true;
        });
      } else {
        // User was at top (position 0), scroll to bottom
        scrollToBottom();
        setTimeout(() => {
          scrollToBottom();
          window.chatScrollRestored = true;
        }, 100);
      }
    } else {
      // No saved position - check persistent storage
      const stored = window.chatScrollPositions[chatId];
      if (stored && stored.position > 0 && !stored.wasNearBottom) {
        // Restore from persistent storage
        requestAnimationFrame(() => {
          const newScrollHeight = messagesContainer.scrollHeight;
          if (stored.scrollHeight > messagesContainer.clientHeight && newScrollHeight > messagesContainer.clientHeight) {
            const scrollRatio = stored.position / (stored.scrollHeight - messagesContainer.clientHeight);
            const newPosition = scrollRatio * (newScrollHeight - messagesContainer.clientHeight);
            messagesContainer.scrollTop = Math.max(0, Math.min(newPosition, newScrollHeight - messagesContainer.clientHeight));
          } else {
            messagesContainer.scrollTop = Math.min(stored.position, newScrollHeight - messagesContainer.clientHeight);
          }
          window.chatScrollRestored = true;
        });
      } else {
        // No saved position at all, scroll to bottom
        scrollToBottom();
        setTimeout(() => {
          scrollToBottom();
          window.chatScrollRestored = true;
        }, 100);
      }
    }

    // Set up MutationObserver for auto-scroll when new messages arrive
    // Remove any existing observer
    if (window.chatScrollObserver) {
      window.chatScrollObserver.disconnect();
    }
    if (window.chatInitialLoadTimeout) {
      clearTimeout(window.chatInitialLoadTimeout);
      window.chatInitialLoadTimeout = null;
    }

    // Track if this is initial load (only for new chats)
    let isInitialLoad = isNewChat;
    if (isInitialLoad) {
      window.chatInitialLoadTimeout = setTimeout(() => {
        isInitialLoad = false;
        window.chatInitialLoadTimeout = null;
      }, 2000);
    }

    // Create observer to watch for content changes
    window.chatScrollObserver = new MutationObserver(() => {
      if (isInitialLoad) {
        // Always scroll during initial load
        requestAnimationFrame(() => {
          messagesContainer.scrollTop = messagesContainer.scrollHeight;
        });
      } else {
        // After initial load, only auto-scroll if user is near the bottom (within 100px)
        const isNearBottom = messagesContainer.scrollHeight - messagesContainer.scrollTop - messagesContainer.clientHeight < 100;
        if (isNearBottom) {
          requestAnimationFrame(() => {
            messagesContainer.scrollTop = messagesContainer.scrollHeight;
          });
        }
      }
    });

    // Observe changes to the messages container
    window.chatScrollObserver.observe(messagesContainer, {
      childList: true,
      subtree: true
    });
  }, 100);
};

// Open manage chat modal
window.openManageChatModal = async function () {
  if (!selectedChatId) return;

  const chat = chats.find(c => c.id === selectedChatId);
  if (!chat) return;

  // Small delay to ensure database is ready if chat was just created
  await new Promise(resolve => setTimeout(resolve, 50));

  // Load participants from database
  // Note: chat_participants table doesn't have contact_id column
  const { data: participantsData, error: participantsError } = await supabase
    .from('chat_participants')
    .select(`
      user_id,
      profiles(
        id,
        first_name,
        last_name,
        role,
        avatar_path,
        is_hh_admin,
        company_id
      )
    `)
    .eq('chat_id', selectedChatId);

  if (participantsError) {
    console.error('Error loading participants:', participantsError);
  }

  console.log('📋 Loaded participants from DB:', participantsData);

  // If profiles are missing (cross-company users), load them separately
  const missingProfileIds = [];
  if (participantsData) {
    participantsData.forEach(p => {
      if (p.user_id && !p.profiles) {
        missingProfileIds.push(p.user_id);
      }
    });
  }

  let additionalProfiles = {};
  if (missingProfileIds.length > 0) {
    console.log('🔍 Loading missing profiles for cross-company users:', missingProfileIds);
    const { data: missingProfiles, error: missingError } = await supabase
      .from('profiles')
      .select('id, first_name, last_name, avatar_path, is_hh_admin, company_id, role')
      .in('id', missingProfileIds);

    if (!missingError && missingProfiles) {
      missingProfiles.forEach(prof => {
        additionalProfiles[prof.id] = prof;
      });
      console.log('✅ Loaded', missingProfiles.length, 'additional profiles');
    }
  }

  // Load available users (team members and contacts)
  const allUsers = [...(teamMembers || [])];
  const contactProfiles = (contacts || []).filter(c => c.contact_profile_id).map(c => ({
    id: c.contact_profile_id,
    user_id: c.contact_profile_id, // Ensure both id and user_id are set
    first_name: c.first_name,
    last_name: c.last_name,
    role: 'CLIENT',
    contact_id: c.id
  }));
  allUsers.push(...contactProfiles);

  // Ensure teamMembers also have both id and user_id, and normalize to strings
  allUsers.forEach(user => {
    if (!user.user_id) user.user_id = user.id;
    if (!user.id) user.id = user.user_id;
    // Normalize to strings for consistent comparison
    user.id = String(user.id);
    user.user_id = String(user.user_id);
  });

  // Load available projects
  const { data: projectsData } = await supabase
    .from('projects')
    .select('id, name, contact_id')
    .eq('company_id', currentCompany.id)
    .order('name', { ascending: true });

  // Map participants from database - ensure both id and user_id are set
  const dbParticipants = (participantsData || []).map(p => {
    const userId = p.user_id;
    // Use profile from join, or from additional profiles lookup, or fallback to user_id
    const profile = p.profiles || additionalProfiles[userId];
    const profileId = profile?.id || userId;

    // Find contact_id by looking up the user in contacts if they're a client
    let contactId = null;
    const contact = contacts.find(c => String(c.contact_profile_id) === String(userId));
    if (contact) {
      contactId = contact.id;
    }

    // Ensure we have both id and user_id for proper comparison
    const participant = {
      id: profileId,
      user_id: userId, // Always use user_id from chat_participants table
      first_name: profile?.first_name || '',
      last_name: profile?.last_name || '',
      role: profile?.role || 'USER',
      avatar_path: profile?.avatar_path,
      is_hh_admin: profile?.is_hh_admin || false,
      company_id: profile?.company_id,
      contact_id: contactId // Get from contacts lookup, not from chat_participants
    };

    // Normalize IDs to strings for consistent comparison
    participant.id = String(participant.id);
    participant.user_id = String(participant.user_id);

    return participant;
  });

  console.log('👥 Mapped participants:', dbParticipants);

  // Load archive status for current user
  const userId = currentUser?.id || currentProfile?.id;
  let isArchived = false;
  if (userId) {
    const { data: archiveData } = await supabase
      .from('chat_participants')
      .select('is_archived')
      .eq('chat_id', selectedChatId)
      .eq('user_id', userId)
      .maybeSingle();
    isArchived = archiveData?.is_archived || false;
  }

  // Initialize manage chat data
  // Use custom_name if set, otherwise use title, otherwise empty string
  const initialChatName = chat.custom_name || chat.title || '';
  manageChatData = {
    chatName: initialChatName,
    originalChatName: initialChatName, // Store original name for comparison
    selectedProject: chat.project?.id || null,
    participants: dbParticipants,
    availableUsers: allUsers,
    availableProjects: projectsData || [],
    showCreateProject: false,
    newProjectName: '',
    showDeleteConfirm: false,
    deleteConfirmText: '',
    isArchived: isArchived
  };
  // Update global reference
  window.manageChatData = manageChatData;

  console.log('📝 Initializing manage chat modal:', {
    chatId: selectedChatId,
    custom_name: chat.custom_name,
    title: chat.title,
    initialChatName: initialChatName
  });

  showManageChatModal = true;
  renderPMTool();
};

// Navigate to contact profile from chat participant
window.openContactFromChat = async function (participantUserId, participantContactId) {
  // If participant has a contact_id, use it directly
  if (participantContactId) {
    selectedContactId = participantContactId;
    currentScreen = 'sales';
    await loadContacts();
    renderPMTool();
    return;
  }

  // Otherwise, try to find contact by profile_id/user_id
  const contact = contacts.find(c => c.contact_profile_id === participantUserId);
  if (contact) {
    selectedContactId = contact.id;
    currentScreen = 'sales';
    await loadContacts();
    renderPMTool();
  } else {
    alert('Contact not found');
  }
};

// Close manage chat modal
window.closeManageChatModal = function () {
  showManageChatModal = false;
  manageChatData.showDeleteConfirm = false;
  manageChatData.deleteConfirmText = '';
  renderPMTool();
};

// Toggle create project in manage chat modal
window.toggleCreateProjectInChat = function () {
  manageChatData.showCreateProject = !manageChatData.showCreateProject;
  renderPMTool();
};

// Save manage chat changes
window.saveManageChat = async function () {
  if (!selectedChatId) {
    alert('No chat selected');
    return;
  }

  if (!manageChatData) {
    alert('Chat data not loaded');
    return;
  }

  try {
    const updates = {};

    // Update chat name - always update custom_name (can be empty to clear it)
    // If custom_name is empty, the display will fall back to title
    const chatNameValue = manageChatData.chatName ? manageChatData.chatName.trim() : '';

    // Update both custom_name and title when a custom name is provided
    if (chatNameValue) {
      updates.custom_name = chatNameValue;
      updates.title = chatNameValue; // Also update title to match custom_name
    } else {
      // If empty, set custom_name to null but keep the existing title
      updates.custom_name = null;
      // Don't update title if custom_name is cleared - keep auto-generated title
    }

    console.log('💾 Saving chat:', {
      chatId: selectedChatId,
      chatName: chatNameValue,
      updates: updates
    });

    // Update project assignment
    if (manageChatData.showCreateProject && manageChatData.newProjectName.trim()) {
      // Create new project
      const { data: newProject, error: projectError } = await supabase
        .from('projects')
        .insert({
          name: manageChatData.newProjectName.trim(),
          company_id: currentCompany.id,
          created_by: currentUser.id
        })
        .select()
        .single();

      if (projectError) {
        console.error('❌ Error creating project:', projectError);
        alert('Failed to create project: ' + projectError.message);
        return;
      }

      updates.project_id = newProject.id;
    } else if (manageChatData.selectedProject) {
      updates.project_id = manageChatData.selectedProject;
    } else {
      updates.project_id = null;
    }

    // Update chat - ensure we're updating the chats table, not chat_participants
    console.log('📤 Updating chat in database:', updates);
    const { data: updateData, error: updateError } = await supabase
      .from('chats')
      .update(updates)
      .eq('id', selectedChatId)
      .select();

    if (updateError) {
      console.error('❌ Error updating chat:', updateError);
      alert('Failed to update chat: ' + updateError.message);
      return;
    }

    console.log('✅ Chat updated successfully:', updateData);

    // Update participants
    // Use user_id from participants (which comes from chat_participants table)
    const currentUserId = currentUser?.id || currentProfile?.id;
    const currentParticipantIds = manageChatData.participants.map(p => {
      // Prefer user_id as it's the actual foreign key in chat_participants table
      return p.user_id || p.id;
    }).filter(Boolean); // Remove any null/undefined values

    // IMPORTANT: Ensure current user is always a participant (prevent self-removal)
    if (currentUserId && !currentParticipantIds.includes(currentUserId)) {
      console.warn('⚠️ Current user not in participants list, adding automatically');
      currentParticipantIds.push(currentUserId);
    }

    console.log('💾 Saving participants:', currentParticipantIds);

    // Get existing participants
    const { data: existingParticipants, error: fetchError } = await supabase
      .from('chat_participants')
      .select('user_id')
      .eq('chat_id', selectedChatId);

    if (fetchError) {
      console.error('Error fetching existing participants:', fetchError);
      alert('Failed to fetch existing participants: ' + fetchError.message);
      return;
    }

    const existingParticipantIds = (existingParticipants || []).map(p => String(p.user_id)).filter(Boolean);
    console.log('📋 Existing participants:', existingParticipantIds);

    // Normalize current participant IDs for comparison
    const normalizedCurrentIds = currentParticipantIds.map(id => String(id));

    // Add new participants
    const toAdd = normalizedCurrentIds.filter(id => !existingParticipantIds.includes(String(id)));
    if (toAdd.length > 0) {
      console.log('➕ Adding participants:', toAdd);
      const { error: addError } = await supabase
        .from('chat_participants')
        .insert(toAdd.map(userId => ({
          chat_id: selectedChatId,
          user_id: userId
        })));

      if (addError) {
        console.error('Error adding participants:', addError);
        alert('Failed to add participants: ' + addError.message);
        return;
      }
    }

    // Remove participants - but NEVER remove the current user
    const toRemove = existingParticipantIds.filter(id => {
      // Don't remove current user
      if (currentUserId && String(id) === String(currentUserId)) {
        return false;
      }
      return !normalizedCurrentIds.includes(String(id));
    });

    if (toRemove.length > 0) {
      console.log('➖ Removing participants:', toRemove);
      const { error: removeError } = await supabase
        .from('chat_participants')
        .delete()
        .eq('chat_id', selectedChatId)
        .in('user_id', toRemove);

      if (removeError) {
        console.error('Error removing participants:', removeError);
        alert('Failed to remove participants: ' + removeError.message);
        return;
      }
    }

    console.log('✅ Participants saved successfully');

    // Preserve the selected chat ID before reloading
    const preservedChatId = selectedChatId;

    // Show success notification - check if chat name was changed
    const originalName = manageChatData.originalChatName || '';
    const newName = chatNameValue || '';
    if (newName && newName !== originalName) {
      // Chat was renamed
      if (typeof window.showNotification === 'function') {
        window.showNotification(`Chat renamed to ${newName}`, 'success');
      } else {
        alert(`Chat renamed to ${newName}`);
      }
    } else {
      // Other updates (participants, project, etc.) but not name change
      if (typeof window.showNotification === 'function') {
        window.showNotification('Chat updated successfully!', 'success');
      } else {
        alert('Chat updated successfully!');
      }
    }

    // Reload chats to get updated data
    await loadChats();

    // Ensure the chat still exists after reload
    const chatStillExists = chats.find(c => c.id === preservedChatId);
    if (!chatStillExists) {
      console.warn('⚠️ Chat not found after reload:', preservedChatId);
      console.log('📋 Available chats:', chats.map(c => ({ id: c.id, title: c.title || c.custom_name })));
      // Don't clear selectedChatId - let user manually select another chat
    } else {
      // Ensure selectedChatId is still set
      selectedChatId = preservedChatId;
      console.log('✅ Chat still selected after reload:', selectedChatId);
    }

    // Close modal
    closeManageChatModal();

    // Re-render to show updated chat title
    renderPMTool();
  } catch (error) {
    console.error('Error saving chat:', error);
    alert('Failed to save changes: ' + error.message);
  }
};

// Toggle participant in manage chat modal
window.toggleChatParticipant = function (userId) {
  // Normalize userId for comparison
  const normalizedUserId = String(userId);

  // Check if user is already a participant (compare both id and user_id)
  const index = manageChatData.participants.findIndex(p => {
    const pId = String(p.id || '');
    const pUserId = String(p.user_id || '');
    return pId === normalizedUserId || pUserId === normalizedUserId;
  });

  if (index >= 0) {
    // Remove participant
    manageChatData.participants.splice(index, 1);
    console.log('➖ Removed participant:', userId);
  } else {
    // Add participant - find user in availableUsers
    const user = manageChatData.availableUsers.find(u => {
      const uId = String(u.id || '');
      const uUserId = String(u.user_id || '');
      return uId === normalizedUserId || uUserId === normalizedUserId;
    });

    if (user) {
      // Ensure both id and user_id are set and normalized to strings
      const participantToAdd = {
        id: String(user.id || user.user_id),
        user_id: String(user.user_id || user.id),
        first_name: user.first_name || '',
        last_name: user.last_name || '',
        role: user.company_role || user.role || 'USER',
        contact_id: user.contact_id || null
      };
      manageChatData.participants.push(participantToAdd);
      console.log('➕ Added participant:', participantToAdd);
    } else {
      console.warn('⚠️ User not found in availableUsers:', userId);
    }
  }

  console.log('👥 Current participants:', manageChatData.participants);
  renderPMTool();
};

// Show delete confirmation
window.showDeleteChatConfirm = async function () {
  // Only owners can delete chats completely
  const userRole = currentProfile?.company_role || currentProfile?.role || 'USER';

  if (userRole !== 'OWNER') {
    alert('Only business owners can permanently delete chats.');
    return;
  }

  const chat = chats.find(c => c.id === selectedChatId);
  if (!chat) {
    alert('Chat not found');
    return;
  }

  manageChatData.showDeleteConfirm = true;
  manageChatData.deleteConfirmText = '';
  renderPMTool();
};

// Delete chat
window.deleteChat = async function () {
  const confirmInput = document.getElementById('delete-confirm-input');
  const confirmText = confirmInput ? confirmInput.value.trim() : manageChatData.deleteConfirmText;

  if (confirmText !== 'DELETE') {
    alert('Please type DELETE in capital letters to confirm');
    return;
  }

  if (!selectedChatId) {
    alert('No chat selected');
    return;
  }

  try {
    // Delete messages first
    const { error: messagesError } = await supabase
      .from('messages')
      .delete()
      .eq('chat_id', selectedChatId);

    if (messagesError) {
      console.error('Error deleting messages:', messagesError);
    }

    // Delete participants
    const { error: participantsError } = await supabase
      .from('chat_participants')
      .delete()
      .eq('chat_id', selectedChatId);

    if (participantsError) {
      console.error('Error deleting participants:', participantsError);
    }

    // Delete read status
    await supabase
      .from('chat_read_status')
      .delete()
      .eq('chat_id', selectedChatId);

    // Delete chat
    const { error } = await supabase
      .from('chats')
      .delete()
      .eq('id', selectedChatId);

    if (error) {
      alert('Failed to delete chat: ' + error.message);
      return;
    }

    // Reload chats and clear selection
    selectedChatId = null;
    chatMessages = [];
    await loadChats();
    closeManageChatModal();
    renderPMTool();
  } catch (error) {
    console.error('Error deleting chat:', error);
    alert('Failed to delete chat: ' + error.message);
  }
};

// Archive chat for current user only (hide from their list)
window.archiveChat = async function () {
  const userId = currentUser?.id || currentProfile?.id;
  if (!selectedChatId || !userId) {
    alert('No chat selected or user not logged in');
    return;
  }

  if (!confirm('Archive this chat? It will be hidden from your chat list but you can view it in the archive filter. Other participants will not be affected.')) {
    return;
  }

  try {
    // Update is_archived for this user only
    const { error } = await supabase
      .from('chat_participants')
      .update({ is_archived: true })
      .eq('chat_id', selectedChatId)
      .eq('user_id', userId);

    if (error) {
      alert('Failed to archive chat: ' + error.message);
      return;
    }

    // Reload chats and clear selection
    selectedChatId = null;
    chatMessages = [];
    await loadChats();
    closeManageChatModal();
    renderPMTool();

    // Show success message
    alert('Chat archived successfully! Use the "Show Archived" toggle to view archived chats.');
  } catch (error) {
    console.error('Error archiving chat:', error);
    alert('Failed to archive chat: ' + error.message);
  }
};

// Unarchive chat for current user
window.unarchiveChat = async function () {
  const userId = currentUser?.id || currentProfile?.id;
  if (!selectedChatId || !userId) {
    alert('No chat selected or user not logged in');
    return;
  }

  try {
    // Update is_archived for this user only
    const { error } = await supabase
      .from('chat_participants')
      .update({ is_archived: false })
      .eq('chat_id', selectedChatId)
      .eq('user_id', userId);

    if (error) {
      alert('Failed to unarchive chat: ' + error.message);
      return;
    }

    // Reload chats and clear selection
    selectedChatId = null;
    chatMessages = [];
    await loadChats();
    closeManageChatModal();
    renderPMTool();
  } catch (error) {
    console.error('Error unarchiving chat:', error);
    alert('Failed to unarchive chat: ' + error.message);
  }
};

// Toggle show archived chats
window.toggleShowArchivedChats = async function () {
  showArchivedChats = !showArchivedChats;
  await loadChats();
  renderPMTool();
};

// Toggle archive chat in manage chat modal
window.toggleArchiveChatInModal = async function () {
  if (!selectedChatId) {
    alert('No chat selected');
    return;
  }

  const userId = currentUser?.id || currentProfile?.id;
  if (!userId) {
    alert('User not logged in');
    return;
  }

  const newArchiveStatus = !manageChatData.isArchived;

  try {
    const { error } = await supabase
      .from('chat_participants')
      .update({ is_archived: newArchiveStatus })
      .eq('chat_id', selectedChatId)
      .eq('user_id', userId);

    if (error) throw error;

    manageChatData.isArchived = newArchiveStatus;
    await loadChats();
    renderPMTool();
  } catch (error) {
    console.error('Error toggling archive:', error);
    alert('Failed to archive chat: ' + error.message);
  }
};

// Handle chat file upload
window.handleChatFileUpload = async function (event) {
  const file = event.target.files?.[0];
  if (!file) return;

  if (!selectedChatId || !currentUser) {
    alert('Please select a chat first');
    // Clear the input
    event.target.value = '';
    return;
  }

  // Validate file type - only images and PDFs
  const isImage = file.type.startsWith('image/');
  const isPDF = file.type === 'application/pdf';

  if (!isImage && !isPDF) {
    alert('Only images and PDF files are allowed');
    event.target.value = '';
    return;
  }

  // Validate file size - max 10MB
  const maxSize = 10 * 1024 * 1024; // 10MB in bytes
  if (file.size > maxSize) {
    alert('File size must be less than 10MB');
    event.target.value = '';
    return;
  }

  try {
    // Show loading indicator
    const fileInput = event.target;
    const originalButton = document.querySelector('button[title="Attach File"]');
    if (originalButton) {
      originalButton.disabled = true;
      originalButton.style.opacity = '0.5';
      originalButton.textContent = '⏳';
    }

    // Generate unique filename
    const fileExt = file.name.split('.').pop();
    const fileName = `${Date.now()}_${file.name.replace(/[^a-zA-Z0-9.-]/g, '_')}`;
    const filePath = `${selectedChatId}/${fileName}`;

    console.log('📤 Uploading file:', { fileName, filePath, size: file.size, type: file.type });

    // Upload to Supabase Storage
    const { data: uploadData, error: uploadError } = await supabase.storage
      .from('chat-media')
      .upload(filePath, file, {
        cacheControl: '3600',
        upsert: false
      });

    if (uploadError) {
      console.error('❌ Upload error:', uploadError);
      alert('Failed to upload file: ' + uploadError.message);
      // Reset button
      const resetButton = document.querySelector('button[title="Attach File"]');
      if (resetButton) {
        resetButton.disabled = false;
        resetButton.style.opacity = '1';
        resetButton.innerHTML = 'Attach';
      }
      event.target.value = '';
      return;
    }

    console.log('✅ Upload successful:', uploadData);

    // Get public URL
    const { data: { publicUrl } } = supabase.storage
      .from('chat-media')
      .getPublicUrl(filePath);

    console.log('🔗 Public URL:', publicUrl);

    // Determine message text based on file type
    const fileIcon = isImage ? '' : '📎';
    const messageText = isImage ? file.name : `${fileIcon} ${file.name}`;

    // Send message with file URL - match native app format
    const { error: messageError } = await supabase
      .from('messages')
      .insert({
        chat_id: selectedChatId,
        sender_id: currentUser.id,
        text: messageText,
        media_path: publicUrl,
        media_type: isImage ? 'image' : 'file',
        status: 'sent',
        created_at: new Date().toISOString()
      });

    if (messageError) {
      console.error('❌ Error sending message with file:', messageError);
      alert('File uploaded but failed to send message: ' + messageError.message);
      // Reset button
      const resetButton = document.querySelector('button[title="Attach File"]');
      if (resetButton) {
        resetButton.disabled = false;
        resetButton.style.opacity = '1';
        resetButton.innerHTML = 'Attach';
      }
      event.target.value = '';
      return;
    }

    console.log('✅ Message with file sent successfully');

    // Clear input
    event.target.value = '';

    // Reset button
    if (originalButton) {
      originalButton.disabled = false;
      originalButton.style.opacity = '1';
      originalButton.innerHTML = 'Attach';
    }

    // Reload messages
    await loadChatMessages(selectedChatId);

    // Re-render to show new message
    renderPMTool();

    // Scroll to bottom after a short delay
    setTimeout(() => {
      const messagesContainer = document.getElementById('chat-messages-container');
      if (messagesContainer) {
        messagesContainer.scrollTop = messagesContainer.scrollHeight;
      }
    }, 100);
  } catch (error) {
    console.error('❌ Error uploading file:', error);
    alert('An unexpected error occurred while uploading the file: ' + error.message);
    // Reset button
    const resetButton = document.querySelector('button[title="Attach File"]');
    if (resetButton) {
      resetButton.disabled = false;
      resetButton.style.opacity = '1';
      resetButton.innerHTML = '📎';
    }
    event.target.value = '';
  }
};

// Send a message
window.sendChatMessage = async function () {
  if (!selectedChatId || !currentUser) return;

  const messageInput = document.getElementById('chat-message-input');
  const messageText = messageInput?.value?.trim();

  if (!messageText) return;

  // Clear input immediately to allow fast typing of next message
  if (messageInput) {
    messageInput.value = '';
    messageInput.focus(); // Keep focus
  }

  try {
    const { error } = await supabase
      .from('messages')
      .insert({
        chat_id: selectedChatId,
        sender_id: currentUser.id,
        text: messageText,
        status: 'sent',
        created_at: new Date().toISOString()
      });

    if (error) {
      console.error('Error sending message:', error);
      alert('Failed to send message: ' + error.message);
      return;
    }

    // Reload messages
    await loadChatMessages(selectedChatId);

    // Optimistic update: Update message list DOM directly
    // This prevents the full renderPMTool() which destroys the input and kills focus/typing
    const messagesContainer = document.getElementById('chat-messages-container');
    if (messagesContainer && window.renderChatMessagesList) {
      messagesContainer.innerHTML = window.renderChatMessagesList(chatMessages);
      messagesContainer.scrollTop = messagesContainer.scrollHeight;
    } else {
      // Fallback
      renderPMTool();

      // Attempt to restore focus if fallback was used
      setTimeout(() => {
        const input = document.getElementById('chat-message-input');
        if (input) input.focus();
      }, 50);
    }

    // Ensure focus is still there
    if (messageInput) {
      messageInput.focus();
    }

  } catch (error) {
    console.error('Error sending message:', error);
    alert('An unexpected error occurred while sending the message');
  }
};

window.showAddOpportunityModal = async function () {
  // If no contact is selected, redirect to contacts view
  if (!selectedContactId) {
    salesView = 'contacts';
    renderPMTool();
    return;
  }

  if (companyEmployees === null) await loadCompanyEmployees();
  // Reset form data
  editingOpportunityId = null; // Not editing, creating new
  opportunityFormData = {
    title: '',
    stage: 'new',
    expected_close_date: '',
    amount: '',
    source: 'website',
    chance: 'medium',
    follow_up_date: '',
    follow_up_time: '',
    notes: '',
    archived: false,
    assigned_to: ''
  };
  window.selectedOpportunityAssignedTo = null;
  window.opportunityMemberSearchQuery = '';
  isOpportunityModalFromSales = false; // Not from sales page
  selectedOpportunityContactId = null;
  window.selectedOpportunityContactId = selectedOpportunityContactId;
  opportunityContactSearchQuery = '';
  window.opportunityContactSearchQuery = opportunityContactSearchQuery;
  showAddOpportunityModal = true;

  // Inject modal directly instead of re-rendering entire page
  const existingModal = document.getElementById('add-opportunity-modal');
  if (existingModal) {
    existingModal.remove();
  }

  const modalHTML = renderAddOpportunityModal();
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = modalHTML;
  const modalElement = tempDiv.firstElementChild;

  document.body.appendChild(modalElement);

  // Animate in
  setTimeout(() => {
    if (modalElement) {
      modalElement.style.opacity = '1';
    }
  }, 10);
}

window.showAddReminderModal = function () {
  // Reset form data
  reminderFormData = {
    title: '',
    description: '',
    priority: 'medium',
    type: 'follow_up',
    due_date: ''
  };
  window.reminderFormData = reminderFormData;
  isReminderModalFromCalendar = false; // Not from calendar
  selectedReminderContactId = null;
  window.selectedReminderContactId = selectedReminderContactId;
  reminderContactSearchQuery = '';
  window.reminderContactSearchQuery = reminderContactSearchQuery;
  showAddReminderModal = true;

  // Inject modal directly instead of re-rendering entire page
  const existingModal = document.getElementById('add-reminder-modal');
  if (existingModal) {
    existingModal.remove();
  }

  const modalHTML = renderAddReminderModal();
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = modalHTML;
  const modalElement = tempDiv.firstElementChild;

  document.body.appendChild(modalElement);

  // Animate in
  setTimeout(() => {
    if (modalElement) {
      modalElement.style.opacity = '1';
    }
  }, 10);
};

// Show reminder modal from calendar (with contact selector)
window.showAddReminderModalFromCalendar = function () {
  // Reset form data
  reminderFormData = {
    title: '',
    description: '',
    priority: 'medium',
    type: 'follow_up',
    due_date: ''
  };
  window.reminderFormData = reminderFormData;
  isReminderModalFromCalendar = true; // From calendar
  selectedReminderContactId = null;
  window.selectedReminderContactId = selectedReminderContactId;
  reminderContactSearchQuery = '';
  window.reminderContactSearchQuery = reminderContactSearchQuery;
  showAddReminderModal = true;

  // Inject modal directly instead of re-rendering entire page
  const existingModal = document.getElementById('add-reminder-modal');
  if (existingModal) {
    existingModal.remove();
  }

  const modalHTML = renderAddReminderModal();
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = modalHTML;
  const modalElement = tempDiv.firstElementChild;

  document.body.appendChild(modalElement);

  // Animate in
  setTimeout(() => {
    if (modalElement) {
      modalElement.style.opacity = '1';
    }
  }, 10);
};

// Show opportunity modal from sales page (with contact selector)
window.showAddOpportunityModalFromSubmission = function (contactId) {
  // Set contact ID
  selectedOpportunityContactId = contactId;
  window.selectedOpportunityContactId = contactId;
  opportunityContactSearchQuery = '';
  window.opportunityContactSearchQuery = '';

  // Use pre-populated data if available, otherwise reset
  if (!opportunityFormData || !opportunityFormData.title) {
    opportunityFormData = {
      title: '',
      stage: 'new',
      expected_close_date: '',
      amount: '',
      source: 'website',
      chance: 'medium',
      follow_up_date: '',
      follow_up_time: '',
      notes: '',
      archived: false,
      assigned_to: ''
    };
  }
  window.opportunityFormData = opportunityFormData;

  editingOpportunityId = null;
  window.selectedOpportunityAssignedTo = null;
  window.opportunityMemberSearchQuery = '';
  isOpportunityModalFromSales = false;
  showAddOpportunityModal = true;

  // Inject modal directly
  const existingModal = document.getElementById('add-opportunity-modal');
  if (existingModal) {
    existingModal.remove();
  }

  const modalHTML = renderAddOpportunityModal();
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = modalHTML;
  const modalElement = tempDiv.firstElementChild;

  document.body.appendChild(modalElement);

  // Animate in
  setTimeout(() => {
    if (modalElement) {
      modalElement.style.opacity = '1';
    }
  }, 10);
};

window.showAddOpportunityModalFromSales = function () {
  // Reset form data
  editingOpportunityId = null; // Not editing, creating new
  opportunityFormData = {
    title: '',
    stage: 'new',
    expected_close_date: '',
    amount: '',
    source: 'website',
    chance: 'medium',
    follow_up_date: '',
    follow_up_time: '',
    notes: '',
    archived: false,
    assigned_to: ''
  };
  window.selectedOpportunityAssignedTo = null;
  window.opportunityMemberSearchQuery = '';
  isOpportunityModalFromSales = true; // From sales page
  selectedOpportunityContactId = null;
  window.selectedOpportunityContactId = selectedOpportunityContactId;
  opportunityContactSearchQuery = '';
  window.opportunityContactSearchQuery = opportunityContactSearchQuery;
  showAddOpportunityModal = true;

  // Inject modal directly instead of re-rendering entire page
  const existingModal = document.getElementById('add-opportunity-modal');
  if (existingModal) {
    existingModal.remove();
  }

  const modalHTML = renderAddOpportunityModal();
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = modalHTML;
  const modalElement = tempDiv.firstElementChild;

  document.body.appendChild(modalElement);

  // Animate in
  setTimeout(() => {
    if (modalElement) {
      modalElement.style.opacity = '1';
    }
  }, 10);
};

// Toggle show all reminders
window.toggleShowAllReminders = function () {
  showAllReminders = !showAllReminders;
  // Re-render just the reminders tab if we have cached data
  if (currentScreen === 'sales' && selectedContactId && cachedContactData.contactId === selectedContactId) {
    const tabContentDiv = document.getElementById('contact-tab-content');
    if (tabContentDiv && contactDetailViewTab === 'reminders') {
      tabContentDiv.innerHTML = renderRemindersTab(cachedContactData.reminders);
      return;
    }
  }
  // Fallback
  if (currentScreen === 'sales' && selectedContactId) {
    updateContactDetailContent();
  } else {
    renderPMTool();
  }
};

window.showAddAppointmentModal = async function () {
  if (companyEmployees === null) await loadCompanyEmployees();
  // Reset form data
  appointmentFormData = {
    title: '',
    appointment_date: '',
    start_time: '',
    duration: '60',
    notes: '',
    assigned_to: ''
  };
  window.appointmentFormData = appointmentFormData;
  window.selectedAppointmentAssignedTo = null;
  window.appointmentMemberSearchQuery = '';
  isAppointmentModalFromCalendar = false; // Not from calendar
  selectedAppointmentContactId = null;
  window.selectedAppointmentContactId = selectedAppointmentContactId;
  appointmentContactSearchQuery = '';
  window.appointmentContactSearchQuery = appointmentContactSearchQuery;
  showAddAppointmentModal = true;

  // Inject modal directly instead of re-rendering entire page
  const existingModal = document.getElementById('add-appointment-modal');
  if (existingModal) {
    existingModal.remove();
  }

  const modalHTML = renderAddAppointmentModal();
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = modalHTML;
  const modalElement = tempDiv.firstElementChild;

  document.body.appendChild(modalElement);

  // Animate in
  setTimeout(() => {
    if (modalElement) {
      modalElement.style.opacity = '1';
    }
  }, 10);
};

// Show appointment modal from form submission (with pre-selected contact)
window.showAddAppointmentModalFromSubmission = async function (contactId) {
  if (companyEmployees === null) await loadCompanyEmployees();
  // Set contact ID
  selectedAppointmentContactId = contactId;
  window.selectedAppointmentContactId = contactId;
  appointmentContactSearchQuery = '';
  window.appointmentContactSearchQuery = '';

  // Use pre-populated data if available, otherwise reset
  if (!appointmentFormData || !appointmentFormData.title) {
    appointmentFormData = {
      title: '',
      appointment_date: '',
      start_time: '',
      duration: '60',
      notes: '',
      assigned_to: ''
    };
    window.selectedAppointmentAssignedTo = null;
    window.appointmentMemberSearchQuery = '';
  }
  window.appointmentFormData = appointmentFormData;

  isAppointmentModalFromCalendar = false;
  showAddAppointmentModal = true;

  // Inject modal directly
  const existingModal = document.getElementById('add-appointment-modal');
  if (existingModal) {
    existingModal.remove();
  }

  const modalHTML = renderAddAppointmentModal();
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = modalHTML;
  const modalElement = tempDiv.firstElementChild;

  document.body.appendChild(modalElement);

  // Animate in
  setTimeout(() => {
    if (modalElement) {
      modalElement.style.opacity = '1';
    }
  }, 10);
};

// Show appointment modal from calendar (with contact selector)
window.showAddAppointmentModalFromCalendar = async function () {
  if (companyEmployees === null) await loadCompanyEmployees();
  // Reset form data
  appointmentFormData = {
    title: '',
    appointment_date: '',
    start_time: '',
    duration: '60',
    notes: '',
    assigned_to: ''
  };
  window.appointmentFormData = appointmentFormData;
  window.selectedAppointmentAssignedTo = null;
  window.appointmentMemberSearchQuery = '';
  isAppointmentModalFromCalendar = true; // From calendar
  selectedAppointmentContactId = null;
  window.selectedAppointmentContactId = selectedAppointmentContactId;
  appointmentContactSearchQuery = '';
  window.appointmentContactSearchQuery = appointmentContactSearchQuery;
  showAddAppointmentModal = true;

  // Inject modal directly instead of re-rendering entire page
  const existingModal = document.getElementById('add-appointment-modal');
  if (existingModal) {
    existingModal.remove();
  }

  const modalHTML = renderAddAppointmentModal();
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = modalHTML;
  const modalElement = tempDiv.firstElementChild;

  document.body.appendChild(modalElement);

  // Animate in
  setTimeout(() => {
    if (modalElement) {
      modalElement.style.opacity = '1';
    }
  }, 10);
};

// Toggle show all appointments
window.toggleShowAllAppointments = function () {
  showAllAppointments = !showAllAppointments;
  // Re-render just the appointments tab if we have cached data
  if (currentScreen === 'sales' && selectedContactId && cachedContactData.contactId === selectedContactId) {
    const tabContentDiv = document.getElementById('contact-tab-content');
    if (tabContentDiv && contactDetailViewTab === 'appointments') {
      tabContentDiv.innerHTML = renderAppointmentsTab(cachedContactData.appointments);
      return;
    }
  }
  // Fallback
  if (currentScreen === 'sales' && selectedContactId) {
    updateContactDetailContent();
  } else {
    renderPMTool();
  }
};

// Load reminders. viewMode: 'team' = all company, 'personal' = only current user (default).
async function loadReminders(startDate = null, endDate = null, viewMode = 'personal') {
  if (!currentCompany || !currentUser) return;

  let query = supabase
    .from('reminders')
    .select(`
      id,
      title,
      description,
      due_at,
      priority,
      type,
      contact_id,
      assigned_to,
      status,
      contact:contacts (
        first_name,
        last_name
      )
    `)
    .eq('company_id', currentCompany.id);

  if (viewMode === 'personal') {
    query = query.eq('assigned_to', currentUser.id);
  }

  // If date range provided, filter by it (for calendar efficiency)
  if (startDate && endDate) {
    query = query
      .gte('due_at', startDate.toISOString())
      .lte('due_at', endDate.toISOString());
  } else {
    // Default behavior for other views: limit to 5 upcoming
    query = query
      .gte('due_at', new Date().toISOString())
      .limit(5);
  }

  // Order by date
  query = query.order('due_at', { ascending: true });

  const { data: remindersData, error } = await query;

  if (error) {
    console.error('Error loading reminders:', error);
  }
  reminders = remindersData || [];
  console.log('⏰ Reminders loaded:', reminders.length);
}

// Load weekly champions
async function loadWeeklyChampions() {
  if (!currentCompany) return;

  try {
    const now = new Date();
    const startOfWeek = new Date(now);
    const day = now.getDay();
    const diff = now.getDate() - day + (day === 0 ? -6 : 1); // Monday
    startOfWeek.setDate(diff);
    startOfWeek.setHours(0, 0, 0, 0);

    const endOfWeek = new Date(startOfWeek);
    endOfWeek.setDate(startOfWeek.getDate() + 6);
    endOfWeek.setHours(23, 59, 59, 999);

    const { data, error } = await supabase
      .from('sales_opportunities')
      .select(`
        assigned_to,
        amount,
        closed_at,
        profiles!inner(
          id,
          first_name,
          last_name,
          avatar_path
        )
      `)
      .eq('company_id', currentCompany.id)
      .eq('stage', 'won')
      .not('closed_at', 'is', null)
      .gte('closed_at', startOfWeek.toISOString())
      .lte('closed_at', endOfWeek.toISOString());

    if (error) {
      console.error('Error loading weekly champions:', error);
      return;
    }

    const userTotals = new Map();

    data?.forEach(opportunity => {
      const userId = opportunity.assigned_to;
      const amount = parseFloat(opportunity.amount) || 0;

      if (userTotals.has(userId)) {
        const existing = userTotals.get(userId);
        existing.total += amount;
        existing.count += 1;
      } else {
        userTotals.set(userId, {
          total: amount,
          count: 1,
          profile: opportunity.profiles
        });
      }
    });

    weeklyChampions = Array.from(userTotals.values())
      .map((data, index) => ({
        ...data.profile,
        total_amount: data.total,
        deals_count: data.count,
        rank: index + 1
      }))
      .sort((a, b) => b.total_amount - a.total_amount)
      .slice(0, 3);

    console.log('🏆 Weekly champions loaded:', weeklyChampions.length);
  } catch (error) {
    console.error('Error loading weekly champions:', error);
  }
}

// Load resources
async function loadResources() {
  const { data: resourcesData } = await supabase
    .from('resources')
    .select('*')
    .is('company_id', null)
    .order('created_at', { ascending: false });

  resources = resourcesData || [];
}

// Load portfolio items
async function loadPortfolioItems() {
  try {
    // Load global portfolio items (company_id IS NULL) and company-specific items
    const { data: portfolioData, error } = await supabase
      .from('portfolio_items')
      .select('*')
      .or(`company_id.is.null,company_id.eq.${currentCompany?.id || ''}`)
      .order('created_at', { ascending: false });

    if (error) {
      console.error('Error loading portfolio items:', error);
      portfolioItems = [];
    } else {
      portfolioItems = portfolioData || [];
    }
  } catch (error) {
    console.error('Error loading portfolio items:', error);
    portfolioItems = [];
  }
}

// Load services
async function loadServices() {
  if (!currentCompany) return;

  const { data: servicesData, error } = await supabase
    .from('services')
    .select('*')
    .eq('company_id', currentCompany.id)
    .order('name', { ascending: true });

  if (error) {
    console.error('Error loading services:', error);
  }
  services = servicesData || [];
}

// Load clients
async function loadClients() {
  if (!currentCompany) {
    console.log('⚠️ [loadClients] No current company');
    return;
  }

  console.log('🔄 [loadClients] Loading clients for company:', currentCompany.id);

  const { data: clientsData, error } = await supabase
    .from('company_members')
    .select(`
      user_id,
      company_id,
      role,
      profiles!company_members_user_id_fkey (
        id,
        first_name,
        last_name
      )
    `)
    .eq('company_id', currentCompany.id)
    .eq('role', 'CLIENT')
    .order('profiles(first_name)', { ascending: true });

  if (error) {
    console.error('❌ [loadClients] Error loading clients:', error);
    clients = [];
  } else {
    clients = (clientsData || [])
      .filter(item => item.profiles)
      .map(item => ({
        id: item.profiles.id,
        first_name: item.profiles.first_name,
        last_name: item.profiles.last_name,
      }));

    console.log('✅ [loadClients] Loaded', clients.length, 'clients');
    console.log('✅ [loadClients] Client profile IDs:', clients.map(c => c.id));
  }
}

// Filter tasks based on current filters
function getFilteredTasks() {
  // Ensure tasks is initialized
  if (!tasks || !Array.isArray(tasks)) {
    tasks = [];
  }

  let filtered = tasks;

  // Always filter by company first
  filtered = filtered.filter(task => task.company_id === currentCompany.id);

  // Filter by team tab (personal vs team)
  if (teamTab === 'personal') {
    filtered = filtered.filter(task =>
      task.assigned_members?.some(member => member.id === currentUser.id)
    );
  }

  // Filter by search query
  if (searchQuery && searchQuery.trim()) {
    const query = searchQuery.toLowerCase();
    filtered = filtered.filter(task =>
      task.title.toLowerCase().includes(query) ||
      (task.description && task.description.toLowerCase().includes(query))
    );
  }

  // Filter by status (default: show BACKLOG and ACTIVE, hide COMPLETED)
  if (taskFilters.status.length > 0) {
    filtered = filtered.filter(task => taskFilters.status.includes(task.state));
  }

  // Filter by priority
  if (taskFilters.priority.length > 0) {
    filtered = filtered.filter(task => taskFilters.priority.includes(task.priority));
  }

  return filtered;
}

// Get paginated tasks for a specific column
function getPaginatedTasks(tasks, column) {
  const startIndex = currentPage[column] * tasksPerPage;
  const endIndex = startIndex + tasksPerPage;
  return tasks.slice(startIndex, endIndex);
}

// Render pagination controls
function renderPagination(column, totalTasks) {
  const totalPages = Math.ceil(totalTasks / tasksPerPage);
  console.log(`📊 Rendering pagination for ${column}: ${totalTasks} tasks, ${totalPages} pages, current page: ${currentPage[column]}`);

  if (totalPages <= 1) {
    console.log(`📊 No pagination needed for ${column} (${totalTasks} tasks)`);
    return '';
  }

  const prevDisabled = currentPage[column] === 0;
  const nextDisabled = currentPage[column] >= totalPages - 1;

  return `
    <div 
      onclick="event.stopPropagation()"
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.5rem;
        margin-top: 1rem;
        padding-top: 1rem;
        border-top: 1px solid ${colors.border};
        position: relative;
        z-index: 10;
      "
    >
      <button
        onclick="event.stopPropagation(); console.log('🔄 Previous button clicked for ${column}'); window.changePage('${column}', ${currentPage[column] - 1}); return false;"
        ${prevDisabled ? 'disabled' : ''}
        style="
          background: ${prevDisabled ? colors.background : colors.primary};
          color: ${prevDisabled ? colors.textSecondary : 'white'};
          border: none;
          padding: 0.5rem 0.75rem;
          border-radius: 0.25rem;
          cursor: ${prevDisabled ? 'not-allowed' : 'pointer'};
          font-size: 0.875rem;
          font-weight: 600;
          pointer-events: ${prevDisabled ? 'none' : 'auto'};
          opacity: ${prevDisabled ? '0.5' : '1'};
          transition: all 0.2s;
        "
        onmouseover="${prevDisabled ? '' : "this.style.background='#d97706'; this.style.transform='scale(1.05)'"}"
        onmouseout="${prevDisabled ? '' : "this.style.background='" + colors.primary + "'; this.style.transform='scale(1)'"}"
      >
        ←
      </button>
      <span style="
        color: ${colors.textSecondary};
        font-size: 0.875rem;
        padding: 0 0.5rem;
        font-weight: 500;
      ">
        ${currentPage[column] + 1} of ${totalPages}
      </span>
      <button
        onclick="event.stopPropagation(); console.log('🔄 Next button clicked for ${column}'); window.changePage('${column}', ${currentPage[column] + 1}); return false;"
        ${nextDisabled ? 'disabled' : ''}
        style="
          background: ${nextDisabled ? colors.background : colors.primary};
          color: ${nextDisabled ? colors.textSecondary : 'white'};
          border: none;
          padding: 0.5rem 0.75rem;
          border-radius: 0.25rem;
          cursor: ${nextDisabled ? 'not-allowed' : 'pointer'};
          font-size: 0.875rem;
          font-weight: 600;
          pointer-events: ${nextDisabled ? 'none' : 'auto'};
          opacity: ${nextDisabled ? '0.5' : '1'};
          transition: all 0.2s;
        "
        onmouseover="${nextDisabled ? '' : "this.style.background='#d97706'; this.style.transform='scale(1.05)'"}"
        onmouseout="${nextDisabled ? '' : "this.style.background='" + colors.primary + "'; this.style.transform='scale(1)'"}"
      >
        →
      </button>
    </div>
  `;
}

// Change page for a specific column
window.changePage = function (column, newPage) {
  console.log(`🔄 Changing page for ${column} to ${newPage}`);
  console.log(`🔄 Current page state:`, currentPage);

  try {
    const filteredTasks = getFilteredTasks();
    let columnTasks = filteredTasks.filter(task => {
      if (column === 'backlog') return task.state === 'BACKLOG';
      if (column === 'active') return task.state === 'ACTIVE';
      if (column === 'completed') return task.state === 'COMPLETED';
      return false;
    });

    // Sort completed tasks by most recent first (descending)
    if (column === 'completed') {
      columnTasks = columnTasks.sort((a, b) => {
        const aDate = new Date(a.updated_at || a.created_at || 0);
        const bDate = new Date(b.updated_at || b.created_at || 0);
        return bDate - aDate; // Most recent first
      });
    }

    const totalPages = Math.ceil(columnTasks.length / tasksPerPage);

    console.log(`📊 ${column}: ${columnTasks.length} tasks, ${totalPages} pages`);
    console.log(`📊 Current page for ${column}: ${currentPage[column]}`);
    console.log(`📊 Requested page: ${newPage}, valid range: 0-${totalPages - 1}`);

    if (newPage >= 0 && newPage < totalPages) {
      currentPage[column] = newPage;
      console.log(`✅ Updated ${column} page to ${newPage}`);
      console.log(`✅ New page state:`, currentPage);
      renderPMTool();
    } else {
      console.log(`❌ Invalid page ${newPage} for ${column} (max: ${totalPages - 1})`);
      alert(`Invalid page. Please select a page between 1 and ${totalPages}.`);
    }
  } catch (error) {
    console.error(`❌ Error in changePage for ${column}:`, error);
    alert('An error occurred while changing pages. Please try again.');
  }
};

// Handle logout
window.handleLogout = async function () {
  await supabase.auth.signOut();
  renderLogin();
};

// Show delete account modal
window.showDeleteAccountModal = function () {
  // Remove existing modal if present
  const existingModal = document.getElementById('delete-account-modal-overlay');
  if (existingModal) {
    existingModal.remove();
  }

  const modalHTML = `
    <div id="delete-account-modal-overlay" style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.6);
      z-index: 10000;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem;
    " onclick="if (event.target.id === 'delete-account-modal-overlay') closeDeleteAccountModal()">
      <div id="delete-account-modal" style="
        background: #ffffff;
        border-radius: 1rem;
        width: 100%;
        max-width: 500px;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
        overflow: hidden;
      " onclick="event.stopPropagation()">
        <!-- Header -->
        <div style="
          padding: 1.5rem;
          border-bottom: 1px solid #e9ecef;
          background: linear-gradient(135deg, #fee2e2 0%, #fef2f2 100%);
        ">
          <div style="
            display: flex;
            align-items: center;
            gap: 1rem;
            margin-bottom: 0.5rem;
          ">
            <div style="
              width: 48px;
              height: 48px;
              background: #dc2626;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 1.5rem;
              flex-shrink: 0;
            ">
              ⚠️
            </div>
            <div>
              <h2 style="
                margin: 0;
                font-size: 1.5rem;
                font-weight: 700;
                color: #991b1b;
              ">Delete Account</h2>
              <p style="
                margin: 0.25rem 0 0 0;
                font-size: 0.875rem;
                color: #7f1d1d;
              ">This action cannot be undone</p>
            </div>
          </div>
        </div>
        
        <!-- Content -->
        <div style="padding: 1.5rem;">
          <div style="
            background: #fef2f2;
            border: 1px solid #fecaca;
            border-radius: 0.5rem;
            padding: 1rem;
            margin-bottom: 1.5rem;
          ">
            <div style="
              display: flex;
              align-items: start;
              gap: 0.75rem;
            ">
              <div style="
                font-size: 1.25rem;
                flex-shrink: 0;
                margin-top: 0.125rem;
              ">🚨</div>
              <div>
                <div style="
                  font-weight: 600;
                  color: #991b1b;
                  margin-bottom: 0.5rem;
                  font-size: 0.9375rem;
                ">Warning: Permanent Account Deletion</div>
                <div style="
                  color: #7f1d1d;
                  font-size: 0.875rem;
                  line-height: 1.5;
                ">
                  Deleting your account will permanently remove all your data including:
                  <ul style="
                    margin: 0.5rem 0 0 1.25rem;
                    padding: 0;
                    color: #7f1d1d;
                  ">
                    <li>Your profile and personal information</li>
                    <li>All your tasks, projects, and contacts</li>
                    <li>Your chat history and messages</li>
                    <li>All other associated data</li>
                  </ul>
                  <div style="margin-top: 0.75rem; font-weight: 600;">
                    This action cannot be undone.
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Confirmation Input -->
          <div style="margin-bottom: 1.5rem;">
            <label style="
              display: block;
              font-weight: 600;
              color: #2c3e50;
              margin-bottom: 0.5rem;
              font-size: 0.9375rem;
            ">
              To confirm, type <span style="color: #dc2626; font-family: monospace; font-weight: 700;">Delete</span> below:
            </label>
            <input
              type="text"
              id="delete-account-confirm-input"
              placeholder="Type 'Delete' to confirm"
              style="
                width: 100%;
                padding: 0.75rem;
                border: 2px solid #e9ecef;
                border-radius: 0.5rem;
                font-size: 0.9375rem;
                box-sizing: border-box;
                transition: border-color 0.2s;
                font-family: inherit;
              "
              oninput="
                const input = this;
                const confirmBtn = document.getElementById('confirm-delete-account-btn');
                if (input.value.trim() === 'Delete') {
                  input.style.borderColor = '#dc2626';
                  if (confirmBtn) confirmBtn.disabled = false;
                } else {
                  input.style.borderColor = '#e9ecef';
                  if (confirmBtn) confirmBtn.disabled = true;
                }
              "
            />
          </div>
          
          <!-- Actions -->
          <div style="
            display: flex;
            gap: 0.75rem;
            justify-content: flex-end;
          ">
            <button
              onclick="closeDeleteAccountModal()"
              style="
                background: #f3f4f6;
                color: #2c3e50;
                border: none;
                padding: 0.75rem 1.5rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-weight: 600;
                font-size: 0.9375rem;
                transition: background-color 0.2s;
              "
              onmouseover="this.style.background='#e5e7eb'"
              onmouseout="this.style.background='#f3f4f6'"
            >
              Cancel
            </button>
            <button
              id="confirm-delete-account-btn"
              onclick="confirmDeleteAccount()"
              disabled
              style="
                background: #dc2626;
                color: white;
                border: none;
                padding: 0.75rem 1.5rem;
                border-radius: 0.5rem;
                cursor: not-allowed;
                font-weight: 600;
                font-size: 0.9375rem;
                transition: all 0.2s;
                opacity: 0.5;
              "
            >
              Delete My Account
            </button>
          </div>
        </div>
      </div>
    </div>
  `;

  document.body.insertAdjacentHTML('beforeend', modalHTML);

  // Focus on input after a short delay
  setTimeout(() => {
    const input = document.getElementById('delete-account-confirm-input');
    if (input) {
      input.focus();
    }
  }, 100);
};

// Close delete account modal
window.closeDeleteAccountModal = function () {
  const modal = document.getElementById('delete-account-modal-overlay');
  if (modal) {
    modal.remove();
  }
};

// Confirm and delete account
window.confirmDeleteAccount = async function () {
  const confirmInput = document.getElementById('delete-account-confirm-input');
  const confirmBtn = document.getElementById('confirm-delete-account-btn');

  if (!confirmInput || confirmInput.value.trim() !== 'Delete') {
    alert('Please type "Delete" exactly to confirm');
    return;
  }

  // Disable button to prevent double-clicking
  if (confirmBtn) {
    confirmBtn.disabled = true;
    confirmBtn.textContent = 'Deleting...';
    confirmBtn.style.opacity = '0.5';
  }

  try {
    const userId = currentUser?.id || currentProfile?.id;
    if (!userId) {
      alert('Unable to identify user. Please try logging out and back in.');
      if (confirmBtn) {
        confirmBtn.disabled = false;
        confirmBtn.textContent = 'Delete My Account';
      }
      return;
    }

    console.log('🗑️ Deleting account for user:', userId);

    // Delete user's profile and related data
    // Note: In Supabase, deleting the auth user will cascade delete related data
    // But we should also clean up any remaining references

    // First, sign out to invalidate the session
    await supabase.auth.signOut();

    // Delete the auth user (this will cascade delete related data)
    // Note: This requires admin privileges or a server-side function
    // For now, we'll delete what we can and sign them out

    // Try to delete profile if possible
    try {
      const { error: profileError } = await supabase
        .from('profiles')
        .delete()
        .eq('id', userId);

      if (profileError) {
        console.warn('Could not delete profile (may require admin):', profileError);
      }
    } catch (error) {
      console.warn('Error deleting profile:', error);
    }

    // Show success message
    alert('Your account has been deleted. You will now be redirected to the login screen.');

    // Close modal
    closeDeleteAccountModal();

    // Clear all local state
    currentUser = null;
    currentProfile = null;
    currentCompany = null;
    chats = [];
    contacts = [];
    tasks = [];

    // Render login screen
    renderLogin();

  } catch (error) {
    console.error('Error deleting account:', error);
    alert('Failed to delete account. Please contact support if this issue persists.');

    // Re-enable button
    if (confirmBtn) {
      confirmBtn.disabled = false;
      confirmBtn.textContent = 'Delete My Account';
      confirmBtn.style.opacity = '1';
    }
  }
};

// Show edit profile modal
window.showEditProfileModal = function () {
  // Remove existing modal if present
  const existingModal = document.getElementById('edit-profile-modal-overlay');
  if (existingModal) {
    existingModal.remove();
  }

  const firstName = currentProfile?.first_name || currentUser?.first_name || '';
  const lastName = currentProfile?.last_name || currentUser?.last_name || '';
  const email = currentUser?.email || '';
  const avatarPath = currentProfile?.avatar_path || currentUser?.avatar_path || '';
  const avatarUrl = avatarPath ? getAvatarUrl(avatarPath) : null;
  const userInitials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase() || 'U';

  const modalHTML = `
    <div id="edit-profile-modal-overlay" style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.6);
      z-index: 10000;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem;
    " onclick="if (event.target.id === 'edit-profile-modal-overlay') closeEditProfileModal()">
      <div id="edit-profile-modal" style="
        background: #ffffff;
        border-radius: 1rem;
        width: 100%;
        max-width: 500px;
        max-height: 90vh;
        overflow-y: auto;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
      " onclick="event.stopPropagation()">
        <!-- Header -->
        <div style="
          padding: 1.5rem;
          border-bottom: 1px solid #e9ecef;
          display: flex;
          justify-content: space-between;
          align-items: center;
        ">
          <h2 style="
            margin: 0;
            font-size: 1.5rem;
            font-weight: 700;
            color: #2c3e50;
          ">Edit Profile</h2>
          <button
            onclick="closeEditProfileModal()"
            style="
              background: transparent;
              border: none;
              color: #6c757d;
              cursor: pointer;
              font-size: 1.5rem;
              padding: 0;
              width: 32px;
              height: 32px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 50%;
              transition: background-color 0.2s;
            "
            onmouseover="this.style.background='#f3f4f6'"
            onmouseout="this.style.background='transparent'"
          >
            ×
          </button>
        </div>
        
        <!-- Content -->
        <div style="padding: 1.5rem;">
          <!-- Avatar Section -->
          <div style="
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 2rem;
          ">
            <div style="
              width: 6rem;
              height: 6rem;
              border-radius: 50%;
              flex-shrink: 0;
              position: relative;
              overflow: hidden;
              background: #f59e0b;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-bottom: 1rem;
              border: 3px solid #f59e0b;
            ">
              ${avatarUrl ? `
                <img
                  id="profile-avatar-preview"
                  src="${avatarUrl}"
                  alt="Profile"
                  style="
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    border-radius: 50%;
                  "
                />
              ` : `
                <div style="
                  width: 100%;
                  height: 100%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  color: white;
                  font-size: 2rem;
                  font-weight: 600;
                ">${userInitials}</div>
              `}
            </div>
            <label
              for="profile-avatar-upload"
              style="
                background: #f59e0b;
                color: white;
                border: none;
                padding: 0.5rem 1rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-weight: 600;
                font-size: 0.875rem;
                transition: background-color 0.2s;
                display: inline-block;
              "
              onmouseover="this.style.background='#d97706'"
              onmouseout="this.style.background='#f59e0b'"
            >
              Change Photo
            </label>
            <input
              type="file"
              id="profile-avatar-upload"
              accept="image/*"
              style="display: none;"
              onchange="handleAvatarUpload(event)"
            />
          </div>
          
          <!-- Form Fields -->
          <div style="display: flex; flex-direction: column; gap: 1rem;">
            <!-- First Name -->
            <div>
              <label style="
                display: block;
                font-weight: 600;
                color: #2c3e50;
                margin-bottom: 0.5rem;
                font-size: 0.9375rem;
              ">First Name</label>
              <input
                type="text"
                id="profile-first-name"
                value="${firstName}"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e9ecef;
                  border-radius: 0.5rem;
                  font-size: 0.9375rem;
                  box-sizing: border-box;
                "
              />
            </div>
            
            <!-- Last Name -->
            <div>
              <label style="
                display: block;
                font-weight: 600;
                color: #2c3e50;
                margin-bottom: 0.5rem;
                font-size: 0.9375rem;
              ">Last Name</label>
              <input
                type="text"
                id="profile-last-name"
                value="${lastName}"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e9ecef;
                  border-radius: 0.5rem;
                  font-size: 0.9375rem;
                  box-sizing: border-box;
                "
              />
            </div>
            
            <!-- Email (read-only) -->
            <div>
              <label style="
                display: block;
                font-weight: 600;
                color: #2c3e50;
                margin-bottom: 0.5rem;
                font-size: 0.9375rem;
              ">Email</label>
              <input
                type="email"
                id="profile-email"
                value="${email}"
                disabled
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e9ecef;
                  border-radius: 0.5rem;
                  font-size: 0.9375rem;
                  box-sizing: border-box;
                  background: #f3f4f6;
                  color: #6c757d;
                "
              />
              <p style="
                margin: 0.25rem 0 0 0;
                font-size: 0.75rem;
                color: #6c757d;
              ">Email cannot be changed</p>
            </div>
          </div>
          
          <!-- Actions -->
          <div style="
            display: flex;
            gap: 0.75rem;
            justify-content: flex-end;
            margin-top: 2rem;
            padding-top: 1.5rem;
            border-top: 1px solid #e9ecef;
          ">
            <button
              onclick="closeEditProfileModal()"
              style="
                background: #f3f4f6;
                color: #2c3e50;
                border: none;
                padding: 0.75rem 1.5rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-weight: 600;
                font-size: 0.9375rem;
                transition: background-color 0.2s;
              "
              onmouseover="this.style.background='#e5e7eb'"
              onmouseout="this.style.background='#f3f4f6'"
            >
              Cancel
            </button>
            <button
              onclick="saveProfileChanges()"
              style="
                background: #f59e0b;
                color: white;
                border: none;
                padding: 0.75rem 1.5rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-weight: 600;
                font-size: 0.9375rem;
                transition: background-color 0.2s;
              "
              onmouseover="this.style.background='#d97706'"
              onmouseout="this.style.background='#f59e0b'"
            >
              Save Changes
            </button>
          </div>
        </div>
      </div>
    </div>
  `;

  document.body.insertAdjacentHTML('beforeend', modalHTML);
};

// Close edit profile modal
window.closeEditProfileModal = function () {
  const modal = document.getElementById('edit-profile-modal-overlay');
  if (modal) {
    modal.remove();
  }
};

// Handle avatar upload
window.handleAvatarUpload = async function (event) {
  const file = event.target.files[0];
  if (!file) return;

  // Validate file type
  if (!file.type.startsWith('image/')) {
    alert('Please select an image file');
    return;
  }

  // Validate file size (max 5MB)
  if (file.size > 5 * 1024 * 1024) {
    alert('Image size must be less than 5MB');
    return;
  }

  try {
    const userId = currentUser?.id || currentProfile?.id;
    if (!userId) {
      alert('Unable to identify user');
      return;
    }

    // Show loading state
    const previewImg = document.getElementById('profile-avatar-preview');
    if (previewImg) {
      previewImg.style.opacity = '0.5';
    }

    // Generate unique filename
    const fileExt = file.name.split('.').pop();
    const fileName = userId + '-' + Date.now() + '.' + fileExt;
    const filePath = userId + '/' + fileName;

    // Upload to Supabase Storage
    const { data: uploadData, error: uploadError } = await supabase.storage
      .from('profile-photos')
      .upload(filePath, file, {
        cacheControl: '3600',
        upsert: true
      });

    if (uploadError) {
      console.error('Error uploading avatar:', uploadError);
      alert('Failed to upload image. Please try again.');
      if (previewImg) {
        previewImg.style.opacity = '1';
      }
      return;
    }

    // Update profile with new avatar path
    const { error: updateError } = await supabase
      .from('profiles')
      .update({ avatar_path: filePath })
      .eq('id', userId);

    if (updateError) {
      console.error('Error updating profile:', updateError);
      alert('Failed to update profile. Please try again.');
      if (previewImg) {
        previewImg.style.opacity = '1';
      }
      return;
    }

    // Update local state
    if (currentProfile) {
      currentProfile.avatar_path = filePath;
    }

    // Update preview
    const newAvatarUrl = getAvatarUrl(filePath);
    if (previewImg && newAvatarUrl) {
      previewImg.src = newAvatarUrl;
      previewImg.style.opacity = '1';
    } else {
      // Create preview if it doesn't exist
      const avatarContainer = previewImg?.parentElement;
      if (avatarContainer && newAvatarUrl) {
        const img = document.createElement('img');
        img.id = 'profile-avatar-preview';
        img.src = newAvatarUrl;
        img.alt = 'Profile';
        img.style.cssText = 'width: 100%; height: 100%; object-fit: cover; border-radius: 50%;';
        avatarContainer.innerHTML = '';
        avatarContainer.appendChild(img);
      }
    }

    // Show success notification
    window.showNotification('Photo added', 'success');

    // Refresh profile screen
    renderPMTool();

  } catch (error) {
    console.error('Error handling avatar upload:', error);
    alert('An error occurred while uploading the image');
  }
};

// Save profile changes
window.saveProfileChanges = async function () {
  const firstNameInput = document.getElementById('profile-first-name');
  const lastNameInput = document.getElementById('profile-last-name');

  if (!firstNameInput || !lastNameInput) {
    alert('Unable to find form fields');
    return;
  }

  const firstName = firstNameInput.value.trim();
  const lastName = lastNameInput.value.trim();

  if (!firstName) {
    alert('First name is required');
    firstNameInput.focus();
    return;
  }

  try {
    const userId = currentUser?.id || currentProfile?.id;
    if (!userId) {
      alert('Unable to identify user');
      return;
    }

    // Update profile
    const { error: updateError } = await supabase
      .from('profiles')
      .update({
        first_name: firstName,
        last_name: lastName
      })
      .eq('id', userId);

    if (updateError) {
      console.error('Error updating profile:', updateError);
      alert('Failed to update profile: ' + updateError.message);
      return;
    }

    // Update local state
    if (currentProfile) {
      currentProfile.first_name = firstName;
      currentProfile.last_name = lastName;
    }

    // Show success message
    alert('Profile updated successfully!');

    // Close modal
    closeEditProfileModal();

    // Refresh profile screen
    renderPMTool();

  } catch (error) {
    console.error('Error saving profile changes:', error);
    alert('An error occurred while saving changes');
  }
};

// Change task status with live update
window.changeTaskStatus = async function (taskId, newStatus) {
  console.log(`🔄 Changing task ${taskId} status to ${newStatus}`);

  try {
    // Update task status in database
    const { data, error } = await supabase
      .from('tasks')
      .update({
        state: newStatus,
        updated_at: new Date().toISOString()
      })
      .eq('id', taskId);

    if (error) {
      console.error('Error updating task status:', error);

      // Check if it's an RLS error related to activity_feed
      if (error.message && (error.message.includes('activity') || error.message.includes('row-level security'))) {
        alert('Failed to update task status due to database permissions. The activity feed table needs proper RLS policies. Please contact your administrator.');
      } else {
        alert('Failed to update task status: ' + error.message);
      }
      return;
    }

    console.log(`✅ Task ${taskId} status updated to ${newStatus}`);

    // Update local task data
    const taskIndex = tasks.findIndex(task => task.id === taskId);
    if (taskIndex !== -1) {
      tasks[taskIndex].state = newStatus;

      // If task was completed and has a contact_id, create activity log entry
      const task = tasks[taskIndex];
      if (newStatus === 'COMPLETED' && task.contact_id) {
        console.log(`🎯 [Task Completion via changeTaskStatus] Creating activity log for task ${taskId}`);
        console.log(`🎯 [Task Data]:`, task);
        await createActivityLogEntry(
          task.contact_id,
          'task_completed',
          `Completed task: ${task.title || 'Untitled Task'}`,
          task.description || null,
          { task_id: task.id }
        );

        // If we're viewing a contact detail, refresh the contact view to update activity log
        if (currentScreen === 'sales' && selectedContactId && task.contact_id === selectedContactId) {
          console.log(`🔄 [Task Completion] Refreshing contact detail view for contact ${selectedContactId}`);
          await updateContactDetailContent();
          return; // Don't render PM tool if we refreshed contact detail
        }
      }
    }

    // Re-render the PM tool to show live updates
    renderPMTool();

  } catch (error) {
    console.error('Error changing task status:', error);
    alert('Failed to change task status: ' + error.message);
  }
};


// Switch team tab
window.switchTeamTab = function (tab) {
  teamTab = tab;
  window.teamTab = tab; // Sync with window for inline event handlers
  // Reset pagination when switching tabs
  currentPage = { backlog: 0, active: 0, completed: 0 };
  renderPMTool();
};

// Refresh PM tool tasks
window.refreshPMTool = async function () {
  await loadTasks();
  renderPMTool();
};

// Open task modal with pre-selected contact
window.openTaskModalForContact = async function (contactId, projectId = null) {
  console.log('🎯 Opening task modal for contact:', contactId, 'project:', projectId);

  // Pre-select the contact - use window variables that submitTask expects
  window.selectedTaskContact = contactId;
  window.preselectedTaskContactId = contactId;

  // Pre-select the project if provided
  if (projectId) {
    window.selectedTaskProject = projectId;
    window.preselectedTaskProjectId = projectId;
  } else {
    window.selectedTaskProject = '';
    window.preselectedTaskProjectId = null;
  }

  // Also set legacy variables for compatibility
  selectedContact = contactId;
  if (projectId) {
    selectedProject = projectId;
  } else {
    selectedProject = null;
  }

  // Clear editing state to ensure we're creating a new task
  editingTask = null;
  window.editingTaskData = null;

  // Reset other states but preserve contact/project
  showProjectCreation = false;
  selectedMembers = [];
  window.selectedTaskMembers = [];
  selectedClients = [];
  selectedService = '';
  window.selectedTaskService = '';
  customServiceName = '';
  window.customTaskServiceName = '';
  taskPriority = 'MEDIUM';
  window.taskPriority = 'MEDIUM';
  taskStatus = 'BACKLOG';
  window.taskStatus = 'BACKLOG';

  // Open the modal using the standard flow
  showAddTaskForm = true;

  // Insert modal directly without full page re-render for performance
  const existingModal = document.getElementById('add-task-modal');
  if (!existingModal) {
    const modalHTML = renderAddTaskModal();
    document.body.insertAdjacentHTML('beforeend', modalHTML);
  }

  console.log('✅ Task modal opened with pre-selected values');
  console.log('📍 Pre-selected contact:', window.selectedTaskContact);
  console.log('📍 Pre-selected project:', window.selectedTaskProject);

  // Display the selected contact and project after a short delay to ensure DOM is ready
  setTimeout(() => {
    // Set selectedContact for compatibility with updateSelectedContactDisplay
    if (window.selectedTaskContact) {
      selectedContact = window.selectedTaskContact;
    }

    updateSelectedContactDisplay();

    if (projectId) {
      // Display the pre-selected project
      fetchAndDisplaySelectedProject(projectId);
    } else if (window.selectedTaskProject) {
      // Also check window.selectedTaskProject
      fetchAndDisplaySelectedProject(window.selectedTaskProject);
    } else {
      // Load the project list for the selected contact using the fixed function
      initializeTaskModalProjectList();
    }
  }, 300);
};

// Toggle add task form
window.toggleAddTaskForm = function (skipRender) {
  console.log('🔄 Toggling add task form. Current state:', showAddTaskForm);
  const wasOpen = showAddTaskForm;
  showAddTaskForm = !showAddTaskForm;
  console.log('🔄 New state:', showAddTaskForm);

  // If opening a new task form (was closed, now opening), clear all editing data
  if (!wasOpen && showAddTaskForm) {
    console.log('🧹 Clearing task form data for new task');
    // Clear all task modal variables
    window.editingTaskData = null;
    // Set preselected contact if we're inside a contact (don't clear it)
    if (currentScreen === 'sales' && selectedContactId) {
      window.preselectedTaskContactId = selectedContactId;
    } else {
      window.preselectedTaskContactId = null;
    }
    window.preselectedTaskProjectId = null;
    window.selectedTaskMembers = [];
    window.selectedTaskService = '';
    window.customTaskServiceName = '';
    window.selectedTaskContact = '';
    window.selectedTaskProject = '';
    window.taskContactSearchQuery = '';
    window.taskProjectSearchQuery = '';
    window.taskMemberSearchQuery = '';
    window.taskPriority = 'MEDIUM';
    window.taskStatus = 'BACKLOG';
    window.showCreateProjectInTask = false;
    window.newProjectNameInTask = '';
    window.newProjectDescriptionInTask = '';
    window.newProjectConfirmedInTask = false;
    // Also clear the regular form state variables
    editingTask = null;  // IMPORTANT: Clear this so form shows "Create Task" not "Edit Task"
    selectedService = '';
    customServiceName = '';
    taskPriority = 'MEDIUM';
    taskStatus = 'BACKLOG';
    selectedMembers = [];
    selectedContact = null;
    selectedProject = null;
    selectedClients = [];
    showProjectCreation = false;
  }

  // Reset project creation state when closing task form
  if (!showAddTaskForm) {
    showProjectCreation = false;

    // Remove modal from DOM if closing
    const existingModal = document.querySelector('#add-task-modal');
    if (existingModal) {
      existingModal.remove();
      console.log('✅ Task modal removed from DOM');
    }
  }

  // Show/hide modal immediately without waiting for full renderPMTool
  if (showAddTaskForm) {
    // Check if modal already exists
    const existingModal = document.getElementById('add-task-modal');
    if (!existingModal) {
      // Insert modal immediately
      const modalHTML = renderAddTaskModal();
      document.body.insertAdjacentHTML('beforeend', modalHTML);
    }
    // Initialize project list after modal is rendered
    setTimeout(() => {
      initializeTaskModalProjectList();
      // Also fetch and display selected project if one is preselected
      if (window.preselectedTaskProjectId) {
        fetchAndDisplaySelectedProject();
      }
    }, 50);
  } else {
    // Remove modal from DOM immediately
    const existingModal = document.getElementById('add-task-modal');
    if (existingModal) {
      existingModal.remove();
    }
    // Only re-render when closing if we're on a screen that needs it and not skipping render
    if (!skipRender && (currentScreen === 'team' || currentScreen === 'pm-tool')) {
      renderPMTool();
    }
  }
};

// Initialize project list in task modal
window.initializeTaskModalProjectList = async function () {
  const listContainer = document.getElementById('project-list-container');
  if (!listContainer) {
    // If container doesn't exist yet, try again after a short delay
    setTimeout(() => {
      initializeTaskModalProjectList();
    }, 100);
    return;
  }

  // Determine the contact ID to use - check multiple sources (prioritize preselected values)
  const contactIdToUse = window.preselectedTaskContactId || window.selectedTaskContact || selectedContact || (currentScreen === 'sales' ? selectedContactId : null);

  console.log('📋 initializeTaskModalProjectList - contactIdToUse:', contactIdToUse);
  console.log('📋 Sources:', {
    preselectedTaskContactId: window.preselectedTaskContactId,
    selectedTaskContact: window.selectedTaskContact,
    selectedContact: selectedContact,
    selectedContactId: currentScreen === 'sales' ? selectedContactId : 'N/A'
  });

  // If there's a preselected project, fetch and display it first
  if (window.preselectedTaskProjectId) {
    fetchAndDisplaySelectedProject(window.preselectedTaskProjectId);
    window.selectedTaskProject = window.preselectedTaskProjectId;
  }

  if (contactIdToUse) {
    window.selectedTaskContact = contactIdToUse;
    selectedContact = contactIdToUse;
    updateSelectedContactDisplay();
  }
  // Always load project list (with or without contact) so we never stay on "Loading..."
  await loadContactProjectList();
};

// Handle modal click (close on outside click)
window.handleModalClick = function (event) {
  if (event.target.id === 'add-task-modal') {
    toggleAddTaskForm();
  }
};

// Load comments for task details modal
async function loadTaskDetailsComments(taskId) {
  try {
    const { data, error } = await supabase
      .from('task_comments')
      .select(`
        *,
        profiles:author_id (
          first_name,
          last_name,
          avatar_path
        )
      `)
      .eq('task_id', taskId)
      .order('created_at', { ascending: true });

    if (error) {
      console.error('Error loading task details comments:', error);
      return;
    }

    taskDetailsComments = data || [];
    console.log(`📝 Loaded ${taskDetailsComments.length} comments for task details ${taskId}`);
  } catch (error) {
    console.error('Error loading task details comments:', error);
  }
}

// View task details
window.viewTaskDetails = async function (taskId) {
  const task = tasks.find(t => t.id === taskId);
  if (!task) {
    console.error('Task not found:', taskId);
    return;
  }

  showTaskDetails = taskId;
  await loadTaskDetailsComments(taskId);
  renderPMTool();
};


// Form state variables
let selectedService = '';
let customServiceName = '';
let taskPriority = 'MEDIUM';
let taskStatus = 'BACKLOG';
let selectedMembers = [];
let selectedContact = null;
let selectedProject = null;
let selectedClients = [];
let showProjectCreation = false;

// Show member dropdown on focus
window.showMemberDropdown = function (input) {
  if (!input) return;

  const inputId = input.id;
  let resultsDiv, selected, selectFunction;

  // Determine which context we're in
  if (inputId === 'task-member-search-input') {
    // Task form with task-member-search-input
    resultsDiv = document.getElementById('task-member-search-results');
    selected = window.selectedTaskMembers || [];
    selectFunction = 'addTaskMember';
  } else if (inputId === 'member-search') {
    // Regular form or task form with member-search
    resultsDiv = document.getElementById('member-search-results');
    // Check if we're in task context (has selectedTaskMembers) or regular context
    if (window.selectedTaskMembers !== undefined) {
      selected = window.selectedTaskMembers || [];
      selectFunction = 'addTaskMember';
    } else {
      selected = selectedMembers || [];
      selectFunction = 'selectMember';
    }
  } else {
    return;
  }

  if (!resultsDiv) return;

  // Get the search query from the input value
  const query = (input.value || '').toLowerCase().trim();

  // Filter team members based on search query and exclude already selected members
  let availableMembers = teamMembers.filter(member =>
    !selected.includes(member.id)
  );

  // If there's a search query, filter by name
  if (query) {
    availableMembers = availableMembers.filter(member =>
      `${member.first_name} ${member.last_name}`.toLowerCase().includes(query)
    );
  }

  if (availableMembers.length > 0) {
    resultsDiv.innerHTML = availableMembers.map(member => `
      <div onmousedown="event.preventDefault(); ${selectFunction}('${member.id}')" style="
        padding: 0.75rem;
        cursor: pointer;
        border-bottom: 1px solid ${colors.border};
      " onmouseover="this.style.background='${colors.background}'" onmouseout="this.style.background='transparent'">
        ${member.first_name} ${member.last_name}
      </div>
    `).join('');
    resultsDiv.style.display = 'block';
    resultsDiv.style.visibility = 'visible';
    resultsDiv.style.opacity = '1';
  } else {
    resultsDiv.style.display = 'none';
    resultsDiv.style.visibility = 'hidden';
    resultsDiv.style.opacity = '0';
  }
};

// Select/deselect team member
window.selectMember = function (memberId) {
  // Check if we're in task context - if so, use window.selectedTaskMembers
  if (window.selectedTaskMembers !== undefined) {
    // We're in task form context
    if (!window.selectedTaskMembers) window.selectedTaskMembers = [];
    if (!window.selectedTaskMembers.includes(memberId)) {
      window.selectedTaskMembers.push(memberId);
      updateTaskSelectedMembersDisplay();
      updateSelectedMembersDisplayForTask();
    }
  } else {
    // Regular form context
    if (!selectedMembers.includes(memberId)) {
      selectedMembers.push(memberId);
      updateSelectedMembersDisplay();
    }
  }
};

window.removeMember = function (memberId) {
  selectedMembers = selectedMembers.filter(id => id !== memberId);
  updateSelectedMembersDisplay();
};

function updateSelectedMembersDisplay() {
  const selectedDiv = document.getElementById('selected-members');
  if (!selectedDiv) return;

  const memberSearch = document.getElementById('member-search');
  if (memberSearch) memberSearch.value = '';

  selectedDiv.innerHTML = selectedMembers.map(id => {
    const member = teamMembers.find(m => m.id === id);
    if (!member) return '';
    return `
      <div style="
        background: ${colors.primary};
        color: white;
        padding: 0.5rem 0.75rem;
        border-radius: 1.5rem;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        font-size: 0.875rem;
      ">
        ${member.first_name} ${member.last_name}
        <button onclick="removeMember('${id}')" style="
          background: rgba(255,255,255,0.3);
          border: none;
          color: white;
          cursor: pointer;
          width: 18px;
          height: 18px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0;
        ">×</button>
      </div>
    `;
  }).join('');

  // Hide results
  const resultsDiv = document.getElementById('member-search-results');
  if (resultsDiv) resultsDiv.style.display = 'none';
}

// Select contact (single selection)
window.selectContact = function (contactId) {
  selectedContact = contactId;
  // Also set for task form context
  window.selectedTaskContact = contactId;
  selectedProject = null; // Reset project when contact changes
  window.selectedTaskProject = null;
  updateSelectedContactDisplay();

  // Clear project selection display
  const selectedProjectDiv = document.getElementById('selected-project');
  if (selectedProjectDiv) {
    selectedProjectDiv.innerHTML = '';
  }

  // Load project list for the newly selected contact
  setTimeout(() => {
    loadContactProjectList();
  }, 100);
};

function updateSelectedContactDisplay() {
  const selectedDiv = document.getElementById('selected-contact');
  const contactSearch = document.getElementById('contact-search');
  if (!selectedDiv) return;

  // Use window.selectedTaskContact if available, otherwise fall back to selectedContact
  const contactId = window.selectedTaskContact || selectedContact;

  if (contactSearch) contactSearch.value = '';

  if (contactId) {
    const contact = contacts.find(c => c.id === contactId);
    if (contact) {
      selectedDiv.innerHTML = `
        <div style="
          background: ${colors.primary};
          color: white;
          padding: 0.5rem 0.75rem;
          border-radius: 1.5rem;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.875rem;
        ">
          👤 ${contact.first_name} ${contact.last_name}
          <button onclick="clearContact()" style="
            background: rgba(255,255,255,0.3);
            border: none;
            color: white;
            cursor: pointer;
            width: 18px;
            height: 18px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0;
          ">×</button>
        </div>
      `;
    }
  } else {
    selectedDiv.innerHTML = '';
  }

  // Hide results
  const resultsDiv = document.getElementById('contact-search-results');
  if (resultsDiv) resultsDiv.style.display = 'none';
}

window.clearContact = function () {
  selectedContact = null;
  selectedProject = null;
  window.selectedTaskContact = null;
  window.preselectedTaskContactId = null;
  updateSelectedContactDisplay();

  // Clear project selection display
  const selectedProjectDiv = document.getElementById('selected-project');
  if (selectedProjectDiv) {
    selectedProjectDiv.innerHTML = '';
  }
  window.selectedTaskProject = null;
  selectedProject = null;

  // Show and reload the project list when contact is cleared
  const listContainer = document.getElementById('project-list-container');
  if (listContainer) {
    listContainer.style.display = 'block';
    loadContactProjectList();
  }
};

// Select project (single selection)
window.selectProject = async function (projectId) {
  selectedProject = projectId;
  // Also set for task form context
  window.selectedTaskProject = projectId;
  showProjectCreation = false;

  // Hide the project list when a project is selected
  const listContainer = document.getElementById('project-list-container');
  if (listContainer) listContainer.style.display = 'none';

  // Hide project creation form if it was open
  const creationForm = document.getElementById('project-creation-form');
  if (creationForm) creationForm.style.display = 'none';

  // Get the selected project display div
  const selectedDiv = document.getElementById('selected-project');
  if (!selectedDiv) return;

  // Ensure it's visible
  selectedDiv.style.display = 'flex';

  // Update the display to show selected project
  if (projectId) {
    // Fetch project details to show the name
    try {
      const { data: project, error } = await supabase
        .from('projects')
        .select('id, name')
        .eq('id', projectId)
        .single();

      if (!error && project) {
        selectedDiv.innerHTML = `
          <div style="
            background: #8B5CF6;
            color: white;
            padding: 0.5rem 0.75rem;
            border-radius: 1.5rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            font-size: 0.875rem;
          ">
            📁 ${project.name}
            <button onclick="clearProject(); event.stopPropagation();" style="
              background: rgba(255,255,255,0.3);
              border: none;
              color: white;
              cursor: pointer;
              width: 18px;
              height: 18px;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 0;
              font-size: 14px;
              line-height: 1;
            ">×</button>
          </div>
        `;
      } else {
        // If fetch fails, still show something
        selectedDiv.innerHTML = `
          <div style="
            background: #8B5CF6;
            color: white;
            padding: 0.5rem 0.75rem;
            border-radius: 1.5rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            font-size: 0.875rem;
          ">
            📁 Project Selected
            <button onclick="clearProject(); event.stopPropagation();" style="
              background: rgba(255,255,255,0.3);
              border: none;
              color: white;
              cursor: pointer;
              width: 18px;
              height: 18px;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 0;
              font-size: 14px;
              line-height: 1;
            ">×</button>
          </div>
        `;
      }
    } catch (error) {
      console.error('Error fetching project:', error);
      // Show fallback display
      selectedDiv.innerHTML = `
        <div style="
          background: #8B5CF6;
          color: white;
          padding: 0.5rem 0.75rem;
          border-radius: 1.5rem;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.875rem;
        ">
          📁 Project Selected
          <button onclick="clearProject(); event.stopPropagation();" style="
            background: rgba(255,255,255,0.3);
            border: none;
            color: white;
            cursor: pointer;
            width: 18px;
            height: 18px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0;
            font-size: 14px;
            line-height: 1;
          ">×</button>
        </div>
      `;
    }
  }
};

// Load and display contact's project list (no search, just scrollable list)
window.loadContactProjectList = async function () {
  // Re-query container each time so we update the live DOM (modal may have been re-rendered)
  let listContainer = document.getElementById('project-list-container');
  if (!listContainer) return;

  try {
    const taskContactId = window.selectedTaskContact || window.preselectedTaskContactId || selectedContact || (currentScreen === 'sales' ? selectedContactId : null);

    // Load projects: for this contact if set, otherwise all active company projects (so user can still link task to a project)
    const projectsToShow = await loadContactProjects(taskContactId || null, true);
    if (taskContactId) {
      // Filter to contact's projects when we have a contact (loadContactProjects already does this when contactId is set)
      // When contactId was null we got all company projects above
    }

    listContainer = document.getElementById('project-list-container');
    if (!listContainer) return;

    if (!taskContactId) {
      listContainer.innerHTML = `
        <div style="padding: 1rem; text-align: center; color: #6c757d; font-size: 0.875rem;">
          Select a contact to see their projects, or pick any project below to link
        </div>
        ${projectsToShow.length ? projectsToShow.map(project => `
        <div
          onclick="selectProject('${project.id}')"
          style="padding: 0.75rem; cursor: pointer; border-bottom: 1px solid ${colors.border}; transition: background-color 0.2s;"
          onmouseover="this.style.backgroundColor='${colors.background}'"
          onmouseout="this.style.backgroundColor='transparent'"
        >
          <div style="font-weight: 500; color: ${colors.text};">📁 ${project.name}</div>
          ${project.description ? `<div style="font-size: 0.75rem; color: ${colors.textSecondary}; margin-top: 0.25rem;">${project.description}</div>` : ''}
        </div>
      `).join('') : ''}
      `;
      return;
    }

    if (projectsToShow.length === 0) {
      listContainer.innerHTML = `
        <div style="padding: 1rem; text-align: center; color: #6c757d; font-size: 0.875rem;">
          No projects found for this contact
        </div>
      `;
    } else {
      listContainer.innerHTML = projectsToShow.map(project => `
        <div
          onclick="selectProject('${project.id}')"
          style="
            padding: 0.75rem;
            cursor: pointer;
            border-bottom: 1px solid ${colors.border};
            transition: background-color 0.2s;
          "
          onmouseover="this.style.backgroundColor='${colors.background}'"
          onmouseout="this.style.backgroundColor='transparent'"
        >
          <div style="font-weight: 500; color: ${colors.text};">📁 ${project.name}</div>
          ${project.description ? `<div style="font-size: 0.75rem; color: ${colors.textSecondary}; margin-top: 0.25rem;">${project.description}</div>` : ''}
        </div>
      `).join('');
    }
  } catch (error) {
    console.error('Error loading projects:', error);
    listContainer = document.getElementById('project-list-container');
    if (listContainer) {
      listContainer.innerHTML = `
        <div style="padding: 1rem; text-align: center; color: #ef4444; font-size: 0.875rem;">
          Error loading projects
        </div>
      `;
    }
  }
};

async function updateSelectedProjectDisplay() {
  const selectedDiv = document.getElementById('selected-project');
  const listContainer = document.getElementById('project-list-container');

  if (!selectedDiv) return;

  // Check both selectedProject and window.selectedTaskProject
  const projectId = window.selectedTaskProject || selectedProject;

  if (projectId) {
    // Fetch project name from server
    try {
      const { data: project, error } = await supabase
        .from('projects')
        .select('id, name')
        .eq('id', projectId)
        .single();

      if (!error && project) {
        selectedDiv.style.display = 'flex';
        selectedDiv.innerHTML = `
          <div style="
            background: #8B5CF6;
            color: white;
            padding: 0.5rem 0.75rem;
            border-radius: 1.5rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            font-size: 0.875rem;
          ">
            📁 ${project.name}
            <button onclick="clearProject(); event.stopPropagation();" style="
              background: rgba(255,255,255,0.3);
              border: none;
              color: white;
              cursor: pointer;
              width: 18px;
              height: 18px;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 0;
              font-size: 14px;
              line-height: 1;
            ">×</button>
          </div>
        `;
      } else {
        // Fallback if fetch fails
        selectedDiv.style.display = 'flex';
        selectedDiv.innerHTML = `
          <div style="
            background: #8B5CF6;
            color: white;
            padding: 0.5rem 0.75rem;
            border-radius: 1.5rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            font-size: 0.875rem;
          ">
            📁 Project Selected
            <button onclick="clearProject(); event.stopPropagation();" style="
              background: rgba(255,255,255,0.3);
              border: none;
              color: white;
              cursor: pointer;
              width: 18px;
              height: 18px;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 0;
              font-size: 14px;
              line-height: 1;
            ">×</button>
          </div>
        `;
      }
    } catch (error) {
      console.error('Error fetching project:', error);
      // Fallback display
      selectedDiv.style.display = 'flex';
      selectedDiv.innerHTML = `
        <div style="
          background: #8B5CF6;
          color: white;
          padding: 0.5rem 0.75rem;
          border-radius: 1.5rem;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          font-size: 0.875rem;
        ">
          📁 Project Selected
          <button onclick="clearProject(); event.stopPropagation();" style="
            background: rgba(255,255,255,0.3);
            border: none;
            color: white;
            cursor: pointer;
            width: 18px;
            height: 18px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0;
            font-size: 14px;
            line-height: 1;
          ">×</button>
        </div>
      `;
    }
    // Hide project list when project is selected
    if (listContainer) listContainer.style.display = 'none';
  } else {
    selectedDiv.innerHTML = '';
    selectedDiv.style.display = 'none';
    // Show project list when no project selected
    if (listContainer) listContainer.style.display = 'block';
  }
}

window.clearProject = function () {
  selectedProject = null;
  // Also clear task form context
  window.selectedTaskProject = '';
  showProjectCreation = false;

  // Clear the selected project display
  const selectedDiv = document.getElementById('selected-project');
  if (selectedDiv) {
    selectedDiv.innerHTML = '';
  }

  // Show project list again and reload it
  const listContainer = document.getElementById('project-list-container');
  if (listContainer) {
    listContainer.style.display = 'block';
    loadContactProjectList();
  }
};

// Edit new project (allows editing the confirmed project before task creation)
window.editNewProject = function () {
  // Remove the confirmed display
  const confirmedDiv = document.getElementById('confirmed-project-display');
  if (confirmedDiv) confirmedDiv.remove();

  // Show the creation form again
  showProjectCreation = true;

  // Re-render modal to show creation form
  const modal = document.getElementById('add-task-modal');
  if (modal) {
    const modalContent = modal.querySelector('div[onclick*="stopPropagation"]');
    if (modalContent) {
      const currentHTML = renderAddTaskModal();
      const newContent = currentHTML.match(/<div onclick="event\.stopPropagation\(\)"[^>]*>([\s\S]*)<\/div>/)?.[1] || '';
      modalContent.innerHTML = newContent;

      // Restore the project name and description if they exist
      if (window.newProjectName) {
        const nameInput = document.getElementById('new-project-name');
        if (nameInput) nameInput.value = window.newProjectName;
      }
      if (window.newProjectDescription) {
        const descInput = document.getElementById('new-project-description');
        if (descInput) descInput.value = window.newProjectDescription;
      }
      if (window.initializeTaskModalProjectList) setTimeout(window.initializeTaskModalProjectList, 50);
    }
  }

  // Clear the stored project info
  window.newProjectName = null;
  window.newProjectDescription = null;
};

// Toggle project creation form - opens the project modal instead of inline form
window.toggleProjectCreation = function () {
  // Check if a contact is selected - required for creating a new project
  const contactId = window.selectedTaskContact || selectedContact;
  if (!contactId) {
    alert('Please select a contact first before creating a new project');
    return;
  }

  // Open the project creation modal with the selected contact
  // Pass the contact ID so it uses the task form's contact
  showAddProjectModal(contactId);
};

// Confirm new project (stores project info for creation when task is saved)
window.confirmNewProject = function () {
  const projectNameInput = document.getElementById('new-project-name');
  const projectDescInput = document.getElementById('new-project-description');
  const projectName = projectNameInput?.value?.trim();

  if (!projectName) {
    alert('Please enter a project name');
    return;
  }

  // Check if a contact is selected - required for creating a new project
  const contactId = window.selectedTaskContact || selectedContact;
  if (!contactId) {
    alert('Please select a contact first before creating a new project');
    return;
  }

  // Preserve selected contact and members before re-rendering
  const preservedContact = contactId;
  const preservedMembers = window.selectedTaskMembers ? [...window.selectedTaskMembers] : [];

  // Store the project info temporarily - use the task-specific variables
  window.newProjectNameInTask = projectName;
  window.newProjectDescriptionInTask = projectDescInput?.value?.trim() || '';
  window.newProjectConfirmedInTask = true;
  window.showCreateProjectInTask = true;

  // Switch back to "Select Existing" mode
  showProjectCreation = false;

  // Re-render the modal to show the confirmed project badge
  renderPMTool();

  // Restore preserved values after re-render
  setTimeout(() => {
    if (preservedContact) {
      window.selectedTaskContact = preservedContact;
      selectedContact = preservedContact;
      updateSelectedContactDisplay();
    }
    if (preservedMembers.length > 0) {
      window.selectedTaskMembers = preservedMembers;
      // Update member displays if functions exist
      if (typeof updateTaskSelectedMembersDisplay === 'function') {
        updateTaskSelectedMembersDisplay();
      }
      if (typeof updateSelectedMembersDisplayForTask === 'function') {
        updateSelectedMembersDisplayForTask();
      }
    }

    console.log('✅ Project confirmed for creation:', projectName);
    console.log('✅ Contact preserved:', preservedContact);
  }, 300);
};

// Handle task form submission
window.handleCreateTask = async function (e) {
  e.preventDefault();

  const titleInput = document.getElementById('task-title');
  const descriptionInput = document.getElementById('task-description');
  const dueDateInput = document.getElementById('task-due-date');
  const serviceInput = document.getElementById('service-name');

  const title = titleInput?.value?.trim();
  const description = descriptionInput?.value?.trim();
  const dueDate = dueDateInput?.value || null;

  // Clear previous errors
  if (typeof clearFieldErrors === 'function') {
    clearFieldErrors();
  }

  let hasErrors = false;
  let errorMessage = 'Please fix the following errors:\n';

  if (!title) {
    highlightInvalidField('task-title');
    hasErrors = true;
    errorMessage += '• Task title is required\n';
  }

  if (!description) {
    highlightInvalidField('task-description');
    hasErrors = true;
    errorMessage += '• Task description is required\n';
  }

  // Priority is OPTIONAL - no validation required

  // Team member validation - TEMPORARILY DISABLED for testing
  // Validate at least one team member is selected
  // First check the DOM directly - this is the most reliable
  const selectedMembersDiv = document.getElementById('selected-members') || document.getElementById('task-selected-members-display');
  const hasDisplayedMembers = selectedMembersDiv && selectedMembersDiv.children && selectedMembersDiv.children.length > 0;

  // Extract member IDs from DOM if displayed
  let extractedMemberIds = [];
  if (hasDisplayedMembers) {
    const memberButtons = selectedMembersDiv.querySelectorAll('button[onclick*="removeTaskMember"], button[onclick*="removeMember"]');
    if (memberButtons.length > 0) {
      extractedMemberIds = Array.from(memberButtons).map(btn => {
        const onclick = btn.getAttribute('onclick') || '';
        const match = onclick.match(/remove(?:Task)?Member\(['"]([^'"]+)['"]\)/);
        return match ? match[1] : null;
      }).filter(Boolean);

      // Sync to selectedMembers if we found members in DOM
      if (extractedMemberIds.length > 0 && (!selectedMembers || selectedMembers.length === 0)) {
        selectedMembers = [...extractedMemberIds];
        console.log('🔄 Synced members from DOM to selectedMembers:', selectedMembers);
      }
    }
  }

  // Check state variables
  const hasTaskMembers = window.selectedTaskMembers && Array.isArray(window.selectedTaskMembers) && window.selectedTaskMembers.length > 0;
  const hasRegularMembers = selectedMembers && Array.isArray(selectedMembers) && selectedMembers.length > 0;

  // Final check: if any source shows members, we're good
  const hasAnyMembers = hasTaskMembers || hasRegularMembers || hasDisplayedMembers || extractedMemberIds.length > 0;

  console.log('🔍 Member validation check (NOT REQUIRED):', {
    selectedTaskMembers: window.selectedTaskMembers,
    hasTaskMembers: hasTaskMembers,
    selectedMembers: selectedMembers,
    hasRegularMembers: hasRegularMembers,
    hasDisplayedMembers: hasDisplayedMembers,
    extractedMemberIds: extractedMemberIds,
    hasAnyMembers: hasAnyMembers
  });

  // Validate team members are required
  if (!hasAnyMembers) {
    const memberSearch = document.getElementById('member-search');
    if (memberSearch) {
      highlightInvalidField('member-search');
      memberSearch.focus();
      // Show dropdown on focus
      if (typeof showMemberDropdown === 'function') {
        showMemberDropdown(memberSearch);
      }
    }
    hasErrors = true;
    errorMessage += '• At least one team member must be assigned\n';
  }

  if (hasErrors) {
    // Show custom notification instead of browser alert
    if (typeof showNotification === 'function') {
      showNotification('Please fill out all required fields', 'error');
    }
    // Scroll to first error field
    setTimeout(() => {
      const firstErrorField = document.querySelector('.field-error') ||
        document.querySelector('[style*="border-color: #ef4444"]') ||
        document.querySelector('[style*="border-color: rgb(239, 68, 68)"]');
      if (firstErrorField) {
        firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
    return;
  }

  const createBtn = document.getElementById('create-task-btn');
  if (createBtn) {
    createBtn.disabled = true;
    createBtn.textContent = editingTask ? 'Updating...' : 'Creating...';
  }

  try {
    // Use task modal variables if available, otherwise fall back to regular variables
    // Convert empty strings to null
    const taskContactId = (window.selectedTaskContact && window.selectedTaskContact.trim() !== '')
      ? window.selectedTaskContact
      : (selectedContact || selectedContactId || null);
    let taskProjectId = (window.selectedTaskProject && window.selectedTaskProject.trim() !== '')
      ? window.selectedTaskProject
      : (selectedProject || null);

    console.log('📝 Creating task with:', {
      taskContactId,
      taskProjectId,
      selectedContact,
      selectedProject,
      windowSelectedTaskContact: window.selectedTaskContact,
      windowSelectedTaskProject: window.selectedTaskProject,
      showProjectCreation
    });

    // Create project inline if requested
    if (window.showCreateProjectInTask && window.newProjectConfirmedInTask && window.newProjectNameInTask) {
      const projectName = window.newProjectNameInTask.trim();
      const projectDesc = window.newProjectDescriptionInTask || null;

      console.log('🏗️ Attempting to create project:', projectName);

      if (projectName) {
        const projectData = {
          name: projectName,
          description: projectDesc,
          company_id: currentCompany.id,
          contact_id: taskContactId,
          created_by: currentUser.id,
          status: 'active',
        };

        console.log('🏗️ Project data:', projectData);

        const { data: newProject, error: projectError } = await supabase
          .from('projects')
          .insert(projectData)
          .select()
          .single();

        if (projectError) {
          console.error('❌ Error creating project:', projectError);
          if (typeof showNotification === 'function') {
            showNotification('Failed to create project: ' + projectError.message, 'error');
          } else {
            alert('Failed to create project: ' + projectError.message);
          }
          if (createBtn) {
            createBtn.disabled = false;
            createBtn.textContent = editingTask ? 'Update Task' : 'Create Task';
          }
          return;
        }

        taskProjectId = newProject.id;
        console.log('✅ Project created:', newProject);

        // Clear the stored project info
        window.newProjectNameInTask = null;
        window.newProjectDescriptionInTask = null;
        window.newProjectConfirmedInTask = false;
      }
    } else if (showProjectCreation || window.newProjectName) {
      // Fallback for old form
      const projectName = window.newProjectName || document.getElementById('new-project-name')?.value?.trim();
      const projectDescInput = document.getElementById('new-project-description');
      const projectDesc = window.newProjectDescription || projectDescInput?.value?.trim() || null;

      console.log('🏗️ Attempting to create project:', projectName);

      if (projectName) {
        const projectData = {
          name: projectName,
          description: projectDesc,
          company_id: currentCompany.id,
          contact_id: taskContactId,
          created_by: currentUser.id,
          status: 'active',
        };

        console.log('🏗️ Project data:', projectData);

        const { data: newProject, error: projectError } = await supabase
          .from('projects')
          .insert(projectData)
          .select()
          .single();

        if (projectError) {
          console.error('❌ Error creating project:', projectError);
          if (typeof showNotification === 'function') {
            showNotification('Failed to create project: ' + projectError.message, 'error');
          } else {
            alert('Failed to create project: ' + projectError.message);
          }
          if (createBtn) {
            createBtn.disabled = false;
            createBtn.textContent = editingTask ? 'Update Task' : 'Create Task';
          }
          return;
        }

        taskProjectId = newProject.id;
        console.log('✅ Project created:', newProject);

        // Clear the stored project info
        window.newProjectName = null;
        window.newProjectDescription = null;
      }
    }

    // Prepare task data - ensure contact_id and project_id are set
    const taskData = {
      title,
      description,
      priority: taskPriority,
      due_at: dueDate ? dueDate : null,
      state: taskStatus,
      company_id: currentCompany.id,
      contact_id: (taskContactId && taskContactId.trim() !== '') ? taskContactId : null,
      project_id: (taskProjectId && taskProjectId.trim() !== '') ? taskProjectId : null,
    };

    console.log('📝 Task data to insert:', taskData);
    console.log('💾 Saving task with contact_id:', taskData.contact_id, 'project_id:', taskData.project_id);

    // Handle service assignment
    if (selectedService) {
      taskData.service_id = selectedService;
      taskData.service_name = null;
    } else if (customServiceName) {
      taskData.service_id = null;
      taskData.service_name = customServiceName;
    }

    let taskResult;

    if (editingTask) {
      // UPDATE
      const { data, error } = await supabase
        .from('tasks')
        .update(taskData)
        .eq('id', editingTask.id)
        .select()
        .single();

      if (error) {
        console.error('Error updating task:', error);
        if (typeof showNotification === 'function') {
          showNotification('Failed to update task: ' + (error.message || 'Unknown error'), 'error');
        } else {
          alert('Failed to update task');
        }
        if (createBtn) {
          createBtn.disabled = false;
          createBtn.textContent = 'Update Task';
        }
        return;
      }

      taskResult = data;

      // Remove existing assignees
      await supabase
        .from('task_assignees')
        .delete()
        .eq('task_id', editingTask.id);
    } else {
      // CREATE
      const { data, error } = await supabase
        .from('tasks')
        .insert([taskData])
        .select()
        .single();

      if (error) {
        console.error('❌ Error creating task:', error);
        if (typeof showNotification === 'function') {
          showNotification('Failed to create task: ' + error.message, 'error');
        } else {
          alert('Failed to create task: ' + error.message);
        }
        if (createBtn) {
          createBtn.disabled = false;
          createBtn.textContent = 'Create Task';
        }
        return;
      }

      taskResult = data;
      console.log('✅ Task created successfully:', taskResult);
    }

    // Add task assignees - use task modal members if available
    const membersToAssign = window.selectedTaskMembers && window.selectedTaskMembers.length > 0
      ? window.selectedTaskMembers
      : selectedMembers;

    if (membersToAssign.length > 0) {
      const assigneesData = membersToAssign.map(userId => ({
        task_id: taskResult.id,
        user_id: userId,
      }));

      const { error: assigneesError } = await supabase
        .from('task_assignees')
        .insert(assigneesData);

      if (assigneesError) {
        console.error('Error assigning team members:', assigneesError);
      } else {
        // Send notifications
        try {
          const assignerName = `${currentUser.first_name || ''} ${currentUser.last_name || ''}`.trim() || 'Someone';

          for (const userId of membersToAssign) {
            await supabase.from('notifications').insert({
              user_id: userId,
              type: 'task_assigned',
              title: 'Assigned to Task',
              body: `${assignerName} assigned you to task "${taskResult.title}"`,
              data: { task_id: taskResult.id },
            });
          }
        } catch (error) {
          console.warn('Failed to send notifications:', error);
        }
      }
    }

    // Reset form
    selectedMembers = [];
    // Don't reset selectedContact/selectedContactId here - preserve for refresh check
    selectedProject = null;
    selectedClients = [];
    showProjectCreation = false;
    selectedService = '';
    customServiceName = '';
    taskPriority = 'MEDIUM';
    taskStatus = 'BACKLOG';
    editingTask = null;
    window.editingTaskData = null; // Also clear window.editingTaskData
    window.newProjectName = null;
    window.newProjectDescription = null;

    // Close modal and refresh
    toggleAddTaskForm();
    await loadTasks();

    console.log('🔄 Refreshing view...');
    console.log('📍 Current screen:', currentScreen);
    console.log('📍 Selected contact ID:', selectedContactId);

    // If we're on the contacts screen with a contact selected, refresh the contact detail
    if (currentScreen === 'sales' && selectedContactId) {
      console.log('🔄 Refreshing contact detail for:', selectedContactId);
      await updateContactDetailContent();
    } else {
      renderPMTool();
    }

    // Show success notification
    if (typeof showNotification === 'function') {
      showNotification(
        editingTask ? 'Task updated successfully!' : 'Task created successfully!',
        'success'
      );
    }

  } catch (error) {
    console.error('Error saving task:', error);
    if (typeof showNotification === 'function') {
      showNotification('An unexpected error occurred while saving the task', 'error');
    } else {
      alert('An unexpected error occurred');
    }
    if (createBtn) {
      createBtn.disabled = false;
      createBtn.textContent = editingTask ? 'Update Task' : 'Create Task';
    }
  }
};

// Set selected service
window.setSelectedService = function (serviceId) {
  selectedService = serviceId;
  window.selectedTaskService = serviceId;

  // Update button styles
  document.querySelectorAll('[id^="service-"]').forEach(btn => {
    btn.style.background = colors.background;
    btn.style.color = colors.text;
  });

  const btn = document.getElementById(`service-${serviceId || 'other'}`);
  if (btn) {
    btn.style.background = colors.primary;
    btn.style.color = 'white';
  }

  // Show/hide custom service input
  const customInput = document.getElementById('custom-service-name');
  if (customInput) {
    customInput.style.display = serviceId === '' ? 'block' : 'none';
  }
};

// Set task priority
window.setTaskPriority = function (priority) {
  taskPriority = priority;
  window.taskPriority = priority;

  // Update button styles
  document.querySelectorAll('[id^="priority-"]').forEach(btn => {
    btn.style.background = colors.background;
    btn.style.color = colors.text;
  });

  const btn = document.getElementById(`priority-${priority.toLowerCase()}`);
  if (btn) {
    const priorityColors = {
      'LOW': '#10b981',
      'MEDIUM': '#f59e0b',
      'HIGH': '#f97316',
      'URGENT': '#dc2626'
    };
    btn.style.background = priorityColors[priority];
    btn.style.color = 'white';
  }
};

// Set task status
window.setTaskStatus = function (status) {
  window.taskStatus = status;
  taskStatus = status;

  // Update button styles
  document.querySelectorAll('[id^="status-"]').forEach(btn => {
    btn.style.background = colors.background;
    btn.style.color = colors.text;
  });

  const btn = document.getElementById(`status-${status.toLowerCase()}`);
  if (btn) {
    const statusColors = {
      'BACKLOG': '#6b7280',
      'ACTIVE': '#3b82f6',
      'COMPLETED': '#10b981'
    };
    btn.style.background = statusColors[status];
    btn.style.color = 'white';
  }
};

// Select member for task assignment
window.selectMember = function (memberId) {
  if (!selectedMembers.includes(memberId)) {
    selectedMembers.push(memberId);
    updateSelectedMembersDisplay();
  }

  // Clear search
  const memberSearch = document.getElementById('member-search');
  const resultsDiv = document.getElementById('member-search-results');
  if (memberSearch) memberSearch.value = '';
  if (resultsDiv) resultsDiv.style.display = 'none';
};

// Select client for task assignment
window.selectClient = function (clientId) {
  if (!selectedClients.includes(clientId)) {
    selectedClients.push(clientId);
    updateSelectedClientsDisplay();
  }

  // Clear search
  const clientSearch = document.getElementById('client-search');
  const resultsDiv = document.getElementById('client-search-results');
  if (clientSearch) clientSearch.value = '';
  if (resultsDiv) resultsDiv.style.display = 'none';
};

// Render login form
window.renderLogin = function () {
  const container = document.getElementById('root');
  container.innerHTML = `
    <div style="
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 100vh;
      background: linear-gradient(135deg, #f59e0b 0%, #dc2626 100%);
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    ">
      <div style="
        background: ${colors.surface};
        padding: 2rem;
        border-radius: 1rem;
        box-shadow: 0 10px 25px rgba(0,0,0,0.1);
        width: 100%;
        max-width: 480px;
        margin: 1rem;
      ">
        <div style="text-align: center; margin-bottom: 1rem; margin-top: 0;">
          <div style="
            width: 280px; 
            height: 200px; 
            margin: 0 auto 0.5rem auto;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;
          ">
            <img 
              src="./icons/helo-logo-dark.png" 
              alt="Helo App Logo" 
              style="
                width: 100%; 
                height: 100%; 
                object-fit: contain;
                object-position: center;
              "
              onerror="this.style.display='none'"
            />
          </div>
          <p style="color: ${colors.textSecondary}; margin: 0;">
            Sign in to access your PM tool
          </p>
        </div>

        <div id="error-message" style="
          background: #fef2f2;
          border: 1px solid #fecaca;
          color: #dc2626;
          padding: 0.75rem;
          border-radius: 0.5rem;
          margin-bottom: 1rem;
          display: none;
        "></div>

        <form id="login-form">
          <div style="margin-bottom: 1rem;">
            <input
              type="email"
              id="email-input"
              placeholder="Email"
              required
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-size: 1rem;
                box-sizing: border-box;
              "
            />
          </div>
          <div style="margin-bottom: 1.5rem;">
            <input
              type="password"
              id="password-input"
              placeholder="Password"
              required
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-size: 1rem;
                box-sizing: border-box;
              "
            />
          </div>
          <button
            type="submit"
            style="
              width: 100%;
              background: #f59e0b;
              color: white;
              padding: 0.75rem;
              border: none;
              border-radius: 0.5rem;
              font-size: 1rem;
              font-weight: 600;
              cursor: pointer;
              transition: background-color 0.2s;
            "
            onmouseover="this.style.background='#d97706'"
            onmouseout="this.style.background='#f59e0b'"
          >
            Sign In
          </button>
        </form>
        
        <div style="margin-top: 1.5rem; text-align: center;">
          <a 
            href="#" 
            onclick="showForgotPasswordScreen(); return false;"
            style="
              color: #f59e0b;
              text-decoration: none;
              font-size: 0.875rem;
              font-weight: 500;
              transition: color 0.2s;
            "
            onmouseover="this.style.color='#d97706'; this.style.textDecoration='underline'"
            onmouseout="this.style.color='#f59e0b'; this.style.textDecoration='none'"
          >
            Forgot Password?
          </a>
        </div>
        
        <div style="
          margin-top: 1.5rem;
          padding-top: 1.5rem;
          border-top: 1px solid ${colors.border};
          text-align: center;
        ">
          <p style="color: ${colors.textSecondary}; margin: 0 0 0.75rem 0; font-size: 0.875rem;">
            Don't have an account?
          </p>
          <button
            type="button"
            onclick="showCreateAccountScreen()"
            style="
              width: 100%;
              background: transparent;
              color: #f59e0b;
              padding: 0.75rem;
              border: 2px solid #f59e0b;
              border-radius: 0.5rem;
              font-size: 1rem;
              font-weight: 600;
              cursor: pointer;
              transition: all 0.2s;
            "
            onmouseover="this.style.background='#f59e0b'; this.style.color='white'"
            onmouseout="this.style.background='transparent'; this.style.color='#f59e0b'"
          >
            Create Account
          </button>
        </div>
      </div>
    </div>
  `;

  // Add login form handler
  document.getElementById('login-form').onsubmit = handleLogin;
}

// Handle login
async function handleLogin(e) {
  e.preventDefault();

  // Show loading modal immediately
  showLoginLoadingModal();

  const email = document.getElementById('email-input').value;
  const password = document.getElementById('password-input').value;
  const errorDiv = document.getElementById('error-message');

  try {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      closeLoginLoadingModal();
      errorDiv.textContent = error.message;
      errorDiv.style.display = 'block';
      return;
    }

    if (data.user) {
      console.log('✅ Login successful for user:', data.user.id);

      // Check for pending signup data and complete it
      await checkAndCompletePendingSignup();

      await loadUserData();

      // Verify user has proper access (company and profile)
      if (!currentCompany) {
        console.warn('⚠️ User logged in but has no company assigned');
        // Check if there's pending signup data we can use
        const pendingData = localStorage.getItem('pendingSignupData');
        if (pendingData) {
          try {
            const signupData = JSON.parse(pendingData);
            await completeAccountSetup(data.user.id, signupData);
            await loadUserData(); // Reload after setup
          } catch (err) {
            console.error('Failed to complete pending signup:', err);
          }
        }
      }

      closeLoginLoadingModal();

      // ============================================
      // MOBILE / SMALL VIEWPORT - Recommend native app; user can choose "Continue to web"
      // ============================================
      const userChoseWebAfterLogin = (function () {
        try {
          return typeof sessionStorage !== 'undefined' && sessionStorage.getItem('helo_use_web_version') === '1';
        } catch (e) { return false; }
      })();
      if (window.isMobileDevice && window.isMobileDevice() && !userChoseWebAfterLogin) {
        console.log('📱 Small viewport / mobile detected - showing mobile app recommendation');
        renderClientLockedScreen();
        return; // Stop here unless user clicks "Continue to web"
      }

      // Check trial status before rendering the app
      if (isCompanyTrialExpired(currentCompany)) {
        console.log('🔒 Trial expired for company:', currentCompany?.name);
        renderTrialExpiredScreen(currentCompany);
        return;
      }

      renderPMTool();
    }
  } catch (err) {
    closeLoginLoadingModal();
    // Only show error message, not the full error object
    const errorMessage = err?.message || 'Login failed';
    // Filter out any variable reference errors that might leak through
    if (!errorMessage.includes('is not defined')) {
      errorDiv.textContent = errorMessage;
      errorDiv.style.display = 'block';
    } else {
      errorDiv.textContent = 'An unexpected error occurred. Please try again.';
      errorDiv.style.display = 'block';
    }
  }
};

// Show Forgot Password Screen
window.showForgotPasswordScreen = function () {
  const container = document.getElementById('root');
  if (!container) return;

  container.innerHTML = `
    <div style="
      min-height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      padding: 1rem;
    ">
      <div style="
        background: ${colors.surface};
        padding: 2rem;
        border-radius: 1rem;
        box-shadow: 0 10px 25px rgba(0,0,0,0.1);
        width: 100%;
        max-width: 400px;
        margin: 1rem;
      ">
        <div style="text-align: center; margin-bottom: 2rem;">
          <div style="font-size: 2.5rem; margin-bottom: 0.75rem; color: #f59e0b;">🔐</div>
          <h1 style="color: ${colors.text}; margin: 0 0 0.5rem 0; font-size: 1.5rem; font-weight: 700;">
            Reset Password
          </h1>
          <p style="color: ${colors.textSecondary}; margin: 0; font-size: 0.875rem;">
            Enter your email and we'll send you a link to reset your password
          </p>
        </div>

        <div id="forgot-success-message" style="
          background: #ecfdf5;
          border: 1px solid #a7f3d0;
          color: #059669;
          padding: 0.75rem;
          border-radius: 0.5rem;
          margin-bottom: 1rem;
          display: none;
        "></div>

        <div id="forgot-error-message" style="
          background: #fef2f2;
          border: 1px solid #fecaca;
          color: #dc2626;
          padding: 0.75rem;
          border-radius: 0.5rem;
          margin-bottom: 1rem;
          display: none;
        "></div>

        <form id="forgot-password-form">
          <div style="margin-bottom: 1.5rem;">
            <input
              type="email"
              id="forgot-email-input"
              placeholder="Email address"
              required
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-size: 1rem;
                box-sizing: border-box;
              "
            />
          </div>
          <button
            type="submit"
            id="forgot-submit-btn"
            style="
              width: 100%;
              background: #f59e0b;
              color: white;
              padding: 0.75rem;
              border: none;
              border-radius: 0.5rem;
              font-size: 1rem;
              font-weight: 600;
              cursor: pointer;
              transition: background-color 0.2s;
            "
            onmouseover="this.style.background='#d97706'"
            onmouseout="this.style.background='#f59e0b'"
          >
            Send Reset Link
          </button>
        </form>
        
        <div style="margin-top: 1.5rem; text-align: center;">
          <a 
            href="#" 
            onclick="renderLogin(); return false;"
            style="
              color: #f59e0b;
              text-decoration: none;
              font-size: 0.875rem;
              font-weight: 500;
            "
            onmouseover="this.style.color='#d97706'"
            onmouseout="this.style.color='#f59e0b'"
          >
            ← Back to Sign In
          </a>
        </div>
      </div>
    </div>
  `;

  // Handle forgot password form
  document.getElementById('forgot-password-form').onsubmit = async (e) => {
    e.preventDefault();
    const email = document.getElementById('forgot-email-input').value;
    const errorDiv = document.getElementById('forgot-error-message');
    const successDiv = document.getElementById('forgot-success-message');
    const submitBtn = document.getElementById('forgot-submit-btn');

    submitBtn.disabled = true;
    submitBtn.textContent = 'Sending...';
    submitBtn.style.opacity = '0.7';
    submitBtn.style.cursor = 'not-allowed';

    try {
      const { error } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: window.location.origin + '/reset-password'
      });

      if (error) {
        errorDiv.textContent = error.message;
        errorDiv.style.display = 'block';
        successDiv.style.display = 'none';
      } else {
        successDiv.textContent = 'Password reset email sent! Check your inbox.';
        successDiv.style.display = 'block';
        errorDiv.style.display = 'none';
      }
    } catch (err) {
      errorDiv.textContent = err?.message || 'Failed to send reset email';
      errorDiv.style.display = 'block';
      successDiv.style.display = 'none';
    } finally {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Send Reset Link';
      submitBtn.style.opacity = '1';
      submitBtn.style.cursor = 'pointer';
    }
  };
}

// Render Reset Password Page (when user clicks reset link)
window.renderResetPassword = function () {
  handlePasswordResetPage();
};

// Handle password reset page
async function handlePasswordResetPage() {
  const container = document.getElementById('root');
  if (!container) return;

  // Check URL hash for recovery token (Supabase puts it in hash)
  const hashParams = new URLSearchParams(window.location.hash.substring(1));
  const accessToken = hashParams.get('access_token');
  const type = hashParams.get('type');

  // Wait a moment for Supabase to process the URL hash if present
  if (type === 'recovery' && accessToken) {
    // Give Supabase a moment to establish the session from the hash
    await new Promise(resolve => setTimeout(resolve, 500));
  }

  // Check if there's a recovery session
  const { data: { session } } = await supabase.auth.getSession();

  // Verify we have a recovery session (either from hash or established session)
  const isRecoverySession = type === 'recovery' || (session && session.user);

  if (!isRecoverySession) {
    // No valid session - show error
    renderResetPasswordError('Invalid or expired reset link. Please request a new password reset email.');
    return;
  }

  // Show reset password form
  container.innerHTML = `
    <div style="
      min-height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      padding: 1rem;
    ">
      <div style="
        background: ${colors.surface};
        padding: 2rem;
        border-radius: 1rem;
        box-shadow: 0 10px 25px rgba(0,0,0,0.1);
        width: 100%;
        max-width: 400px;
        margin: 1rem;
      ">
        <div style="text-align: center; margin-bottom: 2rem;">
          <div style="font-size: 2.5rem; margin-bottom: 0.75rem; color: #f59e0b;">🔐</div>
          <h1 style="color: ${colors.text}; margin: 0 0 0.5rem 0; font-size: 1.5rem; font-weight: 700;">
            Reset Password
          </h1>
          <p style="color: ${colors.textSecondary}; margin: 0; font-size: 0.875rem;">
            Enter your new password below
          </p>
        </div>

        <div id="reset-success-message" style="
          background: #ecfdf5;
          border: 1px solid #a7f3d0;
          color: #059669;
          padding: 0.75rem;
          border-radius: 0.5rem;
          margin-bottom: 1rem;
          display: none;
        "></div>

        <div id="reset-error-message" style="
          background: #fef2f2;
          border: 1px solid #fecaca;
          color: #dc2626;
          padding: 0.75rem;
          border-radius: 0.5rem;
          margin-bottom: 1rem;
          display: none;
        "></div>

        <form id="reset-password-form">
          <div style="margin-bottom: 1rem;">
            <label style="
              display: block;
              color: ${colors.text};
              font-size: 0.875rem;
              font-weight: 500;
              margin-bottom: 0.5rem;
            ">New Password</label>
            <input
              type="password"
              id="reset-password-input"
              placeholder="Enter new password"
              required
              minlength="6"
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid #e5e7eb;
                border-radius: 0.5rem;
                font-size: 1rem;
                box-sizing: border-box;
              "
            />
            <p style="
              margin: 0.25rem 0 0 0;
              color: ${colors.textSecondary};
              font-size: 0.75rem;
            ">Minimum 6 characters</p>
          </div>
          
          <div style="margin-bottom: 1.5rem;">
            <label style="
              display: block;
              color: ${colors.text};
              font-size: 0.875rem;
              font-weight: 500;
              margin-bottom: 0.5rem;
            ">Confirm Password</label>
            <input
              type="password"
              id="reset-confirm-input"
              placeholder="Confirm new password"
              required
              minlength="6"
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid #e5e7eb;
                border-radius: 0.5rem;
                font-size: 1rem;
                box-sizing: border-box;
              "
            />
          </div>
          
          <button
            type="submit"
            id="reset-submit-btn"
            style="
              width: 100%;
              background: #f59e0b;
              color: white;
              padding: 0.75rem;
              border: none;
              border-radius: 0.5rem;
              font-size: 1rem;
              font-weight: 600;
              cursor: pointer;
              transition: background-color 0.2s;
            "
            onmouseover="this.style.background='#d97706'"
            onmouseout="this.style.background='#f59e0b'"
          >
            Update Password
          </button>
        </form>
        
        <div style="margin-top: 1.5rem; text-align: center;">
          <a 
            href="#" 
            onclick="window.renderLogin(); return false;"
            style="
              color: #f59e0b;
              text-decoration: none;
              font-size: 0.875rem;
              font-weight: 500;
            "
            onmouseover="this.style.color='#d97706'"
            onmouseout="this.style.color='#f59e0b'"
          >
            ← Back to Sign In
          </a>
        </div>
      </div>
    </div>
  `;

  // Handle form submission
  document.getElementById('reset-password-form').onsubmit = async (e) => {
    e.preventDefault();
    const newPassword = document.getElementById('reset-password-input').value;
    const confirmPassword = document.getElementById('reset-confirm-input').value;
    const errorDiv = document.getElementById('reset-error-message');
    const successDiv = document.getElementById('reset-success-message');
    const submitBtn = document.getElementById('reset-submit-btn');

    // Clear previous messages
    errorDiv.style.display = 'none';
    successDiv.style.display = 'none';

    // Validate passwords
    if (newPassword.length < 6) {
      errorDiv.textContent = 'Password must be at least 6 characters long.';
      errorDiv.style.display = 'block';
      return;
    }

    if (newPassword !== confirmPassword) {
      errorDiv.textContent = 'Passwords do not match.';
      errorDiv.style.display = 'block';
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Updating...';
    submitBtn.style.opacity = '0.7';
    submitBtn.style.cursor = 'not-allowed';

    try {
      // Update password using Supabase
      const { error } = await supabase.auth.updateUser({
        password: newPassword
      });

      if (error) {
        errorDiv.textContent = error.message || 'Failed to update password. Please try again.';
        errorDiv.style.display = 'block';
        submitBtn.disabled = false;
        submitBtn.textContent = 'Update Password';
        submitBtn.style.opacity = '1';
        submitBtn.style.cursor = 'pointer';
      } else {
        successDiv.textContent = 'Your password has been updated.';
        successDiv.style.display = 'block';

        // Clear URL hash to remove tokens
        window.history.replaceState(null, '', window.location.pathname);

        // Redirect to login after delay
        setTimeout(() => {
          window.renderLogin();
        }, 2000);
      }
    } catch (err) {
      errorDiv.textContent = err?.message || 'An unexpected error occurred. Please try again.';
      errorDiv.style.display = 'block';
      submitBtn.disabled = false;
      submitBtn.textContent = 'Update Password';
      submitBtn.style.opacity = '1';
      submitBtn.style.cursor = 'pointer';
    }
  };
}

// Render reset password error (invalid/expired link)
function renderResetPasswordError(message) {
  const container = document.getElementById('root');
  if (!container) return;

  container.innerHTML = `
    <div style="
      min-height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      padding: 1rem;
    ">
      <div style="
        background: ${colors.surface};
        padding: 2rem;
        border-radius: 1rem;
        box-shadow: 0 10px 25px rgba(0,0,0,0.1);
        width: 100%;
        max-width: 400px;
        margin: 1rem;
        text-align: center;
      ">
        <div style="font-size: 3rem; margin-bottom: 1rem;">⚠️</div>
        <h1 style="color: ${colors.text}; margin: 0 0 1rem 0; font-size: 1.5rem; font-weight: 700;">
          Invalid Reset Link
        </h1>
        <p style="color: ${colors.textSecondary}; margin: 0 0 1.5rem 0; font-size: 0.875rem;">
          ${message || 'This password reset link is invalid or has expired.'}
        </p>
        <button
          onclick="window.renderLogin(); return false;"
          style="
            width: 100%;
            background: #f59e0b;
            color: white;
            padding: 0.75rem;
            border: none;
            border-radius: 0.5rem;
            font-size: 1rem;
            font-weight: 600;
            cursor: pointer;
            transition: background-color 0.2s;
          "
          onmouseover="this.style.background='#d97706'"
          onmouseout="this.style.background='#f59e0b'"
        >
          Back to Sign In
        </button>
      </div>
    </div>
  `;
}

// Signup form data storage
let signupFormData = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  password: '',
  confirmPassword: '',
  passwordError: '',
  companyName: '',
  companyStreet: '',
  companyCity: '',
  companyState: '',
  companyZip: '',
  companyPhone: '',
  employeeCount: ''
};

// Show Create Account Screen - Step 1 (Personal Info)
window.showCreateAccountScreen = function () {
  const container = document.getElementById('root');
  if (!container) return;

  // Reset form data when starting fresh
  signupFormData = {
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    password: '',
    confirmPassword: '',
    passwordError: '',
    companyName: '',
    companyStreet: '',
    companyCity: '',
    companyState: '',
    companyZip: '',
    companyPhone: '',
    employeeCount: ''
  };

  renderSignupStep1();
}

// Account creation loading modal functions
window.showAccountCreationLoadingModal = function () {
  // Remove existing modal if any
  const existingModal = document.getElementById('account-creation-loading-modal');
  if (existingModal) {
    existingModal.remove();
  }

  const modal = document.createElement('div');
  modal.id = 'account-creation-loading-modal';
  modal.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999999;
    backdrop-filter: blur(8px);
  `;

  modal.innerHTML = `
    <div style="
      background: white;
      border-radius: 1rem;
      padding: 3rem 2.5rem;
      max-width: 500px;
      width: 90%;
      text-align: center;
      box-shadow: 0 20px 60px rgba(0,0,0,0.3);
    ">
      <div style="
        width: 80px;
        height: 80px;
        border: 4px solid #f3f4f6;
        border-top-color: #f59e0b;
        border-radius: 50%;
        margin: 0 auto 1.5rem;
        animation: spin 1s linear infinite;
      "></div>
      <h2 style="
        color: #0F172A;
        font-size: 1.5rem;
        font-weight: 700;
        margin: 0 0 0.5rem 0;
      " id="loading-title">Creating Your Account...</h2>
      <p style="
        color: #64748B;
        font-size: 1rem;
        margin: 0 0 1.5rem 0;
        line-height: 1.6;
      " id="loading-message">Setting up your profile and company...</p>
      <div style="
        background: #fef3c7;
        border-left: 4px solid #f59e0b;
        padding: 1rem;
        border-radius: 0.5rem;
        margin-top: 1.5rem;
        text-align: left;
      ">
        <p style="
          color: #92400E;
          font-size: 0.875rem;
          margin: 0;
          font-weight: 600;
        ">🎉 Enjoy your 60-day free trial!</p>
        <p style="
          color: #78350F;
          font-size: 0.8125rem;
          margin: 0.5rem 0 0 0;
        ">Get ready to handle all your business in one spot.</p>
      </div>
    </div>
    <style>
      @keyframes spin {
        to { transform: rotate(360deg); }
      }
    </style>
  `;

  document.body.appendChild(modal);
};

window.updateLoadingMessage = function (message) {
  const messageEl = document.getElementById('loading-message');
  if (messageEl) {
    messageEl.textContent = message;
  }

  const titleEl = document.getElementById('loading-title');
  if (titleEl) {
    if (message.includes('Creating your company')) {
      titleEl.textContent = 'Creating Your Company...';
    } else if (message.includes('Setting up your profile')) {
      titleEl.textContent = 'Setting Up Your Profile...';
    } else if (message.includes('Finalizing')) {
      titleEl.textContent = 'Almost Done!';
    } else {
      titleEl.textContent = 'Creating Your Account...';
    }
  }
};

window.closeAccountCreationLoadingModal = function () {
  const modal = document.getElementById('account-creation-loading-modal');
  if (modal) {
    modal.style.opacity = '0';
    modal.style.transition = 'opacity 0.3s ease';
    setTimeout(() => {
      modal.remove();
    }, 300);
  }
};

// Login loading modal functions
window.showLoginLoadingModal = function () {
  // Remove existing modal if any
  const existingModal = document.getElementById('login-loading-modal');
  if (existingModal) {
    existingModal.remove();
  }

  const modal = document.createElement('div');
  modal.id = 'login-loading-modal';
  modal.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999999;
    backdrop-filter: blur(8px);
  `;

  modal.innerHTML = `
    <div style="
      background: white;
      border-radius: 1rem;
      padding: 3rem 2.5rem;
      max-width: 400px;
      width: 90%;
      text-align: center;
      box-shadow: 0 20px 60px rgba(0,0,0,0.3);
    ">
      <div style="
        width: 60px;
        height: 60px;
        border: 4px solid #f3f4f6;
        border-top-color: #f59e0b;
        border-radius: 50%;
        margin: 0 auto 1.5rem;
        animation: spin 1s linear infinite;
      "></div>
      <h2 style="
        color: #0F172A;
        font-size: 1.25rem;
        font-weight: 700;
        margin: 0 0 0.5rem 0;
      ">Logging in...</h2>
      <p style="
        color: #64748B;
        font-size: 0.9375rem;
        margin: 0;
        line-height: 1.6;
      ">Please wait while we sign you in</p>
    </div>
    <style>
      @keyframes spin {
        to { transform: rotate(360deg); }
      }
    </style>
  `;

  document.body.appendChild(modal);
};

window.closeLoginLoadingModal = function () {
  const modal = document.getElementById('login-loading-modal');
  if (modal) {
    modal.style.opacity = '0';
    modal.style.transition = 'opacity 0.3s ease';
    setTimeout(() => {
      modal.remove();
    }, 300);
  }
};

// Client download app modal functions

window.renderSignupStep1 = function () {
  const container = document.getElementById('root');
  if (!container) return;

  container.innerHTML = `
    <div style="
      min-height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      padding: 1rem;
    ">
      <div style="
        background: ${colors.surface};
        padding: 2rem;
        border-radius: 1rem;
        box-shadow: 0 10px 25px rgba(0,0,0,0.1);
        width: 100%;
        max-width: 440px;
        margin: 1rem;
      ">
        <!-- Progress Indicator -->
        <div style="display: flex; align-items: center; justify-content: center; margin-bottom: 2rem;">
          <div style="display: flex; align-items: center; gap: 0.5rem;">
            <div style="
              width: 32px;
              height: 32px;
              border-radius: 50%;
              background: #f59e0b;
              color: white;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: 700;
              font-size: 0.875rem;
            ">1</div>
            <div style="width: 60px; height: 3px; background: #e5e7eb; border-radius: 2px;"></div>
            <div style="
              width: 32px;
              height: 32px;
              border-radius: 50%;
              background: #e5e7eb;
              color: #9ca3af;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: 700;
              font-size: 0.875rem;
            ">2</div>
          </div>
        </div>

        <div style="text-align: center; margin-bottom: 1.5rem;">
          <h1 style="color: ${colors.text}; margin: 0 0 0.375rem 0; font-size: 1.5rem; font-weight: 700;">
            Create Your Account
          </h1>
          <p style="color: ${colors.textSecondary}; margin: 0; font-size: 0.875rem;">
            Step 1: Personal Information
          </p>
        </div>

        <div id="signup-error-message" style="
          background: #fef2f2;
          border: 1px solid #fecaca;
          color: #dc2626;
          padding: 0.75rem;
          border-radius: 0.5rem;
          margin-bottom: 1rem;
          display: none;
          font-size: 0.875rem;
        "></div>

        <form id="signup-form-step1">
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 0.75rem; margin-bottom: 0.875rem;">
            <div>
              <label style="display: block; font-size: 0.75rem; font-weight: 600; color: ${colors.textSecondary}; margin-bottom: 0.25rem;">
                First Name <span style="color: #dc2626;">*</span>
              </label>
              <input
                type="text"
                id="signup-first-name"
                placeholder="John"
                required
                value="${signupFormData.firstName}"
                style="
                  width: 100%;
                  padding: 0.625rem 0.75rem;
                  border: 1px solid ${colors.border};
                  border-radius: 0.5rem;
                  font-size: 0.9375rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s;
                "
                onfocus="this.style.borderColor='#f59e0b'"
                onblur="this.style.borderColor='${colors.border}'"
              />
            </div>
            <div>
              <label style="display: block; font-size: 0.75rem; font-weight: 600; color: ${colors.textSecondary}; margin-bottom: 0.25rem;">
                Last Name <span style="color: #dc2626;">*</span>
              </label>
              <input
                type="text"
                id="signup-last-name"
                placeholder="Doe"
                required
                value="${signupFormData.lastName}"
                style="
                  width: 100%;
                  padding: 0.625rem 0.75rem;
                  border: 1px solid ${colors.border};
                  border-radius: 0.5rem;
                  font-size: 0.9375rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s;
                "
                onfocus="this.style.borderColor='#f59e0b'"
                onblur="this.style.borderColor='${colors.border}'"
              />
            </div>
          </div>
          
          <div style="margin-bottom: 0.875rem;">
            <label style="display: block; font-size: 0.75rem; font-weight: 600; color: ${colors.textSecondary}; margin-bottom: 0.25rem;">
              Email <span style="color: #dc2626;">*</span>
            </label>
            <input
              type="email"
              id="signup-email"
              placeholder="john@example.com"
              required
              value="${signupFormData.email}"
              style="
                width: 100%;
                padding: 0.625rem 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-size: 0.9375rem;
                box-sizing: border-box;
                transition: border-color 0.2s;
              "
              onfocus="this.style.borderColor='#f59e0b'"
              onblur="this.style.borderColor='${colors.border}'"
            />
          </div>

          <div style="margin-bottom: 0.875rem;">
            <label style="display: block; font-size: 0.75rem; font-weight: 600; color: ${colors.textSecondary}; margin-bottom: 0.25rem;">
              Phone Number <span style="color: #dc2626;">*</span>
            </label>
            <input
              type="tel"
              id="signup-phone"
              placeholder="(555) 123-4567"
              required
              maxlength="14"
              value="${signupFormData.phone}"
              style="
                width: 100%;
                padding: 0.625rem 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-size: 0.9375rem;
                box-sizing: border-box;
                transition: border-color 0.2s;
              "
              onfocus="this.style.borderColor='#f59e0b'"
              onblur="this.style.borderColor='${colors.border}'"
              oninput="formatPhoneNumber(this)"
            />
          </div>

          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 0.75rem; margin-bottom: 1.25rem;">
            <div>
              <label style="display: block; font-size: 0.75rem; font-weight: 600; color: ${colors.textSecondary}; margin-bottom: 0.25rem;">
                Password <span style="color: #dc2626;">*</span>
              </label>
              <input
                type="password"
                id="signup-password"
                placeholder="Password"
                required
                value="${signupFormData.password}"
                style="
                  width: 100%;
                  padding: 0.625rem 0.75rem;
                  border: 1px solid ${colors.border};
                  border-radius: 0.5rem;
                  font-size: 0.9375rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s;
                "
                onfocus="this.style.borderColor='#f59e0b'"
                onblur="this.style.borderColor='${colors.border}'"
              />
            </div>
            <div>
              <label style="display: block; font-size: 0.75rem; font-weight: 600; color: ${colors.textSecondary}; margin-bottom: 0.25rem;">
                Confirm Password <span style="color: #dc2626;">*</span>
              </label>
              <input
                type="password"
                id="signup-confirm-password"
                placeholder="Confirm Password"
                required
                value="${signupFormData.confirmPassword}"
                style="
                  width: 100%;
                  padding: 0.625rem 0.75rem;
                  border: 1px solid ${colors.border};
                  border-radius: 0.5rem;
                  font-size: 0.9375rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s;
                "
                onfocus="this.style.borderColor='#f59e0b'"
                onblur="this.style.borderColor='${colors.border}'"
              />
            </div>
          </div>

          <button
            type="submit"
            style="
              width: 100%;
              background: #f59e0b;
              color: white;
              padding: 0.75rem;
              border: none;
              border-radius: 0.5rem;
              font-size: 1rem;
              font-weight: 600;
              cursor: pointer;
              transition: background-color 0.2s;
            "
            onmouseover="this.style.background='#d97706'"
            onmouseout="this.style.background='#f59e0b'"
          >
            Continue →
          </button>
        </form>
        
        <div style="margin-top: 1.5rem; text-align: center;">
          <span style="color: ${colors.textSecondary}; font-size: 0.875rem;">Already have an account? </span>
          <a 
            href="#" 
            onclick="renderLogin(); return false;"
            style="
              color: #f59e0b;
              text-decoration: none;
              font-size: 0.875rem;
              font-weight: 600;
            "
            onmouseover="this.style.color='#d97706'"
            onmouseout="this.style.color='#f59e0b'"
          >
            Sign In
          </a>
        </div>
      </div>
    </div>
  `;

  // Check for password error from Step 2 and display it
  if (signupFormData.passwordError) {
    const errorDiv = document.getElementById('signup-error-message');
    const passwordInput = document.getElementById('signup-password');
    const confirmPasswordInput = document.getElementById('signup-confirm-password');

    errorDiv.textContent = signupFormData.passwordError;
    errorDiv.style.display = 'block';
    if (passwordInput) passwordInput.style.borderColor = '#dc2626';
    if (confirmPasswordInput) confirmPasswordInput.style.borderColor = '#dc2626';

    // Clear the error after displaying
    signupFormData.passwordError = '';
  }

  // Handle step 1 form submission
  document.getElementById('signup-form-step1').onsubmit = (e) => {
    e.preventDefault();
    const errorDiv = document.getElementById('signup-error-message');

    const firstNameInput = document.getElementById('signup-first-name');
    const lastNameInput = document.getElementById('signup-last-name');
    const emailInput = document.getElementById('signup-email');
    const phoneInput = document.getElementById('signup-phone');
    const passwordInput = document.getElementById('signup-password');
    const confirmPasswordInput = document.getElementById('signup-confirm-password');

    const firstName = firstNameInput.value.trim();
    const lastName = lastNameInput.value.trim();
    const email = emailInput.value.trim();
    const phone = phoneInput.value.trim();
    const password = passwordInput.value;
    const confirmPassword = confirmPasswordInput.value;

    // Reset all borders
    const allInputs = [firstNameInput, lastNameInput, emailInput, phoneInput, passwordInput, confirmPasswordInput];
    allInputs.forEach(input => input.style.borderColor = '#E5E7EB');
    errorDiv.style.display = 'none';

    // Track missing fields
    let hasError = false;
    let errorMessages = [];

    // Validate required fields
    if (!firstName) {
      firstNameInput.style.borderColor = '#dc2626';
      hasError = true;
    }
    if (!lastName) {
      lastNameInput.style.borderColor = '#dc2626';
      hasError = true;
    }
    if (!email) {
      emailInput.style.borderColor = '#dc2626';
      hasError = true;
    }
    if (!phone) {
      phoneInput.style.borderColor = '#dc2626';
      hasError = true;
    }
    if (!password) {
      passwordInput.style.borderColor = '#dc2626';
      hasError = true;
    }
    if (!confirmPassword) {
      confirmPasswordInput.style.borderColor = '#dc2626';
      hasError = true;
    }

    if (hasError) {
      errorDiv.textContent = 'Please fill in all required fields';
      errorDiv.style.display = 'block';
      return;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      emailInput.style.borderColor = '#dc2626';
      errorDiv.textContent = 'Please enter a valid email address';
      errorDiv.style.display = 'block';
      return;
    }

    // Validate password strength
    const passwordErrors = [];
    if (password.length < 8) {
      passwordErrors.push('at least 8 characters');
    }
    if (!/[A-Z]/.test(password)) {
      passwordErrors.push('one uppercase letter');
    }
    if (!/[a-z]/.test(password)) {
      passwordErrors.push('one lowercase letter');
    }
    if (!/[0-9]/.test(password)) {
      passwordErrors.push('one number');
    }
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
      passwordErrors.push('one special character');
    }

    if (passwordErrors.length > 0) {
      passwordInput.style.borderColor = '#dc2626';
      errorDiv.textContent = `Password must contain: ${passwordErrors.join(', ')}`;
      errorDiv.style.display = 'block';
      return;
    }

    // Validate passwords match
    if (password !== confirmPassword) {
      passwordInput.style.borderColor = '#dc2626';
      confirmPasswordInput.style.borderColor = '#dc2626';
      errorDiv.textContent = 'Passwords do not match';
      errorDiv.style.display = 'block';
      return;
    }

    // Store data and proceed to step 2
    signupFormData.firstName = firstName;
    signupFormData.lastName = lastName;
    signupFormData.email = email;
    signupFormData.phone = phone;
    signupFormData.password = password;
    signupFormData.confirmPassword = confirmPassword;

    renderSignupStep2();
  };
}

window.renderSignupStep2 = function () {
  const container = document.getElementById('root');
  if (!container) return;

  // Add Material Icons if not already added
  if (!document.querySelector('link[href*="Material+Icons"]')) {
    const materialIconsLink = document.createElement('link');
    materialIconsLink.href = 'https://fonts.googleapis.com/icon?family=Material+Icons';
    materialIconsLink.rel = 'stylesheet';
    document.head.appendChild(materialIconsLink);
  }

  container.innerHTML = `
    <div style="
      min-height: 100vh;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      padding: 1rem;
    ">
      <div style="
        background: ${colors.surface};
        padding: 2rem;
        border-radius: 1rem;
        box-shadow: 0 10px 25px rgba(0,0,0,0.1);
        width: 100%;
        max-width: 440px;
        margin: 1rem;
      ">
        <!-- Progress Indicator -->
        <div style="display: flex; align-items: center; justify-content: center; margin-bottom: 2rem;">
          <div style="display: flex; align-items: center; gap: 0.5rem;">
            <div style="
              width: 32px;
              height: 32px;
              border-radius: 50%;
              background: #10b981;
              color: white;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: 700;
              font-size: 0.875rem;
            ">✓</div>
            <div style="width: 60px; height: 3px; background: #10b981; border-radius: 2px;"></div>
            <div style="
              width: 32px;
              height: 32px;
              border-radius: 50%;
              background: #f59e0b;
              color: white;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: 700;
              font-size: 0.875rem;
            ">2</div>
          </div>
        </div>

        <div style="text-align: center; margin-bottom: 1.5rem;">
          <h1 style="color: ${colors.text}; margin: 0 0 0.375rem 0; font-size: 1.5rem; font-weight: 700;">
            Company Information
          </h1>
          <p style="color: ${colors.textSecondary}; margin: 0; font-size: 0.875rem;">
            Step 2: Tell us about your business
          </p>
        </div>

        <div id="signup-error-message" style="
          background: #fef2f2;
          border: 1px solid #fecaca;
          color: #dc2626;
          padding: 0.75rem;
          border-radius: 0.5rem;
          margin-bottom: 1rem;
          display: none;
          font-size: 0.875rem;
        "></div>

        <div id="signup-success-message" style="
          background: #ecfdf5;
          border: 1px solid #a7f3d0;
          color: #059669;
          padding: 0.75rem;
          border-radius: 0.5rem;
          margin-bottom: 1rem;
          display: none;
          font-size: 0.875rem;
        "></div>

        <form id="signup-form-step2">
          <div style="margin-bottom: 0.875rem;">
            <label style="display: block; font-size: 0.75rem; font-weight: 600; color: ${colors.textSecondary}; margin-bottom: 0.25rem;">
              Company Name <span style="color: #dc2626;">*</span>
            </label>
            <input
              type="text"
              id="signup-company-name"
              placeholder="Acme Corporation"
              required
              value="${signupFormData.companyName}"
              style="
                width: 100%;
                padding: 0.625rem 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-size: 0.9375rem;
                box-sizing: border-box;
                transition: border-color 0.2s;
              "
              onfocus="this.style.borderColor='#f59e0b'"
              onblur="this.style.borderColor='${colors.border}'"
            />
          </div>

          <div style="margin-bottom: 0.875rem;">
            <label style="display: block; font-size: 0.75rem; font-weight: 600; color: ${colors.textSecondary}; margin-bottom: 0.25rem;">
              Street Address <span style="color: #dc2626;">*</span>
            </label>
            <input
              type="text"
              id="signup-company-street"
              placeholder="123 Main St"
              required
              value="${signupFormData.companyStreet}"
              style="
                width: 100%;
                padding: 0.625rem 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-size: 0.9375rem;
                box-sizing: border-box;
                transition: border-color 0.2s;
              "
              onfocus="this.style.borderColor='#f59e0b'"
              onblur="this.style.borderColor='${colors.border}'"
            />
          </div>

          <div style="display: grid; grid-template-columns: 2fr 1fr 1fr; gap: 0.5rem; margin-bottom: 0.875rem;">
            <div>
              <label style="display: block; font-size: 0.75rem; font-weight: 600; color: ${colors.textSecondary}; margin-bottom: 0.25rem;">
                City <span style="color: #dc2626;">*</span>
              </label>
              <input
                type="text"
                id="signup-company-city"
                placeholder="City"
                required
                value="${signupFormData.companyCity}"
                style="
                  width: 100%;
                  padding: 0.625rem 0.75rem;
                  border: 1px solid ${colors.border};
                  border-radius: 0.5rem;
                  font-size: 0.9375rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s;
                "
                onfocus="this.style.borderColor='#f59e0b'"
                onblur="this.style.borderColor='${colors.border}'"
              />
            </div>
            <div>
              <label style="display: block; font-size: 0.75rem; font-weight: 600; color: ${colors.textSecondary}; margin-bottom: 0.25rem;">
                State <span style="color: #dc2626;">*</span>
              </label>
              <select
                id="signup-company-state"
                required
                style="
                  width: 100%;
                  padding: 0.625rem 0.5rem;
                  border: 1px solid ${colors.border};
                  border-radius: 0.5rem;
                  font-size: 0.9375rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s;
                  background: white;
                  cursor: pointer;
                "
                onfocus="this.style.borderColor='#f59e0b'"
                onblur="this.style.borderColor='${colors.border}'"
              >
                <option value="">--</option>
                <option value="AL" ${signupFormData.companyState === 'AL' ? 'selected' : ''}>AL</option>
                <option value="AK" ${signupFormData.companyState === 'AK' ? 'selected' : ''}>AK</option>
                <option value="AZ" ${signupFormData.companyState === 'AZ' ? 'selected' : ''}>AZ</option>
                <option value="AR" ${signupFormData.companyState === 'AR' ? 'selected' : ''}>AR</option>
                <option value="CA" ${signupFormData.companyState === 'CA' ? 'selected' : ''}>CA</option>
                <option value="CO" ${signupFormData.companyState === 'CO' ? 'selected' : ''}>CO</option>
                <option value="CT" ${signupFormData.companyState === 'CT' ? 'selected' : ''}>CT</option>
                <option value="DE" ${signupFormData.companyState === 'DE' ? 'selected' : ''}>DE</option>
                <option value="FL" ${signupFormData.companyState === 'FL' ? 'selected' : ''}>FL</option>
                <option value="GA" ${signupFormData.companyState === 'GA' ? 'selected' : ''}>GA</option>
                <option value="HI" ${signupFormData.companyState === 'HI' ? 'selected' : ''}>HI</option>
                <option value="ID" ${signupFormData.companyState === 'ID' ? 'selected' : ''}>ID</option>
                <option value="IL" ${signupFormData.companyState === 'IL' ? 'selected' : ''}>IL</option>
                <option value="IN" ${signupFormData.companyState === 'IN' ? 'selected' : ''}>IN</option>
                <option value="IA" ${signupFormData.companyState === 'IA' ? 'selected' : ''}>IA</option>
                <option value="KS" ${signupFormData.companyState === 'KS' ? 'selected' : ''}>KS</option>
                <option value="KY" ${signupFormData.companyState === 'KY' ? 'selected' : ''}>KY</option>
                <option value="LA" ${signupFormData.companyState === 'LA' ? 'selected' : ''}>LA</option>
                <option value="ME" ${signupFormData.companyState === 'ME' ? 'selected' : ''}>ME</option>
                <option value="MD" ${signupFormData.companyState === 'MD' ? 'selected' : ''}>MD</option>
                <option value="MA" ${signupFormData.companyState === 'MA' ? 'selected' : ''}>MA</option>
                <option value="MI" ${signupFormData.companyState === 'MI' ? 'selected' : ''}>MI</option>
                <option value="MN" ${signupFormData.companyState === 'MN' ? 'selected' : ''}>MN</option>
                <option value="MS" ${signupFormData.companyState === 'MS' ? 'selected' : ''}>MS</option>
                <option value="MO" ${signupFormData.companyState === 'MO' ? 'selected' : ''}>MO</option>
                <option value="MT" ${signupFormData.companyState === 'MT' ? 'selected' : ''}>MT</option>
                <option value="NE" ${signupFormData.companyState === 'NE' ? 'selected' : ''}>NE</option>
                <option value="NV" ${signupFormData.companyState === 'NV' ? 'selected' : ''}>NV</option>
                <option value="NH" ${signupFormData.companyState === 'NH' ? 'selected' : ''}>NH</option>
                <option value="NJ" ${signupFormData.companyState === 'NJ' ? 'selected' : ''}>NJ</option>
                <option value="NM" ${signupFormData.companyState === 'NM' ? 'selected' : ''}>NM</option>
                <option value="NY" ${signupFormData.companyState === 'NY' ? 'selected' : ''}>NY</option>
                <option value="NC" ${signupFormData.companyState === 'NC' ? 'selected' : ''}>NC</option>
                <option value="ND" ${signupFormData.companyState === 'ND' ? 'selected' : ''}>ND</option>
                <option value="OH" ${signupFormData.companyState === 'OH' ? 'selected' : ''}>OH</option>
                <option value="OK" ${signupFormData.companyState === 'OK' ? 'selected' : ''}>OK</option>
                <option value="OR" ${signupFormData.companyState === 'OR' ? 'selected' : ''}>OR</option>
                <option value="PA" ${signupFormData.companyState === 'PA' ? 'selected' : ''}>PA</option>
                <option value="RI" ${signupFormData.companyState === 'RI' ? 'selected' : ''}>RI</option>
                <option value="SC" ${signupFormData.companyState === 'SC' ? 'selected' : ''}>SC</option>
                <option value="SD" ${signupFormData.companyState === 'SD' ? 'selected' : ''}>SD</option>
                <option value="TN" ${signupFormData.companyState === 'TN' ? 'selected' : ''}>TN</option>
                <option value="TX" ${signupFormData.companyState === 'TX' ? 'selected' : ''}>TX</option>
                <option value="UT" ${signupFormData.companyState === 'UT' ? 'selected' : ''}>UT</option>
                <option value="VT" ${signupFormData.companyState === 'VT' ? 'selected' : ''}>VT</option>
                <option value="VA" ${signupFormData.companyState === 'VA' ? 'selected' : ''}>VA</option>
                <option value="WA" ${signupFormData.companyState === 'WA' ? 'selected' : ''}>WA</option>
                <option value="WV" ${signupFormData.companyState === 'WV' ? 'selected' : ''}>WV</option>
                <option value="WI" ${signupFormData.companyState === 'WI' ? 'selected' : ''}>WI</option>
                <option value="WY" ${signupFormData.companyState === 'WY' ? 'selected' : ''}>WY</option>
                <option value="DC" ${signupFormData.companyState === 'DC' ? 'selected' : ''}>DC</option>
              </select>
            </div>
            <div>
              <label style="display: block; font-size: 0.75rem; font-weight: 600; color: ${colors.textSecondary}; margin-bottom: 0.25rem;">
                ZIP <span style="color: #dc2626;">*</span>
              </label>
              <input
                type="text"
                id="signup-company-zip"
                placeholder="12345"
                required
                maxlength="10"
                value="${signupFormData.companyZip}"
                style="
                  width: 100%;
                  padding: 0.625rem 0.75rem;
                  border: 1px solid ${colors.border};
                  border-radius: 0.5rem;
                  font-size: 0.9375rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s;
                "
                onfocus="this.style.borderColor='#f59e0b'"
                onblur="this.style.borderColor='${colors.border}'"
              />
            </div>
          </div>

          <div style="margin-bottom: 0.875rem;">
            <label style="display: block; font-size: 0.75rem; font-weight: 600; color: ${colors.textSecondary}; margin-bottom: 0.25rem;">
              Company Phone Number <span style="color: #dc2626;">*</span>
            </label>
            <input
              type="tel"
              id="signup-company-phone"
              placeholder="(555) 987-6543"
              required
              maxlength="14"
              value="${signupFormData.companyPhone}"
              style="
                width: 100%;
                padding: 0.625rem 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-size: 0.9375rem;
                box-sizing: border-box;
                transition: border-color 0.2s;
              "
              onfocus="this.style.borderColor='#f59e0b'"
              onblur="this.style.borderColor='${colors.border}'"
              oninput="formatPhoneNumber(this)"
            />
          </div>

          <div style="margin-bottom: 1.25rem;">
            <label style="display: block; font-size: 0.75rem; font-weight: 600; color: ${colors.textSecondary}; margin-bottom: 0.5rem;">
              Number of Employees <span style="color: #dc2626;">*</span>
            </label>
            <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.5rem;">
              <button
                type="button"
                onclick="selectEmployeeCount('1-10')"
                id="emp-1-10"
                style="
                  padding: 0.75rem;
                  border: 2px solid ${signupFormData.employeeCount === '1-10' ? '#f59e0b' : colors.border};
                  background: ${signupFormData.employeeCount === '1-10' ? '#fef3c7' : 'white'};
                  border-radius: 0.5rem;
                  font-size: 0.875rem;
                  font-weight: 600;
                  cursor: pointer;
                  transition: all 0.2s;
                  color: ${colors.text};
                "
              >
                <span class="material-icons" style="font-size: 1.5rem; color: #f59e0b; display: block; margin-bottom: 0.25rem;">person</span>
                1 - 10
              </button>
              <button
                type="button"
                onclick="selectEmployeeCount('11-25')"
                id="emp-11-25"
                style="
                  padding: 0.75rem;
                  border: 2px solid ${signupFormData.employeeCount === '11-25' ? '#f59e0b' : colors.border};
                  background: ${signupFormData.employeeCount === '11-25' ? '#fef3c7' : 'white'};
                  border-radius: 0.5rem;
                  font-size: 0.875rem;
                  font-weight: 600;
                  cursor: pointer;
                  transition: all 0.2s;
                  color: ${colors.text};
                "
              >
                <span class="material-icons" style="font-size: 1.5rem; color: #f59e0b; display: block; margin-bottom: 0.25rem;">group</span>
                11 - 25
              </button>
              <button
                type="button"
                onclick="selectEmployeeCount('26-50')"
                id="emp-26-50"
                style="
                  padding: 0.75rem;
                  border: 2px solid ${signupFormData.employeeCount === '26-50' ? '#f59e0b' : colors.border};
                  background: ${signupFormData.employeeCount === '26-50' ? '#fef3c7' : 'white'};
                  border-radius: 0.5rem;
                  font-size: 0.875rem;
                  font-weight: 600;
                  cursor: pointer;
                  transition: all 0.2s;
                  color: ${colors.text};
                "
              >
                <span class="material-icons" style="font-size: 1.5rem; color: #f59e0b; display: block; margin-bottom: 0.25rem;">groups</span>
                26 - 50
              </button>
              <button
                type="button"
                onclick="selectEmployeeCount('50+')"
                id="emp-50+"
                style="
                  padding: 0.75rem;
                  border: 2px solid ${signupFormData.employeeCount === '50+' ? '#f59e0b' : colors.border};
                  background: ${signupFormData.employeeCount === '50+' ? '#fef3c7' : 'white'};
                  border-radius: 0.5rem;
                  font-size: 0.875rem;
                  font-weight: 600;
                  cursor: pointer;
                  transition: all 0.2s;
                  color: ${colors.text};
                "
              >
                <span class="material-icons" style="font-size: 1.5rem; color: #f59e0b; display: block; margin-bottom: 0.25rem;">business</span>
                50+
              </button>
            </div>
            <input type="hidden" id="signup-employee-count" value="${signupFormData.employeeCount}" required />
          </div>

          <div style="display: flex; gap: 0.75rem;">
            <button
              type="button"
              onclick="goBackToStep1()"
              style="
                flex: 1;
                background: transparent;
                color: ${colors.textSecondary};
                padding: 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-size: 1rem;
                font-weight: 600;
                cursor: pointer;
                transition: all 0.2s;
              "
              onmouseover="this.style.borderColor='#f59e0b'; this.style.color='#f59e0b'"
              onmouseout="this.style.borderColor='${colors.border}'; this.style.color='${colors.textSecondary}'"
            >
              ← Back
            </button>
            <button
              type="submit"
              id="signup-submit-btn"
              style="
                flex: 2;
                background: #f59e0b;
                color: white;
                padding: 0.75rem;
                border: none;
                border-radius: 0.5rem;
                font-size: 1rem;
                font-weight: 600;
                cursor: pointer;
                transition: background-color 0.2s;
              "
              onmouseover="this.style.background='#d97706'"
              onmouseout="this.style.background='#f59e0b'"
            >
              Create Account
            </button>
          </div>
        </form>
      </div>
    </div>
  `;

  // Handle step 2 form submission
  document.getElementById('signup-form-step2').onsubmit = async (e) => {
    e.preventDefault();
    const errorDiv = document.getElementById('signup-error-message');
    const successDiv = document.getElementById('signup-success-message');
    const submitBtn = document.getElementById('signup-submit-btn');

    const companyNameInput = document.getElementById('signup-company-name');
    const companyStreetInput = document.getElementById('signup-company-street');
    const companyCityInput = document.getElementById('signup-company-city');
    const companyStateInput = document.getElementById('signup-company-state');
    const companyZipInput = document.getElementById('signup-company-zip');
    const companyPhoneInput = document.getElementById('signup-company-phone');

    const companyName = companyNameInput.value.trim();
    const companyStreet = companyStreetInput.value.trim();
    const companyCity = companyCityInput.value.trim();
    const companyState = companyStateInput.value;
    const companyZip = companyZipInput.value.trim();
    const companyPhone = companyPhoneInput.value.trim();
    const employeeCount = document.getElementById('signup-employee-count').value;

    // Reset all borders
    companyNameInput.style.borderColor = '#E5E7EB';
    companyStreetInput.style.borderColor = '#E5E7EB';
    companyCityInput.style.borderColor = '#E5E7EB';
    companyStateInput.style.borderColor = '#E5E7EB';
    companyZipInput.style.borderColor = '#E5E7EB';
    companyPhoneInput.style.borderColor = '#E5E7EB';
    errorDiv.style.display = 'none';

    // Validate required fields
    let hasError = false;

    if (!companyName) {
      companyNameInput.style.borderColor = '#dc2626';
      hasError = true;
    }
    if (!companyStreet) {
      companyStreetInput.style.borderColor = '#dc2626';
      hasError = true;
    }
    if (!companyCity) {
      companyCityInput.style.borderColor = '#dc2626';
      hasError = true;
    }
    if (!companyState) {
      companyStateInput.style.borderColor = '#dc2626';
      hasError = true;
    }
    if (!companyZip) {
      companyZipInput.style.borderColor = '#dc2626';
      hasError = true;
    }
    if (!companyPhone) {
      companyPhoneInput.style.borderColor = '#dc2626';
      hasError = true;
    }
    if (!employeeCount) {
      hasError = true;
    }

    if (hasError) {
      if (!employeeCount) {
        errorDiv.textContent = 'Please fill in all fields and select the number of employees';
      } else {
        errorDiv.textContent = 'Please fill in all required fields';
      }
      errorDiv.style.display = 'block';
      return;
    }

    // Store data
    signupFormData.companyName = companyName;
    signupFormData.companyStreet = companyStreet;
    signupFormData.companyCity = companyCity;
    signupFormData.companyState = companyState;
    signupFormData.companyZip = companyZip;
    signupFormData.companyPhone = companyPhone;
    signupFormData.employeeCount = employeeCount;

    submitBtn.disabled = true;
    submitBtn.textContent = 'Creating Account...';
    submitBtn.style.opacity = '0.7';
    submitBtn.style.cursor = 'not-allowed';

    // Show loading modal immediately
    showAccountCreationLoadingModal();

    try {
      console.log('📝 Starting account creation...');

      // Update loading message
      updateLoadingMessage('Creating your account...');
      await new Promise(resolve => setTimeout(resolve, 800));

      // Create the user account
      const { data, error } = await supabase.auth.signUp({
        email: signupFormData.email,
        password: signupFormData.password,
        options: {
          data: {
            first_name: signupFormData.firstName,
            last_name: signupFormData.lastName,
            phone: signupFormData.phone
          }
        }
      });

      console.log('📝 SignUp response:', { data, error });

      if (error) {
        // If password is rejected by Supabase, go back to Step 1 with error message
        // Close loading modal on error
        closeAccountCreationLoadingModal();

        if (error.message && (error.message.toLowerCase().includes('weak') || error.message.toLowerCase().includes('password'))) {
          console.log('⚠️ Password rejected by Supabase, returning to Step 1');
          console.log('⚠️ Supabase error:', error.message);
          // Store password error to show on Step 1
          signupFormData.passwordError = 'Password rejected. Try a longer password (12+ chars) with mixed case, numbers, and special characters. Avoid common words like "test" or "password". Example: "MySecure2024!Pass"';
          goBackToStep1();
          return;
        }

        // For other errors, show generic message
        errorDiv.textContent = 'An error occurred. Please try again or contact support.';
        errorDiv.style.display = 'block';
        successDiv.style.display = 'none';
        submitBtn.disabled = false;
        submitBtn.textContent = 'Create Account';
        submitBtn.style.opacity = '1';
        submitBtn.style.cursor = 'pointer';
        return;
      }

      if (data.user) {
        console.log('✅ User created:', data.user.id);

        // Create profile immediately (even if email not verified)
        console.log('📝 Creating profile for user:', data.user.id);
        const { error: profileCreateError } = await supabase
          .from('profiles')
          .upsert({
            id: data.user.id,
            first_name: signupFormData.firstName,
            last_name: signupFormData.lastName,
            phone: signupFormData.phone
          }, {
            onConflict: 'id'
          });

        if (profileCreateError) {
          // Close loading modal on error
          closeAccountCreationLoadingModal();

          console.error('❌ Failed to create profile:', profileCreateError);
          console.error('❌ Profile error details:', JSON.stringify(profileCreateError, null, 2));
          errorDiv.textContent = `Failed to create profile. Error: ${profileCreateError.message}. Please contact support if this persists.`;
          errorDiv.style.display = 'block';
          submitBtn.disabled = false;
          submitBtn.textContent = 'Create Account';
          submitBtn.style.opacity = '1';
          submitBtn.style.cursor = 'pointer';
          return;
        }
        console.log('✅ Profile created/updated');

        // Store signup data in localStorage for completion after email verification
        const pendingSignupData = {
          userId: data.user.id,
          companyName: signupFormData.companyName,
          companyStreet: signupFormData.companyStreet,
          companyCity: signupFormData.companyCity,
          companyState: signupFormData.companyState,
          companyZip: signupFormData.companyZip,
          companyPhone: signupFormData.companyPhone,
          employeeCount: signupFormData.employeeCount,
          firstName: signupFormData.firstName,
          lastName: signupFormData.lastName,
          phone: signupFormData.phone
        };
        localStorage.setItem('pendingSignupData', JSON.stringify(pendingSignupData));
        console.log('📝 Stored pending signup data for post-verification completion');

        // Update loading message
        updateLoadingMessage('Setting up your profile...');
        await new Promise(resolve => setTimeout(resolve, 800));

        // ALWAYS try to create company immediately (even if email verification is required)
        // The company will be created when user logs in if this fails due to no session
        console.log('📝 Attempting to create company immediately...');
        updateLoadingMessage('Creating your company...');
        await new Promise(resolve => setTimeout(resolve, 800));

        const setupSuccess = await completeAccountSetup(data.user.id, signupFormData);

        if (!setupSuccess) {
          console.warn('⚠️ Company setup failed - will retry on login');
          // Don't show error to user - it will complete on login
          // The pendingSignupData is already stored in localStorage above
        } else {
          console.log('✅ Full account setup completed successfully - company created and linked!');
        }

        // Update loading message
        updateLoadingMessage('Finalizing your workspace...');
        await new Promise(resolve => setTimeout(resolve, 1000));

        // Close loading modal and refresh page
        closeAccountCreationLoadingModal();

        // Small delay before refresh to ensure everything is saved
        await new Promise(resolve => setTimeout(resolve, 500));

        // Refresh the page to load the new account
        window.location.reload();
      }
    } catch (err) {
      // Close loading modal on error
      closeAccountCreationLoadingModal();

      errorDiv.textContent = err?.message || 'Failed to create account';
      errorDiv.style.display = 'block';
      successDiv.style.display = 'none';
    } finally {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Create Account';
      submitBtn.style.opacity = '1';
      submitBtn.style.cursor = 'pointer';
    }
  };
}

// Helper function to select employee count
window.selectEmployeeCount = function (count) {
  signupFormData.employeeCount = count;
  document.getElementById('signup-employee-count').value = count;

  // Update button styles
  const counts = ['1-10', '11-25', '26-50', '50+'];
  counts.forEach(c => {
    const btn = document.getElementById(`emp-${c}`);
    if (btn) {
      if (c === count) {
        btn.style.borderColor = '#f59e0b';
        btn.style.background = '#fef3c7';
      } else {
        btn.style.borderColor = '#E5E7EB';
        btn.style.background = 'white';
      }
    }
  });
};

// Helper function to go back to step 1
window.goBackToStep1 = function () {
  // Save current step 2 data
  signupFormData.companyName = document.getElementById('signup-company-name')?.value || '';
  signupFormData.companyStreet = document.getElementById('signup-company-street')?.value || '';
  signupFormData.companyCity = document.getElementById('signup-company-city')?.value || '';
  signupFormData.companyState = document.getElementById('signup-company-state')?.value || '';
  signupFormData.companyZip = document.getElementById('signup-company-zip')?.value || '';
  signupFormData.companyPhone = document.getElementById('signup-company-phone')?.value || '';

  renderSignupStep1();
};

// Phone number formatter function
window.formatPhoneNumber = function (input) {
  // Remove all non-digits
  let value = input.value.replace(/\D/g, '');

  // Limit to 10 digits
  if (value.length > 10) {
    value = value.substring(0, 10);
  }

  // Format as (XXX) XXX-XXXX
  if (value.length >= 6) {
    input.value = `(${value.substring(0, 3)}) ${value.substring(3, 6)}-${value.substring(6)}`;
  } else if (value.length >= 3) {
    input.value = `(${value.substring(0, 3)}) ${value.substring(3)}`;
  } else if (value.length > 0) {
    input.value = `(${value}`;
  } else {
    input.value = '';
  }
};

// Complete account setup after email verification
async function completeAccountSetup(userId, signupData) {
  console.log('🔧 Starting account setup for user:', userId);
  console.log('📋 Signup data:', {
    companyName: signupData.companyName,
    companyStreet: signupData.companyStreet,
    companyCity: signupData.companyCity,
    companyState: signupData.companyState,
    companyZip: signupData.companyZip,
    companyPhone: signupData.companyPhone,
    employeeCount: signupData.employeeCount,
    firstName: signupData.firstName,
    lastName: signupData.lastName
  });

  try {
    console.log('📝 Creating company:', signupData.companyName);
    console.log('📝 Company data being inserted:', {
      name: signupData.companyName,
      street_address: signupData.companyStreet,
      city: signupData.companyCity,
      state: signupData.companyState,
      zip: signupData.companyZip,
      company_phone: signupData.companyPhone,
      employee_size: signupData.employeeCount,
      owner_id: userId
    });

    // Create the company record with correct column names (NO address column)
    // Auto-mark as HH client so they can chat with HH and be tracked in CRM
    const { data: companyData, error: companyError } = await supabase
      .from('companies')
      .insert({
        name: signupData.companyName,
        street_address: signupData.companyStreet,
        city: signupData.companyCity,
        state: signupData.companyState,
        zip: signupData.companyZip,
        company_phone: signupData.companyPhone,
        employee_size: signupData.employeeCount, // This is an enum: '1-10', '11-25', '26-50', '50+'
        owner_id: userId,
        is_hh_client: true  // ✅ Auto-mark as HH client (trigger will auto-create/link contact)
      })
      .select()
      .single();

    if (companyError) {
      console.error('❌ Failed to create company:', companyError);
      console.error('❌ Company error details:', JSON.stringify(companyError, null, 2));
      // Try minimal company creation (just name and owner)
      console.log('📝 Attempting fallback company creation with minimal fields...');
      const { data: companyData2, error: companyError2 } = await supabase
        .from('companies')
        .insert({
          name: signupData.companyName,
          owner_id: userId,
          is_hh_client: true  // ✅ Auto-mark as HH client (trigger will auto-create/link contact)
        })
        .select()
        .single();

      if (companyError2) {
        console.error('❌ Failed to create company (fallback):', companyError2);
        console.error('❌ Fallback error details:', JSON.stringify(companyError2, null, 2));
        return false;
      }

      if (companyData2) {
        console.log('✅ Company created (fallback - minimal):', companyData2.id);
        // Try to update with additional fields if they exist
        await supabase
          .from('companies')
          .update({
            street_address: signupData.companyStreet,
            city: signupData.companyCity,
            state: signupData.companyState,
            zip: signupData.companyZip,
            company_phone: signupData.companyPhone,
            employee_size: signupData.employeeCount
          })
          .eq('id', companyData2.id);
        const memberSetupSuccess = await setupCompanyMember(companyData2.id, userId, signupData);
        if (!memberSetupSuccess) {
          console.error('❌ Failed to link user to company - member/profile setup failed');
          return false;
        }
      }
    } else if (companyData) {
      console.log('✅ Company created:', companyData.id);
      const memberSetupSuccess = await setupCompanyMember(companyData.id, userId, signupData);
      if (!memberSetupSuccess) {
        console.error('❌ Failed to link user to company - member/profile setup failed');
        return false;
      }
    } else {
      console.error('❌ No company data returned and no error - unexpected state');
      return false;
    }

    // Clear pending signup data
    localStorage.removeItem('pendingSignupData');
    console.log('✅ Account setup complete - user linked to company');
    return true;
  } catch (err) {
    console.error('❌ Error in completeAccountSetup:', err);
    return false;
  }
}

// Helper to set up company member and profile
async function setupCompanyMember(companyId, userId, signupData) {
  console.log('📝 Setting up company member for company:', companyId);

  // Add the user as an OWNER in company_members (without optional fields that don't exist)
  // Note: Trigger will also create this, but we do it here explicitly to handle RLS
  // Using ON CONFLICT to handle race conditions with trigger
  const { data: memberData, error: memberError } = await supabase
    .from('company_members')
    .insert({
      company_id: companyId,
      user_id: userId,
      role: 'OWNER'
    })
    .select()
    .single();

  if (memberError) {
    // If error is conflict (already exists), that's OK - trigger may have created it
    if (memberError.code === '23505') { // Unique violation
      console.log('ℹ️ Company member already exists (likely created by trigger):', memberError.message);
    } else {
      console.error('❌ Failed to create company member:', memberError);
      console.error('❌ Member error details:', JSON.stringify(memberError, null, 2));
      // Don't return false - trigger should handle it
    }
  } else {
    console.log('✅ Company member created with OWNER role:', memberData);
  }

  // Update the user's profile with the company_id
  console.log('📝 Updating profile with company_id:', companyId);
  const { data: profileData, error: profileError } = await supabase
    .from('profiles')
    .update({
      company_id: companyId,
      first_name: signupData.firstName,
      last_name: signupData.lastName,
      phone: signupData.phone
    })
    .eq('id', userId)
    .select()
    .single();

  if (profileError) {
    console.error('❌ Failed to update profile:', profileError);
    console.error('❌ Profile error details:', JSON.stringify(profileError, null, 2));
    return false;
  } else {
    console.log('✅ Profile updated with company_id:', profileData);
    return true;
  }
}

// Check for pending signup and complete it
async function checkAndCompletePendingSignup() {
  const pendingData = localStorage.getItem('pendingSignupData');
  if (!pendingData) {
    console.log('📝 No pending signup data found');
    return;
  }

  console.log('📝 Found pending signup data, attempting to complete...');

  try {
    const signupData = JSON.parse(pendingData);
    const { data: { user }, error: userError } = await supabase.auth.getUser();

    if (userError) {
      console.error('❌ Error getting user:', userError);
      return;
    }

    if (!user) {
      console.log('📝 No authenticated user, cannot complete signup');
      return;
    }

    if (user.id !== signupData.userId) {
      console.log('📝 User ID mismatch, clearing stale pending data');
      localStorage.removeItem('pendingSignupData');
      return;
    }

    // Check if user already has a company
    const { data: existingMember, error: memberCheckError } = await supabase
      .from('company_members')
      .select('id, company_id')
      .eq('user_id', user.id)
      .maybeSingle();

    if (memberCheckError && memberCheckError.code !== 'PGRST116') {
      console.error('❌ Error checking company membership:', memberCheckError);
    }

    if (!existingMember) {
      console.log('📝 User has no company, completing setup...');
      const success = await completeAccountSetup(user.id, signupData);
      if (success) {
        console.log('✅ Pending signup completed successfully');
      } else {
        console.warn('⚠️ Pending signup completion failed, will retry on next login');
      }
    } else {
      console.log('✅ User already has a company, clearing pending data');
      localStorage.removeItem('pendingSignupData');
    }
  } catch (err) {
    console.error('❌ Error checking pending signup:', err);
    console.error('❌ Error details:', JSON.stringify(err, null, 2));
  }
}

// Persistent scroll position storage per chat
if (!window.chatScrollPositions) {
  window.chatScrollPositions = {};
}

// Render Main App with Navigation
async function renderPMTool() {
  const container = document.getElementById('root');
  if (!container) return;

  // Save scroll position BEFORE rendering (critical - must happen before innerHTML is replaced)
  let savedScrollPosition = null;
  let wasNearBottom = false;
  if (currentScreen === 'chat' && selectedChatId) {
    const messagesContainer = document.getElementById('chat-messages-container');
    if (messagesContainer) {
      // Save current scroll position to persistent storage
      savedScrollPosition = messagesContainer.scrollTop;
      const scrollHeight = messagesContainer.scrollHeight;
      const clientHeight = messagesContainer.clientHeight;
      wasNearBottom = (scrollHeight - savedScrollPosition - clientHeight) < 100;

      // Store in persistent storage
      window.chatScrollPositions[selectedChatId] = {
        position: savedScrollPosition,
        wasNearBottom: wasNearBottom,
        scrollHeight: scrollHeight
      };
    } else {
      // No container yet, try to get from persistent storage
      const stored = window.chatScrollPositions[selectedChatId];
      if (stored) {
        savedScrollPosition = stored.position;
        wasNearBottom = stored.wasNearBottom;
      }
    }

    // Also check if selectChat stored scroll info
    if (window.chatScrollInfo && window.chatScrollInfo.chatId === selectedChatId) {
      savedScrollPosition = window.chatScrollInfo.position;
      wasNearBottom = window.chatScrollInfo.wasNearBottom;
    }
  }

  // Add Material Icons if not already added
  if (!document.querySelector('link[href*="Material+Icons"]')) {
    const materialIconsLink = document.createElement('link');
    materialIconsLink.href = 'https://fonts.googleapis.com/icon?family=Material+Icons';
    materialIconsLink.rel = 'stylesheet';
    document.head.appendChild(materialIconsLink);
  }

  // Check if user is CLIENT
  const userRole = currentProfile?.company_role || currentProfile?.role || 'USER';
  const isClient = userRole === 'CLIENT';

  // For CLIENTs, default to dashboard only if on an invalid screen or if screen is 'team'
  // Allowed: dashboard, chat, vault (Documents), profile
  if (isClient) {
    if (!['dashboard', 'chat', 'vault', 'profile'].includes(currentScreen) || currentScreen === 'team') {
      currentScreen = 'dashboard';
    }
  }

  // Preload intake submissions so Website Requests button shows open count (owners/managers see the button)
  if ((userRole === 'OWNER' || userRole === 'MANAGER' || currentProfile?.is_hh_admin || currentUser?.is_hh_admin) && !intakeSubmissionsHasLoaded && !intakeSubmissionsLoading) {
    loadIntakeSubmissions();
  }

  try {
    let screenContent;
    switch (currentScreen) {
      case 'dashboard':
        screenContent = renderDashboardScreen();
        break;
      case 'team':
        screenContent = isClient ? renderDashboardScreen() : await renderTeamScreen();
        break;
      case 'sales':
        screenContent = isClient ? renderDashboardScreen() : await renderSalesScreen();
        break;
      case 'chat':
        screenContent = await renderChatScreen();
        break;
      case 'calendar':
        screenContent = isClient ? renderDashboardScreen() : await renderCalendarScreen();
        break;
      case 'vault':
        screenContent = await renderVaultScreen();
        break;
      case 'checklist':
        screenContent = isClient ? renderDashboardScreen() : await renderChecklistScreen();
        break;
      case 'profile':
        screenContent = renderProfileScreen();
        break;
      case 'feedback':
        screenContent = isClient ? renderDashboardScreen() : await renderFeedbackScreen();
        break;
      case 'resources':
        screenContent = isClient ? renderDashboardScreen() : renderResourcesScreen();
        break;
      case 'time-tracking':
        screenContent = isClient ? renderDashboardScreen() : renderTimeTrackingScreen();
        break;
      default:
        screenContent = isClient ? renderDashboardScreen() : await renderTeamScreen();
    }

    container.innerHTML = `
    <style>
      body, html {
        overflow-x: hidden !important;
        max-width: 100vw !important;
      }
      * {
        box-sizing: border-box;
      }
      
      /* Mobile Responsive Styles */
      @media (max-width: 768px) {
        .sidebar {
          display: none !important;
        }
        .main-content {
          width: 100% !important;
          padding: 0.5rem !important;
          margin-top: 60px !important;
        }
        .mobile-header {
          display: flex !important;
        }
        .desktop-header {
          display: none !important;
        }
        .kanban-grid {
          grid-template-columns: 1fr !important;
          gap: 1rem !important;
        }
        .kanban-column {
          margin-bottom: 1rem !important;
        }
        
        /* Dashboard Cards */
        .dashboard-cards {
          grid-template-columns: 1fr !important;
          gap: 1rem !important;
        }
        
        /* Contacts Layout - Stack Vertically */
        .contacts-layout {
          flex-direction: column !important;
          height: auto !important;
        }
        .contacts-list-container {
          width: 100% !important;
          height: 250px !important;
          border-right: none !important;
          border-bottom: 1px solid #e9ecef !important;
        }
        .contact-detail-container {
          width: 100% !important;
          height: auto !important;
          min-height: 400px !important;
          border-right: none !important;
          border-bottom: 1px solid #e9ecef !important;
        }
        .contact-sidebar-container {
          width: 100% !important;
          border-left: none !important;
          border-top: 1px solid #e9ecef !important;
        }
        
        /* Hide contact sidebar on mobile to save space */
        .contact-sidebar-container {
          display: none !important;
        }
        
        /* Make tables responsive */
        table {
          font-size: 0.75rem !important;
        }
        
        table th,
        table td {
          padding: 0.5rem !important;
        }
      }
      
      @media (min-width: 769px) {
        .mobile-header {
          display: none !important;
        }
        .desktop-header {
          display: block !important;
        }
      }
      
      /* Modern Orange Scrollbar for Task Drop Zones */
      .task-drop-zone::-webkit-scrollbar {
        width: 6px;
      }
      
      .task-drop-zone::-webkit-scrollbar-track {
        background: transparent;
        border-radius: 10px;
      }
      
      .task-drop-zone::-webkit-scrollbar-thumb {
        background: rgba(255, 127, 0, 0.2);
        border-radius: 10px;
        transition: background 0.3s ease, opacity 0.3s ease;
      }
      
      .task-drop-zone::-webkit-scrollbar-thumb:hover {
        background: rgba(255, 127, 0, 0.5);
      }
      
      /* Enhanced visibility when scrolling */
      .task-drop-zone.scrolling::-webkit-scrollbar-thumb {
        background: rgba(255, 127, 0, 0.7);
      }
      
      /* Firefox scrollbar */
      .task-drop-zone {
        scrollbar-width: thin;
        scrollbar-color: rgba(255, 127, 0, 0.2) transparent;
      }
      
      .task-drop-zone:hover {
        scrollbar-color: rgba(255, 127, 0, 0.4) transparent;
      }
      
      .task-drop-zone.scrolling {
        scrollbar-color: rgba(255, 127, 0, 0.7) transparent;
      }

      /* Website request card buttons – lift on hover */
      .intake-card-action-btn {
        transition: transform 0.15s ease, box-shadow 0.15s ease;
      }
      .intake-card-action-btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0,0,0,0.12);
      }

      /* Workspace (auto-created) item rows – clickable, lift on hover */
      .workspace-item-row {
        cursor: pointer;
        transition: transform 0.15s ease, box-shadow 0.15s ease;
      }
      .workspace-item-row:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 8px rgba(0,0,0,0.08);
      }
    </style>
    <div style="
      min-height: 100vh;
      background: #ffffff;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      overflow-x: hidden;
      max-width: 100%;
      display: flex;
    ">
        <!-- Mobile Header -->
        <div class="mobile-header" style="
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          background: #1e293b;
          color: white;
          padding: 1rem;
          z-index: 1000;
          display: none;
        ">
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <div style="display: flex; align-items: center; gap: 0.75rem;">
              <!-- Logo Icon -->
              <img 
                src="./icons/icon.jpg" 
                alt="Hélo Logo" 
                style="
                  width: 32px;
                  height: 32px;
                  flex-shrink: 0;
                  object-fit: contain;
                "
                onerror="this.style.display='none'"
              />
            </div>
            <button id="mobile-menu-btn" style="
              background: transparent;
              border: none;
              color: white;
              font-size: 1.5rem;
              cursor: pointer;
            ">☰</button>
          </div>
        </div>

        <!-- Mobile Menu Overlay -->
        <div id="mobile-menu" style="
          position: fixed;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100vh;
          background: #1e293b;
          color: white;
          z-index: 1001;
          transition: left 0.3s ease;
          padding: 1rem;
          overflow-y: auto;
        ">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 2rem;">
            <div style="display: flex; align-items: center; gap: 0.75rem;">
              <!-- Logo Icon -->
              <svg width="28" height="28" viewBox="0 0 32 32" style="flex-shrink: 0;">
                <defs>
                  <linearGradient id="logoGradientMenu1" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" style="stop-color:#FFD700;stop-opacity:1" />
                    <stop offset="100%" style="stop-color:#FF8C00;stop-opacity:1" />
                  </linearGradient>
                  <linearGradient id="logoGradientMenu2" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" style="stop-color:#FF8C00;stop-opacity:1" />
                    <stop offset="100%" style="stop-color:#FF4500;stop-opacity:1" />
                  </linearGradient>
                </defs>
                <!-- Flames/leaves shapes -->
                <path d="M16 8 C14 10, 12 14, 14 18 C12 16, 10 18, 12 20 C10 18, 8 16, 10 20 C12 18, 14 20, 16 22 C18 20, 20 18, 22 20 C24 18, 22 16, 20 20 C22 18, 24 16, 22 20 C24 18, 26 14, 24 10 C26 12, 24 10, 22 8 C20 10, 18 8, 16 8 Z" fill="url(#logoGradientMenu1)" opacity="0.9"/>
                <path d="M14 10 C12 12, 10 16, 12 18 C10 16, 8 18, 10 20 C8 18, 6 16, 8 20 C10 18, 12 20, 14 22 C16 20, 18 18, 20 20 C22 18, 20 16, 18 20 C20 18, 22 16, 20 20 C22 18, 24 14, 22 10 C24 12, 22 10, 20 8 C18 10, 16 8, 14 10 Z" fill="url(#logoGradientMenu2)" opacity="0.8"/>
                <ellipse cx="16" cy="14" rx="4" ry="6" fill="#FFD700" opacity="0.7"/>
              </svg>
            </div>
            <button id="close-mobile-menu" style="
              background: transparent;
              border: none;
              color: white;
              font-size: 1.5rem;
              cursor: pointer;
            ">✕</button>
          </div>
          
          <!-- Mobile Navigation Menu -->
          <div style="margin-bottom: 2rem;">
            ${(() => {
        const navRole = currentProfile?.company_role || currentProfile?.role || 'USER';
        const isClient = navRole === 'CLIENT';

        if (isClient) {
          // CLIENTs only see Dashboard, Chat, Profile
          return `
                  <button 
                    onclick="switchScreen('dashboard'); closeMobileMenu();"
                    style="
                      width: 100%;
                      background: ${currentScreen === 'dashboard' ? '#3b82f6' : 'transparent'};
                      color: white;
                      border: none;
                      padding: 1rem;
                      cursor: pointer;
                      font-weight: 500;
                      text-align: left;
                      transition: all 0.2s ease;
                      display: flex;
                      align-items: center;
                      gap: 0.75rem;
                      font-size: 1rem;
                      margin-bottom: 0.5rem;
                      border-radius: 0.5rem;
                    "
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"/>
                    </svg>
                    Dashboard
                  </button>
                  <button 
                    onclick="switchScreen('chat'); closeMobileMenu();"
                    style="
                      width: 100%;
                      background: ${currentScreen === 'chat' ? '#3b82f6' : 'transparent'};
                      color: white;
                      border: none;
                      padding: 1rem;
                      cursor: pointer;
                      font-weight: 500;
                      text-align: left;
                      transition: all 0.2s ease;
                      display: flex;
                      align-items: center;
                      gap: 0.75rem;
                      font-size: 1rem;
                      margin-bottom: 0.5rem;
                      border-radius: 0.5rem;
                    "
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4l4 4 4-4h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"/>
                    </svg>
                    Chat
                  </button>
                  <button 
                    onclick="switchScreen('vault'); closeMobileMenu();"
                    style="
                      width: 100%;
                      background: ${currentScreen === 'vault' ? '#3b82f6' : 'transparent'};
                      color: white;
                      border: none;
                      padding: 1rem;
                      cursor: pointer;
                      font-weight: 500;
                      text-align: left;
                      transition: all 0.2s ease;
                      display: flex;
                      align-items: center;
                      gap: 0.75rem;
                      font-size: 1rem;
                      margin-bottom: 0.5rem;
                      border-radius: 0.5rem;
                    "
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M10 4H4c-1.11 0-2 .89-2 2v12c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2h-8l-2-2z"/>
                    </svg>
                    Documents
                  </button>
                  <button 
                    onclick="switchScreen('profile'); closeMobileMenu();"
                    style="
                      width: 100%;
                      background: ${currentScreen === 'profile' ? '#3b82f6' : 'transparent'};
                      color: white;
                      border: none;
                      padding: 1rem;
                      cursor: pointer;
                      font-weight: 500;
                      text-align: left;
                      transition: all 0.2s ease;
                      display: flex;
                      align-items: center;
                      gap: 0.75rem;
                      font-size: 1rem;
                      margin-bottom: 0.5rem;
                      border-radius: 0.5rem;
                    "
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                    </svg>
                    Profile
                  </button>
                `;
        } else {
          // Regular users see all navigation
          return `
            <button 
              onclick="switchScreen('resources'); closeMobileMenu();"
              style="
                width: 100%;
                background: ${currentScreen === 'resources' ? '#3b82f6' : 'transparent'};
                color: white;
                border: none;
                padding: 1rem;
                cursor: pointer;
                font-weight: 500;
                text-align: left;
                transition: all 0.2s ease;
                display: flex;
                align-items: center;
                gap: 0.75rem;
                font-size: 1rem;
                margin-bottom: 0.5rem;
                border-radius: 0.5rem;
              "
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M10 4H4c-1.11 0-2 .89-2 2v12c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2h-8l-2-2z"/>
              </svg>
              Resources
            </button>
            <button 
              onclick="switchScreen('team'); closeMobileMenu();"
              style="
                width: 100%;
                background: ${currentScreen === 'team' ? '#3b82f6' : 'transparent'};
                color: white;
                border: none;
                padding: 1rem;
                cursor: pointer;
                font-weight: 500;
                text-align: left;
                transition: all 0.2s ease;
                display: flex;
                align-items: center;
                gap: 0.75rem;
                font-size: 1rem;
                margin-bottom: 0.5rem;
                border-radius: 0.5rem;
              "
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm4 18v-6h2.5l-2.54-7.63A1.5 1.5 0 0 0 18.54 7H17c-.8 0-1.54.5-1.85 1.26L14.15 11H12v11h2v-6h2.5l2.5 6H20zM12.5 11.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5S11 9.17 11 10s.67 1.5 1.5 1.5z"/>
              </svg>
              PM Tool
            </button>
            <button 
              onclick="switchScreen('sales'); closeMobileMenu();"
              style="
                width: 100%;
                background: ${currentScreen === 'sales' ? '#3b82f6' : 'transparent'};
                color: white;
                border: none;
                padding: 1rem;
                cursor: pointer;
                font-weight: 500;
                text-align: left;
                transition: all 0.2s ease;
                display: flex;
                align-items: center;
                gap: 0.75rem;
                font-size: 1rem;
                margin-bottom: 0.5rem;
                border-radius: 0.5rem;
              "
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M7 4V2c0-.55-.45-1-1-1s-1 .45-1 1v2c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2V2c0-.55-.45-1-1-1s-1 .45-1 1v2H7zm12 2H5v11h14V6zm-7 3c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 3c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3z"/>
              </svg>
              CRM
            </button>
            <button 
              onclick="switchScreen('contracts'); closeMobileMenu();"
              style="
                width: 100%;
                background: ${currentScreen === 'contracts' ? '#3b82f6' : 'transparent'};
                color: white;
                border: none;
                padding: 1rem;
                cursor: pointer;
                font-weight: 500;
                text-align: left;
                transition: all 0.2s ease;
                display: flex;
                align-items: center;
                gap: 0.75rem;
                font-size: 1rem;
                margin-bottom: 0.5rem;
                border-radius: 0.5rem;
              "
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
              </svg>
              Contracts
            </button>
            <button 
              onclick="switchScreen('time-tracking'); closeMobileMenu();"
              style="
                width: 100%;
                background: ${currentScreen === 'time-tracking' ? '#3b82f6' : 'transparent'};
                color: white;
                border: none;
                padding: 1rem;
                cursor: pointer;
                font-weight: 500;
                text-align: left;
                transition: all 0.2s ease;
                display: flex;
                align-items: center;
                gap: 0.75rem;
                font-size: 1rem;
                margin-bottom: 0.5rem;
                border-radius: 0.5rem;
              "
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </svg>
              Clock In
            </button>
            <button 
              onclick="switchScreen('chat'); closeMobileMenu();"
              style="
                width: 100%;
                background: ${currentScreen === 'chat' ? '#3b82f6' : 'transparent'};
                color: white;
                border: none;
                padding: 1rem;
                cursor: pointer;
                font-weight: 500;
                text-align: left;
                transition: all 0.2s ease;
                display: flex;
                align-items: center;
                gap: 0.75rem;
                font-size: 1rem;
                margin-bottom: 0.5rem;
                border-radius: 0.5rem;
              "
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4l4 4 4-4h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"/>
              </svg>
              Chat
            </button>
            <button 
              onclick="switchScreen('calendar'); closeMobileMenu();"
              style="
                width: 100%;
                background: ${currentScreen === 'calendar' ? '#3b82f6' : 'transparent'};
                color: white;
                border: none;
                padding: 1rem;
                cursor: pointer;
                font-weight: 500;
                text-align: left;
                transition: all 0.2s ease;
                display: flex;
                align-items: center;
                gap: 0.75rem;
                font-size: 1rem;
                margin-bottom: 0.5rem;
                border-radius: 0.5rem;
              "
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11zM5 7V6h14v1H5z"/>
              </svg>
              Calendar
            </button>
            ${!isClient ? `
            <button 
              onclick="switchScreen('checklist'); closeMobileMenu();"
              style="
                width: 100%;
                background: ${currentScreen === 'checklist' ? '#3b82f6' : 'transparent'};
                color: white;
                border: none;
                padding: 1rem;
                cursor: pointer;
                font-weight: 500;
                text-align: left;
                transition: all 0.2s ease;
                display: flex;
                align-items: center;
                gap: 0.75rem;
                font-size: 1rem;
                margin-bottom: 0.5rem;
                border-radius: 0.5rem;
              "
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-5.04-6.71l-2.75 3.54-1.96-2.36L6.5 17h11l-3.54-4.71z"/>
              </svg>
              Checklist
            </button>
            ` : ''}
            <button 
              onclick="switchScreen('profile'); closeMobileMenu();"
              style="
                width: 100%;
                background: ${currentScreen === 'profile' ? '#3b82f6' : 'transparent'};
                color: white;
                border: none;
                padding: 1rem;
                cursor: pointer;
                font-weight: 500;
                text-align: left;
                transition: all 0.2s ease;
                display: flex;
                align-items: center;
                gap: 0.75rem;
                font-size: 1rem;
                margin-bottom: 0.5rem;
                border-radius: 0.5rem;
              "
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
              </svg>
              Profile
            </button>
                `;
        }
      })()}
          </div>
          
          <!-- Mobile User Profile Section -->
          <div style="
            padding: 1rem;
            border-top: 1px solid #334155;
            background: #0f172a;
            border-radius: 0.5rem;
          ">
            <div style="
              display: flex;
              align-items: center;
              gap: 0.75rem;
              margin-bottom: 0.75rem;
            ">
              <div style="
                width: 40px;
                height: 40px;
                border-radius: 50%;
                background: #f59e0b;
                color: white;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 600;
                font-size: 1rem;
                flex-shrink: 0;
              ">
                ${(currentProfile?.first_name || 'U').charAt(0)}${(currentProfile?.last_name || '').charAt(0)}
              </div>
              <div style="flex: 1; min-width: 0;">
                <div style="
                  color: white;
                  font-size: 1rem;
                  font-weight: 500;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                ">
                  ${currentProfile?.first_name || 'User'} ${currentProfile?.last_name || ''}
                </div>
                <div style="
                  color: #94a3b8;
                  font-size: 0.875rem;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                ">
                  ${currentCompany?.name || 'Company'}
                </div>
              </div>
            </div>
            <button 
              onclick="handleLogout(); closeMobileMenu();"
              style="
                background: transparent;
                color: #ef4444;
                border: 1px solid #ef4444;
                padding: 0.75rem 1rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-weight: 500;
                font-size: 0.875rem;
                width: 100%;
                transition: all 0.2s ease;
              "
            >
              Logout
            </button>
          </div>
        </div>

        <!-- Left Sidebar Navigation -->
        <div class="sidebar" style="
          width: 200px;
          background: #1e293b;
          color: white;
          display: flex;
          flex-direction: column;
          min-height: 100vh;
          border-right: 1px solid #334155;
        ">
          <!-- Logo -->
          <div style="
            padding: 1.5rem 1rem;
            border-bottom: 1px solid #334155;
            background: #0B0F14;
            display: flex;
            align-items: center;
            justify-content: flex-start;
          ">
            <img 
              src="/icons/helo-logo-full.png" 
              alt="Hélo Logo" 
              style="
                width: 100%;
                max-width: 175px;
                height: auto;
                object-fit: contain;
                display: block;
              "
              onerror="this.style.display='none'; this.parentElement.innerHTML='<h1 style=\'margin:0;color:#94a3b8;font-size:2rem;font-weight:600;letter-spacing:-0.025em;\'>Hélo</h1>'"
            />
          </div>
          
          <!-- Navigation Menu -->
          <div style="
            flex: 1;
            padding: 1rem 0;
            background: #000000;
          ">
            ${(() => {
        const navRole = currentProfile?.company_role || currentProfile?.role || 'USER';
        const isClient = navRole === 'CLIENT';

        if (isClient) {
          // CLIENTs only see Dashboard, Chat, Profile
          return `
                  <button 
                    onclick="switchScreen('dashboard')"
                    style="
                      width: 100%;
                      background: ${currentScreen === 'dashboard' ? '#0f172a' : 'transparent'};
                      color: white;
                      border: none;
                      padding: 0.75rem 1rem;
                      cursor: pointer;
                      font-weight: 500;
                      text-align: left;
                      transition: all 0.2s ease;
                      display: flex;
                      align-items: center;
                      gap: 0.75rem;
                      font-size: 0.875rem;
                      border-left: ${currentScreen === 'dashboard' ? '3px solid #3b82f6' : '3px solid transparent'};
                    "
                    onmouseover="this.style.background='#ff7f00'; this.style.color='white'"
                    onmouseout="this.style.background='${currentScreen === 'dashboard' ? '#0f172a' : 'transparent'}'; this.style.color='white'"
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"/>
                    </svg>
                    Dashboard
                  </button>
                  <button 
                    onclick="switchScreen('chat')"
                    style="
                      width: 100%;
                      background: ${currentScreen === 'chat' ? '#0f172a' : 'transparent'};
                      color: white;
                      border: none;
                      padding: 0.75rem 1rem;
                      cursor: pointer;
                      font-weight: 500;
                      text-align: left;
                      transition: all 0.2s ease;
                      display: flex;
                      align-items: center;
                      gap: 0.75rem;
                      font-size: 0.875rem;
                      border-left: ${currentScreen === 'chat' ? '3px solid #3b82f6' : '3px solid transparent'};
                    "
                    onmouseover="this.style.background='#ff7f00'; this.style.color='white'"
                    onmouseout="this.style.background='${currentScreen === 'chat' ? '#0f172a' : 'transparent'}'; this.style.color='white'"
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4l4 4 4-4h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"/>
                    </svg>
                    Chat
                  </button>
                  <button 
                    onclick="switchScreen('vault')"
                    style="
                      width: 100%;
                      background: ${currentScreen === 'vault' ? '#0f172a' : 'transparent'};
                      color: white;
                      border: none;
                      padding: 0.75rem 1rem;
                      cursor: pointer;
                      font-weight: 500;
                      text-align: left;
                      transition: all 0.2s ease;
                      display: flex;
                      align-items: center;
                      gap: 0.75rem;
                      font-size: 0.875rem;
                      border-left: ${currentScreen === 'vault' ? '3px solid #3b82f6' : '3px solid transparent'};
                    "
                    onmouseover="this.style.background='#ff7f00'; this.style.color='white'"
                    onmouseout="this.style.background='${currentScreen === 'vault' ? '#0f172a' : 'transparent'}'; this.style.color='white'"
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M10 4H4c-1.11 0-2 .89-2 2v12c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2h-8l-2-2z"/>
                    </svg>
                    Documents
                  </button>
                  <button 
                    onclick="switchScreen('profile')"
                    style="
                      width: 100%;
                      background: ${currentScreen === 'profile' ? '#0f172a' : 'transparent'};
                      color: white;
                      border: none;
                      padding: 0.75rem 1rem;
                      cursor: pointer;
                      font-weight: 500;
                      text-align: left;
                      transition: all 0.2s ease;
                      display: flex;
                      align-items: center;
                      gap: 0.75rem;
                      font-size: 0.875rem;
                      border-left: ${currentScreen === 'profile' ? '3px solid #3b82f6' : '3px solid transparent'};
                    "
                    onmouseover="this.style.background='#ff7f00'; this.style.color='white'"
                    onmouseout="this.style.background='${currentScreen === 'profile' ? '#0f172a' : 'transparent'}'; this.style.color='white'"
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                    </svg>
                    Profile
                  </button>
                `;
        } else {
          // Regular users see all navigation
          return `
            <button 
              onclick="switchScreen('resources')"
              style="
                width: 100%;
                background: ${currentScreen === 'resources' ? '#0f172a' : 'transparent'};
                color: white;
                border: none;
                padding: 0.75rem 1rem;
                cursor: pointer;
                font-weight: 500;
                text-align: left;
                transition: all 0.2s ease;
                display: flex;
                align-items: center;
                gap: 0.75rem;
                font-size: 0.875rem;
                border-left: ${currentScreen === 'resources' ? '3px solid #3b82f6' : '3px solid transparent'};
              "
              onmouseover="this.style.background='#ff7f00'; this.style.color='white'"
              onmouseout="this.style.background='${currentScreen === 'resources' ? '#0f172a' : 'transparent'}'; this.style.color='white'"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M10 4H4c-1.11 0-2 .89-2 2v12c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2h-8l-2-2z"/>
              </svg>
              Resources
            </button>
            <button 
              onclick="switchScreen('team')"
              style="
                width: 100%;
                background: ${currentScreen === 'team' ? '#0f172a' : 'transparent'};
                color: white;
                border: none;
                padding: 0.75rem 1rem;
                cursor: pointer;
                font-weight: 500;
                text-align: left;
                transition: all 0.2s ease;
                display: flex;
                align-items: center;
                gap: 0.75rem;
                font-size: 0.875rem;
                border-left: ${currentScreen === 'team' ? '3px solid #3b82f6' : '3px solid transparent'};
              "
              onmouseover="this.style.background='#ff7f00'; this.style.color='white'"
              onmouseout="this.style.background='${currentScreen === 'team' ? '#0f172a' : 'transparent'}'; this.style.color='white'"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm4 18v-6h2.5l-2.54-7.63A1.5 1.5 0 0 0 18.54 7H17c-.8 0-1.54.5-1.85 1.26L14.15 11H12v11h2v-6h2.5l2.5 6H20zM12.5 11.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5S11 9.17 11 10s.67 1.5 1.5 1.5z"/>
              </svg>
              PM Tool
            </button>
            <button 
              onclick="switchScreen('sales')"
              style="
                width: 100%;
                background: ${currentScreen === 'sales' ? '#0f172a' : 'transparent'};
                color: white;
                border: none;
                padding: 0.75rem 1rem;
                cursor: pointer;
                font-weight: 500;
                text-align: left;
                transition: all 0.2s ease;
                display: flex;
                align-items: center;
                gap: 0.75rem;
                font-size: 0.875rem;
                border-left: ${currentScreen === 'sales' ? '3px solid #3b82f6' : '3px solid transparent'};
              "
              onmouseover="this.style.background='#ff7f00'; this.style.color='white'"
              onmouseout="this.style.background='${currentScreen === 'sales' ? '#0f172a' : 'transparent'}'; this.style.color='white'"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M7 4V2c0-.55-.45-1-1-1s-1 .45-1 1v2c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2V2c0-.55-.45-1-1-1s-1 .45-1 1v2H7zm12 2H5v11h14V6zm-7 3c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 3c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3z"/>
              </svg>
              CRM
            </button>
            <button 
              onclick="switchScreen('contracts')"
              style="
                width: 100%;
                background: ${currentScreen === 'contracts' ? '#0f172a' : 'transparent'};
                color: white;
                border: none;
                padding: 0.75rem 1rem;
                cursor: pointer;
                font-weight: 500;
                text-align: left;
                transition: all 0.2s ease;
                display: flex;
                align-items: center;
                gap: 0.75rem;
                font-size: 0.875rem;
                border-left: ${currentScreen === 'contracts' ? '3px solid #3b82f6' : '3px solid transparent'};
              "
              onmouseover="this.style.background='#ff7f00'; this.style.color='white'"
              onmouseout="this.style.background='${currentScreen === 'contracts' ? '#0f172a' : 'transparent'}'; this.style.color='white'"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
              </svg>
              Contracts
            </button>
            <button 
              onclick="switchScreen('time-tracking')"
              style="
                width: 100%;
                background: ${currentScreen === 'time-tracking' ? '#0f172a' : 'transparent'};
                color: white;
                border: none;
                padding: 0.75rem 1rem;
                cursor: pointer;
                font-weight: 500;
                text-align: left;
                transition: all 0.2s ease;
                display: flex;
                align-items: center;
                gap: 0.75rem;
                font-size: 0.875rem;
                border-left: ${currentScreen === 'time-tracking' ? '3px solid #3b82f6' : '3px solid transparent'};
              "
              onmouseover="this.style.background='#ff7f00'; this.style.color='white'"
              onmouseout="this.style.background='${currentScreen === 'time-tracking' ? '#0f172a' : 'transparent'}'; this.style.color='white'"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </svg>
              Clock In
            </button>
            <button 
              onclick="switchScreen('chat')"
              style="
                width: 100%;
                background: ${currentScreen === 'chat' ? '#0f172a' : 'transparent'};
                color: white;
                border: none;
                padding: 0.75rem 1rem;
                cursor: pointer;
                font-weight: 500;
                text-align: left;
                transition: all 0.2s ease;
                display: flex;
                align-items: center;
                gap: 0.75rem;
                font-size: 0.875rem;
                border-left: ${currentScreen === 'chat' ? '3px solid #3b82f6' : '3px solid transparent'};
              "
              onmouseover="this.style.background='#ff7f00'; this.style.color='white'"
              onmouseout="this.style.background='${currentScreen === 'chat' ? '#0f172a' : 'transparent'}'; this.style.color='white'"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4l4 4 4-4h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"/>
              </svg>
              Chat
            </button>
            <button 
              onclick="switchScreen('calendar')"
              style="
                width: 100%;
                background: ${currentScreen === 'calendar' ? '#0f172a' : 'transparent'};
                color: white;
                border: none;
                padding: 0.75rem 1rem;
                cursor: pointer;
                font-weight: 500;
                text-align: left;
                transition: all 0.2s ease;
                display: flex;
                align-items: center;
                gap: 0.75rem;
                font-size: 0.875rem;
                border-left: ${currentScreen === 'calendar' ? '3px solid #3b82f6' : '3px solid transparent'};
              "
              onmouseover="this.style.background='#ff7f00'; this.style.color='white'"
              onmouseout="this.style.background='${currentScreen === 'calendar' ? '#0f172a' : 'transparent'}'; this.style.color='white'"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11zM5 7V6h14v1H5z"/>
              </svg>
              Calendar
            </button>
            <button 
              onclick="switchScreen('vault')"
              style="
                width: 100%;
                background: ${currentScreen === 'vault' ? '#0f172a' : 'transparent'};
                color: white;
                border: none;
                padding: 0.75rem 1rem;
                cursor: pointer;
                font-weight: 500;
                text-align: left;
                transition: all 0.2s ease;
                display: flex;
                align-items: center;
                gap: 0.75rem;
                font-size: 0.875rem;
                border-left: ${currentScreen === 'vault' ? '3px solid #3b82f6' : '3px solid transparent'};
              "
              onmouseover="this.style.background='#ff7f00'; this.style.color='white'"
              onmouseout="this.style.background='${currentScreen === 'vault' ? '#0f172a' : 'transparent'}'; this.style.color='white'"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M10 4H4c-1.11 0-2 .89-2 2v12c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2h-8l-2-2z"/>
              </svg>
              Documents
            </button>
            <button 
              onclick="switchScreen('checklist')"
              style="
                width: 100%;
                background: ${currentScreen === 'checklist' ? '#0f172a' : 'transparent'};
                color: white;
                border: none;
                padding: 0.75rem 1rem;
                cursor: pointer;
                font-weight: 500;
                text-align: left;
                transition: all 0.2s ease;
                display: flex;
                align-items: center;
                gap: 0.75rem;
                font-size: 0.875rem;
                border-left: ${currentScreen === 'checklist' ? '3px solid #3b82f6' : '3px solid transparent'};
              "
              onmouseover="this.style.background='#ff7f00'; this.style.color='white'"
              onmouseout="this.style.background='${currentScreen === 'checklist' ? '#0f172a' : 'transparent'}'; this.style.color='white'"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-5.04-6.71l-2.75 3.54-1.96-2.36L6.5 17h11l-3.54-4.71z"/>
              </svg>
              Checklist
            </button>
            <button 
              onclick="switchScreen('profile')"
              style="
                width: 100%;
                background: ${currentScreen === 'profile' ? '#0f172a' : 'transparent'};
                color: white;
                border: none;
                padding: 0.75rem 1rem;
                cursor: pointer;
                font-weight: 500;
                text-align: left;
                transition: all 0.2s ease;
                display: flex;
                align-items: center;
                gap: 0.75rem;
                font-size: 0.875rem;
                border-left: ${currentScreen === 'profile' ? '3px solid #3b82f6' : '3px solid transparent'};
              "
              onmouseover="this.style.background='#ff7f00'; this.style.color='white'"
              onmouseout="this.style.background='${currentScreen === 'profile' ? '#0f172a' : 'transparent'}'; this.style.color='white'"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
              </svg>
              Profile
            </button>
                `;
        }
      })()}
          </div>
          
          <!-- User Profile Section -->
          <div style="
            padding: 1rem;
            border-top: 1px solid #334155;
            background: #0f172a;
          ">
            <div style="
              display: flex;
              align-items: center;
              gap: 0.75rem;
              margin-bottom: 0.75rem;
            ">
              <div style="
                width: 32px;
                height: 32px;
                border-radius: 50%;
                background: #f59e0b;
                color: white;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 600;
                font-size: 0.875rem;
                flex-shrink: 0;
              ">
                ${(currentProfile?.first_name || 'U').charAt(0)}${(currentProfile?.last_name || '').charAt(0)}
              </div>
              <div style="flex: 1; min-width: 0;">
                <div style="
                  color: white;
                  font-size: 0.875rem;
                  font-weight: 500;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                ">
                  ${currentProfile?.first_name || 'User'} ${currentProfile?.last_name || ''}
                </div>
                <div style="
                  color: #94a3b8;
                  font-size: 0.75rem;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                ">
                  ${currentCompany?.name || 'Company'}
                </div>
              </div>
            </div>
            <button 
              onclick="handleLogout()"
              style="
                background: transparent;
                color: #ef4444;
                border: 1px solid #ef4444;
                padding: 0.5rem 0.75rem;
                border-radius: 0.375rem;
                cursor: pointer;
                font-weight: 500;
                font-size: 0.75rem;
                width: 100%;
                transition: all 0.2s ease;
              "
              onmouseover="this.style.background='#ef4444'; this.style.color='white'"
              onmouseout="this.style.background='transparent'; this.style.color='#ef4444'"
            >
              Logout
            </button>
          </div>
        </div>
      
      <!-- Main Content Area -->
      <div class="main-content" style="
        flex: 1;
        display: flex;
        flex-direction: column;
        margin-top: 0;
      ">

      <!-- Main Content -->
      <main style="padding: 1.5rem;">
        ${await renderScreenContent()}
      </main>
    </div>
    
    <!-- Eva AI Bubble -->
    ${renderEvaBubble()}
    
    <!-- Eva AI Chat Modal -->
    ${renderEvaChatModal()}
  `;

    // Add event listeners

    // Add event listeners
    setTimeout(() => {
      // Mobile menu functionality
      const mobileMenuBtn = document.getElementById('mobile-menu-btn');
      const mobileMenu = document.getElementById('mobile-menu');
      const closeMobileMenuBtn = document.getElementById('close-mobile-menu');

      if (mobileMenuBtn) {
        mobileMenuBtn.onclick = () => {
          mobileMenu.style.left = '0';
        };
      }

      if (closeMobileMenuBtn) {
        closeMobileMenuBtn.onclick = () => {
          mobileMenu.style.left = '-100%';
        };
      }

      // Close mobile menu when clicking outside
      if (mobileMenu) {
        mobileMenu.onclick = (e) => {
          if (e.target === mobileMenu) {
            mobileMenu.style.left = '-100%';
          }
        };
      }

      // Enhanced scrollbar visibility on scroll for task drop zones
      document.querySelectorAll('.task-drop-zone').forEach(zone => {
        let scrollTimeout;
        zone.addEventListener('scroll', () => {
          // Add scrolling class for enhanced visibility
          zone.classList.add('scrolling');

          // Clear existing timeout
          clearTimeout(scrollTimeout);

          // Remove scrolling class after scrolling stops
          scrollTimeout = setTimeout(() => {
            zone.classList.remove('scrolling');
          }, 500);
        });
      });

      const searchInput = document.getElementById('task-search');
      if (searchInput) {
        searchInput.oninput = (e) => {
          searchQuery = e.target.value;

          // Clear previous timeout
          if (searchTimeout) {
            clearTimeout(searchTimeout);
          }

          // Debounce the search to prevent freezing
          searchTimeout = setTimeout(() => {
            currentPage = { backlog: 0, active: 0, completed: 0 }; // Reset pagination
            renderPMTool();
          }, 300); // Wait 300ms after user stops typing
        };
      }

      // Removed: form now uses inline onsubmit handler (submitTask) from form HTML
      // This ensures the fixed validation logic in submitTask is used

      // Member search functionality
      const memberSearch = document.getElementById('member-search');
      if (memberSearch) {
        memberSearch.oninput = (e) => {
          // Use showMemberDropdown to maintain consistency and proper filtering
          showMemberDropdown(e.target);
        };
      }

      // Contact search functionality - only for modal/search results dropdown
      // The main contacts list uses handleContactSearch() function via oninput attribute
      // Only set up this handler if we're in a context with search results dropdown (not main contacts list)
      const contactSearchResults = document.getElementById('contact-search-results');
      if (contactSearchResults) {
        // This is a modal/dropdown context, set up the dropdown handler
        const contactSearch = document.getElementById('contact-search');
        if (contactSearch) {
          // Store reference to results div in closure
          const resultsDiv = contactSearchResults;
          // Remove inline handler to use our custom one
          contactSearch.removeAttribute('oninput');
          contactSearch.oninput = (e) => {
            // Double-check results div still exists
            if (!resultsDiv) return;

            const query = e.target.value.toLowerCase();

            if (query.trim()) {
              const filteredContacts = contacts.filter(contact =>
                `${contact.first_name} ${contact.last_name} ${contact.company || ''}`.toLowerCase().includes(query)
              );

              resultsDiv.innerHTML = filteredContacts.map(contact => `
              <div onclick="selectContact('${contact.id}')" style="
                padding: 0.75rem;
                cursor: pointer;
                border-bottom: 1px solid ${colors.border};
                display: flex;
                justify-content: space-between;
                align-items: center;
              " onmouseover="this.style.background='${colors.background}'" onmouseout="this.style.background='transparent'">
                <div>
                  <div style="font-weight: 500;">${contact.first_name} ${contact.last_name}</div>
                  ${contact.company ? `<div style="font-size: 0.875rem; color: ${colors.textSecondary};">${contact.company}</div>` : ''}
                </div>
                ${contact.contact_profile_id ? '<span style="background: #ff7f00; color: white; padding: 0.25rem 0.5rem; border-radius: 0.25rem; font-size: 0.75rem;">Client</span>' : ''}
              </div>
            `).join('');
              resultsDiv.style.display = 'block';
            } else {
              resultsDiv.style.display = 'none';
            }
          };
        }
      }
      // If contact-search-results doesn't exist, the inline oninput="handleContactSearch(event)" will handle it

      // Pagination buttons now use onclick attributes directly

      // When add-task modal is in the DOM (e.g. rendered inside main content), load project list so it never stays on "Loading projects..."
      if (document.getElementById('add-task-modal') && document.getElementById('project-list-container') && window.initializeTaskModalProjectList) {
        window.initializeTaskModalProjectList();
      }

      // Restore scroll position for chat after DOM is rendered
      if (currentScreen === 'chat' && selectedChatId && !window.chatScrollRestored) {
        // Use saved position from before render, or from persistent storage
        const stored = window.chatScrollPositions[selectedChatId];
        const positionToRestore = savedScrollPosition !== null ? savedScrollPosition : (stored ? stored.position : null);
        const shouldScrollToBottom = wasNearBottom || (stored ? stored.wasNearBottom : false) || positionToRestore === null || positionToRestore === 0;

        if (positionToRestore !== null) {
          setTimeout(() => {
            const messagesContainer = document.getElementById('chat-messages-container');
            if (messagesContainer && !window.chatScrollRestored) {
              if (shouldScrollToBottom) {
                // User was at bottom or no saved position, scroll to bottom
                requestAnimationFrame(() => {
                  messagesContainer.scrollTop = messagesContainer.scrollHeight;
                  window.chatScrollRestored = true;
                });
              } else if (positionToRestore > 0) {
                // User was scrolled down, preserve position
                requestAnimationFrame(() => {
                  const newScrollHeight = messagesContainer.scrollHeight;
                  const oldScrollHeight = stored ? stored.scrollHeight : (positionToRestore + messagesContainer.clientHeight);
                  if (oldScrollHeight > messagesContainer.clientHeight) {
                    const scrollRatio = positionToRestore / (oldScrollHeight - messagesContainer.clientHeight);
                    const newPosition = scrollRatio * (newScrollHeight - messagesContainer.clientHeight);
                    messagesContainer.scrollTop = Math.max(0, Math.min(newPosition, newScrollHeight - messagesContainer.clientHeight));
                  } else {
                    messagesContainer.scrollTop = positionToRestore;
                  }
                  window.chatScrollRestored = true;
                });
              } else {
                window.chatScrollRestored = true;
              }
            }
          }, 100);
        }
      }
    }, 100);
  } catch (error) {
    console.error('Error rendering PM tool:', error);
    console.error('Error stack:', error.stack);
    console.error('Error details:', {
      message: error.message,
      name: error.name,
      currentScreen: currentScreen,
      currentUser: currentUser?.id,
      currentCompany: currentCompany?.id
    });
    // If there's an error (like tasks not defined), show login screen
    if (!currentUser) {
      renderLogin();
    } else {
      // If user is logged in but there's an error, show a friendly message
      container.innerHTML = `
        <div style="padding: 2rem; text-align: center;">
          <h2 style="color: #ef4444;">Error Loading Application</h2>
          <p style="color: #64748b;">An error occurred while loading the application. Please refresh the page.</p>
          <p style="color: #9ca3af; font-size: 0.875rem; margin-top: 0.5rem;">Error: ${error.message || 'Unknown error'}</p>
          <button onclick="location.reload()" style="
            background: #ea580c;
            color: white;
            border: none;
            padding: 0.75rem 1.5rem;
            border-radius: 0.5rem;
            cursor: pointer;
            margin-top: 1rem;
          ">Refresh Page</button>
        </div>
      `;
    }
  }
}

// Make renderPMTool globally accessible
window.renderPMTool = renderPMTool;

// Load projects for client dashboard. For CLIENTs we do not filter by company_id so they see all their projects; RLS restricts to projects they are linked to. We do not join companies(name) so that projects in companies the client cannot read (companies RLS) still appear; we then fetch company names only for company_ids we have.
window.loadClientDashboardProjects = async function () {
  if (!currentUser) return;
  const userRole = currentProfile?.company_role || currentProfile?.role || 'USER';
  if (userRole !== 'CLIENT') return;
  try {
    const { data, error } = await supabase
      .from('projects')
      .select('id, name, description, status, due_date, company_id')
      .order('created_at', { ascending: false });
    if (error) {
      window.clientDashboardProjects = [];
      return;
    }
    const list = data || [];
    const companyIds = [...new Set(list.map(p => p.company_id).filter(Boolean))];
    let companyNames = {};
    if (companyIds.length > 0) {
      const { data: companiesData } = await supabase.from('companies').select('id, name').in('id', companyIds);
      if (companiesData) companiesData.forEach(c => { companyNames[c.id] = c.name; });
    }
    window.clientDashboardProjects = list.map(p => ({
      ...p,
      company_name: companyNames[p.company_id] || (currentCompany && currentCompany.id === p.company_id ? currentCompany.name : null) || 'Company'
    }));
  } catch (e) {
    window.clientDashboardProjects = [];
  }
};

// Render screen content based on current screen
async function renderScreenContent() {
  // Check if user is CLIENT
  const userRole = currentProfile?.company_role || currentProfile?.role || 'USER';
  const isClient = userRole === 'CLIENT';

  if (isClient) {
    await (window.loadClientDashboardProjects || (() => Promise.resolve()))();
  }

  // Show company management screen if active (but not for CLIENTs)
  if (showCompanyManagement && !isClient) {
    return renderCompanyManagementScreen();
  }

  switch (currentScreen) {
    case 'dashboard':
      return renderDashboardScreen();
    case 'resources':
      return isClient ? renderDashboardScreen() : renderResourcesScreen();
    case 'team':
      return isClient ? renderDashboardScreen() : renderTeamScreen();
    case 'sales':
      return isClient ? renderDashboardScreen() : await renderSalesScreen();
    case 'contracts':
      return isClient ? renderDashboardScreen() : await renderContractsScreen();
    case 'chat':
      return await renderChatScreen();
    case 'calendar':
      return isClient ? renderDashboardScreen() : await renderCalendarScreen() + renderDayScheduleModal();
    case 'vault':
      return await renderVaultScreen();
    case 'time-tracking':
      return isClient ? renderDashboardScreen() : await renderTimeTrackingScreen();
    case 'checklist':
      return isClient ? renderDashboardScreen() : await renderChecklistScreen();
    case 'profile':
      return renderProfileScreen();
    case 'feedback':
      return isClient ? renderDashboardScreen() : await renderFeedbackScreen();
    case 'google-calendar-integration':
      return isClient ? renderDashboardScreen() : await renderGoogleCalendarIntegrationScreen();
    case 'intake-submissions':
      return isClient ? renderDashboardScreen() : await renderIntakeSubmissionsScreen();
    default:
      return isClient ? renderDashboardScreen() : renderTeamScreen();
  }
}

// Render Team Screen (Kanban Board)
// Render Dashboard Screen for CLIENTs (My Projects)
function renderDashboardScreen() {
  // Prefer client dashboard projects (loaded with company name), then global projects, then derive from tasks
  let clientProjects = (window.clientDashboardProjects && window.clientDashboardProjects.length > 0)
    ? window.clientDashboardProjects
    : (projects || []);
  if ((!clientProjects || clientProjects.length === 0) && Array.isArray(tasks)) {
    const projectMap = {};
    tasks.forEach(t => {
      if (!t.project_id) return;
      if (!projectMap[t.project_id]) {
        projectMap[t.project_id] = {
          id: t.project_id,
          name: t.project_name || t.project?.name || 'Project',
          status: (t.project && t.project.status) || 'active',
          due_date: t.due_at || null,
          company_name: (currentCompany && currentCompany.name) || 'Hello Habanero'
        };
      } else if (!projectMap[t.project_id].name || projectMap[t.project_id].name === 'Project') {
        if (t.project_name || t.project?.name) projectMap[t.project_id].name = t.project_name || t.project.name;
      }
    });
    clientProjects = Object.values(projectMap);
  }
  // Normalize status for filtering (DB may use 'active'/'completed')
  clientProjects = clientProjects.map(p => {
    const s = (p.status || 'active').toUpperCase();
    const norm = s === 'DONE' ? 'COMPLETED' : s;
    return {
      ...p,
      company_name: p.company_name || (currentCompany && currentCompany.name) || 'Hello Habanero',
      status: norm
    };
  });
  // Compute task progress per project using global tasks array
  const tasksByProject = {};
  const taskListByProject = {};
  if (Array.isArray(tasks)) {
    tasks.forEach(t => {
      const pid = t.project_id;
      if (!pid) return;
      if (!tasksByProject[pid]) {
        tasksByProject[pid] = { total: 0, done: 0 };
        taskListByProject[pid] = [];
      }
      tasksByProject[pid].total += 1;
      if (t.title) taskListByProject[pid].push({ id: t.id, title: t.title, state: t.state });
      const state = (t.state || '').toUpperCase();
      if (state === 'DONE' || state === 'COMPLETED') {
        tasksByProject[pid].done += 1;
      }
    });
  }
  const getProjectProgress = (projectId) => {
    const info = tasksByProject[projectId] || { total: 0, done: 0 };
    if (info.total === 0) return { pct: 0, text: '0% complete (0/0 tasks)', done: 0, total: 0 };
    const pct = Math.round((info.done / info.total) * 100);
    return { pct, text: `${pct}% complete (${info.done}/${info.total} tasks)`, done: info.done, total: info.total };
  };
  const getProjectTasks = (projectId) => taskListByProject[projectId] || [];

  // Filter projects by selected tab (only show active by default)
  let filteredProjects = [];
  if (window.dashboardTab === 'completed') {
    filteredProjects = clientProjects.filter(p => p.status === 'COMPLETED' || p.status === 'DONE');
  } else if (window.dashboardTab === 'active') {
    filteredProjects = clientProjects.filter(p => p.status !== 'COMPLETED' && p.status !== 'DONE' && p.status !== 'ARCHIVED');
  } else {
    filteredProjects = clientProjects;
  }

  if (!window.dashboardTab) {
    window.dashboardTab = 'active';
  }
  if (!window.dashboardExpandedProjectId) window.dashboardExpandedProjectId = null;

  return `
    <div style="
      width: 100%;
      min-height: 100vh;
      background: #ffffff;
      padding: 1.5rem;
      max-width: 100%;
    ">
      <!-- Header -->
      <div style="margin-bottom: 1.5rem;">
        <h1 style="
          margin: 0 0 1rem 0;
          color: #000000;
          font-size: 1.75rem;
          font-weight: 700;
        ">My Projects</h1>
        
        <!-- Tab Selector (Active / Completed / All) -->
        <div style="
          display: flex;
          gap: 0.5rem;
          margin-bottom: 1rem;
          background: #ffffff;
          padding: 0.25rem;
          border-radius: 0.75rem;
          width: fit-content;
          box-shadow: 0 1px 3px rgba(0,0,0,0.08);
        ">
          <button
            onclick="window.dashboardTab='active'; renderPMTool();"
            style="
              padding: 0.5rem 1.25rem;
              border: none;
              border-radius: 0.5rem;
              font-size: 0.875rem;
              font-weight: 600;
              cursor: pointer;
              transition: all 0.2s;
              background: ${window.dashboardTab === 'active' ? '#ea580c' : 'transparent'};
              color: ${window.dashboardTab === 'active' ? 'white' : '#6c757d'};
            "
            onmouseover="if (window.dashboardTab !== 'active') this.style.background='#f3f4f6'"
            onmouseout="if (window.dashboardTab !== 'active') this.style.background='transparent'"
          >
            Active
          </button>
          <button
            onclick="window.dashboardTab='completed'; renderPMTool();"
            style="
              padding: 0.5rem 1.25rem;
              border: none;
              border-radius: 0.5rem;
              font-size: 0.875rem;
              font-weight: 600;
              cursor: pointer;
              transition: all 0.2s;
              background: ${window.dashboardTab === 'completed' ? '#ea580c' : 'transparent'};
              color: ${window.dashboardTab === 'completed' ? 'white' : '#6c757d'};
            "
            onmouseover="if (window.dashboardTab !== 'completed') this.style.background='#f3f4f6'"
            onmouseout="if (window.dashboardTab !== 'completed') this.style.background='transparent'"
          >
            Completed
          </button>
          <button
            onclick="window.dashboardTab='all'; renderPMTool();"
            style="
              padding: 0.5rem 1.25rem;
              border: none;
              border-radius: 0.5rem;
              font-size: 0.875rem;
              font-weight: 600;
              cursor: pointer;
              transition: all 0.2s;
              background: ${window.dashboardTab === 'all' ? '#ea580c' : 'transparent'};
              color: ${window.dashboardTab === 'all' ? 'white' : '#6c757d'};
            "
            onmouseover="if (window.dashboardTab !== 'all') this.style.background='#f3f4f6'"
            onmouseout="if (window.dashboardTab !== 'all') this.style.background='transparent'"
          >
            All
          </button>
        </div>
      </div>
      
      <!-- Projects List or Empty State -->
      ${filteredProjects.length === 0 ? `
        <div style="
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 4rem 2rem;
          text-align: center;
          background: white;
          border-radius: 1rem;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        ">
          <div style="
            width: 80px;
            height: 80px;
            border: 2px solid #e5e7eb;
            border-radius: 0.75rem;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 1.5rem;
            background: #f9fafb;
          ">
            <span class="material-icons" style="font-size: 3rem; color: #9ca3af;">folder</span>
          </div>
          <h2 style="
            margin: 0 0 0.5rem 0;
            color: #2c3e50;
            font-size: 1.25rem;
            font-weight: 600;
          ">No Projects Yet</h2>
          <p style="
            margin: 0;
            color: #6c757d;
            font-size: 0.9375rem;
            max-width: 300px;
          ">Your projects will appear here once they're created by your team.</p>
        </div>
      ` : `
        <div style="
          display: flex;
          flex-direction: column;
          gap: 1rem;
        ">
          ${filteredProjects.map(project => {
    const progress = getProjectProgress(project.id);
    const statusLabel = (project.status === 'COMPLETED' || project.status === 'DONE') ? 'Completed' : 'Active';
    const companyName = project.company_name || (currentCompany && currentCompany.name) || 'Hello Habanero';
    const projectTasks = getProjectTasks(project.id);
    const isExpanded = window.dashboardExpandedProjectId === project.id;
    return `
            <div style="
              background: white;
              border-radius: 0.75rem;
              padding: 1.25rem;
              box-shadow: 0 1px 3px rgba(0,0,0,0.08);
              border: 1px solid #e5e7eb;
            ">
              <div style="display: flex; justify-content: space-between; align-items: flex-start; gap: 0.75rem; margin-bottom: 0.75rem;">
                <h3 style="
                  margin: 0;
                  color: #1f2937;
                  font-size: 1.125rem;
                  font-weight: 700;
                  flex: 1;
                ">${project.name || 'Project'}</h3>
                <div style="display: flex; align-items: center; gap: 0.5rem; flex-shrink: 0;">
                  <span style="
                    background: #ea580c;
                    color: white;
                    padding: 0.2rem 0.5rem;
                    border-radius: 9999px;
                    font-size: 0.6875rem;
                    font-weight: 600;
                  ">${companyName}</span>
                  <span style="
                    background: ${project.status === 'COMPLETED' || project.status === 'DONE' ? '#10b981' : '#ea580c'};
                    color: white;
                    padding: 0.2rem 0.5rem;
                    border-radius: 9999px;
                    font-size: 0.6875rem;
                    font-weight: 600;
                  ">${statusLabel}</span>
                </div>
              </div>
              <div style="margin-bottom: 0.75rem;">
                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.25rem;">
                  <span style="font-size: 0.75rem; color: #6b7280; font-weight: 600;">Progress</span>
                  <span style="font-size: 0.75rem; color: #1f2937; font-weight: 700;">${progress.pct}%</span>
                </div>
                <div style="
                  height: 8px;
                  background: #e5e7eb;
                  border-radius: 9999px;
                  overflow: hidden;
                ">
                  <div style="
                    height: 100%;
                    width: ${progress.pct}%;
                    background: #ea580c;
                    border-radius: 9999px;
                    transition: width 0.2s;
                  "></div>
                </div>
              </div>
              <div style="display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 0.5rem;">
                <span style="display: inline-flex; align-items: center; gap: 0.25rem; font-size: 0.8125rem; color: #6b7280;">
                  <span style="font-size: 0.875rem;">☑</span>
                  ${progress.text}
                </span>
                <button
                  onclick="window.dashboardExpandedProjectId = (window.dashboardExpandedProjectId === '${project.id}') ? null : '${project.id}'; renderPMTool();"
                  style="
                    background: ${isExpanded ? '#e5e7eb' : '#f3f4f6'};
                    border: 1px solid #e5e7eb;
                    padding: 0.35rem 0.75rem;
                    border-radius: 0.5rem;
                    cursor: pointer;
                    font-size: 0.8125rem;
                    font-weight: 500;
                    color: #374151;
                    transition: background 0.2s;
                  "
                  onmouseover="this.style.background='#e5e7eb'"
                  onmouseout="this.style.background='${isExpanded ? '#e5e7eb' : '#f3f4f6'}'"
                >${isExpanded ? 'Hide Tasks' : 'View Tasks'}</button>
              </div>
              ${isExpanded ? `
              <div style="margin-top: 0.75rem; padding-top: 0.75rem; border-top: 1px solid #e5e7eb;">
                <div style="font-size: 0.75rem; font-weight: 600; color: #6b7280; margin-bottom: 0.5rem;">Tasks</div>
                <ul style="margin: 0; padding-left: 1.25rem; font-size: 0.875rem; color: #374151;">
                  ${projectTasks.length === 0 ? '<li style="color: #9ca3af;">No tasks yet</li>' : projectTasks.map(t => '<li key="' + t.id + '">' + (t.title || 'Untitled task') + '</li>').join('')}
                </ul>
              </div>
              ` : ''}
            </div>
          `;
  }).join('')}
        </div>
      `}
      

      ${showProjectTasksModal ? `
        <div style="
          position: fixed;
          inset: 0;
          background: rgba(0,0,0,0.45);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10000;
          padding: 1rem;
        " onclick="if(event.target.id === 'project-tasks-modal-overlay') closeProjectTasksModal();"
        id="project-tasks-modal-overlay">
          <div style="
            background: white;
            border-radius: 0.75rem;
            padding: 1.25rem;
            width: 100%;
            max-width: 520px;
            box-shadow: 0 10px 30px rgba(0,0,0,0.15);
            position: relative;
          " onclick="event.stopPropagation()">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
              <div>
                <h3 style="margin: 0; font-size: 1.125rem; color: #0f172a;">${projectTasksModalData.projectName || 'Project Tasks'}</h3>
                <p style="margin: 0.25rem 0 0 0; color: #6b7280; font-size: 0.9rem;">Tasks grouped by status</p>
              </div>
              <button onclick="closeProjectTasksModal()" style="
                background: transparent;
                border: none;
                font-size: 1.25rem;
                color: #6b7280;
                cursor: pointer;
              ">×</button>
            </div>
            ${(() => {
        const tasksList = projectTasksModalData.tasks || [];
        const completed = tasksList.filter(t => ['DONE', 'COMPLETED'].includes((t.state || '').toUpperCase()));
        const active = tasksList.filter(t => !['DONE', 'COMPLETED'].includes((t.state || '').toUpperCase()));
        const renderGroup = (title, items) => `
                <div style="margin-bottom: 1rem;">
                  <div style="font-weight: 700; color: #0f172a; margin-bottom: 0.5rem;">${title} (${items.length})</div>
                  ${items.length === 0 ? `<div style="color: #9ca3af; font-size: 0.9rem;">None</div>` : items.map(task => `
                    <div style="
                      padding: 0.75rem;
                      border: 1px solid #e5e7eb;
                      border-radius: 0.5rem;
                      margin-bottom: 0.5rem;
                      background: #f9fafb;
                      color: #0f172a;
                      display: flex;
                      justify-content: space-between;
                      gap: 0.5rem;
                    ">
                      <div style="font-weight: 600;">${task.title || 'Untitled Task'}</div>
                      <div style="font-size: 0.85rem; color: #6b7280; text-transform: uppercase;">${task.state || 'ACTIVE'}</div>
                    </div>
                  `).join('')}
                </div>
              `;
        return `
                <div style="max-height: 60vh; overflow-y: auto; padding-right: 0.25rem;">
                  ${renderGroup('Active', active)}
                  ${renderGroup('Completed', completed)}
                </div>
              `;
      })()}
          </div>
        </div>
      ` : ''}
    </div>
  `;
}

async function renderTeamScreen() {
  // Sync notification popup state
  if (window.showNotificationsPopup !== undefined) {
    showNotificationsPopup = window.showNotificationsPopup;
  } else {
    window.showNotificationsPopup = showNotificationsPopup;
  }

  // Sync teamTab with window for inline event handlers
  if (window.teamTab !== undefined) {
    teamTab = window.teamTab;
  } else {
    window.teamTab = teamTab;
  }

  const filteredTasks = getFilteredTasks();
  // Include DRAFT tasks only when viewing "personal" tab, not "team" tab
  const backlogTasks = filteredTasks.filter(task =>
    task.state === 'BACKLOG' || (task.state === 'DRAFT' && teamTab === 'personal')
  );
  const activeTasks = filteredTasks.filter(task => task.state === 'ACTIVE');
  let completedTasks = filteredTasks.filter(task => task.state === 'COMPLETED');

  // Sort completed tasks by most recent first (descending by updated_at, then created_at)
  completedTasks = completedTasks.sort((a, b) => {
    const aDate = new Date(a.updated_at || a.created_at || 0);
    const bDate = new Date(b.updated_at || b.created_at || 0);
    return bDate - aDate; // Most recent first
  });

  console.log('📊 Task counts:', {
    total: tasks.length,
    filtered: filteredTasks.length,
    backlog: backlogTasks.length,
    active: activeTasks.length,
    completed: completedTasks.length
  });

  // Use all tasks (no pagination, scrollable instead)
  const backlogPaginated = backlogTasks;
  const activePaginated = activeTasks;
  const completedPaginated = completedTasks;

  return `
    <div style="max-width: 1400px; margin: 0 auto; padding: 0 1rem;">
      <!-- Team Header -->
      <div style="margin-bottom: 1.5rem; position: relative;">
        <div style="display: flex; align-items: center; gap: 1rem;">
          <h1 style="
            color: ${colors.text};
            margin: 0 0 1rem 0;
            font-size: 2.5rem;
            font-weight: 800;
            line-height: 1.2;
          ">
            Project Management Tool
          </h1>
          <!-- Notification Bell -->
          <div style="position: relative; margin-bottom: 1rem;">
            <button
              onclick="showNotificationsPopup = !showNotificationsPopup; window.showNotificationsPopup = showNotificationsPopup; renderPMTool();"
              style="
                background: transparent;
                border: none;
                cursor: pointer;
                padding: 0.5rem;
                display: flex;
                align-items: center;
                justify-content: center;
                position: relative;
                color: ${colors.text};
              "
              onmouseover="this.style.opacity='0.7'"
              onmouseout="this.style.opacity='1'"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
                <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
              </svg>
              ${unreadNotificationCount > 0 ? `
                <div style="
                  position: absolute;
                  top: 0;
                  right: 0;
                  background: #ef4444;
                  color: white;
                  border-radius: 50%;
                  width: ${unreadNotificationCount > 9 ? '24px' : '20px'};
                  height: ${unreadNotificationCount > 9 ? '24px' : '20px'};
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: ${unreadNotificationCount > 9 ? '0.625rem' : '0.75rem'};
                  font-weight: 700;
                  border: 2px solid white;
                  transform: translate(25%, -25%);
                ">
                  ${unreadNotificationCount > 9 ? '9+' : unreadNotificationCount}
                </div>
              ` : ''}
            </button>
          </div>
          <!-- Website Requests Button (Owners and Managers Only) -->
          ${(() => {
      const wrRole = currentProfile?.company_role || currentProfile?.role || 'USER';
      return (wrRole === 'OWNER' || wrRole === 'MANAGER' || currentProfile?.is_hh_admin || currentUser?.is_hh_admin);
    })() ? `
          <button
            onclick="switchScreen('intake-submissions')"
            style="
              padding: 0.5rem 1rem;
              background: #ea580c;
              color: white;
              border: none;
              border-radius: 0.5rem;
              cursor: pointer;
              font-size: 0.875rem;
              font-weight: 600;
              margin-bottom: 1rem;
              display: flex;
              align-items: center;
              gap: 0.5rem;
            "
            onmouseover="this.style.opacity='0.9'"
            onmouseout="this.style.opacity='1'"
          >
            Website Requests (${(intakeSubmissions || []).filter(s => s.status === 'open' || s.status === 'in_progress').length})
          </button>
          ` : ''}
        </div>
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.5rem;">
          <p style="
            color: ${colors.textSecondary};
            margin: 0;
            font-size: 1rem;
          ">
            Manage your team's tasks and projects
          </p>
          <div style="display: flex; align-items: center; gap: 0.5rem;">
            <button
              onclick="toggleTaskListModal()"
              style="
                background: white;
                color: #ff7f00;
                border: 1px solid #ff7f00;
                padding: 0.5rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-size: 1rem;
                font-weight: 600;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 2rem;
                height: 2rem;
                transition: all 0.2s ease;
              "
              onmouseover="this.style.background='#fff7ed'; this.style.borderColor='#f97316';"
              onmouseout="this.style.background='white'; this.style.borderColor='#ff7f00';"
              title="View task list"
            >
              ☰
            </button>
            <button
              onclick="togglePMToolView()"
              style="
                background: ${pmToolViewMode === 'folders' ? '#f59e0b' : '#ef4444'};
                color: ${pmToolViewMode === 'folders' ? 'white' : 'white'};
                border: none;
                padding: 0.5rem 1rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-size: 0.875rem;
                font-weight: 600;
                display: flex;
                align-items: center;
                gap: 0.5rem;
                transition: all 0.2s ease;
              "
              onmouseover="this.style.opacity='0.9'"
              onmouseout="this.style.opacity='1'"
            >
              ${pmToolViewMode === 'folders' ? 'See tasks' : 'See projects'}
            </button>
            <button
              onclick="toggleQuickTasksModal()"
              style="
                background: #f59e0b;
                color: white;
                border: none;
                padding: 0.5rem 1rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-size: 0.875rem;
                font-weight: 600;
                display: flex;
                align-items: center;
                gap: 0.5rem;
                transition: all 0.2s ease;
              "
              onmouseover="this.style.opacity='0.9'"
              onmouseout="this.style.opacity='1'"
            >
              + Quick Task
            </button>
            <button
              onclick="refreshPMTool()"
              style="
                background: transparent;
                color: ${colors.textSecondary};
                border: 1px solid ${colors.border};
                padding: 0.5rem;
                border-radius: 0.5rem;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: all 0.2s ease;
                width: 36px;
                height: 36px;
              "
              onmouseover="this.style.background='#f3f4f6'; this.style.borderColor='#d1d5db'"
              onmouseout="this.style.background='transparent'; this.style.borderColor='${colors.border}'"
              title="Refresh tasks"
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"></path>
                <path d="M21 3v5h-5"></path>
                <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"></path>
                <path d="M3 21v-5h5"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
      
      <!-- Notification Popup -->
      ${showNotificationsPopup || window.showNotificationsPopup ? `
        <div style="
          position: fixed;
          top: 80px;
          right: 20px;
          width: 400px;
          max-width: calc(100vw - 40px);
          max-height: 600px;
          background: white;
          border-radius: 1rem;
          box-shadow: 0 10px 40px rgba(0,0,0,0.15);
          z-index: 1000;
          display: flex;
          flex-direction: column;
          overflow: hidden;
        " onclick="event.stopPropagation()">
          <!-- Popup Header -->
          <div style="
            padding: 1.25rem;
            border-bottom: 1px solid #e5e7eb;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: #f8f9fa;
          ">
            <h3 style="margin: 0; font-size: 1.125rem; font-weight: 700; color: #0f172a;">Notifications</h3>
            <button
              onclick="showNotificationsPopup = false; window.showNotificationsPopup = false; renderPMTool();"
              style="
                background: transparent;
                border: none;
                font-size: 1.25rem;
                color: #6b7280;
                cursor: pointer;
                padding: 0.25rem;
              "
              onmouseover="this.style.color='#0f172a'"
              onmouseout="this.style.color='#6b7280'"
            >×</button>
          </div>
          
          <!-- Notifications List -->
          <div style="
            overflow-y: auto;
            max-height: 500px;
            padding: 0.5rem;
          ">
            ${notifications.length === 0 ? `
              <div style="
                padding: 2rem;
                text-align: center;
                color: #9ca3af;
              ">
                <p style="margin: 0;">No notifications</p>
              </div>
            ` : (() => {
        // Group unread notifications by type
        const unreadNotifications = notifications.filter(n => !n.read_status);
        const grouped = {};
        unreadNotifications.forEach(notif => {
          const key = notif.type;
          if (!grouped[key]) {
            grouped[key] = [];
          }
          grouped[key].push(notif);
        });

        // Also show read notifications (most recent 20)
        const readNotifications = notifications.filter(n => n.read_status).slice(0, 20);

        let html = '';

        // Render grouped unread notifications
        Object.keys(grouped).forEach(type => {
          const group = grouped[type];
          const count = group.length;
          const latest = group[0]; // Most recent in group
          const timeAgo = getTimeAgo(new Date(latest.created_at));

          html += `
                  <div
                    onclick="window.handleNotificationClick('${latest.id}', '${latest.link_type || ''}', '${latest.link_id || ''}');"
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #f1f5f9;
                      cursor: pointer;
                      background: #fef3c7;
                      transition: background 0.2s;
                    "
                    onmouseover="this.style.background='#fde68a'"
                    onmouseout="this.style.background='#fef3c7'"
                  >
                    <div style="font-weight: 600; color: #0f172a; margin-bottom: 0.25rem;">
                      ${count > 1 ? `${count} ` : ''}${latest.title}
                    </div>
                    <div style="font-size: 0.875rem; color: #64748b; margin-bottom: 0.5rem;">
                      ${latest.message}
                    </div>
                    <div style="font-size: 0.75rem; color: #9ca3af;">
                      ${timeAgo}
                    </div>
                  </div>
                `;
        });

        // Render read notifications
        readNotifications.forEach(notif => {
          const timeAgo = getTimeAgo(new Date(notif.created_at));
          html += `
                  <div
                    onclick="window.handleNotificationClick('${notif.id}', '${notif.link_type || ''}', '${notif.link_id || ''}');"
                    style="
                      padding: 1rem;
                      border-bottom: 1px solid #f1f5f9;
                      cursor: pointer;
                      background: white;
                      opacity: 0.7;
                      transition: all 0.2s;
                    "
                    onmouseover="this.style.background='#f8f9fa'; this.style.opacity='1'"
                    onmouseout="this.style.background='white'; this.style.opacity='0.7'"
                  >
                    <div style="font-weight: 600; color: #0f172a; margin-bottom: 0.25rem;">
                      ${notif.title}
                    </div>
                    <div style="font-size: 0.875rem; color: #64748b; margin-bottom: 0.5rem;">
                      ${notif.message}
                    </div>
                    <div style="font-size: 0.75rem; color: #9ca3af;">
                      ${timeAgo}
                    </div>
                  </div>
                `;
        });

        return html;
      })()}
          </div>
        </div>
        <!-- Backdrop to close popup -->
        <div
          onclick="showNotificationsPopup = false; window.showNotificationsPopup = false; renderPMTool();"
          style="
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0,0,0,0.3);
            z-index: 999;
          "
        ></div>
      ` : ''}

      <!-- Quick Tasks Modal -->
      ${showQuickTasksModal ? renderQuickTasksModal() : ''}

      <!-- Search and Filters -->
      <div style="
        display: ${pmToolViewMode === 'folders' ? 'none' : 'block'};
        background: ${colors.surface};
        padding: 1rem;
        border-radius: 0.75rem;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        margin-bottom: 1.5rem;
      ">
        <div style="display: flex; gap: 1rem; margin-bottom: 1rem; flex-wrap: wrap; align-items: center;">
          <input
            type="text"
            id="task-search"
            placeholder="Search Tasks..."
            value="${searchQuery}"
            style="
              flex: 1;
              min-width: 200px;
              padding: 0.75rem;
              border: 1px solid ${colors.border};
              border-radius: 0.5rem;
              font-size: 1rem;
            "
          />
          <div style="
            display: ${pmToolViewMode === 'folders' ? 'none' : 'inline-flex'};
            background: #f3f4f6;
            border-radius: 0.5rem;
            padding: 0.25rem;
            border: 1px solid #e5e7eb;
          ">
            <button
              onclick="switchTeamTab('personal')"
              style="
                background: ${teamTab === 'personal' ? '#dc2626' : 'transparent'};
                color: ${teamTab === 'personal' ? '#ffffff' : '#6c757d'};
                border: none;
                padding: 0.625rem 1.25rem;
                border-radius: ${teamTab === 'personal' ? '0.375rem' : '0'};
                cursor: pointer;
                font-size: 0.875rem;
                font-weight: ${teamTab === 'personal' ? '600' : '500'};
                transition: all 0.2s ease;
                box-shadow: ${teamTab === 'personal' ? '0 1px 2px rgba(0,0,0,0.05)' : 'none'};
              "
              onmouseover="if (window.teamTab !== 'personal') { this.style.color='#2c3e50'; }"
              onmouseout="if (window.teamTab !== 'personal') { this.style.color='#6c757d'; }"
            >
              Personal
            </button>
            <button
              onclick="switchTeamTab('team')"
              style="
                background: ${teamTab === 'team' ? '#dc2626' : 'transparent'};
                color: ${teamTab === 'team' ? '#ffffff' : '#6c757d'};
                border: none;
                padding: 0.625rem 1.25rem;
                border-radius: ${teamTab === 'team' ? '0.375rem' : '0'};
                cursor: pointer;
                font-size: 0.875rem;
                font-weight: ${teamTab === 'team' ? '600' : '500'};
                transition: all 0.2s ease;
                box-shadow: ${teamTab === 'team' ? '0 1px 2px rgba(0,0,0,0.05)' : 'none'};
              "
              onmouseover="if (teamTab !== 'team') { this.style.color='#2c3e50'; }"
              onmouseout="if (teamTab !== 'team') { this.style.color='#6c757d'; }"
            >
              Team
            </button>
          </div>
          <button
            onclick="toggleAddTaskForm()"
            style="
              background: #ff7f00;
              color: white;
              border: none;
              padding: 0.875rem 1.5rem;
              border-radius: 0.5rem;
              cursor: pointer;
              font-size: 0.9375rem;
              font-weight: 600;
              white-space: nowrap;
              box-shadow: 0 2px 4px rgba(255, 127, 0, 0.2);
              transition: all 0.2s ease;
            "
            onmouseover="this.style.transform='translateY(-1px)'; this.style.boxShadow='0 4px 8px rgba(255, 127, 0, 0.3)'; this.style.background='#e56b00'"
            onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 2px 4px rgba(255, 127, 0, 0.2)'; this.style.background='#ff7f00'"
          >
            + Add Task
          </button>
        </div>
      </div>

      ${showAddTaskForm ? renderAddTaskModal() : ''}
      ${showTaskDetails ? renderTaskDetailsModal() : ''}
      ${showTaskCommentsModal ? renderTaskCommentsModal() : ''}
      ${showTaskListModal ? renderTaskListModal() : ''}

      ${pmToolViewMode === 'folders' ? await renderFoldersView() : `
      <!-- Kanban Board -->
      <style>
        @media (max-width: 1024px) {
          #kanban-grid {
            grid-template-columns: 1fr !important;
          }
        }
      </style>
      <div id="kanban-grid" class="kanban-grid" style="
        display: grid; 
        grid-template-columns: repeat(3, 1fr); 
        gap: 1rem;
        min-height: 600px;
      ">
        <!-- Backlog Column -->
        <div class="kanban-column" style="
          background: ${colors.surface};
          border-radius: 0.75rem;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
          overflow: hidden;
          min-height: 500px;
        ">
          <div style="
            background: white;
            color: #374151;
            padding: 1.25rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            box-shadow: 0 4px 6px rgba(0,0,0,0.1);
            border-bottom: 1px solid #d1d5db;
          ">
            <h3 style="margin: 0; font-size: 1.125rem; font-weight: 700;">
              Backlog (${backlogTasks.length})
            </h3>
          </div>
          <div 
            class="task-drop-zone"
            data-task-state="BACKLOG"
            ondrop="handleTaskDrop(event, 'BACKLOG')"
            ondragover="handleTaskDragOver(event)"
            ondragleave="handleTaskDragLeave(event)"
            style="
              padding: 1rem; 
              min-height: 200px;
              max-height: ${backlogTasks.length > 3 ? '600px' : 'auto'};
              overflow-y: ${backlogTasks.length > 3 ? 'auto' : 'visible'};
              overflow-x: hidden;
            "
          >
            ${renderTaskColumn(backlogPaginated)}
          </div>
        </div>

        <!-- In Progress Column -->
        <div class="kanban-column" style="
          background: ${colors.surface};
          border-radius: 0.75rem;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
          overflow: hidden;
          min-height: 500px;
        ">
          <div style="
            background: white;
            color: #374151;
            padding: 1.25rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            box-shadow: 0 4px 6px rgba(0,0,0,0.1);
            border-bottom: 1px solid #d1d5db;
          ">
            <h3 style="margin: 0; font-size: 1.125rem; font-weight: 700;">
              In Progress (${activeTasks.length})
            </h3>
          </div>
          <div 
            class="task-drop-zone"
            data-task-state="ACTIVE"
            ondrop="handleTaskDrop(event, 'ACTIVE')"
            ondragover="handleTaskDragOver(event)"
            ondragleave="handleTaskDragLeave(event)"
            style="
              padding: 1rem; 
              min-height: 200px;
              max-height: ${activeTasks.length > 3 ? '600px' : 'auto'};
              overflow-y: ${activeTasks.length > 3 ? 'auto' : 'visible'};
              overflow-x: hidden;
            "
          >
            ${renderTaskColumn(activePaginated)}
          </div>
        </div>

        <!-- Done Column -->
        <div class="kanban-column" style="
          background: ${colors.surface};
          border-radius: 0.75rem;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
          overflow: hidden;
          min-height: 500px;
        ">
          <div style="
            background: white;
            color: #374151;
            padding: 1.25rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            box-shadow: 0 4px 6px rgba(0,0,0,0.1);
            border-bottom: 1px solid #d1d5db;
          ">
            <h3 style="margin: 0; font-size: 1.125rem; font-weight: 700;">
              Complete (${completedTasks.length})
            </h3>
          </div>
          <div 
            class="task-drop-zone"
            data-task-state="COMPLETED"
            ondrop="handleTaskDrop(event, 'COMPLETED')"
            ondragover="handleTaskDragOver(event)"
            ondragleave="handleTaskDragLeave(event)"
            style="
              padding: 1rem; 
              min-height: 200px;
              max-height: ${completedTasks.length > 3 ? '600px' : 'auto'};
              overflow-y: ${completedTasks.length > 3 ? 'auto' : 'visible'};
              overflow-x: hidden;
            "
          >
            ${renderTaskColumn(completedPaginated, true)}
          </div>
        </div>
      </div>
      `}
    </div>
  `;
}

// Render folders view (projects as folders)
async function renderFoldersView() {
  // Load all projects for the company
  let allProjects = [];
  try {
    const { data: projectsData, error } = await supabase
      .from('projects')
      .select('*')
      .eq('company_id', currentCompany.id)
      .order('created_at', { ascending: false });

    if (error) {
      console.error('Error loading projects:', error);
    } else {
      allProjects = projectsData || [];

      // Optimization: Load ALL tasks for the company in ONE query
      // This elimiantes the N+1 problem where we were fetching tasks for each project sequentially
      try {
        const { data: allProjectTasks, error: tasksError } = await supabase
          .from('tasks')
          .select('id, state, project_id')
          .eq('company_id', currentCompany.id);

        if (!tasksError && allProjectTasks) {
          // Create a map for fast lookup
          const taskMap = {}; // projectId -> { total, completed }

          allProjectTasks.forEach(task => {
            if (task.project_id) {
              if (!taskMap[task.project_id]) {
                taskMap[task.project_id] = { total: 0, completed: 0 };
              }
              taskMap[task.project_id].total++;
              if (task.state === 'COMPLETED') {
                taskMap[task.project_id].completed++;
              }
            }
          });

          // Assign counts to projects
          for (const project of allProjects) {
            const counts = taskMap[project.id] || { total: 0, completed: 0 };
            project.task_count = counts.total;
            project.completed_tasks = counts.completed;
          }
          console.log('✅ Loaded project stats via optimized batch query');
        }
      } catch (err) {
        console.warn('Error loading project tasks batch:', err);
        // Fallback to zeros on error
        for (const project of allProjects) {
          project.task_count = 0;
          project.completed_tasks = 0;
        }
      }
    }
  } catch (error) {
    console.error('Error in renderFoldersView:', error);
  }

  // Categorize projects by status
  const activeProjects = allProjects.filter(p => p.status === 'active');
  const completedProjects = allProjects.filter(p => p.status === 'completed');
  const cancelledProjects = allProjects.filter(p => p.status === 'cancelled');

  return `
    <div style="margin-top: 1.5rem;">
      <!-- Add Project Button -->
      <div style="margin-bottom: 1.5rem; display: flex; justify-content: flex-end;">
        <button
          onclick="showAddProjectModalFromPMTool()"
          style="
            background: #f59e0b;
            color: white;
            border: none;
            padding: 0.5rem 1rem;
            border-radius: 0.5rem;
            cursor: pointer;
            font-size: 0.875rem;
            font-weight: 600;
            white-space: nowrap;
            box-shadow: 0 2px 4px rgba(245, 158, 11, 0.2);
            transition: all 0.2s ease;
            display: flex;
            align-items: center;
            gap: 0.375rem;
          "
          onmouseover="this.style.transform='translateY(-1px)'; this.style.boxShadow='0 4px 8px rgba(245, 158, 11, 0.3)'; this.style.background='#d97706'"
          onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 2px 4px rgba(245, 158, 11, 0.2)'; this.style.background='#f59e0b'"
        >
          <span style="font-size: 1rem;">+</span>
          Add Project
        </button>
      </div>
      
      <!-- Three Column Layout -->
      <div id="folders-grid" class="kanban-grid" style="
        display: grid; 
        grid-template-columns: repeat(3, 1fr); 
        gap: 1rem;
        min-height: 600px;
      ">
        <!-- Active Projects Column -->
        <div class="kanban-column" style="
          background: ${colors.surface};
          border-radius: 0.75rem;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
          overflow: hidden;
          min-height: 500px;
        ">
          <div style="
            background: white;
            color: #374151;
            padding: 1.25rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            box-shadow: 0 4px 6px rgba(0,0,0,0.1);
            border-bottom: 1px solid #d1d5db;
          ">
            <h3 style="margin: 0; font-size: 1.125rem; font-weight: 700;">
              Active (${activeProjects.length})
            </h3>
          </div>
          <div 
            class="project-drop-zone"
            data-project-status="active"
            ondrop="handleProjectDrop(event, 'active')"
            ondragover="handleProjectDragOver(event)"
            ondragleave="handleProjectDragLeave(event)"
            style="
              padding: 1rem; 
              min-height: 200px;
              max-height: 600px;
              overflow-y: auto;
              overflow-x: hidden;
            ">
            ${activeProjects.length === 0 ? `
              <div style="text-align: center; padding: 2rem; color: #9ca3af;">
                <p style="margin: 0;">No active projects</p>
              </div>
            ` : activeProjects.map(project => renderProjectFolder(project)).join('')}
          </div>
        </div>
        
        <!-- Completed Projects Column -->
        <div class="kanban-column" style="
          background: ${colors.surface};
          border-radius: 0.75rem;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
          overflow: hidden;
          min-height: 500px;
        ">
          <div style="
            background: white;
            color: #374151;
            padding: 1.25rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            box-shadow: 0 4px 6px rgba(0,0,0,0.1);
            border-bottom: 1px solid #d1d5db;
          ">
            <h3 style="margin: 0; font-size: 1.125rem; font-weight: 700;">
              Completed (${completedProjects.length})
            </h3>
          </div>
          <div 
            class="project-drop-zone"
            data-project-status="completed"
            ondrop="handleProjectDrop(event, 'completed')"
            ondragover="handleProjectDragOver(event)"
            ondragleave="handleProjectDragLeave(event)"
            style="
              padding: 1rem; 
              min-height: 200px;
              max-height: 600px;
              overflow-y: auto;
              overflow-x: hidden;
            ">
            ${completedProjects.length === 0 ? `
              <div style="text-align: center; padding: 2rem; color: #9ca3af;">
                <p style="margin: 0;">No completed projects</p>
              </div>
            ` : completedProjects.map(project => renderProjectFolder(project)).join('')}
          </div>
        </div>
        
        <!-- Cancelled Projects Column -->
        <div class="kanban-column" style="
          background: ${colors.surface};
          border-radius: 0.75rem;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
          overflow: hidden;
          min-height: 500px;
        ">
          <div style="
            background: white;
            color: #374151;
            padding: 1.25rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            box-shadow: 0 4px 6px rgba(0,0,0,0.1);
            border-bottom: 1px solid #d1d5db;
          ">
            <h3 style="margin: 0; font-size: 1.125rem; font-weight: 700;">
              Cancelled (${cancelledProjects.length})
            </h3>
          </div>
          <div 
            class="project-drop-zone"
            data-project-status="cancelled"
            ondrop="handleProjectDrop(event, 'cancelled')"
            ondragover="handleProjectDragOver(event)"
            ondragleave="handleProjectDragLeave(event)"
            style="
              padding: 1rem; 
              min-height: 200px;
              max-height: 600px;
              overflow-y: auto;
              overflow-x: hidden;
            ">
            ${cancelledProjects.length === 0 ? `
              <div style="text-align: center; padding: 2rem; color: #9ca3af;">
                <p style="margin: 0;">No cancelled projects</p>
              </div>
            ` : cancelledProjects.map(project => renderProjectFolder(project)).join('')}
          </div>
        </div>
      </div>
    </div>
  `;
}

// Render a single project folder card
function renderProjectFolder(project) {
  const isExpanded = expandedProjects.has(project.id);
  const taskCount = project.task_count || 0;
  const contact = project.contact_id ? contacts.find(c => c.id === project.contact_id) : null;
  const contactName = contact ? `${contact.first_name || ''} ${contact.last_name || ''}`.trim() : null;
  const currentStatus = project.status || 'active';

  return `
    <div 
      draggable="true"
      data-project-id="${project.id}"
      data-project-status="${currentStatus}"
      ondragstart="handleProjectDragStart(event, '${project.id}', '${currentStatus}')"
      ondragend="handleProjectDragEnd(event)"
      onclick="if (!window.isProjectDragging) { toggleProjectExpansion('${project.id}'); }"
      style="
        background: #ffffff;
        border: 1px solid #e5e7eb;
        border-radius: 0.75rem;
        padding: 1.5rem;
        margin-bottom: 1rem;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        transition: all 0.2s ease;
        cursor: grab;
        width: 100%;
        box-sizing: border-box;
      " 
      onmouseover="if (!this.classList.contains('project-dragging')) { this.style.boxShadow='0 4px 8px rgba(0,0,0,0.15)'; this.style.transform='translateY(-2px)'; }" 
      onmouseout="if (!this.classList.contains('project-dragging')) { this.style.boxShadow='0 2px 4px rgba(0,0,0,0.1)'; this.style.transform='translateY(0)'; }"
      onmousedown="this.style.cursor='grabbing'"
    >
      <!-- Row 1: Project Name Heading -->
      <div style="display: flex; align-items: center; gap: 0.75rem; margin-bottom: 1rem;">
        <span class="material-icons" style="font-size: 1.5rem; color: #f59e0b; flex-shrink: 0;">folder</span>
        <h4 style="
          margin: 0;
          font-size: 1.25rem;
          font-weight: 700;
          color: #2c3e50;
          flex: 1;
          min-width: 0;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        ">${project.name || 'Untitled Project'}</h4>
      </div>
      
      <!-- Row 2: Action Buttons -->
      <div style="display: flex; align-items: center; gap: 0.5rem; margin-bottom: 1rem; flex-shrink: 0;">
        <button 
          onclick="event.stopPropagation(); toggleProjectExpansion('${project.id}')"
          style="
            background: transparent;
            color: #f59e0b;
            border: 1px solid #f59e0b;
            border-radius: 0.25rem;
            width: auto;
            height: 28px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            font-size: 0.75rem;
            font-weight: 500;
            transition: all 0.2s ease;
            padding: 0 0.75rem;
          "
          onmouseover="this.style.background='#fef3c7'; this.style.borderColor='#f59e0b'"
          onmouseout="this.style.background='transparent'; this.style.borderColor='#f59e0b'"
          title="Click to ${isExpanded ? 'collapse' : 'expand'} tasks"
        >
          ${isExpanded ? 'close tasks' : 'see tasks'}
        </button>
        <button 
          onclick="event.stopPropagation(); editProject('${project.id}')"
          style="
            background: transparent;
            border: none;
            color: #f59e0b;
            cursor: pointer;
            padding: 0.25rem;
            transition: all 0.2s ease;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 28px;
            height: 28px;
          "
          onmouseover="this.style.background='#fef3c7'; this.style.borderRadius='0.25rem'; this.style.transform='scale(1.1)'"
          onmouseout="this.style.background='transparent'; this.style.borderRadius='0'; this.style.transform='scale(1)'"
          title="Edit Project"
        >
          <span class="material-icons" style="font-size: 1.125rem;">edit</span>
        </button>
        <button 
          onclick="event.stopPropagation(); deleteProject('${project.id}')"
          style="
            background: transparent;
            border: none;
            color: #ef4444;
            cursor: pointer;
            padding: 0.25rem;
            transition: all 0.2s ease;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 28px;
            height: 28px;
          "
          onmouseover="this.style.background='#fee2e2'; this.style.borderRadius='0.25rem'; this.style.transform='scale(1.1)'"
          onmouseout="this.style.background='transparent'; this.style.borderRadius='0'; this.style.transform='scale(1)'"
          title="Delete Project"
        >
          <span class="material-icons" style="font-size: 1.125rem;">delete</span>
        </button>
      </div>
      
      <!-- Row 3: Task Count and Contact Name (spread out) -->
      <div style="
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 0.875rem;
        color: #6c757d;
        gap: 1rem;
        margin-bottom: ${isExpanded ? '0.75rem' : '0'};
      ">
        <span style="font-weight: 500;">${taskCount} ${taskCount === 1 ? 'task' : 'tasks'}</span>
        ${contactName ? `<span style="font-weight: 500;">${contactName}</span>` : '<span style="color: #9ca3af;">No contact</span>'}
      </div>
      
      ${isExpanded ? renderProjectTasks(project.id) : ''}
    </div>
  `;
}

// Render tasks for an expanded project folder (placeholder - will be loaded on expansion)
function renderProjectTasks(projectId) {
  return `
    <div id="project-tasks-${projectId}" style="margin-top: 1rem; padding-top: 1rem; border-top: 1px solid #e5e7eb;">
      <div style="text-align: center; padding: 1rem; color: #6c757d; font-size: 0.875rem;">
        Loading tasks...
      </div>
    </div>
  `;
}

// Load and render tasks for a project (called when folder is expanded)
async function loadProjectTasks(projectId) {
  const tasksContainer = document.getElementById(`project-tasks-${projectId}`);
  if (!tasksContainer) return;

  let projectTasks = [];
  try {
    const { data: tasksData, error } = await supabase
      .from('tasks')
      .select('*')
      .eq('project_id', projectId)
      .order('created_at', { ascending: false });

    if (!error && tasksData) {
      projectTasks = tasksData;
    }
  } catch (error) {
    console.error('Error loading project tasks:', error);
  }

  if (projectTasks.length === 0) {
    tasksContainer.innerHTML = `
      <div style="
        padding: 1rem;
        background: #f8f9fa;
        border-radius: 0.5rem;
        text-align: center;
        color: #6c757d;
        font-size: 0.875rem;
      ">No tasks for this project</div>
    `;
    return;
  }

  tasksContainer.innerHTML = projectTasks.map(task => {
    const assignee = task.assigned_to ? companyEmployees.find(e => e.id === task.assigned_to) : null;
    const assigneeName = assignee ? `${assignee.first_name || ''} ${assignee.last_name || ''}`.trim() : 'Unassigned';
    const priorityColor = task.priority === 'HIGH' ? '#ef4444' : task.priority === 'MEDIUM' ? '#f59e0b' : '#6b7280';

    return `
      <div
        style="
          background: #f8f9fa;
          border: 1px solid #e5e7eb;
          border-radius: 0.5rem;
          padding: 0.75rem;
          margin-bottom: 0.5rem;
          transition: all 0.2s ease;
        "
        onmouseover="this.style.background='#ffffff'; this.style.borderColor='#f59e0b'; this.style.boxShadow='0 2px 4px rgba(0,0,0,0.1)'"
        onmouseout="this.style.background='#f8f9fa'; this.style.borderColor='#e5e7eb'; this.style.boxShadow='none'"
      >
        <div style="display: flex; justify-content: space-between; align-items: flex-start; gap: 0.5rem;">
          <div 
            onclick="event.stopPropagation(); viewTaskDetails('${task.id}')"
            style="flex: 1; cursor: pointer;"
          >
            <div style="font-weight: 600; color: #2c3e50; margin-bottom: 0.25rem; font-size: 0.875rem;">
              ${task.title || 'Untitled Task'}
            </div>
            <div style="display: flex; align-items: center; gap: 0.5rem; font-size: 0.75rem; color: #6c757d;">
              <span style="
                background: ${priorityColor};
                color: white;
                padding: 0.125rem 0.5rem;
                border-radius: 0.25rem;
                font-weight: 600;
              ">${task.priority || 'LOW'}</span>
              <span>•</span>
              <span>${assigneeName}</span>
            </div>
          </div>
          <button
            onclick="event.stopPropagation(); showDeleteTaskFromProjectConfirm('${task.id}', '${projectId}')"
            style="
              background: transparent;
              border: none;
              color: #ef4444;
              cursor: pointer;
              padding: 0.25rem;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 0.25rem;
              transition: all 0.2s;
            "
            onmouseover="this.style.background='#fee2e2'; this.style.transform='scale(1.1)'"
            onmouseout="this.style.background='transparent'; this.style.transform='scale(1)'"
            title="Delete Task"
          >
            <span class="material-icons" style="font-size: 1rem;">delete</span>
          </button>
        </div>
      </div>
    `;
  }).join('');
}

// Task drag and drop handlers
let draggedTaskId = null;
let draggedFromTaskState = null;
window.isTaskDragging = false; // Make global for onclick handlers

window.handleTaskDragStart = function (event, taskId, currentState) {
  window.isTaskDragging = true;
  draggedTaskId = taskId;
  draggedFromTaskState = currentState;
  event.dataTransfer.effectAllowed = 'move';
  event.dataTransfer.setData('text/html', event.target.outerHTML);

  // Add dragging class for styling
  event.target.classList.add('task-dragging');
  event.target.style.opacity = '0.5';

  // Store the task ID
  event.dataTransfer.setData('task-id', taskId);
};

window.handleTaskDragEnd = function (event) {
  // Remove dragging class
  event.target.classList.remove('task-dragging');
  event.target.style.opacity = '';

  // Reset drag state after a short delay
  setTimeout(() => {
    window.isTaskDragging = false;
    draggedTaskId = null;
    draggedFromTaskState = null;
  }, 100);

  // Remove drag-over styling from all drop zones
  document.querySelectorAll('.task-drop-zone').forEach(zone => {
    zone.style.backgroundColor = '';
    zone.style.border = '';
  });
};

window.handleTaskDragOver = function (event) {
  event.preventDefault();
  event.dataTransfer.dropEffect = 'move';

  // Add visual feedback
  const dropZone = event.currentTarget;
  dropZone.style.backgroundColor = 'rgba(255, 127, 0, 0.1)';
  dropZone.style.border = '2px dashed #ff7f00';
};

window.handleTaskDragLeave = function (event) {
  // Only remove styling if we're actually leaving the drop zone
  const dropZone = event.currentTarget;
  const rect = dropZone.getBoundingClientRect();
  const x = event.clientX;
  const y = event.clientY;

  if (x < rect.left || x > rect.right || y < rect.top || y > rect.bottom) {
    dropZone.style.backgroundColor = '';
    dropZone.style.border = '';
  }
};

window.handleTaskDrop = async function (event, targetState) {
  event.preventDefault();
  event.stopPropagation();

  // Remove drag-over styling
  const dropZone = event.currentTarget;
  dropZone.style.backgroundColor = '';
  dropZone.style.border = '';

  const taskId = event.dataTransfer.getData('task-id') || draggedTaskId;

  if (!taskId) {
    console.error('No task ID found in drag data');
    return;
  }

  // Don't do anything if dropped in the same column
  if (targetState === draggedFromTaskState) {
    console.log('Dropped in same column, no update needed');
    return;
  }

  // Find the task
  const task = tasks.find(t => t.id === taskId);
  if (!task) {
    console.error('Task not found:', taskId);
    return;
  }

  console.log(`Moving task ${taskId} from ${draggedFromTaskState} to ${targetState}`);

  try {
    // Update the task state in the database
    const { error: updateError } = await supabase
      .from('tasks')
      .update({ state: targetState })
      .eq('id', taskId);

    if (updateError) {
      console.error('Error updating task state:', updateError);
      alert('Failed to update task status: ' + updateError.message);
      return;
    }

    // Update local state
    task.state = targetState;

    // If task was completed and has a contact_id, create activity log entry
    if (targetState === 'COMPLETED' && task.contact_id) {
      console.log(`🎯 [Task Completion] Creating activity log for task ${taskId}`);
      console.log(`🎯 [Task Data]:`, task);
      await createActivityLogEntry(
        task.contact_id,
        'task_completed',
        `Completed task: ${task.title || 'Untitled Task'}`,
        task.description || null,
        { task_id: task.id }
      );
    }

    // Reload tasks to get fresh data
    await loadTasks();

    // If we're viewing a contact detail, refresh the contact view to update activity log
    if (currentScreen === 'sales' && selectedContactId) {
      // Check if this task belongs to the selected contact
      const taskContactId = task.contact_id;
      if (taskContactId === selectedContactId) {
        console.log(`🔄 [Task Completion] Refreshing contact detail view for contact ${selectedContactId}`);
        await updateContactDetailContent();
      }
    }

    // Re-render the team screen
    renderPMTool();

    console.log('✅ Task status updated successfully');
  } catch (error) {
    console.error('Error updating task:', error);
    alert('Failed to update task: ' + error.message);
  }
};

// Project drag and drop handlers
let draggedProjectId = null;
let draggedFromProjectStatus = null;
window.isProjectDragging = false;

window.handleProjectDragStart = function (event, projectId, currentStatus) {
  window.isProjectDragging = true;
  draggedProjectId = projectId;
  draggedFromProjectStatus = currentStatus;
  event.dataTransfer.effectAllowed = 'move';
  event.dataTransfer.setData('text/html', event.target.outerHTML);

  // Add dragging class for styling
  event.target.classList.add('project-dragging');
  event.target.style.opacity = '0.5';

  // Store the project ID
  event.dataTransfer.setData('project-id', projectId);
};

window.handleProjectDragEnd = function (event) {
  // Remove dragging class
  event.target.classList.remove('project-dragging');
  event.target.style.opacity = '';
  event.target.style.cursor = 'grab';

  // Reset drag state after a short delay
  setTimeout(() => {
    window.isProjectDragging = false;
    draggedProjectId = null;
    draggedFromProjectStatus = null;
  }, 100);

  // Remove drag-over styling from all drop zones
  document.querySelectorAll('.project-drop-zone').forEach(zone => {
    zone.style.backgroundColor = '';
    zone.style.border = '';
  });
};

window.handleProjectDragOver = function (event) {
  event.preventDefault();
  event.dataTransfer.dropEffect = 'move';

  // Add visual feedback
  const dropZone = event.currentTarget;
  dropZone.style.backgroundColor = 'rgba(245, 158, 11, 0.1)';
  dropZone.style.border = '2px dashed #f59e0b';
};

window.handleProjectDragLeave = function (event) {
  // Only remove styling if we're actually leaving the drop zone
  const dropZone = event.currentTarget;
  const rect = dropZone.getBoundingClientRect();
  const x = event.clientX;
  const y = event.clientY;

  if (x < rect.left || x > rect.right || y < rect.top || y > rect.bottom) {
    dropZone.style.backgroundColor = '';
    dropZone.style.border = '';
  }
};

window.handleProjectDrop = async function (event, targetStatus) {
  event.preventDefault();
  event.stopPropagation();

  // Remove drag-over styling
  const dropZone = event.currentTarget;
  dropZone.style.backgroundColor = '';
  dropZone.style.border = '';

  const projectId = event.dataTransfer.getData('project-id') || draggedProjectId;

  if (!projectId) {
    console.error('No project ID found in drag data');
    return;
  }

  // Don't do anything if dropped in the same column
  if (targetStatus === draggedFromProjectStatus) {
    console.log('Dropped in same column, no update needed');
    return;
  }

  // Find the project in the projects array (we'll need to load it from the database)
  try {
    const { data: projectData, error: fetchError } = await supabase
      .from('projects')
      .select('*')
      .eq('id', projectId)
      .single();

    if (fetchError || !projectData) {
      console.error('Project not found:', fetchError);
      alert('Failed to find project: ' + (fetchError?.message || 'Unknown error'));
      return;
    }

    console.log(`Moving project ${projectId} from ${draggedFromProjectStatus} to ${targetStatus}`);

    // Update the project status in the database
    const { error: updateError } = await supabase
      .from('projects')
      .update({ status: targetStatus })
      .eq('id', projectId);

    if (updateError) {
      console.error('Error updating project status:', updateError);
      alert('Failed to update project status: ' + updateError.message);
      return;
    }

    // Re-render the PM Tool to show updated project positions
    await renderPMTool();

    console.log('✅ Project status updated successfully');
  } catch (error) {
    console.error('Error updating project:', error);
    alert('Failed to update project: ' + error.message);
  }
};

// Render task column
function renderTaskColumn(tasks, isDone = false) {
  if (tasks.length === 0) {
    return `
      <div style="
        text-align: center;
        padding: 2rem;
        color: ${colors.textSecondary};
        opacity: ${isDone ? 0.6 : 1};
      ">
        <div style="font-size: 2rem; margin-bottom: 0.5rem; color: #6c757d;">
          <span class="material-icons" style="font-size: 2rem;">assignment</span>
        </div>
        <p style="margin: 0; font-size: 0.875rem;">No tasks</p>
      </div>
    `;
  }

  return tasks.map(task => renderKanbanTaskCard(task, isDone)).join('');
}

// Render Kanban task card
function renderKanbanTaskCard(task, isDone = false) {
  const priorityColors = {
    LOW: { bg: '#D1FAE5', text: '#065F46', border: '#10B981' }, // Green
    MEDIUM: { bg: '#FEF3C7', text: '#92400E', border: '#F59E0B' }, // Yellow
    HIGH: { bg: '#FCE7F3', text: '#9F1239', border: '#EC4899' }, // Pink
    URGENT: { bg: '#F3E8FF', text: '#6B21A8', border: '#8B5CF6' } // Purple
  };

  const priority = priorityColors[task.priority] || priorityColors.MEDIUM;

  const currentState = task.state || 'BACKLOG';

  return `
    <div 
      draggable="true"
      data-task-id="${task.id}"
      data-current-state="${currentState}"
      ondragstart="handleTaskDragStart(event, '${task.id}', '${currentState}')"
      ondragend="handleTaskDragEnd(event)"
      onclick="if (!window.isTaskDragging) { viewTaskDetails('${task.id}'); }"
      style="
      background: #ffffff;
      border-left: 4px solid #f59e0b;
      border-top: none;
      border-right: none;
      border-bottom: none;
      border-radius: 0.75rem;
      padding: 1.25rem;
      margin-bottom: 1rem;
      cursor: grab;
      transition: all 0.3s ease;
      opacity: ${isDone ? 0.7 : 1};
      box-shadow: 0 2px 4px rgba(0,0,0,0.04);
    " 
    onmouseover="if (!this.classList.contains('task-dragging')) { this.style.transform='translateY(-3px)'; this.style.boxShadow='0 8px 25px rgba(0,0,0,0.08)'; this.style.borderLeft='4px solid #f59e0b'; this.style.borderTop='none'; this.style.borderRight='none'; this.style.borderBottom='none'; this.style.cursor='grab'; }" 
    onmousedown="this.style.cursor='grabbing'"
    onmouseout="if (!this.classList.contains('task-dragging')) { this.style.transform='translateY(0)'; this.style.boxShadow='0 2px 4px rgba(0,0,0,0.04)'; this.style.borderLeft='4px solid #f59e0b'; this.style.borderTop='none'; this.style.borderRight='none'; this.style.borderBottom='none'; this.style.background='#ffffff'; this.style.cursor='grab'; }">
      
      <!-- Priority Badge -->
      <div style="display: flex; justify-content: space-between; align-items: start; margin-bottom: 0.75rem;">
        <span style="
          background: ${priority.bg};
          color: ${priority.text};
          border: 1px solid ${priority.border};
          padding: 0.375rem 0.75rem;
          border-radius: 0.5rem;
          font-size: 0.75rem;
          font-weight: 600;
        ">
          ${task.priority}
        </span>
      </div>

      <!-- Task Title -->
      <h4 style="
        margin: 0 0 0.75rem 0;
        color: ${colors.text};
        font-size: 1rem;
        font-weight: 700;
        line-height: 1.3;
      ">
        ${task.title}
      </h4>

      <!-- Task Description (truncated) -->
      ${task.description ? `
        <p style="
          margin: 0 0 1rem 0;
          color: ${colors.textSecondary};
          font-size: 0.875rem;
          line-height: 1.5;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        ">
          ${makeLinksClickable(task.description)}
        </p>
      ` : ''}

      <!-- Contact and Project Info -->
      ${task.contact_name || task.project_name ? `
        <div style="
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
          margin-bottom: 0.75rem;
          padding-top: 0.75rem;
          border-top: 1px solid ${colors.border};
        ">
          ${task.contact_name ? `
            <div style="
              display: flex;
              align-items: center;
              gap: 0.375rem;
              background: #f0f9ff;
              color: #0369a1;
              padding: 0.375rem 0.625rem;
              border-radius: 0.5rem;
              font-size: 0.75rem;
              font-weight: 500;
            ">
              <span>👤</span>
              <span>${task.contact_name}</span>
            </div>
          ` : ''}
          ${task.project_name ? `
            <div style="
              display: flex;
              align-items: center;
              gap: 0.375rem;
              background: #f0fdf4;
              color: #166534;
              padding: 0.375rem 0.625rem;
              border-radius: 0.5rem;
              font-size: 0.75rem;
              font-weight: 500;
            ">
              <span>📁</span>
              <span>${task.project_name}</span>
            </div>
          ` : ''}
        </div>
      ` : ''}

      <!-- Task Footer -->
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <!-- Assigned Users -->
        <div style="display: flex; align-items: center; gap: 0.5rem;">
          ${task.assigned_members?.length > 0 ? `
            <div style="display: flex; align-items: center; gap: 0.25rem;">
              ${task.assigned_members.slice(0, 3).map((member, index) => `
                <div style="
                  width: 1.5rem;
                  height: 1.5rem;
                  background: ${colors.primary};
                  border-radius: 50%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  color: white;
                  font-size: 0.75rem;
                  font-weight: 600;
                  flex-shrink: 0;
                  border: 2px solid ${colors.surface};
                  margin-left: ${index > 0 ? '-0.25rem' : '0'};
                  position: relative;
                  z-index: ${3 - index};
                " title="${member.first_name} ${member.last_name}">
                  ${member.avatar_path ? `
                    <img 
                      src="${getAvatarUrl(member.avatar_path)}" 
                      alt="${member.first_name} ${member.last_name}"
                      style="
                        width: 100%;
                        height: 100%;
                        border-radius: 50%;
                        object-fit: cover;
                      "
                      onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';"
                    />
                    <div style="display: none; width: 100%; height: 100%; align-items: center; justify-content: center;">
                      ${member.first_name?.charAt(0)?.toUpperCase() || member.last_name?.charAt(0)?.toUpperCase() || 'U'}
                    </div>
                  ` : `
                    ${member.first_name?.charAt(0)?.toUpperCase() || member.last_name?.charAt(0)?.toUpperCase() || 'U'}
                  `}
                </div>
              `).join('')}
              ${task.assigned_members.length > 3 ? `
                <div style="
                  width: 1.5rem;
                  height: 1.5rem;
                  background: ${colors.border};
                  border-radius: 50%;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  color: ${colors.textSecondary};
                  font-size: 0.75rem;
                  font-weight: 600;
                  flex-shrink: 0;
                  border: 2px solid ${colors.surface};
                  margin-left: -0.25rem;
                " title="+${task.assigned_members.length - 3} more">
                  +${task.assigned_members.length - 3}
                </div>
              ` : ''}
            </div>
          ` : `
            <div style="
              width: 1.5rem;
              height: 1.5rem;
              background: ${colors.border};
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              color: ${colors.textSecondary};
              font-size: 0.75rem;
              flex-shrink: 0;
            ">
              ?
            </div>
            <span style="color: ${colors.textSecondary}; font-size: 0.75rem;">
              Unassigned
            </span>
          `}
        </div>

        <!-- Due Date and Comments Button -->
        <div style="display: flex; align-items: center; gap: 0.5rem;">
          ${task.due_at ? `
            <span style="
              color: ${colors.textSecondary};
              font-size: 0.75rem;
              background: ${colors.background};
              padding: 0.25rem 0.5rem;
              border-radius: 0.25rem;
            ">
              ${formatDateLocal(task.due_at)}
            </span>
          ` : ''}
          <button 
            onclick="event.stopPropagation(); if (window.showTaskComments) window.showTaskComments('${task.id}')"
            style="
              background: #ea580c;
              color: white;
              border: none;
              padding: 0.25rem 0.625rem;
              border-radius: 0.375rem;
              cursor: pointer;
              font-size: 0.75rem;
              font-weight: 500;
              transition: background-color 0.2s;
              white-space: nowrap;
            "
            onmouseover="this.style.background='#c2410c'"
            onmouseout="this.style.background='#ea580c'"
          >
            ${(taskCommentCounts[task.id] || 0) > 0 ? `View Comments (${taskCommentCounts[task.id]})` : 'Write Comment'}
          </button>
        </div>
      </div>
    </div>
  `;
}

// Render active filters
function renderActiveFilters() {
  const filters = [];

  if (taskFilters.status.length > 0) {
    filters.push(`
      <span style="
        background: ${colors.primaryLight};
        color: ${colors.primaryDark};
        padding: 0.25rem 0.5rem;
        border-radius: 0.25rem;
        font-size: 0.75rem;
        font-weight: 500;
      ">
        Status: ${taskFilters.status.join(', ')}
      </span>
    `);
  }

  if (taskFilters.priority.length > 0) {
    filters.push(`
      <span style="
        background: ${colors.warning}20;
        color: ${colors.warning};
        padding: 0.25rem 0.5rem;
        border-radius: 0.25rem;
        font-size: 0.75rem;
        font-weight: 500;
      ">
        Priority: ${taskFilters.priority.join(', ')}
      </span>
    `);
  }

  return filters.join('');
}

// Render tasks list
function renderTasksList(tasks) {
  if (tasks.length === 0) {
    return `
      <div style="
        padding: 3rem;
        text-align: center;
        color: ${colors.textSecondary};
      ">
        <div style="font-size: 3rem; margin-bottom: 1rem; color: #6c757d;">
          <span class="material-icons" style="font-size: 3rem;">assignment</span>
        </div>
        <p style="font-size: 1.125rem; margin: 0;">No tasks found</p>
        <p style="font-size: 0.875rem; margin: 0.5rem 0 0 0;">
          Try adjusting your filters or create a new task
        </p>
      </div>
    `;
  }

  return tasks.map(task => renderTaskCard(task)).join('');
}

// Render individual task card
function renderTaskCard(task) {
  const priorityColors = {
    LOW: { bg: '#10b98120', text: '#10b981', label: 'Low' },
    MEDIUM: { bg: '#f59e0b20', text: '#f59e0b', label: 'Medium' },
    HIGH: { bg: '#ea580c20', text: '#ea580c', label: 'High' },
    URGENT: { bg: '#ef444420', text: '#ef4444', label: 'Urgent' }
  };

  const statusColors = {
    BACKLOG: { bg: '#64748b20', text: '#64748b', label: 'Backlog' },
    ACTIVE: { bg: '#3b82f620', text: '#3b82f6', label: 'Active' },
    COMPLETED: { bg: '#10b98120', text: '#10b981', label: 'Completed' }
  };

  const priority = priorityColors[task.priority] || priorityColors.MEDIUM;
  const status = statusColors[task.state] || statusColors.BACKLOG;

  return `
    <div style="
      padding: 1.5rem;
      border-bottom: 1px solid ${colors.border};
      transition: background-color 0.2s;
    " onmouseover="this.style.background='${colors.background}'" onmouseout="this.style.background='${colors.surface}'">
      <div style="display: flex; justify-content: space-between; align-items: start; margin-bottom: 0.75rem;">
        <div style="display: flex; gap: 0.5rem; flex-wrap: wrap;">
          <span style="
            background: ${status.bg};
            color: ${status.text};
            padding: 0.25rem 0.5rem;
            border-radius: 0.25rem;
            font-size: 0.75rem;
            font-weight: 600;
          ">
            ${status.label}
          </span>
          <span style="
            background: ${priority.bg};
            color: ${priority.text};
            padding: 0.25rem 0.5rem;
            border-radius: 0.25rem;
            font-size: 0.75rem;
            font-weight: 600;
          ">
            ${priority.label}
          </span>
        </div>
        <div style="display: flex; gap: 0.5rem;">
          <button
            onclick="editTask('${task.id}')"
            style="
              background: #f59e0b;
              color: white;
              border: none;
              padding: 0.5rem;
              border-radius: 0.25rem;
              cursor: pointer;
              font-size: 0.75rem;
              transition: all 0.2s ease;
            "
            onmouseover="this.style.background='#d97706'"
            onmouseout="this.style.background='#f59e0b'"
          >
            Edit
          </button>
          <button
            onclick="viewTaskDetails('${task.id}')"
            style="
              background: ${colors.primary};
              color: white;
              border: none;
              padding: 0.5rem;
              border-radius: 0.25rem;
              cursor: pointer;
              font-size: 0.75rem;
            "
          >
            View
          </button>
        </div>
      </div>

      <h3 style="
        margin: 0 0 0.5rem 0;
        color: ${colors.text};
        font-size: 1.125rem;
        font-weight: 600;
      ">
        ${task.title}
      </h3>

      ${task.description ? `
        <p style="
          margin: 0 0 0.75rem 0;
          color: ${colors.textSecondary};
          font-size: 0.875rem;
          line-height: 1.5;
        ">
          ${makeLinksClickable(task.description)}
        </p>
      ` : ''}

      <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 0.5rem;">
        <div style="display: flex; align-items: center; gap: 0.5rem;">
          ${task.assigned_members?.length > 0 ? `
            <div style="display: flex; align-items: center; gap: 0.25rem;">
              <div style="
                width: 1.5rem;
                height: 1.5rem;
                background: ${colors.primary};
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                color: white;
                font-size: 0.75rem;
                font-weight: 600;
              ">
                ${task.assigned_members[0].first_name?.charAt(0) || 'U'}
              </div>
              <span style="color: ${colors.textSecondary}; font-size: 0.875rem;">
                ${task.assigned_members[0].first_name} ${task.assigned_members[0].last_name}
              </span>
            </div>
          ` : ''}
        </div>
        
        ${task.due_at ? `
          <span style="color: ${colors.textSecondary}; font-size: 0.875rem;">
            Due: ${formatDateLocal(task.due_at)}
          </span>
        ` : ''}
      </div>
    </div>
  `;
}


// Switch screen
window.switchScreen = function (screen) {
  // Check if user is CLIENT and prevent access to restricted screens
  const userRole = currentProfile?.company_role || currentProfile?.role || 'USER';
  const isClient = userRole === 'CLIENT';

  // CLIENTs can only access dashboard, chat, documents (vault), and profile
  if (isClient && !['dashboard', 'chat', 'vault', 'profile'].includes(screen)) {
    console.log('🚫 CLIENT cannot access screen:', screen);
    currentScreen = 'dashboard';
    renderPMTool();
    return;
  }

  // Close company management if open when switching to another screen
  if (showCompanyManagement) {
    showCompanyManagement = false;
    // Reset search queries and modal states
    memberSearchQuery = '';
    serviceSearchQuery = '';
    clientSearchQuery = '';
    window.clientSearchQuery = '';
    editingMemberId = null;
    showAddMemberModal = false;
    editingServiceId = null;
    showAddServiceModal = false;
    showAddClientModal = false;
    addingClientContactId = null;
  }

  // Reset chat selection when leaving chat screen (so it shows "select a chat" when coming back)
  if (currentScreen === 'chat' && screen !== 'chat') {
    selectedChatId = null;
    chatMessages = [];
  }

  currentScreen = screen;
  // Reset sales view when leaving/entering sales screen
  if (screen === 'sales') {
    salesView = 'contacts';
    selectedContactId = null;
    showAddContactModal = false; // Reset modal state when switching to sales screen
  }

  // Load time tracking data when switching to time tracking screen
  if (screen === 'time-tracking') {
    console.log('🕐 [Time Tracking] switchScreen("time-tracking") called');
    console.log('🕐 [Time Tracking] Profile/Company check:', {
      hasProfile: !!currentProfile?.id,
      hasCompany: !!currentCompany?.id,
      profileId: currentProfile?.id,
      companyId: currentCompany?.id
    });
    timeTrackingView = 'main';
    // Only load if profile and company are available
    if (currentProfile?.id && currentCompany?.id) {
      console.log('🕐 [Time Tracking] Calling loadTimeTrackingData() from switchScreen');
      // Force reload when switching to the screen
      timeTrackingData.forceReload = true;
      loadTimeTrackingData();
    } else {
      console.warn('🕐 [Time Tracking] Profile or company missing, resetting state');
      // Reset state if profile/company not available
      timeTrackingData.checkingStatus = false;
      timeTrackingData.isClockedIn = false;
      timeTrackingData.currentEntryId = null;
      timeTrackingData.dataLoaded = false;
    }
  }

  renderPMTool();
};

window.closeMobileMenu = function () {
  const mobileMenu = document.getElementById('mobile-menu');
  if (mobileMenu) {
    mobileMenu.style.left = '-100%';
  }
};

// Sales View Handlers
// Check if user can access reports (managers and owners only)
function canAccessReports() {
  if (!currentUser && !currentProfile) return false;

  const profile = currentProfile || currentUser;

  // HH Admins can access reports
  if (profile.is_hh_admin) return true;

  // Check company_role from company_members table
  // This should be loaded when user logs in
  const companyRole = profile.company_role;

  // Only OWNER and MANAGER can access reports
  return companyRole === 'OWNER' || companyRole === 'MANAGER';
}

window.switchSalesView = function (view) {
  // Check if user can access reports
  if (view === 'reports' && !canAccessReports()) {
    alert('You do not have permission to access reports. Only managers and owners can view reports.');
    return;
  }

  salesView = view;
  selectedContactId = null;
  contactDetailTab = 'quickview';
  showAddContactModal = false; // Reset modal state when switching views
  renderPMTool();
};

// Sales Dashboard Filter Handlers
window.setSalesDealFilter = function (filter) {
  salesDealFilter = filter;
  renderPMTool();
};

window.setSalesProbabilityFilter = function (filter) {
  salesProbabilityFilter = filter;
  renderPMTool();
};

window.setSalesStageFilter = function (filter) {
  salesStageFilter = filter;
  renderPMTool();
};

window.setUpcomingRemindersFilter = function (filter) {
  upcomingRemindersFilter = filter;
  renderPMTool();
};

window.toggleSalesDealsView = function () {
  salesDealsView = salesDealsView === 'list' ? 'kanban' : 'list';
  renderPMTool();
};

window.setReportsDateFilter = function (filter) {
  reportsDateFilter = filter;
  if (filter === 'custom') {
    showCustomDatePicker = true;
  } else {
    showCustomDatePicker = false;
  }
  renderPMTool();
};

window.applyCustomDateRange = function () {
  const startInput = document.getElementById('custom-start-date');
  const endInput = document.getElementById('custom-end-date');
  if (startInput && endInput && startInput.value && endInput.value) {
    reportsCustomStartDate = startInput.value;
    reportsCustomEndDate = endInput.value;
    showCustomDatePicker = false;
    renderPMTool();
  }
};

window.cancelCustomDatePicker = function () {
  showCustomDatePicker = false;
  reportsDateFilter = 'month';
  renderPMTool();
};

window.switchContactDetailTab = function (tab) {
  contactDetailTab = tab;
  renderPMTool();
};

window.viewContactDetail = async function (contactId) {
  // Update selected contact and reset tab to activity
  const wasDifferentContact = selectedContactId !== contactId;
  selectedContactId = contactId;
  contactDetailTab = 'quickview';
  contactDetailViewTab = 'activity';
  showAllProjects = false; // Reset to show only active projects
  showAllTasks = false; // Reset to show only active tasks

  // Ensure we're on the sales screen
  if (currentScreen !== 'sales') {
    currentScreen = 'sales';
    renderPMTool();
    return; // renderPMTool will handle rendering the contact detail
  }

  // Update contact list highlighting immediately (synchronous)
  const contactsListDiv = document.querySelector('#contacts-list');
  if (contactsListDiv) {
    contactsListDiv.innerHTML = getContactsListHTML();
  }

  // Only update the contact detail area, not the entire app
  const contactDetailDiv = document.getElementById('contact-detail-content');
  if (contactDetailDiv) {
    // Update contact detail content
    await updateContactDetailContent();
  } else {
    // Fallback: re-render entire app if contact detail div doesn't exist
    renderPMTool();
  }
};

window.closeContactDetail = function () {
  selectedContactId = null;
  renderPMTool();
};

// Show add contact modal directly (without re-rendering)
window.showAddContactModalDirect = function () {
  showAddContactModal = true;

  // Inject modal directly instead of re-rendering entire page
  const existingModal = document.getElementById('add-contact-modal');
  if (existingModal) {
    existingModal.remove();
  }

  const modalHTML = renderAddContactModal();
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = modalHTML;
  const modalElement = tempDiv.firstElementChild;

  document.body.appendChild(modalElement);

  // Animate in
  setTimeout(() => {
    if (modalElement) {
      modalElement.style.opacity = '1';
    }
  }, 10);
};

// Format phone number as (XXX) XXX-XXXX (for input while typing)
window.formatPhoneNumber = function (input) {
  // Remove all non-digit characters
  let value = input.value.replace(/\D/g, '');

  // Format based on length
  if (value.length === 0) {
    input.value = '';
    return;
  }

  if (value.length <= 3) {
    input.value = `(${value}`;
  } else if (value.length <= 6) {
    input.value = `(${value.slice(0, 3)}) ${value.slice(3)}`;
  } else {
    input.value = `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6, 10)}`;
  }
};

// Format phone for display: (XXX) XXX-XXXX
function formatPhoneForDisplay(phone) {
  if (!phone || typeof phone !== 'string') return '';
  const digits = phone.replace(/\D/g, '');
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  if (digits.length === 11 && digits[0] === '1') {
    return `(${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }
  return phone;
}

// Handle Contact Search
window.handleContactSearch = function (event) {
  const query = event.target.value || '';
  contactSearchQuery = query.trim();
  window.contactSearchQuery = contactSearchQuery; // Sync global

  // Re-render the contacts list
  const contactsListDiv = document.getElementById('contacts-list');
  if (contactsListDiv) {
    contactsListDiv.innerHTML = getContactsListHTML();
  } else {
    // If contacts list not found, re-render the whole contacts screen
    renderPMTool();
  }
};

// Get filtered contacts based on search
function getFilteredContacts() {
  const searchQuery = (contactSearchQuery || window.contactSearchQuery || '').toLowerCase().trim();
  if (!searchQuery) return contacts || [];

  return (contacts || []).filter(contact => {
    const firstName = (contact.first_name || '').toLowerCase();
    const lastName = (contact.last_name || '').toLowerCase();
    const fullName = `${firstName} ${lastName}`.trim();
    const phone = (contact.phone || '').toLowerCase();
    const email = (contact.email || '').toLowerCase();
    const company = (contact.company || contact.company_name || '').toLowerCase();

    return fullName.includes(searchQuery) ||
      firstName.includes(searchQuery) ||
      lastName.includes(searchQuery) ||
      phone.includes(searchQuery) ||
      email.includes(searchQuery) ||
      company.includes(searchQuery);
  });
};

// Helper: true if contact is a calendar (name contains "Calendar")
function isCalendarContact(contact) {
  return (contact.first_name && contact.first_name.includes('Calendar')) ||
    (contact.last_name && contact.last_name.includes('Calendar')) ||
    (contact.first_name && contact.last_name && `${contact.first_name} ${contact.last_name}`.includes('Calendar'));
}

// Generate contacts list HTML
function getContactsListHTML() {
  const filteredContacts = getFilteredContacts();
  if (filteredContacts.length === 0) {
    return `
      <div style="
        text-align: center;
        padding: 3rem 1.5rem;
        color: #6c757d;
      ">
        <div style="font-size: 2rem; margin-bottom: 1rem; color: #6c757d;">
          <span class="material-icons" style="font-size: 2rem;">people</span>
        </div>
        <p style="font-weight: 600; margin-bottom: 0.5rem;">${contactSearchQuery ? 'No contacts found' : 'No contacts yet'}</p>
        <p style="font-size: 0.875rem;">${contactSearchQuery ? 'Try adjusting your search terms' : 'Start adding contacts to manage your sales pipeline'}</p>
      </div>
    `;
  }
  // Sort: non-calendar contacts first, calendar contacts at the bottom
  const sortedContacts = [...filteredContacts].sort((a, b) => {
    const aCal = isCalendarContact(a);
    const bCal = isCalendarContact(b);
    if (aCal === bCal) return 0;
    return aCal ? 1 : -1;
  });
  return sortedContacts.map(contact => {
    const openOpportunities = salesOpportunities.filter(opp =>
      opp.contact?.id === contact.id &&
      opp.stage !== 'won' &&
      opp.stage !== 'lost' &&
      !opp.closed_at // Exclude archived deals
    );

    // Calculate overdue count and upcoming appointments excluding completed items
    // Use the global reminders and appointments arrays if available
    const contactReminders = (reminders || []).filter(r => r.contact_id === contact.id);
    const contactAppointments = (appointments || []).filter(a => a.contact_id === contact.id);

    // Count overdue reminders (not completed, past due date)
    const now = new Date();
    now.setHours(0, 0, 0, 0); // Set to start of day for comparison
    const overdueReminders = contactReminders.filter(r => {
      if (r.status === 'completed') return false; // Exclude completed
      if (!r.due_at) return false;
      const dueDate = new Date(r.due_at);
      dueDate.setHours(0, 0, 0, 0);
      return dueDate < now;
    });
    const overdueCount = overdueReminders.length;

    // Check for upcoming appointments (future appointments only)
    const upcomingAppointments = contactAppointments.filter(a => {
      if (!a.appointment_date) return false;
      // Parse appointment_date in local timezone to avoid UTC conversion issues
      const dateParts = a.appointment_date.split('-');
      let apptDate;
      if (dateParts.length === 3) {
        apptDate = new Date(
          parseInt(dateParts[0], 10),
          parseInt(dateParts[1], 10) - 1,
          parseInt(dateParts[2], 10)
        );
      } else {
        apptDate = new Date(a.appointment_date);
      }
      apptDate.setHours(0, 0, 0, 0);
      return apptDate >= now; // Future or today
    });
    const hasUpcomingAppt = upcomingAppointments.length > 0;

    const isCal = isCalendarContact(contact);

    // Format display name for calendar contacts
    let displayName = `${contact.first_name} ${contact.last_name}`.trim();
    if (isCal) {
      // Extract calendar name (remove "Calendar" suffix and format as "Calendar: {name}")
      const calendarName = displayName.replace(/\s+Calendar$/, '').trim();
      displayName = `Calendar: ${calendarName}`;
    }

    // Simple badge: Client, Calendar, or Contact
    const normalizedStatus = (contact.status || '').toLowerCase();
    let badgeText = 'Contact';
    let badgeColor = '#6c757d';

    // Show "Calendar" for calendar contacts
    if (isCal) {
      badgeText = 'Calendar';
      badgeColor = '#4285f4'; // Google Calendar blue
    }
    // Show "Client" if:
    // 1. Status is explicitly marked as client or customer
    // 2. Has a user account/profile (contact_profile_id exists)
    else if (['client', 'customer'].includes(normalizedStatus) || contact.contact_profile_id) {
      badgeText = 'Client';
      badgeColor = '#ff7f00';
    }
    const metaBadges = [
      hasUpcomingAppt ? '<span style="background:#0ea5e9; color:white; padding:0.125rem 0.5rem; border-radius:999px; font-size:0.625rem; font-weight:600;">Upcoming Appt</span>' : '',
      openOpportunities.length > 0 ? `<span style="color:#000000; padding:0.125rem 0.5rem; font-size:0.625rem; font-weight:600;"><span style="color:#dc2626; font-weight:700;">${openOpportunities.length}</span> Active Deals</span>` : '',
      overdueCount > 0 ? `<span style="color:#000000; padding:0.125rem 0.5rem; font-size:0.625rem; font-weight:600;"><span style="color:#dc2626; font-weight:700;">${overdueCount}</span> Overdue</span>` : ''
    ].filter(Boolean).join('');

    return `
                  <div 
                    onclick="viewContactDetail('${contact.id}')"
                    style="
                      padding: 1rem 1.5rem;
                      border-bottom: 1px solid #e9ecef;
                      cursor: pointer;
                      transition: all 0.2s ease;
                      display: flex;
                      align-items: center;
                      gap: 1rem;
                      background: ${selectedContactId === contact.id ? '#f8f9fa' : 'transparent'};
                    "
                    onmouseover="this.style.background='#f8f9fa'"
                    onmouseout="this.style.background='${selectedContactId === contact.id ? '#f8f9fa' : 'transparent'}'"
                  >
                    <div style="
                      width: 40px;
                      height: 40px;
                      border-radius: 50%;
                      background: ${getAvatarColor(`${contact.first_name} ${contact.last_name}`)};
                      color: white;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      font-weight: 600;
                      font-size: 0.875rem;
                      flex-shrink: 0;
                    ">
                      ${contact.first_name?.charAt(0) || '?'}${contact.last_name?.charAt(0) || ''}
                    </div>
                    <div style="flex: 1; min-width: 0;">
                      <div style="
                        font-weight: 600;
                        color: #2c3e50;
                        margin-bottom: 0.25rem;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        font-size: 0.875rem;
                      ">
                        ${displayName}
                      </div>
                      <div style="
                        font-size: 0.75rem;
                        color: #6c757d;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                      ">
                        ${contact.phone ? formatPhoneForDisplay(contact.phone) : 'No phone'}
                      </div>
                      ${metaBadges ? `
                        <div style="
                          display: flex;
                          flex-wrap: wrap;
                          gap: 0.25rem;
                          margin-top: 0.35rem;
                        ">
                          ${metaBadges}
                        </div>
                      ` : ''}
                    </div>
                    <div style="flex-shrink: 0;">
                      <div style="
                        background: ${badgeColor};
                        color: white;
                        padding: 0.25rem 0.75rem;
                        border-radius: 1rem;
                        font-size: 0.75rem;
                        font-weight: 600;
                        text-align: center;
                        min-width: 64px;
                        text-transform: capitalize;
                      ">
                        ${badgeText}
                      </div>
                    </div>
                  </div>
                `;
  }).join('');
};

// Render Resources Screen
function renderResourcesScreen() {
  return `
    <div style="max-width: 1200px; margin: 0 auto; padding: 1.5rem;">
      <!-- Header -->
      <div style="margin-bottom: 2rem;">
        <h1 style="
          color: ${colors.text};
          margin: 0 0 0.5rem 0;
          font-size: 2rem;
          font-weight: 700;
        ">
          Resources
        </h1>
        <p style="
          color: ${colors.textSecondary};
          margin: 0;
          font-size: 1rem;
        ">
          Access AI Eva, company resources, and booking services
        </p>
      </div>

      <!-- Tab Navigation -->
      <div style="
        display: flex;
        gap: 0.5rem;
        margin-bottom: 2rem;
        border-bottom: 2px solid #e9ecef;
      ">
        <button
          onclick="switchResourcesTab('resources')"
          style="
            background: ${resourcesTab === 'resources' ? '#f59e0b' : 'transparent'};
            color: ${resourcesTab === 'resources' ? 'white' : '#6c757d'};
            border: none;
            padding: 0.625rem 1.25rem;
            border-radius: 0.5rem 0.5rem 0 0;
            cursor: pointer;
            font-weight: 600;
            font-size: 0.875rem;
            transition: all 0.2s;
            margin-bottom: -2px;
          "
          onmouseover="if ((window.resourcesTab || resourcesTab) !== 'resources') { this.style.color='#2c3e50'; this.style.background='#f3f4f6'; }"
          onmouseout="if ((window.resourcesTab || resourcesTab) !== 'resources') { this.style.color='#6c757d'; this.style.background='transparent'; } else { this.style.color='white'; this.style.background='#f59e0b'; }"
        >
          Resources
        </button>
        <button
          onclick="switchResourcesTab('book-now')"
          style="
            background: ${resourcesTab === 'book-now' ? '#f59e0b' : 'transparent'};
            color: ${resourcesTab === 'book-now' ? 'white' : '#6c757d'};
            border: none;
            padding: 0.625rem 1.25rem;
            border-radius: 0.5rem 0.5rem 0 0;
            cursor: pointer;
            font-weight: 600;
            font-size: 0.875rem;
            transition: all 0.2s;
            margin-bottom: -2px;
          "
          onmouseover="if ((window.resourcesTab || resourcesTab) !== 'book-now') { this.style.color='#2c3e50'; this.style.background='#f3f4f6'; }"
          onmouseout="if ((window.resourcesTab || resourcesTab) !== 'book-now') { this.style.color='#6c757d'; this.style.background='transparent'; } else { this.style.color='white'; this.style.background='#f59e0b'; }"
        >
          Book Now
        </button>
      </div>

      <!-- Tab Content -->
      ${resourcesTab === 'resources' ? renderResourcesTab() : ''}
      ${resourcesTab === 'book-now' ? renderBookNowTab() : ''}
    </div>
  `;
}

// Render AI Eva Tab
function renderAIEvaTab() {
  const language = getEvaUserLanguage();
  const isSpanish = language === 'es';

  return `
    <div style="display: flex; flex-direction: column; gap: 1.5rem;">
      <!-- AI Eva Card -->
      <div style="
        background: ${colors.surface};
        border-radius: 0.75rem;
        padding: 2rem;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
      ">
        <!-- Avatar -->
        <div style="margin-bottom: 1rem;">
          <div style="
            width: 80px;
            height: 80px;
            border-radius: 50%;
            background: linear-gradient(135deg, #3B82F6 0%, #2563EB 100%);
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-size: 2rem;
            font-weight: 600;
            margin: 0 auto;
            box-shadow: 0 4px 6px rgba(59, 130, 246, 0.3);
          ">
            ✨
          </div>
        </div>
        
        <h2 style="
          margin: 0 0 0.5rem 0;
          color: ${colors.text};
          font-size: 1.5rem;
          font-weight: 700;
        ">
          Eva AI
        </h2>
        <p style="
          margin: 0 0 1.5rem 0;
          color: ${colors.textSecondary};
          font-size: 0.9375rem;
          line-height: 1.6;
          max-width: 500px;
        ">
          ${isSpanish ? '¡Hola! Soy Eva, tu asistente de IA. Estoy aquí para ayudarte con información sobre tus tareas, proyectos, contactos y más.' : 'Hello! I\'m Eva, your AI assistant. I\'m here to help you with information about your tasks, projects, contacts, and more.'}
        </p>
        
        <button
          onclick="openEvaChat();"
          style="
            background: #3B82F6;
            color: white;
            border: none;
            padding: 0.75rem 1.5rem;
            border-radius: 0.5rem;
            cursor: pointer;
            font-weight: 600;
            font-size: 0.875rem;
            transition: all 0.2s;
            box-shadow: 0 2px 4px rgba(59, 130, 246, 0.3);
          "
          onmouseover="this.style.background='#2563EB'; this.style.boxShadow='0 4px 6px rgba(59, 130, 246, 0.4)'"
          onmouseout="this.style.background='#3B82F6'; this.style.boxShadow='0 2px 4px rgba(59, 130, 246, 0.3)'"
        >
          ${isSpanish ? '💬 Chatear con Eva' : '💬 Chat with Eva'}
        </button>
      </div>
      
      <!-- Quick Actions -->
      <div style="
        background: ${colors.surface};
        border-radius: 0.75rem;
        padding: 1.5rem;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
      ">
        <h3 style="
          margin: 0 0 1rem 0;
          color: ${colors.text};
          font-size: 1.25rem;
          font-weight: 700;
        ">
          ${isSpanish ? 'Preguntas Ejemplo' : 'Example Questions'}
        </h3>
        <div style="display: flex; flex-direction: column; gap: 0.75rem;">
          ${[
      isSpanish ? '¿Cuántas tareas tengo pendientes?' : 'How many pending tasks do I have?',
      isSpanish ? '¿Tengo citas hoy?' : 'Do I have appointments today?',
      isSpanish ? 'Dame un resumen de mi día' : 'Give me a summary of my day',
      isSpanish ? '¿Cómo creo una tarea?' : 'How do I create a task?'
    ].map(question => `
            <button
              onclick="evaInputText = '${question}'; openEvaChat(); setTimeout(() => { const input = document.getElementById('eva-input'); if (input) { input.value = '${question}'; updateEvaInput('${question}'); } }, 200);"
              style="
                background: transparent;
                border: 1px solid #e9ecef;
                color: ${colors.text};
                padding: 0.75rem 1rem;
                border-radius: 0.5rem;
                cursor: pointer;
                text-align: left;
                font-size: 0.875rem;
                transition: all 0.2s;
              "
              onmouseover="this.style.borderColor='#3B82F6'; this.style.background='#EBF4FF'"
              onmouseout="this.style.borderColor='#e9ecef'; this.style.background='transparent'"
            >
              ${question}
            </button>
          `).join('')}
        </div>
      </div>

      <!-- Logo Maker Section -->
          <div style="
            background: ${colors.surface};
            border-radius: 0.75rem;
            padding: 1.5rem;
            box-shadow: 0 1px 3px rgba(0,0,0,0.1);
      ">
        <h3 style="
          margin: 0 0 1rem 0;
          color: ${colors.text};
          font-size: 1.25rem;
          font-weight: 700;
        ">
          Let's Make a Logo!
        </h3>
        
        <!-- Input and Button Row -->
        <div style="
          display: flex;
          gap: 0.75rem;
          margin-bottom: 1.5rem;
          align-items: flex-start;
        ">
          <input
            type="text"
            id="logo-description-input"
            placeholder="Describe your logo (e.g., 'Modern bakery logo with fresh bread')"
            style="
              flex: 1;
              padding: 0.625rem 0.875rem;
              border: 1px solid #e9ecef;
              border-radius: 0.5rem;
              font-size: 0.875rem;
              box-sizing: border-box;
              transition: border-color 0.2s;
            "
            onfocus="this.style.borderColor='#f59e0b'"
            onblur="this.style.borderColor='#e9ecef'"
          />
          <button
            onclick="alert('Logo creation coming soon!')"
            style="
              background: #6c757d;
              color: white;
              border: none;
              padding: 0.625rem 1.25rem;
              border-radius: 0.5rem;
              cursor: pointer;
              font-weight: 600;
              font-size: 0.875rem;
              white-space: nowrap;
              transition: background-color 0.2s;
            "
            onmouseover="this.style.background='#5a6268'"
            onmouseout="this.style.background='#6c757d'"
          >
            Create Logo
          </button>
        </div>

        <!-- Logo Placeholders Grid -->
        <div style="
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 1rem;
        ">
          ${[1, 2, 3, 4].map(num => `
            <div style="
              background: #f8f9fa;
              border: 2px dashed #dee2e6;
              border-radius: 0.5rem;
              padding: 2rem;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              min-height: 150px;
              cursor: pointer;
              transition: all 0.2s;
            "
            onmouseover="this.style.borderColor='#f59e0b'; this.style.background='#fffbf5'"
            onmouseout="this.style.borderColor='#dee2e6'; this.style.background='#f8f9fa'"
            onclick="alert('Logo ${num} placeholder - Coming soon!')"
            >
              <div style="
                font-size: 2rem;
                margin-bottom: 0.5rem;
                opacity: 0.5;
              ">🎨</div>
              <div style="
                color: #6c757d;
                font-size: 0.875rem;
                font-weight: 500;
              ">Logo ${num}</div>
            </div>
          `).join('')}
        </div>
      </div>
    </div>
  `;
}

// Render Resources Tab
function renderResourcesTab() {
  const videos = resources.filter(item => item.type === 'VIDEO');
  const pdfs = resources.filter(item => item.type === 'PDF');
  const websites = resources.filter(item => item.type === 'WEBSITE');

  return `
    <div style="display: flex; flex-direction: column; gap: 2.5rem;">
      <!-- Videos Section -->
      <div>
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
          <h2 style="
            margin: 0;
            color: ${colors.text};
            font-size: 1.5rem;
            font-weight: 700;
          ">
            Videos
          </h2>
        </div>
        ${videos.length === 0 ? `
          <div style="
            text-align: center;
            padding: 3rem;
            color: ${colors.textSecondary};
            background: ${colors.surface};
            border-radius: 0.75rem;
          ">
            <div style="font-size: 3rem; margin-bottom: 1rem; color: #6c757d;">
              <span class="material-icons" style="font-size: 3rem;">videocam</span>
            </div>
            <p style="margin: 0; font-size: 1rem;">No videos available</p>
          </div>
        ` : `
          <div id="videos-carousel" style="
            display: flex;
            gap: 1rem;
            overflow-x: auto;
            padding-bottom: 0.5rem;
            scroll-behavior: smooth;
            -webkit-overflow-scrolling: touch;
          " onscroll="updateCarouselArrows('videos-carousel')">
            ${videos.map(video => `
              <div style="
                flex: 0 0 320px;
                background: ${colors.surface};
                border-radius: 0.75rem;
                overflow: hidden;
                box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                cursor: pointer;
                transition: transform 0.2s, box-shadow 0.2s;
              "
              onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 4px 6px rgba(0,0,0,0.1)'"
              onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 1px 3px rgba(0,0,0,0.1)'"
              onclick="window.open('${video.url || '#'}', '_blank')"
              >
                <div style="
                  width: 100%;
                  height: 180px;
                  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  position: relative;
                  overflow: hidden;
                ">
                  ${video.thumbnail_url ? `
                    <img
                      src="${video.thumbnail_url}"
                      alt="${video.title || 'Video'}"
                      style="
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                      "
                      onerror="this.parentElement.innerHTML='<div style=\\'width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; color: white; font-size: 3rem;\\'>🎥</div>'"
                    />
                  ` : `
                    <div style="color: white; font-size: 3rem;">🎥</div>
                  `}
                  <div style="
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 60px;
                    height: 60px;
                    background: rgba(255, 255, 255, 0.9);
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 1.5rem;
                  ">
                    ▶
                  </div>
                </div>
                <div style="padding: 1rem;">
            <h3 style="
              margin: 0 0 0.5rem 0;
              color: ${colors.text};
                    font-size: 1rem;
                    font-weight: 700;
                    line-height: 1.3;
                  ">
                    ${video.title || 'Video'}
                  </h3>
                  <p style="
                    margin: 0;
                    color: ${colors.textSecondary};
                    font-size: 0.8125rem;
                    line-height: 1.5;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                  ">
                    ${video.description || 'No description available'}
                  </p>
                </div>
              </div>
            `).join('')}
          </div>
        `}
      </div>

      <!-- Websites Section -->
      <div>
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
          <h2 style="
            margin: 0;
            color: ${colors.text};
            font-size: 1.5rem;
            font-weight: 700;
          ">
            Websites
          </h2>
        </div>
        ${websites.length === 0 ? `
          <div style="
            text-align: center;
            padding: 3rem;
            color: ${colors.textSecondary};
            background: ${colors.surface};
            border-radius: 0.75rem;
          ">
            <div style="font-size: 3rem; margin-bottom: 1rem; color: #6c757d;">
              <span class="material-icons" style="font-size: 3rem;">language</span>
            </div>
            <p style="margin: 0; font-size: 1rem;">No websites available</p>
          </div>
        ` : `
          <div id="websites-carousel" style="
            display: flex;
            gap: 1rem;
            overflow-x: auto;
            padding-bottom: 0.5rem;
            scroll-behavior: smooth;
            -webkit-overflow-scrolling: touch;
          " onscroll="updateCarouselArrows('websites-carousel')">
            ${websites.map(website => `
              <div style="
                flex: 0 0 320px;
                background: ${colors.surface};
                border-radius: 0.75rem;
                overflow: hidden;
                box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                cursor: pointer;
                transition: transform 0.2s, box-shadow 0.2s;
                position: relative;
              "
              onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 4px 6px rgba(0,0,0,0.1)'"
              onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 1px 3px rgba(0,0,0,0.1)'"
              onclick="window.open('${website.url || '#'}', '_blank')"
              >
                <div style="
                  width: 100%;
                  height: 180px;
                  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  position: relative;
                  overflow: hidden;
                ">
                  ${website.thumbnail_url ? `
                    <img
                      src="${website.thumbnail_url}"
                      alt="${website.title || 'Website'}"
                      style="
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                      "
                      onerror="this.parentElement.innerHTML='<div style=\\'width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; color: white; font-size: 3rem;\\'>🌐</div>'"
                    />
                  ` : `
                    <div style="color: white; font-size: 3rem;">🌐</div>
                  `}
                  <button
                    onclick="event.stopPropagation(); window.open('${website.url || '#'}', '_blank')"
                    style="
                      position: absolute;
                      bottom: 0.75rem;
                      right: 0.75rem;
                      width: 36px;
                      height: 36px;
                      background: #f59e0b;
                      color: white;
                      border: none;
                      border-radius: 0.375rem;
                      cursor: pointer;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      font-size: 1rem;
              font-weight: 600;
                      box-shadow: 0 2px 4px rgba(0,0,0,0.2);
                      transition: background-color 0.2s;
                    "
                    onmouseover="this.style.background='#2563eb'"
                    onmouseout="this.style.background='#3b82f6'"
                  >
                    →
                  </button>
                </div>
                <div style="padding: 1rem;">
                  <h3 style="
                    margin: 0 0 0.5rem 0;
                    color: ${colors.text};
                    font-size: 1rem;
                    font-weight: 700;
                    line-height: 1.3;
                  ">
                    ${website.title || 'Website'}
            </h3>
                  ${website.description ? `
            <p style="
              margin: 0;
              color: ${colors.textSecondary};
                      font-size: 0.8125rem;
                      line-height: 1.5;
                      display: -webkit-box;
                      -webkit-line-clamp: 2;
                      -webkit-box-orient: vertical;
                      overflow: hidden;
                    ">
                      ${website.description}
                    </p>
                  ` : ''}
                </div>
              </div>
            `).join('')}
          </div>
        `}
      </div>

      <!-- PDFs Section -->
      <div>
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
          <h2 style="
            margin: 0;
            color: ${colors.text};
            font-size: 1.5rem;
            font-weight: 700;
          ">
            About Us
          </h2>
        </div>
        ${pdfs.length === 0 ? `
          <div style="
            text-align: center;
            padding: 3rem;
            color: ${colors.textSecondary};
            background: ${colors.surface};
            border-radius: 0.75rem;
          ">
            <div style="font-size: 3rem; margin-bottom: 1rem; color: #6c757d;">
              <span class="material-icons" style="font-size: 3rem;">description</span>
            </div>
            <p style="margin: 0; font-size: 1rem;">No PDFs available</p>
          </div>
        ` : `
          <div id="pdfs-carousel" style="
            display: flex;
            gap: 1rem;
            overflow-x: auto;
            padding-bottom: 0.5rem;
            scroll-behavior: smooth;
            -webkit-overflow-scrolling: touch;
          ">
            ${pdfs.map(pdf => `
              <div style="
                flex: 0 0 320px;
                background: ${colors.surface};
                border-radius: 0.75rem;
                overflow: hidden;
                box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                cursor: pointer;
                transition: transform 0.2s, box-shadow 0.2s;
              "
              onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 4px 6px rgba(0,0,0,0.1)'"
              onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 1px 3px rgba(0,0,0,0.1)'"
              onclick="window.open('${pdf.url || '#'}', '_blank')"
              >
                <div style="
                  width: 100%;
                  height: 180px;
                  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  position: relative;
                  overflow: hidden;
                ">
                  ${pdf.thumbnail_url ? `
                    <img
                      src="${pdf.thumbnail_url}"
                      alt="${pdf.title || 'PDF'}"
                      style="
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                      "
                      onerror="this.parentElement.innerHTML='<div style=\\'width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; color: white; font-size: 3rem;\\'>📄</div>'"
                    />
                  ` : `
                    <div style="color: white; font-size: 3rem;">📄</div>
                  `}
                  <div style="
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 60px;
                    height: 60px;
                    background: rgba(255, 255, 255, 0.9);
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 1.5rem;
                  ">
                    📄
                  </div>
                </div>
                <div style="padding: 1rem;">
                  <h3 style="
                    margin: 0 0 0.5rem 0;
                    color: ${colors.text};
                    font-size: 1rem;
                    font-weight: 700;
                    line-height: 1.3;
                  ">
                    ${pdf.title || 'PDF'}
                  </h3>
                  <p style="
                    margin: 0;
                    color: ${colors.textSecondary};
                    font-size: 0.8125rem;
                    line-height: 1.5;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                  ">
                    ${pdf.description || 'No description available'}
                  </p>
                </div>
              </div>
            `).join('')}
          </div>
        `}
      </div>

    </div>
  `;
}

// Carousel scroll functions
window.scrollCarousel = function (carouselId, direction) {
  const carousel = document.getElementById(carouselId);
  if (!carousel) return;

  const scrollAmount = 340; // card width (320px) + gap (1rem = 16px)
  const currentScroll = carousel.scrollLeft;
  const newScroll = direction === 'right'
    ? currentScroll + scrollAmount
    : currentScroll - scrollAmount;

  carousel.scrollTo({
    left: newScroll,
    behavior: 'smooth'
  });
};

window.updateCarouselArrows = function (carouselId) {
  // This can be used to show/hide arrows based on scroll position
  // For now, we'll keep it simple
};

// Switch Resources Tab
window.switchResourcesTab = function (tab) {
  resourcesTab = tab;
  renderPMTool();
};

// Render Book Now Tab
function renderBookNowTab() {
  const websites = portfolioItems.filter(item => item.type === 'WEBSITE');
  const photoVideos = portfolioItems.filter(item => item.type === 'PHOTO' || item.type === 'VIDEO');

  return `
    <div style="display: flex; flex-direction: column; gap: 2.5rem;">
      <!-- Websites Section -->
      <div>
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
          <h2 style="
            margin: 0;
            color: ${colors.text};
            font-size: 1.5rem;
            font-weight: 700;
          ">
            Websites
          </h2>
        </div>
        ${websites.length === 0 ? `
          <div style="
            text-align: center;
            padding: 3rem;
            color: ${colors.textSecondary};
            background: ${colors.surface};
            border-radius: 0.75rem;
          ">
            <div style="font-size: 3rem; margin-bottom: 1rem; color: #6c757d;">
              <span class="material-icons" style="font-size: 3rem;">language</span>
            </div>
            <p style="margin: 0; font-size: 1rem;">No websites available</p>
          </div>
        ` : `
          <div id="book-websites-carousel" style="
            display: flex;
            gap: 1rem;
            overflow-x: auto;
            padding-bottom: 0.5rem;
            scroll-behavior: smooth;
            -webkit-overflow-scrolling: touch;
          ">
            ${websites.map(website => `
              <div style="
                flex: 0 0 320px;
                background: ${colors.surface};
                border-radius: 0.75rem;
                overflow: hidden;
                box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                transition: transform 0.2s, box-shadow 0.2s;
                cursor: ${website.url ? 'pointer' : 'default'};
              "
              onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 4px 6px rgba(0,0,0,0.1)'"
              onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 1px 3px rgba(0,0,0,0.1)'"
              onclick="${website.url ? `window.open('${website.url}', '_blank')` : ''}"
              >
                <div style="
                  width: 100%;
                  height: 180px;
                  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  position: relative;
                  overflow: hidden;
                ">
                  ${website.thumbnail_url ? `
                    <img
                      src="${website.thumbnail_url}"
                      alt="${website.title || 'Website'}"
                      style="
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                      "
                      onerror="this.parentElement.innerHTML='<div style=\\'width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; color: white; font-size: 3rem;\\'>🌐</div>'"
                    />
                  ` : `
                    <div style="color: white; font-size: 3rem;">🌐</div>
                  `}
                </div>
                <div style="padding: 1rem;">
                  <h3 style="
                    margin: 0 0 0.5rem 0;
                    color: ${colors.text};
                    font-size: 1rem;
                    font-weight: 700;
                    line-height: 1.3;
                  ">
                    ${website.title || 'Website'}
                  </h3>
                  ${website.description ? `
                    <p style="
                      margin: 0 0 1rem 0;
                      color: ${colors.textSecondary};
                      font-size: 0.8125rem;
                      line-height: 1.5;
                      display: -webkit-box;
                      -webkit-line-clamp: 2;
                      -webkit-box-orient: vertical;
                      overflow: hidden;
                    ">
                      ${website.description}
                    </p>
                  ` : `
                    <div style="margin-bottom: 1rem;"></div>
                  `}
                  <button
                    onclick="event.stopPropagation(); openBookNowModal('WEBSITE', '${website.id || ''}')"
                    style="
                      background: #dc2626;
                      color: white;
                      border: none;
                      padding: 0.625rem 1rem;
                      border-radius: 0.375rem;
                      cursor: pointer;
                      font-weight: 600;
              font-size: 0.875rem;
                      width: 100%;
                      transition: background-color 0.2s;
                    "
                    onmouseover="this.style.background='#b91c1c'"
                    onmouseout="this.style.background='#dc2626'"
                  >
                    Book Websites Service
                  </button>
                </div>
              </div>
            `).join('')}
          </div>
        `}
      </div>

      <!-- Photo/Video Section -->
      <div>
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
          <h2 style="
            margin: 0;
            color: ${colors.text};
            font-size: 1.5rem;
            font-weight: 700;
          ">
            Photo/Video
          </h2>
        </div>
        ${photoVideos.length === 0 ? `
          <div style="
            text-align: center;
            padding: 3rem;
            color: ${colors.textSecondary};
            background: ${colors.surface};
            border-radius: 0.75rem;
          ">
            <div style="font-size: 3rem; margin-bottom: 1rem; color: #6c757d;">
              <span class="material-icons" style="font-size: 3rem;">photo_camera</span>
            </div>
            <p style="margin: 0; font-size: 1rem;">No photo/video items available</p>
          </div>
        ` : `
          <div id="book-photovideo-carousel" style="
            display: flex;
            gap: 1rem;
            overflow-x: auto;
            padding-bottom: 0.5rem;
            scroll-behavior: smooth;
            -webkit-overflow-scrolling: touch;
          ">
            ${photoVideos.map(item => `
              <div style="
                flex: 0 0 320px;
                background: ${colors.surface};
                border-radius: 0.75rem;
                overflow: hidden;
                box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                transition: transform 0.2s, box-shadow 0.2s;
                cursor: ${item.url ? 'pointer' : 'default'};
              "
              onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 4px 6px rgba(0,0,0,0.1)'"
              onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 1px 3px rgba(0,0,0,0.1)'"
              onclick="${item.url ? `window.open('${item.url}', '_blank')` : ''}"
              >
                <div style="
                  width: 100%;
                  height: 180px;
                  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  position: relative;
                  overflow: hidden;
                ">
                  ${item.thumbnail_url ? `
                    <img
                      src="${item.thumbnail_url}"
                      alt="${item.title || 'Photo/Video'}"
                      style="
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                      "
                      onerror="this.parentElement.innerHTML='<div style=\\'width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; color: white; font-size: 3rem;\\'>${item.type === 'VIDEO' ? '🎥' : '📷'}</div>'"
                    />
                  ` : `
                    <div style="color: white; font-size: 3rem;">${item.type === 'VIDEO' ? '🎥' : '📷'}</div>
                  `}
                  ${item.type === 'VIDEO' ? `
                    <div style="
                      position: absolute;
                      top: 50%;
                      left: 50%;
                      transform: translate(-50%, -50%);
                      width: 60px;
                      height: 60px;
                      background: rgba(255, 255, 255, 0.9);
                      border-radius: 50%;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      font-size: 1.5rem;
                    ">
                      ▶
                    </div>
                  ` : ''}
                </div>
                <div style="padding: 1rem;">
                  <h3 style="
                    margin: 0 0 0.5rem 0;
                    color: ${colors.text};
                    font-size: 1rem;
                    font-weight: 700;
                    line-height: 1.3;
                  ">
                    ${item.title || 'Photo/Video'}
                  </h3>
                  ${item.description ? `
                    <p style="
                      margin: 0 0 1rem 0;
                      color: ${colors.textSecondary};
                      font-size: 0.8125rem;
              line-height: 1.5;
                      display: -webkit-box;
                      -webkit-line-clamp: 2;
                      -webkit-box-orient: vertical;
                      overflow: hidden;
                    ">
                      ${item.description}
                    </p>
                  ` : `
                    <div style="margin-bottom: 1rem;"></div>
                  `}
                  <button
                    onclick="event.stopPropagation(); openBookNowModal('${item.type}', '${item.id || ''}')"
                    style="
                      background: #dc2626;
                      color: white;
                      border: none;
                      padding: 0.625rem 1rem;
                      border-radius: 0.375rem;
                      cursor: pointer;
                      font-weight: 600;
                      font-size: 0.875rem;
                      width: 100%;
                      transition: background-color 0.2s;
                    "
                    onmouseover="this.style.background='#b91c1c'"
                    onmouseout="this.style.background='#dc2626'"
                  >
                    Book Photo/Video Service
                  </button>
                </div>
          </div>
        `).join('')}
      </div>
        `}
    </div>
    </div>
    ${showBookNowModal ? renderBookNowModal() : ''}
  `;
}

// Open Book Now Modal
window.openBookNowModal = function (serviceType, itemId) {
  bookingServiceType = serviceType;
  bookingFormData = {
    phoneNumber: '',
    email: currentUser?.email || '',
    specificService: '',
    additionalNotes: ''
  };
  showBookNowModal = true;
  renderPMTool();
};

// Close Book Now Modal
window.closeBookNowModal = function () {
  showBookNowModal = false;
  bookingServiceType = null;
  bookingFormData = {
    phoneNumber: '',
    email: '',
    specificService: '',
    additionalNotes: ''
  };
  if (window.bookingFormData) {
    window.bookingFormData.phoneNumber = '';
    window.bookingFormData.email = '';
    window.bookingFormData.specificService = '';
    window.bookingFormData.additionalNotes = '';
  }
  renderPMTool();
};

// Render Book Now Modal
function renderBookNowModal() {
  const serviceTypeLabel = bookingServiceType === 'WEBSITE'
    ? 'Website'
    : bookingServiceType === 'VIDEO'
      ? 'Video'
      : 'Photo/Video';

  return `
    <div id="book-now-modal-overlay" style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      z-index: 10000;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem;
    " onclick="if (event.target.id === 'book-now-modal-overlay') closeBookNowModal()">
      <div id="book-now-modal" style="
        background: #ffffff;
        border-radius: 0.75rem;
        width: 100%;
        max-width: 500px;
        max-height: 90vh;
        overflow-y: auto;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
      " onclick="event.stopPropagation()">
        <!-- Header -->
        <div style="
          padding: 1.5rem;
          border-bottom: 1px solid #e9ecef;
          display: flex;
          justify-content: space-between;
          align-items: center;
        ">
          <h2 style="
            margin: 0;
            font-size: 1.25rem;
            font-weight: 700;
            color: #2c3e50;
          ">Request ${serviceTypeLabel} Service</h2>
          <button
            onclick="closeBookNowModal()"
            style="
              background: transparent;
              border: none;
              color: #6c757d;
              cursor: pointer;
              font-size: 1.25rem;
              padding: 0;
              width: 32px;
              height: 32px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 50%;
              transition: background-color 0.2s;
            "
            onmouseover="this.style.background='#f3f4f6'"
            onmouseout="this.style.background='transparent'"
          >
            ×
          </button>
        </div>
        
        <!-- Form Content -->
        <div style="padding: 1.5rem;">
          <form id="book-now-form" onsubmit="submitBookNowRequest(event)">
            <!-- Phone Number -->
            <div style="margin-bottom: 1.5rem;">
              <label style="
                display: block;
                font-weight: 600;
                color: #2c3e50;
                margin-bottom: 0.5rem;
                font-size: 0.9375rem;
              ">
                Phone Number <span style="color: #dc2626;">*</span>
              </label>
              <input
                type="tel"
                id="booking-phone"
                required
                value="${bookingFormData.phoneNumber}"
                oninput="if (window.bookingFormData) { window.bookingFormData.phoneNumber = this.value; bookingFormData.phoneNumber = this.value; }"
                placeholder="Enter your phone number"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e9ecef;
                  border-radius: 0.5rem;
                  font-size: 0.9375rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s;
                "
                onfocus="this.style.borderColor='#f59e0b'"
                onblur="this.style.borderColor='#e9ecef'"
              />
            </div>
            
            <!-- Email Address -->
            <div style="margin-bottom: 1.5rem;">
              <label style="
                display: block;
                font-weight: 600;
                color: #2c3e50;
                margin-bottom: 0.5rem;
                font-size: 0.9375rem;
              ">
                Email Address <span style="color: #dc2626;">*</span>
              </label>
              <input
                type="email"
                id="booking-email"
                required
                value="${bookingFormData.email}"
                oninput="if (window.bookingFormData) { window.bookingFormData.email = this.value; bookingFormData.email = this.value; }"
                placeholder="Enter your email address"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e9ecef;
                  border-radius: 0.5rem;
                  font-size: 0.9375rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s;
                "
                onfocus="this.style.borderColor='#f59e0b'"
                onblur="this.style.borderColor='#e9ecef'"
              />
            </div>
            
            <!-- Specific Service Needed -->
            <div style="margin-bottom: 1.5rem;">
              <label style="
                display: block;
                font-weight: 600;
                color: #2c3e50;
                margin-bottom: 0.5rem;
                font-size: 0.9375rem;
              ">
                Specific Service Needed <span style="color: #dc2626;">*</span>
              </label>
              <input
                type="text"
                id="booking-service"
                required
                value="${bookingFormData.specificService}"
                oninput="if (window.bookingFormData) { window.bookingFormData.specificService = this.value; bookingFormData.specificService = this.value; }"
                placeholder="Describe the service you need"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e9ecef;
                  border-radius: 0.5rem;
                  font-size: 0.9375rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s;
                "
                onfocus="this.style.borderColor='#f59e0b'"
                onblur="this.style.borderColor='#e9ecef'"
              />
            </div>
            
            <!-- Additional Notes -->
            <div style="margin-bottom: 1.5rem;">
              <label style="
                display: block;
                font-weight: 600;
                color: #2c3e50;
                margin-bottom: 0.5rem;
                font-size: 0.9375rem;
              ">
                Additional Notes
              </label>
              <textarea
                id="booking-notes"
                value="${bookingFormData.additionalNotes}"
                oninput="if (window.bookingFormData) { window.bookingFormData.additionalNotes = this.value; bookingFormData.additionalNotes = this.value; }"
                placeholder="Any additional information (optional)"
                rows="4"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e9ecef;
                  border-radius: 0.5rem;
                  font-size: 0.9375rem;
                  box-sizing: border-box;
                  resize: vertical;
                  font-family: inherit;
                  transition: border-color 0.2s;
                "
                onfocus="this.style.borderColor='#f59e0b'"
                onblur="this.style.borderColor='#e9ecef'"
              >${bookingFormData.additionalNotes}</textarea>
            </div>
            
            <!-- Submit Button -->
            <button
              type="submit"
              style="
                background: #dc2626;
                color: white;
                border: none;
                padding: 0.875rem 1.5rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-weight: 600;
                font-size: 0.9375rem;
                width: 100%;
                transition: background-color 0.2s;
              "
              onmouseover="this.style.background='#b91c1c'"
              onmouseout="this.style.background='#dc2626'"
            >
              Send Service Request
            </button>
          </form>
        </div>
      </div>
    </div>
  `;
}

// Submit Book Now Request
window.submitBookNowRequest = async function (event) {
  event.preventDefault();

  const phoneInput = document.getElementById('booking-phone');
  const emailInput = document.getElementById('booking-email');
  const serviceInput = document.getElementById('booking-service');
  const notesInput = document.getElementById('booking-notes');

  if (!phoneInput || !emailInput || !serviceInput) {
    alert('Please fill in all required fields');
    return;
  }

  // Read from DOM inputs (since they're uncontrolled)
  const phoneNumber = phoneInput.value.trim();
  const email = emailInput.value.trim();
  const specificService = serviceInput.value.trim();
  const additionalNotes = notesInput ? notesInput.value.trim() : '';

  // Fallback to formData
  const formData = window.bookingFormData || bookingFormData;
  const finalPhone = phoneNumber || formData?.phoneNumber?.trim() || '';
  const finalEmail = email || formData?.email?.trim() || '';
  const finalService = specificService || formData?.specificService?.trim() || '';
  const finalNotes = additionalNotes || formData?.additionalNotes?.trim() || '';

  if (!finalPhone || !finalEmail || !finalService) {
    alert('Please fill in all required fields');
    return;
  }

  if (!currentProfile?.id) {
    alert('You must be logged in to submit a service request');
    return;
  }

  try {
    console.log('📝 Submitting service request:', {
      serviceType: bookingServiceType,
      phoneNumber: finalPhone,
      email: finalEmail,
      specificService: finalService,
      additionalNotes: finalNotes,
      companyId: currentCompany?.id,
      userId: currentProfile?.id
    });

    // Get all HH admin IDs using RPC function
    const { data: hhAdminIds, error: adminError } = await supabase.rpc('get_hh_admin_ids');

    if (adminError || !hhAdminIds || hhAdminIds.length === 0) {
      console.error('❌ No HH Admin found:', adminError);
      alert('Error: Could not find administrators. Please try again later.');
      return;
    }

    // Extract all HH admin IDs from the returned array of objects
    // Function returns [{id: "uuid1"}, {id: "uuid2"}, ...]
    const targetUserIds = Array.isArray(hhAdminIds)
      ? hhAdminIds
        .map((admin) => admin?.id)
        .filter((id) => !!id && typeof id === 'string')
      : [];

    if (targetUserIds.length === 0) {
      console.error('❌ No valid HH Admin IDs found');
      alert('Error: Could not find administrators. Please try again later.');
      return;
    }

    console.log('👥 Found HH Admins:', targetUserIds);

    // Create the chat - use RPC function if available, otherwise create directly
    let chatId;
    try {
      // Try using RPC function first (if it exists)
      const { data: rpcChatId, error: rpcError } = await supabase.rpc('create_chat', {
        p_created_by: currentProfile.id,
        p_company_id: null // Service requests don't have a company_id
      });

      if (!rpcError && rpcChatId) {
        chatId = rpcChatId;
      } else {
        // Fallback: create chat directly
        // Get session for debug logging only (created_by handled by DB default)
        const { data: { session: currentSession } } = await supabase.auth.getSession();

        // Ensure company_id is set - required for RLS policy
        if (!currentCompany?.id) {
          console.error('❌ Cannot create chat: no company ID available', {
            currentCompany: currentCompany,
            currentProfile: currentProfile
          });
          alert('Company not found. Please refresh and try again.');
          return;
        }

        // Build insert payload - DO NOT include created_by (let DB default handle it)
        const insertPayload = {
          company_id: currentCompany.id, // ✅ Always required - must match user's company
          // created_by is NOT included - DB default auth.uid() will handle it
          chat_type: 'SERVICE_REQUEST',
          title: `Service Request: ${bookingServiceType || 'General'}`,
          project_progress: 0
        };

        // Debug log right before insert
        console.log('📝 [BEFORE INSERT] Service request chat creation debug info:', {
          sessionUserId: currentSession?.user?.id,
          currentCompanyId: currentCompany?.id,
          insertPayload: insertPayload
        });

        const { data: chatData, error: chatError } = await supabase
          .from('chats')
          .insert(insertPayload)
          .select('id')
          .single();

        if (chatError || !chatData) {
          console.error('❌ [FAILING PAYLOAD DEBUG] Service request chat error:', {
            // User/Company IDs for analysis
            sessionUserId: currentSession?.user?.id,
            currentCompanyId: currentCompany?.id,
            // Exact insert payload that failed
            insertPayload: insertPayload,
            // Error details
            errorCode: chatError?.code,
            errorMessage: chatError?.message,
            errorDetails: chatError?.details,
            errorHint: chatError?.hint
          });
          throw chatError || new Error('Failed to create chat');
        }

        chatId = chatData.id;
      }
    } catch (chatError) {
      console.error('❌ Error creating service request chat:', chatError);
      console.error('❌ [FAILING PAYLOAD DEBUG] Service request chat error:', {
        // User/Company IDs for analysis
        sessionUserId: currentSession?.user?.id,
        currentCompanyId: currentCompany?.id,
        // Error details
        errorCode: chatError?.code,
        errorMessage: chatError?.message,
        errorDetails: chatError?.details,
        errorHint: chatError?.hint
      });
      alert('Error creating chat. Please try again.');
      return;
    }

    console.log('✅ Chat created:', chatId);

    // Build participant list: requester + all HH admins
    const participantUserIds = new Set([currentProfile.id, ...targetUserIds]);
    const participants = Array.from(participantUserIds).map(userId => ({
      chat_id: chatId,
      user_id: userId
    }));

    // Add participants to the chat
    const { error: participantError } = await supabase
      .from('chat_participants')
      .insert(participants);

    if (participantError) {
      console.error('❌ Error adding chat participants:', participantError);
      alert('Error adding participants to chat. Please try again.');
      return;
    }

    console.log('✅ Participants added:', participants.length);

    // Generate the recap message (similar to native app)
    const serviceTypeLabel = bookingServiceType === 'WEBSITE'
      ? 'Website'
      : bookingServiceType === 'VIDEO'
        ? 'Video'
        : bookingServiceType === 'PHOTO'
          ? 'Photo'
          : 'Photo/Video';

    let recapMessage = `🎯 **New Service Request - ${serviceTypeLabel}**\n\n`;
    recapMessage += `**Contact Information:**\n`;
    recapMessage += `📞 Phone: ${finalPhone}\n`;
    recapMessage += `📧 Email: ${finalEmail}\n\n`;
    recapMessage += `**Service Details:**\n`;
    recapMessage += `🔧 Service Needed: ${finalService}\n\n`;

    if (finalNotes && finalNotes.trim()) {
      recapMessage += `**Additional Notes:**\n`;
      recapMessage += `${finalNotes}\n\n`;
    }

    recapMessage += `---\n`;
    recapMessage += `This service request was submitted through the ${serviceTypeLabel.toLowerCase()} booking form. `;
    recapMessage += `Please review the details above and contact the client to discuss their project requirements.`;

    // Send the recap message
    const { data: message, error: messageError } = await supabase
      .from('messages')
      .insert({
        chat_id: chatId,
        sender_id: currentProfile.id,
        text: recapMessage,
        meta: {
          message_type: 'service_request_recap',
          is_system_message: true
        }
      })
      .select()
      .single();

    if (messageError) {
      console.error('❌ Error creating recap message:', messageError);
      // Chat was created but message failed - still show success
      alert('Service request submitted! Chat created, but there was an error sending the details. Please check your chats.');
    } else {
      console.log('✅ Recap message sent:', message.id);
      alert('Service request submitted successfully! A chat has been created with our team.');
    }

    // Close modal and refresh
    closeBookNowModal();

    // Navigate to chat screen and open the new chat
    currentScreen = 'chat';
    selectedChatId = chatId;
    renderPMTool();

  } catch (error) {
    console.error('❌ Error submitting service request:', error);
    alert('Failed to submit service request: ' + (error.message || 'Unknown error'));
  }
};

// ============================================
// TIME TRACKING FUNCTIONS
// ============================================

// Load time tracking data
async function loadTimeTrackingData() {
  console.log('🕐 [Time Tracking] loadTimeTrackingData() called');
  console.log('🕐 [Time Tracking] Current state:', {
    checkingStatus: timeTrackingData.checkingStatus,
    isClockedIn: timeTrackingData.isClockedIn,
    dataLoaded: timeTrackingData.dataLoaded,
    hasProfile: !!currentProfile?.id,
    hasCompany: !!currentCompany?.id,
    profileId: currentProfile?.id,
    companyId: currentCompany?.id
  });

  // If profile or company is missing, set checkingStatus to false and return
  if (!currentProfile?.id || !currentCompany?.id) {
    console.warn('🕐 [Time Tracking] Missing profile or company:', {
      hasProfile: !!currentProfile?.id,
      hasCompany: !!currentCompany?.id,
      profile: currentProfile,
      company: currentCompany
    });
    timeTrackingData.checkingStatus = false;
    timeTrackingData.isClockedIn = false;
    timeTrackingData.currentEntryId = null;
    timeTrackingData.dataLoaded = false;
    console.log('🕐 [Time Tracking] Early return - checkingStatus set to false');
    return;
  }

  // Prevent multiple simultaneous loads
  if (timeTrackingData.checkingStatus) {
    console.log('🕐 [Time Tracking] Already checking, skipping duplicate load');
    return;
  }

  // If data is already loaded and we're not forcing a refresh, skip
  // This prevents re-loading on every render
  if (timeTrackingData.dataLoaded && !timeTrackingData.forceReload) {
    console.log('🕐 [Time Tracking] Data already loaded, skipping (use forceReload flag to reload)');
    return;
  }

  // Set timeout to prevent infinite loading (10 seconds)
  const timeoutId = setTimeout(() => {
    if (timeTrackingData.checkingStatus) {
      console.error('🕐 [Time Tracking] TIMEOUT: Data load timed out after 10 seconds');
      timeTrackingData.checkingStatus = false;
      renderPMTool();
    }
  }, 10000);

  try {
    console.log('🕐 [Time Tracking] Setting checkingStatus to true');
    timeTrackingData.checkingStatus = true;

    console.log('🕐 [Time Tracking] Querying time_entries for active entry...');
    // Check clock status
    const { data: activeEntry, error: statusError } = await supabase
      .from('time_entries')
      .select('id, clock_in_at, break_start_at, break_end_at')
      .eq('user_id', currentProfile.id)
      .eq('company_id', currentCompany.id)
      .is('clock_out_at', null)
      .order('clock_in_at', { ascending: false })
      .limit(1)
      .maybeSingle();

    console.log('🕐 [Time Tracking] Query result:', {
      hasData: !!activeEntry,
      entryId: activeEntry?.id,
      clockInAt: activeEntry?.clock_in_at,
      breakStartAt: activeEntry?.break_start_at,
      breakEndAt: activeEntry?.break_end_at,
      error: statusError
    });

    if (statusError && statusError.code !== 'PGRST116') {
      // PGRST116 = no rows returned, which is fine
      console.error('🕐 [Time Tracking] Error checking clock status:', statusError);
    }

    if (activeEntry) {
      console.log('🕐 [Time Tracking] Active entry found, user is clocked in');
      timeTrackingData.isClockedIn = true;
      timeTrackingData.currentEntryId = activeEntry.id;
      // Store clock in time for duration calculation
      timeTrackingData.clockInTime = new Date(activeEntry.clock_in_at);
      console.log('🕐 [Time Tracking] Clock in time stored:', timeTrackingData.clockInTime);

      // Check if user is on break (has break_start_at but no break_end_at)
      if (activeEntry.break_start_at && !activeEntry.break_end_at) {
        timeTrackingData.isOnBreak = true;
        timeTrackingData.breakStartTime = new Date(activeEntry.break_start_at);
        timeTrackingData.currentBreakDuration = '00:00:00';
        startBreakTimer();
        console.log('🕐 [Time Tracking] User is on break');
      } else {
        timeTrackingData.isOnBreak = false;
        timeTrackingData.breakStartTime = null;
        timeTrackingData.currentBreakDuration = '';
        stopBreakTimer();
      }

      updateShiftDuration();
    } else {
      console.log('🕐 [Time Tracking] No active entry, user is clocked out');
      timeTrackingData.isClockedIn = false;
      timeTrackingData.isOnBreak = false;
      timeTrackingData.breakStartTime = null;
      timeTrackingData.currentEntryId = null;
      timeTrackingData.clockInTime = null;
      timeTrackingData.currentBreakDuration = '';
      stopBreakTimer();
    }

    console.log('🕐 [Time Tracking] Loading hours summary...');
    // Load hours summary
    await loadHoursSummary();
    console.log('🕐 [Time Tracking] Hours summary loaded');

    clearTimeout(timeoutId);
    console.log('🕐 [Time Tracking] Setting checkingStatus to false - SUCCESS');
    console.log('🕐 [Time Tracking] Final state after load:', {
      checkingStatus: timeTrackingData.checkingStatus,
      isClockedIn: timeTrackingData.isClockedIn,
      todayHours: timeTrackingData.todayHours,
      weekHours: timeTrackingData.weekHours,
      monthHours: timeTrackingData.monthHours,
      dataLoaded: timeTrackingData.dataLoaded
    });
    timeTrackingData.checkingStatus = false;
    timeTrackingData.dataLoaded = true; // Mark data as loaded
    timeTrackingData.forceReload = false; // Reset force reload flag

    // Load location display if clocked in
    if (timeTrackingData.isClockedIn && timeTrackingData.currentEntryId) {
      setTimeout(async () => {
        try {
          const { data: entry } = await supabase
            .from('time_entries')
            .select('clock_in_location')
            .eq('id', timeTrackingData.currentEntryId)
            .single();

          if (entry?.clock_in_location?.address) {
            const locationDisplay = document.getElementById('time-tracking-location-display');
            if (locationDisplay) {
              locationDisplay.style.display = 'block';
              locationDisplay.innerHTML = `
                <div style="
                  background: #ffffff;
                  border-radius: 1rem;
                  padding: 1.5rem;
                  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                ">
                  <div style="display: flex; align-items: center; gap: 0.75rem;">
                    <span style="font-size: 1.5rem;">📍</span>
                    <div>
                      <div style="font-size: 0.875rem; color: #64748b; margin-bottom: 0.25rem;">Clock In Location</div>
                      <div style="font-size: 0.875rem; color: #0f172a; font-weight: 500;">${entry.clock_in_location.address}</div>
                    </div>
                  </div>
                </div>
              `;
            }
          }
        } catch (error) {
          console.error('Error loading location:', error);
        }
      }, 100);
    } else {
      const locationDisplay = document.getElementById('time-tracking-location-display');
      if (locationDisplay) {
        locationDisplay.style.display = 'none';
      }
    }

    // Force re-render after state update to ensure UI reflects new state
    console.log('🕐 [Time Tracking] Calling renderPMTool() to update UI with new state');
    renderPMTool();
  } catch (error) {
    console.error('🕐 [Time Tracking] ERROR in loadTimeTrackingData:', error);
    clearTimeout(timeoutId);
    timeTrackingData.checkingStatus = false;
    timeTrackingData.isClockedIn = false;
    timeTrackingData.currentEntryId = null;
    timeTrackingData.dataLoaded = false; // Mark as not loaded on error
    console.log('🕐 [Time Tracking] Error handled - checkingStatus set to false');
    // Force re-render even on error to show error state
    renderPMTool();
  }
}

// Update shift duration
let shiftDurationInterval = null;
let breakDurationInterval = null;
let lastRenderTime = 0;
const RENDER_THROTTLE_MS = 1000; // Only re-render once per second

function updateShiftDuration() {
  if (!timeTrackingData.isClockedIn || !timeTrackingData.currentEntryId) {
    timeTrackingData.currentShiftDuration = '';
    if (shiftDurationInterval) {
      clearInterval(shiftDurationInterval);
      shiftDurationInterval = null;
    }
    return;
  }

  // Clear existing interval if any
  if (shiftDurationInterval) {
    clearInterval(shiftDurationInterval);
  }

  // Update immediately
  updateShiftDurationValue();

  // Then update every second
  shiftDurationInterval = setInterval(() => {
    if (!timeTrackingData.currentEntryId) {
      clearInterval(shiftDurationInterval);
      shiftDurationInterval = null;
      return;
    }
    updateShiftDurationValue();
  }, 1000);
}

function updateShiftDurationValue() {
  if (!timeTrackingData.currentEntryId) return;

  try {
    // Calculate duration from stored clock_in_at time
    // We don't need to query the database every second
    const clockInTime = timeTrackingData.clockInTime;
    if (!clockInTime) return;

    const now = new Date();
    const diffMs = now.getTime() - clockInTime.getTime();
    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

    const newDuration = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

    // Only update if duration changed
    if (timeTrackingData.currentShiftDuration !== newDuration) {
      timeTrackingData.currentShiftDuration = newDuration;

      // Update only the timer DOM element instead of re-rendering entire app
      const timerElement = document.getElementById('time-tracking-duration-display');
      if (timerElement) {
        timerElement.textContent = newDuration;
      } else {
        // If element doesn't exist yet, do a minimal re-render (only if really needed)
        const now = Date.now();
        if (now - lastRenderTime >= 5000) { // Only re-render every 5 seconds as fallback
          lastRenderTime = now;
          renderPMTool();
        }
      }
    }
  } catch (error) {
    console.error('Error updating shift duration:', error);
  }
}

// Break timer functions
function startBreakTimer() {
  if (!timeTrackingData.isOnBreak || !timeTrackingData.breakStartTime) {
    if (breakDurationInterval) {
      clearInterval(breakDurationInterval);
      breakDurationInterval = null;
    }
    return;
  }

  // Clear existing interval if any
  if (breakDurationInterval) {
    clearInterval(breakDurationInterval);
  }

  // Update immediately
  updateBreakDurationValue();

  // Then update every second
  breakDurationInterval = setInterval(() => {
    if (!timeTrackingData.isOnBreak || !timeTrackingData.breakStartTime) {
      clearInterval(breakDurationInterval);
      breakDurationInterval = null;
      return;
    }
    updateBreakDurationValue();
  }, 1000);
}

function stopBreakTimer() {
  if (breakDurationInterval) {
    clearInterval(breakDurationInterval);
    breakDurationInterval = null;
  }
  timeTrackingData.currentBreakDuration = '';

  // Clear break duration display if it exists
  const breakTimerElement = document.getElementById('time-tracking-break-duration-display');
  if (breakTimerElement) {
    breakTimerElement.textContent = '00:00:00';
  }
}

function updateBreakDurationValue() {
  if (!timeTrackingData.isOnBreak || !timeTrackingData.breakStartTime) return;

  try {
    const breakStartTime = timeTrackingData.breakStartTime;
    const now = new Date();
    const diffMs = now.getTime() - breakStartTime.getTime();
    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

    const newDuration = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

    // Only update if duration changed
    if (timeTrackingData.currentBreakDuration !== newDuration) {
      timeTrackingData.currentBreakDuration = newDuration;

      // Update only the break timer DOM element instead of re-rendering entire app
      const breakTimerElement = document.getElementById('time-tracking-break-duration-display');
      if (breakTimerElement) {
        breakTimerElement.textContent = newDuration;
      }
    }
  } catch (error) {
    console.error('Error updating break duration:', error);
  }
}

// Load hours summary
async function loadHoursSummary() {
  console.log('🕐 [Time Tracking] loadHoursSummary() called');
  if (!currentProfile?.id || !currentCompany?.id) {
    console.warn('🕐 [Time Tracking] loadHoursSummary() - Missing profile or company');
    return;
  }

  try {
    console.log('🕐 [Time Tracking] Setting loading to true for hours summary');
    timeTrackingData.loading = true;
    const now = new Date();
    const todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const weekStart = new Date(todayStart);
    weekStart.setDate(weekStart.getDate() - weekStart.getDay());
    const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);

    console.log('🕐 [Time Tracking] Date ranges:', {
      todayStart: todayStart.toISOString(),
      weekStart: weekStart.toISOString(),
      monthStart: monthStart.toISOString()
    });

    // Get today's hours
    console.log('🕐 [Time Tracking] Querying today\'s hours...');
    const { data: todayData, error: todayError } = await supabase
      .from('time_entries')
      .select('total_hours')
      .eq('user_id', currentProfile.id)
      .eq('company_id', currentCompany.id)
      .not('clock_out_at', 'is', null)
      .gte('clock_in_at', todayStart.toISOString());

    if (todayError) {
      console.error('🕐 [Time Tracking] Error loading today\'s hours:', todayError);
    }

    const todayTotal = todayData?.reduce((sum, entry) => sum + (entry.total_hours || 0), 0) || 0;
    timeTrackingData.todayHours = todayTotal;
    console.log('🕐 [Time Tracking] Today\'s hours result:', {
      entries: todayData?.length || 0,
      totalHours: todayTotal,
      rawData: todayData
    });

    // Get week's hours
    console.log('🕐 [Time Tracking] Querying week\'s hours...');
    const { data: weekData, error: weekError } = await supabase
      .from('time_entries')
      .select('total_hours')
      .eq('user_id', currentProfile.id)
      .eq('company_id', currentCompany.id)
      .not('clock_out_at', 'is', null)
      .gte('clock_in_at', weekStart.toISOString());

    if (weekError) {
      console.error('🕐 [Time Tracking] Error loading week\'s hours:', weekError);
    }

    const weekTotal = weekData?.reduce((sum, entry) => sum + (entry.total_hours || 0), 0) || 0;
    timeTrackingData.weekHours = weekTotal;
    console.log('🕐 [Time Tracking] Week\'s hours result:', {
      entries: weekData?.length || 0,
      totalHours: weekTotal
    });

    // Get month's hours
    console.log('🕐 [Time Tracking] Querying month\'s hours...');
    const { data: monthData, error: monthError } = await supabase
      .from('time_entries')
      .select('total_hours')
      .eq('user_id', currentProfile.id)
      .eq('company_id', currentCompany.id)
      .not('clock_out_at', 'is', null)
      .gte('clock_in_at', monthStart.toISOString());

    if (monthError) {
      console.error('🕐 [Time Tracking] Error loading month\'s hours:', monthError);
    }

    const monthTotal = monthData?.reduce((sum, entry) => sum + (entry.total_hours || 0), 0) || 0;
    timeTrackingData.monthHours = monthTotal;
    console.log('🕐 [Time Tracking] Month\'s hours result:', {
      entries: monthData?.length || 0,
      totalHours: monthTotal
    });

    console.log('🕐 [Time Tracking] Hours summary loaded successfully:', {
      todayHours: timeTrackingData.todayHours,
      weekHours: timeTrackingData.weekHours,
      monthHours: timeTrackingData.monthHours
    });
  } catch (error) {
    console.error('🕐 [Time Tracking] ERROR in loadHoursSummary:', error);
  } finally {
    console.log('🕐 [Time Tracking] Setting loading to false for hours summary');
    timeTrackingData.loading = false;
  }
}

// Get current location (web geolocation API)
async function getCurrentLocation() {
  return new Promise((resolve) => {
    if (!navigator.geolocation) {
      console.warn('Geolocation is not supported');
      resolve(null);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const location = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
          accuracy: position.coords.accuracy || undefined,
        };

        // Try reverse geocoding
        try {
          const response = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${location.lat}&lon=${location.lng}&zoom=18&addressdetails=1`,
            {
              headers: {
                'User-Agent': 'Hello-App/1.0',
              },
            }
          );

          if (response.ok) {
            const data = await response.json();
            if (data.address) {
              const parts = [];
              if (data.address.house_number && data.address.road) {
                parts.push(`${data.address.house_number} ${data.address.road}`);
              } else if (data.address.road) {
                parts.push(data.address.road);
              }
              if (data.address.city || data.address.town || data.address.village) {
                parts.push(data.address.city || data.address.town || data.address.village);
              }
              if (data.address.state) parts.push(data.address.state);
              if (data.address.postcode) parts.push(data.address.postcode);
              location.address = parts.length > 0 ? parts.join(', ') : `${location.lat.toFixed(6)}, ${location.lng.toFixed(6)}`;
            } else {
              location.address = `${location.lat.toFixed(6)}, ${location.lng.toFixed(6)}`;
            }
          } else {
            location.address = `${location.lat.toFixed(6)}, ${location.lng.toFixed(6)}`;
          }
        } catch (error) {
          console.warn('Reverse geocoding failed:', error);
          location.address = `${location.lat.toFixed(6)}, ${location.lng.toFixed(6)}`;
        }

        resolve(location);
      },
      (error) => {
        console.warn('Geolocation error:', error.message);
        resolve(null);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
    );
  });
}

// Clock in
window.clockIn = async function () {
  console.log('🕐 [Time Tracking] ========== clockIn() CALLED ==========');
  console.log('🕐 [Time Tracking] clockIn() called');
  console.log('🕐 [Time Tracking] Clock in state:', {
    hasProfile: !!currentProfile?.id,
    hasCompany: !!currentCompany?.id,
    profileId: currentProfile?.id,
    companyId: currentCompany?.id,
    currentLoading: timeTrackingData.loading,
    isClockedIn: timeTrackingData.isClockedIn
  });

  if (timeTrackingData.isClockedIn) {
    console.warn('🕐 [Time Tracking] Already clocked in!');
    window.showNotification('You are already clocked in. Please clock out first.', 'warning');
    return;
  }

  if (timeTrackingData.loading) {
    console.warn('🕐 [Time Tracking] Already processing clock in!');
    return;
  }

  if (!currentProfile?.id || !currentCompany?.id) {
    console.error('🕐 [Time Tracking] Clock in failed - missing profile or company');
    window.showNotification('Unable to clock in. Please check your profile.', 'error');
    return;
  }

  // Helper for background location update
  const updateLocationInBackground = async (entryId, type) => {
    try {
      console.log(`🕐 [Time Tracking] Starting background location fetch for clock-${type}...`);

      // Use existing getCurrentLocation but we can't easily pass options if it doesn't support them
      // modifying getCurrentLocation to support skipping might be needed, or just let it run
      // since this IS the background task, waiting is fine here.
      const location = await getCurrentLocation();

      if (!location) {
        console.log('🕐 [Time Tracking] Background location fetch failed or returned null');
        return;
      }

      console.log('🕐 [Time Tracking] Background location found, updating DB...', location);

      const updateData = type === 'in'
        ? {
          clock_in_location: {
            lat: location.lat,
            lng: location.lng,
            address: location.address,
            accuracy: location.accuracy
          }
        }
        : {
          clock_out_location: {
            lat: location.lat,
            lng: location.lng,
            address: location.address,
            accuracy: location.accuracy
          }
        };

      const { error } = await supabase
        .from('time_entries')
        .update(updateData)
        .eq('id', entryId);

      if (error) {
        console.error('🕐 [Time Tracking] Failed to update entry with background location:', error);
      } else {
        console.log('🕐 [Time Tracking] Successfully updated entry with background location');

        // Optionally update UI if user is looking at it (e.g. location display)
        if (type === 'in' && location.address) {
          const locationDisplay = document.getElementById('time-tracking-location-display');
          if (locationDisplay) {
            // Update the display code here if we want dynamic update
          }
        }
      }
    } catch (err) {
      console.error('🕐 [Time Tracking] Background location task error:', err);
    }
  };

  try {
    console.log('🕐 [Time Tracking] Setting loading to true');
    timeTrackingData.loading = true;

    // SKIP location fetch here. Do it in background.

    const clockInTime = new Date().toISOString();
    console.log('🕐 [Time Tracking] Creating time entry with clock_in_at:', clockInTime);

    // Create time entry IMMEDIATELY
    const { data, error } = await supabase
      .from('time_entries')
      .insert({
        user_id: currentProfile.id,
        company_id: currentCompany.id,
        clock_in_at: clockInTime,
        clock_in_location: null, // Will update in background
      })
      .select()
      .single();

    console.log('🕐 [Time Tracking] Insert result:', { data, error });

    if (error) {
      console.error('🕐 [Time Tracking] Insert error:', error);
      throw error;
    }

    console.log('🕐 [Time Tracking] Time entry created successfully:', data.id);

    // Update state immediately (like native app does)
    timeTrackingData.isClockedIn = true;
    timeTrackingData.currentEntryId = data.id;
    timeTrackingData.clockInTime = new Date(data.clock_in_at);
    timeTrackingData.checkingStatus = false; // Make sure checking status is false
    timeTrackingData.dataLoaded = true; // Mark as loaded so UI shows immediately

    console.log('🕐 [Time Tracking] State updated, calling updateShiftDuration()');
    updateShiftDuration();

    console.log('🕐 [Time Tracking] Loading hours summary...');
    await loadHoursSummary();

    console.log('🕐 [Time Tracking] Clock in complete - SUCCESS');
    console.log('🕐 [Time Tracking] Final state after clock in:', {
      isClockedIn: timeTrackingData.isClockedIn,
      currentEntryId: timeTrackingData.currentEntryId,
      clockInTime: timeTrackingData.clockInTime,
      checkingStatus: timeTrackingData.checkingStatus,
      currentShiftDuration: timeTrackingData.currentShiftDuration,
      dataLoaded: timeTrackingData.dataLoaded
    });

    // Immediately render the UI with the updated state (like native app)
    // Don't call loadTimeTrackingData() here as it sets checkingStatus=true and shows loading
    // The state is already set correctly above
    console.log('🕐 [Time Tracking] Calling renderPMTool() to update UI immediately');
    renderPMTool();

    // Show success notification after rendering
    window.showNotification('Clocked in successfully!', 'success');

    // Trigger background location update
    if (data && data.id) {
      updateLocationInBackground(data.id, 'in');
    }
  } catch (error) {
    console.error('🕐 [Time Tracking] ERROR clocking in:', error);
    window.showNotification(error.message || 'Failed to clock in. Please try again.', 'error');
    renderPMTool();
  } finally {
    console.log('🕐 [Time Tracking] Setting loading to false');
    timeTrackingData.loading = false;
  }
};

// Take a break (start break timer, user is still clocked in)
window.takeBreak = async function () {
  console.log('🕐 [Time Tracking] takeBreak() called');

  if (!timeTrackingData.currentEntryId) {
    alert('No active time entry found');
    return;
  }

  if (timeTrackingData.loading || timeTrackingData.isOnBreak) {
    return;
  }

  try {
    timeTrackingData.loading = true;

    // Get current time for break start
    const breakStartTime = new Date();
    let location = null;
    try {
      location = await getCurrentLocation();
    } catch (error) {
      console.warn('Location unavailable for break:', error);
    }

    // Update the time entry with break start time
    const { error: updateError } = await supabase
      .from('time_entries')
      .update({
        break_start_at: breakStartTime.toISOString(),
      })
      .eq('id', timeTrackingData.currentEntryId);

    if (updateError) throw updateError;

    // Set break state
    timeTrackingData.isOnBreak = true;
    timeTrackingData.breakStartTime = breakStartTime;
    timeTrackingData.currentBreakDuration = '00:00:00';

    // Start break timer
    startBreakTimer();

    renderPMTool();
  } catch (error) {
    console.error('Error starting break:', error);
    alert(error.message || 'Failed to start break. Please try again.');
  } finally {
    timeTrackingData.loading = false;
  }
};

// Stop break (end break timer, user is still clocked in)
window.stopBreak = async function () {
  console.log('🕐 [Time Tracking] stopBreak() called');

  if (!timeTrackingData.currentEntryId || !timeTrackingData.isOnBreak) {
    return;
  }

  if (timeTrackingData.loading) {
    return;
  }

  try {
    timeTrackingData.loading = true;

    // Get current time for break end
    const breakEndTime = new Date();
    let location = null;
    try {
      location = await getCurrentLocation();
    } catch (error) {
      console.warn('Location unavailable for break end:', error);
    }

    // Update the time entry with break end time
    const { error: updateError } = await supabase
      .from('time_entries')
      .update({
        break_end_at: breakEndTime.toISOString(),
      })
      .eq('id', timeTrackingData.currentEntryId);

    if (updateError) throw updateError;

    // Call calculate hours function to update break duration
    const { error: calcError } = await supabase.rpc('calculate_time_entry_hours', {
      entry_id: timeTrackingData.currentEntryId,
    });

    if (calcError) {
      console.warn('Error calculating hours for break:', calcError);
    }

    // Clear break state
    timeTrackingData.isOnBreak = false;
    timeTrackingData.breakStartTime = null;
    timeTrackingData.currentBreakDuration = '';

    // Stop break timer
    stopBreakTimer();

    renderPMTool();
  } catch (error) {
    console.error('Error stopping break:', error);
    alert(error.message || 'Failed to stop break. Please try again.');
  } finally {
    timeTrackingData.loading = false;
  }
};

// Clock out
window.clockOut = async function () {
  if (!timeTrackingData.currentEntryId) {
    window.showNotification('No active time entry found.', 'error');
    return;
  }

  // If on break, stop break first
  if (timeTrackingData.isOnBreak) {
    await window.stopBreak();
  }

  try {
    timeTrackingData.loading = true;

    // SKIP location fetch here. Do it in background.

    // Update time entry with clock out IMMEDIATELY
    const { data, error } = await supabase
      .from('time_entries')
      .update({
        clock_out_at: new Date().toISOString(),
        clock_out_location: null, // Will update in background
      })
      .eq('id', timeTrackingData.currentEntryId)
      .select()
      .single();

    if (error) throw error;

    // Calculate hours
    await supabase.rpc('calculate_time_entry_hours', {
      entry_id: timeTrackingData.currentEntryId,
    });

    // Clear the timer intervals
    if (shiftDurationInterval) {
      clearInterval(shiftDurationInterval);
      shiftDurationInterval = null;
    }
    stopBreakTimer();

    // Update state
    timeTrackingData.isClockedIn = false;
    timeTrackingData.isOnBreak = false;
    timeTrackingData.breakStartTime = null;
    timeTrackingData.currentEntryId = null;
    timeTrackingData.clockInTime = null;
    timeTrackingData.currentShiftDuration = '';
    timeTrackingData.currentBreakDuration = '';
    timeTrackingData.dataLoaded = false; // Reset so data reloads to show updated status

    await loadHoursSummary();

    // Force reload data to show updated clock status
    timeTrackingData.forceReload = true;
    renderPMTool();

    // Show success notification after rendering
    window.showNotification('Clocked out successfully!', 'success');

    // Trigger background location update (using previous ID)
    if (timeTrackingData.currentEntryId) {
      updateLocationInBackground(timeTrackingData.currentEntryId, 'out');
    }
  } catch (error) {
    console.error('Error clocking out:', error);
    window.showNotification(error.message || 'Failed to clock out. Please try again.', 'error');
    renderPMTool();
  } finally {
    timeTrackingData.loading = false;
  }
};

// Format hours
function formatHours(hours) {
  const h = Math.floor(hours);
  const m = Math.floor((hours - h) * 60);
  return `${h}h ${m}m`;
}

// Format date
function formatDate(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

// Helper function to format date as YYYY-MM-DD from local date components (not ISO)
function formatDateForInput(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

// Helper function to set start date to beginning of day in local time
window.setTimesheetStartDate = function (dateString) {
  if (!dateString) return;
  const [year, month, day] = dateString.split('-').map(Number);
  // Create date at midnight local time
  timesheetStartDate = new Date(year, month - 1, day, 0, 0, 0, 0);
};

// Helper function to set end date to last millisecond of the selected date
window.setTimesheetEndDate = function (dateString) {
  if (!dateString) return;
  const [year, month, day] = dateString.split('-').map(Number);
  // Create date for the selected date at 23:59:59.999 local time
  timesheetEndDate = new Date(year, month - 1, day, 23, 59, 59, 999);
};

// Generate timesheet based on form filters
window.generateTimesheet = async function () {
  console.log('📊 [Timesheet] Generating timesheet with filters...');

  // Get values from form inputs
  const startDateInput = document.querySelector('input[type="date"][onchange*="timesheetStartDate"]');
  const endDateInput = document.querySelector('input[type="date"][onchange*="timesheetEndDate"]');
  const employeeSelect = document.querySelector('select[onchange*="hourlyRateFormData.employeeId"]');
  const payPeriodSelect = document.getElementById('timesheet-pay-period-select');

  if (startDateInput) {
    // Parse date string as local time and set to start of day (00:00:00)
    const dateStr = startDateInput.value;
    if (dateStr) {
      const [year, month, day] = dateStr.split('-').map(Number);
      timesheetStartDate = new Date(year, month - 1, day, 0, 0, 0, 0);
    }
  }
  if (endDateInput) {
    // Parse date string as local time and set to last millisecond of the selected date
    const dateStr = endDateInput.value;
    if (dateStr) {
      const [year, month, day] = dateStr.split('-').map(Number);
      // Create date for the selected date at 23:59:59.999 local time
      timesheetEndDate = new Date(year, month - 1, day, 23, 59, 59, 999);
    }
  }
  if (employeeSelect) {
    window.hourlyRateFormData.employeeId = employeeSelect.value ? employeeSelect.value : null;
    hourlyRateFormData.employeeId = employeeSelect.value ? employeeSelect.value : null;
  }
  if (payPeriodSelect) {
    timesheetPayPeriod = payPeriodSelect.value;
  }

  console.log('📊 [Timesheet] Filters:', {
    startDate: timesheetStartDate,
    endDate: timesheetEndDate,
    employeeId: hourlyRateFormData.employeeId,
    payPeriod: timesheetPayPeriod
  });

  // Load timesheet entries and pay data
  await loadTimesheetEntries();
  await loadPayData();
  renderPMTool();
};

// Load timesheet entries
async function loadTimesheetEntries() {
  if (!currentProfile?.id || !currentCompany?.id) return;

  try {
    const isOwner = currentProfile?.company_role === 'OWNER';
    const isManager = currentProfile?.company_role === 'MANAGER';
    const canViewOthers = isOwner || isManager;

    // If OWNER/MANAGER and no employee selected, load all company entries
    // Otherwise, load entries for specific user
    let query = supabase
      .from('time_entries')
      .select(`
        *,
        profiles!time_entries_user_id_fkey (
          id,
          first_name,
          last_name,
          email
        )
      `)
      .eq('company_id', currentCompany.id)
      .not('clock_out_at', 'is', null);

    // Format dates to ensure we capture all entries for the selected date range
    // Convert local dates to ISO strings for database query
    // Start date: beginning of day (00:00:00.000)
    // End date: end of day (23:59:59.999)
    query = query
      .gte('clock_in_at', timesheetStartDate.toISOString())
      .lte('clock_in_at', timesheetEndDate.toISOString());

    // If OWNER/MANAGER viewing all, don't filter by user_id
    // If employee selected, filter by that employee
    // Otherwise, filter by current user
    if (canViewOthers && hourlyRateFormData.employeeId) {
      query = query.eq('user_id', hourlyRateFormData.employeeId);
    } else if (!canViewOthers) {
      query = query.eq('user_id', currentProfile.id);
    }
    // If canViewOthers and no employee selected, show all (no user_id filter)

    query = query.order('clock_in_at', { ascending: false });

    const { data, error } = await query;

    if (error) throw error;
    timeEntries = data || [];

    // Load hourly rates for all employees in the timesheet entries
    // Load ALL rates (not just latest) to calculate pay correctly per entry date
    const uniqueEmployeeIds = [...new Set(timeEntries.map(e => e.user_id))];
    for (const empId of uniqueEmployeeIds) {
      if (!employeeHourlyRates[empId] || typeof employeeHourlyRates[empId] === 'number') {
        // Load all rates for this employee and cache them by date
        const { data: allRates } = await supabase
          .from('employee_hourly_rates')
          .select('hourly_rate, effective_date, created_at')
          .eq('user_id', empId)
          .eq('company_id', currentCompany.id)
          .order('effective_date', { ascending: false })
          .order('created_at', { ascending: false });

        if (allRates && allRates.length > 0) {
          // Cache as object with date keys for quick lookup: { '2024-12-22': 20, '2024-12-25': 30 }
          const ratesByDate = {};
          allRates.forEach(rate => {
            const dateKey = rate.effective_date;
            // Only store the most recent rate for each date (if multiple exist)
            if (!ratesByDate[dateKey]) {
              ratesByDate[dateKey] = rate.hourly_rate;
            }
          });
          // Store both the latest rate (for backward compatibility) and the full rates object
          employeeHourlyRates[empId] = {
            latest: allRates[0].hourly_rate,
            byDate: ratesByDate,
            all: allRates
          };
        }
      }
    }

    // Helper function to get rate for a specific date
    window.getRateForDate = function (employeeId, entryDate) {
      const rates = employeeHourlyRates[employeeId];
      if (!rates) return null;

      // If it's the old format (just a number), return it
      if (typeof rates === 'number') return rates;

      // Convert entry date to date string
      const dateStr = typeof entryDate === 'string'
        ? entryDate.split('T')[0]
        : new Date(entryDate).toISOString().split('T')[0];

      // Find the most recent rate that's <= the entry date
      // Use all rates array if available, otherwise use byDate object
      if (rates.all && Array.isArray(rates.all)) {
        const applicableRates = rates.all.filter(rate => rate.effective_date <= dateStr);
        if (applicableRates.length > 0) {
          // Already sorted by effective_date DESC, created_at DESC, so first one is most recent
          return applicableRates[0].hourly_rate;
        }
      } else if (rates.byDate) {
        const matchingDates = Object.keys(rates.byDate)
          .filter(d => d <= dateStr)
          .sort((a, b) => b.localeCompare(a));

        if (matchingDates.length > 0) {
          return rates.byDate[matchingDates[0]];
        }
      }

      return rates.latest || null;
    };

    // Load pay data (non-blocking - don't fail timesheet if pay calc fails)
    loadPayData().catch(err => {
      console.warn('Pay data loading failed (non-critical):', err);
    });
  } catch (error) {
    console.error('Error loading timesheet entries:', error);
    alert('Failed to load timesheet entries');
  }
}

// Load pay data
async function loadPayData() {
  if (!currentProfile?.id || !currentCompany?.id) return;

  try {
    const userId = timeTrackingView === 'timesheet' && hourlyRateFormData.employeeId
      ? hourlyRateFormData.employeeId
      : currentProfile.id;

    let start, end;
    if (timesheetPayPeriod === 'bi-monthly-1') {
      start = new Date(timesheetEndDate.getFullYear(), timesheetEndDate.getMonth(), 1);
      end = new Date(timesheetEndDate.getFullYear(), timesheetEndDate.getMonth(), 15);
    } else if (timesheetPayPeriod === 'bi-monthly-2') {
      start = new Date(timesheetEndDate.getFullYear(), timesheetEndDate.getMonth(), 16);
      end = new Date(timesheetEndDate.getFullYear(), timesheetEndDate.getMonth() + 1, 0);
    } else {
      start = new Date(timesheetEndDate.getFullYear(), timesheetEndDate.getMonth(), 1);
      end = new Date(timesheetEndDate.getFullYear(), timesheetEndDate.getMonth() + 1, 0);
    }

    const { data, error } = await supabase.rpc('calculate_bi_monthly_pay', {
      p_user_id: userId,
      p_start_date: start.toISOString().split('T')[0],
      p_end_date: end.toISOString().split('T')[0],
    });

    if (error) {
      // Database function may have issues (ambiguous column reference, etc.)
      // Silently handle and don't block timesheet loading
      console.warn('Pay calculation unavailable (database function issue):', error.message);
      timesheetPayData = null;
      return;
    }

    timesheetPayData = data?.[0] || null;
  } catch (error) {
    // Silently handle errors - don't block timesheet loading
    console.warn('Error loading pay data:', error.message);
    timesheetPayData = null;
  }
}

// Load hourly rates
window.loadHourlyRates = async function () {
  if (!currentProfile?.id || !currentCompany?.id) return;

  try {
    const userId = (window.hourlyRateFormData?.employeeId || hourlyRateFormData.employeeId) || currentProfile.id;

    const { data, error } = await supabase
      .from('employee_hourly_rates')
      .select(`
        *,
        profiles!employee_hourly_rates_user_id_fkey (
          id,
          first_name,
          last_name,
          email
        )
      `)
      .eq('user_id', userId)
      .eq('company_id', currentCompany.id)
      .order('effective_date', { ascending: false })
      .order('created_at', { ascending: false });

    if (error) throw error;
    hourlyRates = data || [];

    // Get current rate and cache it per employee
    if (hourlyRates.length > 0) {
      currentHourlyRate = hourlyRates[0].hourly_rate;
      // Cache the rate for this employee
      employeeHourlyRates[userId] = currentHourlyRate;
      // Don't auto-populate the input field - keep it at 0 for new entries
      // hourlyRateFormData.rate = currentHourlyRate.toString();
      // window.hourlyRateFormData.rate = currentHourlyRate.toString();
    } else {
      currentHourlyRate = null;
      employeeHourlyRates[userId] = null;
      hourlyRateFormData.rate = '0';
      window.hourlyRateFormData.rate = '0';
    }
  } catch (error) {
    console.error('Error loading hourly rates:', error);
  }
};

// Save overtime rules
window.saveOvertimeRules = async function () {
  if (!currentProfile?.id || !currentCompany?.id || currentProfile?.company_role !== 'OWNER') {
    alert('Only company owners can set overtime rules');
    return;
  }

  try {
    const rulesData = {
      company_id: currentCompany.id,
      overtime_type: overtimeRulesFormData.overtime_type,
      weekly_threshold_hours: overtimeRulesFormData.weekly_threshold_hours,
      daily_threshold_hours: overtimeRulesFormData.daily_threshold_hours,
      overtime_multiplier: overtimeRulesFormData.overtime_multiplier,
      double_time_threshold: overtimeRulesFormData.double_time_threshold,
      double_time_multiplier: overtimeRulesFormData.double_time_multiplier
    };

    if (overtimeRules?.id) {
      // Update existing rules
      const { error } = await supabase
        .from('overtime_rules')
        .update(rulesData)
        .eq('id', overtimeRules.id);

      if (error) throw error;
    } else {
      // Insert new rules
      const { error } = await supabase
        .from('overtime_rules')
        .insert(rulesData);

      if (error) throw error;
    }

    alert('Overtime rules saved successfully');
    await loadOvertimeRules();
    showOvertimeRulesModal = false;
    renderPMTool();
  } catch (error) {
    console.error('Error saving overtime rules:', error);
    alert(error.message || 'Failed to save overtime rules');
  }
};

// Save hourly rate
window.saveHourlyRate = async function () {
  console.log('💾 [Hourly Rate] saveHourlyRate() called');
  console.log('💾 [Hourly Rate] Form data:', window.hourlyRateFormData);

  if (!currentProfile?.id || !currentCompany?.id) {
    window.showNotification('Missing required information', 'error');
    return;
  }

  // Get the raw rate value from the input field
  const rateInput = document.getElementById('hourly-rate-input');
  const rawRateValue = rateInput ? rateInput.value : (window.hourlyRateFormData?.rate || hourlyRateFormData.rate || '');

  // Check if rate is empty or only whitespace (allow 0 as a valid value)
  if (!rawRateValue || rawRateValue.trim() === '') {
    window.showNotification('Please add a rate', 'error');
    if (rateInput) {
      rateInput.focus();
      rateInput.style.borderColor = '#ef4444';
      setTimeout(() => {
        rateInput.style.borderColor = '#e5e7eb';
      }, 3000);
    }
    return;
  }

  const rateValue = parseFloat(rawRateValue);
  console.log('💾 [Hourly Rate] Parsed rate value:', rateValue);

  if (isNaN(rateValue) || rateValue < 0) {
    window.showNotification('Please enter a valid hourly rate (must be a number greater than or equal to 0)', 'error');
    return;
  }

  const isOwner = currentProfile?.company_role === 'OWNER';
  const targetUserId = (window.hourlyRateFormData?.employeeId || hourlyRateFormData.employeeId) || currentProfile.id;
  const canEdit = isOwner || !(window.hourlyRateFormData?.employeeId || hourlyRateFormData.employeeId);

  console.log('💾 [Hourly Rate] Can edit:', canEdit, 'Target user:', targetUserId);

  if (!canEdit) {
    window.showNotification('You do not have permission to set hourly rates', 'error');
    return;
  }

  try {
    const effectiveDate = new Date().toISOString().split('T')[0];
    console.log('💾 [Hourly Rate] Saving rate:', {
      user_id: targetUserId,
      company_id: currentCompany.id,
      hourly_rate: rateValue,
      effective_date: effectiveDate,
      created_by: currentProfile.id
    });

    // Insert new rate entry (creates new history entry each time)
    // Multiple entries per day are now allowed for full history tracking
    const { error } = await supabase
      .from('employee_hourly_rates')
      .insert({
        user_id: targetUserId,
        company_id: currentCompany.id,
        hourly_rate: rateValue,
        effective_date: effectiveDate,
        created_by: currentProfile.id,
      });

    if (error) {
      console.error('💾 [Hourly Rate] Insert error:', error);
      throw error;
    }

    console.log('💾 [Hourly Rate] Rate saved successfully');

    // Cache the new rate for this employee
    employeeHourlyRates[targetUserId] = rateValue;

    // Reset the hourly rate input field to 0
    hourlyRateFormData.rate = '0';
    window.hourlyRateFormData.rate = '0';

    await window.loadHourlyRates();
    showHourlyRateForm = false;
    renderPMTool();

    // Show success notification after rendering
    window.showNotification('Hourly rate saved successfully', 'success');

    // Reset input field after render
    setTimeout(() => {
      const input = document.getElementById('hourly-rate-input');
      if (input) {
        input.value = '0';
      }
    }, 100);
  } catch (error) {
    console.error('Error saving hourly rate:', error);
    window.showNotification(error.message || 'Failed to save hourly rate', 'error');
  }
};

// Modern confirmation dialog
window.showConfirmDialog = function (message, title = 'Confirm') {
  return new Promise((resolve) => {
    // Create overlay
    const overlay = document.createElement('div');
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      z-index: 10002;
      display: flex;
      align-items: center;
      justify-content: center;
      animation: fadeIn 0.2s ease-out;
    `;

    // Create dialog
    const dialog = document.createElement('div');
    dialog.style.cssText = `
      background: white;
      border-radius: 0.75rem;
      padding: 0;
      max-width: 400px;
      width: 90%;
      box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
      animation: slideUp 0.3s ease-out;
    `;

    dialog.innerHTML = `
      <div style="padding: 1.5rem; border-bottom: 1px solid #e5e7eb;">
        <h3 style="margin: 0; font-size: 1.125rem; font-weight: 600; color: #111827;">${title}</h3>
      </div>
      <div style="padding: 1.5rem;">
        <p style="margin: 0; font-size: 0.9375rem; color: #6b7280; line-height: 1.5;">${message}</p>
      </div>
      <div style="padding: 1rem 1.5rem; border-top: 1px solid #e5e7eb; display: flex; gap: 0.75rem; justify-content: flex-end;">
        <button id="confirm-cancel" style="
          padding: 0.5rem 1rem;
          background: #f3f4f6;
          color: #374151;
          border: none;
          border-radius: 0.5rem;
          font-size: 0.875rem;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s;
        " onmouseover="this.style.background='#e5e7eb'" onmouseout="this.style.background='#f3f4f6'">
          Cancel
        </button>
        <button id="confirm-ok" style="
          padding: 0.5rem 1rem;
          background: #ef4444;
          color: white;
          border: none;
          border-radius: 0.5rem;
          font-size: 0.875rem;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s;
        " onmouseover="this.style.background='#dc2626'" onmouseout="this.style.background='#ef4444'">
          Delete
        </button>
      </div>
    `;

    // Add animations if not already added
    if (!document.getElementById('confirm-dialog-style')) {
      const style = document.createElement('style');
      style.id = 'confirm-dialog-style';
      style.textContent = `
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes slideUp {
          from {
            transform: translateY(10px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
      `;
      document.head.appendChild(style);
    }

    overlay.appendChild(dialog);
    document.body.appendChild(overlay);

    // Handle cancel
    const cancelBtn = dialog.querySelector('#confirm-cancel');
    cancelBtn.onclick = () => {
      overlay.style.animation = 'fadeIn 0.2s ease-out reverse';
      setTimeout(() => overlay.remove(), 200);
      resolve(false);
    };

    // Handle confirm
    const okBtn = dialog.querySelector('#confirm-ok');
    okBtn.onclick = () => {
      overlay.style.animation = 'fadeIn 0.2s ease-out reverse';
      setTimeout(() => overlay.remove(), 200);
      resolve(true);
    };

    // Close on overlay click
    overlay.onclick = (e) => {
      if (e.target === overlay) {
        overlay.style.animation = 'fadeIn 0.2s ease-out reverse';
        setTimeout(() => overlay.remove(), 200);
        resolve(false);
      }
    };
  });
};

// Delete hourly rate for selected employee
window.deleteHourlyRate = async function () {
  if (!currentProfile?.id || !currentCompany?.id) {
    window.showNotification('Missing required information', 'error');
    return;
  }

  const targetUserId = (window.hourlyRateFormData?.employeeId || hourlyRateFormData.employeeId);

  if (!targetUserId) {
    window.showNotification('Please select an employee first', 'error');
    return;
  }

  const isOwner = currentProfile?.company_role === 'OWNER';
  const canEdit = isOwner || targetUserId === currentProfile.id;

  if (!canEdit) {
    window.showNotification('You do not have permission to delete hourly rates', 'error');
    return;
  }

  // Get employee name for the confirmation and success message
  let employeeName = 'this employee';
  if (targetUserId === currentProfile.id) {
    employeeName = `${currentProfile.first_name || ''} ${currentProfile.last_name || ''}`.trim() || currentProfile.email || 'you';
  } else if (companyEmployees && Array.isArray(companyEmployees)) {
    const employee = companyEmployees.find(emp => emp.id === targetUserId);
    if (employee) {
      employeeName = employee.name;
    }
  }

  // Show modern confirmation dialog
  const confirmed = await window.showConfirmDialog(
    'Are you sure you want to delete the hourly rate? This action cannot be undone.',
    'Delete Hourly Rate'
  );

  if (!confirmed) {
    return;
  }

  try {
    const { error } = await supabase
      .from('employee_hourly_rates')
      .delete()
      .eq('user_id', targetUserId)
      .eq('company_id', currentCompany.id);

    if (error) {
      console.error('Error deleting hourly rate:', error);
      throw error;
    }

    // Clear cached rate
    employeeHourlyRates[targetUserId] = null;
    currentHourlyRate = null;
    hourlyRates = [];

    // Reset the hourly rate input field to 0
    hourlyRateFormData.rate = '0';
    window.hourlyRateFormData.rate = '0';

    await window.loadHourlyRates();
    renderPMTool();

    // Show success notification with employee name
    window.showNotification(`Hourly rate has been deleted for ${employeeName}`, 'success');

    // Reset input field after render
    setTimeout(() => {
      const input = document.getElementById('hourly-rate-input');
      if (input) {
        input.value = '0';
      }
    }, 100);
  } catch (error) {
    console.error('Error deleting hourly rate:', error);
    window.showNotification(error.message || 'Failed to delete hourly rate', 'error');
  }
};

// Load time off requests
window.loadTimeOffRequests = async function () {
  // #region agent log
  fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:16877', message: 'loadTimeOffRequests ENTRY', data: { hasProfile: !!currentProfile?.id, hasCompany: !!currentCompany?.id }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'C' }) }).catch(() => { });
  // #endregion
  if (!currentProfile?.id || !currentCompany?.id) {
    // #region agent log
    fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:16880', message: 'loadTimeOffRequests EARLY RETURN', data: { hasProfile: !!currentProfile?.id, hasCompany: !!currentCompany?.id }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'C' }) }).catch(() => { });
    // #endregion
    return;
  }

  try {
    const isOwner = currentProfile?.company_role === 'OWNER';
    const isManager = currentProfile?.company_role === 'MANAGER';
    const canViewOthers = isOwner || isManager;

    // Get the current employee filter value (check window version first, then local)
    const selectedEmployeeId = (window.hourlyRateFormData && window.hourlyRateFormData.employeeId)
      ? window.hourlyRateFormData.employeeId
      : (hourlyRateFormData && hourlyRateFormData.employeeId)
        ? hourlyRateFormData.employeeId
        : null;

    let query = supabase
      .from('time_off_requests')
      .select(`
        *,
        profiles!time_off_requests_user_id_fkey (
          id,
          first_name,
          last_name,
          email
        )
      `)
      .eq('company_id', currentCompany.id);

    // Filter logic:
    // - If OWNER/MANAGER and employee filter is selected: show only that employee's requests
    // - If OWNER/MANAGER and no employee filter: show all company requests
    // - If regular employee: show only their own requests
    if (!canViewOthers) {
      // Regular employee: only their own requests
      query = query.eq('user_id', currentProfile.id);
    } else if (canViewOthers && selectedEmployeeId) {
      // OWNER/MANAGER with employee filter: show only that employee's requests
      query = query.eq('user_id', selectedEmployeeId);
    }
    // else: OWNER/MANAGER with no filter = show all (no additional filter)

    query = query.order('created_at', { ascending: false });

    const { data, error } = await query;

    if (error) throw error;
    timeOffRequests = data || [];
    // #region agent log
    fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:16921', message: 'loadTimeOffRequests SUCCESS', data: { timeOffRequestsLength: timeOffRequests.length, selectedEmployeeId }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'C' }) }).catch(() => { });
    // #endregion
    console.log('📅 [Time Off] Loaded', timeOffRequests.length, 'requests for employee:', selectedEmployeeId || 'all');
  } catch (error) {
    // #region agent log
    fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:16924', message: 'loadTimeOffRequests ERROR', data: { error: error.message }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'C' }) }).catch(() => { });
    // #endregion
    console.error('Error loading time off requests:', error);
    timeOffRequests = [];
  }
}

// Submit time off request
window.submitTimeOffRequest = async function () {
  if (!currentProfile?.id || !currentCompany?.id) {
    window.showNotification('Missing required information', 'error');
    return;
  }

  // Sync with window version
  if (window.timeOffRequestFormData) {
    timeOffRequestFormData.startDate = window.timeOffRequestFormData.startDate || timeOffRequestFormData.startDate;
    timeOffRequestFormData.endDate = window.timeOffRequestFormData.endDate || timeOffRequestFormData.endDate;
    timeOffRequestFormData.requestType = window.timeOffRequestFormData.requestType || timeOffRequestFormData.requestType;
    timeOffRequestFormData.reason = window.timeOffRequestFormData.reason || timeOffRequestFormData.reason;
  }

  console.log('📅 [Time Off] Submitting request with data:', timeOffRequestFormData);

  if (!timeOffRequestFormData.startDate || !timeOffRequestFormData.endDate) {
    window.showNotification('Please select start and end dates', 'error');
    return;
  }

  const startDate = new Date(timeOffRequestFormData.startDate);
  const endDate = new Date(timeOffRequestFormData.endDate);

  if (endDate < startDate) {
    window.showNotification('End date must be after start date', 'error');
    return;
  }

  try {
    console.log('📅 [Time Off] Submitting request for user:', currentProfile.id, 'Name:', `${currentProfile.first_name || ''} ${currentProfile.last_name || ''}`.trim() || currentProfile.email);

    const { data: newTimeOffRequest, error } = await supabase
      .from('time_off_requests')
      .insert({
        user_id: currentProfile.id,
        company_id: currentCompany.id,
        start_date: startDate.toISOString().split('T')[0],
        end_date: endDate.toISOString().split('T')[0],
        request_type: timeOffRequestFormData.requestType,
        reason: timeOffRequestFormData.reason || null,
        status: 'PENDING',
      })
      .select('id')
      .single();

    if (error) throw error;

    // Push to Google Calendar if connected (sets last_modified_source='app')
    if (newTimeOffRequest?.id) {
      await pushToGoogleCalendar('time_off', newTimeOffRequest.id);
    }

    // Close form and reset
    showTimeOffRequestForm = false;
    window.showTimeOffRequestForm = false;
    timeOffRequestFormData = {
      startDate: '',
      endDate: '',
      requestType: 'VACATION',
      reason: ''
    };
    await loadTimeOffRequests();
    renderPMTool();

    // Show success notification after rendering
    window.showNotification('Time off request submitted successfully', 'success');
  } catch (error) {
    console.error('Error submitting time off request:', error);
    window.showNotification(error.message || 'Failed to submit time off request', 'error');
  }
};

// Approve time off request
window.approveTimeOffRequest = async function () {
  // Sync with window version
  if (window.selectedTimeOffRequest) {
    selectedTimeOffRequest = window.selectedTimeOffRequest;
  }

  if (!currentProfile?.id || !selectedTimeOffRequest) {
    window.showNotification('Missing required information', 'error');
    return;
  }

  try {
    const { error } = await supabase
      .from('time_off_requests')
      .update({
        status: 'APPROVED',
        approved_by: currentProfile.id,
        approved_at: new Date().toISOString(),
      })
      .eq('id', selectedTimeOffRequest.id);

    if (error) throw error;

    // Push to Google Calendar if connected (sets last_modified_source='app')
    if (selectedTimeOffRequest.id) {
      try {
        await pushToGoogleCalendar('time_off', selectedTimeOffRequest.id);
      } catch (calendarError) {
        console.warn('Calendar push error (non-critical):', calendarError);
      }
    }

    showTimeOffApprovalModal = false;
    window.showTimeOffApprovalModal = false;
    selectedTimeOffRequest = null;
    window.selectedTimeOffRequest = null;

    // Reload and show notification
    await window.loadTimeOffRequests();
    renderPMTool();
    window.showNotification('Time off request approved', 'success');
  } catch (error) {
    console.error('Error approving request:', error);
    window.showNotification('Failed to approve request: ' + (error.message || 'Unknown error'), 'error');
  }
};

// Reject time off request (mark as REJECTED)
window.rejectTimeOffRequest = async function (requestId) {
  // Get request ID from parameter
  if (!requestId) {
    window.showNotification('No time off request selected', 'error');
    console.error('Reject failed - no request ID provided');
    return;
  }

  if (!currentProfile?.id) {
    window.showNotification('Missing user information', 'error');
    return;
  }

  try {
    // Update the time off request status to REJECTED
    const { error } = await supabase
      .from('time_off_requests')
      .update({
        status: 'REJECTED',
        approved_by: currentProfile.id,
        approved_at: new Date().toISOString()
      })
      .eq('id', requestId);

    if (error) throw error;

    // Push to Google Calendar if connected (sets last_modified_source='app')
    if (requestId) {
      try {
        await pushToGoogleCalendar('time_off', requestId);
      } catch (calendarError) {
        console.warn('Calendar push error (non-critical):', calendarError);
      }
    }

    // Reload time off requests and re-render
    await window.loadTimeOffRequests();
    renderPMTool();

    // Show rejection notification
    window.showNotification('Time off request rejected', 'rejected');
  } catch (error) {
    console.error('Error rejecting time off request:', error);
    window.showNotification('Failed to reject time off request: ' + (error.message || error), 'error');
  }
};

// Delete time off request
// Show delete time off request confirmation modal
window.showDeleteTimeOffRequestConfirm = function (requestId) {
  if (!requestId) return;

  // Remove any existing modal
  const existingModal = document.getElementById('delete-time-off-request-modal');
  if (existingModal) {
    existingModal.remove();
  }

  const request = timeOffRequests.find(r => r.id === requestId);
  const requestTitle = request ? (request.reason || 'Time Off Request') : 'this time off request';
  const requestDate = request ? formatDate(request.start_date) : '';

  const modal = document.createElement('div');
  modal.id = 'delete-time-off-request-modal';
  modal.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10001;
    animation: fadeIn 0.2s ease-out;
  `;

  modal.innerHTML = `
    <div style="
      background: white;
      border-radius: 1rem;
      padding: 0;
      max-width: 400px;
      width: 90%;
      box-shadow: 0 25px 50px rgba(0,0,0,0.25);
      animation: scaleIn 0.2s ease-out;
      overflow: hidden;
    ">
      <!-- Header -->
      <div style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1.25rem 1.5rem;
        border-bottom: 1px solid #E5E7EB;
      ">
        <div style="display: flex; align-items: center; gap: 0.75rem;">
          <span class="material-icons" style="color: #EF4444; font-size: 24px;">warning</span>
          <h3 style="margin: 0; font-size: 1.125rem; font-weight: 600; color: #111827;">Delete Time Off Request</h3>
        </div>
        <button 
          onclick="closeDeleteTimeOffRequestModal()"
          style="
            background: transparent;
            border: none;
            cursor: pointer;
            padding: 0.25rem;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 0.375rem;
            color: #6B7280;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#F3F4F6'; this.style.color='#111827';"
          onmouseout="this.style.background='transparent'; this.style.color='#6B7280';"
        >
          <span class="material-icons" style="font-size: 20px;">close</span>
        </button>
      </div>
      
      <!-- Body -->
      <div style="padding: 1.5rem;">
        <p style="margin: 0; color: #4B5563; font-size: 0.9375rem; line-height: 1.5;">
          Are you sure you want to delete <strong>${requestTitle}${requestDate ? ' for ' + requestDate : ''}</strong>? This action cannot be undone.
        </p>
      </div>
      
      <!-- Footer -->
      <div style="
        display: flex;
        gap: 0.75rem;
        padding: 1rem 1.5rem;
        background: #F9FAFB;
        border-top: 1px solid #E5E7EB;
        justify-content: flex-end;
      ">
        <button 
          onclick="closeDeleteTimeOffRequestModal()"
          style="
            padding: 0.75rem 1.5rem;
            background: white;
            border: 1px solid #D1D5DB;
            border-radius: 0.5rem;
            color: #374151;
            font-size: 0.9375rem;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#F9FAFB'; this.style.borderColor='#9CA3AF';"
          onmouseout="this.style.background='white'; this.style.borderColor='#D1D5DB';"
        >
          Cancel
        </button>
        <button 
          onclick="confirmDeleteTimeOffRequest('${requestId}')"
          style="
            padding: 0.75rem 1.5rem;
            background: #EF4444;
            border: none;
            border-radius: 0.5rem;
            color: white;
            font-size: 0.9375rem;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#DC2626';"
          onmouseout="this.style.background='#EF4444';"
        >
          Delete
        </button>
      </div>
    </div>
  `;

  // Add styles if not already added (reuse if exists from other modals)
  if (!document.getElementById('delete-time-off-request-modal-styles')) {
    const style = document.createElement('style');
    style.id = 'delete-time-off-request-modal-styles';
    style.textContent = `
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      @keyframes scaleIn {
        from { transform: scale(0.95); opacity: 0; }
        to { transform: scale(1); opacity: 1; }
      }
    `;
    document.head.appendChild(style);
  }

  // Close on backdrop click
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      closeDeleteTimeOffRequestModal();
    }
  });

  document.body.appendChild(modal);
};

// Close delete time off request modal
window.closeDeleteTimeOffRequestModal = function () {
  const modal = document.getElementById('delete-time-off-request-modal');
  if (modal) {
    modal.style.opacity = '0';
    setTimeout(() => {
      modal.remove();
    }, 200);
  }
};

// Confirm delete time off request
window.confirmDeleteTimeOffRequest = async function (requestId) {
  if (!requestId) return;

  const deleteBtn = document.querySelector('#delete-time-off-request-modal button[onclick*="confirmDeleteTimeOffRequest"]');
  if (deleteBtn) {
    deleteBtn.disabled = true;
    deleteBtn.textContent = 'Deleting...';
  }

  try {
    // Find the request to check permissions
    const request = timeOffRequests.find(r => r.id === requestId);
    if (!request) {
      window.showNotification('Time off request not found', 'error');
      closeDeleteTimeOffRequestModal();
      return;
    }

    // Permission check: Employees can only delete their own PENDING requests
    // Managers/Owners can delete any request
    const userRole = currentProfile?.company_role || currentProfile?.role || 'USER';
    const isEmployee = userRole === 'EMPLOYEE';
    const canApprove = userRole === 'OWNER' || userRole === 'MANAGER' || userRole === 'ADMIN' || currentProfile?.is_hh_admin;

    if (isEmployee && !canApprove) {
      // Employee trying to delete
      if (request.user_id !== currentProfile?.id) {
        window.showNotification('You can only delete your own time off requests', 'error');
        closeDeleteTimeOffRequestModal();
        return;
      }
      if (request.status !== 'PENDING') {
        window.showNotification('You can only delete pending time off requests', 'error');
        closeDeleteTimeOffRequestModal();
        return;
      }
    }

    console.log('Attempting to delete time off request:', requestId);

    // Delete the time off request from database
    const { data, error } = await supabase
      .from('time_off_requests')
      .delete()
      .eq('id', requestId)
      .select(); // Select to verify deletion

    if (error) {
      console.error('Delete error:', error);
      throw error;
    }

    console.log('Delete result:', data);

    // Push delete to Google Calendar if connected
    try {
      await pushToGoogleCalendar('time_off', requestId, 'delete');
    } catch (calendarError) {
      console.warn('Calendar delete error (non-critical):', calendarError);
    }

    closeDeleteTimeOffRequestModal();

    // Reload time off requests and re-render
    await loadTimeOffRequests();
    renderPMTool();

    window.showNotification('Time off request deleted successfully', 'success');
  } catch (error) {
    console.error('Error deleting time off request:', error);
    window.showNotification('Failed to delete time off request: ' + (error.message || error), 'error');
    closeDeleteTimeOffRequestModal();
  }
};

window.deleteTimeOffRequest = async function (requestId) {
  if (!requestId) {
    window.showNotification('No time off request selected', 'error');
    return;
  }

  // Find the request to check permissions
  const request = timeOffRequests.find(r => r.id === requestId);
  if (!request) {
    window.showNotification('Time off request not found', 'error');
    return;
  }

  // Permission check: Employees can only delete their own PENDING requests
  // Managers/Owners can delete any request
  const userRole = currentProfile?.company_role || currentProfile?.role || 'USER';
  const isEmployee = userRole === 'EMPLOYEE';
  const canApprove = userRole === 'OWNER' || userRole === 'MANAGER' || userRole === 'ADMIN' || currentProfile?.is_hh_admin;

  if (isEmployee && !canApprove) {
    // Employee trying to delete
    if (request.user_id !== currentProfile?.id) {
      window.showNotification('You can only delete your own time off requests', 'error');
      return;
    }
    if (request.status !== 'PENDING') {
      window.showNotification('You can only delete pending time off requests', 'error');
      return;
    }
  }

  // Show confirmation modal
  showDeleteTimeOffRequestConfirm(requestId);

  try {
    console.log('Attempting to delete time off request:', requestId);

    // Delete the time off request from database
    const { data, error } = await supabase
      .from('time_off_requests')
      .delete()
      .eq('id', requestId)
      .select(); // Select to verify deletion

    if (error) {
      console.error('Delete error:', error);
      throw error;
    }

    console.log('Delete result:', data);

    // Push delete to Google Calendar if connected
    try {
      await pushToGoogleCalendar('time_off', requestId, 'delete');
    } catch (calendarError) {
      console.warn('Calendar delete error (non-critical):', calendarError);
    }

    // Reload time off requests and re-render
    await window.loadTimeOffRequests();
    renderPMTool();

    // Show success notification after reload
    window.showNotification('Time off request deleted successfully', 'success');
  } catch (error) {
    console.error('Error deleting time off request:', error);
    const errorMessage = error.message || error.code || 'Unknown error';
    console.error('Full error details:', {
      message: error.message,
      code: error.code,
      details: error.details,
      hint: error.hint
    });
    window.showNotification('Failed to delete time off request: ' + errorMessage + '. Check console for details.', 'error');
  }
};

// Export timesheet to CSV
window.exportTimesheet = function () {
  // #region agent log
  fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:16985', message: 'exportTimesheet ENTRY', data: { timeEntriesLength: timeEntries.length, companyEmployeesIsNull: companyEmployees === null, companyEmployeesLength: companyEmployees?.length }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'D' }) }).catch(() => { });
  // #endregion
  if (timeEntries.length === 0) {
    if (typeof window.showNotification === 'function') {
      window.showNotification('No data to export. Please generate timesheet first.', 'error');
    } else {
      alert('No data to export. Please generate timesheet first.');
    }
    return;
  }

  try {
    const isOwner = currentProfile?.company_role === 'OWNER';
    const isManager = currentProfile?.company_role === 'MANAGER';
    const canViewOthers = isOwner || isManager;

    const headers = canViewOthers
      ? ['Employee', 'Date', 'Clock In', 'Clock Out', 'Break', 'Total Hours', 'Regular Hours', 'Overtime Hours', 'Pay', 'Clock In Location', 'Clock Out Location']
      : ['Date', 'Clock In', 'Clock Out', 'Break', 'Total Hours', 'Regular Hours', 'Overtime Hours', 'Pay', 'Clock In Location', 'Clock Out Location'];

    const rows = timeEntries.map((entry) => {
      const date = new Date(entry.clock_in_at);
      const clockInLoc = entry.clock_in_location?.address || (entry.clock_in_location ? `${entry.clock_in_location.lat}, ${entry.clock_in_location.lng}` : '');
      const clockOutLoc = entry.clock_out_location?.address || (entry.clock_out_location ? `${entry.clock_out_location.lat}, ${entry.clock_out_location.lng}` : '');

      // Get employee name
      const employeeName = entry.profiles
        ? `${entry.profiles.first_name || ''} ${entry.profiles.last_name || ''}`.trim() || entry.profiles.email
        : 'Unknown';

      // Calculate break duration
      let breakDuration = '-';
      if (entry.break_start_at && entry.break_end_at) {
        const breakStart = new Date(entry.break_start_at);
        const breakEnd = new Date(entry.break_end_at);
        const breakMs = breakEnd.getTime() - breakStart.getTime();
        const breakHours = Math.floor(breakMs / (1000 * 60 * 60));
        const breakMinutes = Math.floor((breakMs % (1000 * 60 * 60)) / (1000 * 60));
        breakDuration = `${breakHours}h ${breakMinutes}m`;
      }

      // Calculate pay (using employee hourly rate for this entry's date)
      const employeeId = entry.user_id;
      const entryDate = new Date(entry.clock_in_at);
      const hourlyRate = window.getRateForDate ? window.getRateForDate(employeeId, entryDate) :
        (typeof employeeHourlyRates[employeeId] === 'number' ? employeeHourlyRates[employeeId] :
          (employeeHourlyRates[employeeId]?.latest || 0));
      const pay = (entry.total_hours || 0) * hourlyRate;

      const row = canViewOthers
        ? [
          employeeName,
          date.toLocaleDateString(),
          entry.clock_in_at ? formatTime(entry.clock_in_at) : '',
          entry.clock_out_at ? formatTime(entry.clock_out_at) : '',
          breakDuration,
          (entry.total_hours || 0).toFixed(2),
          (entry.regular_hours || 0).toFixed(2),
          (entry.overtime_hours || 0).toFixed(2),
          `$${pay.toFixed(2)}`,
          clockInLoc,
          clockOutLoc,
        ]
        : [
          date.toLocaleDateString(),
          entry.clock_in_at ? formatTime(entry.clock_in_at) : '',
          entry.clock_out_at ? formatTime(entry.clock_out_at) : '',
          breakDuration,
          (entry.total_hours || 0).toFixed(2),
          (entry.regular_hours || 0).toFixed(2),
          (entry.overtime_hours || 0).toFixed(2),
          `$${pay.toFixed(2)}`,
          clockInLoc,
          clockOutLoc,
        ];

      return row;
    });

    const csvContent = [
      headers.join(','),
      ...rows.map(row => row.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(','))
    ].join('\n');

    // Create and trigger download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `timesheet_${timesheetStartDate.toISOString().split('T')[0]}_${timesheetEndDate.toISOString().split('T')[0]}.csv`;
    link.style.display = 'none';
    document.body.appendChild(link);

    // Trigger download
    link.click();

    // Clean up after a short delay to ensure download starts
    setTimeout(() => {
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }, 100);

    // Show success notification
    if (typeof window.showNotification === 'function') {
      window.showNotification('Timesheet exported successfully', 'success');
    } else {
      alert('Timesheet exported successfully');
    }
  } catch (error) {
    console.error('Error exporting timesheet:', error);
    if (typeof window.showNotification === 'function') {
      window.showNotification('Failed to export timesheet', 'error');
    } else {
      alert('Failed to export timesheet');
    }
  }
};

// Switch time tracking view
window.switchTimeTrackingView = async function (view) {
  // Remove debug logs - they're causing connection refused errors
  // #region agent log
  fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:17102', message: 'switchTimeTrackingView ENTRY', data: { view, currentView: timeTrackingView, companyEmployeesIsNull: companyEmployees === null, companyEmployeesLoading, companyEmployeesLength: companyEmployees?.length }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'A' }) }).catch(() => { });
  // #endregion
  timeTrackingView = view;
  if (view === 'timesheet') {
    // #region agent log
    fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:17105', message: 'BEFORE await loadCompanyEmployees', data: { companyEmployeesIsNull: companyEmployees === null, companyEmployeesLoading, companyEmployeesLength: companyEmployees?.length }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'A' }) }).catch(() => { });
    // #endregion
    // Load data first, then render
    await loadCompanyEmployees();
    // #region agent log
    fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:17108', message: 'AFTER await loadCompanyEmployees', data: { companyEmployeesIsNull: companyEmployees === null, companyEmployeesLoading, companyEmployeesLength: companyEmployees?.length }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'A' }) }).catch(() => { });
    // #endregion
    // Don't auto-load timesheet entries - user must click Generate button
    // await loadTimesheetEntries();
  } else if (view === 'hourly-rate') {
    await loadCompanyEmployees();
    loadHourlyRates();
  } else if (view === 'time-off') {
    // #region agent log
    fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:17239', message: 'switchTimeTrackingView time-off ENTRY', data: { hasProfile: !!currentProfile?.id, hasCompany: !!currentCompany?.id, companyEmployeesIsNull: companyEmployees === null, companyEmployeesLength: companyEmployees?.length }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'A' }) }).catch(() => { });
    // #endregion
    if (currentProfile?.id && currentCompany?.id) {
      // Initialize employee filter for non-OWNER/MANAGER users
      const isOwner = currentProfile?.company_role === 'OWNER';
      const isManager = currentProfile?.company_role === 'MANAGER';
      const canApprove = isOwner || isManager;

      if (!canApprove) {
        hourlyRateFormData.employeeId = currentProfile.id;
        window.hourlyRateFormData = window.hourlyRateFormData || {};
        window.hourlyRateFormData.employeeId = currentProfile.id;
      }

      // #region agent log
      fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:17252', message: 'BEFORE loadCompanyEmployees for time-off', data: { companyEmployeesIsNull: companyEmployees === null, companyEmployeesLoading }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'A' }) }).catch(() => { });
      // #endregion
      // Load company employees and then load time off requests
      await loadCompanyEmployees();
      // #region agent log
      fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:17255', message: 'AFTER loadCompanyEmployees for time-off', data: { companyEmployeesIsNull: companyEmployees === null, companyEmployeesLength: companyEmployees?.length, companyEmployeesIsArray: Array.isArray(companyEmployees) }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'A' }) }).catch(() => { });
      // #endregion
      // #region agent log
      fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:17257', message: 'BEFORE loadTimeOffRequests for time-off', data: { timeOffRequestsLength: timeOffRequests?.length }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'C' }) }).catch(() => { });
      // #endregion
      await window.loadTimeOffRequests();
      // #region agent log
      fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:17259', message: 'AFTER loadTimeOffRequests for time-off', data: { timeOffRequestsLength: timeOffRequests?.length }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'C' }) }).catch(() => { });
      // #endregion
    }
  }
  // #region agent log
  fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:17115', message: 'BEFORE renderPMTool call', data: { companyEmployeesIsNull: companyEmployees === null, companyEmployeesLoading, companyEmployeesLength: companyEmployees?.length }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'A' }) }).catch(() => { });
  // #endregion
  renderPMTool();
};

// Render Time Tracking Screen
async function renderTimeTrackingScreen() {
  console.log('🕐 [Time Tracking] renderTimeTrackingScreen() called');
  console.log('🕐 [Time Tracking] Render state:', {
    view: timeTrackingView,
    checkingStatus: timeTrackingData.checkingStatus,
    isClockedIn: timeTrackingData.isClockedIn,
    dataLoaded: timeTrackingData.dataLoaded,
    hasProfile: !!currentProfile?.id,
    hasCompany: !!currentCompany?.id
  });

  // Load data if needed - only load if profile and company are available
  // IMPORTANT: Don't load on every render - only load if data hasn't been loaded yet
  // This prevents infinite render loops
  if (timeTrackingView === 'main') {
    // Only load if:
    // 1. Not already checking
    // 2. Data hasn't been loaded yet (or forceReload is set)
    // 3. Profile and company exist
    if (!timeTrackingData.checkingStatus && !timeTrackingData.dataLoaded && currentProfile?.id && currentCompany?.id) {
      console.log('🕐 [Time Tracking] Calling loadTimeTrackingData() from renderTimeTrackingScreen (first load)');
      loadTimeTrackingData();
    } else {
      console.log('🕐 [Time Tracking] Skipping load - already checking, data loaded, or missing profile/company');
    }
  } else if (timeTrackingView === 'timesheet') {
    // #region agent log
    fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:17144', message: 'renderTimeTrackingScreen timesheet branch', data: { companyEmployeesIsNull: companyEmployees === null, companyEmployeesLoading, companyEmployeesLength: companyEmployees?.length, companyEmployeesIsArray: Array.isArray(companyEmployees) }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'B' }) }).catch(() => { });
    // #endregion
    if (currentProfile?.id && currentCompany?.id) {
      // Only load company employees if not already loaded/loading to prevent infinite loops
      if (!companyEmployeesLoading && companyEmployees === null) {
        // #region agent log
        fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:17148', message: 'renderTimeTrackingScreen calling loadCompanyEmployees', data: { companyEmployeesIsNull: companyEmployees === null, companyEmployeesLoading }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'B' }) }).catch(() => { });
        // #endregion
        loadCompanyEmployees();
      }
      // Only load overtime rules if not already loaded
      if (!overtimeRules) {
        loadOvertimeRules();
      }
      // Don't auto-load timesheet entries on render - user must click "Generate" button
      // This prevents infinite loops and gives user control over when to load data
    }
  } else if (timeTrackingView === 'hourly-rate') {
    if (currentProfile?.id && currentCompany?.id) {
      const isOwner = currentProfile?.company_role === 'OWNER';
      const isManager = currentProfile?.company_role === 'MANAGER';
      const canViewOthers = isOwner || isManager;

      // If employee (not OWNER/MANAGER), set employeeId to current user
      if (!canViewOthers) {
        hourlyRateFormData.employeeId = currentProfile.id;
        window.hourlyRateFormData.employeeId = currentProfile.id;
      } else {
        // For OWNER/MANAGER, ensure employeeId is initialized (can be null for "Select Employee")
        if (!window.hourlyRateFormData) {
          window.hourlyRateFormData = { rate: '0', employeeId: null };
        }
        if (hourlyRateFormData.employeeId === undefined) {
          hourlyRateFormData.employeeId = null;
        }
      }

      // Load employees and rates, but don't trigger a re-render here
      // The render will happen naturally when the function returns
      // Only load if not already loaded to prevent infinite loops
      if (companyEmployees === null && !companyEmployeesLoading) {
        loadCompanyEmployees();
      }
      window.loadHourlyRates();
    }
  } else if (timeTrackingView === 'time-off') {
    if (currentProfile?.id && currentCompany?.id) {
      // Initialize employee filter for non-OWNER/MANAGER users
      const isOwner = currentProfile?.company_role === 'OWNER';
      const isManager = currentProfile?.company_role === 'MANAGER';
      const canApprove = isOwner || isManager;

      if (!canApprove) {
        hourlyRateFormData.employeeId = currentProfile.id;
        window.hourlyRateFormData = window.hourlyRateFormData || {};
        window.hourlyRateFormData.employeeId = currentProfile.id;
      }

      // Load company employees and then load time off requests
      await loadCompanyEmployees();
      await window.loadTimeOffRequests();
    }
  }

  // Load overtime rules for main view too (for pay calculations)
  if (timeTrackingView === 'main' && currentProfile?.id && currentCompany?.id) {
    loadOvertimeRules();
  }

  const isOwner = currentProfile?.company_role === 'OWNER';
  const isManager = currentProfile?.company_role === 'MANAGER';
  const canViewOthers = isOwner || isManager;

  if (timeTrackingView === 'timesheet') {
    return renderTimesheetView();
  } else if (timeTrackingView === 'hourly-rate') {
    return renderHourlyRateView();
  } else if (timeTrackingView === 'time-off') {
    return renderTimeOffView();
  }

  // Main time tracking view
  return `
    <div style="max-width: 1200px; margin: 0 auto; padding: 1.5rem;">
      <!-- Header -->
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 2rem;">
        <h1 style="font-size: 2rem; font-weight: 700; color: #0f172a; margin: 0;">Time Tracking</h1>
        ${(() => {
      const userRole = currentProfile?.company_role || currentProfile?.role || 'USER';
      const canViewTimesheets = userRole === 'OWNER' || userRole === 'MANAGER' || userRole === 'ADMIN' || currentProfile?.is_hh_admin;
      return canViewTimesheets ? `
            <button
              onclick="switchTimeTrackingView('timesheet');"
              style="
                display: flex;
                align-items: center;
                gap: 0.5rem;
                padding: 0.75rem 1.25rem;
                background: #ffffff;
                border: 1px solid #e5e7eb;
                border-radius: 0.5rem;
                color: #f59e0b;
                font-weight: 600;
                cursor: pointer;
                transition: all 0.2s;
              "
              onmouseover="this.style.background='#f8f9fa'"
              onmouseout="this.style.background='#ffffff'"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" stroke-width="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                <polyline points="14 2 14 8 20 8"></polyline>
                <line x1="16" y1="13" x2="8" y2="13"></line>
                <line x1="16" y1="17" x2="8" y2="17"></line>
                <polyline points="10 9 9 9 8 9"></polyline>
              </svg>
              See Timesheets
            </button>
          ` : '';
    })()}
      </div>
      
      <!-- Clock In/Out Button -->
      <div style="
        background: #ffffff;
        border-radius: 1rem;
        padding: 2rem;
        margin-bottom: 2rem;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        text-align: center;
      ">
        ${(() => {
      console.log('🕐 [Time Tracking] Rendering clock button - checkingStatus:', timeTrackingData.checkingStatus, 'isClockedIn:', timeTrackingData.isClockedIn);
      return timeTrackingData.checkingStatus;
    })() ? `
          <div style="padding: 2rem;">
            <div style="display: inline-block; width: 2rem; height: 2rem; border: 3px solid #e5e7eb; border-top-color: #3b82f6; border-radius: 50%; animation: spin 1s linear infinite;"></div>
            <p style="margin-top: 1rem; color: #64748b;">Checking status...</p>
            <p style="margin-top: 0.5rem; font-size: 0.75rem; color: #94a3b8;">Debug: checkingStatus=${timeTrackingData.checkingStatus}, dataLoaded=${timeTrackingData.dataLoaded}</p>
          </div>
        ` : timeTrackingData.isClockedIn ? `
          <div>
            <div style="margin-bottom: 1rem;">
              <div style="
                display: inline-block;
                padding: 0.5rem 1rem;
                background: ${timeTrackingData.isOnBreak ? '#fef3c7' : '#dcfce7'};
                color: ${timeTrackingData.isOnBreak ? '#92400e' : '#166534'};
                border-radius: 0.5rem;
                font-weight: 600;
                font-size: 0.875rem;
              ">
                ${timeTrackingData.isOnBreak ? 'ON BREAK' : 'CLOCKED IN'}
              </div>
            </div>
            ${timeTrackingData.isOnBreak ? `
              <div style="margin-bottom: 1.5rem;">
                <div id="time-tracking-break-duration-display" style="font-size: 3rem; font-weight: 700; color: #f59e0b; font-family: monospace; letter-spacing: 0.1em;">
                  ${timeTrackingData.currentBreakDuration || '00:00:00'}
                </div>
                <p style="color: #64748b; margin-top: 0.5rem;">Break duration</p>
              </div>
            ` : `
              <div style="margin-bottom: 1.5rem;">
                <div id="time-tracking-duration-display" style="font-size: 3rem; font-weight: 700; color: #0f172a; font-family: monospace; letter-spacing: 0.1em;">
                  ${timeTrackingData.currentShiftDuration || '00:00:00'}
                </div>
                <p style="color: #64748b; margin-top: 0.5rem;">Current shift duration</p>
              </div>
            `}
            <div style="display: flex; gap: 1rem; justify-content: center; flex-wrap: wrap;">
              ${timeTrackingData.isOnBreak ? `
                <button
                  onclick="event.preventDefault(); event.stopPropagation(); console.log('🕐 [Time Tracking] Stop Break button clicked'); if (window.stopBreak && !${timeTrackingData.loading}) { window.stopBreak(); } else { console.error('🕐 [Time Tracking] Cannot stop break - function:', typeof window.stopBreak, 'loading:', ${timeTrackingData.loading}); }"
                  ${timeTrackingData.loading ? 'disabled' : ''}
                  style="
                    padding: 1rem 2rem;
                    background: #f59e0b;
                    color: white;
                    border: none;
                    border-radius: 0.5rem;
                    font-size: 1.125rem;
                    font-weight: 600;
                    cursor: ${timeTrackingData.loading ? 'not-allowed' : 'pointer'};
                    opacity: ${timeTrackingData.loading ? '0.6' : '1'};
                    transition: all 0.2s;
                    pointer-events: ${timeTrackingData.loading ? 'none' : 'auto'};
                  "
                  onmouseover="if (!${timeTrackingData.loading}) this.style.background='#d97706'"
                  onmouseout="if (!${timeTrackingData.loading}) this.style.background='#f59e0b'"
                >
                  ${timeTrackingData.loading ? 'Processing...' : 'Stop Break'}
                </button>
                <button
                  onclick="event.preventDefault(); event.stopPropagation(); console.log('🕐 [Time Tracking] Clock Out button clicked'); if (window.clockOut && !${timeTrackingData.loading}) { window.clockOut(); } else { console.error('🕐 [Time Tracking] Cannot clock out - function:', typeof window.clockOut, 'loading:', ${timeTrackingData.loading}); }"
                  ${timeTrackingData.loading ? 'disabled' : ''}
                  style="
                    padding: 1rem 2rem;
                    background: #ef4444;
                    color: white;
                    border: none;
                    border-radius: 0.5rem;
                    font-size: 1.125rem;
                    font-weight: 600;
                    cursor: ${timeTrackingData.loading ? 'not-allowed' : 'pointer'};
                    opacity: ${timeTrackingData.loading ? '0.6' : '1'};
                    transition: all 0.2s;
                    pointer-events: ${timeTrackingData.loading ? 'none' : 'auto'};
                  "
                  onmouseover="if (!${timeTrackingData.loading}) this.style.background='#dc2626'"
                  onmouseout="if (!${timeTrackingData.loading}) this.style.background='#ef4444'"
                >
                  ${timeTrackingData.loading ? 'Processing...' : 'Clock Out'}
                </button>
              ` : `
                <button
                  onclick="event.preventDefault(); event.stopPropagation(); console.log('🕐 [Time Tracking] Clock Out button clicked'); if (window.clockOut && !${timeTrackingData.loading}) { window.clockOut(); } else { console.error('🕐 [Time Tracking] Cannot clock out - function:', typeof window.clockOut, 'loading:', ${timeTrackingData.loading}); }"
                  ${timeTrackingData.loading ? 'disabled' : ''}
                  style="
                    padding: 1rem 2rem;
                    background: #ef4444;
                    color: white;
                    border: none;
                    border-radius: 0.5rem;
                    font-size: 1.125rem;
                    font-weight: 600;
                    cursor: ${timeTrackingData.loading ? 'not-allowed' : 'pointer'};
                    opacity: ${timeTrackingData.loading ? '0.6' : '1'};
                    transition: all 0.2s;
                    pointer-events: ${timeTrackingData.loading ? 'none' : 'auto'};
                  "
                  onmouseover="if (!${timeTrackingData.loading}) this.style.background='#dc2626'"
                  onmouseout="if (!${timeTrackingData.loading}) this.style.background='#ef4444'"
                >
                  ${timeTrackingData.loading ? 'Processing...' : 'Clock Out'}
                </button>
              `}
            </div>
          </div>
        ` : `
          <div>
            <div style="margin-bottom: 1.5rem;">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#64748b" stroke-width="2" style="margin: 0 auto;">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="12 6 12 12 16 14"></polyline>
              </svg>
            </div>
            <button
              onclick="event.preventDefault(); event.stopPropagation(); console.log('🕐 [Time Tracking] Clock In button clicked!'); console.log('🕐 [Time Tracking] window.clockIn exists:', typeof window.clockIn); console.log('🕐 [Time Tracking] isClockedIn:', ${timeTrackingData.isClockedIn}, 'loading:', ${timeTrackingData.loading}); if (window.clockIn && !${timeTrackingData.loading} && !${timeTrackingData.isClockedIn}) { window.clockIn(); } else { console.error('🕐 [Time Tracking] Cannot clock in - function:', typeof window.clockIn, 'loading:', ${timeTrackingData.loading}, 'isClockedIn:', ${timeTrackingData.isClockedIn}); }"
              ${timeTrackingData.loading || timeTrackingData.isClockedIn ? 'disabled' : ''}
              style="
                padding: 1rem 2rem;
                background: #ff7f00;
                color: white;
                border: none;
                border-radius: 0.5rem;
                font-size: 1.125rem;
                font-weight: 600;
                cursor: ${timeTrackingData.loading || timeTrackingData.isClockedIn ? 'not-allowed' : 'pointer'};
                opacity: ${timeTrackingData.loading || timeTrackingData.isClockedIn ? '0.6' : '1'};
                transition: all 0.2s;
                pointer-events: ${timeTrackingData.loading || timeTrackingData.isClockedIn ? 'none' : 'auto'};
              "
              onmouseover="if (!${timeTrackingData.loading} && !${timeTrackingData.isClockedIn}) this.style.background='#e67300'"
              onmouseout="if (!${timeTrackingData.loading} && !${timeTrackingData.isClockedIn}) this.style.background='#ff7f00'"
            >
              ${timeTrackingData.loading ? 'Processing...' : 'Clock In'}
            </button>
          </div>
        `}
      </div>
      
      <!-- Today's Summary -->
      <div style="
        background: #ffffff;
        border-radius: 1rem;
        padding: 2rem;
        margin-bottom: 2rem;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        text-align: center;
      ">
        <h2 style="font-size: 1rem; font-weight: 600; color: #64748b; margin: 0 0 1rem 0;">Today's Hours</h2>
        ${(() => {
      console.log('🕐 [Time Tracking] Rendering today\'s hours - loading:', timeTrackingData.loading, 'todayHours:', timeTrackingData.todayHours);
      return timeTrackingData.loading;
    })() ? `
          <div style="display: inline-block; width: 2rem; height: 2rem; border: 3px solid #e5e7eb; border-top-color: #3b82f6; border-radius: 50%; animation: spin 1s linear infinite;"></div>
        ` : `
          <div style="font-size: 2.5rem; font-weight: 700; color: #ff7f00;">
            ${formatHours(timeTrackingData.todayHours)}
          </div>
        `}
      </div>
      
      <!-- Location Display (if clocked in) - will be loaded separately -->
      <div id="time-tracking-location-display" style="display: none; margin-bottom: 2rem;"></div>
      
      <!-- Quick Stats -->
      <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem; margin-bottom: 2rem;">
        <div style="
          background: #ffffff;
          border-radius: 1rem;
          padding: 1.5rem;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
          text-align: center;
        ">
          <p style="font-size: 0.875rem; color: #64748b; margin: 0 0 0.5rem 0;">This Week</p>
          ${timeTrackingData.loading ? `
            <div style="display: inline-block; width: 1.5rem; height: 1.5rem; border: 2px solid #e5e7eb; border-top-color: #3b82f6; border-radius: 50%; animation: spin 1s linear infinite;"></div>
          ` : `
            <p style="font-size: 1.5rem; font-weight: 700; color: #0f172a; margin: 0;">
              ${formatHours(timeTrackingData.weekHours)}
            </p>
          `}
        </div>
        
        <div style="
          background: #ffffff;
          border-radius: 1rem;
          padding: 1.5rem;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
          text-align: center;
        ">
          <p style="font-size: 0.875rem; color: #64748b; margin: 0 0 0.5rem 0;">This Month</p>
          ${timeTrackingData.loading ? `
            <div style="display: inline-block; width: 1.5rem; height: 1.5rem; border: 2px solid #e5e7eb; border-top-color: #3b82f6; border-radius: 50%; animation: spin 1s linear infinite;"></div>
          ` : `
            <p style="font-size: 1.5rem; font-weight: 700; color: #0f172a; margin: 0;">
              ${formatHours(timeTrackingData.monthHours)}
            </p>
          `}
        </div>
      </div>
      
      <!-- Break Tracking (if clocked in) -->
      ${timeTrackingData.isClockedIn ? `
        <div style="
          background: #ffffff;
          border-radius: 1rem;
          padding: 1.5rem;
          margin-bottom: 2rem;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        ">
          <h2 style="font-size: 1rem; font-weight: 600; color: #64748b; margin: 0 0 1rem 0;">Break Tracking</h2>
          <p style="font-size: 0.875rem; color: #64748b; margin-bottom: 1rem;">
            Note: Break tracking requires clocking out and back in. Your break time will be automatically calculated.
          </p>
          <div style="padding: 1rem; background: #f8f9fa; border-radius: 0.5rem;">
            <div style="font-size: 0.875rem; color: #64748b; margin-bottom: 0.5rem;">Current Break Status</div>
            <div style="font-size: 1rem; font-weight: 600; color: #0f172a;">On Break: Clock out to start break, clock in to end break</div>
          </div>
        </div>
      ` : ''}
      
      <!-- Quick Actions -->
      <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 1rem;">
        ${(() => {
      const userRole = currentProfile?.company_role || currentProfile?.role || 'USER';
      const isOwner = userRole === 'OWNER' || currentProfile?.is_hh_admin;
      return isOwner ? `
            <button
              onclick="switchTimeTrackingView('hourly-rate');"
              style="
                background: #ffffff;
                border: 1px solid #e5e7eb;
                border-radius: 0.75rem;
                padding: 1.5rem;
                text-align: left;
                cursor: pointer;
                transition: all 0.2s;
              "
              onmouseover="this.style.borderColor='#ff7f00'; this.style.boxShadow='0 4px 6px rgba(0,0,0,0.1)'"
              onmouseout="this.style.borderColor='#e5e7eb'; this.style.boxShadow='none'"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-bottom: 0.5rem; color: #f59e0b;">
                <line x1="12" y1="1" x2="12" y2="23"></line>
                <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
              </svg>
              <h3 style="font-size: 1rem; font-weight: 600; color: #0f172a; margin: 0 0 0.25rem 0;">Hourly Rates</h3>
              <p style="font-size: 0.875rem; color: #64748b; margin: 0;">Manage employee hourly rates</p>
            </button>
          ` : '';
    })()}
        
        <button
          onclick="switchTimeTrackingView('time-off');"
          style="
            background: #ffffff;
            border: 1px solid #e5e7eb;
            border-radius: 0.75rem;
            padding: 1.5rem;
            text-align: left;
            cursor: pointer;
            transition: all 0.2s;
          "
          onmouseover="this.style.borderColor='#ff7f00'; this.style.boxShadow='0 4px 6px rgba(0,0,0,0.1)'"
          onmouseout="this.style.borderColor='#e5e7eb'; this.style.boxShadow='none'"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-bottom: 0.5rem; color: #f59e0b;">
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
            <path d="M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01M16 18h.01"></path>
          </svg>
          <h3 style="font-size: 1rem; font-weight: 600; color: #0f172a; margin: 0 0 0.25rem 0;">Time Off</h3>
          <p style="font-size: 0.875rem; color: #64748b; margin: 0;">Request and manage time off</p>
        </button>
        
      </div>
      
      <!-- Overtime Rules Modal -->
      ${showOvertimeRulesModal && currentProfile?.company_role === 'OWNER' ? `
        <div style="
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0,0,0,0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          padding: 1rem;
        " onclick="if (event.target === this) { showOvertimeRulesModal = false; renderPMTool(); }">
          <div style="
            background: white;
            border-radius: 1rem;
            padding: 2rem;
            max-width: 600px;
            width: 100%;
            max-height: 90vh;
            overflow-y: auto;
          " onclick="event.stopPropagation();">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1.5rem;">
              <h2 style="font-size: 1.5rem; font-weight: 700; color: #0f172a; margin: 0;">Overtime Rules</h2>
              <button
                onclick="showOvertimeRulesModal = false; renderPMTool();"
                style="
                  width: 32px;
                  height: 32px;
                  border: none;
                  background: #f1f5f9;
                  border-radius: 50%;
                  cursor: pointer;
                  font-size: 1.25rem;
                  color: #64748b;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >×</button>
            </div>
            
            <div style="display: flex; flex-direction: column; gap: 1.5rem;">
              <div>
                <label style="display: block; font-size: 0.875rem; font-weight: 600; color: #64748b; margin-bottom: 0.5rem;">Overtime Type</label>
                <select
                  onchange="overtimeRulesFormData.overtime_type = this.value;"
                  style="
                    width: 100%;
                    padding: 0.625rem;
                    border: 1px solid #e5e7eb;
                    border-radius: 0.5rem;
                    font-size: 0.875rem;
                  "
                >
                  <option value="WEEKLY" ${overtimeRulesFormData.overtime_type === 'WEEKLY' ? 'selected' : ''}>Weekly</option>
                  <option value="DAILY" ${overtimeRulesFormData.overtime_type === 'DAILY' ? 'selected' : ''}>Daily</option>
                  <option value="BOTH" ${overtimeRulesFormData.overtime_type === 'BOTH' ? 'selected' : ''}>Both</option>
                </select>
              </div>
              
              <div>
                <label style="display: block; font-size: 0.875rem; font-weight: 600; color: #64748b; margin-bottom: 0.5rem;">Weekly Threshold (hours)</label>
                <input
                  type="number"
                  step="0.1"
                  min="0"
                  value="${overtimeRulesFormData.weekly_threshold_hours}"
                  onchange="overtimeRulesFormData.weekly_threshold_hours = parseFloat(this.value) || 40;"
                  style="
                    width: 100%;
                    padding: 0.625rem;
                    border: 1px solid #e5e7eb;
                    border-radius: 0.5rem;
                    font-size: 0.875rem;
                  "
                />
              </div>
              
              <div>
                <label style="display: block; font-size: 0.875rem; font-weight: 600; color: #64748b; margin-bottom: 0.5rem;">Daily Threshold (hours)</label>
                <input
                  type="number"
                  step="0.1"
                  min="0"
                  value="${overtimeRulesFormData.daily_threshold_hours}"
                  onchange="overtimeRulesFormData.daily_threshold_hours = parseFloat(this.value) || 8;"
                  style="
                    width: 100%;
                    padding: 0.625rem;
                    border: 1px solid #e5e7eb;
                    border-radius: 0.5rem;
                    font-size: 0.875rem;
                  "
                />
              </div>
              
              <div>
                <label style="display: block; font-size: 0.875rem; font-weight: 600; color: #64748b; margin-bottom: 0.5rem;">Overtime Multiplier</label>
                <input
                  type="number"
                  step="0.1"
                  min="1"
                  value="${overtimeRulesFormData.overtime_multiplier}"
                  onchange="overtimeRulesFormData.overtime_multiplier = parseFloat(this.value) || 1.5;"
                  style="
                    width: 100%;
                    padding: 0.625rem;
                    border: 1px solid #e5e7eb;
                    border-radius: 0.5rem;
                    font-size: 0.875rem;
                  "
                />
              </div>
              
              <div>
                <label style="display: block; font-size: 0.875rem; font-weight: 600; color: #64748b; margin-bottom: 0.5rem;">Double Time Threshold (hours, optional)</label>
                <input
                  type="number"
                  step="0.1"
                  min="0"
                  value="${overtimeRulesFormData.double_time_threshold || ''}"
                  onchange="overtimeRulesFormData.double_time_threshold = this.value ? parseFloat(this.value) : null;"
                  placeholder="Leave empty to disable"
                  style="
                    width: 100%;
                    padding: 0.625rem;
                    border: 1px solid #e5e7eb;
                    border-radius: 0.5rem;
                    font-size: 0.875rem;
                  "
                />
              </div>
              
              <div>
                <label style="display: block; font-size: 0.875rem; font-weight: 600; color: #64748b; margin-bottom: 0.5rem;">Double Time Multiplier</label>
                <input
                  type="number"
                  step="0.1"
                  min="1"
                  value="${overtimeRulesFormData.double_time_multiplier}"
                  onchange="overtimeRulesFormData.double_time_multiplier = parseFloat(this.value) || 2.0;"
                  style="
                    width: 100%;
                    padding: 0.625rem;
                    border: 1px solid #e5e7eb;
                    border-radius: 0.5rem;
                    font-size: 0.875rem;
                  "
                />
              </div>
              
              <div style="display: flex; gap: 0.75rem; margin-top: 0.5rem;">
                <button
                  onclick="saveOvertimeRules();"
                  style="
                    flex: 1;
                    padding: 0.75rem;
                    background: #10b981;
                    color: white;
                    border: none;
                    border-radius: 0.5rem;
                    font-weight: 600;
                    cursor: pointer;
                  "
                  onmouseover="this.style.background='#059669'"
                  onmouseout="this.style.background='#10b981'"
                >
                  Save Rules
                </button>
                <button
                  onclick="showOvertimeRulesModal = false; renderPMTool();"
                  style="
                    flex: 1;
                    padding: 0.75rem;
                    background: #f1f5f9;
                    color: #64748b;
                    border: none;
                    border-radius: 0.5rem;
                    font-weight: 600;
                    cursor: pointer;
                  "
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      ` : ''}
      
      <style>
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      </style>
    </div>
  `;
}

// Load company employees for filters
async function loadCompanyEmployees() {
  // #region agent log
  fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:17774', message: 'loadCompanyEmployees ENTRY', data: { companyEmployeesIsNull: companyEmployees === null, companyEmployeesLoading, companyEmployeesLength: companyEmployees?.length, hasCompany: !!currentCompany?.id }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'C' }) }).catch(() => { });
  // #endregion
  if (!currentCompany?.id) {
    // #region agent log
    fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:17776', message: 'loadCompanyEmployees EARLY RETURN - no company', data: { companyEmployeesIsNull: companyEmployees === null }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'C' }) }).catch(() => { });
    // #endregion
    companyEmployees = [];
    return;
  }

  // Prevent multiple simultaneous loads
  if (companyEmployeesLoading) {
    // #region agent log
    fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:17782', message: 'loadCompanyEmployees EARLY RETURN - already loading', data: { companyEmployeesIsNull: companyEmployees === null, companyEmployeesLoading }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'E' }) }).catch(() => { });
    // #endregion
    console.log('⏳ [Company Employees] Already loading, skipping...');
    return;
  }

  // If already loaded, don't reload
  if (companyEmployees !== null) {
    // #region agent log
    fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:17788', message: 'loadCompanyEmployees EARLY RETURN - already loaded', data: { companyEmployeesIsNull: companyEmployees === null, companyEmployeesLength: companyEmployees?.length }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'C' }) }).catch(() => { });
    // #endregion
    console.log('✅ [Company Employees] Already loaded, skipping...');
    return;
  }

  companyEmployeesLoading = true;
  // #region agent log
  fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:17792', message: 'loadCompanyEmployees SET loading=true', data: { companyEmployeesIsNull: companyEmployees === null, companyEmployeesLoading }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'C' }) }).catch(() => { });
  // #endregion

  try {
    const { data, error } = await supabase
      .from('company_members')
      .select(`
        user_id,
        role,
        profiles!company_members_user_id_fkey (
          id,
          first_name,
          last_name,
          email
        )
      `)
      .eq('company_id', currentCompany.id)
      .in('role', ['OWNER', 'MANAGER', 'EMPLOYEE']);

    if (error) {
      // #region agent log
      fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:17810', message: 'loadCompanyEmployees ERROR from supabase', data: { error: error.message, companyEmployeesIsNull: companyEmployees === null }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'C' }) }).catch(() => { });
      // #endregion
      console.error('Error loading company employees:', error);
      companyEmployees = [];
      // #region agent log
      fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:17813', message: 'loadCompanyEmployees SET to [] on error', data: { companyEmployeesIsNull: companyEmployees === null, companyEmployeesLength: companyEmployees?.length }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'C' }) }).catch(() => { });
      // #endregion
      return;
    }

    companyEmployees = (data || [])
      .filter(item => item.profiles && item.role && ['OWNER', 'MANAGER', 'EMPLOYEE'].includes(item.role))
      .map(item => ({
        id: item.profiles.id,
        name: `${item.profiles.first_name || ''} ${item.profiles.last_name || ''}`.trim() || item.profiles.email,
        role: item.role
      }));

    // #region agent log
    fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:17824', message: 'loadCompanyEmployees SUCCESS', data: { companyEmployeesIsNull: companyEmployees === null, companyEmployeesLength: companyEmployees?.length, companyEmployeesIsArray: Array.isArray(companyEmployees) }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'C' }) }).catch(() => { });
    // #endregion
    console.log('✅ [Company Employees] Loaded:', companyEmployees.length);

    // Only trigger re-render if we're on a view that needs it AND not already rendering
    // This prevents infinite loops - the render will happen naturally when needed
  } catch (error) {
    // #region agent log
    fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:17830', message: 'loadCompanyEmployees CATCH ERROR', data: { error: error.message, companyEmployeesIsNull: companyEmployees === null }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'C' }) }).catch(() => { });
    // #endregion
    console.error('Error loading company employees:', error);
    companyEmployees = [];
    // #region agent log
    fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:17833', message: 'loadCompanyEmployees SET to [] in catch', data: { companyEmployeesIsNull: companyEmployees === null, companyEmployeesLength: companyEmployees?.length }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'C' }) }).catch(() => { });
    // #endregion
  } finally {
    companyEmployeesLoading = false;
    // #region agent log
    fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:17836', message: 'loadCompanyEmployees FINALLY - set loading=false', data: { companyEmployeesIsNull: companyEmployees === null, companyEmployeesLoading, companyEmployeesLength: companyEmployees?.length }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'C' }) }).catch(() => { });
    // #endregion
  }
}

// Load overtime rules
window.loadOvertimeRules = async function () {
  if (!currentCompany?.id) return;

  try {
    // Use maybeSingle() instead of single() to avoid 406 errors when no rows exist
    const { data, error } = await supabase
      .from('overtime_rules')
      .select('*')
      .eq('company_id', currentCompany.id)
      .maybeSingle();

    // Silently handle all errors - don't log anything
    if (error) {
      overtimeRules = null;
      return;
    }

    if (data) {
      overtimeRules = data;
      overtimeRulesFormData = {
        overtime_type: data.overtime_type || 'WEEKLY',
        weekly_threshold_hours: data.weekly_threshold_hours || 40,
        daily_threshold_hours: data.daily_threshold_hours || 8,
        overtime_multiplier: data.overtime_multiplier || 1.5,
        double_time_threshold: data.double_time_threshold,
        double_time_multiplier: data.double_time_multiplier || 2.0
      };
    } else {
      overtimeRules = null;
    }
  } catch (error) {
    // Silently handle errors - completely suppress
    overtimeRules = null;
  }
};

// Sort timesheet entries
window.sortTimesheet = function (column) {
  if (timesheetSortColumn === column) {
    timesheetSortDirection = timesheetSortDirection === 'asc' ? 'desc' : 'asc';
  } else {
    timesheetSortColumn = column;
    timesheetSortDirection = 'asc';
  }

  timeEntries.sort((a, b) => {
    let aVal, bVal;

    switch (column) {
      case 'clock_in_at':
        aVal = new Date(a.clock_in_at);
        bVal = new Date(b.clock_in_at);
        break;
      case 'clock_out_at':
        aVal = a.clock_out_at ? new Date(a.clock_out_at) : new Date(0);
        bVal = b.clock_out_at ? new Date(b.clock_out_at) : new Date(0);
        break;
      case 'total_hours':
        aVal = a.total_hours || 0;
        bVal = b.total_hours || 0;
        break;
      case 'regular_hours':
        aVal = a.regular_hours || 0;
        bVal = b.regular_hours || 0;
        break;
      case 'overtime_hours':
        aVal = a.overtime_hours || 0;
        bVal = b.overtime_hours || 0;
        break;
      default:
        return 0;
    }

    if (timesheetSortDirection === 'asc') {
      return aVal > bVal ? 1 : aVal < bVal ? -1 : 0;
    } else {
      return aVal < bVal ? 1 : aVal > bVal ? -1 : 0;
    }
  });

  renderPMTool();
};

// Calculate break duration
function calculateBreakDuration(entry) {
  if (!entry.break_start_at || !entry.break_end_at) return 0;
  const start = new Date(entry.break_start_at);
  const end = new Date(entry.break_end_at);
  return (end - start) / (1000 * 60 * 60); // Convert to hours
}

// Render Timesheet View (Full Implementation)
function renderTimesheetView() {
  // #region agent log
  fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:17929', message: 'renderTimesheetView ENTRY', data: { companyEmployeesIsNull: companyEmployees === null, companyEmployeesLoading, companyEmployeesLength: companyEmployees?.length, companyEmployeesIsArray: Array.isArray(companyEmployees), companyEmployeesType: typeof companyEmployees }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'D' }) }).catch(() => { });
  // #endregion
  const isOwner = currentProfile?.company_role === 'OWNER';
  const isManager = currentProfile?.company_role === 'MANAGER';
  const canViewOthers = isOwner || isManager;

  // Safety check: if companyEmployees is null (still loading or error), show loading state
  // This prevents crashes when trying to use .find() or .map() on null
  if (companyEmployees === null) {
    // #region agent log
    fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:17936', message: 'renderTimesheetView RETURNING loading state', data: { companyEmployeesIsNull: companyEmployees === null, companyEmployeesLoading }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'D' }) }).catch(() => { });
    // #endregion
    return `
      <div style="max-width: 1400px; margin: 0 auto; padding: 1.5rem;">
        <div style="text-align: center; padding: 3rem;">
          <div style="font-size: 1.125rem; color: #64748b; margin-bottom: 1rem;">Loading timesheet...</div>
          <div style="font-size: 0.875rem; color: #9ca3af;">Please wait while we load the data.</div>
        </div>
      </div>
    `;
  }

  // #region agent log
  fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:17947', message: 'renderTimesheetView BEFORE find()', data: { companyEmployeesIsNull: companyEmployees === null, companyEmployeesLength: companyEmployees?.length, companyEmployeesIsArray: Array.isArray(companyEmployees) }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'D' }) }).catch(() => { });
  // #endregion
  const selectedEmployee = companyEmployees && companyEmployees.length > 0
    ? companyEmployees.find(e => e.id === hourlyRateFormData.employeeId)
    : null;
  // #region agent log
  fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:17950', message: 'renderTimesheetView AFTER find()', data: { selectedEmployee: !!selectedEmployee }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'D' }) }).catch(() => { });
  // #endregion

  // Calculate totals
  const totals = timeEntries.reduce((acc, entry) => {
    acc.total += entry.total_hours || 0;
    acc.regular += entry.regular_hours || 0;
    acc.overtime += entry.overtime_hours || 0;
    return acc;
  }, { total: 0, regular: 0, overtime: 0 });

  // Calculate estimated pay - use rate for selected employee or entry's employee
  let estimatedPay = 0;
  if (timesheetPayData && timesheetPayData.total_pay) {
    estimatedPay = parseFloat(timesheetPayData.total_pay);
  } else {
    // Use pay data from database function which now calculates correctly per entry date
    // Fallback: Get hourly rate for the selected employee (use latest rate for estimate)
    if (!estimatedPay) {
      const targetEmployeeId = hourlyRateFormData.employeeId || (timeEntries.length > 0 ? timeEntries[0].user_id : null);
      const employeeRateData = targetEmployeeId ? (employeeHourlyRates[targetEmployeeId] || null) : null;
      const employeeRate = employeeRateData ?
        (typeof employeeRateData === 'number' ? employeeRateData : employeeRateData.latest) :
        null;
      if (employeeRate) {
        estimatedPay = totals.regular * employeeRate + (totals.overtime * employeeRate * (overtimeRules?.overtime_multiplier || 1.5));
      }
    }
  }

  return `
    <div style="max-width: 1400px; margin: 0 auto; padding: 1.5rem;">
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 2rem; flex-wrap: wrap; gap: 1rem;">
        <h1 style="font-size: 2rem; font-weight: 700; color: #0f172a; margin: 0;">Timesheet</h1>
        <div style="display: flex; gap: 0.75rem; flex-wrap: wrap;">
          ${isOwner ? `
              <button
              onclick="window.exportTimesheet();"
              style="
                padding: 0.75rem 1.25rem;
                background: #f59e0b;
                color: white;
                border: none;
                border-radius: 0.5rem;
                font-weight: 600;
                cursor: pointer;
                font-size: 0.875rem;
              "
              onmouseover="this.style.background='#d97706'"
              onmouseout="this.style.background='#f59e0b'"
            >
              Export CSV
            </button>
          ` : ''}
          <button
            onclick="switchTimeTrackingView('main');"
            style="
              padding: 0.75rem 1.25rem;
              background: #f8f9fa;
              border: 1px solid #e5e7eb;
              border-radius: 0.5rem;
              color: #64748b;
              font-weight: 600;
              cursor: pointer;
            "
          >
            Back
          </button>
        </div>
      </div>
      
      <!-- Filters -->
      <div style="
        background: #ffffff;
        border-radius: 1rem;
        padding: 1.5rem;
        margin-bottom: 2rem;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
      ">
        <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem;">
          <!-- Date Range -->
          <div>
            <label style="display: block; font-size: 0.875rem; font-weight: 600; color: #64748b; margin-bottom: 0.5rem;">Start Date</label>
            <input
              type="date"
              value="${formatDateForInput(timesheetStartDate)}"
              onchange="setTimesheetStartDate(this.value);"
              style="
                width: 100%;
                padding: 0.625rem;
                border: 1px solid #e5e7eb;
                border-radius: 0.5rem;
                font-size: 0.875rem;
              "
            />
          </div>
          <div>
            <label style="display: block; font-size: 0.875rem; font-weight: 600; color: #64748b; margin-bottom: 0.5rem;">End Date</label>
            <input
              type="date"
              value="${formatDateForInput(timesheetEndDate)}"
              onchange="setTimesheetEndDate(this.value);"
              style="
                width: 100%;
                padding: 0.625rem;
                border: 1px solid #e5e7eb;
                border-radius: 0.5rem;
                font-size: 0.875rem;
              "
            />
          </div>
          
          <!-- Employee Filter (OWNER/MANAGER only) -->
          ${canViewOthers ? `
            <div>
              <label style="display: block; font-size: 0.875rem; font-weight: 600; color: #64748b; margin-bottom: 0.5rem;">Employee</label>
              <select
                onchange="window.hourlyRateFormData.employeeId = this.value ? this.value : null; hourlyRateFormData.employeeId = this.value ? this.value : null;"
                style="
                  width: 100%;
                  padding: 0.625rem;
                  border: 1px solid #e5e7eb;
                  border-radius: 0.5rem;
                  font-size: 0.875rem;
                "
              >
                <option value="">All Employees</option>
                ${companyEmployees === null ? '<option value="" disabled>Loading employees...</option>' : companyEmployees.length > 0 ? companyEmployees.map(emp => `
                  <option value="${emp.id}" ${window.hourlyRateFormData?.employeeId === emp.id ? 'selected' : ''}>${emp.name}</option>
                `).join('') : '<option value="" disabled>No employees found</option>'}
              </select>
            </div>
          ` : ''}
          
          <!-- Pay Period -->
          <div>
            <label style="display: block; font-size: 0.875rem; font-weight: 600; color: #64748b; margin-bottom: 0.5rem;">Pay Period</label>
            <select
              id="timesheet-pay-period-select"
              onchange="timesheetPayPeriod = this.value;"
              style="
                width: 100%;
                padding: 0.625rem;
                border: 1px solid #e5e7eb;
                border-radius: 0.5rem;
                font-size: 0.875rem;
              "
            >
              <option value="bi-monthly-1" ${timesheetPayPeriod === 'bi-monthly-1' ? 'selected' : ''}>1st - 15th</option>
              <option value="bi-monthly-2" ${timesheetPayPeriod === 'bi-monthly-2' ? 'selected' : ''}>16th - End</option>
              <option value="monthly" ${timesheetPayPeriod === 'monthly' ? 'selected' : ''}>Monthly</option>
            </select>
          </div>
        </div>
        <div style="margin-top: 1rem; display: flex; justify-content: flex-end;">
          <button
            onclick="window.generateTimesheet();"
            style="
              padding: 0.75rem 1.5rem;
              background: #f59e0b;
              color: white;
              border: none;
              border-radius: 0.5rem;
              font-weight: 600;
              cursor: pointer;
              font-size: 0.875rem;
            "
            onmouseover="this.style.background='#d97706'"
            onmouseout="this.style.background='#f59e0b'"
          >
            Generate
          </button>
        </div>
      </div>
      
      <!-- Pay Summary -->
      ${estimatedPay > 0 ? `
        <div style="
          background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
          border-radius: 1rem;
          padding: 1.5rem;
          margin-bottom: 2rem;
          color: white;
        ">
          <div style="font-size: 0.875rem; opacity: 0.9; margin-bottom: 0.5rem;">Estimated Pay</div>
          <div style="font-size: 2rem; font-weight: 700;">$${estimatedPay.toFixed(2)}</div>
          ${timesheetPayData ? `
            <div style="font-size: 0.75rem; opacity: 0.8; margin-top: 0.5rem;">
              Regular: $${(timesheetPayData.regular_pay || 0).toFixed(2)} | 
              Overtime: $${(timesheetPayData.overtime_pay || 0).toFixed(2)}
            </div>
          ` : ''}
        </div>
      ` : ''}
      
      <!-- Timesheet Table -->
      <div style="
        background: #ffffff;
        border-radius: 1rem;
        padding: 1.5rem;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        overflow-x: auto;
      ">
        ${timeEntries.length === 0 ? `
          <div style="text-align: center; padding: 3rem; color: #64748b;">
            <p>No time entries found for the selected period.</p>
          </div>
        ` : `
          <table style="width: 100%; border-collapse: collapse; min-width: 1000px;">
            <thead>
              <tr style="border-bottom: 2px solid #e5e7eb;">
                ${canViewOthers ? `
                  <th style="padding: 0.75rem; text-align: left; font-weight: 600; color: #64748b; font-size: 0.875rem;">Employee</th>
                ` : ''}
                <th style="padding: 0.75rem; text-align: left; font-weight: 600; color: #64748b; font-size: 0.875rem; cursor: pointer;" onclick="sortTimesheet('clock_in_at')">
                  Date ${timesheetSortColumn === 'clock_in_at' ? (timesheetSortDirection === 'asc' ? '↑' : '↓') : ''}
                </th>
                <th style="padding: 0.75rem; text-align: left; font-weight: 600; color: #64748b; font-size: 0.875rem; cursor: pointer;" onclick="sortTimesheet('clock_in_at')">
                  Clock In ${timesheetSortColumn === 'clock_in_at' ? (timesheetSortDirection === 'asc' ? '↑' : '↓') : ''}
                </th>
                <th style="padding: 0.75rem; text-align: left; font-weight: 600; color: #64748b; font-size: 0.875rem; cursor: pointer;" onclick="sortTimesheet('clock_out_at')">
                  Clock Out ${timesheetSortColumn === 'clock_out_at' ? (timesheetSortDirection === 'asc' ? '↑' : '↓') : ''}
                </th>
                <th style="padding: 0.75rem; text-align: left; font-weight: 600; color: #64748b; font-size: 0.875rem;">Break</th>
                <th style="padding: 0.75rem; text-align: left; font-weight: 600; color: #64748b; font-size: 0.875rem; cursor: pointer;" onclick="sortTimesheet('total_hours')">
                  Total Hours ${timesheetSortColumn === 'total_hours' ? (timesheetSortDirection === 'asc' ? '↑' : '↓') : ''}
                </th>
                <th style="padding: 0.75rem; text-align: left; font-weight: 600; color: #64748b; font-size: 0.875rem; cursor: pointer;" onclick="sortTimesheet('regular_hours')">
                  Regular ${timesheetSortColumn === 'regular_hours' ? (timesheetSortDirection === 'asc' ? '↑' : '↓') : ''}
                </th>
                <th style="padding: 0.75rem; text-align: left; font-weight: 600; color: #64748b; font-size: 0.875rem; cursor: pointer;" onclick="sortTimesheet('overtime_hours')">
                  Overtime ${timesheetSortColumn === 'overtime_hours' ? (timesheetSortDirection === 'asc' ? '↑' : '↓') : ''}
                </th>
                <th style="padding: 0.75rem; text-align: left; font-weight: 600; color: #64748b; font-size: 0.875rem;">Pay</th>
                <th style="padding: 0.75rem; text-align: left; font-weight: 600; color: #64748b; font-size: 0.875rem;">Clock In Location</th>
                <th style="padding: 0.75rem; text-align: left; font-weight: 600; color: #64748b; font-size: 0.875rem;">Clock Out Location</th>
              </tr>
            </thead>
            <tbody>
              ${timeEntries.map(entry => {
    const date = new Date(entry.clock_in_at);
    const breakDuration = calculateBreakDuration(entry);
    // Get hourly rate for this specific entry's date
    const entryDate = new Date(entry.clock_in_at);
    const entryEmployeeRate = window.getRateForDate ? window.getRateForDate(entry.user_id, entryDate) :
      (typeof employeeHourlyRates[entry.user_id] === 'number' ? employeeHourlyRates[entry.user_id] :
        (employeeHourlyRates[entry.user_id]?.latest || null));
    const entryPay = (entry.regular_hours || 0) * (entryEmployeeRate || 0) +
      (entry.overtime_hours || 0) * (entryEmployeeRate || 0) * (overtimeRules?.overtime_multiplier || 1.5);
    const clockInLoc = entry.clock_in_location?.address || '';
    const clockOutLoc = entry.clock_out_location?.address || '';
    const employeeName = entry.profiles
      ? `${entry.profiles.first_name || ''} ${entry.profiles.last_name || ''}`.trim() || entry.profiles.email
      : 'Unknown';

    return `
                  <tr style="border-bottom: 1px solid #f1f5f9;">
                    ${canViewOthers ? `
                      <td style="padding: 0.75rem; color: #0f172a; font-weight: 500;">${employeeName}</td>
                    ` : ''}
                    <td style="padding: 0.75rem; color: #0f172a;">${date.toLocaleDateString()}</td>
                    <td style="padding: 0.75rem; color: #0f172a;">
                      ${formatTime(entry.clock_in_at)}
                    </td>
                    <td style="padding: 0.75rem; color: #0f172a;">
                      ${entry.clock_out_at ? formatTime(entry.clock_out_at) : '-'}
                    </td>
                    <td style="padding: 0.75rem; color: #0f172a;">
                      ${breakDuration > 0 ? formatHours(breakDuration) : '-'}
                    </td>
                    <td style="padding: 0.75rem; color: #0f172a; font-weight: 600;">${formatHours(entry.total_hours || 0)}</td>
                    <td style="padding: 0.75rem; color: #0f172a;">${formatHours(entry.regular_hours || 0)}</td>
                    <td style="padding: 0.75rem; color: #ef4444;">${formatHours(entry.overtime_hours || 0)}</td>
                    <td style="padding: 0.75rem; color: #10b981; font-weight: 600;">$${entryPay.toFixed(2)}</td>
                    <td style="padding: 0.75rem; color: #64748b; font-size: 0.875rem;">
                      ${clockInLoc ? `<span title="${clockInLoc}">📍 ${clockInLoc.length > 30 ? clockInLoc.substring(0, 30) + '...' : clockInLoc}</span>` : '-'}
                    </td>
                    <td style="padding: 0.75rem; color: #64748b; font-size: 0.875rem;">
                      ${clockOutLoc ? `<span title="${clockOutLoc}">📍 ${clockOutLoc.length > 30 ? clockOutLoc.substring(0, 30) + '...' : clockOutLoc}</span>` : '-'}
                    </td>
                  </tr>
                `;
  }).join('')}
              <!-- Totals Row -->
              <tr style="border-top: 2px solid #e5e7eb; background: #f8f9fa; font-weight: 600;">
                ${canViewOthers ? `<td style="padding: 0.75rem; color: #0f172a;">Total</td>` : ''}
                <td style="padding: 0.75rem; color: #0f172a;">Total</td>
                <td style="padding: 0.75rem;"></td>
                <td style="padding: 0.75rem;"></td>
                <td style="padding: 0.75rem;"></td>
                <td style="padding: 0.75rem; color: #0f172a;">${formatHours(totals.total)}</td>
                <td style="padding: 0.75rem; color: #0f172a;">${formatHours(totals.regular)}</td>
                <td style="padding: 0.75rem; color: #ef4444;">${formatHours(totals.overtime)}</td>
                <td style="padding: 0.75rem; color: #10b981;">$${estimatedPay.toFixed(2)}</td>
                <td style="padding: 0.75rem;"></td>
                <td style="padding: 0.75rem;"></td>
              </tr>
            </tbody>
          </table>
        `}
      </div>
    </div>
  `;
}

// Render Hourly Rate View (Full Implementation)
function renderHourlyRateView() {
  const isOwner = currentProfile?.company_role === 'OWNER';
  const isManager = currentProfile?.company_role === 'MANAGER';
  const canViewOthers = isOwner || isManager;

  // If employee (not OWNER/MANAGER), ensure they only see their own data
  if (!canViewOthers) {
    hourlyRateFormData.employeeId = currentProfile.id;
    window.hourlyRateFormData.employeeId = currentProfile.id;
  }

  const selectedEmployee = (companyEmployees && companyEmployees.length > 0)
    ? companyEmployees.find(e => e.id === (window.hourlyRateFormData?.employeeId || hourlyRateFormData.employeeId)) || null
    : (!canViewOthers ? { id: currentProfile.id, name: `${currentProfile.first_name || ''} ${currentProfile.last_name || ''}`.trim() || currentProfile.email } : null);

  return `
    <div style="max-width: 1200px; margin: 0 auto; padding: 1.5rem;">
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 2rem; flex-wrap: wrap; gap: 1rem;">
        <h1 style="font-size: 2rem; font-weight: 700; color: #0f172a; margin: 0;">Hourly Rates</h1>
        <button
          onclick="switchTimeTrackingView('main');"
          style="
            padding: 0.75rem 1.25rem;
            background: #f8f9fa;
            border: 1px solid #e5e7eb;
            border-radius: 0.5rem;
            color: #64748b;
            font-weight: 600;
            cursor: pointer;
          "
        >
          Back
        </button>
      </div>
      
      <!-- Set Hourly Rate Form -->
      <div style="
        background: #ffffff;
        border-radius: 1rem;
        padding: 1.5rem;
        margin-bottom: 2rem;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
      ">
        <h2 style="font-size: 1.25rem; font-weight: 600; color: #0f172a; margin: 0 0 1.5rem 0;">
          ${selectedEmployee && currentHourlyRate ? `Change Rate for ${selectedEmployee.name}` : selectedEmployee ? `Set Rate for ${selectedEmployee.name}` : 'Set Hourly Rate'}
        </h2>
        
        <div style="margin-bottom: 1rem;">
          <label style="display: block; font-size: 0.875rem; font-weight: 600; color: #64748b; margin-bottom: 0.5rem;">Employee</label>
          <select
            onchange="window.hourlyRateFormData.employeeId = this.value ? this.value : null; hourlyRateFormData.employeeId = this.value ? this.value : null; hourlyRateFormData.rate = '0'; window.hourlyRateFormData.rate = '0'; window.loadHourlyRates().then(() => { const hourlyRateSection = document.querySelector('[data-hourly-rate-section]'); if (hourlyRateSection) { hourlyRateSection.outerHTML = renderHourlyRateView(); } else { renderPMTool(); } });"
            style="
              width: 100%;
              padding: 0.625rem;
              border: 1px solid #e5e7eb;
              border-radius: 0.5rem;
              font-size: 0.875rem;
            "
          >
            ${canViewOthers ? `
              <option value="" ${!hourlyRateFormData.employeeId && !window.hourlyRateFormData?.employeeId ? 'selected' : ''}>Select Employee</option>
              ${companyEmployees === null ? '<option value="" disabled>Loading employees...</option>' : companyEmployees.length > 0 ? companyEmployees.map(emp => `
                <option value="${emp.id}" ${(window.hourlyRateFormData?.employeeId || hourlyRateFormData.employeeId) === emp.id ? 'selected' : ''}>${emp.name}</option>
              `).join('') : '<option value="" disabled>No employees found</option>'}
            ` : `
              <option value="${currentProfile.id}" selected>${`${currentProfile.first_name || ''} ${currentProfile.last_name || ''}`.trim() || currentProfile.email}</option>
            `}
          </select>
        </div>
        
        <div style="display: grid; grid-template-columns: 1fr auto; gap: 1rem; align-items: end;">
          <div>
            <label style="display: block; font-size: 0.875rem; font-weight: 600; color: #64748b; margin-bottom: 0.5rem;">Hourly Rate ($)</label>
            <input
              type="number"
              step="0.01"
              min="0"
              value="${hourlyRateFormData.rate || '0'}"
              onchange="window.hourlyRateFormData.rate = this.value; hourlyRateFormData.rate = this.value;"
              placeholder="0.00"
              id="hourly-rate-input"
              style="
                width: 100%;
                padding: 0.625rem;
                border: 1px solid #e5e7eb;
                border-radius: 0.5rem;
                font-size: 1rem;
              "
            />
          </div>
          <button
            onclick="saveHourlyRate();"
            style="
              padding: 0.625rem 1.5rem;
              background: #f59e0b;
              color: white;
              border: none;
              border-radius: 0.5rem;
              font-weight: 600;
              cursor: pointer;
              white-space: nowrap;
              transition: background 0.2s;
            "
            onmouseover="this.style.background='#d97706'"
            onmouseout="this.style.background='#f59e0b'"
          >
            ${selectedEmployee && currentHourlyRate ? 'Change Rate' : 'Save Rate'}
          </button>
        </div>
        
        ${selectedEmployee && currentHourlyRate ? `
          <div style="margin-top: 1.5rem; padding: 1.25rem; background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%); border: 2px solid #10b981; border-radius: 0.75rem; box-shadow: 0 2px 4px rgba(16, 185, 129, 0.1);">
            <div style="display: flex; align-items: center; gap: 0.75rem; margin-bottom: 0.5rem;">
              <div style="width: 8px; height: 8px; background: #10b981; border-radius: 50%;"></div>
              <div style="font-size: 0.875rem; font-weight: 600; color: #059669; text-transform: uppercase; letter-spacing: 0.05em;">
                Current Rate
              </div>
            </div>
            <div style="font-size: 2rem; font-weight: 700; color: #0f172a; line-height: 1.2;">
              $${parseFloat(currentHourlyRate).toFixed(2)}<span style="font-size: 1rem; font-weight: 500; color: #64748b;">/hr</span>
            </div>
            ${selectedEmployee ? `
              <div style="font-size: 0.875rem; color: #64748b; margin-top: 0.5rem;">
                for ${selectedEmployee.name}
              </div>
            ` : ''}
          </div>
        ` : ''}
      </div>
      
      <!-- Rate History -->
      <div style="
        background: #ffffff;
        border-radius: 1rem;
        padding: 1.5rem;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
      ">
        <h2 style="font-size: 1.25rem; font-weight: 600; color: #0f172a; margin: 0 0 1.5rem 0;">Rate History</h2>
        
        ${hourlyRates.length === 0 ? `
          <div style="text-align: center; padding: 2rem; color: #64748b;">
            <p>No rate history found.</p>
          </div>
        ` : `
          <table style="width: 100%; border-collapse: collapse;">
            <thead>
              <tr style="border-bottom: 2px solid #e5e7eb;">
                ${canViewOthers ? `
                  <th style="padding: 0.75rem; text-align: left; font-weight: 600; color: #64748b; font-size: 0.875rem;">Employee</th>
                ` : ''}
                <th style="padding: 0.75rem; text-align: left; font-weight: 600; color: #64748b; font-size: 0.875rem;">Effective Date</th>
                <th style="padding: 0.75rem; text-align: left; font-weight: 600; color: #64748b; font-size: 0.875rem;">Hourly Rate</th>
                <th style="padding: 0.75rem; text-align: left; font-weight: 600; color: #64748b; font-size: 0.875rem;">Set By</th>
              </tr>
            </thead>
            <tbody>
              ${hourlyRates.map(rate => {
    const effectiveDate = new Date(rate.effective_date);
    const employeeName = rate.profiles
      ? `${rate.profiles.first_name || ''} ${rate.profiles.last_name || ''}`.trim() || rate.profiles.email
      : 'Unknown';
    return `
                  <tr style="border-bottom: 1px solid #f1f5f9;">
                    ${canViewOthers ? `
                      <td style="padding: 0.75rem; color: #0f172a; font-weight: 500;">${employeeName}</td>
                    ` : ''}
                    <td style="padding: 0.75rem; color: #0f172a;">${effectiveDate.toLocaleDateString()}</td>
                    <td style="padding: 0.75rem; color: #0f172a; font-weight: 600;">$${parseFloat(rate.hourly_rate).toFixed(2)}/hr</td>
                    <td style="padding: 0.75rem; color: #64748b; font-size: 0.875rem;">
                      ${rate.created_by === currentProfile?.id ? 'You' : 'Manager'}
                    </td>
                  </tr>
                `;
  }).join('')}
            </tbody>
          </table>
        `}
      </div>
    </div>
  `;
}

// Render Time Off View (Full Implementation)
function renderTimeOffView() {
  // #region agent log
  fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:18616', message: 'renderTimeOffView ENTRY', data: { companyEmployeesIsNull: companyEmployees === null, companyEmployeesLength: companyEmployees?.length, companyEmployeesIsArray: Array.isArray(companyEmployees), timeOffRequestsLength: timeOffRequests?.length, timeOffRequestsIsArray: Array.isArray(timeOffRequests) }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'D' }) }).catch(() => { });
  // #endregion
  // Sync showTimeOffRequestForm with window version
  if (window.showTimeOffRequestForm !== undefined) {
    showTimeOffRequestForm = window.showTimeOffRequestForm;
  } else {
    window.showTimeOffRequestForm = showTimeOffRequestForm;
  }

  // Sync timeOffApprovalData
  if (window.timeOffApprovalData) {
    timeOffApprovalData.rejectionReason = window.timeOffApprovalData.rejectionReason || timeOffApprovalData.rejectionReason;
  }

  const isOwner = currentProfile?.company_role === 'OWNER';
  const isManager = currentProfile?.company_role === 'MANAGER';
  const canApprove = isOwner || isManager;

  // If employee (not OWNER/MANAGER), set employeeId to current user
  if (!canApprove) {
    hourlyRateFormData.employeeId = currentProfile.id;
    window.hourlyRateFormData = window.hourlyRateFormData || {};
    window.hourlyRateFormData.employeeId = currentProfile.id;
  }

  const getStatusBadge = (status) => {
    const styles = {
      PENDING: { bg: '#fef3c7', color: '#92400e', text: 'Pending' },
      APPROVED: { bg: '#d1fae5', color: '#065f46', text: 'Approved' },
      REJECTED: { bg: '#fee2e2', color: '#991b1b', text: 'Rejected' }
    };
    const style = styles[status] || styles.PENDING;
    return `<span style="
      display: inline-block;
      padding: 0.25rem 0.75rem;
      background: ${style.bg};
      color: ${style.color};
      border-radius: 9999px;
      font-size: 0.75rem;
      font-weight: 600;
    ">${style.text}</span>`;
  };

  const getRequestTypeLabel = (type) => {
    const labels = {
      VACATION: 'Vacation',
      SICK: 'Sick Leave',
      PERSONAL: 'Personal',
      OTHER: 'Other'
    };
    return labels[type] || type;
  };

  // Make getRequestTypeLabel globally accessible for calendar
  if (!window.getRequestTypeLabel) {
    window.getRequestTypeLabel = getRequestTypeLabel;
  }

  return `
    <div style="max-width: 1200px; margin: 0 auto; padding: 1.5rem;">
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 2rem; flex-wrap: wrap; gap: 1rem;">
        <h1 style="font-size: 2rem; font-weight: 700; color: #0f172a; margin: 0;">Time Off</h1>
        <div style="display: flex; gap: 0.75rem;">
          <button
            onclick="showTimeOffRequestForm = true; window.showTimeOffRequestForm = true; console.log('📅 [Time Off] Request form button clicked, showTimeOffRequestForm:', showTimeOffRequestForm, 'window.showTimeOffRequestForm:', window.showTimeOffRequestForm); renderPMTool();"
            style="
              padding: 0.75rem 1.25rem;
              background: #f59e0b;
              color: white;
              border: none;
              border-radius: 0.5rem;
              font-weight: 600;
              cursor: pointer;
              font-size: 0.875rem;
            "
            onmouseover="this.style.background='#d97706'"
            onmouseout="this.style.background='#f59e0b'"
          >
            + Request Time Off
          </button>
          <button
            onclick="switchTimeTrackingView('main');"
            style="
              padding: 0.75rem 1.25rem;
              background: #f8f9fa;
              border: 1px solid #e5e7eb;
              border-radius: 0.5rem;
              color: #64748b;
              font-weight: 600;
              cursor: pointer;
            "
          >
            Back
          </button>
        </div>
      </div>
      
      <!-- Request Form Modal -->
      ${(showTimeOffRequestForm || window.showTimeOffRequestForm) ? `
        <div style="
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0,0,0,0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          padding: 1rem;
        " onclick="if (event.target === this) { showTimeOffRequestForm = false; window.showTimeOffRequestForm = false; renderPMTool(); }">
          <div style="
            background: white;
            border-radius: 1rem;
            padding: 2rem;
            max-width: 500px;
            width: 100%;
            max-height: 90vh;
            overflow-y: auto;
          " onclick="event.stopPropagation();">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1.5rem;">
              <h2 style="font-size: 1.5rem; font-weight: 700; color: #0f172a; margin: 0;">Request Time Off</h2>
              <button
                onclick="showTimeOffRequestForm = false; window.showTimeOffRequestForm = false; renderPMTool();"
                style="
                  width: 32px;
                  height: 32px;
                  border: none;
                  background: #f1f5f9;
                  border-radius: 50%;
                  cursor: pointer;
                  font-size: 1.25rem;
                  color: #64748b;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >×</button>
            </div>
            
            <div style="display: flex; flex-direction: column; gap: 1rem;">
              <div>
                <label style="display: block; font-size: 0.875rem; font-weight: 600; color: #64748b; margin-bottom: 0.5rem;">Start Date</label>
                <input
                  type="date"
                  value="${timeOffRequestFormData.startDate || ''}"
                  onchange="timeOffRequestFormData.startDate = this.value; window.timeOffRequestFormData = window.timeOffRequestFormData || {}; window.timeOffRequestFormData.startDate = this.value;"
                  style="
                    width: 100%;
                    padding: 0.625rem;
                    border: 1px solid #e5e7eb;
                    border-radius: 0.5rem;
                    font-size: 0.875rem;
                  "
                />
              </div>
              
              <div>
                <label style="display: block; font-size: 0.875rem; font-weight: 600; color: #64748b; margin-bottom: 0.5rem;">End Date</label>
                <input
                  type="date"
                  value="${timeOffRequestFormData.endDate || ''}"
                  onchange="timeOffRequestFormData.endDate = this.value; window.timeOffRequestFormData = window.timeOffRequestFormData || {}; window.timeOffRequestFormData.endDate = this.value;"
                  style="
                    width: 100%;
                    padding: 0.625rem;
                    border: 1px solid #e5e7eb;
                    border-radius: 0.5rem;
                    font-size: 0.875rem;
                  "
                />
              </div>
              
              <div>
                <label style="display: block; font-size: 0.875rem; font-weight: 600; color: #64748b; margin-bottom: 0.5rem;">Type</label>
                <select
                  onchange="timeOffRequestFormData.requestType = this.value; window.timeOffRequestFormData = window.timeOffRequestFormData || {}; window.timeOffRequestFormData.requestType = this.value;"
                  style="
                    width: 100%;
                    padding: 0.625rem;
                    border: 1px solid #e5e7eb;
                    border-radius: 0.5rem;
                    font-size: 0.875rem;
                  "
                >
                  <option value="VACATION" ${timeOffRequestFormData.requestType === 'VACATION' ? 'selected' : ''}>Vacation</option>
                  <option value="SICK" ${timeOffRequestFormData.requestType === 'SICK' ? 'selected' : ''}>Sick Leave</option>
                  <option value="PERSONAL" ${timeOffRequestFormData.requestType === 'PERSONAL' ? 'selected' : ''}>Personal</option>
                  <option value="OTHER" ${timeOffRequestFormData.requestType === 'OTHER' ? 'selected' : ''}>Other</option>
                </select>
              </div>
              
              <div>
                <label style="display: block; font-size: 0.875rem; font-weight: 600; color: #64748b; margin-bottom: 0.5rem;">Reason (Optional)</label>
                <textarea
                  onchange="timeOffRequestFormData.reason = this.value; window.timeOffRequestFormData = window.timeOffRequestFormData || {}; window.timeOffRequestFormData.reason = this.value;"
                  placeholder="Enter reason for time off request..."
                  rows="4"
                  style="
                    width: 100%;
                    padding: 0.625rem;
                    border: 1px solid #e5e7eb;
                    border-radius: 0.5rem;
                    font-size: 0.875rem;
                    font-family: inherit;
                    resize: vertical;
                  "
                >${timeOffRequestFormData.reason || ''}</textarea>
              </div>
              
              <div style="display: flex; gap: 0.75rem; margin-top: 0.5rem;">
                <button
                  onclick="submitTimeOffRequest();"
                  style="
                    flex: 1;
                    padding: 0.75rem;
                    background: #10b981;
                    color: white;
                    border: none;
                    border-radius: 0.5rem;
                    font-weight: 600;
                    cursor: pointer;
                  "
                  onmouseover="this.style.background='#059669'"
                  onmouseout="this.style.background='#10b981'"
                >
                  Submit Request
                </button>
                <button
                  onclick="showTimeOffRequestForm = false; window.showTimeOffRequestForm = false; renderPMTool();"
                  style="
                    flex: 1;
                    padding: 0.75rem;
                    background: #f1f5f9;
                    color: #64748b;
                    border: none;
                    border-radius: 0.5rem;
                    font-weight: 600;
                    cursor: pointer;
                  "
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      ` : ''}
      
      <!-- Time Off Requests List -->
      <div style="
        background: #ffffff;
        border-radius: 1rem;
        padding: 1.5rem;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
      ">
        <h2 style="font-size: 1.25rem; font-weight: 600; color: #0f172a; margin: 0 0 1.5rem 0;">
          ${canApprove && !hourlyRateFormData.employeeId ? 'All Company Requests' : 'My Requests'}
        </h2>
        
        ${canApprove ? `
          <div style="margin-bottom: 1.5rem;">
            <label style="display: block; font-size: 0.875rem; font-weight: 600; color: #64748b; margin-bottom: 0.5rem;">Filter by Employee</label>
            <div style="display: flex; gap: 0.75rem; align-items: flex-end;">
              <select
                id="time-off-employee-filter"
                onchange="window.hourlyRateFormData = window.hourlyRateFormData || {}; window.hourlyRateFormData.employeeId = this.value ? this.value : null; hourlyRateFormData.employeeId = this.value ? this.value : null; window.loadTimeOffRequests().then(() => renderPMTool());"
                style="
                  flex: 1;
                  max-width: 300px;
                  padding: 0.625rem;
                  border: 1px solid #e5e7eb;
                  border-radius: 0.5rem;
                  font-size: 0.875rem;
                "
              >
                <option value="">All Employees</option>
                ${(() => {
        // #region agent log
        fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:18880', message: 'renderTimeOffView CHECKING employees for dropdown', data: { companyEmployeesIsNull: companyEmployees === null, companyEmployeesLength: companyEmployees?.length, companyEmployeesIsArray: Array.isArray(companyEmployees), companyEmployeesLoading }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'B' }) }).catch(() => { });
        // #endregion
        if (companyEmployees === null) {
          return '<option value="" disabled>Loading employees...</option>';
        } else if (Array.isArray(companyEmployees) && companyEmployees.length > 0) {
          return companyEmployees.map(emp => `
                      <option value="${emp.id}" ${hourlyRateFormData.employeeId === emp.id ? 'selected' : ''}>${emp.name}</option>
                    `).join('');
        } else {
          return '<option value="" disabled>No employees found</option>';
        }
      })()}
              </select>
              <button
                onclick="window.hourlyRateFormData = window.hourlyRateFormData || {}; const filterSelect = document.getElementById('time-off-employee-filter'); if (filterSelect) { window.hourlyRateFormData.employeeId = filterSelect.value ? filterSelect.value : null; hourlyRateFormData.employeeId = filterSelect.value ? filterSelect.value : null; } window.loadTimeOffRequests().then(() => renderPMTool());"
                style="
                  padding: 0.625rem 1.25rem;
                  background: #f59e0b;
                  color: white;
                  border: none;
                  border-radius: 0.5rem;
                  font-weight: 600;
                  cursor: pointer;
                  font-size: 0.875rem;
                  white-space: nowrap;
                "
                onmouseover="this.style.background='#d97706'"
                onmouseout="this.style.background='#f59e0b'"
              >
                Search
              </button>
            </div>
          </div>
        ` : `
          <div style="margin-bottom: 1.5rem; display: none;">
            <label style="display: block; font-size: 0.875rem; font-weight: 600; color: #64748b; margin-bottom: 0.5rem;">Employee</label>
            <select
              disabled
              style="
                width: 100%;
                max-width: 300px;
                padding: 0.625rem;
                border: 1px solid #e5e7eb;
                border-radius: 0.5rem;
                font-size: 0.875rem;
                background: #f8f9fa;
              "
            >
              <option value="${currentProfile.id}" selected>${`${currentProfile.first_name || ''} ${currentProfile.last_name || ''}`.trim() || currentProfile.email}</option>
            </select>
          </div>
        `}
        
        ${(() => {
      // #region agent log
      fetch('http://127.0.0.1:7242/ingest/6f94da31-e07d-45b2-90fc-5601ef827053', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ location: 'app-modern-pm.js:18924', message: 'renderTimeOffView CHECKING requests', data: { timeOffRequestsLength: timeOffRequests?.length, timeOffRequestsIsArray: Array.isArray(timeOffRequests), timeOffRequestsType: typeof timeOffRequests }, timestamp: Date.now(), sessionId: 'debug-session', runId: 'run1', hypothesisId: 'D' }) }).catch(() => { });
      // #endregion
      return timeOffRequests && Array.isArray(timeOffRequests) && timeOffRequests.length > 0;
    })() ? `
          <div style="display: flex; flex-direction: column; gap: 1rem;">
            ${timeOffRequests.map(request => {
      const startDate = new Date(request.start_date);
      const endDate = new Date(request.end_date);
      const days = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;

      // Get employee name from profiles relation
      const employeeName = request.profiles
        ? `${request.profiles.first_name || ''} ${request.profiles.last_name || ''}`.trim() || request.profiles.email
        : 'Unknown Employee';

      return `
                <div style="
                  border: 1px solid #e5e7eb;
                  border-radius: 0.75rem;
                  padding: 1.5rem;
                  ${request.status === 'PENDING' ? 'background: #fffbeb;' : ''}
                ">
                  <div style="display: flex; justify-content: space-between; align-items: start; flex-wrap: wrap; gap: 1rem;">
                    <div style="flex: 1; min-width: 200px;">
                      <div style="font-size: 0.875rem; font-weight: 600; color: #000000; margin-bottom: 0.75rem;">
                        ${employeeName}
                      </div>
                      <div style="display: flex; align-items: center; gap: 0.75rem; margin-bottom: 0.75rem;">
                        ${getStatusBadge(request.status)}
                        <span style="font-size: 0.875rem; color: #64748b;">${getRequestTypeLabel(request.request_type)}</span>
                      </div>
                      <div style="font-weight: 600; color: #0f172a; margin-bottom: 0.5rem;">
                        ${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}
                      </div>
                      <div style="font-size: 0.875rem; color: #64748b;">
                        ${days} day${days !== 1 ? 's' : ''}
                      </div>
                      ${request.reason ? `
                        <div style="margin-top: 0.75rem; padding: 0.75rem; background: #f8f9fa; border-radius: 0.5rem;">
                          <div style="font-size: 0.75rem; color: #64748b; margin-bottom: 0.25rem;">Reason</div>
                          <div style="font-size: 0.875rem; color: #0f172a;">${request.reason}</div>
                        </div>
                      ` : ''}
                      ${request.rejection_reason ? `
                        <div style="margin-top: 0.75rem; padding: 0.75rem; background: #fee2e2; border-radius: 0.5rem;">
                          <div style="font-size: 0.75rem; color: #991b1b; margin-bottom: 0.25rem; font-weight: 600;">Rejection Reason</div>
                          <div style="font-size: 0.875rem; color: #991b1b;">${request.rejection_reason}</div>
                        </div>
                      ` : ''}
                    </div>
                    <div style="display: flex; gap: 0.5rem; flex-wrap: wrap;">
                      ${canApprove && request.status === 'PENDING' ? `
                        <button
                          onclick="window.selectedTimeOffRequest = ${JSON.stringify(request).replace(/"/g, '&quot;')}; selectedTimeOffRequest = window.selectedTimeOffRequest; window.approveTimeOffRequest();"
                          style="
                            padding: 0.5rem 1rem;
                            background: #10b981;
                            color: white;
                            border: none;
                            border-radius: 0.5rem;
                            font-weight: 600;
                            cursor: pointer;
                            font-size: 0.875rem;
                          "
                          onmouseover="this.style.background='#059669'"
                          onmouseout="this.style.background='#10b981'"
                        >
                          Approve
                        </button>
                        <button
                          onclick="window.rejectTimeOffRequest('${request.id}');"
                          style="
                            padding: 0.5rem 1rem;
                            background: #ef4444;
                            color: white;
                            border: none;
                            border-radius: 0.5rem;
                            font-weight: 600;
                            cursor: pointer;
                            font-size: 0.875rem;
                          "
                          onmouseover="this.style.background='#dc2626'"
                          onmouseout="this.style.background='#ef4444'"
                        >
                          Reject
                        </button>
                      ` : ''}
                      ${(() => {
          // Managers/Owners can always delete
          if (canApprove) {
            return `
                            <button
                              onclick="window.deleteTimeOffRequest('${request.id}');"
                              style="
                                padding: 0.5rem 1rem;
                                background: transparent;
                                color: #ef4444;
                                border: 1px solid #ef4444;
                                border-radius: 0.5rem;
                                font-weight: 600;
                                cursor: pointer;
                                font-size: 0.875rem;
                              "
                              onmouseover="this.style.background='#fee2e2'"
                              onmouseout="this.style.background='transparent'"
                              title="Delete time off request"
                            >
                              Delete
                            </button>
                          `;
          }
          // Employees can only delete their own requests if status is PENDING
          if (request.user_id === currentProfile?.id && request.status === 'PENDING') {
            return `
                            <button
                              onclick="window.deleteTimeOffRequest('${request.id}');"
                              style="
                                padding: 0.5rem 1rem;
                                background: transparent;
                                color: #ef4444;
                                border: 1px solid #ef4444;
                                border-radius: 0.5rem;
                                font-weight: 600;
                                cursor: pointer;
                                font-size: 0.875rem;
                              "
                              onmouseover="this.style.background='#fee2e2'"
                              onmouseout="this.style.background='transparent'"
                              title="Delete time off request"
                            >
                              Delete
                            </button>
                          `;
          }
          return '';
        })()}
                    </div>
                  </div>
                </div>
              `;
    }).join('')}
          </div>
        ` : `
          <div style="text-align: center; padding: 3rem; color: #64748b;">
            <p>No time off requests found.</p>
          </div>
        `}
      </div>
      
      <!-- Approval Modal -->
      ${showTimeOffApprovalModal && selectedTimeOffRequest ? `
        <div style="
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0,0,0,0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          padding: 1rem;
        " onclick="if (event.target === this) { showTimeOffApprovalModal = false; selectedTimeOffRequest = null; renderPMTool(); }">
          <div style="
            background: white;
            border-radius: 1rem;
            padding: 2rem;
            max-width: 500px;
            width: 100%;
          " onclick="event.stopPropagation();">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1.5rem;">
              <h2 style="font-size: 1.5rem; font-weight: 700; color: #0f172a; margin: 0;">Review Request</h2>
              <button
                onclick="showTimeOffApprovalModal = false; selectedTimeOffRequest = null; renderPMTool();"
                style="
                  width: 32px;
                  height: 32px;
                  border: none;
                  background: #f1f5f9;
                  border-radius: 50%;
                  cursor: pointer;
                  font-size: 1.25rem;
                  color: #64748b;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                "
              >×</button>
            </div>
            
            <div style="margin-bottom: 1.5rem;">
              <div style="font-size: 0.875rem; color: #64748b; margin-bottom: 0.5rem;">Request Type</div>
              <div style="font-weight: 600; color: #0f172a;">${getRequestTypeLabel(selectedTimeOffRequest.request_type)}</div>
            </div>
            
            <div style="margin-bottom: 1.5rem;">
              <div style="font-size: 0.875rem; color: #64748b; margin-bottom: 0.5rem;">Date Range</div>
              <div style="font-weight: 600; color: #0f172a;">
                ${new Date(selectedTimeOffRequest.start_date).toLocaleDateString()} - ${new Date(selectedTimeOffRequest.end_date).toLocaleDateString()}
              </div>
            </div>
            
            ${selectedTimeOffRequest.reason ? `
              <div style="margin-bottom: 1.5rem;">
                <div style="font-size: 0.875rem; color: #64748b; margin-bottom: 0.5rem;">Reason</div>
                <div style="color: #0f172a;">${selectedTimeOffRequest.reason}</div>
              </div>
            ` : ''}
            
            <div style="margin-bottom: 1.5rem;">
              <label style="display: block; font-size: 0.875rem; font-weight: 600; color: #64748b; margin-bottom: 0.5rem;">Rejection Reason (Required for rejection)</label>
              <textarea
                value="${timeOffApprovalData.rejectionReason || ''}"
                onchange="timeOffApprovalData.rejectionReason = this.value; window.timeOffApprovalData = window.timeOffApprovalData || {}; window.timeOffApprovalData.rejectionReason = this.value;"
                placeholder="Enter reason for rejection..."
                rows="3"
                style="
                  width: 100%;
                  padding: 0.625rem;
                  border: 1px solid #e5e7eb;
                  border-radius: 0.5rem;
                  font-size: 0.875rem;
                  font-family: inherit;
                  resize: vertical;
                "
              ></textarea>
            </div>
            
            <div style="display: flex; gap: 0.75rem;">
              <button
                onclick="approveTimeOffRequest();"
                style="
                  flex: 1;
                  padding: 0.75rem;
                  background: #10b981;
                  color: white;
                  border: none;
                  border-radius: 0.5rem;
                  font-weight: 600;
                  cursor: pointer;
                "
                onmouseover="this.style.background='#059669'"
                onmouseout="this.style.background='#10b981'"
              >
                Approve
              </button>
              <button
                onclick="window.rejectTimeOffRequest(selectedTimeOffRequest?.id || window.selectedTimeOffRequest?.id);"
                style="
                  flex: 1;
                  padding: 0.75rem;
                  background: #ef4444;
                  color: white;
                  border: none;
                  border-radius: 0.5rem;
                  font-weight: 600;
                  cursor: pointer;
                "
                onmouseover="this.style.background='#dc2626'"
                onmouseout="this.style.background='#ef4444'"
              >
                Reject
              </button>
              <button
                onclick="showTimeOffApprovalModal = false; selectedTimeOffRequest = null; renderPMTool();"
                style="
                  flex: 1;
                  padding: 0.75rem;
                  background: #f1f5f9;
                  color: #64748b;
                  border: none;
                  border-radius: 0.5rem;
                  font-weight: 600;
                  cursor: pointer;
                "
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      ` : ''}
    </div>
  `;
}

// Render Sales Screen
async function renderSalesScreen() {
  // Redirect to dashboard if user tries to access reports without permission
  if (salesView === 'reports' && !canAccessReports()) {
    salesView = 'dashboard';
  }

  let content = '';
  if (salesView === 'dashboard') {
    content = await renderSalesDashboard();
  } else if (salesView === 'contacts') {
    content = await renderContactsList();
  } else if (salesView === 'reports') {
    content = renderReportsView();
  } else {
    content = await renderSalesDashboard();
  }

  // Only add modal if not already included in contacts list
  if (salesView !== 'contacts') {
    return content + (showAddContactModal ? renderAddContactModal() : '');
  }
  return content;
}

// Load dashboard reminders and appointments (cached)
async function loadDashboardRemindersAndAppointments() {
  const now = Date.now();
  // Use cache if it's still valid
  if (dashboardCacheTimestamp && (now - dashboardCacheTimestamp) < DASHBOARD_CACHE_DURATION) {
    return {
      reminders: dashboardRemindersCache,
      appointments: dashboardAppointmentsCache
    };
  }

  // Load both in parallel for better performance
  const [remindersResult, appointmentsResult] = await Promise.all([
    supabase
      .from('reminders')
      .select(`
        id,
        title,
        description,
        due_at,
        priority,
        type,
        status,
        contact_id,
        assigned_to,
        owner_id,
        contact:contacts (
          first_name,
          last_name
        )
      `)
      .eq('company_id', currentCompany.id)
      .in('status', ['pending', 'overdue'])
      .order('due_at', { ascending: true }),

    supabase
      .from('appointments')
      .select(`
        id,
        title,
        appointment_date,
        start_time,
        duration_minutes,
        status,
        assigned_to,
        contact:contacts (
          first_name,
          last_name
        ),
        assigned_user:assigned_to (
          first_name,
          last_name
        )
      `)
      .eq('company_id', currentCompany.id)
      .in('status', ['scheduled', 'confirmed'])
      .order('appointment_date', { ascending: true })
      .order('start_time', { ascending: true })
  ]);

  dashboardRemindersCache = remindersResult.data || [];
  dashboardAppointmentsCache = appointmentsResult.data || [];
  dashboardCacheTimestamp = now;

  return {
    reminders: dashboardRemindersCache,
    appointments: dashboardAppointmentsCache
  };
}

// Invalidate dashboard cache (call after creating/updating reminders/appointments)
window.invalidateDashboardCache = function () {
  dashboardCacheTimestamp = null;
};

// Render Sales Dashboard (Home/Personal Dashboard)
async function renderSalesDashboard() {
  // Load reminders and appointments (cached, loads in parallel)
  const { reminders: allRemindersForDashboard, appointments: allAppointmentsForDashboard } =
    await loadDashboardRemindersAndAppointments();

  // Filter opportunities based on current filters
  let filteredOpportunities = salesOpportunities.filter(opp => {
    // In kanban view, show all opportunities
    if (salesDealsView === 'kanban') {
      return true;
    }

    // If showing archived opportunities, include won/lost and closed_at deals
    if (showArchivedOpportunities) {
      return true; // Show all including archived
    }

    // Otherwise, exclude archived deals (won/lost or have closed_at)
    // Exclude won/lost deals
    if (opp.stage === 'won' || opp.stage === 'lost') {
      return false;
    }
    // Exclude archived deals (have closed_at set)
    if (opp.closed_at) {
      return false;
    }

    return true;
  });

  // Apply deal filter (all vs my)
  if (salesDealFilter === 'my') {
    filteredOpportunities = filteredOpportunities.filter(opp =>
      opp.assigned_to === currentUser?.id
    );
  }

  // Apply probability filter
  if (salesProbabilityFilter !== 'all') {
    filteredOpportunities = filteredOpportunities.filter(opp => {
      const chance = opp.chance?.toLowerCase() || 'medium';
      return chance === salesProbabilityFilter.toLowerCase();
    });
  }

  // Apply stage filter (only in list view, kanban shows all stages)
  if (salesDealsView === 'list' && salesStageFilter !== 'all') {
    filteredOpportunities = filteredOpportunities.filter(opp =>
      opp.stage?.toLowerCase() === salesStageFilter.toLowerCase()
    );
  }

  // Sort opportunities by follow-up date (past due first, then upcoming dates)
  // Only sort in list view, kanban maintains its own grouping
  if (salesDealsView === 'list') {
    const nowTime = Date.now();
    filteredOpportunities.sort((a, b) => {
      // If no follow-up date, put at the end
      if (!a.follow_up_date && !b.follow_up_date) return 0;
      if (!a.follow_up_date) return 1;
      if (!b.follow_up_date) return -1;

      const dateA = new Date(a.follow_up_date).getTime();
      const dateB = new Date(b.follow_up_date).getTime();

      // Past due items come first (oldest first)
      if (dateA < nowTime && dateB < nowTime) {
        return dateA - dateB; // Oldest past due first
      }
      // Future items come after (earliest first)
      if (dateA >= nowTime && dateB >= nowTime) {
        return dateA - dateB; // Earliest upcoming first
      }
      // Past due always comes before future
      if (dateA < nowTime) return -1;
      if (dateB < nowTime) return 1;

      return dateA - dateB;
    });
  }

  // Group opportunities by stage for kanban view
  const kanbanColumns = {
    'new': [],
    'contacted': [],
    'qualified': [],
    'proposal': [],
    'negotiation': [],
    'active': [], // Won deals
    'archived': [] // Won or Lost deals
  };

  if (salesDealsView === 'kanban') {
    filteredOpportunities.forEach(opp => {
      const stage = opp.stage?.toLowerCase() || 'new';
      const isArchived = opp.closed_at && (stage === 'won' || stage === 'lost');

      if (stage === 'won') {
        if (isArchived) {
          // Won deals with closed_at go to archived column
          kanbanColumns.archived.push(opp);
        } else {
          // Won deals without closed_at go to active column (not archived)
          kanbanColumns.active.push(opp);
        }
      } else if (stage === 'lost') {
        // Lost deals always go to archived column
        kanbanColumns.archived.push(opp);
      } else if (kanbanColumns[stage]) {
        kanbanColumns[stage].push(opp);
      } else {
        kanbanColumns.new.push(opp);
      }
    });
  }

  // Get upcoming reminders and appointments (combine and sort by date)
  const allReminders = allRemindersForDashboard.map(r => ({
    ...r,
    type: 'reminder',
    date: r.due_at
  }));

  const allAppointments = allAppointmentsForDashboard.map(a => {
    // Parse appointment date properly
    let dateStr = null;
    if (a.appointment_date) {
      // If start_time exists, combine them; otherwise just use date
      if (a.start_time) {
        // Handle both HH:MM:SS and HH:MM formats
        const timePart = a.start_time.includes(':') ? a.start_time.split(':').slice(0, 2).join(':') : '00:00';
        dateStr = `${a.appointment_date}T${timePart}:00`;
      } else {
        dateStr = `${a.appointment_date}T00:00:00`;
      }
    }
    return {
      ...a,
      type: 'appointment',
      date: dateStr,
      contact_name: a.contact ? `${a.contact.first_name} ${a.contact.last_name}` : 'Unknown'
    };
  });

  // Filter reminders/appointments - only include items on or after current date
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate()); // Today at midnight

  let upcomingItems = [...allReminders, ...allAppointments].filter(item => {
    if (!item.date) return false;

    // Parse the date and compare with today
    const itemDate = new Date(item.date);
    const itemDateOnly = new Date(itemDate.getFullYear(), itemDate.getMonth(), itemDate.getDate());

    // Only include items that are today or in the future
    if (itemDateOnly < today) return false;

    // For reminders, include pending reminders from today onwards
    if (item.type === 'reminder') {
      return true;
    }

    // For appointments, include scheduled/confirmed appointments from today onwards
    if (item.type === 'appointment') {
      return true;
    }

    return false;
  });

  // Apply "my" filter if selected
  if (upcomingRemindersFilter === 'my') {
    upcomingItems = upcomingItems.filter(item =>
      item.assigned_to === currentUser?.id || item.owner_id === currentUser?.id
    );
  }

  // Sort by date (all items are now today or future, so just sort by date ascending)
  upcomingItems.sort((a, b) => {
    const dateA = new Date(a.date);
    const dateB = new Date(b.date);
    return dateA - dateB;
  });

  // Helper functions for colors
  const getChanceColor = (chance) => {
    const c = chance?.toLowerCase() || 'medium';
    if (c === 'high') return '#10b981'; // Green
    if (c === 'medium') return '#f59e0b'; // Orange/Yellow
    if (c === 'low') return '#ef4444'; // Red
    return '#6b7280'; // Gray
  };

  const getChanceLabel = (chance) => {
    const c = chance?.toUpperCase() || 'MEDIUM';
    return c;
  };

  const formatFollowUpDate = (dateStr) => {
    if (!dateStr) return null;
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  };

  const formatDateTime = (dateStr, timeStr) => {
    if (!dateStr) return 'Not set';
    const date = new Date(dateStr);
    const dateFormatted = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    if (timeStr) {
      const [hours, minutes] = timeStr.split(':');
      const hour = parseInt(hours);
      const ampm = hour >= 12 ? 'PM' : 'AM';
      const displayHour = hour % 12 || 12;
      return `${dateFormatted} · ${displayHour}:${minutes} ${ampm}`;
    }
    return dateFormatted;
  };

  return `
    <div style="max-width: 1400px; margin: 0 auto; padding: 1.5rem;">
      <!-- Sales Header -->
      <div style="margin-bottom: 2rem;">
          <h1 style="
            color: #2c3e50;
            margin: 0 0 0.5rem 0;
          font-size: 2rem;
          font-weight: 700;
            line-height: 1.2;
          ">
            Sales Dashboard
          </h1>
          <p style="
            color: #6c757d;
          margin: 0 0 1.5rem 0;
            font-size: 1rem;
          ">
            Your personal sales overview
          </p>
        
        <!-- View Toggle Buttons -->
        <div style="display: flex; gap: 0.75rem; margin-bottom: 1.5rem;">
          <button
            onclick="switchSalesView('dashboard')"
            style="
              background: ${salesView === 'dashboard' ? '#ff7f00' : '#ffffff'};
              color: ${salesView === 'dashboard' ? 'white' : '#6c757d'};
              border: 1px solid ${salesView === 'dashboard' ? '#ff7f00' : '#e9ecef'};
              padding: 0.75rem 1.5rem;
              border-radius: 0.75rem;
              cursor: pointer;
              font-weight: 600;
              transition: all 0.2s ease;
            "
          >
            Sales
          </button>
          <button
            onclick="switchSalesView('contacts')"
            style="
              background: ${salesView === 'contacts' ? '#ff7f00' : '#ffffff'};
              color: ${salesView === 'contacts' ? 'white' : '#6c757d'};
              border: 1px solid ${salesView === 'contacts' ? '#ff7f00' : '#e9ecef'};
              padding: 0.75rem 1.5rem;
              border-radius: 0.75rem;
              cursor: pointer;
              font-weight: 600;
              transition: all 0.2s ease;
            "
          >
            Contacts
          </button>
          ${canAccessReports() ? `
          <button
            onclick="switchSalesView('reports')"
            style="
              background: ${salesView === 'reports' ? '#ff7f00' : '#ffffff'};
              color: ${salesView === 'reports' ? 'white' : '#6c757d'};
              border: 1px solid ${salesView === 'reports' ? '#ff7f00' : '#e9ecef'};
              padding: 0.75rem 1.5rem;
              border-radius: 0.75rem;
              cursor: pointer;
              font-weight: 600;
              transition: all 0.2s ease;
            "
          >
            Reports
          </button>
          ` : ''}
        </div>
      </div>

      <!-- Deal Filters Section -->
      <div style="background: #ffffff; border-radius: 0.75rem; padding: ${salesDealsView === 'kanban' ? '1rem' : '1.5rem'}; margin-bottom: 1.5rem; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
        <!-- Deal Type Filters -->
        <div style="margin-bottom: ${salesDealsView === 'kanban' ? '0.5rem' : '1rem'};">
          <div style="display: flex; gap: 0.5rem;">
            <button
              onclick="setSalesDealFilter('all')"
              style="
                background: ${salesDealFilter === 'all' ? '#f59e0b' : '#ffffff'};
                color: ${salesDealFilter === 'all' ? 'white' : '#2c3e50'};
                border: 1px solid ${salesDealFilter === 'all' ? '#f59e0b' : '#e9ecef'};
                padding: 0.5rem 1rem;
                border-radius: 0.75rem;
                cursor: pointer;
                font-weight: 600;
                font-size: 0.75rem;
                transition: all 0.2s ease;
              "
            >
              All Deals
            </button>
            <button
              onclick="setSalesDealFilter('my')"
              style="
                background: ${salesDealFilter === 'my' ? '#f59e0b' : '#ffffff'};
                color: ${salesDealFilter === 'my' ? 'white' : '#2c3e50'};
                border: 1px solid ${salesDealFilter === 'my' ? '#f59e0b' : '#e9ecef'};
                padding: 0.5rem 1rem;
                border-radius: 0.75rem;
                cursor: pointer;
                font-weight: 600;
                font-size: 0.75rem;
                transition: all 0.2s ease;
              "
            >
              My Deals
            </button>
          </div>
        </div>
        
        ${salesDealsView === 'list' ? `
        <!-- Probability Filters -->
        <div style="margin-bottom: 1rem;">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.5rem;">
            <div style="font-size: 0.875rem; font-weight: 600; color: #2c3e50;">
              Probability:
            </div>
            <div style="display: flex; gap: 0.5rem; align-items: center;">
              <button
                onclick="showAddOpportunityModalFromSales()"
                style="
                  background: #f59e0b;
                  color: white;
                  border: none;
                  padding: 0.5rem 1rem;
                  border-radius: 0.375rem;
                  cursor: pointer;
                  font-size: 0.875rem;
                  font-weight: 500;
                  display: flex;
                  align-items: center;
                  gap: 0.375rem;
                "
                onmouseover="this.style.background='#d97706'"
                onmouseout="this.style.background='#f59e0b'"
              >
                + Add
              </button>
              <button
                onclick="toggleSalesDealsView()"
                style="
                  background: #f59e0b;
                  color: white;
                  border: 1px solid #f59e0b;
                  padding: 0.5rem 1rem;
                  border-radius: 0.5rem;
                  cursor: pointer;
                  font-weight: 500;
                  font-size: 0.875rem;
                  transition: all 0.2s ease;
                display: flex;
                align-items: center;
                  gap: 0.375rem;
                "
                title="Toggle Kanban View"
              >
                ${salesDealsView === 'kanban' ? 'Kanban' : 'Sales Board'}
              </button>
            </div>
          </div>
          <div style="display: flex; gap: 0.5rem; flex-wrap: wrap;">
            ${['all', 'high', 'medium', 'low'].map(prob => `
              <button
                onclick="setSalesProbabilityFilter('${prob}')"
                style="
                  background: ${salesProbabilityFilter === prob ? '#fef3c7' : '#ffffff'};
                  color: ${salesProbabilityFilter === prob ? '#f59e0b' : '#6c757d'};
                  border: 2px solid ${salesProbabilityFilter === prob ? '#f59e0b' : '#e9ecef'};
                  padding: 0.5rem 1rem;
                  border-radius: 2rem;
                  cursor: pointer;
                  font-weight: 500;
                  font-size: 0.875rem;
                  transition: all 0.2s ease;
                "
              >
                ${prob === 'all' ? 'All' : prob.charAt(0).toUpperCase() + prob.slice(1)}
              </button>
            `).join('')}
          </div>
        </div>
        
        <!-- Stage Filters -->
        <div>
          <div style="font-size: 0.875rem; font-weight: 600; color: #2c3e50; margin-bottom: 0.5rem;">
            Stage:
          </div>
          <div style="display: flex; gap: 0.5rem; flex-wrap: wrap;">
            ${['all', 'new', 'contacted', 'qualified', 'proposal', 'negotiation'].map(stage => `
              <button
                onclick="setSalesStageFilter('${stage}')"
                style="
                  background: ${salesStageFilter === stage ? '#fef3c7' : '#ffffff'};
                  color: ${salesStageFilter === stage ? '#f59e0b' : '#6c757d'};
                  border: 2px solid ${salesStageFilter === stage ? '#f59e0b' : '#e9ecef'};
                  padding: 0.5rem 1rem;
                  border-radius: 2rem;
                  cursor: pointer;
                  font-weight: 500;
                  font-size: 0.875rem;
                  transition: all 0.2s ease;
                "
              >
                ${stage === 'all' ? 'All' : stage.charAt(0).toUpperCase() + stage.slice(1)}
              </button>
            `).join('')}
          </div>
        </div>
        ` : `
        <!-- Kanban View Toggle -->
        <div style="display: flex; justify-content: flex-end;">
          <button
            onclick="toggleSalesDealsView()"
            style="
              background: ${salesDealsView === 'kanban' ? '#f59e0b' : '#ffffff'};
              color: ${salesDealsView === 'kanban' ? 'white' : '#6c757d'};
              border: 1px solid ${salesDealsView === 'kanban' ? '#f59e0b' : '#e9ecef'};
              padding: 0.5rem 1rem;
              border-radius: 0.5rem;
              cursor: pointer;
              font-weight: 500;
              font-size: 0.875rem;
              transition: all 0.2s ease;
              display: flex;
              align-items: center;
              gap: 0.375rem;
            "
            title="Toggle List View"
          >
            List
          </button>
          </div>
        `}
      </div>

      <!-- Won/Lost Modal -->
      ${showWonLostModal ? renderWonLostModal() : ''}

      <!-- Deals Section (List or Kanban) -->
      ${salesDealsView === 'kanban' ? renderKanbanView(kanbanColumns, getChanceColor, getChanceLabel, formatFollowUpDate) : `
      <!-- Horizontal Scrollable Deals Section -->
      <div style="margin-bottom: 2rem;">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
          <h2 style="
              color: #2c3e50;
            margin: 0;
            font-size: 1.25rem;
              font-weight: 700;
          ">
            Upcoming Deals
          </h2>
        </div>
        <div id="deals-scroll-container" style="
          overflow-x: auto;
          overflow-y: hidden;
          padding-bottom: 0.5rem;
          padding-right: 0;
          -webkit-overflow-scrolling: touch;
          scrollbar-width: thin;
          scrollbar-color: #f59e0b #f8f9fa;
        ">
          <style>
            /* Modern scrollbar styling for deals container */
            #deals-scroll-container::-webkit-scrollbar {
              width: 8px;
              height: 8px;
            }
            #deals-scroll-container::-webkit-scrollbar-track {
              background: #f8f9fa;
              border-radius: 4px;
            }
            #deals-scroll-container::-webkit-scrollbar-thumb {
              background: #f59e0b;
              border-radius: 4px;
              transition: background 0.2s ease;
            }
            #deals-scroll-container::-webkit-scrollbar-thumb:hover {
              background: #d97706;
            }
          </style>
          <div style="display: flex; gap: 1rem; min-width: max-content;">
            ${filteredOpportunities.length === 0 ? `
              <div style="
                min-width: 300px;
                padding: 3rem 2rem;
                text-align: center;
                color: #6c757d;
                background: #f8f9fa;
                border-radius: 0.75rem;
              ">
                <div style="font-size: 2rem; margin-bottom: 0.5rem; color: #6c757d;">
                  <span class="material-icons" style="font-size: 2rem;">bar_chart</span>
                </div>
                <p style="margin: 0; font-size: 0.875rem;">No deals match your filters</p>
        </div>
            ` : filteredOpportunities.map(opp => {
    const chanceColor = getChanceColor(opp.chance);
    const chanceLabel = getChanceLabel(opp.chance);
    const followUpDate = formatFollowUpDate(opp.follow_up_date);
    const stageLabel = opp.stage ? opp.stage.charAt(0).toUpperCase() + opp.stage.slice(1) : 'New';

    // Determine if archived (has closed_at or stage is won/lost)
    const isArchived = !!opp.closed_at || opp.stage === 'won' || opp.stage === 'lost';
    const cardBgColor = isArchived ? '#f8f9fa' : '#ffffff';

    return `
                <div onclick="editOpportunity('${opp.id}')" style="
                  min-width: 380px;
                  max-width: 380px;
                  min-height: 190px;
          background: ${cardBgColor};
          border: 1px solid #e9ecef;
          border-radius: 0.75rem;
                  padding: 1.625rem;
                  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                  cursor: pointer;
                  transition: all 0.2s ease;
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                  opacity: ${isArchived ? 0.85 : 1};
                " onmouseover="this.style.boxShadow='0 4px 8px rgba(0,0,0,0.15)'" onmouseout="this.style.boxShadow='0 2px 4px rgba(0,0,0,0.1)'">
                  <!-- Top Row: Probability and Stage -->
                  <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.75rem;">
                    <div style="display: flex; align-items: center; gap: 0.5rem;">
            <div style="
                        width: 8px;
                        height: 8px;
              border-radius: 50%;
                        background: ${chanceColor};
                      "></div>
                      <span style="
                        font-size: 0.75rem;
              font-weight: 600;
                        color: ${chanceColor};
                      ">${chanceLabel}</span>
          </div>
                    <button style="
                      background: #fef3c7;
                      color: #f59e0b;
                      border: none;
                      padding: 0.25rem 0.75rem;
                      border-radius: 1rem;
                      font-size: 0.75rem;
                      font-weight: 600;
                      cursor: pointer;
                    ">${stageLabel}</button>
                  </div>
                  
                  <!-- Deal Title and Amount -->
                  <div style="margin-bottom: 0.75rem; flex: 1;">
                    <h3 style="
                      margin: 0 0 0.5rem 0;
                      color: #2c3e50;
                      font-size: 1.125rem;
                      font-weight: 700;
                      line-height: 1.4;
                    ">${opp.title || 'Untitled Deal'}</h3>
                    ${opp.contact ? `
                      <div style="
                        margin: 0 0 0.5rem 0;
                        color: #6c757d;
                        font-size: 0.875rem;
                        font-weight: 500;
                        display: flex;
                        align-items: center;
                        gap: 0.375rem;
                      ">
                        ${opp.contact.first_name || ''} ${opp.contact.last_name || ''}
                      </div>
                    ` : ''}
          <p style="
            margin: 0;
            color: #2c3e50;
                      font-size: 1.25rem;
            font-weight: 700;
                    ">$${(opp.amount || 0).toLocaleString()}</p>
      </div>
      
                  <!-- Follow-up Date -->
                  ${followUpDate ? `
        <div style="
                      background: #fee2e2;
                      color: #dc2626;
                      padding: 0.625rem 0.875rem;
                      border-radius: 0.5rem;
                      display: inline-flex;
                align-items: center;
                      gap: 0.375rem;
                      font-size: 0.8125rem;
                      font-weight: 500;
                      margin-top: auto;
              ">
                      Next follow-up ${followUpDate}
                  </div>
                  ` : ''}
                  </div>
              `;
  }).join('')}
                </div>
                </div>
              </div>
      `}

      <!-- Upcoming Reminders/Appointments Section (Only in List View) -->
      ${salesDealsView === 'list' ? `
      <div>
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
          <h2 style="
              color: #2c3e50;
            margin: 0;
            font-size: 1.25rem;
            font-weight: 700;
          ">
            Upcoming Appointments and Reminders
          </h2>
                  </div>
        
        <!-- Reminders/Appointments Filter -->
        <div style="display: flex; gap: 0.5rem; margin-bottom: 1rem;">
          <button
            onclick="setUpcomingRemindersFilter('all')"
            style="
              background: ${upcomingRemindersFilter === 'all' ? '#f59e0b' : '#ffffff'};
              color: ${upcomingRemindersFilter === 'all' ? 'white' : '#6c757d'};
              border: 1px solid ${upcomingRemindersFilter === 'all' ? '#f59e0b' : '#e9ecef'};
              padding: 0.5rem 1rem;
              border-radius: 2rem;
              cursor: pointer;
              font-weight: 600;
              font-size: 0.875rem;
              transition: all 0.2s ease;
            "
          >
            All
          </button>
          <button
            onclick="setUpcomingRemindersFilter('my')"
            style="
              background: ${upcomingRemindersFilter === 'my' ? '#f59e0b' : '#ffffff'};
              color: ${upcomingRemindersFilter === 'my' ? 'white' : '#6c757d'};
              border: 1px solid ${upcomingRemindersFilter === 'my' ? '#f59e0b' : '#e9ecef'};
              padding: 0.5rem 1rem;
              border-radius: 2rem;
              cursor: pointer;
              font-weight: 600;
              font-size: 0.875rem;
              transition: all 0.2s ease;
            "
          >
            My Reminders/Appointments
          </button>
                  </div>
        
        <!-- Upcoming Items List -->
        <div style="display: flex; flex-direction: column; gap: 0.75rem;">
          ${upcomingItems.length === 0 ? `
            <div style="
              padding: 3rem 2rem;
              text-align: center;
              color: #6c757d;
              background: #f8f9fa;
              border-radius: 0.75rem;
            ">
              <div style="font-size: 2rem; margin-bottom: 0.5rem; color: #6c757d;">
                <span class="material-icons" style="font-size: 2rem;">event</span>
              </div>
              <p style="margin: 0; font-size: 0.875rem;">No upcoming reminders or appointments</p>
              </div>
          ` : upcomingItems.slice(0, 10).map(item => {
    const isReminder = item.type === 'reminder';
    const dateTime = isReminder
      ? formatDateTime(item.due_at, null)
      : formatDateTime(item.appointment_date, item.start_time);

    // Get assigned user name
    let assignedTo = 'Unassigned';
    if (isReminder) {
      // For reminders, check owner_id or assigned_to
      if (item.owner_id === currentUser?.id || item.assigned_to === currentUser?.id) {
        assignedTo = 'You';
      } else if (item.assigned_to) {
        // Try to get user name from teamMembers if available
        const assignedMember = teamMembers.find(m => m.id === item.assigned_to);
        if (assignedMember) {
          assignedTo = `${assignedMember.first_name} ${assignedMember.last_name}`;
        } else {
          assignedTo = 'Assigned User';
        }
      }
    } else {
      // For appointments, use assigned_user
      if (item.assigned_user) {
        const fullName = `${item.assigned_user.first_name || ''} ${item.assigned_user.last_name || ''}`.trim();
        assignedTo = fullName || 'Unassigned';
        if (item.assigned_to === currentUser?.id) {
          assignedTo = 'You';
        }
      } else if (item.assigned_to === currentUser?.id) {
        assignedTo = 'You';
      }
    }

    const contactName = isReminder
      ? (item.contact ? `${item.contact.first_name} ${item.contact.last_name}` : 'Unknown')
      : item.contact_name || 'Unknown';

    return `
              <div onclick="${isReminder ? `window.editReminder('${item.id}')` : `window.editAppointment('${item.id}')`}; return false;" style="
          background: #ffffff;
          border: 1px solid #e9ecef;
          border-radius: 0.75rem;
                padding: 1rem;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                cursor: pointer;
                transition: all 0.2s ease;
                display: flex;
                align-items: center;
                gap: 1rem;
              " onmouseover="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.15)'" onmouseout="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.1)'">
                <!-- Content -->
                <div style="flex: 1; min-width: 0;">
                  <div style="
                    font-weight: 600;
              color: #2c3e50;
              font-size: 1rem;
                    margin-bottom: 0.25rem;
                  ">${item.title || 'Untitled'}</div>
              <div style="
                display: flex;
                align-items: center;
                    gap: 0.5rem;
                    margin-bottom: 0.125rem;
                    font-size: 0.875rem;
                    color: #6c757d;
              ">
                    <span style="color: #000000;">${assignedTo}</span>
                  </div>
                  <div style="
                    font-size: 0.875rem;
                    color: #6c757d;
                    margin-bottom: 0.125rem;
                  ">${dateTime}</div>
                  <div style="
                    font-size: 0.875rem;
                    color: #6c757d;
                  ">Contact: ${contactName}</div>
                  </div>
                
                <!-- Arrow -->
                <div style="
                  color: #9ca3af;
                  font-size: 1.25rem;
                  flex-shrink: 0;
                ">→</div>
                </div>
            `;
  }).join('')}
              </div>
              </div>
            ` : ''}
    </div>
  `;
}

// Render Weekly Champions (Top 3 Podium)
function renderWeeklyChampions() {
  // TODO: Fetch weekly champions data
  const champions = weeklyChampions || [];

  return `
    <div style="
      background: ${colors.surface};
      border-radius: 1rem;
      padding: 2rem;
      margin-bottom: 2rem;
      box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    ">
      <h2 style="
        margin: 0 0 1.5rem 0;
        color: ${colors.text};
        font-size: 1.5rem;
        font-weight: 700;
      ">
        🏆 Weekly Champions
      </h2>
      <div style="display: flex; justify-content: center; align-items: flex-end; gap: 2rem; min-height: 200px;">
        ${champions.length === 0 ? `
          <div style="text-align: center; color: ${colors.textSecondary};">
            <p>No deals closed this week yet</p>
          </div>
        ` : champions.slice(0, 3).map((champion, index) => `
          <div style="
            text-align: center;
            ${index === 0 ? 'order: 2;' : index === 1 ? 'order: 1;' : 'order: 3;'}
          ">
            <div style="
              width: 80px;
              height: 80px;
              border-radius: 50%;
              background: ${index === 0 ? '#FFD700' : index === 1 ? '#C0C0C0' : '#CD7F32'};
              display: flex;
              align-items: center;
              justify-content: center;
              margin: 0 auto 1rem;
              font-size: 2rem;
            ">
              ${champion.avatar_path ? `
                <img src="https://kiegklpumwuynysqwyot.supabase.co/storage/v1/object/public/profile-photos/${champion.avatar_path}" 
                     style="width: 100%; height: 100%; border-radius: 50%; object-fit: cover;" />
              ` : champion.first_name?.charAt(0) || '?'}
            </div>
            <div style="font-weight: 700; color: ${colors.text}; margin-bottom: 0.25rem;">
              ${champion.first_name} ${champion.last_name}
            </div>
            <div style="font-size: 0.875rem; color: ${colors.textSecondary};">
              $${(champion.total_amount || 0).toLocaleString()} • ${champion.deals_count} deal${champion.deals_count !== 1 ? 's' : ''}
            </div>
          </div>
        `).join('')}
      </div>
    </div>
  `;
}

// Render User Appointments
function renderUserAppointments() {
  const userAppointments = appointments.filter(apt => apt.user_id === currentUser?.id).slice(0, 5);

  return `
    <div style="
      background: ${colors.surface};
      border-radius: 1rem;
      padding: 1.5rem;
      margin-bottom: 2rem;
      box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    ">
      <h3 style="margin: 0 0 1rem 0; color: ${colors.text}; font-size: 1.25rem; font-weight: 700;">
        📅 Your Appointments
      </h3>
      ${userAppointments.length === 0 ? `
        <div style="text-align: center; padding: 2rem; color: ${colors.textSecondary};">
          No upcoming appointments
        </div>
      ` : userAppointments.map(apt => `
        <div style="
          padding: 1rem;
          border-bottom: 1px solid ${colors.border};
          display: flex;
          justify-content: space-between;
          align-items: center;
        ">
          <div>
            <div style="font-weight: 600; color: ${colors.text}; margin-bottom: 0.25rem;">
              ${apt.title || 'Appointment'}
            </div>
            <div style="font-size: 0.875rem; color: ${colors.textSecondary};">
              ${new Date(apt.scheduled_at).toLocaleDateString()} at ${new Date(apt.scheduled_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
            </div>
          </div>
          <span style="
            background: ${colors.primaryLight};
            color: ${colors.primary};
            padding: 0.375rem 0.75rem;
            border-radius: 0.5rem;
            font-size: 0.75rem;
            font-weight: 600;
          ">
            ${apt.type || 'Meeting'}
          </span>
        </div>
      `).join('')}
    </div>
  `;
}

// Render User Sales Opportunities
function renderUserSalesOpportunities() {
  const userOpportunities = salesOpportunities.filter(opp => opp.assigned_to === currentUser?.id).slice(0, 5);

  return `
    <div style="
      background: ${colors.surface};
      border-radius: 1rem;
      padding: 1.5rem;
      margin-bottom: 2rem;
      box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    ">
      <h3 style="margin: 0 0 1rem 0; color: ${colors.text}; font-size: 1.25rem; font-weight: 700;">
        💰 Your Sales Opportunities
      </h3>
      ${userOpportunities.length === 0 ? `
        <div style="text-align: center; padding: 2rem; color: ${colors.textSecondary};">
          No active opportunities
        </div>
      ` : userOpportunities.map(opp => `
        <div style="
          padding: 1rem;
          border-bottom: 1px solid ${colors.border};
          display: flex;
          justify-content: space-between;
          align-items: center;
        ">
          <div>
            <div style="font-weight: 600; color: ${colors.text}; margin-bottom: 0.25rem;">
              ${opp.title || 'Opportunity'}
            </div>
            <div style="font-size: 0.875rem; color: ${colors.textSecondary};">
              ${opp.contact_name || 'No contact'} • Stage: ${opp.stage || 'lead'}
            </div>
          </div>
          <div style="font-weight: 700; color: ${colors.success}; font-size: 1.125rem;">
            $${(opp.amount || 0).toLocaleString()}
          </div>
        </div>
      `).join('')}
    </div>
  `;
}

// Render User Reminders
function renderUserReminders() {
  const userReminders = reminders.filter(rem => rem.user_id === currentUser?.id).slice(0, 5);

  return `
    <div style="
      background: ${colors.surface};
      border-radius: 1rem;
      padding: 1.5rem;
      margin-bottom: 2rem;
      box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    ">
      <h3 style="margin: 0 0 1rem 0; color: ${colors.text}; font-size: 1.25rem; font-weight: 700;">
        ⏰ Your Reminders
      </h3>
      ${userReminders.length === 0 ? `
        <div style="text-align: center; padding: 2rem; color: ${colors.textSecondary};">
          No pending reminders
        </div>
      ` : userReminders.map(rem => `
        <div style="
          padding: 1rem;
          border-bottom: 1px solid ${colors.border};
        ">
          <div style="font-weight: 600; color: ${colors.text}; margin-bottom: 0.25rem;">
            ${rem.title || 'Reminder'}
          </div>
          <div style="font-size: 0.875rem; color: ${colors.textSecondary};">
            Due: ${new Date(rem.due_at).toLocaleDateString()}
          </div>
        </div>
      `).join('')}
    </div>
  `;
}

// Render Add Contact Modal
function renderAddContactModal() {
  return `
    <!-- Modal Overlay -->
    <div id="add-contact-modal" onclick="if (event.target.id === 'add-contact-modal') { showAddContactModal = false; const modal = document.getElementById('add-contact-modal'); if (modal) modal.remove(); }" style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 99999;
      animation: fadeIn 0.3s ease-out;
    ">
      <!-- Modal Content -->
      <div onclick="event.stopPropagation()" style="
        background: #ffffff;
        border-radius: 1rem;
        padding: 0;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
        max-width: 600px;
        width: 95%;
        max-height: 90vh;
        overflow-y: auto;
        animation: slideIn 0.3s ease-out;
        position: relative;
      ">
        <!-- Header -->
        <div style="
          padding: 1rem 1.5rem;
          border-bottom: 1px solid #e9ecef;
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: sticky;
          top: 0;
          background: #ffffff;
          z-index: 10;
        ">
          <button
            onclick="showAddContactModal = false; const modal = document.getElementById('add-contact-modal'); if (modal) modal.remove();"
            style="
              background: transparent;
              border: none;
              color: #f59e0b;
              cursor: pointer;
              font-size: 0.875rem;
              font-weight: 500;
              padding: 0.5rem;
            "
          >
            Cancel
          </button>
          <h2 style="
            margin: 0;
            color: #2c3e50;
            font-size: 1.125rem;
            font-weight: 700;
          ">
            Add Contact
          </h2>
          <button
            id="add-contact-submit-btn"
            onclick="handleAddContact(event)"
            style="
              background: #f59e0b;
              color: white;
              border: none;
              padding: 0.5rem 1rem;
              border-radius: 0.375rem;
              cursor: pointer;
              font-size: 0.875rem;
              font-weight: 600;
            "
          >
            Add
          </button>
        </div>

        <!-- Form Content -->
        <form id="add-contact-form" onsubmit="handleAddContact(event); return false;" style="padding: 1.5rem;">
          <div style="display: flex; flex-direction: column; gap: 1.5rem;">
            <!-- First Name -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 500;
                font-size: 0.875rem;
              ">
                First Name *
              </label>
              <input
                type="text"
                id="contact-first-name"
                placeholder="Enter first name"
                required
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e5e7eb;
                  border-radius: 0.5rem;
                  font-size: 1rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s ease;
                "
                onfocus="this.style.borderColor='#00ADB5'"
                onblur="this.style.borderColor='#e5e7eb'"
              />
            </div>

            <!-- Last Name -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 500;
                font-size: 0.875rem;
              ">
                Last Name *
              </label>
              <input
                type="text"
                id="contact-last-name"
                placeholder="Enter last name"
                required
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e5e7eb;
                  border-radius: 0.5rem;
                  font-size: 1rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s ease;
                "
                onfocus="this.style.borderColor='#00ADB5'"
                onblur="this.style.borderColor='#e5e7eb'"
              />
            </div>

            <!-- Phone -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 500;
                font-size: 0.875rem;
              ">
                Phone
              </label>
              <input
                type="tel"
                id="contact-phone"
                placeholder="(509) 585-4739"
                maxlength="14"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e5e7eb;
                  border-radius: 0.5rem;
                  font-size: 1rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s ease;
                "
                oninput="window.formatPhoneNumber(this)"
                onfocus="this.style.borderColor='#00ADB5'"
                onblur="this.style.borderColor='#e5e7eb'"
              />
            </div>

            <!-- Email -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 500;
                font-size: 0.875rem;
              ">
                Email
              </label>
              <input
                type="email"
                id="contact-email"
                placeholder="Enter email address"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e5e7eb;
                  border-radius: 0.5rem;
                  font-size: 1rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s ease;
                "
                onfocus="this.style.borderColor='#00ADB5'"
                onblur="this.style.borderColor='#e5e7eb'"
              />
            </div>

            <!-- Business Name -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 500;
                font-size: 0.875rem;
              ">
                Business Name
              </label>
              <input
                type="text"
                id="contact-business-name"
                placeholder="Enter business name"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e5e7eb;
                  border-radius: 0.5rem;
                  font-size: 1rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s ease;
                "
                onfocus="this.style.borderColor='#00ADB5'"
                onblur="this.style.borderColor='#e5e7eb'"
              />
            </div>

            <!-- Role Label -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 500;
                font-size: 0.875rem;
              ">
                Role Label
              </label>
              <input
                type="text"
                id="contact-role-label"
                placeholder="e.g., Owner, Manager, Employee"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e5e7eb;
                  border-radius: 0.5rem;
                  font-size: 1rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s ease;
                "
                onfocus="this.style.borderColor='#00ADB5'"
                onblur="this.style.borderColor='#e5e7eb'"
              />
            </div>

            <!-- Notes -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 500;
                font-size: 0.875rem;
              ">
                Notes
              </label>
              <textarea
                id="contact-notes"
                placeholder="Enter notes..."
                rows="4"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e5e7eb;
                  border-radius: 0.5rem;
                  font-size: 1rem;
                  box-sizing: border-box;
                  resize: vertical;
                  font-family: inherit;
                  transition: border-color 0.2s ease;
                  min-height: 100px;
                "
                onfocus="this.style.borderColor='#00ADB5'"
                onblur="this.style.borderColor='#e5e7eb'"
              ></textarea>
            </div>

            <!-- Validation Message -->
            <div id="contact-validation-message" style="
              display: none;
              color: #00ADB5;
              font-size: 0.875rem;
              padding: 0.75rem;
              background: #f0f9ff;
              border-left: 3px solid #00ADB5;
              border-radius: 0.25rem;
            ">
              * First and last name are required. Either phone or email is required.
            </div>
          </div>
        </form>
      </div>
    </div>
  `;
}

// Handle Add Contact
window.handleAddContact = async function (e) {
  if (e) e.preventDefault();

  const firstNameInput = document.getElementById('contact-first-name');
  const lastNameInput = document.getElementById('contact-last-name');
  const phoneInput = document.getElementById('contact-phone');
  const emailInput = document.getElementById('contact-email');
  const businessNameInput = document.getElementById('contact-business-name');
  const roleLabelInput = document.getElementById('contact-role-label');
  const notesInput = document.getElementById('contact-notes');
  const validationMsg = document.getElementById('contact-validation-message');

  const firstName = firstNameInput?.value?.trim() || '';
  const lastName = lastNameInput?.value?.trim() || '';
  const phone = phoneInput?.value?.replace(/\D/g, '') || ''; // Strip formatting, keep only digits
  const email = emailInput?.value?.trim() || '';
  const businessName = businessNameInput?.value?.trim() || '';
  const roleLabel = roleLabelInput?.value?.trim() || '';
  const notes = notesInput?.value?.trim() || '';

  console.log('📝 Form submission - Email:', email, 'First:', firstName, 'Last:', lastName);

  // Validation
  if (!firstName || !lastName) {
    if (validationMsg) {
      validationMsg.style.display = 'block';
    }
    return;
  }

  if (!phone && !email) {
    if (validationMsg) {
      validationMsg.style.display = 'block';
    }
    return;
  }

  // Hide validation message
  if (validationMsg) {
    validationMsg.style.display = 'none';
  }

  // Initialize linkingExistingAccount if not set
  if (typeof window.linkingExistingAccount === 'undefined') {
    window.linkingExistingAccount = false;
  }

  // Check if email matches existing account (only if email is provided and we're not already linking)
  let existingProfile = null;
  if (email && !window.linkingExistingAccount) {
    const emailLower = email.toLowerCase().trim();
    console.log('🔍 Checking for existing profile with email:', emailLower);

    try {
      // Use RPC function to bypass RLS and check across all profiles
      const { data: profileData, error: profileError } = await supabase
        .rpc('check_profile_by_email', { p_email: emailLower });

      if (profileError) {
        console.error('❌ Error checking existing profile via RPC:', profileError);
        console.error('❌ Full error object:', JSON.stringify(profileError, null, 2));
        console.error('❌ Error code:', profileError.code);
        console.error('❌ Error message:', profileError.message);
        console.error('❌ Error details:', profileError.details);
        console.error('❌ Error hint:', profileError.hint);
        // Continue with normal flow if there's an error
      } else if (profileData && profileData.length > 0) {
        console.log('✅ Found existing profile:', profileData[0]);
        existingProfile = profileData[0];
      } else {
        console.log('ℹ️ No existing profile found for email:', emailLower);
      }
    } catch (err) {
      console.error('❌ Exception checking existing profile:', err);
      // Continue with normal flow if there's an exception
    }
  } else {
    if (!email) {
      console.log('ℹ️ No email provided, skipping profile check');
    } else {
      console.log('ℹ️ Already linking existing account, skipping check');
    }
  }

  // If existing account found, show confirmation dialog
  if (existingProfile && !window.linkingExistingAccount) {
    console.log('📋 Showing confirmation dialog for existing account:', existingProfile);
    const confirmed = confirm(
      `An account with this email already exists (${existingProfile.first_name} ${existingProfile.last_name}). ` +
      `Would you like to link the contact to this existing account?`
    );

    if (!confirmed) {
      return;
    }

    // Auto-fill form with existing account data
    if (firstNameInput) firstNameInput.value = existingProfile.first_name || '';
    if (lastNameInput) lastNameInput.value = existingProfile.last_name || '';
    if (emailInput) emailInput.value = existingProfile.email || email;
    if (phoneInput) phoneInput.value = existingProfile.phone || '';

    window.linkingExistingAccount = true;

    // Use existing profile data for contact creation (user may have entered businessName, roleLabel, notes)
    const contactFirstName = existingProfile.first_name || '';
    const contactLastName = existingProfile.last_name || '';
    const contactPhone = existingProfile.phone?.replace(/\D/g, '') || '';
    const contactEmail = existingProfile.email || email;

    // Check if contact already exists for this profile
    const { data: existingContact, error: checkError } = await supabase
      .from('contacts')
      .select('id')
      .eq('company_id', currentCompany.id)
      .eq('profile_id', existingProfile.id)
      .maybeSingle();

    if (checkError && checkError.code !== 'PGRST116') {
      console.error('Error checking existing contact:', checkError);
      alert('Failed to check for existing contact');
      return;
    }

    if (existingContact) {
      alert('A contact for this account already exists in your company.');
      window.linkingExistingAccount = false;
      return;
    }

    // Create contact with profile_id
    const submitBtn = document.getElementById('add-contact-submit-btn');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding...';
    }

    try {
      const { data, error } = await supabase
        .from('contacts')
        .insert({
          company_id: currentCompany.id,
          profile_id: existingProfile.id,
          first_name: contactFirstName,
          last_name: contactLastName,
          phone: contactPhone || null,
          email: contactEmail || null,
          company_name: businessName || null,
          role_label: roleLabel || null,
          notes: notes || null,
          owner_id: currentUser.id,
          status: 'lead',
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString(),
        })
        .select()
        .single();

      if (error) {
        console.error('Error creating contact:', error);
        alert('Failed to create contact: ' + error.message);
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Add';
        }
        window.linkingExistingAccount = false;
        return;
      }

      console.log('✅ Contact linked to existing account:', data);

      // Link to company via contact_companies if needed
      try {
        const { data: existingLink } = await supabase
          .from('contact_companies')
          .select('contact_id, company_id')
          .eq('contact_id', data.id)
          .eq('company_id', currentCompany.id)
          .maybeSingle();

        if (!existingLink) {
          await supabase
            .from('contact_companies')
            .insert({
              contact_id: data.id,
              company_id: currentCompany.id,
            });
        }
        const { error: memberErr } = await supabase.from('company_members').insert({
          company_id: currentCompany.id,
          user_id: existingProfile.id,
          role: 'CLIENT',
        });
        if (memberErr && memberErr.code !== '23505') console.warn('Add contact: company_members insert', memberErr);
      } catch (linkError) {
        console.warn('Error linking contact to company:', linkError);
      }

      // Reload contacts
      await loadContacts();

      // Close modal
      showAddContactModal = false;
      const modal = document.getElementById('add-contact-modal');
      if (modal) {
        modal.remove();
      }

      // Refresh contacts list
      const contactsListDiv = document.querySelector('#contacts-list');
      if (contactsListDiv) {
        contactsListDiv.innerHTML = getContactsListHTML();
      }

      // Show success message
      const successMsg = document.createElement('div');
      successMsg.textContent = 'Contact linked to existing account successfully!';
      successMsg.style.cssText = `
        position: fixed;
        top: 20px;
        right: 20px;
        background: #28a745;
        color: white;
        padding: 0.75rem 1.5rem;
        border-radius: 0.5rem;
        z-index: 100001;
        box-shadow: 0 4px 6px rgba(0,0,0,0.1);
      `;
      document.body.appendChild(successMsg);
      setTimeout(() => successMsg.remove(), 3000);

      window.linkingExistingAccount = false;
      return;
    } catch (error) {
      console.error('Error creating contact:', error);
      alert('An unexpected error occurred while creating the contact');
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Add';
      }
      window.linkingExistingAccount = false;
      return;
    }
  }

  // If we get here, either no existing profile was found, or user cancelled linking
  // Proceed with normal contact creation
  console.log('📝 Creating new contact (no existing account or user cancelled linking)');

  const submitBtn = document.getElementById('add-contact-submit-btn');
  if (submitBtn) {
    submitBtn.disabled = true;
    submitBtn.textContent = 'Adding...';
  }

  try {
    const { data, error } = await supabase
      .from('contacts')
      .insert({
        company_id: currentCompany.id,
        first_name: firstName,
        last_name: lastName,
        phone: phone || null,
        email: email || null,
        company_name: businessName || null,
        role_label: roleLabel || null,
        notes: notes || null,
        owner_id: currentUser.id,
        status: 'lead',
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      })
      .select()
      .single();

    if (error) {
      console.error('Error creating contact:', error);
      alert('Failed to create contact: ' + error.message);
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Add';
      }
      return;
    }

    console.log('✅ Contact created successfully:', data);

    // Reload contacts
    await loadContacts();

    // Close modal directly instead of re-rendering
    showAddContactModal = false;
    const modal = document.getElementById('add-contact-modal');
    if (modal) {
      modal.remove();
    }

    // Reset linking flag
    if (window.linkingExistingAccount) {
      window.linkingExistingAccount = false;
    }

    // Refresh contacts list if we're on contacts view
    const contactsListDiv = document.querySelector('#contacts-list');
    if (contactsListDiv) {
      contactsListDiv.innerHTML = getContactsListHTML();
    }

    // Show success message
    const successMsg = document.createElement('div');
    successMsg.textContent = 'Contact added successfully!';
    successMsg.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #28a745;
      color: white;
      padding: 0.75rem 1.5rem;
      border-radius: 0.5rem;
      z-index: 100001;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
    `;
    document.body.appendChild(successMsg);
    setTimeout(() => successMsg.remove(), 3000);
  } catch (error) {
    console.error('Error creating contact:', error);
    alert('An unexpected error occurred while creating the contact');
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Add';
    }
    window.linkingExistingAccount = false;
  }
};

// Open Edit Contact Modal
window.openEditContactModal = function (contactId) {
  editingContactId = contactId;
  showEditContactModal = true;

  // Inject modal directly
  const existingModal = document.getElementById('edit-contact-modal');
  if (existingModal) {
    existingModal.remove();
  }

  const modalHTML = renderEditContactModal();
  if (modalHTML) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = modalHTML;
    const modalElement = tempDiv.firstElementChild;

    document.body.appendChild(modalElement);

    // Populate form with contact data
    const contact = contacts.find(c => c.id === contactId);
    if (contact) {
      setTimeout(() => {
        const firstNameInput = document.getElementById('edit-contact-first-name');
        const lastNameInput = document.getElementById('edit-contact-last-name');
        const phoneInput = document.getElementById('edit-contact-phone');
        const emailInput = document.getElementById('edit-contact-email');
        const businessNameInput = document.getElementById('edit-contact-business-name');
        const roleLabelInput = document.getElementById('edit-contact-role-label');
        const notesInput = document.getElementById('edit-contact-notes');

        if (firstNameInput) firstNameInput.value = contact.first_name || '';
        if (lastNameInput) lastNameInput.value = contact.last_name || '';
        if (phoneInput) {
          // Format existing phone number if it exists
          const phone = contact.phone || '';
          if (phone) {
            const digits = phone.replace(/\D/g, '');
            if (digits.length === 10) {
              phoneInput.value = `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
            } else {
              phoneInput.value = phone;
            }
          } else {
            phoneInput.value = '';
          }
        }
        if (emailInput) emailInput.value = contact.email || '';
        if (businessNameInput) businessNameInput.value = contact.company || contact.company_name || '';
        if (roleLabelInput) roleLabelInput.value = contact.role || contact.role_label || '';
        if (notesInput) notesInput.value = contact.notes || '';
      }, 10);
    }

    // Animate in
    setTimeout(() => {
      if (modalElement) {
        modalElement.style.opacity = '1';
      }
    }, 10);
  } else {
    renderPMTool();
  }
};

// Close Edit Contact Modal
window.closeEditContactModal = function () {
  showEditContactModal = false;
  editingContactId = null;

  const existingModal = document.getElementById('edit-contact-modal');
  if (existingModal) {
    existingModal.remove();
  }

  renderPMTool();
};

// Render Edit Contact Modal
function renderEditContactModal() {
  if (!editingContactId) return '';

  return `
    <!-- Modal Overlay -->
    <div id="edit-contact-modal" onclick="if (event.target.id === 'edit-contact-modal') { closeEditContactModal(); }" style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 99999;
      animation: fadeIn 0.3s ease-out;
    ">
      <!-- Modal Content -->
      <div onclick="event.stopPropagation()" style="
        background: #ffffff;
        border-radius: 1rem;
        padding: 0;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
        max-width: 600px;
        width: 95%;
        max-height: 90vh;
        overflow-y: auto;
        animation: slideIn 0.3s ease-out;
        position: relative;
      ">
        <!-- Header -->
        <div style="
          padding: 1rem 1.5rem;
          border-bottom: 1px solid #e9ecef;
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: sticky;
          top: 0;
          background: #ffffff;
          z-index: 10;
        ">
          <button
            onclick="closeEditContactModal()"
            style="
              background: transparent;
              border: none;
              color: #f59e0b;
              cursor: pointer;
              font-size: 0.875rem;
              font-weight: 500;
              padding: 0.5rem;
            "
          >
            Cancel
          </button>
          <h2 style="
            margin: 0;
            color: #2c3e50;
            font-size: 1.125rem;
            font-weight: 700;
          ">
            Edit Contact
          </h2>
          <button
            id="edit-contact-submit-btn"
            onclick="handleUpdateContact(event)"
            style="
              background: #f59e0b;
              color: white;
              border: none;
              padding: 0.5rem 1rem;
              border-radius: 0.375rem;
              cursor: pointer;
              font-size: 0.875rem;
              font-weight: 600;
            "
          >
            Save
          </button>
        </div>

        <!-- Form Content -->
        <form id="edit-contact-form" onsubmit="handleUpdateContact(event); return false;" style="padding: 1.5rem;">
          <div style="display: flex; flex-direction: column; gap: 1.5rem;">
            <!-- First Name -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 500;
                font-size: 0.875rem;
              ">
                First Name *
              </label>
              <input
                type="text"
                id="edit-contact-first-name"
                placeholder="Enter first name"
                required
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e5e7eb;
                  border-radius: 0.5rem;
                  font-size: 1rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s ease;
                "
                onfocus="this.style.borderColor='#00ADB5'"
                onblur="this.style.borderColor='#e5e7eb'"
              />
            </div>

            <!-- Last Name -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 500;
                font-size: 0.875rem;
              ">
                Last Name *
              </label>
              <input
                type="text"
                id="edit-contact-last-name"
                placeholder="Enter last name"
                required
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e5e7eb;
                  border-radius: 0.5rem;
                  font-size: 1rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s ease;
                "
                onfocus="this.style.borderColor='#00ADB5'"
                onblur="this.style.borderColor='#e5e7eb'"
              />
            </div>

            <!-- Phone -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 500;
                font-size: 0.875rem;
              ">
                Phone
              </label>
              <input
                type="tel"
                id="edit-contact-phone"
                placeholder="(509) 585-4739"
                maxlength="14"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e5e7eb;
                  border-radius: 0.5rem;
                  font-size: 1rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s ease;
                "
                oninput="window.formatPhoneNumber(this)"
                onfocus="this.style.borderColor='#00ADB5'"
                onblur="this.style.borderColor='#e5e7eb'"
              />
            </div>

            <!-- Email -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 500;
                font-size: 0.875rem;
              ">
                Email
              </label>
              <input
                type="email"
                id="edit-contact-email"
                placeholder="Enter email address"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e5e7eb;
                  border-radius: 0.5rem;
                  font-size: 1rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s ease;
                "
                onfocus="this.style.borderColor='#00ADB5'"
                onblur="this.style.borderColor='#e5e7eb'"
              />
            </div>

            <!-- Business Name -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 500;
                font-size: 0.875rem;
              ">
                Business Name
              </label>
              <input
                type="text"
                id="edit-contact-business-name"
                placeholder="Enter business name"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e5e7eb;
                  border-radius: 0.5rem;
                  font-size: 1rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s ease;
                "
                onfocus="this.style.borderColor='#00ADB5'"
                onblur="this.style.borderColor='#e5e7eb'"
              />
            </div>

            <!-- Role Label -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 500;
                font-size: 0.875rem;
              ">
                Role Label
              </label>
              <input
                type="text"
                id="edit-contact-role-label"
                placeholder="Enter role label"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e5e7eb;
                  border-radius: 0.5rem;
                  font-size: 1rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s ease;
                "
                onfocus="this.style.borderColor='#00ADB5'"
                onblur="this.style.borderColor='#e5e7eb'"
              />
            </div>

            <!-- Notes -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 500;
                font-size: 0.875rem;
              ">
                Notes
              </label>
              <textarea
                id="edit-contact-notes"
                placeholder="Enter notes"
                rows="4"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e5e7eb;
                  border-radius: 0.5rem;
                  font-size: 1rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s ease;
                  resize: vertical;
                  font-family: inherit;
                "
                onfocus="this.style.borderColor='#00ADB5'"
                onblur="this.style.borderColor='#e5e7eb'"
              ></textarea>
            </div>
          </div>
          
          <!-- Delete Button -->
          <div style="
            margin-top: 2rem;
            padding-top: 2rem;
            border-top: 2px solid #e5e7eb;
          ">
            <button
              type="button"
              onclick="handleDeleteContact('${editingContactId}')"
              style="
                width: 100%;
                background: #dc2626;
                color: white;
                border: none;
                padding: 0.75rem 1.5rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-size: 0.9375rem;
                font-weight: 600;
                transition: all 0.2s;
              "
              onmouseover="this.style.background='#b91c1c'"
              onmouseout="this.style.background='#dc2626'"
            >
              Delete Contact
            </button>
          </div>
        </form>
      </div>
    </div>
  `;
}

// Handle Update Contact
window.handleUpdateContact = async function (e) {
  if (e) e.preventDefault();

  if (!editingContactId) return;

  const firstNameInput = document.getElementById('edit-contact-first-name');
  const lastNameInput = document.getElementById('edit-contact-last-name');
  const phoneInput = document.getElementById('edit-contact-phone');
  const emailInput = document.getElementById('edit-contact-email');
  const businessNameInput = document.getElementById('edit-contact-business-name');
  const roleLabelInput = document.getElementById('edit-contact-role-label');
  const notesInput = document.getElementById('edit-contact-notes');

  const firstName = firstNameInput?.value?.trim() || '';
  const lastName = lastNameInput?.value?.trim() || '';
  const phone = phoneInput?.value?.replace(/\D/g, '') || ''; // Strip formatting, keep only digits
  const email = emailInput?.value?.trim() || '';
  const businessName = businessNameInput?.value?.trim() || '';
  const roleLabel = roleLabelInput?.value?.trim() || '';
  const notes = notesInput?.value?.trim() || '';

  // Validation
  if (!firstName || !lastName) {
    alert('First name and last name are required');
    return;
  }

  const submitBtn = document.getElementById('edit-contact-submit-btn');
  if (submitBtn) {
    submitBtn.disabled = true;
    submitBtn.textContent = 'Saving...';
  }

  try {
    const { data, error } = await supabase
      .from('contacts')
      .update({
        first_name: firstName,
        last_name: lastName,
        phone: phone || null,
        email: email || null,
        company_name: businessName || null,
        role_label: roleLabel || null,
        notes: notes || null,
        updated_at: new Date().toISOString(),
      })
      .eq('id', editingContactId)
      .select()
      .single();

    if (error) {
      console.error('Error updating contact:', error);
      alert('Failed to update contact: ' + error.message);
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Save';
      }
      return;
    }

    console.log('✅ Contact updated successfully:', data);

    // Reload contacts
    await loadContacts();

    // Close modal
    closeEditContactModal();

    // Update contact detail if viewing this contact
    if (selectedContactId === editingContactId) {
      await updateContactDetailContent();
    }

    // Refresh contacts list
    const contactsListDiv = document.querySelector('#contacts-list');
    if (contactsListDiv) {
      contactsListDiv.innerHTML = getContactsListHTML();
    }

    // Show success message
    showNotification('Contact updated successfully!', 'success');
  } catch (error) {
    console.error('Error updating contact:', error);
    alert('An unexpected error occurred while updating the contact');
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Save';
    }
  }
};

// Open Delete Contact Confirmation Modal
window.handleDeleteContact = function (contactId) {
  deletingContactId = contactId;
  showDeleteContactModal = true;

  // Inject modal directly
  const existingModal = document.getElementById('delete-contact-modal');
  if (existingModal) {
    existingModal.remove();
  }

  const modalHTML = renderDeleteContactModal();
  if (modalHTML) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = modalHTML;
    const modalElement = tempDiv.firstElementChild;

    document.body.appendChild(modalElement);

    // Animate in
    setTimeout(() => {
      if (modalElement) {
        modalElement.style.opacity = '1';
      }
    }, 10);
  } else {
    renderPMTool();
  }
};

// Close Delete Contact Modal
window.closeDeleteContactModal = function () {
  showDeleteContactModal = false;
  deletingContactId = null;

  const existingModal = document.getElementById('delete-contact-modal');
  if (existingModal) {
    existingModal.remove();
  }
};

// Render Delete Contact Confirmation Modal
function renderDeleteContactModal() {
  if (!deletingContactId) return '';

  const contact = contacts.find(c => c.id === deletingContactId);
  if (!contact) return '';

  const contactName = `${contact.first_name || ''} ${contact.last_name || ''}`.trim() || 'this contact';

  return `
    <div
      id="delete-contact-modal"
      onclick="if (event.target.id === 'delete-contact-modal') closeDeleteContactModal()"
      style="
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.6);
        z-index: 100002;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 1rem;
        animation: fadeIn 0.3s ease-out;
      "
    >
      <div
        onclick="event.stopPropagation()"
        style="
          background: #ffffff;
          border-radius: 1rem;
          width: 100%;
          max-width: 500px;
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
          animation: slideIn 0.3s ease-out;
        "
      >
        <!-- Header -->
        <div style="
          padding: 1.5rem;
          border-bottom: 1px solid #e5e7eb;
        ">
          <div style="
            display: flex;
            align-items: center;
            gap: 1rem;
            margin-bottom: 1rem;
          ">
            <div style="
              width: 48px;
              height: 48px;
              border-radius: 50%;
              background: #fee2e2;
              color: #dc2626;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 1.5rem;
              flex-shrink: 0;
            ">
              ⚠️
            </div>
            <h2 style="
              margin: 0;
              color: #2c3e50;
              font-size: 1.5rem;
              font-weight: 700;
            ">
              Delete Contact
            </h2>
          </div>
          <p style="
            margin: 0;
            color: #6c757d;
            font-size: 0.9375rem;
            line-height: 1.5;
          ">
            You are about to permanently delete <strong>${contactName}</strong> and ALL associated data.
          </p>
        </div>

        <!-- Warning Content -->
        <div style="
          padding: 1.5rem;
          background: #fef2f2;
          border-left: 4px solid #dc2626;
        ">
          <div style="
            color: #991b1b;
            font-size: 0.9375rem;
            line-height: 1.6;
            margin-bottom: 1rem;
          ">
            <strong>This will permanently delete:</strong>
          </div>
          <ul style="
            margin: 0;
            padding-left: 1.5rem;
            color: #991b1b;
            font-size: 0.9375rem;
            line-height: 1.8;
          ">
            <li>The contact record</li>
            <li>Associated user profile (if exists)</li>
            <li>Company membership (if exists)</li>
            <li>All related data and history</li>
          </ul>
          <div style="
            margin-top: 1rem;
            padding: 0.75rem;
            background: #ffffff;
            border-radius: 0.5rem;
            color: #dc2626;
            font-weight: 600;
            font-size: 0.875rem;
          ">
            ⚠️ This action CANNOT be undone.
          </div>
        </div>

        <!-- Actions -->
        <div style="
          padding: 1.5rem;
          border-top: 1px solid #e5e7eb;
          display: flex;
          gap: 0.75rem;
          justify-content: flex-end;
        ">
          <button
            onclick="closeDeleteContactModal()"
            style="
              background: #f3f4f6;
              color: #374151;
              border: none;
              padding: 0.75rem 1.5rem;
              border-radius: 0.5rem;
              cursor: pointer;
              font-size: 0.9375rem;
              font-weight: 600;
              transition: all 0.2s;
            "
            onmouseover="this.style.background='#e5e7eb'"
            onmouseout="this.style.background='#f3f4f6'"
          >
            Cancel
          </button>
          <button
            onclick="confirmDeleteContact()"
            style="
              background: #dc2626;
              color: white;
              border: none;
              padding: 0.75rem 1.5rem;
              border-radius: 0.5rem;
              cursor: pointer;
              font-size: 0.9375rem;
              font-weight: 600;
              transition: all 0.2s;
            "
            onmouseover="this.style.background='#b91c1c'"
            onmouseout="this.style.background='#dc2626'"
          >
            Delete Contact
          </button>
        </div>
      </div>
    </div>
  `;
}

// Confirm Delete Contact
window.confirmDeleteContact = async function () {
  if (!deletingContactId) return;

  const contact = contacts.find(c => c.id === deletingContactId);
  if (!contact) {
    showNotification('Contact not found', 'error');
    closeDeleteContactModal();
    return;
  }

  const contactName = `${contact.first_name || ''} ${contact.last_name || ''}`.trim() || 'this contact';

  try {
    console.log('🗑️ Attempting to delete contact:', deletingContactId);
    console.log('🗑️ Contact owner_id:', contact.owner_id, 'Current user:', currentUser?.id);
    console.log('🗑️ Is manager/owner:', isManagerOrOwner());

    // Use RPC function to delete contact (bypasses RLS)
    const { data: deleteResult, error: deleteError } = await supabase
      .rpc('delete_contact', {
        p_contact_id: deletingContactId
      });

    if (deleteError) {
      console.error('❌ Error deleting contact:', deleteError);

      // Extract error message
      let errorMessage = 'Failed to delete contact.';
      if (deleteError.message) {
        errorMessage = deleteError.message;
      } else if (deleteError.details) {
        errorMessage = deleteError.details;
      }

      showNotification(errorMessage, 'error');
      closeDeleteContactModal();
      return;
    }

    if (!deleteResult || deleteResult.length === 0) {
      console.error('❌ Contact was not deleted. No rows affected.');
      showNotification('Failed to delete contact. The contact may not exist or you may not have permission.', 'error');
      closeDeleteContactModal();
      return;
    }

    console.log('✅ Contact deleted successfully:', deleteResult);

    // Close the delete modal
    closeDeleteContactModal();

    // Close the edit modal if open
    closeEditContactModal();

    // Reload contacts
    await loadContacts();

    // If we were viewing this contact, close the detail view
    if (selectedContactId === deletingContactId) {
      selectedContactId = null;
    }

    // Refresh contacts list
    const contactsListDiv = document.querySelector('#contacts-list');
    if (contactsListDiv) {
      contactsListDiv.innerHTML = getContactsListHTML();
    }

    // Refresh the main view
    renderPMTool();

    // Show success message
    showNotification('Contact deleted successfully', 'success');
  } catch (error) {
    console.error('Error deleting contact:', error);
    showNotification('An unexpected error occurred while deleting the contact', 'error');
    closeDeleteContactModal();
  }
};

// Render Won/Lost Selection Modal
function renderWonLostModal() {
  if (!pendingOpportunityUpdate) return '';

  const opp = pendingOpportunityUpdate.opportunity;
  const oppTitle = opp.title || 'Untitled Deal';

  return `
    <!-- Won/Lost Modal Overlay -->
    <div id="won-lost-modal" onclick="if (event.target.id === 'won-lost-modal') { closeWonLostModal(); }" style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 100000;
      animation: fadeIn 0.3s ease-out;
    ">
      <!-- Modal Content -->
      <div onclick="event.stopPropagation()" style="
        background: #ffffff;
        border-radius: 1rem;
        padding: 2rem;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
        max-width: 400px;
        width: 90%;
        animation: slideIn 0.3s ease-out;
      ">
        <h2 style="
          margin: 0 0 1rem 0;
          color: #2c3e50;
          font-size: 1.25rem;
          font-weight: 700;
        ">
          Archive Opportunity
        </h2>
        
        <p style="
          margin: 0 0 1.5rem 0;
          color: #6c757d;
          font-size: 0.875rem;
        ">
          Was this lead won or lost?
        </p>
        
        <div style="
          background: #f8f9fa;
          border-radius: 0.5rem;
          padding: 1rem;
          margin-bottom: 1.5rem;
        ">
          <div style="
            font-weight: 600;
            color: #2c3e50;
            margin-bottom: 0.25rem;
          ">${oppTitle}</div>
          ${opp.contact ? `
            <div style="
              font-size: 0.875rem;
              color: #6c757d;
            ">${opp.contact.first_name || ''} ${opp.contact.last_name || ''}</div>
          ` : ''}
        </div>
        
        <div style="display: flex; gap: 1rem;">
          <button
            onclick="selectWonLost('won')"
            style="
              flex: 1;
              background: #10b981;
              color: white;
              border: none;
              padding: 0.875rem 1.5rem;
              border-radius: 0.5rem;
              cursor: pointer;
              font-size: 0.875rem;
              font-weight: 600;
              transition: all 0.2s ease;
            "
            onmouseover="this.style.background='#059669'"
            onmouseout="this.style.background='#10b981'"
          >
            ✅ Won
          </button>
          <button
            onclick="selectWonLost('lost')"
            style="
              flex: 1;
              background: #dc2626;
              color: white;
              border: none;
              padding: 0.875rem 1.5rem;
              border-radius: 0.5rem;
              cursor: pointer;
              font-size: 0.875rem;
              font-weight: 600;
              transition: all 0.2s ease;
            "
            onmouseover="this.style.background='#b91c1c'"
            onmouseout="this.style.background='#dc2626'"
          >
            ❌ Lost
          </button>
        </div>
        
        <button
          onclick="closeWonLostModal()"
          style="
            width: 100%;
            margin-top: 0.75rem;
            background: transparent;
            color: #6c757d;
            border: 1px solid #e5e7eb;
            padding: 0.625rem 1rem;
            border-radius: 0.5rem;
            cursor: pointer;
            font-size: 0.875rem;
            font-weight: 500;
            transition: all 0.2s ease;
          "
          onmouseover="this.style.background='#f8f9fa'"
          onmouseout="this.style.background='transparent'"
        >
          Cancel
        </button>
      </div>
    </div>
  `;
}

// Handle Won/Lost selection
window.selectWonLost = async function (stage) {
  if (!pendingOpportunityUpdate) return;

  const { opportunityId, opportunity } = pendingOpportunityUpdate;
  const stageToSave = stage;

  try {
    const updateData = {
      stage: stageToSave,
      closed_at: new Date().toISOString()
    };

    const { error: updateError } = await supabase
      .from('sales_opportunities')
      .update(updateData)
      .eq('id', opportunityId);

    if (updateError) {
      console.error('Error updating opportunity stage:', updateError);
      alert('Failed to update opportunity stage: ' + updateError.message);
      return;
    }

    // Update local state
    opportunity.stage = stageToSave;
    opportunity.closed_at = updateData.closed_at;

    // Create activity log entry for won/lost opportunity
    if (opportunity.contact_id) {
      const eventType = stageToSave === 'won' ? 'opportunity_won' : 'opportunity_lost';
      const title = stageToSave === 'won'
        ? `Sale won: ${opportunity.title || 'Untitled Opportunity'}`
        : `Sale lost: ${opportunity.title || 'Untitled Opportunity'}`;
      const description = `Amount: $${opportunity.amount || 0}`;

      console.log(`💰 [Sales Opportunity] Creating activity log for ${stageToSave} opportunity ${opportunityId}`);
      await createActivityLogEntry(
        opportunity.contact_id,
        eventType,
        title,
        description,
        {
          opportunity_id: opportunityId,
          amount: opportunity.amount,
          stage: stageToSave
        }
      );
    }

    // If editing in form, update form data
    if (editingOpportunityId === opportunityId) {
      opportunityFormData.stage = stageToSave;
      opportunityFormData.archived = true;

      // Update stage buttons in form
      const stageButtons = document.querySelectorAll('#stage-buttons button');
      stageButtons.forEach(btn => {
        const value = btn.id.replace('stage-btn-', '');
        if (value === stageToSave) {
          btn.style.borderColor = '#f59e0b';
          btn.style.background = '#fef3c7';
          btn.style.color = '#f59e0b';
        } else {
          btn.style.borderColor = '#e5e7eb';
          btn.style.background = '#ffffff';
          btn.style.color = '#6c757d';
        }
      });

      // Update archived toggle UI
      updateArchivedToggleUI();
    }

    // Close modal
    closeWonLostModal();

    // Reload opportunities to get fresh data
    await loadSalesOpportunities();

    // If we're viewing a contact detail, refresh the contact view to update activity log
    if (currentScreen === 'sales' && selectedContactId && opportunity.contact_id === selectedContactId) {
      console.log(`🔄 [Sales Opportunity] Refreshing contact detail view for contact ${selectedContactId}`);
      await updateContactDetailContent();
    } else {
      // Re-render the dashboard
      renderPMTool();
    }

    console.log('✅ Opportunity archived successfully as', stageToSave);
  } catch (error) {
    console.error('Error updating opportunity:', error);
    alert('Failed to update opportunity: ' + error.message);
  }
};

// Close Won/Lost modal
window.closeWonLostModal = function () {
  showWonLostModal = false;
  pendingOpportunityUpdate = null;
  renderPMTool();
};

// Render Kanban View for Sales Deals
function renderKanbanView(kanbanColumns, getChanceColor, getChanceLabel, formatFollowUpDate) {
  const columnConfig = [
    { key: 'new', label: 'New', color: '#6b7280' },
    { key: 'contacted', label: 'Contacted', color: '#3b82f6' },
    { key: 'qualified', label: 'Qualified', color: '#8b5cf6' },
    { key: 'proposal', label: 'Proposal', color: '#10b981' },
    { key: 'negotiation', label: 'Negotiation', color: '#f59e0b' },
    { key: 'active', label: 'Active', color: '#10b981' },
    { key: 'archived', label: 'Archived', color: '#6b7280' }
  ];

  return `
    <div style="
      margin-bottom: 2rem;
      height: calc(100vh - 200px);
      overflow: hidden;
    ">
      <div id="kanban-scroll-container" style="
        display: flex;
        gap: 1rem;
        height: 100%;
        overflow-x: auto;
        overflow-y: hidden;
        padding-bottom: 1rem;
        padding-right: 0.5rem;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: thin;
        scrollbar-color: #f59e0b #f8f9fa;
      ">
        <style>
          /* Modern scrollbar styling for kanban container */
          #kanban-scroll-container::-webkit-scrollbar {
            width: 8px;
            height: 8px;
          }
          #kanban-scroll-container::-webkit-scrollbar-track {
            background: #f8f9fa;
            border-radius: 4px;
          }
          #kanban-scroll-container::-webkit-scrollbar-thumb {
            background: #f59e0b;
            border-radius: 4px;
            transition: background 0.2s ease;
          }
          #kanban-scroll-container::-webkit-scrollbar-thumb:hover {
            background: #d97706;
          }
        </style>
        ${columnConfig.map(column => {
    const deals = kanbanColumns[column.key] || [];
    const count = deals.length;

    return `
            <div style="
              min-width: 300px;
              max-width: 300px;
              background: #f8f9fa;
              border-radius: 0.75rem;
              padding: 1rem;
              display: flex;
              flex-direction: column;
              height: 100%;
              overflow: hidden;
            ">
              <!-- Column Header -->
              <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 0.75rem; flex-shrink: 0;">
                <div style="display: flex; align-items: center; gap: 0.5rem;">
                  <div style="
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    background: ${column.color};
                  "></div>
                  <h3 style="
                    margin: 0;
                    color: #2c3e50;
                    font-size: 0.875rem;
                    font-weight: 600;
                  ">${column.label}</h3>
                </div>
                <div style="
                  background: ${column.color}20;
                  color: ${column.color};
                  padding: 0.25rem 0.5rem;
                  border-radius: 1rem;
                  font-size: 0.75rem;
                  font-weight: 600;
                ">${count}</div>
              </div>
              
              <!-- Deal Cards -->
              <div 
                class="kanban-column-scroll kanban-drop-zone" 
                data-stage="${column.key}"
                ondrop="handleKanbanDrop(event, '${column.key}')"
                ondragover="handleKanbanDragOver(event)"
                ondragleave="handleKanbanDragLeave(event)"
                style="
                display: flex;
                flex-direction: column;
                gap: 0.75rem;
                overflow-y: auto;
                flex: 1;
                padding-right: 0.5rem;
                scrollbar-width: thin;
                scrollbar-color: #f59e0b #f8f9fa;
                min-height: 100px;
              ">
                <style>
                  /* Modern scrollbar styling for kanban columns */
                  .kanban-column-scroll::-webkit-scrollbar {
                    width: 6px;
                  }
                  .kanban-column-scroll::-webkit-scrollbar-track {
                    background: #f8f9fa;
                    border-radius: 3px;
                  }
                  .kanban-column-scroll::-webkit-scrollbar-thumb {
                    background: #f59e0b;
                    border-radius: 3px;
                    transition: background 0.2s ease;
                  }
                  .kanban-column-scroll::-webkit-scrollbar-thumb:hover {
                    background: #d97706;
                  }
                  
                  /* Drag and drop styling */
                  .kanban-drop-zone.drag-over {
                    background-color: rgba(245, 158, 11, 0.1) !important;
                    border: 2px dashed #f59e0b !important;
                  }
                  
                  [draggable="true"].dragging {
                    opacity: 0.5;
                    cursor: grabbing !important;
                  }
                  
                  [draggable="true"]:not(.dragging) {
                    cursor: grab;
                  }
                  
                  [draggable="true"]:not(.dragging):hover {
                    cursor: grab;
                  }
                </style>
                ${deals.length === 0 ? `
                  <div style="
                    padding: 2rem 1rem;
                    text-align: center;
                    color: #9ca3af;
                    font-size: 0.875rem;
                  ">
                    No deals
                  </div>
                ` : deals.map(opp => {
      const chanceColor = getChanceColor(opp.chance);
      const chanceLabel = getChanceLabel(opp.chance);
      const followUpDate = formatFollowUpDate(opp.follow_up_date);
      const assignedUser = opp.assigned_user
        ? `${opp.assigned_user.first_name || ''} ${opp.assigned_user.last_name || ''}`.trim()
        : 'Unassigned';

      // Determine if archived (has closed_at or stage is won/lost)
      const isArchived = !!opp.closed_at || opp.stage === 'won' || opp.stage === 'lost';
      const cardBgColor = isArchived ? '#f8f9fa' : '#ffffff';

      return `
                    <div 
                      draggable="true"
                      data-opportunity-id="${opp.id}"
                      data-current-stage="${column.key}"
                      ondragstart="handleKanbanDragStart(event, '${opp.id}', '${column.key}')"
                      ondragend="handleKanbanDragEnd(event)"
                      onclick="if (!isDragging) { event.stopPropagation(); editOpportunity('${opp.id}'); }" 
                      style="
                      background: ${cardBgColor};
                      border-left: 4px solid ${column.color};
                      border-radius: 0.5rem;
                      padding: 1rem;
                      box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                      cursor: grab;
                      transition: all 0.2s ease;
                      flex-shrink: 0;
                      opacity: ${isArchived ? 0.85 : 1};
                    " 
                    onmouseover="if (!this.classList.contains('dragging')) this.style.boxShadow='0 2px 6px rgba(0,0,0,0.15)'; this.style.cursor='grab'" 
                    onmousedown="this.style.cursor='grabbing'"
                    onmouseout="if (!this.classList.contains('dragging')) this.style.boxShadow='0 1px 3px rgba(0,0,0,0.1)'; this.style.cursor='grab'">
                      <!-- Probability Badge -->
                      <div style="display: flex; justify-content: flex-end; margin-bottom: 0.5rem;">
                        <span style="
                          background: ${chanceColor === '#10b981' ? '#dc2626' : chanceColor === '#f59e0b' ? '#f59e0b' : '#10b981'}20;
                          color: ${chanceColor === '#10b981' ? '#dc2626' : chanceColor === '#f59e0b' ? '#f59e0b' : '#10b981'};
                          padding: 0.25rem 0.5rem;
                          border-radius: 0.25rem;
                          font-size: 0.75rem;
                          font-weight: 600;
                        ">${chanceLabel}</span>
                      </div>
                      
                      <!-- Deal Title -->
                      <h4 style="
                        margin: 0 0 0.5rem 0;
                        color: #2c3e50;
                        font-size: 0.875rem;
                        font-weight: 700;
                      ">${opp.title || 'Untitled Deal'}</h4>
                      
                      <!-- Subtitle -->
                      ${opp.contact ? `
                        <p style="
                          margin: 0 0 0.5rem 0;
                          color: #6c757d;
                          font-size: 0.75rem;
                        ">${opp.contact.first_name || ''} ${opp.contact.last_name || ''}</p>
                      ` : ''}
                      
                      <!-- Amount -->
                      <p style="
                        margin: 0 0 0.5rem 0;
                        color: #f59e0b;
                        font-size: 1rem;
                        font-weight: 700;
                      ">$${(opp.amount || 0).toLocaleString()}</p>
                      
                      <!-- Assigned User -->
                      <div style="
                        display: flex;
                        align-items: center;
                        gap: 0.375rem;
                        margin-bottom: 0.5rem;
                        font-size: 0.75rem;
                        color: #000000;
                      ">
                        ${assignedUser}
                      </div>
                      
                      <!-- Follow-up Date -->
                      ${followUpDate ? `
                        <div style="
                          display: flex;
                          align-items: center;
                          gap: 0.375rem;
                          font-size: 0.75rem;
                          color: #000000;
                          margin-bottom: 0.5rem;
                        ">
                          Follow-up: ${followUpDate}
                        </div>
                      ` : ''}
                      
                      <!-- View Button -->
                      <button 
                        onclick="event.stopPropagation(); editOpportunity('${opp.id}')"
                        style="
                          width: 100%;
                          background: #f59e0b;
                          color: white;
                          border: none;
                          padding: 0.5rem;
                          border-radius: 0.375rem;
                          font-size: 0.75rem;
                          font-weight: 600;
                          cursor: pointer;
                          transition: background-color 0.2s;
                          margin-top: 0.5rem;
                        "
                        onmouseover="this.style.background='#d97706'"
                        onmouseout="this.style.background='#f59e0b'"
                      >
                        View
                      </button>
                    </div>
                  `;
    }).join('')}
              </div>
            </div>
          `;
  }).join('')}
      </div>
    </div>
  `;
}

// Kanban drag and drop handlers
let draggedOpportunityId = null;
let draggedFromStage = null;
let isDragging = false;
let kanbanAutoScrollInterval = null;
let showWonLostModal = false;
let pendingOpportunityUpdate = null; // { opportunityId, targetStage, opportunity }

// Auto-scroll kanban container when dragging near edges
function startKanbanAutoScroll() {
  // Clear any existing interval
  if (kanbanAutoScrollInterval) {
    clearInterval(kanbanAutoScrollInterval);
  }
}

function stopKanbanAutoScroll() {
  if (kanbanAutoScrollInterval) {
    clearInterval(kanbanAutoScrollInterval);
    kanbanAutoScrollInterval = null;
  }
}

function handleKanbanAutoScroll(event) {
  const container = document.getElementById('kanban-scroll-container');
  if (!container) return;

  const containerRect = container.getBoundingClientRect();
  const mouseX = event.clientX;
  const scrollThreshold = 100; // Distance from edge to trigger scroll
  const scrollSpeed = 10; // Pixels per scroll

  // Clear existing interval
  stopKanbanAutoScroll();

  // Check if mouse is near left edge
  if (mouseX - containerRect.left < scrollThreshold && container.scrollLeft > 0) {
    kanbanAutoScrollInterval = setInterval(() => {
      container.scrollLeft = Math.max(0, container.scrollLeft - scrollSpeed);
    }, 16); // ~60fps
  }
  // Check if mouse is near right edge
  else if (containerRect.right - mouseX < scrollThreshold &&
    container.scrollLeft < container.scrollWidth - container.clientWidth) {
    kanbanAutoScrollInterval = setInterval(() => {
      container.scrollLeft = Math.min(
        container.scrollWidth - container.clientWidth,
        container.scrollLeft + scrollSpeed
      );
    }, 16); // ~60fps
  }
}

window.handleKanbanDragStart = function (event, opportunityId, currentStage) {
  isDragging = true;
  draggedOpportunityId = opportunityId;
  draggedFromStage = currentStage;
  event.dataTransfer.effectAllowed = 'move';
  event.dataTransfer.setData('text/html', event.target.outerHTML);

  // Add dragging class for styling
  event.target.classList.add('dragging');
  event.target.style.opacity = '0.5';

  // Store the original element for reference
  event.dataTransfer.setData('opportunity-id', opportunityId);

  // Start auto-scroll when dragging
  startKanbanAutoScroll();
};

window.handleKanbanDragEnd = function (event) {
  // Remove dragging class
  event.target.classList.remove('dragging');
  event.target.style.opacity = '1';

  // Stop auto-scroll
  stopKanbanAutoScroll();

  // Reset drag state after a short delay to prevent click events
  setTimeout(() => {
    isDragging = false;
    draggedOpportunityId = null;
    draggedFromStage = null;
  }, 100);

  // Remove drag-over styling from all drop zones
  document.querySelectorAll('.kanban-drop-zone').forEach(zone => {
    zone.style.backgroundColor = '';
    zone.style.border = '';
  });
};

window.handleKanbanDragOver = function (event) {
  event.preventDefault();
  event.dataTransfer.dropEffect = 'move';

  // Add visual feedback
  const dropZone = event.currentTarget;
  dropZone.style.backgroundColor = 'rgba(245, 158, 11, 0.1)';
  dropZone.style.border = '2px dashed #f59e0b';

  // Auto-scroll when near edges
  handleKanbanAutoScroll(event);
};

// Global drag handler for auto-scroll (works even when not over drop zones)
if (typeof document !== 'undefined') {
  document.addEventListener('dragover', function (event) {
    if (isDragging && draggedOpportunityId) {
      handleKanbanAutoScroll(event);
    }
  });

  document.addEventListener('dragend', function (event) {
    if (isDragging) {
      stopKanbanAutoScroll();
    }
  });
}

window.handleKanbanDragLeave = function (event) {
  // Only remove styling if we're actually leaving the drop zone
  const dropZone = event.currentTarget;
  const rect = dropZone.getBoundingClientRect();
  const x = event.clientX;
  const y = event.clientY;

  if (x < rect.left || x > rect.right || y < rect.top || y > rect.bottom) {
    dropZone.style.backgroundColor = '';
    dropZone.style.border = '';
  }
};

window.handleKanbanDrop = async function (event, targetStage) {
  event.preventDefault();
  event.stopPropagation();

  // Remove drag-over styling
  const dropZone = event.currentTarget;
  dropZone.style.backgroundColor = '';
  dropZone.style.border = '';

  const opportunityId = event.dataTransfer.getData('opportunity-id') || draggedOpportunityId;

  if (!opportunityId) {
    console.error('No opportunity ID found in drag data');
    return;
  }

  // Don't do anything if dropped in the same column
  if (targetStage === draggedFromStage) {
    console.log('Dropped in same column, no update needed');
    return;
  }

  // Find the opportunity
  const opportunity = salesOpportunities.find(opp => opp.id === opportunityId);
  if (!opportunity) {
    console.error('Opportunity not found:', opportunityId);
    return;
  }

  // Map target stage (handle 'active' and 'archived' special cases)
  let stageToSave = targetStage;
  let updateData = { stage: stageToSave };

  // Check if dragging FROM archived (won/lost) to a regular stage
  const isDraggingFromArchived = draggedFromStage === 'archived' ||
    opportunity.stage === 'won' ||
    opportunity.stage === 'lost' ||
    opportunity.closed_at;

  if (targetStage === 'active') {
    // Active column is for won deals that are NOT archived
    stageToSave = 'won';
    updateData.stage = 'won';
    // Clear closed_at to unarchive (active = won but not archived)
    updateData.closed_at = null;
  } else if (targetStage === 'archived') {
    // Archived contains both won and lost deals
    // Check if stage is already won or lost
    const isAlreadyWonOrLost = opportunity.stage === 'won' || opportunity.stage === 'lost';

    if (!isAlreadyWonOrLost) {
      // Show modal to ask user if this lead was won or lost
      pendingOpportunityUpdate = { opportunityId, targetStage, opportunity };
      showWonLostModal = true;
      renderPMTool();
      return; // Exit early, will be handled by modal
    } else {
      // Keep existing stage (won or lost) and ensure it's archived
      stageToSave = opportunity.stage;
      updateData.stage = stageToSave;
    }

    // Always set closed_at when moving to archived (required for archived status)
    updateData.closed_at = new Date().toISOString();
  } else if (isDraggingFromArchived && targetStage !== 'active' && targetStage !== 'archived') {
    // Dragging FROM archived to a regular stage - unarchive it
    stageToSave = targetStage;
    updateData.stage = stageToSave;
    // Clear closed_at to unarchive
    updateData.closed_at = null;
  }

  console.log(`Moving opportunity ${opportunityId} from ${draggedFromStage} to ${targetStage} (saving as ${stageToSave})`);

  try {
    // Update the opportunity stage in the database
    const { error: updateError } = await supabase
      .from('sales_opportunities')
      .update(updateData)
      .eq('id', opportunityId);

    if (updateError) {
      console.error('Error updating opportunity stage:', updateError);
      alert('Failed to update opportunity stage: ' + updateError.message);
      return;
    }

    // Update local state
    opportunity.stage = stageToSave;
    opportunity.closed_at = updateData.closed_at || null;

    // If editing in form, update form data to reflect the change
    if (editingOpportunityId === opportunityId) {
      opportunityFormData.stage = stageToSave;
      opportunityFormData.archived = !!updateData.closed_at; // Archived = has closed_at

      // Update stage buttons in form
      const stageButtons = document.querySelectorAll('#stage-buttons button');
      stageButtons.forEach(btn => {
        const value = btn.id.replace('stage-btn-', '');
        if (value === stageToSave) {
          btn.style.borderColor = '#f59e0b';
          btn.style.background = '#fef3c7';
          btn.style.color = '#f59e0b';
        } else {
          btn.style.borderColor = '#e5e7eb';
          btn.style.background = '#ffffff';
          btn.style.color = '#6c757d';
        }
      });

      // Update archived toggle UI
      updateArchivedToggleUI();
    }

    // Reload opportunities to get fresh data
    await loadSalesOpportunities();

    // Re-render the dashboard
    renderPMTool();

    console.log('✅ Opportunity stage updated successfully');
  } catch (error) {
    console.error('Error updating opportunity:', error);
    alert('Failed to update opportunity: ' + error.message);
  }
};

// Render Reports View
function renderReportsView() {
  // Calculate date range based on filter
  const now = new Date();
  let startDate = new Date();
  let endDate = new Date();

  switch (reportsDateFilter) {
    case 'week':
      startDate = new Date(now);
      startDate.setDate(now.getDate() - now.getDay()); // Start of week (Sunday)
      startDate.setHours(0, 0, 0, 0);
      endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6);
      endDate.setHours(23, 59, 59, 999);
      break;
    case 'month':
      startDate = new Date(now.getFullYear(), now.getMonth(), 1);
      endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999);
      break;
    case 'quarter':
      const quarter = Math.floor(now.getMonth() / 3);
      startDate = new Date(now.getFullYear(), quarter * 3, 1);
      endDate = new Date(now.getFullYear(), (quarter + 1) * 3, 0, 23, 59, 59, 999);
      break;
    case 'custom':
      if (reportsCustomStartDate && reportsCustomEndDate) {
        startDate = new Date(reportsCustomStartDate);
        startDate.setHours(0, 0, 0, 0);
        endDate = new Date(reportsCustomEndDate);
        endDate.setHours(23, 59, 59, 999);
      } else {
        // Default to current month if custom dates not set
        startDate = new Date(now.getFullYear(), now.getMonth(), 1);
        endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999);
      }
      break;
    default:
      // All time
      startDate = new Date(0);
      endDate = new Date();
  }

  // Filter opportunities by date range
  const filteredOpportunities = salesOpportunities.filter(opp => {
    if (!opp.created_at) return false;
    const oppDate = new Date(opp.created_at);
    return oppDate >= startDate && oppDate <= endDate;
  });

  // Calculate metrics
  const totalLeads = contacts.length;
  const activeOpportunities = filteredOpportunities.filter(opp =>
    opp.stage !== 'won' && opp.stage !== 'lost'
  ).length;
  const dealsWon = filteredOpportunities.filter(opp => opp.stage === 'won').length;
  const dealsLost = filteredOpportunities.filter(opp => opp.stage === 'lost').length;
  const conversionRate = totalLeads > 0 ? (dealsWon / totalLeads) * 100 : 0;
  const openValue = filteredOpportunities
    .filter(opp => opp.stage !== 'won' && opp.stage !== 'lost')
    .reduce((sum, opp) => sum + (opp.amount || 0), 0);

  // Pipeline funnel by stage
  const pipelineStages = [
    { key: 'new', label: 'New' },
    { key: 'contacted', label: 'Contacted' },
    { key: 'qualified', label: 'Qualified' },
    { key: 'proposal', label: 'Proposal' },
    { key: 'negotiation', label: 'Negotiation' }
  ];

  const pipelineData = pipelineStages.map(stage => {
    const count = filteredOpportunities.filter(opp =>
      opp.stage === stage.key && opp.stage !== 'won' && opp.stage !== 'lost'
    ).length;
    const maxCount = Math.max(...pipelineStages.map(s =>
      filteredOpportunities.filter(opp =>
        opp.stage === s.key && opp.stage !== 'won' && opp.stage !== 'lost'
      ).length
    ), 1);
    const percentage = maxCount > 0 ? (count / maxCount) * 100 : 0;

    return { ...stage, count, percentage };
  });

  // Lead sources
  const sourceCounts = {};
  filteredOpportunities.forEach(opp => {
    const source = opp.source || 'other';
    sourceCounts[source] = (sourceCounts[source] || 0) + 1;
  });

  const totalSources = Object.values(sourceCounts).reduce((sum, count) => sum + count, 0);
  const leadSources = [
    { key: 'referral', label: 'Referral' },
    { key: 'website', label: 'Website' },
    { key: 'walk_in', label: 'Walk-in' },
    { key: 'phone', label: 'Phone' },
    { key: 'email', label: 'Email' },
    { key: 'cold', label: 'Cold' },
    { key: 'other', label: 'Other' }
  ].map(source => {
    const count = sourceCounts[source.key] || 0;
    const percentage = totalSources > 0 ? (count / totalSources) * 100 : 0;
    return { ...source, count, percentage };
  });

  // Follow-up health
  const nowTime = Date.now();
  const overdueCount = filteredOpportunities.filter(opp => {
    if (!opp.follow_up_date || opp.stage === 'won' || opp.stage === 'lost') return false;
    const followUpTime = new Date(opp.follow_up_date).getTime();
    return followUpTime < nowTime;
  }).length;

  const onTimeCount = filteredOpportunities.filter(opp => {
    if (!opp.follow_up_date || opp.stage === 'won' || opp.stage === 'lost') return false;
    const followUpTime = new Date(opp.follow_up_date).getTime();
    return followUpTime >= nowTime;
  }).length;

  const totalFollowUps = overdueCount + onTimeCount;
  const overduePercentage = totalFollowUps > 0 ? (overdueCount / totalFollowUps) * 100 : 0;
  const onTimePercentage = totalFollowUps > 0 ? (onTimeCount / totalFollowUps) * 100 : 0;

  // Top Performing Reps
  const repStats = {};
  filteredOpportunities.forEach(opp => {
    if (!opp.assigned_to) return;
    const repId = opp.assigned_to;
    if (!repStats[repId]) {
      const repName = opp.assigned_user
        ? `${opp.assigned_user.first_name || ''} ${opp.assigned_user.last_name || ''}`.trim()
        : 'Unknown';
      repStats[repId] = {
        id: repId,
        name: repName || 'Unknown',
        conversions: 0,
        revenue: 0
      };
    }
    if (opp.stage === 'won') {
      repStats[repId].conversions++;
      repStats[repId].revenue += opp.amount || 0;
    }
  });

  const topReps = Object.values(repStats)
    .sort((a, b) => b.revenue - a.revenue)
    .slice(0, 5);

  // Past Due Leads (based on follow_up_date)
  // Exclude won/lost deals and archived deals (those with closed_at)
  const pastDueLeads = filteredOpportunities
    .filter(opp => {
      if (!opp.follow_up_date) return false;
      // Exclude won/lost deals
      if (opp.stage === 'won' || opp.stage === 'lost') return false;
      // Exclude archived deals (have closed_at set)
      if (opp.closed_at) return false;
      const followUpTime = new Date(opp.follow_up_date).getTime();
      return followUpTime < nowTime;
    })
    .map(opp => {
      const followUpDate = new Date(opp.follow_up_date);
      const daysPastDue = Math.floor((nowTime - followUpDate.getTime()) / (1000 * 60 * 60 * 24));
      return {
        ...opp,
        daysPastDue,
        followUpDateFormatted: followUpDate.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })
      };
    })
    .sort((a, b) => b.daysPastDue - a.daysPastDue);

  // Upcoming Leads - includes past due leads and leads with follow-up dates in the next 7 days
  // Exclude won/lost deals and archived deals (those with closed_at)
  const sevenDaysFromNow = nowTime + (7 * 24 * 60 * 60 * 1000);
  const upcomingLeads = filteredOpportunities
    .filter(opp => {
      if (!opp.follow_up_date) return false;
      // Exclude won/lost deals
      if (opp.stage === 'won' || opp.stage === 'lost') return false;
      // Exclude archived deals (have closed_at set)
      if (opp.closed_at) return false;
      const followUpTime = new Date(opp.follow_up_date).getTime();
      // Include past due leads (before now) and upcoming leads (within next 7 days)
      return followUpTime <= sevenDaysFromNow;
    })
    .sort((a, b) => {
      const dateA = new Date(a.follow_up_date).getTime();
      const dateB = new Date(b.follow_up_date).getTime();

      // Past due items come first (oldest first)
      if (dateA < nowTime && dateB < nowTime) {
        return dateA - dateB; // Oldest past due first
      }
      // Future items come after (earliest first)
      if (dateA >= nowTime && dateB >= nowTime) {
        return dateA - dateB; // Earliest upcoming first
      }
      // Past due always comes before future
      if (dateA < nowTime) return -1;
      if (dateB < nowTime) return 1;

      return dateA - dateB;
    });

  return `
    <div style="max-width: 1400px; margin: 0 auto; padding: 1.5rem;">
      <!-- Header -->
      <div style="margin-bottom: 2rem;">
        <h1 style="
          color: #2c3e50;
          margin: 0 0 0.5rem 0;
          font-size: 2rem;
          font-weight: 700;
          line-height: 1.2;
        ">
          Reports
        </h1>
        <p style="
          color: #6c757d;
          margin: 0 0 1.5rem 0;
          font-size: 1rem;
        ">
          Sales reports and analytics
        </p>
        
        <!-- View Toggle Buttons -->
        <div style="display: flex; gap: 0.5rem; margin-bottom: 1.5rem;">
          <button
            onclick="switchSalesView('dashboard')"
            style="
              background: ${salesView === 'dashboard' ? '#ff7f00' : '#ffffff'};
              color: ${salesView === 'dashboard' ? 'white' : '#6c757d'};
              border: 1px solid ${salesView === 'dashboard' ? '#ff7f00' : '#e9ecef'};
              padding: 0.5rem 1rem;
              border-radius: 0.5rem;
              cursor: pointer;
              font-weight: 600;
              font-size: 0.875rem;
              transition: all 0.2s ease;
            "
          >
            Sales
          </button>
          <button
            onclick="switchSalesView('contacts')"
            style="
              background: ${salesView === 'contacts' ? '#ff7f00' : '#ffffff'};
              color: ${salesView === 'contacts' ? 'white' : '#6c757d'};
              border: 1px solid ${salesView === 'contacts' ? '#ff7f00' : '#e9ecef'};
              padding: 0.5rem 1rem;
              border-radius: 0.5rem;
              cursor: pointer;
              font-weight: 600;
              font-size: 0.875rem;
              transition: all 0.2s ease;
            "
          >
            Contacts
          </button>
          ${canAccessReports() ? `
          <button
            onclick="switchSalesView('reports')"
            style="
              background: ${salesView === 'reports' ? '#ff7f00' : '#ffffff'};
              color: ${salesView === 'reports' ? 'white' : '#6c757d'};
              border: 1px solid ${salesView === 'reports' ? '#ff7f00' : '#e9ecef'};
              padding: 0.5rem 1rem;
              border-radius: 0.5rem;
              cursor: pointer;
              font-weight: 600;
              font-size: 0.875rem;
              transition: all 0.2s ease;
            "
          >
            Reports
          </button>
          ` : ''}
        </div>
      </div>

      <!-- Report Title -->
      <div style="margin-bottom: 1.5rem;">
        <h2 style="
          color: #2c3e50;
          margin: 0 0 0.25rem 0;
          font-size: 1.5rem;
          font-weight: 700;
        ">
          Leads & Opportunities Report
        </h2>
        <p style="
          color: #6c757d;
          margin: 0;
          font-size: 0.875rem;
        ">
          Stay on top of team performance
        </p>
      </div>

      <!-- Date Range Selector -->
      <div style="display: flex; gap: 0.5rem; margin-bottom: 2rem; flex-wrap: wrap; align-items: center;">
        <button
          onclick="setReportsDateFilter('week')"
          style="
            background: ${reportsDateFilter === 'week' ? '#f59e0b' : '#ffffff'};
            color: ${reportsDateFilter === 'week' ? 'white' : '#2c3e50'};
            border: 1px solid ${reportsDateFilter === 'week' ? '#f59e0b' : '#e9ecef'};
            padding: 0.5rem 1rem;
            border-radius: 0.5rem;
            cursor: pointer;
            font-weight: 500;
            font-size: 0.875rem;
            transition: all 0.2s ease;
            display: flex;
            align-items: center;
            gap: 0.375rem;
          "
        >
          This Week
        </button>
        <button
          onclick="setReportsDateFilter('month')"
          style="
            background: ${reportsDateFilter === 'month' ? '#f59e0b' : '#ffffff'};
            color: ${reportsDateFilter === 'month' ? 'white' : '#2c3e50'};
            border: 1px solid ${reportsDateFilter === 'month' ? '#f59e0b' : '#e9ecef'};
            padding: 0.5rem 1rem;
            border-radius: 0.5rem;
            cursor: pointer;
            font-weight: 500;
            font-size: 0.875rem;
            transition: all 0.2s ease;
          "
        >
          This Month
        </button>
        <button
          onclick="setReportsDateFilter('quarter')"
          style="
            background: ${reportsDateFilter === 'quarter' ? '#f59e0b' : '#ffffff'};
            color: ${reportsDateFilter === 'quarter' ? 'white' : '#2c3e50'};
            border: 1px solid ${reportsDateFilter === 'quarter' ? '#f59e0b' : '#e9ecef'};
            padding: 0.5rem 1rem;
            border-radius: 0.5rem;
            cursor: pointer;
            font-weight: 500;
            font-size: 0.875rem;
            transition: all 0.2s ease;
          "
        >
          This Quarter
        </button>
        <button
          onclick="setReportsDateFilter('custom')"
          style="
            background: ${reportsDateFilter === 'custom' ? '#f59e0b' : '#ffffff'};
            color: ${reportsDateFilter === 'custom' ? 'white' : '#2c3e50'};
            border: 1px solid ${reportsDateFilter === 'custom' ? '#f59e0b' : '#e9ecef'};
            padding: 0.5rem 1rem;
            border-radius: 0.5rem;
            cursor: pointer;
            font-weight: 500;
            font-size: 0.875rem;
            transition: all 0.2s ease;
          "
        >
          Custom
        </button>
        ${reportsDateFilter === 'custom' && reportsCustomStartDate && reportsCustomEndDate ? `
          <span style="
            font-size: 0.875rem;
            color: #6c757d;
            padding: 0.5rem 1rem;
            background: #f8f9fa;
            border-radius: 0.5rem;
          ">
            ${new Date(reportsCustomStartDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })} - ${new Date(reportsCustomEndDate).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}
          </span>
        ` : ''}
      </div>

      ${showCustomDatePicker ? `
      <!-- Custom Date Picker Modal -->
      <div id="custom-date-picker-modal" onclick="if (event.target.id === 'custom-date-picker-modal') { cancelCustomDatePicker(); }" style="
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99999;
      ">
        <div onclick="event.stopPropagation()" style="
          background: #ffffff;
          border-radius: 0.75rem;
          padding: 1.5rem;
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
          max-width: 400px;
          width: 90%;
        ">
          <h3 style="
            margin: 0 0 1rem 0;
            color: #2c3e50;
            font-size: 1.125rem;
            font-weight: 700;
          ">
            Select Date Range
          </h3>
          <div style="display: flex; flex-direction: column; gap: 1rem; margin-bottom: 1.5rem;">
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 600;
                font-size: 0.875rem;
              ">
                Start Date
              </label>
              <input
                type="date"
                id="custom-start-date"
                value="${reportsCustomStartDate}"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e5e7eb;
                  border-radius: 0.5rem;
                  font-size: 1rem;
                  box-sizing: border-box;
                "
              />
            </div>
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 600;
                font-size: 0.875rem;
              ">
                End Date
              </label>
              <input
                type="date"
                id="custom-end-date"
                value="${reportsCustomEndDate}"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e5e7eb;
                  border-radius: 0.5rem;
                  font-size: 1rem;
                  box-sizing: border-box;
                "
              />
            </div>
          </div>
          <div style="display: flex; gap: 0.75rem; justify-content: flex-end;">
            <button
              onclick="cancelCustomDatePicker()"
              style="
                background: transparent;
                border: 1px solid #e9ecef;
                color: #2c3e50;
                padding: 0.5rem 1rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-weight: 500;
                font-size: 0.875rem;
              "
            >
              Cancel
            </button>
            <button
              onclick="applyCustomDateRange()"
              style="
                background: #f59e0b;
                border: none;
                color: white;
                padding: 0.5rem 1rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-weight: 600;
                font-size: 0.875rem;
              "
            >
              Apply
            </button>
          </div>
        </div>
      </div>
      ` : ''}

      <!-- Key Metrics Cards -->
      <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 1rem; margin-bottom: 2rem;">
        <!-- Total Leads -->
        <div style="
          background: #ffffff;
          border-radius: 0.75rem;
          padding: 1.25rem;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        ">
          <div style="
            font-size: 2rem;
            font-weight: 700;
            color: #2c3e50;
            margin-bottom: 0.25rem;
          ">${totalLeads}</div>
          <div style="
            font-size: 0.875rem;
            color: #6c757d;
          ">This period</div>
        </div>

        <!-- Active Opportunities -->
        <div style="
          background: #ffffff;
          border-radius: 0.75rem;
          padding: 1.25rem;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        ">
          <div style="
            font-size: 2rem;
            font-weight: 700;
            color: #2c3e50;
            margin-bottom: 0.25rem;
          ">${activeOpportunities}</div>
          <div style="
            font-size: 0.875rem;
            color: #6c757d;
          ">In pipeline</div>
        </div>

        <!-- Deals Won -->
        <div style="
          background: #ffffff;
          border-radius: 0.75rem;
          padding: 1.25rem;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        ">
          <div style="
            font-size: 2rem;
            font-weight: 700;
            color: #dc2626;
            margin-bottom: 0.25rem;
          ">${dealsWon}</div>
          <div style="
            font-size: 0.875rem;
            color: #6c757d;
            margin-bottom: 0.125rem;
          ">Lost: ${dealsLost}</div>
          <div style="
            font-size: 0.75rem;
            color: #9ca3af;
          ">Won / Lost</div>
        </div>

        <!-- Conversion % -->
        <div style="
          background: #ffffff;
          border-radius: 0.75rem;
          padding: 1.25rem;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        ">
          <div style="
            font-size: 2rem;
            font-weight: 700;
            color: #2c3e50;
            margin-bottom: 0.25rem;
          ">${conversionRate.toFixed(0)}%</div>
          <div style="
            font-size: 0.875rem;
            color: #6c757d;
          ">Close Rate</div>
        </div>

        <!-- Open Opportunity Value -->
        <div style="
          background: #ffffff;
          border-radius: 0.75rem;
          padding: 1.25rem;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        ">
          <div style="
            font-size: 2rem;
            font-weight: 700;
            color: #2c3e50;
            margin-bottom: 0.25rem;
          ">$${openValue.toLocaleString()}</div>
          <div style="
            font-size: 0.875rem;
            color: #6c757d;
          ">Active pipeline</div>
        </div>
      </div>

      <!-- Pipeline Funnel -->
      <div style="
        background: #ffffff;
        border-radius: 0.75rem;
        padding: 1.5rem;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        margin-bottom: 1.5rem;
      ">
        <h3 style="
          color: #2c3e50;
          margin: 0 0 1.25rem 0;
          font-size: 1.125rem;
          font-weight: 700;
        ">
          Pipeline Funnel
        </h3>
        <div style="display: flex; flex-direction: column; gap: 0.75rem;">
          ${pipelineData.map(stage => `
            <div>
              <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.5rem;">
                <span style="
                  font-size: 0.875rem;
                  color: #2c3e50;
                  font-weight: 500;
                ">${stage.label}</span>
                <span style="
                  font-size: 0.875rem;
                  color: #6c757d;
                  font-weight: 600;
                ">${stage.count}</span>
              </div>
              <div style="
                width: 100%;
                height: 8px;
                background: #f3f4f6;
                border-radius: 4px;
                overflow: hidden;
              ">
                <div style="
                  width: ${stage.percentage}%;
                  height: 100%;
                  background: ${stage.count > 0 ? '#f59e0b' : '#e5e7eb'};
                  transition: width 0.3s ease;
                "></div>
              </div>
            </div>
          `).join('')}
        </div>
      </div>

      <!-- Lead Sources -->
      <div style="
        background: #ffffff;
        border-radius: 0.75rem;
        padding: 1.5rem;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        margin-bottom: 1.5rem;
      ">
        <h3 style="
          color: #2c3e50;
          margin: 0 0 1.25rem 0;
          font-size: 1.125rem;
          font-weight: 700;
        ">
          Lead Sources
        </h3>
        <div style="display: flex; flex-direction: column; gap: 1rem;">
          ${leadSources.map(source => `
            <div>
              <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.5rem;">
                <span style="
                  font-size: 0.875rem;
                  color: #2c3e50;
                  font-weight: 500;
                  min-width: 80px;
                ">${source.label}</span>
                <span style="
                  font-size: 0.875rem;
                  color: #6c757d;
                  font-weight: 600;
                  margin-left: 0.75rem;
                ">${source.percentage.toFixed(0)}%</span>
              </div>
              <div style="
                width: 100%;
                height: 24px;
                background: #f3f4f6;
                border-radius: 12px;
                overflow: hidden;
                position: relative;
              ">
                <div style="
                  width: ${source.percentage}%;
                  height: 100%;
                  background: ${source.percentage > 0 ? '#f59e0b' : '#e5e7eb'};
                  transition: width 0.3s ease;
                  border-radius: 12px;
                "></div>
              </div>
            </div>
          `).join('')}
        </div>
      </div>

      <!-- Follow-up Health -->
      <div style="
        background: #ffffff;
        border-radius: 0.75rem;
        padding: 1.5rem;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        margin-bottom: 1.5rem;
      ">
        <h3 style="
          color: #2c3e50;
          margin: 0 0 1.25rem 0;
          font-size: 1.125rem;
          font-weight: 700;
        ">
          Follow-up Health
        </h3>
        <div style="display: flex; flex-direction: column; gap: 0.75rem;">
          <!-- On-time -->
          <div>
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.5rem;">
              <span style="
                font-size: 0.875rem;
                color: #2c3e50;
                font-weight: 500;
              ">On-time</span>
              <span style="
                font-size: 0.875rem;
                color: #6c757d;
                font-weight: 600;
              ">${onTimePercentage.toFixed(0)}%</span>
            </div>
            <div style="
              width: 100%;
              height: 8px;
              background: #f3f4f6;
              border-radius: 4px;
              overflow: hidden;
            ">
              <div style="
                width: ${onTimePercentage}%;
                height: 100%;
                background: ${onTimeCount > 0 ? '#10b981' : '#e5e7eb'};
                transition: width 0.3s ease;
              "></div>
            </div>
          </div>
          
          <!-- Overdue -->
          <div>
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.5rem;">
              <span style="
                font-size: 0.875rem;
                color: #2c3e50;
                font-weight: 500;
              ">Overdue</span>
              <span style="
                font-size: 0.875rem;
                color: #6c757d;
                font-weight: 600;
              ">${overduePercentage.toFixed(0)}%</span>
            </div>
            <div style="
              width: 100%;
              height: 8px;
              background: #f3f4f6;
              border-radius: 4px;
              overflow: hidden;
            ">
              <div style="
                width: ${overduePercentage}%;
                height: 100%;
                background: ${overdueCount > 0 ? '#f59e0b' : '#e5e7eb'};
                transition: width 0.3s ease;
              "></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Top Performing Reps -->
      <div style="
        background: #ffffff;
        border-radius: 0.75rem;
        padding: 1.5rem;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        margin-bottom: 1.5rem;
      ">
        <h3 style="
          color: #2c3e50;
          margin: 0 0 1.25rem 0;
          font-size: 1.125rem;
          font-weight: 700;
        ">
          Top Performing Reps
        </h3>
        <div style="display: flex; flex-direction: column; gap: 1rem;">
          ${topReps.length === 0 ? `
            <div style="
              padding: 2rem 1rem;
              text-align: center;
              color: #9ca3af;
              font-size: 0.875rem;
            ">
              No data available
            </div>
          ` : topReps.map(rep => `
            <div style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 1rem;
              background: #f8f9fa;
              border-radius: 0.5rem;
            ">
              <div>
                <div style="
                  font-size: 0.875rem;
                  font-weight: 600;
                  color: #2c3e50;
                  margin-bottom: 0.25rem;
                ">${rep.name}</div>
                <div style="
                  font-size: 0.75rem;
                  color: #6c757d;
                ">Conversion: ${rep.conversions}</div>
              </div>
              <div style="
                font-size: 1rem;
                font-weight: 700;
                color: #2c3e50;
              ">
                Revenue: $${rep.revenue.toLocaleString()}
              </div>
            </div>
          `).join('')}
        </div>
      </div>

      <!-- Past Due Leads -->
      <div style="
        background: #ffffff;
        border-radius: 0.75rem;
        padding: 1.5rem;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        margin-bottom: 1.5rem;
      ">
        <h3 style="
          color: #2c3e50;
          margin: 0 0 1.25rem 0;
          font-size: 1.125rem;
          font-weight: 700;
        ">
          Past Due Leads
        </h3>
        <div style="display: flex; flex-direction: column; gap: 0.75rem;">
          ${pastDueLeads.length === 0 ? `
            <div style="
              padding: 2rem 1rem;
              text-align: center;
              color: #9ca3af;
              font-size: 0.875rem;
            ">
              No past due leads
            </div>
          ` : pastDueLeads.map(lead => {
    const assignedUser = lead.assigned_user
      ? `${lead.assigned_user.first_name || ''} ${lead.assigned_user.last_name || ''}`.trim()
      : 'Unassigned';
    const contactName = lead.contact
      ? `${lead.contact.first_name || ''} ${lead.contact.last_name || ''}`.trim()
      : lead.title || 'Unknown';

    return `
              <div onclick="editOpportunity('${lead.id}')" style="
                padding: 1rem;
                background: #f8f9fa;
                border-radius: 0.5rem;
                cursor: pointer;
                transition: all 0.2s ease;
              " onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='#f8f9fa'">
                <div style="
                  font-size: 0.875rem;
                  font-weight: 600;
                  color: #2c3e50;
                  margin-bottom: 0.375rem;
                ">${contactName}</div>
                <div style="
                  font-size: 0.75rem;
                  color: #6c757d;
                  margin-bottom: 0.25rem;
                ">Assigned Rep: ${assignedUser}</div>
                <div style="
                  font-size: 0.75rem;
                  color: #dc2626;
                  font-weight: 600;
                  margin-bottom: 0.125rem;
                ">${lead.daysPastDue} days past due</div>
                <div style="
                  font-size: 0.75rem;
                  color: #6c757d;
                ">Due: ${lead.followUpDateFormatted}</div>
              </div>
            `;
  }).join('')}
        </div>
      </div>

      <!-- Upcoming Leads (7 Days) -->
      <div style="
        background: #ffffff;
        border-radius: 0.75rem;
        padding: 1.5rem;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
      ">
        <h3 style="
          color: #2c3e50;
          margin: 0 0 1.25rem 0;
          font-size: 1.125rem;
          font-weight: 700;
        ">
          Upcoming Deals (7 Days)
        </h3>
        <div style="display: flex; flex-direction: column; gap: 0.75rem;">
          ${upcomingLeads.length === 0 ? `
            <div style="
              padding: 2rem 1rem;
              text-align: center;
              color: #9ca3af;
              font-size: 0.875rem;
            ">
              No upcoming leads
            </div>
          ` : upcomingLeads.map(lead => {
    const assignedUser = lead.assigned_user
      ? `${lead.assigned_user.first_name || ''} ${lead.assigned_user.last_name || ''}`.trim()
      : 'Unassigned';
    const contactName = lead.contact
      ? `${lead.contact.first_name || ''} ${lead.contact.last_name || ''}`.trim()
      : lead.title || 'Unknown';
    const followUpDate = new Date(lead.follow_up_date);
    const daysUntil = Math.ceil((followUpDate.getTime() - nowTime) / (1000 * 60 * 60 * 24));
    const followUpFormatted = followUpDate.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });

    return `
              <div onclick="editOpportunity('${lead.id}')" style="
                padding: 1rem;
                background: #f8f9fa;
                border-radius: 0.5rem;
                cursor: pointer;
                transition: all 0.2s ease;
              " onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='#f8f9fa'">
                <div style="
                  font-size: 0.875rem;
                  font-weight: 600;
                  color: #2c3e50;
                  margin-bottom: 0.375rem;
                ">${contactName}</div>
                <div style="
                  font-size: 0.75rem;
                  color: #6c757d;
                  margin-bottom: 0.25rem;
                ">Assigned Rep: ${assignedUser}</div>
                <div style="
                  font-size: 0.75rem;
                  color: #f59e0b;
                  font-weight: 600;
                  margin-bottom: 0.125rem;
                ">Due in ${daysUntil} ${daysUntil === 1 ? 'day' : 'days'}</div>
                <div style="
                  font-size: 0.75rem;
                  color: #6c757d;
                ">Due: ${followUpFormatted}</div>
              </div>
            `;
  }).join('')}
        </div>
      </div>
    </div>
  `;
}

// Render Contacts List - Professional CRM Style
async function renderContactsList() {
  // Ensure contacts is initialized
  if (!contacts || !Array.isArray(contacts)) {
    contacts = [];
  }

  // Ensure teamMembers is initialized
  if (!teamMembers || !Array.isArray(teamMembers)) {
    teamMembers = [];
  }

  return `
    <div class="contacts-layout" style="
      display: flex;
      height: calc(100vh - 80px);
      background: #ffffff;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    ">
      <!-- Left Sidebar - Contact List -->
      <div class="contacts-list-container" style="
        width: 350px;
        background: #f8f9fa;
        border-right: 1px solid #e9ecef;
        display: flex;
        flex-direction: column;
        overflow: hidden;
      ">
        <!-- Header -->
        <div style="
          padding: 1.5rem 1rem;
          border-bottom: 1px solid #e9ecef;
          background: #ffffff;
        ">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
            <h1 style="
              margin: 0;
              color: #2c3e50;
              font-size: 1.25rem;
              font-weight: 600;
            ">
              Client Relationship Management Tool
            </h1>
            <button onclick="showAddContactModalDirect()" style="
              background: #f59e0b;
              color: white;
              border: none;
              padding: 0.5rem;
              border-radius: 50%;
              cursor: pointer;
              font-size: 1rem;
              width: 32px;
              height: 32px;
              display: flex;
              align-items: center;
              justify-content: center;
            " title="Add Contact">
              +
            </button>
          </div>
          
          <!-- View Toggle Buttons -->
          <div style="display: flex; gap: 0.5rem; margin-bottom: 1rem;">
            <button
              onclick="switchSalesView('dashboard')"
              style="
                background: ${salesView === 'dashboard' ? '#ff7f00' : colors.background};
                color: ${salesView === 'dashboard' ? 'white' : colors.text};
                border: 1px solid ${colors.border};
                padding: 0.5rem 1rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-weight: 600;
                font-size: 0.875rem;
                transition: all 0.2s ease;
                flex: 1;
              "
            >
              Sales
            </button>
            <button
              onclick="switchSalesView('contacts')"
              style="
                background: ${salesView === 'contacts' ? '#ff7f00' : colors.background};
                color: ${salesView === 'contacts' ? 'white' : colors.text};
                border: 1px solid ${colors.border};
                padding: 0.5rem 1rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-weight: 600;
                font-size: 0.875rem;
                transition: all 0.2s ease;
                flex: 1;
              "
            >
              Contacts
            </button>
            ${canAccessReports() ? `
            <button
              onclick="switchSalesView('reports')"
              style="
                background: ${salesView === 'reports' ? '#ff7f00' : colors.background};
                color: ${salesView === 'reports' ? 'white' : colors.text};
                border: 1px solid ${colors.border};
                padding: 0.5rem 1rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-weight: 600;
                font-size: 0.875rem;
                transition: all 0.2s ease;
                flex: 1;
              "
            >
              Reports
            </button>
            ` : ''}
          </div>
          
          <!-- Search Bar -->
          <div style="position: relative;">
            <input
              type="text"
              id="contact-search"
              placeholder="Search contacts..."
              value="${contactSearchQuery}"
              style="
                width: 100%;
                padding: 0.75rem 1rem 0.75rem 2.5rem;
                border: 1px solid #e9ecef;
                border-radius: 0.375rem;
                font-size: 0.875rem;
                outline: none;
                background: #ffffff;
                transition: border-color 0.2s ease;
              "
              oninput="handleContactSearch(event)"
              onfocus="this.style.borderColor='#007bff'"
              onblur="this.style.borderColor='#e9ecef'"
            />
          </div>
          
        </div>

        <!-- Contact List -->
        <div id="contacts-list" style="flex: 1; overflow-y: auto; background: #ffffff;">
          ${getContactsListHTML()}
        </div>
      </div>

      <!-- Center Content - Contact Details -->
      <div id="contact-detail-content" class="contact-detail-container" style="
        flex: 1;
        background: #ffffff;
        display: flex;
        flex-direction: column;
        overflow: hidden;
      ">
        ${selectedContactId ? await renderContactDetailContent() : renderContactPlaceholder()}
      </div>
    </div>

    ${showAddTaskForm ? renderAddTaskModal() : ''}
  `;
}

// Contact placeholder when none selected
function renderContactPlaceholder() {
  return `
    <div style="
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      color: ${colors.textSecondary};
      text-align: center;
      padding: 2rem;
    ">
      <div style="font-size: 4rem; margin-bottom: 1rem;"></div>
      <h2 style="margin: 0 0 0.5rem 0; font-size: 1.5rem; font-weight: 600;">Select a Contact</h2>
      <p style="margin: 0; font-size: 1rem;">Choose a contact from the list to view their details</p>
    </div>
  `;
}

// Contact info sidebar placeholder
function renderContactInfoPlaceholder() {
  return `
    <div style="
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      color: ${colors.textSecondary};
      text-align: center;
    ">
      <div style="font-size: 3rem; margin-bottom: 1rem; color: #6c757d;">
        <span class="material-icons" style="font-size: 3rem;">info</span>
      </div>
      <p style="margin: 0; font-size: 0.875rem;">Contact information will appear here</p>
    </div>
  `;
}

// Contact activity sidebar (Sales Opportunities, Appointments, Reminders)
async function renderContactActivitySidebar() {
  const contact = contacts.find(c => c.id === selectedContactId);
  if (!contact) return renderContactInfoPlaceholder();

  console.log('🔍 renderContactActivitySidebar - selectedContactId:', selectedContactId);
  console.log('🔍 renderContactActivitySidebar - contact:', contact);

  // Get contact-specific data
  const contactAppointments = await loadContactAppointments(selectedContactId);
  const contactReminders = await loadContactReminders(selectedContactId);
  const contactOpportunities = salesOpportunities.filter(opp => opp.contact?.id === selectedContactId);

  console.log('🔍 contactOpportunities:', contactOpportunities);
  console.log('🔍 contactAppointments:', contactAppointments);
  console.log('🔍 contactReminders:', contactReminders);

  return `
    <div>
      <h3 style="
        margin: 0 0 1.5rem 0;
        color: #2c3e50;
        font-size: 1rem;
        font-weight: 600;
      ">Activity Summary</h3>

      <!-- Sales Opportunities -->
      <div style="margin-bottom: 2rem;">
        <h4 style="
          margin: 0 0 1rem 0;
          color: #2c3e50;
          font-size: 0.875rem;
          font-weight: 600;
        ">Sales Opportunities (${contactOpportunities.length})</h4>
        
        ${contactOpportunities.length === 0 ? `
          <div style="
            padding: 1rem;
            background: #f8f9fa;
            border-radius: 0.375rem;
            text-align: center;
            color: #6c757d;
            font-size: 0.875rem;
          ">
            No opportunities
          </div>
        ` : contactOpportunities.slice(0, 3).map(opp => `
          <div style="
            padding: 0.75rem;
            background: #ffffff;
            border: 1px solid #e9ecef;
            border-radius: 0.375rem;
            margin-bottom: 0.5rem;
          ">
            <div style="
              font-weight: 600;
              color: #2c3e50;
              font-size: 0.875rem;
              margin-bottom: 0.25rem;
            ">${opp.title}</div>
            <div style="
              font-size: 0.75rem;
              color: #6c757d;
              margin-bottom: 0.25rem;
            ">${opp.stage} • $${(opp.amount || 0).toLocaleString()}</div>
            <div style="
              font-size: 0.75rem;
              color: #6c757d;
            ">Chance: ${opp.chance || 0}%</div>
          </div>
        `).join('')}
        
        ${contactOpportunities.length > 3 ? `
          <div style="
            text-align: center;
            color: #007bff;
            font-size: 0.75rem;
            cursor: pointer;
          ">
            +${contactOpportunities.length - 3} more
          </div>
        ` : ''}
      </div>

      <!-- Appointments -->
      <div style="margin-bottom: 2rem;">
        <h4 style="
          margin: 0 0 1rem 0;
          color: #2c3e50;
          font-size: 0.875rem;
          font-weight: 600;
        ">Appointments (${contactAppointments.length})</h4>
        
        ${contactAppointments.length === 0 ? `
          <div style="
            padding: 1rem;
            background: #f8f9fa;
            border-radius: 0.375rem;
            text-align: center;
            color: #6c757d;
            font-size: 0.875rem;
          ">
            No appointments
          </div>
        ` : contactAppointments.slice(0, 3).map(apt => `
          <div style="
            padding: 0.75rem;
            background: #ffffff;
            border: 1px solid #e9ecef;
            border-radius: 0.375rem;
            margin-bottom: 0.5rem;
          ">
            <div style="
              font-weight: 600;
              color: #2c3e50;
              font-size: 0.875rem;
              margin-bottom: 0.25rem;
            ">${apt.title}</div>
            <div style="
              font-size: 0.75rem;
              color: #6c757d;
              margin-bottom: 0.25rem;
            ">${(() => {
      const dateParts = apt.appointment_date.split('-');
      if (dateParts.length === 3) {
        const date = new Date(parseInt(dateParts[0], 10), parseInt(dateParts[1], 10) - 1, parseInt(dateParts[2], 10));
        return date.toLocaleDateString();
      }
      return new Date(apt.appointment_date).toLocaleDateString();
    })()}</div>
            <div style="
              font-size: 0.75rem;
              color: #6c757d;
            ">${apt.start_time} - ${apt.end_time}</div>
          </div>
        `).join('')}
        
        ${contactAppointments.length > 3 ? `
          <div style="
            text-align: center;
            color: #007bff;
            font-size: 0.75rem;
            cursor: pointer;
          ">
            +${contactAppointments.length - 3} more
          </div>
        ` : ''}
      </div>

      <!-- Reminders -->
      <div style="margin-bottom: 2rem;">
        <h4 style="
          margin: 0 0 1rem 0;
          color: #2c3e50;
          font-size: 0.875rem;
          font-weight: 600;
        ">Reminders (${contactReminders.length})</h4>
        
        ${contactReminders.length === 0 ? `
          <div style="
            padding: 1rem;
            background: #f8f9fa;
            border-radius: 0.375rem;
            text-align: center;
            color: #6c757d;
            font-size: 0.875rem;
          ">
            No reminders
          </div>
        ` : contactReminders.slice(0, 3).map(rem => `
          <div style="
            padding: 0.75rem;
            background: #ffffff;
            border: 1px solid #e9ecef;
            border-radius: 0.375rem;
            margin-bottom: 0.5rem;
          ">
            <div style="
              font-weight: 600;
              color: #2c3e50;
              font-size: 0.875rem;
              margin-bottom: 0.25rem;
            ">${rem.title}</div>
            <div style="
              font-size: 0.75rem;
              color: #6c757d;
              margin-bottom: 0.25rem;
            ">Due: ${new Date(rem.due_at).toLocaleDateString()}</div>
            <div style="
              font-size: 0.75rem;
              color: #6c757d;
            ">Priority: ${rem.priority || 'LOW'}</div>
          </div>
        `).join('')}
        
        ${contactReminders.length > 3 ? `
          <div style="
            text-align: center;
            color: #007bff;
            font-size: 0.75rem;
            cursor: pointer;
          ">
            +${contactReminders.length - 3} more
          </div>
        ` : ''}
      </div>
    </div>
    
    ${showAddContactModal ? renderAddContactModal() : ''}
  `;
}

// Contact info sidebar
function renderContactInfoSidebar() {
  const contact = contacts.find(c => c.id === selectedContactId);
  if (!contact) return renderContactInfoPlaceholder();

  return `
    <div>
      <div style="
        display: flex;
        align-items: center;
        gap: 0.5rem;
        margin-bottom: 1.5rem;
      ">
        <div style="
          width: 24px;
          height: 24px;
          border-radius: 50%;
          background: #f59e0b;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 0.75rem;
          font-weight: 600;
        ">ℹ️</div>
        <h3 style="
          margin: 0;
          color: #2c3e50;
          font-size: 1rem;
          font-weight: 600;
        ">Contact info</h3>
      </div>

      <!-- General Information -->
      <div style="margin-bottom: 2rem;">
        <h4 style="
          margin: 0 0 1rem 0;
          color: #2c3e50;
          font-size: 0.875rem;
          font-weight: 600;
        ">General</h4>
        
        <div style="margin-bottom: 0.75rem;">
          <div style="
            font-size: 0.75rem;
            color: #6c757d;
            margin-bottom: 0.25rem;
          ">First Name</div>
          <div style="font-size: 0.875rem; color: #2c3e50;">
            ${contact.first_name || 'Not provided'}
          </div>
        </div>
        
        <div style="margin-bottom: 0.75rem;">
          <div style="
            font-size: 0.75rem;
            color: #6c757d;
            margin-bottom: 0.25rem;
          ">Last Name</div>
          <div style="font-size: 0.875rem; color: #2c3e50;">
            ${contact.last_name || 'Not provided'}
          </div>
        </div>
        
        ${contact.company ? `
          <div style="margin-bottom: 0.75rem;">
            <div style="
              font-size: 0.75rem;
              color: #6c757d;
              margin-bottom: 0.25rem;
            ">Company</div>
            <div style="font-size: 0.875rem; color: #2c3e50;">
              ${contact.company}
            </div>
          </div>
        ` : ''}
      </div>

      <!-- Phone, Email, and Fax -->
      <div style="margin-bottom: 2rem;">
        <h4 style="
          margin: 0 0 1rem 0;
          color: #2c3e50;
          font-size: 0.875rem;
          font-weight: 600;
        ">Phone, email, and fax</h4>
        
        ${contact.phone ? `
          <div style="margin-bottom: 0.75rem;">
            <div style="
              font-size: 0.75rem;
              color: #6c757d;
              margin-bottom: 0.25rem;
            ">Other phone</div>
            <div style="font-size: 0.875rem; color: #2c3e50;">
              ${formatPhoneForDisplay(contact.phone)}
            </div>
          </div>
        ` : ''}
        
        ${contact.email ? `
          <div style="margin-bottom: 0.75rem;">
            <div style="
              font-size: 0.75rem;
              color: #6c757d;
              margin-bottom: 0.25rem;
            ">Work email</div>
            <div style="font-size: 0.875rem; color: #2c3e50;">
              ${contact.email}
            </div>
          </div>
        ` : ''}
      </div>

      <!-- Additional Info -->
      ${contact.role || contact.status || contact.notes ? `
        <div style="margin-bottom: 2rem;">
          <h4 style="
            margin: 0 0 1rem 0;
            color: #2c3e50;
            font-size: 0.875rem;
            font-weight: 600;
          ">Additional Information</h4>
          
          ${contact.role ? `
            <div style="margin-bottom: 0.75rem;">
              <div style="
                font-size: 0.75rem;
                color: #6c757d;
                margin-bottom: 0.25rem;
              ">Role</div>
              <div style="font-size: 0.875rem; color: #2c3e50;">
                ${contact.role}
              </div>
            </div>
          ` : ''}
          
          ${contact.status ? `
            <div style="margin-bottom: 0.75rem;">
              <div style="
                font-size: 0.75rem;
                color: #6c757d;
                margin-bottom: 0.25rem;
              ">Status</div>
              <div style="font-size: 0.875rem; color: #2c3e50;">
                ${contact.status}
              </div>
            </div>
          ` : ''}
          
          ${contact.notes ? `
            <div style="margin-bottom: 0.75rem;">
              <div style="
                font-size: 0.75rem;
                color: #6c757d;
                margin-bottom: 0.25rem;
              ">Notes</div>
              <div style="font-size: 0.875rem; color: #2c3e50;">
                ${contact.notes}
              </div>
            </div>
          ` : ''}
        </div>
      ` : ''}
    </div>
  `;
}

// Render Contact Detail Content (middle section)
async function renderContactDetailContent() {
  const contact = contacts.find(c => c.id === selectedContactId);
  if (!contact) return renderContactPlaceholder();

  // Check if contact is a client by querying company_members directly
  let isContactClient = false;
  const contactProfileId = contact.contact_profile_id || contact.profile_id || null;
  if (contactProfileId && currentCompany) {
    try {
      const { data: memberData, error } = await supabase
        .from('company_members')
        .select('role')
        .eq('company_id', currentCompany.id)
        .eq('user_id', contactProfileId)
        .eq('role', 'CLIENT')
        .maybeSingle();

      if (!error && memberData) {
        isContactClient = true;
      }
    } catch (err) {
      console.error('Error checking if contact is client:', err);
    }
  }

  // Get contact-specific data for all tabs
  const contactAppointments = await loadContactAppointments(selectedContactId);
  const contactReminders = await loadContactReminders(selectedContactId);

  // Filter opportunities - exclude won/lost, optionally show all
  let contactOpportunities = salesOpportunities.filter(opp =>
    opp.contact?.id === selectedContactId
  );

  // If not showing archived, exclude won/lost and closed_at deals
  if (!showArchivedOpportunities) {
    contactOpportunities = contactOpportunities.filter(opp =>
      opp.stage !== 'won' &&
      opp.stage !== 'lost' &&
      !opp.closed_at
    );
  }

  // If showAllOpportunities is false, only show active status opportunities
  if (!showAllOpportunities) {
    contactOpportunities = contactOpportunities.filter(opp => opp.status === 'active');
  }

  // Sort opportunities: Active first, then Archived (sorted by closed_at date descending)
  contactOpportunities.sort((a, b) => {
    const aIsArchived = !!a.closed_at || a.stage === 'won' || a.stage === 'lost';
    const bIsArchived = !!b.closed_at || b.stage === 'won' || b.stage === 'lost';

    // Active opportunities come first
    if (!aIsArchived && bIsArchived) return -1;
    if (aIsArchived && !bIsArchived) return 1;

    // If both are archived, sort by closed_at date (most recent first)
    if (aIsArchived && bIsArchived) {
      const aClosedAt = a.closed_at ? new Date(a.closed_at).getTime() : 0;
      const bClosedAt = b.closed_at ? new Date(b.closed_at).getTime() : 0;
      return bClosedAt - aClosedAt; // Descending (newest first)
    }

    // If both are active, maintain original order (or sort by follow_up_date if needed)
    return 0;
  });

  const contactActivityLog = await loadContactActivityLog(selectedContactId);
  const contactTasks = await loadContactTasks(selectedContactId);
  const contactProjects = await loadContactProjects(selectedContactId);
  const contactChats = await loadContactChats(selectedContactId);

  // Cache the loaded data for smooth tab switching
  cachedContactData = {
    contactId: selectedContactId,
    appointments: contactAppointments,
    reminders: contactReminders,
    opportunities: contactOpportunities,
    activityLog: contactActivityLog,
    tasks: contactTasks,
    projects: contactProjects,
    chats: contactChats,
    isClient: isContactClient
  };

  const isCalContact = isCalendarContact(contact);

  // Tab configuration - only show Reminders and Appointments for calendar contacts
  const allTabs = [
    { id: 'activity', label: 'Activity' },
    { id: 'projects', label: 'Projects' },
    { id: 'tasks', label: 'Tasks' },
    { id: 'chats', label: 'Chats' },
    { id: 'opportunities', label: 'Deals' },
    { id: 'contracts', label: 'Contracts' },
    { id: 'reminders', label: 'Reminders' },
    { id: 'appointments', label: 'Appointments' }
  ];
  const tabs = isCalContact
    ? allTabs.filter(tab => tab.id === 'reminders' || tab.id === 'appointments')
    : allTabs;

  // Render content based on active tab
  async function renderTabContent() {
    // For calendar contacts, default to reminders if invalid tab
    if (isCalContact && !['reminders', 'appointments'].includes(contactDetailViewTab)) {
      contactDetailViewTab = 'reminders';
    }

    switch (contactDetailViewTab) {
      case 'activity':
        return isCalContact ? renderRemindersTab(contactReminders) : renderActivityTab(contactActivityLog);
      case 'projects':
        return isCalContact ? renderRemindersTab(contactReminders) : await renderProjectsTab(contactProjects);
      case 'tasks':
        return isCalContact ? renderRemindersTab(contactReminders) : renderTasksTab(contactTasks);
      case 'chats':
        return isCalContact ? renderRemindersTab(contactReminders) : renderChatsTab(contactChats);
      case 'opportunities':
        return isCalContact ? renderRemindersTab(contactReminders) : renderOpportunitiesTab(contactOpportunities);
      case 'contracts':
        return isCalContact ? renderRemindersTab(contactReminders) : await renderContactContractsTab();
      case 'reminders':
        return renderRemindersTab(contactReminders);
      case 'appointments':
        return renderAppointmentsTab(contactAppointments);
      default:
        return isCalContact ? renderRemindersTab(contactReminders) : renderActivityTab(contactActivityLog);
    }
  }

  const tabContentHTML = await renderTabContent();

  return `
    <div style="
      display: flex;
      flex-direction: column;
      height: 100%;
      background: #ffffff;
    ">
      <!-- Contact Header -->
      <div style="
        padding: ${isMobileDevice() ? '1rem' : '1.5rem'};
        border-bottom: 1px solid #e9ecef;
        background: #ffffff;
      ">
            <div style="display: flex; align-items: center; gap: ${isMobileDevice() ? '0.75rem' : '1rem'}; margin-bottom: 1rem;">
              <div style="
                width: ${isMobileDevice() ? '50px' : '60px'};
                height: ${isMobileDevice() ? '50px' : '60px'};
                border-radius: 50%;
                background: ${getAvatarColor(`${contact.first_name} ${contact.last_name}`)};
                color: white;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 600;
                font-size: ${isMobileDevice() ? '1.25rem' : '1.5rem'};
                flex-shrink: 0;
              ">
                ${contact.first_name?.charAt(0) || '?'}${contact.last_name?.charAt(0) || ''}
              </div>
          <div style="flex: 1; min-width: 0;">
            <div style="display: flex; align-items: center; gap: 0.5rem; margin-bottom: 0.25rem;">
              <h1 style="
                margin: 0;
                color: #2c3e50;
                font-size: ${isMobileDevice() ? '1.25rem' : '1.5rem'};
                font-weight: 600;
              ">
                ${contact.first_name} ${contact.last_name}
              </h1>
              <button
                onclick="openEditContactModal('${contact.id}')"
                style="
                  background: transparent;
                  border: none;
                  color: #6c757d;
                  cursor: pointer;
                  padding: 0.25rem;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  border-radius: 0.25rem;
                  transition: all 0.2s;
                  font-size: 1rem;
                "
                onmouseover="this.style.background='#f3f4f6'; this.style.color='#2c3e50'"
                onmouseout="this.style.background='transparent'; this.style.color='#6c757d'"
                title="Edit Contact"
              >
                edit
              </button>
            </div>
            ${!isCalContact ? `
            <p style="
              margin: 0 0 0.25rem 0;
              color: #6c757d;
              font-size: ${isMobileDevice() ? '0.8rem' : '0.875rem'};
            ">
              ${contact.company || 'No company'}
            </p>
            ` : ''}
            <p style="
              margin: 0 0 0.25rem 0;
              color: #6c757d;
              font-size: ${isMobileDevice() ? '0.8rem' : '0.875rem'};
            ">
              ${contact.email || 'No email'}
            </p>
            ${!isCalContact ? `
            <p style="
              margin: 0 0 0.25rem 0;
              color: #6c757d;
              font-size: ${isMobileDevice() ? '0.8rem' : '0.875rem'};
            ">
              ${contact.phone ? formatPhoneForDisplay(contact.phone) : 'No phone'}
            </p>
            ` : ''}
            ${contact.role ? `
              <p style="
                margin: 0;
                color: #6c757d;
                font-size: ${isMobileDevice() ? '0.8rem' : '0.875rem'};
              ">
                ${contact.role}
              </p>
            ` : ''}
          </div>
        </div>

        <!-- Action Buttons - Hidden for calendar contacts -->
        ${!isCalContact ? `
        <div style="display: flex; gap: ${isMobileDevice() ? '0.375rem' : '0.5rem'}; margin-bottom: 1rem; flex-wrap: wrap;">
          ${(() => {
        // Check if user is manager or owner
        const canMakeClient = isManagerOrOwner();

        // Use the isContactClient value determined at the top of the function
        // Show "Make a client" button only if user is manager/owner, contact is not already a client, and contact is not already tied to an existing account (profile_id)
        const hasExistingAccount = !!(contact.contact_profile_id || contact.profile_id);
        if (canMakeClient && !isContactClient && !hasExistingAccount) {
          return `
                <button onclick="openAddClientModal('${contact.id}')" style="
                  background: #f59e0b;
                  color: white;
                  border: none;
                  padding: ${isMobileDevice() ? '0.375rem 0.75rem' : '0.5rem 1rem'};
                  border-radius: 0.375rem;
                  cursor: pointer;
                  font-size: ${isMobileDevice() ? '0.8rem' : '0.875rem'};
                  font-weight: 600;
                  display: flex;
                  align-items: center;
                  gap: 0.25rem;
                  white-space: nowrap;
                  transition: all 0.2s;
                "
                onmouseover="this.style.background='#d97706'; this.style.transform='scale(1.05)'"
                onmouseout="this.style.background='#f59e0b'; this.style.transform='scale(1)'"
                >
                  Make a Client
                </button>
              `;
        }
        return '';
      })()}
          <button onclick="window.location.href='mailto:${contact.email || ''}'" style="
            background: #ffffff;
            color: #6c757d;
            border: 1px solid #e9ecef;
            padding: ${isMobileDevice() ? '0.375rem 0.75rem' : '0.5rem 1rem'};
            border-radius: 0.375rem;
            cursor: pointer;
            font-size: ${isMobileDevice() ? '0.8rem' : '0.875rem'};
            font-weight: 500;
            display: flex;
            align-items: center;
            gap: 0.25rem;
            white-space: nowrap;
          ">
            ✉️ Email
          </button>
        </div>
        ` : ''}

        <!-- Horizontal Scrollable Tabs -->
        <div class="contact-tabs-container" style="
          overflow-x: auto;
          overflow-y: hidden;
          white-space: nowrap;
          margin-bottom: 1rem;
          -webkit-overflow-scrolling: touch;
          scrollbar-width: thin;
          ${isMobileDevice() ? 'padding-bottom: 0.5rem;' : ''}
        ">
          <div style="display: inline-flex; gap: ${isMobileDevice() ? '0.375rem' : '0.5rem'}; min-width: 100%;">
            ${tabs.map(tab => `
              <button onclick="window.switchContactDetailViewTab('${tab.id}')" data-tab-id="${tab.id}" style="
                background: ${contactDetailViewTab === tab.id ? '#f59e0b' : '#ffffff'};
                color: ${contactDetailViewTab === tab.id ? 'white' : '#6c757d'};
                border: 1px solid ${contactDetailViewTab === tab.id ? '#f59e0b' : '#e9ecef'};
                padding: ${isMobileDevice() ? '0.4rem 0.75rem' : '0.5rem 1rem'};
                border-radius: 0.375rem;
                cursor: pointer;
                font-size: ${isMobileDevice() ? '0.8rem' : '0.875rem'};
                font-weight: ${contactDetailViewTab === tab.id ? '600' : '500'};
                white-space: nowrap;
                transition: all 0.2s ease;
                flex-shrink: 0;
              " onmouseover="if(this.style.background !== 'rgb(245, 158, 11)' && this.style.background !== '#f59e0b') { this.style.background='#f8f9fa'; } else { this.style.background='#d97706'; }" onmouseout="if(this.style.color === 'white' || this.style.color === 'rgb(255, 255, 255)') { this.style.background='#f59e0b'; } else { this.style.background='#ffffff'; }">
                ${tab.label}
              </button>
            `).join('')}
          </div>
        </div>
      </div>

      <!-- Tab Content Section -->
      <div id="contact-tab-content" style="flex: 1; padding: ${isMobileDevice() ? '1rem' : '1.5rem'}; overflow-y: auto; overflow-x: hidden;">
        ${tabContentHTML}
      </div>
    </div>
    ${showAddClientModal ? renderAddClientModal() : ''}
  `;
}

// Render Activity Tab
function renderActivityTab(activityLog) {
  const contact = contacts.find(c => c.id === selectedContactId);
  const contactName = contact ? `${contact.first_name} ${contact.last_name}` : '';

  // Helper function to get event label and icon
  const getEventInfo = (activity) => {
    switch (activity.event_type) {
      case 'task_completed':
        return {
          label: 'Completed task',
          icon: 'check_circle',
          color: '#10b981'
        };
      case 'task_created':
        return {
          label: 'Task created',
          icon: 'assignment',
          color: '#6366f1'
        };
      case 'project_created':
        return {
          label: 'Project created',
          icon: 'folder',
          color: '#8b5cf6'
        };
      case 'reminder':
        return {
          label: 'Reminder',
          icon: 'notifications',
          color: '#3b82f6'
        };
      case 'reminder_completed':
        return {
          label: 'Completed reminder',
          icon: 'notifications',
          color: '#3b82f6'
        };
      case 'appointment':
        return {
          label: 'Appointment',
          icon: 'event',
          color: '#8b5cf6'
        };
      case 'opportunity_created':
        return {
          label: 'Sales opportunity created',
          icon: 'trending_up',
          color: '#f59e0b'
        };
      case 'opportunity_won':
        return {
          label: 'Sale won',
          icon: 'emoji_events',
          color: '#10b981'
        };
      case 'opportunity_lost':
        return {
          label: 'Sale lost',
          icon: 'cancel',
          color: '#ef4444'
        };
      case 'contract_sent':
        return {
          label: 'Contract sent',
          icon: 'send',
          color: '#3b82f6'
        };
      case 'contract_viewed':
        return {
          label: 'Contract viewed',
          icon: 'visibility',
          color: '#f59e0b'
        };
      case 'contract_signed':
        return {
          label: 'Contract signed',
          icon: 'draw',
          color: '#10b981'
        };
      case 'contract_expired':
        return {
          label: 'Contract expired',
          icon: 'schedule',
          color: '#ef4444'
        };
      case 'activity':
      default:
        return {
          label: activity.type || 'Activity',
          icon: 'note',
          color: '#6c757d'
        };
    }
  };

  return `
    <div>
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
        <h3 style="margin: 0; color: #2c3e50; font-size: ${isMobileDevice() ? '1rem' : '1.125rem'}; font-weight: 600;">
          Activity
        </h3>
        <button onclick="showAddActivityModal()" style="
          background: #f59e0b;
          color: white;
          border: none;
          padding: ${isMobileDevice() ? '0.4rem 0.75rem' : '0.5rem 1rem'};
          border-radius: 0.375rem;
          cursor: pointer;
          font-size: ${isMobileDevice() ? '0.8rem' : '0.875rem'};
          font-weight: 500;
          display: flex;
          align-items: center;
          gap: 0.375rem;
          white-space: nowrap;
        ">
          + Add Activity
        </button>
      </div>
      ${activityLog.length === 0 ? `
        <div style="text-align: center; padding: 3rem 1rem;">
          <p style="color: #6c757d; font-size: 0.875rem; margin: 0;">No activity for this contact</p>
        </div>
      ` : `
        <div style="display: flex; flex-direction: column; gap: ${isMobileDevice() ? '0.75rem' : '1rem'};">
          ${activityLog.map(activity => {
    const eventInfo = getEventInfo(activity);
    return `
            <div style="
              background: #ffffff;
              border: 1px solid #e9ecef;
              border-radius: 0.5rem;
              padding: ${isMobileDevice() ? '0.75rem' : '1rem'};
              display: flex;
              gap: 0.75rem;
            ">
              <div style="
                width: 40px;
                height: 40px;
                border-radius: 50%;
                background: ${eventInfo.color}15;
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;
              ">
                <span class="material-icons" style="
                  color: ${eventInfo.color};
                  font-size: 20px;
                ">${eventInfo.icon}</span>
              </div>
              <div style="flex: 1; min-width: 0;">
                <div style="display: flex; justify-content: space-between; align-items: start; margin-bottom: 0.5rem; flex-wrap: ${isMobileDevice() ? 'wrap' : 'nowrap'};">
                  <div style="flex: 1; min-width: ${isMobileDevice() ? '100%' : 'auto'};">
                    <div style="
                      color: ${eventInfo.color};
                      font-size: ${isMobileDevice() ? '0.7rem' : '0.75rem'};
                      font-weight: 600;
                      margin-bottom: 0.25rem;
                      text-transform: uppercase;
                      letter-spacing: 0.5px;
                    ">${eventInfo.label}</div>
                    <h4 style="
                      margin: 0;
                      color: #2c3e50;
                      font-size: ${isMobileDevice() ? '0.85rem' : '0.9375rem'};
                      font-weight: 600;
                    ">${activity.title || 'Activity'}</h4>
                  </div>
                  <span style="
                    color: #6c757d;
                    font-size: ${isMobileDevice() ? '0.7rem' : '0.75rem'};
                    ${isMobileDevice() ? 'width: 100%; margin-top: 0.25rem;' : ''}
                  ">${new Date(activity.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}</span>
                </div>
                ${activity.description ? `
                  <p style="
                    margin: 0 0 0.5rem 0;
                    color: #6c757d;
                    font-size: ${isMobileDevice() ? '0.8rem' : '0.875rem'};
                    line-height: 1.5;
                  ">${activity.description}</p>
                ` : ''}
                ${activity.stage ? `
                  <p style="
                    margin: 0 0 0.5rem 0;
                    color: #6c757d;
                    font-size: ${isMobileDevice() ? '0.75rem' : '0.8125rem'};
                  ">Stage: <strong>${activity.stage}</strong></p>
                ` : ''}
                <p style="
                  margin: 0;
                  color: #9ca3af;
                  font-size: ${isMobileDevice() ? '0.7rem' : '0.75rem'};
                ">By ${activity.user_name}</p>
              </div>
            </div>
          `;
  }).join('')}
        </div>
      `}
    </div>
  `;
}

// Toggle project expansion to show/hide tasks
window.toggleProjectExpansion = async function (projectId) {
  // Toggle expansion state
  const wasExpanded = expandedProjects.has(projectId);
  if (wasExpanded) {
    expandedProjects.delete(projectId);
  } else {
    expandedProjects.add(projectId);
  }

  // Re-render PM Tool if in folder view (this will create the tasks container)
  if (currentScreen === 'team' && pmToolViewMode === 'folders') {
    await renderPMTool();
    // After re-rendering, wait for DOM to update then load tasks into the container
    if (!wasExpanded) {
      // Small delay to ensure DOM is updated
      setTimeout(async () => {
        await loadProjectTasks(projectId);
      }, 50);
    }
    return;
  }

  // Re-render just the projects tab if we have cached data
  if (currentScreen === 'sales' && selectedContactId && cachedContactData.contactId === selectedContactId) {
    const tabContentDiv = document.getElementById('contact-tab-content');
    if (tabContentDiv && contactDetailViewTab === 'projects') {
      tabContentDiv.innerHTML = await renderProjectsTab(cachedContactData.projects);
      return;
    }
  }
  // Fallback to full reload
  if (currentScreen === 'sales' && selectedContactId) {
    updateContactDetailContent();
  }
};

// Render Projects Tab
async function renderProjectsTab(projects) {
  const contact = contacts.find(c => c.id === selectedContactId);

  // Load tasks for this contact to show under projects
  const contactTasks = await loadContactTasks(selectedContactId);

  // Filter projects based on showAllProjects flag
  const filteredProjects = showAllProjects
    ? projects
    : projects.filter(p => p.status === 'active');

  // Check if there are non-active projects to filter
  const hasNonActiveProjects = projects.some(p => p.status !== 'active');

  return `
    <div style="display: flex; flex-direction: column; gap: 1rem;">
      <!-- Header with Create Button and Show All -->
      <div style="display: flex; justify-content: space-between; align-items: center; gap: 1rem;">
        <button onclick="showAddProjectModal()" style="
          background: #f59e0b;
          color: white;
          border: none;
          padding: 0.625rem 1rem;
          border-radius: 0.5rem;
          cursor: pointer;
          font-size: 0.875rem;
          font-weight: 600;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.375rem;
          transition: all 0.2s ease;
          box-shadow: 0 2px 4px rgba(0, 173, 181, 0.2);
        " onmouseover="this.style.background='#d97706'; this.style.boxShadow='0 4px 8px rgba(245, 158, 11, 0.3)'" onmouseout="this.style.background='#f59e0b'; this.style.boxShadow='0 2px 4px rgba(245, 158, 11, 0.2)'">
          <span style="font-size: 1rem;">+</span>
          Create Project
        </button>
        ${hasNonActiveProjects ? `
          <div style="display: flex; align-items: center; gap: 0.5rem;">
            <span style="color: #6c757d; font-size: 0.875rem; font-weight: 500;">View all projects</span>
            <label style="
              position: relative;
              display: inline-block;
              width: 44px;
              height: 24px;
              cursor: pointer;
            ">
              <input 
                type="checkbox" 
                ${showAllProjects ? 'checked' : ''}
                onchange="toggleShowAllProjects();"
                style="
                  opacity: 0;
                  width: 0;
                  height: 0;
                "
              />
              <span style="
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-color: ${showAllProjects ? '#00ADB5' : '#cbd5e1'};
                border-radius: 24px;
                transition: background-color 0.3s ease;
              ">
                <span style="
                  position: absolute;
                  content: '';
                  height: 18px;
                  width: 18px;
                  left: ${showAllProjects ? '22px' : '3px'};
                  bottom: 3px;
                  background-color: white;
                  border-radius: 50%;
                  transition: left 0.3s ease;
                  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
                "></span>
              </span>
            </label>
          </div>
        ` : ''}
      </div>

      ${filteredProjects.length === 0 ? `
        <div style="text-align: center; padding: 3rem 1rem;">
          <div style="font-size: 3rem; margin-bottom: 1rem; color: #6c757d;">
            <span class="material-icons" style="font-size: 3rem;">folder</span>
          </div>
          <p style="color: #6c757d; font-size: 0.875rem; margin: 0;">
            ${showAllProjects ? 'No projects for this contact' : 'No active projects for this contact'}
          </p>
          <p style="color: #6c757d; font-size: 0.75rem; margin: 0.5rem 0 0 0;">Click "+ Create Project" to get started</p>
        </div>
      ` : `
        <!-- Projects List -->
        <div style="display: flex; flex-direction: column; gap: 1rem;">
          ${filteredProjects.map(project => {
    const progress = project.progress_percentage || 0;
    const taskCount = project.task_count || 0;
    const completedCount = project.completed_tasks || 0;
    const statusColor = project.status === 'active' ? '#EF4444' :
      project.status === 'completed' ? '#10B981' :
        project.status === 'on_hold' ? '#F59E0B' : '#6B7280';
    const statusLabel = project.status ? project.status.charAt(0).toUpperCase() + project.status.slice(1).replace('_', ' ') : 'Active';

    const createdDate = project.created_at ? new Date(project.created_at).toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' }) : '';
    const dueDate = project.due_date ? new Date(project.due_date).toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' }) : '';

    const isInactive = project.status === 'completed' || project.status === 'cancelled';
    const cardOpacity = isInactive ? 0.6 : 1;
    const cardBackground = isInactive ? '#f9fafb' : '#ffffff';
    const cardBorder = isInactive ? '#e5e7eb' : '#f59e0b';

    return `
          <div style="
            background: ${cardBackground};
                border: 1px solid ${cardBorder};
                border-radius: 0.75rem;
                padding: 1.25rem;
                box-shadow: 0 2px 4px rgba(0,0,0,0.05);
                transition: all 0.2s ease;
                position: relative;
                opacity: ${cardOpacity};
              " onmouseover="this.style.boxShadow='0 4px 8px rgba(0,0,0,0.1)'" onmouseout="this.style.boxShadow='0 2px 4px rgba(0,0,0,0.05)'">
                <!-- Project Header -->
                <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 0.75rem;">
                  <div style="display: flex; align-items: center; gap: 0.5rem; flex: 1; min-width: 0;">
                    <button 
                      onclick="toggleProjectExpansion('${project.id}')"
                      style="
                        background: transparent;
                        color: #f59e0b;
                        border: 1px solid #f59e0b;
                        border-radius: 0.25rem;
                        width: auto;
                        height: 24px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                        font-size: 0.75rem;
                        font-weight: 500;
                        transition: all 0.2s ease;
                        flex-shrink: 0;
                        padding: 0 0.5rem;
                      "
                      onmouseover="this.style.background='#f59e0b'; this.style.color='white'; this.style.transform='scale(1.05)'"
                      onmouseout="this.style.background='transparent'; this.style.color='#f59e0b'; this.style.transform='scale(1)'"
                      title="Click to ${expandedProjects.has(project.id) ? 'collapse' : 'expand'} tasks"
                    >
                      ${expandedProjects.has(project.id) ? 'close tasks' : 'see tasks'}
                    </button>
                    <h4 style="
                      margin: 0;
                      font-size: 1.125rem;
                      font-weight: 700;
                      color: ${isInactive ? '#9ca3af' : '#2c3e50'};
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    ">${project.name || 'Untitled Project'}</h4>
                  </div>
                  
                  <!-- Action Buttons -->
                  <div style="display: flex; gap: 0.5rem; align-items: center; flex-shrink: 0;">
                    <div style="position: relative;">
                      <button onclick="toggleProjectStatusMenu('${project.id}')" style="
                        background: ${statusColor};
                        color: white;
                        padding: 0.25rem 0.75rem;
                        border-radius: 1rem;
                        font-size: 0.75rem;
                        font-weight: 600;
                        white-space: nowrap;
                        border: none;
                        cursor: pointer;
                        transition: all 0.2s ease;
                      " onmouseover="this.style.opacity='0.9'" onmouseout="this.style.opacity='1'">
                        ${statusLabel}
                      </button>
                      <div id="status-menu-${project.id}" onclick="event.stopPropagation();" style="
                        position: absolute;
                        top: 100%;
                        right: 0;
                        margin-top: 0.25rem;
                        background: white;
            border: 1px solid #e9ecef;
                        border-radius: 0.5rem;
                        box-shadow: 0 4px 12px rgba(0,0,0,0.15);
                        z-index: 1000;
                        display: none;
                        min-width: 120px;
                        overflow: hidden;
                      ">
                        <button onclick="changeProjectStatus('${project.id}', 'active'); event.stopPropagation();" style="
                          width: 100%;
                          padding: 0.5rem 0.75rem;
                          border: none;
                          background: ${project.status === 'active' ? '#f8f9fa' : 'white'};
                          color: #2c3e50;
                          text-align: left;
                          cursor: pointer;
                          font-size: 0.875rem;
                          transition: background 0.2s;
                        " onmouseover="this.style.background='#f8f9fa'" onmouseout="this.style.background='${project.status === 'active' ? '#f8f9fa' : 'white'}'">
                          Active
                        </button>
                        <button onclick="changeProjectStatus('${project.id}', 'completed'); event.stopPropagation();" style="
                          width: 100%;
                          padding: 0.5rem 0.75rem;
                          border: none;
                          background: ${project.status === 'completed' ? '#f8f9fa' : 'white'};
                          color: #2c3e50;
                          text-align: left;
                          cursor: pointer;
                          font-size: 0.875rem;
                          transition: background 0.2s;
                          border-top: 1px solid #e9ecef;
                        " onmouseover="this.style.background='#f8f9fa'" onmouseout="this.style.background='${project.status === 'completed' ? '#f8f9fa' : 'white'}'">
                          Completed
                        </button>
                        <button onclick="changeProjectStatus('${project.id}', 'cancelled'); event.stopPropagation();" style="
                          width: 100%;
                          padding: 0.5rem 0.75rem;
                          border: none;
                          background: ${project.status === 'cancelled' ? '#f8f9fa' : 'white'};
                          color: #2c3e50;
                          text-align: left;
                          cursor: pointer;
                          font-size: 0.875rem;
                          transition: background 0.2s;
                          border-top: 1px solid #e9ecef;
                        " onmouseover="this.style.background='#f8f9fa'" onmouseout="this.style.background='${project.status === 'cancelled' ? '#f8f9fa' : 'white'}'">
                          Cancelled
                        </button>
                      </div>
                    </div>
                    <button onclick="editProject('${project.id}')" style="
                      background: #ffffff;
                      color: #6c757d;
                      border: 1px solid #e9ecef;
                      padding: 0.375rem 0.75rem;
            border-radius: 0.375rem;
          cursor: pointer;
                      font-size: 0.875rem;
          font-weight: 500;
                      white-space: nowrap;
                      transition: all 0.2s ease;
                    " onmouseover="this.style.borderColor='#00ADB5'; this.style.color='#00ADB5'" onmouseout="this.style.borderColor='#e9ecef'; this.style.color='#6c757d'">
                      Edit
                    </button>
                    <button onclick="openTaskModalForContact('${selectedContactId}', '${project.id}')" style="
                      background: #f59e0b;
                      color: white;
                      border: none;
                      padding: 0.375rem 0.75rem;
                      border-radius: 0.375rem;
                      cursor: pointer;
                      font-size: 0.875rem;
                      font-weight: 600;
          display: flex;
          align-items: center;
                      gap: 0.25rem;
          white-space: nowrap;
                      transition: all 0.2s ease;
                    " onmouseover="this.style.background='#d97706'" onmouseout="this.style.background='#f59e0b'">
                      <span>+</span> Add Task
                    </button>
                  </div>
                </div>
                
                <!-- Progress Bar -->
                <div style="margin-bottom: 0.75rem;">
                  <div style="
                    width: 100%;
                    height: 6px;
                    background: #e9ecef;
                    border-radius: 3px;
            overflow: hidden;
                    margin-bottom: 0.25rem;
                  ">
                    <div style="
                      width: ${progress}%;
                      height: 100%;
                      background: #f59e0b;
                      transition: width 0.3s ease;
                    "></div>
                  </div>
                  <div style="display: flex; justify-content: space-between; align-items: center;">
                    <span style="font-size: 0.75rem; color: #6c757d; font-weight: 500;">
                      ${progress}% Complete
                    </span>
                    <span style="font-size: 0.75rem; color: #6c757d;">
                      ${completedCount} / ${taskCount} tasks
                    </span>
                  </div>
                </div>
                
                <!-- Dates -->
                <div style="display: flex; flex-wrap: wrap; gap: 1rem; margin-bottom: 0.5rem;">
                  ${dueDate ? `
                    <div style="font-size: 0.75rem; color: #6c757d;">
                      <span style="font-weight: 600;">Due:</span> ${dueDate}
                    </div>
                  ` : ''}
                  ${createdDate ? `
                    <div style="font-size: 0.75rem; color: #6c757d;">
                      <span style="font-weight: 600;">Created:</span> ${createdDate}
                    </div>
                  ` : ''}
                </div>
                
                <!-- Tasks List (shown when expanded) -->
                ${expandedProjects.has(project.id) ? (() => {
        const projectTasks = contactTasks.filter(t => t.project_id === project.id);
        if (projectTasks.length === 0) {
          return `
                      <div style="
                        margin-top: 1rem;
                        padding: 1rem;
                        background: #f8f9fa;
                        border-radius: 0.5rem;
                        text-align: center;
                        color: #6c757d;
                        font-size: 0.875rem;
                      ">
                        No tasks for this project
          </div>
        `;
        }
        return `
                    <div style="margin-top: 1rem; padding-top: 1rem; border-top: 1px solid #e9ecef;">
                      <div style="font-size: 0.875rem; font-weight: 600; color: #2c3e50; margin-bottom: 0.75rem;">
                        Tasks (${projectTasks.length})
                      </div>
                      <div style="display: flex; flex-direction: column; gap: 0.5rem;">
                        ${projectTasks.map(task => {
          const priorityColor = task.priority === 'URGENT' ? '#dc2626' :
            task.priority === 'HIGH' ? '#f97316' :
              task.priority === 'MEDIUM' ? '#f59e0b' : '#10b981';
          const stateColor = task.state === 'COMPLETED' ? '#10b981' :
            task.state === 'ACTIVE' ? '#3b82f6' :
              task.state === 'BACKLOG' ? '#6b7280' : '#f59e0b';
          const dueDate = task.due_at ? formatDateLocal(task.due_at, { month: 'numeric', day: 'numeric' }) : null;
          return `
                            <div style="
                              background: #f8f9fa;
                              border-left: 3px solid ${priorityColor};
                              border-radius: 0.375rem;
                              padding: 0.75rem;
                              display: flex;
                              align-items: flex-start;
                              gap: 0.75rem;
                            ">
                              <div style="
                                width: 20px;
                                height: 20px;
                                border: 2px solid ${stateColor};
                                border-radius: 0.25rem;
                                flex-shrink: 0;
                                margin-top: 0.125rem;
                                background: ${task.state === 'COMPLETED' ? stateColor : 'transparent'};
                              "></div>
                              <div style="flex: 1; min-width: 0;">
                                <div style="
                                  font-weight: 600;
                                  color: #2c3e50;
                                  font-size: 0.875rem;
                                  margin-bottom: 0.25rem;
                                ">${task.title || 'Untitled Task'}</div>
                                ${task.description ? `
                                  <div style="
                                    color: #6c757d;
                                    font-size: 0.75rem;
                                    margin-bottom: 0.25rem;
                                  ">${makeLinksClickable(task.description)}</div>
                                ` : ''}
                                <div style="display: flex; align-items: center; gap: 0.75rem; flex-wrap: wrap;">
                                  <span style="
                                    background: ${stateColor}20;
                                    color: ${stateColor};
                                    padding: 0.125rem 0.5rem;
                                    border-radius: 0.25rem;
                                    font-size: 0.75rem;
                                    font-weight: 500;
                                  ">${task.state || 'BACKLOG'}</span>
                                  ${dueDate ? `
                                    <span style="font-size: 0.75rem; color: #6c757d;">
                                      Due: ${dueDate}
                                    </span>
                                  ` : ''}
                                  ${task.priority ? `
                                    <span style="
                                      background: ${priorityColor}20;
                                      color: ${priorityColor};
                                      padding: 0.125rem 0.5rem;
                                      border-radius: 0.25rem;
                                      font-size: 0.75rem;
                                      font-weight: 500;
                                    ">${task.priority}</span>
                                  ` : ''}
                                </div>
                              </div>
                            </div>
                          `;
        }).join('')}
                      </div>
                    </div>
                  `;
      })() : ''}
                
                <!-- Delete Button -->
                <button onclick="deleteProject('${project.id}')" style="
                  position: absolute;
                  bottom: 1rem;
                  right: 1rem;
                  background: transparent;
                  border: none;
                  color: #ef4444;
                  cursor: pointer;
                  font-size: 0.875rem;
                  font-weight: 500;
                  padding: 0.25rem;
                  transition: all 0.2s ease;
                " onmouseover="this.style.transform='scale(1.2)'" onmouseout="this.style.transform='scale(1)'" title="Delete Project">
                  delete
        </button>
      </div>
            `;
  }).join('')}
        </div>
      `}
    </div>
  `;
}

// Render Tasks Tab
function renderTasksTab(tasks) {
  // Filter tasks - show only active (ACTIVE or BACKLOG) by default
  const activeTasks = tasks.filter(t => t.state === 'ACTIVE' || t.state === 'BACKLOG');
  const filteredTasks = showAllTasks ? tasks : activeTasks;

  // Check if there are completed tasks to filter
  const hasCompletedTasks = tasks.some(t => t.state === 'COMPLETED');

  // Group tasks by project
  const tasksByProject = {};
  const tasksWithoutProject = [];

  filteredTasks.forEach(task => {
    const projectName = task.project_name || 'No Project';
    if (projectName === 'No Project') {
      tasksWithoutProject.push(task);
    } else {
      if (!tasksByProject[projectName]) {
        tasksByProject[projectName] = [];
      }
      tasksByProject[projectName].push(task);
    }
  });

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'URGENT': return '#dc2626';
      case 'HIGH': return '#f97316';
      case 'MEDIUM': return '#f59e0b';
      case 'LOW': return '#10b981';
      default: return '#f59e0b';
    }
  };

  return `
    <div style="display: flex; flex-direction: column; gap: 1rem;">
      <!-- Header with Task Count, Show All, and Add Task Button -->
      <div style="display: flex; justify-content: space-between; align-items: center; gap: 1rem;">
        <h3 style="margin: 0; color: #2c3e50; font-size: ${isMobileDevice() ? '1rem' : '1.125rem'}; font-weight: 600;">
          ${filteredTasks.length} Task${filteredTasks.length !== 1 ? 's' : ''}
        </h3>
        <div style="display: flex; align-items: center; gap: 0.75rem;">
          ${hasCompletedTasks ? `
            <button onclick="toggleShowAllTasks()" style="
              background: transparent;
              color: #f59e0b;
              border: none;
              padding: 0.5rem 0.75rem;
              cursor: pointer;
              font-size: 0.875rem;
              font-weight: 500;
              text-decoration: underline;
            ">
              ${showAllTasks ? 'Show Active Only' : 'Show All'}
            </button>
          ` : ''}
          <button onclick="openTaskModalForContact('${selectedContactId}')" style="
            background: #f59e0b;
          color: white;
          border: none;
            padding: 0.5rem 1rem;
          border-radius: 0.375rem;
          cursor: pointer;
            font-size: 0.875rem;
            font-weight: 600;
          display: flex;
          align-items: center;
          gap: 0.375rem;
          white-space: nowrap;
        ">
          + Add Task
        </button>
      </div>
      </div>
      
      ${filteredTasks.length === 0 ? `
        <div style="text-align: center; padding: 3rem 1rem;">
          <div style="font-size: 3rem; margin-bottom: 1rem; color: #6c757d;">
            <span class="material-icons" style="font-size: 3rem;">check_circle</span>
          </div>
          <p style="color: #6c757d; font-size: 0.875rem; margin: 0;">
            ${showAllTasks ? 'No tasks for this contact' : 'No active tasks for this contact'}
          </p>
        </div>
      ` : `
        <!-- Tasks Grouped by Project -->
        <div style="display: flex; flex-direction: column; gap: 1.5rem;">
          ${Object.keys(tasksByProject).map(projectName => {
    const projectTasks = tasksByProject[projectName];
    return `
              <div style="display: flex; flex-direction: column; gap: 0.75rem;">
                <!-- Project Header -->
          <div style="
                  font-weight: 600;
                  font-size: 0.875rem;
                  color: #2c3e50;
                  padding-bottom: 0.5rem;
                  border-bottom: 1px solid #e9ecef;
                ">
                  ${projectName} (${projectTasks.length})
                </div>
                
                <!-- Tasks in this Project -->
                ${projectTasks.map(task => {
      const priorityColor = getPriorityColor(task.priority || 'MEDIUM');
      const dueDate = task.due_at ? formatDateLocal(task.due_at, { month: 'numeric', day: 'numeric', year: 'numeric' }) : null;
      const isCompleted = task.state === 'COMPLETED';

      return `
                    <div onclick="editTask('${task.id}')" style="
                      background: #ffffff;
                      border-left: 4px solid ${priorityColor};
                      border-radius: 0.5rem;
                      padding: 1rem;
                      box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                        cursor: pointer;
                      transition: all 0.2s ease;
                      display: flex;
                      align-items: flex-start;
                      gap: 0.75rem;
                      position: relative;
                    " onmouseover="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.15)'" onmouseout="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.1)'">
                      <!-- Task Content -->
                      <div style="flex: 1; min-width: 0;">
                        <h4 style="
                          margin: 0 0 0.25rem 0;
                          font-size: 1rem;
                          font-weight: 600;
                          color: #2c3e50;
                        ">${task.title || 'Untitled Task'}</h4>
                        ${task.description ? `
                          <p style="
                            margin: 0 0 0.5rem 0;
                            font-size: 0.875rem;
                            color: #6c757d;
                            line-height: 1.4;
                          ">${task.description}</p>
                        ` : ''}
                        <div style="display: flex; flex-wrap: wrap; gap: 0.75rem; align-items: center;">
                          ${dueDate ? `
                            <span style="font-size: 0.75rem; color: #6c757d;">
                              Due: ${dueDate}
                        </span>
                          ` : ''}
                        ${task.priority ? `
                        <span style="
                              font-size: 0.75rem;
                              font-weight: 600;
                              color: ${priorityColor};
                          ">
                            ${task.priority}
                        </span>
                        ` : ''}
                        </div>
                      </div>
                      
                      <!-- Completion Checkbox (on the right) -->
                      <div 
                        onclick="event.stopPropagation(); changeTaskStatus('${task.id}', '${isCompleted ? 'ACTIVE' : 'COMPLETED'}')"
                      style="
                          width: 20px;
                          height: 20px;
                          border: 2px solid ${isCompleted ? '#10b981' : '#d1d5db'};
                          border-radius: 50%;
                          flex-shrink: 0;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          background: ${isCompleted ? '#10b981' : 'transparent'};
                        cursor: pointer;
                          transition: all 0.2s ease;
                          color: white;
                          font-size: 0.75rem;
                          font-weight: 600;
                        "
                        onmouseover="this.style.borderColor=\"${isCompleted ? '#059669' : '#10b981'}\"; this.style.background=\"${isCompleted ? '#059669' : '#10b98120'}\""
                        onmouseout="this.style.borderColor=\"${isCompleted ? '#10b981' : '#d1d5db'}\"; this.style.background=\"${isCompleted ? '#10b981' : 'transparent'}\""
                        title="${isCompleted ? 'Mark as active' : 'Mark as complete'}"
                      >
                        ${isCompleted ? '✓' : ''}
                      </div>
                    </div>
                  `;
    }).join('')}
          </div>
        `;
  }).join('')}
          
          ${tasksWithoutProject.length > 0 ? `
            <div style="display: flex; flex-direction: column; gap: 0.75rem;">
              <!-- No Project Header -->
              <div style="
                font-weight: 600;
                font-size: 0.875rem;
                color: #2c3e50;
                padding-bottom: 0.5rem;
                border-bottom: 1px solid #e9ecef;
              ">
                No Project (${tasksWithoutProject.length})
              </div>
              
              <!-- Tasks without Project -->
              ${tasksWithoutProject.map(task => {
    const priorityColor = getPriorityColor(task.priority || 'MEDIUM');
    const dueDate = task.due_at ? new Date(task.due_at).toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' }) : null;
    const isCompleted = task.state === 'COMPLETED';

    return `
                  <div onclick="editTask('${task.id}')" style="
                    background: #ffffff;
                    border-left: 4px solid ${priorityColor};
                    border-radius: 0.5rem;
                    padding: 1rem;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                    cursor: pointer;
                    transition: all 0.2s ease;
                    display: flex;
                    align-items: flex-start;
                    gap: 0.75rem;
                    position: relative;
                  " onmouseover="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.15)'" onmouseout="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.1)'">
                    <!-- Task Content -->
                    <div style="flex: 1; min-width: 0;">
                      <h4 style="
                        margin: 0 0 0.25rem 0;
                        font-size: 1rem;
                        font-weight: 600;
                        color: #2c3e50;
                      ">${task.title || 'Untitled Task'}</h4>
                      ${task.description ? `
                        <p style="
                          margin: 0 0 0.5rem 0;
                          font-size: 0.875rem;
                          color: #6c757d;
                          line-height: 1.4;
                        ">${task.description}</p>
                      ` : ''}
                      <div style="display: flex; flex-wrap: wrap; gap: 0.75rem; align-items: center;">
                        ${dueDate ? `
                          <span style="font-size: 0.75rem; color: #6c757d;">
                            Due: ${dueDate}
                        </span>
                        ` : ''}
                        ${task.priority ? `
                          <span style="
                            font-size: 0.75rem;
                            font-weight: 600;
                            color: ${priorityColor};
                          ">
                            ${task.priority}
                          </span>
                        ` : ''}
                      </div>
                    </div>
                    
                    <!-- Completion Checkbox (on the right) -->
                    <div 
                      onclick="event.stopPropagation(); changeTaskStatus('${task.id}', '${isCompleted ? 'ACTIVE' : 'COMPLETED'}')"
                      style="
                        width: 20px;
                        height: 20px;
                        border: 2px solid ${isCompleted ? '#10b981' : '#d1d5db'};
                        border-radius: 50%;
                        flex-shrink: 0;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background: ${isCompleted ? '#10b981' : 'transparent'};
                        cursor: pointer;
                        transition: all 0.2s ease;
                        color: white;
                        font-size: 0.75rem;
                        font-weight: 600;
                      "
                      onmouseover="this.style.borderColor=\"${isCompleted ? '#059669' : '#10b981'}\"; this.style.background=\"${isCompleted ? '#059669' : '#10b98120'}\""
                      onmouseout="this.style.borderColor=\"${isCompleted ? '#10b981' : '#d1d5db'}\"; this.style.background=\"${isCompleted ? '#10b981' : 'transparent'}\""
                      title="${isCompleted ? 'Mark as active' : 'Mark as complete'}"
                    >
                      ${isCompleted ? '✓' : ''}
                    </div>
                  </div>
                  `;
  }).join('')}
          </div>
          ` : ''}
        </div>
      `}
    </div>
  `;
}

// Render Chats Tab
function renderChatsTab(chats) {
  return `
    <div>
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
        <h3 style="margin: 0; color: #2c3e50; font-size: ${isMobileDevice() ? '1rem' : '1.125rem'}; font-weight: 600;">
          Chats
        </h3>
      </div>
      ${chats.length === 0 ? `
        <div style="text-align: center; padding: 3rem 1rem;">
          <p style="color: #6c757d; font-size: 0.875rem; margin: 0;">No chats for this contact</p>
        </div>
      ` : `
        <div style="display: flex; flex-direction: column; gap: ${isMobileDevice() ? '0.75rem' : '1rem'};">
          ${chats.map(chat => `
            <div 
              onclick="openChatFromContact('${chat.id}')"
              style="
              background: #ffffff;
              border: 1px solid #e9ecef;
              border-radius: 0.375rem;
              padding: ${isMobileDevice() ? '0.75rem' : '1rem'};
                cursor: pointer;
                transition: all 0.2s ease;
              "
              onmouseover="this.style.background='#f8f9fa'; this.style.borderColor='#007bff';"
              onmouseout="this.style.background='#ffffff'; this.style.borderColor='#e9ecef';"
            >
              <div style="display: flex; justify-content: space-between; align-items: start; margin-bottom: 0.5rem; flex-wrap: ${isMobileDevice() ? 'wrap' : 'nowrap'};">
                <h4 style="
                  margin: 0;
                  color: #2c3e50;
                  font-size: ${isMobileDevice() ? '0.8rem' : '0.875rem'};
                  font-weight: 600;
                  flex: 1;
                  min-width: ${isMobileDevice() ? '100%' : 'auto'};
                ">${chat.title || 'Untitled Chat'}</h4>
                <span style="
                  color: #6c757d;
                  font-size: ${isMobileDevice() ? '0.7rem' : '0.75rem'};
                  ${isMobileDevice() ? 'width: 100%; margin-top: 0.25rem;' : ''}
                ">${chat.created_at ? new Date(chat.created_at).toLocaleDateString() : 'N/A'}</span>
              </div>
              ${chat.last_message ? `
                <p style="
                  margin: 0;
                  color: #6c757d;
                  font-size: ${isMobileDevice() ? '0.8rem' : '0.875rem'};
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                ">${chat.last_message}</p>
              ` : ''}
            </div>
          `).join('')}
        </div>
      `}
    </div>
  `;
}

// Render Add Opportunity Modal
function renderAddOpportunityModal() {
  const stageOptions = [
    { value: 'new', label: 'New' },
    { value: 'contacted', label: 'Contacted' },
    { value: 'qualified', label: 'Qualified' },
    { value: 'proposal', label: 'Proposal' },
    { value: 'negotiation', label: 'Negotiation' },
    { value: 'won', label: 'Won' },
    { value: 'lost', label: 'Lost' }
  ];

  const sourceOptions = [
    { value: 'referral', label: 'Referral' },
    { value: 'website', label: 'Website' },
    { value: 'walk_in', label: 'Walk-in' },
    { value: 'phone', label: 'Phone' },
    { value: 'email', label: 'Email' },
    { value: 'cold', label: 'Cold' },
    { value: 'other', label: 'Other' }
  ];

  const chanceOptions = [
    { value: 'low', label: 'Low (25%)' },
    { value: 'medium', label: 'Medium (50%)' },
    { value: 'high', label: 'High (80%)' }
  ];

  return `
    <!-- Modal Overlay -->
    <div id="add-opportunity-modal" onclick="if (event.target.id === 'add-opportunity-modal') { cancelOpportunityModal(); }" style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 99999;
      animation: fadeIn 0.3s ease-out;
    ">
      <!-- Modal Content -->
      <div onclick="event.stopPropagation()" style="
        background: #ffffff;
        border-radius: 1rem;
        padding: 0;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
        max-width: 600px;
        width: 95%;
        max-height: 90vh;
        overflow-y: auto;
        animation: slideIn 0.3s ease-out;
        position: relative;
      ">
        <!-- Header -->
        <div style="
          padding: 1rem 1.5rem;
          border-bottom: 1px solid #e9ecef;
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: sticky;
          top: 0;
          background: #ffffff;
          z-index: 10;
        ">
          <button
            onclick="event.stopPropagation(); cancelOpportunityModal();"
            style="
              background: transparent;
              border: none;
              color: #2c3e50;
              cursor: pointer;
              font-size: 0.875rem;
              font-weight: 500;
              padding: 0.5rem;
            "
          >
            Cancel
          </button>
          <h2 style="
            margin: 0;
            color: #2c3e50;
            font-size: 1.125rem;
            font-weight: 700;
          ">
            ${editingOpportunityId ? 'Edit Sales Opportunity' : 'Add Sales Opportunity'}
          </h2>
          <button
            id="save-opportunity-btn"
            onclick="event.stopPropagation(); handleAddOpportunity(event)"
            ${(() => {
      // Disable save button for employees viewing others' opportunities
      if (editingOpportunityId && window.canEditCurrentOpportunity === false) {
        return 'disabled style="background: #d1d5db; color: #9ca3af; border: none; padding: 0.5rem 1rem; border-radius: 0.375rem; cursor: not-allowed; font-size: 0.875rem; font-weight: 600;"';
      }
      return 'style="background: #ea580c; color: white; border: none; padding: 0.5rem 1rem; border-radius: 0.375rem; cursor: pointer; font-size: 0.875rem; font-weight: 600;"';
    })()}
          >
            Save
          </button>
        </div>

        <!-- Form Content -->
        <form id="add-opportunity-form" onsubmit="handleAddOpportunity(event); return false;" style="padding: 1.5rem;">
          ${(() => {
      // Show view-only notice for employees viewing others' opportunities
      if (editingOpportunityId && window.canEditCurrentOpportunity === false) {
        return `
                <div style="
                  background: #fef3c7;
                  border-left: 4px solid #f59e0b;
                  padding: 1rem;
                  border-radius: 0.5rem;
                  margin-bottom: 1.5rem;
                ">
                  <p style="
                    margin: 0;
                    font-size: 0.875rem;
                    font-weight: 600;
                    color: #92400e;
                  ">
                    View Only - You can only edit your own sales opportunities
                  </p>
                </div>
              `;
      }
      return '';
    })()}
          <div style="display: flex; flex-direction: column; gap: 1.5rem;">
            ${isOpportunityModalFromSales ? `
            <!-- Contact Selector (only when opened from sales page) -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 700;
                font-size: 0.875rem;
              ">
                Contact (Optional)
              </label>
              <div style="position: relative;">
                ${selectedOpportunityContactId ? `
                  <div style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0.75rem;
                    border: 1px solid #e5e7eb;
                    border-radius: 0.5rem;
                    background: #f9fafb;
                  ">
                    <span style="color: #2c3e50; font-size: 0.875rem;">
                      ${(() => {
          const contact = contacts.find(c => c.id === selectedOpportunityContactId);
          return contact ? `${contact.first_name || ''} ${contact.last_name || ''}`.trim() || contact.company || 'Selected Contact' : 'Selected Contact';
        })()}
                    </span>
                    <button
                      type="button"
                      onclick="clearOpportunityContact()"
                      style="
                        background: transparent;
                        border: none;
                        color: #ef4444;
                        cursor: pointer;
                        padding: 0.25rem 0.5rem;
                        font-size: 0.75rem;
                      "
                    >×</button>
                  </div>
                ` : `
                  <input
                    type="text"
                    id="opportunity-contact-search-input"
                    placeholder="Search contacts..."
                    value="${opportunityContactSearchQuery || ''}"
                    oninput="handleOpportunityContactSearch(this.value)"
                    style="
                      width: 100%;
                      padding: 0.75rem;
                      border: 1px solid #e5e7eb;
                      border-radius: 0.5rem;
                      font-size: 0.875rem;
                      box-sizing: border-box;
                      transition: border-color 0.2s;
                    "
                    onfocus="this.style.borderColor='#f59e0b'"
                    onblur="this.style.borderColor='#e5e7eb'"
                  />
                  <div id="opportunity-contact-search-results" style="
                    max-height: 200px;
                    overflow-y: auto;
                    border: 1px solid #e5e7eb;
                    border-radius: 0.5rem;
                    background: #ffffff;
                    margin-top: 0.5rem;
                    display: ${opportunityContactSearchQuery && opportunityContactSearchQuery.trim() ? 'block' : 'none'};
                    position: absolute;
                    width: 100%;
                    z-index: 1000;
                    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
                  ">
                    ${contacts.filter(contact =>
          `${contact.first_name || ''} ${contact.last_name || ''} ${contact.company || ''}`.toLowerCase().includes((opportunityContactSearchQuery || '').toLowerCase())
        ).map(contact => `
                      <div
                        onclick="selectOpportunityContact('${contact.id}')"
                        style="
                          padding: 0.75rem;
                          border-bottom: 1px solid #e9ecef;
                          cursor: pointer;
                          transition: background-color 0.2s;
                          display: flex;
                          justify-content: space-between;
                          align-items: center;
                        "
                        onmouseover="this.style.backgroundColor='#f8f9fa'"
                        onmouseout="this.style.backgroundColor='transparent'"
                      >
                        <div>
                          <div style="font-weight: 500; color: #2c3e50;">${contact.first_name || ''} ${contact.last_name || ''}</div>
                          ${contact.company ? `<div style="font-size: 0.75rem; color: #6c757d; margin-top: 0.25rem;">${contact.company}</div>` : ''}
                        </div>
                        ${contact.contact_profile_id ? `
                          <span style="background: #ff7f00; color: white; padding: 0.25rem 0.5rem; border-radius: 0.25rem; font-size: 0.75rem; font-weight: 600;">Client</span>
                        ` : ''}
                      </div>
                    `).join('')}
                    ${contacts.filter(contact =>
          `${contact.first_name || ''} ${contact.last_name || ''} ${contact.company || ''}`.toLowerCase().includes((opportunityContactSearchQuery || '').toLowerCase())
        ).length === 0 && opportunityContactSearchQuery && opportunityContactSearchQuery.trim() ? `
                      <div style="padding: 1rem; text-align: center; color: #6c757d; font-size: 0.875rem;">
                        No contacts found matching "${opportunityContactSearchQuery}"
                      </div>
                    ` : ''}
                  </div>
                `}
              </div>
            </div>
            ` : ''}
            <!-- Title (Product) -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 700;
                font-size: 0.875rem;
              ">
                Title (Product) *
              </label>
              <input
                type="text"
                id="opportunity-title"
                placeholder="e.g., Software License, Consulting Services"
                required
                value="${opportunityFormData.title}"
                oninput="opportunityFormData.title = this.value"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e5e7eb;
                  border-radius: 0.5rem;
                  font-size: 1rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s ease;
                "
                onfocus="this.style.borderColor='#00ADB5'"
                onblur="this.style.borderColor='#e5e7eb'"
              />
            </div>

            <!-- Assign to (single: search + select like task form) -->
            <div style="margin-bottom: 1rem;">
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 700;
                font-size: 0.875rem;
              ">
                Assign to *
              </label>
              <input
                type="text"
                id="opportunity-member-search-input"
                placeholder="Search members..."
                value="${window.opportunityMemberSearchQuery || ''}"
                oninput="handleOpportunityMemberSearch(this.value)"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e5e7eb;
                  border-radius: 0.5rem;
                  font-size: 0.875rem;
                  box-sizing: border-box;
                  margin-bottom: 0.5rem;
                  transition: border-color 0.2s;
                "
                onfocus="this.style.borderColor='#00ADB5'; handleOpportunityMemberSearch(document.getElementById('opportunity-member-search-input')?.value || '')"
                onblur="this.style.borderColor='#e5e7eb'"
              />
              <div id="opportunity-selected-assignee-display" style="
                display: flex;
                flex-wrap: wrap;
                gap: 0.5rem;
                margin-bottom: 0.5rem;
                min-height: 40px;
              ">
                ${(() => {
      const assignedId = window.selectedOpportunityAssignedTo || opportunityFormData.assigned_to || '';
      const emp = (companyEmployees || []).find(e => e.id === assignedId);
      return emp ? `
                  <div style="
                    background: #ea580c;
                    color: white;
                    padding: 0.5rem 0.75rem;
                    border-radius: 1.5rem;
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    font-size: 0.875rem;
                    font-weight: 500;
                  ">
                    ${(emp.name || 'Unknown').replace(/</g, '&lt;')}
                    <button type="button" onclick="event.preventDefault(); removeOpportunityAssignee(event); return false;" style="background: rgba(255,255,255,0.3); border: none; color: white; cursor: pointer; font-size: 1rem; padding: 0; width: 18px; height: 18px; display: flex; align-items: center; justify-content: center; border-radius: 50%;">×</button>
                  </div>
                ` : '<span style="color: #6b7280; font-size: 0.875rem;">Select a team member</span>';
    })()}
              </div>
              <div id="opportunity-member-search-results" style="
                max-height: 200px;
                overflow-y: auto;
                border: 1px solid #e5e7eb;
                border-radius: 0.5rem;
                background: #ffffff;
                display: ${(window.opportunityMemberSearchQuery || '').trim() ? 'block' : 'none'};
              ">
                ${((companyEmployees || []).filter(emp => {
      const selected = window.selectedOpportunityAssignedTo || opportunityFormData.assigned_to || '';
      if (emp.id === selected) return false;
      const q = (window.opportunityMemberSearchQuery || '').toLowerCase();
      return !q || (emp.name || '').toLowerCase().includes(q);
    })).map(emp => `
                  <div onmousedown="event.preventDefault(); addOpportunityAssignee('${emp.id}')" style="padding: 0.75rem; border-bottom: 1px solid #e9ecef; cursor: pointer; transition: background-color 0.2s;" onmouseover="this.style.backgroundColor='#f8f9fa'" onmouseout="this.style.backgroundColor='transparent'">${(emp.name || 'Unknown').replace(/</g, '&lt;')}</div>
                `).join('')}
                ${(companyEmployees || []).filter(emp => {
      const selected = window.selectedOpportunityAssignedTo || opportunityFormData.assigned_to || '';
      if (emp.id === selected) return false;
      const q = (window.opportunityMemberSearchQuery || '').toLowerCase();
      return !q || (emp.name || '').toLowerCase().includes(q);
    }).length === 0 && (window.opportunityMemberSearchQuery || '').trim() ? `
                  <div style="padding: 1rem; text-align: center; color: #6c757d; font-size: 0.875rem;">No members found</div>
                ` : ''}
              </div>
            </div>

            <!-- Stage -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 700;
                font-size: 0.875rem;
              ">
                Stage *
              </label>
              <div id="stage-buttons" style="display: flex; flex-wrap: wrap; gap: 0.5rem;">
                ${stageOptions.map(option => `
                  <button
                    type="button"
                    onclick="updateOpportunityStage('${option.value}')"
                    id="stage-btn-${option.value}"
                    style="
                      padding: 0.5rem 1rem;
                      border-radius: 0.5rem;
                      border: 2px solid ${opportunityFormData.stage === option.value ? '#f59e0b' : '#e5e7eb'};
                      background: ${opportunityFormData.stage === option.value ? '#fef3c7' : '#ffffff'};
                      color: ${opportunityFormData.stage === option.value ? '#f59e0b' : '#6c757d'};
                      cursor: pointer;
                      font-size: 0.875rem;
                      font-weight: 500;
                      transition: all 0.2s ease;
                    "
                  >
                    ${option.label}
                  </button>
                `).join('')}
              </div>
            </div>

            <!-- Expected Close Date -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 700;
                font-size: 0.875rem;
              ">
                Expected Close Date *
              </label>
              <input
                type="date"
                id="opportunity-close-date"
                required
                value="${opportunityFormData.expected_close_date}"
                oninput="opportunityFormData.expected_close_date = this.value"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e5e7eb;
                  border-radius: 0.5rem;
                  font-size: 1rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s ease;
                "
                onfocus="this.style.borderColor='#00ADB5'"
                onblur="this.style.borderColor='#e5e7eb'"
              />
            </div>

            <!-- Amount -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 700;
                font-size: 0.875rem;
              ">
                Amount (Currency) *
              </label>
              <input
                type="number"
                id="opportunity-amount"
                step="0.01"
                min="0"
                placeholder="0.00"
                required
                value="${opportunityFormData.amount}"
                oninput="opportunityFormData.amount = this.value"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e5e7eb;
                  border-radius: 0.5rem;
                  font-size: 1rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s ease;
                "
                onfocus="this.style.borderColor='#00ADB5'"
                onblur="this.style.borderColor='#e5e7eb'"
              />
            </div>

            <!-- Source -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 700;
                font-size: 0.875rem;
              ">
                Source
              </label>
              <div id="source-buttons" style="display: flex; flex-wrap: wrap; gap: 0.5rem;">
                ${sourceOptions.map(option => `
                  <button
                    type="button"
                    onclick="updateOpportunitySource('${option.value}')"
                    id="source-btn-${option.value}"
                    style="
                      padding: 0.5rem 1rem;
                      border-radius: 0.5rem;
                      border: 2px solid ${opportunityFormData.source === option.value ? '#f59e0b' : '#e5e7eb'};
                      background: ${opportunityFormData.source === option.value ? '#fef3c7' : '#ffffff'};
                      color: ${opportunityFormData.source === option.value ? '#f59e0b' : '#6c757d'};
                      cursor: pointer;
                      font-size: 0.875rem;
                      font-weight: 500;
                      transition: all 0.2s ease;
                    "
                  >
                    ${option.label}
                  </button>
                `).join('')}
              </div>
            </div>

            <!-- Chance (Probability) -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 700;
                font-size: 0.875rem;
              ">
                Chance (Probability)
              </label>
              <div id="chance-buttons" style="display: flex; flex-wrap: wrap; gap: 0.5rem;">
                ${chanceOptions.map(option => {
      const getChanceColors = (value) => {
        if (value === 'low') {
          return {
            border: opportunityFormData.chance === value ? '#ef4444' : '#e5e7eb',
            background: opportunityFormData.chance === value ? '#fee2e2' : '#ffffff',
            color: opportunityFormData.chance === value ? '#dc2626' : '#6c757d'
          };
        } else if (value === 'medium') {
          return {
            border: opportunityFormData.chance === value ? '#f59e0b' : '#e5e7eb',
            background: opportunityFormData.chance === value ? '#fef3c7' : '#ffffff',
            color: opportunityFormData.chance === value ? '#d97706' : '#6c757d'
          };
        } else if (value === 'high') {
          return {
            border: opportunityFormData.chance === value ? '#10b981' : '#e5e7eb',
            background: opportunityFormData.chance === value ? '#d1fae5' : '#ffffff',
            color: opportunityFormData.chance === value ? '#059669' : '#6c757d'
          };
        }
        return {
          border: '#e5e7eb',
          background: '#ffffff',
          color: '#6c757d'
        };
      };
      const colors = getChanceColors(option.value);
      return `
                  <button
                    type="button"
                    onclick="updateOpportunityChance('${option.value}')"
                    id="chance-btn-${option.value}"
                    style="
                      padding: 0.5rem 1rem;
                      border-radius: 0.5rem;
                      border: 2px solid ${colors.border};
                      background: ${colors.background};
                      color: ${colors.color};
                      cursor: pointer;
                      font-size: 0.875rem;
                      font-weight: 500;
                      transition: all 0.2s ease;
                    "
                  >
                    ${option.label}
                  </button>
                `;
    }).join('')}
              </div>
            </div>

            <!-- Follow-Up (Date & Time) -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 700;
                font-size: 0.875rem;
              ">
                Follow-Up (Date & Time) *
              </label>
              <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 0.75rem;">
                <div>
                  <div style="font-size: 0.75rem; color: #6c757d; margin-bottom: 0.25rem;">Date</div>
                  <input
                    type="date"
                    id="opportunity-follow-up-date"
                    required
                    value="${opportunityFormData.follow_up_date}"
                    oninput="opportunityFormData.follow_up_date = this.value"
                    style="
                      width: 100%;
                      padding: 0.75rem;
                      border: 1px solid #e5e7eb;
                      border-radius: 0.5rem;
                      font-size: 1rem;
                      box-sizing: border-box;
                      transition: border-color 0.2s ease;
                    "
                    onfocus="this.style.borderColor='#00ADB5'"
                    onblur="this.style.borderColor='#e5e7eb'"
                  />
                </div>
                <div>
                  <div style="font-size: 0.75rem; color: #6c757d; margin-bottom: 0.25rem;">Time</div>
                  <input
                    type="time"
                    id="opportunity-follow-up-time"
                    required
                    value="${opportunityFormData.follow_up_time || '09:00'}"
                    oninput="opportunityFormData.follow_up_time = this.value"
                    style="
                      width: 100%;
                      padding: 0.75rem;
                      border: 1px solid #e5e7eb;
                      border-radius: 0.5rem;
                      font-size: 1rem;
                      box-sizing: border-box;
                      transition: border-color 0.2s ease;
                    "
                    onfocus="this.style.borderColor='#00ADB5'"
                    onblur="this.style.borderColor='#e5e7eb'"
                  />
                </div>
              </div>
            </div>

            <!-- Notes -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 700;
                font-size: 0.875rem;
              ">
                Notes
              </label>
              <textarea
                id="opportunity-notes"
                placeholder="Additional notes about this opportunity..."
                rows="4"
                oninput="opportunityFormData.notes = this.value"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e5e7eb;
                  border-radius: 0.5rem;
                  font-size: 1rem;
                  box-sizing: border-box;
                  resize: vertical;
                  font-family: inherit;
                  transition: border-color 0.2s ease;
                  min-height: 100px;
                "
                onfocus="this.style.borderColor='#00ADB5'"
                onblur="this.style.borderColor='#e5e7eb'"
              >${opportunityFormData.notes || ''}</textarea>
            </div>

            <!-- Archived Toggle -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 700;
                font-size: 0.875rem;
              ">
                Archived
              </label>
              <div style="display: flex; align-items: center; gap: 0.75rem;">
                <button
                  type="button"
                  onclick="toggleOpportunityArchived()"
                  id="archived-toggle"
                  style="
                    width: 48px;
                    height: 24px;
                    border-radius: 12px;
                    border: none;
                    background: ${opportunityFormData.archived ? '#10b981' : '#d1d5db'};
                    cursor: pointer;
                    position: relative;
                    transition: background-color 0.2s ease;
                    padding: 0;
                  "
                >
                  <div style="
                    width: 20px;
                    height: 20px;
                    border-radius: 50%;
                    background: white;
                    position: absolute;
                    top: 2px;
                    left: ${opportunityFormData.archived ? '26px' : '2px'};
                    transition: left 0.2s ease;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.2);
                  "></div>
                </button>
                <span style="
                  color: ${opportunityFormData.archived ? '#10b981' : '#6c757d'};
                  font-size: 0.875rem;
                  font-weight: ${opportunityFormData.archived ? '600' : '500'};
                ">
                  ${opportunityFormData.archived ? 'Archived' : 'Not Archived'}
                </span>
              </div>
              <p style="
                margin: 0.5rem 0 0 0;
                color: #6c757d;
                font-size: 0.75rem;
              ">
                Marking as archived will set the closed date. The stage indicates if it was won or lost.
              </p>
            </div>
          </div>
        </form>
      </div>
    </div>
  `;
}

// Opportunity assignee: search and single-select (like task form)
window.handleOpportunityMemberSearch = function (query) {
  window.opportunityMemberSearchQuery = typeof query === 'string' ? query : (document.getElementById('opportunity-member-search-input')?.value || '');
  const resultsDiv = document.getElementById('opportunity-member-search-results');
  if (!resultsDiv) return;
  const selected = window.selectedOpportunityAssignedTo || '';
  const list = companyEmployees || [];
  const q = (window.opportunityMemberSearchQuery || '').toLowerCase().trim();
  const filtered = list.filter(emp => emp.id !== selected && (!q || (emp.name || '').toLowerCase().includes(q)));
  resultsDiv.innerHTML = filtered.map(emp => `
    <div onmousedown="event.preventDefault(); addOpportunityAssignee('${emp.id}')" style="padding: 0.75rem; border-bottom: 1px solid #e9ecef; cursor: pointer; transition: background-color 0.2s;" onmouseover="this.style.backgroundColor='#f8f9fa'" onmouseout="this.style.backgroundColor='transparent'">${(emp.name || 'Unknown').replace(/</g, '&lt;')}</div>
  `).join('') + (filtered.length === 0 && q ? '<div style="padding: 1rem; text-align: center; color: #6c757d; font-size: 0.875rem;">No members found</div>' : '');
  resultsDiv.style.display = (window.opportunityMemberSearchQuery || '').trim() ? 'block' : 'none';
};

window.addOpportunityAssignee = function (memberId) {
  window.selectedOpportunityAssignedTo = memberId;
  opportunityFormData.assigned_to = memberId;
  updateOpportunityAssignedDisplay();
  window.opportunityMemberSearchQuery = '';
  const input = document.getElementById('opportunity-member-search-input');
  if (input) { input.value = ''; input.blur(); }
  const resultsDiv = document.getElementById('opportunity-member-search-results');
  if (resultsDiv) { resultsDiv.style.display = 'none'; resultsDiv.innerHTML = ''; }
};

window.removeOpportunityAssignee = function (event) {
  if (event) event.preventDefault();
  window.selectedOpportunityAssignedTo = null;
  opportunityFormData.assigned_to = '';
  updateOpportunityAssignedDisplay();
};

function updateOpportunityAssignedDisplay() {
  const displayDiv = document.getElementById('opportunity-selected-assignee-display');
  if (!displayDiv) return;
  const assignedId = window.selectedOpportunityAssignedTo || opportunityFormData?.assigned_to || '';
  const emp = (companyEmployees || []).find(e => e.id === assignedId);
  displayDiv.innerHTML = emp
    ? `<div style="background: #ea580c; color: white; padding: 0.5rem 0.75rem; border-radius: 1.5rem; display: flex; align-items: center; gap: 0.5rem; font-size: 0.875rem; font-weight: 500;">${(emp.name || 'Unknown').replace(/</g, '&lt;')}<button type="button" onclick="event.preventDefault(); removeOpportunityAssignee(event); return false;" style="background: rgba(255,255,255,0.3); border: none; color: white; cursor: pointer; font-size: 1rem; padding: 0; width: 18px; height: 18px; display: flex; align-items: center; justify-content: center; border-radius: 50%;">×</button></div>`
    : '<span style="color: #6b7280; font-size: 0.875rem;">Select a team member</span>';
}

// Handle Add Opportunity
window.handleAddOpportunity = async function (e) {
  if (e) e.preventDefault();

  const titleInput = document.getElementById('opportunity-title');
  const closeDateInput = document.getElementById('opportunity-close-date');
  const amountInput = document.getElementById('opportunity-amount');
  const followUpDateInput = document.getElementById('opportunity-follow-up-date');
  const followUpTimeInput = document.getElementById('opportunity-follow-up-time');

  const title = titleInput?.value?.trim() || '';
  const expectedCloseDate = closeDateInput?.value || '';
  const amount = amountInput?.value || '';
  const followUpDate = followUpDateInput?.value || '';
  const followUpTime = followUpTimeInput?.value || '09:00';
  const assignedTo = (window.selectedOpportunityAssignedTo || opportunityFormData.assigned_to || '').trim();

  // Validation: require assignee (no auto-assign to current user)
  if (!title || !expectedCloseDate || !amount || !followUpDate || !assignedTo) {
    alert('Please fill in all required fields including Assign to.');
    return;
  }

  const submitBtn = document.getElementById('save-opportunity-btn');
  if (submitBtn) {
    submitBtn.disabled = true;
    submitBtn.textContent = 'Saving...';
  }

  try {
    // Combine follow-up date and time
    let followUpDateTime = null;
    if (followUpDate && followUpTime) {
      const [hours, minutes] = followUpTime.split(':');
      const date = new Date(followUpDate);
      date.setHours(parseInt(hours), parseInt(minutes), 0, 0);
      followUpDateTime = date.toISOString();
    }

    let data, error;

    // Handle archived status - if archived, ensure stage is won or lost and set closed_at
    // Note: 'archived' is not a valid stage, so use the actual stage value
    let stageToSave = opportunityFormData.stage || 'new';
    let closedAt = null;

    if (opportunityFormData.archived) {
      // If archived, ensure stage is won or lost (should already be set by toggle function)
      const isAlreadyWonOrLost = stageToSave === 'won' || stageToSave === 'lost';
      if (!isAlreadyWonOrLost) {
        // Fallback: if somehow archived but not won/lost, set to won
        stageToSave = 'won';
      }
      closedAt = new Date().toISOString();
    } else {
      // If not archived, clear closed_at
      closedAt = null;
    }

    if (editingOpportunityId) {
      // Permission check: Employees can only save their own opportunities
      // Managers and Owners can save any opportunity
      if (window.canEditCurrentOpportunity === false) {
        window.showNotification('You can only edit your own sales opportunities', 'error');
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Save';
        }
        return;
      }

      // Update existing opportunity
      const updateData = {
        title: title,
        stage: stageToSave,
        expected_close_date: expectedCloseDate,
        amount: parseFloat(amount),
        source: opportunityFormData.source || 'website',
        chance: opportunityFormData.chance || 'medium',
        follow_up_date: followUpDateTime,
        notes: opportunityFormData.notes?.trim() || null,
        assigned_to: assignedTo,
        updated_at: new Date().toISOString(),
      };

      // Set or clear closed_at based on archived status
      updateData.closed_at = closedAt;

      const result = await supabase
        .from('sales_opportunities')
        .update(updateData)
        .eq('id', editingOpportunityId)
        .select()
        .single();

      data = result.data;
      error = result.error;
    } else {
      // Create new opportunity
      // Use selected contact from sales modal if opened from sales page, or from form submission if selectedOpportunityContactId is set, otherwise use selectedContactId
      const contactIdToUse = (isOpportunityModalFromSales || selectedOpportunityContactId) ? selectedOpportunityContactId : selectedContactId;

      const insertData = {
        company_id: currentCompany.id,
        contact_id: contactIdToUse,
        assigned_to: assignedTo,
        title: title,
        stage: stageToSave,
        expected_close_date: expectedCloseDate,
        amount: parseFloat(amount),
        source: opportunityFormData.source || 'website',
        chance: opportunityFormData.chance || 'medium',
        follow_up_date: followUpDateTime,
        notes: opportunityFormData.notes?.trim() || null,
        status: 'active',
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      };

      // Set closed_at (null if not archived)
      insertData.closed_at = closedAt;

      const result = await supabase
        .from('sales_opportunities')
        .insert(insertData)
        .select()
        .single();

      data = result.data;
      error = result.error;
    }

    if (error) {
      console.error(`Error ${editingOpportunityId ? 'updating' : 'creating'} opportunity:`, error);
      alert(`Failed to ${editingOpportunityId ? 'update' : 'create'} opportunity: ` + error.message);
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Save';
      }
      return;
    }

    console.log(`✅ Opportunity ${editingOpportunityId ? 'updated' : 'created'} successfully:`, data);

    // Reset editing flag before closing modal
    const wasEditing = editingOpportunityId !== null;
    editingOpportunityId = null;
    window.selectedOpportunityAssignedTo = null;
    window.opportunityMemberSearchQuery = '';

    // Reload opportunities
    await loadSalesOpportunities();

    // Close modal directly instead of re-rendering
    showAddOpportunityModal = false;
    const modal = document.getElementById('add-opportunity-modal');
    if (modal) {
      modal.remove();
    }

    // Check if modal was opened from sales page before resetting flags
    const wasFromSales = isOpportunityModalFromSales;

    // Reset sales modal flags
    if (isOpportunityModalFromSales) {
      isOpportunityModalFromSales = false;
      selectedOpportunityContactId = null;
      window.selectedOpportunityContactId = selectedOpportunityContactId;
      opportunityContactSearchQuery = '';
      window.opportunityContactSearchQuery = opportunityContactSearchQuery;
    }

    // Refresh the opportunities tab if we're viewing a contact
    if (currentScreen === 'sales' && selectedContactId) {
      updateContactDetailContent();
    } else if (currentScreen === 'sales' && wasFromSales) {
      // Refresh sales dashboard if opened from sales page
      await renderSalesDashboard();
    }

    // Show success message
    const successMsg = document.createElement('div');
    successMsg.textContent = `Opportunity ${wasEditing ? 'updated' : 'added'} successfully!`;
    successMsg.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #28a745;
      color: white;
      padding: 0.75rem 1.5rem;
      border-radius: 0.5rem;
      z-index: 100001;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
    `;
    document.body.appendChild(successMsg);
    setTimeout(() => successMsg.remove(), 3000);
  } catch (error) {
    console.error('Error creating opportunity:', error);
    alert('An unexpected error occurred while creating the opportunity');
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Save';
    }
  }
};

// Cancel opportunity modal and reset form
window.cancelOpportunityModal = function () {
  // Reset form data
  editingOpportunityId = null; // Reset editing flag
  opportunityFormData = {
    title: '',
    stage: 'new',
    expected_close_date: '',
    amount: '',
    source: 'website',
    chance: 'medium',
    follow_up_date: '',
    follow_up_time: '',
    notes: '',
    archived: false,
    assigned_to: ''
  };
  window.selectedOpportunityAssignedTo = null;
  window.opportunityMemberSearchQuery = '';
  // Reset sales modal flags
  if (isOpportunityModalFromSales) {
    isOpportunityModalFromSales = false;
    selectedOpportunityContactId = null;
    window.selectedOpportunityContactId = selectedOpportunityContactId;
    opportunityContactSearchQuery = '';
    window.opportunityContactSearchQuery = opportunityContactSearchQuery;
  }
  showAddOpportunityModal = false;

  // Remove modal directly instead of re-rendering
  const modal = document.getElementById('add-opportunity-modal');
  if (modal) {
    modal.remove();
  }
};

// Update opportunity stage (without re-rendering)
window.updateOpportunityStage = function (stage) {
  opportunityFormData.stage = stage;
  const buttons = document.querySelectorAll('#stage-buttons button');
  buttons.forEach(btn => {
    const value = btn.id.replace('stage-btn-', '');
    if (value === stage) {
      btn.style.borderColor = '#f59e0b';
      btn.style.background = '#fef3c7';
      btn.style.color = '#f59e0b';
    } else {
      btn.style.borderColor = '#e5e7eb';
      btn.style.background = '#ffffff';
      btn.style.color = '#6c757d';
    }
  });

  // If stage is set to 'won' or 'lost', automatically set archived to true
  if (stage === 'won' || stage === 'lost') {
    if (!opportunityFormData.archived) {
      opportunityFormData.archived = true;
      updateArchivedToggleUI();
    }
  } else {
    // If stage is changed from won/lost to something else, unarchive
    if (opportunityFormData.archived && (stage !== 'won' && stage !== 'lost')) {
      opportunityFormData.archived = false;
      updateArchivedToggleUI();
    }
  }
};

// Toggle archived status
window.toggleOpportunityArchived = function () {
  const wasArchived = opportunityFormData.archived;
  opportunityFormData.archived = !opportunityFormData.archived;
  updateArchivedToggleUI();

  // If archiving and stage is not won or lost, show modal to ask user
  if (opportunityFormData.archived && !wasArchived) {
    const currentStage = opportunityFormData.stage;
    const isAlreadyWonOrLost = currentStage === 'won' || currentStage === 'lost';

    if (!isAlreadyWonOrLost) {
      // Show the won/lost modal (same as drag to archived)
      pendingOpportunityUpdate = {
        opportunityId: editingOpportunityId,
        targetStage: 'archived',
        opportunity: {
          id: editingOpportunityId,
          title: opportunityFormData.title,
          stage: currentStage,
          contact: null // We don't have contact info in form data
        }
      };
      showWonLostModal = true;
      renderPMTool();
      return; // Exit early, modal will handle the update
    }
    // If already won or lost, keep the stage as-is
  } else if (!opportunityFormData.archived && wasArchived) {
    // If unarchiving, stage should already be changed by user, but ensure closed_at will be cleared
    // The save function will handle clearing closed_at
  }
};

// Update archived toggle UI
function updateArchivedToggleUI() {
  const toggle = document.getElementById('archived-toggle');
  if (toggle) {
    toggle.style.background = opportunityFormData.archived ? '#10b981' : '#d1d5db';
    const slider = toggle.querySelector('div');
    if (slider) {
      slider.style.left = opportunityFormData.archived ? '26px' : '2px';
    }
  }

  // Update label
  const label = toggle?.nextElementSibling;
  if (label) {
    label.textContent = opportunityFormData.archived ? 'Archived' : 'Not Archived';
    label.style.color = opportunityFormData.archived ? '#10b981' : '#6c757d';
    label.style.fontWeight = opportunityFormData.archived ? '600' : '500';
  }
}

// Update opportunity source (without re-rendering)
window.updateOpportunitySource = function (source) {
  opportunityFormData.source = source;
  const buttons = document.querySelectorAll('#source-buttons button');
  buttons.forEach(btn => {
    const value = btn.id.replace('source-btn-', '');
    if (value === source) {
      btn.style.borderColor = '#f59e0b';
      btn.style.background = '#fef3c7';
      btn.style.color = '#f59e0b';
    } else {
      btn.style.borderColor = '#e5e7eb';
      btn.style.background = '#ffffff';
      btn.style.color = '#6c757d';
    }
  });
};

// Update opportunity chance (without re-rendering)
window.updateOpportunityChance = function (chance) {
  opportunityFormData.chance = chance;
  const buttons = document.querySelectorAll('#chance-buttons button');
  buttons.forEach(btn => {
    const value = btn.id.replace('chance-btn-', '');
    if (value === chance) {
      // Set colors based on chance value
      if (value === 'low') {
        btn.style.borderColor = '#ef4444';
        btn.style.background = '#fee2e2';
        btn.style.color = '#dc2626';
      } else if (value === 'medium') {
        btn.style.borderColor = '#f59e0b';
        btn.style.background = '#fef3c7';
        btn.style.color = '#d97706';
      } else if (value === 'high') {
        btn.style.borderColor = '#10b981';
        btn.style.background = '#d1fae5';
        btn.style.color = '#059669';
      }
    } else {
      btn.style.borderColor = '#e5e7eb';
      btn.style.background = '#ffffff';
      btn.style.color = '#6c757d';
    }
  });
};

// Toggle show all opportunities
window.toggleShowAllOpportunities = function () {
  showAllOpportunities = !showAllOpportunities;
  if (currentScreen === 'sales' && selectedContactId) {
    updateContactDetailContent();
  } else {
    renderPMTool();
  }
};

// Toggle show archived opportunities (won/lost/closed)
window.toggleShowArchivedOpportunities = function () {
  showArchivedOpportunities = !showArchivedOpportunities;
  if (currentScreen === 'sales' && selectedContactId) {
    updateContactDetailContent();
  } else {
    renderPMTool();
  }
};

// Edit opportunity - load data and show modal
window.editOpportunity = async function (opportunityId) {
  if (companyEmployees === null) await loadCompanyEmployees();
  // Find the opportunity in the salesOpportunities array
  const opportunity = salesOpportunities.find(opp => opp.id === opportunityId);

  if (!opportunity) {
    console.error('Opportunity not found:', opportunityId);
    alert('Opportunity not found');
    return;
  }

  // Store permission info for later use in save handler
  // Employees can view any opportunity but can only save their own
  const userRole = currentProfile?.company_role || currentProfile?.role || 'USER';
  const isEmployee = userRole === 'EMPLOYEE';
  const isManagerOrOwner = userRole === 'OWNER' || userRole === 'MANAGER' || userRole === 'ADMIN' || currentProfile?.is_hh_admin;
  const canEdit = isManagerOrOwner || (isEmployee && opportunity.assigned_to === currentUser?.id);

  // Store this in a global variable for the save handler
  window.canEditCurrentOpportunity = canEdit;

  // Set editing flag
  editingOpportunityId = opportunityId;

  // Parse follow_up_date to extract date and time
  let followUpDate = '';
  let followUpTime = '09:00';
  if (opportunity.follow_up_date) {
    const followUpDateTime = new Date(opportunity.follow_up_date);
    followUpDate = followUpDateTime.toISOString().split('T')[0];
    const hours = String(followUpDateTime.getHours()).padStart(2, '0');
    const minutes = String(followUpDateTime.getMinutes()).padStart(2, '0');
    followUpTime = `${hours}:${minutes}`;
  }

  // Parse expected_close_date
  let expectedCloseDate = '';
  if (opportunity.expected_close_date) {
    expectedCloseDate = new Date(opportunity.expected_close_date).toISOString().split('T')[0];
  }

  // Populate form data
  // Archived = has closed_at set (won/lost deals with closed_at are archived)
  // Active = won deals without closed_at (not archived)
  const isArchived = !!opportunity.closed_at;

  // Use the actual stage, not 'archived' (which doesn't exist in stage options)
  const actualStage = opportunity.stage || 'new';

  opportunityFormData = {
    title: opportunity.title || '',
    stage: actualStage, // Use actual stage (won/lost/new/etc), not 'archived'
    expected_close_date: expectedCloseDate,
    amount: opportunity.amount ? String(opportunity.amount) : '',
    source: opportunity.source || 'website',
    chance: opportunity.chance || 'medium',
    follow_up_date: followUpDate,
    follow_up_time: followUpTime,
    notes: opportunity.notes || '',
    archived: isArchived, // Archived = has closed_at
    assigned_to: opportunity.assigned_to || ''
  };
  window.selectedOpportunityAssignedTo = opportunity.assigned_to || '';
  window.opportunityMemberSearchQuery = '';

  showAddOpportunityModal = true;

  // Inject modal directly
  const existingModal = document.getElementById('add-opportunity-modal');
  if (existingModal) {
    existingModal.remove();
  }

  const modalHTML = renderAddOpportunityModal();
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = modalHTML;
  const modalElement = tempDiv.firstElementChild;

  document.body.appendChild(modalElement);

  // Populate form inputs after modal is added
  setTimeout(() => {
    const titleInput = document.getElementById('opportunity-title');
    const closeDateInput = document.getElementById('opportunity-close-date');
    const amountInput = document.getElementById('opportunity-amount');
    const followUpDateInput = document.getElementById('opportunity-follow-up-date');
    const followUpTimeInput = document.getElementById('opportunity-follow-up-time');
    const notesInput = document.getElementById('opportunity-notes');

    if (titleInput) titleInput.value = opportunityFormData.title;
    if (closeDateInput) closeDateInput.value = opportunityFormData.expected_close_date;
    if (amountInput) amountInput.value = opportunityFormData.amount;
    if (followUpDateInput) followUpDateInput.value = opportunityFormData.follow_up_date;
    if (followUpTimeInput) followUpTimeInput.value = opportunityFormData.follow_up_time;
    if (notesInput) notesInput.value = opportunityFormData.notes;
    updateOpportunityAssignedDisplay();

    // Update button states (must be called before updateArchivedToggleUI)
    updateOpportunityStage(opportunityFormData.stage);
    updateOpportunitySource(opportunityFormData.source);
    updateOpportunityChance(opportunityFormData.chance);

    // Update archived toggle UI (after stage is set, as it may affect archived status)
    updateArchivedToggleUI();

    // Update modal title
    const modalTitle = modalElement.querySelector('h2');
    if (modalTitle) {
      modalTitle.textContent = 'Edit Sales Opportunity';
    }
  }, 10);
};

// Render Opportunities Tab
function renderOpportunitiesTab(opportunities) {
  const getStageColor = (stage) => {
    switch (stage?.toLowerCase()) {
      case 'new': return '#f59e0b';
      case 'contacted': return '#3b82f6';
      case 'qualified': return '#8b5cf6';
      case 'proposal': return '#6366f1';
      case 'negotiation': return '#ef4444';
      case 'won': return '#10b981';
      case 'lost': return '#6b7280';
      default: return '#6b7280';
    }
  };

  const getChanceColor = (chance) => {
    if (typeof chance === 'number') {
      if (chance >= 80) return '#10b981'; // Green
      if (chance >= 50) return '#f59e0b'; // Yellow
      return '#ef4444'; // Red
    }
    switch (chance?.toLowerCase()) {
      case 'high': return '#10b981';
      case 'medium': return '#f59e0b';
      case 'low': return '#ef4444';
      default: return '#6b7280';
    }
  };

  const getChanceValue = (chance) => {
    if (typeof chance === 'number') return chance;
    switch (chance?.toLowerCase()) {
      case 'high': return 80;
      case 'medium': return 50;
      case 'low': return 25;
      default: return 0;
    }
  };

  const getStageLabel = (stage) => {
    const labels = {
      'new': 'New',
      'contacted': 'Contacted',
      'qualified': 'Qualified',
      'proposal': 'Proposal',
      'negotiation': 'Negotiation',
      'won': 'Won',
      'lost': 'Lost'
    };
    return labels[stage?.toLowerCase()] || stage || 'New';
  };

  return `
    <div style="display: flex; flex-direction: column; gap: 1rem;">
      <!-- Header -->
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <div style="display: flex; align-items: center; gap: 0.5rem;">
          <span style="font-size: 1rem;">↗</span>
        <h3 style="margin: 0; color: #2c3e50; font-size: ${isMobileDevice() ? '1rem' : '1.125rem'}; font-weight: 600;">
            Deal
        </h3>
        </div>
        <div style="display: flex; align-items: center; gap: 0.75rem;">
          ${(() => {
      const allOpps = salesOpportunities.filter(opp =>
        opp.contact?.id === selectedContactId &&
        opp.stage !== 'won' &&
        opp.stage !== 'lost'
      );
      const activeOpps = allOpps.filter(opp => opp.status === 'active');
      return allOpps.length > activeOpps.length;
    })() ? `
            <button onclick="toggleShowAllOpportunities()" style="
              background: transparent;
              color: #00ADB5;
              border: none;
              padding: 0.5rem 0.75rem;
              cursor: pointer;
              font-size: 0.875rem;
              font-weight: 500;
              text-decoration: underline;
            ">
              ${showAllOpportunities ? 'Show Active Only' : 'Show All'}
            </button>
          ` : ''}
        <button onclick="toggleShowArchivedOpportunities()" style="
            background: ${showArchivedOpportunities ? '#fef3c7' : '#ffffff'};
            color: ${showArchivedOpportunities ? '#f59e0b' : '#6c757d'};
            border: 2px solid ${showArchivedOpportunities ? '#f59e0b' : '#e9ecef'};
            padding: 0.5rem 1rem;
            border-radius: 0.375rem;
            cursor: pointer;
            font-size: 0.875rem;
            font-weight: 500;
            display: flex;
            align-items: center;
            gap: 0.375rem;
            white-space: nowrap;
            transition: all 0.2s ease;
          ">
            ${showArchivedOpportunities ? 'Hide Archived' : 'View All Deals'}
        </button>
        <button onclick="showAddOpportunityModal()" style="
            background: #f59e0b;
          color: white;
          border: none;
            padding: 0.5rem 1rem;
          border-radius: 0.375rem;
          cursor: pointer;
            font-size: 0.875rem;
          font-weight: 500;
          display: flex;
          align-items: center;
          gap: 0.375rem;
          white-space: nowrap;
        ">
            + Add
        </button>
      </div>
      </div>
      
      ${opportunities.length === 0 ? `
        <div style="text-align: center; padding: 3rem 1rem;">
          <div style="font-size: 3rem; margin-bottom: 1rem; color: #6c757d;">
            <span class="material-icons" style="font-size: 3rem;">work</span>
          </div>
          <p style="color: #6c757d; font-size: 0.875rem; margin: 0;">No sales opportunities for this contact</p>
        </div>
      ` : `
        <!-- Opportunity Cards -->
        <div style="display: flex; flex-direction: column; gap: 1rem;">
          ${opportunities.map(opp => {
      const stageColor = getStageColor(opp.stage);
      const chanceValue = getChanceValue(opp.chance);
      const chanceColor = getChanceColor(opp.chance);
      const stageLabel = getStageLabel(opp.stage);
      const closeDate = opp.expected_close_date ? new Date(opp.expected_close_date).toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' }) : null;
      const followUpDate = opp.follow_up_date ? new Date(opp.follow_up_date).toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' }) : null;
      const assignedTo = opp.assigned_user ?
        `${opp.assigned_user.first_name || ''} ${opp.assigned_user.last_name || ''}`.trim() || 'Unassigned' :
        (opp.assigned_to_name || 'Unassigned');
      const source = opp.source || 'other';

      // Determine if archived (has closed_at or stage is won/lost)
      const isArchived = !!opp.closed_at || opp.stage === 'won' || opp.stage === 'lost';
      const statusLabel = isArchived ? 'ARCHIVED' : 'ACTIVE';
      const statusBgColor = isArchived ? '#e5e7eb' : '#10b981';
      const statusTextColor = isArchived ? '#6b7280' : '#ffffff';
      const cardBgColor = isArchived ? '#f8f9fa' : '#ffffff';

      return `
              <div onclick="editOpportunity('${opp.id}')" style="
            background: ${cardBgColor};
                border-left: 4px solid ${stageColor};
                border-radius: 0.5rem;
                padding: 1rem;
                box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                position: relative;
                transition: all 0.2s ease;
                cursor: pointer;
                opacity: ${isArchived ? 0.85 : 1};
              " onmouseover="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.15)'" onmouseout="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.1)'">
                <!-- Header Row -->
                <div style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 0.75rem;">
                  <div style="flex: 1;">
                    <div style="display: flex; align-items: center; gap: 0.5rem; margin-bottom: 0.25rem;">
                      <h4 style="
                        margin: 0;
                        font-size: 1rem;
                        font-weight: 600;
                        color: #2c3e50;
                      ">${opp.title || 'Untitled Opportunity'}</h4>
                      <span style="font-size: 0.75rem; color: #6c757d;">□</span>
                    </div>
                    <div style="
                      font-size: 1.25rem;
                      font-weight: 700;
                      color: #2c3e50;
                      margin-bottom: 0.5rem;
                    ">$${(opp.amount || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
                  </div>
                  <div style="display: flex; flex-direction: column; align-items: flex-end; gap: 0.5rem;">
                      <span style="
                      background: ${statusBgColor};
                      color: ${statusTextColor};
                      padding: 0.25rem 0.5rem;
                      border-radius: 0.25rem;
                      font-size: 0.75rem;
                      font-weight: 500;
                    ">${statusLabel}</span>
                    <span style="
                      background: ${chanceColor};
                        color: white;
                        padding: 0.25rem 0.5rem;
                        border-radius: 0.25rem;
                      font-size: 0.75rem;
                      font-weight: 600;
                    ">${chanceValue}%</span>
                  </div>
                </div>
                
                <!-- Details Grid -->
                <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 0.75rem; margin-bottom: 0.75rem;">
                  <div>
                    <div style="font-size: 0.75rem; color: #6c757d; margin-bottom: 0.25rem;">Close Date</div>
                    <div style="font-size: 0.875rem; color: #2c3e50; font-weight: 500;">${closeDate || 'Not set'}</div>
                  </div>
                  <div>
                    <div style="font-size: 0.75rem; color: #6c757d; margin-bottom: 0.25rem;">Stage</div>
                    <span style="
                      background: ${stageColor}20;
                      color: ${stageColor};
                      padding: 0.25rem 0.5rem;
                      border-radius: 0.25rem;
                      font-size: 0.75rem;
                        font-weight: 500;
                    ">${stageLabel}</span>
                  </div>
                  <div>
                    <div style="font-size: 0.75rem; color: #6c757d; margin-bottom: 0.25rem;">Source</div>
                    <div style="font-size: 0.875rem; color: #2c3e50; font-weight: 500;">${source}</div>
                  </div>
                  <div>
                    <div style="font-size: 0.75rem; color: #6c757d; margin-bottom: 0.25rem;">Follow Up</div>
                    <div style="font-size: 0.875rem; color: #2c3e50; font-weight: 500;">${followUpDate || 'Not set'}</div>
                  </div>
                </div>
                
                <!-- Assigned To -->
                <div style="
                  padding-top: 0.75rem;
                  border-top: 1px solid #e9ecef;
                  font-size: 0.875rem;
                  color: #6c757d;
                ">
                  Assigned to: <span style="font-weight: 500; color: #2c3e50;">${assignedTo}</span>
                </div>
          </div>
        `;
    }).join('')}
        </div>
      `}
      
      ${showAddOpportunityModal ? renderAddOpportunityModal() : ''}
    </div>
  `;
}

// Render Add Reminder Modal
function renderAddReminderModal() {
  const priorityOptions = [
    { value: 'low', label: 'Low' },
    { value: 'medium', label: 'Medium' },
    { value: 'high', label: 'High' },
    { value: 'urgent', label: 'Urgent' }
  ];

  const typeOptions = [
    { value: 'follow_up', label: 'Follow Up' },
    { value: 'call', label: 'Call' },
    { value: 'email', label: 'Email' }
  ];

  return `
    <!-- Modal Overlay -->
    <div id="add-reminder-modal" onclick="if (event.target.id === 'add-reminder-modal') { cancelReminderModal(); }" style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 99999;
      animation: fadeIn 0.3s ease-out;
    ">
      <!-- Modal Content -->
      <div onclick="event.stopPropagation()" style="
        background: #ffffff;
        border-radius: 1rem;
        padding: 0;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
        max-width: 600px;
        width: 95%;
        max-height: 90vh;
        overflow-y: auto;
        animation: slideIn 0.3s ease-out;
        position: relative;
      ">
        <!-- Header -->
        <div style="
          padding: 1rem 1.5rem;
          border-bottom: 1px solid #e9ecef;
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: sticky;
          top: 0;
          background: #ffffff;
          z-index: 10;
        ">
          <button
            onclick="event.stopPropagation(); cancelReminderModal();"
            style="
              background: transparent;
              border: none;
              color: #f59e0b;
              cursor: pointer;
              font-size: 0.875rem;
              font-weight: 500;
              padding: 0.5rem;
            "
          >
            Cancel
          </button>
          <h2 style="
            margin: 0;
            color: #2c3e50;
            font-size: 1.125rem;
            font-weight: 700;
          ">
            ${editingReminderId ? 'Edit Reminder' : 'Add Reminder'}
          </h2>
          <button
            id="add-reminder-submit-btn"
            onclick="event.stopPropagation(); handleAddReminder(event)"
            style="
              background: #f59e0b;
              color: white;
              border: none;
              padding: 0.5rem 1rem;
              border-radius: 0.375rem;
              cursor: pointer;
              font-size: 0.875rem;
              font-weight: 600;
            "
          >
            ${editingReminderId ? 'Update' : 'Add'}
          </button>
        </div>

        <!-- Form Content -->
        <form id="add-reminder-form" onsubmit="handleAddReminder(event); return false;" style="padding: 1.5rem;">
          <div style="display: flex; flex-direction: column; gap: 1.5rem;">
            ${isReminderModalFromCalendar ? `
            <!-- Contact Selector (only when opened from calendar) -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 700;
                font-size: 0.875rem;
              ">
                Contact (Optional)
              </label>
              <div style="position: relative;">
                ${selectedReminderContactId ? `
                  <div style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0.75rem;
                    border: 1px solid #e5e7eb;
                    border-radius: 0.5rem;
                    background: #f9fafb;
                  ">
                    <span style="color: #2c3e50; font-size: 0.875rem;">
                      ${(() => {
          const contact = contacts.find(c => c.id === selectedReminderContactId);
          return contact ? `${contact.first_name || ''} ${contact.last_name || ''}`.trim() || contact.company || 'Selected Contact' : 'Selected Contact';
        })()}
                    </span>
                    <button
                      type="button"
                      onclick="clearReminderContact()"
                      style="
                        background: transparent;
                        border: none;
                        color: #ef4444;
                        cursor: pointer;
                        padding: 0.25rem 0.5rem;
                        font-size: 0.75rem;
                      "
                    >×</button>
                  </div>
                ` : `
                  <input
                    type="text"
                    id="reminder-contact-search-input"
                    placeholder="Search contacts..."
                    value="${reminderContactSearchQuery || ''}"
                    oninput="handleReminderContactSearch(this.value)"
                    style="
                      width: 100%;
                      padding: 0.75rem;
                      border: 1px solid #e5e7eb;
                      border-radius: 0.5rem;
                      font-size: 0.875rem;
                      box-sizing: border-box;
                      transition: border-color 0.2s;
                    "
                    onfocus="this.style.borderColor='#f59e0b'"
                    onblur="this.style.borderColor='#e5e7eb'"
                  />
                  <div id="reminder-contact-search-results" style="
                    max-height: 200px;
                    overflow-y: auto;
                    border: 1px solid #e5e7eb;
                    border-radius: 0.5rem;
                    background: #ffffff;
                    margin-top: 0.5rem;
                    display: ${reminderContactSearchQuery && reminderContactSearchQuery.trim() ? 'block' : 'none'};
                    position: absolute;
                    width: 100%;
                    z-index: 1000;
                    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
                  ">
                    ${contacts.filter(contact =>
          `${contact.first_name || ''} ${contact.last_name || ''} ${contact.company || ''}`.toLowerCase().includes((reminderContactSearchQuery || '').toLowerCase())
        ).map(contact => `
                      <div
                        onclick="selectReminderContact('${contact.id}')"
                        style="
                          padding: 0.75rem;
                          border-bottom: 1px solid #e9ecef;
                          cursor: pointer;
                          transition: background-color 0.2s;
                          display: flex;
                          justify-content: space-between;
                          align-items: center;
                        "
                        onmouseover="this.style.backgroundColor='#f8f9fa'"
                        onmouseout="this.style.backgroundColor='transparent'"
                      >
                        <div>
                          <div style="font-weight: 500; color: #2c3e50;">${contact.first_name || ''} ${contact.last_name || ''}</div>
                          ${contact.company ? `<div style="font-size: 0.75rem; color: #6c757d; margin-top: 0.25rem;">${contact.company}</div>` : ''}
                        </div>
                        ${contact.contact_profile_id ? `
                          <span style="background: #ff7f00; color: white; padding: 0.25rem 0.5rem; border-radius: 0.25rem; font-size: 0.75rem; font-weight: 600;">Client</span>
                        ` : ''}
                      </div>
                    `).join('')}
                    ${contacts.filter(contact =>
          `${contact.first_name || ''} ${contact.last_name || ''} ${contact.company || ''}`.toLowerCase().includes((reminderContactSearchQuery || '').toLowerCase())
        ).length === 0 && reminderContactSearchQuery && reminderContactSearchQuery.trim() ? `
                      <div style="padding: 1rem; text-align: center; color: #6c757d; font-size: 0.875rem;">
                        No contacts found matching "${reminderContactSearchQuery}"
                      </div>
                    ` : ''}
                  </div>
                `}
              </div>
            </div>
            ` : ''}
            <!-- Title -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 700;
                font-size: 0.875rem;
              ">
                Title *
              </label>
              <input
                type="text"
                id="reminder-title"
                placeholder="e.g., Send contract to client"
                required
                value="${reminderFormData.title}"
                oninput="window.reminderFormData.title = this.value"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e5e7eb;
                  border-radius: 0.5rem;
                  font-size: 1rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s ease;
                "
                onfocus="this.style.borderColor='#f59e0b'"
                onblur="this.style.borderColor='#e5e7eb'"
              />
            </div>

            <!-- Description -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 700;
                font-size: 0.875rem;
              ">
                Description
              </label>
              <textarea
                id="reminder-description"
                placeholder="Add any additional details..."
                rows="4"
                oninput="window.reminderFormData.description = this.value"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e5e7eb;
                  border-radius: 0.5rem;
                  font-size: 1rem;
                  box-sizing: border-box;
                  resize: vertical;
                  font-family: inherit;
                  transition: border-color 0.2s ease;
                  min-height: 100px;
                "
                onfocus="this.style.borderColor='#f59e0b'"
                onblur="this.style.borderColor='#e5e7eb'"
              >${reminderFormData.description || ''}</textarea>
            </div>

            <!-- Priority -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 700;
                font-size: 0.875rem;
              ">
                Priority
              </label>
              <div id="priority-buttons" style="display: flex; flex-wrap: wrap; gap: 0.5rem;">
                ${priorityOptions.map(option => `
                  <button
                    type="button"
                    onclick="updateReminderPriority('${option.value}')"
                    id="priority-btn-${option.value}"
                    style="
                      padding: 0.5rem 1rem;
                      border-radius: 0.5rem;
                      border: 2px solid ${reminderFormData.priority === option.value ? '#f59e0b' : '#e5e7eb'};
                      background: ${reminderFormData.priority === option.value ? '#fef3c7' : '#ffffff'};
                      color: ${reminderFormData.priority === option.value ? '#f59e0b' : '#6c757d'};
                      cursor: pointer;
                      font-size: 0.875rem;
                      font-weight: 500;
                      transition: all 0.2s ease;
                    "
                  >
                    ${option.label}
                  </button>
                `).join('')}
              </div>
            </div>

            <!-- Type -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 700;
                font-size: 0.875rem;
              ">
                Type
              </label>
              <div id="type-buttons" style="display: flex; flex-wrap: wrap; gap: 0.5rem;">
                ${typeOptions.map(option => `
                  <button
                    type="button"
                    onclick="updateReminderType('${option.value}')"
                    id="type-btn-${option.value}"
                    style="
                      padding: 0.5rem 1rem;
                      border-radius: 0.5rem;
                      border: 2px solid ${reminderFormData.type === option.value ? '#f59e0b' : '#e5e7eb'};
                      background: ${reminderFormData.type === option.value ? '#fef3c7' : '#ffffff'};
                      color: ${reminderFormData.type === option.value ? '#f59e0b' : '#6c757d'};
                      cursor: pointer;
                      font-size: 0.875rem;
                      font-weight: 500;
                      transition: all 0.2s ease;
                    "
                  >
                    ${option.label}
                  </button>
                `).join('')}
              </div>
            </div>

            <!-- Due Date -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 700;
                font-size: 0.875rem;
              ">
                Due Date *
              </label>
              <div style="position: relative;">
                <input
                  type="date"
                  id="reminder-due-date"
                  required
                  value="${reminderFormData.due_date}"
                  oninput="window.reminderFormData.due_date = this.value"
                  style="
                    width: 100%;
                    padding: 0.75rem;
                    border: 1px solid #e5e7eb;
                    border-radius: 0.5rem;
                    font-size: 1rem;
                    box-sizing: border-box;
                    transition: border-color 0.2s ease;
                  "
                  onfocus="this.style.borderColor='#f59e0b'"
                  onblur="this.style.borderColor='#e5e7eb'"
                />
              </div>
              <div style="font-size: 0.75rem; color: #6c757d; margin-top: 0.25rem;">
                Tap to select a date
              </div>
            </div>

            <!-- Validation Message -->
            <div id="reminder-validation-message" style="
              display: none;
              background: #fef3c7;
              border-left: 3px solid #f59e0b;
              border-radius: 0.25rem;
              padding: 0.75rem;
              color: #92400e;
              font-size: 0.875rem;
            ">
              * Title and due date are required fields.
            </div>
          </div>
        </form>
      </div>
    </div>
  `;
}

// Cancel reminder modal
window.cancelReminderModal = function () {
  // Reset calendar modal flags
  if (isReminderModalFromCalendar) {
    isReminderModalFromCalendar = false;
    selectedReminderContactId = null;
    window.selectedReminderContactId = selectedReminderContactId;
    reminderContactSearchQuery = '';
    window.reminderContactSearchQuery = reminderContactSearchQuery;
  }
  reminderFormData = {
    title: '',
    description: '',
    priority: 'medium',
    type: 'follow_up',
    due_date: ''
  };
  window.reminderFormData = reminderFormData;
  showAddReminderModal = false;
  const modal = document.getElementById('add-reminder-modal');
  if (modal) {
    modal.remove();
  }
};

// Update reminder priority (without re-rendering)
window.updateReminderPriority = function (priority) {
  reminderFormData.priority = priority;
  const buttons = document.querySelectorAll('#priority-buttons button');
  buttons.forEach(btn => {
    const value = btn.id.replace('priority-btn-', '');
    if (value === priority) {
      btn.style.borderColor = '#f59e0b';
      btn.style.background = '#fef3c7';
      btn.style.color = '#f59e0b';
    } else {
      btn.style.borderColor = '#e5e7eb';
      btn.style.background = '#ffffff';
      btn.style.color = '#6c757d';
    }
  });
};

// Update reminder type (without re-rendering)
window.updateReminderType = function (type) {
  reminderFormData.type = type;
  const buttons = document.querySelectorAll('#type-buttons button');
  buttons.forEach(btn => {
    const value = btn.id.replace('type-btn-', '');
    if (value === type) {
      btn.style.borderColor = '#f59e0b';
      btn.style.background = '#fef3c7';
      btn.style.color = '#f59e0b';
    } else {
      btn.style.borderColor = '#e5e7eb';
      btn.style.background = '#ffffff';
      btn.style.color = '#6c757d';
    }
  });
};

// Handle Add Reminder
window.handleAddReminder = async function (e) {
  if (e) e.preventDefault();

  const titleInput = document.getElementById('reminder-title');
  const dueDateInput = document.getElementById('reminder-due-date');
  const descriptionInput = document.getElementById('reminder-description');
  const validationMsg = document.getElementById('reminder-validation-message');

  const title = titleInput?.value?.trim() || '';
  const dueDate = dueDateInput?.value || '';
  const description = descriptionInput?.value?.trim() || '';

  // Validation
  if (!title || !dueDate) {
    if (validationMsg) {
      validationMsg.style.display = 'block';
    }
    return;
  }

  // Hide validation message
  if (validationMsg) {
    validationMsg.style.display = 'none';
  }

  const submitBtn = document.getElementById('add-reminder-submit-btn');
  if (submitBtn) {
    submitBtn.disabled = true;
    submitBtn.textContent = editingReminderId ? 'Updating...' : 'Adding...';
  }

  try {
    // Parse date string (YYYY-MM-DD) manually to avoid timezone issues
    // new Date("2026-01-18") is interpreted as midnight UTC which shifts to previous day in local time!
    const dateParts = dueDate.split('-');
    const dateTime = new Date(
      parseInt(dateParts[0], 10),
      parseInt(dateParts[1], 10) - 1, // Month is 0-indexed
      parseInt(dateParts[2], 10),
      9, 0, 0, 0 // 9 AM LOCAL time
    );

    const reminderData = {
      title: title,
      description: description || null,
      due_at: dateTime.toISOString(),
      priority: (window.reminderFormData || reminderFormData).priority || 'medium',
      type: (window.reminderFormData || reminderFormData).type || 'follow_up',
      updated_at: new Date().toISOString(),
    };

    let data, error;

    if (editingReminderId) {
      // Update existing reminder
      console.log('📝 Updating reminder:', editingReminderId, reminderData);
      const result = await supabase
        .from('reminders')
        .update(reminderData)
        .eq('id', editingReminderId)
        .select();

      console.log('📝 Update result:', result);

      if (result.error) {
        data = null;
        error = result.error;
      } else if (!result.data || result.data.length === 0) {
        // Update might have succeeded but select failed due to RLS
        console.log('⚠️ Update select returned 0 rows, fetching separately...');
        const fetchResult = await supabase
          .from('reminders')
          .select('*')
          .eq('id', editingReminderId)
          .maybeSingle();

        if (fetchResult.error && fetchResult.error.code !== 'PGRST116') {
          // Real error, not just "not found"
          data = null;
          error = fetchResult.error;
        } else if (fetchResult.data) {
          // Found it, update succeeded
          data = fetchResult.data;
          error = null;
        } else {
          // Not found - update might have failed or reminder doesn't exist
          data = null;
          error = {
            code: 'UPDATE_FAILED',
            message: 'Reminder update may have failed. The reminder was not found after update.'
          };
        }
      } else {
        data = result.data[0];
        error = null;
      }
    } else {
      // Create new reminder
      // Use selected contact from calendar modal if opened from calendar, otherwise use selectedContactId
      const contactIdToUse = isReminderModalFromCalendar ? selectedReminderContactId : selectedContactId;

      const result = await supabase
        .from('reminders')
        .insert({
          ...reminderData,
          company_id: currentCompany.id,
          contact_id: contactIdToUse,
          owner_id: currentUser.id,
          assigned_to: currentUser.id,
          status: 'pending',
          created_at: new Date().toISOString(),
        })
        .select()
        .single();
      data = result.data;
      error = result.error;
    }

    if (error) {
      console.error(`Error ${editingReminderId ? 'updating' : 'creating'} reminder:`, error);
      alert(`Failed to ${editingReminderId ? 'update' : 'create'} reminder: ` + error.message);
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = editingReminderId ? 'Update' : 'Add';
      }
      return;
    }

    console.log(`✅ Reminder ${editingReminderId ? 'updated' : 'created'} successfully:`, data);

    // Invalidate dashboard cache
    invalidateDashboardCache();

    // Reload reminders
    await loadContactReminders(selectedContactId);

    // Reset editing state
    editingReminderId = null;

    // Close modal directly
    showAddReminderModal = false;
    const modal = document.getElementById('add-reminder-modal');
    if (modal) {
      modal.remove();
    }

    // Refresh reminders tab if we're viewing a contact
    if (currentScreen === 'sales' && selectedContactId) {
      updateContactDetailContent();
    } else if (currentScreen === 'sales') {
      // Refresh the sales dashboard to show updated reminders in "Upcoming" section
      await renderSalesDashboard();
    } else if (currentScreen === 'calendar' && isReminderModalFromCalendar) {
      // Refresh calendar if opened from calendar
      await loadCalendarEvents();
      renderPMTool();
    }

    // Reset calendar modal flags
    if (isReminderModalFromCalendar) {
      isReminderModalFromCalendar = false;
      selectedReminderContactId = null;
      window.selectedReminderContactId = selectedReminderContactId;
      reminderContactSearchQuery = '';
      window.reminderContactSearchQuery = reminderContactSearchQuery;
    }

    // Show success message
    const successMsg = document.createElement('div');
    successMsg.textContent = 'Reminder added successfully!';
    successMsg.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #28a745;
      color: white;
      padding: 0.75rem 1.5rem;
      border-radius: 0.5rem;
      z-index: 100001;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
    `;
    document.body.appendChild(successMsg);
    setTimeout(() => successMsg.remove(), 3000);
  } catch (error) {
    console.error('Error creating reminder:', error);
    alert('An unexpected error occurred while creating the reminder');
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Add';
    }
  }
};

// Toggle reminder complete status
window.toggleReminderComplete = async function (reminderId, isCompleted) {
  try {
    // Get fresh reminder data from database to ensure we have the latest title
    const { data: reminderData, error: fetchError } = await supabase
      .from('reminders')
      .select('*')
      .eq('id', reminderId)
      .single();

    if (fetchError || !reminderData) {
      console.error('Error fetching reminder:', fetchError);
      alert('Failed to load reminder details');
      return;
    }

    const contactId = reminderData.contact_id || selectedContactId;

    const { error } = await supabase
      .from('reminders')
      .update({
        status: isCompleted ? 'completed' : 'pending',
        updated_at: new Date().toISOString()
      })
      .eq('id', reminderId);

    if (error) {
      console.error('Error updating reminder:', error);
      alert('Failed to update reminder status');
      return;
    }

    // Invalidate dashboard cache
    invalidateDashboardCache();

    // Reload reminders
    await loadContactReminders(selectedContactId);

    // If reminder was completed and has a contact_id, create activity log entry
    if (isCompleted && contactId) {
      console.log(`🔔 [Reminder Completion] Creating activity log for reminder ${reminderId}`);
      console.log(`🔔 [Reminder Data]:`, reminderData);
      await createActivityLogEntry(
        contactId,
        'reminder_completed',
        `Completed reminder: ${reminderData.title || 'Untitled Reminder'}`,
        reminderData.description || reminderData.notes || null,
        { reminder_id: reminderId }
      );
    }

    // Refresh reminders tab
    if (currentScreen === 'sales' && selectedContactId) {
      console.log(`🔄 [Reminder Completion] Refreshing contact detail view for contact ${selectedContactId}`);
      await updateContactDetailContent();
    }
  } catch (error) {
    console.error('Error updating reminder:', error);
    alert('An unexpected error occurred');
  }
};

// Edit reminder (placeholder)
window.editReminder = async function (reminderId) {
  try {
    // Fetch reminder from database
    const { data: reminder, error } = await supabase
      .from('reminders')
      .select('*')
      .eq('id', reminderId)
      .single();

    if (error || !reminder) {
      console.error('Error fetching reminder:', error);
      alert('Reminder not found');
      return;
    }

    // Check if current user owns this reminder
    const currentUserId = currentUser?.id || currentProfile?.id;
    if (reminder.owner_id !== currentUserId) {
      window.showNotification('You can\'t edit other people\'s reminders', 'error');
      return;
    }

    // Open the add reminder modal in edit mode
    editingReminderId = reminderId;
    reminderFormData = {
      title: reminder.title || '',
      description: reminder.description || reminder.notes || '',
      due_date: reminder.due_at ? new Date(reminder.due_at).toISOString().split('T')[0] : '',
      priority: reminder.priority || 'medium',
      type: reminder.type || 'follow_up'
    };
    window.reminderFormData = reminderFormData;
    showAddReminderModal = true;

    // Inject modal directly instead of re-rendering entire page
    const existingModal = document.getElementById('add-reminder-modal');
    if (existingModal) {
      existingModal.remove();
    }

    const modalHTML = renderAddReminderModal();
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = modalHTML;
    const modalElement = tempDiv.firstElementChild;

    document.body.appendChild(modalElement);

    // Animate in
    setTimeout(() => {
      if (modalElement) {
        modalElement.style.opacity = '1';
      }
    }, 10);
  } catch (error) {
    console.error('Error editing reminder:', error);
    alert('Failed to load reminder details');
  }
};

// Delete reminder
// Show delete reminder confirmation modal
window.showDeleteReminderConfirm = function (reminderId) {
  if (!reminderId) return;

  // Remove any existing modal
  const existingModal = document.getElementById('delete-reminder-modal');
  if (existingModal) {
    existingModal.remove();
  }

  const reminder = reminders.find(r => r.id === reminderId);
  const reminderTitle = reminder ? reminder.title || 'Untitled Reminder' : 'this reminder';

  const modal = document.createElement('div');
  modal.id = 'delete-reminder-modal';
  modal.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10001;
    animation: fadeIn 0.2s ease-out;
  `;

  modal.innerHTML = `
    <div style="
      background: white;
      border-radius: 1rem;
      padding: 0;
      max-width: 400px;
      width: 90%;
      box-shadow: 0 25px 50px rgba(0,0,0,0.25);
      animation: scaleIn 0.2s ease-out;
      overflow: hidden;
    ">
      <!-- Header -->
      <div style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1.25rem 1.5rem;
        border-bottom: 1px solid #E5E7EB;
      ">
        <div style="display: flex; align-items: center; gap: 0.75rem;">
          <span class="material-icons" style="color: #EF4444; font-size: 24px;">warning</span>
          <h3 style="margin: 0; font-size: 1.125rem; font-weight: 600; color: #111827;">Delete Reminder</h3>
        </div>
        <button 
          onclick="closeDeleteReminderModal()"
          style="
            background: transparent;
            border: none;
            cursor: pointer;
            padding: 0.25rem;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 0.375rem;
            color: #6B7280;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#F3F4F6'; this.style.color='#111827';"
          onmouseout="this.style.background='transparent'; this.style.color='#6B7280';"
        >
          <span class="material-icons" style="font-size: 20px;">close</span>
        </button>
      </div>
      
      <!-- Body -->
      <div style="padding: 1.5rem;">
        <p style="margin: 0; color: #4B5563; font-size: 0.9375rem; line-height: 1.5;">
          Are you sure you want to delete <strong>${reminderTitle}</strong>? This action cannot be undone.
        </p>
      </div>
      
      <!-- Footer -->
      <div style="
        display: flex;
        gap: 0.75rem;
        padding: 1rem 1.5rem;
        background: #F9FAFB;
        border-top: 1px solid #E5E7EB;
        justify-content: flex-end;
      ">
        <button 
          onclick="closeDeleteReminderModal()"
          style="
            padding: 0.75rem 1.5rem;
            background: white;
            border: 1px solid #D1D5DB;
            border-radius: 0.5rem;
            color: #374151;
            font-size: 0.9375rem;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#F9FAFB'; this.style.borderColor='#9CA3AF';"
          onmouseout="this.style.background='white'; this.style.borderColor='#D1D5DB';"
        >
          Cancel
        </button>
        <button 
          onclick="confirmDeleteReminder('${reminderId}')"
          style="
            padding: 0.75rem 1.5rem;
            background: #EF4444;
            border: none;
            border-radius: 0.5rem;
            color: white;
            font-size: 0.9375rem;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#DC2626';"
          onmouseout="this.style.background='#EF4444';"
        >
          Delete
        </button>
      </div>
    </div>
  `;

  // Add styles if not already added
  if (!document.getElementById('delete-reminder-modal-styles')) {
    const style = document.createElement('style');
    style.id = 'delete-reminder-modal-styles';
    style.textContent = `
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      @keyframes scaleIn {
        from { transform: scale(0.95); opacity: 0; }
        to { transform: scale(1); opacity: 1; }
      }
    `;
    document.head.appendChild(style);
  }

  // Close on backdrop click
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      closeDeleteReminderModal();
    }
  });

  document.body.appendChild(modal);
};

// Close delete reminder modal
window.closeDeleteReminderModal = function () {
  const modal = document.getElementById('delete-reminder-modal');
  if (modal) {
    modal.style.opacity = '0';
    setTimeout(() => {
      modal.remove();
    }, 200);
  }
};

// Confirm delete reminder
window.confirmDeleteReminder = async function (reminderId) {
  if (!reminderId) return;

  const deleteBtn = document.querySelector('#delete-reminder-modal button[onclick*="confirmDeleteReminder"]');
  if (deleteBtn) {
    deleteBtn.disabled = true;
    deleteBtn.textContent = 'Deleting...';
  }

  try {
    // First, fetch the reminder to check ownership
    const { data: reminder, error: fetchError } = await supabase
      .from('reminders')
      .select('assigned_to, owner_id')
      .eq('id', reminderId)
      .single();

    if (fetchError || !reminder) {
      window.showNotification('Reminder not found', 'error');
      closeDeleteReminderModal();
      return;
    }

    // Check if current user owns this reminder OR is an owner
    const currentUserId = currentUser?.id || currentProfile?.id;
    const isOwner = currentProfile?.company_role === 'OWNER' || currentUser?.role === 'OWNER';
    const reminderOwnerId = reminder.assigned_to || reminder.owner_id;

    if (reminderOwnerId !== currentUserId && !isOwner) {
      window.showNotification('You can\'t delete other people\'s reminders', 'error');
      closeDeleteReminderModal();
      return;
    }

    // Delete the reminder from database
    const { error } = await supabase
      .from('reminders')
      .delete()
      .eq('id', reminderId);

    if (error) throw error;

    closeDeleteReminderModal();

    // Reload reminders and re-render
    if (selectedContactId) {
      await updateContactDetailContent();
    } else {
      await loadReminders();
      renderPMTool();
    }

    window.showNotification('Reminder deleted successfully', 'success');
  } catch (error) {
    console.error('Error deleting reminder:', error);
    window.showNotification('Failed to delete reminder: ' + (error.message || error), 'error');
    closeDeleteReminderModal();
  }
};

window.deleteReminder = async function (reminderId) {
  if (!reminderId) {
    alert('No reminder selected');
    return;
  }

  try {
    // First, fetch the reminder to check ownership
    const { data: reminder, error: fetchError } = await supabase
      .from('reminders')
      .select('assigned_to, owner_id')
      .eq('id', reminderId)
      .single();

    if (fetchError || !reminder) {
      window.showNotification('Reminder not found', 'error');
      return;
    }

    // Check if current user owns this reminder OR is an owner
    const currentUserId = currentUser?.id || currentProfile?.id;
    const isOwner = currentProfile?.company_role === 'OWNER' || currentUser?.role === 'OWNER';
    const reminderOwnerId = reminder.assigned_to || reminder.owner_id;

    if (reminderOwnerId !== currentUserId && !isOwner) {
      window.showNotification('You can\'t delete other people\'s reminders', 'error');
      return;
    }

    // Show confirmation modal
    showDeleteReminderConfirm(reminderId);
  } catch (error) {
    console.error('Error checking reminder:', error);
    window.showNotification('Failed to load reminder: ' + (error.message || error), 'error');
  }
};

// Contact Contracts Tab State
let contactContractsFilter = 'all'; // all, sent, viewed, signed, expired, closed

window.setContactContractsFilter = function (filter) {
  contactContractsFilter = filter;
  renderPMTool();
};

window.goToContractsPage = function (preSelectContactId = null) {
  switchScreen('contracts');
  // If a contact is specified, open the new contract modal with that contact pre-selected
  if (preSelectContactId) {
    const contact = contacts.find(c => c.id === preSelectContactId);
    if (contact) {
      setTimeout(() => {
        openNewContractModal();
        // Pre-fill client info from contact
        newContractData.contactId = contact.id;
        newContractData.clientName = `${contact.first_name || ''} ${contact.last_name || ''}`.trim();
        newContractData.clientEmail = contact.email || '';
        newContractData.clientPhone = contact.phone || '';
        newContractData.clientCompanyName = contact.company_name || '';
        renderPMTool();
      }, 100);
    }
  }
};

window.viewContractFromContact = async function (contractId) {
  // Make sure contracts are loaded
  if (contractsList.length === 0) {
    await loadContracts();
  }
  selectedContractId = contractId;
  contractViewMode = 'detail';
  switchScreen('contracts');
};

// Render Contact Contracts Tab
async function renderContactContractsTab() {
  const contact = contacts.find(c => c.id === selectedContactId);
  if (!contact) {
    return `<div style="text-align: center; color: #6b7280; padding: 2rem;">No contact selected</div>`;
  }

  // Fetch contracts for this contact
  let contactContracts = [];
  try {
    const { data, error } = await supabase
      .from('contracts')
      .select('*')
      .eq('contact_id', selectedContactId)
      .order('created_at', { ascending: false });

    if (!error && data) {
      contactContracts = data;
    }
  } catch (err) {
    console.error('Error loading contact contracts:', err);
  }

  // Filter contracts
  const filteredContracts = contactContractsFilter === 'all'
    ? contactContracts
    : contactContracts.filter(c => c.status === contactContractsFilter);

  const getStatusColor = (status) => {
    switch (status) {
      case 'draft': return '#6b7280';
      case 'sent': return '#3b82f6';
      case 'viewed': return '#f59e0b';
      case 'signed': return '#10b981';
      case 'expired': return '#ef4444';
      case 'closed': return '#8b5cf6';
      case 'voided': return '#6b7280';
      default: return '#6b7280';
    }
  };

  const getStatusLabel = (status) => {
    const labels = {
      draft: 'Draft',
      sent: 'Sent',
      viewed: 'Viewed',
      signed: 'Signed',
      expired: 'Expired',
      closed: 'Closed',
      voided: 'Voided'
    };
    return labels[status] || status;
  };

  const filterCounts = {
    all: contactContracts.length,
    sent: contactContracts.filter(c => c.status === 'sent').length,
    viewed: contactContracts.filter(c => c.status === 'viewed').length,
    signed: contactContracts.filter(c => c.status === 'signed').length,
    expired: contactContracts.filter(c => c.status === 'expired').length,
    closed: contactContracts.filter(c => c.status === 'closed').length
  };

  return `
    <div style="display: flex; flex-direction: column; gap: 1rem;">
      <!-- Header -->
      <div style="display: flex; justify-content: space-between; align-items: center; flex-wrap: wrap; gap: 0.75rem;">
        <div style="display: flex; align-items: center; gap: 0.5rem;">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="#3b82f6"><path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/></svg>
          <h3 style="margin: 0; color: #2c3e50; font-size: ${isMobileDevice() ? '1rem' : '1.125rem'}; font-weight: 600;">
            Contracts
          </h3>
        </div>
        ${(() => {
      const userRole = currentProfile?.company_role || currentProfile?.role || 'USER';
      const canCreateContract = userRole === 'OWNER' || userRole === 'MANAGER' || userRole === 'ADMIN';
      return canCreateContract ? `
            <button onclick="goToContractsPage('${selectedContactId}')" style="
              background: linear-gradient(135deg, #ef4444 0%, #f97316 100%);
              color: white;
              border: none;
              padding: 0.5rem 1rem;
              border-radius: 0.375rem;
              cursor: pointer;
              font-size: 0.875rem;
              font-weight: 500;
              display: flex;
              align-items: center;
              gap: 0.375rem;
            ">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
              New Contract
            </button>
          ` : '';
    })()}
      </div>
      
      <!-- Filters -->
      <div style="display: flex; gap: 0.5rem; flex-wrap: wrap;">
        ${['all', 'sent', 'viewed', 'signed', 'expired', 'closed'].map(filter => `
          <button onclick="setContactContractsFilter('${filter}')" style="
            background: ${contactContractsFilter === filter ? '#ef4444' : '#f1f5f9'};
            color: ${contactContractsFilter === filter ? 'white' : '#64748b'};
            border: none;
            padding: 0.375rem 0.75rem;
            border-radius: 1rem;
            cursor: pointer;
            font-size: 0.75rem;
            font-weight: 500;
            display: flex;
            align-items: center;
            gap: 0.25rem;
          ">
            ${filter.charAt(0).toUpperCase() + filter.slice(1)}
            <span style="
              background: ${contactContractsFilter === filter ? 'rgba(255,255,255,0.25)' : '#e2e8f0'};
              padding: 0.125rem 0.375rem;
              border-radius: 0.5rem;
              font-size: 0.625rem;
            ">${filterCounts[filter]}</span>
          </button>
        `).join('')}
      </div>
      
      <!-- Contracts List -->
      ${filteredContracts.length === 0 ? `
        <div style="text-align: center; padding: 3rem 1rem; color: #64748b;">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="#d1d5db" style="margin-bottom: 1rem;"><path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/></svg>
          <div style="font-weight: 500; margin-bottom: 0.25rem;">No contracts found</div>
          <div style="font-size: 0.875rem;">
            ${contactContractsFilter === 'all'
        ? 'Create a contract to get started'
        : `No ${contactContractsFilter} contracts`}
          </div>
        </div>
      ` : `
        <div style="display: flex; flex-direction: column; gap: 0.75rem;">
          ${filteredContracts.map(contract => `
            <div style="
              background: white;
              border: 1px solid #e2e8f0;
              border-radius: 0.75rem;
              padding: 1rem;
              cursor: pointer;
              transition: all 0.2s ease;
            " onclick="viewContractFromContact('${contract.id}')" onmouseover="this.style.borderColor='#3b82f6'; this.style.boxShadow='0 2px 8px rgba(59,130,246,0.15)';" onmouseout="this.style.borderColor='#e2e8f0'; this.style.boxShadow='none';">
              <div style="display: flex; justify-content: space-between; align-items: flex-start; gap: 1rem;">
                <div style="flex: 1; min-width: 0;">
                  <div style="display: flex; align-items: center; gap: 0.5rem; margin-bottom: 0.25rem;">
                    <span style="font-weight: 600; color: #1e293b; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">
                      ${contract.name || 'Untitled Contract'}
                    </span>
                    <span style="
                      background: ${getStatusColor(contract.status)}20;
                      color: ${getStatusColor(contract.status)};
                      padding: 0.125rem 0.5rem;
                      border-radius: 1rem;
                      font-size: 0.625rem;
                      font-weight: 600;
                      text-transform: uppercase;
                      flex-shrink: 0;
                    ">${getStatusLabel(contract.status)}</span>
                  </div>
                  <div style="font-size: 0.75rem; color: #64748b;">
                    ${contract.contract_number || ''}
                    ${contract.rep_name ? ` • Prepared by: ${contract.rep_name}` : ''}
                    ${contract.effective_date ? ` • Effective: ${formatDateLocal(contract.effective_date)}` : ''}
                  </div>
                </div>
                <div style="display: flex; align-items: center; gap: 1rem;">
                  <div style="text-align: right; flex-shrink: 0;">
                    <div style="font-weight: 600; color: #1e293b;">$${parseFloat(contract.total || 0).toFixed(2)}</div>
                    <div style="font-size: 0.75rem; color: #64748b;">${formatDateLocal(contract.created_at)}</div>
                  </div>
                  <button onclick="event.stopPropagation(); viewContractFromContact('${contract.id}')" style="
                    background: #f1f5f9;
                    color: #3b82f6;
                    border: none;
                    padding: 0.5rem 0.75rem;
                    border-radius: 0.375rem;
                    cursor: pointer;
                    font-size: 0.75rem;
                    font-weight: 500;
                    display: flex;
                    align-items: center;
                    gap: 0.25rem;
                    flex-shrink: 0;
                  ">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/></svg>
                    View
                  </button>
                </div>
              </div>
              ${contract.status === 'signed' && contract.signed_at ? `
                <div style="margin-top: 0.5rem; padding-top: 0.5rem; border-top: 1px solid #e2e8f0; font-size: 0.75rem; color: #10b981; display: flex; align-items: center; gap: 0.25rem;">
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
                  Signed by ${contract.signer_name || 'Client'} on ${formatDateLocal(contract.signed_at)}
                </div>
              ` : ''}
            </div>
          `).join('')}
        </div>
      `}
    </div>
  `;
}

// Render Reminders Tab
function renderRemindersTab(reminders) {
  // Filter reminders - show pending/overdue by default, optionally show all
  const pendingReminders = reminders.filter(r => r.status === 'pending' || r.status === 'overdue');
  const completedReminders = reminders.filter(r => r.status === 'completed');
  const filteredReminders = showAllReminders ? reminders : pendingReminders;

  // Check if there are completed reminders
  const hasCompletedReminders = completedReminders.length > 0;

  const getPriorityColor = (priority) => {
    switch (priority?.toLowerCase()) {
      case 'urgent': return '#dc2626';
      case 'high': return '#f97316';
      case 'medium': return '#f59e0b';
      case 'low': return '#10b981';
      default: return '#f59e0b';
    }
  };

  const getPriorityLabel = (priority) => {
    switch (priority?.toLowerCase()) {
      case 'urgent': return 'Urgent Priority';
      case 'high': return 'High Priority';
      case 'medium': return 'Medium Priority';
      case 'low': return 'Low Priority';
      default: return 'Medium Priority';
    }
  };

  const getTypeLabel = (type) => {
    switch (type?.toLowerCase()) {
      case 'follow_up': return 'Follow Up';
      case 'call': return 'Call';
      case 'email': return 'Email';
      case 'appointment': return 'Appointment';
      default: return 'Follow Up';
    }
  };

  const isOverdue = (dueAt) => {
    if (!dueAt) return false;
    return new Date(dueAt) < new Date();
  };

  return `
    <div style="display: flex; flex-direction: column; gap: 1rem;">
      <!-- Header -->
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <div style="display: flex; align-items: center; gap: 0.5rem;">
          <span style="font-size: 1rem; color: #f59e0b;"></span>
        <h3 style="margin: 0; color: #2c3e50; font-size: ${isMobileDevice() ? '1rem' : '1.125rem'}; font-weight: 600;">
          Reminders
        </h3>
        </div>
        <button onclick="showAddReminderModal()" style="
          background: #fef3c7;
          color: #f59e0b;
          border: none;
          padding: 0.5rem 1rem;
          border-radius: 0.375rem;
          cursor: pointer;
          font-size: 0.875rem;
          font-weight: 500;
          display: flex;
          align-items: center;
          gap: 0.375rem;
          white-space: nowrap;
        ">
          <span style="font-size: 1rem;">+</span> Add
        </button>
      </div>
      
      ${filteredReminders.length === 0 ? `
        <div style="text-align: center; padding: 3rem 1rem;">
          <div style="font-size: 3rem; margin-bottom: 1rem; color: #6c757d;">
            <span class="material-icons" style="font-size: 3rem;">schedule</span>
          </div>
          <p style="color: #6c757d; font-size: 0.875rem; margin: 0;">
            ${showAllReminders ? 'No reminders for this contact' : 'No pending reminders for this contact'}
          </p>
        </div>
      ` : `
        <!-- Reminder Cards -->
        <div style="display: flex; flex-direction: column; gap: 1rem;">
          ${filteredReminders.map(rem => {
    const dueDate = rem.due_at ? new Date(rem.due_at) : null;
    const formattedDate = dueDate ? dueDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : '';
    const overdue = isOverdue(rem.due_at);
    const priorityColor = getPriorityColor(rem.priority);
    const priorityLabel = getPriorityLabel(rem.priority);
    const typeLabel = getTypeLabel(rem.type);
    const isCompleted = rem.status === 'completed';

    return `
          <div style="
            background: #ffffff;
                border-left: 4px solid #f59e0b;
                border-radius: 0.5rem;
                padding: 1rem;
                box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                position: relative;
                transition: all 0.2s ease;
              " onmouseover="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.15)'" onmouseout="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.1)'">
                <div style="display: flex; align-items: flex-start; gap: 1rem;">
                  <!-- Main Content -->
                  <div style="flex: 1; min-width: 0;">
                    <div style="display: flex; align-items: flex-start; justify-content: space-between; margin-bottom: 0.5rem;">
                      <div style="flex: 1;">
                        <div style="
                          font-weight: 600;
                          color: #2c3e50;
                          font-size: 1rem;
                          margin-bottom: 0.25rem;
                        ">${rem.title || 'Untitled Reminder'}</div>
                        ${overdue && !isCompleted ? `
                          <div style="color: #dc2626; font-size: 0.875rem; margin-bottom: 0.25rem; font-weight: 500;">
                            Overdue
                          </div>
                        ` : ''}
                        <div style="color: #6c757d; font-size: 0.875rem; margin-bottom: 0.125rem;">
                          ${isCompleted ? 'Completed' : 'Pending'} • ${priorityLabel}
                        </div>
                        <div style="color: #6c757d; font-size: 0.875rem; margin-bottom: 0.125rem;">
                          Type: ${typeLabel}
                        </div>
                        <div style="color: #6c757d; font-size: 0.875rem;">
                          Created by: ${(() => {
        if (rem.owner_id === currentUser?.id || rem.owner_id === currentProfile?.id) {
          return 'You';
        }
        if (rem.owner && rem.owner.first_name) {
          const ownerName = `${rem.owner.first_name || ''} ${rem.owner.last_name || ''}`.trim();
          return ownerName || 'Unknown';
        }
        return 'Unknown';
      })()}
                        </div>
                      </div>
                      <div style="display: flex; gap: 0.5rem; align-items: center;">
                        <button onclick="editReminder('${rem.id}')" style="
                          background: transparent;
                          border: none;
                          color: #9ca3af;
                          cursor: pointer;
                          padding: 0.25rem;
                          font-size: 0.875rem;
                          font-weight: 500;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                        " title="Edit reminder">
                          <span class="material-icons" style="font-size: 18px;">edit</span>
                        </button>
                        <button onclick="deleteReminder('${rem.id}')" style="
                          background: transparent;
                          border: none;
                          color: #ef4444;
                          cursor: pointer;
                          padding: 0.25rem;
                          font-size: 0.875rem;
                          font-weight: 500;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                        " title="Delete reminder">
                          <span class="material-icons" style="font-size: 18px;">delete</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  
                  <!-- Completion Checkbox -->
                  <div style="display: flex; flex-direction: column; align-items: center; gap: 0.25rem; flex-shrink: 0;">
                    <input
                      type="checkbox"
                      ${isCompleted ? 'checked' : ''}
                      onclick="toggleReminderComplete('${rem.id}', this.checked)"
                      style="
                        width: 24px;
                        height: 24px;
                        cursor: pointer;
                        accent-color: #f59e0b;
                      "
                    />
                    <span style="font-size: 0.75rem; color: #6c757d;">Complete</span>
                  </div>
                </div>
              </div>
            `;
  }).join('')}
        </div>
      `}
      
      ${hasCompletedReminders && !showAllReminders ? `
        <button onclick="toggleShowAllReminders()" style="
          background: transparent;
          color: #f59e0b;
          border: none;
          padding: 0.5rem 0.75rem;
          cursor: pointer;
          font-size: 0.875rem;
          font-weight: 500;
          text-decoration: underline;
          display: flex;
          align-items: center;
          gap: 0.375rem;
        ">
          <span></span> View All (${completedReminders.length} completed)
        </button>
      ` : hasCompletedReminders && showAllReminders ? `
        <button onclick="toggleShowAllReminders()" style="
          background: transparent;
          color: #f59e0b;
          border: none;
          padding: 0.5rem 0.75rem;
          cursor: pointer;
          font-size: 0.875rem;
                        font-weight: 500;
          text-decoration: underline;
        ">
          Show Pending Only
        </button>
      ` : ''}
      
      ${showAddReminderModal ? renderAddReminderModal() : ''}
    </div>
  `;
}

// Render Appointments Tab
function renderAppointmentsTab(appointments) {
  // Filter appointments - show scheduled/confirmed by default, optionally show all
  const scheduledAppointments = appointments.filter(a => a.status === 'scheduled' || a.status === 'confirmed');
  const completedAppointments = appointments.filter(a => a.status === 'completed');
  const filteredAppointments = showAllAppointments ? appointments : scheduledAppointments;

  // Check if there are completed appointments
  const hasCompletedAppointments = completedAppointments.length > 0;

  const formatDateTime = (dateStr, timeStr) => {
    if (!dateStr && !timeStr) return 'Not set';
    let date, timeDisplay = '';

    // If start_time is a full datetime string, parse it
    if (timeStr && timeStr.includes('T')) {
      date = new Date(timeStr);
      timeDisplay = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
    } else if (dateStr) {
      // Parse date string:
      // - If it includes time (ISO), let Date handle it
      // - If it's a plain YYYY-MM-DD, construct a local date to avoid off-by-one issues
      if (dateStr.includes('T')) {
        date = new Date(dateStr);
      } else {
        const [year, month, day] = dateStr.split('-').map(Number);
        date = new Date(year, month - 1, day);
      }
      if (timeStr) {
        // Parse time string (HH:MM format)
        const [hours, minutes] = timeStr.split(':');
        const hour = parseInt(hours);
        const ampm = hour >= 12 ? 'PM' : 'AM';
        const displayHour = hour % 12 || 12;
        timeDisplay = `${displayHour}:${minutes} ${ampm}`;
      }
    } else {
      return 'Not set';
    }

    const dateFormatted = date.toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: 'numeric' });

    return timeDisplay ? `${dateFormatted} at ${timeDisplay}` : dateFormatted;
  };

  const getDurationLabel = (durationMinutes) => {
    if (!durationMinutes) return '1 hour';
    const hours = durationMinutes / 60;
    if (hours === 0.5) return '30 minutes';
    if (hours === 1) return '1 hour';
    if (hours === 1.5) return '1.5 hours';
    if (hours === 2) return '2 hours';
    if (hours === 3) return '3 hours';
    return `${hours} hour${hours !== 1 ? 's' : ''}`;
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'scheduled': return '#f59e0b';
      case 'confirmed': return '#10b981';
      case 'completed': return '#6b7280';
      case 'cancelled': return '#dc2626';
      default: return '#f59e0b';
    }
  };

  return `
    <div style="display: flex; flex-direction: column; gap: 1rem;">
      <!-- Header -->
      <div style="display: flex; justify-content: space-between; align-items: center;">
        <div style="display: flex; align-items: center; gap: 0.5rem;">
          <span style="font-size: 1rem; color: #f59e0b;"></span>
        <h3 style="margin: 0; color: #2c3e50; font-size: ${isMobileDevice() ? '1rem' : '1.125rem'}; font-weight: 600;">
          Appointments
        </h3>
        </div>
        <button onclick="showAddAppointmentModal()" style="
          background: #fef3c7;
          color: #f59e0b;
          border: none;
          padding: 0.5rem 1rem;
          border-radius: 0.375rem;
          cursor: pointer;
          font-size: 0.875rem;
          font-weight: 500;
          display: flex;
          align-items: center;
          gap: 0.375rem;
          white-space: nowrap;
        ">
          <span style="font-size: 1rem;">+</span> Add
        </button>
      </div>
      
      ${filteredAppointments.length === 0 ? `
        <div style="text-align: center; padding: 3rem 1rem;">
          <div style="font-size: 3rem; margin-bottom: 1rem; color: #6c757d;">
            <span class="material-icons" style="font-size: 3rem;">event</span>
          </div>
          <p style="color: #6c757d; font-size: 0.875rem; margin: 0;">
            ${showAllAppointments ? 'No appointments for this contact' : 'No scheduled appointments for this contact'}
          </p>
        </div>
      ` : `
        <!-- Appointment Cards -->
        <div style="display: flex; flex-direction: column; gap: 1rem;">
          ${filteredAppointments.map(apt => {
    // Handle different time formats
    let startTime = '';
    if (apt.start_time) {
      const startTimeDate = new Date(apt.start_time);
      if (!isNaN(startTimeDate.getTime())) {
        startTime = startTimeDate.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
      }
    }

    const dateTimeStr = formatDateTime(apt.appointment_date || apt.start_time, apt.start_time || startTime);
    const duration = getDurationLabel(apt.duration_minutes);
    const assignedTo = apt.assigned_user ?
      `${apt.assigned_user.first_name || ''} ${apt.assigned_user.last_name || ''}`.trim() || 'Unassigned' :
      'Unassigned';
    const statusColor = getStatusColor(apt.status);
    const isCompleted = apt.status === 'completed';

    return `
          <div style="
            background: #ffffff;
                border-left: 4px solid #f59e0b;
                border-radius: 0.5rem;
                padding: 1rem;
                box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                position: relative;
                transition: all 0.2s ease;
              " onmouseover="this.style.boxShadow='0 2px 6px rgba(0,0,0,0.15)'" onmouseout="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.1)'">
                <div style="display: flex; align-items: flex-start; gap: 1rem;">
                  <!-- Main Content -->
                  <div style="flex: 1; min-width: 0;">
                    <div style="display: flex; align-items: flex-start; justify-content: space-between; margin-bottom: 0.5rem;">
                      <div style="flex: 1;">
                        <div style="display: flex; align-items: center; gap: 0.5rem; margin-bottom: 0.25rem;">
                          <span style="font-size: 1rem; color: #f59e0b;"></span>
                          <div style="
                            font-weight: 600;
                            color: #2c3e50;
                            font-size: 1rem;
                          ">${apt.title || 'Untitled Appointment'}</div>
                        </div>
                        <div style="color: #6c757d; font-size: 0.875rem; margin-bottom: 0.125rem;">
                          ${dateTimeStr}
                        </div>
                        <div style="color: #6c757d; font-size: 0.875rem; margin-bottom: 0.125rem;">
                          Duration: ${duration}
                        </div>
                        <div style="color: #6c757d; font-size: 0.875rem;">
                          Assigned to: ${assignedTo}
                        </div>
                      </div>
                      <div style="display: flex; gap: 0.25rem; align-items: center;">
                        <button onclick="editAppointment('${apt.id}')" style="
                          background: transparent;
                          border: none;
                          color: #9ca3af;
                          cursor: pointer;
                          padding: 0.25rem;
                          font-size: 1rem;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                        " title="Edit appointment">
                          <span class="material-icons" style="font-size: 1rem;">edit</span>
                        </button>
                        <button onclick="deleteAppointment('${apt.id}')" style="
                          background: transparent;
                          border: none;
                          color: #ef4444;
                          cursor: pointer;
                          padding: 0.25rem;
                          font-size: 1rem;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                        " title="Delete appointment">
                          <span class="material-icons" style="font-size: 1rem;">delete</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  
                  <!-- Completion Checkbox and Status -->
                  <div style="display: flex; flex-direction: column; align-items: center; gap: 0.5rem; flex-shrink: 0;">
                    <input
                      type="checkbox"
                      ${isCompleted ? 'checked' : ''}
                      onclick="toggleAppointmentComplete('${apt.id}', this.checked)"
                      style="
                        width: 24px;
                        height: 24px;
                        cursor: pointer;
                        accent-color: #f59e0b;
                      "
                    />
                    <span style="font-size: 0.75rem; color: #6c757d;">Complete</span>
                      <span style="
                      background: ${statusColor};
                        color: white;
                        padding: 0.25rem 0.5rem;
                        border-radius: 0.25rem;
                      font-size: 0.75rem;
                      font-weight: 600;
                      text-transform: uppercase;
                    ">${apt.status || 'SCHEDULED'}</span>
                  </div>
                </div>
              </div>
            `;
  }).join('')}
        </div>
      `}
      
      ${hasCompletedAppointments && !showAllAppointments ? `
        <button onclick="toggleShowAllAppointments()" style="
          background: transparent;
          color: #f59e0b;
          border: none;
          padding: 0.5rem 0.75rem;
          cursor: pointer;
          font-size: 0.875rem;
                        font-weight: 500;
          text-decoration: underline;
          display: flex;
          align-items: center;
          gap: 0.375rem;
        ">
          <span></span> View All (${completedAppointments.length} completed)
        </button>
      ` : hasCompletedAppointments && showAllAppointments ? `
        <button onclick="toggleShowAllAppointments()" style="
          background: transparent;
          color: #f59e0b;
          border: none;
          padding: 0.5rem 0.75rem;
          cursor: pointer;
          font-size: 0.875rem;
          font-weight: 500;
          text-decoration: underline;
        ">
          Show Scheduled Only
        </button>
      ` : ''}
      
      ${showAddAppointmentModal ? renderAddAppointmentModal() : ''}
    </div>
  `;
}

// Render Add Appointment Modal
function renderAddAppointmentModal() {
  const durationOptions = [
    { value: '30', label: '30 minutes' },
    { value: '60', label: '1 hour' },
    { value: '90', label: '1.5 hours' },
    { value: '120', label: '2 hours' },
    { value: '180', label: '3 hours' }
  ];

  return `
    <!-- Modal Overlay -->
    <div id="add-appointment-modal" onclick="if (event.target.id === 'add-appointment-modal') { cancelAppointmentModal(); }" style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 99999;
      animation: fadeIn 0.3s ease-out;
    ">
      <!-- Modal Content -->
      <div onclick="event.stopPropagation()" style="
        background: #ffffff;
        border-radius: 1rem;
        padding: 0;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
        max-width: 600px;
        width: 95%;
        max-height: 90vh;
        overflow-y: auto;
        animation: slideIn 0.3s ease-out;
        position: relative;
      ">
        <!-- Header -->
        <div style="
          padding: 1rem 1.5rem;
          border-bottom: 1px solid #e9ecef;
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: sticky;
          top: 0;
          background: #ffffff;
          z-index: 10;
        ">
          <button
            onclick="event.stopPropagation(); cancelAppointmentModal();"
            style="
              background: transparent;
              border: none;
              color: #f59e0b;
              cursor: pointer;
              font-size: 0.875rem;
              font-weight: 500;
              padding: 0.5rem;
            "
          >
            Cancel
          </button>
          <h2 style="
          margin: 0;
            color: #2c3e50;
            font-size: 1.125rem;
            font-weight: 700;
          ">
            ${editingAppointmentId ? 'Edit Appointment' : 'Schedule Appointment'}
          </h2>
          <button
            id="save-appointment-btn"
            onclick="event.stopPropagation(); handleAddAppointment(event)"
            style="
              background: #f59e0b;
              color: white;
              border: none;
              padding: 0.5rem 1rem;
              border-radius: 0.375rem;
              cursor: pointer;
              font-size: 0.875rem;
              font-weight: 600;
            "
          >
            ${editingAppointmentId ? 'Update' : 'Save'}
          </button>
        </div>

        <!-- Form Content -->
        <form id="add-appointment-form" onsubmit="handleAddAppointment(event); return false;" style="padding: 1.5rem;">
          <div style="display: flex; flex-direction: column; gap: 1.5rem;">
            ${isAppointmentModalFromCalendar ? `
            <!-- Contact Selector (only when opened from calendar) -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 700;
                font-size: 0.875rem;
              ">
                Contact (Optional)
              </label>
              <div style="position: relative;">
                ${selectedAppointmentContactId ? `
                  <div style="
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0.75rem;
                    border: 1px solid #e5e7eb;
                    border-radius: 0.5rem;
                    background: #f9fafb;
                  ">
                    <span style="color: #2c3e50; font-size: 0.875rem;">
                      ${(() => {
          const contact = contacts.find(c => c.id === selectedAppointmentContactId);
          return contact ? `${contact.first_name || ''} ${contact.last_name || ''}`.trim() || contact.company || 'Selected Contact' : 'Selected Contact';
        })()}
                    </span>
                    <button
                      type="button"
                      onclick="clearAppointmentContact()"
                      style="
                        background: transparent;
                        border: none;
                        color: #ef4444;
                        cursor: pointer;
                        padding: 0.25rem 0.5rem;
                        font-size: 0.75rem;
                      "
                    >×</button>
                  </div>
                ` : `
                  <input
                    type="text"
                    id="appointment-contact-search-input"
                    placeholder="Search contacts..."
                    value="${appointmentContactSearchQuery || ''}"
                    oninput="handleAppointmentContactSearch(this.value)"
                    style="
                      width: 100%;
                      padding: 0.75rem;
                      border: 1px solid #e5e7eb;
                      border-radius: 0.5rem;
                      font-size: 0.875rem;
                      box-sizing: border-box;
                      transition: border-color 0.2s;
                    "
                    onfocus="this.style.borderColor='#f59e0b'"
                    onblur="this.style.borderColor='#e5e7eb'"
                  />
                  <div id="appointment-contact-search-results" style="
                    max-height: 200px;
                    overflow-y: auto;
                    border: 1px solid #e5e7eb;
                    border-radius: 0.5rem;
                    background: #ffffff;
                    margin-top: 0.5rem;
                    display: ${appointmentContactSearchQuery && appointmentContactSearchQuery.trim() ? 'block' : 'none'};
                    position: absolute;
                    width: 100%;
                    z-index: 1000;
                    box-shadow: 0 4px 6px rgba(0,0,0,0.1);
                  ">
                    ${contacts.filter(contact =>
          `${contact.first_name || ''} ${contact.last_name || ''} ${contact.company || ''}`.toLowerCase().includes((appointmentContactSearchQuery || '').toLowerCase())
        ).map(contact => `
                      <div
                        onclick="selectAppointmentContact('${contact.id}')"
                        style="
                          padding: 0.75rem;
                          border-bottom: 1px solid #e9ecef;
                          cursor: pointer;
                          transition: background-color 0.2s;
                          display: flex;
                          justify-content: space-between;
                          align-items: center;
                        "
                        onmouseover="this.style.backgroundColor='#f8f9fa'"
                        onmouseout="this.style.backgroundColor='transparent'"
                      >
                        <div>
                          <div style="font-weight: 500; color: #2c3e50;">${contact.first_name || ''} ${contact.last_name || ''}</div>
                          ${contact.company ? `<div style="font-size: 0.75rem; color: #6c757d; margin-top: 0.25rem;">${contact.company}</div>` : ''}
                        </div>
                        ${contact.contact_profile_id ? `
                          <span style="background: #ff7f00; color: white; padding: 0.25rem 0.5rem; border-radius: 0.25rem; font-size: 0.75rem; font-weight: 600;">Client</span>
                        ` : ''}
                      </div>
                    `).join('')}
                    ${contacts.filter(contact =>
          `${contact.first_name || ''} ${contact.last_name || ''} ${contact.company || ''}`.toLowerCase().includes((appointmentContactSearchQuery || '').toLowerCase())
        ).length === 0 && appointmentContactSearchQuery && appointmentContactSearchQuery.trim() ? `
                      <div style="padding: 1rem; text-align: center; color: #6c757d; font-size: 0.875rem;">
                        No contacts found matching "${appointmentContactSearchQuery}"
                      </div>
                    ` : ''}
                  </div>
                `}
              </div>
            </div>
            ` : ''}
            <!-- Title -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 700;
                font-size: 0.875rem;
              ">
                Title *
              </label>
              <input
                type="text"
                id="appointment-title"
                placeholder="e.g., Demo call with client"
                required
                value="${appointmentFormData.title}"
                oninput="window.appointmentFormData.title = this.value"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e5e7eb;
                  border-radius: 0.5rem;
          font-size: 1rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s ease;
                "
                onfocus="this.style.borderColor='#f59e0b'"
                onblur="this.style.borderColor='#e5e7eb'"
              />
            </div>

            <!-- Date -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 700;
                font-size: 0.875rem;
              ">
                Date *
              </label>
              <div style="position: relative;">
                <input
                  type="date"
                  id="appointment-date"
                  required
                  value="${appointmentFormData.appointment_date}"
                  oninput="window.appointmentFormData.appointment_date = this.value"
                  style="
                    width: 100%;
                    padding: 0.75rem;
                    border: 1px solid #e5e7eb;
                    border-radius: 0.5rem;
                    font-size: 1rem;
                    box-sizing: border-box;
                    transition: border-color 0.2s ease;
                  "
                  onfocus="this.style.borderColor='#f59e0b'"
                  onblur="this.style.borderColor='#e5e7eb'"
                />
              </div>
      </div>

            <!-- Start Time -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 700;
                font-size: 0.875rem;
              ">
                Start Time *
              </label>
              <div style="position: relative;">
                <input
                  type="time"
                  id="appointment-start-time"
                  required
                  value="${appointmentFormData.start_time}"
                  oninput="window.appointmentFormData.start_time = this.value"
                  style="
                    width: 100%;
                    padding: 0.75rem;
                    padding-right: 2.5rem;
                    border: 1px solid #e5e7eb;
                    border-radius: 0.5rem;
                    font-size: 1rem;
                    box-sizing: border-box;
                    transition: border-color 0.2s ease;
                  "
                  onfocus="this.style.borderColor='#f59e0b'"
                  onblur="this.style.borderColor='#e5e7eb'"
                />
                <span style="
                  position: absolute;
                  right: 0.75rem;
                  top: 50%;
                  transform: translateY(-50%);
                  color: #9ca3af;
                  pointer-events: none;
                "></span>
              </div>
            </div>

            <!-- Duration -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 700;
                font-size: 0.875rem;
              ">
                Duration *
              </label>
              <div id="duration-buttons" style="display: flex; flex-wrap: wrap; gap: 0.5rem;">
                ${durationOptions.map(option => `
                  <button
                    type="button"
                    onclick="updateAppointmentDuration('${option.value}')"
                    id="duration-btn-${option.value}"
                    style="
                      padding: 0.5rem 1rem;
                      border-radius: 0.5rem;
                      border: 2px solid ${appointmentFormData.duration === option.value ? '#f59e0b' : '#e5e7eb'};
                      background: ${appointmentFormData.duration === option.value ? '#fef3c7' : '#ffffff'};
                      color: ${appointmentFormData.duration === option.value ? '#f59e0b' : '#6c757d'};
                      cursor: pointer;
                      font-size: 0.875rem;
                      font-weight: 500;
                      transition: all 0.2s ease;
                    "
                  >
                    ${option.label}
                  </button>
                `).join('')}
              </div>
            </div>

            <!-- Assign to (single: search + select like task form) -->
            <div style="margin-bottom: 1rem;">
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 700;
                font-size: 0.875rem;
              ">
                Assign to *
              </label>
              <input
                type="text"
                id="appointment-member-search-input"
                placeholder="Search members..."
                value="${window.appointmentMemberSearchQuery || ''}"
                oninput="handleAppointmentMemberSearch(this.value)"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e5e7eb;
                  border-radius: 0.5rem;
                  font-size: 0.875rem;
                  box-sizing: border-box;
                  margin-bottom: 0.5rem;
                  transition: border-color 0.2s;
                "
                onfocus="this.style.borderColor='#f59e0b'; handleAppointmentMemberSearch(document.getElementById('appointment-member-search-input')?.value || '')"
                onblur="this.style.borderColor='#e5e7eb'"
              />
              <div id="appointment-selected-assignee-display" style="
                display: flex;
                flex-wrap: wrap;
                gap: 0.5rem;
                margin-bottom: 0.5rem;
                min-height: 40px;
              ">
                ${(() => {
      const assignedId = window.selectedAppointmentAssignedTo || appointmentFormData.assigned_to || '';
      const emp = (companyEmployees || []).find(e => e.id === assignedId);
      return emp ? `
                  <div style="
                    background: #f59e0b;
                    color: white;
                    padding: 0.5rem 0.75rem;
                    border-radius: 1.5rem;
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    font-size: 0.875rem;
                    font-weight: 500;
                  ">
                    ${(emp.name || 'Unknown').replace(/</g, '&lt;')}
                    <button type="button" onclick="event.preventDefault(); removeAppointmentAssignee(event); return false;" style="background: rgba(255,255,255,0.3); border: none; color: white; cursor: pointer; font-size: 1rem; padding: 0; width: 18px; height: 18px; display: flex; align-items: center; justify-content: center; border-radius: 50%;">×</button>
                  </div>
                ` : '<span style="color: #6b7280; font-size: 0.875rem;">Select a team member</span>';
    })()}
              </div>
              <div id="appointment-member-search-results" style="
                max-height: 200px;
                overflow-y: auto;
                border: 1px solid #e5e7eb;
                border-radius: 0.5rem;
                background: #ffffff;
                display: ${(window.appointmentMemberSearchQuery || '').trim() ? 'block' : 'none'};
              ">
                ${((companyEmployees || []).filter(emp => {
      const selected = window.selectedAppointmentAssignedTo || appointmentFormData.assigned_to || '';
      if (emp.id === selected) return false;
      const q = (window.appointmentMemberSearchQuery || '').toLowerCase();
      return !q || (emp.name || '').toLowerCase().includes(q);
    })).map(emp => `
                  <div onmousedown="event.preventDefault(); addAppointmentAssignee('${emp.id}')" style="padding: 0.75rem; border-bottom: 1px solid #e9ecef; cursor: pointer; transition: background-color 0.2s;" onmouseover="this.style.backgroundColor='#f8f9fa'" onmouseout="this.style.backgroundColor='transparent'">${(emp.name || 'Unknown').replace(/</g, '&lt;')}</div>
                `).join('')}
                ${(companyEmployees || []).filter(emp => {
      const selected = window.selectedAppointmentAssignedTo || appointmentFormData.assigned_to || '';
      if (emp.id === selected) return false;
      const q = (window.appointmentMemberSearchQuery || '').toLowerCase();
      return !q || (emp.name || '').toLowerCase().includes(q);
    }).length === 0 && (window.appointmentMemberSearchQuery || '').trim() ? `
                  <div style="padding: 1rem; text-align: center; color: #6c757d; font-size: 0.875rem;">No members found</div>
                ` : ''}
              </div>
            </div>

            <!-- Notes -->
            <div>
              <label style="
                display: block;
                margin-bottom: 0.5rem;
                color: #2c3e50;
                font-weight: 700;
                font-size: 0.875rem;
              ">
                Notes
              </label>
              <textarea
                id="appointment-notes"
                placeholder="Add any additional notes about this appointment..."
                rows="4"
                oninput="window.appointmentFormData.notes = this.value"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e5e7eb;
                  border-radius: 0.5rem;
                  font-size: 1rem;
                  box-sizing: border-box;
                  resize: vertical;
                  font-family: inherit;
                  transition: border-color 0.2s ease;
                  min-height: 100px;
                "
                onfocus="this.style.borderColor='#f59e0b'"
                onblur="this.style.borderColor='#e5e7eb'"
              >${appointmentFormData.notes || ''}</textarea>
            </div>

            <!-- Validation Message -->
            <div id="appointment-validation-message" style="
              display: none;
              background: #fef3c7;
              border-left: 3px solid #f59e0b;
              border-radius: 0.25rem;
              padding: 0.75rem;
              color: #92400e;
              font-size: 0.875rem;
            ">
              * Title, date, start time, duration, and assignee are required.
            </div>
          </div>
        </form>
      </div>
    </div>
  `;
}

// Cancel appointment modal
window.cancelAppointmentModal = function () {
  // Reset calendar modal flags
  if (isAppointmentModalFromCalendar) {
    isAppointmentModalFromCalendar = false;
    selectedAppointmentContactId = null;
    window.selectedAppointmentContactId = selectedAppointmentContactId;
    appointmentContactSearchQuery = '';
    window.appointmentContactSearchQuery = appointmentContactSearchQuery;
  }
  appointmentFormData = {
    title: '',
    appointment_date: '',
    start_time: '',
    duration: '60',
    notes: '',
    assigned_to: ''
  };
  window.appointmentFormData = appointmentFormData;
  window.selectedAppointmentAssignedTo = null;
  window.appointmentMemberSearchQuery = '';
  showAddAppointmentModal = false;
  const modal = document.getElementById('add-appointment-modal');
  if (modal) {
    modal.remove();
  }
};

// Update appointment duration (without re-rendering)
window.updateAppointmentDuration = function (duration) {
  appointmentFormData.duration = duration;
  window.appointmentFormData.duration = duration;
  const buttons = document.querySelectorAll('#duration-buttons button');
  buttons.forEach(btn => {
    const value = btn.id.replace('duration-btn-', '');
    if (value === duration) {
      btn.style.borderColor = '#f59e0b';
      btn.style.background = '#fef3c7';
      btn.style.color = '#f59e0b';
    } else {
      btn.style.borderColor = '#e5e7eb';
      btn.style.background = '#ffffff';
      btn.style.color = '#6c757d';
    }
  });
};

// Appointment assignee: search and single-select (like task form)
window.handleAppointmentMemberSearch = function (query) {
  window.appointmentMemberSearchQuery = typeof query === 'string' ? query : (document.getElementById('appointment-member-search-input')?.value || '');
  const resultsDiv = document.getElementById('appointment-member-search-results');
  if (!resultsDiv) return;
  const selected = window.selectedAppointmentAssignedTo || '';
  const list = companyEmployees || [];
  const q = (window.appointmentMemberSearchQuery || '').toLowerCase().trim();
  const filtered = list.filter(emp => emp.id !== selected && (!q || (emp.name || '').toLowerCase().includes(q)));
  resultsDiv.innerHTML = filtered.map(emp => `
    <div onmousedown="event.preventDefault(); addAppointmentAssignee('${emp.id}')" style="padding: 0.75rem; border-bottom: 1px solid #e9ecef; cursor: pointer; transition: background-color 0.2s;" onmouseover="this.style.backgroundColor='#f8f9fa'" onmouseout="this.style.backgroundColor='transparent'">${(emp.name || 'Unknown').replace(/</g, '&lt;')}</div>
  `).join('') + (filtered.length === 0 && q ? '<div style="padding: 1rem; text-align: center; color: #6c757d; font-size: 0.875rem;">No members found</div>' : '');
  resultsDiv.style.display = (window.appointmentMemberSearchQuery || '').trim() ? 'block' : 'none';
};

window.addAppointmentAssignee = function (memberId) {
  window.selectedAppointmentAssignedTo = memberId;
  window.appointmentFormData = window.appointmentFormData || appointmentFormData;
  window.appointmentFormData.assigned_to = memberId;
  updateAppointmentAssignedDisplay();
  window.appointmentMemberSearchQuery = '';
  const input = document.getElementById('appointment-member-search-input');
  if (input) { input.value = ''; input.blur(); }
  const resultsDiv = document.getElementById('appointment-member-search-results');
  if (resultsDiv) { resultsDiv.style.display = 'none'; resultsDiv.innerHTML = ''; }
};

window.removeAppointmentAssignee = function (event) {
  if (event) event.preventDefault();
  window.selectedAppointmentAssignedTo = null;
  window.appointmentFormData = window.appointmentFormData || appointmentFormData;
  window.appointmentFormData.assigned_to = '';
  appointmentFormData.assigned_to = '';
  updateAppointmentAssignedDisplay();
};

function updateAppointmentAssignedDisplay() {
  const displayDiv = document.getElementById('appointment-selected-assignee-display');
  if (!displayDiv) return;
  const assignedId = window.selectedAppointmentAssignedTo || appointmentFormData?.assigned_to || '';
  const emp = (companyEmployees || []).find(e => e.id === assignedId);
  displayDiv.innerHTML = emp
    ? `<div style="background: #f59e0b; color: white; padding: 0.5rem 0.75rem; border-radius: 1.5rem; display: flex; align-items: center; gap: 0.5rem; font-size: 0.875rem; font-weight: 500;">${(emp.name || 'Unknown').replace(/</g, '&lt;')}<button type="button" onclick="event.preventDefault(); removeAppointmentAssignee(event); return false;" style="background: rgba(255,255,255,0.3); border: none; color: white; cursor: pointer; font-size: 1rem; padding: 0; width: 18px; height: 18px; display: flex; align-items: center; justify-content: center; border-radius: 50%;">×</button></div>`
    : '<span style="color: #6b7280; font-size: 0.875rem;">Select a team member</span>';
}

// Handle Add Appointment
window.handleAddAppointment = async function (e) {
  if (e) e.preventDefault();

  const titleInput = document.getElementById('appointment-title');
  const dateInput = document.getElementById('appointment-date');
  const startTimeInput = document.getElementById('appointment-start-time');
  const notesInput = document.getElementById('appointment-notes');
  const validationMsg = document.getElementById('appointment-validation-message');

  const title = titleInput?.value?.trim() || '';
  let appointmentDate = dateInput?.value || '';
  const startTime = startTimeInput?.value || '';
  const notes = notesInput?.value?.trim() || '';
  const durationMinutes = parseInt((window.appointmentFormData || appointmentFormData).duration || '60');
  const assignedTo = (window.selectedAppointmentAssignedTo || (window.appointmentFormData || appointmentFormData).assigned_to || '').trim();

  // Validation: require assignee (no auto-assign to current user)
  if (!title || !appointmentDate || !startTime || !(window.appointmentFormData || appointmentFormData).duration || !assignedTo) {
    if (validationMsg) {
      validationMsg.style.display = 'block';
    }
    return;
  }

  // Fix timezone issue: HTML5 date input returns YYYY-MM-DD which can be interpreted as UTC midnight
  // Normalize the date to ensure it's stored as the correct local date
  // Extract date components from the input value to avoid UTC conversion
  if (appointmentDate) {
    // If the date string is in YYYY-MM-DD format, use it directly
    // But ensure we're not accidentally converting it to UTC
    // Create a date in local timezone to verify the date components
    const dateParts = appointmentDate.split('-');
    if (dateParts.length === 3) {
      const year = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10) - 1; // Month is 0-indexed
      const day = parseInt(dateParts[2], 10);

      // Create a date in local timezone to ensure correct date
      const localDate = new Date(year, month, day);
      const normalizedYear = localDate.getFullYear();
      const normalizedMonth = String(localDate.getMonth() + 1).padStart(2, '0');
      const normalizedDay = String(localDate.getDate()).padStart(2, '0');

      // Use the normalized date string to ensure correct date storage
      appointmentDate = `${normalizedYear}-${normalizedMonth}-${normalizedDay}`;
    }
  }

  // Hide validation message
  if (validationMsg) {
    validationMsg.style.display = 'none';
  }

  const submitBtn = document.getElementById('save-appointment-btn');
  if (submitBtn) {
    submitBtn.disabled = true;
    submitBtn.textContent = editingAppointmentId ? 'Updating...' : 'Saving...';
  }

  try {
    // Format start_time as TIME (HH:MM:SS format)
    // The schema expects TIME, not TIMESTAMP
    // Only add seconds if not already present (input type="time" gives HH:MM)
    const startTimeFormatted = startTime.includes(':') && startTime.split(':').length === 2
      ? startTime + ':00'
      : startTime;

    const appointmentData = {
      title: title,
      notes: notes || null,
      appointment_date: appointmentDate,
      start_time: startTimeFormatted,
      duration_minutes: durationMinutes,
      assigned_to: assignedTo,
      updated_at: new Date().toISOString()
    };

    let data, error;

    if (editingAppointmentId) {
      // Update existing appointment
      console.log('📝 Updating appointment:', editingAppointmentId, appointmentData);
      const result = await supabase
        .from('appointments')
        .update(appointmentData)
        .eq('id', editingAppointmentId)
        .select();

      console.log('📝 Update result:', result);

      if (result.error) {
        data = null;
        error = result.error;
      } else if (!result.data || result.data.length === 0) {
        // Update succeeded (status 200) but select failed due to RLS
        // Since we know the update succeeded, construct the updated data from what we sent
        console.log('⚠️ Update select returned 0 rows (RLS), using update data...');

        // Fetch the appointment to get the fields we didn't update (like id, company_id, etc.)
        const fetchResult = await supabase
          .from('appointments')
          .select('*')
          .eq('id', editingAppointmentId)
          .maybeSingle();

        if (fetchResult.error && fetchResult.error.code !== 'PGRST116') {
          // Real error, not just "not found"
          data = null;
          error = fetchResult.error;
        } else if (fetchResult.data) {
          // Merge the fetched data with our update data to ensure we have the latest
          data = { ...fetchResult.data, ...appointmentData };
          error = null;
          console.log('✅ Using merged update data:', data);
        } else {
          // Not found - but update succeeded, so use the data we sent
          // We'll need to fetch the base appointment data separately
          const baseFetch = await supabase
            .from('appointments')
            .select('id, company_id, contact_id, assigned_to, status, created_at')
            .eq('id', editingAppointmentId)
            .maybeSingle();

          if (baseFetch.data) {
            data = { ...baseFetch.data, ...appointmentData };
            error = null;
            console.log('✅ Using constructed update data:', data);
          } else {
            data = null;
            error = {
              code: 'UPDATE_FAILED',
              message: 'Appointment update may have failed. The appointment was not found after update.'
            };
          }
        }
      } else {
        data = result.data[0];
        error = null;
      }
    } else {
      // Create new appointment
      // Use selected contact from calendar modal if opened from calendar, or from form submission if selectedAppointmentContactId is set, otherwise use selectedContactId
      const contactIdToUse = (isAppointmentModalFromCalendar || selectedAppointmentContactId) ? selectedAppointmentContactId : selectedContactId;

      const result = await supabase
        .from('appointments')
        .insert({
          ...appointmentData,
          company_id: currentCompany.id,
          contact_id: contactIdToUse,
          assigned_to: assignedTo,
          status: 'scheduled',
          created_at: new Date().toISOString()
        })
        .select()
        .single();
      data = result.data;
      error = result.error;
    }

    if (error) {
      console.error(`Error ${editingAppointmentId ? 'updating' : 'creating'} appointment:`, error);
      alert(`Failed to ${editingAppointmentId ? 'update' : 'create'} appointment: ` + error.message);
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = editingAppointmentId ? 'Update' : 'Save';
      }
      return;
    }

    console.log(`✅ Appointment ${editingAppointmentId ? 'updated' : 'created'} successfully:`, data);

    // Push to Google Calendar if connected (sets last_modified_source='app')
    if (data?.id) {
      await pushToGoogleCalendar('appointment', data.id);
    }

    // Invalidate dashboard cache
    invalidateDashboardCache();

    // Reload appointments to get fresh data
    if (selectedContactId) {
      await loadContactAppointments(selectedContactId);
    } else {
      await loadAppointments(calendarViewMode);
    }

    // Reset editing state
    editingAppointmentId = null;
    window.selectedAppointmentAssignedTo = null;
    window.appointmentMemberSearchQuery = '';

    // Close modal directly
    showAddAppointmentModal = false;
    const modal = document.getElementById('add-appointment-modal');
    if (modal) {
      modal.remove();
    }

    // Refresh appointments tab if we're viewing a contact
    if (currentScreen === 'sales' && selectedContactId) {
      // Force refresh of contact detail content to show updated appointment
      await updateContactDetailContent();
    } else if (currentScreen === 'sales') {
      // Refresh the sales dashboard to show updated appointments in "Upcoming" section
      await renderSalesDashboard();
    } else if (currentScreen === 'calendar') {
      // Refresh calendar if on calendar screen
      await loadCalendarEvents(true);
      renderPMTool();
    }

    // Reset calendar modal flags
    if (isAppointmentModalFromCalendar) {
      isAppointmentModalFromCalendar = false;
      selectedAppointmentContactId = null;
      window.selectedAppointmentContactId = selectedAppointmentContactId;
      appointmentContactSearchQuery = '';
      window.appointmentContactSearchQuery = appointmentContactSearchQuery;
    }

    // Show success message
    const successMsg = document.createElement('div');
    successMsg.textContent = 'Appointment scheduled successfully!';
    successMsg.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #28a745;
      color: white;
      padding: 0.75rem 1.5rem;
      border-radius: 0.5rem;
      z-index: 100001;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
    `;
    document.body.appendChild(successMsg);
    setTimeout(() => successMsg.remove(), 3000);
  } catch (error) {
    console.error('Error creating appointment:', error);
    alert('An unexpected error occurred while creating the appointment');
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Save';
    }
  }
};

// Toggle appointment complete status
window.toggleAppointmentComplete = async function (appointmentId, isCompleted) {
  try {
    // Get fresh appointment data from database to ensure we have the latest title
    const { data: appointmentData, error: fetchError } = await supabase
      .from('appointments')
      .select('*')
      .eq('id', appointmentId)
      .single();

    if (fetchError || !appointmentData) {
      console.error('Error fetching appointment:', fetchError);
      alert('Failed to load appointment details');
      return;
    }

    const contactId = appointmentData.contact_id || selectedContactId;

    const { error } = await supabase
      .from('appointments')
      .update({
        status: isCompleted ? 'completed' : 'scheduled',
        updated_at: new Date().toISOString()
      })
      .eq('id', appointmentId);

    if (error) {
      console.error('Error updating appointment:', error);
      alert('Failed to update appointment status');
      return;
    }

    // Push to Google Calendar if connected (sets last_modified_source='app')
    await pushToGoogleCalendar('appointment', appointmentId);

    // Invalidate dashboard cache
    invalidateDashboardCache();

    // Reload appointments
    if (selectedContactId) {
      await loadContactAppointments(selectedContactId);
    } else {
      await loadAppointments(calendarViewMode);
    }

    // If appointment was completed and has a contact_id, create activity log entry
    if (isCompleted && contactId) {
      console.log(`📅 [Appointment Completion] Creating activity log for appointment ${appointmentId}`);
      console.log(`📅 [Appointment Data]:`, appointmentData);
      await createActivityLogEntry(
        contactId,
        'appointment',
        `Completed appointment: ${appointmentData.title || 'Untitled Appointment'}`,
        appointmentData.notes || null,
        { appointment_id: appointmentId }
      );
    }

    // Refresh UI based on current screen
    if (currentScreen === 'sales' && selectedContactId) {
      console.log(`🔄 [Appointment Completion] Refreshing contact detail view for contact ${selectedContactId}`);
      await updateContactDetailContent();
    } else if (currentScreen === 'calendar') {
      await loadCalendarEvents(true);
      renderPMTool();
    }
  } catch (error) {
    console.error('Error updating appointment:', error);
    alert('An unexpected error occurred');
  }
};

// Edit appointment (placeholder)
window.editAppointment = async function (appointmentId) {
  try {
    if (companyEmployees === null) await loadCompanyEmployees();
    // Fetch appointment from database with cache-busting to ensure fresh data
    const { data: appointment, error } = await supabase
      .from('appointments')
      .select('*')
      .eq('id', appointmentId)
      .single();

    if (error || !appointment) {
      console.error('Error fetching appointment:', error);
      alert('Appointment not found');
      return;
    }

    // Check if current user is assigned to this appointment
    const currentUserId = currentUser?.id || currentProfile?.id;
    if (appointment.assigned_to !== currentUserId) {
      window.showNotification('You can\'t edit other people\'s appointments', 'error');
      return;
    }

    console.log('📝 Loading appointment for edit:', appointment);

    // Open the add appointment modal in edit mode
    editingAppointmentId = appointmentId;
    // Strip seconds from start_time for HTML5 time input (only accepts HH:MM)
    const startTimeForInput = appointment.start_time
      ? appointment.start_time.split(':').slice(0, 2).join(':')
      : '';

    appointmentFormData = {
      title: appointment.title || '',
      notes: appointment.notes || '',
      appointment_date: appointment.appointment_date ? (() => {
        // Parse appointment_date in local timezone to avoid UTC conversion issues
        const dateParts = appointment.appointment_date.split('-');
        if (dateParts.length === 3) {
          const date = new Date(parseInt(dateParts[0], 10), parseInt(dateParts[1], 10) - 1, parseInt(dateParts[2], 10));
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        }
        return new Date(appointment.appointment_date).toISOString().split('T')[0];
      })() : '',
      start_time: startTimeForInput,
      duration: appointment.duration_minutes?.toString() || appointment.duration?.toString() || '60',
      location: appointment.location || '',
      type: appointment.type || 'meeting',
      assigned_to: appointment.assigned_to || ''
    };
    window.appointmentFormData = appointmentFormData;
    window.selectedAppointmentAssignedTo = appointment.assigned_to || '';
    window.appointmentMemberSearchQuery = '';
    showAddAppointmentModal = true;

    // Inject modal directly instead of re-rendering entire page
    const existingModal = document.getElementById('add-appointment-modal');
    if (existingModal) {
      existingModal.remove();
    }

    const modalHTML = renderAddAppointmentModal();
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = modalHTML;
    const modalElement = tempDiv.firstElementChild;

    document.body.appendChild(modalElement);

    // Set form field values explicitly after injection to ensure they're correct
    setTimeout(() => {
      const titleInput = document.getElementById('appointment-title');
      const dateInput = document.getElementById('appointment-date');
      const timeInput = document.getElementById('appointment-start-time');
      const notesInput = document.getElementById('appointment-notes');

      if (titleInput) titleInput.value = appointmentFormData.title;
      if (dateInput) dateInput.value = appointmentFormData.appointment_date;
      if (timeInput) timeInput.value = appointmentFormData.start_time;
      if (notesInput) notesInput.value = appointmentFormData.notes || '';
      updateAppointmentAssignedDisplay();

      // Update duration buttons
      const durationButtons = document.querySelectorAll('#duration-buttons button');
      durationButtons.forEach(btn => {
        const value = btn.id.replace('duration-btn-', '');
        if (value === appointmentFormData.duration) {
          btn.style.borderColor = '#f59e0b';
          btn.style.background = '#fef3c7';
          btn.style.color = '#f59e0b';
        } else {
          btn.style.borderColor = '#e5e7eb';
          btn.style.background = '#ffffff';
          btn.style.color = '#6c757d';
        }
      });

      // Animate in
      if (modalElement) {
        modalElement.style.opacity = '1';
      }
    }, 10);
  } catch (error) {
    console.error('Error editing appointment:', error);
    alert('Failed to load appointment details');
  }
};

// Delete appointment
// Show delete appointment confirmation modal
window.showDeleteAppointmentConfirm = function (appointmentId) {
  if (!appointmentId) return;

  // Remove any existing modal
  const existingModal = document.getElementById('delete-appointment-modal');
  if (existingModal) {
    existingModal.remove();
  }

  const appointment = appointments.find(a => a.id === appointmentId);
  const appointmentTitle = appointment ? appointment.title || 'Untitled Appointment' : 'this appointment';

  const modal = document.createElement('div');
  modal.id = 'delete-appointment-modal';
  modal.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10001;
    animation: fadeIn 0.2s ease-out;
  `;

  modal.innerHTML = `
    <div style="
      background: white;
      border-radius: 1rem;
      padding: 0;
      max-width: 400px;
      width: 90%;
      box-shadow: 0 25px 50px rgba(0,0,0,0.25);
      animation: scaleIn 0.2s ease-out;
      overflow: hidden;
    ">
      <!-- Header -->
      <div style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1.25rem 1.5rem;
        border-bottom: 1px solid #E5E7EB;
      ">
        <div style="display: flex; align-items: center; gap: 0.75rem;">
          <span class="material-icons" style="color: #EF4444; font-size: 24px;">warning</span>
          <h3 style="margin: 0; font-size: 1.125rem; font-weight: 600; color: #111827;">Delete Appointment</h3>
        </div>
        <button 
          onclick="closeDeleteAppointmentModal()"
          style="
            background: transparent;
            border: none;
            cursor: pointer;
            padding: 0.25rem;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 0.375rem;
            color: #6B7280;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#F3F4F6'; this.style.color='#111827';"
          onmouseout="this.style.background='transparent'; this.style.color='#6B7280';"
        >
          <span class="material-icons" style="font-size: 20px;">close</span>
        </button>
      </div>
      
      <!-- Body -->
      <div style="padding: 1.5rem;">
        <p style="margin: 0; color: #4B5563; font-size: 0.9375rem; line-height: 1.5;">
          Are you sure you want to delete <strong>${appointmentTitle}</strong>? This action cannot be undone.
        </p>
      </div>
      
      <!-- Footer -->
      <div style="
        display: flex;
        gap: 0.75rem;
        padding: 1rem 1.5rem;
        background: #F9FAFB;
        border-top: 1px solid #E5E7EB;
        justify-content: flex-end;
      ">
        <button 
          onclick="closeDeleteAppointmentModal()"
          style="
            padding: 0.75rem 1.5rem;
            background: white;
            border: 1px solid #D1D5DB;
            border-radius: 0.5rem;
            color: #374151;
            font-size: 0.9375rem;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#F9FAFB'; this.style.borderColor='#9CA3AF';"
          onmouseout="this.style.background='white'; this.style.borderColor='#D1D5DB';"
        >
          Cancel
        </button>
        <button 
          onclick="confirmDeleteAppointment('${appointmentId}')"
          style="
            padding: 0.75rem 1.5rem;
            background: #EF4444;
            border: none;
            border-radius: 0.5rem;
            color: white;
            font-size: 0.9375rem;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#DC2626';"
          onmouseout="this.style.background='#EF4444';"
        >
          Delete
        </button>
      </div>
    </div>
  `;

  // Add styles if not already added
  if (!document.getElementById('delete-appointment-modal-styles')) {
    const style = document.createElement('style');
    style.id = 'delete-appointment-modal-styles';
    style.textContent = `
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      @keyframes scaleIn {
        from { transform: scale(0.95); opacity: 0; }
        to { transform: scale(1); opacity: 1; }
      }
    `;
    document.head.appendChild(style);
  }

  // Close on backdrop click
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      closeDeleteAppointmentModal();
    }
  });

  document.body.appendChild(modal);
};

// Close delete appointment modal
window.closeDeleteAppointmentModal = function () {
  const modal = document.getElementById('delete-appointment-modal');
  if (modal) {
    modal.style.opacity = '0';
    setTimeout(() => {
      modal.remove();
    }, 200);
  }
};

// Confirm delete appointment
window.confirmDeleteAppointment = async function (appointmentId) {
  if (!appointmentId) return;

  const deleteBtn = document.querySelector('#delete-appointment-modal button[onclick*="confirmDeleteAppointment"]');
  if (deleteBtn) {
    deleteBtn.disabled = true;
    deleteBtn.textContent = 'Deleting...';
  }

  try {
    // First, fetch the appointment to check ownership
    const { data: appointment, error: fetchError } = await supabase
      .from('appointments')
      .select('assigned_to')
      .eq('id', appointmentId)
      .single();

    if (fetchError || !appointment) {
      window.showNotification('Appointment not found', 'error');
      closeDeleteAppointmentModal();
      return;
    }

    // Check if current user is assigned to this appointment OR is an owner
    const currentUserId = currentUser?.id || currentProfile?.id;
    const isOwner = currentProfile?.company_role === 'OWNER' || currentUser?.role === 'OWNER';

    if (appointment.assigned_to !== currentUserId && !isOwner) {
      window.showNotification('You can\'t delete other people\'s appointments', 'error');
      closeDeleteAppointmentModal();
      return;
    }

    // Delete the appointment from database
    const { error } = await supabase
      .from('appointments')
      .delete()
      .eq('id', appointmentId);

    if (error) throw error;

    // Push delete to Google Calendar if connected
    await pushToGoogleCalendar('appointment', appointmentId, 'delete');

    closeDeleteAppointmentModal();

    // Reload appointments and re-render
    if (selectedContactId) {
      await updateContactDetailContent();
    } else {
      await loadAppointments(calendarViewMode);
      renderPMTool();
    }

    window.showNotification('Appointment deleted successfully', 'success');
  } catch (error) {
    console.error('Error deleting appointment:', error);
    window.showNotification('Failed to delete appointment: ' + (error.message || error), 'error');
    closeDeleteAppointmentModal();
  }
};

window.deleteAppointment = async function (appointmentId) {
  if (!appointmentId) {
    alert('No appointment selected');
    return;
  }

  try {
    // First, fetch the appointment to check ownership
    const { data: appointment, error: fetchError } = await supabase
      .from('appointments')
      .select('assigned_to')
      .eq('id', appointmentId)
      .single();

    if (fetchError || !appointment) {
      window.showNotification('Appointment not found', 'error');
      return;
    }

    // Check if current user is assigned to this appointment OR is an owner
    const currentUserId = currentUser?.id || currentProfile?.id;
    const isOwner = currentProfile?.company_role === 'OWNER' || currentUser?.role === 'OWNER';

    if (appointment.assigned_to !== currentUserId && !isOwner) {
      window.showNotification('You can\'t delete other people\'s appointments', 'error');
      return;
    }

    // Show confirmation modal
    showDeleteAppointmentConfirm(appointmentId);
  } catch (error) {
    console.error('Error checking appointment:', error);
    window.showNotification('Failed to load appointment: ' + (error.message || error), 'error');
  }
};

// Extracted function to render chat messages list HTML
// This allows updating just the message list without re-rendering the whole page (which kills input focus)
window.renderChatMessagesList = function (messages) {
  if (!messages || messages.length === 0) {
    return `
      <div style="
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #9ca3af;
        font-size: 0.875rem;
      ">
        No messages yet. Start the conversation!
      </div>
    `;
  }

  // Helper: Get avatar background color
  const getAvatarBackgroundColor = (name) => {
    const colors = [
      '#EF4444', '#F97316', '#F59E0B', '#EAB308', '#84CC16',
      '#22C55E', '#10B981', '#14B8A6', '#06B6D4', '#3B82F6',
      '#6366F1', '#8B5CF6', '#A855F7', '#EC4899', '#F43F5E'
    ];
    if (!name || name.length === 0) return colors[0];
    const index = name.charCodeAt(0) % colors.length;
    return colors[index];
  };

  // Helper: Format message time
  const formatMessageTime = (msg) => {
    let dateStr;
    if (typeof msg === 'string') {
      dateStr = msg;
    } else if (msg && typeof msg === 'object') {
      if (msg.status !== 'scheduled' && msg.updated_at && msg.updated_at !== msg.created_at) {
        dateStr = msg.updated_at;
      } else if (msg.sent_at) {
        dateStr = msg.sent_at;
      } else if (msg.updated_at) {
        dateStr = msg.updated_at;
      } else {
        dateStr = msg.created_at;
      }
    } else {
      return '';
    }

    if (!dateStr) return '';
    const date = new Date(dateStr);
    const now = new Date();
    const isToday = date.getDate() === now.getDate() &&
      date.getMonth() === now.getMonth() &&
      date.getFullYear() === now.getFullYear();

    if (isToday) {
      return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
    } else {
      const formattedDate = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined });
      const timeStr = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
      return `${formattedDate} ${timeStr}`;
    }
  };

  return messages.map(msg => {
    const isOwnMessage = msg.sender_id === currentUser?.id;
    const senderName = msg.profiles
      ? `${msg.profiles.first_name || ''} ${msg.profiles.last_name || ''}`.trim()
      : 'Unknown';

    return `
      <div style="
        display: flex;
        justify-content: ${isOwnMessage ? 'flex-end' : 'flex-start'};
        align-items: flex-end;
        gap: 0.5rem;
      ">
        ${!isOwnMessage ? (() => {
        // Try to find sender in teamMembers or contacts
        const sender = (window.teamMembers || []).find(m => m.id === msg.sender_id) ||
          (window.contacts || []).find(c => c.contact_profile_id === msg.sender_id);

        // Helper to get global getAvatarUrl
        const getUrl = (path) => {
          if (window.getAvatarUrl) return window.getAvatarUrl(path);
          if (typeof getAvatarUrl === 'function') return getAvatarUrl(path);
          return null;
        };

        const senderAvatarPath = sender?.avatar_path;
        const senderAvatarUrl = senderAvatarPath ? getUrl(senderAvatarPath) : null;
        const senderInitials = senderName.substring(0, 2).toUpperCase();

        return senderAvatarUrl ? `
            <img
              src="${senderAvatarUrl}"
              alt="${senderInitials}"
              style="
                width: 32px;
                height: 32px;
                border-radius: 50%;
                object-fit: cover;
                flex-shrink: 0;
              "
              onerror="
                this.style.display='none';
                const fallback = this.nextElementSibling;
                fallback.style.display='flex';
              "
            />
            <div style="
              display: none;
              width: 32px;
              height: 32px;
              border-radius: 50%;
              background: #f59e0b;
              color: white;
              align-items: center;
              justify-content: center;
              font-weight: 600;
              font-size: 0.75rem;
              flex-shrink: 0;
            ">${senderInitials}</div>
          ` : `
            <div style="
              width: 32px;
              height: 32px;
              border-radius: 50%;
              background: #f59e0b;
              color: white;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: 600;
              font-size: 0.75rem;
              flex-shrink: 0;
            ">${senderInitials}</div>
          `;
      })() : ''}
        <div style="
          max-width: 60%;
          display: flex;
          flex-direction: column;
          gap: 0.25rem;
        ">
          ${!isOwnMessage ? `
            <div style="
              font-size: 0.75rem;
              color: #6c757d;
              padding-left: 0.5rem;
            ">${senderName}</div>
          ` : ''}
          ${(() => {
        const isImage = msg.media_path && (msg.media_type === 'image' || msg.media_path.match(/\.(jpg|jpeg|png|gif|webp|bmp)(\?|$)/i));
        const messageBg = isImage ? 'transparent' : (isOwnMessage ? '#f59e0b' : '#ffffff');
        const messageColor = isImage ? '#f59e0b' : (isOwnMessage ? 'white' : '#2c3e50');
        const messageShadow = isImage ? 'none' : '0 1px 2px rgba(0,0,0,0.1)';
        return `
              <div style="
                background: ${messageBg};
                color: ${messageColor};
                padding: 0.625rem 0.875rem;
                border-radius: ${isOwnMessage ? '1rem 1rem 0.25rem 1rem' : '1rem 1rem 1rem 0.25rem'};
                font-size: 0.875rem;
                line-height: 1.4;
                box-shadow: ${messageShadow};
                overflow-wrap: anywhere;
                word-break: break-word;
              ">
                ${msg.media_path ? (() => {
            const isImageFile = msg.media_type === 'image' || msg.media_path.match(/\.(jpg|jpeg|png|gif|webp|bmp)(\?|$)/i);
            const isPDF = msg.media_path.match(/\.pdf(\?|$)/i);

            if (isImageFile) {
              return `
                      <div style="margin-bottom: 0.5rem;">
                        <img 
                          src="${msg.media_path}" 
                          alt="${msg.text || 'Image'}"
                          style="
                            max-width: 100%;
                            max-height: 300px;
                            border-radius: 0.5rem;
                            object-fit: contain;
                            cursor: pointer;
                          "
                          onclick="openImageViewer('${msg.media_path.replace(/'/g, "\\'")}')"
                          onerror="this.style.display='none'; this.nextElementSibling.style.display='block';"
                        />
                        <div style="display: none; padding: 0.5rem; background: rgba(0,0,0,0.1); border-radius: 0.25rem; font-size: 0.75rem;">
                          Failed to load image. <a href="${msg.media_path}" target="_blank" style="color: ${isOwnMessage ? '#fff' : '#3b82f6'}; text-decoration: underline;">Open in new tab</a>
                        </div>
                      </div>
                    `;
            } else if (isPDF || true) { // Default to file style
              return `
                      <div style="margin-bottom: 0.5rem;">
                        <a 
                          href="${msg.media_path}" 
                          target="_blank"
                          style="
                            display: inline-flex;
                            align-items: center;
                            gap: 0.5rem;
                            padding: 0.5rem 0.75rem;
                            background: ${isOwnMessage ? 'rgba(255,255,255,0.2)' : '#f3f4f6'};
                            border-radius: 0.5rem;
                            text-decoration: none;
                            color: ${isOwnMessage ? 'white' : '#2c3e50'};
                            font-weight: 500;
                          "
                          onmouseover="this.style.background='${isOwnMessage ? 'rgba(255,255,255,0.3)' : '#e5e7eb'}'"
                          onmouseout="this.style.background='${isOwnMessage ? 'rgba(255,255,255,0.2)' : '#f3f4f6'}'"
                        >
                          ${msg.text || (isPDF ? 'PDF Document' : 'File')}
                          <span style="font-size: 0.75rem; opacity: 0.8;">(Click to open)</span>
                        </a>
                      </div>
                    `;
            }
          })() : (() => {
            const text = msg.text || '';
            if (!text) return '';
            const urlPattern = /(https?:\/\/[^\s]+)/g;
            const parts = text.split(urlPattern);
            return parts.map(part => {
              if (urlPattern.test(part)) {
                return `<a href="${part}" target="_blank" rel="noopener noreferrer" style="color: ${isOwnMessage ? '#fff' : '#3b82f6'}; text-decoration: underline; word-break: break-all;">${part}</a>`;
              }
              return part;
            }).join('');
          })()}
                ${(() => {
            let meta = msg.meta;
            if (typeof meta === 'string') { try { meta = JSON.parse(meta); } catch (e) { meta = null; } }
            const isMediaRequest = meta && meta.type === 'media_request';
            const hasBucketPath = meta && meta.bucket_path;
            const hasMediaRequestId = meta && meta.media_request_id;
            if (isMediaRequest && hasBucketPath && hasMediaRequestId) {
              return `
                      <div style="margin-top: 0.75rem;">
                        <button
                          onclick="handleSubmitMediaRequest('${meta.media_request_id.replace(/'/g, "\\'")}', '${meta.bucket_path.replace(/'/g, "\\'")}')"
                          style="background: #ffffff; color: #f59e0b; border: 1px solid #f59e0b; padding: 0.5rem 1rem; border-radius: 0.5rem; cursor: pointer; font-weight: 600; font-size: 0.875rem; width: 100%; transition: all 0.2s;"
                          onmouseover="this.style.background='#fef3c7'; this.style.color='#d97706';"
                          onmouseout="this.style.background='#ffffff'; this.style.color='#f59e0b';"
                        >Submit Media</button>
                      </div>
                    `;
            }
            return '';
          })()}
              </div>
            `;
      })()}
          <div style="font-size: 0.75rem; color: #9ca3af; padding-left: 0.5rem; padding-right: 0.5rem;">${formatMessageTime(msg)}</div>
        </div>
      </div>
    `;
  }).join('');
};

// Render Chat Screen - Instagram-style two-panel layout
async function renderChatScreen() {
  // Check if user is CLIENT
  const userRole = currentProfile?.company_role || currentProfile?.role || 'USER';
  const isClient = userRole === 'CLIENT';

  // Ensure chats is initialized
  if (!chats || !Array.isArray(chats)) {
    chats = [];
  }

  // Store isClient in a way that's accessible in the template
  window.isClient = isClient;

  // For CLIENTs, only show chats they are part of (already filtered by loadChats)
  // Filter chats based on search query
  const searchQuery = chatSearchQuery || window.chatSearchQuery || '';
  const filteredChats = chats.filter(chat => {
    if (!searchQuery) return true;
    const query = searchQuery.toLowerCase();
    return (
      chat.title?.toLowerCase().includes(query) ||
      chat.last_message?.toLowerCase().includes(query) ||
      chat.sender_name?.toLowerCase().includes(query) ||
      chat.client_name?.toLowerCase().includes(query) || // Search by client name
      chat.client_company?.toLowerCase().includes(query) // Search by client company
    );
  });

  // Get selected chat details
  const selectedChat = chats.find(c => c.id === selectedChatId);

  // Get current user ID for participant filtering
  const currentUserId = currentUser?.id || currentProfile?.id;

  // Helper function to format participants list
  const formatParticipantsList = (chat) => {
    if (!chat || !chat.participants || chat.participants.length === 0) {
      return null;
    }

    // Include current user in participant list if not already there
    const allParticipants = [...chat.participants];
    const currentUserInList = allParticipants.find(p => (p.id || p.user_id) === currentUserId);

    if (!currentUserInList && currentUserId) {
      // Add current user to the list
      // Ensure teamMembers is initialized
      if (!teamMembers || !Array.isArray(teamMembers)) {
        teamMembers = [];
      }

      const currentUserProfile = teamMembers.find(m => m.id === currentUserId) ||
        (currentProfile ? {
          id: currentProfile.id,
          first_name: currentProfile.first_name || '',
          last_name: currentProfile.last_name || '',
          contact_id: null
        } : null);
      if (currentUserProfile) {
        allParticipants.push(currentUserProfile);
      }
    }

    return allParticipants.map(p => {
      const fullName = `${p.first_name || ''} ${p.last_name || ''}`.trim() || 'Unknown';
      const isClient = p.contact_id;
      const isCurrentUser = (p.id || p.user_id) === currentUserId;

      if (isClient) {
        return `
          <span
            onclick="event.stopPropagation(); openContactFromChat('${p.id || p.user_id}', '${p.contact_id || ''}')"
            style="
              color: #3b82f6;
              cursor: pointer;
              text-decoration: underline;
              font-weight: ${isCurrentUser ? '600' : '500'};
            "
            onmouseover="this.style.color='#2563eb'"
            onmouseout="this.style.color='#3b82f6'"
          >
            ${fullName}${isCurrentUser ? ' (You)' : ''}
          </span>
        `;
      } else {
        return `<span style="font-weight: ${isCurrentUser ? '600' : '400'};">${fullName}${isCurrentUser ? ' (You)' : ''}</span>`;
      }
    }).join(', ');
  };

  // Debug: Log selected chat and participants
  if (selectedChat) {
    console.log('🔍 Selected chat:', selectedChat.id);
    console.log('📝 Chat title:', selectedChat.title);
    console.log('📝 Chat custom_name:', selectedChat.custom_name);
    console.log('👥 Participants:', selectedChat.participants);
    console.log('👤 Current user ID:', currentUserId);
  }

  // Format date helper
  const formatChatDate = (dateStr) => {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    const now = new Date();
    const diffTime = Math.abs(now - date);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) {
      return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
    } else if (diffDays === 1) {
      return 'Yesterday';
    } else if (diffDays < 7) {
      return date.toLocaleDateString('en-US', { weekday: 'short' });
    } else {
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    }
  };

  // Format message time - show date if not today, otherwise just time
  // For scheduled messages that were sent, use sent_at or updated_at instead of created_at
  const formatMessageTime = (msg) => {
    // If msg is a string (old format), use it directly
    let dateStr;
    if (typeof msg === 'string') {
      dateStr = msg;
    } else if (msg && typeof msg === 'object') {
      // For scheduled messages that were sent, prefer sent_at or updated_at
      // If status is not 'scheduled' and updated_at exists and is different from created_at, use updated_at
      if (msg.status !== 'scheduled' && msg.updated_at && msg.updated_at !== msg.created_at) {
        dateStr = msg.updated_at;
      } else if (msg.sent_at) {
        dateStr = msg.sent_at;
      } else if (msg.updated_at) {
        dateStr = msg.updated_at;
      } else {
        dateStr = msg.created_at;
      }
    } else {
      return '';
    }

    if (!dateStr) return '';
    const date = new Date(dateStr);
    const now = new Date();

    // Check if same day
    const isToday = date.getDate() === now.getDate() &&
      date.getMonth() === now.getMonth() &&
      date.getFullYear() === now.getFullYear();

    if (isToday) {
      // Just show time for today
      return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
    } else {
      // Show date and time for other days
      const formattedDate = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined });
      const timeStr = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
      return `${formattedDate} ${timeStr}`;
    }
  };

  // Get avatar background color (matching native app ChatAvatar)
  const getAvatarBackgroundColor = (name) => {
    const colors = [
      '#EF4444', '#F97316', '#F59E0B', '#EAB308', '#84CC16',
      '#22C55E', '#10B981', '#14B8A6', '#06B6D4', '#3B82F6',
      '#6366F1', '#8B5CF6', '#A855F7', '#EC4899', '#F43F5E'
    ];

    if (!name || name.length === 0) {
      return colors[0];
    }

    const index = name.charCodeAt(0) % colors.length;
    return colors[index];
  };

  // Get avatar HTML (with image if available, otherwise initials) - matching native app structure
  const getAvatarHTML = (chat, size = 48) => {
    let avatarUrl = null;
    let initials = 'CH';
    let participant = null;

    if (chat.participants && chat.participants.length > 0) {
      // For individual chats, use the first participant (matching native app ChatAvatar logic)
      participant = chat.participants[0];
      initials = `${(participant.first_name || '').charAt(0)}${(participant.last_name || '').charAt(0)}`.toUpperCase() || 'CH';
      if (participant.avatar_path) {
        avatarUrl = getAvatarUrl(participant.avatar_path);
      }
    } else {
      initials = chat.title?.substring(0, 2).toUpperCase() || 'CH';
    }

    // Use color-coded background based on participant name (matching native app)
    const bgColor = participant
      ? getAvatarBackgroundColor(participant.first_name || participant.id)
      : (chat.id === selectedChatId ? '#f59e0b' : '#3b82f6');

    if (avatarUrl) {
      return `
        <img
          src="${avatarUrl}"
          alt="${initials}"
          style="
            width: ${size}px;
            height: ${size}px;
            border-radius: 50%;
            object-fit: cover;
          "
          onerror="
            this.style.display='none';
            const fallback = this.nextElementSibling;
            fallback.style.display='flex';
          "
        />
        <div style="
          display: none;
          width: ${size}px;
          height: ${size}px;
          border-radius: 50%;
          background: ${bgColor};
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 600;
          font-size: ${size * 0.4}px;
        ">${initials}</div>
      `;
    }

    return `
      <div style="
        width: ${size}px;
        height: ${size}px;
        border-radius: 50%;
        background: ${bgColor};
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 600;
        font-size: ${size * 0.4}px;
      ">${initials}</div>
    `;
  };

  // Get avatar initials (for backward compatibility)
  const getAvatarInitials = (chat) => {
    if (chat.participants && chat.participants.length > 0) {
      const firstParticipant = chat.participants[0];
      return `${(firstParticipant.first_name || '').charAt(0)}${(firstParticipant.last_name || '').charAt(0)}`.toUpperCase() || 'CH';
    }
    return chat.title?.substring(0, 2).toUpperCase() || 'CH';
  };

  return `
      <div style="
      display: flex;
      height: calc(100vh - 120px);
      background: #ffffff;
        border-radius: 0.75rem;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
      overflow: hidden;
      position: relative;
    ">
      <!-- Chat layout container -->
      <style>
        @media (max-width: 768px) {
          .chat-layout-container {
            overflow-x: auto !important;
            scroll-snap-type: x mandatory !important;
          }
          .chat-layout-inner {
            min-width: max-content !important;
          }
          .chat-left-panel {
            min-width: 300px !important;
            max-width: 100vw !important;
            scroll-snap-align: start !important;
          }
          .chat-right-panel {
            min-width: 100vw !important;
            scroll-snap-align: start !important;
          }
        }
      </style>
      <div class="chat-layout-container" style="
        display: flex;
        width: 100%;
        height: 100%;
        overflow-x: hidden;
        overflow-y: hidden;
      ">
      <div class="chat-layout-inner" style="display: flex; width: 100%; height: 100%;">
      <!-- Left Panel: Chat List -->
            <div class="chat-left-panel" style="
        width: 350px;
        min-width: 350px;
        border-right: 1px solid #e9ecef;
        display: flex;
        flex-direction: column;
        background: #ffffff;
        flex-shrink: 0;
      ">
        <!-- Chat List Header -->
        <div style="
          padding: 1rem;
          border-bottom: 1px solid #e9ecef;
          background: #ffffff;
        ">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
            <h2 style="
              margin: 0;
              font-size: 1.25rem;
              font-weight: 700;
              color: #2c3e50;
            ">Chats</h2>
            <button onclick="showAddChatModal()" style="
              background: #f59e0b;
              color: white;
              border: none;
              width: 32px;
              height: 32px;
              border-radius: 50%;
              cursor: pointer;
              font-size: 1.25rem;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: 600;
              transition: background-color 0.2s;
            "
            onmouseover="this.style.background='#d97706'"
            onmouseout="this.style.background='#f59e0b'"
            title="Add Chat"
            >+</button>
          </div>
          
          <!-- Search Bar -->
          <input
            type="text"
            id="chat-search-input"
            placeholder="Search chats..."
            value="${searchQuery}"
            oninput="const inputValue = this.value; const cursorPos = this.selectionStart; chatSearchQuery = inputValue; window.chatSearchQuery = inputValue; renderPMTool(); setTimeout(() => { const searchInput = document.getElementById('chat-search-input'); if (searchInput && searchInput.value !== inputValue) { searchInput.value = inputValue; } if (searchInput) { searchInput.focus(); const pos = Math.min(cursorPos, inputValue.length); searchInput.setSelectionRange(pos, pos); } }, 0);"
            style="
              width: 100%;
              padding: 0.625rem 0.75rem;
              border: 1px solid #e9ecef;
              border-radius: 0.5rem;
              font-size: 0.875rem;
              box-sizing: border-box;
              margin-bottom: 0.75rem;
            "
          />
          
          <!-- Archive Toggle -->
          <div style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0.25rem 0;
          ">
            <span style="
              font-size: 0.75rem;
              color: #6B7280;
              font-weight: 500;
            ">Archived</span>
            <label style="
              position: relative;
              display: inline-block;
              width: 44px;
              height: 24px;
              cursor: pointer;
            ">
              <input
                type="checkbox"
                ${showArchivedChats ? 'checked' : ''}
                onchange="toggleShowArchivedChats()"
                style="
                  opacity: 0;
                  width: 0;
                  height: 0;
                "
              />
              <span style="
                position: absolute;
                cursor: pointer;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-color: ${showArchivedChats ? '#EF4444' : '#D1D5DB'};
                transition: 0.3s;
                border-radius: 24px;
              "></span>
              <span style="
                position: absolute;
                content: '';
                height: 18px;
                width: 18px;
                left: ${showArchivedChats ? '22px' : '3px'};
                bottom: 3px;
                background-color: white;
                transition: 0.3s;
                border-radius: 50%;
                box-shadow: 0 2px 4px rgba(0,0,0,0.2);
              "></span>
            </label>
          </div>
        </div>

        <!-- Chat List -->
        <div style="
          flex: 1;
          overflow-y: auto;
          background: #ffffff;
        ">
          ${filteredChats.length === 0 ? `
            <div style="
              padding: 3rem 1.5rem;
              text-align: center;
              color: #9ca3af;
              font-size: 0.875rem;
            ">
              ${searchQuery ? 'No chats found' : 'No chats yet'}
            </div>
          ` : filteredChats.map(chat => {
    const isSelected = chat.id === selectedChatId;
    const unreadCount = chatUnreadCounts[chat.id] || 0;
    const displayTitle = chat.custom_name || chat.title || 'Untitled Chat';

    return `
              <div
                onclick="selectChat('${chat.id}')"
                style="
                  padding: 0.75rem 1rem;
                  border-bottom: 1px solid #f3f4f6;
              cursor: pointer;
              transition: background-color 0.2s;
                  background: ${isSelected ? '#f8f9fa' : '#ffffff'};
                  display: flex;
                  align-items: center;
                  gap: 0.75rem;
                  position: relative;
                "
                onmouseover="if (!${isSelected}) this.style.background='#f8f9fa'"
                onmouseout="if (!${isSelected}) this.style.background='${isSelected ? '#f8f9fa' : '#ffffff'}'"
              >
                ${unreadCount > 0 ? `
                  <div style="
                    position: absolute;
                    top: 8px;
                    right: 8px;
                    background: #dc2626;
                    color: white;
                    border-radius: 50%;
                    width: 20px;
                    height: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 0.625rem;
                    font-weight: 700;
                    border: 2px solid white;
                    z-index: 10;
                  ">${unreadCount > 9 ? '9+' : unreadCount}</div>
                ` : ''}
                
                <!-- Participant Avatars -->
                ${chat.participants && Array.isArray(chat.participants) && chat.participants.length > 0 ? `
                  <div style="
                    display: flex;
                    align-items: center;
                    flex-shrink: 0;
                    margin-right: 0.5rem;
                  ">
                    ${(() => {
          try {
            const maxVisible = 3;
            const participantsToShow = (chat.participants || []).slice(0, maxVisible);
            const remainingCount = Math.max(0, (chat.participants || []).length - maxVisible);
            const avatarSize = 32;
            const overlapOffset = -12;

            const avatarHTML = participantsToShow.map((p, index) => {
              if (!p) return '';
              const initials = `${(p.first_name || '').charAt(0)}${(p.last_name || '').charAt(0)}`.toUpperCase() || 'U';
              const avatarUrl = p.avatar_path ? getAvatarUrl(p.avatar_path) : null;
              const bgColor = getAvatarBackgroundColor(p.first_name || p.id);
              const zIndex = maxVisible - index;
              const marginLeft = index > 0 ? overlapOffset : 0;
              const displayStyle = avatarUrl ? 'display: none;' : 'display: flex;';

              return `
                            <div style="
                              position: relative;
                              margin-left: ${marginLeft}px;
                              z-index: ${zIndex};
                              width: ${avatarSize}px;
                              height: ${avatarSize}px;
                              flex-shrink: 0;
                            ">
                              ${avatarUrl ? `
                                <img
                                  src="${avatarUrl}"
                                  alt="${initials}"
                                  style="
                                    width: ${avatarSize}px;
                                    height: ${avatarSize}px;
                                    border-radius: 50%;
                                    object-fit: cover;
                                    border: 2px solid white;
                                    box-shadow: 0 0 0 1px rgba(0,0,0,0.1);
                                  "
                                  onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';"
                                />
                              ` : ''}
                              <div style="
                                ${displayStyle}
                                width: ${avatarSize}px;
                                height: ${avatarSize}px;
                                border-radius: 50%;
                                background: ${bgColor};
                                color: white;
                                align-items: center;
                                justify-content: center;
                                font-weight: 600;
                                font-size: ${avatarSize * 0.4}px;
                                border: 2px solid white;
                                box-shadow: 0 0 0 1px rgba(0,0,0,0.1);
                              ">${initials}</div>
                            </div>
                          `;
            }).join('');

            const moreBadgeHTML = remainingCount > 0 ?
              '<div style="position: relative; margin-left: ' + overlapOffset + 'px; z-index: 1; width: ' + avatarSize + 'px; height: ' + avatarSize + 'px; flex-shrink: 0; border-radius: 50%; background: #E5E7EB; color: #6B7280; display: flex; align-items: center; justify-content: center; font-weight: 600; font-size: ' + (avatarSize * 0.35) + 'px; border: 2px solid white; box-shadow: 0 0 0 1px rgba(0,0,0,0.1);">+' + remainingCount + '</div>'
              : '';

            return avatarHTML + moreBadgeHTML;
          } catch (e) {
            console.error('Error rendering participant avatars:', e);
            return '';
          }
        })()}
                  </div>
                ` : ''}
                
                <!-- Chat Info -->
                <div style="flex: 1; min-width: 0;">
                  <div style="
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 0.25rem;
                  ">
                    <div style="
                      font-weight: ${unreadCount > 0 ? '700' : '600'};
                      color: #2c3e50;
                      font-size: 0.875rem;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    ">${displayTitle}</div>
                    ${(() => {
        // Format last message time
        const lastActivity = chat.last_activity_at || chat.created_at;
        if (!lastActivity) return '<span style="font-size: 0.75rem; color: #9ca3af;">-</span>';

        const lastDate = new Date(lastActivity);
        const now = new Date();

        // Check if it's today by comparing date components
        const isToday = lastDate.getDate() === now.getDate() &&
          lastDate.getMonth() === now.getMonth() &&
          lastDate.getFullYear() === now.getFullYear();

        let timeDisplay = '';
        if (isToday) {
          timeDisplay = 'Today';
        } else {
          // Calculate days difference - use date comparison to handle day boundaries correctly
          const lastDateOnly = new Date(lastDate.getFullYear(), lastDate.getMonth(), lastDate.getDate());
          const nowDateOnly = new Date(now.getFullYear(), now.getMonth(), now.getDate());
          const diffTime = nowDateOnly - lastDateOnly;
          const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
          timeDisplay = `${diffDays}d`;
        }

        return `<span style="
                        font-size: 0.75rem;
                        color: #9ca3af;
                        flex-shrink: 0;
                        margin-left: 0.5rem;
                      ">${timeDisplay}</span>`;
      })()}
                  </div>
                  ${chat.is_client_chat ? `
                    <div style="
                      font-size: 0.75rem;
                      color: #6c757d;
                      margin-bottom: 0.125rem;
                      display: flex;
                      align-items: center;
                      gap: 0.25rem;
                    ">
                      <span>📁</span>
                      <span>${chat.client_company || 'Client account'}</span>
                    </div>
                  ` : ''}
                  <div style="
                    font-size: 0.8125rem;
                    color: #6c757d;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                  ">${chat.sender_name ? `${chat.sender_name}: ` : ''}${chat.last_message || 'No messages'}</div>
                </div>
              </div>
            `;
  }).join('')}
        </div>
      </div>

      <!-- Right Panel: Selected Chat View -->
      <div class="chat-right-panel" style="
        flex: 1;
        min-width: 0;
        display: flex;
        flex-direction: column;
        background: #ffffff;
        overflow-y: auto;
        overflow-x: hidden;
      ">
        ${selectedChat ? `
          <!-- Chat Header -->
          <div style="
            padding: 1rem 1.5rem;
            border-bottom: 1px solid #e9ecef;
            background: #ffffff;
          ">
            <!-- Chat Title and Participants -->
            <div style="margin-bottom: 0.75rem;">
              <div style="flex: 1;">
                <div style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  margin-bottom: 0.5rem;
                ">
                  <div style="
                    font-weight: 600;
                    color: #2c3e50;
                    font-size: 0.9375rem;
                  ">${selectedChat.custom_name || selectedChat.title || 'Untitled Chat'}</div>
                  ${selectedChat.last_activity_at || selectedChat.created_at ? `
                    <span style="
                      font-size: 0.75rem;
                      color: #9ca3af;
                      margin-left: 0.5rem;
                    ">${formatChatDate(selectedChat.last_activity_at || selectedChat.created_at)}</span>
                  ` : ''}
                </div>
                ${selectedChat.participants && selectedChat.participants.length > 0 ? `
                  <div style="
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    gap: 0.5rem;
                    margin-bottom: 0.25rem;
                  ">
                    ${selectedChat.participants.map(p => {
    const fullName = `${p.first_name || ''} ${p.last_name || ''}`.trim() || 'Unknown User';
    const initials = `${(p.first_name || '').charAt(0)}${(p.last_name || '').charAt(0)}`.toUpperCase() || 'U';
    const avatarUrl = p.avatar_path ? getAvatarUrl(p.avatar_path) : null;
    const bgColor = getAvatarBackgroundColor(p.first_name || p.id);
    const uniqueId = `participant-${p.id || Math.random()}`;
    return `
                        <div 
                          style="position: relative; cursor: pointer;"
                          title="${fullName}"
                          onmouseenter="
                            const tooltip = document.getElementById('${uniqueId}-tooltip');
                            if (tooltip) tooltip.style.display = 'block';
                          "
                          onmouseleave="
                            const tooltip = document.getElementById('${uniqueId}-tooltip');
                            if (tooltip) tooltip.style.display = 'none';
                          "
                        >
                          ${avatarUrl ? `
                            <img
                              src="${avatarUrl}"
                              alt="${initials}"
                              style="
                                width: 32px;
                                height: 32px;
                                border-radius: 50%;
                                object-fit: cover;
                                border: 2px solid white;
                                box-shadow: 0 0 0 1px rgba(0,0,0,0.1);
                              "
                              onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';"
                            />
                          ` : ''}
                          <div style="
                            ${avatarUrl ? 'display: none;' : 'display: flex;'}
                            width: 32px;
                            height: 32px;
                            border-radius: 50%;
                            background: ${bgColor};
                            color: white;
                            align-items: center;
                            justify-content: center;
                            font-weight: 600;
                            font-size: 0.75rem;
                            border: 2px solid white;
                            box-shadow: 0 0 0 1px rgba(0,0,0,0.1);
                          ">${initials}</div>
                          <div
                            id="${uniqueId}-tooltip"
                            style="
                              display: none;
                              position: absolute;
                              bottom: 100%;
                              left: 50%;
                              transform: translateX(-50%);
                              margin-bottom: 0.5rem;
                              padding: 0.375rem 0.625rem;
                              background: #1f2937;
                              color: white;
                              font-size: 0.75rem;
                              font-weight: 500;
                              border-radius: 0.375rem;
                              white-space: nowrap;
                              z-index: 1000;
                              pointer-events: none;
                              box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
                            "
                          >${fullName}</div>
                        </div>
                      `;
  }).join('')}
                  </div>
                ` : ''}
              </div>
            </div>
            
            <!-- Action Buttons -->
            <div style="display: flex; gap: 0.5rem; align-items: center;">
              ${(() => {
        const canRequestMedia = () => {
          if (!currentUser) return false;
          // Only HH admins can request media
          return (currentUser.is_hh_admin === true) || (currentProfile?.is_hh_admin === true);
        };
        return canRequestMedia() ? `
                  <button
                    onclick="openMediaRequestModal();"
                    style="
                      background: #f59e0b;
                      color: white;
                      border: none;
                      padding: 0.5rem 0.75rem;
                      border-radius: 0.375rem;
                      cursor: pointer;
                      font-weight: 600;
                      font-size: 0.8125rem;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      gap: 0.375rem;
                    "
                  >
                    Send Media Request
                  </button>
                ` : '';
      })()}
              ${!isClient ? `
              <button
                onclick="openScheduleMessageModal();"
                style="
                  background: #f59e0b;
                  color: white;
                  border: none;
                  padding: 0.5rem 0.75rem;
                  border-radius: 0.375rem;
                  cursor: pointer;
                  font-weight: 600;
                  font-size: 0.8125rem;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  gap: 0.375rem;
                "
              >
                <span>Schedule A Chat</span>
              </button>
              ` : ''}
              ${selectedChatId ? `
              <button
                onclick="window.refreshChatMessages();"
                style="
                  background: #f59e0b;
                  color: white;
                  border: none;
                  padding: 0.5rem 0.75rem;
                  border-radius: 0.375rem;
                  cursor: pointer;
                  font-weight: 600;
                  font-size: 0.8125rem;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  gap: 0.375rem;
                "
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: block;">
                  <path d="M4 12a8 8 0 018-8V2l4 4-4 4V6a6 6 0 106 6h2a8 8 0 01-16 0z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
                </svg>
              </button>
              ` : ''}
              ${scheduledMessages.length > 0 ? `
                <button
                  onclick="toggleScheduledMessagesView();"
                  style="
                    background: transparent;
                    color: #f59e0b;
                    border: 1px solid #f59e0b;
                    padding: 0.5rem 0.75rem;
                    border-radius: 0.375rem;
                    cursor: pointer;
                    font-weight: 600;
                    font-size: 0.8125rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 0.375rem;
                  "
                >
                  <span>View Scheduled</span>
                </button>
              ` : ''}
            </div>
            
            ${scheduledMessages.length > 0 && showScheduledMessagesView ? `
              <!-- Scheduled Messages Section -->
              <div style="
                padding: 1rem;
                background: #fef3c7;
                border-top: 1px solid #fde68a;
                border-bottom: 1px solid #fde68a;
              ">
                <div style="
                  font-size: 0.875rem;
                  font-weight: 600;
                  color: #92400e;
                  margin-bottom: 0.75rem;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  gap: 0.5rem;
                ">
                  <span>Scheduled Messages (${scheduledMessages.length})</span>
                  ${(() => {
          const canRequestMedia = () => {
            if (!currentUser) return false;
            // Only HH admins can request media
            return (currentUser.is_hh_admin === true) || (currentProfile?.is_hh_admin === true);
          };
          return canRequestMedia() ? `
                      <button
                        onclick="openMediaRequestModal();"
                        style="
                          background: #f59e0b;
                          color: white;
                          border: none;
                          padding: 0.5rem 0.75rem;
                          border-radius: 0.375rem;
                          cursor: pointer;
                          font-weight: 600;
                          font-size: 0.8125rem;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          gap: 0.375rem;
                        "
                      >
                        Send Media Request
                      </button>
                    ` : '';
        })()}
                </div>
                <div style="display: flex; flex-direction: column; gap: 0.5rem;">
                  ${scheduledMessages.map(msg => {
          const scheduledDate = new Date(msg.scheduled_at);
          const dateStr = scheduledDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: scheduledDate.getFullYear() !== new Date().getFullYear() ? 'numeric' : undefined });
          const timeStr = scheduledDate.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
          return `
                      <div style="
                        background: #ffffff;
                        border: 1px solid #fde68a;
                        border-radius: 0.5rem;
                        padding: 0.75rem;
                        display: flex;
                        justify-content: space-between;
                        align-items: flex-start;
                        gap: 1rem;
                      ">
                        <div style="flex: 1;">
                          <div style="
                            font-size: 0.875rem;
                            color: #2c3e50;
                            margin-bottom: 0.25rem;
                            font-weight: 500;
                          ">${msg.text || ''}</div>
                          <div style="
                            font-size: 0.75rem;
                            color: #92400e;
                          ">Scheduled for: ${dateStr} at ${timeStr}</div>
                        </div>
                        <div style="display: flex; gap: 0.5rem; align-items: center;">
                          <button
                            onclick="cancelScheduledMessage('${msg.id}')"
                            style="
                              background: transparent;
                              border: 1px solid #dc2626;
                              color: #dc2626;
                              cursor: pointer;
                              padding: 0.375rem 0.75rem;
                              font-size: 0.75rem;
                              font-weight: 500;
                              border-radius: 0.375rem;
                            "
                            onmouseover="this.style.background='#fee2e2'"
                            onmouseout="this.style.background='transparent'"
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    `;
        }).join('')}
                </div>
              </div>
            ` : ''}
          </div>

          <!-- Messages Area -->
          <div id="chat-messages-container" style="
            flex: 1;
            overflow-y: auto;
            padding: 1rem;
            background: #f8f9fa;
            display: flex;
            flex-direction: column;
            gap: 0.75rem;
          ">
            ${window.renderChatMessagesList ? window.renderChatMessagesList(chatMessages) : 'Loading messages...'}
          </div>

          <!-- Message Input -->
          <div style="
            padding: 1rem 1.5rem;
            border-top: 1px solid #e9ecef;
            background: #ffffff;
          ">
            <div style="display: flex; gap: 0.25rem; align-items: center;">
              <button
                onclick="document.getElementById('chat-file-input').click()"
                style="
                  background: #f59e0b;
                  border: none;
                  color: white;
                  padding: 0.625rem;
                  border-radius: 0.375rem;
                  cursor: pointer;
                  font-size: 0.875rem;
                  font-weight: 500;
                  flex-shrink: 0;
                "
                title="Attach File"
              >
                Attach
              </button>
              ${!isClient ? `
              <button
                onclick="openManageChatModal()"
                style="
                  background: #f59e0b;
                  border: none;
                  color: white;
                  padding: 0.625rem;
                  border-radius: 0.375rem;
                  cursor: pointer;
                  font-size: 0.875rem;
                  font-weight: 500;
                  flex-shrink: 0;
                "
                title="Manage Chat"
              >
                Settings
              </button>
              ` : ''}
              <input
                type="file"
                id="chat-file-input"
                style="display: none;"
                accept="image/*,application/pdf"
                onchange="handleChatFileUpload(event)"
              />
              <input
                type="text"
                id="chat-message-input"
                placeholder="Type a message..."
                onkeypress="if (event.key === 'Enter') { sendChatMessage(); }"
                style="
                  flex: 1;
                  padding: 0.75rem 1rem;
                  border: 1px solid #e9ecef;
                  border-radius: 1.5rem;
                  font-size: 0.875rem;
                  box-sizing: border-box;
                  outline: none;
                "
                onfocus="this.style.borderColor='#f59e0b'"
                onblur="this.style.borderColor='#e9ecef'"
              />
              <button
                onclick="sendChatMessage()"
                style="
                  background: #f59e0b;
                  color: white;
                  border: none;
                  padding: 0.75rem 1rem;
                  border-radius: 1.5rem;
                  cursor: pointer;
                  font-weight: 600;
                  font-size: 0.875rem;
                  flex-shrink: 0;
                "
                title="Send"
              >
                ➤
              </button>
            </div>
          </div>
        ` : `
          <!-- Empty State -->
          <div style="
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            color: #9ca3af;
            padding: 2rem;
          ">
            <div style="font-size: 3rem; margin-bottom: 1rem;">💬</div>
            <div style="font-size: 1.125rem; font-weight: 600; color: #6c757d; margin-bottom: 0.5rem;">
              Select a chat to start messaging
            </div>
            <div style="font-size: 0.875rem;">
              Choose a conversation from the list to view messages
            </div>
          </div>
        `}
      </div>
      </div>
      </div>
    </div>
    ${showManageChatModal ? renderManageChatModal() : ''}
    ${showAddChatModal ? renderAddChatModal() : ''}
    ${showScheduleMessageModal ? renderScheduleMessageModal() : ''}
    ${showMediaRequestModal ? renderMediaRequestModal() : ''}
    ${showImageViewerModal ? renderImageViewerModal() : ''}
  `;
}

// Render Manage Chat Modal
function renderManageChatModal() {
  if (manageChatData.showDeleteConfirm) {
    return `
      <div id="manage-chat-modal" onclick="event.stopPropagation()" style="
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;
      ">
        <div style="
          background: #ffffff;
          border-radius: 1rem;
          padding: 2rem;
          max-width: 500px;
          width: 90%;
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
        ">
          <h2 style="margin: 0 0 1rem 0; font-size: 1.5rem; font-weight: 700; color: #2c3e50;">
            Delete Chat
          </h2>
          <p style="margin: 0 0 1.5rem 0; color: #6c757d; font-size: 0.875rem;">
            This action cannot be undone. All messages and data will be permanently deleted.
          </p>
          <p style="margin: 0 0 1rem 0; color: #dc2626; font-size: 0.875rem; font-weight: 600;">
            <p style="margin-bottom: 0.75rem; font-weight: 600; color: #DC2626;">
              Are you sure you want to PERMANENTLY delete this chat?
            </p>
            <p style="margin-bottom: 0.75rem; color: #6B7280; font-size: 0.875rem;">
              This action cannot be undone and the chat will be gone forever for all participants.
            </p>
            <p style="margin-bottom: 0.75rem; color: #1F2937; font-weight: 600;">
              Type DELETE in capital letters to confirm:
            </p>
          <input
            type="text"
            id="delete-confirm-input"
            value="${manageChatData.deleteConfirmText}"
            oninput="manageChatData.deleteConfirmText = this.value;"
            style="
              width: 100%;
              padding: 0.75rem;
              border: 1px solid #e9ecef;
              border-radius: 0.5rem;
              font-size: 0.875rem;
              margin-bottom: 1.5rem;
              box-sizing: border-box;
            "
            placeholder="DELETE"
          />
          <div style="display: flex; gap: 0.75rem; justify-content: flex-end;">
            <button
              onclick="manageChatData.showDeleteConfirm = false; manageChatData.deleteConfirmText = ''; renderPMTool();"
              style="
                background: transparent;
                color: #6c757d;
                border: 1px solid #e9ecef;
                padding: 0.625rem 1.25rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-weight: 600;
                font-size: 0.875rem;
              "
            >
              Cancel
            </button>
            <button
              onclick="deleteChat()"
              style="
                background: #dc2626;
                color: white;
                border: none;
                padding: 0.625rem 1.25rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-weight: 600;
                font-size: 0.875rem;
              "
            >
              Yes, Delete
            </button>
          </div>
        </div>
      </div>
    `;
  }

  return `
    <div id="manage-chat-modal" onclick="event.stopPropagation()" style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1000;
    ">
      <div style="
        background: #ffffff;
        border-radius: 1rem;
        padding: 0;
        max-width: 600px;
        width: 90%;
        max-height: 85vh;
        overflow-y: auto;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
      ">
        <!-- Header -->
        <div style="
          padding: 1rem 1.5rem;
          border-bottom: 1px solid #e9ecef;
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: sticky;
          top: 0;
          background: #ffffff;
          z-index: 10;
        ">
          <button
            onclick="closeManageChatModal()"
            style="
              background: transparent;
              border: none;
              color: #6c757d;
              cursor: pointer;
              font-size: 0.875rem;
              font-weight: 500;
              padding: 0.5rem;
            "
          >
            Cancel
          </button>
          <h2 style="margin: 0; font-size: 1.125rem; font-weight: 700; color: #2c3e50;">
            Manage Chat
          </h2>
          <button
            onclick="saveManageChat()"
            style="
              background: #f59e0b;
              color: white;
              border: none;
              padding: 0.5rem 1rem;
              border-radius: 0.375rem;
              cursor: pointer;
              font-weight: 600;
              font-size: 0.875rem;
            "
          >
            Save
          </button>
        </div>
        
        <!-- Content -->
        <div style="padding: 1.5rem;">
          <!-- Chat Name -->
          <div style="margin-bottom: 1.5rem;">
            <label style="
              display: block;
              font-weight: 700;
              color: #2c3e50;
              margin-bottom: 0.5rem;
              font-size: 0.9375rem;
            ">Chat Name</label>
            <input
              type="text"
              id="chat-name-input"
              value="${manageChatData.chatName || ''}"
              oninput="if (window.manageChatData) { window.manageChatData.chatName = this.value; }"
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid #e9ecef;
                border-radius: 0.5rem;
                font-size: 0.875rem;
                box-sizing: border-box;
              "
              placeholder="Enter chat name"
            />
          </div>
          
          <!-- Project Assignment -->
          <div style="margin-bottom: 1.5rem;">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.5rem;">
              <label style="
                font-weight: 700;
                color: #2c3e50;
                font-size: 0.9375rem;
              ">Project Assignment</label>
              <button
                onclick="toggleCreateProjectInChat()"
                style="
                  background: #f59e0b;
                  color: white;
                  border: none;
                  padding: 0.375rem 0.75rem;
                  border-radius: 0.375rem;
                  cursor: pointer;
                  font-weight: 600;
                  font-size: 0.8125rem;
                "
              >
                ${manageChatData.showCreateProject ? 'Select Existing' : '+ Create New'}
              </button>
            </div>
            
            ${manageChatData.showCreateProject ? `
              <input
                type="text"
                id="new-project-name-input"
                value="${manageChatData.newProjectName}"
                oninput="manageChatData.newProjectName = this.value;"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e9ecef;
                  border-radius: 0.5rem;
                  font-size: 0.875rem;
                  box-sizing: border-box;
                "
                placeholder="Enter project name"
              />
            ` : `
              <div style="
                max-height: 200px;
                overflow-y: auto;
                border: 1px solid #e9ecef;
                border-radius: 0.5rem;
              ">
                ${manageChatData.availableProjects.length === 0 ? `
                  <div style="padding: 1rem; text-align: center; color: #9ca3af; font-size: 0.875rem;">
                    No projects available
                  </div>
                ` : manageChatData.availableProjects.map(project => {
    const isSelected = manageChatData.selectedProject === project.id;
    return `
                    <div
                      onclick="manageChatData.selectedProject = ${isSelected ? 'null' : `'${project.id}'`}; renderPMTool();"
                      style="
                        padding: 0.75rem 1rem;
                        border-bottom: 1px solid #f3f4f6;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        background: ${isSelected ? '#fef3c7' : '#ffffff'};
                      "
                      onmouseover="this.style.background='${isSelected ? '#fef3c7' : '#f8f9fa'}'"
                      onmouseout="this.style.background='${isSelected ? '#fef3c7' : '#ffffff'}'"
                    >
                      <div style="display: flex; align-items: center; gap: 0.5rem;">
                        <span>📁</span>
                        <span style="color: #2c3e50; font-size: 0.875rem;">${project.name}</span>
                      </div>
                      ${isSelected ? '<span style="color: #f59e0b; font-weight: 600;">✓</span>' : ''}
                    </div>
                  `;
  }).join('')}
              </div>
            `}
          </div>
          
          <!-- Participants -->
          <div style="margin-bottom: 1.5rem;">
            <label style="
              display: block;
              font-weight: 700;
              color: #2c3e50;
              margin-bottom: 0.5rem;
              font-size: 0.9375rem;
            ">Participants (${manageChatData.participants.length})</label>
            <div style="
              max-height: 300px;
              overflow-y: auto;
              border: 1px solid #e9ecef;
              border-radius: 0.5rem;
            ">
              ${manageChatData.availableUsers.length === 0 ? `
                <div style="padding: 1rem; text-align: center; color: #9ca3af; font-size: 0.875rem;">
                  No users available
                </div>
              ` : manageChatData.availableUsers.map(user => {
    // Normalize IDs for comparison - ensure both id and user_id are strings
    const userId = String(user.id || user.user_id || '');
    const userUserId = String(user.user_id || user.id || '');

    // Check if user is a participant by comparing both id and user_id
    const isParticipant = manageChatData.participants.some(p => {
      const pId = String(p.id || '');
      const pUserId = String(p.user_id || '');
      // Match if either id matches id, or user_id matches user_id, or cross-match
      return (pId === userId || pId === userUserId ||
        pUserId === userId || pUserId === userUserId);
    });

    const initials = `${(user.first_name || '').charAt(0)}${(user.last_name || '').charAt(0)}`.toUpperCase() || 'U';
    const fullName = `${user.first_name || ''} ${user.last_name || ''}`.trim() || 'Unknown';
    // Get role from company_role (from company_members) if available, otherwise fall back to role
    const role = user.company_role || user.role || 'USER';

    // Use user_id if available, otherwise use id - ensure it's a string
    const userIdentifier = String(user.user_id || user.id);

    return `
                  <div
                    onclick="toggleChatParticipant('${userIdentifier}')"
                    style="
                      padding: 0.75rem 1rem;
                      border-bottom: 1px solid #f3f4f6;
                      cursor: pointer;
                      display: flex;
                      align-items: center;
                      justify-content: space-between;
                      background: ${isParticipant ? '#fef3c7' : '#ffffff'};
                    "
                    onmouseover="this.style.background='${isParticipant ? '#fef3c7' : '#f8f9fa'}'"
                    onmouseout="this.style.background='${isParticipant ? '#fef3c7' : '#ffffff'}'"
                  >
                    <div style="display: flex; align-items: center; gap: 0.75rem;">
                      <div style="
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                        background: ${role === 'CLIENT' ? '#3b82f6' : '#6b7280'};
                        color: white;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-weight: 600;
                        font-size: 0.875rem;
                      ">
                        ${initials}
                      </div>
                      <div>
                        <div style="color: #2c3e50; font-size: 0.875rem; font-weight: 500;">
                          ${fullName}
                        </div>
                        <div style="color: #6c757d; font-size: 0.75rem;">
                          ${role}
                        </div>
                      </div>
                    </div>
                    <button
                      onclick="event.stopPropagation(); toggleChatParticipant('${userIdentifier}')"
                      style="
                        background: ${isParticipant ? '#dc2626' : '#f59e0b'};
                        color: white;
                        border: none;
                        width: 32px;
                        height: 32px;
                        border-radius: 50%;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-size: 1rem;
                        font-weight: 600;
                      "
                    >
                      ${isParticipant ? '−' : '+'}
                    </button>
                  </div>
                `;
  }).join('')}
            </div>
          </div>
          
          <!-- Delete Button -->
          ${(() => {
      // Only owners can delete chats completely
      const userRole = currentProfile?.company_role || currentProfile?.role || 'USER';
      const canDelete = userRole === 'OWNER';
      const isArchived = manageChatData.isArchived || false;

      return `
              <div style="border-top: 1px solid #e9ecef; padding-top: 1rem; display: flex; flex-direction: column; gap: 1rem;">
                <!-- Archive Toggle -->
                <div style="display: flex; align-items: center; justify-content: space-between; padding: 0.75rem 1rem; background: ${isArchived ? '#FEE2E2' : '#F3F4F6'}; border-radius: 0.5rem; border: 1px solid ${isArchived ? '#EF4444' : '#E5E7EB'};">
                  <div style="display: flex; align-items: center; gap: 0.75rem;">
                    <span style="font-size: 1.125rem;">${isArchived ? '📦' : '📦'}</span>
                    <div>
                      <div style="font-weight: 600; font-size: 0.875rem; color: ${isArchived ? '#EF4444' : '#6B7280'};">
                        ${isArchived ? 'Archived' : 'Not Archived'}
                      </div>
                      <div style="font-size: 0.75rem; color: #6c757d; margin-top: 0.125rem;">
                        ${isArchived ? 'Chat is hidden from your main list' : 'Chat is visible in your main list'}
                      </div>
                    </div>
                  </div>
                  <label style="position: relative; display: inline-block; width: 44px; height: 24px; cursor: pointer;">
                    <input
                      type="checkbox"
                      ${isArchived ? 'checked' : ''}
                      onchange="toggleArchiveChatInModal()"
                      style="opacity: 0; width: 0; height: 0;"
                    />
                    <span style="position: absolute; cursor: pointer; top: 0; left: 0; right: 0; bottom: 0; background-color: ${isArchived ? '#EF4444' : '#D1D5DB'}; transition: 0.3s; border-radius: 24px;"></span>
                    <span style="position: absolute; height: 18px; width: 18px; left: ${isArchived ? '22px' : '3px'}; bottom: 3px; background-color: white; transition: 0.3s; border-radius: 50%; box-shadow: 0 2px 4px rgba(0,0,0,0.2);"></span>
                  </label>
                </div>
                
                ${canDelete ? `
                <!-- Delete Button - Only for Owners -->
                <div>
                  <button
                    onclick="showDeleteChatConfirm()"
                    style="
                      width: 100%;
                      background: #dc2626;
                      color: white;
                      border: none;
                      padding: 0.75rem 1rem;
                      border-radius: 0.5rem;
                      cursor: pointer;
                      font-weight: 600;
                      font-size: 0.875rem;
                    "
                  >
                    Delete Chat Forever
                  </button>
                  <p style="
                    margin-top: 0.5rem;
                    font-size: 0.75rem;
                    color: #dc2626;
                    text-align: center;
                    font-weight: 600;
                  ">
                    This will permanently delete the chat for all users. This action cannot be undone.
                  </p>
                </div>
                ` : ''}
              </div>
            `;
    })()}
        </div>
      </div>
    </div>
  `;
}

// Render Profile Screen
// Check if user is manager or owner
function isManagerOrOwner() {
  if (!currentUser && !currentProfile) return false;

  const profile = currentProfile || currentUser;

  // HH Admins are considered managers/owners
  if (profile.is_hh_admin) return true;

  // Check company_role from company_members table
  const companyRole = profile.company_role;

  // Only OWNER and MANAGER
  return companyRole === 'OWNER' || companyRole === 'MANAGER';
}

// Show add chat modal
window.showAddChatModal = async function () {
  addChatData = {
    chatName: '',
    selectedProject: null,
    selectedParticipants: [],
    participantSearchQuery: '',
    projectSearchQuery: '',
    availableProjects: [],
    availableHHUsers: [], // HH team members (only loaded for HH clients)
    availableHHClientUsers: [], // HH client company owners/admins (only loaded for HH admins)
    availableLinkedClientProfiles: [], // Client profiles from linked companies (via contact_companies)
    isLoading: true, // NEW: Loading state for immediate feedback
    mergedParticipants: [] // Pre-merged participants list
  };

  // Show modal IMMEDIATELY with loading state (instant feedback)
  window.addChatData = addChatData;
  showAddChatModal = true;
  renderPMTool();

  // Get company ID - try currentCompany first, then fallback to company_members if needed
  let companyIdForChat = currentCompany?.id;
  if (!companyIdForChat && currentProfile?.company_members && currentProfile.company_members.length > 0) {
    // If currentCompany is not set, get it from company_members
    companyIdForChat = currentProfile.company_members[0].company_id;
    console.log('⚠️ currentCompany not set, using company from company_members:', companyIdForChat);
  }

  // Load all data asynchronously (modal already visible with loading state)
  if (companyIdForChat) {
    try {
      // Run projects and client profiles RPC in parallel (independent calls)
      const [projectsResult, clientProfilesResult] = await Promise.all([
        supabase
          .from('projects')
          .select(`
            id,
            name,
            contact_id,
            contact:contacts!projects_contact_id_fkey(
              id,
              first_name,
              last_name,
              company_name
            )
          `)
          .eq('company_id', companyIdForChat)
          .order('name', { ascending: true }),
        supabase
          .rpc('get_company_client_profiles', { p_company_id: companyIdForChat })
      ]);

      addChatData.availableProjects = projectsResult.data || [];

      // Process client profiles
      if (clientProfilesResult.data && clientProfilesResult.data.length > 0) {
        addChatData.availableLinkedClientProfiles = clientProfilesResult.data.map(profile => ({
          id: profile.profile_id,
          first_name: profile.first_name || '',
          last_name: profile.last_name || '',
          role: profile.role || 'CLIENT',
          avatar_path: profile.avatar_path,
          company_id: profile.company_id,
          is_linked_client: true
        }));
      }
    } catch (error) {
      console.error('Error loading projects/clients:', error);
      addChatData.availableProjects = [];
    }

    // Load cross-company participants based on HH client status
    try {
      const isCurrentUserHHAdmin = currentProfile?.is_hh_admin || currentUser?.is_hh_admin || false;
      const currentUserId = currentUser?.id;

      // Case 1: If current company is HH client, load HH team members
      const { data: companyData, error: companyDataError } = await supabase
        .from('companies')
        .select('is_hh_client, name')
        .eq('id', companyIdForChat)
        .maybeSingle();

      console.log('🔍 Checking HH client status for company:', companyIdForChat, companyData);
      const isHelloHabaneroCompany = (companyData?.name || '').trim() === 'Hello Habanero';
      if (isHelloHabaneroCompany) {
        addChatData.availableLinkedClientProfiles = [];
        console.log('ℹ️ Hello Habanero company: not loading HH clients into participants list');
      }

      if (companyDataError) {
        console.error('Error checking HH client status:', companyDataError);
      } else if (companyData?.is_hh_client) {
        console.log('✅ Company is HH client, loading HH users...');
        // Get HH company ID
        const { data: hhCompany } = await supabase
          .from('companies')
          .select('id')
          .eq('name', 'Hello Habanero')
          .single();

        // Use RPC function to get HH users - bypasses RLS restrictions
        // This function checks if company is HH client and returns HH team members
        const { data: hhUsers, error: hhUsersError } = await supabase
          .rpc('get_hh_users_for_client', { user_company_id: companyIdForChat });

        if (hhUsersError) {
          console.error('❌ Error loading HH users via RPC:', hhUsersError);
          addChatData.availableHHUsers = [];
        } else {
          console.log('📋 HH users loaded via RPC:', hhUsers?.length || 0, 'users', hhUsers);

          addChatData.availableHHUsers = (hhUsers || []).map(user => ({
            id: user.id,
            first_name: user.first_name || '',
            last_name: user.last_name || '',
            role: user.is_hh_admin ? 'HH_ADMIN' : 'HH_TEAM',
            avatar_path: user.avatar_path,
            is_hh_user: true // Flag to identify HH users
          }));
          console.log('✅ Loaded', addChatData.availableHHUsers.length, 'HH users for chat');
        }
      }

      // Case 2: If current user is HH admin OR company is HH client, load OWNERS of other HH client companies
      // HH clients can message owners of other HH client companies (not just HH admins can see them)
      if (isCurrentUserHHAdmin || companyData?.is_hh_client) {
        console.log('🔍 Loading HH client company OWNERS - user is HH admin or from HH client company');
        // Get all HH client companies (exclude current company)
        const { data: hhClientCompanies, error: hhClientError } = await supabase
          .from('companies')
          .select('id, name, owner_id')
          .eq('is_hh_client', true)
          .neq('id', companyIdForChat); // Exclude current company

        if (hhClientError) {
          console.error('Error loading HH client companies:', hhClientError);
        } else {
          console.log('📋 Found', hhClientCompanies?.length || 0, 'other HH client companies');

          if (hhClientCompanies && hhClientCompanies.length > 0) {
            // Get ONLY OWNERS of these companies (not managers/admins)
            const ownerIds = hhClientCompanies.map(c => c.owner_id).filter(Boolean);

            console.log('📋 Owner IDs to load:', ownerIds);

            // Load company owners from profiles
            let ownersQuery = supabase
              .from('profiles')
              .select(`
                id,
                first_name,
                last_name,
                avatar_path,
                company_id,
                is_hh_admin
              `)
              .in('id', ownerIds);

            if (currentUserId) {
              ownersQuery = ownersQuery.neq('id', currentUserId);
            }

            const { data: ownersData, error: ownersError } = await ownersQuery;

            // Also verify they're actually OWNER role in company_members
            const { data: companyOwners, error: ownersVerifyError } = await supabase
              .from('company_members')
              .select(`
                user_id,
                role,
                profiles!company_members_user_id_fkey(
                  id,
                  first_name,
                  last_name,
                  avatar_path,
                  company_id,
                  is_hh_admin
                )
              `)
              .in('company_id', hhClientCompanies.map(c => c.id))
              .eq('role', 'OWNER'); // ONLY OWNERS, not managers

            if (ownersError || ownersVerifyError) {
              console.error('Error loading HH client company owners:', ownersError || ownersVerifyError);
              addChatData.availableHHClientUsers = [];
            } else {
              console.log('📋 Loaded owners from profiles:', ownersData?.length || 0);
              console.log('📋 Verified owners from company_members:', companyOwners?.length || 0);

              // Use company_members verification as source of truth (only OWNER role)
              const allClientUsers = [];

              // Add verified OWNERS from company_members
              if (companyOwners && companyOwners.length > 0) {
                companyOwners.forEach(cm => {
                  const profile = cm.profiles;
                  if (profile && profile.id !== currentUserId) {
                    allClientUsers.push({
                      id: profile.id,
                      first_name: profile.first_name || '',
                      last_name: profile.last_name || '',
                      role: 'CLIENT_OWNER',
                      avatar_path: profile.avatar_path,
                      company_id: profile.company_id,
                      is_hh_client_user: true // Flag to identify HH client company owners
                    });
                  }
                });
              }

              // Deduplicate by id
              const uniqueClientUsers = allClientUsers.filter((user, index, self) =>
                index === self.findIndex(u => u.id === user.id)
              );

              addChatData.availableHHClientUsers = uniqueClientUsers;
              console.log('✅ Loaded', uniqueClientUsers.length, 'HH client company OWNERS for chat');
              console.log('👥 Client owners:', uniqueClientUsers.map(u => `${u.first_name} ${u.last_name} (${u.role})`));
            }
          } else {
            console.log('⚠️ No other HH client companies found');
            addChatData.availableHHClientUsers = [];
          }
        }
      } else {
        console.log('ℹ️ User is not HH admin and company is not HH client, skipping HH client company owners load');
      }

      // Client profiles already loaded via Promise.all at start of function
    } catch (error) {
      console.error('Error loading cross-company participants:', error);
    }
  }

  // PRE-MERGE ALL PARTICIPANTS ONCE (optimization to prevent repeated deduplication on every render)
  // Build a single merged array using Map for O(1) deduplication
  const participantMap = new Map();
  const currentUserRole = currentProfile?.company_role || currentProfile?.role || 'USER';
  const isClientUser = currentUserRole === 'CLIENT';

  // 1. Add company members (base participants). For CLIENT users, ONLY company staff: OWNER, MANAGER, EMPLOYEE (no clients, no USER).
  const companyMembersList = currentProfile?.company_members || [];
  const staffRoles = ['OWNER', 'MANAGER', 'EMPLOYEE'];
  if (Array.isArray(companyMembersList)) {
    companyMembersList.forEach(member => {
      const id = String(member.user_id || member.id);
      const role = (member.role || 'USER').toUpperCase();
      if (isClientUser && !staffRoles.includes(role)) return; // Clients can only contact owners, managers, employees
      if (id && id !== String(currentUser?.id)) {
        participantMap.set(id, {
          id: id,
          first_name: member.profiles?.first_name || member.first_name || '',
          last_name: member.profiles?.last_name || member.last_name || '',
          role: role,
          avatar_path: member.profiles?.avatar_path || member.avatar_path,
          source: 'company_member'
        });
      }
    });
  }

  // 2. Add HH users (for HH clients) - not for CLIENT users; clients only see company members (owners, managers, employees)
  if (!isClientUser && addChatData.availableHHUsers && addChatData.availableHHUsers.length > 0) {
    addChatData.availableHHUsers.forEach(user => {
      const id = String(user.id);
      if (!participantMap.has(id)) {
        participantMap.set(id, {
          id: id,
          first_name: user.first_name || '',
          last_name: user.last_name || '',
          role: user.role || 'HH_TEAM',
          avatar_path: user.avatar_path,
          is_hh_user: true,
          source: 'hh_user'
        });
      }
    });
  }

  // 3. Add HH client company users (for HH admins only - not for CLIENT users)
  if (!isClientUser && addChatData.availableHHClientUsers && addChatData.availableHHClientUsers.length > 0) {
    addChatData.availableHHClientUsers.forEach(user => {
      const id = String(user.id);
      if (!participantMap.has(id)) {
        participantMap.set(id, {
          id: id,
          first_name: user.first_name || '',
          last_name: user.last_name || '',
          role: user.role || 'CLIENT_OWNER',
          avatar_path: user.avatar_path,
          is_hh_client_user: true,
          source: 'hh_client_user'
        });
      }
    });
  }

  // 4. Add linked client profiles (only for non-CLIENT users - clients can only contact HH members)
  if (!isClientUser && addChatData.availableLinkedClientProfiles && addChatData.availableLinkedClientProfiles.length > 0) {
    addChatData.availableLinkedClientProfiles.forEach(profile => {
      const id = String(profile.id);
      if (!participantMap.has(id)) {
        participantMap.set(id, {
          id: id,
          first_name: profile.first_name || '',
          last_name: profile.last_name || '',
          role: profile.role || 'CLIENT',
          avatar_path: profile.avatar_path,
          is_linked_client: true,
          source: 'linked_client'
        });
      }
    });
  }

  // Store the pre-merged array (deduplication done once, not on every render)
  addChatData.mergedParticipants = Array.from(participantMap.values());
  console.log('✅ Pre-merged', addChatData.mergedParticipants.length, 'unique participants (deduplication done once)');

  // Mark loading complete and sync to window
  addChatData.isLoading = false;
  window.addChatData = addChatData;

  // Re-render now that data is loaded (modal was already visible with loading state)
  renderPMTool();
  console.log('✅ Add Chat modal data loaded - modal updated');
};

// Close add chat modal
window.closeAddChatModal = function () {
  showAddChatModal = false;
  addChatData = {
    chatName: '',
    selectedProject: null,
    selectedParticipants: [],
    participantSearchQuery: '',
    projectSearchQuery: '',
    availableProjects: [],
    availableHHUsers: [], // Reset HH users
    availableHHClientUsers: [], // Reset HH client users
    availableLinkedClientProfiles: [] // Reset linked client profiles
  };
  // Update global reference
  window.addChatData = addChatData;
  renderPMTool();
};

// Toggle participant selection in add chat modal
window.toggleAddChatParticipant = function (userId) {
  // Ensure addChatData is accessible
  if (!addChatData) {
    addChatData = window.addChatData || {
      chatName: '',
      selectedProject: null,
      selectedParticipants: [],
      participantSearchQuery: '',
      projectSearchQuery: '',
      availableProjects: []
    };
  }

  // Preserve chat name from input field before re-rendering
  const nameInput = document.getElementById('add-chat-name-input');
  if (nameInput && nameInput.value) {
    addChatData.chatName = nameInput.value;
    if (window.addChatData) {
      window.addChatData.chatName = nameInput.value;
    }
  }

  // Normalize userId to string for consistent comparison
  const normalizedUserId = String(userId);

  // Normalize all existing participants to strings for comparison
  const normalizedParticipants = addChatData.selectedParticipants.map(id => String(id));
  const index = normalizedParticipants.indexOf(normalizedUserId);

  if (index >= 0) {
    // Remove participant - remove from original array using original index
    addChatData.selectedParticipants.splice(index, 1);
    console.log('➖ Removed participant from selection:', normalizedUserId);
  } else {
    // Add participant - add normalized ID
    addChatData.selectedParticipants.push(normalizedUserId);
    console.log('➕ Added participant to selection:', normalizedUserId);
  }

  // Update global reference
  window.addChatData = addChatData;

  console.log('👥 Selected participants:', addChatData.selectedParticipants);
  renderPMTool();
};

// Handle participant search in add chat modal
window.handleAddChatParticipantSearch = function (query) {
  // Preserve chat name from input field before re-rendering
  const nameInput = document.getElementById('add-chat-name-input');
  if (nameInput && nameInput.value) {
    addChatData.chatName = nameInput.value;
    if (window.addChatData) {
      window.addChatData.chatName = nameInput.value;
    }
  }

  addChatData.participantSearchQuery = query;
  renderPMTool();
};

// Handle project search in add chat modal
window.handleAddChatProjectSearch = function (query) {
  // Preserve chat name from input field before re-rendering
  const nameInput = document.getElementById('add-chat-name-input');
  if (nameInput && nameInput.value) {
    addChatData.chatName = nameInput.value;
    if (window.addChatData) {
      window.addChatData.chatName = nameInput.value;
    }
  }

  addChatData.projectSearchQuery = query;
  renderPMTool();
};

// Select project in add chat modal
window.selectAddChatProject = function (projectId) {
  // Preserve chat name from input field before re-rendering
  const nameInput = document.getElementById('add-chat-name-input');
  if (nameInput && nameInput.value) {
    addChatData.chatName = nameInput.value;
    if (window.addChatData) {
      window.addChatData.chatName = nameInput.value;
    }
  }

  addChatData.selectedProject = addChatData.selectedProject === projectId ? null : projectId;
  renderPMTool();
};

// Create chat
window.createChat = async function () {
  if (!currentCompany || !currentUser) {
    alert('Missing required information');
    return;
  }

  // At least one participant is required (besides current user)
  if (addChatData.selectedParticipants.length === 0) {
    alert('Please select at least one participant');
    return;
  }

  try {
    // Get chat name from input field directly (most reliable source)
    const nameInput = document.getElementById('add-chat-name-input');
    let chatNameFromInput = '';
    if (nameInput && nameInput.value) {
      chatNameFromInput = nameInput.value.trim();
    }
    // Also check addChatData as fallback
    const chatNameFromData = (addChatData?.chatName || window.addChatData?.chatName || '').trim();
    // Use input field value if available and not empty, otherwise use data
    const finalChatNameValue = chatNameFromInput || chatNameFromData;

    console.log('🔍 Reading chat name:', {
      inputElement: nameInput ? 'found' : 'not found',
      inputValue: nameInput ? nameInput.value : 'N/A',
      chatNameFromInput: chatNameFromInput,
      chatNameFromData: chatNameFromData,
      finalChatNameValue: finalChatNameValue
    });

    // Normalize selected participants to strings for consistent comparison
    const normalizedSelectedParticipants = addChatData.selectedParticipants.map(id => String(id));

    console.log('📝 Creating chat with data:', {
      chatNameFromInput: chatNameFromInput,
      chatNameFromData: chatNameFromData,
      finalChatNameValue: finalChatNameValue,
      selectedParticipants: normalizedSelectedParticipants,
      selectedParticipantsCount: normalizedSelectedParticipants.length,
      selectedProject: addChatData.selectedProject
    });

    // Generate chat title
    let chatTitle = '';
    if (finalChatNameValue) {
      chatTitle = finalChatNameValue;
    } else {
      // Auto-generate title based on participants
      const participantNames = normalizedSelectedParticipants.map(userId => {
        // All participants are either team members, clients with profiles, HH users, or HH client users
        // Normalize IDs for comparison
        const teamMember = teamMembers.find(m => String(m.id) === userId);
        const contact = contacts.find(c => String(c.contact_profile_id) === userId);
        const hhUser = addChatData.availableHHUsers?.find(u => String(u.id) === userId);
        const hhClientUser = addChatData.availableHHClientUsers?.find(u => String(u.id) === userId);

        if (teamMember) {
          return `${teamMember.first_name || ''} ${teamMember.last_name || ''}`.trim();
        } else if (contact) {
          return `${contact.first_name || ''} ${contact.last_name || ''}`.trim();
        } else if (hhUser) {
          return `${hhUser.first_name || ''} ${hhUser.last_name || ''}`.trim();
        } else if (hhClientUser) {
          return `${hhClientUser.first_name || ''} ${hhClientUser.last_name || ''}`.trim();
        }
        return null;
      }).filter(Boolean);

      if (participantNames.length === 1) {
        chatTitle = `Chat with ${participantNames[0]}`;
      } else if (participantNames.length > 1) {
        chatTitle = `Group Chat (${participantNames.length + 1} people)`;
      } else {
        chatTitle = 'New Chat';
      }
    }

    // Determine contact_id if one of the participants is a client with profile
    let contactId = null;
    for (const userId of normalizedSelectedParticipants) {
      // Check if this is a client with profile - normalize for comparison
      const contact = contacts.find(c => String(c.contact_profile_id) === userId);
      if (contact) {
        contactId = contact.id;
        break; // Use first client found
      }
    }

    // Add current user as participant - normalize all IDs to strings
    const currentUserId = String(currentUser.id);
    const participants = [currentUserId, ...normalizedSelectedParticipants];

    // Create chat
    // If custom name is provided, use it for both title and custom_name
    // Otherwise, use auto-generated title
    // Use explicit check for non-empty string
    const customName = (finalChatNameValue && finalChatNameValue.length > 0) ? finalChatNameValue : null;
    const finalTitle = customName || chatTitle;

    console.log('📝 Final chat details:', {
      customName: customName,
      finalTitle: finalTitle,
      participants: participants,
      participantsCount: participants.length
    });

    // Ensure we have company_id - use from company_members if currentCompany is not set
    let companyIdForInsert = currentCompany?.id;
    if (!companyIdForInsert && currentProfile?.company_members && currentProfile.company_members.length > 0) {
      companyIdForInsert = currentProfile.company_members[0].company_id;
      console.log('⚠️ Using company_id from company_members:', companyIdForInsert);
    }

    // Ensure company_id is set - required for RLS policy
    if (!companyIdForInsert) {
      console.error('❌ Cannot create chat: company_id is required', {
        currentCompany: currentCompany,
        currentProfile: currentProfile
      });
      alert('Company not found. Please refresh and try again.');
      return;
    }

    // Get session for debug logging only (created_by handled by DB default)
    const { data: { session: currentSession } } = await supabase.auth.getSession();

    // Ensure company_id is set - required for RLS policy
    if (!companyIdForInsert) {
      console.error('❌ Cannot create chat: no company ID available', {
        currentCompany: currentCompany,
        currentProfile: currentProfile
      });
      alert('Company not found. Please refresh and try again.');
      return;
    }

    // Build insert payload - MUST include created_by for RLS policy to work
    // RLS WITH CHECK runs BEFORE defaults, so created_by must be explicit
    const createdById = currentUser?.id || currentSession?.user?.id || currentProfile?.id;

    if (!createdById) {
      console.error('❌ Cannot create chat: created_by is required', {
        currentUser: currentUser,
        currentSession: currentSession,
        currentProfile: currentProfile
      });
      alert('User ID not found. Please refresh and try again.');
      return;
    }

    const insertPayload = {
      title: finalTitle,
      custom_name: customName,
      project_id: addChatData.selectedProject || null,
      contact_id: contactId,
      company_id: companyIdForInsert, // ✅ Always required - must match user's company
      created_by: createdById, // ✅ Required for RLS policy check - must match auth.uid()
      chat_type: contactId ? 'CLIENT' : 'TEAM',
      priority: 'NORMAL',
      project_progress: 0
    };

    // Debug log right before insert
    console.log('📝 [BEFORE INSERT] Chat creation debug info:', {
      currentUserId: currentUser?.id,
      sessionUserId: currentSession?.user?.id,
      profileId: currentProfile?.id,
      createdById: createdById,
      currentCompanyId: currentCompany?.id,
      companyIdForInsert: companyIdForInsert,
      insertPayload: insertPayload,
      willPassRLS: createdById && (createdById === currentUser?.id || createdById === currentSession?.user?.id)
    });

    const { data: newChat, error: chatError } = await supabase
      .from('chats')
      .insert(insertPayload)
      .select()
      .single();

    if (chatError) {
      console.error('❌ Error creating chat:', chatError);
      console.error('❌ Chat creation error details:', {
        errorCode: chatError.code,
        errorMessage: chatError.message,
        errorDetails: chatError.details,
        errorHint: chatError.hint,
        insertPayload: insertPayload,
        sessionUserId: currentSession?.user?.id,
        currentCompanyId: currentCompany?.id,
        currentUser: currentUser,
        currentCompany: currentCompany
      });
      alert('Failed to create chat: ' + chatError.message);
      return;
    }

    console.log('✅ Chat created successfully:', newChat);
    console.log('👥 Final participants list:', participants);

    // Build participant records - insert without contact_id first
    const participantRecords = participants.map(userId => ({
      chat_id: newChat.id,
      user_id: userId
    }));

    // Insert participants first (without contact_id)
    const { error: participantsError } = await supabase
      .from('chat_participants')
      .insert(participantRecords);

    // Note: chat_participants table doesn't have contact_id column
    // We don't need to update it - contact_id is stored in the chats table instead

    if (participantsError) {
      console.error('Error adding participants:', participantsError);
      alert('Chat created but failed to add participants: ' + participantsError.message);
    }

    // Close modal IMMEDIATELY for fast feedback
    closeAddChatModal();
    selectedChatId = newChat.id;
    renderPMTool();

    // Send initial message (fire and forget, no await needed)
    supabase
      .from('messages')
      .insert({
        chat_id: newChat.id,
        sender_id: currentUser.id,
        text: `Chat created by ${currentProfile?.first_name || 'User'} ${currentProfile?.last_name || ''}`,
        status: 'sent',
        created_at: new Date().toISOString()
      })
      .then(() => console.log('✅ Initial message sent'))
      .catch(err => console.warn('⚠️ Initial message failed:', err));

    // Load chats and messages in parallel in background
    Promise.all([
      loadChats(),
      loadChatMessages(newChat.id)
    ]).then(() => {
      console.log('✅ Chats and messages loaded');
      renderPMTool();
    });
  } catch (error) {
    console.error('Error creating chat:', error);
    // Better error handling - check if it's a TypeScript/type error
    const errorMessage = error.message || String(error);
    if (errorMessage.includes('Type') || errorMessage.includes('type')) {
      console.error('Type error details:', error);
    }
    alert('Failed to create chat: ' + errorMessage);
  }
};

// Render Add Chat Modal
function renderAddChatModal() {
  // Sync addChatData from window if available
  if (window.addChatData) {
    addChatData = window.addChatData;
  } else {
    window.addChatData = addChatData;
  }

  const currentUserRole = (currentProfile?.company_role || currentProfile?.role || 'USER').toUpperCase();
  const isClientUser = currentUserRole === 'CLIENT';
  const staffRoles = ['OWNER', 'MANAGER', 'EMPLOYEE'];
  // Hello Habanero is the admin company: only show members/managers/owners or HH admins, never HH clients
  const isHelloHabaneroCompany = (currentCompany?.name || '').trim() === 'Hello Habanero';

  // Get available participants (company members, clients, and HH users if company is HH client)
  const availableParticipants = [];

  // Add team members (excluding current user)
  teamMembers.forEach(member => {
    if (member.id === currentUser?.id) {
      return;
    }
    const memberRole = (member.company_role || member.role || 'USER').toUpperCase();
    if (isClientUser && !staffRoles.includes(memberRole)) {
      return;
    }
    availableParticipants.push({
      id: member.id,
      first_name: member.first_name || '',
      last_name: member.last_name || '',
      role: memberRole,
      avatar_path: member.avatar_path
    });
  });

  // Add only clients with profiles (contacts that have accounts and can login)
  // Skip when current company is Hello Habanero: only show members/managers/owners or HH admins, not HH clients
  if (!isClientUser && !isHelloHabaneroCompany) {
    contacts.forEach(contact => {
      if (contact.contact_profile_id) {
        if (!availableParticipants.find(p => p.id === contact.contact_profile_id)) {
          availableParticipants.push({
            id: contact.contact_profile_id,
            contact_id: contact.id, // Store contact_id for reference
            first_name: contact.first_name || '',
            last_name: contact.last_name || '',
            role: 'CLIENT',
            avatar_path: null
          });
        }
      }
    });
  }

  // Add HH users if company is HH client (loaded in showAddChatModal)
  if (!isClientUser && addChatData.availableHHUsers && addChatData.availableHHUsers.length > 0) {
    console.log('➕ Adding', addChatData.availableHHUsers.length, 'HH users to available participants');
    addChatData.availableHHUsers.forEach(hhUser => {
      if (!availableParticipants.find(p => String(p.id) === String(hhUser.id))) {
        availableParticipants.push(hhUser);
        console.log('  ✅ Added HH user:', hhUser.first_name, hhUser.last_name);
      } else {
        console.log('  ⏭️ Skipped duplicate HH user:', hhUser.first_name, hhUser.last_name);
      }
    });
  } else if (isClientUser) {
    console.log('ℹ️ Client users cannot add HH users to chats');
  } else {
    console.log('ℹ️ No HH users available to add');
  }

  // Add HH client company owners/admins if current user is HH admin (loaded in showAddChatModal)
  if (!isClientUser && addChatData.availableHHClientUsers && addChatData.availableHHClientUsers.length > 0) {
    console.log('➕ Adding', addChatData.availableHHClientUsers.length, 'HH client company users to available participants');
    addChatData.availableHHClientUsers.forEach(clientUser => {
      if (!availableParticipants.find(p => String(p.id) === String(clientUser.id))) {
        availableParticipants.push(clientUser);
        console.log('  ✅ Added HH client user:', clientUser.first_name, clientUser.last_name, `(${clientUser.role})`);
      } else {
        console.log('  ⏭️ Skipped duplicate HH client user:', clientUser.first_name, clientUser.last_name);
      }
    });
  } else if (isClientUser) {
    console.log('ℹ️ Client users cannot add other client companies to chats');
  } else {
    console.log('ℹ️ No HH client company users available to add');
  }

  // Add client profiles from linked companies (loaded in showAddChatModal)
  // Skip when current company is Hello Habanero: do not show HH clients in participants list
  if (!isClientUser && !isHelloHabaneroCompany && addChatData.availableLinkedClientProfiles && addChatData.availableLinkedClientProfiles.length > 0) {
    console.log('➕ Adding', addChatData.availableLinkedClientProfiles.length, 'linked client profiles to available participants');
    addChatData.availableLinkedClientProfiles.forEach(clientProfile => {
      if (!availableParticipants.find(p => String(p.id) === String(clientProfile.id))) {
        availableParticipants.push(clientProfile);
        console.log('  ✅ Added linked client profile:', clientProfile.first_name, clientProfile.last_name, `(${clientProfile.role})`);
      } else {
        console.log('  ⏭️ Skipped duplicate linked client profile:', clientProfile.first_name, clientProfile.last_name);
      }
    });
  } else if (isClientUser) {
    console.log('ℹ️ Client users cannot add linked clients to chats');
  } else if (isHelloHabaneroCompany) {
    console.log('ℹ️ Hello Habanero company: only showing members/managers/owners and HH admins, not HH clients');
  } else {
    console.log('ℹ️ No linked client profiles available to add');
  }

  // Filter participants based on search query
  const filteredParticipants = availableParticipants.filter(p => {
    if (!addChatData.participantSearchQuery) return true;
    const query = addChatData.participantSearchQuery.toLowerCase();
    const fullName = `${p.first_name || ''} ${p.last_name || ''}`.toLowerCase();
    const role = p.role.toLowerCase();
    return fullName.includes(query) || role.includes(query);
  });

  // Filter projects based on search query
  const filteredProjects = (addChatData.availableProjects || []).filter(p => {
    if (!addChatData.projectSearchQuery) return true;
    const query = addChatData.projectSearchQuery.toLowerCase();
    const projectName = (p.name || '').toLowerCase();
    const clientName = p.contact ? `${p.contact.first_name || ''} ${p.contact.last_name || ''}`.toLowerCase() : '';
    const companyName = (p.contact?.company_name || '').toLowerCase();
    return projectName.includes(query) || clientName.includes(query) || companyName.includes(query);
  });

  // Get avatar initials helper
  const getParticipantInitials = (p) => {
    return `${(p.first_name || '').charAt(0)}${(p.last_name || '').charAt(0)}`.toUpperCase() || 'U';
  };

  return `
    <div id="add-chat-modal" onclick="event.stopPropagation()" style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1000;
    ">
      <div style="
        background: #ffffff;
        border-radius: 1rem;
        padding: 0;
        max-width: 600px;
        width: 90%;
        max-height: 85vh;
        overflow-y: auto;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
      ">
        <!-- Header -->
        <div style="
          padding: 1rem 1.5rem;
          border-bottom: 1px solid #e9ecef;
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: sticky;
          top: 0;
          background: #ffffff;
          z-index: 10;
        ">
          <button
            onclick="closeAddChatModal()"
            style="
              background: transparent;
              border: none;
              color: #6c757d;
              cursor: pointer;
              font-size: 0.875rem;
              font-weight: 500;
              padding: 0.5rem;
            "
          >
            Cancel
          </button>
          <h2 style="margin: 0; font-size: 1.125rem; font-weight: 700; color: #2c3e50;">
            Create Chat
          </h2>
          <button
            onclick="createChat()"
            style="
              background: ${addChatData.selectedParticipants.length > 0 ? '#f59e0b' : '#d1d5db'};
              color: white;
              border: none;
              padding: 0.5rem 1rem;
              border-radius: 0.375rem;
              cursor: ${addChatData.selectedParticipants.length > 0 ? 'pointer' : 'not-allowed'};
              font-weight: 600;
              font-size: 0.875rem;
            "
            ${addChatData.selectedParticipants.length === 0 ? 'disabled' : ''}
          >
            Create
          </button>
        </div>
        
        <!-- Content -->
        <div style="padding: 1.5rem;">
          <!-- Chat Name -->
          <div style="margin-bottom: 1.5rem;">
            <label style="
              display: block;
              font-weight: 700;
              color: #2c3e50;
              margin-bottom: 0.5rem;
              font-size: 0.9375rem;
            ">Chat Name (Optional)</label>
            <input
              type="text"
              id="add-chat-name-input"
              value="${addChatData.chatName || ''}"
              oninput="if (window.addChatData) { window.addChatData.chatName = this.value; addChatData.chatName = this.value; }"
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid #e9ecef;
                border-radius: 0.5rem;
                font-size: 0.875rem;
                box-sizing: border-box;
              "
              placeholder="Enter custom chat name"
            />
            <p style="
              margin: 0.5rem 0 0 0;
              color: #6c757d;
              font-size: 0.8125rem;
            ">
              Leave empty for automatic naming
            </p>
          </div>
          
          <!-- Project Selection -->
          <div style="margin-bottom: 1.5rem;">
            <label style="
              display: block;
              font-weight: 700;
              color: #2c3e50;
              margin-bottom: 0.5rem;
              font-size: 0.9375rem;
            ">Project (Optional)</label>
            <input
              type="text"
              value="${addChatData.projectSearchQuery}"
              oninput="handleAddChatProjectSearch(this.value)"
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid #e9ecef;
                border-radius: 0.5rem;
                font-size: 0.875rem;
                box-sizing: border-box;
                margin-bottom: 0.5rem;
              "
              placeholder="Search projects by name, client, or description"
            />
            ${filteredProjects.length > 0 ? `
              <div style="
                max-height: 200px;
                overflow-y: auto;
                border: 1px solid #e9ecef;
                border-radius: 0.5rem;
              ">
                ${filteredProjects.map(project => {
    const isSelected = addChatData.selectedProject === project.id;
    const clientName = project.contact
      ? `${project.contact.first_name || ''} ${project.contact.last_name || ''}`.trim()
      : null;
    return `
                    <div
                      onclick="selectAddChatProject('${project.id}')"
                      style="
                        padding: 0.75rem 1rem;
                        border-bottom: 1px solid #f3f4f6;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        background: ${isSelected ? '#fef3c7' : '#ffffff'};
                      "
                      onmouseover="this.style.background='${isSelected ? '#fef3c7' : '#f8f9fa'}'"
                      onmouseout="this.style.background='${isSelected ? '#fef3c7' : '#ffffff'}'"
                    >
                      <div>
                        <div style="color: #2c3e50; font-size: 0.875rem; font-weight: 500;">
                          ${project.name}
                        </div>
                        ${clientName ? `
                          <div style="color: #6c757d; font-size: 0.8125rem; margin-top: 0.25rem; display: flex; align-items: center; gap: 0.25rem;">
                            <span>👤</span>
                            <span>${clientName}</span>
                          </div>
                        ` : ''}
                      </div>
                      ${isSelected ? '<span style="color: #f59e0b; font-weight: 600;">✓</span>' : ''}
                    </div>
                  `;
  }).join('')}
              </div>
            ` : addChatData.projectSearchQuery ? `
              <div style="padding: 1rem; text-align: center; color: #9ca3af; font-size: 0.875rem;">
                No projects found
              </div>
            ` : ''}
          </div>
          
          <!-- Participants -->
          <div style="margin-bottom: 1.5rem;">
            <label style="
              display: block;
              font-weight: 700;
              color: #2c3e50;
              margin-bottom: 0.5rem;
              font-size: 0.9375rem;
            ">Participants (${addChatData.selectedParticipants.length} selected)</label>
            <input
              type="text"
              value="${addChatData.participantSearchQuery}"
              oninput="handleAddChatParticipantSearch(this.value)"
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid #e9ecef;
                border-radius: 0.5rem;
                font-size: 0.875rem;
                box-sizing: border-box;
                margin-bottom: 0.5rem;
              "
              placeholder="Search users by name or role..."
            />
            ${filteredParticipants.length > 0 ? `
              <div style="
                max-height: 300px;
                overflow-y: auto;
                border: 1px solid #e9ecef;
                border-radius: 0.5rem;
              ">
                ${filteredParticipants.map(p => {
    // Normalize IDs to strings for comparison
    const participantId = String(p.id);
    const normalizedSelected = addChatData.selectedParticipants.map(id => String(id));
    const isSelected = normalizedSelected.includes(participantId);
    const initials = getParticipantInitials(p);
    const fullName = `${p.first_name || ''} ${p.last_name || ''}`.trim() || 'Unknown';
    return `
                    <div
                      onclick="toggleAddChatParticipant('${participantId}')"
                      style="
                        padding: 0.75rem 1rem;
                        border-bottom: 1px solid #f3f4f6;
                        cursor: pointer;
                        display: flex;
                        align-items: center;
                        gap: 0.75rem;
                        background: ${isSelected ? '#fef3c7' : '#ffffff'};
                      "
                      onmouseover="this.style.background='${isSelected ? '#fef3c7' : '#f8f9fa'}'"
                      onmouseout="this.style.background='${isSelected ? '#fef3c7' : '#ffffff'}'"
                    >
                      <div style="
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                        background: ${p.is_hh_user ? '#f59e0b' : p.is_hh_client_user ? '#10b981' : p.role === 'CLIENT' ? '#3b82f6' : '#6b7280'};
                        color: white;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        font-weight: 600;
                        font-size: 0.875rem;
                        flex-shrink: 0;
                      ">
                        ${initials}
                      </div>
                      <div style="flex: 1;">
                        <div style="color: #2c3e50; font-size: 0.875rem; font-weight: 500;">
                          ${fullName}
                        </div>
                        <div style="color: #6c757d; font-size: 0.75rem;">
                          ${p.is_hh_user ? (p.role === 'HH_ADMIN' ? 'HH Admin' : 'HH Team') :
        p.is_hh_client_user ? (p.role === 'CLIENT_OWNER' ? 'Client Owner' : 'Client Manager') :
          p.role}
                        </div>
                      </div>
                      ${isSelected ? `
                        <div style="
                          width: 24px;
                          height: 24px;
                          border-radius: 50%;
                          background: #f59e0b;
                          color: white;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          font-size: 0.75rem;
                          font-weight: 600;
                        ">
                          ✓
                        </div>
                      ` : `
                        <div style="
                          width: 24px;
                          height: 24px;
                          border-radius: 50%;
                          border: 2px solid #d1d5db;
                        "></div>
                      `}
                    </div>
                  `;
  }).join('')}
              </div>
            ` : addChatData.participantSearchQuery ? `
              <div style="padding: 1rem; text-align: center; color: #9ca3af; font-size: 0.875rem;">
                No participants found
              </div>
            ` : `
              <div style="padding: 1rem; text-align: center; color: #9ca3af; font-size: 0.875rem;">
                No participants available
              </div>
            `}
          </div>
        </div>
      </div>
    </div>
  `;
}

// Render Schedule Message Modal
function renderScheduleMessageModal() {
  // Show modal even if no chat selected - will show message in form

  // Get current date/time for default values
  const now = new Date();
  const defaultDate = now.toISOString().split('T')[0];
  const defaultTime = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;

  return `
    <!-- Modal Overlay -->
    <div id="schedule-message-modal" onclick="if (event.target.id === 'schedule-message-modal') { closeScheduleMessageModal(); }" style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 99999;
      animation: fadeIn 0.3s ease-out;
    ">
      <!-- Modal Content -->
      <div onclick="event.stopPropagation()" style="
        background: #ffffff;
        border-radius: 1rem;
        padding: 0;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
        max-width: 500px;
        width: 95%;
        max-height: 90vh;
        overflow-y: auto;
        animation: slideIn 0.3s ease-out;
        position: relative;
      ">
        <!-- Header -->
        <div style="
          padding: 1rem 1.5rem;
          border-bottom: 1px solid #e9ecef;
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: sticky;
          top: 0;
          background: #ffffff;
          z-index: 10;
        ">
          <button
            onclick="event.stopPropagation(); closeScheduleMessageModal();"
            style="
              background: transparent;
              border: none;
              color: #6c757d;
              cursor: pointer;
              font-size: 0.875rem;
              font-weight: 500;
              padding: 0.5rem;
            "
          >
            Cancel
          </button>
          <h2 style="
            margin: 0;
            font-size: 1.25rem;
            font-weight: 700;
            color: #2c3e50;
          ">
            ${editingScheduledMessageId ? 'Edit Scheduled Message' : 'Schedule Message'}
          </h2>
          <div style="width: 60px;"></div>
        </div>
        
        <!-- Form -->
        <form onsubmit="handleScheduleMessage(event); return false;" style="padding: 1.5rem;">
          ${!selectedChatId ? `
            <div style="
              background: #fee2e2;
              color: #dc2626;
              padding: 1rem;
              border-radius: 0.5rem;
              margin-bottom: 1rem;
              text-align: center;
              font-size: 0.875rem;
            ">
              ⚠️ Please select a chat first to schedule a message.
            </div>
          ` : ''}
          <!-- Message Text -->
          <div style="margin-bottom: 1.5rem;">
            <label style="
              display: block;
              font-weight: 700;
              color: #2c3e50;
              margin-bottom: 0.5rem;
              font-size: 0.9375rem;
            ">Message *</label>
            <textarea
              id="schedule-message-text"
              required
              ${!selectedChatId ? 'disabled' : ''}
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid #e9ecef;
                border-radius: 0.5rem;
                font-size: 0.875rem;
                box-sizing: border-box;
                min-height: 120px;
                resize: vertical;
                font-family: inherit;
                ${!selectedChatId ? 'background: #f3f4f6; cursor: not-allowed;' : ''}
              "
              placeholder="Enter your message..."
              onfocus="if (this.disabled) return; this.style.borderColor='#f59e0b'"
              onblur="if (this.disabled) return; this.style.borderColor='#e9ecef'"
            >${editingScheduledMessageId && scheduledMessageFormData.text ? scheduledMessageFormData.text : ''}</textarea>
          </div>
          
          <!-- Date -->
          <div style="margin-bottom: 1.5rem;">
            <label style="
              display: block;
              font-weight: 700;
              color: #2c3e50;
              margin-bottom: 0.5rem;
              font-size: 0.9375rem;
            ">Date *</label>
            <input
              type="date"
              id="schedule-message-date"
              required
              ${!selectedChatId ? 'disabled' : ''}
              min="${defaultDate}"
              value="${editingScheduledMessageId && scheduledMessageFormData.date ? scheduledMessageFormData.date : defaultDate}"
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid #e9ecef;
                border-radius: 0.5rem;
                font-size: 0.875rem;
                box-sizing: border-box;
                ${!selectedChatId ? 'background: #f3f4f6; cursor: not-allowed;' : ''}
              "
              onfocus="if (this.disabled) return; this.style.borderColor='#f59e0b'"
              onblur="if (this.disabled) return; this.style.borderColor='#e9ecef'"
            />
          </div>
          
          <!-- Time -->
          <div style="margin-bottom: 1.5rem;">
            <label style="
              display: block;
              font-weight: 700;
              color: #2c3e50;
              margin-bottom: 0.5rem;
              font-size: 0.9375rem;
            ">Time *</label>
            <input
              type="time"
              id="schedule-message-time"
              required
              ${!selectedChatId ? 'disabled' : ''}
              value="${editingScheduledMessageId && scheduledMessageFormData.time ? scheduledMessageFormData.time : defaultTime}"
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid #e9ecef;
                border-radius: 0.5rem;
                font-size: 0.875rem;
                box-sizing: border-box;
                ${!selectedChatId ? 'background: #f3f4f6; cursor: not-allowed;' : ''}
              "
              onfocus="if (this.disabled) return; this.style.borderColor='#f59e0b'"
              onblur="if (this.disabled) return; this.style.borderColor='#e9ecef'"
            />
          </div>
          
          <!-- Submit Button -->
          <button
            type="submit"
            ${!selectedChatId ? 'disabled' : ''}
            style="
              width: 100%;
              background: ${!selectedChatId ? '#d1d5db' : '#f59e0b'};
              color: white;
              border: none;
              padding: 0.875rem 1.5rem;
              border-radius: 0.5rem;
              cursor: ${!selectedChatId ? 'not-allowed' : 'pointer'};
              font-size: 0.875rem;
              font-weight: 600;
              transition: background-color 0.2s;
            "
            onmouseover="if (!this.disabled) this.style.background='#d97706'"
            onmouseout="if (!this.disabled) this.style.background='#f59e0b'"
          >
            ${editingScheduledMessageId ? 'Update Scheduled Message' : 'Schedule Message'}
          </button>
        </form>
      </div>
    </div>
  `;
}

// Handle schedule message submission
window.handleScheduleMessage = async function (e) {
  e.preventDefault();

  if (!selectedChatId || !currentUser) {
    alert('Please select a chat first');
    return;
  }

  const messageText = document.getElementById('schedule-message-text')?.value?.trim();
  const scheduleDate = document.getElementById('schedule-message-date')?.value;
  const scheduleTime = document.getElementById('schedule-message-time')?.value;

  if (!messageText || !scheduleDate || !scheduleTime) {
    alert('Please fill in all fields');
    return;
  }

  // Combine date and time into ISO string
  const scheduledDateTime = new Date(`${scheduleDate}T${scheduleTime}`);
  const now = new Date();

  if (scheduledDateTime <= now) {
    alert('Please select a future date and time');
    return;
  }

  try {
    let result;

    if (editingScheduledMessageId) {
      // Update existing scheduled message
      const { data: updatedMessage, error } = await supabase
        .from('messages')
        .update({
          text: messageText,
          scheduled_at: scheduledDateTime.toISOString(),
          updated_at: new Date().toISOString()
        })
        .eq('id', editingScheduledMessageId)
        .eq('status', 'scheduled')
        .select()
        .single();

      if (error) {
        console.error('Error updating scheduled message:', error);
        alert('Failed to update scheduled message: ' + error.message);
        return;
      }

      result = updatedMessage;
    } else {
      // Create new scheduled message
      const { data: newMessage, error } = await supabase
        .from('messages')
        .insert({
          chat_id: selectedChatId,
          sender_id: currentUser.id,
          text: messageText,
          status: 'scheduled',
          scheduled_at: scheduledDateTime.toISOString(),
          created_at: new Date().toISOString()
        })
        .select()
        .single();

      if (error) {
        console.error('Error scheduling message:', error);
        alert('Failed to schedule message: ' + error.message);
        return;
      }

      result = newMessage;
    }

    // Reload scheduled messages
    await loadScheduledMessages(selectedChatId);

    // Reset editing state
    if (typeof editingScheduledMessageId !== 'undefined') {
      editingScheduledMessageId = null;
    } else {
      window.editingScheduledMessageId = null;
    }
    if (typeof scheduledMessageFormData !== 'undefined') {
      scheduledMessageFormData = { text: '', date: '', time: '' };
    } else {
      window.scheduledMessageFormData = { text: '', date: '', time: '' };
    }

    // Close modal
    showScheduleMessageModal = false;
    window.renderPMTool();

    // Show success message
    const successMsg = document.createElement('div');
    successMsg.textContent = editingScheduledMessageId ? 'Scheduled message updated successfully!' : 'Message scheduled successfully!';
    successMsg.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #10b981;
      color: white;
      padding: 1rem 1.5rem;
      border-radius: 0.5rem;
      box-shadow: 0 4px 6px rgba(0,0,0,0.1);
      z-index: 100000;
      font-weight: 500;
    `;
    document.body.appendChild(successMsg);
    setTimeout(() => successMsg.remove(), 3000);
  } catch (error) {
    console.error('Error scheduling message:', error);
    alert('An unexpected error occurred while scheduling the message');
  }
};

// Open schedule message modal
window.openScheduleMessageModal = function () {
  if (!selectedChatId) {
    alert('Please select a chat first to schedule a message.');
    return;
  }
  // Reset editing state when opening new modal
  editingScheduledMessageId = null;
  scheduledMessageFormData = { text: '', date: '', time: '' };
  showScheduleMessageModal = true;
  window.renderPMTool();
};

// Edit scheduled message
window.editScheduledMessage = function (messageId) {
  const message = scheduledMessages.find(m => m.id === messageId);
  if (!message) {
    alert('Scheduled message not found');
    return;
  }

  editingScheduledMessageId = messageId;

  // Parse scheduled date/time
  const scheduledDate = new Date(message.scheduled_at);
  const dateStr = scheduledDate.toISOString().split('T')[0];
  const timeStr = `${String(scheduledDate.getHours()).padStart(2, '0')}:${String(scheduledDate.getMinutes()).padStart(2, '0')}`;

  scheduledMessageFormData = {
    text: message.text || '',
    date: dateStr,
    time: timeStr
  };

  // Open the schedule modal with pre-filled data
  showScheduleMessageModal = true;
  window.renderPMTool();

  // Wait for modal to render, then populate fields
  setTimeout(() => {
    const textInput = document.getElementById('schedule-message-text');
    const dateInput = document.getElementById('schedule-message-date');
    const timeInput = document.getElementById('schedule-message-time');

    if (textInput) {
      textInput.value = scheduledMessageFormData.text || '';
    }
    if (dateInput) {
      dateInput.value = scheduledMessageFormData.date || '';
    }
    if (timeInput) {
      timeInput.value = scheduledMessageFormData.time || '';
    }
  }, 200);
};

// Close schedule message modal
window.closeScheduleMessageModal = function () {
  showScheduleMessageModal = false;
  editingScheduledMessageId = null;
  scheduledMessageFormData = { text: '', date: '', time: '' };
  window.renderPMTool();
};

// Render Media Request Modal
function renderMediaRequestModal() {
  if (!selectedChatId) {
    return '';
  }

  return `
    <!-- Modal Overlay -->
    <div id="media-request-modal" onclick="if (event.target.id === 'media-request-modal') { closeMediaRequestModal(); }" style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 99999;
      animation: fadeIn 0.3s ease-out;
    ">
      <!-- Modal Content -->
      <div onclick="event.stopPropagation()" style="
        background: #ffffff;
        border-radius: 1rem;
        padding: 0;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
        max-width: 500px;
        width: 95%;
        max-height: 90vh;
        overflow-y: auto;
        animation: slideIn 0.3s ease-out;
        position: relative;
      ">
        <!-- Header -->
        <div style="
          padding: 1rem 1.5rem;
          border-bottom: 1px solid #e9ecef;
          display: flex;
          justify-content: space-between;
          align-items: center;
          position: sticky;
          top: 0;
          background: #ffffff;
          z-index: 10;
        ">
          <button
            onclick="event.stopPropagation(); closeMediaRequestModal();"
            style="
              background: transparent;
              border: none;
              color: #f59e0b;
              cursor: pointer;
              font-size: 1rem;
              font-weight: 600;
              padding: 0.5rem;
            "
          >
            Cancel
          </button>
          <h2 style="
            margin: 0;
            font-size: 1.25rem;
            font-weight: 700;
            color: #2c3e50;
          ">
            Request Media
          </h2>
          <button
            onclick="event.stopPropagation(); event.preventDefault(); submitMediaRequest(); return false;"
            ${submittingMediaRequest ? 'disabled' : ''}
            type="button"
            style="
              background: transparent;
              border: none;
              color: ${submittingMediaRequest ? '#9ca3af' : '#f59e0b'};
              cursor: ${submittingMediaRequest ? 'not-allowed' : 'pointer'};
              font-size: 1rem;
              font-weight: 600;
              padding: 0.5rem;
              opacity: ${submittingMediaRequest ? 0.5 : 1};
            "
          >
            ${submittingMediaRequest ? 'Sending...' : 'Send'}
          </button>
        </div>
        
        <!-- Content -->
        <div style="padding: 1.5rem;">
          <!-- Instructions -->
          <div style="
            background: ${colors.surface};
            padding: 1rem;
            border-radius: 0.75rem;
            margin-bottom: 1.5rem;
          ">
            <div style="display: flex; align-items: center; margin-bottom: 0.5rem;">
              <span style="color: #f59e0b; font-size: 1.25rem; margin-right: 0.5rem;">ℹ️</span>
              <h3 style="
                margin: 0;
                font-size: 1rem;
                font-weight: 600;
                color: ${colors.text};
              ">
                How to Request Media
              </h3>
            </div>
            <p style="
              margin: 0;
              color: ${colors.textSecondary};
              line-height: 1.5;
              font-size: 0.875rem;
            ">
              1. Add a description of what media you need<br/>
              2. The client will receive a message with a "Submit Media" button<br/>
              3. They can upload photos, videos, and documents directly<br/>
              4. You can download all media from the Supabase dashboard
            </p>
          </div>

          <!-- Description Input -->
          <div style="margin-bottom: 1.25rem;">
            <label style="
              display: block;
              font-size: 1rem;
              font-weight: 600;
              margin-bottom: 0.5rem;
              color: ${colors.text};
            ">
              Media Description *
            </label>
            <textarea
              id="media-request-description"
              placeholder="Describe what media you need (photos, videos, documents, etc.)"
              oninput="mediaRequestDescription = this.value; updateMediaRequestPreview();"
              style="
                width: 100%;
                min-height: 120px;
                padding: 1rem;
                border: 1px solid ${colors.border};
                border-radius: 0.75rem;
                font-size: 1rem;
                font-family: inherit;
                background: ${colors.surface};
                color: ${colors.text};
                resize: vertical;
                box-sizing: border-box;
              "
            >${mediaRequestDescription}</textarea>
          </div>

          <!-- Preview -->
          <div 
            id="media-request-preview"
            style="
              display: ${mediaRequestDescription.trim() ? 'block' : 'none'};
              background: ${colors.surface};
              padding: 1rem;
              border-radius: 0.75rem;
              border: 1px solid ${colors.border};
            "
          >
            ${mediaRequestDescription.trim() ? `
              <p style="
                margin: 0 0 0.5rem 0;
                font-size: 0.875rem;
                font-weight: 600;
                color: ${colors.text};
              ">
                Preview:
              </p>
              <p style="
                margin: 0;
                color: ${colors.textSecondary};
                line-height: 1.5;
                font-size: 0.875rem;
              ">
                The client will receive a message with a "Submit Media" button.
                They'll be told: "${mediaRequestDescription.trim()}"
              </p>
            ` : ''}
          </div>
        </div>
      </div>
    </div>
  `;
}

// Open media request modal
window.openMediaRequestModal = function () {
  if (!selectedChatId) {
    alert('Please select a chat first');
    return;
  }
  mediaRequestDescription = '';
  showMediaRequestModal = true;
  window.renderPMTool();
  // Set textarea value after render
  setTimeout(() => {
    const textarea = document.getElementById('media-request-description');
    if (textarea) {
      textarea.value = mediaRequestDescription;
    }
  }, 100);
};

// Close media request modal
window.closeMediaRequestModal = function () {
  showMediaRequestModal = false;
  mediaRequestDescription = '';
  window.renderPMTool();
};

// Open image viewer modal
window.openImageViewer = function (imageUrl) {
  imageViewerUrl = imageUrl;
  showImageViewerModal = true;
  window.renderPMTool();
};

// Close image viewer modal
window.closeImageViewer = function () {
  showImageViewerModal = false;
  imageViewerUrl = '';
  window.renderPMTool();
};

// Render image viewer modal
function renderImageViewerModal() {
  if (!imageViewerUrl) {
    return '';
  }

  return `
    <!-- Image Viewer Modal Overlay -->
    <div id="image-viewer-modal" onclick="if (event.target.id === 'image-viewer-modal') { closeImageViewer(); }" style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.9);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10000;
      cursor: pointer;
    ">
      <!-- Close Button -->
      <button
        onclick="closeImageViewer();"
        style="
          position: absolute;
          top: 1rem;
          right: 1rem;
          background: rgba(255, 255, 255, 0.2);
          border: none;
          color: white;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          cursor: pointer;
          font-size: 1.5rem;
          font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 10001;
          transition: background 0.2s;
        "
        onmouseover="this.style.background='rgba(255, 255, 255, 0.3)'"
        onmouseout="this.style.background='rgba(255, 255, 255, 0.2)'"
      >
        ✕
      </button>
      
      <!-- Image Container -->
      <div style="
        max-width: 90%;
        max-height: 90%;
        display: flex;
        align-items: center;
        justify-content: center;
      " onclick="event.stopPropagation();">
        <img
          src="${imageViewerUrl}"
          alt="Image"
          style="
            max-width: 100%;
            max-height: 90vh;
            object-fit: contain;
            border-radius: 0.5rem;
          "
          onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';"
        />
        <div style="
          display: none;
          padding: 2rem;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 0.5rem;
          color: white;
          text-align: center;
        ">
          Failed to load image.
        </div>
      </div>
    </div>
  `;
}

// Update media request preview without full re-render
window.updateMediaRequestPreview = function () {
  const previewDiv = document.getElementById('media-request-preview');
  const textarea = document.getElementById('media-request-description');
  if (!previewDiv || !textarea) return;

  const description = textarea.value.trim();
  if (description) {
    // Escape HTML to prevent XSS
    const escapedDescription = description.replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    previewDiv.innerHTML = `
      <p style="
        margin: 0 0 0.5rem 0;
        font-size: 0.875rem;
        font-weight: 600;
        color: #2c3e50;
      ">
        Preview:
      </p>
      <p style="
        margin: 0;
        color: #6c757d;
        line-height: 1.5;
        font-size: 0.875rem;
      ">
        The client will receive a message with a "Submit Media" button.
        They'll be told: "${escapedDescription}"
      </p>
    `;
    previewDiv.style.display = 'block';
  } else {
    previewDiv.style.display = 'none';
  }
};

// Submit media request
window.submitMediaRequest = async function () {
  if (!selectedChatId || !currentUser) {
    alert('Please select a chat first');
    return;
  }

  const description = document.getElementById('media-request-description')?.value?.trim();
  if (!description) {
    alert('Please enter a description for the media request');
    return;
  }

  try {
    submittingMediaRequest = true;
    window.renderPMTool();

    console.log('📁 Creating media request:', {
      chatId: selectedChatId,
      requesterId: currentUser.id,
      description: description
    });

    // Create media request record
    const { data: mediaRequestData, error: mediaError } = await supabase
      .rpc('create_media_request_with_bucket', {
        p_chat_id: selectedChatId,
        p_requester_id: currentUser.id,
        p_description: description
      });

    if (mediaError) {
      console.error('❌ Media request RPC error:', mediaError);
      throw new Error(`Failed to create media request: ${mediaError.message || JSON.stringify(mediaError)}`);
    }

    console.log('📁 Media request data received:', mediaRequestData);

    const mediaRequest = mediaRequestData?.[0];
    if (!mediaRequest) {
      console.error('❌ No media request returned from RPC');
      throw new Error('Failed to create media request: No data returned');
    }

    console.log('✅ Media request created:', mediaRequest);

    // Send a message to the chat about the media request
    const messageText = `📁 Media Request\n\n${description ? `Description: ${description}\n\n` : ''}Click "Submit Media" below to upload photos, videos, or documents.`;

    console.log('📨 Sending media request message:', {
      chatId: selectedChatId,
      senderId: currentUser.id,
      mediaRequestId: mediaRequest.id,
      bucketPath: mediaRequest.bucket_path
    });

    const { data: newMessage, error: messageError } = await supabase
      .from('messages')
      .insert({
        chat_id: selectedChatId,
        sender_id: currentUser.id,
        text: messageText,
        meta: {
          type: 'media_request',
          media_request_id: mediaRequest.id,
          bucket_path: mediaRequest.bucket_path,
        },
      })
      .select()
      .single();

    if (messageError) {
      console.error('❌ Message insert error:', messageError);
      throw new Error(`Failed to send message: ${messageError.message || JSON.stringify(messageError)}`);
    }

    console.log('✅ Message sent successfully:', newMessage);

    // Reload chat messages
    await loadChatMessages(selectedChatId);

    // Close modal
    showMediaRequestModal = false;
    mediaRequestDescription = '';

    // Show success notification
    if (typeof window.showNotification === 'function') {
      window.showNotification('Media request created successfully!', 'success');
    } else {
      alert('Media request sent successfully!');
    }

    // Re-render
    window.renderPMTool();
  } catch (error) {
    console.error('❌ Error sending media request:', error);
    const errorMessage = error?.message || error?.toString() || 'Unknown error occurred';
    alert(`Failed to send media request: ${errorMessage}`);
  } finally {
    submittingMediaRequest = false;
    window.renderPMTool();
  }
};

// Handle submit media request (for recipients)
window.handleSubmitMediaRequest = async function (mediaRequestId, bucketPath) {
  if (!selectedChatId || !currentUser) {
    alert('Please select a chat first');
    return;
  }

  if (!bucketPath) {
    alert('Invalid media request: bucket path not found');
    return;
  }

  // Create a hidden file input element
  const fileInput = document.createElement('input');
  fileInput.type = 'file';
  fileInput.multiple = true; // Allow multiple file selection
  fileInput.accept = 'image/*,video/*,.pdf,.doc,.docx,.txt'; // Accept images, videos, and documents
  fileInput.style.display = 'none';

  // Handle file selection
  fileInput.onchange = async function (event) {
    const files = Array.from(event.target.files || []);
    if (files.length === 0) {
      fileInput.remove();
      return;
    }

    // Validate file sizes (max 50MB per file)
    const maxSize = 50 * 1024 * 1024; // 50MB
    const oversizedFiles = files.filter(f => f.size > maxSize);
    if (oversizedFiles.length > 0) {
      alert(`Some files are too large (max 50MB per file):\n${oversizedFiles.map(f => f.name).join('\n')}`);
      fileInput.remove();
      return;
    }

    // Show loading indicator
    const button = event.target.closest('button');
    const originalText = button ? button.textContent : 'Submit Media';
    if (button) {
      button.disabled = true;
      button.style.opacity = '0.5';
      button.textContent = `Uploading ${files.length} file(s)...`;
    }

    try {
      // Upload each file to the media-requests bucket using the bucket_path
      // Match native app: upload files and create media_uploads records
      const uploadPromises = files.map(async (file, index) => {
        // Generate unique filename (match native app format: timestamp + random string + extension)
        const fileExt = file.name.split('.').pop() || 'bin';
        const randomString = Math.random().toString(36).substring(2);
        const fileName = `${Date.now()}_${randomString}.${fileExt}`;
        // Use the bucket_path from the media request: bucket_path already includes the full path
        // bucket_path format: "ChatName_{chat_id}/"
        const filePath = `${bucketPath}${fileName}`;

        console.log(`📤 [${index + 1}/${files.length}] Uploading ${file.name}...`);
        console.log(`📤 Full file path in bucket: ${filePath}`);

        // Upload to Supabase Storage
        const { data: uploadData, error: uploadError } = await supabase.storage
          .from('media-requests')
          .upload(filePath, file, {
            cacheControl: '3600',
            upsert: false,
            contentType: file.type || 'application/octet-stream'
          });

        if (uploadError) {
          console.error(`❌ Upload error for ${file.name}:`, uploadError);
          throw new Error(`Failed to upload ${file.name}: ${uploadError.message}`);
        }

        const uploadedFilePath = uploadData.path;
        console.log(`✅ File uploaded successfully: ${uploadedFilePath}`);

        // Create database record in media_uploads table (like native app)
        console.log('💾 Creating database record for upload...');
        console.log('💾 User ID:', currentUser.id);
        console.log('💾 Media Request ID:', mediaRequestId);

        const { error: dbError } = await supabase
          .from('media_uploads')
          .insert({
            media_request_id: mediaRequestId,
            file_name: file.name,
            file_path: uploadedFilePath,
            file_size: file.size,
            mime_type: file.type || 'application/octet-stream',
            uploaded_by: currentUser.id,
          });

        if (dbError) {
          console.error('❌ Database error:', dbError);
          // Continue with other uploads even if DB insert fails
        } else {
          console.log('✅ Database record created successfully!');
        }

        return {
          fileName: file.name,
          filePath: uploadedFilePath,
          size: file.size,
          type: file.type
        };
      });

      // Wait for all uploads to complete
      const uploadResults = await Promise.all(uploadPromises);

      console.log('✅ All files uploaded successfully:', uploadResults);

      // Note: upload_count and last_uploaded_at are automatically updated by trigger
      // No need to manually update media_requests table

      // Show success notification
      const fileCount = uploadResults.length;
      const fileText = fileCount === 1 ? 'file' : 'files';
      if (typeof window.showNotification === 'function') {
        window.showNotification(`Successfully submitted ${fileCount} ${fileText}!`, 'success');
      } else {
        alert(`Successfully uploaded ${fileCount} file(s)!`);
      }

      // Reload chat messages to show any updates
      if (selectedChatId) {
        await loadChatMessages(selectedChatId);
      }

    } catch (error) {
      console.error('❌ Error uploading files:', error);
      alert(`Failed to upload files: ${error.message || 'Unknown error'}`);
    } finally {
      // Reset button
      if (button) {
        button.disabled = false;
        button.style.opacity = '1';
        button.textContent = originalText;
      }
      // Remove the file input
      fileInput.remove();
    }
  };

  // Trigger file picker
  document.body.appendChild(fileInput);
  fileInput.click();
};

// Toggle scheduled messages view
window.toggleScheduledMessagesView = function () {
  showScheduledMessagesView = !showScheduledMessagesView;
  window.renderPMTool();
};

// Cancel scheduled message
// Matches the native app's deleteScheduledMessage function exactly
window.cancelScheduledMessage = async function (messageId) {
  console.log('🗑️ cancelScheduledMessage called with messageId:', messageId);

  if (!confirm('Are you sure you want to delete this scheduled message?')) {
    console.log('❌ User cancelled deletion');
    return;
  }

  try {
    console.log('✅ User confirmed deletion');

    // Get chat_id before deletion for reloading
    console.log('🔍 Fetching message data before deletion...');
    const { data: messageData, error: fetchError } = await supabase
      .from('messages')
      .select('chat_id, status, sender_id')
      .eq('id', messageId)
      .single();

    console.log('📋 Message data before delete:', messageData);
    console.log('📋 Fetch error:', fetchError);

    if (fetchError && fetchError.code !== 'PGRST116') {
      console.error('❌ Error fetching message:', fetchError);
      alert('Failed to find message: ' + fetchError.message);
      return;
    }

    if (!messageData) {
      console.warn('⚠️ Message not found, may have already been deleted');
      alert('Message not found. It may have already been deleted.');
      return;
    }

    const chatIdToReload = messageData?.chat_id || selectedChatId;
    console.log('📋 Chat ID to reload:', chatIdToReload);
    console.log('👤 Current user ID:', currentUser?.id);
    console.log('👤 Message sender ID:', messageData?.sender_id);

    // Delete the message - explicitly check sender_id to match RLS policy
    console.log('🗑️ Attempting to delete message...');
    const { data: deleteData, error } = await supabase
      .from('messages')
      .delete()
      .eq('id', messageId)
      .eq('sender_id', currentUser.id)
      .select();

    console.log('🗑️ Delete result - data:', deleteData);
    console.log('🗑️ Delete result - error:', error);

    if (error) {
      console.error('❌ Error deleting scheduled message:', error);
      console.error('❌ Error details:', JSON.stringify(error, null, 2));
      alert('Failed to delete scheduled message: ' + error.message);
      return;
    }

    // Verify deletion by checking if message still exists
    console.log('🔍 Verifying deletion...');
    const { data: verifyData, error: verifyError } = await supabase
      .from('messages')
      .select('id')
      .eq('id', messageId)
      .single();

    console.log('🔍 Verification result - data:', verifyData);
    console.log('🔍 Verification result - error:', verifyError);

    if (verifyData) {
      console.error('❌ Message still exists after delete! This is likely an RLS permissions issue.');
      alert('Failed to delete scheduled message. The message still exists. This might be a permissions issue. Please check your database policies.');
      return;
    }

    console.log('✅ Message successfully deleted');

    // Reload scheduled messages and chat messages
    if (chatIdToReload) {
      console.log('🔄 Reloading scheduled messages and chat messages...');
      await loadScheduledMessages(chatIdToReload);
      await loadChatMessages(chatIdToReload);
    }

    // Force re-render
    console.log('🎨 Re-rendering UI...');
    window.renderPMTool();

    console.log('✅ Delete process completed successfully');
  } catch (error) {
    console.error('❌ Error in cancelScheduledMessage:', error);
    console.error('❌ Error stack:', error.stack);
    alert('An unexpected error occurred: ' + error.message);
  }
};

// Load all calendar events
async function loadCalendarEvents(force = false) {
  if (!currentCompany || !currentUser) return [];

  // Throttle calendar loading to prevent multiple simultaneous calls
  const now = Date.now();
  if (!force && (calendarLoading || (now - lastCalendarLoadTime < CALENDAR_LOAD_THROTTLE_MS))) {
    return calendarEvents; // Return cached events if loading or too soon
  }

  calendarLoading = true;
  lastCalendarLoadTime = now;

  const events = [];
  // Use currentCalendarDate instead of now, so we load events for the displayed month
  const displayMonth = currentCalendarDate.getMonth();
  const displayYear = currentCalendarDate.getFullYear();
  const startOfMonth = new Date(displayYear, displayMonth, 1);
  const endOfMonth = new Date(displayYear, displayMonth + 1, 0, 23, 59, 59);

  // Load tasks with due dates
  const tasksWithDueDates = (tasks || []).filter(task => task.due_at);
  tasksWithDueDates.forEach(task => {
    // Filter by personal/team mode
    if (calendarViewMode === 'personal') {
      // Only show tasks assigned to current user
      const isAssignedToUser = task.assigned_members?.some(member => member.id === currentUser?.id);
      if (!isAssignedToUser) return;
    }

    // Parse due date in local timezone to avoid UTC conversion issues
    let dueDate;
    const dueAtStr = task.due_at.toString().trim();

    // Always parse as local date to avoid timezone issues
    // Check if it's just a date (YYYY-MM-DD) or includes time
    if (/^\d{4}-\d{2}-\d{2}(T|$)/.test(dueAtStr)) {
      // Extract just the date part (YYYY-MM-DD)
      const dateOnly = dueAtStr.split('T')[0].split(' ')[0];
      const dateParts = dateOnly.split('-');
      if (dateParts.length === 3) {
        // Create date in local timezone (month is 0-indexed)
        // Set to local noon to avoid any timezone date shifts (±12 hours from UTC)
        dueDate = new Date(
          parseInt(dateParts[0], 10),
          parseInt(dateParts[1], 10) - 1, // month is 0-indexed
          parseInt(dateParts[2], 10),
          12, 0, 0, 0 // Set to local NOON to prevent date shift across timezones
        );
      } else {
        // Fallback: parse and normalize - USE UTC components to avoid timezone shift
        const tempDate = new Date(task.due_at);
        dueDate = new Date(tempDate.getUTCFullYear(), tempDate.getUTCMonth(), tempDate.getUTCDate(), 12, 0, 0, 0); // NOON in LOCAL, but date from UTC
      }
    } else {
      // Full timestamp: parse and normalize - USE UTC components
      const tempDate = new Date(task.due_at);
      dueDate = new Date(tempDate.getUTCFullYear(), tempDate.getUTCMonth(), tempDate.getUTCDate(), 12, 0, 0, 0); // NOON in LOCAL, but date from UTC
    }

    if (dueDate >= startOfMonth && dueDate <= endOfMonth) {
      events.push({
        id: `task-${task.id}`,
        type: 'task',
        title: task.title,
        description: task.description || null,
        date: dueDate,
        time: null,
        color: '#3b82f6', // Blue for tasks
        priority: task.priority,
        contact: task.contact_name,
        project: task.project_name,
        assignedMembers: task.assigned_members || [],
        rawData: task // Store full task data
      });
    }
  });

  // Load appointments (team = all company, personal = current user only)
  await loadAppointments(calendarViewMode);
  (appointments || []).forEach(apt => {
    if (calendarViewMode === 'personal') {
      if (apt.assigned_to !== currentUser?.id) return;
    }

    if (apt.appointment_date) {
      // Parse appointment_date in local timezone to avoid UTC conversion issues
      // appointment_date is in YYYY-MM-DD format, parse it as local date
      let aptDate;
      const dateParts = apt.appointment_date.split('-');
      if (dateParts.length === 3) {
        // Create date in local timezone (month is 0-indexed)
        aptDate = new Date(
          parseInt(dateParts[0], 10),
          parseInt(dateParts[1], 10) - 1,
          parseInt(dateParts[2], 10),
          12, 0, 0, 0 // NOON
        );
      } else {
        // Fallback to original parsing if format is unexpected
        aptDate = new Date(apt.appointment_date);
        aptDate.setHours(12, 0, 0, 0); // Ensure NOON
      }

      if (aptDate >= startOfMonth && aptDate <= endOfMonth) {
        events.push({
          id: `appointment-${apt.id}`,
          type: 'appointment',
          title: apt.title,
          description: apt.description || apt.notes || null,
          date: aptDate,
          time: apt.start_time,
          duration: apt.duration_minutes || null,
          color: '#10b981', // Green for appointments
          contact: apt.contact ? `${apt.contact.first_name || ''} ${apt.contact.last_name || ''}`.trim() : null,
          rawData: apt // Store full appointment data
        });
      }
    }
  });

  // Load reminders for the displayed month (team = all company, personal = current user only)
  await loadReminders(startOfMonth, endOfMonth, calendarViewMode);
  (reminders || []).forEach(reminder => {
    if (calendarViewMode === 'personal') {
      if (reminder.assigned_to !== currentUser?.id) return;
    }

    if (reminder.due_at) {
      // Parse reminder date in local timezone to avoid UTC conversion issues
      // Use NOON (12:00 PM) to safely land in the correct day regardless of small timezone shifts
      let remDate;
      const dueAtStr = reminder.due_at.toString().trim();
      if (/^\d{4}-\d{2}-\d{2}(T|$)/.test(dueAtStr)) {
        const dateOnly = dueAtStr.split('T')[0].split(' ')[0];
        const dateParts = dateOnly.split('-');
        if (dateParts.length === 3) {
          remDate = new Date(
            parseInt(dateParts[0], 10),
            parseInt(dateParts[1], 10) - 1,
            parseInt(dateParts[2], 10),
            12, 0, 0, 0 // NOON
          );
        } else {
          const tempDate = new Date(reminder.due_at);
          remDate = new Date(tempDate.getUTCFullYear(), tempDate.getUTCMonth(), tempDate.getUTCDate(), 12, 0, 0, 0); // UTC date -> LOCAL noon
        }
      } else {
        const tempDate = new Date(reminder.due_at);
        remDate = new Date(tempDate.getUTCFullYear(), tempDate.getUTCMonth(), tempDate.getUTCDate(), 12, 0, 0, 0); // UTC date -> LOCAL noon
      }

      if (remDate >= startOfMonth && remDate <= endOfMonth) {
        events.push({
          id: `reminder-${reminder.id}`,
          type: 'reminder',
          title: reminder.title,
          description: reminder.description || null,
          date: remDate,
          time: null,
          color: '#f59e0b', // Orange for reminders
          priority: reminder.priority,
          contact: reminder.contact ? `${reminder.contact.first_name || ''} ${reminder.contact.last_name || ''}`.trim() : null,
          rawData: reminder // Store full reminder data
        });
      }
    }
  });

  // Load sales opportunities with follow-up dates
  await loadSalesOpportunities();
  (salesOpportunities || []).forEach(opp => {
    // Show all opportunities regardless of stage, status, or archived status

    // Filter by personal/team mode
    if (calendarViewMode === 'personal') {
      // Only show sales opportunities assigned to current user
      if (opp.user_id !== currentUser?.id && opp.assigned_to !== currentUser?.id) {
        return;
      }
    }

    if (opp.follow_up_date) {
      const followUpDate = new Date(opp.follow_up_date);
      if (followUpDate >= startOfMonth && followUpDate <= endOfMonth) {
        const contactName = opp.contact ? `${opp.contact.first_name || ''} ${opp.contact.last_name || ''}`.trim() : (opp.title || 'Opportunity');
        events.push({
          id: `sales-${opp.id}`,
          type: 'sales',
          title: `Follow up: ${contactName}`,
          description: opp.notes || null,
          date: followUpDate,
          time: opp.follow_up_time || null,
          color: '#8b5cf6', // Purple for sales
          contact: contactName,
          amount: opp.amount || null,
          stage: opp.stage || null,
          rawData: opp // Store full sales opportunity data
        });
      }
    }
  });

  // Load approved time off requests
  try {
    const { data: timeOffData, error: timeOffError } = await supabase
      .from('time_off_requests')
      .select(`
        *,
        profiles!time_off_requests_user_id_fkey (
          id,
          first_name,
          last_name,
          email
        )
      `)
      .eq('company_id', currentCompany.id)
      .eq('status', 'APPROVED');

    if (!timeOffError && timeOffData) {
      timeOffData.forEach(request => {
        // Filter by personal/team mode
        if (calendarViewMode === 'personal') {
          // Only show time off requests for current user
          if (request.user_id !== currentUser?.id) {
            return;
          }
        }

        const startDate = new Date(request.start_date);
        const endDate = new Date(request.end_date);
        const employeeName = request.profiles
          ? `${request.profiles.first_name || ''} ${request.profiles.last_name || ''}`.trim() || request.profiles.email
          : 'Unknown';

        // Create events for each day in the time off range
        const currentDate = new Date(startDate);
        while (currentDate <= endDate) {
          if (currentDate >= startOfMonth && currentDate <= endOfMonth) {
            events.push({
              id: `timeoff-${request.id}-${currentDate.toISOString().split('T')[0]}`,
              type: 'timeoff',
              title: `${employeeName} - ${(window.getRequestTypeLabel || ((type) => {
                const labels = { VACATION: 'Vacation', SICK: 'Sick Leave', PERSONAL: 'Personal', OTHER: 'Other' };
                return labels[type] || type;
              }))(request.request_type)}`,
              description: request.reason || null,
              date: new Date(currentDate),
              time: null,
              color: '#06b6d4', // Cyan for time off
              employee: employeeName,
              requestType: request.request_type,
              rawData: request // Store full time off request data
            });
          }
          currentDate.setDate(currentDate.getDate() + 1);
        }
      });
    }
  } catch (error) {
    console.warn('Error loading time off requests for calendar:', error);
  }

  calendarEvents = events.sort((a, b) => {
    const dateCompare = a.date.getTime() - b.date.getTime();
    if (dateCompare !== 0) return dateCompare;
    if (a.time && b.time) return a.time.localeCompare(b.time);
    if (a.time) return -1;
    if (b.time) return 1;
    return 0;
  });

  calendarLoading = false;
  return calendarEvents;
}

// Format date helper
function formatCalendarDate(date) {
  const months = ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'];
  return `${months[date.getMonth()]}, ${date.getFullYear()}`;
}

// Format time helper - handles both time strings (HH:MM) and date strings (ISO)
function formatTime(timeString) {
  if (!timeString) return '';

  // If it's a date string (contains T or is a full ISO date), extract time first
  if (timeString.includes('T') || timeString.match(/^\d{4}-\d{2}-\d{2}/)) {
    const date = new Date(timeString);
    return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
  }

  // Otherwise treat as time string (HH:MM format)
  const [hours, minutes] = timeString.split(':');
  const hour = parseInt(hours);
  const ampm = hour >= 12 ? 'PM' : 'AM';
  const displayHour = hour % 12 || 12;
  return `${displayHour}:${minutes} ${ampm}`;
}

// Render Calendar Screen
async function renderCalendarScreen() {
  await loadCalendarEvents();

  const today = new Date();
  const currentMonth = currentCalendarDate.getMonth();
  const currentYear = currentCalendarDate.getFullYear();
  const firstDay = new Date(currentYear, currentMonth, 1);
  const lastDay = new Date(currentYear, currentMonth + 1, 0);
  const daysInMonth = lastDay.getDate();
  const startingDayOfWeek = firstDay.getDay();

  // Get upcoming events (next 5)
  const upcomingEvents = calendarEvents
    .filter(e => e.date >= today)
    .slice(0, 5);

  // Get events for mini calendar
  const eventsByDate = {};
  calendarEvents.forEach(event => {
    const dateKey = `${event.date.getFullYear()}-${event.date.getMonth()}-${event.date.getDate()}`;
    if (!eventsByDate[dateKey]) eventsByDate[dateKey] = [];
    eventsByDate[dateKey].push(event);
  });

  // Generate calendar days
  const calendarDays = [];
  // Add empty cells for days before month starts
  for (let i = 0; i < startingDayOfWeek; i++) {
    calendarDays.push(null);
  }
  // Add days of the month
  for (let day = 1; day <= daysInMonth; day++) {
    calendarDays.push(day);
  }

  // Get user profile data
  const userInitials = `${(currentProfile?.first_name || 'U').charAt(0)}${(currentProfile?.last_name || '').charAt(0)}`.toUpperCase();
  const userName = `${currentProfile?.first_name || 'User'} ${currentProfile?.last_name || ''}`.trim();
  const avatarPath = currentProfile?.avatar_path || currentUser?.avatar_path;
  const avatarUrl = avatarPath ? getAvatarUrl(avatarPath) : null;

  return `
    <style>
      @media (max-width: 1024px) {
        .calendar-container {
          flex-direction: column !important;
          gap: 1rem !important;
        }
        .calendar-sidebar {
          width: 100% !important;
          min-width: 0 !important;
          order: 2 !important;
        }
        .calendar-main {
          width: 100% !important;
          min-width: 0 !important;
          order: 1 !important;
        }
        .calendar-header {
          flex-direction: column !important;
          gap: 0.75rem !important;
          align-items: stretch !important;
          padding: 1rem !important;
        }
        .calendar-header-controls {
          flex-wrap: wrap !important;
          width: 100% !important;
          justify-content: center !important;
          gap: 0.5rem !important;
        }
        .calendar-grid {
          gap: 0.25rem !important;
        }
        .calendar-grid .day-header {
          padding: 0.5rem 0.25rem !important;
          font-size: 0.7rem !important;
        }
        .calendar-grid .day-cell {
          min-height: 50px !important;
          padding: 0.25rem !important;
        }
        .calendar-grid .day-number {
          font-size: 0.7rem !important;
        }
      }
      @media (max-width: 600px) {
        .calendar-grid .day-cell {
          min-height: 40px !important;
        }
        .calendar-header-controls button {
          padding: 0.375rem 0.75rem !important;
          font-size: 0.75rem !important;
        }
      }
    </style>
    <div style="
      width: 100%;
      height: calc(100vh - 120px);
      overflow-x: hidden;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      scrollbar-width: thin;
      scrollbar-color: #f59e0b #f8f9fa;
      padding: 1rem;
      box-sizing: border-box;
    ">
      <div class="calendar-container" style="display: flex; gap: 1.5rem; max-width: 1400px; margin: 0 auto; align-items: flex-start;">
      <!-- Left Sidebar -->
      <div class="calendar-sidebar" style="
        width: 320px;
        min-width: 280px;
        flex-shrink: 0;
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
      ">
        <!-- User Profile -->
        <div style="
          background: #ffffff;
          border-radius: 0.75rem;
          padding: 1.5rem;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        ">
          <div style="display: flex; align-items: center; gap: 1rem; margin-bottom: 1rem;">
            ${avatarUrl ? `
            <img
              src="${avatarUrl}"
              alt="${userName}"
              style="
                width: 48px;
                height: 48px;
                border-radius: 50%;
                object-fit: cover;
              "
              onerror="
                this.style.display='none';
                const fallback = this.nextElementSibling;
                if (fallback) fallback.style.display='flex';
              "
            />
            ` : ''}
            <div style="
              width: 48px;
              height: 48px;
              border-radius: 50%;
              background: #f59e0b;
              color: white;
              display: ${avatarUrl ? 'none' : 'flex'};
              align-items: center;
              justify-content: center;
              font-weight: 600;
              font-size: 1.125rem;
            ">${userInitials}</div>
            <div style="flex: 1;">
              <div style="font-weight: 600; color: #2c3e50; margin-bottom: 0.25rem;">${userName}</div>
            </div>
          </div>
        </div>
        
        <!-- Quick Actions -->
        <div style="
          background: #ffffff;
          border-radius: 0.75rem;
          padding: 1.5rem;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        ">
          <div style="
            display: flex;
            gap: 0.75rem;
            flex-direction: column;
          ">
            <button 
              onclick="showAddAppointmentModalFromCalendar()"
              style="
                background: #fef3c7;
                color: #f59e0b;
                border: none;
                padding: 0.5rem 1rem;
                border-radius: 0.375rem;
                cursor: pointer;
                font-size: 0.875rem;
                font-weight: 500;
                display: flex;
                align-items: center;
                gap: 0.375rem;
                justify-content: center;
                width: 100%;
              "
              onmouseover="this.style.background='#fde68a'"
              onmouseout="this.style.background='#fef3c7'"
            >
              + Add Appointment
            </button>
            <button 
              onclick="showAddReminderModalFromCalendar()"
              style="
                background: #fef3c7;
                color: #f59e0b;
                border: none;
                padding: 0.5rem 1rem;
                border-radius: 0.375rem;
                cursor: pointer;
                font-size: 0.875rem;
                font-weight: 500;
                display: flex;
                align-items: center;
                gap: 0.375rem;
                justify-content: center;
                width: 100%;
              "
              onmouseover="this.style.background='#fde68a'"
              onmouseout="this.style.background='#fef3c7'"
            >
              + Add Reminder
            </button>
          </div>
        </div>
        
        <!-- Upcoming Event -->
        ${upcomingEvents.length > 0 ? `
        <div style="
          background: #ffffff;
          border-radius: 0.75rem;
          padding: 1.5rem;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        ">
          <div style="font-size: 0.875rem; font-weight: 600; color: #6c757d; margin-bottom: 1rem; text-transform: uppercase; letter-spacing: 0.05em;">Upcoming event</div>
          <div style="display: flex; align-items: center; gap: 1rem;">
            <div style="
              width: 40px;
              height: 40px;
              border-radius: 0.5rem;
              background: #3b82f6;
              color: white;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 1.25rem;
            ">📹</div>
            <div style="flex: 1;">
              <div style="font-weight: 600; color: #2c3e50; margin-bottom: 0.25rem;">${upcomingEvents[0].title}</div>
              <div style="font-size: 0.875rem; color: #6c757d;">
                ${upcomingEvents[0].date.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' })}, ${upcomingEvents[0].time ? formatTime(upcomingEvents[0].time) : 'All day'}
              </div>
            </div>
          </div>
        </div>
        ` : ''}
        
        <!-- Mini Calendar -->
        <div style="
          background: #ffffff;
          border-radius: 0.75rem;
          padding: 1.5rem;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        ">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
            <div style="font-weight: 600; color: #2c3e50;">${formatCalendarDate(currentCalendarDate)}</div>
            <div style="display: flex; gap: 0.5rem;">
              <button onclick="changeCalendarNavigation(-1)" style="
                width: 28px;
                height: 28px;
                border: none;
                background: transparent;
                cursor: pointer;
                color: #6c757d;
                font-size: 1rem;
              ">&lt;</button>
              <button onclick="changeCalendarNavigation(1)" style="
                width: 28px;
                height: 28px;
                border: none;
                background: transparent;
                cursor: pointer;
                color: #6c757d;
                font-size: 1rem;
              ">&gt;</button>
            </div>
          </div>
          <div style="display: grid; grid-template-columns: repeat(7, 1fr); gap: 0.25rem; margin-bottom: 0.5rem;">
            ${['M', 'T', 'W', 'T', 'F', 'S', 'S'].map(day => `
              <div style="
                text-align: center;
                font-size: 0.75rem;
                font-weight: 600;
                color: #6c757d;
                padding: 0.5rem 0;
              ">${day}</div>
            `).join('')}
          </div>
          <div style="display: grid; grid-template-columns: repeat(7, 1fr); gap: 0.25rem;">
            ${calendarDays.map((day, index) => {
    if (day === null) return '<div></div>';
    const dateKey = `${currentYear}-${currentMonth}-${day}`;
    const dayEvents = eventsByDate[dateKey] || [];
    const isToday = day === today.getDate() && currentMonth === today.getMonth() && currentYear === today.getFullYear();
    const dayDate = new Date(currentYear, currentMonth, day);
    const isWeekend = dayDate.getDay() === 0 || dayDate.getDay() === 6;

    return `
                <div 
                  onclick="hideCalendarEventHover(); showDaySchedule(${currentYear}, ${currentMonth}, ${day});"
                  style="
                  aspect-ratio: 1;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                  border-radius: 0.5rem;
                  cursor: pointer;
                  position: relative;
                  background: ${isToday ? '#1e293b' : 'transparent'};
                  color: ${isToday ? 'white' : isWeekend ? '#ef4444' : '#2c3e50'};
                  font-weight: ${isToday ? '600' : '500'};
                  font-size: 0.875rem;
                  transition: all 0.2s;
                " onmouseover="this.style.background='${isToday ? '#1e293b' : '#f3f4f6'}'; this.style.transform='scale(1.1)'" onmouseout="this.style.background='${isToday ? '#1e293b' : 'transparent'}'; this.style.transform='scale(1)'">
                  ${day}
                  ${dayEvents.length > 0 ? `
                    <div style="
                      position: absolute;
                      bottom: 2px;
                      display: flex;
                      gap: 2px;
                      justify-content: center;
                    ">
                      ${dayEvents.slice(0, 3).map((e, i) => `
                        <div style="
                          width: 4px;
                          height: 4px;
                          border-radius: 50%;
                          background: ${e.color};
                        "></div>
                      `).join('')}
                    </div>
                  ` : ''}
                </div>
              `;
  }).join('')}
          </div>
        </div>
        
        <!-- Upcoming Events -->
        <div style="
          background: #ffffff;
          border-radius: 0.75rem;
          padding: 1.5rem;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        ">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
            <div style="font-weight: 600; color: #2c3e50;">Upcoming Events</div>
            <div style="color: #6c757d; cursor: pointer;">⌃</div>
          </div>
          ${[
      { name: 'Reminders', color: '#f59e0b', count: calendarEvents.filter(e => e.type === 'reminder').length },
      { name: 'Appointments', color: '#10b981', count: calendarEvents.filter(e => e.type === 'appointment').length },
      { name: 'Sales Opportunities', color: '#8b5cf6', count: calendarEvents.filter(e => e.type === 'sales').length },
      { name: 'Tasks', color: '#3b82f6', count: calendarEvents.filter(e => e.type === 'task').length }
    ].map(cat => {
      const total = calendarEvents.length || 1;
      const percentage = (cat.count / total) * 100;
      return `
              <div style="margin-bottom: 1rem;">
                <div style="display: flex; justify-content: space-between; margin-bottom: 0.5rem;">
                  <div style="font-size: 0.875rem; color: #2c3e50;">${cat.name}</div>
                  <div style="font-size: 0.875rem; color: #6c757d; font-weight: 600;">${cat.count}</div>
                </div>
                <div style="
                  width: 100%;
                  height: 6px;
                  background: #f3f4f6;
                  border-radius: 3px;
                  overflow: hidden;
                ">
                  <div style="
                    width: ${percentage}%;
                    height: 100%;
                    background: ${cat.color};
                    border-radius: 3px;
                    transition: width 0.3s;
                  "></div>
                </div>
              </div>
            `;
    }).join('')}
        </div>
      </div>
      
      <!-- Main Calendar View -->
      <div class="calendar-main" style="
        flex: 1;
        min-width: 0;
        max-width: 100%;
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
        overflow-x: hidden;
      ">
        <!-- Calendar Header -->
        <div class="calendar-header" style="
          background: #ffffff;
          border-radius: 0.75rem;
          padding: 1.5rem;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 1rem;
        ">
          <div style="font-size: 1.5rem; font-weight: 700; color: #2c3e50;">${formatCalendarDate(currentCalendarDate)}</div>
          <div class="calendar-header-controls" style="display: flex; gap: 1rem; align-items: center; flex-wrap: wrap;">
            ${(currentProfile?.is_hh_admin || currentUser?.is_hh_admin) ? `
            <button onclick="switchScreen('google-calendar-integration')" style="
              padding: 0.5rem 1rem;
              border: none;
              background: #FF6B35;
              color: white;
              border-radius: 0.5rem;
              cursor: pointer;
              font-weight: 600;
              font-size: 0.875rem;
              display: flex;
              align-items: center;
              gap: 0.5rem;
              transition: all 0.2s;
            " title="Google Calendar Integration">
              Sync
            </button>
            ` : ''}
            <div style="display: flex; gap: 0.5rem; background: #f3f4f6; padding: 0.25rem; border-radius: 0.5rem;">
              <button onclick="setCalendarViewMode('personal')" style="
                padding: 0.5rem 1rem;
                border: none;
                background: ${calendarViewMode === 'personal' ? '#EF4444' : 'transparent'};
                color: ${calendarViewMode === 'personal' ? '#ffffff' : '#6c757d'};
                border-radius: 0.375rem;
                cursor: pointer;
                font-weight: ${calendarViewMode === 'personal' ? '600' : '500'};
                font-size: 0.875rem;
                transition: all 0.2s;
              ">Personal</button>
              <button onclick="setCalendarViewMode('team')" style="
                padding: 0.5rem 1rem;
                border: none;
                background: ${calendarViewMode === 'team' ? '#EF4444' : 'transparent'};
                color: ${calendarViewMode === 'team' ? '#ffffff' : '#6c757d'};
                border-radius: 0.375rem;
                cursor: pointer;
                font-weight: ${calendarViewMode === 'team' ? '600' : '500'};
                font-size: 0.875rem;
                transition: all 0.2s;
              ">Team</button>
            </div>
            <div style="display: flex; gap: 0.5rem; background: #f3f4f6; padding: 0.25rem; border-radius: 0.5rem;">
              <button onclick="setCalendarView('month')" style="
                padding: 0.5rem 1rem;
                border: none;
                background: ${calendarView === 'month' ? '#ffffff' : 'transparent'};
                color: ${calendarView === 'month' ? '#2c3e50' : '#6c757d'};
                border-radius: 0.375rem;
                cursor: pointer;
                font-weight: ${calendarView === 'month' ? '600' : '500'};
                font-size: 0.875rem;
                transition: all 0.2s;
              ">Month</button>
              <button onclick="setCalendarView('week')" style="
                padding: 0.5rem 1rem;
                border: none;
                background: ${calendarView === 'week' ? '#ffffff' : 'transparent'};
                color: ${calendarView === 'week' ? '#2c3e50' : '#6c757d'};
                border-radius: 0.375rem;
                cursor: pointer;
                font-weight: ${calendarView === 'week' ? '600' : '500'};
                font-size: 0.875rem;
                transition: all 0.2s;
              ">Week</button>
            </div>
            <div style="display: flex; gap: 0.5rem;">
              <button onclick="changeCalendarNavigation(-1)" style="
                width: 36px;
                height: 36px;
                border: 1px solid #e5e7eb;
                background: white;
                border-radius: 0.5rem;
                cursor: pointer;
                color: #6c757d;
                font-size: 1rem;
                display: flex;
                align-items: center;
                justify-content: center;
              ">&lt;</button>
              <button onclick="goToToday()" style="
                padding: 0.5rem 1rem;
                border: 1px solid #e5e7eb;
                background: white;
                border-radius: 0.5rem;
                cursor: pointer;
                color: #2c3e50;
                font-weight: 500;
                font-size: 0.875rem;
              ">Today</button>
              <button onclick="changeCalendarNavigation(1)" style="
                width: 36px;
                height: 36px;
                border: 1px solid #e5e7eb;
                background: white;
                border-radius: 0.5rem;
                cursor: pointer;
                color: #6c757d;
                font-size: 1rem;
                display: flex;
                align-items: center;
                justify-content: center;
              ">&gt;</button>
            </div>
          </div>
        </div>
        
        <!-- Calendar Grid -->
        <div class="calendar-grid-container" style="
          background: #ffffff;
          border-radius: 0.75rem;
          padding: 1rem;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
          flex: 1;
          overflow-x: auto;
        ">
          ${calendarView === 'month' ? renderMonthView(calendarEvents, currentYear, currentMonth, today) : ''}
          ${calendarView === 'week' ? renderWeekView(calendarEvents, currentCalendarDate, today) : ''}
        </div>
      </div>
      
      </div>
      <!-- Event Details Modal -->
      ${renderCalendarEventDetailsModal()}
      
      <!-- Hover Preview Tooltip -->
      ${renderCalendarEventHoverPreview()}
    </div>
  `;
}

// Render month view
function renderMonthView(events, year, month, today) {
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  const daysInMonth = lastDay.getDate();
  const startingDayOfWeek = firstDay.getDay();

  const calendarDays = [];
  for (let i = 0; i < startingDayOfWeek; i++) {
    calendarDays.push(null);
  }
  for (let day = 1; day <= daysInMonth; day++) {
    calendarDays.push(day);
  }

  const eventsByDate = {};
  events.forEach(event => {
    const dateKey = `${event.date.getFullYear()}-${event.date.getMonth()}-${event.date.getDate()}`;
    if (!eventsByDate[dateKey]) eventsByDate[dateKey] = [];
    eventsByDate[dateKey].push(event);
  });

  const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  return `
    <style>
      @media (max-width: 768px) {
        .calendar-grid {
          gap: 0.25rem !important;
        }
        .calendar-grid .day-header {
          padding: 0.5rem 0.25rem !important;
          font-size: 0.75rem !important;
        }
        .calendar-grid .day-cell {
          min-height: 60px !important;
          padding: 0.25rem !important;
        }
        .calendar-grid .day-number {
          font-size: 0.75rem !important;
        }
        .calendar-grid .event-dot {
          width: 6px !important;
          height: 6px !important;
        }
      }
    </style>
    <div class="calendar-grid" style="display: grid; grid-template-columns: repeat(7, 1fr); gap: 0.25rem; min-width: 280px;">
      ${dayNames.map(day => `
        <div class="day-header" style="
          padding: 0.5rem 0.25rem;
          text-align: center;
          font-weight: 600;
          color: #6c757d;
          font-size: 0.75rem;
          border-bottom: 2px solid #f3f4f6;
        ">${day.substring(0, 3)}</div>
      `).join('')}
      ${calendarDays.map((day, index) => {
    if (day === null) {
      return '<div class="day-cell" style="min-height: 80px; border: 1px solid #f3f4f6; border-radius: 0.5rem;"></div>';
    }

    const dateKey = `${year}-${month}-${day}`;
    const dayEvents = eventsByDate[dateKey] || [];
    const isToday = day === today.getDate() && month === today.getMonth() && year === today.getFullYear();
    const dayDate = new Date(year, month, day);

    return `
          <div 
            class="day-cell" 
            onclick="hideCalendarEventHover(); window.showDaySchedule(${year}, ${month}, ${day});"
            style="
              min-height: 80px;
              border: 1px solid #f3f4f6;
              border-radius: 0.5rem;
              padding: 0.5rem;
              background: ${isToday ? '#fef3c7' : 'white'};
              position: relative;
              overflow: hidden;
              cursor: pointer;
              transition: all 0.2s;
            "
            onmouseover="this.style.borderColor='#3b82f6'; this.style.boxShadow='0 2px 4px rgba(59, 130, 246, 0.1)';"
            onmouseout="this.style.borderColor='#f3f4f6'; this.style.boxShadow='none';"
          >
            <div class="day-number" style="
              font-weight: ${isToday ? '700' : '600'};
              color: ${isToday ? '#92400e' : '#2c3e50'};
              margin-bottom: 0.25rem;
              font-size: 0.75rem;
            ">${day}</div>
            <div style="display: flex; flex-direction: column; gap: 0.25rem;">
              ${dayEvents.slice(0, 3).map(event => `
                <div 
                  onmouseenter="showCalendarEventHover('${event.id}', this)"
                  onmouseleave="hideCalendarEventHover()"
                  style="
                    background: ${event.color}20;
                    border-left: 3px solid ${event.color};
                    padding: 0.375rem 0.5rem;
                    border-radius: 0.25rem;
                    font-size: 0.75rem;
                    color: #2c3e50;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    transition: all 0.2s;
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                  " title="${event.title}${event.time ? ' - ' + formatTime(event.time) : ''}">
                  <span style="flex: 1; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    ${event.time ? formatTime(event.time) + ' ' : ''}${event.title}
                  </span>
                  ${event.assignedMembers && event.assignedMembers.length > 0 ? `
                    <div style="display: flex; align-items: center; gap: -4px; flex-shrink: 0;">
                      ${event.assignedMembers.slice(0, 2).map((member, idx) => {
      const initials = `${(member.first_name || '').charAt(0)}${(member.last_name || '').charAt(0)}`.toUpperCase() || 'U';
      const avatarUrl = member.avatar_path ? getAvatarUrl(member.avatar_path) : null;
      return `
                          <div style="
                            width: 20px;
                            height: 20px;
                            border-radius: 50%;
                            border: 1.5px solid white;
                            background: ${avatarUrl ? 'transparent' : '#f59e0b'};
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            color: white;
                            font-weight: 600;
                            font-size: 0.625rem;
                            margin-left: ${idx > 0 ? '-6px' : '0'};
                            overflow: hidden;
                            z-index: ${2 - idx};
                            position: relative;
                          ">
                            ${avatarUrl ? `
                              <img src="${avatarUrl}" alt="${member.first_name}" style="width: 100%; height: 100%; object-fit: cover;" onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';" />
                              <div style="display: none; width: 100%; height: 100%; align-items: center; justify-content: center; background: #f59e0b; color: white; font-size: 0.625rem;">${initials}</div>
                            ` : initials}
                          </div>
                        `;
    }).join('')}
                    </div>
                  ` : ''}
                </div>
              `).join('')}
              ${dayEvents.length > 3 ? `
                <div style="
                  font-size: 0.75rem;
                  color: #6c757d;
                  padding: 0.25rem;
                  text-align: center;
                ">+${dayEvents.length - 3} more</div>
              ` : ''}
            </div>
          </div>
        `;
  }).join('')}
    </div>
  `;
}

// Render week view
function renderWeekView(events, currentDate, today) {
  const startOfWeek = new Date(currentDate);
  const day = startOfWeek.getDay();
  const diff = startOfWeek.getDate() - day;
  startOfWeek.setDate(diff);
  startOfWeek.setHours(0, 0, 0, 0);

  const weekDays = [];
  for (let i = 0; i < 7; i++) {
    const date = new Date(startOfWeek);
    date.setDate(startOfWeek.getDate() + i);
    weekDays.push(date);
  }

  const timeSlots = [];
  for (let hour = 8; hour <= 20; hour++) {
    timeSlots.push(hour);
  }

  const eventsByDate = {};
  events.forEach(event => {
    const dateKey = `${event.date.getFullYear()}-${event.date.getMonth()}-${event.date.getDate()}`;
    if (!eventsByDate[dateKey]) eventsByDate[dateKey] = [];
    eventsByDate[dateKey].push(event);
  });

  return `
    <div style="display: grid; grid-template-columns: 80px repeat(7, 1fr); gap: 0.5rem;">
      <div></div>
      ${weekDays.map(day => {
    const isToday = day.toDateString() === today.toDateString();
    return `
          <div style="
            padding: 1rem;
            text-align: center;
            border-bottom: 2px solid #f3f4f6;
            background: ${isToday ? '#1e293b' : 'transparent'};
            color: ${isToday ? 'white' : '#2c3e50'};
            border-radius: ${isToday ? '0.5rem 0.5rem 0 0' : '0'};
          ">
            <div style="font-size: 0.75rem; color: ${isToday ? '#94a3b8' : '#6c757d'}; margin-bottom: 0.25rem;">
              ${day.toLocaleDateString('en-US', { weekday: 'short' })}
            </div>
            <div style="font-weight: 700; font-size: 1.125rem;">
              ${day.getDate()}
            </div>
          </div>
        `;
  }).join('')}
      ${timeSlots.map(hour => `
        <div style="
          padding: 0.5rem;
          font-size: 0.75rem;
          color: #6c757d;
          text-align: right;
          border-right: 1px solid #f3f4f6;
        ">${formatTime(`${hour.toString().padStart(2, '0')}:00`)}</div>
        ${weekDays.map(day => {
    const dateKey = `${day.getFullYear()}-${day.getMonth()}-${day.getDate()}`;
    const dayEvents = (eventsByDate[dateKey] || []).filter(e => {
      // For events without time, show them at the first hour slot (8 AM)
      if (!e.time) {
        return hour === 8;
      }
      const [eventHour] = e.time.split(':');
      return parseInt(eventHour) === hour;
    });

    return `
            <div style="
              min-height: 60px;
              border: 1px solid #f3f4f6;
              border-left: none;
              padding: 0.25rem;
              position: relative;
            ">
              ${dayEvents.map(event => `
                <div 
                  onmouseenter="showCalendarEventHover('${event.id}', this)"
                  onmouseleave="hideCalendarEventHover()"
                  style="
                    background: ${event.color}20;
                    border-left: 3px solid ${event.color};
                    padding: 0.5rem;
                    border-radius: 0.25rem;
                    margin-bottom: 0.25rem;
                    font-size: 0.75rem;
                    color: #2c3e50;
                    transition: all 0.2s;
                  " title="${event.title}">
                  <div style="font-weight: 600;">${formatTime(event.time)}</div>
                  <div style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${event.title}</div>
                  ${event.assignedMembers && event.assignedMembers.length > 0 ? `
                    <div style="display: flex; align-items: center; gap: -4px; margin-top: 0.25rem;">
                      ${event.assignedMembers.slice(0, 3).map((member, idx) => {
      const initials = `${(member.first_name || '').charAt(0)}${(member.last_name || '').charAt(0)}`.toUpperCase() || 'U';
      const avatarUrl = member.avatar_path ? getAvatarUrl(member.avatar_path) : null;
      return `
                          <div style="
                            width: 18px;
                            height: 18px;
                            border-radius: 50%;
                            border: 1.5px solid white;
                            background: ${avatarUrl ? 'transparent' : '#f59e0b'};
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            color: white;
                            font-weight: 600;
                            font-size: 0.5rem;
                            margin-left: ${idx > 0 ? '-4px' : '0'};
                            overflow: hidden;
                            z-index: ${3 - idx};
                            position: relative;
                          ">
                            ${avatarUrl ? `
                              <img src="${avatarUrl}" alt="${member.first_name}" style="width: 100%; height: 100%; object-fit: cover;" onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';" />
                              <div style="display: none; width: 100%; height: 100%; align-items: center; justify-content: center; background: #f59e0b; color: white; font-size: 0.5rem;">${initials}</div>
                            ` : initials}
                          </div>
                        `;
    }).join('')}
                    </div>
                  ` : ''}
                </div>
              `).join('')}
            </div>
          `;
  }).join('')}
      `).join('')}
    </div>
  `;
}

// Render day view
function renderDayView(events, currentDate, today) {
  const isToday = currentDate.toDateString() === today.toDateString();
  const dateKey = `${currentDate.getFullYear()}-${currentDate.getMonth()}-${currentDate.getDate()}`;
  const dayEvents = events.filter(e => {
    const eDateKey = `${e.date.getFullYear()}-${e.date.getMonth()}-${e.date.getDate()}`;
    return eDateKey === dateKey;
  });

  const timeSlots = [];
  for (let hour = 8; hour <= 20; hour++) {
    timeSlots.push(hour);
  }

  return `
    <div style="display: grid; grid-template-columns: 80px 1fr; gap: 0.5rem;">
      <div></div>
      <div style="
        padding: 1rem;
        text-align: center;
        border-bottom: 2px solid #f3f4f6;
        background: ${isToday ? '#1e293b' : 'transparent'};
        color: ${isToday ? 'white' : '#2c3e50'};
        border-radius: ${isToday ? '0.5rem 0.5rem 0 0' : '0'};
        font-weight: 700;
        font-size: 1.25rem;
      ">
        ${currentDate.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })}
      </div>
      ${timeSlots.map(hour => `
        <div style="
          padding: 0.5rem;
          font-size: 0.75rem;
          color: #6c757d;
          text-align: right;
          border-right: 1px solid #f3f4f6;
        ">${formatTime(`${hour.toString().padStart(2, '0')}:00`)}</div>
        <div style="
          min-height: 60px;
          border: 1px solid #f3f4f6;
          border-left: none;
          padding: 0.5rem;
          position: relative;
        ">
          ${dayEvents.filter(e => {
    if (!e.time) return false;
    const [eventHour] = e.time.split(':');
    return parseInt(eventHour) === hour;
  }).map(event => `
            <div 
              onmouseenter="showCalendarEventHover('${event.id}')"
              onmouseleave="hideCalendarEventHover()"
              style="
                background: ${event.color}20;
                border-left: 3px solid ${event.color};
                padding: 0.75rem;
                border-radius: 0.5rem;
                margin-bottom: 0.5rem;
                transition: all 0.2s;
              " title="${event.title}">
              <div style="font-weight: 600; color: #2c3e50; margin-bottom: 0.25rem;">${event.title}</div>
              <div style="font-size: 0.75rem; color: #6c757d; margin-bottom: 0.25rem;">
                ${formatTime(event.time)} ${event.contact ? '• ' + event.contact : ''}
              </div>
              ${event.assignedMembers && event.assignedMembers.length > 0 ? `
                <div style="display: flex; align-items: center; gap: -4px; margin-top: 0.5rem;">
                  ${event.assignedMembers.slice(0, 3).map((member, idx) => {
    const initials = `${(member.first_name || '').charAt(0)}${(member.last_name || '').charAt(0)}`.toUpperCase() || 'U';
    const avatarUrl = member.avatar_path ? getAvatarUrl(member.avatar_path) : null;
    return `
                      <div style="
                        width: 24px;
                        height: 24px;
                        border-radius: 50%;
                        border: 2px solid white;
                        background: ${avatarUrl ? 'transparent' : '#f59e0b'};
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        color: white;
                        font-weight: 600;
                        font-size: 0.625rem;
                        margin-left: ${idx > 0 ? '-6px' : '0'};
                        overflow: hidden;
                        z-index: ${3 - idx};
                        position: relative;
                      ">
                        ${avatarUrl ? `
                          <img src="${avatarUrl}" alt="${member.first_name}" style="width: 100%; height: 100%; object-fit: cover;" onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';" />
                          <div style="display: none; width: 100%; height: 100%; align-items: center; justify-content: center; background: #f59e0b; color: white; font-size: 0.625rem;">${initials}</div>
                        ` : initials}
                      </div>
                    `;
  }).join('')}
                </div>
              ` : ''}
            </div>
          `).join('')}
        </div>
      `).join('')}
    </div>
  `;
}

// Calendar navigation functions
window.changeCalendarMonth = function (delta) {
  currentCalendarDate = new Date(currentCalendarDate.getFullYear(), currentCalendarDate.getMonth() + delta, 1);
  renderPMTool();
};

// Unified navigation function that handles both month and week views
window.changeCalendarNavigation = function (delta) {
  if (calendarView === 'week') {
    // Change by weeks
    const newDate = new Date(currentCalendarDate);
    newDate.setDate(newDate.getDate() + (delta * 7));
    currentCalendarDate = newDate;
  } else {
    // Change by months (default)
    const newDate = new Date(currentCalendarDate.getFullYear(), currentCalendarDate.getMonth() + delta, 1);
    currentCalendarDate = newDate;
  }
  // Force reload to bypass throttle
  loadCalendarEvents(true).then(() => {
    renderPMTool();
  });
};

window.setCalendarViewMode = function (mode) {
  calendarViewMode = mode;
  loadCalendarEvents(true).then(() => {
    renderPMTool();
  });
};

window.setCalendarView = function (view) {
  calendarView = view;
  loadCalendarEvents(true).then(() => {
    renderPMTool();
  });
};

window.goToToday = function () {
  currentCalendarDate = new Date();
  renderPMTool();
};

// Show calendar event details modal
window.showCalendarEventDetails = function (eventId) {
  // Hide hover tooltip when clicking
  hideCalendarEventHover();

  const event = calendarEvents.find(e => e.id === eventId);
  if (!event) return;

  selectedCalendarEvent = event;
  renderPMTool();
};

// Helper function to render avatars
function renderAvatars(members, maxVisible = 3) {
  if (!members || members.length === 0) return '';

  const visible = members.slice(0, maxVisible);
  const remaining = members.length - maxVisible;

  return `
    <div style="display: flex; align-items: center; gap: -0.5rem;">
      ${visible.map((member, index) => {
    const initials = `${(member.first_name || '').charAt(0)}${(member.last_name || '').charAt(0)}`.toUpperCase() || 'U';
    const avatarUrl = member.avatar_path ? getAvatarUrl(member.avatar_path) : null;
    const zIndex = maxVisible - index;

    return `
          <div style="
            width: 32px;
            height: 32px;
            border-radius: 50%;
            border: 2px solid white;
            background: ${avatarUrl ? 'transparent' : '#f59e0b'};
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-weight: 600;
            font-size: 0.75rem;
            position: relative;
            z-index: ${zIndex};
            margin-left: ${index > 0 ? '-8px' : '0'};
            overflow: hidden;
          ">
            ${avatarUrl ? `
              <img
                src="${avatarUrl}"
                alt="${member.first_name} ${member.last_name}"
                style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%;"
                onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';"
              />
              <div style="display: none; width: 100%; height: 100%; align-items: center; justify-content: center; background: #f59e0b; color: white; font-weight: 600; font-size: 0.75rem;">
                ${initials}
              </div>
            ` : initials}
          </div>
        `;
  }).join('')}
      ${remaining > 0 ? `
        <div style="
          width: 32px;
          height: 32px;
          border-radius: 50%;
          border: 2px dashed #d1d5db;
          background: #f9fafb;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #6c757d;
          font-weight: 600;
          font-size: 0.75rem;
          margin-left: -8px;
        ">+${remaining}</div>
      ` : ''}
    </div>
  `;
}

// Render calendar event details modal
function renderCalendarEventDetailsModal() {
  // Individual event modal disabled - only day popup is used
  return '';

  const event = selectedCalendarEvent;
  const eventDate = event.date.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
  const eventDateShort = event.date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });

  // Get tags/categories based on event type
  let tags = [];
  if (event.type === 'task') {
    const task = event.rawData;
    if (task.priority) tags.push({ label: task.priority, color: event.color });
    if (task.project_name) tags.push({ label: task.project_name, color: '#10b981' });
    if (task.state) tags.push({ label: task.state, color: '#6b7280' });
  } else if (event.type === 'appointment') {
    const apt = event.rawData;
    tags.push({ label: 'Appointment', color: '#10b981' });
    if (apt.status) tags.push({ label: apt.status, color: '#6b7280' });
  } else if (event.type === 'reminder') {
    const reminder = event.rawData;
    if (reminder.priority) tags.push({ label: reminder.priority, color: event.color });
    if (reminder.type) tags.push({ label: reminder.type, color: '#6b7280' });
  } else if (event.type === 'sales') {
    const opp = event.rawData;
    if (opp.stage) tags.push({ label: opp.stage, color: event.color });
    if (opp.chance) tags.push({ label: `${opp.chance}% chance`, color: '#6b7280' });
  }

  // Get attendees/assignees
  let attendees = [];
  if (event.type === 'task' && event.assignedMembers) {
    attendees = event.assignedMembers;
  } else if (event.type === 'appointment' && event.rawData?.assigned_user) {
    attendees = [event.rawData.assigned_user];
  }

  // Calculate end time for appointments
  let endTime = null;
  if (event.type === 'appointment' && event.time && event.rawData?.duration_minutes) {
    const [hours, minutes] = event.time.split(':');
    const startDate = new Date();
    startDate.setHours(parseInt(hours), parseInt(minutes), 0, 0);
    startDate.setMinutes(startDate.getMinutes() + event.rawData.duration_minutes);
    endTime = formatTime(`${startDate.getHours().toString().padStart(2, '0')}:${startDate.getMinutes().toString().padStart(2, '0')}`);
  }

  return `
    <div id="calendar-event-modal" style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10000;
      padding: 1rem;
    " onclick="if(event.target.id === 'calendar-event-modal') { window.closeCalendarEventModal(); }">
      <div style="
        background: white;
        border-radius: 1rem;
        padding: 2rem;
        max-width: 500px;
        width: 100%;
        max-height: 90vh;
        overflow-y: auto;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
      " onclick="event.stopPropagation()">
        <!-- Header with close button -->
        <div style="display: flex; justify-content: space-between; align-items: start; margin-bottom: 2rem;">
          <h2 style="
            margin: 0;
            color: #2c3e50;
            font-size: 1.5rem;
            font-weight: 700;
            flex: 1;
          ">${event.title}</h2>
          <button onclick="window.closeCalendarEventModal();" style="
            width: 32px;
            height: 32px;
            border: none;
            background: #f3f4f6;
            border-radius: 0.5rem;
            cursor: pointer;
            font-size: 1.25rem;
            color: #6c757d;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.2s;
          " onmouseover="this.style.background='#e5e7eb'; this.style.transform='scale(1.1)'" onmouseout="this.style.background='#f3f4f6'; this.style.transform='scale(1)'">×</button>
        </div>
        
        <!-- Date Field -->
        <div style="display: flex; align-items: center; gap: 0.75rem; margin-bottom: 1rem; padding: 0.75rem; background: #f9fafb; border-radius: 0.5rem;">
          <span style="font-size: 1.25rem;">📅</span>
          <div style="flex: 1; color: #2c3e50; font-weight: 500;">${eventDateShort}</div>
        </div>
        
        <!-- Time Field -->
        ${event.time ? `
        <div style="display: flex; align-items: center; gap: 0.75rem; margin-bottom: 1rem; padding: 0.75rem; background: #f9fafb; border-radius: 0.5rem;">
          <span style="font-size: 1.25rem;">🕐</span>
          <div style="flex: 1; display: flex; align-items: center; gap: 0.5rem;">
            <div style="padding: 0.5rem 0.75rem; background: white; border: 1px solid #e5e7eb; border-radius: 0.375rem; color: #2c3e50; font-weight: 500;">${formatTime(event.time)}</div>
            ${endTime ? `
              <span style="color: #6c757d;">-</span>
              <div style="padding: 0.5rem 0.75rem; background: white; border: 1px solid #e5e7eb; border-radius: 0.375rem; color: #2c3e50; font-weight: 500;">${endTime}</div>
            ` : ''}
          </div>
        </div>
        ` : ''}
        
        <!-- Location/Contact Field -->
        ${event.contact ? `
        <div style="display: flex; align-items: center; gap: 0.75rem; margin-bottom: 1rem; padding: 0.75rem; background: #f9fafb; border-radius: 0.5rem;">
          <span style="font-size: 1.25rem;">👤</span>
          <div style="flex: 1; color: #2c3e50; font-weight: 500;">${event.contact}</div>
        </div>
        ` : ''}
        
        ${event.project ? `
        <div style="display: flex; align-items: center; gap: 0.75rem; margin-bottom: 1rem; padding: 0.75rem; background: #f9fafb; border-radius: 0.5rem;">
          <span style="font-size: 1.25rem;">📁</span>
          <div style="flex: 1; color: #2c3e50; font-weight: 500;">${event.project}</div>
        </div>
        ` : ''}
        
        <!-- Tags/Categories -->
        ${tags.length > 0 ? `
        <div style="margin-bottom: 1.5rem;">
          <div style="display: flex; flex-wrap: gap: 0.5rem;">
            ${tags.map(tag => `
              <div style="
                padding: 0.375rem 0.75rem;
                border-radius: 1rem;
                background: ${tag.color}20;
                color: ${tag.color};
                font-weight: 500;
                font-size: 0.875rem;
              ">${tag.label}</div>
            `).join('')}
          </div>
        </div>
        ` : ''}
        
        <!-- Attendees/Assigned Members -->
        ${attendees.length > 0 ? `
        <div style="margin-bottom: 1.5rem;">
          <div style="font-size: 0.875rem; color: #6c757d; margin-bottom: 0.75rem; font-weight: 500;">Assigned to</div>
          ${renderAvatars(attendees)}
        </div>
        ` : ''}
        
        <!-- Additional Details -->
        ${event.type === 'task' && event.rawData?.description ? `
        <div style="margin-bottom: 1rem; padding: 1rem; background: #f9fafb; border-radius: 0.5rem;">
          <div style="font-size: 0.875rem; color: #6c757d; margin-bottom: 0.5rem; font-weight: 500;">Description</div>
          <div style="color: #2c3e50; line-height: 1.6;">${event.rawData.description}</div>
        </div>
        ` : ''}
        
        ${event.type === 'sales' && event.rawData?.amount ? `
        <div style="margin-bottom: 1rem; padding: 1rem; background: #f9fafb; border-radius: 0.5rem;">
          <div style="font-size: 0.875rem; color: #6c757d; margin-bottom: 0.5rem; font-weight: 500;">Amount</div>
          <div style="color: #2c3e50; font-weight: 700; font-size: 1.25rem;">$${parseFloat(event.rawData.amount).toLocaleString()}</div>
        </div>
        ` : ''}
        
        ${event.type === 'sales' && event.rawData?.notes ? `
        <div style="margin-bottom: 1rem; padding: 1rem; background: #f9fafb; border-radius: 0.5rem;">
          <div style="font-size: 0.875rem; color: #6c757d; margin-bottom: 0.5rem; font-weight: 500;">Notes</div>
          <div style="color: #2c3e50; line-height: 1.6;">${event.rawData.notes}</div>
        </div>
        ` : ''}
      </div>
    </div>
  `;
}

// Helper function to generate tooltip inner content (without the wrapper div)
function generateCalendarEventHoverInnerContent(event) {
  if (!event) return '';

  const eventDate = event.date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });

  // Build detailed information based on event type
  let detailsSections = '';

  if (event.type === 'task' && event.rawData) {
    const task = event.rawData;
    if (task.description) {
      detailsSections += `<div style="margin-top: 0.75rem; padding-top: 0.75rem; border-top: 1px solid #e5e7eb;"><div style="font-size: 0.75rem; color: #6c757d; margin-bottom: 0.5rem; font-weight: 500;">Description</div><div style="color: #2c3e50; font-size: 0.875rem; line-height: 1.5; max-height: 100px; overflow-y: auto;">${task.description}</div></div>`;
    }
    if (task.priority) {
      detailsSections += `<div style="margin-top: 0.75rem; display: flex; align-items: center; gap: 0.5rem;"><div style="font-size: 0.75rem; color: #6c757d; font-weight: 500;">Priority:</div><div style="display: inline-block; padding: 0.25rem 0.5rem; border-radius: 0.5rem; background: ${event.color}20; color: ${event.color}; font-weight: 600; font-size: 0.75rem;">${task.priority}</div></div>`;
    }
    if (task.state) {
      detailsSections += `<div style="margin-top: 0.5rem; display: flex; align-items: center; gap: 0.5rem;"><div style="font-size: 0.75rem; color: #6c757d; font-weight: 500;">Status:</div><div style="color: #2c3e50; font-size: 0.875rem; font-weight: 500;">${task.state}</div></div>`;
    }
    if (task.service_name || task.service) {
      detailsSections += `<div style="margin-top: 0.5rem; display: flex; align-items: center; gap: 0.5rem;"><div style="font-size: 0.75rem; color: #6c757d; font-weight: 500;">Service:</div><div style="color: #2c3e50; font-size: 0.875rem;">${task.service_name || task.service || ''}</div></div>`;
    }
  } else if (event.type === 'sales' && event.rawData) {
    const opp = event.rawData;
    if (opp.notes) {
      detailsSections += `<div style="margin-top: 0.75rem; padding-top: 0.75rem; border-top: 1px solid #e5e7eb;"><div style="font-size: 0.75rem; color: #6c757d; margin-bottom: 0.5rem; font-weight: 500;">Notes</div><div style="color: #2c3e50; font-size: 0.875rem; line-height: 1.5; max-height: 100px; overflow-y: auto;">${opp.notes}</div></div>`;
    }
    if (opp.amount) {
      detailsSections += `<div style="margin-top: 0.75rem; display: flex; align-items: center; gap: 0.5rem;"><div style="font-size: 0.75rem; color: #6c757d; font-weight: 500;">Amount:</div><div style="color: #2c3e50; font-weight: 700; font-size: 0.875rem;">$${parseFloat(opp.amount).toLocaleString()}</div></div>`;
    }
    if (opp.stage) {
      detailsSections += `<div style="margin-top: 0.5rem; display: flex; align-items: center; gap: 0.5rem;"><div style="font-size: 0.75rem; color: #6c757d; font-weight: 500;">Stage:</div><div style="display: inline-block; padding: 0.25rem 0.5rem; border-radius: 0.5rem; background: ${event.color}20; color: ${event.color}; font-weight: 600; font-size: 0.75rem;">${opp.stage}</div></div>`;
    }
    if (opp.chance) {
      detailsSections += `<div style="margin-top: 0.5rem; display: flex; align-items: center; gap: 0.5rem;"><div style="font-size: 0.75rem; color: #6c757d; font-weight: 500;">Chance:</div><div style="color: #2c3e50; font-size: 0.875rem; font-weight: 500;">${opp.chance}%</div></div>`;
    }
    if (opp.source) {
      detailsSections += `<div style="margin-top: 0.5rem; display: flex; align-items: center; gap: 0.5rem;"><div style="font-size: 0.75rem; color: #6c757d; font-weight: 500;">Source:</div><div style="color: #2c3e50; font-size: 0.875rem;">${opp.source}</div></div>`;
    }
  } else if (event.type === 'reminder' && event.rawData) {
    const reminder = event.rawData;
    if (reminder.description) {
      detailsSections += `<div style="margin-top: 0.75rem; padding-top: 0.75rem; border-top: 1px solid #e5e7eb;"><div style="font-size: 0.75rem; color: #6c757d; margin-bottom: 0.5rem; font-weight: 500;">Description</div><div style="color: #2c3e50; font-size: 0.875rem; line-height: 1.5; max-height: 100px; overflow-y: auto;">${reminder.description}</div></div>`;
    }
    if (reminder.priority) {
      detailsSections += `<div style="margin-top: 0.75rem; display: flex; align-items: center; gap: 0.5rem;"><div style="font-size: 0.75rem; color: #6c757d; font-weight: 500;">Priority:</div><div style="display: inline-block; padding: 0.25rem 0.5rem; border-radius: 0.5rem; background: ${event.color}20; color: ${event.color}; font-weight: 600; font-size: 0.75rem;">${reminder.priority}</div></div>`;
    }
    if (reminder.type) {
      detailsSections += `<div style="margin-top: 0.5rem; display: flex; align-items: center; gap: 0.5rem;"><div style="font-size: 0.75rem; color: #6c757d; font-weight: 500;">Type:</div><div style="color: #2c3e50; font-size: 0.875rem;">${reminder.type}</div></div>`;
    }
  } else if (event.type === 'appointment' && event.rawData) {
    const apt = event.rawData;
    if (apt.description || apt.notes) {
      detailsSections += `<div style="margin-top: 0.75rem; padding-top: 0.75rem; border-top: 1px solid #e5e7eb;"><div style="font-size: 0.75rem; color: #6c757d; margin-bottom: 0.5rem; font-weight: 500;">Description</div><div style="color: #2c3e50; font-size: 0.875rem; line-height: 1.5; max-height: 100px; overflow-y: auto;">${apt.description || apt.notes || ''}</div></div>`;
    }
    if (apt.duration_minutes) {
      detailsSections += `<div style="margin-top: 0.75rem; display: flex; align-items: center; gap: 0.5rem;"><div style="font-size: 0.75rem; color: #6c757d; font-weight: 500;">Duration:</div><div style="color: #2c3e50; font-size: 0.875rem; font-weight: 500;">${apt.duration_minutes} minutes</div></div>`;
    }
    if (apt.status) {
      detailsSections += `<div style="margin-top: 0.5rem; display: flex; align-items: center; gap: 0.5rem;"><div style="font-size: 0.75rem; color: #6c757d; font-weight: 500;">Status:</div><div style="color: #2c3e50; font-size: 0.875rem; font-weight: 500;">${apt.status}</div></div>`;
    }
  }

  return `
    <div style="display: inline-block; padding: 0.25rem 0.5rem; border-radius: 0.5rem; background: ${event.color}20; color: ${event.color}; font-weight: 600; font-size: 0.75rem; margin-bottom: 0.75rem;">${event.type === 'sales' ? 'Sales Follow-up' : event.type.charAt(0).toUpperCase() + event.type.slice(1)}</div>
    <h3 style="margin: 0 0 0.5rem 0; color: #2c3e50; font-size: 1rem; font-weight: 700; line-height: 1.3;">${event.title}</h3>
    <div style="display: flex; align-items: center; gap: 0.5rem; color: #6c757d; font-size: 0.875rem; margin-bottom: 0.75rem;">
      <span>📅</span>
      <span>${eventDate}</span>
      ${event.time ? `<span>•</span><span>${formatTime(event.time)}</span>` : ''}
    </div>
    ${event.contact ? `<div style="display: flex; align-items: center; gap: 0.5rem; color: #6c757d; font-size: 0.875rem; margin-bottom: 0.75rem;"><span>👤</span><span>${event.contact}</span></div>` : ''}
    ${event.project ? `<div style="display: flex; align-items: center; gap: 0.5rem; color: #6c757d; font-size: 0.875rem; margin-bottom: 0.75rem;"><span>📁</span><span>${event.project}</span></div>` : ''}
    ${detailsSections}
    ${event.assignedMembers && event.assignedMembers.length > 0 ? `<div style="margin-top: 0.75rem; padding-top: 0.75rem; border-top: 1px solid #e5e7eb;"><div style="font-size: 0.75rem; color: #6c757d; margin-bottom: 0.5rem; font-weight: 500;">Assigned to</div>${renderAvatars(event.assignedMembers, 3)}</div>` : ''}
  `;
}

// Hover preview functions
window.showCalendarEventHover = function (eventId, eventElement) {
  const event = calendarEvents.find(e => e.id === eventId);
  if (!event) return;
  hoveredCalendarEvent = event;

  // Get or create tooltip element - DO NOT re-render entire page
  let tooltip = document.getElementById('calendar-event-hover');
  if (!tooltip) {
    // Create tooltip element if it doesn't exist
    tooltip = document.createElement('div');
    tooltip.id = 'calendar-event-hover';
    tooltip.style.cssText = 'position: fixed; background: white; border-radius: 0.75rem; padding: 1.5rem; box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.15); z-index: 10001; max-width: 350px; pointer-events: none; border: 1px solid #e5e7eb; display: none;';
    document.body.appendChild(tooltip);
  }

  // Update tooltip content directly - no page re-render
  tooltip.innerHTML = generateCalendarEventHoverInnerContent(event);
  tooltip.style.display = 'block';

  // Position tooltip above the event element (not over it)
  setTimeout(() => {
    if (tooltip && eventElement) {
      const rect = eventElement.getBoundingClientRect();
      const tooltipRect = tooltip.getBoundingClientRect();
      const left = rect.left + (rect.width / 2) - (tooltipRect.width / 2);
      const top = rect.top + window.scrollY - tooltipRect.height - 15;
      const adjustedLeft = Math.max(10, Math.min(left, window.innerWidth - tooltipRect.width - 10));
      let adjustedTop = top;
      if (top < window.scrollY + 10) {
        adjustedTop = rect.bottom + window.scrollY + 15;
      }
      tooltip.style.top = `${adjustedTop}px`;
      tooltip.style.left = `${adjustedLeft}px`;
    }
  }, 10);

  // DO NOT call renderPMTool() - this causes full page re-render and glitches
};

window.hideCalendarEventHover = function () {
  hoveredCalendarEvent = null;

  // Hide tooltip directly - no page re-render
  const tooltip = document.getElementById('calendar-event-hover');
  if (tooltip) {
    tooltip.style.display = 'none';
  }

  // DO NOT call renderPMTool() - this causes full page re-render and glitches
};

// Render hover preview tooltip
function renderCalendarEventHoverPreview() {
  if (!hoveredCalendarEvent) return '';

  const event = hoveredCalendarEvent;
  const eventDate = event.date.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });

  // Build detailed information based on event type
  let detailsSections = '';

  if (event.type === 'task' && event.rawData) {
    const task = event.rawData;

    // Description
    if (task.description) {
      detailsSections += `
        <div style="margin-top: 0.75rem; padding-top: 0.75rem; border-top: 1px solid #e5e7eb;">
          <div style="font-size: 0.75rem; color: #6c757d; margin-bottom: 0.5rem; font-weight: 500;">Description</div>
          <div style="color: #2c3e50; font-size: 0.875rem; line-height: 1.5; max-height: 100px; overflow-y: auto;">${task.description}</div>
        </div>
      `;
    }

    // Priority
    if (task.priority) {
      detailsSections += `
        <div style="margin-top: 0.75rem; display: flex; align-items: center; gap: 0.5rem;">
          <div style="font-size: 0.75rem; color: #6c757d; font-weight: 500;">Priority:</div>
          <div style="
            display: inline-block;
            padding: 0.25rem 0.5rem;
            border-radius: 0.5rem;
            background: ${event.color}20;
            color: ${event.color};
            font-weight: 600;
            font-size: 0.75rem;
          ">${task.priority}</div>
        </div>
      `;
    }

    // Status/State
    if (task.state) {
      detailsSections += `
        <div style="margin-top: 0.5rem; display: flex; align-items: center; gap: 0.5rem;">
          <div style="font-size: 0.75rem; color: #6c757d; font-weight: 500;">Status:</div>
          <div style="color: #2c3e50; font-size: 0.875rem; font-weight: 500;">${task.state}</div>
        </div>
      `;
    }

    // Service
    if (task.service_name || task.service) {
      detailsSections += `
        <div style="margin-top: 0.5rem; display: flex; align-items: center; gap: 0.5rem;">
          <div style="font-size: 0.75rem; color: #6c757d; font-weight: 500;">Service:</div>
          <div style="color: #2c3e50; font-size: 0.875rem;">${task.service_name || task.service || ''}</div>
        </div>
      `;
    }

  } else if (event.type === 'sales' && event.rawData) {
    const opp = event.rawData;

    // Notes/Description
    if (opp.notes) {
      detailsSections += `
        <div style="margin-top: 0.75rem; padding-top: 0.75rem; border-top: 1px solid #e5e7eb;">
          <div style="font-size: 0.75rem; color: #6c757d; margin-bottom: 0.5rem; font-weight: 500;">Notes</div>
          <div style="color: #2c3e50; font-size: 0.875rem; line-height: 1.5; max-height: 100px; overflow-y: auto;">${opp.notes}</div>
        </div>
      `;
    }

    // Amount
    if (opp.amount) {
      detailsSections += `
        <div style="margin-top: 0.75rem; display: flex; align-items: center; gap: 0.5rem;">
          <div style="font-size: 0.75rem; color: #6c757d; font-weight: 500;">Amount:</div>
          <div style="color: #2c3e50; font-weight: 700; font-size: 0.875rem;">$${parseFloat(opp.amount).toLocaleString()}</div>
        </div>
      `;
    }

    // Stage
    if (opp.stage) {
      detailsSections += `
        <div style="margin-top: 0.5rem; display: flex; align-items: center; gap: 0.5rem;">
          <div style="font-size: 0.75rem; color: #6c757d; font-weight: 500;">Stage:</div>
          <div style="
            display: inline-block;
            padding: 0.25rem 0.5rem;
            border-radius: 0.5rem;
            background: ${event.color}20;
            color: ${event.color};
            font-weight: 600;
            font-size: 0.75rem;
          ">${opp.stage}</div>
        </div>
      `;
    }

    // Chance
    if (opp.chance) {
      detailsSections += `
        <div style="margin-top: 0.5rem; display: flex; align-items: center; gap: 0.5rem;">
          <div style="font-size: 0.75rem; color: #6c757d; font-weight: 500;">Chance:</div>
          <div style="color: #2c3e50; font-size: 0.875rem; font-weight: 500;">${opp.chance}%</div>
        </div>
      `;
    }

    // Source
    if (opp.source) {
      detailsSections += `
        <div style="margin-top: 0.5rem; display: flex; align-items: center; gap: 0.5rem;">
          <div style="font-size: 0.75rem; color: #6c757d; font-weight: 500;">Source:</div>
          <div style="color: #2c3e50; font-size: 0.875rem;">${opp.source}</div>
        </div>
      `;
    }

  } else if (event.type === 'reminder' && event.rawData) {
    const reminder = event.rawData;

    // Description
    if (reminder.description) {
      detailsSections += `
        <div style="margin-top: 0.75rem; padding-top: 0.75rem; border-top: 1px solid #e5e7eb;">
          <div style="font-size: 0.75rem; color: #6c757d; margin-bottom: 0.5rem; font-weight: 500;">Description</div>
          <div style="color: #2c3e50; font-size: 0.875rem; line-height: 1.5; max-height: 100px; overflow-y: auto;">${reminder.description}</div>
        </div>
      `;
    }

    // Priority
    if (reminder.priority) {
      detailsSections += `
        <div style="margin-top: 0.75rem; display: flex; align-items: center; gap: 0.5rem;">
          <div style="font-size: 0.75rem; color: #6c757d; font-weight: 500;">Priority:</div>
          <div style="
            display: inline-block;
            padding: 0.25rem 0.5rem;
            border-radius: 0.5rem;
            background: ${event.color}20;
            color: ${event.color};
            font-weight: 600;
            font-size: 0.75rem;
          ">${reminder.priority}</div>
        </div>
      `;
    }

    // Type
    if (reminder.type) {
      detailsSections += `
        <div style="margin-top: 0.5rem; display: flex; align-items: center; gap: 0.5rem;">
          <div style="font-size: 0.75rem; color: #6c757d; font-weight: 500;">Type:</div>
          <div style="color: #2c3e50; font-size: 0.875rem;">${reminder.type}</div>
        </div>
      `;
    }

  } else if (event.type === 'appointment' && event.rawData) {
    const apt = event.rawData;

    // Description/Notes
    if (apt.description || apt.notes) {
      detailsSections += `
        <div style="margin-top: 0.75rem; padding-top: 0.75rem; border-top: 1px solid #e5e7eb;">
          <div style="font-size: 0.75rem; color: #6c757d; margin-bottom: 0.5rem; font-weight: 500;">Description</div>
          <div style="color: #2c3e50; font-size: 0.875rem; line-height: 1.5; max-height: 100px; overflow-y: auto;">${apt.description || apt.notes || ''}</div>
        </div>
      `;
    }

    // Duration
    if (apt.duration_minutes) {
      detailsSections += `
        <div style="margin-top: 0.75rem; display: flex; align-items: center; gap: 0.5rem;">
          <div style="font-size: 0.75rem; color: #6c757d; font-weight: 500;">Duration:</div>
          <div style="color: #2c3e50; font-size: 0.875rem; font-weight: 500;">${apt.duration_minutes} minutes</div>
        </div>
      `;
    }

    // Status
    if (apt.status) {
      detailsSections += `
        <div style="margin-top: 0.5rem; display: flex; align-items: center; gap: 0.5rem;">
          <div style="font-size: 0.75rem; color: #6c757d; font-weight: 500;">Status:</div>
          <div style="color: #2c3e50; font-size: 0.875rem; font-weight: 500;">${apt.status}</div>
        </div>
      `;
    }
  }

  return `
    <div id="calendar-event-hover" style="
      position: fixed;
      background: white;
      border-radius: 0.75rem;
      padding: 1.5rem;
      box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.15);
      z-index: 10001;
      max-width: 350px;
      pointer-events: none;
      border: 1px solid #e5e7eb;
    ">
      <div style="
        display: inline-block;
        padding: 0.25rem 0.5rem;
        border-radius: 0.5rem;
        background: ${event.color}20;
        color: ${event.color};
        font-weight: 600;
        font-size: 0.75rem;
        margin-bottom: 0.75rem;
      ">${event.type === 'sales' ? 'Sales Follow-up' : event.type.charAt(0).toUpperCase() + event.type.slice(1)}</div>
      <h3 style="margin: 0 0 0.5rem 0; color: #2c3e50; font-size: 1rem; font-weight: 700; line-height: 1.3;">${event.title}</h3>
      <div style="display: flex; align-items: center; gap: 0.5rem; color: #6c757d; font-size: 0.875rem; margin-bottom: 0.75rem;">
        <span>📅</span>
        <span>${eventDate}</span>
        ${event.time ? `<span>•</span><span>${formatTime(event.time)}</span>` : ''}
      </div>
      ${event.contact ? `
      <div style="display: flex; align-items: center; gap: 0.5rem; color: #6c757d; font-size: 0.875rem; margin-bottom: 0.75rem;">
        <span>👤</span>
        <span>${event.contact}</span>
      </div>
      ` : ''}
      ${event.project ? `
      <div style="display: flex; align-items: center; gap: 0.5rem; color: #6c757d; font-size: 0.875rem; margin-bottom: 0.75rem;">
        <span>📁</span>
        <span>${event.project}</span>
      </div>
      ` : ''}
      ${detailsSections}
      ${event.assignedMembers && event.assignedMembers.length > 0 ? `
      <div style="margin-top: 0.75rem; padding-top: 0.75rem; border-top: 1px solid #e5e7eb;">
        <div style="font-size: 0.75rem; color: #6c757d; margin-bottom: 0.5rem; font-weight: 500;">Assigned to</div>
        ${renderAvatars(event.assignedMembers, 3)}
      </div>
      ` : ''}
    </div>
  `;
}

// Load checklist items
async function loadChecklistItems() {
  if (!currentCompany || !currentUser) return;

  // Load checklist items with creator info and today's completion status
  const { data: itemsData, error } = await supabase
    .from('team_checklist_items')
    .select(`
      *,
      created_by_user:profiles!team_checklist_items_created_by_fkey(
        id,
        first_name,
        last_name,
        avatar_path
      ),
      completions:team_checklist_completions!team_checklist_completions_checklist_item_id_fkey(
        id,
        user_id,
        date
      )
    `)
    .eq('company_id', currentCompany.id)
    .eq('is_active', true)
    .order('sort_order', { ascending: true, nullsFirst: false })
    .order('created_at', { ascending: false });

  if (error) {
    console.error('Error loading checklist items:', error);
    console.error('Error details:', JSON.stringify(error, null, 2));
    return;
  }

  // Process items to add completion status for current user
  const today = new Date().toISOString().split('T')[0];
  checklistItems = (itemsData || []).map(item => {
    const userCompletion = item.completions?.find(
      c => c.user_id === currentUser.id && c.date === today
    );
    return {
      ...item,
      completed: !!userCompletion
    };
  });

  console.log('Loaded checklist items:', checklistItems.length);
}

// Render Checklist Screen
async function renderChecklistScreen() {
  // Sync checklistTab from window if it exists (for inline event handlers)
  if (window.checklistTab) {
    checklistTab = window.checklistTab;
  }
  // Also sync window.checklistTab with checklistTab for inline event handlers
  window.checklistTab = checklistTab;

  await loadChecklistItems();

  // Get current tab value (use window version if available, fallback to local)
  const currentTab = window.checklistTab || checklistTab || 'team';

  console.log('🔍 [Checklist] Rendering with tab:', currentTab);
  console.log('🔍 [Checklist] Total items loaded:', checklistItems.length);
  console.log('🔍 [Checklist] Current user ID:', currentUser?.id);

  // Filter items by tab (team vs personal) and search query
  const filteredItems = checklistItems.filter(item => {
    // Filter by tab: 'team' shows all items, 'personal' shows only items created by current user
    if (currentTab === 'personal') {
      if (item.created_by !== currentUser?.id) {
        return false;
      }
    }

    // Filter by search query
    if (checklistSearchQuery && checklistSearchQuery.trim()) {
      const query = checklistSearchQuery.toLowerCase();
      const matchesSearch = (
        item.title?.toLowerCase().includes(query) ||
        item.description?.toLowerCase().includes(query) ||
        item.category?.toLowerCase().includes(query)
      );
      if (!matchesSearch) {
        return false;
      }
    }

    return true;
  });

  console.log('🔍 [Checklist] Filtered items for', currentTab, 'tab:', filteredItems.length);

  // Color options for checklist items
  const colorOptions = [
    '#6366f1', // Indigo
    '#ef4444', // Red
    '#10b981', // Green
    '#f59e0b', // Orange
    '#8b5cf6', // Purple
    '#ec4899', // Pink
    '#f97316', // Orange-red
    '#14b8a6', // Teal
    '#6b7280', // Gray
    '#3b82f6'  // Blue
  ];

  return `
    <div style="max-width: 1200px; margin: 0 auto; padding: 1.5rem;">
      <!-- Header -->
      <div style="
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 1.5rem;
      ">
        <h1 style="
          color: #2c3e50;
          margin: 0;
          font-size: 2rem;
          font-weight: 700;
        ">
          Team Checklist
        </h1>
        <button 
          onclick="openAddChecklistModal()"
          style="
            width: 48px;
            height: 48px;
            border-radius: 50%;
            background: #ef4444;
            color: white;
            border: none;
            cursor: pointer;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1.5rem;
            font-weight: 300;
            box-shadow: 0 4px 6px rgba(239, 68, 68, 0.3);
            transition: all 0.2s;
          "
          onmouseover="this.style.transform='scale(1.1)'; this.style.boxShadow='0 6px 8px rgba(239, 68, 68, 0.4)'"
          onmouseout="this.style.transform='scale(1)'; this.style.boxShadow='0 4px 6px rgba(239, 68, 68, 0.3)'"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="12" y1="5" x2="12" y2="19"></line>
            <line x1="5" y1="12" x2="19" y2="12"></line>
          </svg>
        </button>
      </div>
      
      <!-- Tabs -->
      <div style="
        display: flex;
        gap: 0.5rem;
        margin-bottom: 1.5rem;
        border-bottom: 2px solid #e5e7eb;
      ">
        <button
          onclick="window.checklistTab = 'team'; checklistTab = 'team'; renderPMTool();"
          style="
            background: ${currentTab === 'team' ? '#ef4444' : 'transparent'};
            color: ${currentTab === 'team' ? '#ffffff' : '#6c757d'};
            border: none;
            padding: 0.75rem 1.5rem;
            border-radius: ${currentTab === 'team' ? '0.5rem 0.5rem 0 0' : '0'};
            cursor: pointer;
            font-size: 1rem;
            font-weight: ${currentTab === 'team' ? '600' : '500'};
            transition: all 0.2s;
            margin-bottom: -2px;
            border-bottom: ${currentTab === 'team' ? '2px solid #ef4444' : '2px solid transparent'};
          "
          onmouseover="if (window.checklistTab !== 'team') { this.style.color='#2c3e50'; this.style.background='#f9fafb'; }"
          onmouseout="if (window.checklistTab !== 'team') { this.style.color='#6c757d'; this.style.background='transparent'; }"
        >
          Team
        </button>
        <button
          onclick="window.checklistTab = 'personal'; checklistTab = 'personal'; renderPMTool();"
          style="
            background: ${currentTab === 'personal' ? '#ef4444' : 'transparent'};
            color: ${currentTab === 'personal' ? '#ffffff' : '#6c757d'};
            border: none;
            padding: 0.75rem 1.5rem;
            border-radius: ${currentTab === 'personal' ? '0.5rem 0.5rem 0 0' : '0'};
            cursor: pointer;
            font-size: 1rem;
            font-weight: ${currentTab === 'personal' ? '600' : '500'};
            transition: all 0.2s;
            margin-bottom: -2px;
            border-bottom: ${currentTab === 'personal' ? '2px solid #ef4444' : '2px solid transparent'};
          "
          onmouseover="if (window.checklistTab !== 'personal') { this.style.color='#2c3e50'; this.style.background='#f9fafb'; }"
          onmouseout="if (window.checklistTab !== 'personal') { this.style.color='#6c757d'; this.style.background='transparent'; }"
        >
          Personal
        </button>
      </div>
      
      <!-- Search Bar -->
      <div style="margin-bottom: 1.5rem;">
        <input
          type="text"
          id="checklist-search"
          placeholder="Search checklist items..."
          value="${checklistSearchQuery}"
          oninput="checklistSearchQuery = this.value; renderPMTool();"
          style="
            width: 100%;
            padding: 0.75rem 1rem;
            border: 1px solid #e5e7eb;
            border-radius: 0.5rem;
            font-size: 1rem;
            box-sizing: border-box;
            transition: border-color 0.2s;
          "
          onfocus="this.style.borderColor='#6366f1'"
          onblur="this.style.borderColor='#e5e7eb'"
        />
      </div>
      
      <!-- Checklist Items -->
      <div style="display: flex; flex-direction: column; gap: 1rem;">
        ${filteredItems.length === 0 ? `
          <div style="
            background: #ffffff;
            border-radius: 0.75rem;
            padding: 3rem;
            box-shadow: 0 1px 3px rgba(0,0,0,0.1);
            text-align: center;
          ">
            <div style="
              color: #9ca3af;
              font-size: 1rem;
              margin-bottom: 0.5rem;
            ">No checklist items found</div>
            <div style="
              color: #d1d5db;
              font-size: 0.875rem;
            ">${checklistSearchQuery ? 'Try a different search term' : currentTab === 'personal' ? 'Click the + button to add your first personal item' : 'Click the + button to add your first item'}</div>
          </div>
        ` : filteredItems.map(item => {
    const isCompleted = item.completed || false;
    const itemColor = item.color || '#6366f1';

    return `
            <div style="
              background: #ffffff;
              border-radius: 0.75rem;
              padding: 1.25rem;
              box-shadow: 0 1px 3px rgba(0,0,0,0.1);
              display: flex;
              align-items: center;
              gap: 1rem;
              border-left: 4px solid ${itemColor};
              transition: all 0.2s;
            " onmouseover="this.style.boxShadow='0 4px 6px rgba(0,0,0,0.15)'; this.style.transform='translateY(-2px)'" onmouseout="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.1)'; this.style.transform='translateY(0)'">
              <!-- Checkbox -->
              <div 
                onclick="toggleChecklistItem('${item.id}')"
                style="
                  width: 24px;
                  height: 24px;
                  border: 2px solid ${isCompleted ? itemColor : '#d1d5db'};
                  border-radius: 0.25rem;
                  background: ${isCompleted ? itemColor : 'transparent'};
                  cursor: pointer;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  flex-shrink: 0;
                  transition: all 0.2s;
                "
                onmouseover="this.style.borderColor='${itemColor}'"
                onmouseout="this.style.borderColor='${isCompleted ? itemColor : '#d1d5db'}'"
              >
                ${isCompleted ? `
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                ` : ''}
              </div>
              
              <!-- Content -->
              <div style="flex: 1; min-width: 0;">
                <div style="
                  color: ${itemColor};
                  font-weight: 600;
                  font-size: 1rem;
                  margin-bottom: 0.5rem;
                  text-decoration: ${isCompleted ? 'line-through' : 'none'};
                  opacity: ${isCompleted ? 0.6 : 1};
                ">${item.title || 'Untitled'}</div>
                ${item.description ? `
                  <div style="
                    color: #6c757d;
                    font-size: 0.875rem;
                    margin-bottom: 0.25rem;
                    text-decoration: ${isCompleted ? 'line-through' : 'none'};
                    opacity: ${isCompleted ? 0.6 : 1};
                  ">${item.description}</div>
                ` : ''}
                ${item.category ? `
                  <div style="
                    color: #9ca3af;
                    font-size: 0.75rem;
                    text-decoration: ${isCompleted ? 'line-through' : 'none'};
                    opacity: ${isCompleted ? 0.6 : 1};
                  ">${item.category}</div>
                ` : ''}
                ${item.created_by_user ? `
                  <div style="
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    margin-top: 0.5rem;
                  ">
                    ${(() => {
          const firstName = item.created_by_user.first_name || '';
          const lastName = item.created_by_user.last_name || '';
          const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase() || 'U';
          const avatarPath = item.created_by_user.avatar_path;
          const avatarId = `checklist-avatar-${item.id}-${item.created_by_user.id}`;

          return `
                        <div style="
                          width: 24px;
                          height: 24px;
                          border-radius: 50%;
                          background: ${itemColor};
                          color: white;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          font-size: 0.625rem;
                          font-weight: 600;
                          position: relative;
                          overflow: hidden;
                          flex-shrink: 0;
                        " id="${avatarId}">
                          <span id="${avatarId}-initials" style="
                            position: relative;
                            z-index: 1;
                            ${avatarPath ? 'display: none;' : ''}
                          ">${initials}</span>
                          ${avatarPath ? `
                            <img 
                              src="${avatarPath}" 
                              alt="${firstName} ${lastName}"
                              style="
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                                position: absolute;
                                top: 0;
                                left: 0;
                                z-index: 2;
                              "
                              onerror="
                                const initialsEl = document.getElementById('${avatarId}-initials');
                                if (initialsEl) {
                                  initialsEl.style.display = 'flex';
                                }
                                this.style.display = 'none';
                              "
                            />
                          ` : ''}
                        </div>
                      `;
        })()}
                    <span style="
                      color: #6c757d;
                      font-size: 0.75rem;
                    ">
                      ${(item.created_by_user.first_name || '') + ' ' + (item.created_by_user.last_name || '')}
                    </span>
                  </div>
                ` : ''}
              </div>
              
              <!-- Actions -->
              <div style="display: flex; align-items: center; gap: 0.5rem; flex-shrink: 0;">
                <button
                  onclick="editChecklistItem('${item.id}')"
                  style="
                    width: 36px;
                    height: 36px;
                    border: none;
                    background: transparent;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 0.375rem;
                    color: #f59e0b;
                    transition: all 0.2s;
                  "
                  onmouseover="this.style.background='#fef3c7'; this.style.transform='scale(1.1)'"
                  onmouseout="this.style.background='transparent'; this.style.transform='scale(1)'"
                  title="Edit"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                  </svg>
                </button>
                <button
                  onclick="showDeleteChecklistItemConfirm('${item.id}')"
                  style="
                    width: 36px;
                    height: 36px;
                    border: none;
                    background: transparent;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 0.375rem;
                    color: #3b82f6;
                    transition: all 0.2s;
                  "
                  onmouseover="this.style.background='#dbeafe'; this.style.transform='scale(1.1)'"
                  onmouseout="this.style.background='transparent'; this.style.transform='scale(1)'"
                  title="Delete"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="3 6 5 6 21 6"></polyline>
                    <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                  </svg>
                </button>
              </div>
            </div>
          `;
  }).join('')}
      </div>
      
      <!-- Add/Edit Checklist Modal -->
      ${renderChecklistModal(colorOptions)}
    </div>
  `;
}

// Render Add/Edit Checklist Modal
function renderChecklistModal(colorOptions) {
  if (!showAddChecklistModal) return '';

  const isEditing = editingChecklistItem !== null || window.editingChecklistItem !== null;
  // Use window versions if available (for persistence during re-renders)
  const formData = isEditing
    ? (window.editingChecklistItem || editingChecklistItem)
    : (window.checklistFormData || checklistFormData);

  return `
    <div id="checklist-modal" style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10000;
      padding: 1rem;
    " onclick="if(event.target.id === 'checklist-modal') { closeChecklistModal(); }">
      <div style="
        background: white;
        border-radius: 1rem;
        padding: 2rem;
        max-width: 500px;
        width: 100%;
        max-height: 90vh;
        overflow-y: auto;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
      " onclick="event.stopPropagation()">
        <!-- Header -->
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 2rem;">
          <h2 style="margin: 0; color: #2c3e50; font-size: 1.5rem; font-weight: 700;">
            ${isEditing ? 'Edit Checklist Item' : 'Add Checklist Item'}
          </h2>
          <button 
            onclick="closeChecklistModal()"
            style="
              width: 32px;
              height: 32px;
              border: none;
              background: #f3f4f6;
              border-radius: 0.5rem;
              cursor: pointer;
              font-size: 1.25rem;
              color: #6c757d;
              display: flex;
              align-items: center;
              justify-content: center;
              transition: all 0.2s;
            "
            onmouseover="this.style.background='#e5e7eb'; this.style.transform='scale(1.1)'"
            onmouseout="this.style.background='#f3f4f6'; this.style.transform='scale(1)'"
          >×</button>
        </div>
        
        <!-- Form -->
        <div style="display: flex; flex-direction: column; gap: 1.5rem;">
          <!-- Title -->
          <div>
            <label style="
              display: block;
              color: #2c3e50;
              font-weight: 600;
              font-size: 0.875rem;
              margin-bottom: 0.5rem;
            ">Title *</label>
            <input
              type="text"
              id="checklist-title"
              placeholder="Enter checklist item title"
              value="${formData.title || ''}"
              oninput="if (window.editingChecklistItem) { window.editingChecklistItem.title = this.value; } else { window.checklistFormData = window.checklistFormData || {}; window.checklistFormData.title = this.value; checklistFormData.title = this.value; }"
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid #e5e7eb;
                border-radius: 0.5rem;
                font-size: 1rem;
                box-sizing: border-box;
                transition: border-color 0.2s;
              "
              onfocus="this.style.borderColor='#6366f1'"
              onblur="this.style.borderColor='#e5e7eb'"
            />
          </div>
          
          <!-- Description -->
          <div>
            <label style="
              display: block;
              color: #2c3e50;
              font-weight: 600;
              font-size: 0.875rem;
              margin-bottom: 0.5rem;
            ">Description</label>
            <input
              type="text"
              id="checklist-description"
              placeholder="Enter description (optional)"
              value="${formData.description || ''}"
              oninput="if (window.editingChecklistItem) { window.editingChecklistItem.description = this.value; } else { window.checklistFormData = window.checklistFormData || {}; window.checklistFormData.description = this.value; checklistFormData.description = this.value; }"
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid #e5e7eb;
                border-radius: 0.5rem;
                font-size: 1rem;
                box-sizing: border-box;
                transition: border-color 0.2s;
              "
              onfocus="this.style.borderColor='#6366f1'"
              onblur="this.style.borderColor='#e5e7eb'"
            />
          </div>
          
          <!-- Category -->
          <div>
            <label style="
              display: block;
              color: #2c3e50;
              font-weight: 600;
              font-size: 0.875rem;
              margin-bottom: 0.5rem;
            ">Category</label>
            <input
              type="text"
              id="checklist-category"
              placeholder="Enter category (optional)"
              value="${formData.category || ''}"
              oninput="if (window.editingChecklistItem) { window.editingChecklistItem.category = this.value; } else { window.checklistFormData = window.checklistFormData || {}; window.checklistFormData.category = this.value; checklistFormData.category = this.value; }"
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid #e5e7eb;
                border-radius: 0.5rem;
                font-size: 1rem;
                box-sizing: border-box;
                transition: border-color 0.2s;
              "
              onfocus="this.style.borderColor='#6366f1'"
              onblur="this.style.borderColor='#e5e7eb'"
            />
          </div>
          
          <!-- Color Selection -->
          <div>
            <label style="
              display: block;
              color: #2c3e50;
              font-weight: 600;
              font-size: 0.875rem;
              margin-bottom: 0.75rem;
            ">Color</label>
            <div style="display: flex; flex-wrap: wrap; gap: 0.75rem;">
              ${colorOptions.map(color => {
    const isSelected = (formData.color || '#6366f1') === color;
    return `
                  <div
                    onclick="selectChecklistColor('${color}')"
                    style="
                      width: 40px;
                      height: 40px;
                      border-radius: 50%;
                      background: ${color};
                      cursor: pointer;
                      border: ${isSelected ? '3px solid #2c3e50' : '2px solid #e5e7eb'};
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      transition: all 0.2s;
                    "
                    onmouseover="this.style.transform='scale(1.1)'"
                    onmouseout="this.style.transform='scale(1)'"
                  >
                    ${isSelected ? `
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    ` : ''}
                  </div>
                `;
  }).join('')}
            </div>
          </div>
        </div>
        
        <!-- Actions -->
        <div style="display: flex; gap: 1rem; margin-top: 2rem; justify-content: flex-end;">
          <button
            onclick="closeChecklistModal()"
            style="
              padding: 0.75rem 1.5rem;
              border: 1px solid #e5e7eb;
              background: white;
              border-radius: 0.5rem;
              cursor: pointer;
              color: #6c757d;
              font-weight: 600;
              font-size: 0.875rem;
              transition: all 0.2s;
            "
            onmouseover="this.style.background='#f9fafb'"
            onmouseout="this.style.background='white'"
          >Cancel</button>
          <button
            onclick="saveChecklistItem()"
            style="
              padding: 0.75rem 1.5rem;
              border: none;
              background: #6366f1;
              border-radius: 0.5rem;
              cursor: pointer;
              color: white;
              font-weight: 600;
              font-size: 0.875rem;
              transition: all 0.2s;
            "
            onmouseover="this.style.background='#4f46e5'; this.style.transform='translateY(-1px)'"
            onmouseout="this.style.background='#6366f1'; this.style.transform='translateY(0)'"
          >${isEditing ? 'Save' : 'Add'}</button>
        </div>
      </div>
    </div>
  `;
}

// Checklist functions
window.openAddChecklistModal = function () {
  editingChecklistItem = null;
  checklistFormData = {
    title: '',
    description: '',
    category: '',
    color: '#6366f1'
  };
  // Also set window version for inline handlers
  window.checklistFormData = { ...checklistFormData };
  window.editingChecklistItem = null;
  showAddChecklistModal = true;
  renderPMTool();
};

window.closeChecklistModal = function () {
  showAddChecklistModal = false;
  editingChecklistItem = null;
  checklistFormData = {
    title: '',
    description: '',
    category: '',
    color: '#6366f1'
  };
  renderPMTool();
};

window.selectChecklistColor = function (color) {
  // Preserve form data before re-rendering
  const titleInput = document.getElementById('checklist-title');
  const descriptionInput = document.getElementById('checklist-description');
  const categoryInput = document.getElementById('checklist-category');

  if (editingChecklistItem) {
    editingChecklistItem.color = color;
    // Preserve input values
    if (titleInput) editingChecklistItem.title = titleInput.value;
    if (descriptionInput) editingChecklistItem.description = descriptionInput.value;
    if (categoryInput) editingChecklistItem.category = categoryInput.value;
  } else {
    checklistFormData.color = color;
    // Preserve input values
    if (titleInput) checklistFormData.title = titleInput.value;
    if (descriptionInput) checklistFormData.description = descriptionInput.value;
    if (categoryInput) checklistFormData.category = categoryInput.value;
    // Also update window version
    window.checklistFormData = { ...checklistFormData };
  }
  renderPMTool();
};

window.editChecklistItem = function (itemId) {
  const item = checklistItems.find(i => i.id === itemId);
  if (!item) return;

  editingChecklistItem = { ...item };
  // Also set window version for inline handlers
  window.editingChecklistItem = { ...item };
  showAddChecklistModal = true;
  renderPMTool();
};

// Show delete checklist item confirmation modal
window.showDeleteChecklistItemConfirm = function (itemId) {
  if (!itemId) return;

  const item = checklistItems.find(i => i.id === itemId);
  if (!item) return;

  // Check permissions: employees can only delete their own items
  const isOwnerOrManager = isManagerOrOwner();
  const isHHAdmin = currentProfile?.is_hh_admin || false;
  const isCreator = item.created_by === currentUser?.id || item.created_by === currentProfile?.id;

  if (!isOwnerOrManager && !isHHAdmin && !isCreator) {
    showNotification('You can only delete checklist items you created', 'error');
    return;
  }

  // Remove any existing modal
  const existingModal = document.getElementById('delete-checklist-item-modal');
  if (existingModal) {
    existingModal.remove();
  }

  const modal = document.createElement('div');
  modal.id = 'delete-checklist-item-modal';
  modal.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10001;
    animation: fadeIn 0.2s ease-out;
  `;

  modal.innerHTML = `
    <div style="
      background: white;
      border-radius: 1rem;
      padding: 0;
      max-width: 400px;
      width: 90%;
      box-shadow: 0 25px 50px rgba(0,0,0,0.25);
      animation: scaleIn 0.2s ease-out;
      overflow: hidden;
    ">
      <!-- Header -->
      <div style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1.25rem 1.5rem;
        border-bottom: 1px solid #E5E7EB;
      ">
        <div style="display: flex; align-items: center; gap: 0.75rem;">
          <span class="material-icons" style="color: #EF4444; font-size: 24px;">warning</span>
          <h3 style="margin: 0; font-size: 1.125rem; font-weight: 600; color: #111827;">Delete Checklist Item</h3>
        </div>
        <button 
          onclick="closeDeleteChecklistItemModal()"
          style="
            background: transparent;
            border: none;
            cursor: pointer;
            padding: 0.25rem;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 0.375rem;
            color: #6B7280;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#F3F4F6'; this.style.color='#111827';"
          onmouseout="this.style.background='transparent'; this.style.color='#6B7280';"
        >
          <span class="material-icons" style="font-size: 20px;">close</span>
        </button>
      </div>
      
      <!-- Body -->
      <div style="padding: 1.5rem;">
        <p style="margin: 0; color: #4B5563; font-size: 0.9375rem; line-height: 1.5;">
          Are you sure you want to delete <strong>${item.title || 'this checklist item'}</strong>? This action cannot be undone.
        </p>
      </div>
      
      <!-- Footer -->
      <div style="
        display: flex;
        gap: 0.75rem;
        padding: 1rem 1.5rem;
        background: #F9FAFB;
        border-top: 1px solid #E5E7EB;
        justify-content: flex-end;
      ">
        <button 
          onclick="closeDeleteChecklistItemModal()"
          style="
            padding: 0.75rem 1.5rem;
            background: white;
            border: 1px solid #D1D5DB;
            border-radius: 0.5rem;
            color: #374151;
            font-size: 0.9375rem;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#F9FAFB'; this.style.borderColor='#9CA3AF';"
          onmouseout="this.style.background='white'; this.style.borderColor='#D1D5DB';"
        >
          Cancel
        </button>
        <button 
          onclick="confirmDeleteChecklistItem('${itemId}')"
          style="
            padding: 0.75rem 1.5rem;
            background: #EF4444;
            border: none;
            border-radius: 0.5rem;
            color: white;
            font-size: 0.9375rem;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#DC2626';"
          onmouseout="this.style.background='#EF4444';"
        >
          Delete
        </button>
      </div>
    </div>
  `;

  // Add fadeIn and scaleIn animations if they don't exist
  if (!document.getElementById('delete-checklist-item-modal-styles')) {
    const style = document.createElement('style');
    style.id = 'delete-checklist-item-modal-styles';
    style.textContent = `
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      @keyframes scaleIn {
        from { transform: scale(0.95); opacity: 0; }
        to { transform: scale(1); opacity: 1; }
      }
    `;
    document.head.appendChild(style);
  }

  // Close on backdrop click
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      closeDeleteChecklistItemModal();
    }
  });

  document.body.appendChild(modal);
};

// Close delete checklist item modal
window.closeDeleteChecklistItemModal = function () {
  const modal = document.getElementById('delete-checklist-item-modal');
  if (modal) {
    modal.style.opacity = '0';
    setTimeout(() => {
      modal.remove();
    }, 200);
  }
};

// Confirm delete checklist item
window.confirmDeleteChecklistItem = async function (itemId) {
  if (!itemId) return;

  const item = checklistItems.find(i => i.id === itemId);
  if (!item) return;

  // Check permissions again before deleting
  const isOwnerOrManager = isManagerOrOwner();
  const isHHAdmin = currentProfile?.is_hh_admin || false;
  const isCreator = item.created_by === currentUser?.id || item.created_by === currentProfile?.id;

  if (!isOwnerOrManager && !isHHAdmin && !isCreator) {
    closeDeleteChecklistItemModal();
    showNotification('You can only delete checklist items you created', 'error');
    return;
  }

  const deleteBtn = document.querySelector('#delete-checklist-item-modal button[onclick*="confirmDeleteChecklistItem"]');
  if (deleteBtn) {
    deleteBtn.disabled = true;
    deleteBtn.innerHTML = '<span class="material-icons" style="font-size: 18px; animation: spin 1s linear infinite; display: inline-block;">refresh</span> Deleting...';
  }

  try {
    const { error } = await supabase
      .from('team_checklist_items')
      .delete()
      .eq('id', itemId)
      .eq('company_id', currentCompany.id);

    if (error) throw error;

    closeDeleteChecklistItemModal();
    showNotification('Checklist item deleted successfully', 'success');

    await loadChecklistItems();
    renderPMTool();
  } catch (error) {
    console.error('Error deleting checklist item:', error);
    closeDeleteChecklistItemModal();
    showNotification('Failed to delete checklist item: ' + (error.message || error), 'error');
  }
};

// Delete checklist item (shows confirmation modal)
window.deleteChecklistItem = function (itemId) {
  if (!itemId) return;
  showDeleteChecklistItemConfirm(itemId);
};

window.toggleChecklistItem = async function (itemId) {
  const item = checklistItems.find(i => i.id === itemId);
  if (!item) return;

  const today = new Date().toISOString().split('T')[0];
  const isCompleted = item.completed || false;

  if (isCompleted) {
    // Delete completion
    const { error } = await supabase
      .from('team_checklist_completions')
      .delete()
      .eq('checklist_item_id', itemId)
      .eq('user_id', currentUser.id)
      .eq('date', today);

    if (error) {
      console.error('Error removing completion:', error);
      alert('Failed to update checklist item: ' + error.message);
      return;
    }
  } else {
    // Insert completion
    const { error } = await supabase
      .from('team_checklist_completions')
      .insert({
        checklist_item_id: itemId,
        user_id: currentUser.id,
        date: today
      });

    if (error) {
      console.error('Error adding completion:', error);
      alert('Failed to update checklist item: ' + error.message);
      return;
    }
  }

  await loadChecklistItems();
  renderPMTool();
};

window.saveChecklistItem = async function () {
  const titleInput = document.getElementById('checklist-title');
  const descriptionInput = document.getElementById('checklist-description');
  const categoryInput = document.getElementById('checklist-category');

  const title = titleInput?.value.trim() || '';
  const description = descriptionInput?.value.trim() || '';
  const category = categoryInput?.value.trim() || '';
  const color = editingChecklistItem ? editingChecklistItem.color : checklistFormData.color;

  if (!title) {
    alert('Please enter a title');
    return;
  }

  if (editingChecklistItem) {
    // Update existing item
    const { error } = await supabase
      .from('team_checklist_items')
      .update({
        title,
        description: description || null,
        category: category || null,
        color
      })
      .eq('id', editingChecklistItem.id)
      .eq('company_id', currentCompany.id);

    if (error) {
      console.error('Error updating checklist item:', error);
      console.error('Error details:', JSON.stringify(error, null, 2));
      alert('Failed to update checklist item: ' + error.message);
      return;
    }
  } else {
    // Create new item
    const { error } = await supabase
      .from('team_checklist_items')
      .insert({
        company_id: currentCompany.id,
        created_by: currentUser.id,
        title,
        description: description || null,
        category: category || null,
        color: color || '#3B82F6',
        is_active: true
      });

    if (error) {
      console.error('Error creating checklist item:', error);
      console.error('Error details:', JSON.stringify(error, null, 2));
      alert('Failed to create checklist item: ' + error.message);
      return;
    }
  }

  // Close modal and reload
  showAddChecklistModal = false;
  editingChecklistItem = null;
  checklistFormData = { color: '#3B82F6' };
  await loadChecklistItems();
  renderPMTool();

  await loadChecklistItems();
  closeChecklistModal();
  renderPMTool();
};

function renderProfileScreen() {
  // Check if user is CLIENT
  const userRole = currentProfile?.company_role || currentProfile?.role || 'USER';
  const isClient = userRole === 'CLIENT';

  const isManagerOwner = isManagerOrOwner();
  const isHHAdmin = currentProfile?.is_hh_admin || currentUser?.is_hh_admin || false;
  const userInitials = `${(currentProfile?.first_name || '').charAt(0)}${(currentProfile?.last_name || '').charAt(0)}`.toUpperCase() || 'U';
  const userName = `${currentProfile?.first_name || 'User'} ${currentProfile?.last_name || ''}`.trim();
  const userEmail = currentUser?.email || '';

  // Get avatar URL if available
  const avatarPath = currentProfile?.avatar_path || currentUser?.avatar_path;
  const avatarUrl = avatarPath ? getAvatarUrl(avatarPath) : null;

  return `
    <div style="max-width: 800px; margin: 0 auto; padding: 1.5rem;">
      <!-- Header -->
      <div style="margin-bottom: 2rem;">
        <h1 style="
          color: #2c3e50;
          margin: 0 0 0.5rem 0;
          font-size: 2rem;
          font-weight: 700;
        ">
          Profile
        </h1>
        <p style="
          color: #6c757d;
          margin: 0;
          font-size: 1rem;
        ">
          Manage your profile and account settings
        </p>
      </div>

      <!-- User Info Card -->
      <div style="
        background: #ffffff;
        border-radius: 0.75rem;
        padding: 1.5rem;
        margin-bottom: 1.5rem;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        display: flex;
        align-items: center;
        gap: 1rem;
      ">
        <div
          onclick="showEditProfileModal()"
          style="
          width: 4rem;
          height: 4rem;
            border-radius: 50%;
            flex-shrink: 0;
            position: relative;
            overflow: visible;
          background: #f59e0b;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: transform 0.2s, box-shadow 0.2s;
          "
          onmouseover="this.style.transform='scale(1.05)'; this.style.boxShadow='0 4px 8px rgba(0,0,0,0.2)'"
          onmouseout="this.style.transform='scale(1)'; this.style.boxShadow='none'"
          title="Click to edit profile"
        >
          ${avatarUrl ? `
            <img
              src="${avatarUrl}"
              alt="${userName}"
              style="
                width: 100%;
                height: 100%;
                object-fit: cover;
          border-radius: 50%;
              "
              onerror="
                this.style.display='none';
                const fallback = this.parentElement.querySelector('.avatar-fallback');
                if (fallback) fallback.style.display='flex';
              "
            />
            <div class="avatar-fallback" style="
              display: none;
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
              align-items: center;
              justify-content: center;
              color: white;
              font-size: 1.5rem;
              font-weight: 600;
              border-radius: 50%;
            ">${userInitials}</div>
          ` : `
            <div style="
              width: 100%;
              height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 1.5rem;
          font-weight: 600;
            ">${userInitials}</div>
          `}
          <!-- Edit Pencil Icon -->
          <div style="
            position: absolute;
            bottom: 0;
            right: 0;
            width: 24px;
            height: 24px;
            background: #dc2626;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 2px solid #ffffff;
            box-shadow: 0 2px 4px rgba(0,0,0,0.2);
            z-index: 10;
          ">
            <span style="
              color: white;
              font-size: 0.75rem;
              font-weight: 600;
              line-height: 1;
            ">✏️</span>
          </div>
        </div>
        <div style="flex: 1;">
          <h3 style="margin: 0; color: #2c3e50; font-size: 1.25rem; font-weight: 600;">
            ${userName}
          </h3>
          ${currentCompany?.name ? `
            <p style="margin: 0.25rem 0 0 0; color: #6c757d; font-size: 0.875rem; font-weight: 500;">
              ${currentCompany.name}
              ${(() => {
        if (currentCompany.is_premium === true) {
          return ' <span style="background: #10b981; color: white; padding: 0.125rem 0.5rem; border-radius: 0.25rem; font-size: 0.75rem; font-weight: 600; margin-left: 0.5rem;">Premium</span>';
        } else {
          const daysRemaining = getTrialDaysRemaining(currentCompany);
          if (daysRemaining !== null && daysRemaining > 0) {
            return ` <span style="background: #f59e0b; color: white; padding: 0.125rem 0.5rem; border-radius: 0.25rem; font-size: 0.75rem; font-weight: 600; margin-left: 0.5rem;">${daysRemaining} ${daysRemaining === 1 ? 'day' : 'days'} on trial</span>`;
          }
        }
        return '';
      })()}
            </p>
          ` : ''}
          ${currentProfile?.company_role ? `
            <p style="margin: 0.125rem 0 0 0; color: #9ca3af; font-size: 0.75rem; text-transform: capitalize;">
              ${currentProfile.company_role}
            </p>
          ` : ''}
          <p style="margin: 0.25rem 0 0 0; color: #6c757d; font-size: 0.875rem;">
            ${userEmail}
          </p>
          <button
            onclick="showChangePasswordModal()"
            style="
              margin-top: 1rem;
              background: #f59e0b;
              color: white;
              border: none;
              padding: 0.625rem 1.25rem;
              border-radius: 0.5rem;
              cursor: pointer;
              font-weight: 600;
              font-size: 0.875rem;
              transition: background-color 0.2s;
            "
            onmouseover="this.style.background='#d97706'"
            onmouseout="this.style.background='#f59e0b'"
          >
            Change Password
          </button>
        </div>
      </div>

      ${isClient ? `
      <!-- CLIENT: Only show App Feedback and Logout -->
      <div style="margin-bottom: 2rem;">
        <h2 style="
          color: #2c3e50;
          margin: 0 0 0.75rem 0;
          font-size: 1.125rem;
          font-weight: 700;
        ">
          Settings
        </h2>
        <div style="
          background: #ffffff;
          border-radius: 0.75rem;
          overflow: hidden;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        ">
          <div
            onclick="openFeedbackScreen();"
            style="
              padding: 1rem 1.25rem;
              border-bottom: 1px solid #f3f4f6;
              display: flex;
              align-items: center;
              gap: 1rem;
              cursor: pointer;
              transition: background-color 0.2s;
            "
            onmouseover="this.style.backgroundColor='#f8f9fa'"
            onmouseout="this.style.backgroundColor='#ffffff'"
          >
            <div style="flex: 1;">
              <div style="color: #2c3e50; font-weight: 500; font-size: 0.9375rem;">
                App Feedback
              </div>
            </div>
            <div style="color: #f59e0b; font-size: 1.25rem;">›</div>
          </div>
        </div>
      </div>

      <!-- Actions Section -->
      <div style="margin-bottom: 2rem;">
        <h2 style="
          color: #2c3e50;
          margin: 0 0 0.75rem 0;
          font-size: 1.125rem;
          font-weight: 700;
        ">
          Actions
        </h2>
        <div style="
          background: #ffffff;
          border-radius: 0.75rem;
          overflow: hidden;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        ">
          <div
            onclick="if (confirm('Are you sure you want to logout?')) { handleLogout(); }"
            style="
              padding: 1rem 1.25rem;
              display: flex;
              align-items: center;
              gap: 1rem;
              cursor: pointer;
              transition: background-color 0.2s;
            "
            onmouseover="this.style.backgroundColor='#f8f9fa'"
            onmouseout="this.style.backgroundColor='#ffffff'"
          >
            <div style="flex: 1;">
              <div style="color: #2c3e50; font-weight: 500; font-size: 0.9375rem;">
                Logout
              </div>
            </div>
            <div style="color: #f59e0b; font-size: 1.25rem;">›</div>
          </div>
        </div>
      </div>
      ` : `
      <!-- Regular Users: Show all sections -->
      <!-- Settings Section -->
      <div style="margin-bottom: 2rem;">
        <h2 style="
          color: #2c3e50;
          margin: 0 0 0.75rem 0;
          font-size: 1.125rem;
          font-weight: 700;
        ">
          Settings
        </h2>
        <div style="
          background: #ffffff;
          border-radius: 0.75rem;
          overflow: hidden;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        ">
          <div
            onclick="openFeedbackScreen();"
            style="
              padding: 1rem 1.25rem;
              border-bottom: 1px solid #f3f4f6;
              display: flex;
              align-items: center;
              gap: 1rem;
              cursor: pointer;
              transition: background-color 0.2s;
            "
            onmouseover="this.style.backgroundColor='#f8f9fa'"
            onmouseout="this.style.backgroundColor='#ffffff'"
          >
            <div style="flex: 1;">
              <div style="color: #2c3e50; font-weight: 500; font-size: 0.9375rem;">
                App Feedback
              </div>
            </div>
            <div style="color: #f59e0b; font-size: 1.25rem;">›</div>
          </div>
        </div>
      </div>

      <!-- Company Section -->
      <div style="margin-bottom: 2rem;">
        <h2 style="
          color: #2c3e50;
          margin: 0 0 0.75rem 0;
          font-size: 1.125rem;
          font-weight: 700;
        ">
          Company
        </h2>
        <div style="
          background: #ffffff;
          border-radius: 0.75rem;
          overflow: hidden;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        ">
          ${isManagerOwner ? `
          <div
            onclick="openCompanyManagement()"
            style="
              padding: 1rem 1.25rem;
              border-bottom: 1px solid #f3f4f6;
              display: flex;
              align-items: center;
              gap: 1rem;
              cursor: pointer;
              transition: background-color 0.2s;
            "
            onmouseover="this.style.backgroundColor='#f8f9fa'"
            onmouseout="this.style.backgroundColor='#ffffff'"
          >
            <div style="flex: 1;">
              <div style="color: #2c3e50; font-weight: 500; font-size: 0.9375rem;">
                Management
              </div>
            </div>
            <div style="color: #f59e0b; font-size: 1.25rem;">›</div>
          </div>
          ` : ''}
          ${currentProfile?.company_role === 'OWNER' ? `
          <div
            onclick="openBillingManagement()"
            style="
              padding: 1rem 1.25rem;
              ${isManagerOwner ? 'border-bottom: 1px solid #f3f4f6;' : ''}
              display: flex;
              align-items: center;
              gap: 1rem;
              cursor: pointer;
              transition: background-color 0.2s;
            "
            onmouseover="this.style.backgroundColor='#f8f9fa'"
            onmouseout="this.style.backgroundColor='#ffffff'"
          >
            <div style="flex: 1;">
              <div style="color: #2c3e50; font-weight: 500; font-size: 0.9375rem;">
                Billing
              </div>
            </div>
            <div style="color: #f59e0b; font-size: 1.25rem;">›</div>
          </div>
          ` : ''}
          ${currentCompany?.is_hh_client === true && (currentProfile?.company_role === 'OWNER' || currentProfile?.company_role === 'MANAGER') ? `
          <div
            onclick="window.open('https://share.hsforms.com/2oXBbiWRmQp-Q66iU2lCDewqryah', '_blank')"
            style="
              padding: 1rem 1.25rem;
              ${(currentProfile?.company_role === 'OWNER' || currentProfile?.company_role === 'MANAGER') ? 'border-bottom: 1px solid #f3f4f6;' : ''}
              display: flex;
              align-items: center;
              gap: 1rem;
              cursor: pointer;
              transition: background-color 0.2s;
            "
            onmouseover="this.style.backgroundColor='#f8f9fa'"
            onmouseout="this.style.backgroundColor='#ffffff'"
          >
            <div style="flex: 1;">
              <div style="color: #2c3e50; font-weight: 500; font-size: 0.9375rem;">
                Update Website
              </div>
              <div style="color: #6c757d; font-size: 0.8125rem; margin-top: 0.25rem;">
                If you have a website with Hello Habanero, use this button to request updates.
              </div>
            </div>
            <div style="color: #f59e0b; font-size: 1.25rem;">›</div>
          </div>
          ` : ''}
        </div>
      </div>

      <!-- Actions Section -->
      <div style="margin-bottom: 2rem;">
        <h2 style="
          color: #2c3e50;
          margin: 0 0 0.75rem 0;
          font-size: 1.125rem;
          font-weight: 700;
        ">
          Actions
        </h2>
        <div style="
          background: #ffffff;
          border-radius: 0.75rem;
          overflow: hidden;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        ">
          <div
            onclick="showDeleteAccountModal()"
            style="
              padding: 1rem 1.25rem;
              border-bottom: 1px solid #f3f4f6;
              display: flex;
              align-items: center;
              gap: 1rem;
              cursor: pointer;
              transition: background-color 0.2s;
            "
            onmouseover="this.style.backgroundColor='#f8f9fa'"
            onmouseout="this.style.backgroundColor='#ffffff'"
          >
            <div style="flex: 1;">
              <div style="color: #2c3e50; font-weight: 500; font-size: 0.9375rem;">
                Delete Account
              </div>
            </div>
            <div style="color: #f59e0b; font-size: 1.25rem;">›</div>
          </div>
          <div
            onclick="if (confirm('Are you sure you want to logout?')) { handleLogout(); }"
            style="
              padding: 1rem 1.25rem;
              display: flex;
              align-items: center;
              gap: 1rem;
              cursor: pointer;
              transition: background-color 0.2s;
            "
            onmouseover="this.style.backgroundColor='#f8f9fa'"
            onmouseout="this.style.backgroundColor='#ffffff'"
          >
            <div style="flex: 1;">
              <div style="color: #2c3e50; font-weight: 500; font-size: 0.9375rem;">
                Logout
              </div>
            </div>
            <div style="color: #f59e0b; font-size: 1.25rem;">›</div>
          </div>
        </div>
      </div>
      `}
    </div>
    ${showChangePasswordModal ? renderChangePasswordModal() : ''}
  `;
}

// Render Change Password Modal
function renderChangePasswordModal() {
  return `
    <div id="change-password-modal-overlay" style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.6);
      z-index: 10000;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem;
    " onclick="if (event.target.id === 'change-password-modal-overlay') closeChangePasswordModal()">
      <div id="change-password-modal" style="
        background: #ffffff;
        border-radius: 1rem;
        width: 100%;
        max-width: 500px;
        max-height: 90vh;
        overflow-y: auto;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
      " onclick="event.stopPropagation()">
        <!-- Header -->
        <div style="
          padding: 1.5rem;
          border-bottom: 1px solid #e9ecef;
          display: flex;
          justify-content: space-between;
          align-items: center;
        ">
          <h2 style="
            margin: 0;
            font-size: 1.25rem;
            font-weight: 700;
            color: #2c3e50;
          ">Change Password</h2>
          <button
            onclick="closeChangePasswordModal()"
            style="
              background: transparent;
              border: none;
              color: #6c757d;
              cursor: pointer;
              font-size: 1.25rem;
              padding: 0;
              width: 32px;
              height: 32px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 50%;
              transition: background-color 0.2s;
            "
            onmouseover="this.style.background='#f3f4f6'"
            onmouseout="this.style.background='transparent'"
          >
            ×
          </button>
        </div>
        
        <!-- Form Content -->
        <div style="padding: 1.5rem;">
          <form id="change-password-form" onsubmit="submitChangePassword(event)">
            <!-- Current Password -->
            <div style="margin-bottom: 1.5rem;">
              <label style="
                display: block;
                font-weight: 600;
                color: #2c3e50;
                margin-bottom: 0.5rem;
                font-size: 0.9375rem;
              ">
                Current Password <span style="color: #dc2626;">*</span>
              </label>
              <input
                type="password"
                id="current-password"
                required
                value="${changePasswordData.currentPassword}"
                oninput="changePasswordData.currentPassword = this.value"
                placeholder="Enter your current password"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e9ecef;
                  border-radius: 0.5rem;
                  font-size: 0.9375rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s;
                "
                onfocus="this.style.borderColor='#f59e0b'"
                onblur="this.style.borderColor='#e9ecef'"
              />
            </div>
            
            <!-- New Password -->
            <div style="margin-bottom: 1.5rem;">
              <label style="
                display: block;
                font-weight: 600;
                color: #2c3e50;
                margin-bottom: 0.5rem;
                font-size: 0.9375rem;
              ">
                New Password <span style="color: #dc2626;">*</span>
              </label>
              <input
                type="password"
                id="new-password"
                required
                value="${changePasswordData.newPassword}"
                oninput="changePasswordData.newPassword = this.value"
                placeholder="Enter your new password"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e9ecef;
                  border-radius: 0.5rem;
                  font-size: 0.9375rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s;
                "
                onfocus="this.style.borderColor='#f59e0b'"
                onblur="this.style.borderColor='#e9ecef'"
              />
            </div>
            
            <!-- Confirm New Password -->
            <div style="margin-bottom: 1.5rem;">
              <label style="
                display: block;
                font-weight: 600;
                color: #2c3e50;
                margin-bottom: 0.5rem;
                font-size: 0.9375rem;
              ">
                Confirm New Password <span style="color: #dc2626;">*</span>
              </label>
              <input
                type="password"
                id="confirm-password"
                required
                value="${changePasswordData.confirmPassword}"
                oninput="changePasswordData.confirmPassword = this.value"
                placeholder="Confirm your new password"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid #e9ecef;
                  border-radius: 0.5rem;
                  font-size: 0.9375rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s;
                "
                onfocus="this.style.borderColor='#f59e0b'"
                onblur="this.style.borderColor='#e9ecef'"
              />
            </div>
            
            <!-- Submit Button -->
            <button
              type="submit"
              style="
                background: #f59e0b;
                color: white;
                border: none;
                padding: 0.875rem 1.5rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-weight: 600;
                font-size: 0.9375rem;
                width: 100%;
                transition: background-color 0.2s;
              "
              onmouseover="this.style.background='#d97706'"
              onmouseout="this.style.background='#f59e0b'"
            >
              Change Password
            </button>
          </form>
        </div>
      </div>
    </div>
  `;
}

// Show Change Password Modal
window.showChangePasswordModal = function () {
  changePasswordData = {
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  };
  showChangePasswordModal = true;
  renderPMTool();
};

// Close Change Password Modal
window.closeChangePasswordModal = function () {
  showChangePasswordModal = false;
  changePasswordData = {
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  };
  renderPMTool();
};

// Submit Change Password
window.submitChangePassword = async function (event) {
  event.preventDefault();

  const currentPasswordInput = document.getElementById('current-password');
  const newPasswordInput = document.getElementById('new-password');
  const confirmPasswordInput = document.getElementById('confirm-password');

  if (!currentPasswordInput || !newPasswordInput || !confirmPasswordInput) {
    alert('Please fill in all fields');
    return;
  }

  const currentPassword = currentPasswordInput.value.trim();
  const newPassword = newPasswordInput.value.trim();
  const confirmPassword = confirmPasswordInput.value.trim();

  if (!currentPassword || !newPassword || !confirmPassword) {
    alert('Please fill in all fields');
    return;
  }

  if (newPassword !== confirmPassword) {
    alert('New password and confirm password do not match');
    confirmPasswordInput.focus();
    return;
  }

  if (newPassword.length < 6) {
    alert('New password must be at least 6 characters long');
    newPasswordInput.focus();
    return;
  }

  try {
    // Update password using Supabase Auth
    const { error: updateError } = await supabase.auth.updateUser({
      password: newPassword
    });

    if (updateError) {
      console.error('Error updating password:', updateError);
      alert('Failed to change password: ' + updateError.message);
      return;
    }

    alert('Password changed successfully!');

    closeChangePasswordModal();
    renderPMTool();

  } catch (error) {
    console.error('Error changing password:', error);
    alert('An error occurred while changing password. Please try again.');
  }
};

// Render Add Task Modal (Animated popup)
function renderAddTaskModal() {
  // Load projects if needed for displaying selected project
  let allProjects = [];
  try {
    // Try to get from global scope or load
    if (typeof window.allProjectsCache !== 'undefined') {
      allProjects = window.allProjectsCache;
    }
  } catch (e) {
    console.warn('Could not load projects for display');
  }

  // Get contact and project data for display
  const contactId = window.selectedTaskContact || selectedContact;
  const contactData = contactId ? contacts.find(c => c.id === contactId) : null;
  const projectId = window.selectedTaskProject || selectedProject;

  return `
    <!-- Modal Overlay -->
    <div id="add-task-modal" onclick="handleModalClick(event)" style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 99999;
      animation: fadeIn 0.3s ease-out;
    ">
      <!-- Modal Content -->
      <div onclick="event.stopPropagation()" style="
        background: ${colors.surface};
        border-radius: 1rem;
        padding: 1.5rem;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
        max-width: 600px;
        width: 95%;
        max-height: 85vh;
        overflow-y: auto;
        animation: slideIn 0.3s ease-out;
        position: relative;
      ">
      <style>
        @media (max-width: 640px) {
          #add-task-modal > div {
            width: 100% !important;
            max-height: 100vh !important;
            border-radius: 0 !important;
            padding: 1rem !important;
          }
        }
      </style>
        <!-- Close Button -->
        <button
          onclick="toggleAddTaskForm()"
          style="
            position: absolute;
            top: 1rem;
            right: 1rem;
            background: #dc2626;
            color: white;
            border: none;
            width: 2.5rem;
            height: 2.5rem;
            border-radius: 50%;
            cursor: pointer;
            font-size: 1.5rem;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.2s ease;
            box-shadow: 0 2px 4px rgba(0,0,0,0.2);
            z-index: 10;
          "
          onmouseover="this.style.transform='scale(1.1)'; this.style.background='#b91c1c'"
          onmouseout="this.style.transform='scale(1)'; this.style.background='#dc2626'"
        >
          ×
        </button>

        <!-- Modal Header -->
        <div style="margin-bottom: 2rem; padding-right: 3rem;">
          <h2 style="margin: 0; color: ${colors.text}; font-size: 1.75rem; font-weight: 600;">
            ${editingTask ? 'Edit Task' : 'Create New Task'}
          </h2>
          <p style="margin: 0.5rem 0 0 0; color: ${colors.textSecondary}; font-size: 1rem;">
            ${editingTask ? 'Update task details' : 'Add a new task to your project management board'}
          </p>
        </div>

        <!-- Modal Form -->
        <form id="add-task-form" novalidate onsubmit="event.preventDefault(); submitTask(event); return false;">
          <div style="display: grid; gap: 1.5rem;">
            <!-- Title -->
            <div>
              <label style="display: block; margin-bottom: 0.5rem; color: ${colors.text}; font-weight: 500;">
                Task Title *
              </label>
              <div>
                <input
                  type="text"
                  id="task-title"
                  placeholder="Enter task title"
                  value="${editingTask ? editingTask.title : ''}"
                  style="
                    width: 100%;
                    padding: 0.75rem;
                    border: 1px solid ${colors.border};
                    border-radius: 0.5rem;
                    font-size: 1rem;
                    box-sizing: border-box;
                    transition: border-color 0.2s ease;
                  "
                  onfocus="this.style.borderColor='${colors.primary}'"
                  onblur="this.style.borderColor='${colors.border}'"
                />
              </div>
            </div>

            <!-- Description -->
            <div>
              <label style="display: block; margin-bottom: 0.5rem; color: ${colors.text}; font-weight: 500;">
                Description *
              </label>
              <textarea
                id="task-description"
                rows="4"
                placeholder="Enter task description"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid ${colors.border};
                  border-radius: 0.5rem;
                  font-size: 1rem;
                  box-sizing: border-box;
                  resize: vertical;
                  min-height: 100px;
                  transition: border-color 0.2s ease;
                "
                onfocus="this.style.borderColor='${colors.primary}'"
                onblur="this.style.borderColor='${colors.border}'"
              >${editingTask ? editingTask.description || '' : ''}</textarea>
            </div>

            <!-- Service -->
            <div>
              <label style="display: block; margin-bottom: 0.5rem; color: ${colors.text}; font-weight: 500;">
                Service
              </label>
              <div style="display: flex; flex-wrap: wrap; gap: 0.5rem; margin-bottom: 0.5rem;">
                <button
                  type="button"
                  onclick="setSelectedService('')"
                  id="service-other"
                  style="
                    padding: 0.5rem 1rem;
                    border-radius: 1rem;
                    border: 1px solid ${colors.border};
                    background: ${selectedService === '' ? '#f59e0b' : colors.background};
                    color: ${selectedService === '' ? 'white' : colors.text};
                    cursor: pointer;
                    font-size: 0.875rem;
                    transition: all 0.2s ease;
                  "
                >
                  Other
                </button>
                ${services.map(service => `
                  <button
                    type="button"
                    onclick="setSelectedService('${service.id}')"
                    id="service-${service.id}"
                    style="
                      padding: 0.5rem 1rem;
                      border-radius: 1rem;
                      border: 1px solid ${colors.border};
                      background: ${selectedService === service.id ? colors.primary : colors.background};
                      color: ${selectedService === service.id ? 'white' : colors.text};
                      cursor: pointer;
                      font-size: 0.875rem;
                      transition: all 0.2s ease;
                    "
                  >
                    ${service.name}
                  </button>
                `).join('')}
              </div>
              <input
                type="text"
                id="custom-service-name"
                placeholder="Enter custom service name"
                value="${customServiceName}"
                oninput="customServiceName = this.value; window.customTaskServiceName = this.value"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid ${colors.border};
                  border-radius: 0.5rem;
                  font-size: 1rem;
                  box-sizing: border-box;
                  display: ${selectedService === '' ? 'block' : 'none'};
                  transition: border-color 0.2s ease;
                "
                onfocus="this.style.borderColor='${colors.primary}'"
                onblur="this.style.borderColor='${colors.border}'"
              />
            </div>

            <!-- Priority -->
            <div>
              <label style="display: block; margin-bottom: 0.5rem; color: ${colors.text}; font-weight: 500;">
                Priority
              </label>
              <div style="display: flex; flex-wrap: wrap; gap: 0.5rem;">
                <button
                  type="button"
                  onclick="setTaskPriority('LOW')"
                  id="priority-low"
                  style="
                    padding: 0.5rem 1rem;
                    border-radius: 1rem;
                    border: 1px solid #10b981;
                    background: ${taskPriority === 'LOW' ? '#10b981' : colors.background};
                    color: ${taskPriority === 'LOW' ? 'white' : colors.text};
                    cursor: pointer;
                    font-size: 0.875rem;
                    transition: all 0.2s ease;
                  "
                >
                  Low
                </button>
                <button
                  type="button"
                  onclick="setTaskPriority('MEDIUM')"
                  id="priority-medium"
                  style="
                    padding: 0.5rem 1rem;
                    border-radius: 1rem;
                    border: 1px solid #f59e0b;
                    background: ${taskPriority === 'MEDIUM' ? '#f59e0b' : colors.background};
                    color: ${taskPriority === 'MEDIUM' ? 'white' : colors.text};
                    cursor: pointer;
                    font-size: 0.875rem;
                    transition: all 0.2s ease;
                  "
                >
                  Medium
                </button>
                <button
                  type="button"
                  onclick="setTaskPriority('HIGH')"
                  id="priority-high"
                  style="
                    padding: 0.5rem 1rem;
                    border-radius: 1rem;
                    border: 1px solid #f97316;
                    background: ${taskPriority === 'HIGH' ? '#f97316' : colors.background};
                    color: ${taskPriority === 'HIGH' ? 'white' : colors.text};
                    cursor: pointer;
                    font-size: 0.875rem;
                    transition: all 0.2s ease;
                  "
                >
                  High
                </button>
                <button
                  type="button"
                  onclick="setTaskPriority('URGENT')"
                  id="priority-urgent"
                  style="
                    padding: 0.5rem 1rem;
                    border-radius: 1rem;
                    border: 1px solid #dc2626;
                    background: ${taskPriority === 'URGENT' ? '#dc2626' : colors.background};
                    color: ${taskPriority === 'URGENT' ? 'white' : colors.text};
                    cursor: pointer;
                    font-size: 0.875rem;
                    transition: all 0.2s ease;
                  "
                >
                  Urgent
                </button>
              </div>
            </div>

            <!-- Due Date -->
            <div>
              <label style="display: block; margin-bottom: 0.5rem; color: ${colors.text}; font-weight: 500;">
                Due Date
              </label>
              <input
                type="date"
                id="task-due-date"
                value="${editingTask && editingTask.due_at ? new Date(editingTask.due_at).toISOString().split('T')[0] : ''}"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid ${colors.border};
                  border-radius: 0.5rem;
                  font-size: 1rem;
                  box-sizing: border-box;
                  transition: border-color 0.2s ease;
                "
                onfocus="this.style.borderColor='${colors.primary}'"
                onblur="this.style.borderColor='${colors.border}'"
              />
            </div>

            <!-- Status -->
            <div>
              <label style="display: block; margin-bottom: 0.5rem; color: ${colors.text}; font-weight: 500;">
                Status
              </label>
              <div style="display: flex; flex-wrap: wrap; gap: 0.5rem;">
                <button
                  type="button"
                  onclick="setTaskStatus('BACKLOG')"
                  id="status-backlog"
                  style="
                    padding: 0.5rem 1rem;
                    border-radius: 1rem;
                    border: 1px solid #6b7280;
                    background: ${(window.taskStatus || 'BACKLOG') === 'BACKLOG' ? '#6b7280' : colors.background};
                    color: ${(window.taskStatus || 'BACKLOG') === 'BACKLOG' ? 'white' : colors.text};
                    cursor: pointer;
                    font-size: 0.875rem;
                    transition: all 0.2s ease;
                  "
                >
                  Backlog
                </button>
                <button
                  type="button"
                  onclick="setTaskStatus('ACTIVE')"
                  id="status-active"
                  style="
                    padding: 0.5rem 1rem;
                    border-radius: 1rem;
                    border: 1px solid #3b82f6;
                    background: ${(window.taskStatus || 'BACKLOG') === 'ACTIVE' ? '#3b82f6' : colors.background};
                    color: ${(window.taskStatus || 'BACKLOG') === 'ACTIVE' ? 'white' : colors.text};
                    cursor: pointer;
                    font-size: 0.875rem;
                    transition: all 0.2s ease;
                  "
                >
                  Active
                </button>
              </div>
            </div>

            <!-- Assign Team Members -->
            <div>
              <label style="display: block; margin-bottom: 0.5rem; color: ${colors.text}; font-weight: 500;">
                Assign Team Members *
              </label>
              <input
                type="text"
                id="member-search"
                placeholder="Search members..."
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid ${colors.border};
                  border-radius: 0.5rem;
                  font-size: 1rem;
                  box-sizing: border-box;
                  margin-bottom: 0.5rem;
                  transition: border-color 0.2s ease;
                "
                onfocus="this.style.borderColor='${colors.primary}'; showMemberDropdown(this)"
                onblur="setTimeout(() => { const results = document.getElementById('member-search-results'); if (results && !results.matches(':hover') && !event.relatedTarget?.closest('#member-search-results')) { this.style.borderColor='${colors.border}'; results.style.display='none'; } }, 200)"
              />
              <div id="selected-members" style="display: flex; flex-wrap: wrap; gap: 0.5rem; margin-bottom: 0.5rem;">
                <!-- Selected members will appear here -->
              </div>
              <div id="member-search-results" style="
                max-height: 200px;
                overflow-y: auto;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                background: ${colors.surface};
                display: none;
              ">
                <!-- Search results will appear here -->
              </div>
            </div>

            <!-- Link to Contact -->
            ${(() => {
      // Hide "Link to Contact" if we're inside a contact
      // Check preselectedTaskContactId first, then selectedContactId on sales screen
      const isInsideContact = window.preselectedTaskContactId || (currentScreen === 'sales' && selectedContactId);
      if (isInsideContact) {
        return ''; // Don't show this section when inside a contact
      }

      const contactId = window.selectedTaskContact || selectedContact;
      if (contactId) {
        // Contact is selected - hide search input, show placeholder div that will be populated
        return `
                  <div>
                    <label style="display: block; margin-bottom: 0.5rem; color: ${colors.text}; font-weight: 500;">
                      Link to Contact
                    </label>
                    <div id="selected-contact" style="display: flex; flex-wrap: wrap; gap: 0.5rem; margin-bottom: 0.5rem;">
                      <!-- Selected contact will appear here -->
                    </div>
                    <div id="contact-search-results" style="
                      max-height: 200px;
                      overflow-y: auto;
                      border: 1px solid ${colors.border};
                      border-radius: 0.5rem;
                      background: ${colors.surface};
                      display: none;
                    ">
                      <!-- Search results will appear here -->
                    </div>
                  </div>
                `;
      }
      return `
                <div>
                  <label style="display: block; margin-bottom: 0.5rem; color: ${colors.text}; font-weight: 500;">
                    Link to Contact
                  </label>
                  <input
                    type="text"
                    id="contact-search"
                    placeholder="Search contacts..."
                    style="
                      width: 100%;
                      padding: 0.75rem;
                      border: 1px solid ${colors.border};
                      border-radius: 0.5rem;
                      font-size: 1rem;
                      box-sizing: border-box;
                      margin-bottom: 0.5rem;
                      transition: border-color 0.2s ease;
                    "
                    oninput="handleContactSearchInTaskModal(this.value)"
                    onfocus="this.style.borderColor='${colors.primary}'"
                    onblur="this.style.borderColor='${colors.border}'"
                  />
                  <div id="selected-contact" style="display: flex; flex-wrap: wrap; gap: 0.5rem; margin-bottom: 0.5rem;">
                    <!-- Selected contact will appear here -->
                  </div>
                  <div id="contact-search-results" style="
                    max-height: 200px;
                    overflow-y: auto;
                    border: 1px solid ${colors.border};
                    border-radius: 0.5rem;
                    background: ${colors.surface};
                    display: none;
                  ">
                    <!-- Search results will appear here -->
                  </div>
                </div>
              `;
    })()}

            <!-- Link to Project -->
            ${(() => {
      // Always show "Link to Project" section - projects will load based on selected contact
      return `
                <div>
                  <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 0.5rem;">
                    <label style="color: ${colors.text}; font-weight: 500; display: flex; align-items: center; gap: 0.5rem;">
                      📁 Link to Project
                    </label>
                    ${!showProjectCreation ? `
                    <button
                      type="button"
                      onclick="toggleProjectCreation()"
                      style="
                        background: #f59e0b;
                        color: white;
                        border: none;
                          padding: 0.375rem 0.75rem;
                        border-radius: 0.375rem;
                        cursor: pointer;
                        font-size: 0.875rem;
                        font-weight: 600;
                      "
                    >
                        Create New
                    </button>
                    ` : ''}
                  </div>
                  
                  ${!showProjectCreation ? `
                    ${window.newProjectConfirmedInTask && window.newProjectNameInTask ? `
                      <!-- Confirmed New Project Badge -->
                      <div style="
                        background: ${colors.primary};
                        color: white;
                        padding: 1rem;
                        border-radius: 0.5rem;
                        margin-bottom: 0.5rem;
                      ">
                        <div style="display: flex; justify-content: space-between; align-items: start;">
                          <div>
                            <div style="font-size: 0.75rem; opacity: 0.9; margin-bottom: 0.25rem;">📁 New Project Ready</div>
                            <div style="font-weight: 600; margin-bottom: 0.25rem;">${window.newProjectNameInTask}</div>
                            ${window.newProjectDescriptionInTask ? `<div style="font-size: 0.875rem; opacity: 0.9;">${window.newProjectDescriptionInTask}</div>` : ''}
                            <div style="font-size: 0.75rem; opacity: 0.8; margin-top: 0.5rem; font-style: italic;">Project will be created when task is saved</div>
                          </div>
                          <button
                            onclick="window.newProjectConfirmedInTask = false; window.newProjectNameInTask = ''; window.newProjectDescriptionInTask = ''; showProjectCreation = false; renderPMTool();"
                            style="
                              background: rgba(255,255,255,0.2);
                              border: none;
                              color: white;
                              padding: 0.5rem;
                              border-radius: 0.25rem;
                              cursor: pointer;
                            "
                          >✏️</button>
                        </div>
                      </div>
                    ` : (() => {
            const currentProjectId = window.selectedTaskProject || selectedProject || window.preselectedTaskProjectId;
            if (currentProjectId) {
              // Project is selected - show placeholder div that will be populated by fetchAndDisplaySelectedProject
              return `
                          <div id="selected-project" style="display: flex; flex-wrap: wrap; gap: 0.5rem; margin-bottom: 0.5rem;">
                            <!-- Selected project will appear here -->
                          </div>
                        `;
            }
            return `
                        <!-- Project Selection - scrollable list for selected contact -->
                        <div id="selected-project" style="display: flex; flex-wrap: wrap; gap: 0.5rem; margin-bottom: 0.5rem;">
                          <!-- Selected project will appear here -->
                        </div>
                        <div id="project-list-container" style="
                          max-height: 200px;
                          overflow-y: auto;
                          border: 1px solid ${colors.border};
                          border-radius: 0.5rem;
                          background: ${colors.surface};
                        ">
                          <div style="padding: 1rem; text-align: center; color: #6c757d; font-size: 0.875rem;">
                            Loading projects...
                          </div>
                        </div>
                      `;
          })()}
                  ` : `
                <!-- Create New Project Section -->
                <div style="margin-top: 0.5rem; padding: 1rem; background: ${colors.background}; border-radius: 0.5rem; border: 1px solid ${colors.border};">
                  <div style="display: flex; align-items: center; gap: 0.5rem; margin-bottom: 1rem;">
                    <span style="color: ${colors.primary}; font-size: 1rem;">+</span>
                    <label style="color: ${colors.text}; font-weight: 600; font-size: 0.875rem;">
                      Create New Project
                    </label>
                  </div>
                <input
                  type="text"
                  id="new-project-name"
                  placeholder="Project name *"
                  style="
                    width: 100%;
                    padding: 0.75rem;
                    border: 1px solid ${colors.border};
                    border-radius: 0.5rem;
                    font-size: 1rem;
                    box-sizing: border-box;
                      margin-bottom: 0.75rem;
                      transition: border-color 0.2s ease;
                  "
                    onfocus="this.style.borderColor='${colors.primary}'"
                    onblur="this.style.borderColor='${colors.border}'"
                />
                <textarea
                  id="new-project-description"
                  placeholder="Description (optional)"
                  rows="2"
                  style="
                    width: 100%;
                    padding: 0.75rem;
                    border: 1px solid ${colors.border};
                    border-radius: 0.5rem;
                    font-size: 1rem;
                    box-sizing: border-box;
                    resize: vertical;
                    font-family: inherit;
                      margin-bottom: 0.75rem;
                      transition: border-color 0.2s ease;
                  "
                    onfocus="this.style.borderColor='${colors.primary}'"
                    onblur="this.style.borderColor='${colors.border}'"
                ></textarea>
                  <button
                    type="button"
                    onclick="confirmNewProject()"
                    style="
                      width: 100%;
                      background: ${colors.primary};
                      color: white;
                      border: none;
                      padding: 0.625rem 1rem;
                      border-radius: 0.5rem;
                      cursor: pointer;
                      font-size: 0.875rem;
                      font-weight: 600;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      gap: 0.5rem;
                      transition: all 0.2s ease;
                    "
                    onmouseover="this.style.opacity='0.9'"
                    onmouseout="this.style.opacity='1'"
                  >
                    ✓ Confirm Project
                  </button>
              </div>
              `}
                </div>
              `;
    })()}

            <!-- Submit Buttons -->
            <div style="display: flex; gap: 1rem; justify-content: flex-end; margin-top: 2rem; padding-top: 1.5rem; border-top: 1px solid ${colors.border};">
              <button
                type="button"
                onclick="toggleAddTaskForm()"
                style="
                  background: ${colors.background};
                  color: ${colors.text};
                  border: 1px solid ${colors.border};
                  padding: 0.75rem 1.5rem;
                  border-radius: 0.5rem;
                  cursor: pointer;
                  font-size: 1rem;
                  transition: all 0.2s ease;
                "
                onmouseover="this.style.background='${colors.border}'"
                onmouseout="this.style.background='${colors.background}'"
              >
                Cancel
              </button>
              <button
                type="button"
                id="create-task-btn"
                onclick="submitTask(event)"
                style="
                  background: #f59e0b;
                  color: white;
                  border: none;
                  padding: 0.75rem 1.5rem;
                  border-radius: 0.5rem;
                  cursor: pointer;
                  font-size: 1rem;
                  font-weight: 500;
                  transition: all 0.2s ease;
                "
                onmouseover="this.style.background='#d97706'"
                onmouseout="this.style.background='#f59e0b'"
              >
                ${editingTask ? 'Update Task' : 'Create Task'}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <style>
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      
      @keyframes slideIn {
        from { 
          opacity: 0;
          transform: scale(0.9) translateY(-20px);
        }
        to { 
          opacity: 1;
          transform: scale(1) translateY(0);
        }
      }
    </style>
  `;
}

// Render Task Details Modal
function renderTaskDetailsModal() {
  const task = tasks.find(t => t.id === showTaskDetails);
  if (!task) return '';

  const priorityColors = {
    LOW: { bg: '#10b981', text: 'white', icon: '🟢' },
    MEDIUM: { bg: '#f59e0b', text: 'white', icon: '🟡' },
    HIGH: { bg: '#ea580c', text: 'white', icon: '🟠' },
    URGENT: { bg: '#ef4444', text: 'white', icon: '🔴' }
  };

  const statusColors = {
    BACKLOG: { bg: '#6b7280', text: 'white', icon: '📋' },
    ACTIVE: { bg: '#3b82f6', text: 'white', icon: '🔄' },
    COMPLETED: { bg: '#10b981', text: 'white', icon: '✅' }
  };

  const priority = priorityColors[task.priority] || priorityColors.MEDIUM;
  const status = statusColors[task.state] || statusColors.BACKLOG;

  return `
    <!-- Task Details Modal Overlay -->
    <div id="task-details-modal" onclick="handleTaskDetailsModalClick(event)" style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.6);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1000;
      animation: fadeIn 0.3s ease-out;
      backdrop-filter: blur(4px);
    ">
      <!-- Modal Content -->
      <div onclick="event.stopPropagation()" style="
        background: ${colors.surface};
        border-radius: 1.5rem;
        box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
        max-width: 800px;
        width: 95%;
        max-height: 90vh;
        overflow: hidden;
        animation: slideIn 0.3s ease-out;
        position: relative;
        display: flex;
        flex-direction: column;
      ">
        <!-- Close Button -->
        <button
          onclick="closeTaskDetails()"
          style="
            position: absolute;
            top: 1.5rem;
            right: 1.5rem;
            background: #dc2626;
            color: white;
            border: none;
            width: 3rem;
            height: 3rem;
            border-radius: 50%;
            cursor: pointer;
            font-size: 1.5rem;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.2s ease;
            box-shadow: 0 4px 12px rgba(220, 38, 38, 0.3);
            z-index: 10;
          "
          onmouseover="this.style.transform='scale(1.1)'; this.style.background='#b91c1c'"
          onmouseout="this.style.transform='scale(1)'; this.style.background='#dc2626'"
        >
          ×
        </button>

        <!-- Header Section -->
        <div style="
          background: #ff7f00;
          color: white;
          padding: 2rem 2rem 3rem 2rem;
          border-radius: 1.5rem 1.5rem 0 0;
          position: relative;
          overflow: visible;
          z-index: 1000;
        ">
          <!-- Background Pattern -->
          <div style="
            position: absolute;
            top: -50%;
            right: -20%;
            width: 200px;
            height: 200px;
            background: rgba(255,255,255,0.1);
            border-radius: 50%;
            opacity: 0.3;
          "></div>
          
          <!-- Priority & Status Badges -->
          <div style="display: flex; align-items: center; gap: 1rem; margin-bottom: 1rem; position: relative; z-index: 1001;">
            <span style="
              background: rgba(255,255,255,0.2);
              backdrop-filter: blur(10px);
              color: white;
              padding: 0.5rem 1rem;
              border-radius: 1rem;
              font-size: 0.875rem;
              font-weight: 600;
              display: flex;
              align-items: center;
              gap: 0.5rem;
              border: 1px solid rgba(255,255,255,0.3);
            ">
${task.priority}
            </span>
            <span style="
              background: rgba(255,255,255,0.2);
              backdrop-filter: blur(10px);
              color: white;
              padding: 0.5rem 1rem;
              border-radius: 1rem;
              font-size: 0.875rem;
              font-weight: 600;
              display: flex;
              align-items: center;
              gap: 0.5rem;
              border: 1px solid rgba(255,255,255,0.3);
            ">
${task.state}
            </span>
            ${(() => {
      const getNextStatus = (current) => {
        if (current === 'BACKLOG') return 'ACTIVE';
        if (current === 'ACTIVE') return 'COMPLETED';
        if (current === 'COMPLETED') return 'BACKLOG';
        return 'ACTIVE';
      };
      const getNextStatusLabel = (current) => {
        if (current === 'BACKLOG') return 'Start Task';
        if (current === 'ACTIVE') return 'Complete Task';
        if (current === 'COMPLETED') return 'Restart Task';
        return 'Start Task';
      };
      const nextStatus = getNextStatus(task.state);
      const nextLabel = getNextStatusLabel(task.state);
      return `
                <button
                  onclick="event.stopPropagation(); changeTaskStatus('${task.id}', '${nextStatus}'); renderPMTool();"
                  style="
                    background: white;
                    color: #ff7f00;
                    border: none;
                    padding: 0.5rem 1rem;
                    border-radius: 1rem;
                    font-size: 0.875rem;
                    font-weight: 600;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    transition: all 0.2s ease;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
                    white-space: nowrap;
                  "
                  onmouseover="this.style.background='#fef3e2'; this.style.transform='translateY(-1px)'; this.style.boxShadow='0 4px 8px rgba(0,0,0,0.3)';"
                  onmouseout="this.style.background='white'; this.style.transform='translateY(0)'; this.style.boxShadow='0 2px 4px rgba(0,0,0,0.2)';"
                >
                  ${nextLabel}
                </button>
              `;
    })()}
          </div>
          
          <!-- Task Title -->
          <h2 style="
            margin: 0 0 1rem 0;
            font-size: 2rem;
            font-weight: 700;
            line-height: 1.2;
            text-shadow: 0 2px 4px rgba(0,0,0,0.1);
            position: relative;
            z-index: 1001;
          ">
            ${task.title}
          </h2>
          
          <!-- Created Date -->
          <p style="
            margin: 0.75rem 0 0 0;
            color: rgba(255,255,255,0.8);
            font-size: 1rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            position: relative;
            z-index: 1001;
          ">
            Created ${new Date(task.created_at).toLocaleDateString('en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })}
          </p>
        </div>

        <!-- Content Section -->
        <div style="
          padding: 2rem;
          flex: 1;
          overflow-y: auto;
          display: grid;
          gap: 2rem;
          position: relative;
          z-index: 1;
          margin-top: 0;
        ">
          <!-- Description Card -->
          <div style="
            background: rgba(255,255,255,0.2);
            backdrop-filter: blur(10px);
            border: 1px solid rgba(255,255,255,0.3);
            border-radius: 1rem;
            padding: 1.5rem;
            box-shadow: 0 2px 8px rgba(0,0,0,0.05);
          ">
            <h3 style="
              margin: 0 0 1rem 0;
              color: ${colors.text};
              font-size: 1.25rem;
              font-weight: 600;
              display: flex;
              align-items: center;
              gap: 0.5rem;
            ">
Description
            </h3>
            <div style="
              color: ${colors.text};
              line-height: 1.7;
              font-size: 1rem;
              background: white;
              padding: 1rem;
              border-radius: 0.5rem;
              border: 1px solid #e5e7eb;
              min-height: 80px;
              white-space: pre-wrap;
            ">
              ${task.description ? makeLinksClickable(task.description) : 'No description provided'}
            </div>
          </div>

          <!-- Assigned Team Members Card -->
          <div style="
            background: rgba(255,255,255,0.2);
            backdrop-filter: blur(10px);
            border: 1px solid rgba(255,255,255,0.3);
            border-radius: 1rem;
            padding: 1.5rem;
            box-shadow: 0 2px 8px rgba(0,0,0,0.05);
          ">
            <h3 style="
              margin: 0 0 1rem 0;
              color: ${colors.text};
              font-size: 1.25rem;
              font-weight: 600;
              display: flex;
              align-items: center;
              gap: 0.5rem;
            ">
Assigned Team Members
            </h3>
            <div style="display: flex; flex-wrap: wrap; gap: 0.75rem;">
              ${task.assigned_members && task.assigned_members.length > 0 ?
      task.assigned_members.map(member => {
        const initials = `${(member.first_name || '').charAt(0)}${(member.last_name || '').charAt(0)}`.toUpperCase() || 'U';
        const avatarUrl = member.avatar_path ? getAvatarUrl(member.avatar_path) : null;
        const bgColor = getAvatarBackgroundColor(member.first_name || member.id || '');
        return `
                  <div style="
                    display: flex;
                    align-items: center;
                    gap: 0.75rem;
                    background: white;
                    border: 1px solid ${colors.border};
                    border-radius: 1rem;
                    padding: 0.75rem 1rem;
                    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
                    transition: transform 0.2s ease;
                  " onmouseover="this.style.transform='translateY(-2px)'" onmouseout="this.style.transform='translateY(0)'">
                    <div style="position: relative;">
                      ${avatarUrl ? `
                        <img
                          src="${avatarUrl}"
                          alt="${initials}"
                          style="
                            width: 2rem;
                            height: 2rem;
                            border-radius: 50%;
                            object-fit: cover;
                            border: 2px solid white;
                            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                          "
                          onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';"
                        />
                      ` : ''}
                      <div style="
                        ${avatarUrl ? 'display: none;' : 'display: flex;'}
                        width: 2rem;
                        height: 2rem;
                        border-radius: 50%;
                        background: ${bgColor};
                        color: white;
                        align-items: center;
                        justify-content: center;
                        font-size: 0.875rem;
                        font-weight: 600;
                        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
                        border: 2px solid white;
                      ">${initials}</div>
                    </div>
                    <span style="color: ${colors.text}; font-size: 0.875rem; font-weight: 500;">
                      ${member.first_name} ${member.last_name}
                    </span>
                  </div>
                `;
      }).join('') :
      `<div style="
                  color: ${colors.textSecondary};
                  font-style: italic;
                  background: white;
                  padding: 1rem;
                  border-radius: 0.5rem;
                  border: 1px dashed ${colors.border};
                  text-align: center;
                ">No team members assigned</div>`
    }
            </div>
          </div>

          <!-- Due Date Card -->
          <div style="
            background: rgba(255,255,255,0.2);
            backdrop-filter: blur(10px);
            border: 1px solid rgba(255,255,255,0.3);
            border-radius: 1rem;
            padding: 1.5rem;
            box-shadow: 0 2px 8px rgba(0,0,0,0.05);
          ">
            <h3 style="
              margin: 0 0 1rem 0;
              color: ${colors.text};
              font-size: 1.25rem;
              font-weight: 600;
              display: flex;
              align-items: center;
              gap: 0.5rem;
            ">
Due Date
            </h3>
            <div style="
              background: white;
              border: 1px solid #e5e7eb;
              border-radius: 0.5rem;
              padding: 1rem;
              color: ${colors.text};
              font-size: 1rem;
              font-weight: 500;
            ">
              ${task.due_at ? formatDateLocal(task.due_at, {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }) : 'No due date set'}
            </div>
          </div>

          <!-- Comments Card -->
          <div style="
            background: rgba(255,255,255,0.2);
            backdrop-filter: blur(10px);
            border: 1px solid rgba(255,255,255,0.3);
            border-radius: 1rem;
            padding: 1.5rem;
            box-shadow: 0 2px 8px rgba(0,0,0,0.05);
          ">
            <h3 style="
              margin: 0 0 1rem 0;
              color: ${colors.text};
              font-size: 1.25rem;
              font-weight: 600;
              display: flex;
              align-items: center;
              gap: 0.5rem;
            ">
              💬 Comments (${taskDetailsComments.length})
            </h3>
            
            <!-- Comments List -->
            <div style="
              max-height: 300px;
              overflow-y: auto;
              margin-bottom: 1rem;
            ">
              ${taskDetailsComments.length === 0 ? `
                <div style="
                  text-align: center;
                  padding: 2rem;
                  color: ${colors.textSecondary};
                  background: white;
                  border-radius: 0.5rem;
                  border: 1px dashed ${colors.border};
                ">
                  <div style="font-size: 2rem; margin-bottom: 0.5rem;">💬</div>
                  <p style="margin: 0;">No comments yet. Be the first to comment!</p>
                </div>
              ` : renderTaskDetailsComments()}
            </div>
            
            <!-- Add Comment Form -->
            <form id="add-comment-form-details" onsubmit="handleAddCommentFromDetails(event, '${task.id}')">
              <div style="margin-bottom: 1rem;">
                <textarea
                  id="comment-content-details"
                  placeholder="Add a comment..."
                  required
                  style="
                    width: 100%;
                    min-height: 80px;
                    padding: 0.75rem;
                    border: 1px solid ${colors.border};
                    border-radius: 0.5rem;
                    font-family: inherit;
                    font-size: 0.875rem;
                    resize: vertical;
                    background: white;
                    color: ${colors.text};
                  "
                ></textarea>
              </div>
              <div style="display: flex; gap: 1rem; justify-content: flex-end;">
                <button
                  type="submit"
                  style="
                    background: ${colors.primary};
                    color: white;
                    border: none;
                    padding: 0.75rem 1.5rem;
                    border-radius: 0.5rem;
                    cursor: pointer;
                    font-size: 0.875rem;
                    font-weight: 500;
                    transition: all 0.2s ease;
                  "
                  onmouseover="this.style.background='${colors.primaryDark}'"
                  onmouseout="this.style.background='${colors.primary}'"
                >
                  Add Comment
                </button>
              </div>
            </form>
          </div>

        </div>

        <!-- Action Buttons Footer -->
        <div style="
          padding: 1.5rem 2rem;
          border-top: 1px solid ${colors.border};
          background: ${colors.background};
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-radius: 0 0 1.5rem 1.5rem;
        ">
          <button
            onclick="deleteTask('${task.id}')"
            style="
              background: ${colors.error};
              color: white;
              border: none;
              padding: 0.75rem 1.5rem;
              border-radius: 0.5rem;
              cursor: pointer;
              font-size: 0.875rem;
              font-weight: 500;
              display: flex;
              align-items: center;
              gap: 0.5rem;
              transition: all 0.2s ease;
              box-shadow: 0 2px 4px rgba(239, 68, 68, 0.2);
            "
            onmouseover="this.style.background='#dc2626'; this.style.transform='translateY(-1px)'"
            onmouseout="this.style.background='#ef4444'; this.style.transform='translateY(0)'"
          >
Delete Task
          </button>
          
          <button
            onclick="closeTaskDetails()"
            style="
              background: ${colors.border};
              color: ${colors.text};
              border: none;
              padding: 0.75rem 1.5rem;
              border-radius: 0.5rem;
              cursor: pointer;
              font-size: 0.875rem;
              font-weight: 500;
              transition: all 0.2s ease;
            "
            onmouseover="this.style.background='#d1d5db'; this.style.transform='translateY(-1px)'"
            onmouseout="this.style.background='#e5e7eb'; this.style.transform='translateY(0)'"
          >
            Close
          </button>
          
          <button
            onclick="editTask('${task.id}')"
            style="
              background: ${colors.primary};
              color: white;
              border: none;
              padding: 0.75rem 1.5rem;
              border-radius: 0.5rem;
              cursor: pointer;
              font-size: 0.875rem;
              font-weight: 500;
              transition: all 0.2s ease;
              box-shadow: 0 2px 4px rgba(234, 88, 12, 0.2);
            "
            onmouseover="this.style.background='#c2410c'; this.style.transform='translateY(-1px)'"
            onmouseout="this.style.background='#ea580c'; this.style.transform='translateY(0)'"
          >
Edit Task
          </button>
        </div>
      </div>
    </div>
  `;
}

// Handle task details modal click
window.handleTaskDetailsModalClick = function (event) {
  if (event.target.id === 'task-details-modal') {
    closeTaskDetails();
  }
};

// Close task details modal
window.closeTaskDetails = function () {
  showTaskDetails = null;
  taskDetailsComments = [];
  renderPMTool();
};

// Render comments for task details modal
function renderTaskDetailsComments() {
  // Group comments by parent_id
  const topLevelComments = taskDetailsComments.filter(c => !c.parent_id);
  const replies = taskDetailsComments.filter(c => c.parent_id);

  return topLevelComments.map(comment => {
    const commentReplies = replies.filter(r => r.parent_id === comment.id);

    return `
      <div>
        <!-- Main Comment -->
        ${renderTaskDetailsComment(comment, false)}
        
        <!-- Replies -->
        ${commentReplies.map(reply => renderTaskDetailsComment(reply, true)).join('')}
      </div>
    `;
  }).join('');
}

// Render individual comment for task details modal
function renderTaskDetailsComment(comment, isReply) {
  return `
    <div style="
      background: ${colors.background};
      border-radius: 0.5rem;
      padding: 1rem;
      margin-bottom: 1rem;
      border-left: 3px solid ${colors.primary};
      margin-left: ${isReply ? '2rem' : '0'};
      opacity: ${isReply ? '0.9' : '1'};
    ">
      <div style="display: flex; align-items: center; margin-bottom: 0.5rem;">
        <div style="position: relative; margin-right: 0.5rem;">
          ${(() => {
      const profile = comment.profiles;
      if (!profile) return '<div style="width: 2rem; height: 2rem; border-radius: 50%; background: #6b7280; color: white; display: flex; align-items: center; justify-content: center; font-size: 0.75rem; font-weight: 600;">?</div>';

      const initials = `${(profile.first_name || '').charAt(0)}${(profile.last_name || '').charAt(0)}`.toUpperCase() || '?';
      const avatarUrl = profile.avatar_path ? getAvatarUrl(profile.avatar_path) : null;
      const bgColor = getAvatarBackgroundColor(profile.first_name || profile.id || '');

      return `
              ${avatarUrl ? `
                <img
                  src="${avatarUrl}"
                  alt="${initials}"
                  style="
                    width: 2rem;
                    height: 2rem;
                    border-radius: 50%;
                    object-fit: cover;
                    border: 2px solid white;
                    box-shadow: 0 0 0 1px rgba(0,0,0,0.1);
                  "
                  onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';"
                />
              ` : ''}
              <div style="
                ${avatarUrl ? 'display: none;' : 'display: flex;'}
                width: 2rem;
                height: 2rem;
                border-radius: 50%;
                background: ${bgColor};
                color: white;
                align-items: center;
                justify-content: center;
                font-size: 0.75rem;
                font-weight: 600;
                border: 2px solid white;
                box-shadow: 0 0 0 1px rgba(0,0,0,0.1);
              ">${initials}</div>
            `;
    })()}
        </div>
        <div style="flex: 1;">
          <div style="font-weight: 600; color: ${colors.text}; font-size: 0.875rem;">
            ${comment.profiles ? `${comment.profiles.first_name} ${comment.profiles.last_name}` : 'Unknown User'}
            ${isReply ? '<span style="color: #6b7280; font-weight: normal; font-size: 0.75rem;"> (reply)</span>' : ''}
          </div>
          <div style="color: ${colors.textSecondary}; font-size: 0.75rem;">
            ${new Date(comment.created_at).toLocaleString()}
          </div>
        </div>
      </div>
      <div style="color: ${colors.text}; line-height: 1.5;">
        ${makeLinksClickable(comment.body)}
      </div>
    </div>
  `;
}

// Handle adding comment from task details modal
window.handleAddCommentFromDetails = async function (event, taskId) {
  event.preventDefault();

  const textarea = document.getElementById('comment-content-details');
  const content = textarea.value.trim();

  if (!content || !taskId || !currentUser?.id) return;

  try {
    const { error } = await supabase
      .from('task_comments')
      .insert({
        task_id: taskId,
        author_id: currentUser.id,
        body: content
      });

    if (error) throw error;

    // Clear the textarea
    textarea.value = '';

    // Reload comments
    await loadTaskDetailsComments(taskId);

    // Update comment count
    taskCommentCounts[taskId] = (taskCommentCounts[taskId] || 0) + 1;

    // Re-render the modal
    renderPMTool();

    showNotification('Comment added successfully!', 'success');
  } catch (error) {
    console.error('Error adding comment:', error);
    showNotification('Failed to add comment', 'error');
  }
};

// Delete task function
// Show delete task confirmation modal
window.showDeleteTaskConfirm = function (taskId) {
  // Remove any existing modal
  const existingModal = document.getElementById('delete-task-modal');
  if (existingModal) {
    existingModal.remove();
  }

  const modal = document.createElement('div');
  modal.id = 'delete-task-modal';
  modal.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99999;
    animation: fadeIn 0.2s ease-out;
  `;

  modal.innerHTML = `
    <div style="
      background: white;
      border-radius: 1rem;
      padding: 0;
      max-width: 400px;
      width: 90%;
      box-shadow: 0 25px 50px rgba(0,0,0,0.25);
      animation: scaleIn 0.2s ease-out;
      overflow: hidden;
    ">
      <!-- Header -->
      <div style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1.25rem 1.5rem;
        border-bottom: 1px solid #E5E7EB;
      ">
        <div style="display: flex; align-items: center; gap: 0.75rem;">
          <span class="material-icons" style="color: #EF4444; font-size: 24px;">warning</span>
          <h3 style="margin: 0; font-size: 1.125rem; font-weight: 600; color: #111827;">Delete Task</h3>
        </div>
        <button 
          onclick="closeDeleteTaskModal()"
          style="
            background: transparent;
            border: none;
            cursor: pointer;
            padding: 0.25rem;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 0.375rem;
            color: #6B7280;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#F3F4F6'; this.style.color='#111827';"
          onmouseout="this.style.background='transparent'; this.style.color='#6B7280';"
        >
          <span class="material-icons" style="font-size: 20px;">close</span>
        </button>
      </div>
      
      <!-- Body -->
      <div style="padding: 1.5rem;">
        <p style="margin: 0; color: #4B5563; font-size: 0.9375rem; line-height: 1.5;">
          Are you sure you want to delete this task? This action cannot be undone.
        </p>
      </div>
      
      <!-- Footer -->
      <div style="
        display: flex;
        gap: 0.75rem;
        padding: 1rem 1.5rem;
        background: #F9FAFB;
        border-top: 1px solid #E5E7EB;
      ">
        <button 
          onclick="closeDeleteTaskModal()"
          style="
            flex: 1;
            padding: 0.75rem 1rem;
            background: white;
            border: 1px solid #D1D5DB;
            border-radius: 0.5rem;
            color: #374151;
            font-size: 0.9375rem;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#F3F4F6';"
          onmouseout="this.style.background='white';"
        >
          Cancel
        </button>
        <button 
          onclick="confirmDeleteTask('${taskId}')"
          style="
            flex: 1;
            padding: 0.75rem 1rem;
            background: #EF4444;
            border: none;
            border-radius: 0.5rem;
            color: white;
            font-size: 0.9375rem;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#DC2626';"
          onmouseout="this.style.background='#EF4444';"
        >
          Delete
        </button>
      </div>
    </div>
  `;

  // Close on backdrop click
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      closeDeleteTaskModal();
    }
  });

  document.body.appendChild(modal);
};

// Close delete task modal
window.closeDeleteTaskModal = function () {
  const modal = document.getElementById('delete-task-modal');
  if (modal) {
    modal.style.opacity = '0';
    setTimeout(() => modal.remove(), 200);
  }
};

// Confirm delete task
window.confirmDeleteTask = async function (taskId) {
  const deleteBtn = document.querySelector('#delete-task-modal button[onclick*="confirmDeleteTask"]');
  if (deleteBtn) {
    deleteBtn.disabled = true;
    deleteBtn.innerHTML = '<span class="material-icons" style="font-size: 18px; animation: spin 1s linear infinite;">refresh</span> Deleting...';
  }

  try {
    // Delete task assignees first
    await supabase
      .from('task_assignees')
      .delete()
      .eq('task_id', taskId);

    // Delete task clients
    await supabase
      .from('task_clients')
      .delete()
      .eq('task_id', taskId);

    // Delete the task
    const { error } = await supabase
      .from('tasks')
      .delete()
      .eq('id', taskId);

    if (error) {
      console.error('Error deleting task:', error);
      closeDeleteTaskModal();
      showNotification('Failed to delete task', 'error');
      return;
    }

    closeDeleteTaskModal();
    showNotification('Task deleted successfully', 'success');

    // Close modal and refresh tasks
    closeTaskDetails();
    await loadTasks();
    renderPMTool();
  } catch (error) {
    console.error('Error deleting task:', error);
    closeDeleteTaskModal();
    showNotification('Failed to delete task', 'error');
  }
};

// Delete task (shows confirmation modal)
window.deleteTask = function (taskId) {
  showDeleteTaskConfirm(taskId);
};

// Edit task function
window.editTask = function (taskId) {
  console.log('✏️ Edit task:', taskId);
  const task = tasks.find(t => t.id === taskId);
  if (!task) {
    console.error('Task not found:', taskId);
    return;
  }

  console.log('✏️ Task data:', task);

  // Set editing task and populate form
  editingTask = task;
  window.editingTaskData = task; // Also set window.editingTaskData for submitTask function
  showAddTaskForm = true;
  showTaskDetails = null; // Close details modal

  // Populate form with existing task data
  selectedService = task.service_id || '';
  customServiceName = task.service_name || '';
  taskPriority = task.priority || 'MEDIUM';
  taskStatus = task.state || 'BACKLOG';
  selectedMembers = task.assigned_members?.map(m => m.id) || [];
  selectedContact = task.contact_id || null;
  selectedProject = task.project_id || null;
  selectedClients = []; // TODO: Load clients for this task
  showProjectCreation = false;

  // Also set window variables for task modal compatibility
  window.selectedTaskContact = task.contact_id || null;
  window.selectedTaskProject = task.project_id || null;
  window.selectedTaskMembers = task.assigned_members?.map(m => m.id) || [];
  window.taskPriority = task.priority || 'MEDIUM';
  window.taskStatus = task.state || 'BACKLOG';
  window.selectedTaskService = task.service_id || '';
  window.customTaskServiceName = task.service_name || '';

  console.log('✏️ Populated form state:', {
    selectedService,
    customServiceName,
    taskPriority,
    taskStatus,
    selectedMembers,
    selectedContact,
    selectedProject
  });

  renderPMTool();

  // After rendering, update displays for contact and project
  setTimeout(() => {
    if (selectedContact) {
      updateSelectedContactDisplay();
    }
    if (selectedProject) {
      // Fetch and display the selected project
      fetchAndDisplaySelectedProject(selectedProject);
    }
    if (selectedMembers.length > 0) {
      updateSelectedMembersDisplay();
    }
  }, 200);
};

// Helper function to fetch and display selected project
async function fetchAndDisplaySelectedProject(projectId) {
  try {
    // Ensure window.selectedTaskProject is set
    window.selectedTaskProject = projectId;
    selectedProject = projectId;
    console.log('📁 Setting selectedTaskProject to:', projectId);

    const { data: project, error } = await supabase
      .from('projects')
      .select('id, name')
      .eq('id', projectId)
      .single();

    if (!error && project) {
      const selectedDiv = document.getElementById('selected-project');
      if (selectedDiv) {
        selectedDiv.style.display = 'flex';
        selectedDiv.innerHTML = `
          <div style="
            background: #8B5CF6;
            color: white;
            padding: 0.5rem 0.75rem;
            border-radius: 1.5rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            font-size: 0.875rem;
          ">
            📁 ${project.name}
            <button onclick="clearProject(); event.stopPropagation();" style="
              background: rgba(255,255,255,0.3);
              border: none;
              color: white;
              cursor: pointer;
              width: 18px;
              height: 18px;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 0;
              font-size: 14px;
              line-height: 1;
            ">×</button>
          </div>
        `;
      }

      // Hide project list when project is displayed
      const listContainer = document.getElementById('project-list-container');
      if (listContainer) listContainer.style.display = 'none';
    } else {
      console.error('Error fetching project:', error);
    }
  } catch (error) {
    console.error('Error fetching project:', error);
  }
}

// Render Add Task Form (Complete version based on AddTaskSheet.tsx)
function renderAddTaskForm() {
  return `
    <div style="
      background: ${colors.surface};
      border-radius: 0.75rem;
      padding: 1.5rem;
      box-shadow: 0 1px 3px rgba(0,0,0,0.1);
      margin-bottom: 1.5rem;
      max-width: 800px;
      margin: 0 auto 1.5rem auto;
    ">
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1.5rem;">
        <h3 style="margin: 0; color: ${colors.text}; font-size: 1.5rem; font-weight: 600;">
          Create New Task
        </h3>
        <button
          onclick="toggleAddTaskForm()"
          style="
            background: ${colors.danger};
            color: white;
            border: none;
            padding: 0.5rem;
            border-radius: 0.25rem;
            cursor: pointer;
            font-size: 1rem;
          "
        >
          ✕
        </button>
      </div>

      <form id="add-task-form" novalidate onsubmit="event.preventDefault(); submitTask(event); return false;">
        <div style="display: grid; gap: 1.5rem;">
          <!-- Title -->
          <div>
            <label style="display: block; margin-bottom: 0.5rem; color: ${colors.text}; font-weight: 500;">
              Task Title *
            </label>
            <input
              type="text"
              id="task-title"
              placeholder="Enter task title"
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-size: 1rem;
                box-sizing: border-box;
              "
            />
          </div>

          <!-- Description -->
          <div>
            <label style="display: block; margin-bottom: 0.5rem; color: ${colors.text}; font-weight: 500;">
              Description *
            </label>
            <textarea
              id="task-description"
              rows="4"
              placeholder="Enter task description"
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-size: 1rem;
                box-sizing: border-box;
                resize: vertical;
                min-height: 100px;
              "
            ></textarea>
          </div>

          <!-- Service -->
          <div>
            <label style="display: block; margin-bottom: 0.5rem; color: ${colors.text}; font-weight: 500;">
              Service
            </label>
            <div style="display: flex; flex-wrap: wrap; gap: 0.5rem; margin-bottom: 0.5rem;">
              <button
                type="button"
                onclick="setSelectedService('')"
                id="service-other"
                style="
                  padding: 0.5rem 1rem;
                  border-radius: 1rem;
                  border: 1px solid ${colors.border};
                  background: ${colors.background};
                  color: ${colors.text};
                  cursor: pointer;
                  font-size: 0.875rem;
                "
              >
                Other
              </button>
              ${services.map(service => `
                <button
                  type="button"
                  onclick="setSelectedService('${service.id}')"
                  id="service-${service.id}"
                  style="
                    padding: 0.5rem 1rem;
                    border-radius: 1rem;
                    border: 1px solid ${colors.border};
                    background: ${colors.background};
                    color: ${colors.text};
                    cursor: pointer;
                    font-size: 0.875rem;
                  "
                >
                  ${service.name}
                </button>
              `).join('')}
            </div>
            <input
              type="text"
              id="custom-service-name"
              placeholder="Enter custom service name"
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-size: 1rem;
                box-sizing: border-box;
                display: none;
              "
            />
          </div>

          <!-- Priority -->
          <div>
            <label style="display: block; margin-bottom: 0.5rem; color: ${colors.text}; font-weight: 500;">
              Priority *
            </label>
            <div style="display: flex; flex-wrap: wrap; gap: 0.5rem;">
              <button
                type="button"
                onclick="setTaskPriority('LOW')"
                id="priority-low"
                style="
                  padding: 0.5rem 1rem;
                  border-radius: 1rem;
                  border: 1px solid #10b981;
                  background: ${colors.background};
                  color: ${colors.text};
                  cursor: pointer;
                  font-size: 0.875rem;
                "
              >
                Low
              </button>
              <button
                type="button"
                onclick="setTaskPriority('MEDIUM')"
                id="priority-medium"
                style="
                  padding: 0.5rem 1rem;
                  border-radius: 1rem;
                  border: 1px solid #f59e0b;
                  background: #f59e0b;
                  color: white;
                  cursor: pointer;
                  font-size: 0.875rem;
                "
              >
                Medium
              </button>
              <button
                type="button"
                onclick="setTaskPriority('HIGH')"
                id="priority-high"
                style="
                  padding: 0.5rem 1rem;
                  border-radius: 1rem;
                  border: 1px solid #f97316;
                  background: ${colors.background};
                  color: ${colors.text};
                  cursor: pointer;
                  font-size: 0.875rem;
                "
              >
                High
              </button>
              <button
                type="button"
                onclick="setTaskPriority('URGENT')"
                id="priority-urgent"
                style="
                  padding: 0.5rem 1rem;
                  border-radius: 1rem;
                  border: 1px solid #dc2626;
                  background: ${colors.background};
                  color: ${colors.text};
                  cursor: pointer;
                  font-size: 0.875rem;
                "
              >
                Urgent
              </button>
            </div>
          </div>

          <!-- Due Date -->
          <div>
            <label style="display: block; margin-bottom: 0.5rem; color: ${colors.text}; font-weight: 500;">
              Due Date
            </label>
            <input
              type="date"
              id="task-due-date"
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-size: 1rem;
                box-sizing: border-box;
              "
            />
          </div>

          <!-- Status -->
          <div>
            <label style="display: block; margin-bottom: 0.5rem; color: ${colors.text}; font-weight: 500;">
              Status
            </label>
            <div style="display: flex; flex-wrap: wrap; gap: 0.5rem;">
              <button
                type="button"
                onclick="setTaskStatus('BACKLOG')"
                id="status-backlog"
                style="
                  padding: 0.5rem 1rem;
                  border-radius: 1rem;
                  border: 1px solid #6b7280;
                  background: #6b7280;
                  color: white;
                  cursor: pointer;
                  font-size: 0.875rem;
                "
              >
                Backlog
              </button>
              <button
                type="button"
                onclick="setTaskStatus('ACTIVE')"
                id="status-active"
                style="
                  padding: 0.5rem 1rem;
                  border-radius: 1rem;
                  border: 1px solid #3b82f6;
                  background: ${colors.background};
                  color: ${colors.text};
                  cursor: pointer;
                  font-size: 0.875rem;
                "
              >
                Active
              </button>
            </div>
          </div>

          <!-- Assign Team Members -->
          <div>
            <label style="display: block; margin-bottom: 0.5rem; color: ${colors.text}; font-weight: 500;">
              Assign Team Members *
            </label>
            <input
              type="text"
              id="member-search"
              placeholder="Search members..."
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-size: 1rem;
                box-sizing: border-box;
                margin-bottom: 0.5rem;
              "
              onfocus="this.style.borderColor='${colors.primary}'; showMemberDropdown(this)"
              onblur="this.style.borderColor='${colors.border}'"
            />
            <div id="selected-members" style="display: flex; flex-wrap: wrap; gap: 0.5rem; margin-bottom: 0.5rem;">
              <!-- Selected members will appear here -->
            </div>
            <div id="member-search-results" style="
              max-height: 200px;
              overflow-y: auto;
              border: 1px solid ${colors.border};
              border-radius: 0.5rem;
              background: ${colors.surface};
              display: none;
            ">
              <!-- Search results will appear here -->
            </div>
          </div>

          <!-- Tag Clients -->
          <div>
            <label style="display: block; margin-bottom: 0.5rem; color: ${colors.text}; font-weight: 500;">
              Tag Clients
            </label>
            <input
              type="text"
              id="client-search"
              placeholder="Search clients..."
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-size: 1rem;
                box-sizing: border-box;
                margin-bottom: 0.5rem;
              "
            />
            <div id="selected-clients" style="display: flex; flex-wrap: wrap; gap: 0.5rem; margin-bottom: 0.5rem;">
              <!-- Selected clients will appear here -->
            </div>
            <div id="client-search-results" style="
              max-height: 200px;
              overflow-y: auto;
              border: 1px solid ${colors.border};
              border-radius: 0.5rem;
              background: ${colors.surface};
              display: none;
            ">
              <!-- Search results will appear here -->
            </div>
          </div>

          <!-- Submit Button -->
          <div style="display: flex; gap: 1rem; justify-content: flex-end;">
            <button
              type="button"
              onclick="toggleAddTaskForm()"
              style="
                background: ${colors.background};
                color: ${colors.text};
                border: 1px solid ${colors.border};
                padding: 0.75rem 1.5rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-size: 1rem;
              "
            >
              Cancel
            </button>
            <button
              type="button"
              id="create-task-btn"
              onclick="submitTask(event)"
              style="
                background: #f59e0b;
                color: white;
                border: none;
                padding: 0.75rem 1.5rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-size: 1rem;
                font-weight: 500;
                transition: all 0.2s ease;
              "
              onmouseover="this.style.background='#d97706'"
              onmouseout="this.style.background='#f59e0b'"
            >
              Create Task
            </button>
          </div>
        </div>
      </form>
    </div>
  `;
}

// Handle task creation/update (Enhanced version)
async function handleCreateTask(e) {
  e.preventDefault();

  const title = document.getElementById('task-title').value;
  const description = document.getElementById('task-description').value;
  const dueDate = document.getElementById('task-due-date').value;
  const customService = document.getElementById('custom-service-name').value;

  if (!title.trim()) {
    alert('Please enter a task title');
    return;
  }

  if (!description.trim()) {
    alert('Please enter a task description');
    return;
  }

  // Priority is OPTIONAL - no validation required

  // Use window.selectedTaskMembers if available (from task modal), otherwise fall back to selectedMembers
  const membersToUse = (window.selectedTaskMembers && window.selectedTaskMembers.length > 0)
    ? window.selectedTaskMembers
    : (selectedMembers && selectedMembers.length > 0 ? selectedMembers : []);

  // Get contact and project IDs from task modal variables OR from editing task data
  // Convert empty strings to null explicitly
  let contactId = null;
  let projectId = null;

  // First check if we're editing and have task data with contact/project IDs
  if (editingTask) {
    contactId = editingTask.contact_id || null;
    projectId = editingTask.project_id || null;
  }

  // Then check window variables (from task modal form)
  if (!contactId && window.selectedTaskContact) {
    const trimmed = String(window.selectedTaskContact).trim();
    contactId = trimmed !== '' ? trimmed : null;
  }

  if (!projectId && window.selectedTaskProject) {
    const trimmed = String(window.selectedTaskProject).trim();
    projectId = trimmed !== '' ? trimmed : null;
  }

  // Also check regular form variables as fallback
  if (!contactId && selectedContact) {
    contactId = selectedContact;
  }

  if (!projectId && selectedProject) {
    projectId = selectedProject;
  }

  // Contact and project IDs extracted from various sources

  // Validate team members are required
  if (membersToUse.length === 0) {
    const memberSearch = document.getElementById('member-search');
    if (memberSearch) {
      highlightInvalidField('member-search');
      memberSearch.focus();
      // Show dropdown on focus
      if (typeof showMemberDropdown === 'function') {
        showMemberDropdown(memberSearch);
      }
    }
    if (typeof showNotification === 'function') {
      showNotification('You must select at least one team member to assign to this task.', 'error');
    }
    return;
  }

  const createBtn = document.getElementById('create-task-btn');
  if (createBtn) {
    createBtn.disabled = true;
    createBtn.textContent = editingTask ? 'Updating...' : 'Creating...';
  }

  try {
    // Prepare task data
    const taskData = {
      title: title.trim(),
      description: description.trim(),
      priority: taskPriority,
      state: taskStatus,
      due_at: dueDate || null,
      company_id: currentCompany.id,
      coin_value: editingTask ? editingTask.coin_value : 1
    };

    // Add contact_id and project_id - always include them (null if not set)
    // This ensures they're saved even if clearing an existing value
    taskData.contact_id = (contactId && String(contactId).trim() !== '') ? String(contactId).trim() : null;
    taskData.project_id = (projectId && String(projectId).trim() !== '') ? String(projectId).trim() : null;

    // Debug: Verify values are in taskData before saving
    console.log('💾 handleCreateTask - Saving task with:', {
      contact_id: taskData.contact_id,
      project_id: taskData.project_id,
      contactId_source: contactId,
      projectId_source: projectId
    });

    // Handle service assignment
    if (selectedService && selectedService !== '') {
      // Predefined service selected
      taskData.service_id = selectedService;
      taskData.service_name = null;
    } else if (customService.trim()) {
      // Custom service name provided
      taskData.service_id = null;
      taskData.service_name = customService.trim();
    }

    let taskResult;
    if (editingTask) {
      // Update existing task
      console.log('💾 Final taskData before update:', JSON.stringify(taskData, null, 2));

      const { data, error: taskError } = await supabase
        .from('tasks')
        .update(taskData)
        .eq('id', editingTask.id)
        .select()
        .single();

      if (taskError) {
        console.error('Error updating task:', taskError);
        console.error('Task data that failed:', taskData);
        alert('Failed to update task: ' + taskError.message);
        return;
      }

      console.log('✅ Task updated successfully. Returned data:', data);
      console.log('✅ Verifying contact_id and project_id in updated task:', {
        contact_id: data?.contact_id,
        project_id: data?.project_id
      });

      taskResult = data;
    } else {
      // Create new task
      console.log('🔄 Creating new task with data:', taskData);
      console.log('🔄 Supabase client:', supabase);
      console.log('🔄 Current user:', currentUser);
      console.log('🔄 Current company:', currentCompany);

      // Verify taskData includes contact_id and project_id
      console.log('💾 Final taskData before insert:', JSON.stringify(taskData, null, 2));

      const { data, error: taskError } = await supabase
        .from('tasks')
        .insert([taskData])
        .select()
        .single();

      if (taskError) {
        console.error('Error creating task:', taskError);
        console.error('Task data that failed:', taskData);
        alert('Failed to create task: ' + taskError.message);
        return;
      }

      console.log('✅ Task created successfully. Returned data:', data);
      console.log('✅ Verifying contact_id and project_id in saved task:', {
        contact_id: data?.contact_id,
        project_id: data?.project_id
      });
      taskResult = data;
    }

    // Handle team member assignments
    if (editingTask) {
      // Remove existing assignments
      await supabase
        .from('task_assignees')
        .delete()
        .eq('task_id', editingTask.id);
    }

    // Add new assignments - use membersToUse which includes both window.selectedTaskMembers and selectedMembers
    if (membersToUse.length > 0) {
      const assigneesData = membersToUse.map(memberId => ({
        task_id: taskResult.id,
        user_id: memberId,
      }));

      console.log('👥 Assigning team members:', assigneesData);

      const { error: assigneesError } = await supabase
        .from('task_assignees')
        .insert(assigneesData);

      if (assigneesError) {
        console.error('Error assigning team members:', assigneesError);
        alert('Task saved but failed to assign some team members');
      } else {
        console.log('✅ Team members assigned successfully');
      }
    } else {
      console.log('⚠️ No team members to assign');
    }

    // Handle client assignments
    if (editingTask) {
      // Remove existing client assignments
      await supabase
        .from('task_clients')
        .delete()
        .eq('task_id', editingTask.id);
    }

    if (selectedClients.length > 0) {
      const clientAssignmentsData = selectedClients.map(clientId => ({
        task_id: taskResult.id,
        client_id: clientId,
      }));

      const { error: clientsError } = await supabase
        .from('task_clients')
        .insert(clientAssignmentsData);

      if (clientsError) {
        console.error('Error assigning clients:', clientsError);
        alert('Task saved but failed to assign some clients');
      }
    }

    // Show success notification BEFORE clearing editingTask
    const wasEditing = !!editingTask;
    if (typeof showNotification === 'function') {
      showNotification(wasEditing ? 'Task updated successfully!' : 'Task Created', 'success');
    }

    // Reset form state - clear ALL task-related variables
    selectedService = '';
    customServiceName = '';
    taskPriority = 'MEDIUM';
    taskStatus = 'BACKLOG';
    selectedMembers = [];
    selectedClients = [];
    editingTask = null;
    // Also clear window variables to ensure modal form is reset
    window.editingTaskData = null;
    window.selectedTaskMembers = [];
    window.selectedTaskContact = '';
    window.selectedTaskProject = '';
    window.selectedTaskService = '';
    window.customTaskServiceName = '';
    window.taskPriority = 'MEDIUM';
    window.taskStatus = 'BACKLOG';

    // Refresh tasks and close form
    await loadTasks();
    showAddTaskForm = false;
    renderPMTool();

    // Show success notification
    if (typeof showNotification === 'function') {
      showNotification(editingTask ? 'Task updated successfully!' : 'Task Created', 'success');
    }
  } catch (error) {
    console.error('Error saving task:', error);
    alert('Failed to save task: ' + error.message);
  } finally {
    const createBtn = document.getElementById('create-task-btn');
    if (createBtn) {
      createBtn.disabled = false;
      createBtn.textContent = editingTask ? 'Update Task' : 'Create Task';
    }
  }
}

// Show task comments modal
window.showTaskComments = async function (taskId) {
  console.log(`💬 Showing comments for task ${taskId}`);
  showTaskCommentsModal = taskId;
  await loadTaskComments(taskId);
  renderPMTool();
};

// Load task comments
async function loadTaskComments(taskId) {
  try {
    const { data, error } = await supabase
      .from('task_comments')
      .select(`
        *,
        profiles:author_id (
          first_name,
          last_name,
          avatar_path
        )
      `)
      .eq('task_id', taskId)
      .order('created_at', { ascending: true });

    if (error) {
      console.error('Error loading task comments:', error);
      return;
    }

    taskComments = data || [];
    console.log(`📝 Loaded ${taskComments.length} comments for task ${taskId}`);
  } catch (error) {
    console.error('Error loading task comments:', error);
  }
}

// Render task comments modal
function renderTaskCommentsModal() {
  const task = tasks.find(t => t.id === showTaskCommentsModal);
  if (!task) return '';

  return `
    <!-- Task Comments Modal Overlay -->
    <div id="task-comments-modal" onclick="handleTaskCommentsModalClick(event)" style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 1000;
      animation: fadeIn 0.3s ease-out;
    ">
      <!-- Modal Content -->
      <div onclick="event.stopPropagation()" style="
        background: ${colors.surface};
        border-radius: 1rem;
        padding: 2rem;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
        max-width: 600px;
        width: 90%;
        max-height: 80vh;
        overflow-y: auto;
        animation: slideIn 0.3s ease-out;
        position: relative;
      ">
        <!-- Close Button -->
        <button
          onclick="closeTaskComments()"
          style="
            position: absolute;
            top: 1rem;
            right: 1rem;
            background: #dc2626;
            color: white;
            border: none;
            width: 2.5rem;
            height: 2.5rem;
            border-radius: 50%;
            cursor: pointer;
            font-size: 1.5rem;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.2s ease;
            box-shadow: 0 2px 4px rgba(0,0,0,0.2);
            z-index: 10;
          "
          onmouseover="this.style.transform='scale(1.1)'; this.style.background='#b91c1c'"
          onmouseout="this.style.transform='scale(1)'; this.style.background='#dc2626'"
        >
          ×
        </button>
        
        <!-- Header -->
        <div style="margin-bottom: 1.5rem;">
          <h2 style="margin: 0 0 0.5rem 0; color: ${colors.text}; font-size: 1.5rem;">
            💬 Comments for "${task.title}" (${taskComments.length} comment${taskComments.length !== 1 ? 's' : ''})
          </h2>
        </div>
        
        <!-- Comments List -->
        <div style="margin-bottom: 1.5rem; max-height: 400px; overflow-y: auto;">
          ${taskComments.length === 0 ? `
            <div style="
              text-align: center;
              padding: 2rem;
              color: ${colors.textSecondary};
            ">
              <div style="font-size: 2rem; margin-bottom: 0.5rem;">💬</div>
              <p style="margin: 0;">No comments yet. Be the first to comment!</p>
            </div>
          ` : renderThreadedComments()}
        </div>
        
        <!-- Add Comment Form -->
        <form id="add-comment-form" onsubmit="handleAddComment(event)">
          <div style="margin-bottom: 1rem;">
            <textarea
              id="comment-content"
              placeholder="Add a comment..."
              required
              style="
                width: 100%;
                min-height: 80px;
                padding: 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-family: inherit;
                font-size: 0.875rem;
                resize: vertical;
                background: ${colors.surface};
                color: ${colors.text};
              "
            ></textarea>
          </div>
          <div style="display: flex; gap: 1rem; justify-content: flex-end;">
            <button
              type="button"
              onclick="closeTaskComments()"
              style="
                background: ${colors.background};
                color: ${colors.text};
                border: 1px solid ${colors.border};
                padding: 0.75rem 1.5rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-size: 0.875rem;
                transition: all 0.2s ease;
              "
              onmouseover="this.style.background='${colors.border}'"
              onmouseout="this.style.background='${colors.background}'"
            >
              Cancel
            </button>
            <button
              type="submit"
              style="
                background: ${colors.primary};
                color: white;
                border: none;
                padding: 0.75rem 1.5rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-size: 0.875rem;
                font-weight: 500;
                transition: all 0.2s ease;
              "
              onmouseover="this.style.background='${colors.primaryDark}'"
              onmouseout="this.style.background='${colors.primary}'"
            >
              Add Comment
            </button>
          </div>
        </form>
      </div>
    </div>
  `;
}

// Render threaded comments
function renderThreadedComments() {
  // Group comments by parent_id
  const topLevelComments = taskComments.filter(c => !c.parent_id);
  const replies = taskComments.filter(c => c.parent_id);

  return topLevelComments.map(comment => {
    const commentReplies = replies.filter(r => r.parent_id === comment.id);

    return `
      <div>
        <!-- Main Comment -->
        ${renderComment(comment, false)}
        
        <!-- Replies -->
        ${commentReplies.map(reply => renderComment(reply, true)).join('')}
      </div>
    `;
  }).join('');
}

// Render individual comment
function renderComment(comment, isReply) {
  return `
    <div style="
      background: ${colors.background};
      border-radius: 0.5rem;
      padding: 1rem;
      margin-bottom: 1rem;
      border-left: 3px solid ${colors.primary};
      margin-left: ${isReply ? '2rem' : '0'};
      opacity: ${isReply ? '0.9' : '1'};
    ">
      <div style="display: flex; align-items: center; margin-bottom: 0.5rem;">
        <div style="position: relative; margin-right: 0.5rem;">
          ${(() => {
      const profile = comment.profiles;
      if (!profile) return '<div style="width: 2rem; height: 2rem; border-radius: 50%; background: #6b7280; color: white; display: flex; align-items: center; justify-content: center; font-size: 0.75rem; font-weight: 600;">?</div>';

      const initials = `${(profile.first_name || '').charAt(0)}${(profile.last_name || '').charAt(0)}`.toUpperCase() || '?';
      const avatarUrl = profile.avatar_path ? getAvatarUrl(profile.avatar_path) : null;
      const bgColor = getAvatarBackgroundColor(profile.first_name || profile.id || '');

      return `
              ${avatarUrl ? `
                <img
                  src="${avatarUrl}"
                  alt="${initials}"
                  style="
                    width: 2rem;
                    height: 2rem;
                    border-radius: 50%;
                    object-fit: cover;
                    border: 2px solid white;
                    box-shadow: 0 0 0 1px rgba(0,0,0,0.1);
                  "
                  onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';"
                />
              ` : ''}
              <div style="
                ${avatarUrl ? 'display: none;' : 'display: flex;'}
                width: 2rem;
                height: 2rem;
                border-radius: 50%;
                background: ${bgColor};
                color: white;
                align-items: center;
                justify-content: center;
                font-size: 0.75rem;
                font-weight: 600;
                border: 2px solid white;
                box-shadow: 0 0 0 1px rgba(0,0,0,0.1);
              ">${initials}</div>
            `;
    })()}
        </div>
        <div style="flex: 1;">
          <div style="font-weight: 600; color: ${colors.text}; font-size: 0.875rem;">
            ${comment.profiles ? `${comment.profiles.first_name} ${comment.profiles.last_name}` : 'Unknown User'}
            ${isReply ? '<span style="color: #6b7280; font-weight: normal; font-size: 0.75rem;"> (reply)</span>' : ''}
          </div>
          <div style="color: ${colors.textSecondary}; font-size: 0.75rem;">
            ${new Date(comment.created_at).toLocaleString()}
          </div>
        </div>
        ${!isReply ? `
          <button
            onclick="startReply('${comment.id}')"
            style="
              background: ${colors.primaryLight};
              color: ${colors.primary};
              border: none;
              padding: 0.25rem 0.5rem;
              border-radius: 0.25rem;
              cursor: pointer;
              font-size: 0.75rem;
            "
          >
            Reply
          </button>
        ` : ''}
      </div>
      <div style="color: ${colors.text}; line-height: 1.5;">
        ${makeLinksClickable(comment.body)}
      </div>
      
      <!-- Reply Input -->
      ${replyingTo === comment.id ? `
        <div style="
          margin-top: 1rem;
          padding: 0.75rem;
          background: ${colors.surface};
          border-radius: 0.5rem;
          border: 1px solid ${colors.primary};
        ">
          <textarea
            id="reply-text-${comment.id}"
            placeholder="Write your reply..."
            style="
              width: 100%;
              padding: 0.5rem;
              border: 1px solid ${colors.border};
              border-radius: 0.25rem;
              font-size: 0.875rem;
              resize: vertical;
              min-height: 60px;
              box-sizing: border-box;
            "
          >${replyText}</textarea>
          <div style="display: flex; gap: 0.5rem; margin-top: 0.5rem; justify-content: flex-end;">
            <button
              type="button"
              onclick="cancelReply()"
              style="
                background: ${colors.border};
                color: ${colors.text};
                border: none;
                padding: 0.5rem 1rem;
                border-radius: 0.25rem;
                cursor: pointer;
                font-size: 0.875rem;
              "
            >
              Cancel
            </button>
            <button
              type="button"
              onclick="submitReply('${comment.id}')"
              style="
                background: ${colors.primary};
                color: white;
                border: none;
                padding: 0.5rem 1rem;
                border-radius: 0.25rem;
                cursor: pointer;
                font-size: 0.875rem;
              "
            >
              Reply
            </button>
          </div>
        </div>
      ` : ''}
    </div>
  `;
}

// Start replying to a comment
window.startReply = function (commentId) {
  replyingTo = commentId;
  replyText = '';
  renderPMTool();
};

// Cancel reply
window.cancelReply = function () {
  replyingTo = null;
  replyText = '';
  renderPMTool();
};

// Toggle task list modal
window.toggleTaskListModal = function () {
  showTaskListModal = !showTaskListModal;
  renderPMTool();
};

// Close task list modal
window.closeTaskListModal = function () {
  showTaskListModal = false;
  renderPMTool();
};

// Render task list modal
function renderTaskListModal() {
  const filteredTasks = getFilteredTasks() || [];
  const backlogTasks = (filteredTasks.filter(t => t && t.state === 'BACKLOG') || []);
  const activeTasks = (filteredTasks.filter(t => t && t.state === 'ACTIVE') || []);

  // Sort by due date (null/undefined dates go to end)
  const sortByDueDate = (a, b) => {
    if (!a.due_at && !b.due_at) return 0;
    if (!a.due_at) return 1;
    if (!b.due_at) return -1;
    return new Date(a.due_at) - new Date(b.due_at);
  };

  backlogTasks.sort(sortByDueDate);
  activeTasks.sort(sortByDueDate);

  const priorityColors = {
    LOW: { bg: '#D1FAE5', text: '#065F46' },
    MEDIUM: { bg: '#FEF3C7', text: '#92400E' },
    HIGH: { bg: '#FCE7F3', text: '#9F1239' },
    URGENT: { bg: '#F3E8FF', text: '#6B21A8' }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'No due date';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: date.getFullYear() !== new Date().getFullYear() ? 'numeric' : undefined });
  };

  const getAssignedNames = (task) => {
    if (!task.assigned_members || task.assigned_members.length === 0) return 'Unassigned';
    return task.assigned_members.map(m => `${m.first_name || ''} ${m.last_name || ''}`.trim() || 'Unknown').join(', ');
  };

  const renderTaskItem = (task) => {
    if (!task || !task.id) return '';
    const priority = priorityColors[task.priority] || priorityColors.MEDIUM;
    const taskTitle = task.title || 'Untitled Task';
    return `
      <div
        onclick="if (window.viewTaskDetails) { window.viewTaskDetails('${task.id}'); closeTaskListModal(); }"
        style="
          background: white;
          border-left: 3px solid ${priority.text};
          padding: 0.75rem;
          margin-bottom: 0.5rem;
          border-radius: 0.25rem;
          cursor: pointer;
          transition: all 0.2s ease;
        "
        onmouseover="this.style.background='#f8f9fa'; this.style.transform='translateX(4px)';"
        onmouseout="this.style.background='white'; this.style.transform='translateX(0)';"
      >
        <div style="font-weight: 600; color: ${colors.text}; margin-bottom: 0.5rem; font-size: 0.875rem;">
          ${taskTitle}
        </div>
        <div style="display: flex; flex-wrap: wrap; gap: 0.5rem; font-size: 0.75rem; color: ${colors.textSecondary};">
          <span style="
            background: ${priority.bg};
            color: ${priority.text};
            padding: 0.25rem 0.5rem;
            border-radius: 0.25rem;
            font-weight: 500;
          ">${task.priority}</span>
          <span style="display: flex; align-items: center; gap: 0.25rem;">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
            ${getAssignedNames(task)}
          </span>
          <span style="display: flex; align-items: center; gap: 0.25rem;">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="16" y1="2" x2="16" y2="6"></line>
              <line x1="8" y1="2" x2="8" y2="6"></line>
              <line x1="3" y1="10" x2="21" y2="10"></line>
            </svg>
            ${formatDate(task.due_at)}
          </span>
        </div>
      </div>
    `;
  };

  return `
    <div
      id="task-list-modal"
      onclick="if (event.target.id === 'task-list-modal') closeTaskListModal();"
      style="
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(255, 255, 255, 0.12);
        backdrop-filter: blur(4px);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
        animation: fadeIn 0.3s ease-out;
      "
    >
      <div
        onclick="event.stopPropagation()"
        style="
          background: white;
          border-radius: 1rem;
          padding: 1.5rem;
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
          max-width: 1000px;
          width: 90%;
          max-height: 80vh;
          overflow-y: auto;
          animation: slideIn 0.3s ease-out;
          position: relative;
        "
      >
        <!-- Close Button -->
        <button
          onclick="closeTaskListModal()"
          style="
            position: absolute;
            top: 1rem;
            right: 1rem;
            background: #dc2626;
            color: white;
            border: none;
            width: 2rem;
            height: 2rem;
            border-radius: 50%;
            cursor: pointer;
            font-size: 1.25rem;
            font-weight: bold;
            display: flex;
            align-items: center;
            justify-content: center;
            transition: all 0.2s ease;
            z-index: 10;
          "
          onmouseover="this.style.background='#b91c1c'; this.style.transform='scale(1.1)';"
          onmouseout="this.style.background='#dc2626'; this.style.transform='scale(1)';"
        >
          ×
        </button>

        <!-- Header -->
        <div style="margin-bottom: 1.5rem;">
          <h2 style="margin: 0 0 0.5rem 0; color: ${colors.text}; font-size: 1.5rem; font-weight: 600;">
            Task List
          </h2>
          <p style="margin: 0; color: ${colors.textSecondary}; font-size: 0.875rem;">
            Quick view of all tasks
          </p>
        </div>

        <!-- Two Column Layout -->
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1.5rem;">
          <!-- Backlog Column -->
          <div>
            <div style="
              background: #ff7f00;
              color: white;
              padding: 0.75rem 1rem;
              border-radius: 0.5rem;
              font-weight: 600;
              margin-bottom: 1rem;
              font-size: 0.875rem;
              display: flex;
              align-items: center;
              gap: 0.5rem;
            ">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="8" y1="6" x2="21" y2="6"></line>
                <line x1="8" y1="12" x2="21" y2="12"></line>
                <line x1="8" y1="18" x2="21" y2="18"></line>
                <line x1="3" y1="6" x2="3.01" y2="6"></line>
                <line x1="3" y1="12" x2="3.01" y2="12"></line>
                <line x1="3" y1="18" x2="3.01" y2="18"></line>
              </svg>
              Backlog (${backlogTasks.length})
            </div>
            <div>
              ${backlogTasks.length === 0 ? `
                <div style="
                  text-align: center;
                  padding: 2rem;
                  color: ${colors.textSecondary};
                  font-size: 0.875rem;
                ">
                  No backlog tasks
                </div>
              ` : backlogTasks.map(renderTaskItem).join('')}
            </div>
          </div>

          <!-- Active Column -->
          <div>
            <div style="
              background: #ef4444;
              color: white;
              padding: 0.75rem 1rem;
              border-radius: 0.5rem;
              font-weight: 600;
              margin-bottom: 1rem;
              font-size: 0.875rem;
              display: flex;
              align-items: center;
              gap: 0.5rem;
            ">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="23 4 23 10 17 10"></polyline>
                <polyline points="1 20 1 14 7 14"></polyline>
                <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
              </svg>
              Active (${activeTasks.length})
            </div>
            <div>
              ${activeTasks.length === 0 ? `
                <div style="
                  text-align: center;
                  padding: 2rem;
                  color: ${colors.textSecondary};
                  font-size: 0.875rem;
                ">
                  No active tasks
                </div>
              ` : activeTasks.map(renderTaskItem).join('')}
            </div>
          </div>
        </div>
      </div>
    </div>
  `;
}

// Submit reply
window.submitReply = async function (parentCommentId) {
  const replyContent = document.getElementById(`reply-text-${parentCommentId}`).value.trim();

  if (!replyContent) {
    alert('Please enter a reply');
    return;
  }

  try {
    const { error } = await supabase
      .from('task_comments')
      .insert({
        task_id: showTaskCommentsModal,
        author_id: currentUser.id,
        body: replyContent,
        parent_id: parentCommentId
      });

    if (error) {
      console.error('Error adding reply:', error);
      alert('Failed to add reply: ' + error.message);
      return;
    }

    console.log('✅ Reply added successfully');

    // Update comment count
    taskCommentCounts[showTaskCommentsModal] = (taskCommentCounts[showTaskCommentsModal] || 0) + 1;

    // Reset reply state
    replyingTo = null;
    replyText = '';

    // Reload comments
    await loadTaskComments(showTaskCommentsModal);
    renderPMTool();

  } catch (error) {
    console.error('Error adding reply:', error);
    alert('Failed to add reply: ' + error.message);
  }
};

// Close task comments modal
window.closeTaskComments = function () {
  showTaskCommentsModal = null;
  taskComments = [];
  replyingTo = null;
  replyText = '';
  renderPMTool();
};

// Handle task comments modal click
window.handleTaskCommentsModalClick = function (event) {
  if (event.target.id === 'task-comments-modal') {
    closeTaskComments();
  }
};

// Handle add comment
window.handleAddComment = async function (event) {
  event.preventDefault();

  const content = document.getElementById('comment-content').value.trim();
  if (!content) return;

  const submitBtn = event.target.querySelector('button[type="submit"]');
  if (submitBtn) {
    submitBtn.disabled = true;
    submitBtn.textContent = 'Adding...';
  }

  try {
    console.log('🔄 Adding comment with data:', {
      task_id: showTaskCommentsModal,
      author_id: currentUser.id,
      body: content
    });
    console.log('🔄 Supabase client:', supabase);
    console.log('🔄 Current user:', currentUser);

    const { error } = await supabase
      .from('task_comments')
      .insert({
        task_id: showTaskCommentsModal,
        author_id: currentUser.id,
        body: content
      });

    if (error) {
      console.error('Error adding comment:', error);
      alert('Failed to add comment: ' + error.message);
      return;
    }

    console.log('✅ Comment added successfully');

    // Update comment count
    taskCommentCounts[showTaskCommentsModal] = (taskCommentCounts[showTaskCommentsModal] || 0) + 1;

    // Clear form
    document.getElementById('comment-content').value = '';

    // Reload comments
    await loadTaskComments(showTaskCommentsModal);
    renderPMTool();

  } catch (error) {
    console.error('Error adding comment:', error);
    alert('Failed to add comment: ' + error.message);
  } finally {
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Add Comment';
    }
  }
};

// Company Management Functions
window.openCompanyManagement = async function () {
  showCompanyManagement = true;
  managementTab = 'members'; // Default to members tab
  memberSearchQuery = '';
  serviceSearchQuery = '';
  clientSearchQuery = '';
  window.clientSearchQuery = '';
  await loadTeamMembers(); // Reload to get latest data
  await loadContacts(); // Load contacts for clients tab
  await loadClients(); // Load clients for clients tab
  await loadServices(); // Load services for services tab
  renderPMTool();
};

// Billing Management Functions
window.openBillingManagement = async function () {
  showCompanyManagement = true;
  managementTab = 'billing'; // Set to billing tab
  renderPMTool();
};

// Show custom cancellation confirmation modal
window.showCancelSubscriptionModal = function () {
  if (!currentCompany?.stripe_subscription_id) {
    alert('No active subscription found.');
    return;
  }

  // Calculate days until period end
  const currentPeriodEnd = currentCompany?.stripe_current_period_end;
  let daysRemaining = null;
  if (currentPeriodEnd) {
    const endDate = new Date(currentPeriodEnd);
    const now = new Date();
    const diffTime = endDate - now;
    daysRemaining = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  }

  const periodEndDate = currentPeriodEnd
    ? new Date(currentPeriodEnd).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
    : 'the end of your billing period';

  const modal = document.createElement('div');
  modal.id = 'cancel-subscription-modal';
  modal.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    padding: 1rem;
  `;

  modal.innerHTML = `
    <div style="
      background: white;
      border-radius: 1rem;
      padding: 2rem;
      max-width: 500px;
      width: 100%;
      box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
      animation: slideIn 0.2s ease-out;
    ">
      <div style="margin-bottom: 1.5rem;">
        <h2 style="
          margin: 0 0 1rem 0;
          font-size: 1.5rem;
          font-weight: 700;
          color: #1f2937;
        ">Cancel Subscription?</h2>
        <p style="
          margin: 0 0 1rem 0;
          color: #6b7280;
          font-size: 0.9375rem;
          line-height: 1.6;
        ">
          Are you sure you want to cancel your subscription?
        </p>
        <div style="
          background: #fef3c7;
          border: 1px solid #fcd34d;
          border-radius: 0.5rem;
          padding: 1rem;
          margin-bottom: 1rem;
        ">
          <p style="
            margin: 0;
            color: #92400e;
            font-size: 0.875rem;
            line-height: 1.6;
          ">
            Your premium access will remain active ${daysRemaining !== null ? `for ${daysRemaining} day${daysRemaining !== 1 ? 's' : ''} ` : ''}until <strong>${periodEndDate}</strong>.
          </p>
          <p style="
            margin: 0.75rem 0 0 0;
            color: #92400e;
            font-size: 0.875rem;
            line-height: 1.6;
          ">
            After that date, your subscription will be canceled and you will lose access to premium features.
          </p>
        </div>
      </div>
      <div style="
        display: flex;
        gap: 0.75rem;
        justify-content: flex-end;
      ">
        <button
          id="cancel-subscription-cancel-btn"
          style="
            background: #f3f4f6;
            color: #374151;
            border: none;
            padding: 0.75rem 1.5rem;
            border-radius: 0.5rem;
            font-weight: 600;
            cursor: pointer;
            font-size: 0.9375rem;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#e5e7eb'"
          onmouseout="this.style.background='#f3f4f6'"
        >
          Cancel
        </button>
        <button
          id="cancel-subscription-confirm-btn"
          style="
            background: #ef4444;
            color: white;
            border: none;
            padding: 0.75rem 1.5rem;
            border-radius: 0.5rem;
            font-weight: 600;
            cursor: pointer;
            font-size: 0.9375rem;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#dc2626'"
          onmouseout="this.style.background='#ef4444'"
        >
          Yes, Cancel Subscription
        </button>
      </div>
    </div>
  `;

  document.body.appendChild(modal);

  // Close on cancel button
  modal.querySelector('#cancel-subscription-cancel-btn').onclick = () => {
    modal.remove();
  };

  // Close on backdrop click
  modal.onclick = (e) => {
    if (e.target === modal) {
      modal.remove();
    }
  };

  // Confirm cancellation
  modal.querySelector('#cancel-subscription-confirm-btn').onclick = () => {
    modal.remove();
    window.processCancelSubscription();
  };
};

window.cancelSubscription = async function () {
  window.showCancelSubscriptionModal();
};

// Show custom success modal for cancellation
window.showCancelSuccessModal = function (endDate) {
  const modal = document.createElement('div');
  modal.id = 'cancel-subscription-success-modal';
  modal.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
    padding: 1rem;
  `;

  modal.innerHTML = `
    <div style="
      background: white;
      border-radius: 1rem;
      padding: 2rem;
      max-width: 500px;
      width: 100%;
      box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
      animation: slideIn 0.2s ease-out;
    ">
      <div style="text-align: center; margin-bottom: 1.5rem;">
        <div style="
          width: 64px;
          height: 64px;
          background: #10b981;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1rem;
        ">
          <span style="font-size: 2rem; color: white;">✓</span>
        </div>
        <h2 style="
          margin: 0 0 0.75rem 0;
          font-size: 1.5rem;
          font-weight: 700;
          color: #1f2937;
        ">Cancellation Scheduled</h2>
        <p style="
          margin: 0;
          color: #6b7280;
          font-size: 0.9375rem;
          line-height: 1.6;
        ">
          Your subscription has been scheduled for cancellation.
        </p>
      </div>
      <div style="
        background: #f0fdf4;
        border: 1px solid #86efac;
        border-radius: 0.5rem;
        padding: 1rem;
        margin-bottom: 1.5rem;
      ">
        <p style="
          margin: 0;
          color: #166534;
          font-size: 0.875rem;
          line-height: 1.6;
          text-align: center;
        ">
          Your plan will remain active until <strong>${endDate}</strong>.
        </p>
      </div>
      <div style="display: flex; justify-content: center;">
        <button
          id="cancel-subscription-success-ok-btn"
          style="
            background: #10b981;
            color: white;
            border: none;
            padding: 0.75rem 2rem;
            border-radius: 0.5rem;
            font-weight: 600;
            cursor: pointer;
            font-size: 0.9375rem;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#059669'"
          onmouseout="this.style.background='#10b981'"
        >
          OK
        </button>
      </div>
    </div>
  `;

  document.body.appendChild(modal);

  // Close on OK button or backdrop click
  const closeModal = () => {
    modal.remove();
  };

  modal.querySelector('#cancel-subscription-success-ok-btn').onclick = closeModal;
  modal.onclick = (e) => {
    if (e.target === modal) {
      closeModal();
    }
  };
};

window.processCancelSubscription = async function () {

  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.access_token) {
      alert('Please sign in to cancel your subscription.');
      return;
    }

    const response = await fetch('/api/stripe/cancel-subscription', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${session.access_token}`
      }
    });

    const status = response.status;
    const contentType = response.headers.get('content-type');
    const raw = await response.text();
    console.log('Cancel subscription raw response:', { status, contentType, raw });

    let data;
    try {
      data = raw ? JSON.parse(raw) : {};
    } catch {
      data = { error: 'non_json_error', raw };
    }

    if (!response.ok) {
      console.error('Cancel subscription error:', { status, data });
      alert(data?.message || data?.error || 'Failed to cancel subscription. Please try again.');
      return;
    }

    if (data?.ok) {
      const currentPeriodEnd = currentCompany?.stripe_current_period_end;
      const endDate = data.current_period_end
        ? new Date(data.current_period_end * 1000).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
        : (currentPeriodEnd
          ? new Date(currentPeriodEnd).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
          : 'the end of your billing period');

      // Show custom success modal instead of alert
      window.showCancelSuccessModal(endDate);

      // Reload company data to get updated cancel_at_period_end
      if (currentCompany?.id) {
        const { data: updatedCompany, error: companyError } = await supabase
          .from('companies')
          .select('*')
          .eq('id', currentCompany.id)
          .maybeSingle();

        if (!companyError && updatedCompany) {
          currentCompany = updatedCompany;
        }
      }

      renderPMTool();
    } else {
      alert('Failed to cancel subscription. Please try again.');
    }
  } catch (error) {
    console.error('Cancel subscription error:', error);
    alert('Failed to cancel subscription. Please try again.');
  }
};

window.switchManagementTab = function (tab) {
  managementTab = tab;
  renderPMTool();
};

window.closeCompanyManagement = function () {
  showCompanyManagement = false;
  memberSearchQuery = '';
  serviceSearchQuery = '';
  clientSearchQuery = '';
  window.clientSearchQuery = '';
  showAddMemberModal = false;
  showAddServiceModal = false;
  showAddClientModal = false;
  editingMemberId = null;
  editingServiceId = null;
  addingClientContactId = null;
  renderPMTool();
};

window.openAddMemberModal = function () {
  showAddMemberModal = true;
  renderPMTool();
};

window.closeAddMemberModal = function () {
  showAddMemberModal = false;
  // Clear email exists message when closing modal
  const messageDiv = document.getElementById('email-exists-message');
  if (messageDiv) {
    messageDiv.style.display = 'none';
  }
  renderPMTool();
};

window.openEditMemberModal = function (memberId) {
  editingMemberId = memberId;
  renderPMTool();
};

window.closeEditMemberModal = function () {
  editingMemberId = null;
  renderPMTool();
};

// Show delete member confirmation modal
window.showDeleteMemberConfirmation = function (memberId) {
  const member = teamMembers.find(m => m.id === memberId);
  if (!member) {
    alert('Member not found');
    return;
  }

  const memberName = `${member.first_name} ${member.last_name}`;

  // Create confirmation modal
  const modalHTML = `
    <div id="delete-member-modal-overlay" style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.6);
      z-index: 100001;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 1rem;
    " onclick="if (event.target.id === 'delete-member-modal-overlay') closeDeleteMemberModal()">
      <div style="
        background: white;
        border-radius: 1rem;
        padding: 2rem;
        max-width: 500px;
        width: 100%;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
      " onclick="event.stopPropagation()">
        <!-- Header -->
        <div style="margin-bottom: 1.5rem;">
          <h2 style="
            margin: 0 0 0.5rem 0;
            font-size: 1.5rem;
            font-weight: 700;
            color: #dc2626;
          ">Delete Member</h2>
          <p style="
            margin: 0;
            color: #6c757d;
            font-size: 0.9375rem;
          ">Are you sure you want to delete <strong>${memberName}</strong>? This action cannot be restored.</p>
        </div>

        <!-- Warning -->
        <div style="
          background: #fef2f2;
          border: 1px solid #fecaca;
          border-radius: 0.5rem;
          padding: 1rem;
          margin-bottom: 1.5rem;
        ">
          <div style="
            color: #dc2626;
            font-size: 0.875rem;
            font-weight: 600;
            margin-bottom: 0.5rem;
          ">⚠️ Warning</div>
          <div style="
            color: #991b1b;
            font-size: 0.875rem;
          ">This will permanently delete the user account and all associated data. This action cannot be undone.</div>
        </div>

        <!-- Confirmation Input -->
        <div style="margin-bottom: 1.5rem;">
          <label style="
            display: block;
            font-size: 0.875rem;
            font-weight: 600;
            color: #2c3e50;
            margin-bottom: 0.5rem;
          ">
            Type <strong>DELETE</strong> to confirm:
          </label>
          <input
            type="text"
            id="delete-confirmation-input"
            placeholder="Type DELETE to confirm"
            style="
              width: 100%;
              padding: 0.75rem;
              border: 2px solid #e5e7eb;
              border-radius: 0.5rem;
              font-size: 0.9375rem;
              box-sizing: border-box;
              transition: border-color 0.2s;
            "
            oninput="
              const btn = document.getElementById('confirm-delete-btn');
              if (btn) {
                if (this.value.trim().toUpperCase() === 'DELETE') {
                  btn.disabled = false;
                  btn.style.background = '#dc2626';
                  btn.style.cursor = 'pointer';
                  this.style.borderColor = '#10b981';
                } else {
                  btn.disabled = true;
                  btn.style.background = '#9ca3af';
                  btn.style.cursor = 'not-allowed';
                  this.style.borderColor = '#e5e7eb';
                }
              }
            "
            onfocus="this.style.borderColor='#dc2626'"
            onblur="if (this.value.trim().toUpperCase() !== 'DELETE') this.style.borderColor='#e5e7eb'"
          />
        </div>

        <!-- Actions -->
        <div style="
          display: flex;
          gap: 0.75rem;
          justify-content: flex-end;
        ">
          <button
            type="button"
            onclick="closeDeleteMemberModal()"
            style="
              background: #f3f4f6;
              color: #2c3e50;
              border: none;
              padding: 0.75rem 1.5rem;
              border-radius: 0.5rem;
              cursor: pointer;
              font-weight: 600;
              font-size: 0.9375rem;
            "
            onmouseover="this.style.background='#e5e7eb'"
            onmouseout="this.style.background='#f3f4f6'"
          >
            Cancel
          </button>
          <button
            type="button"
            id="confirm-delete-btn"
            onclick="confirmDeleteMember('${memberId}')"
            disabled
            style="
              background: #9ca3af;
              color: white;
              border: none;
              padding: 0.75rem 1.5rem;
              border-radius: 0.5rem;
              cursor: not-allowed;
              font-weight: 600;
              font-size: 0.9375rem;
              transition: all 0.2s;
            "
          >
            Delete User
          </button>
        </div>
      </div>
    </div>
  `;

  document.body.insertAdjacentHTML('beforeend', modalHTML);

  // Focus on input
  setTimeout(() => {
    const input = document.getElementById('delete-confirmation-input');
    if (input) input.focus();
  }, 100);
};

// Close delete member modal
window.closeDeleteMemberModal = function () {
  const modal = document.getElementById('delete-member-modal-overlay');
  if (modal) {
    modal.remove();
  }
};

// Confirm and delete member
window.confirmDeleteMember = async function (memberId) {
  const confirmationInput = document.getElementById('delete-confirmation-input');
  if (!confirmationInput || confirmationInput.value.trim().toUpperCase() !== 'DELETE') {
    alert('Please type DELETE to confirm');
    return;
  }

  const member = teamMembers.find(m => m.id === memberId);
  if (!member) {
    alert('Member not found');
    closeDeleteMemberModal();
    return;
  }

  const deleteBtn = document.getElementById('confirm-delete-btn');
  if (deleteBtn) {
    deleteBtn.disabled = true;
    deleteBtn.textContent = 'Deleting...';
  }

  try {
    // Delete from company_members first
    const { error: memberError } = await supabase
      .from('company_members')
      .delete()
      .eq('company_id', currentCompany.id)
      .eq('user_id', memberId);

    if (memberError) {
      console.error('Error removing member from company:', memberError);
      alert('Failed to remove member from company: ' + memberError.message);
      if (deleteBtn) {
        deleteBtn.disabled = false;
        deleteBtn.textContent = 'Delete User';
      }
      return;
    }

    // Note: We don't delete the profile/auth user as they might be in other companies
    // The profile will remain but they won't have access to this company

    // Close delete modal
    closeDeleteMemberModal();

    // Close edit modal
    closeEditMemberModal();

    // Reload team members
    await loadTeamMembers();

    // Show success notification
    showNotification('Member deleted successfully', 'success');
  } catch (error) {
    console.error('Error deleting member:', error);
    alert('An unexpected error occurred: ' + error.message);
    if (deleteBtn) {
      deleteBtn.disabled = false;
      deleteBtn.textContent = 'Delete User';
    }
  }
};

window.saveMemberChanges = async function () {
  if (!editingMemberId || !currentCompany) {
    alert('No member selected');
    return;
  }

  const firstNameInput = document.getElementById('edit-member-first-name');
  const lastNameInput = document.getElementById('edit-member-last-name');
  const phoneInput = document.getElementById('edit-member-phone');
  const roleInputs = document.querySelectorAll('input[name="member-role"]:checked');

  if (!firstNameInput || !lastNameInput || !phoneInput) {
    alert('Form fields not found');
    return;
  }

  const firstName = firstNameInput.value.trim();
  const lastName = lastNameInput.value.trim();
  const phone = phoneInput.value.trim();
  const newRole = roleInputs.length > 0 ? roleInputs[0].value : null;

  if (!firstName || !lastName) {
    alert('First name and last name are required');
    return;
  }

  if (!newRole) {
    alert('Please select a role');
    return;
  }

  try {
    // Update profile (first name, last name, phone)
    const { error: profileError } = await supabase
      .from('profiles')
      .update({
        first_name: firstName,
        last_name: lastName,
        phone: phone || null,
        updated_at: new Date().toISOString()
      })
      .eq('id', editingMemberId);

    if (profileError) {
      console.error('Error updating profile:', profileError);
      alert('Failed to update member profile: ' + profileError.message);
      return;
    }

    // Update role in company_members
    const { error: roleError } = await supabase
      .from('company_members')
      .update({
        role: newRole
      })
      .eq('company_id', currentCompany.id)
      .eq('user_id', editingMemberId);

    if (roleError) {
      console.error('Error updating role:', roleError);
      alert('Failed to update member role: ' + roleError.message);
      return;
    }

    // Reload team members
    await loadTeamMembers();

    // Close modal
    closeEditMemberModal();

    // Show custom success notification
    showNotification('Member updated successfully!', 'success');
  } catch (error) {
    console.error('Error saving member changes:', error);
    alert('An unexpected error occurred: ' + error.message);
  }
};

// Highlight invalid field in red
window.highlightInvalidField = function (fieldId, labelText) {
  const field = document.getElementById(fieldId);
  if (field) {
    field.style.borderColor = '#ef4444';
    field.style.borderWidth = '2px';
    field.style.backgroundColor = '#fef2f2';

    // Add error class for animation
    field.classList.add('field-error');

    // Remove error styling after user starts typing
    const removeError = () => {
      field.style.borderColor = '';
      field.style.borderWidth = '';
      field.style.backgroundColor = '';
      field.classList.remove('field-error');
      field.removeEventListener('input', removeError);
      field.removeEventListener('change', removeError);
    };

    field.addEventListener('input', removeError);
    field.addEventListener('change', removeError);

    // Scroll to field
    field.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  // Highlight label if it exists
  const label = field?.previousElementSibling?.tagName === 'LABEL'
    ? field.previousElementSibling
    : document.querySelector(`label[for="${fieldId}"]`);

  if (label) {
    label.style.color = '#ef4444';
    label.style.fontWeight = '600';

    // Remove error styling after a delay
    setTimeout(() => {
      label.style.color = '';
      label.style.fontWeight = '';
    }, 3000);
  }

  // Highlight priority buttons if needed
  if (fieldId === 'priority' || fieldId.includes('priority')) {
    document.querySelectorAll('[onclick^="setTaskPriority"]').forEach(btn => {
      btn.style.boxShadow = '0 0 0 2px #ef4444';
      btn.style.borderColor = '#ef4444';
      // Remove error styling when priority is selected
      const removePriorityError = () => {
        btn.style.boxShadow = '';
        btn.style.borderColor = '';
        document.querySelectorAll('[onclick^="setTaskPriority"]').forEach(b => {
          b.removeEventListener('click', removePriorityError);
        });
      };
      btn.addEventListener('click', removePriorityError, { once: true });
      setTimeout(() => {
        btn.style.boxShadow = '';
        btn.style.borderColor = '';
      }, 5000);
    });
  }

  // Highlight member search container if needed
  if (fieldId === 'member-search' || fieldId === 'task-member-search-input') {
    const memberSearchContainer = field?.parentElement;
    if (memberSearchContainer) {
      memberSearchContainer.style.border = '2px solid #ef4444';
      memberSearchContainer.style.borderRadius = '0.5rem';
      memberSearchContainer.style.padding = '0.25rem';

      // Add error message below the field
      let errorMsg = memberSearchContainer.querySelector('.member-error-message');
      if (!errorMsg) {
        errorMsg = document.createElement('div');
        errorMsg.className = 'member-error-message';
        errorMsg.style.cssText = 'color: #ef4444; font-size: 0.875rem; margin-top: 0.5rem; font-weight: 500;';
        errorMsg.textContent = 'You must select at least one team member';
        memberSearchContainer.appendChild(errorMsg);
      }

      // Remove error styling when member is selected
      const removeMemberError = () => {
        memberSearchContainer.style.border = '';
        memberSearchContainer.style.padding = '';
        if (errorMsg) errorMsg.remove();
      };

      // Check if members are selected periodically
      const checkMembers = setInterval(() => {
        const selectedDiv = document.getElementById('selected-members') || document.getElementById('task-selected-members-display');
        const hasDisplayed = selectedDiv && selectedDiv.children && selectedDiv.children.length > 0;
        const hasMembers = (window.selectedTaskMembers && window.selectedTaskMembers.length > 0) ||
          (selectedMembers && selectedMembers.length > 0) ||
          hasDisplayed;
        if (hasMembers) {
          removeMemberError();
          clearInterval(checkMembers);
        }
      }, 500);
      setTimeout(() => {
        clearInterval(checkMembers);
      }, 10000);
    }
  }

  // Add error message for title and description fields
  if (fieldId === 'task-title-input' || fieldId === 'task-title') {
    const fieldContainer = field?.parentElement;
    if (fieldContainer) {
      // Remove existing error message if any
      const existingError = fieldContainer.querySelector('.field-error-message');
      if (existingError) existingError.remove();

      // Add error message below the field
      const errorMsg = document.createElement('div');
      errorMsg.className = 'field-error-message';
      errorMsg.style.cssText = 'color: #ef4444; font-size: 0.875rem; margin-top: 0.5rem; font-weight: 500;';
      errorMsg.textContent = 'Please fill out this part';
      fieldContainer.appendChild(errorMsg);

      // Remove error message when user starts typing
      const removeErrorMsg = () => {
        if (errorMsg && errorMsg.parentNode) {
          errorMsg.remove();
        }
        field.removeEventListener('input', removeErrorMsg);
      };
      field.addEventListener('input', removeErrorMsg, { once: false });
    }
  }

  if (fieldId === 'task-description-input' || fieldId === 'task-description') {
    const fieldContainer = field?.parentElement;
    if (fieldContainer) {
      // Remove existing error message if any
      const existingError = fieldContainer.querySelector('.field-error-message');
      if (existingError) existingError.remove();

      // Add error message below the field
      const errorMsg = document.createElement('div');
      errorMsg.className = 'field-error-message';
      errorMsg.style.cssText = 'color: #ef4444; font-size: 0.875rem; margin-top: 0.5rem; font-weight: 500;';
      errorMsg.textContent = 'Please fill out this part';
      fieldContainer.appendChild(errorMsg);

      // Remove error message when user starts typing
      const removeErrorMsg = () => {
        if (errorMsg && errorMsg.parentNode) {
          errorMsg.remove();
        }
        field.removeEventListener('input', removeErrorMsg);
      };
      field.addEventListener('input', removeErrorMsg, { once: false });
    }
  }
};

// Clear all field errors
window.clearFieldErrors = function () {
  document.querySelectorAll('.field-error').forEach(field => {
    field.style.borderColor = '';
    field.style.borderWidth = '';
    field.style.backgroundColor = '';
    field.classList.remove('field-error');
  });

  // Remove all error messages
  document.querySelectorAll('.field-error-message, .member-error-message').forEach(errorMsg => {
    errorMsg.remove();
  });
};

// Show custom notification
window.showNotification = function (message, type = 'success') {
  // Remove any existing notifications first
  document.querySelectorAll('.modern-notification').forEach(n => n.remove());

  const notification = document.createElement('div');
  notification.className = 'modern-notification';

  // Define colors and icons based on type
  const config = {
    success: { bg: '#10b981', icon: '✓', text: 'Approved' },
    error: { bg: '#ef4444', icon: '✕', text: 'Error' },
    warning: { bg: '#f59e0b', icon: '⚠', text: 'Warning' },
    rejected: { bg: '#ef4444', icon: '✕', text: 'Rejected' },
    info: { bg: '#3b82f6', icon: 'ℹ', text: 'Info' }
  };

  const style = config[type] || config.success;

  // Create notification HTML with icon
  notification.innerHTML = `
    <div style="display: flex; align-items: center; gap: 0.75rem;">
      <div style="
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.2);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-weight: 600;
        flex-shrink: 0;
      ">${style.icon}</div>
      <div style="flex: 1;">
        <div style="font-weight: 600; font-size: 0.875rem; margin-bottom: 0.125rem;">${style.text}</div>
        <div style="font-size: 0.875rem; opacity: 0.95;">${message}</div>
      </div>
    </div>
  `;

  notification.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: ${style.bg};
    color: white;
    padding: 1rem 1.25rem;
    border-radius: 0.75rem;
    z-index: 10001;
    box-shadow: 0 10px 25px rgba(0,0,0,0.15), 0 4px 10px rgba(0,0,0,0.1);
    font-size: 0.9375rem;
    animation: slideInNotification 0.4s cubic-bezier(0.16, 1, 0.3, 1);
    max-width: 420px;
    min-width: 300px;
    backdrop-filter: blur(10px);
  `;

  // Add animation styles if not already present
  if (!document.getElementById('notification-style')) {
    const styleEl = document.createElement('style');
    styleEl.id = 'notification-style';
    styleEl.textContent = `
      @keyframes slideInNotification {
        from {
          transform: translateX(calc(100% + 20px));
          opacity: 0;
        }
        to {
          transform: translateX(0);
          opacity: 1;
        }
      }
      @keyframes slideOutNotification {
        from {
          transform: translateX(0);
          opacity: 1;
        }
        to {
          transform: translateX(calc(100% + 20px));
          opacity: 0;
        }
      }
    `;
    document.head.appendChild(styleEl);
  }

  document.body.appendChild(notification);

  // Auto-remove after delay
  setTimeout(() => {
    notification.style.animation = 'slideOutNotification 0.3s cubic-bezier(0.4, 0, 1, 1) forwards';
    setTimeout(() => notification.remove(), 300);
  }, 4000);
};

// Start Stripe checkout for premium upgrade
window.startBillingUpgrade = async function () {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.access_token) {
      alert('Please sign in to upgrade.');
      return;
    }

    const response = await fetch('/api/stripe/create-checkout-session', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${session.access_token}`
      }
    });

    const status = response.status;
    const contentType = response.headers.get('content-type');
    const raw = await response.text();
    console.log('Checkout raw response:', { status, contentType, raw });

    let data;
    try {
      data = raw ? JSON.parse(raw) : {};
    } catch {
      data = { error: 'non_json_error', raw };
    }

    if (!response.ok) {
      console.error('Upgrade error response:', { status, data });
      alert(data?.message || data?.error || 'Failed to start checkout.');
      return;
    }

    if (data?.url) {
      window.location.href = data.url;
    } else {
      console.error('Upgrade missing URL:', data);
      alert('No checkout URL returned. Please try again.');
    }
  } catch (error) {
    console.error('Upgrade error:', error);
    alert('Failed to start checkout. Please try again.');
  }
};

// Open Stripe Customer Portal to manage active subscription
window.openStripeCustomerPortal = async function () {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.access_token) {
      alert('Please sign in to manage billing.');
      return;
    }

    // Show loading state on button or alert
    const btn = event?.currentTarget;
    const oldText = btn ? btn.textContent : '';
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Opening Portal...';
    }

    const response = await fetch('/api/stripe/create-portal-session', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${session.access_token}`
      }
    });

    const raw = await response.text();
    let data;
    try {
      data = raw ? JSON.parse(raw) : {};
    } catch {
      data = { error: 'non_json_error', raw };
    }

    if (!response.ok) {
      console.error('Portal error response:', data);
      alert(data?.message || data?.error || 'Failed to open billing portal.');
      if (btn) {
        btn.disabled = false;
        btn.textContent = oldText;
      }
      return;
    }

    if (data?.url) {
      window.location.href = data.url;
    } else {
      console.error('Portal missing URL:', data);
      alert('No portal URL returned. Please try again.');
      if (btn) {
        btn.disabled = false;
        btn.textContent = oldText;
      }
    }
  } catch (error) {
    console.error('Portal error:', error);
    alert('Failed to open billing portal. Please try again.');
  }
};

// Render Company Management Screen
function renderCompanyManagementScreen() {
  return `
    <div style="max-width: 1200px; margin: 0 auto; padding: 2rem 1rem;">
      <!-- Header -->
      <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 2rem;">
        <div style="display: flex; align-items: center; gap: 1rem;">
          <button
            onclick="closeCompanyManagement()"
            style="
              background: transparent;
              border: none;
              color: #f59e0b;
              font-size: 1.5rem;
              cursor: pointer;
              padding: 0.5rem;
              display: flex;
              align-items: center;
            "
            onmouseover="this.style.opacity='0.7'"
            onmouseout="this.style.opacity='1'"
          >
            ←
          </button>
          <h1 style="margin: 0; font-size: 2rem; font-weight: 700; color: ${colors.text};">
            Company Management
          </h1>
        </div>
        <div style="display: flex; align-items: center; gap: 0.75rem;">
          ${currentCompany?.is_premium ? `
            <span style="
              background: #10b98122;
              color: #047857;
              padding: 0.5rem 0.75rem;
              border-radius: 0.5rem;
              font-weight: 600;
              font-size: 0.9375rem;
            ">Premium Active</span>
          ` : `
            <button
              onclick="startBillingUpgrade()"
              style="
                background: #10b981;
                color: white;
                border: none;
                padding: 0.75rem 1rem;
                border-radius: 0.5rem;
                font-weight: 700;
                cursor: pointer;
                font-size: 0.95rem;
                box-shadow: 0 10px 15px -3px rgba(16, 185, 129, 0.3);
              "
              onmouseover="this.style.background='#059669'"
              onmouseout="this.style.background='#10b981'"
              title="Upgrade to Premium"
            >
              Upgrade to Premium
            </button>
          `}
        </div>
      </div>

      <!-- Tabs -->
      <div style="
        display: flex;
        gap: 0.5rem;
        margin-bottom: 2rem;
        border-bottom: 2px solid ${colors.border};
      ">
        <button
          onclick="switchManagementTab('members')"
          style="
            background: ${managementTab === 'members' ? '#f59e0b' : 'transparent'};
            color: ${managementTab === 'members' ? 'white' : colors.textSecondary};
            border: none;
            padding: 0.75rem 1.5rem;
            border-radius: 0.5rem 0.5rem 0 0;
            font-size: 0.9375rem;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
            margin-bottom: -2px;
          "
          onmouseover="${managementTab !== 'members' ? `this.style.background='#f3f4f6'; this.style.color='${colors.text}'` : ''}"
          onmouseout="${managementTab !== 'members' ? `this.style.background='transparent'; this.style.color='${colors.textSecondary}'` : ''}"
        >
          Members
        </button>
        <button
          onclick="switchManagementTab('clients')"
          style="
            background: ${managementTab === 'clients' ? '#f59e0b' : 'transparent'};
            color: ${managementTab === 'clients' ? 'white' : colors.textSecondary};
            border: none;
            padding: 0.75rem 1.5rem;
            border-radius: 0.5rem 0.5rem 0 0;
            font-size: 0.9375rem;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
            margin-bottom: -2px;
          "
          onmouseover="${managementTab !== 'clients' ? `this.style.background='#f3f4f6'; this.style.color='${colors.text}'` : ''}"
          onmouseout="${managementTab !== 'clients' ? `this.style.background='transparent'; this.style.color='${colors.textSecondary}'` : ''}"
        >
          Contacts
        </button>
        <button
          onclick="switchManagementTab('services')"
          style="
            background: ${managementTab === 'services' ? '#f59e0b' : 'transparent'};
            color: ${managementTab === 'services' ? 'white' : colors.textSecondary};
            border: none;
            padding: 0.75rem 1.5rem;
            border-radius: 0.5rem 0.5rem 0 0;
            font-size: 0.9375rem;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
            margin-bottom: -2px;
          "
          onmouseover="${managementTab !== 'services' ? `this.style.background='#f3f4f6'; this.style.color='${colors.text}'` : ''}"
          onmouseout="${managementTab !== 'services' ? `this.style.background='transparent'; this.style.color='${colors.textSecondary}'` : ''}"
        >
          Services
        </button>
        ${currentProfile?.company_role === 'OWNER' ? `
        <button
          onclick="switchManagementTab('billing')"
          style="
            background: ${managementTab === 'billing' ? '#f59e0b' : 'transparent'};
            color: ${managementTab === 'billing' ? 'white' : colors.textSecondary};
            border: none;
            padding: 0.75rem 1.5rem;
            border-radius: 0.5rem 0.5rem 0 0;
            font-size: 0.9375rem;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
            margin-bottom: -2px;
          "
          onmouseover="${managementTab !== 'billing' ? `this.style.background='#f3f4f6'; this.style.color='${colors.text}'` : ''}"
          onmouseout="${managementTab !== 'billing' ? `this.style.background='transparent'; this.style.color='${colors.textSecondary}'` : ''}"
        >
          Billing
        </button>
        ` : ''}
      </div>

      <!-- Tab Content -->
      <div id="management-tab-content">
        ${managementTab === 'members' ? renderMembersTab() : ''}
        ${managementTab === 'clients' ? renderClientsTab() : ''}
        ${managementTab === 'services' ? renderServicesTab() : ''}
        ${managementTab === 'billing' && currentProfile?.company_role === 'OWNER' ? renderBillingTab() : ''}
      </div>
    </div>
    ${editingMemberId ? renderEditMemberModal() : ''}
  `;
}

// Render Members Tab
function renderMembersTab() {
  // Filter members based on search query
  const searchQuery = (window.memberSearchQuery || memberSearchQuery || '').trim();
  const filteredMembers = teamMembers.filter(member => {
    if (!searchQuery) return true;
    const query = searchQuery.toLowerCase();
    const fullName = `${member.first_name || ''} ${member.last_name || ''}`.toLowerCase();
    const phone = (member.phone || '').toLowerCase();
    return fullName.includes(query) || phone.includes(query);
  });

  return `
    <!-- Header with Search and Add Button -->
    <div style="display: flex; align-items: center; gap: 1rem; margin-bottom: 1.5rem;">
      <div style="flex: 1;">
        <input
          type="text"
          id="member-search-input"
          placeholder="Search members..."
          value="${window.memberSearchQuery || memberSearchQuery || ''}"
          oninput="
          const val = this.value;
          window.memberSearchQuery = val;
          memberSearchQuery = val;
          // Update only the members list, not the entire screen
          setTimeout(() => {
            const membersList = document.querySelector('#members-list');
            if (membersList) {
              membersList.innerHTML = window.getMembersListHTML();
            }
          }, 0);
        "
          style="
            width: 100%;
            padding: 0.75rem 1rem;
            border: 1px solid ${colors.border};
            border-radius: 0.5rem;
            font-size: 0.9375rem;
            box-sizing: border-box;
          "
          onfocus="this.style.borderColor='${colors.primary}'"
          onblur="this.style.borderColor='${colors.border}'"
        />
      </div>
      <button
        onclick="openAddMemberModal()"
        style="
          background: #f59e0b;
          color: white;
          border: none;
          padding: 0.75rem 1.5rem;
          border-radius: 0.5rem;
          font-size: 0.9375rem;
          font-weight: 600;
          cursor: pointer;
          white-space: nowrap;
          transition: all 0.2s;
        "
        onmouseover="this.style.background='#d97706'; this.style.transform='scale(1.05)'"
        onmouseout="this.style.background='#f59e0b'; this.style.transform='scale(1)'"
      >
        + Add Member
      </button>
    </div>

    <!-- Members List -->
    <div id="members-list" style="display: flex; flex-direction: column; gap: 1rem;">
      ${filteredMembers.length === 0 ? `
        <div style="
          text-align: center;
          padding: 3rem;
          color: ${colors.textSecondary};
        ">
          <div style="font-size: 3rem; margin-bottom: 1rem;">👥</div>
          <div style="font-size: 1.125rem; font-weight: 500; margin-bottom: 0.5rem;">
            ${searchQuery ? 'No members found' : 'No team members'}
          </div>
          <div style="font-size: 0.875rem;">
            ${searchQuery ? 'Try a different search term' : 'Add team members to get started'}
          </div>
        </div>
      ` : filteredMembers.map(member => {
    const initials = `${(member.first_name || '').charAt(0)}${(member.last_name || '').charAt(0)}`.toUpperCase() || 'U';
    const fullName = `${member.first_name || ''} ${member.last_name || ''}`.trim() || 'Unknown';
    const phone = member.phone || 'No phone number';
    const role = member.company_role || 'EMPLOYEE';

    // Role badge colors
    const roleColors = {
      'OWNER': { bg: '#f59e0b', text: 'white' },
      'MANAGER': { bg: '#3b82f6', text: 'white' },
      'EMPLOYEE': { bg: '#dc2626', text: 'white' }
    };
    const roleColor = roleColors[role] || roleColors['EMPLOYEE'];

    return `
          <div style="
            background: #ffffff;
            border: 1px solid ${colors.border};
            border-radius: 0.75rem;
            padding: 1.25rem;
            display: flex;
            align-items: center;
            gap: 1rem;
            box-shadow: 0 1px 3px rgba(0,0,0,0.1);
            transition: all 0.2s;
          "
          onmouseover="this.style.boxShadow='0 4px 6px rgba(0,0,0,0.15)'; this.style.transform='translateY(-2px)'"
          onmouseout="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.1)'; this.style.transform='translateY(0)'"
          >
            <!-- Avatar -->
            <div style="position: relative; flex-shrink: 0;">
              ${(() => {
        const avatarUrl = member.avatar_path ? getAvatarUrl(member.avatar_path) : null;
        const bgColor = getAvatarBackgroundColor(member.first_name || member.id || '');
        return `
                  ${avatarUrl ? `
                    <img
                      src="${avatarUrl}"
                      alt="${fullName}"
                      style="
                        width: 56px;
                        height: 56px;
                        border-radius: 50%;
                        object-fit: cover;
                        border: 3px solid ${roleColor.bg};
                        box-shadow: 0 0 0 1px rgba(0,0,0,0.1);
                      "
                      onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';"
                    />
                  ` : ''}
                  <div style="
                    ${avatarUrl ? 'display: none;' : 'display: flex;'}
                    width: 56px;
                    height: 56px;
                    border-radius: 50%;
                    background: ${bgColor};
                    color: white;
                    align-items: center;
                    justify-content: center;
                    font-weight: 700;
                    font-size: 1.25rem;
                    border: 3px solid ${roleColor.bg};
                    box-shadow: 0 0 0 1px rgba(0,0,0,0.1);
                  ">${initials}</div>
                `;
      })()}
            </div>
            
            <!-- Member Info -->
            <div style="flex: 1; min-width: 0;">
              <div style="
                font-size: 1.125rem;
                font-weight: 600;
                color: ${colors.text};
                margin-bottom: 0.5rem;
              ">
                ${fullName}
              </div>
              <div style="display: flex; align-items: center; gap: 0.75rem; flex-wrap: wrap;">
                <!-- Role Badge -->
                <span style="
                  background: ${roleColor.bg};
                  color: ${roleColor.text};
                  padding: 0.25rem 0.75rem;
                  border-radius: 1rem;
                  font-size: 0.75rem;
                  font-weight: 600;
                  text-transform: uppercase;
                ">
                  ${role}
                </span>
                <!-- Phone -->
                <div style="
                  display: flex;
                  align-items: center;
                  gap: 0.5rem;
                  color: ${colors.textSecondary};
                  font-size: 0.875rem;
                ">
                  <span class="material-icons" style="font-size: 1rem; vertical-align: middle;">phone</span>
                  <span>${phone}</span>
                </div>
              </div>
            </div>
            
            <!-- Edit Button -->
            <button
              onclick="openEditMemberModal('${member.id}')"
              style="
                background: #f59e0b;
                color: white;
                border: none;
                padding: 0.625rem 1.25rem;
                border-radius: 0.5rem;
                font-size: 0.875rem;
                font-weight: 600;
                cursor: pointer;
                display: flex;
                align-items: center;
                gap: 0.5rem;
                transition: all 0.2s;
              "
              onmouseover="this.style.background='#d97706'; this.style.transform='scale(1.05)'"
              onmouseout="this.style.background='#f59e0b'; this.style.transform='scale(1)'"
            >
              <span class="material-icons" style="font-size: 1rem;">edit</span>
              Edit Member
            </button>
          </div>
        `;
  }).join('')}
    </div>
    ${showAddMemberModal ? renderAddMemberModal() : ''}
  `;
}

// Helper function to render just the members list (for real-time filtering)
window.getMembersListHTML = function () {
  // Filter members based on search query
  const searchQuery = (window.memberSearchQuery || memberSearchQuery || '').trim();
  const filteredMembers = teamMembers.filter(member => {
    if (!searchQuery) return true;
    const query = searchQuery.toLowerCase();
    const fullName = `${member.first_name || ''} ${member.last_name || ''}`.toLowerCase();
    const phone = (member.phone || '').toLowerCase();
    return fullName.includes(query) || phone.includes(query);
  });

  if (filteredMembers.length === 0) {
    return `
      <div style="
        text-align: center;
        padding: 3rem;
        color: ${colors.textSecondary};
      ">
        <div style="font-size: 3rem; margin-bottom: 1rem;">👥</div>
        <div style="font-size: 1.125rem; font-weight: 500; margin-bottom: 0.5rem;">
          ${searchQuery ? 'No members found' : 'No team members'}
        </div>
        <div style="font-size: 0.875rem;">
          ${searchQuery ? 'Try a different search term' : 'Add team members to get started'}
        </div>
      </div>
    `;
  }

  return filteredMembers.map(member => {
    const initials = `${(member.first_name || '').charAt(0)}${(member.last_name || '').charAt(0)}`.toUpperCase() || 'U';
    const fullName = `${member.first_name || ''} ${member.last_name || ''}`.trim() || 'Unknown';
    const phone = member.phone || 'No phone number';
    const role = member.company_role || 'EMPLOYEE';

    // Role badge colors
    const roleColors = {
      'OWNER': { bg: '#f59e0b', text: 'white' },
      'MANAGER': { bg: '#3b82f6', text: 'white' },
      'EMPLOYEE': { bg: '#dc2626', text: 'white' }
    };
    const roleColor = roleColors[role] || roleColors['EMPLOYEE'];

    return `
      <div style="
        background: #ffffff;
        border: 1px solid ${colors.border};
        border-radius: 0.75rem;
        padding: 1.25rem;
        display: flex;
        align-items: center;
        gap: 1rem;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        transition: all 0.2s;
      "
      onmouseover="this.style.boxShadow='0 4px 6px rgba(0,0,0,0.15)'; this.style.transform='translateY(-2px)'"
      onmouseout="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.1)'; this.style.transform='translateY(0)'"
      >
        <!-- Avatar -->
        <div style="position: relative; flex-shrink: 0;">
          ${(() => {
        const avatarUrl = member.avatar_path ? getAvatarUrl(member.avatar_path) : null;
        const bgColor = getAvatarBackgroundColor(member.first_name || member.id || '');
        return `
              ${avatarUrl ? `
                <img
                  src="${avatarUrl}"
                  alt="${fullName}"
                  style="
                    width: 56px;
                    height: 56px;
                    border-radius: 50%;
                    object-fit: cover;
                    border: 3px solid ${roleColor.bg};
                    box-shadow: 0 0 0 1px rgba(0,0,0,0.1);
                  "
                  onerror="this.style.display='none'; this.nextElementSibling.style.display='flex';"
                />
              ` : ''}
              <div style="
                ${avatarUrl ? 'display: none;' : 'display: flex;'}
                width: 56px;
                height: 56px;
                border-radius: 50%;
                background: ${bgColor};
                color: white;
                align-items: center;
                justify-content: center;
                font-weight: 700;
                font-size: 1.25rem;
                border: 3px solid ${roleColor.bg};
                box-shadow: 0 0 0 1px rgba(0,0,0,0.1);
              ">${initials}</div>
            `;
      })()}
        </div>
        
        <!-- Member Info -->
        <div style="flex: 1; min-width: 0;">
          <div style="
            font-size: 1.125rem;
            font-weight: 600;
            color: ${colors.text};
            margin-bottom: 0.5rem;
          ">
            ${fullName}
          </div>
          <div style="display: flex; align-items: center; gap: 0.75rem; flex-wrap: wrap;">
            <!-- Role Badge -->
            <span style="
              background: ${roleColor.bg};
              color: ${roleColor.text};
              padding: 0.375rem 0.75rem;
              border-radius: 0.375rem;
              font-size: 0.8125rem;
              font-weight: 600;
              text-transform: uppercase;
            ">
              ${role}
            </span>
            
            <!-- Phone -->
            <div style="
              display: flex;
              align-items: center;
              gap: 0.5rem;
              color: ${colors.textSecondary};
              font-size: 0.875rem;
            ">
              <span class="material-icons" style="font-size: 1rem; vertical-align: middle;">phone</span>
              <span>${phone}</span>
            </div>
          </div>
        </div>
        
        <!-- Edit Button -->
        <button
          onclick="openEditMemberModal('${member.id}')"
          style="
            background: #f59e0b;
            color: white;
            border: none;
            padding: 0.625rem 1.25rem;
            border-radius: 0.5rem;
            font-size: 0.875rem;
            font-weight: 600;
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#d97706'; this.style.transform='scale(1.05)'"
          onmouseout="this.style.background='#f59e0b'; this.style.transform='scale(1)'"
        >
          ✏️ Edit Member
        </button>
      </div>
    `;
  }).join('');
};

// Render Add Member Modal
function renderAddMemberModal() {
  // Ensure Material Icons are loaded
  if (!document.querySelector('link[href*="Material+Icons"]')) {
    const materialIconsLink = document.createElement('link');
    materialIconsLink.rel = 'stylesheet';
    materialIconsLink.href = 'https://fonts.googleapis.com/icon?family=Material+Icons';
    document.head.appendChild(materialIconsLink);
  }

  return `
    <style>
      @keyframes shake {
        0%, 100% { transform: translateX(0); }
        10%, 30%, 50%, 70%, 90% { transform: translateX(-10px); }
        20%, 40%, 60%, 80% { transform: translateX(10px); }
      }
    </style>
    <div
      id="add-member-modal-overlay"
      onclick="if (event.target.id === 'add-member-modal-overlay') closeAddMemberModal()"
      style="
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.6);
        z-index: 10000;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 1rem;
      "
    >
      <div
        onclick="event.stopPropagation()"
        style="
          background: #ffffff;
          border-radius: 1rem;
          width: 100%;
          max-width: 500px;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
        "
      >
        <!-- Header -->
        <div style="
          padding: 1.5rem;
          border-bottom: 1px solid ${colors.border};
          display: flex;
          justify-content: space-between;
          align-items: center;
        ">
          <h2 style="
            margin: 0;
            font-size: 1.5rem;
            font-weight: 700;
            color: ${colors.text};
          ">Create New User</h2>
          <button
            onclick="closeAddMemberModal()"
            style="
              background: transparent;
              border: none;
              color: ${colors.textSecondary};
              cursor: pointer;
              font-size: 1.5rem;
              padding: 0;
              width: 32px;
              height: 32px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 50%;
            "
            onmouseover="this.style.background='#f3f4f6'"
            onmouseout="this.style.background='transparent'"
          >
            ×
          </button>
        </div>

        <!-- Form -->
        <form
          id="create-user-form"
          onsubmit="createNewUser(event); return false;"
          style="padding: 1.5rem; display: flex; flex-direction: column; gap: 1.5rem;"
        >
          <!-- Error Message -->
          <div id="create-user-error-message" style="
            display: none;
            padding: 1rem;
            background: #FEE2E2;
            border: 2px solid #EF4444;
            border-radius: 0.5rem;
            color: #991B1B;
            font-size: 0.9375rem;
            font-weight: 600;
            margin-bottom: 0.5rem;
            text-align: center;
          ">
            <div style="display: flex; align-items: center; justify-content: center; gap: 0.5rem;">
              <span class="material-icons" style="font-size: 1.25rem;">error</span>
              <span id="create-user-error-text"></span>
            </div>
          </div>
          
          <!-- First Name -->
          <div>
            <label style="
              display: block;
              font-size: 0.875rem;
              font-weight: 600;
              color: ${colors.text};
              margin-bottom: 0.5rem;
            ">
              First Name *
            </label>
            <input
              type="text"
              id="new-member-first-name"
              placeholder="Enter first name"
              required
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-size: 0.9375rem;
                box-sizing: border-box;
              "
              onfocus="this.style.borderColor='${colors.primary}'"
              onblur="this.style.borderColor='${colors.border}'"
            />
          </div>

          <!-- Last Name -->
          <div>
            <label style="
              display: block;
              font-size: 0.875rem;
              font-weight: 600;
              color: ${colors.text};
              margin-bottom: 0.5rem;
            ">
              Last Name *
            </label>
            <input
              type="text"
              id="new-member-last-name"
              placeholder="Enter last name"
              required
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-size: 0.9375rem;
                box-sizing: border-box;
              "
              onfocus="this.style.borderColor='${colors.primary}'"
              onblur="this.style.borderColor='${colors.border}'"
            />
          </div>

          <!-- Email -->
          <div>
            <label style="
              display: block;
              font-size: 0.875rem;
              font-weight: 600;
              color: ${colors.text};
              margin-bottom: 0.5rem;
            ">
              Email Address *
            </label>
            <input
              type="email"
              id="new-member-email"
              placeholder="Enter email address"
              required
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-size: 0.9375rem;
                box-sizing: border-box;
              "
              onfocus="this.style.borderColor='${colors.primary}'; this.style.borderWidth='1px'; window.hideCreateUserError();"
              onblur="checkEmailExists(this.value); this.style.borderColor='${colors.border}'; this.style.borderWidth='1px';"
              oninput="if (this.value.trim()) { window.hideCreateUserError(); this.style.borderColor='${colors.primary}'; this.style.borderWidth='1px'; }"
            />
            <div id="email-exists-message" style="
              display: none;
              margin-top: 0.5rem;
              padding: 0.75rem;
              background: #FEF3C7;
              border: 1px solid #F59E0B;
              border-radius: 0.5rem;
              color: #92400E;
              font-size: 0.875rem;
            "></div>
          </div>

          <!-- Phone -->
          <div>
            <label style="
              display: block;
              font-size: 0.875rem;
              font-weight: 600;
              color: ${colors.text};
              margin-bottom: 0.5rem;
            ">
              Phone Number
            </label>
            <input
              type="tel"
              id="new-member-phone"
              placeholder="Enter phone number (optional)"
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-size: 0.9375rem;
                box-sizing: border-box;
              "
              onfocus="this.style.borderColor='${colors.primary}'"
              onblur="this.style.borderColor='${colors.border}'"
            />
          </div>

          <!-- Role Selection -->
          <div>
            <label style="
              display: block;
              font-size: 0.875rem;
              font-weight: 600;
              color: ${colors.text};
              margin-bottom: 0.75rem;
            ">
              Role *
            </label>
            <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 0.75rem;">
              ${['Employee', 'Manager', 'Owner'].map(role => {
    const roleValue = role.toUpperCase();
    const roleColors = {
      'OWNER': { bg: '#f59e0b', text: 'white' },
      'MANAGER': { bg: '#3b82f6', text: 'white' },
      'EMPLOYEE': { bg: '#dc2626', text: 'white' }
    };
    const roleColor = roleColors[roleValue] || roleColors['EMPLOYEE'];
    const isDefault = role === 'Employee';

    return `
                  <label style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 0.5rem;
                    padding: 0.875rem;
                    border: 2px solid ${isDefault ? roleColor.bg : colors.border};
                    border-radius: 0.5rem;
                    background: ${isDefault ? roleColor.bg : 'transparent'};
                    cursor: pointer;
                    transition: all 0.2s;
                    font-weight: 600;
                    color: ${isDefault ? roleColor.text : colors.text};
                  "
                  onmouseover="if (!this.querySelector('input').checked) { this.style.borderColor='${roleColor.bg}'; this.style.background='${roleColor.bg}15'; }"
                  onmouseout="if (!this.querySelector('input').checked) { this.style.borderColor='${colors.border}'; this.style.background='transparent'; this.style.color='${colors.text}'; }"
                  >
                    <input
                      type="radio"
                      name="new-member-role"
                      value="${roleValue}"
                      ${isDefault ? 'checked' : ''}
                      style="
                        width: 18px;
                        height: 18px;
                        cursor: pointer;
                      "
                      onchange="updateRoleSelection(this)"
                    />
                    <span>${role}</span>
                  </label>
                `;
  }).join('')}
            </div>
          </div>

          <!-- Password -->
          <div>
            <label style="
              display: block;
              font-size: 0.875rem;
              font-weight: 600;
              color: ${colors.text};
              margin-bottom: 0.5rem;
            ">
              Password *
            </label>
            <input
              type="password"
              id="new-member-password"
              placeholder="Enter password for new user"
              required
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-size: 0.9375rem;
                box-sizing: border-box;
              "
              onfocus="this.style.borderColor='${colors.primary}'"
              onblur="this.style.borderColor='${colors.border}'"
            />
            <p style="
              margin: 0.5rem 0 0 0;
              font-size: 0.75rem;
              color: ${colors.textSecondary};
            ">This will be their initial login password</p>
          </div>

          <!-- Actions -->
          <div style="
            display: flex;
            gap: 0.75rem;
            justify-content: flex-end;
            margin-top: 1rem;
            padding-top: 1.5rem;
            border-top: 1px solid ${colors.border};
          ">
            <button
              type="button"
              onclick="closeAddMemberModal()"
              style="
                background: #f3f4f6;
                color: ${colors.text};
                border: none;
                padding: 0.75rem 1.5rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-weight: 600;
                font-size: 0.9375rem;
              "
              onmouseover="this.style.background='#e5e7eb'"
              onmouseout="this.style.background='#f3f4f6'"
            >
              Cancel
            </button>
            <button
              type="submit"
              id="create-user-btn"
              style="
                background: #f59e0b;
                color: white;
                border: none;
                padding: 0.75rem 1.5rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-weight: 600;
                font-size: 0.9375rem;
                transition: all 0.2s ease;
              "
              onmouseover="if (!this.disabled) this.style.background='#d97706'"
              onmouseout="if (!this.disabled) this.style.background='#f59e0b'"
            >
              Create User
            </button>
          </div>
        </form>
      </div>
    </div>
  `;
}

// Update role selection visual state
window.updateRoleSelection = function (selectedInput) {
  // Find all role radio inputs
  const allInputs = document.querySelectorAll('input[name="new-member-role"]');
  const roleColors = {
    'OWNER': { bg: '#f59e0b', text: 'white' },
    'MANAGER': { bg: '#3b82f6', text: 'white' },
    'EMPLOYEE': { bg: '#dc2626', text: 'white' }
  };

  allInputs.forEach(input => {
    const label = input.closest('label');
    if (!label) return;

    const roleVal = input.value;
    const roleCol = roleColors[roleVal] || roleColors['EMPLOYEE'];

    if (input.checked) {
      label.style.borderColor = roleCol.bg;
      label.style.background = roleCol.bg;
      label.style.color = roleCol.text;
    } else {
      label.style.borderColor = '#E5E7EB';
      label.style.background = 'transparent';
      label.style.color = '#0F172A';
    }
  });
};

// Helper function to show form error with shake animation
window.showCreateUserError = function (message) {
  const errorDiv = document.getElementById('create-user-error-message');
  const errorText = document.getElementById('create-user-error-text');
  const form = document.getElementById('create-user-form');

  if (errorDiv && errorText) {
    errorText.textContent = message;
    errorDiv.style.display = 'block';

    // Add shake animation to form
    if (form) {
      // Remove any existing shake class
      form.style.animation = 'none';
      // Trigger reflow
      void form.offsetWidth;
      // Add shake animation
      form.style.animation = 'shake 0.5s ease-in-out';
    }

    // Scroll to error message
    errorDiv.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

    // Remove shake animation after it completes
    if (form) {
      setTimeout(() => {
        form.style.animation = '';
      }, 500);
    }
  }
};

// Hide form error message
window.hideCreateUserError = function () {
  const errorDiv = document.getElementById('create-user-error-message');
  if (errorDiv) {
    errorDiv.style.display = 'none';
  }
};

// Create new user function
// Check if email already exists in the database
window.checkEmailExists = async function (email) {
  const messageDiv = document.getElementById('email-exists-message');
  const emailInput = document.getElementById('new-member-email');

  if (!email || !email.trim()) {
    if (messageDiv) {
      messageDiv.style.display = 'none';
    }
    if (emailInput) {
      emailInput.style.borderColor = colors.border;
    }
    return;
  }

  // Basic email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email.trim())) {
    if (messageDiv) {
      messageDiv.style.display = 'none';
    }
    return;
  }

  try {
    // Check if email exists in profiles table
    const { data, error } = await supabase
      .from('profiles')
      .select('id, email')
      .eq('email', email.trim().toLowerCase())
      .maybeSingle();

    if (error && error.code !== 'PGRST116') {
      // PGRST116 is "not found" which is fine
      console.error('Error checking email:', error);
      return;
    }

    if (data) {
      // Email exists - show warning message
      if (messageDiv) {
        messageDiv.innerHTML = '<span class="material-icons" style="font-size: 1rem; vertical-align: middle; margin-right: 0.25rem;">warning</span>A user with that email already exists. If you feel this is an error, contact support.';
        messageDiv.style.display = 'block';
      }
      if (emailInput) {
        emailInput.style.borderColor = '#F59E0B';
      }
    } else {
      // Email doesn't exist - hide message
      if (messageDiv) {
        messageDiv.style.display = 'none';
      }
      if (emailInput) {
        emailInput.style.borderColor = colors.border;
      }
    }
  } catch (error) {
    console.error('Error checking email existence:', error);
  }
};

window.createNewUser = async function (event) {
  event.preventDefault();

  if (!currentCompany) {
    showNotification('No company selected', 'error');
    return;
  }

  const firstNameInput = document.getElementById('new-member-first-name');
  const lastNameInput = document.getElementById('new-member-last-name');
  const emailInput = document.getElementById('new-member-email');
  const phoneInput = document.getElementById('new-member-phone');
  const passwordInput = document.getElementById('new-member-password');
  const roleInputs = document.querySelectorAll('input[name="new-member-role"]:checked');

  if (!firstNameInput || !lastNameInput || !emailInput || !passwordInput) {
    showNotification('Form fields not found', 'error');
    return;
  }

  const firstName = firstNameInput.value.trim();
  const lastName = lastNameInput.value.trim();
  const email = emailInput.value.trim();
  const phone = phoneInput.value.trim();
  const password = passwordInput.value;
  const role = roleInputs.length > 0 ? roleInputs[0].value : 'EMPLOYEE';

  if (!firstName || !lastName || !email || !password) {
    showNotification('Please fill in all required fields', 'error');
    return;
  }

  if (password.length < 6) {
    showNotification('Password must be at least 6 characters long', 'error');
    return;
  }

  // Get the submit button and set loading state
  const submitBtn = document.getElementById('create-user-btn');
  const originalText = submitBtn ? submitBtn.textContent : 'Create User';

  if (submitBtn) {
    submitBtn.disabled = true;
    submitBtn.textContent = 'Creating...';
    submitBtn.style.background = '#9ca3af';
    submitBtn.style.cursor = 'not-allowed';
    submitBtn.style.opacity = '0.7';
  }

  try {
    // IMPORTANT: Using Edge Function, NOT admin API
    // Prepare data for Edge Function (matching native app pattern)
    const requestData = {
      email: email.trim().toLowerCase(),
      password: password,
      first_name: firstName.trim(),
      last_name: lastName.trim(),
      phone: phone?.trim() || null,
      profile_role: 'USER', // Profile role is always USER
      company_role: role, // Company role (EMPLOYEE, MANAGER, or OWNER)
      company_id: currentCompany.id
    };

    console.log('🚀 [WEB] Calling create-user Edge Function (NOT admin API) with data:', {
      ...requestData,
      password: '***' // Don't log password
    });

    // Call Edge Function - this is the correct way (same as native app)
    const { data, error } = await supabase.functions.invoke('create-user', {
      body: requestData
    });

    console.log('📡 Edge Function response:', { data, error });

    if (error) {
      console.error('❌ Edge Function error:', error);

      // Check if error is due to email already existing
      const errorMessage = error.message || error.toString() || '';
      const errorMessageLower = errorMessage.toLowerCase();
      const isEmailExistsError =
        errorMessageLower.includes('email') &&
        (errorMessageLower.includes('already') ||
          errorMessageLower.includes('exists') ||
          errorMessageLower.includes('duplicate') ||
          errorMessageLower.includes('unique') ||
          errorMessageLower.includes('violates'));

      const userFriendlyMessage = isEmailExistsError
        ? 'A user with this email address already exists. Please use a different email address.'
        : 'Unable to create user. Please check the information and try again, or verify the user doesn\'t already exist with that email.';

      // Show error in form with shake animation
      window.showCreateUserError(userFriendlyMessage);

      // Also highlight email field (always highlight for any error since email is likely the issue)
      if (emailInput) {
        emailInput.style.borderColor = '#EF4444';
        emailInput.style.borderWidth = '2px';
      }

      // Only show notification for non-email errors, or show a generic message for email errors
      if (isEmailExistsError) {
        showNotification('Please check the form for details', 'info');
      } else {
        showNotification(userFriendlyMessage, 'error');
      }
      // Re-enable button on error
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
        submitBtn.style.background = '#f59e0b';
        submitBtn.style.cursor = 'pointer';
        submitBtn.style.opacity = '1';
      }
      return;
    }

    if (!data || !data.success) {
      console.error('❌ User creation failed:', data?.error);

      // Check if error is due to email already existing
      const errorMessage = data?.error || 'Failed to create user';
      const errorMessageLower = errorMessage.toLowerCase();
      const isEmailExistsError =
        errorMessageLower.includes('email') &&
        (errorMessageLower.includes('already') ||
          errorMessageLower.includes('exists') ||
          errorMessageLower.includes('duplicate') ||
          errorMessageLower.includes('unique') ||
          errorMessageLower.includes('violates'));

      const userFriendlyMessage = isEmailExistsError
        ? 'A user with this email address already exists. Please use a different email address.'
        : 'Unable to create user. Please check the information and try again, or verify the user doesn\'t already exist with that email.';

      // Show error in form with shake animation
      window.showCreateUserError(userFriendlyMessage);

      // Also highlight email field (always highlight for any error since email is likely the issue)
      if (emailInput) {
        emailInput.style.borderColor = '#EF4444';
        emailInput.style.borderWidth = '2px';
      }

      // Only show notification for non-email errors, or show a generic message for email errors
      if (isEmailExistsError) {
        showNotification('Please check the form for details', 'info');
      } else {
        showNotification(userFriendlyMessage, 'error');
      }
      // Re-enable button on error
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
        submitBtn.style.background = '#f59e0b';
        submitBtn.style.cursor = 'pointer';
        submitBtn.style.opacity = '1';
      }
      return;
    }

    // Reload team members
    await loadTeamMembers();

    // Close modal
    closeAddMemberModal();

    // Clear form
    if (firstNameInput) firstNameInput.value = '';
    if (lastNameInput) lastNameInput.value = '';
    if (emailInput) emailInput.value = '';
    if (phoneInput) phoneInput.value = '';
    if (passwordInput) passwordInput.value = '';

    // Clear email exists message
    const messageDiv = document.getElementById('email-exists-message');
    if (messageDiv) {
      messageDiv.style.display = 'none';
    }

    // Hide form error message
    window.hideCreateUserError();

    // Show success notification (custom notification, not browser alert)
    showNotification('New user created', 'success');

    // Re-enable button on success (form will be cleared and modal closed)
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = originalText;
      submitBtn.style.background = '#f59e0b';
      submitBtn.style.cursor = 'pointer';
      submitBtn.style.opacity = '1';
    }
  } catch (error) {
    console.error('❌ Error creating new user:', error);

    // Check if error is due to email already existing
    const errorMessage = error.message || error.toString() || '';
    const errorMessageLower = errorMessage.toLowerCase();
    const isEmailExistsError =
      errorMessageLower.includes('email') &&
      (errorMessageLower.includes('already') ||
        errorMessageLower.includes('exists') ||
        errorMessageLower.includes('duplicate') ||
        errorMessageLower.includes('unique') ||
        errorMessageLower.includes('violates'));

    const userFriendlyMessage = isEmailExistsError
      ? 'A user with this email address already exists. Please use a different email address.'
      : 'Unable to create user. Please check the information and try again, or verify the user doesn\'t already exist with that email.';

    // Show error in form with shake animation
    window.showCreateUserError(userFriendlyMessage);

    // Also highlight email field (always highlight for any error since email is likely the issue)
    if (emailInput) {
      emailInput.style.borderColor = '#EF4444';
      emailInput.style.borderWidth = '2px';
    }

    // Only show notification for non-email errors, or show a generic message for email errors
    if (isEmailExistsError) {
      showNotification('Please check the form for details', 'info');
    } else {
      showNotification(userFriendlyMessage, 'error');
    }

    // Re-enable button on error
    if (submitBtn) {
      submitBtn.disabled = false;
      submitBtn.textContent = originalText;
      submitBtn.style.background = '#f59e0b';
      submitBtn.style.cursor = 'pointer';
      submitBtn.style.opacity = '1';
    }
  }
};

// Render Clients Tab
function renderClientsTab() {
  // Get list of client profile IDs (users with CLIENT role in company_members for this company)
  // clients array is loaded from company_members where role = 'CLIENT' and company_id = currentCompany.id
  const clientProfileIds = new Set(clients.map(c => c.id));
  console.log('👥 [Clients Tab] Client profile IDs for company:', currentCompany?.id, Array.from(clientProfileIds));
  console.log('👥 [Clients Tab] Total clients loaded:', clients.length);

  // Filter contacts based on search query (case-insensitive, real-time, fluid)
  const searchQuery = (window.clientSearchQuery || clientSearchQuery || '').trim();

  const filteredContacts = contacts.filter(contact => {
    if (!searchQuery) {
      return true;
    }

    const query = searchQuery.toLowerCase();
    const firstName = (contact.first_name || '').toLowerCase();
    const lastName = (contact.last_name || '').toLowerCase();
    const fullName = `${firstName} ${lastName}`.trim();
    const email = (contact.email || '').toLowerCase();
    const company = (contact.company || '').toLowerCase();

    // Check if query matches any part of name (first, last, or full), email, or company
    const matches = fullName.includes(query) ||
      firstName.includes(query) ||
      lastName.includes(query) ||
      email.includes(query) ||
      company.includes(query);

    return matches;
  });

  console.log('🔍 [Clients Tab] Filtered contacts count:', filteredContacts.length);

  return `
    <!-- Header -->
    <div style="margin-bottom: 1.5rem;">
      <h2 style="
        margin: 0 0 1rem 0;
        font-size: 1.5rem;
        font-weight: 700;
        color: ${colors.text};
      ">Clients</h2>
      <p style="
        margin: 0 0 1.5rem 0;
        color: ${colors.textSecondary};
        font-size: 0.9375rem;
      ">Convert contacts to client accounts so they can log in and access their projects</p>
    </div>

    <!-- Search Bar -->
    <div style="margin-bottom: 1.5rem;">
      <input
        type="text"
        id="client-search-input"
        placeholder="Search contacts by name, email, or company..."
        value="${window.clientSearchQuery || clientSearchQuery || ''}"
        oninput="
          const val = this.value;
          window.clientSearchQuery = val;
          clientSearchQuery = val;
          // Update only the contacts list using setTimeout to preserve input focus
          setTimeout(() => {
            const contactsList = document.querySelector('#clients-contacts-list');
            if (contactsList) {
              contactsList.innerHTML = window.getClientsContactsListHTML();
            }
          }, 0);
        "
        style="
          width: 100%;
          padding: 0.75rem 1rem;
          border: 1px solid ${colors.border};
          border-radius: 0.5rem;
          font-size: 0.9375rem;
          box-sizing: border-box;
        "
        onfocus="this.style.borderColor='${colors.primary}'"
        onblur="this.style.borderColor='${colors.border}'"
      />
    </div>

    <!-- Contacts List -->
    <div id="clients-contacts-list" style="display: flex; flex-direction: column; gap: 1rem;">
      ${filteredContacts.length === 0 ? `
        <div style="
          text-align: center;
          padding: 3rem;
          color: ${colors.textSecondary};
        ">
          <div style="font-size: 3rem; margin-bottom: 1rem;">👥</div>
          <div style="font-size: 1.125rem; font-weight: 500; margin-bottom: 0.5rem;">
            ${clientSearchQuery ? 'No contacts found' : 'No contacts'}
          </div>
          <div style="font-size: 0.875rem;">
            ${clientSearchQuery ? 'Try a different search term' : 'Add contacts to get started'}
          </div>
        </div>
      ` : filteredContacts.map(contact => {
    const fullName = `${contact.first_name || ''} ${contact.last_name || ''}`.trim() || 'Unknown';
    const email = contact.email || 'No email';
    const company = contact.company || 'No company';
    const phone = contact.phone ? formatPhoneForDisplay(contact.phone) : 'No phone';

    // Check if contact is a client: their profile_id must have role='CLIENT' in company_members for this company
    // contact_profile_id comes from the RPC function (get_sales_contacts) and represents the profile_id
    const contactProfileId = contact.contact_profile_id || contact.profile_id || null;

    // Check if this contact's profile_id is in the list of clients (users with CLIENT role in company_members)
    const isClient = contactProfileId ? clientProfileIds.has(contactProfileId) : false;

    console.log(`🔍 [Clients Tab] Contact ${fullName}: profile_id=${contactProfileId}, isClient=${isClient}, clientProfileIds has it: ${contactProfileId ? clientProfileIds.has(contactProfileId) : 'N/A'}`);

    const initials = `${(contact.first_name || '').charAt(0)}${(contact.last_name || '').charAt(0)}`.toUpperCase() || 'U';

    return `
          <div style="
            background: #ffffff;
            border: 1px solid ${colors.border};
            border-radius: 0.75rem;
            padding: 1.25rem;
            display: flex;
            align-items: center;
            gap: 1rem;
            box-shadow: 0 1px 3px rgba(0,0,0,0.1);
            transition: all 0.2s;
          "
          onmouseover="this.style.boxShadow='0 4px 6px rgba(0,0,0,0.15)'; this.style.transform='translateY(-2px)'"
          onmouseout="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.1)'; this.style.transform='translateY(0)'"
          >
            <!-- Avatar -->
            <div style="
              width: 56px;
              height: 56px;
              border-radius: 50%;
              background: ${isClient ? '#ef4444' : '#6b7280'};
              color: white;
              display: flex;
              align-items: center;
              justify-content: center;
              font-weight: 700;
              font-size: 1.25rem;
              flex-shrink: 0;
            ">
              ${initials}
            </div>
            
            <!-- Contact Info -->
            <div style="flex: 1; min-width: 0;">
              <div style="
                font-size: 1.125rem;
                font-weight: 600;
                color: ${colors.text};
                margin-bottom: 0.5rem;
              ">
                ${fullName}
              </div>
              <div style="display: flex; flex-direction: column; gap: 0.25rem;">
                <div style="
                  font-size: 0.875rem;
                  color: ${colors.textSecondary};
                  display: flex;
                  align-items: center;
                  gap: 0.5rem;
                ">
                  <span class="material-icons" style="font-size: 1rem; vertical-align: middle;">email</span>
                  <span>${email}</span>
                </div>
                ${phone !== 'No phone' ? `
                  <div style="
                    font-size: 0.875rem;
                    color: ${colors.textSecondary};
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                  ">
                    <span class="material-icons" style="font-size: 1rem; vertical-align: middle;">phone</span>
                    <span>${phone}</span>
                  </div>
                ` : ''}
                <div style="
                  font-size: 0.875rem;
                  color: ${colors.textSecondary};
                  display: flex;
                  align-items: center;
                  gap: 0.5rem;
                ">
                  <span class="material-icons" style="font-size: 1rem; vertical-align: middle;">business</span>
                  <span>${company}</span>
                </div>
              </div>
            </div>
            
            <!-- Client Status / Action -->
            <div style="display: flex; align-items: center; gap: 0.5rem;">
              ${isClient ? `
                <span style="
                  background: #ef4444;
                  color: white;
                  padding: 0.5rem 1rem;
                  border-radius: 0.5rem;
                  font-size: 0.875rem;
                  font-weight: 600;
                ">
                  Client
                </span>
                ${contactProfileId ? `
                  <button
                    onclick="openUpgradeCompanyModal('${contact.id}', '${contactProfileId}')"
                    style="
                      background: #10b981;
                      color: white;
                      border: none;
                      padding: 0.5rem 1rem;
                      border-radius: 0.5rem;
                      font-size: 0.875rem;
                      font-weight: 600;
                      cursor: pointer;
                      transition: all 0.2s;
                    "
                    onmouseover="this.style.background='#059669'; this.style.transform='scale(1.05)'"
                    onmouseout="this.style.background='#10b981'; this.style.transform='scale(1)'"
                  >
                    Upgrade to Company Owner
                  </button>
                ` : ''}
              ` : (contact.contact_profile_id || contact.profile_id) ? '' : `
                <button
                  onclick="openAddClientModal('${contact.id}')"
                  style="
                    background: #f59e0b;
                    color: white;
                    border: none;
                    padding: 0.5rem 1rem;
                    border-radius: 0.5rem;
                    font-size: 0.875rem;
                    font-weight: 600;
                    cursor: pointer;
                    transition: all 0.2s;
                  "
                  onmouseover="this.style.background='#d97706'; this.style.transform='scale(1.05)'"
                  onmouseout="this.style.background='#f59e0b'; this.style.transform='scale(1)'"
                >
                  Add as Client
                </button>
              `}
            </div>
          </div>
        `;
  }).join('')}
    </div>
    ${showAddClientModal ? renderAddClientModal() : ''}
    ${showUpgradeCompanyModal ? renderUpgradeCompanyModal() : ''}
  `;
}

// Helper function to render just the clients contacts list (for real-time filtering)
window.getClientsContactsListHTML = function () {
  // Get list of client profile IDs
  const clientProfileIds = new Set(clients.map(c => c.id));

  // Filter contacts based on search query
  const searchQuery = (window.clientSearchQuery || clientSearchQuery || '').trim();

  const filteredContacts = contacts.filter(contact => {
    if (!searchQuery) {
      return true;
    }

    const query = searchQuery.toLowerCase();
    const firstName = (contact.first_name || '').toLowerCase();
    const lastName = (contact.last_name || '').toLowerCase();
    const fullName = `${firstName} ${lastName}`.trim();
    const email = (contact.email || '').toLowerCase();
    const company = (contact.company || '').toLowerCase();

    return fullName.includes(query) ||
      firstName.includes(query) ||
      lastName.includes(query) ||
      email.includes(query) ||
      company.includes(query);
  });

  if (filteredContacts.length === 0) {
    return `
      <div style="
        text-align: center;
        padding: 3rem;
        color: ${colors.textSecondary};
      ">
        <div style="font-size: 3rem; margin-bottom: 1rem;">👥</div>
        <div style="font-size: 1.125rem; font-weight: 500; margin-bottom: 0.5rem;">
          ${searchQuery ? 'No contacts found' : 'No contacts'}
        </div>
        <div style="font-size: 0.875rem;">
          ${searchQuery ? 'Try a different search term' : 'Add contacts to get started'}
        </div>
      </div>
    `;
  }

  return filteredContacts.map(contact => {
    const fullName = `${contact.first_name || ''} ${contact.last_name || ''}`.trim() || 'Unknown';
    const email = contact.email || 'No email';
    const company = contact.company || 'No company';
    const phone = contact.phone ? formatPhoneForDisplay(contact.phone) : 'No phone';
    const contactProfileId = contact.contact_profile_id || contact.profile_id || null;
    const isClient = contactProfileId ? clientProfileIds.has(contactProfileId) : false;
    const initials = `${(contact.first_name || '').charAt(0)}${(contact.last_name || '').charAt(0)}`.toUpperCase() || 'U';

    return `
      <div style="
        background: #ffffff;
        border: 1px solid ${colors.border};
        border-radius: 0.75rem;
        padding: 1.25rem;
        display: flex;
        align-items: center;
        gap: 1rem;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        transition: all 0.2s;
      "
      onmouseover="this.style.boxShadow='0 4px 6px rgba(0,0,0,0.15)'; this.style.transform='translateY(-2px)'"
      onmouseout="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.1)'; this.style.transform='translateY(0)'"
      >
        <!-- Avatar -->
        <div style="
          width: 56px;
          height: 56px;
          border-radius: 50%;
          background: ${isClient ? '#ef4444' : '#6b7280'};
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          font-size: 1.25rem;
          flex-shrink: 0;
        ">
          ${initials}
        </div>
        
        <!-- Contact Info -->
        <div style="flex: 1; min-width: 0;">
          <div style="
            font-size: 1.125rem;
            font-weight: 600;
            color: ${colors.text};
            margin-bottom: 0.5rem;
          ">
            ${fullName}
          </div>
          <div style="display: flex; flex-direction: column; gap: 0.25rem;">
            <div style="
              font-size: 0.875rem;
              color: ${colors.textSecondary};
              display: flex;
              align-items: center;
              gap: 0.5rem;
            ">
              <span>📧</span>
              <span>${email}</span>
            </div>
            ${phone !== 'No phone' ? `
              <div style="
                font-size: 0.875rem;
                color: ${colors.textSecondary};
                display: flex;
                align-items: center;
                gap: 0.5rem;
              ">
                <span class="material-icons" style="font-size: 1rem; vertical-align: middle;">phone</span>
                <span>${phone}</span>
              </div>
            ` : ''}
            <div style="
              font-size: 0.875rem;
              color: ${colors.textSecondary};
              display: flex;
              align-items: center;
              gap: 0.5rem;
            ">
              <span class="material-icons" style="font-size: 1rem; vertical-align: middle;">business</span>
              <span>${company}</span>
            </div>
          </div>
        </div>
        
        <!-- Client Status / Action -->
        <div style="display: flex; align-items: center;">
          ${isClient ? `
            <span style="
              background: #10b981;
              color: white;
              padding: 0.5rem 1rem;
              border-radius: 0.5rem;
              font-size: 0.875rem;
              font-weight: 600;
            ">
              Client
            </span>
          ` : (contact.contact_profile_id || contact.profile_id) ? '' : `
            <button
              onclick="openAddClientModal('${contact.id}')"
              style="
                background: #f59e0b;
                color: white;
                border: none;
                padding: 0.5rem 1rem;
                border-radius: 0.5rem;
                font-size: 0.875rem;
                font-weight: 600;
                cursor: pointer;
                transition: all 0.2s;
              "
              onmouseover="this.style.background='#d97706'; this.style.transform='scale(1.05)'"
              onmouseout="this.style.background='#f59e0b'; this.style.transform='scale(1)'"
            >
              Add as Client
            </button>
          `}
        </div>
      </div>
    `;
  }).join('');
};

// Client Management Functions
window.openAddClientModal = async function (contactId) {
  const contact = (window.contacts || []).find(c => c.id === contactId);
  if (!contact) return;
  const email = (contact.email || '').trim().toLowerCase();
  if (email) {
    try {
      const { data: isBlocked, error } = await supabase.rpc('is_email_member_or_owner', { p_email: email });
      if (!error && isBlocked === true) {
        showNotification('This contact\'s email is already associated with a company member or owner and cannot be made a client.', 'error');
        return;
      }
    } catch (e) {
      console.warn('is_email_member_or_owner check failed:', e);
    }
  }

  addingClientContactId = contactId;
  showAddClientModal = true;

  // Inject modal directly instead of re-rendering entire page
  const existingModal = document.getElementById('add-client-modal-overlay');
  if (existingModal) {
    existingModal.remove();
  }

  const modalHTML = renderAddClientModal();
  if (modalHTML) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = modalHTML;
    const modalElement = tempDiv.firstElementChild;

    document.body.appendChild(modalElement);

    // Animate in
    setTimeout(() => {
      if (modalElement) {
        modalElement.style.opacity = '1';
      }
    }, 10);
  } else {
    // Fallback: re-render if modal HTML is empty
    renderPMTool();
  }
};

window.closeAddClientModal = function () {
  // Reset flags
  window.linkingExistingClientAccount = false;
  window.existingClientAccountId = null;
  showAddClientModal = false;
  addingClientContactId = null;

  // Remove the modal directly from DOM if it exists
  const existingModal = document.getElementById('add-client-modal-overlay');
  if (existingModal) {
    existingModal.remove();
  }

  // Also re-render to update any UI that depends on showAddClientModal state
  renderPMTool();
};

// Upgrade Company Modal Functions
window.openUpgradeCompanyModal = function (contactId, profileId) {
  upgradingContactId = contactId;
  upgradingContactProfileId = profileId;
  showUpgradeCompanyModal = true;

  // Inject modal directly instead of re-rendering entire page
  const existingModal = document.getElementById('upgrade-company-modal-overlay');
  if (existingModal) {
    existingModal.remove();
  }

  const modalHTML = renderUpgradeCompanyModal();
  if (modalHTML) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = modalHTML;
    const modalElement = tempDiv.firstElementChild;

    document.body.appendChild(modalElement);

    // Fade in animation
    setTimeout(() => {
      if (modalElement) {
        modalElement.style.opacity = '1';
      }
    }, 10);
  } else {
    // Fallback: re-render if modal HTML is empty
    renderPMTool();
  }
};

window.closeUpgradeCompanyModal = function () {
  showUpgradeCompanyModal = false;
  upgradingContactId = null;
  upgradingContactProfileId = null;

  // Remove the modal directly from DOM if it exists
  const existingModal = document.getElementById('upgrade-company-modal-overlay');
  if (existingModal) {
    existingModal.remove();
  }

  // Also re-render to update any UI that depends on showUpgradeCompanyModal state
  renderPMTool();
};

// Render Upgrade Company Modal
function renderUpgradeCompanyModal() {
  const contact = contacts.find(c => c.id === upgradingContactId);
  if (!contact) return '';

  const fullName = `${contact.first_name || ''} ${contact.last_name || ''}`.trim() || 'Unknown';
  const contactEmail = contact.email || '';

  // Default form data
  const upgradeFormData = {
    companyName: contact.company_name || '',
    companyPhone: contact.phone || '',
    companyCity: '',
    companyState: ''
  };

  return `
    <div
      id="upgrade-company-modal-overlay"
      onclick="if (event.target.id === 'upgrade-company-modal-overlay') closeUpgradeCompanyModal()"
      style="
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.6);
        z-index: 10000;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 1rem;
        opacity: 0;
        transition: opacity 0.2s;
      "
    >
      <div
        onclick="event.stopPropagation()"
        style="
          background: #ffffff;
          border-radius: 1rem;
          width: 100%;
          max-width: 500px;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
        "
      >
        <!-- Header -->
        <div style="
          padding: 1.5rem;
          border-bottom: 1px solid ${colors.border};
          display: flex;
          justify-content: space-between;
          align-items: center;
        ">
          <h2 style="
            margin: 0;
            font-size: 1.5rem;
            font-weight: 700;
            color: ${colors.text};
          ">Upgrade to Company Owner</h2>
          <button
            onclick="closeUpgradeCompanyModal()"
            style="
              background: transparent;
              border: none;
              color: ${colors.textSecondary};
              cursor: pointer;
              font-size: 1.5rem;
              padding: 0;
              width: 32px;
              height: 32px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 50%;
            "
            onmouseover="this.style.background='#f3f4f6'"
            onmouseout="this.style.background='transparent'"
          >
            ×
          </button>
        </div>

        <!-- Form -->
        <form
          onsubmit="submitUpgradeToCompanyOwner(event); return false;"
          style="padding: 1.5rem; display: flex; flex-direction: column; gap: 1.5rem;"
        >
          <!-- Contact Info Display -->
          <div style="
            background: #f3f4f6;
            padding: 1rem;
            border-radius: 0.5rem;
            margin-bottom: 0.5rem;
          ">
            <div style="font-size: 0.875rem; color: ${colors.textSecondary}; margin-bottom: 0.25rem;">
              Upgrading Contact
            </div>
            <div style="font-weight: 600; color: ${colors.text};">
              ${fullName}${contactEmail ? ` (${contactEmail})` : ''}
            </div>
          </div>

          <!-- Company Name (Required) -->
          <div>
            <label style="
              display: block;
              font-size: 0.875rem;
              font-weight: 600;
              color: ${colors.text};
              margin-bottom: 0.5rem;
            ">
              Company Name <span style="color: #ef4444;">*</span>
            </label>
            <input
              type="text"
              id="upgrade-company-name"
              placeholder="Enter company name"
              value="${upgradeFormData.companyName}"
              required
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-size: 0.9375rem;
                box-sizing: border-box;
              "
              onfocus="this.style.borderColor='${colors.primary}'"
              onblur="this.style.borderColor='${colors.border}'"
            />
          </div>

          <!-- Company Phone (Optional) -->
          <div>
            <label style="
              display: block;
              font-size: 0.875rem;
              font-weight: 600;
              color: ${colors.text};
              margin-bottom: 0.5rem;
            ">
              Phone (Optional)
            </label>
            <input
              type="tel"
              id="upgrade-company-phone"
              placeholder="(555) 123-4567"
              value="${upgradeFormData.companyPhone}"
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-size: 0.9375rem;
                box-sizing: border-box;
              "
              onfocus="this.style.borderColor='${colors.primary}'"
              onblur="this.style.borderColor='${colors.border}'"
            />
          </div>

          <!-- City/State Row -->
          <div style="display: flex; gap: 1rem;">
            <div style="flex: 1;">
              <label style="
                display: block;
                font-size: 0.875rem;
                font-weight: 600;
                color: ${colors.text};
                margin-bottom: 0.5rem;
              ">
                City (Optional)
              </label>
              <input
                type="text"
                id="upgrade-company-city"
                placeholder="City"
                value="${upgradeFormData.companyCity}"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid ${colors.border};
                  border-radius: 0.5rem;
                  font-size: 0.9375rem;
                  box-sizing: border-box;
                "
                onfocus="this.style.borderColor='${colors.primary}'"
                onblur="this.style.borderColor='${colors.border}'"
              />
            </div>
            <div style="flex: 1;">
              <label style="
                display: block;
                font-size: 0.875rem;
                font-weight: 600;
                color: ${colors.text};
                margin-bottom: 0.5rem;
              ">
                State (Optional)
              </label>
              <input
                type="text"
                id="upgrade-company-state"
                placeholder="State"
                value="${upgradeFormData.companyState}"
                style="
                  width: 100%;
                  padding: 0.75rem;
                  border: 1px solid ${colors.border};
                  border-radius: 0.5rem;
                  font-size: 0.9375rem;
                  box-sizing: border-box;
                "
                onfocus="this.style.borderColor='${colors.primary}'"
                onblur="this.style.borderColor='${colors.border}'"
              />
            </div>
          </div>

          <!-- Error Message -->
          <div id="upgrade-company-error" style="
            display: none;
            background: #fee2e2;
            color: #991b1b;
            padding: 0.75rem;
            border-radius: 0.5rem;
            font-size: 0.875rem;
          "></div>

          <!-- Buttons -->
          <div style="display: flex; gap: 0.75rem; margin-top: 0.5rem;">
            <button
              type="button"
              onclick="closeUpgradeCompanyModal()"
              style="
                flex: 1;
                background: transparent;
                color: ${colors.textSecondary};
                padding: 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-size: 1rem;
                font-weight: 600;
                cursor: pointer;
                transition: all 0.2s;
              "
              onmouseover="this.style.borderColor='${colors.primary}'; this.style.color='${colors.primary}'"
              onmouseout="this.style.borderColor='${colors.border}'; this.style.color='${colors.textSecondary}'"
            >
              Cancel
            </button>
            <button
              type="submit"
              id="upgrade-company-submit-btn"
              style="
                flex: 2;
                background: #10b981;
                color: white;
                padding: 0.75rem;
                border: none;
                border-radius: 0.5rem;
                font-size: 1rem;
                font-weight: 600;
                cursor: pointer;
                transition: background-color 0.2s;
              "
              onmouseover="this.style.background='#059669'"
              onmouseout="this.style.background='#10b981'"
            >
              Upgrade to Company Owner
            </button>
          </div>
        </form>
      </div>
    </div>
  `;
}

// Submit Upgrade to Company Owner
window.submitUpgradeToCompanyOwner = async function (event) {
  event.preventDefault();

  const submitButton = document.getElementById('upgrade-company-submit-btn');
  const errorDiv = document.getElementById('upgrade-company-error');

  if (!upgradingContactProfileId) {
    if (errorDiv) {
      errorDiv.textContent = 'Contact profile ID is missing. Please refresh and try again.';
      errorDiv.style.display = 'block';
    }
    return;
  }

  // Get form values
  const companyName = document.getElementById('upgrade-company-name')?.value?.trim();
  const companyPhone = document.getElementById('upgrade-company-phone')?.value?.trim() || null;
  const companyCity = document.getElementById('upgrade-company-city')?.value?.trim() || null;
  const companyState = document.getElementById('upgrade-company-state')?.value?.trim() || null;

  if (!companyName) {
    if (errorDiv) {
      errorDiv.textContent = 'Company name is required.';
      errorDiv.style.display = 'block';
    }
    const nameInput = document.getElementById('upgrade-company-name');
    if (nameInput) {
      nameInput.style.borderColor = '#ef4444';
      nameInput.focus();
    }
    return;
  }

  // Hide error, show loading
  if (errorDiv) {
    errorDiv.style.display = 'none';
  }

  if (submitButton) {
    submitButton.disabled = true;
    submitButton.textContent = 'Upgrading...';
  }

  try {
    // Call RPC function with target_user_id (admin upgrade)
    const { data, error } = await supabase.rpc('upgrade_to_company_owner', {
      p_company_name: companyName,
      p_company_phone: companyPhone,
      p_company_city: companyCity,
      p_company_state: companyState,
      p_target_user_id: upgradingContactProfileId
    });

    if (error) {
      throw error;
    }

    // Check if successful
    if (!data?.success) {
      throw new Error(data?.error || 'Failed to upgrade contact');
    }

    // Success!
    console.log('✅ Contact upgraded successfully:', data);

    // Show success message briefly
    if (submitButton) {
      submitButton.textContent = 'Success!';
      submitButton.style.background = '#10b981';
    }

    // Reload data and close modal after a moment
    setTimeout(async () => {
      await loadClients();
      await loadContacts();
      closeUpgradeCompanyModal();
      renderPMTool();
    }, 1000);

  } catch (err) {
    console.error('❌ Error upgrading contact:', err);

    if (errorDiv) {
      errorDiv.textContent = err.message || 'Failed to upgrade contact. Please try again.';
      errorDiv.style.display = 'block';
    }

    if (submitButton) {
      submitButton.disabled = false;
      submitButton.textContent = 'Upgrade to Company Owner';
    }
  }
};

// Render Add Client Modal
function renderAddClientModal() {
  const contact = contacts.find(c => c.id === addingClientContactId);
  if (!contact) return '';

  const fullName = `${contact.first_name || ''} ${contact.last_name || ''}`.trim() || 'Unknown';
  const contactEmail = contact.email || '';

  return `
    <div
      id="add-client-modal-overlay"
      onclick="if (event.target.id === 'add-client-modal-overlay') closeAddClientModal()"
      style="
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.6);
        z-index: 10000;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 1rem;
      "
    >
      <div
        onclick="event.stopPropagation()"
        style="
          background: #ffffff;
          border-radius: 1rem;
          width: 100%;
          max-width: 500px;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
        "
      >
        <!-- Header -->
        <div style="
          padding: 1.5rem;
          border-bottom: 1px solid ${colors.border};
          display: flex;
          justify-content: space-between;
          align-items: center;
        ">
          <h2 style="
            margin: 0;
            font-size: 1.5rem;
            font-weight: 700;
            color: ${colors.text};
          ">Add as Client</h2>
          <button
            onclick="closeAddClientModal()"
            style="
              background: transparent;
              border: none;
              color: ${colors.textSecondary};
              cursor: pointer;
              font-size: 1.5rem;
              padding: 0;
              width: 32px;
              height: 32px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 50%;
            "
            onmouseover="this.style.background='#f3f4f6'"
            onmouseout="this.style.background='transparent'"
          >
            ×
          </button>
        </div>

        <!-- Form -->
        <form
          onsubmit="createClientAccount(event); return false;"
          style="padding: 1.5rem; display: flex; flex-direction: column; gap: 1.5rem;"
        >
          <!-- Contact Info Display -->
          <div style="
            background: #f3f4f6;
            padding: 1rem;
            border-radius: 0.5rem;
            margin-bottom: 0.5rem;
          ">
            <div style="font-size: 0.875rem; color: ${colors.textSecondary}; margin-bottom: 0.25rem;">
              Contact
            </div>
            <div style="font-weight: 600; color: ${colors.text};">
              ${fullName}
            </div>
          </div>

          <!-- Email -->
          <div>
            <label style="
              display: block;
              font-size: 0.875rem;
              font-weight: 600;
              color: ${colors.text};
              margin-bottom: 0.5rem;
            ">
              Email Address *
            </label>
            <input
              type="email"
              id="client-email"
              placeholder="Enter email address for client account"
              value="${contactEmail}"
              required
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-size: 0.9375rem;
                box-sizing: border-box;
              "
              onfocus="this.style.borderColor='${colors.primary}'"
              onblur="this.style.borderColor='${colors.border}'; checkExistingEmailForClient()"
            />
            <p style="
              margin: 0.5rem 0 0 0;
              font-size: 0.75rem;
              color: ${colors.textSecondary};
            ">This will be their login email</p>
            <!-- Existing Account Message -->
            <div id="existing-email-message" style="display: none; margin-top: 0.75rem; padding: 0.75rem; background: #fef3c7; border: 1px solid #f59e0b; border-radius: 0.5rem;">
              <div style="display: flex; align-items: flex-start; gap: 0.5rem;">
                <span style="font-size: 1.25rem;">⚠️</span>
                <div style="flex: 1;">
                  <div style="font-weight: 600; color: #92400e; margin-bottom: 0.25rem; font-size: 0.875rem;">
                    Account with this email already exists
                  </div>
                  <div style="color: #78350f; font-size: 0.8125rem; margin-bottom: 0.5rem;" id="existing-account-info">
                    Loading account info...
                  </div>
                  <button
                    type="button"
                    onclick="linkExistingAccountAsClient()"
                    style="
                      background: #f59e0b;
                      color: white;
                      border: none;
                      padding: 0.5rem 1rem;
                      border-radius: 0.375rem;
                      cursor: pointer;
                      font-size: 0.8125rem;
                      font-weight: 600;
                    "
                  >
                    Link Existing Account
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Password -->
          <div id="password-field-container">
            <label style="
              display: block;
              font-size: 0.875rem;
              font-weight: 600;
              color: ${colors.text};
              margin-bottom: 0.5rem;
            ">
              Password *
            </label>
            <input
              type="password"
              id="client-password"
              placeholder="Enter password for client account"
              required
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-size: 0.9375rem;
                box-sizing: border-box;
              "
              onfocus="this.style.borderColor='${colors.primary}'"
              onblur="this.style.borderColor='${colors.border}'"
            />
            <p style="
              margin: 0.5rem 0 0 0;
              font-size: 0.75rem;
              color: ${colors.textSecondary};
            ">This will be their initial login password</p>
          </div>

          <!-- Actions -->
          <div style="
            display: flex;
            gap: 0.75rem;
            justify-content: flex-end;
            margin-top: 1rem;
            padding-top: 1.5rem;
            border-top: 1px solid ${colors.border};
          ">
            <button
              type="button"
              onclick="closeAddClientModal()"
              style="
                background: #f3f4f6;
                color: ${colors.text};
                border: none;
                padding: 0.75rem 1.5rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-weight: 600;
                font-size: 0.9375rem;
              "
              onmouseover="this.style.background='#e5e7eb'"
              onmouseout="this.style.background='#f3f4f6'"
            >
              Cancel
            </button>
            <button
              type="submit"
              style="
                background: #f59e0b;
                color: white;
                border: none;
                padding: 0.75rem 1.5rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-weight: 600;
                font-size: 0.9375rem;
              "
              onmouseover="this.style.background='#d97706'"
              onmouseout="this.style.background='#f59e0b'"
            >
              Create Client Account
            </button>
          </div>
        </form>
      </div>
    </div>
  `;
}

// Create Client Account Function
// Global flag to track if we're linking an existing account
window.linkingExistingClientAccount = false;
window.existingClientAccountId = null;

// Check if email exists when user enters it
window.checkExistingEmailForClient = async function () {
  const emailInput = document.getElementById('client-email');
  const messageDiv = document.getElementById('existing-email-message');
  const infoDiv = document.getElementById('existing-account-info');
  const passwordContainer = document.getElementById('password-field-container');

  if (!emailInput || !messageDiv) return;

  const email = emailInput.value.trim().toLowerCase();

  if (!email || email.length < 3) {
    messageDiv.style.display = 'none';
    window.linkingExistingClientAccount = false;
    window.existingClientAccountId = null;
    if (passwordContainer) passwordContainer.style.display = 'block';
    return;
  }

  try {
    // Check if email exists in profiles
    const { data: existingProfile, error } = await supabase
      .from('profiles')
      .select('id, first_name, last_name, email, company_id')
      .eq('email', email)
      .maybeSingle();

    if (error) {
      console.error('Error checking email:', error);
      return;
    }

    if (existingProfile) {
      const fullName = `${existingProfile.first_name || ''} ${existingProfile.last_name || ''}`.trim() || 'User';
      const { data: isBlocked } = await supabase.rpc('is_email_member_or_owner', { p_email: email });
      if (isBlocked === true) {
        infoDiv.textContent = `Account found: ${fullName}. This account is a company member or owner and cannot be made a client.`;
        messageDiv.style.display = 'block';
        window.existingClientAccountId = null;
        const linkBtn = messageDiv.querySelector('button[onclick*="linkExistingAccountAsClient"]');
        if (linkBtn) linkBtn.style.display = 'none';
      } else {
        infoDiv.textContent = `Account found: ${fullName}. Click "Link Existing Account" to add them as a client without creating a new account.`;
        messageDiv.style.display = 'block';
        window.existingClientAccountId = existingProfile.id;
        const linkBtn = messageDiv.querySelector('button[onclick*="linkExistingAccountAsClient"]');
        if (linkBtn) linkBtn.style.display = '';
      }

      // Hide password field when linking existing account
      if (passwordContainer) {
        passwordContainer.style.display = 'none';
        const passwordInput = document.getElementById('client-password');
        if (passwordInput) {
          passwordInput.removeAttribute('required');
        }
      }
    } else {
      // Email doesn't exist - hide message
      messageDiv.style.display = 'none';
      window.linkingExistingClientAccount = false;
      window.existingClientAccountId = null;
      if (passwordContainer) {
        passwordContainer.style.display = 'block';
        const passwordInput = document.getElementById('client-password');
        if (passwordInput) {
          passwordInput.setAttribute('required', 'required');
        }
      }
    }
  } catch (error) {
    console.error('Error checking existing email:', error);
  }
};

// Link existing account as client
window.linkExistingAccountAsClient = async function () {
  if (!window.existingClientAccountId || !addingClientContactId || !currentCompany) {
    showNotification('Missing required information', 'error');
    return;
  }

  const emailInput = document.getElementById('client-email');
  if (!emailInput) {
    showNotification('Email field not found', 'error');
    return;
  }

  const email = emailInput.value.trim().toLowerCase();
  if (!email) {
    showNotification('Please enter an email address', 'error');
    return;
  }

  try {
    const { data: isBlocked, error } = await supabase.rpc('is_email_member_or_owner', { p_email: email });
    if (!error && isBlocked === true) {
      showNotification('This contact\'s email is already associated with a company member or owner and cannot be made a client.', 'error');
      return;
    }
  } catch (e) {
    console.warn('is_email_member_or_owner check failed:', e);
  }

  const contact = contacts.find(c => c.id === addingClientContactId);
  if (!contact) {
    showNotification('Contact not found', 'error');
    return;
  }

  // Set flag to indicate we're linking
  window.linkingExistingClientAccount = true;

  // Disable form during processing
  const submitButton = document.querySelector('#add-client-modal form button[type="submit"]');
  if (submitButton) {
    submitButton.disabled = true;
    submitButton.textContent = 'Linking...';
  }

  try {
    const userId = window.existingClientAccountId;

    // Check if user is already a CLIENT for this company
    const { data: existingMember, error: memberCheckError } = await supabase
      .from('company_members')
      .select('user_id, role, company_id')
      .eq('user_id', userId)
      .eq('company_id', currentCompany.id)
      .maybeSingle();

    if (memberCheckError) {
      console.error('❌ Error checking company membership:', memberCheckError);
      showNotification('Failed to check company membership', 'error');
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = 'Create Client Account';
      }
      return;
    }

    if (existingMember) {
      if (existingMember.role === 'CLIENT') {
        console.log('✅ User is already a CLIENT for this company, linking contact');
      } else {
        // Update role to CLIENT
        console.log('📝 User is a company member with role', existingMember.role, '- updating to CLIENT');
        const { error: updateRoleError } = await supabase
          .from('company_members')
          .update({ role: 'CLIENT' })
          .eq('company_id', currentCompany.id)
          .eq('user_id', userId);

        if (updateRoleError) {
          console.error('❌ Error updating user role to CLIENT:', updateRoleError);
          showNotification('Failed to update user role to client: ' + updateRoleError.message, 'error');
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = 'Create Client Account';
          }
          return;
        }
        console.log('✅ User role updated to CLIENT');
      }
    } else {
      // User exists but is not a member of this company - add them as CLIENT
      console.log('📝 User exists but not a company member, adding as CLIENT');
      const { error: addMemberError } = await supabase
        .from('company_members')
        .insert({
          company_id: currentCompany.id,
          user_id: userId,
          role: 'CLIENT'
        });

      if (addMemberError) {
        console.error('❌ Error adding user as CLIENT:', addMemberError);
        if (addMemberError.code === '23505') {
          console.log('⚠️ Duplicate key error - user was added by another process, continuing...');
        } else {
          showNotification('Failed to add user as client: ' + addMemberError.message, 'error');
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = 'Create Client Account';
          }
          return;
        }
      }
    }

    // Link contact to profile
    const emailLower = email.toLowerCase().trim();
    const validStages = ['opportunity', 'follow_up', 'deal_sent', 'signed_paid', 'active', 'complete'];
    const existingStage = contact.pipeline_stage;
    const pipelineStage = (existingStage && validStages.includes(existingStage)) ? existingStage : 'active';

    const { data: updatedContact, error: contactError } = await supabase.rpc('link_contact_to_profile', {
      p_contact_id: contact.id,
      p_profile_id: userId,
      p_email: emailLower,
      p_pipeline_stage: pipelineStage,
      p_status: 'portal',
    });

    if (contactError) {
      const errorMsg = contactError.message || contactError.details || contactError.hint || 'Unknown error';
      showNotification(`Failed to link contact: ${errorMsg}`, 'error');
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = 'Create Client Account';
      }
      return;
    }

    // Link existing projects to this client
    await supabase
      .from('projects')
      .update({ profile_id: userId })
      .eq('contact_id', contact.id)
      .is('profile_id', null);

    // Also link contact to company via contact_companies if not already linked
    const { data: existingLink, error: linkCheckError } = await supabase
      .from('contact_companies')
      .select('contact_id, company_id')
      .eq('contact_id', contact.id)
      .eq('company_id', currentCompany.id)
      .maybeSingle();

    if (!linkCheckError && !existingLink) {
      // Link contact to this company
      await supabase
        .from('contact_companies')
        .insert({
          contact_id: contact.id,
          company_id: currentCompany.id
        });
    }

    // Reload contacts and clients
    await loadClients();
    await loadContacts();

    // Close modal
    closeAddClientModal();

    // Re-render
    renderPMTool();

    // Show success notification
    showNotification('Existing account linked as client successfully', 'success');
  } catch (error) {
    console.error('❌ Error linking existing account:', error);
    showNotification('An unexpected error occurred: ' + error.message, 'error');
    if (submitButton) {
      submitButton.disabled = false;
      submitButton.textContent = 'Create Client Account';
    }
  } finally {
    window.linkingExistingClientAccount = false;
    window.existingClientAccountId = null;
  }
};

window.createClientAccount = async function (event) {
  event.preventDefault();

  // If we're linking an existing account, use that function instead
  if (window.linkingExistingClientAccount && window.existingClientAccountId) {
    await linkExistingAccountAsClient();
    return;
  }

  // Prevent double-clicks
  const submitButton = event.target.closest('form')?.querySelector('button[type="submit"]');
  if (submitButton && submitButton.disabled) {
    console.log('⏸️ Already processing, ignoring duplicate click');
    return;
  }

  // Disable submit button to prevent double-clicks
  if (submitButton) {
    submitButton.disabled = true;
    submitButton.textContent = 'Creating...';
  }

  if (!currentCompany || !addingClientContactId) {
    if (submitButton) {
      submitButton.disabled = false;
      submitButton.textContent = 'Create Client Account';
    }
    showNotification('Missing required information', 'error');
    return;
  }

  const contact = contacts.find(c => c.id === addingClientContactId);
  if (!contact) {
    showNotification('Contact not found', 'error');
    return;
  }

  const emailInput = document.getElementById('client-email');
  const passwordInput = document.getElementById('client-password');

  if (!emailInput || !passwordInput) {
    showNotification('Form fields not found', 'error');
    return;
  }

  const email = emailInput.value.trim().toLowerCase();
  const password = passwordInput.value;
  const firstName = (contact.first_name || '').trim();
  const lastName = (contact.last_name || '').trim();
  const phone = contact.phone ? contact.phone.trim() : null;

  if (!email) {
    showNotification('Please enter an email address', 'error');
    if (submitButton) {
      submitButton.disabled = false;
      submitButton.textContent = 'Create Client Account';
    }
    return;
  }

  if (!password) {
    showNotification('Please enter a password', 'error');
    if (submitButton) {
      submitButton.disabled = false;
      submitButton.textContent = 'Create Client Account';
    }
    return;
  }

  if (!firstName || !lastName) {
    showNotification('Contact must have a first name and last name', 'error');
    return;
  }

  if (password.length < 6) {
    showNotification('Password must be at least 6 characters long', 'error');
    return;
  }

  if (!currentCompany || !currentCompany.id) {
    showNotification('No company selected', 'error');
    return;
  }

  try {
    // First, check if email already exists
    console.log('🔍 Checking if email already exists:', email);
    const { data: existingProfile, error: profileCheckError } = await supabase
      .from('profiles')
      .select('id, first_name, last_name, email')
      .eq('email', email.toLowerCase())
      .maybeSingle();

    if (profileCheckError) {
      console.error('❌ Error checking email existence:', profileCheckError);
      showNotification('Failed to check if email exists', 'error');
      return;
    }

    let userId = null;

    if (existingProfile) {
      // Email already exists - check if user is already a CLIENT for this company
      console.log('📧 Email already exists, checking company membership:', existingProfile.id);

      const { data: existingMember, error: memberCheckError } = await supabase
        .from('company_members')
        .select('user_id, role, company_id')
        .eq('user_id', existingProfile.id)
        .eq('company_id', currentCompany.id)
        .maybeSingle();

      if (memberCheckError) {
        console.error('❌ Error checking company membership:', memberCheckError);
        showNotification('Failed to check company membership', 'error');
        return;
      }

      if (existingMember) {
        // User is already a member of this company
        if (existingMember.role === 'CLIENT') {
          // Already a CLIENT - just link the contact to this profile
          console.log('✅ User is already a CLIENT for this company, linking contact');
          userId = existingProfile.id;
        } else {
          // User exists but is not a CLIENT (might be Employee, Manager, etc.)
          // Update their role to CLIENT
          console.log('📝 User is a company member with role', existingMember.role, '- updating to CLIENT');
          const { error: updateRoleError } = await supabase
            .from('company_members')
            .update({ role: 'CLIENT' })
            .eq('company_id', currentCompany.id)
            .eq('user_id', existingProfile.id);

          if (updateRoleError) {
            console.error('❌ Error updating user role to CLIENT:', updateRoleError);
            showNotification('Failed to update user role to client: ' + updateRoleError.message, 'error');
            return;
          }

          console.log('✅ User role updated to CLIENT');
          userId = existingProfile.id;
        }
      } else {
        // User exists but is not a member of this company - add them as CLIENT
        console.log('📝 User exists but not a company member, adding as CLIENT');
        const { error: addMemberError } = await supabase
          .from('company_members')
          .insert({
            company_id: currentCompany.id,
            user_id: existingProfile.id,
            role: 'CLIENT'
          });

        if (addMemberError) {
          console.error('❌ Error adding user as CLIENT:', addMemberError);
          // Check if it's a duplicate key error (race condition)
          if (addMemberError.code === '23505') {
            console.log('⚠️ Duplicate key error - user was added by another process, continuing...');
            userId = existingProfile.id;
          } else {
            showNotification('Failed to add user as client: ' + addMemberError.message, 'error');
            return;
          }
        } else {
          userId = existingProfile.id;
        }
      }
    } else {
      // Email doesn't exist - create new user account
      console.log('🆕 Email is new, creating new user account');

      // Prepare data for Edge Function
      const requestData = {
        email: email,
        password: password,
        first_name: firstName,
        last_name: lastName,
        phone: phone || null,
        profile_role: 'USER', // Profile role is always USER
        company_role: 'CLIENT', // Company role is CLIENT
        company_id: currentCompany.id
      };

      console.log('🚀 [WEB] Calling create-user Edge Function for client with data:', {
        ...requestData,
        password: '***' // Don't log password
      });

      // Call Edge Function - use fetch directly to get better error handling
      let responseData = null;
      let responseError = null;

      try {
        // Get session for auth header
        const { data: { session } } = await supabase.auth.getSession();
        if (!session) {
          showNotification('Please log in to create a client account', 'error');
          return;
        }

        // Call Edge Function using fetch to get full response control
        const response = await fetch(`${SUPABASE_URL}/functions/v1/create-user`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${session.access_token}`,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestData)
        });

        console.log('📡 Edge Function HTTP response status:', response.status);

        // Parse response body
        let responseBody;
        try {
          responseBody = await response.json();
          console.log('📡 Edge Function response body:', responseBody);
        } catch (parseError) {
          const textBody = await response.text();
          console.error('❌ Failed to parse response as JSON:', textBody);
          showNotification('Invalid response from server', 'error');
          return;
        }

        if (!response.ok) {
          // Error response - extract error message
          responseError = {
            status: response.status,
            statusText: response.statusText,
            message: responseBody?.error || responseBody?.message || `Server returned status ${response.status}`
          };
          responseData = responseBody; // Store body even on error
        } else {
          // Success response
          responseData = responseBody;
        }
      } catch (fetchError) {
        console.error('💥 Fetch exception:', fetchError);
        responseError = {
          message: fetchError.message || 'Failed to call server'
        };
      }

      console.log('📡 Processed response:', { data: responseData, error: responseError });

      // Check for error
      if (responseError) {
        console.error('❌ Edge Function error:', responseError);

        // Extract error message from response body
        let errorMessage = 'Failed to create client account';

        // Check responseData (the parsed response body) for error message
        if (responseData && typeof responseData === 'object') {
          if (responseData.error) {
            errorMessage = typeof responseData.error === 'string'
              ? responseData.error
              : JSON.stringify(responseData.error);
            console.log('✅ Found error in responseData.error:', errorMessage);
          } else if (responseData.message) {
            errorMessage = responseData.message;
            console.log('✅ Found error in responseData.message:', errorMessage);
          }
        }

        // Fallback to error message from responseError
        if (errorMessage === 'Failed to create client account' && responseError.message) {
          errorMessage = responseError.message;
        }

        // Check if error is "email already exists" - if so, try to link existing user
        if (errorMessage.includes('already exists') || errorMessage.includes('already been registered')) {
          console.log('🔄 Email already exists, attempting to link to existing user...');

          // Try to find the existing user by email
          const { data: existingProfileByEmail, error: emailCheckError } = await supabase
            .from('profiles')
            .select('id, first_name, last_name, email')
            .eq('email', email.toLowerCase())
            .maybeSingle();

          if (!emailCheckError && existingProfileByEmail) {
            console.log('✅ Found existing profile by email:', existingProfileByEmail.id);
            userId = existingProfileByEmail.id;

            // Check if they're already a CLIENT for this company
            const { data: existingMember, error: memberCheckError } = await supabase
              .from('company_members')
              .select('user_id, role, company_id')
              .eq('user_id', userId)
              .eq('company_id', currentCompany.id)
              .maybeSingle();

            if (!memberCheckError) {
              if (existingMember && existingMember.role === 'CLIENT') {
                console.log('✅ User is already a CLIENT, just linking contact');
                // Continue to link contact below
              } else if (existingMember) {
                // Update role to CLIENT
                const { error: updateError } = await supabase
                  .from('company_members')
                  .update({ role: 'CLIENT' })
                  .eq('company_id', currentCompany.id)
                  .eq('user_id', userId);

                if (updateError) {
                  console.error('❌ Error updating role:', updateError);
                } else {
                  console.log('✅ Updated user role to CLIENT');
                }
              } else {
                // Add as CLIENT
                const { error: addError } = await supabase
                  .from('company_members')
                  .insert({
                    company_id: currentCompany.id,
                    user_id: userId,
                    role: 'CLIENT'
                  });

                if (addError && addError.code !== '23505') { // Ignore duplicate key errors
                  console.error('❌ Error adding as CLIENT:', addError);
                } else {
                  console.log('✅ Added user as CLIENT');
                }
              }

              // Continue to link contact (skip the return statement)
            } else {
              console.error('❌ Error checking company membership:', memberCheckError);
              if (submitButton) {
                submitButton.disabled = false;
                submitButton.textContent = 'Create Client Account';
              }
              showNotification('Email already exists but could not verify company membership', 'error');
              return;
            }
          } else {
            console.error('❌ Could not find existing profile by email');
            if (submitButton) {
              submitButton.disabled = false;
              submitButton.textContent = 'Create Client Account';
            }
            showNotification(errorMessage, 'error');
            return;
          }
        } else {
          console.log('📢 Final error message to show:', errorMessage);
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = 'Create Client Account';
          }
          showNotification(errorMessage, 'error');
          return;
        }
      }

      // Check if data indicates failure (even without error object)
      if (!responseData) {
        showNotification('No response from server', 'error');
        return;
      }

      if (!responseData.success) {
        console.error('❌ Client creation failed:', responseData?.error);
        const errorMessage = responseData?.error || responseData?.message || 'Failed to create client account';
        showNotification(errorMessage, 'error');
        return;
      }

      userId = responseData.user_id;
    }

    // Link contact to profile using RPC function (same as native app)
    if (userId && contact.id) {
      const emailLower = email.toLowerCase().trim();
      // Valid pipeline_stage values: 'opportunity', 'follow_up', 'deal_sent', 'signed_paid', 'active', 'complete'
      // Check if existing pipeline_stage is valid, otherwise use 'active'
      const validStages = ['opportunity', 'follow_up', 'deal_sent', 'signed_paid', 'active', 'complete'];
      const existingStage = contact.pipeline_stage;
      const pipelineStage = (existingStage && validStages.includes(existingStage)) ? existingStage : 'active';

      // Ensure all parameters are valid
      if (!contact.id || !userId || !emailLower) {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = 'Create Client Account';
        }
        showNotification('Missing required information to link contact', 'error');
        return;
      }

      const { data: updatedContact, error: contactError } = await supabase.rpc('link_contact_to_profile', {
        p_contact_id: contact.id,
        p_profile_id: userId,
        p_email: emailLower,
        p_pipeline_stage: pipelineStage,
        p_status: 'portal',
      });

      if (contactError) {
        // RPC errors from PostgreSQL functions return the error message directly
        // The error.message should contain the RAISE EXCEPTION message from the function
        const errorMsg = contactError.message || contactError.details || contactError.hint || 'Unknown error';

        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = 'Create Client Account';
        }
        showNotification(`Failed to link contact: ${errorMsg}`, 'error');
        return;
      }

      // Link existing projects to this client (same as native app)
      await supabase
        .from('projects')
        .update({ profile_id: userId })
        .eq('contact_id', contact.id)
        .is('profile_id', null);
    }

    // Reload contacts and clients
    await loadClients();
    await loadContacts();

    // Close modal
    closeAddClientModal();

    // Re-render
    renderPMTool();

    // Show success notification
    showNotification('Client account created successfully', 'success');
  } catch (error) {
    console.error('❌ Error creating client account:', error);
    showNotification('An unexpected error occurred: ' + error.message, 'error');
  } finally {
    // Re-enable submit button
    const submitButton = document.querySelector('#add-client-modal form button[type="submit"]');
    if (submitButton) {
      submitButton.disabled = false;
      submitButton.textContent = 'Create Client Account';
    }
  }
};

// Render Services Tab
function renderServicesTab() {
  // Filter services based on search query
  const filteredServices = services.filter(service => {
    if (!serviceSearchQuery) return true;
    const query = serviceSearchQuery.toLowerCase();
    const name = (service.name || '').toLowerCase();
    const category = (service.category || '').toLowerCase();
    const description = (service.description || '').toLowerCase();
    return name.includes(query) || category.includes(query) || description.includes(query);
  });

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return 'Unknown';
    const date = new Date(dateString);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  return `
    <!-- Header with Search and Add Button -->
    <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 1.5rem;">
      <h2 style="
        margin: 0;
        font-size: 1.5rem;
        font-weight: 700;
        color: ${colors.text};
      ">Company Services</h2>
      <button
        onclick="openAddServiceModal()"
        style="
          background: #f59e0b;
          color: white;
          border: none;
          padding: 0.75rem 1.5rem;
          border-radius: 0.5rem;
          font-size: 0.9375rem;
          font-weight: 600;
          cursor: pointer;
          white-space: nowrap;
          transition: all 0.2s;
        "
        onmouseover="this.style.background='#d97706'; this.style.transform='scale(1.05)'"
        onmouseout="this.style.background='#f59e0b'; this.style.transform='scale(1)'"
      >
        Add Service
      </button>
    </div>

    <!-- Services List -->
    <div style="display: flex; flex-direction: column; gap: 1rem;">
      ${filteredServices.length === 0 ? `
        <div style="
          text-align: center;
          padding: 3rem;
          color: ${colors.textSecondary};
        ">
          <div style="font-size: 3rem; margin-bottom: 1rem;">🛠️</div>
          <div style="font-size: 1.125rem; font-weight: 500; margin-bottom: 0.5rem;">
            ${serviceSearchQuery ? 'No services found' : 'No services'}
          </div>
          <div style="font-size: 0.875rem;">
            ${serviceSearchQuery ? 'Try a different search term' : 'Add services to get started'}
          </div>
        </div>
      ` : filteredServices.map(service => {
    const serviceName = service.name || 'Unnamed Service';
    const addedDate = formatDate(service.created_at);

    return `
          <div style="
            background: #ffffff;
            border: 1px solid ${colors.border};
            border-radius: 0.75rem;
            padding: 1.25rem;
            display: flex;
            align-items: center;
            gap: 1rem;
            box-shadow: 0 1px 3px rgba(0,0,0,0.1);
            transition: all 0.2s;
          "
          onmouseover="this.style.boxShadow='0 4px 6px rgba(0,0,0,0.15)'; this.style.transform='translateY(-2px)'"
          onmouseout="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.1)'; this.style.transform='translateY(0)'"
          >
            <!-- Icon -->
            <div style="
              width: 48px;
              height: 48px;
              border-radius: 0.5rem;
              background: #f3f4f6;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 1.5rem;
              flex-shrink: 0;
            ">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z" stroke="#6b7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
              </svg>
            </div>
            
            <!-- Service Info -->
            <div style="flex: 1; min-width: 0;">
              <div style="
                font-size: 1.125rem;
                font-weight: 600;
                color: ${colors.text};
                margin-bottom: 0.5rem;
              ">
                ${serviceName}
              </div>
              <div style="
                font-size: 0.875rem;
                color: ${colors.textSecondary};
              ">
                Added ${addedDate}
              </div>
            </div>
            
            <!-- Action Buttons -->
            <div style="display: flex; gap: 0.5rem;">
              <button
                onclick="openEditServiceModal('${service.id}')"
                style="
                  background: #f59e0b;
                  color: white;
                  border: none;
                  padding: 0.5rem 1rem;
                  border-radius: 0.5rem;
                  font-size: 0.875rem;
                  font-weight: 600;
                  cursor: pointer;
                  display: flex;
                  align-items: center;
                  gap: 0.5rem;
                  transition: all 0.2s;
                "
                onmouseover="this.style.background='#d97706'; this.style.transform='scale(1.05)'"
                onmouseout="this.style.background='#f59e0b'; this.style.transform='scale(1)'"
              >
                <span class="material-icons" style="font-size: 1rem;">edit</span>
                Edit
              </button>
              <button
                onclick="deleteService('${service.id}')"
                style="
                  background: #ef4444;
                  color: white;
                  border: none;
                  padding: 0.5rem 1rem;
                  border-radius: 0.5rem;
                  font-size: 0.875rem;
                  font-weight: 600;
                  cursor: pointer;
                  display: flex;
                  align-items: center;
                  gap: 0.5rem;
                  transition: all 0.2s;
                "
                onmouseover="this.style.background='#dc2626'; this.style.transform='scale(1.05)'"
                onmouseout="this.style.background='#ef4444'; this.style.transform='scale(1)'"
              >
                <span class="material-icons" style="font-size: 1rem;">delete</span>
                Delete
              </button>
            </div>
          </div>
        `;
  }).join('')}
    </div>
    ${showAddServiceModal || editingServiceId ? renderServiceModal() : ''}
  `;
}

// Service Management Functions
window.openAddServiceModal = function () {
  showAddServiceModal = true;
  editingServiceId = null;
  renderPMTool();
};

window.closeServiceModal = function () {
  showAddServiceModal = false;
  editingServiceId = null;
  renderPMTool();
};

window.openEditServiceModal = function (serviceId) {
  editingServiceId = serviceId;
  showAddServiceModal = true;
  renderPMTool();
};

// Render Service Modal (Add/Edit)
function renderServiceModal() {
  const service = editingServiceId ? services.find(s => s.id === editingServiceId) : null;
  const isEditing = !!editingServiceId;

  return `
    <div
      id="service-modal-overlay"
      onclick="if (event.target.id === 'service-modal-overlay') closeServiceModal()"
      style="
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.6);
        z-index: 10000;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 1rem;
      "
    >
      <div
        onclick="event.stopPropagation()"
        style="
          background: #ffffff;
          border-radius: 1rem;
          width: 100%;
          max-width: 500px;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
        "
      >
        <!-- Header -->
        <div style="
          padding: 1.5rem;
          border-bottom: 1px solid ${colors.border};
          display: flex;
          justify-content: space-between;
          align-items: center;
        ">
          <h2 style="
            margin: 0;
            font-size: 1.5rem;
            font-weight: 700;
            color: ${colors.text};
          ">${isEditing ? 'Edit Service' : 'Add Service'}</h2>
          <button
            onclick="closeServiceModal()"
            style="
              background: transparent;
              border: none;
              color: ${colors.textSecondary};
              cursor: pointer;
              font-size: 1.5rem;
              padding: 0;
              width: 32px;
              height: 32px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 50%;
            "
            onmouseover="this.style.background='#f3f4f6'"
            onmouseout="this.style.background='transparent'"
          >
            ×
          </button>
        </div>

        <!-- Form -->
        <form
          onsubmit="saveService(event); return false;"
          style="padding: 1.5rem; display: flex; flex-direction: column; gap: 1.5rem;"
        >
          <!-- Service Title -->
          <div>
            <label style="
              display: block;
              font-size: 0.875rem;
              font-weight: 600;
              color: ${colors.text};
              margin-bottom: 0.5rem;
            ">
              Service Title *
            </label>
            <input
              type="text"
              id="service-title"
              placeholder="Enter service title"
              value="${service?.name || ''}"
              required
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-size: 0.9375rem;
                box-sizing: border-box;
              "
              onfocus="this.style.borderColor='${colors.primary}'"
              onblur="this.style.borderColor='${colors.border}'"
            />
          </div>

          <!-- Description -->
          <div>
            <label style="
              display: block;
              font-size: 0.875rem;
              font-weight: 600;
              color: ${colors.text};
              margin-bottom: 0.5rem;
            ">
              Description
            </label>
            <textarea
              id="service-description"
              placeholder="Enter service description (optional)"
              rows="4"
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-size: 0.9375rem;
                box-sizing: border-box;
                font-family: inherit;
                resize: vertical;
              "
              onfocus="this.style.borderColor='${colors.primary}'"
              onblur="this.style.borderColor='${colors.border}'"
            >${service?.description || ''}</textarea>
          </div>

          <!-- Category -->
          <div>
            <label style="
              display: block;
              font-size: 0.875rem;
              font-weight: 600;
              color: ${colors.text};
              margin-bottom: 0.5rem;
            ">
              Category
            </label>
            <input
              type="text"
              id="service-category"
              placeholder="e.g., Web Development, Landscaping"
              value="${service?.category || ''}"
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-size: 0.9375rem;
                box-sizing: border-box;
              "
              onfocus="this.style.borderColor='${colors.primary}'"
              onblur="this.style.borderColor='${colors.border}'"
            />
          </div>

          <!-- Price -->
          <div>
            <label style="
              display: block;
              font-size: 0.875rem;
              font-weight: 600;
              color: ${colors.text};
              margin-bottom: 0.5rem;
            ">
              Price
            </label>
            <input
              type="number"
              id="service-price"
              placeholder="Enter price (optional)"
              value="${service?.price || ''}"
              step="0.01"
              min="0"
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-size: 0.9375rem;
                box-sizing: border-box;
              "
              onfocus="this.style.borderColor='${colors.primary}'"
              onblur="this.style.borderColor='${colors.border}'"
            />
          </div>

          <!-- Actions -->
          <div style="
            display: flex;
            gap: 0.75rem;
            justify-content: flex-end;
            margin-top: 1rem;
            padding-top: 1.5rem;
            border-top: 1px solid ${colors.border};
          ">
            <button
              type="button"
              onclick="closeServiceModal()"
              style="
                background: #f3f4f6;
                color: ${colors.text};
                border: none;
                padding: 0.75rem 1.5rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-weight: 600;
                font-size: 0.9375rem;
              "
              onmouseover="this.style.background='#e5e7eb'"
              onmouseout="this.style.background='#f3f4f6'"
            >
              Cancel
            </button>
            <button
              type="submit"
              style="
                background: #f59e0b;
                color: white;
                border: none;
                padding: 0.75rem 1.5rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-weight: 600;
                font-size: 0.9375rem;
              "
              onmouseover="this.style.background='#d97706'"
              onmouseout="this.style.background='#f59e0b'"
            >
              ${isEditing ? 'Save Changes' : 'Add Service'}
            </button>
          </div>
        </form>
      </div>
    </div>
  `;
}

// Render Billing Tab
function renderBillingTab() {
  const isPremium = currentCompany?.is_premium || false;
  const stripeCustomerId = currentCompany?.stripe_customer_id || null;
  const stripeSubscriptionId = currentCompany?.stripe_subscription_id || null;
  const stripePriceId = currentCompany?.stripe_price_id || null;
  // Handle stripe_current_period_end - could be timestamp (number) or ISO string
  let currentPeriodEnd = currentCompany?.stripe_current_period_end || null;
  if (currentPeriodEnd) {
    // If it's a Unix timestamp (number), convert to Date
    if (typeof currentPeriodEnd === 'number') {
      currentPeriodEnd = new Date(currentPeriodEnd * 1000).toISOString();
    } else if (typeof currentPeriodEnd === 'string' && !currentPeriodEnd.includes('T') && !isNaN(currentPeriodEnd)) {
      // If it's a string that's a number (Unix timestamp as string), convert it
      currentPeriodEnd = new Date(parseInt(currentPeriodEnd) * 1000).toISOString();
    }
  }
  const cancelAtPeriodEnd = currentCompany?.cancel_at_period_end || false;

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  };

  // Calculate days remaining if cancellation is scheduled
  let daysRemaining = null;
  if (cancelAtPeriodEnd && currentPeriodEnd) {
    const endDate = new Date(currentPeriodEnd);
    const now = new Date();
    const diffTime = endDate - now;
    daysRemaining = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  }

  return `
    <div style="max-width: 800px;">
      <h2 style="
        margin: 0 0 1.5rem 0;
        font-size: 1.5rem;
        font-weight: 700;
        color: ${colors.text};
      ">Manage Subscription</h2>

      <!-- Current Plan Card -->
      <div style="
        background: white;
        border-radius: 0.75rem;
        padding: 1.5rem;
        margin-bottom: 1.5rem;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
      ">
        <div style="display: flex; align-items: center; margin-bottom: 1rem;">
          <span style="font-size: 1.5rem; color: ${isPremium ? '#10b981' : colors.textTertiary}; margin-right: 0.5rem;">★</span>
          <h3 style="margin: 0; font-size: 1.125rem; font-weight: 600; color: ${colors.text};">
            Current Plan
          </h3>
        </div>
        
        <div style="
          font-size: 1.5rem; 
          font-weight: 700; 
          color: ${isPremium ? '#047857' : colors.text}; 
          margin-bottom: 0.25rem;
        ">
          ${isPremium ? 'Premium Plan' : 'Free Plan'}
        </div>
        <div style="font-size: 1rem; color: ${colors.textSecondary};">
          ${isPremium ? '1 Premium account' : 'Basic access'}
        </div>
      </div>

      <!-- Payment Details Card (Only if Premium) -->
      ${isPremium ? `
      <div style="
        background: ${cancelAtPeriodEnd ? '#fef3c7' : 'white'};
        border: ${cancelAtPeriodEnd ? '1px solid #fcd34d' : 'none'};
        border-radius: 0.75rem;
        padding: 1.5rem;
        margin-bottom: 1.5rem;
        box-shadow: ${cancelAtPeriodEnd ? 'none' : '0 1px 3px rgba(0,0,0,0.1)'};
      ">
        <h3 style="
          margin: 0 0 1rem 0; 
          font-size: 1.125rem; 
          font-weight: 600; 
          color: ${cancelAtPeriodEnd ? '#92400e' : colors.text};
        ">
          Payment Details
        </h3>
        
        <div style="display: flex; align-items: center; gap: 0.5rem; margin-bottom: 0.5rem;">
          <span style="font-size: 1.25rem;">${cancelAtPeriodEnd ? '📅' : '🔄'}</span>
          <span style="color: ${cancelAtPeriodEnd ? '#92400e' : colors.textSecondary}; font-size: 0.875rem;">
            ${cancelAtPeriodEnd ? 'Last day of subscription' : 'Next renewal date'}
          </span>
        </div>
        
        <div style="
          color: ${cancelAtPeriodEnd ? '#92400e' : colors.text}; 
          font-size: 1rem; 
          font-weight: 500; 
          margin-left: 1.75rem;
        ">
          ${currentPeriodEnd
        ? formatDate(currentPeriodEnd)
        : 'Available after sync'
      }
        </div>

        ${cancelAtPeriodEnd ? `
          <div style="
            color: #92400e; 
            font-size: 0.875rem; 
            margin-top: 1rem; 
            font-style: italic;
          ">
            Your subscription has been scheduled for cancellation at the end of your current billing period. Premium features will remain active until then.
          </div>
        ` : ''}

        <div style="display: grid; gap: 1rem; margin-top: 1.5rem; margin-left: 1.75rem;">
            ${stripeCustomerId ? `
              <div>
                <div style="font-size: 0.75rem; color: ${colors.textSecondary}; margin-bottom: 0.25rem;">
                  Customer ID
                </div>
                <div style="font-size: 0.875rem; color: ${colors.text}; font-family: monospace;">
                  ${stripeCustomerId}
                </div>
              </div>
            ` : ''}
        </div>
      </div>
      ` : `
      <!-- Free Plan Payment Details -->
      <div style="
        background: white;
        border-radius: 0.75rem;
        padding: 1.5rem;
        margin-bottom: 1.5rem;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
      ">
        <h3 style="
          margin: 0 0 1rem 0; 
          font-size: 1.125rem; 
          font-weight: 600; 
          color: ${colors.text};
        ">
          Payment Details
        </h3>
        <div style="font-size: 0.875rem; color: ${colors.textSecondary};">
          You are currently on a free or expired trial. You will not be charged.
        </div>
      </div>
      `}
      ${!cancelAtPeriodEnd ? `
      <!-- Action Card -->
      <div style="
        background: white;
        border-radius: 0.75rem;
        padding: 1.5rem;
        margin-bottom: 1.5rem;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
      ">
        <h3 style="margin: 0 0 0.5rem 0; font-size: 1.25rem; font-weight: 700; color: ${colors.text};">
          ${isPremium ? 'Available plans' : 'Get Premium'}
        </h3>
        <p style="margin: 0 0 1.5rem 0; font-size: 0.875rem; color: ${colors.textSecondary};">
          ${isPremium
        ? 'View or change your subscription plan directly with Stripe.'
        : 'Unlock advanced features and priority support by upgrading today.'}
        </p>
        
        <button
          onclick="${isPremium ? 'openStripeCustomerPortal()' : 'startBillingUpgrade()'}"
          style="
            background: ${colors.primary};
            color: white;
            border: none;
            padding: 0.75rem 1.5rem;
            border-radius: 0.5rem;
            font-weight: 600;
            cursor: pointer;
            font-size: 0.9375rem;
            width: 100%;
            transition: all 0.2s;
          "
          onmouseover="this.style.opacity='0.9'"
          onmouseout="this.style.opacity='1'"
        >
          ${isPremium ? 'Manage Subscription' : 'Upgrade Now'}
        </button>
      </div>
      
      ${isPremium ? `
        <!-- Secondary Cancel Button -->
        <div style="margin-top: 1rem; text-align: center;">
          <button
            onclick="cancelSubscription()"
            style="
              background: transparent;
              color: ${colors.error};
              border: 1px solid ${colors.error};
              padding: 0.5rem 1rem;
              border-radius: 0.5rem;
              font-weight: 600;
              cursor: pointer;
              font-size: 0.875rem;
              transition: all 0.2s;
            "
            onmouseover="this.style.background='#fef2f2'"
            onmouseout="this.style.background='transparent'"
          >
            Cancel Subscription
          </button>
        </div>
      ` : ''}
      ` : ''}

      <!-- Billing Information -->
      ${isPremium ? `
        <div style="
          background: white;
          border-radius: 0.75rem;
          padding: 1.5rem;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        ">
          <h3 style="margin: 0 0 1rem 0; font-size: 1.125rem; font-weight: 600; color: ${colors.text};">
            Billing Information
          </h3>
          <p style="color: ${colors.textSecondary}; font-size: 0.9375rem; margin: 0;">
            For support please contact us at <a href="mailto:contact@hellohabanero.com" style="color: ${colors.primary}; text-decoration: none;">contact@hellohabanero.com</a> for any help
          </p>
        </div>
      ` : ''}
    </div>
  `;
}

// ----------------------------------------------------------------------
// Subscription & Stripe Handlers
// ----------------------------------------------------------------------

window.startBillingUpgrade = async function () {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    const token = session?.access_token;

    if (!token) {
      alert('Authentication error. Please log in again.');
      return;
    }

    // Show loading state (could be improved with a spinner)
    const btn = document.querySelector('button[onclick="startBillingUpgrade()"]');
    if (btn) {
      btn.dataset.originalText = btn.innerText;
      btn.disabled = true;
      btn.innerText = 'Loading...';
    }

    // Call our backend endpoint to create a Stripe Checkout session
    // Redirects to Stripe Checkout
    const returnUrl = window.location.origin + window.location.pathname + '?tab=billing';

    const response = await fetch('/api/stripe/create-checkout-session', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        returnUrl: returnUrl
      })
    });

    const data = await response.json();

    if (data.url) {
      window.location.href = data.url;
    } else {
      throw new Error(data.error || 'Failed to create checkout session');
    }
  } catch (err) {
    console.error('Error starting billing upgrade:', err);
    alert('Failed to start upgrade process. Please try again.');

    const btn = document.querySelector('button[onclick="startBillingUpgrade()"]');
    if (btn && btn.dataset.originalText) {
      btn.disabled = false;
      btn.innerText = btn.dataset.originalText;
    }
  }
}

window.openStripeCustomerPortal = async function () {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    const token = session?.access_token;

    if (!token) {
      alert('Please log in to manage your subscription.');
      return;
    }

    // Show loading state
    const btn = document.querySelector('button[onclick="openStripeCustomerPortal()"]');
    if (btn) {
      btn.dataset.originalText = btn.innerText;
      btn.disabled = true;
      btn.innerText = 'Loading...';
    }

    const returnUrl = window.location.origin + window.location.pathname + '?tab=billing';

    const response = await fetch('/api/stripe/create-portal-session', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        returnUrl: returnUrl
      })
    });

    const data = await response.json();

    if (data.url) {
      window.location.href = data.url;
    } else {
      throw new Error(data.error || 'Failed to open customer portal');
    }
  } catch (err) {
    console.error('Error opening customer portal:', err);
    alert('Failed to open billing settings. Please try again.');

    const btn = document.querySelector('button[onclick="openStripeCustomerPortal()"]');
    if (btn && btn.dataset.originalText) {
      btn.disabled = false;
      btn.innerText = btn.dataset.originalText;
    }
  }
}

window.cancelSubscription = async function () {
  if (!confirm('Are you sure you want to cancel your Premium subscription? You will still have access until the end of your current billing period.')) {
    return;
  }

  // They can cancel by going to the portal. It's much safer and easier
  // than trying to implement cancellation through the API directly right now.
  await window.openStripeCustomerPortal();
}

// Save Service Function
window.saveService = async function (event) {
  event.preventDefault();

  if (!currentCompany) {
    showNotification('No company selected', 'error');
    return;
  }

  const titleInput = document.getElementById('service-title');
  const descriptionInput = document.getElementById('service-description');
  const categoryInput = document.getElementById('service-category');
  const priceInput = document.getElementById('service-price');

  if (!titleInput) {
    showNotification('Form fields not found', 'error');
    return;
  }

  const name = titleInput.value.trim();
  const description = descriptionInput?.value.trim() || null;
  const category = categoryInput?.value.trim() || null;
  const price = priceInput?.value ? parseFloat(priceInput.value) : null;

  if (!name) {
    showNotification('Service title is required', 'error');
    return;
  }

  try {
    if (editingServiceId) {
      // Update existing service
      const { error } = await supabase
        .from('services')
        .update({
          name: name,
          description: description,
          category: category,
          price: price,
          updated_at: new Date().toISOString()
        })
        .eq('id', editingServiceId)
        .eq('company_id', currentCompany.id);

      if (error) {
        console.error('Error updating service:', error);
        showNotification('Failed to update service: ' + error.message, 'error');
        return;
      }

      showNotification('Service updated successfully', 'success');
    } else {
      // Create new service
      const { error } = await supabase
        .from('services')
        .insert({
          company_id: currentCompany.id,
          name: name,
          description: description,
          category: category,
          price: price,
          created_at: new Date().toISOString(),
          updated_at: new Date().toISOString()
        });

      if (error) {
        console.error('Error creating service:', error);
        showNotification('Failed to create service: ' + error.message, 'error');
        return;
      }

      showNotification('Service created successfully', 'success');
    }

    // Reload services
    await loadServices();

    // Close modal and reset state
    showAddServiceModal = false;
    editingServiceId = null;

    // Re-render to update UI and remove modal
    renderPMTool();
  } catch (error) {
    console.error('Error saving service:', error);
    showNotification('An unexpected error occurred: ' + error.message, 'error');
  }
};

// Delete Service Function
window.deleteService = async function (serviceId) {
  if (!confirm('Are you sure you want to delete this service?')) {
    return;
  }

  if (!currentCompany) {
    showNotification('No company selected', 'error');
    return;
  }

  try {
    const { error } = await supabase
      .from('services')
      .delete()
      .eq('id', serviceId)
      .eq('company_id', currentCompany.id);

    if (error) {
      console.error('Error deleting service:', error);
      showNotification('Failed to delete service: ' + error.message, 'error');
      return;
    }

    // Reload services
    await loadServices();

    // Re-render to update UI and show changes
    renderPMTool();

    showNotification('Service deleted successfully', 'success');
  } catch (error) {
    console.error('Error deleting service:', error);
    showNotification('An unexpected error occurred: ' + error.message, 'error');
  }
};

// Render Edit Member Modal
function renderEditMemberModal() {
  const member = teamMembers.find(m => m.id === editingMemberId);
  if (!member) return '';

  const currentRole = member.company_role || 'EMPLOYEE';
  const firstName = member.first_name || '';
  const lastName = member.last_name || '';
  const phone = member.phone || '';

  return `
        < div
id = "edit-member-modal-overlay"
onclick = "if (event.target.id === 'edit-member-modal-overlay') closeEditMemberModal()"
style = "
position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.6);
      z - index: 10000;
    display: flex;
    align - items: center;
    justify - content: center;
    padding: 1rem;
    "
      >
      <div
        onclick="event.stopPropagation()"
        style="
          background: #ffffff;
          border-radius: 1rem;
          width: 100%;
          max-width: 500px;
          max-height: 90vh;
          overflow-y: auto;
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
        "
      >
        <!-- Header -->
        <div style="
          padding: 1.5rem;
          border-bottom: 1px solid ${colors.border};
          display: flex;
          justify-content: space-between;
          align-items: center;
        ">
          <h2 style="
            margin: 0;
            font-size: 1.5rem;
            font-weight: 700;
            color: ${colors.text};
          ">Edit Member</h2>
          <button
            onclick="closeEditMemberModal()"
            style="
              background: transparent;
              border: none;
              color: ${colors.textSecondary};
              cursor: pointer;
              font-size: 1.5rem;
              padding: 0;
              width: 32px;
              height: 32px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 50%;
            "
            onmouseover="this.style.background='#f3f4f6'"
            onmouseout="this.style.background='transparent'"
          >
            ×
          </button>
        </div>

        <!-- Form -->
        <form
          onsubmit="saveMemberChanges(); return false;"
          style="padding: 1.5rem; display: flex; flex-direction: column; gap: 1.5rem;"
        >
          <!-- First Name -->
          <div>
            <label style="
              display: block;
              font-size: 0.875rem;
              font-weight: 600;
              color: ${colors.text};
              margin-bottom: 0.5rem;
            ">
              First Name *
            </label>
            <input
              type="text"
              id="edit-member-first-name"
              value="${firstName}"
              required
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-size: 0.9375rem;
                box-sizing: border-box;
              "
              onfocus="this.style.borderColor='${colors.primary}'"
              onblur="this.style.borderColor='${colors.border}'"
            />
          </div>

          <!-- Last Name -->
          <div>
            <label style="
              display: block;
              font-size: 0.875rem;
              font-weight: 600;
              color: ${colors.text};
              margin-bottom: 0.5rem;
            ">
              Last Name *
            </label>
            <input
              type="text"
              id="edit-member-last-name"
              value="${lastName}"
              required
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-size: 0.9375rem;
                box-sizing: border-box;
              "
              onfocus="this.style.borderColor='${colors.primary}'"
              onblur="this.style.borderColor='${colors.border}'"
            />
          </div>

          <!-- Phone -->
          <div>
            <label style="
              display: block;
              font-size: 0.875rem;
              font-weight: 600;
              color: ${colors.text};
              margin-bottom: 0.5rem;
            ">
              Phone Number
            </label>
            <input
              type="tel"
              id="edit-member-phone"
              value="${phone}"
              placeholder="Enter phone number"
              style="
                width: 100%;
                padding: 0.75rem;
                border: 1px solid ${colors.border};
                border-radius: 0.5rem;
                font-size: 0.9375rem;
                box-sizing: border-box;
              "
              onfocus="this.style.borderColor='${colors.primary}'"
              onblur="this.style.borderColor='${colors.border}'"
            />
          </div>

          <!-- Role Selection -->
          <div>
            <label style="
              display: block;
              font-size: 0.875rem;
              font-weight: 600;
              color: ${colors.text};
              margin-bottom: 0.75rem;
            ">
              Role *
            </label>
            <div style="display: flex; flex-direction: column; gap: 0.75rem;">
              ${['OWNER', 'MANAGER', 'EMPLOYEE'].map(role => {
    const isSelected = currentRole === role;
    const roleColors = {
      'OWNER': { bg: '#f59e0b', text: 'white' },
      'MANAGER': { bg: '#3b82f6', text: 'white' },
      'EMPLOYEE': { bg: '#dc2626', text: 'white' }
    };
    const roleColor = roleColors[role];

    return `
                  <label style="
                    display: flex;
                    align-items: center;
                    gap: 0.75rem;
                    padding: 0.875rem;
                    border: 2px solid ${isSelected ? roleColor.bg : colors.border};
                    border-radius: 0.5rem;
                    background: ${isSelected ? roleColor.bg + '15' : 'transparent'};
                    cursor: pointer;
                    transition: all 0.2s;
                  "
                  onmouseover="this.style.borderColor='${roleColor.bg}'; this.style.background='${roleColor.bg}20'"
                  onmouseout="this.style.borderColor='${isSelected ? roleColor.bg : colors.border}'; this.style.background='${isSelected ? roleColor.bg + '15' : 'transparent'}'"
                  >
                    <input
                      type="radio"
                      name="member-role"
                      value="${role}"
                      ${isSelected ? 'checked' : ''}
                      style="
                        width: 20px;
                        height: 20px;
                        cursor: pointer;
                      "
                    />
                    <div style="flex: 1;">
                      <div style="
                        font-weight: 600;
                        color: ${colors.text};
                        margin-bottom: 0.25rem;
                      ">
                        ${role}
                      </div>
                    </div>
                    ${isSelected ? `
                      <span style="
                        background: ${roleColor.bg};
                        color: ${roleColor.text};
                        padding: 0.25rem 0.75rem;
                        border-radius: 1rem;
                        font-size: 0.75rem;
                        font-weight: 600;
                      ">
                        Current
                      </span>
                    ` : ''}
                  </label>
                `;
  }).join('')}
            </div>
          </div>

          <!-- Actions -->
          <div style="
            display: flex;
            gap: 0.75rem;
            justify-content: space-between;
            margin-top: 1rem;
            padding-top: 1.5rem;
            border-top: 1px solid ${colors.border};
          ">
            <button
              type="button"
              onclick="showDeleteMemberConfirmation('${editingMemberId}')"
              style="
                background: #dc2626;
                color: white;
                border: none;
                padding: 0.75rem 1.5rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-weight: 600;
                font-size: 0.9375rem;
              "
              onmouseover="this.style.background='#b91c1c'"
              onmouseout="this.style.background='#dc2626'"
            >
              Delete Member
            </button>
            <div style="display: flex; gap: 0.75rem;">
              <button
                type="button"
                onclick="closeEditMemberModal()"
                style="
                  background: #f3f4f6;
                  color: ${colors.text};
                  border: none;
                  padding: 0.75rem 1.5rem;
                  border-radius: 0.5rem;
                  cursor: pointer;
                  font-weight: 600;
                  font-size: 0.9375rem;
                "
                onmouseover="this.style.background='#e5e7eb'"
                onmouseout="this.style.background='#f3f4f6'"
              >
                Cancel
              </button>
              <button
                type="submit"
                style="
                  background: #f59e0b;
                  color: white;
                  border: none;
                  padding: 0.75rem 1.5rem;
                  border-radius: 0.5rem;
                  cursor: pointer;
                  font-weight: 600;
                  font-size: 0.9375rem;
                "
                onmouseover="this.style.background='#d97706'"
                onmouseout="this.style.background='#f59e0b'"
              >
                Save Changes
              </button>
            </div>
          </div>
        </form>
      </div>
    </div >
      `;
}

// View task details (placeholder)
function viewTaskDetails(taskId) {
  alert(`View task details ${taskId} - coming soon!`);
}

// Listen for auth state changes
supabase.auth.onAuthStateChange((event, session) => {
  if (event === 'SIGNED_IN' && session?.user) {
    loadUserData().then(() => {
      // Mobile/small viewport: show app recommendation and stay until user clicks Continue (once per session)
      const userChoseWebAuth = (function () {
        try {
          return typeof sessionStorage !== 'undefined' && sessionStorage.getItem('helo_use_web_version') === '1';
        } catch (e) { return false; }
      })();
      if (window.isMobileDevice && window.isMobileDevice() && !userChoseWebAuth) {
        console.log('📱 Auth: small viewport / mobile - showing mobile app recommendation');
        renderClientLockedScreen();
        return;
      }
      // Check trial status before rendering the app
      if (isCompanyTrialExpired(currentCompany)) {
        console.log('🔒 Trial expired for company:', currentCompany?.name);
        renderTrialExpiredScreen(currentCompany);
        return;
      }
      renderPMTool();
    });
  } else if (event === 'SIGNED_OUT') {
    renderLogin();
  }
});

// When user resizes from big to small: show mobile recommendation once per session (if they haven't clicked Continue)
function checkShowMobileRecommendationOnResize() {
  try {
    if (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('helo_use_web_version') === '1') return;
    if (!window.isMobileDevice || !window.isMobileDevice()) return;
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (!session?.user) return;
      console.log('📱 Resize: small viewport - showing mobile app recommendation');
      renderClientLockedScreen();
    });
  } catch (e) { }
}
var mobileRecommendationResizeTimeout;
window.addEventListener('resize', function () {
  clearTimeout(mobileRecommendationResizeTimeout);
  mobileRecommendationResizeTimeout = setTimeout(checkShowMobileRecommendationOnResize, 200);
});

// Initialize the app with error handling
try {
  initApp();
} catch (error) {
  console.error('❌ Critical error during app initialization:', error);
  document.getElementById('root').innerHTML = `
      < div style = "
    display: flex;
    justify - content: center;
    align - items: center;
    min - height: 100vh;
    font - family: -apple - system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans - serif;
    background: #f8fafc;
    ">
      < div style = "text-align: center; padding: 2rem;" >
        <h1 style="color: #ef4444; margin-bottom: 1rem;">❌ Critical Error</h1>
        <p style="color: #64748b;">The app failed to initialize.</p>
        <p style="color: #64748b; font-size: 0.875rem; margin-top: 0.5rem;">${error.message}</p>
        <button onclick="location.reload()" style="
          background: #ea580c;
          color: white;
          border: none;
          padding: 0.75rem 1.5rem;
          border-radius: 0.5rem;
          cursor: pointer;
          margin-top: 1rem;
        ">
          Refresh Page
        </button>
      </div >
    </div >
      `;
}

// ============================================
// EVA AI SERVICE FUNCTIONS
// ============================================

// NOTE: OpenAI API key is now handled server-side via Supabase Edge Function
// The getOpenAIApiKey function has been removed for security reasons.
// All AI requests now go through /functions/v1/ai-chat which keeps the API key secure.

// Get user language preference
const getEvaUserLanguage = () => {
  try {
    return localStorage.getItem('locale') || 'en';
  } catch {
    return 'en';
  }
};

// Get comprehensive user context for Eva
async function getEvaUserContext(userId) {
  try {
    if (!userId) {
      console.error('No userId provided to getEvaUserContext');
      return null;
    }

    // Get user data
    const { data: userData, error: userError } = await supabase
      .from('profiles')
      .select(`
    id,
      first_name,
      last_name,
      role,
      company_role,
      company_id
        `)
      .eq('id', userId)
      .single();

    if (userError || !userData) {
      console.error('Error fetching user data for Eva:', userError);
      return null;
    }

    if (!userData.company_id) {
      console.warn('User has no company_id');
      // Return minimal context if no company
      return {
        currentPage: evaCurrentPage,
        userData: {
          id: userData.id,
          name: `${userData.first_name || ''} ${userData.last_name || ''} `.trim() || 'User',
          role: userData.company_role || userData.role || 'USER',
          company_id: undefined
        },
        recentActivity: {
          tasks: [],
          appointments: [],
          reminders: [],
          chats: [],
          contacts: [],
          projects: [],
          salesOpportunities: [],
          unreadMessageCount: 0,
          unreadMessages: []
        },
        teamMembers: []
      };
    }

    // Get tasks assigned to user - query through task_assignees
    let evaTasks = [];
    try {
      // First get task IDs assigned to user
      const { data: assigneesData } = await supabase
        .from('task_assignees')
        .select('task_id')
        .eq('user_id', userId);

      if (assigneesData && assigneesData.length > 0) {
        const taskIds = assigneesData.map(a => a.task_id);

        const { data: tasksData } = await supabase
          .from('tasks')
          .select(`
    id,
      title,
      description,
      due_at,
      priority,
      state,
      company_id
        `)
          .in('id', taskIds)
          .eq('company_id', userData.company_id)
          .order('due_at', { ascending: true })
          .limit(50);

        evaTasks = (tasksData || []).map(task => ({
          ...task,
          is_overdue: task.due_at && task.state !== 'COMPLETED' ? new Date(task.due_at) < new Date() : false,
          is_completed: task.state === 'COMPLETED',
          is_incomplete: task.state !== 'COMPLETED'
        }));
      }
    } catch (error) {
      console.warn('Error fetching tasks for Eva:', error);
    }

    // Get appointments
    let evaAppointments = [];
    try {
      const { data: appointmentsData } = await supabase
        .from('appointments')
        .select(`
    id,
      title,
      appointment_date,
      start_time,
      status,
      company_id
        `)
        .eq('company_id', userData.company_id)
        .eq('assigned_to', userId)
        .order('appointment_date', { ascending: true })
        .limit(20);

      evaAppointments = appointmentsData || [];
    } catch (error) {
      console.warn('Error fetching appointments for Eva:', error);
    }

    // Get reminders
    let evaReminders = [];
    try {
      const { data: remindersData } = await supabase
        .from('reminders')
        .select(`
    id,
      title,
      due_at,
      priority,
      status,
      company_id
        `)
        .eq('company_id', userData.company_id)
        .eq('owner_id', userId)
        .order('due_at', { ascending: true })
        .limit(20);

      evaReminders = remindersData || [];
    } catch (error) {
      console.warn('Error fetching reminders for Eva:', error);
    }

    // Get chats
    let evaChats = [];
    let unreadCount = 0;
    try {
      const { data: chatsData } = await supabase
        .from('chat_participants')
        .select(`
    chats(
      id,
      title,
      custom_name,
      chat_type
    )
      `)
        .eq('user_id', userId)
        .limit(20);

      evaChats = (chatsData || []).map(cp => cp.chats).filter(Boolean);

      if (chatUnreadCounts) {
        unreadCount = Object.values(chatUnreadCounts).reduce((sum, count) => sum + count, 0);
      }
    } catch (error) {
      console.warn('Error fetching chats for Eva:', error);
    }

    // Get contacts
    let evaContacts = [];
    try {
      const { data: contactsData } = await supabase
        .from('contacts')
        .select(`
    id,
      first_name,
      last_name,
      email,
      pipeline_stage,
      company_id
        `)
        .eq('company_id', userData.company_id)
        .limit(50);

      evaContacts = contactsData || [];
    } catch (error) {
      console.warn('Error fetching contacts for Eva:', error);
    }

    // Get projects
    let evaProjects = [];
    try {
      const { data: projectsData } = await supabase
        .from('projects')
        .select(`
    id,
      name,
      description,
      status,
      progress_percentage,
      due_date,
      company_id
        `)
        .eq('company_id', userData.company_id)
        .order('created_at', { ascending: false })
        .limit(50);

      evaProjects = (projectsData || []).map(project => ({
        ...project,
        status_normalized: (project.status || '').toLowerCase(),
        is_active: (project.status || '').toLowerCase() === 'active',
        is_completed: (project.status || '').toLowerCase() === 'completed',
        is_overdue: project.due_date && new Date(project.due_date) < new Date() && (project.status || '').toLowerCase() !== 'completed'
      }));
    } catch (error) {
      console.warn('Error fetching projects for Eva:', error);
    }

    // Get sales opportunities
    let evaSalesOpportunities = [];
    try {
      const { data: opportunitiesData } = await supabase
        .from('sales_opportunities')
        .select(`
    id,
      contact_id,
      amount,
      stage,
      probability,
      expected_close_date,
      company_id
        `)
        .eq('company_id', userData.company_id)
        .limit(50);

      evaSalesOpportunities = opportunitiesData || [];
    } catch (error) {
      console.warn('Error fetching sales opportunities for Eva:', error);
    }

    // Get team members
    let evaTeamMembers = [];
    try {
      const { data: membersData } = await supabase
        .from('profiles')
        .select(`
    id,
      first_name,
      last_name,
      role,
      company_role
        `)
        .eq('company_id', userData.company_id)
        .limit(50);

      evaTeamMembers = membersData || [];
    } catch (error) {
      console.warn('Error fetching team members for Eva:', error);
    }

    return {
      currentPage: evaCurrentPage,
      userData: {
        id: userData.id,
        name: `${userData.first_name || ''} ${userData.last_name || ''} `.trim() || 'User',
        role: userData.company_role || userData.role || 'USER',
        company_id: userData.company_id
      },
      recentActivity: {
        tasks: evaTasks,
        appointments: evaAppointments,
        reminders: evaReminders,
        chats: evaChats,
        contacts: evaContacts,
        projects: evaProjects,
        salesOpportunities: evaSalesOpportunities,
        unreadMessageCount: unreadCount,
        unreadMessages: []
      },
      teamMembers: evaTeamMembers
    };
  } catch (error) {
    console.error('Error getting Eva user context:', error);
    // Return minimal context on error instead of null
    return {
      currentPage: evaCurrentPage,
      userData: {
        id: userId,
        name: 'User',
        role: 'USER',
        company_id: undefined
      },
      recentActivity: {
        tasks: [],
        appointments: [],
        reminders: [],
        chats: [],
        contacts: [],
        projects: [],
        salesOpportunities: [],
        unreadMessageCount: 0,
        unreadMessages: []
      },
      teamMembers: []
    };
  }
}

// Build system prompt for Eva
function buildEvaSystemPrompt(context, language) {
  const isSpanish = language === 'es';

  const basePrompt = isSpanish
    ? `Eres Eva, un asistente de IA profesional y amigable para Helo App.Tu rol es ayudar a los usuarios a entender cómo usar la aplicación Helo App.

🚨 REGLAS CRÍTICAS:
    1. SOLO proporcionas información y guía sobre cómo usar la aplicación
    2. NO puedes crear tareas, enviar mensajes, agregar citas, o modificar datos
    3. Respondes preguntas sobre cómo usar las características de la aplicación
    4. Explicas paso a paso cómo realizar acciones en la aplicación
    5. Proporcionas consejos y mejores prácticas

🎯 LO QUE PUEDES HACER:

** 1. Guía de la Aplicación:**
      - "¿Cómo creo una tarea?"
      - "¿Cómo uso la página de equipo?"
      - "¿Cómo programo un mensaje?"
      - "¿Cómo funcionan los roles?"
      - "¿Cómo marco entrada?"
      - "¿Cómo creo un contrato?"
      - "¿Cómo veo mi hoja de tiempo?"
      - "¿Cómo cambio a la vista de proyectos?"

📖 BASE DE CONOCIMIENTOS - GUÍA DE LA APLICACIÓN:

** NAVEGACIÓN Y ESTRUCTURA:**

** Roles de Usuario:**
      - ADMIN: Acceso a administración global del sistema
        - OWNER: Acceso completo a gestión de compañía
          - MANAGER: Gestión de equipo, contactos, reportes
            - EMPLOYEE: Ver / completar tareas asignadas
              - CLIENT: Solo dashboard del cliente y chats
                - USER: Recursos, chat y perfil únicamente

                  ** Pestañas Principales:**
                    1. Recursos: Recursos de compañía, servicios
    2. Equipo: Tareas personales y de equipo, calendario
    3. Contactos: Lista de contactos, pipeline de ventas, reportes
    4. Chat: Conversaciones en tiempo real
    5. Perfil: Configuración, gestión de compañía

      ** PÁGINA DE EQUIPO:**
        - Cómo crear tarea: Botón "+", llenar título(obligatorio), descripción, fecha de vencimiento, prioridad(BAJA / MEDIA / ALTA / URGENTE), asignar miembros
          - Cómo cambiar estado de tarea: Click en botón de estado en la tarjeta → seleccionar BACKLOG / ACTIVE / COMPLETED
            - Cómo agregar comentarios: Abrir detalles de tarea → sección de comentarios → escribir y enviar
              - Filtros: Por estado, prioridad, asignado, búsqueda por título
                - Vista de calendario: Icono de calendario en encabezado

                  ** PÁGINA DE CHAT:**
                    - Tipos de chat: Proyecto(vinculado a proyecto), Contacto(vinculado a cliente), General(discusiones de equipo), Solicitud de Servicio
                      - Cómo crear chat: Botón "+", elegir tipo, seleccionar participantes
                        - Enviar mensajes: Texto, fotos(cámara o biblioteca), archivos(PDFs, docs)
                          - Programar mensajes: Menú "⋯" → "Programar Mensaje" → establecer fecha / hora
                            - Solicitar medios: Menú "⋯" → "Solicitar Medios" → cliente puede aceptar / rechazar

                              ** PÁGINA DE CONTACTOS:**
                                - Cómo agregar contacto: Botón "+", llenar nombre(obligatorio), email, teléfono, compañía, etapa del pipeline, asignar a miembro del equipo
                                  - Pestañas de detalles del contacto: Vista General, Proyectos, Tareas, Chats, Archivos, Citas, Recordatorios, Oportunidades de Venta, Actividad
                                    - Pipeline de ventas: Etapas: Nuevo → Contactado → Calificado → Propuesta → Negociación → Ganado / Perdido
                                      - Cómo crear proyecto: En pestaña de Proyectos → "+ Crear Proyecto" → nombre, descripción, estado, fechas, miembros asignados
                                        - Cómo agregar cita: Pestaña de Citas → "+ Agregar Cita" → título, fecha, hora, ubicación, notas
                                          - Cómo agregar recordatorio: Pestaña de Recordatorios → "+ Agregar Recordatorio" → título, fecha / hora de vencimiento, prioridad(Baja / Media / Alta)

                                            ** PÁGINA DE PERFIL:**
                                              - Cambiar contraseña: Perfil → "Cambiar Contraseña"
                                                - Cambiar idioma: Perfil → alternar Idioma(Inglés / Español)
                                                  - Tema: Alternar entre modo claro y oscuro
                                                    - Gestión de compañía(OWNER / MANAGER): Perfil → "Gestión" → pestañas para Miembros del Equipo, Servicios de la Compañía, Clientes
                                                      - Administración global(ADMIN): Perfil → "Administración Global" → gestionar todos los usuarios y compañías

                                                        ** DASHBOARD DEL CLIENTE:**
                                                          - Ver proyectos: Activos, completados o todos
                                                            - Seguimiento de progreso: Barra de progreso, cuenta de tareas
                                                              - Solicitar servicio: Botón "Solicitar un Servicio" → llenar formulario → crea chat automáticamente con administradores de HH

                                                                ** CARACTERÍSTICAS DE GAMIFICACIÓN:**
                                                                  - Monedas: Ganadas al completar tareas(0 - 1000 por tarea)
                                                                    - Tabla de clasificación: Perfil → Tabla de clasificación → ver clasificaciones del equipo
                                                                      - Racha de inicio de sesión: Rastrear días consecutivos de inicio de sesión

                                                                        ** GESTIÓN DE ARCHIVOS:**
                                                                          - Tipos soportados: Imágenes(JPG, PNG, GIF, WEBP), PDFs, documentos(DOC, DOCX, XLS, XLSX, TXT), archivos ZIP, CSV
                                                                            - Límite de tamaño: 50MB por archivo
                                                                              - Ubicación: Todos los archivos compartidos en chats, organizados por usuario / chat

                                                                                ** PÁGINA DE SEGUIMIENTO DE TIEMPO:**
                                                                                  - Marcar Entrada / Salida: Rastrear horas de trabajo con seguimiento de ubicación, ver duración del turno actual
                                                                                    - Vista de Hoja de Tiempo: Ver entradas de tiempo detalladas, filtrar por rango de fechas, generar hojas de tiempo
                                                                                      - Tarifas por Hora: Establecer y gestionar tarifas por hora para empleados(solo Propietarios / Gerentes), ver historial de tarifas
                                                                                        - Solicitudes de Tiempo Libre: Solicitar y gestionar tiempo libre, ver solicitudes del equipo
                                                                                          - Resumen de Horas: Ver horas de hoy, esta semana y este mes
                                                                                            - Acceso: Disponible en aplicaciones nativas y web a través de la pantalla / pestaña "Seguimiento de Tiempo"

                                                                                              ** PÁGINA DE CONTRATOS(Aplicación Web):**
                                                                                                - Crear Contratos: Construir contratos con productos, cláusulas y precios, establecer tasa de impuestos global
                                                                                                  - Enviar Contratos: Enviar contratos por correo electrónico a clientes con enlaces de firma seguros(expiración de 14 días)
                                                                                                    - Firmar Contratos: Los clientes pueden firmar contratos electrónicamente a través de enlaces seguros en / sign / [token]
                                                                                                      - Estado del Contrato: Rastrear borrador, enviado, visto, firmado, expirado, cerrado, anulado
                                                                                                        - Gestión de Contratos: Filtrar por estado(todos, borrador, enviado, visto, firmado, expirado, cerrado), buscar contratos, ver detalles del contrato
                                                                                                          - Pestañas: Bandeja de entrada(lista de contratos), Productos(catálogo de productos), Cláusulas(biblioteca de cláusulas)
                                                                                                            - Acceso: Disponible en aplicación web a través de la pantalla "Contratos"(botones rojos / naranjas)

                                                                                                              ** NOTIFICACIONES DE APLICACIÓN WEB:**
                                                                                                                - Sistema de Notificaciones: Notificaciones en tiempo real en la aplicación web
                                                                                                                  - Tipos de Notificaciones: Actualizaciones de tareas, recordatorios de citas, cambios de estado de contratos, envíos de formularios, etc.
- Centro de Notificaciones: Ver todas las notificaciones en una ubicación centralizada a través del icono de campana de notificación
      - Acceso: Disponible en aplicación web a través del icono de campana de notificación en el encabezado

        ** VISTA VER PROYECTOS:**
          - Alternar Vista: Cambiar entre vistas "Ver proyectos" y "Ver tareas" usando el botón de alternancia
            - Vista de Proyectos: Ver proyectos organizados por carpetas(cuando se muestra el botón "Ver tareas")
              - Vista de Tareas: Ver tareas en formato de tablero kanban(cuando se muestra el botón "Ver proyectos")
                - Acceso: Disponible en aplicaciones nativas y web a través del botón de alternancia en la página de Herramienta PM / Equipo

                  ** SOLUCIÓN DE PROBLEMAS COMUNES:**

                    "No puedo ver la página de Equipo":
    - Causa: Tu rol es CLIENT o USER, o la compañía no es premium
      - Solución: La página de Equipo es solo para OWNER / MANAGER / EMPLOYEE con membresía premium de compañía

    "Mis mensajes no se envían":
    - Causa: Sin conexión a internet, chat archivado
      - Solución: Verificar WiFi / datos celulares, desarchivar el chat en configuración

    "No puedo eliminar una tarea/contacto":
    - Causa: Permisos insuficientes(solo OWNER / MANAGER pueden eliminar la mayoría de elementos)
      - Solución: Solicitar al propietario o gerente que elimine

    "La racha de inicio de sesión se reinició":
    - Explicación: Las rachas se reinician si no inicias sesión durante más de 24 horas

      ** MEJORES PRÁCTICAS:**

** Colaboración en equipo:**
      - Usar títulos de tarea claros y accionables
        - Establecer fechas de vencimiento realistas
          - Agregar descripciones con contexto
            - Usar chats de proyecto para discusiones relacionadas con el proyecto
              - Registrar todas las interacciones en la actividad del contacto

                ** Gestión de clientes:**
                  - Responder a clientes dentro de 24 horas
                    - Mantener actualizada la información del contacto
                      - Establecer recordatorios de seguimiento
                        - Mover contactos a través de las etapas del pipeline
                          - Actualizar el progreso del proyecto regularmente

                            ** Éxito en ventas:**
                              - Actualizar montos de negocios a medida que cambian
                                - Establecer fechas realistas de cierre esperado
                                  - Usar recordatorios para cada seguimiento
                                    - Marcar negocios perdidos para limpiar el pipeline
                                      - Registrar todos los puntos de contacto en actividad

🔍 CÓMO RESPONDER A PREGUNTAS:

** Para preguntas sobre la aplicación:**
      - Usa la base de conocimientos anterior para explicar características
        - Proporciona instrucciones paso a paso
          - Menciona roles / permisos cuando sean relevantes
            - Sugiere mejores prácticas cuando sea apropiado

🚨 RECUERDA: NUNCA uses frases como "Voy a crear...", "Lo agregaré...", "He programado...".Solo proporcionas información y guía sobre cómo usar la aplicación.

Mantente amigable, profesional y útil.Si no sabes algo, admítelo honestamente.`
    : `You are Eva, a professional and friendly AI assistant for Helo App.Your role is to help users understand how to use the Helo App.

🚨 CRITICAL RULES:
    1. You ONLY provide information and guidance about how to use the app
    2. You CANNOT create tasks, send messages, add appointments, or modify data
    3. You answer questions about how to use app features
    4. You explain step - by - step how to perform actions in the app
    5. You provide tips and best practices

🎯 WHAT YOU CAN DO:

** 1. App Guidance:**
      - "How do I create a task?"
      - "How do I use the team page?"
      - "How do I schedule a message?"
      - "How do roles work?"
      - "How do I clock in?"
      - "How do I create a contract?"
      - "How do I view my timesheet?"
      - "How do I switch to projects view?"

📖 KNOWLEDGE BASE - APP GUIDE:

** NAVIGATION & STRUCTURE:**

** User Roles:**
      - ADMIN: Global system administration access
        - OWNER: Full company management access
          - MANAGER: Team management, contacts, reports
            - EMPLOYEE: View / complete assigned tasks
              - CLIENT: Client dashboard and chats only
                - USER: Resources, chat, and profile only

                  ** Main Tabs:**
                    1. Resources: Company resources, services
    2. Team: Personal and team tasks, calendar
    3. Contacts: Contact list, sales pipeline, reports
    4. Chat: Real - time conversations
    5. Profile: Settings, company management

      ** TEAM PAGE:**
        - How to create task: "+" button, fill title(required), description, due date, priority(LOW / MEDIUM / HIGH / URGENT), assign members
          - How to change task status: Click status button on card → select BACKLOG / ACTIVE / COMPLETED
            - How to add comments: Open task details → comments section → type and send
    - Filters: By status, priority, assignee, search by title
      - Calendar view: Calendar icon in header

        ** CHAT PAGE:**
          - Chat types: Project(linked to project), Contact(linked to client), General(team discussions), Service Request
            - How to create chat: "+" button, choose type, select participants
              - Send messages: Text, photos(camera or library), files(PDFs, docs)
                - Schedule messages: "⋯" menu → "Schedule Message" → set date / time
                  - Request media: "⋯" menu → "Request Media" → client can accept / reject

                    ** CONTACTS PAGE:**
                      - How to add contact: "+" button, fill name(required), email, phone, company, pipeline stage, assign to team member
                        - Contact detail tabs: Overview, Projects, Tasks, Chats, Files, Appointments, Reminders, Sales Opportunities, Activity
                          - Sales pipeline: Stages: New → Contacted → Qualified → Proposal → Negotiation → Won / Lost
                            - How to create project: In Projects tab → "+ Create Project" → name, description, status, dates, assigned members
                              - How to add appointment: Appointments tab → "+ Add Appointment" → title, date, time, location, notes
                                - How to add reminder: Reminders tab → "+ Add Reminder" → title, due date / time, priority(Low / Medium / High)

                                  ** PROFILE PAGE:**
                                    - Change password: Profile → "Change Password"
                                      - Change language: Profile → toggle Language(English / Spanish)
                                        - Theme: Toggle between light and dark mode
                                          - Company management(OWNER / MANAGER): Profile → "Management" → tabs for Team Members, Company Services, Clients
                                            - Global admin(ADMIN): Profile → "Global Admin" → manage all users and companies

                                              ** CLIENT DASHBOARD:**
                                                - View projects: Active, completed, or all
                                                  - Track progress: Progress bar, task counts
                                                    - Request service: "Request a Service" button → fill form → automatically creates chat with HH admins

                                                      ** GAMIFICATION FEATURES:**
                                                        - Coins: Earned from completing tasks(0 - 1000 per task)
                                                          - Leaderboard: Profile → Leaderboard → see team rankings
                                                            - Login Streak: Track consecutive days of logging in

** FILE MANAGEMENT:**
      - Supported types: Images(JPG, PNG, GIF, WEBP), PDFs, Documents(DOC, DOCX, XLS, XLSX, TXT), ZIP files, CSV
        - Size limit: 50MB per file
          - Location: All files shared in chats, organized by user / chat

            ** TIME TRACKING PAGE:**
              - Clock In / Out: Track work hours with location tracking, view current shift duration
                - Timesheet View: View detailed time entries, filter by date range, generate timesheets
                  - Hourly Rates: Set and manage hourly rates for employees(Owners / Managers only), view rate history
                    - Time Off Requests: Request and manage time off, view team time off requests
                      - Hours Summary: View today's, this week's, and this month's hours
                        - Access: Available in both Native and Web apps via the "Time Tracking" screen / tab

                          ** CONTRACTS PAGE(Web App):**
                            - Create Contracts: Build contracts with products, clauses, and pricing, set global tax rate
                              - Send Contracts: Email contracts to clients with secure signing links(14 - day expiry)
                                - Sign Contracts: Clients can sign contracts electronically via secure links at / sign / [token]
                                  - Contract Status: Track draft, sent, viewed, signed, expired, closed, voided
                                    - Contract Management: Filter by status(all, draft, sent, viewed, signed, expired, closed), search contracts, view contract details
                                      - Tabs: Inbox(contracts list), Products(product catalog), Clauses(clause library)
                                        - Access: Available in Web app via the "Contracts" screen(red / orange buttons)

                                          ** WEB APP NOTIFICATIONS:**
                                            - Notification System: Real - time notifications in the web app
                                              - Notification Types: Task updates, appointment reminders, contract status changes, form submissions, etc.
- Notification Center: View all notifications in a centralized location via notification bell icon
      - Access: Available in Web app via notification bell icon in header

        ** SEE PROJECTS VIEW:**
          - Toggle View: Switch between "See projects" and "See tasks" views using toggle button
    - Projects View: View projects organized by folders(when "See tasks" button is shown)
      - Tasks View: View tasks in kanban board format(when "See projects" button is shown)
        - Access: Available in both Native and Web apps via toggle button in PM Tool / Team page

          ** COMMON TROUBLESHOOTING:**

            "I can't see the Team page":
    - Cause: Your role is CLIENT or USER, or company is not premium
      - Solution: Team page is only for OWNER / MANAGER / EMPLOYEE with premium company membership

    "My messages aren't sending":
    - Cause: No internet connection, chat archived
      - Solution: Check WiFi / cellular data, unarchive chat in settings

    "I can't delete a task/contact":
    - Cause: Insufficient permissions(only OWNER / MANAGER can delete most items)
      - Solution: Ask owner or manager to delete

        "Login streak reset":
    - Explanation: Streaks reset if you don't log in for more than 24 hours

      ** BEST PRACTICES:**

** Team Collaboration:**
      - Use clear, actionable task titles
        - Set realistic due dates
          - Add descriptions with context
          - Use project chats for project - related discussions
            - Log all interactions in contact activity

              ** Client Management:**
                - Respond to clients within 24 hours
                  - Keep contact info up to date
                    - Set follow - up reminders
                      - Move contacts through pipeline stages
                        - Update project progress regularly

                          ** Sales Success:**
                            - Update deal amounts as they change
                              - Set realistic expected close dates
                                - Use reminders for every follow - up
                                  - Mark lost deals to clean pipeline
                                    - Log all touchpoints in activity

🔍 HOW TO RESPOND TO QUESTIONS:

** For app questions:**
      - Use the knowledge base above to explain features
        - Provide step - by - step instructions
          - Mention roles / permissions when relevant
            - Suggest best practices where appropriate

🚨 REMEMBER: NEVER use phrases like "I'll create...", "I'll add...", "I've scheduled...".You only provide information and guidance about how to use the app.

Stay friendly, professional, and helpful.If you don't know something, admit it honestly.`;

  return basePrompt;
}

// Process Eva message and get AI response
async function processEvaMessage(message, context, conversationHistory = []) {
  try {
    const language = getEvaUserLanguage();

    // Get Supabase session for authentication
    const { data: { session }, error: sessionError } = await supabase.auth.getSession();

    if (sessionError || !session) {
      const isSpanish = language === 'es';
      throw new Error(isSpanish
        ? 'Autenticación requerida. Por favor, inicia sesión nuevamente.'
        : 'Authentication required. Please log in again.');
    }

    const systemPrompt = buildEvaSystemPrompt(context, language);

    // Build conversation history (convert to ChatMessage format)
    const messages = [
      ...conversationHistory.map(msg => ({
        role: msg.role,
        content: msg.content
      })),
      { role: 'user', content: message }
    ];

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 30000);

    try {
      // Call Supabase Edge Function instead of direct OpenAI API
      const response = await fetch(`${SUPABASE_URL}/functions/v1/ai-chat`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${session.access_token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          messages: messages, // Don't include system message here
          systemPrompt: systemPrompt, // Send system prompt separately
          conversationId: undefined // Eva doesn't use conversation IDs
        }),
        signal: controller.signal
      });

      clearTimeout(timeoutId);

      if (!response.ok) {
        let errorMessage = 'An error occurred while processing your request.';

        try {
          const errorData = await response.text();
          const errorJson = JSON.parse(errorData);

          if (errorJson.error === 'daily_limit_reached') {
            errorMessage = 'You have reached your daily chat limit. Please try again tomorrow.';
          } else if (errorJson.error === 'total_limit_reached') {
            errorMessage = 'You have reached your total chat limit. Please upgrade for unlimited access.';
          } else if (errorJson.error === 'content_flagged') {
            errorMessage = errorJson.message || 'I cannot reply to that for safety reasons. Please ask a different question.';
          } else if (errorJson.message) {
            errorMessage = errorJson.message;
          }
        } catch {
          // If parsing fails, use default error message
        }

        if (response.status === 401) {
          throw new Error('Authentication failed. Please log in again.');
        } else if (response.status === 429) {
          throw new Error(errorMessage);
        } else if (response.status >= 500) {
          throw new Error('Service is temporarily unavailable. Please try again later.');
        } else {
          throw new Error(errorMessage);
        }
      }

      const data = await response.json();
      const aiMessage = data.message;

      if (!aiMessage) {
        throw new Error('No response from AI service');
      }

      return aiMessage.trim();
    } catch (error) {
      clearTimeout(timeoutId);

      if (error.name === 'AbortError') {
        throw new Error('Request timed out. Please check your internet connection and try again.');
      } else if (error.message.includes('Failed to fetch') || error.message.includes('NetworkError')) {
        throw new Error('Network error. Please check your internet connection and try again.');
      }

      throw error;
    }
  } catch (error) {
    console.error('Eva AI Service error:', error);
    const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
    throw new Error(errorMessage);
  }
}

// Generate daily recap
async function generateEvaDailyRecap(context) {
  const language = getEvaUserLanguage();
  const isSpanish = language === 'es';

  const incompleteTasks = context.recentActivity.tasks.filter(t => t.state !== 'COMPLETED').length;
  const todayAppointments = context.recentActivity.appointments.filter(a => {
    // Parse appointment_date in local timezone to avoid UTC conversion issues
    const dateParts = a.appointment_date.split('-');
    let apptDate;
    if (dateParts.length === 3) {
      apptDate = new Date(
        parseInt(dateParts[0], 10),
        parseInt(dateParts[1], 10) - 1,
        parseInt(dateParts[2], 10)
      );
    } else {
      apptDate = new Date(a.appointment_date);
    }
    const today = new Date();
    return apptDate.toDateString() === today.toDateString() && a.status === 'scheduled';
  }).length;
  const overdueTasks = context.recentActivity.tasks.filter(t =>
    t.due_at && t.state !== 'COMPLETED' && new Date(t.due_at) < new Date()
  ).length;
  const unreadMessages = context.recentActivity.unreadMessageCount;
  const activeProjects = context.recentActivity.projects.filter(p => {
    const status = (p.status_normalized || '').toLowerCase();
    return status === 'active' || status === 'on_hold';
  }).length;

  if (isSpanish) {
    return `¡Buenos días, ${context.userData.name}! 👋

Aquí está tu resumen de hoy:

📋 Tareas: ${incompleteTasks} pendientes${overdueTasks > 0 ? ` (${overdueTasks} vencidas)` : ''}
📅 Citas: ${todayAppointments} programadas para hoy
📂 Proyectos: ${activeProjects} activos
💬 Mensajes: ${unreadMessages} sin leer

${overdueTasks > 0 ? '⚠️ Tienes tareas vencidas que necesitan atención.' : ''}
${todayAppointments > 0 ? '📌 No olvides tus citas de hoy.' : ''}

¿En qué puedo ayudarte hoy?`;
  } else {
    return `Good morning, ${context.userData.name}! 👋

Here's your summary for today:

📋 Tasks: ${incompleteTasks} pending${overdueTasks > 0 ? ` (${overdueTasks} overdue)` : ''}
📅 Appointments: ${todayAppointments} scheduled today
📂 Projects: ${activeProjects} active
💬 Messages: ${unreadMessages} unread

${overdueTasks > 0 ? '⚠️ You have overdue tasks that need attention.' : ''}
${todayAppointments > 0 ? '📌 Don\'t forget about your appointments today.' : ''}

How can I help you today?`;
  }
}

// ============================================
// EVA AI UI FUNCTIONS
// ============================================

// Open Eva chat
window.openEvaChat = async function () {
  evaOpen = true;
  evaCurrentPage = currentScreen;

  // Add welcome message if no messages yet
  if (evaMessages.length === 0) {
    const language = getEvaUserLanguage();
    const isSpanish = language === 'es';
    const welcomeMessage = isSpanish
      ? '¡Hola! Soy Eva, tu asistente de IA. Puedo ayudarte a entender cómo usar la aplicación Helo App. ¿En qué puedo ayudarte?'
      : 'Hello! I\'m Eva, your AI assistant. I can help you understand how to use the Helo App. How can I help you?';

    evaMessages = [{
      id: 'welcome',
      text: welcomeMessage,
      isUser: false,
      timestamp: new Date()
    }];
  }

  window.renderPMTool();

  setTimeout(() => {
    const messagesContainer = document.getElementById('eva-messages-container');
    if (messagesContainer) {
      messagesContainer.scrollTop = messagesContainer.scrollHeight;
    }
  }, 100);
};

// Close Eva chat
window.closeEvaChat = function () {
  evaOpen = false;
  showEvaWelcome = false;
  window.renderPMTool();
};

// Dismiss Eva welcome message (persist for entire day)
window.dismissEvaWelcome = function () {
  showEvaWelcome = false;
  const today = new Date().toDateString();
  localStorage.setItem('evaWelcomeDismissedDate', today);
  window.renderPMTool();
};

// Send Eva message
window.sendEvaMessage = async function () {
  // Get the input value directly from the textarea element
  const inputElement = document.getElementById('eva-input');
  const messageText = inputElement ? inputElement.value.trim() : (evaInputText || '').trim();

  if (!messageText || evaLoading) {
    return;
  }

  const userMessage = {
    id: Date.now().toString(),
    text: messageText,
    isUser: true,
    timestamp: new Date()
  };

  evaMessages.push(userMessage);
  evaInputText = '';
  if (inputElement) inputElement.value = '';
  evaLoading = true;
  window.renderPMTool();

  setTimeout(() => {
    const messagesContainer = document.getElementById('eva-messages-container');
    if (messagesContainer) {
      messagesContainer.scrollTop = messagesContainer.scrollHeight;
    }
  }, 100);

  try {
    const recentMessages = evaMessages.filter(msg => !msg.isTyping);
    const limitedHistory = recentMessages.slice(Math.max(recentMessages.length - 10, 0));
    const conversationHistory = limitedHistory.map(msg => ({
      role: msg.isUser ? 'user' : 'assistant',
      content: msg.text,
      timestamp: msg.timestamp
    }));

    // Create a minimal context for app guidance only (no user data)
    const minimalContext = {
      currentPage: evaCurrentPage || 'unknown',
      userData: {
        id: currentUser?.id || 'user',
        name: 'User',
        role: 'USER',
        company_id: undefined
      },
      recentActivity: {
        tasks: [],
        appointments: [],
        reminders: [],
        chats: [],
        contacts: [],
        projects: [],
        salesOpportunities: [],
        unreadMessageCount: 0,
        unreadMessages: []
      },
      teamMembers: []
    };

    const response = await processEvaMessage(messageText, minimalContext, conversationHistory);

    const aiMessage = {
      id: (Date.now() + 1).toString(),
      text: response,
      isUser: false,
      timestamp: new Date()
    };

    evaMessages.push(aiMessage);
  } catch (error) {
    console.error('Eva AI Error:', error);

    const language = getEvaUserLanguage();
    const isSpanish = language === 'es';

    let errorText = '';
    if (error.message.includes('Rate limit')) {
      errorText = isSpanish
        ? '⏳ Límite de solicitudes alcanzado. Por favor espera un momento e intenta de nuevo.'
        : '⏳ Rate limit reached. Please wait a moment and try again.';
    } else if (error.message.includes('Network') || error.message.includes('fetch')) {
      errorText = isSpanish
        ? '🌐 Error de conexión. Verifica tu internet e intenta de nuevo.'
        : '🌐 Connection error. Please check your internet and try again.';
    } else if (error.message.includes('timeout')) {
      errorText = isSpanish
        ? '⏱️ La solicitud tardó demasiado. Intenta de nuevo.'
        : '⏱️ Request timed out. Please try again.';
    } else {
      errorText = isSpanish
        ? '❌ Lo siento, hubo un problema procesando tu solicitud. Intenta de nuevo.'
        : '❌ Sorry, there was a problem processing your request. Please try again.';
    }

    const errorMessage = {
      id: (Date.now() + 1).toString(),
      text: errorText,
      isUser: false,
      timestamp: new Date()
    };
    evaMessages.push(errorMessage);
  } finally {
    evaLoading = false;
    window.renderPMTool();

    setTimeout(() => {
      const messagesContainer = document.getElementById('eva-messages-container');
      if (messagesContainer) {
        messagesContainer.scrollTop = messagesContainer.scrollHeight;
      }
    }, 100);
  }
};

// Update Eva input text
window.updateEvaInput = function (value) {
  evaInputText = value;
};

// Render Eva Chat Modal
function renderEvaChatModal() {
  if (!evaOpen) return '';

  const language = getEvaUserLanguage();
  const isSpanish = language === 'es';

  return `
    <div id="eva-chat-modal" onclick="if (event.target.id === 'eva-chat-modal') { closeEvaChat(); }" style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 99999;
      animation: fadeIn 0.3s ease-out;
    ">
      <div onclick="event.stopPropagation()" style="
        background: #ffffff;
        border-radius: 1rem;
        width: 90%;
        max-width: 800px;
        height: 85vh;
        max-height: 85vh;
        display: flex;
        flex-direction: column;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
        animation: slideIn 0.3s ease-out;
      ">
        <!-- Header -->
        <div style="
          padding: 1rem 1.5rem;
          border-bottom: 1px solid #e9ecef;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: #ffffff;
          border-radius: 1rem 1rem 0 0;
        ">
          <div style="display: flex; align-items: center; gap: 0.75rem;">
            <div style="
              width: 40px;
              height: 40px;
              border-radius: 50%;
              background: #EBF4FF;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #3B82F6;
              font-size: 1.25rem;
            ">
              ✨
            </div>
            <div>
              <div style="font-size: 1rem; font-weight: 600; color: #1F2937;">Eva</div>
              <div style="font-size: 0.75rem; color: #6B7280;">${isSpanish ? 'Asistente IA' : 'AI Assistant'}</div>
            </div>
          </div>
          <button
            onclick="closeEvaChat();"
            style="
              background: transparent;
              border: none;
              color: #6B7280;
              cursor: pointer;
              font-size: 1.25rem;
              padding: 0.5rem;
              border-radius: 0.5rem;
            "
            onmouseover="this.style.background='#f3f4f6'"
            onmouseout="this.style.background='transparent'"
          >
            ✕
          </button>
        </div>

        <!-- Messages -->
        <div id="eva-messages-container" style="
          flex: 1;
          overflow-y: auto;
          padding: 1.5rem;
          background: #f8f9fa;
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
          min-height: 0;
        ">
          ${evaMessages.map(msg => `
            <div style="
              display: flex;
              justify-content: ${msg.isUser ? 'flex-end' : 'flex-start'};
              align-items: flex-end;
              gap: 0.5rem;
            ">
              <div style="
                max-width: 70%;
                background: ${msg.isUser ? '#f59e0b' : '#F3F4F6'};
                color: ${msg.isUser ? 'white' : '#1F2937'};
                padding: 0.625rem 0.875rem;
                border-radius: ${msg.isUser ? '1rem 1rem 0.25rem 1rem' : '1rem 1rem 1rem 0.25rem'};
                font-size: 0.875rem;
                line-height: 1.4;
                box-shadow: 0 1px 2px rgba(0,0,0,0.1);
                white-space: pre-wrap;
              ">
                ${msg.text}
              </div>
              <div style="
                font-size: 0.75rem;
                color: #9ca3af;
                padding: 0 0.25rem;
              ">
                ${msg.timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
              </div>
            </div>
          `).join('')}
          
          ${evaLoading ? `
            <div style="
              display: flex;
              justify-content: flex-start;
              align-items: center;
              gap: 0.5rem;
            ">
              <div style="
                background: #F3F4F6;
                padding: 0.625rem 0.875rem;
                border-radius: 1rem 1rem 1rem 0.25rem;
                display: flex;
                align-items: center;
                gap: 0.5rem;
              ">
                <div style="
                  display: flex;
                  gap: 0.25rem;
                ">
                  <div style="width: 6px; height: 6px; border-radius: 50%; background: #f59e0b; opacity: 0.3; animation: pulse 1s infinite;"></div>
                  <div style="width: 6px; height: 6px; border-radius: 50%; background: #f59e0b; opacity: 0.6; animation: pulse 1s infinite 0.2s;"></div>
                  <div style="width: 6px; height: 6px; border-radius: 50%; background: #f59e0b; opacity: 1; animation: pulse 1s infinite 0.4s;"></div>
                </div>
                <span style="font-size: 0.875rem; color: #6B7280; font-style: italic;">
                  ${isSpanish ? 'Eva está escribiendo...' : 'Eva is typing...'}
                </span>
              </div>
            </div>
          ` : ''}
        </div>

        <!-- Input -->
        <div style="
          padding: 1rem 1.5rem;
          border-top: 1px solid #e9ecef;
          background: #ffffff;
          border-radius: 0 0 1rem 1rem;
          display: flex;
          gap: 0.5rem;
          align-items: flex-end;
        ">
          <textarea
            id="eva-input"
            placeholder="${isSpanish ? 'Escribe tu mensaje...' : 'Type your message...'}"
            oninput="updateEvaInput(this.value); const btn = this.nextElementSibling; if (btn && btn.tagName === 'BUTTON') { const hasText = this.value.trim().length > 0; btn.disabled = ${evaLoading} || !hasText; btn.style.background = (${evaLoading} || !hasText) ? '#E5E7EB' : '#3B82F6'; btn.style.cursor = (${evaLoading} || !hasText) ? 'not-allowed' : 'pointer'; }"
            onkeydown="if (event.key === 'Enter' && !event.shiftKey) { event.preventDefault(); sendEvaMessage(); }"
            style="
              flex: 1;
              border: 1px solid #D1D5DB;
              border-radius: 1.25rem;
              padding: 0.75rem 1rem;
              font-size: 0.875rem;
              color: #1F2937;
              background: #FFFFFF;
              resize: none;
              max-height: 100px;
              font-family: inherit;
            "
            rows="1"
            ${evaLoading ? 'disabled' : ''}
          >${evaInputText}</textarea>
          <button
            onclick="sendEvaMessage();"
            ${evaLoading || !evaInputText.trim() ? 'disabled' : ''}
            style="
              width: 44px;
              height: 44px;
              border-radius: 50%;
              background: ${evaLoading || !evaInputText.trim() ? '#E5E7EB' : '#3B82F6'};
              color: white;
              border: none;
              cursor: ${evaLoading || !evaInputText.trim() ? 'not-allowed' : 'pointer'};
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 1.25rem;
              transition: all 0.2s;
              flex-shrink: 0;
            "
            onmouseover="if (!${evaLoading} && this.previousElementSibling && this.previousElementSibling.value.trim()) { this.style.background='#2563EB'; }"
            onmouseout="if (!${evaLoading} && this.previousElementSibling && this.previousElementSibling.value.trim()) { this.style.background='#3B82F6'; }"
            type="button"
          >
            ➤
          </button>
        </div>
      </div>
    </div>
  `;
}

// Render Eva Bubble
function renderEvaBubble() {
  if (!evaVisible) return '';

  const language = getEvaUserLanguage();
  const isSpanish = language === 'es';

  return `
    <div style="
      position: fixed;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 1000;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.75rem;
    ">
      ${showEvaWelcome ? `
        <div style="
          background: #3B82F6;
          color: white;
          padding: 0.875rem 1rem;
          border-radius: 0.75rem;
          max-width: 300px;
          box-shadow: 0 4px 6px rgba(0,0,0,0.1);
          animation: slideUp 0.3s ease-out;
        ">
          <div style="display: flex; justify-content: space-between; align-items: flex-start; gap: 0.5rem;">
            <span style="font-size: 0.875rem; line-height: 1.4;">
              ${isSpanish ? '¡Hola! Soy Eva, tu asistente de IA. Haz clic para comenzar.' : 'Hi! I\'m Eva, your AI assistant. Click to get started.'}
            </span>
            <button
              onclick="dismissEvaWelcome();"
              style="
                background: rgba(255,255,255,0.2);
                border: none;
                color: white;
                cursor: pointer;
                padding: 0.25rem;
                border-radius: 0.25rem;
                font-size: 0.875rem;
                flex-shrink: 0;
              "
            >
              ✕
            </button>
          </div>
        </div>
      ` : ''}
      
      <button
        onclick="openEvaChat();"
        style="
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background: #3B82F6;
          color: white;
          border: none;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
          box-shadow: 0 4px 6px rgba(0,0,0,0.25);
          transition: all 0.2s;
        "
        onmouseover="this.style.transform='scale(1.1)'; this.style.boxShadow='0 6px 8px rgba(0,0,0,0.3)'"
        onmouseout="this.style.transform='scale(1)'; this.style.boxShadow='0 4px 6px rgba(0,0,0,0.25)'"
        title="${isSpanish ? 'Abrir Eva' : 'Open Eva'}"
      >
        ✨
      </button>
    </div>
  `;
}

// ==================== APP FEEDBACK SYSTEM ====================

// Helper function to escape HTML
function escapeHtml(text) {
  if (!text) return '';
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

// Load feedback from database
async function loadFeedback() {
  try {
    feedbackLoading = true;

    // Get the authenticated user ID
    const { data: { user: authUser }, error: authError } = await supabase.auth.getUser();
    console.log('🔄 Loading feedback...', {
      currentProfileId: currentProfile?.id,
      authUserId: authUser?.id,
      isHHAdmin: currentProfile?.is_hh_admin,
      authError: authError
    });

    if (authError || !authUser) {
      console.error('❌ Not authenticated:', authError);
      feedbackLoading = false;
      return;
    }

    // Use RPC function to get feedback with email from auth.users
    const { data, error } = await supabase.rpc('get_app_feedback_with_email');

    if (error) {
      console.error('❌ Error loading feedback:', error);
      throw error;
    }

    // Filter by user_id for non-HH admins
    const userIdToFilter = currentProfile?.id || authUser.id;
    let filteredData = data || [];
    if (!currentProfile?.is_hh_admin) {
      filteredData = filteredData.filter(item => item.user_id === userIdToFilter);
    }

    feedbackList = filteredData.map((item) => ({
      id: item.id,
      user_id: item.user_id,
      title: item.title,
      description: item.description,
      status: item.status || 'backlog',
      created_at: item.created_at,
      updated_at: item.updated_at,
      user: {
        first_name: item.user_first_name,
        last_name: item.user_last_name,
        email: item.user_email
      }
    }));

    feedbackLoading = false;
  } catch (error) {
    console.error('Error loading feedback:', error);
    alert('Failed to load feedback: ' + (error.message || 'Unknown error'));
    feedbackLoading = false;
  }
}

// Submit new feedback
window.submitFeedback = async function () {
  // Read directly from input fields (since they're uncontrolled)
  const titleInput = document.getElementById('feedback-title');
  const descInput = document.getElementById('feedback-description');

  const title = titleInput ? titleInput.value.trim() : '';
  const description = descInput ? descInput.value.trim() : '';

  // Also try to get from formData as fallback
  const formData = window.feedbackFormData || feedbackFormData;
  const finalTitle = title || formData?.title?.trim() || '';
  const finalDescription = description || formData?.description?.trim() || '';

  console.log('📝 Submitting feedback:', { title: finalTitle, description: finalDescription });

  if (!finalTitle) {
    showNotification('Please enter a title', 'warning');
    return;
  }

  if (!finalDescription) {
    showNotification('Please enter a description', 'warning');
    return;
  }

  try {
    submittingFeedback = true;
    renderPMTool();

    const { error } = await supabase.from('app_feedback').insert({
      user_id: currentProfile?.id,
      title: finalTitle,
      description: finalDescription,
      status: 'backlog', // New feedback starts as backlog
    });

    if (error) {
      console.error('❌ Error inserting feedback:', error);
      throw error;
    }

    // Notify all HH admins
    try {
      const { data: hhAdminIds, error: adminError } = await supabase.rpc('get_hh_admin_ids');
      if (adminError) {
        console.error('Error getting HH admin IDs:', adminError);
      } else if (hhAdminIds && hhAdminIds.length > 0) {
        const submitterName = `${currentProfile?.first_name || ''} ${currentProfile?.last_name || ''}`.trim() || 'A user';
        for (const admin of hhAdminIds) {
          if (admin?.id) {
            const { error: notifError } = await supabase.from('notifications').insert({
              user_id: admin.id,
              type: 'service_inquiry',
              title: 'New App Feedback',
              message: `${submitterName} submitted feedback: "${finalTitle}"`,
              metadata: { feedback_title: finalTitle }
            });
            if (notifError) {
              console.error('Error creating notification for admin', admin.id, ':', notifError);
            }
          }
        }
      } else {
        console.warn('No HH admins found to notify');
      }
    } catch (notifError) {
      console.error('Failed to notify HH admins:', notifError);
    }

    // Clear form data
    feedbackFormData.title = '';
    feedbackFormData.description = '';
    if (window.feedbackFormData) {
      window.feedbackFormData.title = '';
      window.feedbackFormData.description = '';
    }

    // Clear input fields
    if (titleInput) titleInput.value = '';
    if (descInput) descInput.value = '';

    showFeedbackModal = false;
    submittingFeedback = false;
    await loadFeedback();
    await loadNotifications(); // Reload notifications to show the new one
    renderPMTool();

    // Show success notification after modal closes
    showNotification('Feedback submitted successfully!', 'success');
  } catch (error) {
    console.error('Error submitting feedback:', error);
    showNotification('Failed to submit feedback', 'error');
    submittingFeedback = false;
    renderPMTool();
  }
};

// Show modern notification
window.showNotification = function (message, type = 'success') {
  // Remove any existing notification
  const existingNotification = document.getElementById('app-notification');
  if (existingNotification) {
    existingNotification.remove();
  }

  const colors = {
    success: { bg: '#10B981', icon: 'check_circle' },
    error: { bg: '#EF4444', icon: 'error' },
    info: { bg: '#3B82F6', icon: 'info' },
    warning: { bg: '#F59E0B', icon: 'warning' }
  };

  const config = colors[type] || colors.success;

  const notification = document.createElement('div');
  notification.id = 'app-notification';
  notification.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: ${config.bg};
    color: white;
    padding: 1rem 1.5rem;
    border-radius: 0.75rem;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    box-shadow: 0 10px 25px rgba(0,0,0,0.2);
    z-index: 100000;
    animation: slideInRight 0.3s ease-out;
    font-weight: 500;
    font-size: 0.9375rem;
  `;

  notification.innerHTML = `
    <span class="material-icons" style="font-size: 24px;">${config.icon}</span>
    <span>${message}</span>
  `;

  // Add animation keyframes if not already added
  if (!document.getElementById('notification-styles')) {
    const style = document.createElement('style');
    style.id = 'notification-styles';
    style.textContent = `
      @keyframes slideInRight {
        from { transform: translateX(100%); opacity: 0; }
        to { transform: translateX(0); opacity: 1; }
      }
      @keyframes slideOutRight {
        from { transform: translateX(0); opacity: 1; }
        to { transform: translateX(100%); opacity: 0; }
      }
    `;
    document.head.appendChild(style);
  }

  document.body.appendChild(notification);

  // Auto-remove after 3 seconds
  setTimeout(() => {
    notification.style.animation = 'slideOutRight 0.3s ease-in forwards';
    setTimeout(() => notification.remove(), 300);
  }, 3000);
};

// Show delete confirmation modal
window.showDeleteFeedbackConfirm = function (feedbackId) {
  // Remove any existing modal
  const existingModal = document.getElementById('delete-feedback-modal');
  if (existingModal) {
    existingModal.remove();
  }

  const modal = document.createElement('div');
  modal.id = 'delete-feedback-modal';
  modal.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99999;
    animation: fadeIn 0.2s ease-out;
  `;

  // Add animation keyframes
  if (!document.getElementById('modal-styles')) {
    const style = document.createElement('style');
    style.id = 'modal-styles';
    style.textContent = `
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      @keyframes scaleIn {
        from { transform: scale(0.9); opacity: 0; }
        to { transform: scale(1); opacity: 1; }
      }
    `;
    document.head.appendChild(style);
  }

  modal.innerHTML = `
    <div style="
      background: white;
      border-radius: 1rem;
      padding: 0;
      max-width: 400px;
      width: 90%;
      box-shadow: 0 25px 50px rgba(0,0,0,0.25);
      animation: scaleIn 0.2s ease-out;
      overflow: hidden;
    ">
      <!-- Header -->
      <div style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1.25rem 1.5rem;
        border-bottom: 1px solid #E5E7EB;
      ">
        <div style="display: flex; align-items: center; gap: 0.75rem;">
          <span class="material-icons" style="color: #EF4444; font-size: 24px;">warning</span>
          <h3 style="margin: 0; font-size: 1.125rem; font-weight: 600; color: #111827;">Delete Feedback</h3>
        </div>
        <button 
          onclick="closeDeleteFeedbackModal()"
          style="
            background: transparent;
            border: none;
            cursor: pointer;
            padding: 0.25rem;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 0.375rem;
            color: #6B7280;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#F3F4F6'; this.style.color='#111827';"
          onmouseout="this.style.background='transparent'; this.style.color='#6B7280';"
        >
          <span class="material-icons" style="font-size: 20px;">close</span>
        </button>
      </div>
      
      <!-- Body -->
      <div style="padding: 1.5rem;">
        <p style="margin: 0; color: #4B5563; font-size: 0.9375rem; line-height: 1.5;">
          Are you sure you want to delete this feedback? This action cannot be undone.
        </p>
      </div>
      
      <!-- Footer -->
      <div style="
        display: flex;
        gap: 0.75rem;
        padding: 1rem 1.5rem;
        background: #F9FAFB;
        border-top: 1px solid #E5E7EB;
      ">
        <button 
          onclick="closeDeleteFeedbackModal()"
          style="
            flex: 1;
            padding: 0.75rem 1rem;
            background: white;
            border: 1px solid #D1D5DB;
            border-radius: 0.5rem;
            color: #374151;
            font-size: 0.9375rem;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#F3F4F6';"
          onmouseout="this.style.background='white';"
        >
          Cancel
        </button>
        <button 
          onclick="confirmDeleteFeedback('${feedbackId}')"
          style="
            flex: 1;
            padding: 0.75rem 1rem;
            background: #EF4444;
            border: none;
            border-radius: 0.5rem;
            color: white;
            font-size: 0.9375rem;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#DC2626';"
          onmouseout="this.style.background='#EF4444';"
        >
          Delete
        </button>
      </div>
    </div>
  `;

  // Close on backdrop click
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      closeDeleteFeedbackModal();
    }
  });

  document.body.appendChild(modal);
};

// Close delete feedback modal
window.closeDeleteFeedbackModal = function () {
  const modal = document.getElementById('delete-feedback-modal');
  if (modal) {
    modal.style.opacity = '0';
    setTimeout(() => modal.remove(), 200);
  }
};

// Confirm delete feedback
window.confirmDeleteFeedback = async function (feedbackId) {
  const deleteBtn = document.querySelector('#delete-feedback-modal button[onclick*="confirmDeleteFeedback"]');
  if (deleteBtn) {
    deleteBtn.disabled = true;
    deleteBtn.innerHTML = '<span class="material-icons" style="font-size: 18px; animation: spin 1s linear infinite;">refresh</span> Deleting...';
  }

  try {
    const { error } = await supabase
      .from('app_feedback')
      .delete()
      .eq('id', feedbackId);

    if (error) throw error;

    closeDeleteFeedbackModal();
    showNotification('Feedback deleted successfully', 'success');

    await loadFeedback();
    renderPMTool();
  } catch (error) {
    console.error('Error deleting feedback:', error);
    closeDeleteFeedbackModal();
    showNotification('Failed to delete feedback', 'error');
  }
};

// Update feedback status (for HH Admins)
window.updateFeedbackStatus = async function (feedbackId, newStatus) {
  if (!currentProfile?.is_hh_admin) {
    showNotification('Only HH Admins can update feedback status', 'error');
    return;
  }

  if (!['backlog', 'in_progress', 'completed'].includes(newStatus)) {
    showNotification('Invalid status', 'error');
    return;
  }

  try {
    const { error } = await supabase
      .from('app_feedback')
      .update({
        status: newStatus,
        updated_at: new Date().toISOString()
      })
      .eq('id', feedbackId);

    if (error) throw error;

    const statusLabel = newStatus === 'backlog' ? 'In Review' : newStatus === 'in_progress' ? 'In Progress' : newStatus === 'completed' ? 'Completed' : 'Unmarked';
    showNotification(`Feedback marked as ${statusLabel}`, 'success');

    await loadFeedback();
    renderPMTool();
  } catch (error) {
    console.error('Error updating feedback status:', error);
    showNotification('Failed to update feedback status', 'error');
  }
};

// Delete feedback (shows confirmation modal)
window.deleteFeedback = function (feedbackId) {
  showDeleteFeedbackConfirm(feedbackId);
};

// Update feedback submit button state
window.updateFeedbackSubmitButton = function () {
  const submitBtn = document.getElementById('feedback-submit-btn');
  if (!submitBtn) return;

  // Read from DOM inputs first (since they're uncontrolled)
  const titleInput = document.getElementById('feedback-title');
  const descInput = document.getElementById('feedback-description');
  const title = titleInput ? titleInput.value.trim() : '';
  const description = descInput ? descInput.value.trim() : '';

  // Fallback to formData
  if (!title || !description) {
    const formData = window.feedbackFormData || feedbackFormData;
    const formTitle = formData?.title?.trim() || '';
    const formDesc = formData?.description?.trim() || '';
    const finalTitle = title || formTitle;
    const finalDesc = description || formDesc;
    const hasContent = finalTitle && finalDesc;

    submitBtn.disabled = submittingFeedback || !hasContent;
    submitBtn.style.cursor = (submittingFeedback || !hasContent) ? 'not-allowed' : 'pointer';
    submitBtn.style.opacity = (submittingFeedback || !hasContent) ? '0.5' : '1';
  } else {
    const hasContent = title && description;
    submitBtn.disabled = submittingFeedback || !hasContent;
    submitBtn.style.cursor = (submittingFeedback || !hasContent) ? 'not-allowed' : 'pointer';
    submitBtn.style.opacity = (submittingFeedback || !hasContent) ? '0.5' : '1';
  }
};

// Open feedback modal
window.openFeedbackModal = function () {
  feedbackFormData.title = '';
  feedbackFormData.description = '';
  if (window.feedbackFormData) {
    window.feedbackFormData.title = '';
    window.feedbackFormData.description = '';
  }
  showFeedbackModal = true;
  renderPMTool();

  // Set input values after render
  setTimeout(() => {
    const titleInput = document.getElementById('feedback-title');
    const descInput = document.getElementById('feedback-description');
    if (titleInput) {
      titleInput.value = '';
      titleInput.focus();
    }
    if (descInput) descInput.value = '';
    window.updateFeedbackSubmitButton();
  }, 100);
};

// Close feedback modal
window.closeFeedbackModal = function () {
  showFeedbackModal = false;
  feedbackFormData.title = '';
  feedbackFormData.description = '';
  if (window.feedbackFormData) {
    window.feedbackFormData.title = '';
    window.feedbackFormData.description = '';
  }
  renderPMTool();
};

// Navigate to feedback screen
window.openFeedbackScreen = function () {
  currentScreen = 'feedback';
  renderPMTool();
};

// Navigate back to profile screen
window.goBackToProfile = function () {
  currentScreen = 'profile';
  renderPMTool();
};

// Navigate back to profile screen
window.goBackToProfile = function () {
  currentScreen = 'profile';
  renderPMTool();
};

// Render Feedback Screen
async function renderFeedbackScreen() {
  // Always load feedback when screen opens (to get latest data from database)
  // Only load if we have a currentProfile (user is logged in)
  if (!feedbackLoading) {
    if (!currentProfile?.id) {
      console.warn('⚠️ Cannot load feedback: currentProfile.id is missing', { currentProfile });
    } else {
      await loadFeedback();
    }
  }

  // Sync feedbackFilter from window if it exists
  if (window.feedbackFilter) {
    feedbackFilter = window.feedbackFilter;
  } else {
    window.feedbackFilter = feedbackFilter;
  }

  const isHHAdmin = currentProfile?.is_hh_admin || false;

  // Filter and sort feedback
  let filteredFeedback = [...feedbackList];

  // Apply status filter
  if (feedbackFilter === 'in_review') {
    filteredFeedback = filteredFeedback.filter(item => (item.status || 'backlog') === 'backlog');
  } else if (feedbackFilter === 'in_progress') {
    filteredFeedback = filteredFeedback.filter(item => item.status === 'in_progress');
  } else if (feedbackFilter === 'completed') {
    filteredFeedback = filteredFeedback.filter(item => item.status === 'completed');
  }

  // Sort: in_progress first, then by created_at desc
  filteredFeedback.sort((a, b) => {
    const aStatus = a.status || 'backlog';
    const bStatus = b.status || 'backlog';
    if (aStatus === 'in_progress' && bStatus !== 'in_progress') return -1;
    if (aStatus !== 'in_progress' && bStatus === 'in_progress') return 1;
    return new Date(b.created_at) - new Date(a.created_at);
  });

  return `
    <div style="max-width: 1000px; margin: 0 auto; padding: 1.5rem;">
      <!-- Header -->
      <div style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 2rem;
        padding-bottom: 1rem;
        border-bottom: 1px solid #e5e7eb;
      ">
        <div style="display: flex; align-items: center; gap: 1rem;">
          <button
            onclick="if (window.goBackToProfile) { window.goBackToProfile(); } else { currentScreen = 'profile'; if (typeof renderPMTool === 'function') renderPMTool(); }"
            style="
              background: transparent;
              border: none;
              color: #f59e0b;
              font-size: 1.5rem;
              cursor: pointer;
              padding: 0.5rem;
              display: flex;
              align-items: center;
            "
            onmouseover="this.style.opacity='0.7'"
            onmouseout="this.style.opacity='1'"
          >
            ←
          </button>
          <h1 style="
            margin: 0;
            font-size: 1.75rem;
            font-weight: 700;
            color: #2c3e50;
          ">
            App Feedback
          </h1>
        </div>
        <button
          onclick="openFeedbackModal();"
          style="
            background: #ef4444;
            color: white;
            border: none;
            width: 36px;
            height: 36px;
            border-radius: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            font-size: 1.5rem;
            font-weight: 600;
            transition: background-color 0.2s;
          "
          onmouseover="this.style.background='#dc2626'"
          onmouseout="this.style.background='#ef4444'"
        >
          +
        </button>
      </div>

      <!-- Filter Buttons -->
      <div style="
        display: flex;
        gap: 0.5rem;
        margin-bottom: 1.5rem;
        padding-bottom: 1rem;
        border-bottom: 1px solid #e5e7eb;
      ">
        <button
          onclick="window.feedbackFilter = 'all'; feedbackFilter = 'all'; renderPMTool();"
          style="
            padding: 0.5rem 1rem;
            border-radius: 0.5rem;
            border: 1px solid ${feedbackFilter === 'all' ? '#ef4444' : '#e5e7eb'};
            background: ${feedbackFilter === 'all' ? '#ef4444' : 'white'};
            color: ${feedbackFilter === 'all' ? 'white' : '#6c757d'};
            font-size: 0.875rem;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
          "
          onmouseover="if (feedbackFilter !== 'all') { this.style.borderColor='#ef4444'; this.style.color='#ef4444'; }"
          onmouseout="if (feedbackFilter !== 'all') { this.style.borderColor='#e5e7eb'; this.style.color='#6c757d'; }"
        >
          All
        </button>
        <button
          onclick="window.feedbackFilter = 'in_review'; feedbackFilter = 'in_review'; renderPMTool();"
          style="
            padding: 0.5rem 1rem;
            border-radius: 0.5rem;
            border: 1px solid ${feedbackFilter === 'in_review' ? '#6b7280' : '#e5e7eb'};
            background: ${feedbackFilter === 'in_review' ? '#6b7280' : 'white'};
            color: ${feedbackFilter === 'in_review' ? 'white' : '#6c757d'};
            font-size: 0.875rem;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
          "
          onmouseover="if (feedbackFilter !== 'in_review') { this.style.borderColor='#6b7280'; this.style.color='#6b7280'; }"
          onmouseout="if (feedbackFilter !== 'in_review') { this.style.borderColor='#e5e7eb'; this.style.color='#6c757d'; }"
        >
          In Review
        </button>
        <button
          onclick="window.feedbackFilter = 'in_progress'; feedbackFilter = 'in_progress'; renderPMTool();"
          style="
            padding: 0.5rem 1rem;
            border-radius: 0.5rem;
            border: 1px solid ${feedbackFilter === 'in_progress' ? '#f59e0b' : '#e5e7eb'};
            background: ${feedbackFilter === 'in_progress' ? '#f59e0b' : 'white'};
            color: ${feedbackFilter === 'in_progress' ? 'white' : '#6c757d'};
            font-size: 0.875rem;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
          "
          onmouseover="if (feedbackFilter !== 'in_progress') { this.style.borderColor='#f59e0b'; this.style.color='#f59e0b'; }"
          onmouseout="if (feedbackFilter !== 'in_progress') { this.style.borderColor='#e5e7eb'; this.style.color='#6c757d'; }"
        >
          In Progress
        </button>
        <button
          onclick="window.feedbackFilter = 'completed'; feedbackFilter = 'completed'; renderPMTool();"
          style="
            padding: 0.5rem 1rem;
            border-radius: 0.5rem;
            border: 1px solid ${feedbackFilter === 'completed' ? '#10b981' : '#e5e7eb'};
            background: ${feedbackFilter === 'completed' ? '#10b981' : 'white'};
            color: ${feedbackFilter === 'completed' ? 'white' : '#6c757d'};
            font-size: 0.875rem;
            font-weight: 600;
            cursor: pointer;
            transition: all 0.2s;
          "
          onmouseover="if (feedbackFilter !== 'completed') { this.style.borderColor='#10b981'; this.style.color='#10b981'; }"
          onmouseout="if (feedbackFilter !== 'completed') { this.style.borderColor='#e5e7eb'; this.style.color='#6c757d'; }"
        >
          Completed
        </button>
      </div>

      <!-- Feedback List -->
      ${feedbackLoading ? `
        <div style="
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 4rem 2rem;
        ">
          <div style="
            width: 40px;
            height: 40px;
            border: 4px solid #f3f4f6;
            border-top-color: #f59e0b;
            border-radius: 50%;
            animation: spin 1s linear infinite;
          "></div>
        </div>
      ` : feedbackList.length === 0 ? `
        <div style="
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 4rem 2rem;
          text-align: center;
        ">
          <div style="font-size: 3rem; margin-bottom: 1rem;">💬</div>
          <p style="
            color: #6c757d;
            font-size: 1rem;
            margin: 0;
          ">
            No feedback yet. Click + to add your first feedback!
          </p>
        </div>
      ` : filteredFeedback.length === 0 ? `
        <div style="
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 4rem 2rem;
          text-align: center;
        ">
          <div style="font-size: 3rem; margin-bottom: 1rem;">💬</div>
          <p style="
            color: #6c757d;
            font-size: 1rem;
            margin: 0;
          ">
            No ${feedbackFilter === 'in_review' ? 'in review' : feedbackFilter === 'in_progress' ? 'in progress' : feedbackFilter === 'completed' ? 'completed' : ''} feedback found.
          </p>
        </div>
      ` : `
        <div style="display: flex; flex-direction: column; gap: 1rem;">
          ${filteredFeedback.map((item) => {
    const isOwnFeedback = item.user_id === currentProfile?.id;
    const showUserInfo = isHHAdmin;
    const canDelete = (isOwnFeedback && (item.status === 'backlog' || item.status === null)) || isHHAdmin;

    return `
              <div style="
                background: #ffffff;
                border-radius: 0.75rem;
                padding: 1.25rem;
                border: 1px solid #e5e7eb;
                box-shadow: 0 1px 3px rgba(0,0,0,0.1);
              ">
                <div style="
                  display: flex;
                  justify-content: space-between;
                  align-items: flex-start;
                  margin-bottom: 0.75rem;
                ">
                  <div style="flex: 1;">
                    <h3 style="
                      margin: 0 0 0.5rem 0;
                      font-size: 1.125rem;
                      font-weight: 600;
                      color: #2c3e50;
                    ">
                      ${escapeHtml(item.title)}
                    </h3>
                    <div style="
                      font-size: 0.875rem;
                      font-weight: 500;
                      color: ${(item.status || 'backlog') === 'backlog' ? '#6b7280' : item.status === 'in_progress' ? '#f59e0b' : '#10b981'};
                    ">
                      ${(item.status || 'backlog') === 'backlog' ? 'In Review' : item.status === 'in_progress' ? 'In Progress' : item.status === 'completed' ? 'Completed' : 'In Review'}
                    </div>
                  </div>
                  <div style="display: flex; align-items: center; gap: 0.25rem;">
                    ${isHHAdmin ? (() => {
        const currentStatus = item.status || 'backlog';
        let nextStatus, buttonColor, buttonIcon, buttonTitle;

        if (currentStatus === 'backlog') {
          // backlog (displays as "In Review") - orange button to mark as "In Progress"
          nextStatus = 'in_progress';
          buttonColor = '#f59e0b'; // Orange
          buttonIcon = 'play_circle';
          buttonTitle = 'Mark as In Progress';
        } else if (currentStatus === 'in_progress') {
          // In Progress - green button to mark as "Completed"
          nextStatus = 'completed';
          buttonColor = '#10b981'; // Green
          buttonIcon = 'check_circle';
          buttonTitle = 'Mark as Completed';
        } else {
          // Completed - no button
          return '';
        }

        return `
                        <button
                          onclick="updateFeedbackStatus('${item.id}', '${nextStatus}');"
                          style="
                            background: transparent;
                            border: none;
                            color: ${buttonColor};
                            cursor: pointer;
                            padding: 0.25rem;
                            font-size: 1.125rem;
                            display: flex;
                            align-items: center;
                          "
                          onmouseover="this.style.opacity='0.7'"
                          onmouseout="this.style.opacity='1'"
                          title="${buttonTitle}"
                        >
                          <span class="material-icons" style="font-size: 20px;">${buttonIcon}</span>
                        </button>
                      `;
      })() : ''}
                    ${canDelete ? `
                      <button
                        onclick="deleteFeedback('${item.id}');"
                        style="
                          background: transparent;
                          border: none;
                          color: #ef4444;
                          cursor: pointer;
                          padding: 0.25rem;
                          font-size: 1.125rem;
                          display: flex;
                          align-items: center;
                        "
                        onmouseover="this.style.opacity='0.7'"
                        onmouseout="this.style.opacity='1'"
                        title="Delete feedback"
                      >
                        <span class="material-icons" style="font-size: 20px;">delete</span>
                      </button>
                    ` : ''}
                  </div>
                </div>
                
                <p style="
                  margin: 0 0 1rem 0;
                  color: #4b5563;
                  font-size: 0.9375rem;
                  line-height: 1.6;
                ">
                  ${escapeHtml(item.description)}
                </p>
                
                <div style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                ">
                  ${showUserInfo && item.user ? `
                    <span style="
                      font-size: 0.75rem;
                      color: #111827;
                    ">
                      By: ${escapeHtml(item.user.first_name)} ${escapeHtml(item.user.last_name)}${item.user.email ? ` Email: ${escapeHtml(item.user.email)}` : ''}
                    </span>
                  ` : '<span></span>'}
                  <span style="
                    font-size: 0.75rem;
                    color: #6c757d;
                    margin-left: auto;
                  ">
                    ${new Date(item.created_at).toLocaleDateString()}
                  </span>
                </div>
              </div>
            `;
  }).join('')}
        </div>
      `}

      <!-- Add Feedback Modal -->
      ${showFeedbackModal ? `
        <div style="
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          padding: 1rem;
        " onclick="if (event.target === this) closeFeedbackModal();">
          <div style="
            background: #ffffff;
            border-radius: 1rem;
            width: 100%;
            max-width: 600px;
            max-height: 90vh;
            display: flex;
            flex-direction: column;
            box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
            pointer-events: auto;
          " onclick="event.stopPropagation();">
            <!-- Modal Header -->
            <div style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              padding: 1.25rem 1.5rem;
              border-bottom: 1px solid #e5e7eb;
            ">
              <button
                onclick="closeFeedbackModal();"
                disabled="${submittingFeedback}"
                style="
                  background: transparent;
                  border: none;
                  color: #f59e0b;
                  font-size: 1rem;
                  cursor: ${submittingFeedback ? 'not-allowed' : 'pointer'};
                  opacity: ${submittingFeedback ? '0.5' : '1'};
                "
              >
                Cancel
              </button>
              <h2 style="
                margin: 0;
                font-size: 1.125rem;
                font-weight: 600;
                color: #2c3e50;
              ">
                New Feedback
              </h2>
              <button
                onclick="if (window.submitFeedback) { window.submitFeedback(); } else { console.error('submitFeedback function not found'); }"
                id="feedback-submit-btn"
                ${submittingFeedback ? 'disabled' : ''}
                style="
                  background: transparent;
                  border: none;
                  color: #f59e0b;
                  font-size: 1rem;
                  font-weight: 600;
                  cursor: ${submittingFeedback ? 'not-allowed' : 'pointer'};
                  opacity: ${submittingFeedback ? '0.5' : '1'};
                  pointer-events: auto;
                "
              >
                ${submittingFeedback ? 'Submitting...' : 'Submit'}
              </button>
            </div>

            <!-- Modal Content -->
            <div style="
              flex: 1;
              overflow-y: auto;
              padding: 1.5rem;
              pointer-events: auto;
              z-index: 1001;
              position: relative;
            ">
              <!-- Title Input -->
              <div style="margin-bottom: 1.5rem;">
                <label style="
                  display: block;
                  font-size: 1rem;
                  font-weight: 600;
                  margin-bottom: 0.5rem;
                  color: #2c3e50;
                ">
                  Title
                </label>
                <input
                  type="text"
                  id="feedback-title"
                  placeholder="Brief title for your feedback"
                  oninput="(function() { const val = this.value; if (window.feedbackFormData) { window.feedbackFormData.title = val; } feedbackFormData.title = val; if (window.updateFeedbackSubmitButton) window.updateFeedbackSubmitButton(); })()"
                  onfocus="this.style.outline='2px solid #f59e0b'; this.style.outlineOffset='2px'"
                  onblur="this.style.outline='none'"
                  ${submittingFeedback ? 'disabled' : ''}
                  style="
                    width: 100%;
                    padding: 0.875rem;
                    border: 1px solid #e5e7eb;
                    border-radius: 0.75rem;
                    font-size: 1rem;
                    background: #ffffff;
                    color: #2c3e50;
                    box-sizing: border-box;
                    pointer-events: auto;
                    z-index: 1001;
                    position: relative;
                  "
                />
              </div>

              <!-- Description Input -->
              <div style="margin-bottom: 1.5rem;">
                <label style="
                  display: block;
                  font-size: 1rem;
                  font-weight: 600;
                  margin-bottom: 0.5rem;
                  color: #2c3e50;
                ">
                  Description
                </label>
                <textarea
                  id="feedback-description"
                  placeholder="Describe your feedback in detail..."
                  oninput="(function() { const val = this.value; if (window.feedbackFormData) { window.feedbackFormData.description = val; } feedbackFormData.description = val; if (window.updateFeedbackSubmitButton) window.updateFeedbackSubmitButton(); })()"
                  ${submittingFeedback ? 'disabled' : ''}
                  rows="8"
                  onfocus="this.style.outline='2px solid #f59e0b'; this.style.outlineOffset='2px'"
                  onblur="this.style.outline='none'"
                  style="
                    width: 100%;
                    padding: 0.875rem;
                    border: 1px solid #e5e7eb;
                    border-radius: 0.75rem;
                    font-size: 1rem;
                    background: #ffffff;
                    color: #2c3e50;
                    resize: vertical;
                    min-height: 150px;
                    font-family: inherit;
                    box-sizing: border-box;
                    pointer-events: auto;
                    z-index: 1001;
                    position: relative;
                  "
                ></textarea>
              </div>

              <!-- Helper Text -->
              <div style="
                background: #f8f9fa;
                padding: 1rem;
                border-radius: 0.75rem;
                border: 1px solid #e5e7eb;
              ">
                <p style="
                  margin: 0;
                  font-size: 0.875rem;
                  color: #6c757d;
                  line-height: 1.6;
                ">
                  💡 Your feedback helps us improve the app. Please be as specific as possible.
                </p>
              </div>
            </div>
          </div>
        </div>
      ` : ''}
    </div>
  `;
}

// Google Calendar Integration state - make selectedCalendarId global
let googleCalendarConnection = null;
let googleCalendarCalendars = [];
let googleCalendarSelectedCalendarId = '';
window.googleCalendarSelectedCalendarId = ''; // Also expose on window for inline handlers
let googleCalendarViewMode = 'sync'; // 'sync' or 'selection'
window.googleCalendarViewMode = 'sync'; // Expose to window for inline handlers
let googleCalendarLoading = false;
let googleCalendarStatus = null;

// Intake Submissions state
let intakeSubmissions = [];
let intakeSubmissionsLoading = false;
let intakeSubmissionsHasLoaded = false; // Track if we've attempted to load
let intakeSubmissionsStatusFilter = 'open'; // 'all', 'open', 'done'
let intakeSubmissionsSiteFilter = 'all'; // 'all' or specific site_key

// Initialize functions immediately to ensure they're available
console.log('📅 Initializing Google Calendar integration functions...');

// Get org_id from current profile/company
function getOrgId() {
  if (currentProfile?.current_company_id) {
    return currentProfile.current_company_id;
  }
  if (currentProfile?.company_id) {
    return currentProfile.company_id;
  }
  if (currentCompany?.id) {
    return currentCompany.id;
  }
  throw new Error('No organization found for user');
}

// Load Google Calendar connection status
async function loadGoogleCalendarConnection(reloadAfterCallback = false) {
  try {
    let orgId;
    try {
      orgId = getOrgId();
    } catch (error) {
      console.warn('⚠️ Could not get org_id:', error.message);
      googleCalendarConnection = null;
      return; // Silently fail - user might not have a company yet
    }

    // Get user ID for multi-user support
    let userId = null;
    try {
      const { data: { session } } = await supabase.auth.getSession();
      userId = session?.user?.id || null;
    } catch (error) {
      console.warn('⚠️ Could not get user ID:', error.message);
    }

    // Build query with user filtering if available
    let query = supabase
      .from('google_connections')
      .select('*')
      .eq('org_id', orgId);

    if (userId) {
      query = query.eq('connected_by_user_id', userId);
    }

    const { data, error } = await query.maybeSingle();

    if (error && error.code !== 'PGRST116') {
      throw error;
    }

    googleCalendarConnection = data || null;
    console.log('📅 Connection loaded:', { hasConnection: !!googleCalendarConnection, calendar_id: googleCalendarConnection?.calendar_id });

    // Only process callback on first call, not on reload
    if (!reloadAfterCallback) {
      // Check URL for callback result
      const urlParams = new URLSearchParams(window.location.search);
      const callbackResult = urlParams.get('callback_result');
      const errorParam = urlParams.get('error');

      // If we have callback params, switch to integration screen
      if (callbackResult || errorParam) {
        if (currentScreen !== 'google-calendar-integration') {
          currentScreen = 'google-calendar-integration';
        }
      }

      if (errorParam) {
        googleCalendarStatus = { type: 'error', message: `OAuth error: ${decodeURIComponent(errorParam)}` };
        // Clean up URL after processing
        window.history.replaceState({}, '', window.location.pathname);
        renderPMTool(); // Re-render to show error
        return;
      } else if (callbackResult) {
        try {
          const result = JSON.parse(decodeURIComponent(callbackResult));
          if (result.needs_calendar_select && result.calendars) {
            // Set calendars FIRST
            googleCalendarCalendars = result.calendars;
            console.log('📅 Calendars loaded from callback:', googleCalendarCalendars.length);
            // Force selection view mode when calendars are available
            googleCalendarViewMode = 'selection';
            window.googleCalendarViewMode = 'selection';
            googleCalendarStatus = { type: 'info', message: 'Please select your Operations calendar' };
            // Clean up URL AFTER calendars and viewMode are set
            window.history.replaceState({}, '', window.location.pathname);
            renderPMTool(); // Re-render to show calendar selection

            // Initialize button state after render
            setTimeout(() => {
              updateGoogleCalendarSaveButton();
              console.log('📅 Initialized save button state');
            }, 100);
            return;
          } else if (result.ok) {
            // Connection was successful - reload connection data first
            await loadGoogleCalendarConnection(true); // Reload without processing callback again
            // Check if we have calendars in the result (edge function might have included them)
            if (result.calendars && result.calendars.length > 0 && !googleCalendarConnection?.calendar_id) {
              googleCalendarCalendars = result.calendars;
              googleCalendarViewMode = 'selection';
              window.googleCalendarViewMode = 'selection';
              googleCalendarStatus = { type: 'info', message: 'Please select your Operations calendar' };
            } else {
              googleCalendarStatus = { type: 'success', message: 'Google Calendar connected successfully!' };
            }
            // Clean up URL after connection is loaded
            window.history.replaceState({}, '', window.location.pathname);
            renderPMTool(); // Re-render
            return;
          }
        } catch (e) {
          console.error('Error parsing callback result:', e);
          // Clean up URL even on parse error
          window.history.replaceState({}, '', window.location.pathname);
        }
      }
    }
  } catch (error) {
    console.error('Error loading Google Calendar connection:', error);
    googleCalendarStatus = { type: 'error', message: `Failed to load connection: ${error.message}` };
  }
}

// Connect Google Calendar - Make it globally accessible immediately
window.connectGoogleCalendar = async function connectGoogleCalendar() {
  console.log('🔘 connectGoogleCalendar function called');
  try {
    googleCalendarLoading = true;
    googleCalendarStatus = null;
    renderPMTool(); // Re-render to show loading state

    if (!currentProfile?.id) {
      throw new Error('Not authenticated. Please log in.');
    }

    let orgId;
    try {
      orgId = getOrgId();
    } catch (error) {
      throw new Error(`Failed to get organization ID: ${error.message}`);
    }

    const userId = currentProfile.id;

    console.log('🔗 Connecting Google Calendar...', { orgId, userId });

    const response = await fetch(`${SUPABASE_URL}/functions/v1/google-auth-url`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
      },
      body: JSON.stringify({
        org_id: orgId,
        connected_by_user_id: userId,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Failed to get auth URL' }));
      console.error('❌ Edge Function error response:', errorData);

      // Build detailed error message
      let errorMessage = errorData.error || errorData.message || 'Failed to get auth URL';
      if (errorData.missing && errorData.missing.length > 0) {
        errorMessage += `\n\nMissing secrets: ${errorData.missing.join(', ')}`;
      }
      if (errorData.hint) {
        errorMessage += `\n\n${errorData.hint}`;
      }

      throw new Error(errorMessage);
    }

    const data = await response.json();
    const url = data.url;

    if (!url) {
      throw new Error('No authorization URL returned');
    }

    console.log('✅ Got auth URL, redirecting...', url);
    window.location.href = url;
  } catch (error) {
    console.error('❌ Error connecting Google Calendar:', error);
    // Replace newlines with spaces for display, but log full message
    const displayMessage = error.message.replace(/\n/g, ' ').replace(/\s+/g, ' ').trim();
    googleCalendarStatus = { type: 'error', message: `Failed to connect: ${displayMessage}` };
    googleCalendarLoading = false;
    renderPMTool(); // Re-render to show error
  }
}

// Save calendar selection - Make it globally accessible immediately
// Handle calendar selection - global function to avoid template literal issues
window.handleGoogleCalendarSelect = function handleGoogleCalendarSelect(selectElement) {
  const selectedValue = selectElement.value;
  console.log('📅 Calendar selected - selectElement:', selectElement, 'selectedValue:', selectedValue, 'type:', typeof selectedValue);

  if (!selectedValue) {
    console.warn('⚠️ No value selected!');
    googleCalendarSelectedCalendarId = '';
    window.googleCalendarSelectedCalendarId = '';
    updateGoogleCalendarSaveButton();
    return;
  }

  googleCalendarSelectedCalendarId = selectedValue;
  window.googleCalendarSelectedCalendarId = selectedValue; // Also set on window
  console.log('📅 Set googleCalendarSelectedCalendarId to:', googleCalendarSelectedCalendarId);

  const debugDisplay = document.getElementById('google-calendar-selected-display');
  if (debugDisplay) {
    debugDisplay.textContent = selectedValue || '(none)';
  }

  updateGoogleCalendarSaveButton();
};

// Update save button state based on selectedCalendarId
function updateGoogleCalendarSaveButton() {
  const saveBtn = document.getElementById('google-calendar-save-btn');
  if (!saveBtn) return;

  const selectedId = window.googleCalendarSelectedCalendarId || googleCalendarSelectedCalendarId;
  const isDisabled = !selectedId || googleCalendarLoading;
  saveBtn.disabled = isDisabled;
  saveBtn.style.cursor = isDisabled ? 'not-allowed' : 'pointer';
  saveBtn.style.opacity = isDisabled ? '0.6' : '1';
  saveBtn.style.backgroundColor = (selectedId && !googleCalendarLoading) ? '#28a745' : '#6c757d';
  console.log('📅 Button updated:', { disabled: isDisabled, selectedValue: selectedId });
}

window.saveGoogleCalendarSelection = async function saveGoogleCalendarSelection() {
  // Get the selected calendar ID from window or local variable
  const selectedId = window.googleCalendarSelectedCalendarId || googleCalendarSelectedCalendarId;

  if (!selectedId) {
    googleCalendarStatus = { type: 'error', message: 'Please select a calendar' };
    renderPMTool();
    return;
  }

  try {
    googleCalendarLoading = true;
    googleCalendarStatus = null;
    renderPMTool(); // Re-render to show loading state

    const orgId = getOrgId();

    // Get user ID for multi-user support
    let userId = null;
    try {
      const { data: { session } } = await supabase.auth.getSession();
      userId = session?.user?.id || null;
    } catch (error) {
      console.warn('⚠️ Could not get user ID:', error.message);
    }

    console.log('💾 Saving calendar selection...', { orgId, calendarId: selectedId, userId });

    const requestBody = {
      org_id: orgId,
      calendar_id: selectedId,
    };

    if (userId) {
      requestBody.connected_by_user_id = userId;
    }

    const response = await fetch(`${SUPABASE_URL}/functions/v1/google-auth-callback`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Failed to save calendar' }));
      throw new Error(errorData.error || errorData.message || 'Failed to save calendar');
    }

    const result = await response.json();
    if (!result.ok) {
      throw new Error(result.error || 'Failed to save calendar');
    }

    googleCalendarStatus = { type: 'success', message: 'Calendar saved successfully!' };
    await loadGoogleCalendarConnection();
    googleCalendarCalendars = [];
    googleCalendarSelectedCalendarId = '';
    window.googleCalendarSelectedCalendarId = '';
    googleCalendarViewMode = 'sync'; // Switch to sync view after saving
    renderPMTool(); // Re-render to update UI
  } catch (error) {
    console.error('❌ Error saving calendar:', error);
    googleCalendarStatus = { type: 'error', message: `Failed to save calendar: ${error.message}` };
    renderPMTool(); // Re-render to show error
  } finally {
    googleCalendarLoading = false;
  }
}

// Handle Change Calendar button - clear calendar_id and reconnect to show calendar selection
window.handleChangeCalendar = async function handleChangeCalendar() {
  try {
    console.log('🔄 Change Calendar clicked - clearing calendar_id and reconnecting...');

    const orgId = getOrgId();
    const { data: { session } } = await supabase.auth.getSession();
    const userId = session?.user?.id;

    // Clear the calendar_id by updating it to null
    // This will force the OAuth callback to show calendar selection
    const response = await fetch(`${SUPABASE_URL}/functions/v1/google-auth-callback`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        org_id: orgId,
        calendar_id: null, // Clear it so OAuth callback shows calendar selection
        connected_by_user_id: userId,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Failed to clear calendar selection' }));
      throw new Error(errorData.error || 'Failed to clear calendar selection');
    }

    // Now trigger reconnect which will show calendar selection
    if (window.connectGoogleCalendar) {
      await window.connectGoogleCalendar();
    }
  } catch (error) {
    console.error('❌ Error changing calendar:', error);
    googleCalendarStatus = { type: 'error', message: `Failed to change calendar: ${error.message}` };
    renderPMTool();
  }
};

// Helper function to push appointment/time_off changes to Google Calendar
// This sets last_modified_source='app' in the mapping to track that the change originated from the app
async function pushToGoogleCalendar(localType, localId, action = 'upsert') {
  try {
    const orgId = getOrgId();
    if (!orgId) {
      console.log('⚠️ [Google Sync] No org_id available, skipping push');
      return;
    }

    // Get current user ID for multi-user support
    let userId = null;
    try {
      if (currentUser?.id) {
        userId = currentUser.id;
      } else {
        const { data: { session } } = await supabase.auth.getSession();
        if (session?.user) {
          userId = session.user.id;
        }
      }
    } catch (error) {
      console.log('⚠️ [Google Sync] Could not get user ID, proceeding without it:', error);
    }

    const actionLabel = action === 'delete' ? 'deleting' : 'pushing';
    console.log(`🔄 [Google Sync] ${actionLabel.charAt(0).toUpperCase() + actionLabel.slice(1)} ${localType} ${localId} to Google Calendar`);

    const requestBody = {
      org_id: orgId,
      local_type: localType,
      local_id: localId,
      action: action,
      origin: 'app' // Always mark as app-originated when called from web app UI
    };

    // Add user_id if available (multi-user support)
    if (userId) {
      requestBody.connected_by_user_id = userId;
    }

    const response = await fetch(`${SUPABASE_URL}/functions/v1/google-push-local-to-google`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Push failed' }));
      console.error(`❌ [Google Sync] ${action === 'delete' ? 'Delete' : 'Push'} failed:`, errorData.error || errorData.message);
      // Don't throw - we don't want to fail the main operation if sync fails
      return;
    }

    const result = await response.json();
    if (!result.ok) {
      console.error(`❌ [Google Sync] ${action === 'delete' ? 'Delete' : 'Push'} failed:`, result.error);
      return;
    }

    if (result.skipped) {
      console.log(`⚠️ [Google Sync] ${action === 'delete' ? 'Delete' : 'Push'} skipped: ${result.reason}`);
    } else {
      const actionMsg = action === 'delete' ? (result.cancelled ? 'cancelled' : 'deleted') : 'pushed';
      console.log(`✅ [Google Sync] Successfully ${actionMsg} ${localType} ${localId} in Google Calendar`);
    }
  } catch (error) {
    console.error(`❌ [Google Sync] Error ${action === 'delete' ? 'deleting' : 'pushing'} to Google:`, error);
    // Don't throw - we don't want to fail the main operation if sync fails
  }
}

// Run Google Calendar sync - Make it globally accessible immediately
window.runGoogleCalendarSync = async function runGoogleCalendarSync() {
  try {
    googleCalendarLoading = true;
    googleCalendarStatus = null;
    renderPMTool(); // Re-render to show loading state

    const orgId = getOrgId();

    // Get user ID for multi-user support
    let userId = null;
    try {
      const { data: { session } } = await supabase.auth.getSession();
      userId = session?.user?.id || null;
    } catch (error) {
      console.warn('⚠️ Could not get user ID:', error.message);
    }

    console.log('🔄 Running Google Calendar sync...', { orgId, userId });

    const requestBody = {
      org_id: orgId,
    };

    if (userId) {
      requestBody.connected_by_user_id = userId;
    }

    const response = await fetch(`${SUPABASE_URL}/functions/v1/google-poll-google-to-local`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${SUPABASE_ANON_KEY}`,
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ error: 'Sync failed' }));
      console.error('❌ Sync error response:', errorData);
      throw new Error(errorData.error || errorData.message || 'Sync failed');
    }

    const result = await response.json();
    console.log('📅 Sync result:', result);
    if (!result.ok) {
      console.error('❌ Sync result not ok:', result);
      throw new Error(result.error || 'Sync failed');
    }

    googleCalendarStatus = {
      type: 'success',
      message: `Sync completed! Processed ${result.events_processed || 0} events.`
    };
    renderPMTool(); // Re-render to update UI
  } catch (error) {
    console.error('❌ Error running sync:', error);
    googleCalendarStatus = { type: 'error', message: `Sync failed: ${error.message}` };
    renderPMTool(); // Re-render to show error
  } finally {
    googleCalendarLoading = false;
  }
}

// Render Google Calendar Integration Screen
async function renderGoogleCalendarIntegrationScreen() {
  // Sync window.googleCalendarViewMode to local variable (for inline handlers)
  if (window.googleCalendarViewMode) {
    googleCalendarViewMode = window.googleCalendarViewMode;
  }

  // Always load connection status (this will process callback if present)
  await loadGoogleCalendarConnection();

  // If calendars are available from OAuth callback, always show selection view
  // This handles the initial calendar selection after OAuth
  if (googleCalendarCalendars && googleCalendarCalendars.length > 0) {
    googleCalendarViewMode = 'selection';
    window.googleCalendarViewMode = 'selection';
  } else {
    // Set view mode based on connection state (only set default if not already set)
    // Don't override user's explicit choice
    if (googleCalendarConnection?.calendar_id) {
      // If calendar is selected, default to sync view (but don't override if user selected 'selection')
      if (!googleCalendarViewMode) {
        googleCalendarViewMode = 'sync';
        window.googleCalendarViewMode = 'sync';
      }
    } else {
      // If no calendar selected, show selection view
      if (!googleCalendarViewMode) {
        googleCalendarViewMode = 'selection';
        window.googleCalendarViewMode = 'selection';
      }
    }
  }

  // Reset selected calendar ID when screen renders (will be set by user selection)
  if (!googleCalendarSelectedCalendarId) {
    googleCalendarSelectedCalendarId = '';
    window.googleCalendarSelectedCalendarId = '';
  }

  const statusBg = googleCalendarStatus?.type === 'success' ? '#d4edda' :
    googleCalendarStatus?.type === 'error' ? '#f8d7da' : '#d1ecf1';
  const statusColor = googleCalendarStatus?.type === 'success' ? '#155724' :
    googleCalendarStatus?.type === 'error' ? '#721c24' : '#0c5460';
  const statusBorder = googleCalendarStatus?.type === 'success' ? '#c3e6cb' :
    googleCalendarStatus?.type === 'error' ? '#f5c6cb' : '#bee5eb';

  // Always show button if no connection exists
  const hasConnection = googleCalendarConnection && googleCalendarConnection.id;
  console.log('📅 Rendering Google Calendar screen:', {
    hasConnection,
    googleCalendarConnection,
    googleCalendarLoading,
    googleCalendarStatus
  });

  return `
    <div style="padding: 2rem; max-width: 800px; margin: 0 auto;">
      <h1 style="font-size: 2rem; margin-bottom: 1.5rem; color: #2c3e50;">Google Calendar Integration</h1>
      
      ${googleCalendarStatus ? `
        <div style="
          padding: 1rem;
          margin-bottom: 1.5rem;
          border-radius: 8px;
          background-color: ${statusBg};
          color: ${statusColor};
          border: 1px solid ${statusBorder};
        ">
          ${googleCalendarStatus.message}
        </div>
      ` : ''}
      
      ${hasConnection ? `
        <div style="margin-bottom: 1.5rem; padding: 1rem; background-color: #f8f9fa; border-radius: 8px;">
          <h2 style="font-size: 1.25rem; margin-bottom: 0.5rem; color: #2c3e50;">Connection Status</h2>
          <p style="margin: 0.5rem 0; color: #2c3e50;">
            <strong>Connected as:</strong> ${googleCalendarConnection.google_email || 'Unknown'}
          </p>
          ${googleCalendarConnection.calendar_id ? `
            <p style="margin: 0.5rem 0; color: #2c3e50; word-wrap: break-word; overflow-wrap: break-word;">
              <strong>Calendar ID:</strong> ${googleCalendarConnection.calendar_id}
            </p>
          ` : ''}
          <p style="margin: 0.5rem 0; color: #2c3e50;">
            <strong>Connected:</strong> ${new Date(googleCalendarConnection.created_at).toLocaleDateString()}
          </p>
        </div>
      ` : ''}
      
      ${!hasConnection ? `
        <div style="margin-bottom: 1.5rem;">
          <button
            id="google-calendar-connect-button"
            onclick="(function(){console.log('🔘 Connect Google Calendar button clicked!'); try { if(window.connectGoogleCalendar) { console.log('✅ Function found, calling...'); window.connectGoogleCalendar(); } else { console.error('❌ Function not found on window'); throw new Error('Function not found'); } } catch(e) { console.error('❌ Error:', e); alert('Error: ' + e.message); }})()"
            ${googleCalendarLoading ? 'disabled' : ''}
            style="
              padding: 0.75rem 1.5rem;
              font-size: 1rem;
              font-weight: 600;
              background-color: #4285f4;
              color: white;
              border: none;
              border-radius: 8px;
              cursor: ${googleCalendarLoading ? 'not-allowed' : 'pointer'};
              margin-bottom: 1rem;
              opacity: ${googleCalendarLoading ? 0.6 : 1};
              display: inline-block;
              min-width: 200px;
            "
          >
            ${googleCalendarLoading ? 'Connecting...' : 'Connect Google Calendar'}
          </button>
        </div>
      ` : ''}
      
      ${(googleCalendarConnection && !googleCalendarConnection.calendar_id) || (googleCalendarConnection?.calendar_id && googleCalendarViewMode === 'selection') ? `
        <div style="margin-bottom: 1.5rem; padding: 1rem; background-color: #fff; border: 1px solid #dee2e6; border-radius: 8px;">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
            <h2 style="font-size: 1.25rem; margin: 0; color: #2c3e50;">Select Calendar</h2>
            ${googleCalendarConnection?.calendar_id ? `
              <button
                onclick="window.googleCalendarViewMode = 'sync'; renderPMTool();"
                style="
                  padding: 0.5rem 1rem;
                  font-size: 0.875rem;
                  background-color: #4285f4;
                  color: white;
                  border: none;
                  border-radius: 4px;
                  cursor: pointer;
                "
              >
                Go to Sync
              </button>
            ` : ''}
          </div>
          ${googleCalendarCalendars.length > 0 ? `
          <select
            id="google-calendar-select"
            onchange="if(window.handleGoogleCalendarSelect) { window.handleGoogleCalendarSelect(this); } else { console.error('handleGoogleCalendarSelect not found'); }"
            style="
              width: 100%;
              padding: 0.5rem;
              font-size: 1rem;
              margin-bottom: 1rem;
              border: 1px solid #ced4da;
              border-radius: 4px;
            "
          >
            <option value="">Select a calendar...</option>
            ${googleCalendarCalendars.map(cal => {
    const calId = cal.id || '';
    if (!calId) {
      console.warn('⚠️ Calendar missing id:', cal);
      return '';
    }
    const calSummary = (cal.summary || cal.name || 'Unknown').replace(/"/g, '&quot;');
    return `<option value="${calId}">${calSummary}${cal.primary ? ' (Primary)' : ''}</option>`;
  }).join('')}
          </select>
          <div style="margin-bottom: 1rem; font-size: 0.875rem; color: #6c757d; padding: 0.5rem; background-color: #f8f9fa; border-radius: 4px;">
            <strong>Debug:</strong> Selected calendar id: <span id="google-calendar-selected-display">${googleCalendarSelectedCalendarId || '(none)'}</span>
          </div>
          <button
            id="google-calendar-save-btn"
            onclick="if(window.saveGoogleCalendarSelection) { const selectedId = window.googleCalendarSelectedCalendarId || googleCalendarSelectedCalendarId; console.log('🔘 Save button clicked', {selectedCalendarId: selectedId}); window.saveGoogleCalendarSelection(); } else { alert('Function not found'); }"
            disabled
            style="
              padding: 0.75rem 1.5rem;
              font-size: 1rem;
              font-weight: bold;
              background-color: #6c757d;
              color: white;
              border: none;
              border-radius: 8px;
              cursor: not-allowed;
              opacity: 0.6;
              width: 100%;
              pointer-events: auto;
            "
          >
            ${googleCalendarLoading ? 'Saving...' : 'Save calendar'}
          </button>
          ` : `
          <div style="padding: 1rem; background-color: #fff3cd; border: 1px solid #ffc107; border-radius: 4px;">
            <p style="color: #856404; margin-bottom: 1rem;">
              Reconnect to your google account in order to sync a different calendar
            </p>
            <button
              onclick="(function(){console.log('🔘 Reconnect button clicked'); if(window.connectGoogleCalendar) { window.connectGoogleCalendar(); } else { alert('Function not found'); }})()"
              ${googleCalendarLoading ? 'disabled' : ''}
              style="
                padding: 0.75rem 1.5rem;
                font-size: 1rem;
                background-color: #4285f4;
                color: white;
                border: none;
                border-radius: 8px;
                cursor: ${googleCalendarLoading ? 'not-allowed' : 'pointer'};
                opacity: ${googleCalendarLoading ? 0.6 : 1};
              "
            >
              ${googleCalendarLoading ? 'Connecting...' : 'Reconnect to Load Calendars'}
            </button>
          </div>
          `}
        </div>
      ` : ''}
      
      ${hasConnection && googleCalendarConnection.calendar_id && googleCalendarViewMode === 'sync' ? `
        <div style="margin-bottom: 1.5rem; padding: 1.5rem; background-color: #fff; border: 1px solid #dee2e6; border-radius: 8px;">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
            <h2 style="font-size: 1.25rem; margin: 0; color: #2c3e50;">Sync</h2>
            <button
              onclick="window.handleChangeCalendar();"
              style="
                padding: 0.5rem 1rem;
                font-size: 0.875rem;
                background-color: #4285f4;
                color: white;
                border: none;
                border-radius: 4px;
                cursor: pointer;
              "
            >
              Change Calendar
            </button>
          </div>
          <p style="margin-bottom: 1rem; color: #6c757d;">
            Click the button below to sync your calendar now.
          </p>
          <button
            onclick="(function(){console.log('🔘 Sync button clicked'); if(window.runGoogleCalendarSync) { window.runGoogleCalendarSync(); } else { alert('Function not found'); }})()"
            ${googleCalendarLoading ? 'disabled' : ''}
            style="
              padding: 0.75rem 1.5rem;
              font-size: 1rem;
              background-color: #17a2b8;
              color: white;
              border: none;
              border-radius: 8px;
              cursor: ${googleCalendarLoading ? 'not-allowed' : 'pointer'};
              opacity: ${googleCalendarLoading ? 0.6 : 1};
              width: 100%;
            "
          >
            ${googleCalendarLoading ? 'Syncing...' : 'Run Sync Now'}
          </button>
        </div>
      ` : ''}
      
      <!-- Fallback: Always show connect button if somehow hidden above -->
      ${!hasConnection ? `
        <div style="margin-top: 1rem; padding: 1rem; background-color: #fff3cd; border: 1px solid #ffc107; border-radius: 8px;">
          <p style="margin: 0 0 0.5rem 0; color: #856404; font-weight: 600;">Need to connect?</p>
          <button
            onclick="(function(){console.log('🔘 Fallback Connect button clicked!'); if(window.connectGoogleCalendar) { window.connectGoogleCalendar(); } else { alert('Function not available. Please refresh the page.'); }})()"
            style="
              padding: 0.75rem 1.5rem;
              font-size: 1rem;
              background-color: #4285f4;
              color: white;
              border: none;
              border-radius: 8px;
              cursor: pointer;
              display: block;
            "
          >
            Connect Google Calendar
          </button>
        </div>
      ` : ''}
    </div>
  `;
}

// Load intake submissions from database (filtered by company)
async function loadIntakeSubmissions() {
  // Prevent concurrent loads
  if (intakeSubmissionsLoading) {
    console.log('⏸️ Load already in progress, skipping...');
    return;
  }

  console.log('🔄 Loading intake submissions...');
  try {
    intakeSubmissionsLoading = true;
    intakeSubmissionsHasLoaded = true; // Set early to prevent multiple load attempts
    // Don't call renderPMTool() here - it causes infinite loops

    // Filter by company_id - only show submissions for user's company
    let query = supabase
      .from('intake_requests')
      .select('*')
      .order('created_at', { ascending: false });

    // Filter by current company
    if (currentCompany?.id) {
      query = query.eq('company_id', currentCompany.id);
    } else {
      // If no company, return empty array (user shouldn't see any)
      console.warn('⚠️ No company context, returning empty submissions');
      intakeSubmissions = [];
      intakeSubmissionsLoading = false;
      renderPMTool();
      return;
    }

    // Load contacts so "Make a Client" can match submission email to contact
    await loadContacts();

    const { data, error } = await query;

    if (error) {
      throw error;
    }

    intakeSubmissions = data || [];
    console.log('✅ Loaded intake submissions:', intakeSubmissions.length, 'for company:', currentCompany.id);
  } catch (error) {
    console.error('❌ Error loading intake submissions:', error);
    intakeSubmissions = [];
  } finally {
    intakeSubmissionsLoading = false;
    renderPMTool(); // Only render once at the end
  }
}

// Update intake submission status
async function updateIntakeStatus(intakeId, newStatus) {
  console.log('🔄 Updating intake status:', { intakeId, newStatus });
  try {
    const updateData = {
      status: newStatus,
    };

    // If marking as done, set completed_at and completed_by
    if (newStatus === 'done') {
      updateData.completed_at = new Date().toISOString();
      updateData.completed_by = currentProfile?.id || null;
    } else if (newStatus !== 'done') {
      updateData.completed_at = null;
      updateData.completed_by = null;
    }

    const { error } = await supabase
      .from('intake_requests')
      .update(updateData)
      .eq('id', intakeId);

    if (error) {
      throw error;
    }

    // Reload submissions
    await loadIntakeSubmissions();
  } catch (error) {
    console.error('❌ Error updating intake status:', error);
    alert('Failed to update status: ' + error.message);
  }
}

// Delete a website request (intake)
async function deleteIntakeRequest(intakeId) {
  if (!confirm('Delete this website request? This cannot be undone.')) {
    return;
  }
  try {
    const { error } = await supabase
      .from('intake_requests')
      .delete()
      .eq('id', intakeId);

    if (error) {
      throw error;
    }
    await loadIntakeSubmissions();
  } catch (error) {
    console.error('❌ Error deleting website request:', error);
    alert('Failed to delete: ' + error.message);
  }
}

// Make functions globally accessible
window.loadIntakeSubmissions = loadIntakeSubmissions;
window.updateIntakeStatus = updateIntakeStatus;
window.deleteIntakeRequest = deleteIntakeRequest;

// Render Intake Submissions Screen
async function renderIntakeSubmissionsScreen() {
  console.log('📋 Rendering Intake Submissions screen...');

  // Check if user has permission (OWNER, MANAGER, or HH Admin)
  const userRole = currentProfile?.company_role || currentProfile?.role || 'USER';
  const isOwner = userRole === 'OWNER';
  const isManager = userRole === 'MANAGER';
  const isHhAdmin = currentProfile?.is_hh_admin || currentUser?.is_hh_admin;

  if (!isOwner && !isManager && !isHhAdmin) {
    return `
      <div style="padding: 2rem; text-align: center;">
        <h2 style="color: #ef4444; margin-bottom: 1rem;">Access Denied</h2>
        <p style="color: #64748b;">Only owners and managers can access website requests.</p>
        <button onclick="switchScreen('team')" style="
          margin-top: 1rem;
          padding: 0.5rem 1rem;
          background: #ea580c;
          color: white;
          border: none;
          border-radius: 0.5rem;
          cursor: pointer;
        ">Go Back</button>
      </div>
    `;
  }

  // Sync filter state with window for inline handlers
  if (window.intakeSubmissionsStatusFilter !== undefined) {
    intakeSubmissionsStatusFilter = window.intakeSubmissionsStatusFilter;
  } else {
    window.intakeSubmissionsStatusFilter = intakeSubmissionsStatusFilter;
  }

  if (window.intakeSubmissionsSiteFilter !== undefined) {
    intakeSubmissionsSiteFilter = window.intakeSubmissionsSiteFilter;
  } else {
    window.intakeSubmissionsSiteFilter = intakeSubmissionsSiteFilter;
  }

  // Load submissions if not already loaded and haven't attempted to load yet
  if (!intakeSubmissionsHasLoaded && !intakeSubmissionsLoading) {
    loadIntakeSubmissions(); // Don't await - let it load in background
  }

  // Get unique site keys for filter
  const uniqueSiteKeys = [...new Set(intakeSubmissions.map(s => s.site_key))].sort();

  // Filter submissions
  let filteredSubmissions = intakeSubmissions;

  if (intakeSubmissionsStatusFilter !== 'all') {
    filteredSubmissions = filteredSubmissions.filter(s => s.status === intakeSubmissionsStatusFilter);
  }

  if (intakeSubmissionsSiteFilter !== 'all') {
    filteredSubmissions = filteredSubmissions.filter(s => s.site_key === intakeSubmissionsSiteFilter);
  }

  // Sort: open first, done at bottom (then by created_at desc)
  filteredSubmissions = [...filteredSubmissions].sort((a, b) => {
    const order = { open: 0, in_progress: 0, done: 1 };
    const diff = (order[a.status] ?? 0) - (order[b.status] ?? 0);
    if (diff !== 0) return diff;
    return new Date(b.created_at) - new Date(a.created_at);
  });

  // Count by status (only open and done)
  const statusCounts = {
    all: intakeSubmissions.length,
    open: intakeSubmissions.filter(s => s.status === 'open' || s.status === 'in_progress').length,
    done: intakeSubmissions.filter(s => s.status === 'done').length,
  };

  // Build content first (don't return yet)
  let content = `
    <div style="max-width: 1400px; margin: 0 auto; padding: 0 1rem;">
      <!-- Header -->
      <div style="margin-bottom: 1.5rem;">
        <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 1rem;">
          <div>
            <h1 style="
              color: ${colors.text};
              margin: 0 0 0.5rem 0;
              font-size: 2.5rem;
              font-weight: 800;
              line-height: 1.2;
            ">
              Website Requests
            </h1>
            <p style="
              color: ${colors.textSecondary};
              margin: 0;
              font-size: 1rem;
            ">
              View and manage website requests from your website
            </p>
          </div>
          <button
            onclick="switchScreen('team')"
            style="
              padding: 0.5rem 1rem;
              background: #ea580c;
              color: white;
              border: none;
              border-radius: 0.5rem;
              cursor: pointer;
              font-size: 0.875rem;
              font-weight: 600;
            "
          >
            ← Back to Team
          </button>
        </div>
        
        <!-- Filters -->
        <div style="
          display: flex;
          gap: 1rem;
          flex-wrap: wrap;
          margin-bottom: 1rem;
          padding: 1rem;
          background: white;
          border-radius: 0.75rem;
          border: 1px solid #e5e7eb;
        ">
          <!-- Status Filter -->
          <div style="display: flex; flex-direction: column; gap: 0.5rem;">
            <label style="font-size: 0.875rem; font-weight: 600; color: ${colors.text};">Status</label>
            <select
              onchange="intakeSubmissionsStatusFilter = this.value; window.intakeSubmissionsStatusFilter = this.value; renderPMTool();"
              style="
                padding: 0.5rem;
                border: 1px solid #e5e7eb;
                border-radius: 0.5rem;
                font-size: 0.875rem;
                background: white;
                color: ${colors.text};
                cursor: pointer;
              "
            >
              <option value="all" ${intakeSubmissionsStatusFilter === 'all' ? 'selected' : ''}>All (${statusCounts.all})</option>
              <option value="open" ${intakeSubmissionsStatusFilter === 'open' ? 'selected' : ''}>Open (${statusCounts.open})</option>
              <option value="done" ${intakeSubmissionsStatusFilter === 'done' ? 'selected' : ''}>Done (${statusCounts.done})</option>
            </select>
          </div>
          
          <!-- Site Filter -->
          ${uniqueSiteKeys.length > 0 ? `
            <div style="display: flex; flex-direction: column; gap: 0.5rem;">
              <label style="font-size: 0.875rem; font-weight: 600; color: ${colors.text};">Site</label>
              <select
                onchange="intakeSubmissionsSiteFilter = this.value; window.intakeSubmissionsSiteFilter = this.value; renderPMTool();"
                style="
                  padding: 0.5rem;
                  border: 1px solid #e5e7eb;
                  border-radius: 0.5rem;
                  font-size: 0.875rem;
                  background: white;
                  color: ${colors.text};
                  cursor: pointer;
                "
              >
                <option value="all" ${intakeSubmissionsSiteFilter === 'all' ? 'selected' : ''}>All Sites</option>
                ${uniqueSiteKeys.map(siteKey => `
                  <option value="${siteKey}" ${intakeSubmissionsSiteFilter === siteKey ? 'selected' : ''}>${siteKey}</option>
                `).join('')}
              </select>
            </div>
          ` : ''}
          
          <!-- Refresh Button -->
          <div style="display: flex; align-items: flex-end;">
            <button
              onclick="loadIntakeSubmissions();"
              disabled="${intakeSubmissionsLoading}"
              style="
                padding: 0.5rem 1rem;
                background: ${intakeSubmissionsLoading ? '#9ca3af' : '#ea580c'};
                color: white;
                border: none;
                border-radius: 0.5rem;
                cursor: ${intakeSubmissionsLoading ? 'not-allowed' : 'pointer'};
                font-size: 0.875rem;
                font-weight: 600;
              "
            >
              ${intakeSubmissionsLoading ? 'Loading...' : 'Refresh'}
            </button>
          </div>
        </div>
      </div>
      
      <!-- Submissions List -->
      ${intakeSubmissionsLoading ? `
        <div style="text-align: center; padding: 3rem; color: ${colors.textSecondary};">
          Loading submissions...
        </div>
      ` : filteredSubmissions.length === 0 ? `
        <div style="
          text-align: center;
          padding: 3rem;
          background: white;
          border-radius: 0.75rem;
          border: 1px solid #e5e7eb;
        ">
          <p style="color: ${colors.textSecondary}; font-size: 1.125rem; margin: 0;">
            No submissions found
          </p>
        </div>
      ` : `
        <div style="display: flex; flex-direction: column; gap: 1rem;">
          ${filteredSubmissions.map(submission => {
    const statusColors = {
      open: { bg: '#fef3c7', text: '#92400e', border: '#fde68a' },
      in_progress: { bg: '#fef3c7', text: '#92400e', border: '#fde68a' },
      done: { bg: '#d1fae5', text: '#065f46', border: '#6ee7b7' },
    };
    const statusColor = statusColors[submission.status] || statusColors.open;
    const createdDate = new Date(submission.created_at);
    const completedDate = submission.completed_at ? new Date(submission.completed_at) : null;
    const submissionContact = (contacts || []).find(c => (c.email || '').toLowerCase() === (submission.email || '').toLowerCase());
    const submissionContactId = submissionContact?.id;

    return `
              <div style="
                background: white;
                border-radius: 0.75rem;
                border: 1px solid #e5e7eb;
                padding: 1.5rem;
                transition: box-shadow 0.2s;
              " onmouseover="this.style.boxShadow='0 4px 6px rgba(0,0,0,0.1)'" onmouseout="this.style.boxShadow='none'">
                <!-- Header -->
                <div style="display: flex; align-items: start; justify-content: space-between; margin-bottom: 1rem;">
                  <div style="flex: 1;">
                    <div style="display: flex; align-items: center; gap: 0.75rem; margin-bottom: 0.5rem;">
                      <span style="
                        padding: 0.25rem 0.75rem;
                        border-radius: 0.5rem;
                        font-size: 0.75rem;
                        font-weight: 600;
                        background: ${statusColor.bg};
                        color: ${statusColor.text};
                        border: 1px solid ${statusColor.border};
                      ">
                        ${(submission.status === 'in_progress' ? 'open' : submission.status).toUpperCase()}
                      </span>
                      <span style="
                        padding: 0.25rem 0.75rem;
                        border-radius: 0.5rem;
                        font-size: 0.75rem;
                        background: #f3f4f6;
                        color: #6b7280;
                      ">
                        ${submission.site_key}
                      </span>
                      <span style="color: ${colors.textSecondary}; font-size: 0.875rem;">
                        ${createdDate.toLocaleDateString()} ${createdDate.toLocaleTimeString()}
                      </span>
                    </div>
                    ${submission.full_name ? `
                      <h3 style="
                        margin: 0;
                        font-size: 1.25rem;
                        font-weight: 600;
                        color: ${colors.text};
                      ">
                        ${submission.full_name}
                      </h3>
                    ` : ''}
                  </div>
                  
                  <!-- Status Actions: View Page first, then Mark Open, Create from Submission, Mark Done, Delete -->
                  <div style="display: flex; gap: 0.5rem; flex-wrap: wrap; align-items: center;">
                    ${submission.page_url ? `
                      <a href="${submission.page_url}" target="_blank" class="intake-card-action-btn" style="padding: 0.5rem 1rem; color: #ea580c; text-decoration: none; font-size: 0.875rem; font-weight: 600;">View Page →</a>
                    ` : ''}
                    ${(submission.status === 'done' || submission.status === 'in_progress') ? `
                      <button type="button" class="intake-card-action-btn" onclick="updateIntakeStatus('${submission.id}', 'open')" style="padding: 0.5rem 1rem; background: #ea580c; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.875rem; font-weight: 600;">Mark Open</button>
                    ` : ''}
                    <button type="button" class="intake-card-action-btn" onclick="openFormSubmissionModal('${submission.id}')" style="padding: 0.5rem 1rem; background: #ea580c; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.875rem; font-weight: 600;">Manage Submission</button>
                    ${submissionContactId && !(submissionContact?.contact_profile_id || submissionContact?.profile_id) ? `
                    <button type="button" class="intake-card-action-btn" onclick="openAddClientModal('${submissionContactId}')" style="padding: 0.5rem 1rem; background: #d97706; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.875rem; font-weight: 600;" onmouseover="this.style.background='#b45309'" onmouseout="this.style.background='#d97706'">Make a Client</button>
                    ` : ''}
                    ${submission.status !== 'done' ? `
                      <button type="button" class="intake-card-action-btn" onclick="updateIntakeStatus('${submission.id}', 'done')" style="padding: 0.5rem 1rem; background: #ea580c; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.875rem; font-weight: 600;">Mark Done</button>
                    ` : ''}
                    <button type="button" class="intake-card-action-btn" onclick="deleteIntakeRequest('${submission.id}')" style="padding: 0.5rem 1rem; background: transparent; color: #dc2626; border: 1px solid #dc2626; border-radius: 0.5rem; cursor: pointer; font-size: 0.875rem; font-weight: 600;">Delete</button>
                  </div>
                </div>
                
                <!-- Contact Info -->
                <div style="
                  display: grid;
                  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                  gap: 1rem;
                  margin-bottom: 1rem;
                  padding: 1rem;
                  background: #f9fafb;
                  border-radius: 0.5rem;
                ">
                  ${submission.email ? `
                    <div>
                      <div style="font-size: 0.75rem; color: #0f172a; margin-bottom: 0.25rem; font-weight: 600;">Email</div>
                      <div style="font-size: 0.875rem; color: ${colors.text};">
                        <a href="mailto:${submission.email}" style="color: #ea580c; text-decoration: none;">
                          ${submission.email}
                        </a>
                      </div>
                    </div>
                  ` : ''}
                  ${submission.phone ? `
                    <div>
                      <div style="font-size: 0.75rem; color: #0f172a; margin-bottom: 0.25rem; font-weight: 600;">Phone</div>
                      <div style="font-size: 0.875rem; color: ${colors.text};">
                        <a href="tel:${submission.phone}" style="color: #ea580c; text-decoration: none;">
                          ${submission.phone}
                        </a>
                      </div>
                    </div>
                  ` : ''}
                  ${(submission.page_name || submission.page_url) ? `
                    <div>
                      <div style="font-size: 0.75rem; color: #0f172a; margin-bottom: 0.25rem; font-weight: 600;">${submission.page_name ? 'From page' : 'Page URL'}</div>
                      <div style="font-size: 0.875rem; color: ${colors.text};">
                        ${submission.page_name ? `<span style="font-weight: 500;">${(submission.page_name || '').replace(/</g, '&lt;')}</span>` : ''}
                      </div>
                    </div>
                  ` : ''}
                </div>
                
                <!-- Message -->
                ${submission.message ? `
                  <div style="
                    padding: 1rem;
                    background: #f9fafb;
                    border-radius: 0.5rem;
                    border-left: 3px solid #ea580c;
                    margin-bottom: 1rem;
                  ">
                    <div style="font-size: 0.75rem; color: #0f172a; margin-bottom: 0.5rem; font-weight: 600;">
                      Message
                    </div>
                    <div style="font-size: 0.875rem; color: ${colors.text}; white-space: pre-wrap; line-height: 1.6;">
                      ${submission.message}
                    </div>
                  </div>
                ` : ''}
                
                <!-- Footer -->
                <div style="
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  padding-top: 1rem;
                  border-top: 1px solid #e5e7eb;
                  font-size: 0.75rem;
                  color: ${colors.textSecondary};
                ">
                  <div>
                    ${completedDate ? `
                      Completed: ${completedDate.toLocaleDateString()} ${completedDate.toLocaleTimeString()}
                    ` : 'Not completed'}
                  </div>
                  <div>
                    ID: ${submission.id.substring(0, 8)}...
                  </div>
                </div>
              </div>
            `;
  }).join('')}
        </div>
      `}
    </div>
  `;

  // Add modal if open (check AFTER building content)
  console.log('🔍 Checking modal state:', {
    showFormSubmissionModal: showFormSubmissionModal,
    windowShowFormSubmissionModal: window.showFormSubmissionModal,
    hasModalData: !!window.formSubmissionModalData
  });

  if (window.showFormSubmissionModal) {
    console.log('✅ Modal should be shown, rendering...');
    const modalHtml = renderFormSubmissionModal();
    console.log('✅ Modal HTML generated, length:', modalHtml.length);
    content = content + modalHtml;
  } else {
    console.log('❌ Modal not shown - window.showFormSubmissionModal is:', window.showFormSubmissionModal);
  }

  // Add appointment date/time modal if open

  return content;
}

// Form Submission Modal Functions
async function openFormSubmissionModal(intakeRequestId) {
  console.log('📋 Opening form submission modal for:', intakeRequestId);

  const submission = intakeSubmissions.find(s => s.id === intakeRequestId);
  if (!submission) {
    console.error('❌ Submission not found:', intakeRequestId);
    showNotification('Form submission not found', 'error');
    return;
  }

  // Show modal immediately with loading state (no await before this)
  formSubmissionModalData = {
    intakeRequestId: intakeRequestId,
    intakeRequest: submission,
    existingContact: null,
    detectedType: detectSubmissionType(submission),
    currentStep: 'loading',
    createdContactId: null,
    workspaceProjects: [],
    workspaceTasks: [],
    workspaceChats: [],
    workspaceSalesOpportunities: [],
    editingWorkspaceItem: null
  };
  window.formSubmissionModalData = formSubmissionModalData;
  showFormSubmissionModal = true;
  window.showFormSubmissionModal = true;
  renderPMTool();

  // Load data in background, then update modal
  try {
    if (submission.email && currentCompany?.id) {
      const { data: contacts, error } = await supabase
        .from('contacts')
        .select('id, first_name, last_name, email, phone')
        .eq('company_id', currentCompany.id)
        .eq('email', submission.email.toLowerCase().trim())
        .limit(1);
      if (!error && contacts && contacts.length > 0) {
        formSubmissionModalData.existingContact = contacts[0];
        window.formSubmissionModalData = formSubmissionModalData;
      }
    }

    await loadIntakeWorkspace(intakeRequestId);
    formSubmissionModalData.initialWorkspaceOpportunityIds = (formSubmissionModalData.workspaceSalesOpportunities || []).map(o => o.id);
    window.formSubmissionModalData = formSubmissionModalData;

    if (companyEmployees === null) await loadCompanyEmployees();

    formSubmissionModalData.currentStep = formSubmissionModalData.existingContact ? 'create_record' : (submission.email ? 'create_contact' : 'create_record');
    window.formSubmissionModalData = formSubmissionModalData;
  } catch (error) {
    console.error('Error loading form submission modal:', error);
    formSubmissionModalData.currentStep = formSubmissionModalData.existingContact ? 'create_record' : 'create_contact';
    window.formSubmissionModalData = formSubmissionModalData;
  }
  renderPMTool();
}

function detectSubmissionType(submission) {
  const message = (submission.message || '').toLowerCase();
  const fullName = (submission.full_name || '').toLowerCase();

  // Keywords for different types
  const appointmentKeywords = ['appointment', 'schedule', 'meeting', 'call', 'demo', 'consultation', 'available', 'when can', 'book', 'reserve'];
  const salesKeywords = ['quote', 'price', 'cost', 'pricing', 'estimate', 'budget', 'purchase', 'buy', 'interested in', 'want to buy'];
  const taskKeywords = ['fix', 'repair', 'issue', 'problem', 'help with', 'need help', 'support', 'broken', 'not working'];

  // Check for appointment indicators
  if (appointmentKeywords.some(keyword => message.includes(keyword) || fullName.includes(keyword))) {
    return 'appointment';
  }

  // Check for sales opportunity indicators
  if (salesKeywords.some(keyword => message.includes(keyword))) {
    return 'sales_opportunity';
  }

  // Check for task indicators
  if (taskKeywords.some(keyword => message.includes(keyword))) {
    return 'task';
  }

  // Default to contact if no clear type
  return 'contact';
}

function closeFormSubmissionModal() {
  showFormSubmissionModal = false;
  formSubmissionModalData = {
    intakeRequestId: null,
    intakeRequest: null,
    existingContact: null,
    detectedType: null,
    currentStep: 'detect',
    createdContactId: null,
    workspaceProjects: [],
    workspaceTasks: [],
    workspaceChats: [],
    workspaceSalesOpportunities: [],
    editingWorkspaceItem: null,
    initialWorkspaceOpportunityIds: []
  };
  window.formSubmissionModalData = formSubmissionModalData;
  renderPMTool();
}

// Load workspace (projects, tasks, chats, sales opportunities) created by intake-create-workspace for this intake
async function loadIntakeWorkspace(intakeRequestId) {
  if (!intakeRequestId || !currentCompany?.id) {
    formSubmissionModalData.workspaceProjects = [];
    formSubmissionModalData.workspaceTasks = [];
    formSubmissionModalData.workspaceChats = [];
    formSubmissionModalData.workspaceSalesOpportunities = [];
    window.formSubmissionModalData = formSubmissionModalData;
    return;
  }
  try {
    const contactId = formSubmissionModalData.existingContact?.id || null;

    const { data: projects, error: projErr } = await supabase
      .from('projects')
      .select('id, name, description, status, created_at')
      .eq('company_id', currentCompany.id)
      .eq('intake_id', intakeRequestId)
      .order('created_at', { ascending: false });

    if (projErr) {
      console.warn('loadIntakeWorkspace projects:', projErr);
      formSubmissionModalData.workspaceProjects = [];
    } else {
      formSubmissionModalData.workspaceProjects = projects || [];
    }

    const projectIds = (formSubmissionModalData.workspaceProjects || []).map(p => p.id);

    // Tasks: only from current intake projects (with assignees for inline edit)
    if (projectIds.length === 0) {
      formSubmissionModalData.workspaceTasks = [];
    } else {
      const tasksRes = await supabase.from('tasks').select('id, title, state, created_at').in('project_id', projectIds).order('created_at', { ascending: false });
      const tasks = tasksRes.data || [];
      const taskIds = tasks.map(t => t.id);
      let assigneesByTask = {};
      if (taskIds.length > 0) {
        const { data: assignees } = await supabase.from('task_assignees').select('task_id, user_id').in('task_id', taskIds);
        (assignees || []).forEach(a => {
          if (!assigneesByTask[a.task_id]) assigneesByTask[a.task_id] = [];
          assigneesByTask[a.task_id].push(a.user_id);
        });
      }
      formSubmissionModalData.workspaceTasks = tasks.map(t => ({ ...t, assigned_member_ids: assigneesByTask[t.id] || [] }));
    }

    // Chats: from intake projects OR by contact (so chats stay visible after project delete)
    const chatPromises = [];
    if (projectIds.length > 0) {
      chatPromises.push(supabase.from('chats').select('id, title, created_at').in('project_id', projectIds).order('created_at', { ascending: false }));
    }
    if (contactId) {
      chatPromises.push(supabase.from('chats').select('id, title, created_at').eq('company_id', currentCompany.id).eq('contact_id', contactId).order('created_at', { ascending: false }));
    }
    if (chatPromises.length === 0) {
      formSubmissionModalData.workspaceChats = [];
    } else {
      const chatResults = await Promise.all(chatPromises);
      const seen = new Set();
      const merged = [];
      for (const res of chatResults) {
        if (res.data) {
          for (const c of res.data) {
            if (!seen.has(c.id)) { seen.add(c.id); merged.push(c); }
          }
        }
      }
      merged.sort((a, b) => new Date(b.created_at || 0) - new Date(a.created_at || 0));
      formSubmissionModalData.workspaceChats = merged;
    }

    // Sales opportunities: for this contact (from website intake)
    if (contactId) {
      const oppRes = await supabase.from('sales_opportunities').select('id, title, stage, source, notes, created_at').eq('company_id', currentCompany.id).eq('contact_id', contactId).order('created_at', { ascending: false });
      formSubmissionModalData.workspaceSalesOpportunities = oppRes.data || [];
    } else {
      formSubmissionModalData.workspaceSalesOpportunities = [];
    }

    window.formSubmissionModalData = formSubmissionModalData;
  } catch (err) {
    console.error('loadIntakeWorkspace:', err);
    formSubmissionModalData.workspaceProjects = [];
    formSubmissionModalData.workspaceTasks = [];
    formSubmissionModalData.workspaceChats = [];
    formSubmissionModalData.workspaceSalesOpportunities = [];
    window.formSubmissionModalData = formSubmissionModalData;
  }
}

// Delete workspace contact from form submission modal (and their workspace + the website request)
async function deleteIntakeWorkspaceContact(contactId, intakeRequestId) {
  if (!contactId || !intakeRequestId) return;
  if (!confirm('Are you sure you want to delete this contact? This will also delete their workspace (projects, tasks, chats, sales opportunity) and the website request.')) return;
  try {
    const projectIds = (formSubmissionModalData.workspaceProjects || []).map(p => p.id);

    // Delete in order (respect FKs): sales opportunities, chats, tasks, projects, contact, then intake request
    await supabase.from('sales_opportunities').delete().eq('contact_id', contactId);
    await supabase.from('chats').delete().eq('contact_id', contactId);
    if (projectIds.length > 0) {
      await supabase.from('tasks').delete().in('project_id', projectIds);
      await supabase.from('projects').delete().eq('intake_id', intakeRequestId);
    }
    const { error: contactErr } = await supabase.from('contacts').delete().eq('id', contactId);
    if (contactErr) throw contactErr;

    const { error: intakeErr } = await supabase.from('intake_requests').delete().eq('id', intakeRequestId);
    if (intakeErr) throw intakeErr;

    formSubmissionModalData.existingContact = null;
    formSubmissionModalData.workspaceProjects = [];
    formSubmissionModalData.workspaceTasks = [];
    formSubmissionModalData.workspaceChats = [];
    formSubmissionModalData.workspaceSalesOpportunities = [];
    window.formSubmissionModalData = formSubmissionModalData;
    closeFormSubmissionModal();
    showNotification('Contact, workspace, and website request deleted', 'success');
    renderPMTool();
  } catch (err) {
    console.error('deleteIntakeWorkspaceContact:', err);
    showNotification('Failed to delete contact: ' + (err.message || err), 'error');
  }
}

// Delete workspace project (tasks are removed; chats are kept and unlinked from project)
async function deleteIntakeWorkspaceProject(projectId, intakeRequestId) {
  if (!projectId || !intakeRequestId) return;
  if (!confirm('Delete this project? Tasks under it will be removed. Chats will be kept.')) return;
  try {
    await supabase.from('tasks').delete().eq('project_id', projectId);
    const { error } = await supabase.from('projects').delete().eq('id', projectId);
    if (error) throw error;
    await loadIntakeWorkspace(intakeRequestId);
    window.formSubmissionModalData = formSubmissionModalData;
    showNotification('Project deleted', 'success');
    renderPMTool();
  } catch (err) {
    console.error('deleteIntakeWorkspaceProject:', err);
    showNotification('Failed to delete project: ' + (err.message || err), 'error');
  }
}

// Delete workspace task
async function deleteIntakeWorkspaceTask(taskId, intakeRequestId) {
  if (!taskId || !intakeRequestId) return;
  if (!confirm('Delete this task?')) return;
  try {
    const { error } = await supabase.from('tasks').delete().eq('id', taskId);
    if (error) throw error;
    await loadIntakeWorkspace(intakeRequestId);
    window.formSubmissionModalData = formSubmissionModalData;
    showNotification('Task deleted', 'success');
    renderPMTool();
  } catch (err) {
    console.error('deleteIntakeWorkspaceTask:', err);
    showNotification('Failed to delete task: ' + (err.message || err), 'error');
  }
}

// Delete workspace chat
async function deleteIntakeWorkspaceChat(chatId, intakeRequestId) {
  if (!chatId || !intakeRequestId) return;
  if (!confirm('Delete this chat and its messages?')) return;
  try {
    const { error } = await supabase.from('chats').delete().eq('id', chatId);
    if (error) throw error;
    await loadIntakeWorkspace(intakeRequestId);
    window.formSubmissionModalData = formSubmissionModalData;
    showNotification('Chat deleted', 'success');
    renderPMTool();
  } catch (err) {
    console.error('deleteIntakeWorkspaceChat:', err);
    const msg = err?.message || err?.error_description || String(err);
    showNotification('Failed to delete chat: ' + msg, 'error');
  }
}

// Delete workspace sales opportunity
async function deleteIntakeWorkspaceSalesOpportunity(opportunityId, intakeRequestId) {
  if (!opportunityId || !intakeRequestId) return;
  if (!confirm('Are you sure you want to delete this sales opportunity?')) return;
  try {
    const { error } = await supabase.from('sales_opportunities').delete().eq('id', opportunityId);
    if (error) throw error;
    await loadIntakeWorkspace(intakeRequestId);
    window.formSubmissionModalData = formSubmissionModalData;
    showNotification('Sales opportunity deleted', 'success');
    renderPMTool();
  } catch (err) {
    console.error('deleteIntakeWorkspaceSalesOpportunity:', err);
    showNotification('Failed to delete sales opportunity: ' + (err.message || err), 'error');
  }
}

function openEditIntakeWorkspaceContact(contactId) {
  formSubmissionModalData.editingWorkspaceItem = { type: 'contact', id: contactId };
  window.formSubmissionModalData = formSubmissionModalData;
  const el = document.getElementById('form-submission-workspace-section');
  if (el) { el.outerHTML = getFormSubmissionModalWorkspaceSectionHTML(); return; }
  renderPMTool();
}
function openEditIntakeWorkspaceSalesOpportunity(opportunityId) {
  formSubmissionModalData.editingWorkspaceItem = { type: 'sales_opportunity', id: opportunityId };
  window.formSubmissionModalData = formSubmissionModalData;
  const el = document.getElementById('form-submission-workspace-section');
  if (el) { el.outerHTML = getFormSubmissionModalWorkspaceSectionHTML(); return; }
  renderPMTool();
}
function openEditIntakeWorkspaceProject(projectId) {
  formSubmissionModalData.editingWorkspaceItem = { type: 'project', id: projectId };
  window.formSubmissionModalData = formSubmissionModalData;
  const el = document.getElementById('form-submission-workspace-section');
  if (el) { el.outerHTML = getFormSubmissionModalWorkspaceSectionHTML(); return; }
  renderPMTool();
}
function openEditIntakeWorkspaceTask(taskId) {
  formSubmissionModalData.editingWorkspaceItem = { type: 'task', id: taskId };
  window.formSubmissionModalData = formSubmissionModalData;
  const el = document.getElementById('form-submission-workspace-section');
  if (el) { el.outerHTML = getFormSubmissionModalWorkspaceSectionHTML(); return; }
  renderPMTool();
}
function openEditIntakeWorkspaceChat(chatId) {
  formSubmissionModalData.editingWorkspaceItem = { type: 'chat', id: chatId };
  window.formSubmissionModalData = formSubmissionModalData;
  const el = document.getElementById('form-submission-workspace-section');
  if (el) { el.outerHTML = getFormSubmissionModalWorkspaceSectionHTML(); return; }
  renderPMTool();
}
function cancelEditIntakeWorkspace() {
  formSubmissionModalData.editingWorkspaceItem = null;
  window.formSubmissionModalData = formSubmissionModalData;
  const el = document.getElementById('form-submission-workspace-section');
  if (el) { el.outerHTML = getFormSubmissionModalWorkspaceSectionHTML(); return; }
  renderPMTool();
}
async function saveEditIntakeWorkspaceContact(contactId, intakeRequestId) {
  const firstName = (document.getElementById('workspace-edit-contact-first-name')?.value || '').trim();
  const lastName = (document.getElementById('workspace-edit-contact-last-name')?.value || '').trim();
  const email = (document.getElementById('workspace-edit-contact-email')?.value || '').trim().toLowerCase();
  const phone = (document.getElementById('workspace-edit-contact-phone')?.value || '').trim();
  if (!firstName || !lastName || !email) { showNotification('First name, last name, and email are required', 'error'); return; }
  try {
    const { error } = await supabase.from('contacts').update({ first_name: firstName, last_name: lastName, email, phone: phone || null }).eq('id', contactId);
    if (error) throw error;
    formSubmissionModalData.editingWorkspaceItem = null;
    formSubmissionModalData.existingContact = { ...formSubmissionModalData.existingContact, first_name: firstName, last_name: lastName, email, phone: phone || null };
    window.formSubmissionModalData = formSubmissionModalData;
    await loadIntakeWorkspace(intakeRequestId);
    window.formSubmissionModalData = formSubmissionModalData;
    showNotification('Contact updated', 'success');
    renderPMTool();
  } catch (err) {
    console.error('saveEditIntakeWorkspaceContact:', err);
    showNotification('Failed to update contact: ' + (err?.message || err), 'error');
  }
}
async function saveEditIntakeWorkspaceSalesOpportunity(opportunityId, intakeRequestId) {
  const title = (document.getElementById('workspace-edit-opp-' + opportunityId + '-title')?.value || '').trim();
  const stage = (document.getElementById('workspace-edit-opp-' + opportunityId + '-stage')?.value || '').trim();
  const notes = (document.getElementById('workspace-edit-opp-' + opportunityId + '-notes')?.value || '').trim();
  if (!title) { showNotification('Title is required', 'error'); return; }
  try {
    const { error } = await supabase.from('sales_opportunities').update({ title, stage: stage || 'new', notes: notes || null }).eq('id', opportunityId);
    if (error) throw error;
    formSubmissionModalData.editingWorkspaceItem = null;
    window.formSubmissionModalData = formSubmissionModalData;
    await loadIntakeWorkspace(intakeRequestId);
    window.formSubmissionModalData = formSubmissionModalData;
    showNotification('Sales opportunity updated', 'success');
    renderPMTool();
  } catch (err) {
    console.error('saveEditIntakeWorkspaceSalesOpportunity:', err);
    showNotification('Failed to update: ' + (err?.message || err), 'error');
  }
}
async function saveEditIntakeWorkspaceProject(projectId, intakeRequestId) {
  const name = (document.getElementById('workspace-edit-project-' + projectId + '-name')?.value || '').trim();
  const description = (document.getElementById('workspace-edit-project-' + projectId + '-description')?.value || '').trim();
  const status = (document.getElementById('workspace-edit-project-' + projectId + '-status')?.value || 'active').trim();
  if (!name) { showNotification('Project name is required', 'error'); return; }
  try {
    const { error } = await supabase.from('projects').update({ name, description: description || null, status }).eq('id', projectId);
    if (error) throw error;
    formSubmissionModalData.editingWorkspaceItem = null;
    window.formSubmissionModalData = formSubmissionModalData;
    await loadIntakeWorkspace(intakeRequestId);
    window.formSubmissionModalData = formSubmissionModalData;
    showNotification('Project updated', 'success');
    renderPMTool();
  } catch (err) {
    console.error('saveEditIntakeWorkspaceProject:', err);
    showNotification('Failed to update: ' + (err?.message || err), 'error');
  }
}
async function saveEditIntakeWorkspaceTask(taskId, intakeRequestId) {
  const title = (document.getElementById('workspace-edit-task-' + taskId + '-title')?.value || '').trim();
  const state = (document.getElementById('workspace-edit-task-' + taskId + '-state')?.value || 'BACKLOG').trim();
  const assignedTo = (document.getElementById('workspace-edit-task-' + taskId + '-assigned-to')?.value || '').trim();
  if (!title) { showNotification('Task title is required', 'error'); return; }
  try {
    const { error } = await supabase.from('tasks').update({ title, state }).eq('id', taskId);
    if (error) throw error;
    await supabase.from('task_assignees').delete().eq('task_id', taskId);
    if (assignedTo) {
      await supabase.from('task_assignees').insert({ task_id: taskId, user_id: assignedTo });
    }
    formSubmissionModalData.editingWorkspaceItem = null;
    window.formSubmissionModalData = formSubmissionModalData;
    await loadIntakeWorkspace(intakeRequestId);
    window.formSubmissionModalData = formSubmissionModalData;
    showNotification('Task updated', 'success');
    renderPMTool();
  } catch (err) {
    console.error('saveEditIntakeWorkspaceTask:', err);
    showNotification('Failed to update: ' + (err?.message || err), 'error');
  }
}
async function saveEditIntakeWorkspaceChat(chatId, intakeRequestId) {
  const title = (document.getElementById('workspace-edit-chat-' + chatId + '-title')?.value || '').trim();
  if (!title) { showNotification('Chat title is required', 'error'); return; }
  try {
    const { error } = await supabase.from('chats').update({ title }).eq('id', chatId);
    if (error) throw error;
    formSubmissionModalData.editingWorkspaceItem = null;
    window.formSubmissionModalData = formSubmissionModalData;
    await loadIntakeWorkspace(intakeRequestId);
    window.formSubmissionModalData = formSubmissionModalData;
    showNotification('Chat updated', 'success');
    renderPMTool();
  } catch (err) {
    console.error('saveEditIntakeWorkspaceChat:', err);
    showNotification('Failed to update: ' + (err?.message || err), 'error');
  }
}

window.loadIntakeWorkspace = loadIntakeWorkspace;
window.deleteIntakeWorkspaceContact = deleteIntakeWorkspaceContact;
window.deleteIntakeWorkspaceProject = deleteIntakeWorkspaceProject;
window.deleteIntakeWorkspaceTask = deleteIntakeWorkspaceTask;
window.deleteIntakeWorkspaceChat = deleteIntakeWorkspaceChat;
window.deleteIntakeWorkspaceSalesOpportunity = deleteIntakeWorkspaceSalesOpportunity;
window.openEditIntakeWorkspaceContact = openEditIntakeWorkspaceContact;
window.openEditIntakeWorkspaceSalesOpportunity = openEditIntakeWorkspaceSalesOpportunity;
window.openEditIntakeWorkspaceProject = openEditIntakeWorkspaceProject;
window.openEditIntakeWorkspaceTask = openEditIntakeWorkspaceTask;
window.openEditIntakeWorkspaceChat = openEditIntakeWorkspaceChat;
window.cancelEditIntakeWorkspace = cancelEditIntakeWorkspace;
window.saveEditIntakeWorkspaceContact = saveEditIntakeWorkspaceContact;
window.saveEditIntakeWorkspaceSalesOpportunity = saveEditIntakeWorkspaceSalesOpportunity;
window.saveEditIntakeWorkspaceProject = saveEditIntakeWorkspaceProject;
window.saveEditIntakeWorkspaceTask = saveEditIntakeWorkspaceTask;
window.saveEditIntakeWorkspaceChat = saveEditIntakeWorkspaceChat;

// Make functions globally accessible
window.openFormSubmissionModal = openFormSubmissionModal;
window.closeFormSubmissionModal = closeFormSubmissionModal;

// Close modal and navigate to the workspace item (contact, project, task, sales opportunity, chat)
window.openWorkspaceItem = function (type, id, projectId) {
  closeFormSubmissionModal();
  if (type === 'contact') {
    viewContactDetail(id);
  } else if (type === 'project' || type === 'task') {
    // PM tool page (Project Management Tool with project list)
    currentScreen = 'team';
    renderPMTool();
  } else if (type === 'sales_opportunity') {
    // Sales Dashboard page
    currentScreen = 'sales';
    renderPMTool();
  } else if (type === 'chat') {
    currentScreen = 'chat';
    renderPMTool();
    setTimeout(function () { selectChat(id); }, 150);
  }
};

// Returns only the Workspace (auto-created) section HTML for partial updates (avoids full re-render and scroll jump)
function getFormSubmissionModalWorkspaceSectionHTML() {
  const modalData = window.formSubmissionModalData;
  if (!modalData?.intakeRequest) return '';
  const submission = modalData.intakeRequest;
  const existingContact = modalData.existingContact;
  const colors = { text: '#0f172a', textSecondary: '#64748b', border: '#e2e8f0', background: '#f8fafc' };
  const workspaceOpportunities = (modalData.workspaceSalesOpportunities || []).filter(o => (modalData.initialWorkspaceOpportunityIds || []).includes(o.id));
  return `<div id="form-submission-workspace-section" style="margin-top: 1.5rem; padding-top: 1.5rem; border-top: 1px solid #e5e7eb;">
            <h3 style="margin: 0 0 1rem 0; font-size: 1.125rem; font-weight: 600; color: ${colors.text};">
              Workspace (auto-created)
            </h3>
            <p style="margin: 0 0 1rem 0; font-size: 0.875rem; color: ${colors.textSecondary};">
              Project, task, chat, contact, and sales opportunities were created for this inquiry from your website. You can edit or delete any of these below:
            </p>
            ${existingContact ? `
            <div style="margin-bottom: 1rem;">
              <div style="font-size: 0.875rem; font-weight: 600; color: ${colors.text}; margin-bottom: 0.5rem;">Contact</div>
              ${modalData.editingWorkspaceItem?.type === 'contact' && modalData.editingWorkspaceItem?.id === existingContact.id ? `
              <div style="padding: 0.75rem; background: #f9fafb; border-radius: 0.5rem; border: 1px solid #e5e7eb;">
                <div style="display: grid; gap: 0.5rem; margin-bottom: 0.75rem;">
                  <input type="text" id="workspace-edit-contact-first-name" placeholder="First name" value="${(existingContact.first_name || '').replace(/"/g, '&quot;').replace(/</g, '&lt;')}" style="padding: 0.5rem; border: 1px solid #e5e7eb; border-radius: 0.375rem; font-size: 0.875rem;" />
                  <input type="text" id="workspace-edit-contact-last-name" placeholder="Last name" value="${(existingContact.last_name || '').replace(/"/g, '&quot;').replace(/</g, '&lt;')}" style="padding: 0.5rem; border: 1px solid #e5e7eb; border-radius: 0.375rem; font-size: 0.875rem;" />
                  <input type="email" id="workspace-edit-contact-email" placeholder="Email" value="${(existingContact.email || '').replace(/"/g, '&quot;').replace(/</g, '&lt;')}" style="padding: 0.5rem; border: 1px solid #e5e7eb; border-radius: 0.375rem; font-size: 0.875rem;" />
                  <input type="text" id="workspace-edit-contact-phone" placeholder="Phone" value="${(existingContact.phone || '').replace(/"/g, '&quot;').replace(/</g, '&lt;')}" style="padding: 0.5rem; border: 1px solid #e5e7eb; border-radius: 0.375rem; font-size: 0.875rem;" />
                </div>
                <div style="display: flex; gap: 0.5rem;">
                  <button type="button" onclick="saveEditIntakeWorkspaceContact('${existingContact.id}', '${submission.id}')" style="padding: 0.35rem 0.75rem; background: #16a34a; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Save</button>
                  <button type="button" onclick="cancelEditIntakeWorkspace()" style="padding: 0.35rem 0.75rem; background: #6b7280; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Cancel</button>
                </div>
              </div>
              ` : `
              <div style="display: flex; align-items: center; justify-content: space-between; padding: 0.75rem; background: #f9fafb; border-radius: 0.5rem; border: 1px solid #e5e7eb;">
                <span style="font-size: 0.875rem;">${(existingContact.first_name || '').replace(/</g, '&lt;')} ${(existingContact.last_name || '').replace(/</g, '&lt;')} (${(existingContact.email || '').replace(/</g, '&lt;')})</span>
                <div style="display: flex; gap: 0.35rem;">
                  <button type="button" onclick="openEditIntakeWorkspaceContact('${existingContact.id}')" style="padding: 0.35rem 0.75rem; background: #2563eb; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Edit</button>
                  <button type="button" onclick="deleteIntakeWorkspaceContact('${existingContact.id}', '${submission.id}')" style="padding: 0.35rem 0.75rem; background: #dc2626; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Delete</button>
                </div>
              </div>
              `}
            </div>
            ` : ''}
            ${(workspaceOpportunities.length > 0) ? `
            <div style="margin-bottom: 1rem;">
              <div style="font-size: 0.875rem; font-weight: 600; color: ${colors.text}; margin-bottom: 0.5rem;">Sales opportunities</div>
              ${workspaceOpportunities.map(o => `
              ${modalData.editingWorkspaceItem?.type === 'sales_opportunity' && modalData.editingWorkspaceItem?.id === o.id ? `
              <div style="padding: 0.75rem; background: #f9fafb; border-radius: 0.5rem; border: 1px solid #e5e7eb; margin-bottom: 0.5rem;">
                <div style="display: grid; gap: 0.5rem; margin-bottom: 0.75rem;">
                  <input type="text" id="workspace-edit-opp-${o.id}-title" placeholder="Title" value="${(o.title || '').replace(/"/g, '&quot;').replace(/</g, '&lt;')}" style="padding: 0.5rem; border: 1px solid #e5e7eb; border-radius: 0.375rem; font-size: 0.875rem;" />
                  <select id="workspace-edit-opp-${o.id}-stage" style="padding: 0.5rem; border: 1px solid #e5e7eb; border-radius: 0.375rem; font-size: 0.875rem;">
                    <option value="new" ${(o.stage || '') === 'new' ? 'selected' : ''}>new</option>
                    <option value="contacted" ${(o.stage || '') === 'contacted' ? 'selected' : ''}>contacted</option>
                    <option value="qualified" ${(o.stage || '') === 'qualified' ? 'selected' : ''}>qualified</option>
                    <option value="proposal" ${(o.stage || '') === 'proposal' ? 'selected' : ''}>proposal</option>
                    <option value="negotiation" ${(o.stage || '') === 'negotiation' ? 'selected' : ''}>negotiation</option>
                    <option value="won" ${(o.stage || '') === 'won' ? 'selected' : ''}>won</option>
                    <option value="lost" ${(o.stage || '') === 'lost' ? 'selected' : ''}>lost</option>
                  </select>
                  <textarea id="workspace-edit-opp-${o.id}-notes" placeholder="Notes" rows="2" style="padding: 0.5rem; border: 1px solid #e5e7eb; border-radius: 0.375rem; font-size: 0.875rem;">${(o.notes || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')}</textarea>
                </div>
                <div style="display: flex; gap: 0.5rem;">
                  <button type="button" onclick="saveEditIntakeWorkspaceSalesOpportunity('${o.id}', '${submission.id}')" style="padding: 0.35rem 0.75rem; background: #16a34a; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Save</button>
                  <button type="button" onclick="cancelEditIntakeWorkspace()" style="padding: 0.35rem 0.75rem; background: #6b7280; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Cancel</button>
                </div>
              </div>
              ` : `
              <div class="workspace-item-row" onclick="openWorkspaceItem('sales_opportunity', '${o.id}')" style="display: flex; align-items: center; justify-content: space-between; padding: 0.75rem; background: #f9fafb; border-radius: 0.5rem; border: 1px solid #e5e7eb; margin-bottom: 0.5rem;">
                <span style="font-size: 0.875rem;">${(o.title || 'Untitled').replace(/</g, '&lt;')} ${o.stage ? '(' + String(o.stage).replace(/</g, '&lt;') + ')' : ''}</span>
                <div style="display: flex; gap: 0.35rem;" onclick="event.stopPropagation()">
                  <button type="button" onclick="openEditIntakeWorkspaceSalesOpportunity('${o.id}')" style="padding: 0.35rem 0.75rem; background: #2563eb; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Edit</button>
                  <button type="button" onclick="deleteIntakeWorkspaceSalesOpportunity('${o.id}', '${submission.id}')" style="padding: 0.35rem 0.75rem; background: #dc2626; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Delete</button>
                </div>
              </div>
              `}
              `).join('')}
            </div>
            ` : ''}
            ${(modalData.workspaceProjects && modalData.workspaceProjects.length > 0) ? `
            <div style="margin-bottom: 1rem;">
              <div style="font-size: 0.875rem; font-weight: 600; color: ${colors.text}; margin-bottom: 0.5rem;">Projects</div>
              ${modalData.workspaceProjects.map(p => `
              ${modalData.editingWorkspaceItem?.type === 'project' && modalData.editingWorkspaceItem?.id === p.id ? `
              <div style="padding: 0.75rem; background: #f9fafb; border-radius: 0.5rem; border: 1px solid #e5e7eb; margin-bottom: 0.5rem;">
                <div style="display: grid; gap: 0.5rem; margin-bottom: 0.75rem;">
                  <input type="text" id="workspace-edit-project-${p.id}-name" placeholder="Project name" value="${(p.name || '').replace(/"/g, '&quot;').replace(/</g, '&lt;')}" style="padding: 0.5rem; border: 1px solid #e5e7eb; border-radius: 0.375rem; font-size: 0.875rem;" />
                  <input type="text" id="workspace-edit-project-${p.id}-description" placeholder="Description" value="${(p.description || '').replace(/"/g, '&quot;').replace(/</g, '&lt;')}" style="padding: 0.5rem; border: 1px solid #e5e7eb; border-radius: 0.375rem; font-size: 0.875rem;" />
                  <select id="workspace-edit-project-${p.id}-status" style="padding: 0.5rem; border: 1px solid #e5e7eb; border-radius: 0.375rem; font-size: 0.875rem;">
                    <option value="active" ${(p.status || '') === 'active' ? 'selected' : ''}>active</option>
                    <option value="completed" ${(p.status || '') === 'completed' ? 'selected' : ''}>completed</option>
                    <option value="on_hold" ${(p.status || '') === 'on_hold' ? 'selected' : ''}>on_hold</option>
                    <option value="cancelled" ${(p.status || '') === 'cancelled' ? 'selected' : ''}>cancelled</option>
                  </select>
                </div>
                <div style="display: flex; gap: 0.5rem;">
                  <button type="button" onclick="saveEditIntakeWorkspaceProject('${p.id}', '${submission.id}')" style="padding: 0.35rem 0.75rem; background: #16a34a; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Save</button>
                  <button type="button" onclick="cancelEditIntakeWorkspace()" style="padding: 0.35rem 0.75rem; background: #6b7280; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Cancel</button>
                </div>
              </div>
              ` : `
              <div class="workspace-item-row" onclick="openWorkspaceItem('project', '${p.id}')" style="display: flex; align-items: center; justify-content: space-between; padding: 0.75rem; background: #f9fafb; border-radius: 0.5rem; border: 1px solid #e5e7eb; margin-bottom: 0.5rem;">
                <span style="font-size: 0.875rem;">${(p.name || 'Untitled').replace(/</g, '&lt;')}</span>
                <div style="display: flex; gap: 0.35rem;" onclick="event.stopPropagation()">
                  <button type="button" onclick="openEditIntakeWorkspaceProject('${p.id}')" style="padding: 0.35rem 0.75rem; background: #2563eb; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Edit</button>
                  <button type="button" onclick="deleteIntakeWorkspaceProject('${p.id}', '${submission.id}')" style="padding: 0.35rem 0.75rem; background: #dc2626; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Delete</button>
                </div>
              </div>
              `}
              `).join('')}
            </div>
            ` : ''}
            ${(modalData.workspaceTasks && modalData.workspaceTasks.length > 0) ? `
            <div style="margin-bottom: 1rem;">
              <div style="font-size: 0.875rem; font-weight: 600; color: ${colors.text}; margin-bottom: 0.5rem;">Tasks</div>
              ${modalData.workspaceTasks.map(t => `
              ${modalData.editingWorkspaceItem?.type === 'task' && modalData.editingWorkspaceItem?.id === t.id ? `
              <div style="padding: 0.75rem; background: #f9fafb; border-radius: 0.5rem; border: 1px solid #e5e7eb; margin-bottom: 0.5rem;">
                <div style="display: grid; gap: 0.5rem; margin-bottom: 0.75rem;">
                  <input type="text" id="workspace-edit-task-${t.id}-title" placeholder="Task title" value="${(t.title || '').replace(/"/g, '&quot;').replace(/</g, '&lt;')}" style="padding: 0.5rem; border: 1px solid #e5e7eb; border-radius: 0.375rem; font-size: 0.875rem;" />
                  <select id="workspace-edit-task-${t.id}-state" style="padding: 0.5rem; border: 1px solid #e5e7eb; border-radius: 0.375rem; font-size: 0.875rem;">
                    <option value="BACKLOG" ${(t.state || '') === 'BACKLOG' ? 'selected' : ''}>BACKLOG</option>
                    <option value="IN_PROGRESS" ${(t.state || '') === 'IN_PROGRESS' ? 'selected' : ''}>IN_PROGRESS</option>
                    <option value="DONE" ${(t.state || '') === 'DONE' ? 'selected' : ''}>DONE</option>
                    <option value="CANCELLED" ${(t.state || '') === 'CANCELLED' ? 'selected' : ''}>CANCELLED</option>
                  </select>
                  <div>
                    <label style="display: block; font-size: 0.75rem; font-weight: 600; color: #374151; margin-bottom: 0.25rem;">Assigned to</label>
                    <select id="workspace-edit-task-${t.id}-assigned-to" style="padding: 0.5rem; border: 1px solid #e5e7eb; border-radius: 0.375rem; font-size: 0.875rem; width: 100%;">
                      <option value="">— None —</option>
                      ${(companyEmployees || []).map(emp => `<option value="${emp.id}" ${(t.assigned_member_ids && t.assigned_member_ids[0] === emp.id) ? 'selected' : ''}>${(emp.name || 'Unknown').replace(/</g, '&lt;')}</option>`).join('')}
                    </select>
                  </div>
                </div>
                <div style="display: flex; gap: 0.5rem;">
                  <button type="button" onclick="saveEditIntakeWorkspaceTask('${t.id}', '${submission.id}')" style="padding: 0.35rem 0.75rem; background: #16a34a; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Save</button>
                  <button type="button" onclick="cancelEditIntakeWorkspace()" style="padding: 0.35rem 0.75rem; background: #6b7280; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Cancel</button>
                </div>
              </div>
              ` : `
              <div class="workspace-item-row" onclick="openWorkspaceItem('task', '${t.id}', '${(t.project_id || '').replace(/'/g, "\\'")}')" style="display: flex; align-items: center; justify-content: space-between; padding: 0.75rem; background: #f9fafb; border-radius: 0.5rem; border: 1px solid #e5e7eb; margin-bottom: 0.5rem;">
                <span style="font-size: 0.875rem;">${(t.title || 'Untitled').replace(/</g, '&lt;')}</span>
                <div style="display: flex; gap: 0.35rem;" onclick="event.stopPropagation()">
                  <button type="button" onclick="openEditIntakeWorkspaceTask('${t.id}')" style="padding: 0.35rem 0.75rem; background: #2563eb; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Edit</button>
                  <button type="button" onclick="deleteIntakeWorkspaceTask('${t.id}', '${submission.id}')" style="padding: 0.35rem 0.75rem; background: #dc2626; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Delete</button>
                </div>
              </div>
              `}
              `).join('')}
            </div>
            ` : ''}
            ${(modalData.workspaceChats && modalData.workspaceChats.length > 0) ? `
            <div style="margin-bottom: 1rem;">
              <div style="font-size: 0.875rem; font-weight: 600; color: ${colors.text}; margin-bottom: 0.5rem;">Chats</div>
              ${modalData.workspaceChats.map(c => `
              ${modalData.editingWorkspaceItem?.type === 'chat' && modalData.editingWorkspaceItem?.id === c.id ? `
              <div style="padding: 0.75rem; background: #f9fafb; border-radius: 0.5rem; border: 1px solid #e5e7eb; margin-bottom: 0.5rem;">
                <div style="display: grid; gap: 0.5rem; margin-bottom: 0.75rem;">
                  <input type="text" id="workspace-edit-chat-${c.id}-title" placeholder="Chat title" value="${(c.title || '').replace(/"/g, '&quot;').replace(/</g, '&lt;')}" style="padding: 0.5rem; border: 1px solid #e5e7eb; border-radius: 0.375rem; font-size: 0.875rem;" />
                </div>
                <div style="display: flex; gap: 0.5rem;">
                  <button type="button" onclick="saveEditIntakeWorkspaceChat('${c.id}', '${submission.id}')" style="padding: 0.35rem 0.75rem; background: #16a34a; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Save</button>
                  <button type="button" onclick="cancelEditIntakeWorkspace()" style="padding: 0.35rem 0.75rem; background: #6b7280; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Cancel</button>
                </div>
              </div>
              ` : `
              <div class="workspace-item-row" onclick="openWorkspaceItem('chat', '${c.id}')" style="display: flex; align-items: center; justify-content: space-between; padding: 0.75rem; background: #f9fafb; border-radius: 0.5rem; border: 1px solid #e5e7eb; margin-bottom: 0.5rem;">
                <span style="font-size: 0.875rem;">${(c.title || 'Untitled').replace(/</g, '&lt;')}</span>
                <div style="display: flex; gap: 0.35rem;" onclick="event.stopPropagation()">
                  <button type="button" onclick="openEditIntakeWorkspaceChat('${c.id}')" style="padding: 0.35rem 0.75rem; background: #2563eb; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Edit</button>
                  <button type="button" onclick="deleteIntakeWorkspaceChat('${c.id}', '${submission.id}')" style="padding: 0.35rem 0.75rem; background: #dc2626; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Delete</button>
                </div>
              </div>
              `}
              `).join('')}
            </div>
            ` : ''}
          </div>`;
}

// Render Form Submission Modal
function renderFormSubmissionModal() {
  console.log('🔍 renderFormSubmissionModal called');
  const modalData = window.formSubmissionModalData;
  console.log('🔍 Modal data:', modalData);

  if (!modalData?.intakeRequest) {
    console.error('❌ No intake request in modal data');
    return '';
  }

  const submission = modalData.intakeRequest;
  const existingContact = modalData.existingContact;
  const detectedType = modalData.detectedType || 'contact';
  const currentStep = modalData.currentStep;
  console.log('✅ Rendering modal HTML for submission:', submission.id);

  // Parse name into first/last
  const nameParts = (submission.full_name || '').trim().split(' ');
  const firstName = nameParts[0] || '';
  const lastName = nameParts.slice(1).join(' ') || '';

  // Type labels and colors
  const typeInfo = {
    appointment: { label: 'Appointment', color: '#3b82f6', icon: '📅' },
    sales_opportunity: { label: 'Sales Opportunity', color: '#10b981', icon: '💰' },
    task: { label: 'Task', color: '#f59e0b', icon: '✓' },
    contact: { label: 'Contact', color: '#ea580c', icon: '👤' }
  };
  const type = typeInfo[detectedType] || typeInfo.contact;
  const workspaceOpportunities = (modalData.workspaceSalesOpportunities || []).filter(o => (modalData.initialWorkspaceOpportunityIds || []).includes(o.id));

  return `
    <!-- Modal Overlay -->
    <div id="form-submission-modal" onclick="if (event.target.id === 'form-submission-modal') { closeFormSubmissionModal(); }" style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 99999;
      animation: fadeIn 0.3s ease-out;
    ">
      <!-- Modal Content -->
      <div onclick="event.stopPropagation()" style="
        background: #ffffff;
        border-radius: 1rem;
        padding: 0;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
        max-width: 920px;
        width: 95%;
        max-height: 90vh;
        overflow-y: auto;
        animation: slideIn 0.3s ease-out;
        position: relative;
      ">
        <!-- Header -->
        <div style="
          padding: 1.5rem;
          border-bottom: 1px solid #e9ecef;
          background: linear-gradient(135deg, #ea580c18 0%, #dc262608 100%);
        ">
          <div style="display: flex; justify-content: space-between; align-items: start; margin-bottom: 1rem;">
            <div>
              <h2 style="margin: 0 0 0.5rem 0; font-size: 1.5rem; font-weight: 700; color: ${colors.text};">
                Create from Form Submission
              </h2>
              <p style="margin: 0; color: ${colors.textSecondary}; font-size: 0.875rem;">
                Detected type: <strong style="color: ${type.color};">${type.label}</strong>
              </p>
            </div>
            <button
              onclick="closeFormSubmissionModal()"
              style="
                background: transparent;
                border: none;
                color: #6b7280;
                cursor: pointer;
                font-size: 1.5rem;
                padding: 0.25rem;
                line-height: 1;
              "
            >
              ×
            </button>
          </div>
          
          <!-- Submission Summary -->
          <div style="
            background: white;
            border-radius: 0.5rem;
            padding: 1rem;
            border: 1px solid #e5e7eb;
          ">
            <div style="font-size: 0.75rem; color: ${colors.textSecondary}; margin-bottom: 0.5rem; font-weight: 600;">
              Form Submission Details
            </div>
            <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 0.75rem; font-size: 0.875rem;">
              ${submission.full_name ? `<div><strong>Name:</strong> ${submission.full_name}</div>` : ''}
              ${submission.email ? `<div><strong>Email:</strong> ${submission.email}</div>` : ''}
              ${submission.phone ? `<div><strong>Phone:</strong> ${submission.phone}</div>` : ''}
              ${submission.site_key ? `<div><strong>Site:</strong> ${submission.site_key}</div>` : ''}
            </div>
            ${submission.message ? `
              <div style="margin-top: 0.75rem; padding-top: 0.75rem; border-top: 1px solid #e5e7eb;">
                <div style="font-size: 0.875rem;"><strong>Message:</strong></div>
                <div style="font-size: 0.875rem; color: ${colors.text}; white-space: pre-wrap;">${submission.message}</div>
              </div>
            ` : ''}
          </div>
        </div>
        
        <!-- Content -->
        <div style="padding: 1.5rem;">
          ${currentStep === 'loading' ? `
            <div style="display: flex; align-items: center; justify-content: center; padding: 2rem; color: #6b7280;">
              <span style="margin-right: 0.5rem;">Loading…</span>
            </div>
          ` : existingContact ? `
            <!-- Contact Exists -->
            <div style="
              background: #f0fdf4;
              border: 1px solid #86efac;
              border-radius: 0.5rem;
              padding: 1rem;
              margin-bottom: 1.5rem;
            ">
              <div style="display: flex; align-items: center; gap: 0.5rem; margin-bottom: 0.5rem;">
                <span style="font-size: 1.25rem;">✅</span>
                <strong style="color: #166534;">Contact Already Exists</strong>
              </div>
              <div style="font-size: 0.875rem; color: #166534;">
                ${existingContact.first_name} ${existingContact.last_name} (${existingContact.email})
              </div>
            </div>
            
            <!-- Workspace (auto-created) - show first so user can edit/delete, then create more below -->
            ${getFormSubmissionModalWorkspaceSectionHTML()}
            
            <!-- Create Record Options -->
            <div style="margin-top: 1.5rem;">
              <h3 style="margin: 0 0 1rem 0; font-size: 1.125rem; font-weight: 600; color: ${colors.text};">
                What would you like to create?
              </h3>
              <div style="display: grid; gap: 0.5rem;">
                <button
                  onclick="openAppointmentDateTimeModal('${submission.id}', '${existingContact.id}')"
                  style="
                    width: 100%;
                    padding: 0.75rem 1rem;
                    background: white;
                    color: ${colors.text};
                    border: 1px solid #e5e7eb;
                    border-radius: 0.5rem;
                    cursor: pointer;
                    font-size: 0.875rem;
                    font-weight: 500;
                    text-align: left;
                  "
                >
                  Appointment
                </button>
                <button
                  onclick="createSalesOpportunityFromSubmission('${submission.id}', '${existingContact.id}')"
                  style="
                    width: 100%;
                    padding: 0.75rem 1rem;
                    background: white;
                    color: ${colors.text};
                    border: 1px solid #e5e7eb;
                    border-radius: 0.5rem;
                    cursor: pointer;
                    font-size: 0.875rem;
                    font-weight: 500;
                    text-align: left;
                  "
                >
                  Sales Opportunity
                </button>
                <button
                  onclick="createTaskFromSubmission('${submission.id}', '${existingContact.id}')"
                  style="
                    width: 100%;
                    padding: 0.75rem 1rem;
                    background: white;
                    color: ${colors.text};
                    border: 1px solid #e5e7eb;
                    border-radius: 0.5rem;
                    cursor: pointer;
                    font-size: 0.875rem;
                    font-weight: 500;
                    text-align: left;
                  "
                >
                  Task
                </button>
              </div>
            </div>
          ` : `
            <!-- No Contact - Must Create First -->
            <div style="
              background: #fef3c7;
              border: 1px solid #fde68a;
              border-radius: 0.5rem;
              padding: 1rem;
              margin-bottom: 1.5rem;
            ">
              <div style="display: flex; align-items: center; gap: 0.5rem; margin-bottom: 0.5rem;">
                <span style="font-size: 1.25rem;">⚠️</span>
                <strong style="color: #92400e;">Contact Required</strong>
              </div>
              <div style="font-size: 0.875rem; color: #92400e;">
                A contact must be created first before creating a ${type.label.toLowerCase()}.
              </div>
            </div>
            
            <!-- Create Contact Form -->
            <div>
              <h3 style="margin: 0 0 1rem 0; font-size: 1.125rem; font-weight: 600; color: ${colors.text};">
                Step 1: Create Contact
              </h3>
              <form onsubmit="event.preventDefault(); createContactFromSubmission('${submission.id}');" style="display: flex; flex-direction: column; gap: 1rem;">
                <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem;">
                  <div>
                    <label style="display: block; font-size: 0.875rem; font-weight: 600; color: ${colors.text}; margin-bottom: 0.5rem;">
                      First Name *
                    </label>
                    <input
                      type="text"
                      id="contact-first-name"
                      value="${firstName}"
                      required
                      style="
                        width: 100%;
                        padding: 0.75rem;
                        border: 1px solid #e5e7eb;
                        border-radius: 0.5rem;
                        font-size: 0.875rem;
                      "
                    />
                  </div>
                  <div>
                    <label style="display: block; font-size: 0.875rem; font-weight: 600; color: ${colors.text}; margin-bottom: 0.5rem;">
                      Last Name *
                    </label>
                    <input
                      type="text"
                      id="contact-last-name"
                      value="${lastName}"
                      required
                      style="
                        width: 100%;
                        padding: 0.75rem;
                        border: 1px solid #e5e7eb;
                        border-radius: 0.5rem;
                        font-size: 0.875rem;
                      "
                    />
                  </div>
                </div>
                <div>
                  <label style="display: block; font-size: 0.875rem; font-weight: 600; color: ${colors.text}; margin-bottom: 0.5rem;">
                    Email *
                  </label>
                  <input
                    type="email"
                    id="contact-email"
                    value="${submission.email || ''}"
                    required
                    style="
                      width: 100%;
                      padding: 0.75rem;
                      border: 1px solid #e5e7eb;
                      border-radius: 0.5rem;
                      font-size: 0.875rem;
                    "
                  />
                </div>
                <div>
                  <label style="display: block; font-size: 0.875rem; font-weight: 600; color: ${colors.text}; margin-bottom: 0.5rem;">
                    Phone
                  </label>
                  <input
                    type="tel"
                    id="contact-phone"
                    value="${submission.phone || ''}"
                    style="
                      width: 100%;
                      padding: 0.75rem;
                      border: 1px solid #e5e7eb;
                      border-radius: 0.5rem;
                      font-size: 0.875rem;
                    "
                  />
                </div>
                <div style="display: flex; gap: 0.75rem; margin-top: 0.5rem;">
                  <button
                    type="submit"
                    style="
                      flex: 1;
                      padding: 0.75rem 1.5rem;
                      background: ${colors.primary};
                      color: white;
                      border: none;
                      border-radius: 0.5rem;
                      cursor: pointer;
                      font-size: 0.875rem;
                      font-weight: 600;
                    "
                  >
                    Create Contact & Continue
                  </button>
                  <button
                    type="button"
                    onclick="closeFormSubmissionModal()"
                    style="
                      padding: 0.75rem 1.5rem;
                      background: white;
                      color: ${colors.text};
                      border: 1px solid #e5e7eb;
                      border-radius: 0.5rem;
                      cursor: pointer;
                      font-size: 0.875rem;
                      font-weight: 600;
                    "
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          `}
          ${(!existingContact && ((modalData.workspaceProjects && modalData.workspaceProjects.length > 0) || (modalData.workspaceTasks && modalData.workspaceTasks.length > 0) || (modalData.workspaceChats && modalData.workspaceChats.length > 0) || (workspaceOpportunities.length > 0))) ? `
          <!-- Workspace (when no contact but workspace data exists) -->
          <div id="form-submission-workspace-section" style="margin-top: 1.5rem; padding-top: 1.5rem; border-top: 1px solid #e5e7eb;">
            <h3 style="margin: 0 0 1rem 0; font-size: 1.125rem; font-weight: 600; color: ${colors.text};">
              Workspace (auto-created)
            </h3>
            <p style="margin: 0 0 1rem 0; font-size: 0.875rem; color: ${colors.textSecondary};">
              Project, task, chat, contact, and sales opportunities were created for this inquiry from your website. You can edit or delete any of these below:
            </p>
            ${existingContact ? `
            <div style="margin-bottom: 1rem;">
              <div style="font-size: 0.875rem; font-weight: 600; color: ${colors.text}; margin-bottom: 0.5rem;">Contact</div>
              ${modalData.editingWorkspaceItem?.type === 'contact' && modalData.editingWorkspaceItem?.id === existingContact.id ? `
              <div style="padding: 0.75rem; background: #f9fafb; border-radius: 0.5rem; border: 1px solid #e5e7eb;">
                <div style="display: grid; gap: 0.5rem; margin-bottom: 0.75rem;">
                  <input type="text" id="workspace-edit-contact-first-name" placeholder="First name" value="${(existingContact.first_name || '').replace(/"/g, '&quot;').replace(/</g, '&lt;')}" style="padding: 0.5rem; border: 1px solid #e5e7eb; border-radius: 0.375rem; font-size: 0.875rem;" />
                  <input type="text" id="workspace-edit-contact-last-name" placeholder="Last name" value="${(existingContact.last_name || '').replace(/"/g, '&quot;').replace(/</g, '&lt;')}" style="padding: 0.5rem; border: 1px solid #e5e7eb; border-radius: 0.375rem; font-size: 0.875rem;" />
                  <input type="email" id="workspace-edit-contact-email" placeholder="Email" value="${(existingContact.email || '').replace(/"/g, '&quot;').replace(/</g, '&lt;')}" style="padding: 0.5rem; border: 1px solid #e5e7eb; border-radius: 0.375rem; font-size: 0.875rem;" />
                  <input type="text" id="workspace-edit-contact-phone" placeholder="Phone" value="${(existingContact.phone || '').replace(/"/g, '&quot;').replace(/</g, '&lt;')}" style="padding: 0.5rem; border: 1px solid #e5e7eb; border-radius: 0.375rem; font-size: 0.875rem;" />
                </div>
                <div style="display: flex; gap: 0.5rem;">
                  <button type="button" onclick="saveEditIntakeWorkspaceContact('${existingContact.id}', '${submission.id}')" style="padding: 0.35rem 0.75rem; background: #16a34a; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Save</button>
                  <button type="button" onclick="cancelEditIntakeWorkspace()" style="padding: 0.35rem 0.75rem; background: #6b7280; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Cancel</button>
                </div>
              </div>
              ` : `
              <div style="display: flex; align-items: center; justify-content: space-between; padding: 0.75rem; background: #f9fafb; border-radius: 0.5rem; border: 1px solid #e5e7eb;">
                <span style="font-size: 0.875rem;">${(existingContact.first_name || '').replace(/</g, '&lt;')} ${(existingContact.last_name || '').replace(/</g, '&lt;')} (${(existingContact.email || '').replace(/</g, '&lt;')})</span>
                <div style="display: flex; gap: 0.35rem;">
                  <button type="button" onclick="openEditIntakeWorkspaceContact('${existingContact.id}')" style="padding: 0.35rem 0.75rem; background: #2563eb; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Edit</button>
                  <button type="button" onclick="deleteIntakeWorkspaceContact('${existingContact.id}', '${submission.id}')" style="padding: 0.35rem 0.75rem; background: #dc2626; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Delete</button>
                </div>
              </div>
              `}
            </div>
            ` : ''}
            ${(workspaceOpportunities.length > 0) ? `
            <div style="margin-bottom: 1rem;">
              <div style="font-size: 0.875rem; font-weight: 600; color: ${colors.text}; margin-bottom: 0.5rem;">Sales opportunities</div>
              ${workspaceOpportunities.map(o => `
              ${modalData.editingWorkspaceItem?.type === 'sales_opportunity' && modalData.editingWorkspaceItem?.id === o.id ? `
              <div style="padding: 0.75rem; background: #f9fafb; border-radius: 0.5rem; border: 1px solid #e5e7eb; margin-bottom: 0.5rem;">
                <div style="display: grid; gap: 0.5rem; margin-bottom: 0.75rem;">
                  <input type="text" id="workspace-edit-opp-${o.id}-title" placeholder="Title" value="${(o.title || '').replace(/"/g, '&quot;').replace(/</g, '&lt;')}" style="padding: 0.5rem; border: 1px solid #e5e7eb; border-radius: 0.375rem; font-size: 0.875rem;" />
                  <select id="workspace-edit-opp-${o.id}-stage" style="padding: 0.5rem; border: 1px solid #e5e7eb; border-radius: 0.375rem; font-size: 0.875rem;">
                    <option value="new" ${(o.stage || '') === 'new' ? 'selected' : ''}>new</option>
                    <option value="contacted" ${(o.stage || '') === 'contacted' ? 'selected' : ''}>contacted</option>
                    <option value="qualified" ${(o.stage || '') === 'qualified' ? 'selected' : ''}>qualified</option>
                    <option value="proposal" ${(o.stage || '') === 'proposal' ? 'selected' : ''}>proposal</option>
                    <option value="negotiation" ${(o.stage || '') === 'negotiation' ? 'selected' : ''}>negotiation</option>
                    <option value="won" ${(o.stage || '') === 'won' ? 'selected' : ''}>won</option>
                    <option value="lost" ${(o.stage || '') === 'lost' ? 'selected' : ''}>lost</option>
                  </select>
                  <textarea id="workspace-edit-opp-${o.id}-notes" placeholder="Notes" rows="2" style="padding: 0.5rem; border: 1px solid #e5e7eb; border-radius: 0.375rem; font-size: 0.875rem;">${(o.notes || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')}</textarea>
                </div>
                <div style="display: flex; gap: 0.5rem;">
                  <button type="button" onclick="saveEditIntakeWorkspaceSalesOpportunity('${o.id}', '${submission.id}')" style="padding: 0.35rem 0.75rem; background: #16a34a; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Save</button>
                  <button type="button" onclick="cancelEditIntakeWorkspace()" style="padding: 0.35rem 0.75rem; background: #6b7280; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Cancel</button>
                </div>
              </div>
              ` : `
              <div class="workspace-item-row" onclick="openWorkspaceItem('sales_opportunity', '${o.id}')" style="display: flex; align-items: center; justify-content: space-between; padding: 0.75rem; background: #f9fafb; border-radius: 0.5rem; border: 1px solid #e5e7eb; margin-bottom: 0.5rem;">
                <span style="font-size: 0.875rem;">${(o.title || 'Untitled').replace(/</g, '&lt;')} ${o.stage ? '(' + String(o.stage).replace(/</g, '&lt;') + ')' : ''}</span>
                <div style="display: flex; gap: 0.35rem;" onclick="event.stopPropagation()">
                  <button type="button" onclick="openEditIntakeWorkspaceSalesOpportunity('${o.id}')" style="padding: 0.35rem 0.75rem; background: #2563eb; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Edit</button>
                  <button type="button" onclick="deleteIntakeWorkspaceSalesOpportunity('${o.id}', '${submission.id}')" style="padding: 0.35rem 0.75rem; background: #dc2626; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Delete</button>
                </div>
              </div>
              `}
              `).join('')}
            </div>
            ` : ''}
            ${(modalData.workspaceProjects && modalData.workspaceProjects.length > 0) ? `
            <div style="margin-bottom: 1rem;">
              <div style="font-size: 0.875rem; font-weight: 600; color: ${colors.text}; margin-bottom: 0.5rem;">Projects</div>
              ${modalData.workspaceProjects.map(p => `
              ${modalData.editingWorkspaceItem?.type === 'project' && modalData.editingWorkspaceItem?.id === p.id ? `
              <div style="padding: 0.75rem; background: #f9fafb; border-radius: 0.5rem; border: 1px solid #e5e7eb; margin-bottom: 0.5rem;">
                <div style="display: grid; gap: 0.5rem; margin-bottom: 0.75rem;">
                  <input type="text" id="workspace-edit-project-${p.id}-name" placeholder="Project name" value="${(p.name || '').replace(/"/g, '&quot;').replace(/</g, '&lt;')}" style="padding: 0.5rem; border: 1px solid #e5e7eb; border-radius: 0.375rem; font-size: 0.875rem;" />
                  <input type="text" id="workspace-edit-project-${p.id}-description" placeholder="Description" value="${(p.description || '').replace(/"/g, '&quot;').replace(/</g, '&lt;')}" style="padding: 0.5rem; border: 1px solid #e5e7eb; border-radius: 0.375rem; font-size: 0.875rem;" />
                  <select id="workspace-edit-project-${p.id}-status" style="padding: 0.5rem; border: 1px solid #e5e7eb; border-radius: 0.375rem; font-size: 0.875rem;">
                    <option value="active" ${(p.status || '') === 'active' ? 'selected' : ''}>active</option>
                    <option value="completed" ${(p.status || '') === 'completed' ? 'selected' : ''}>completed</option>
                    <option value="on_hold" ${(p.status || '') === 'on_hold' ? 'selected' : ''}>on_hold</option>
                    <option value="cancelled" ${(p.status || '') === 'cancelled' ? 'selected' : ''}>cancelled</option>
                  </select>
                </div>
                <div style="display: flex; gap: 0.5rem;">
                  <button type="button" onclick="saveEditIntakeWorkspaceProject('${p.id}', '${submission.id}')" style="padding: 0.35rem 0.75rem; background: #16a34a; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Save</button>
                  <button type="button" onclick="cancelEditIntakeWorkspace()" style="padding: 0.35rem 0.75rem; background: #6b7280; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Cancel</button>
                </div>
              </div>
              ` : `
              <div class="workspace-item-row" onclick="openWorkspaceItem('project', '${p.id}')" style="display: flex; align-items: center; justify-content: space-between; padding: 0.75rem; background: #f9fafb; border-radius: 0.5rem; border: 1px solid #e5e7eb; margin-bottom: 0.5rem;">
                <span style="font-size: 0.875rem;">${(p.name || 'Untitled').replace(/</g, '&lt;')}</span>
                <div style="display: flex; gap: 0.35rem;" onclick="event.stopPropagation()">
                  <button type="button" onclick="openEditIntakeWorkspaceProject('${p.id}')" style="padding: 0.35rem 0.75rem; background: #2563eb; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Edit</button>
                  <button type="button" onclick="deleteIntakeWorkspaceProject('${p.id}', '${submission.id}')" style="padding: 0.35rem 0.75rem; background: #dc2626; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Delete</button>
                </div>
              </div>
              `}
              `).join('')}
            </div>
            ` : ''}
            ${(modalData.workspaceTasks && modalData.workspaceTasks.length > 0) ? `
            <div style="margin-bottom: 1rem;">
              <div style="font-size: 0.875rem; font-weight: 600; color: ${colors.text}; margin-bottom: 0.5rem;">Tasks</div>
              ${modalData.workspaceTasks.map(t => `
              ${modalData.editingWorkspaceItem?.type === 'task' && modalData.editingWorkspaceItem?.id === t.id ? `
              <div style="padding: 0.75rem; background: #f9fafb; border-radius: 0.5rem; border: 1px solid #e5e7eb; margin-bottom: 0.5rem;">
                <div style="display: grid; gap: 0.5rem; margin-bottom: 0.75rem;">
                  <input type="text" id="workspace-edit-task-${t.id}-title" placeholder="Task title" value="${(t.title || '').replace(/"/g, '&quot;').replace(/</g, '&lt;')}" style="padding: 0.5rem; border: 1px solid #e5e7eb; border-radius: 0.375rem; font-size: 0.875rem;" />
                  <select id="workspace-edit-task-${t.id}-state" style="padding: 0.5rem; border: 1px solid #e5e7eb; border-radius: 0.375rem; font-size: 0.875rem;">
                    <option value="BACKLOG" ${(t.state || '') === 'BACKLOG' ? 'selected' : ''}>BACKLOG</option>
                    <option value="IN_PROGRESS" ${(t.state || '') === 'IN_PROGRESS' ? 'selected' : ''}>IN_PROGRESS</option>
                    <option value="DONE" ${(t.state || '') === 'DONE' ? 'selected' : ''}>DONE</option>
                    <option value="CANCELLED" ${(t.state || '') === 'CANCELLED' ? 'selected' : ''}>CANCELLED</option>
                  </select>
                  <div>
                    <label style="display: block; font-size: 0.75rem; font-weight: 600; color: #374151; margin-bottom: 0.25rem;">Assigned to</label>
                    <select id="workspace-edit-task-${t.id}-assigned-to" style="padding: 0.5rem; border: 1px solid #e5e7eb; border-radius: 0.375rem; font-size: 0.875rem; width: 100%;">
                      <option value="">— None —</option>
                      ${(companyEmployees || []).map(emp => `<option value="${emp.id}" ${(t.assigned_member_ids && t.assigned_member_ids[0] === emp.id) ? 'selected' : ''}>${(emp.name || 'Unknown').replace(/</g, '&lt;')}</option>`).join('')}
                    </select>
                  </div>
                </div>
                <div style="display: flex; gap: 0.5rem;">
                  <button type="button" onclick="saveEditIntakeWorkspaceTask('${t.id}', '${submission.id}')" style="padding: 0.35rem 0.75rem; background: #16a34a; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Save</button>
                  <button type="button" onclick="cancelEditIntakeWorkspace()" style="padding: 0.35rem 0.75rem; background: #6b7280; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Cancel</button>
                </div>
              </div>
              ` : `
              <div class="workspace-item-row" onclick="openWorkspaceItem('task', '${t.id}', '${(t.project_id || '').replace(/'/g, "\\'")}')" style="display: flex; align-items: center; justify-content: space-between; padding: 0.75rem; background: #f9fafb; border-radius: 0.5rem; border: 1px solid #e5e7eb; margin-bottom: 0.5rem;">
                <span style="font-size: 0.875rem;">${(t.title || 'Untitled').replace(/</g, '&lt;')}</span>
                <div style="display: flex; gap: 0.35rem;" onclick="event.stopPropagation()">
                  <button type="button" onclick="openEditIntakeWorkspaceTask('${t.id}')" style="padding: 0.35rem 0.75rem; background: #2563eb; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Edit</button>
                  <button type="button" onclick="deleteIntakeWorkspaceTask('${t.id}', '${submission.id}')" style="padding: 0.35rem 0.75rem; background: #dc2626; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Delete</button>
                </div>
              </div>
              `}
              `).join('')}
            </div>
            ` : ''}
            ${(modalData.workspaceChats && modalData.workspaceChats.length > 0) ? `
            <div style="margin-bottom: 1rem;">
              <div style="font-size: 0.875rem; font-weight: 600; color: ${colors.text}; margin-bottom: 0.5rem;">Chats</div>
              ${modalData.workspaceChats.map(c => `
              ${modalData.editingWorkspaceItem?.type === 'chat' && modalData.editingWorkspaceItem?.id === c.id ? `
              <div style="padding: 0.75rem; background: #f9fafb; border-radius: 0.5rem; border: 1px solid #e5e7eb; margin-bottom: 0.5rem;">
                <div style="display: grid; gap: 0.5rem; margin-bottom: 0.75rem;">
                  <input type="text" id="workspace-edit-chat-${c.id}-title" placeholder="Chat title" value="${(c.title || '').replace(/"/g, '&quot;').replace(/</g, '&lt;')}" style="padding: 0.5rem; border: 1px solid #e5e7eb; border-radius: 0.375rem; font-size: 0.875rem;" />
                </div>
                <div style="display: flex; gap: 0.5rem;">
                  <button type="button" onclick="saveEditIntakeWorkspaceChat('${c.id}', '${submission.id}')" style="padding: 0.35rem 0.75rem; background: #16a34a; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Save</button>
                  <button type="button" onclick="cancelEditIntakeWorkspace()" style="padding: 0.35rem 0.75rem; background: #6b7280; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Cancel</button>
                </div>
              </div>
              ` : `
              <div style="display: flex; align-items: center; justify-content: space-between; padding: 0.75rem; background: #f9fafb; border-radius: 0.5rem; border: 1px solid #e5e7eb; margin-bottom: 0.5rem;">
                <span style="font-size: 0.875rem;">${(c.title || 'Untitled').replace(/</g, '&lt;')}</span>
                <div style="display: flex; gap: 0.35rem;">
                  <button type="button" onclick="openEditIntakeWorkspaceChat('${c.id}')" style="padding: 0.35rem 0.75rem; background: #2563eb; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Edit</button>
                  <button type="button" onclick="deleteIntakeWorkspaceChat('${c.id}', '${submission.id}')" style="padding: 0.35rem 0.75rem; background: #dc2626; color: white; border: none; border-radius: 0.5rem; cursor: pointer; font-size: 0.75rem;">Delete</button>
                </div>
              </div>
              `}
              `).join('')}
            </div>
            ` : ''}
          </div>
          ` : ''}
        </div>
      </div>
    </div>
  `;
}

// Create Contact from Form Submission
async function createContactFromSubmission(intakeRequestId) {
  const firstName = document.getElementById('contact-first-name').value.trim();
  const lastName = document.getElementById('contact-last-name').value.trim();
  const email = document.getElementById('contact-email').value.trim().toLowerCase();
  const phone = document.getElementById('contact-phone').value.trim();

  if (!firstName || !lastName || !email) {
    showNotification('Please fill in all required fields', 'error');
    return;
  }

  if (!currentCompany?.id) {
    showNotification('No company context', 'error');
    return;
  }

  try {
    // Create contact
    const { data: contact, error } = await supabase
      .from('contacts')
      .insert({
        company_id: currentCompany.id,
        owner_id: currentProfile?.id || null,
        first_name: firstName,
        last_name: lastName,
        email: email,
        phone: phone || null,
        status: 'lead'
      })
      .select()
      .single();

    if (error) {
      console.error('Error creating contact:', error);
      showNotification('Failed to create contact: ' + error.message, 'error');
      return;
    }

    // Update modal data
    formSubmissionModalData.existingContact = contact;
    formSubmissionModalData.createdContactId = contact.id;
    formSubmissionModalData.currentStep = 'create_record';
    window.formSubmissionModalData = formSubmissionModalData;

    showNotification('Contact created successfully!', 'success');
    renderPMTool(); // Re-render to show next step
  } catch (error) {
    console.error('Error creating contact:', error);
    showNotification('Failed to create contact', 'error');
  }
}

// Create Task from Form Submission
function createTaskFromSubmission(intakeRequestId, contactId) {
  const submission = window.formSubmissionModalData?.intakeRequest || formSubmissionModalData.intakeRequest;
  if (!submission) {
    showNotification('Form submission not found', 'error');
    return;
  }

  // Pre-populate task data
  const taskTitle = submission.message
    ? (submission.message.length > 100 ? submission.message.substring(0, 100) + '...' : submission.message)
    : `Follow up with ${submission.full_name || 'contact'}`;
  const taskDescription = submission.message || `Form submission from ${submission.site_key || 'website'}`;

  // Set temp variables for pre-population
  window.tempTaskTitle = taskTitle;
  window.tempTaskDescription = taskDescription;

  // If we have a contact from form submission modal, ensure it's in the contacts array
  if (contactId && window.formSubmissionModalData?.existingContact) {
    const formContact = window.formSubmissionModalData.existingContact;
    // Check if contact is already in contacts array
    const existingContactIndex = contacts.findIndex(c => c.id === contactId);
    if (existingContactIndex === -1) {
      // Contact not in array, add it
      contacts.push({
        id: formContact.id,
        first_name: formContact.first_name || '',
        last_name: formContact.last_name || '',
        email: formContact.email || '',
        phone: formContact.phone || '',
        company_name: formContact.company_name || '',
        contact_profile_id: formContact.contact_profile_id || null,
        company_id: formContact.company_id || currentCompany?.id
      });
    }
  }

  // Open task modal with pre-selected contact
  closeFormSubmissionModal();
  window.showAddTaskModal(contactId || null, null);
}

// Open Appointment Date/Time Picker Modal
function openAppointmentDateTimeModal(intakeRequestId, contactId) {
  const submission = window.formSubmissionModalData?.intakeRequest || formSubmissionModalData.intakeRequest;
  if (!submission) {
    showNotification('Form submission not found', 'error');
    return;
  }

  if (!contactId) {
    showNotification('Contact is required for appointments', 'error');
    return;
  }

  // Pre-populate appointment data
  const appointmentTitle = submission.message
    ? (submission.message.length > 80 ? submission.message.substring(0, 80) + '...' : submission.message)
    : `Appointment with ${submission.full_name || 'contact'}`;

  // Set the contact ID and form data before opening modal
  selectedAppointmentContactId = contactId;
  window.selectedAppointmentContactId = contactId;
  appointmentFormData = {
    title: appointmentTitle,
    appointment_date: '',
    start_time: '',
    duration: '60',
    notes: submission.message || `Form submission from ${submission.site_key || 'website'}`,
    assigned_to: (currentUser?.id || currentProfile?.id) || ''
  };
  window.appointmentFormData = appointmentFormData;
  window.selectedAppointmentAssignedTo = (currentUser?.id || currentProfile?.id) || '';
  window.appointmentMemberSearchQuery = '';
  appointmentContactSearchQuery = '';
  window.appointmentContactSearchQuery = '';

  // Close form submission modal and open appointment modal
  closeFormSubmissionModal();
  window.showAddAppointmentModalFromSubmission(contactId);
}

// Create Appointment from Form Submission
async function createAppointmentFromSubmission(intakeRequestId, contactId, appointmentDate, startTime) {
  const submission = formSubmissionModalData.intakeRequest;
  if (!submission) {
    showNotification('Form submission not found', 'error');
    return;
  }

  if (!currentCompany?.id || !currentProfile?.id) {
    showNotification('No company or user context', 'error');
    return;
  }

  if (!contactId) {
    showNotification('Contact is required for appointments', 'error');
    return;
  }

  if (!appointmentDate || !startTime) {
    showNotification('Date and time are required', 'error');
    return;
  }

  try {
    // Convert time from HH:MM to HH:MM:SS format
    const timeParts = startTime.split(':');
    const formattedTime = timeParts.length === 2 ? `${startTime}:00` : startTime;

    const appointmentTitle = submission.message
      ? (submission.message.length > 80 ? submission.message.substring(0, 80) + '...' : submission.message)
      : `Appointment with ${submission.full_name || 'contact'}`;

    const { data: appointment, error } = await supabase
      .from('appointments')
      .insert({
        company_id: currentCompany.id,
        contact_id: contactId,
        assigned_to: currentProfile.id,
        title: appointmentTitle,
        notes: submission.message || `Form submission from ${submission.site_key || 'website'}`,
        appointment_date: appointmentDate,
        start_time: formattedTime,
        duration_minutes: 60,
        status: 'scheduled'
      })
      .select()
      .single();

    if (error) {
      console.error('Error creating appointment:', error);
      showNotification('Failed to create appointment: ' + error.message, 'error');
      return;
    }

    showNotification('Appointment created successfully!', 'success');
    closeFormSubmissionModal();
    await loadIntakeSubmissions();
    renderPMTool();
  } catch (error) {
    console.error('Error creating appointment:', error);
    showNotification('Failed to create appointment', 'error');
  }
}

// Create Sales Opportunity from Form Submission
function createSalesOpportunityFromSubmission(intakeRequestId, contactId) {
  const submission = window.formSubmissionModalData?.intakeRequest || formSubmissionModalData.intakeRequest;
  if (!submission) {
    showNotification('Form submission not found', 'error');
    return;
  }

  if (!contactId) {
    showNotification('Contact is required for sales opportunities', 'error');
    return;
  }

  // Pre-populate opportunity data
  const opportunityTitle = submission.message
    ? (submission.message.length > 80 ? submission.message.substring(0, 80) + '...' : submission.message)
    : `Opportunity with ${submission.full_name || 'contact'}`;

  // Set the contact ID and form data before opening modal
  selectedOpportunityContactId = contactId;
  window.selectedOpportunityContactId = contactId;
  opportunityFormData = {
    title: opportunityTitle,
    stage: 'new',
    expected_close_date: '',
    amount: '',
    source: 'website',
    chance: 'medium',
    follow_up_date: '',
    follow_up_time: '',
    notes: submission.message || `Form submission from ${submission.site_key || 'website'}`,
    archived: false,
    assigned_to: ''
  };
  window.opportunityFormData = opportunityFormData;
  window.selectedOpportunityAssignedTo = null;
  window.opportunityMemberSearchQuery = '';
  opportunityContactSearchQuery = '';
  window.opportunityContactSearchQuery = '';

  // Close form submission modal and open opportunity modal
  closeFormSubmissionModal();
  window.showAddOpportunityModalFromSubmission(contactId);
}

// Render Appointment Date/Time Picker Modal
// Make functions globally accessible
window.openAppointmentDateTimeModal = openAppointmentDateTimeModal;
window.createContactFromSubmission = createContactFromSubmission;
window.createTaskFromSubmission = createTaskFromSubmission;
window.createAppointmentFromSubmission = createAppointmentFromSubmission;
window.createSalesOpportunityFromSubmission = createSalesOpportunityFromSubmission;

// =============================================================================
// CONTRACTS MODULE
// =============================================================================

// Load contracts data
async function loadContracts() {
  if (!currentCompany?.id) return;

  try {
    const { data, error } = await supabase
      .from('contracts')
      .select(`
        *,
        contact:contacts(id, first_name, last_name, email),
        owner:profiles!contracts_owner_id_fkey(id, first_name, last_name)
      `)
      .eq('company_id', currentCompany.id)
      .order('created_at', { ascending: false });

    if (error) {
      console.error('Error loading contracts:', error);
      return;
    }

    contractsList = data || [];
    console.log('📄 Loaded contracts:', contractsList.length);
  } catch (error) {
    console.error('Error loading contracts:', error);
  }
}

// Load contract products
async function loadContractProducts() {
  if (!currentCompany?.id) return;

  try {
    const { data, error } = await supabase
      .from('contract_products')
      .select('*')
      .eq('company_id', currentCompany.id)
      .eq('is_archived', false)
      .order('name', { ascending: true });

    if (error) {
      console.error('Error loading products:', error);
      return;
    }

    contractProducts = data || [];
    console.log('📦 Loaded products:', contractProducts.length);
  } catch (error) {
    console.error('Error loading products:', error);
  }
}

// Load product categories
async function loadProductCategories() {
  if (!currentCompany?.id) return;

  try {
    const { data, error } = await supabase
      .from('contract_product_categories')
      .select('*')
      .eq('company_id', currentCompany.id)
      .eq('is_archived', false)
      .order('sort_order', { ascending: true })
      .order('name', { ascending: true });

    if (error) {
      console.error('Error loading product categories:', error);
      return;
    }

    productCategories = data || [];
    console.log('📁 Loaded product categories:', productCategories.length);
  } catch (error) {
    console.error('Error loading product categories:', error);
  }
}

// Load contract clauses
async function loadContractClauses() {
  if (!currentCompany?.id) return;

  try {
    const { data, error } = await supabase
      .from('contract_clauses')
      .select('*')
      .eq('company_id', currentCompany.id)
      .eq('is_archived', false)
      .order('category', { ascending: true })
      .order('sort_order', { ascending: true });

    if (error) {
      console.error('Error loading clauses:', error);
      return;
    }

    contractClauses = data || [];
    console.log('📜 Loaded clauses:', contractClauses.length);
  } catch (error) {
    console.error('Error loading clauses:', error);
  }
}

// Switch contracts tab
window.switchContractsTab = function (tab) {
  contractsTab = tab;
  window.contractsTab = tab;
  renderPMTool();
};

// Switch contracts filter
window.setContractsFilter = function (filter) {
  contractsFilter = filter;
  window.contractsFilter = filter;
  renderPMTool();
};

// Update contracts search query
window.updateContractsSearch = function (query) {
  contractsSearchQuery = query;
  window.contractsSearchQuery = query;
  renderPMTool();
};

// Open new contract modal
window.openNewContractModal = function () {
  showNewContractModal = true;
  newContractStep = 1;

  // Reset selected products for multi-select
  selectedProductIds = [];
  window.selectedProductIds = selectedProductIds;

  // Reset product search
  productSearchQuery = '';
  window.productSearchQuery = productSearchQuery;

  // Reset contact search
  contactSearchQuery = '';
  showContactDropdown = false;

  // Pre-select default clauses
  const defaultClauseIds = contractClauses
    .filter(c => c.is_default === true)
    .map(c => c.id);

  newContractData = {
    contactId: null,
    clientName: '',
    clientEmail: '',
    clientPhone: '',
    clientCompanyName: '',
    effectiveDate: new Date().toISOString().split('T')[0],
    closeDate: '',
    contractName: '',
    lineItems: [],
    discountType: null,
    discountValue: 0,
    taxRate: globalTaxRate, // Use global tax rate
    selectedClauses: defaultClauseIds, // Pre-select default clauses
    customNotes: ''
  };
  window.newContractData = newContractData;
  renderPMTool();
};

// Close new contract modal
window.closeNewContractModal = function () {
  showNewContractModal = false;
  newContractStep = 1;
  // Reset selected products
  selectedProductIds = [];
  window.selectedProductIds = selectedProductIds;
  // Reset product search
  productSearchQuery = '';
  window.productSearchQuery = productSearchQuery;
  renderPMTool();
};

// Validate contract step before proceeding
window.validateContractStep = function (currentStep) {
  if (currentStep === 1) {
    // Step 1: Contract name and client info required
    if (!newContractData.contractName || newContractData.contractName.trim() === '') {
      showNotification('Please enter a contract name', 'warning');
      return false;
    }

    // Must have either selected contact OR manual entry
    if (!newContractData.contactId) {
      if (!newContractData.clientName || newContractData.clientName.trim() === '' ||
        !newContractData.clientEmail || newContractData.clientEmail.trim() === '') {
        showNotification('Please select a contact or enter client name and email', 'warning');
        return false;
      }
    }
    return true;
  } else if (currentStep === 2) {
    // Step 2: At least one product/item required
    if (!newContractData.lineItems || newContractData.lineItems.length === 0) {
      showNotification('Please add at least one product or custom item', 'warning');
      return false;
    }
    return true;
  }
  return true; // Other steps don't need validation
};

// Navigate contract wizard steps
window.setContractStep = function (step) {
  // Validate before moving forward
  if (step > newContractStep) {
    if (!validateContractStep(newContractStep)) {
      return; // Don't proceed if validation fails
    }
  }
  newContractStep = step;
  renderPMTool();
};

// Select contact for new contract
window.selectContractContact = function (contactId) {
  const contact = contacts.find(c => c.id === contactId);
  if (contact) {
    newContractData.contactId = contactId;
    newContractData.clientName = `${contact.first_name || ''} ${contact.last_name || ''}`.trim();
    newContractData.clientEmail = contact.email || '';
    newContractData.clientPhone = contact.phone || '';
    newContractData.clientCompanyName = contact.company_name || '';
    window.newContractData = newContractData;
    renderPMTool();
  }
};

// Track selected products for multi-select
let selectedProductIds = [];
window.selectedProductIds = selectedProductIds;

// Product search for contract product selection
let productSearchQuery = '';
window.productSearchQuery = productSearchQuery;
let productSearchTimeout = null;

// Contact search for new contract (contactSearchQuery already declared at top)
let showContactDropdown = false;
window.showContactDropdown = showContactDropdown;

// Handle contact search input for CONTRACT modal (not main contacts page)
window.handleContractContactSearch = function (query) {
  contactSearchQuery = query;
  showContactDropdown = query.length > 0;

  // Update the dropdown without full re-render
  const dropdown = document.getElementById('contact-search-dropdown');
  const input = document.getElementById('contact-search-input');

  if (dropdown) {
    const filteredContacts = contacts.filter(c => {
      const searchLower = query.toLowerCase();
      const fullName = `${c.first_name || ''} ${c.last_name || ''}`.toLowerCase();
      const email = (c.email || '').toLowerCase();
      const company = (c.company_name || '').toLowerCase();
      return fullName.includes(searchLower) || email.includes(searchLower) || company.includes(searchLower);
    }).slice(0, 10); // Limit to 10 results

    if (filteredContacts.length > 0 && query.length > 0) {
      dropdown.innerHTML = filteredContacts.map(c => `
        <div onclick="selectContactFromSearch('${c.id}')" style="
          padding: 0.75rem 1rem;
          cursor: pointer;
          border-bottom: 1px solid #f1f5f9;
          transition: background 0.15s;
        " onmouseover="this.style.background='#f1f5f9'" onmouseout="this.style.background='white'">
          <div style="font-weight: 500; color: #1e293b;">${c.first_name || ''} ${c.last_name || ''}</div>
          <div style="font-size: 0.75rem; color: #64748b;">${c.email || 'No email'}${c.company_name ? ` • ${c.company_name}` : ''}</div>
        </div>
      `).join('');
      dropdown.style.display = 'block';
    } else if (query.length > 0) {
      dropdown.innerHTML = `
        <div style="padding: 1rem; text-align: center; color: #64748b; font-size: 0.875rem;">
          No contacts found matching "${query}"
        </div>
      `;
      dropdown.style.display = 'block';
    } else {
      dropdown.style.display = 'none';
    }
  }
};

// Handle contract name input without full re-render
window.handleContractNameInput = function (value) {
  newContractData.contractName = value;
  window.newContractData = newContractData;

  // Update input border color directly
  const input = document.getElementById('contract-name-input');
  if (input) {
    const isValid = value && value.trim() !== '';
    input.style.borderColor = isValid ? '#22c55e' : '#d1d5db';
  }

  // Update Next button state without full re-render
  updateContractNextButton();
};

// Handle client name input without full re-render
window.handleClientNameInput = function (value) {
  newContractData.clientName = value;
  window.newContractData = newContractData;

  // Update input border color directly
  const input = document.getElementById('client-name-input');
  if (input) {
    const isValid = newContractData.contactId || (value && value.trim() !== '');
    input.style.borderColor = isValid ? '#22c55e' : '#d1d5db';
  }

  // Update Next button state without full re-render
  updateContractNextButton();
};

// Handle client email input without full re-render
window.handleClientEmailInput = function (value) {
  newContractData.clientEmail = value;
  window.newContractData = newContractData;

  // Update input border color directly
  const input = document.getElementById('client-email-input');
  if (input) {
    const isValid = newContractData.contactId || (value && value.trim() !== '');
    input.style.borderColor = isValid ? '#22c55e' : '#d1d5db';
  }

  // Update Next button state without full re-render
  updateContractNextButton();
};

// Update contract Next button state without full re-render
function updateContractNextButton() {
  const nextButton = document.querySelector('button[onclick*="setContractStep"]');
  if (!nextButton) return;

  let isValid = true;
  if (newContractStep === 1) {
    isValid = newContractData.contractName && newContractData.contractName.trim() !== '' &&
      (newContractData.contactId ||
        (newContractData.clientName && newContractData.clientName.trim() !== '' &&
          newContractData.clientEmail && newContractData.clientEmail.trim() !== ''));
  } else if (newContractStep === 2) {
    isValid = newContractData.lineItems && newContractData.lineItems.length > 0;
  }

  nextButton.style.background = isValid ? 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)' : '#cbd5e1';
  nextButton.style.cursor = isValid ? 'pointer' : 'not-allowed';
  nextButton.style.opacity = isValid ? '1' : '0.6';
  nextButton.disabled = !isValid;

  // Update helper message
  const helperDiv = nextButton.parentElement.querySelector('div[style*="font-size: 0.75rem"]');
  if (helperDiv) {
    helperDiv.style.display = isValid ? 'none' : 'block';
  }
}

// Select contact from search dropdown
window.selectContactFromSearch = function (contactId) {
  selectContractContact(contactId);

  // Update UI
  const contact = contacts.find(c => c.id === contactId);
  const input = document.getElementById('contact-search-input');
  const dropdown = document.getElementById('contact-search-dropdown');

  if (input && contact) {
    input.value = `${contact.first_name || ''} ${contact.last_name || ''}`.trim();
  }
  if (dropdown) {
    dropdown.style.display = 'none';
  }

  contactSearchQuery = '';
  showContactDropdown = false;

  // Update Next button state
  updateContractNextButton();
};

// Clear contact selection
window.clearContactSelection = function () {
  newContractData.contactId = null;
  newContractData.clientName = '';
  newContractData.clientEmail = '';
  newContractData.clientPhone = '';
  newContractData.clientCompanyName = '';
  window.newContractData = newContractData;

  const input = document.getElementById('contact-search-input');
  if (input) {
    input.value = '';
  }

  // Update input border colors
  const clientNameInput = document.getElementById('client-name-input');
  const clientEmailInput = document.getElementById('client-email-input');
  if (clientNameInput) {
    clientNameInput.style.borderColor = '#d1d5db';
  }
  if (clientEmailInput) {
    clientEmailInput.style.borderColor = '#d1d5db';
  }

  // Update Next button state
  updateContractNextButton();

  renderPMTool();
};

// Hide contact dropdown when clicking outside
document.addEventListener('click', function (e) {
  const searchContainer = document.getElementById('contact-search-container');
  const dropdown = document.getElementById('contact-search-dropdown');
  if (searchContainer && dropdown && !searchContainer.contains(e.target)) {
    dropdown.style.display = 'none';
  }
});

// Handle product search input with minimal debounce and focus preservation
window.handleProductSearchInput = function (input) {
  var value = input.value;
  var cursorPos = input.selectionStart;

  // Update the search query immediately
  productSearchQuery = value;
  window.productSearchQuery = value;

  // Clear existing timeout
  if (productSearchTimeout) {
    clearTimeout(productSearchTimeout);
  }

  // Use immediate update for smoother experience - no debounce needed for filtering
  // Update only the product list container without full re-render
  var productContainer = document.querySelector('[data-product-list-container]');
  if (productContainer) {
    // Just update the inner HTML of the product list immediately
    var filteredHtml = getFilteredProductsHtml();
    productContainer.innerHTML = filteredHtml;
  } else {
    // Fallback to full render if container not found (first render)
    renderPMTool();
    setTimeout(function () {
      var searchInput = document.getElementById('product-search-input');
      if (searchInput) {
        searchInput.focus();
        if (cursorPos !== null && cursorPos !== undefined && cursorPos <= value.length) {
          searchInput.setSelectionRange(cursorPos, cursorPos);
        }
      }
    }, 10);
  }
};

// Helper function to get filtered products HTML
function getFilteredProductsHtml() {
  var filteredProducts = contractProducts;

  // Apply search filter
  if (productSearchQuery && productSearchQuery.trim()) {
    var searchLower = productSearchQuery.toLowerCase().trim();
    filteredProducts = contractProducts.filter(function (p) {
      return p.name.toLowerCase().includes(searchLower) ||
        (p.sku && p.sku.toLowerCase().includes(searchLower)) ||
        (p.description && p.description.toLowerCase().includes(searchLower));
    });
  }

  // Sort alphabetically by name
  filteredProducts = filteredProducts.slice().sort(function (a, b) {
    var nameA = (a.name || '').toLowerCase();
    var nameB = (b.name || '').toLowerCase();
    return nameA.localeCompare(nameB);
  });

  if (filteredProducts.length === 0) {
    return '<div style="color: #64748b; font-size: 0.875rem; padding: 0.5rem; grid-column: 1 / -1;">' + (contractProducts.length === 0 ? 'No products available. Add products in the Products tab.' : 'No products match your search.') + '</div>';
  }

  return filteredProducts.map(function (p) {
    var isSelected = (window.selectedProductIds || []).includes(p.id);
    var borderColor = isSelected ? '#3b82f6' : '#e2e8f0';
    var bgColor = isSelected ? '#eff6ff' : 'white';
    return '<label style="display: flex; align-items: center; gap: 0.75rem; padding: 0.625rem 0.75rem; background: ' + bgColor + '; border: 1px solid ' + borderColor + '; border-radius: 0.375rem; cursor: pointer; transition: all 0.15s;" onmouseover="this.style.borderColor=\'#3b82f6\'" onmouseout="this.style.borderColor=\'' + borderColor + '\'"><input type="checkbox" id="product-check-' + p.id + '" ' + (isSelected ? 'checked' : '') + ' onchange="toggleProductSelection(\'' + p.id + '\')" style="width: 18px; height: 18px; cursor: pointer; accent-color: #3b82f6;" /><div style="flex: 1; min-width: 0;"><div style="font-weight: 500; color: #1e293b; font-size: 0.875rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">' + p.name + '</div><div style="font-size: 0.75rem; color: #64748b;">$' + parseFloat(p.price).toFixed(2) + (p.is_recurring ? ' / ' + (p.recurring_interval || 'month') : '') + '</div></div></label>';
  }).join('');
}

// Toggle product selection in multi-select dropdown
window.toggleProductSelection = function (productId) {
  const idx = selectedProductIds.indexOf(productId);
  if (idx > -1) {
    selectedProductIds.splice(idx, 1);
  } else {
    selectedProductIds.push(productId);
  }
  window.selectedProductIds = selectedProductIds;
  // Update checkbox visual state without full re-render
  const checkbox = document.getElementById(`product-check-${productId}`);
  if (checkbox) {
    checkbox.checked = selectedProductIds.includes(productId);
  }
  // Update the "Add Selected" button text
  const addBtn = document.getElementById('add-selected-products-btn');
  if (addBtn) {
    addBtn.textContent = selectedProductIds.length > 0
      ? `Add Selected (${selectedProductIds.length})`
      : 'Add Selected';
    addBtn.style.opacity = selectedProductIds.length > 0 ? '1' : '0.5';
  }
};

// Add multiple selected products to contract
window.addSelectedProductsToContract = function () {
  if (selectedProductIds.length === 0) {
    showNotification('Please select at least one product', 'warning');
    return;
  }

  const addedCount = selectedProductIds.length;

  selectedProductIds.forEach(productId => {
    const product = contractProducts.find(p => p.id === productId);
    if (product) {
      const lineItem = {
        id: crypto.randomUUID(),
        productId: product.id,
        name: product.name,
        sku: product.sku || '',
        description: product.description || '',
        quantity: 1,
        unitPrice: parseFloat(product.price) || 0,
        isRecurring: product.is_recurring || false,
        recurringInterval: product.recurring_interval || 'monthly',
        discountType: null,
        discountValue: 0
      };
      newContractData.lineItems.push(lineItem);
    }
  });

  // Clear selections
  selectedProductIds = [];
  window.selectedProductIds = selectedProductIds;
  window.newContractData = newContractData;

  showNotification(`Added ${addedCount} ${addedCount > 1 ? 'products' : 'product'} to contract`, 'success');
  renderPMTool();
};

// Add single product to contract (for quick add)
window.addProductToContract = function (productId) {
  const product = contractProducts.find(p => p.id === productId);
  if (product) {
    const lineItem = {
      id: crypto.randomUUID(),
      productId: product.id,
      name: product.name,
      sku: product.sku || '',
      description: product.description || '',
      quantity: 1,
      unitPrice: parseFloat(product.price) || 0,
      isRecurring: product.is_recurring || false,
      recurringInterval: product.recurring_interval || 'monthly',
      discountType: null,
      discountValue: 0
    };
    newContractData.lineItems.push(lineItem);
    window.newContractData = newContractData;
    renderPMTool();
  }
};

// Add misc item to contract
window.addMiscItemToContract = function () {
  const lineItem = {
    id: crypto.randomUUID(),
    productId: null,
    name: 'Custom Item',
    sku: '',
    description: '',
    quantity: 1,
    unitPrice: 0,
    isRecurring: false,
    recurringInterval: 'monthly',
    discountType: null,
    discountValue: 0
  };
  newContractData.lineItems.push(lineItem);
  window.newContractData = newContractData;
  renderPMTool();
};

// Remove line item from contract
window.removeContractLineItem = function (lineItemId) {
  newContractData.lineItems = newContractData.lineItems.filter(item => item.id !== lineItemId);
  window.newContractData = newContractData;
  renderPMTool();
};

// Update line item
window.updateContractLineItem = function (lineItemId, field, value) {
  const item = newContractData.lineItems.find(i => i.id === lineItemId);
  if (item) {
    if (field === 'quantity' || field === 'unitPrice' || field === 'discountValue') {
      item[field] = parseFloat(value) || 0;
    } else if (field === 'isRecurring') {
      item[field] = value === 'true' || value === true;
    } else {
      item[field] = value;
    }
    window.newContractData = newContractData;
  }
};

// Toggle clause selection
window.toggleContractClause = function (clauseId) {
  const idx = newContractData.selectedClauses.indexOf(clauseId);
  if (idx >= 0) {
    newContractData.selectedClauses.splice(idx, 1);
  } else {
    newContractData.selectedClauses.push(clauseId);
  }
  window.newContractData = newContractData;
  renderPMTool();
};

// Calculate contract totals
function calculateContractTotals() {
  let subtotal = 0;
  let monthlyRecurring = 0;

  newContractData.lineItems.forEach(item => {
    const lineTotal = item.quantity * item.unitPrice;
    let lineDiscount = 0;

    if (item.discountType === 'percentage') {
      lineDiscount = lineTotal * (item.discountValue / 100);
    } else if (item.discountType === 'fixed') {
      lineDiscount = Math.min(item.discountValue, lineTotal);
    }

    const lineFinal = lineTotal - lineDiscount;

    if (item.isRecurring) {
      monthlyRecurring += lineFinal;
    } else {
      subtotal += lineFinal;
    }
  });

  // Overall discount
  let discountAmount = 0;
  if (newContractData.discountType === 'percentage') {
    discountAmount = subtotal * (newContractData.discountValue / 100);
  } else if (newContractData.discountType === 'fixed') {
    discountAmount = Math.min(newContractData.discountValue, subtotal);
  }

  const afterDiscount = subtotal - discountAmount;
  const taxAmount = afterDiscount * (newContractData.taxRate / 100);
  const total = afterDiscount + taxAmount;

  return {
    subtotal,
    discountAmount,
    taxAmount,
    total,
    monthlyRecurring,
    savings: discountAmount
  };
}

// Save contract
window.saveContract = async function (sendNow = false) {
  if (!currentCompany?.id || !currentProfile?.id) {
    showNotification('Missing company or user context', 'error');
    return;
  }

  if (!newContractData.clientName || !newContractData.clientEmail) {
    showNotification('Client name and email are required', 'error');
    return;
  }

  if (!newContractData.contractName) {
    showNotification('Contract name is required', 'error');
    return;
  }

  try {
    const totals = calculateContractTotals();

    // Generate contract number
    const { data: countData } = await supabase
      .from('contracts')
      .select('id', { count: 'exact', head: true })
      .eq('company_id', currentCompany.id);

    const year = new Date().getFullYear();
    const count = (countData?.length || 0) + 1;
    const contractNumber = `CNT-${year}-${String(count).padStart(4, '0')}`;

    // Get company rep info (auto-filled from current user)
    const repName = `${currentProfile.first_name || ''} ${currentProfile.last_name || ''}`.trim() || 'Company Representative';
    const repTitle = currentProfile.company_role || 'Representative';
    const repCompanyName = currentCompany.name || '';

    // Create contract
    const contractInsert = {
      company_id: currentCompany.id,
      contract_number: contractNumber,
      name: newContractData.contractName,
      contact_id: newContractData.contactId || null,
      client_name: newContractData.clientName,
      client_email: newContractData.clientEmail,
      client_phone: newContractData.clientPhone || null,
      client_company_name: newContractData.clientCompanyName || null,
      status: sendNow ? 'sent' : 'draft',
      effective_date: newContractData.effectiveDate || null,
      close_date: newContractData.closeDate || null,
      subtotal: totals.subtotal,
      discount_type: newContractData.discountType,
      discount_value: newContractData.discountValue,
      discount_amount: totals.discountAmount,
      tax_rate: newContractData.taxRate,
      tax_amount: totals.taxAmount,
      total: totals.total,
      monthly_recurring: totals.monthlyRecurring,
      custom_notes: newContractData.customNotes || null,
      created_by: currentProfile.id,
      owner_id: currentProfile.id,
      // Company representative auto-fill
      rep_company_name: repCompanyName,
      rep_name: repName,
      rep_title: repTitle,
      rep_signature: repName, // Use name as typed signature
      rep_signed_at: new Date().toISOString()
    };

    if (sendNow) {
      // Generate signing token
      const tokenBytes = new Uint8Array(32);
      crypto.getRandomValues(tokenBytes);
      const signingToken = Array.from(tokenBytes).map(b => b.toString(16).padStart(2, '0')).join('');
      contractInsert.signing_token = signingToken;
      contractInsert.sent_at = new Date().toISOString();
      contractInsert.expiry_date = new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toISOString(); // 14 days
    }

    const { data: contract, error: contractError } = await supabase
      .from('contracts')
      .insert(contractInsert)
      .select()
      .single();

    if (contractError) {
      console.error('Error creating contract:', contractError);
      showNotification('Failed to create contract: ' + contractError.message, 'error');
      return;
    }

    // Insert line items
    if (newContractData.lineItems.length > 0) {
      const lineItemsInsert = newContractData.lineItems.map((item, idx) => ({
        contract_id: contract.id,
        product_id: item.productId || null,
        name: item.name,
        sku: item.sku || null,
        description: item.description || null,
        quantity: item.quantity,
        unit_price: item.unitPrice,
        is_recurring: item.isRecurring,
        recurring_interval: item.recurringInterval,
        discount_type: item.discountType,
        discount_value: item.discountValue || 0,
        subtotal: item.quantity * item.unitPrice,
        total: item.quantity * item.unitPrice - (item.discountType === 'percentage' ? item.quantity * item.unitPrice * item.discountValue / 100 : (item.discountValue || 0)),
        sort_order: idx
      }));

      const { error: lineError } = await supabase
        .from('contract_line_items')
        .insert(lineItemsInsert);

      if (lineError) {
        console.error('Error creating line items:', lineError);
      }
    }

    // Insert selected clauses
    if (newContractData.selectedClauses.length > 0) {
      const clausesInsert = newContractData.selectedClauses.map((clauseId, idx) => ({
        contract_id: contract.id,
        clause_id: clauseId,
        sort_order: idx
      }));

      const { error: clauseError } = await supabase
        .from('contract_selected_clauses')
        .insert(clausesInsert);

      if (clauseError) {
        console.error('Error saving clauses:', clauseError);
      }
    }

    // Log activity to contract_activity_log
    await supabase.from('contract_activity_log').insert({
      contract_id: contract.id,
      action: sendNow ? 'created_with_link' : 'created',
      actor_id: currentProfile.id,
      actor_name: `${currentProfile.first_name || ''} ${currentProfile.last_name || ''}`.trim()
    });

    // Log activity to contact's activity log if contract is linked to a contact
    if (newContractData.contactId && sendNow) {
      const senderName = `${currentProfile.first_name || ''} ${currentProfile.last_name || ''}`.trim() || 'Team Member';
      try {
        const { error: activityError } = await supabase.from('activity_log').insert({
          company_id: currentCompany.id,
          contact_id: newContractData.contactId,
          user_id: currentProfile.id,
          activity_type: 'note', // For backwards compatibility
          event_type: 'contract_sent',
          title: `Contract created: ${newContractData.contractName || 'Untitled'}`,
          description: `Contract "${newContractData.contractName || 'Untitled'}" was created and sent by ${senderName}. Total: $${totals.total.toFixed(2)}`,
          metadata: JSON.stringify({
            contract_id: contract.id,
            contract_name: newContractData.contractName,
            contract_total: totals.total,
            sent_by: senderName
          })
        });
        if (activityError) {
          console.error('Error logging contact activity:', activityError);
        } else {
          console.log('✅ Contract activity logged successfully');
        }
      } catch (actErr) {
        console.error('Error logging contact activity:', actErr);
      }
    }

    showNewContractModal = false;
    await loadContracts();

    // Show signing link modal if contract was created with link
    if (sendNow && contract.signing_token) {
      const signingLink = `${window.location.origin}/sign/${contract.signing_token}`;
      showContractLinkModal(signingLink, newContractData.contractName);
    } else {
      showNotification('Contract saved as draft', 'success');
    }

    renderPMTool();

  } catch (error) {
    console.error('Error saving contract:', error);
    showNotification('Failed to save contract', 'error');
  }
};

// Open product modal
window.openProductModal = function (productId = null, categoryId = null) {
  editingProductId = productId;
  if (productId) {
    const product = contractProducts.find(p => p.id === productId);
    if (product) {
      productFormData = {
        name: product.name,
        sku: product.sku || '',
        description: product.description || '',
        price: product.price || 0,
        cost: product.cost || 0,
        is_recurring: product.is_recurring || false,
        recurring_interval: product.recurring_interval || 'monthly',
        is_taxable: product.is_taxable !== false, // Default to true if undefined
        category_id: product.category_id || null
      };
    }
  } else {
    productFormData = {
      name: '',
      sku: '',
      description: '',
      price: 0,
      cost: 0,
      is_recurring: false,
      recurring_interval: 'monthly',
      is_taxable: true, // Default to taxable
      category_id: categoryId || selectedCategoryId || null
    };
  }
  window.productFormData = productFormData;
  showProductModal = true;
  renderPMTool();
};

// Close product modal
window.closeProductModal = function () {
  showProductModal = false;
  editingProductId = null;
  renderPMTool();
};

// Save product
window.saveProduct = async function () {
  if (!currentCompany?.id) {
    showNotification('No company context', 'error');
    return;
  }

  if (!productFormData.name) {
    showNotification('Product name is required', 'error');
    return;
  }

  // Validate SKU uniqueness per company (only if SKU is provided)
  if (productFormData.sku && productFormData.sku.trim()) {
    const skuToCheck = productFormData.sku.trim();

    // Check if SKU already exists for this company
    let query = supabase
      .from('contract_products')
      .select('id, name')
      .eq('company_id', currentCompany.id)
      .eq('sku', skuToCheck)
      .eq('is_archived', false);

    // If editing, exclude the current product from the check
    if (editingProductId) {
      query = query.neq('id', editingProductId);
    }

    const { data: existingProducts, error: checkError } = await query;

    if (checkError) {
      console.error('Error checking SKU:', checkError);
      showNotification('Error checking SKU availability', 'error');
      return;
    }

    if (existingProducts && existingProducts.length > 0) {
      showNotification(`A product with SKU "${skuToCheck}" already exists. Please use a different SKU.`, 'error');
      return;
    }
  }

  try {
    const productData = {
      company_id: currentCompany.id,
      name: productFormData.name,
      sku: productFormData.sku && productFormData.sku.trim() ? productFormData.sku.trim() : null,
      description: productFormData.description || null,
      price: parseFloat(productFormData.price) || 0,
      cost: parseFloat(productFormData.cost) || 0,
      is_recurring: productFormData.is_recurring,
      recurring_interval: productFormData.recurring_interval,
      is_taxable: productFormData.is_taxable,
      category_id: productFormData.category_id || null,
      created_by: currentProfile?.id
    };

    if (editingProductId) {
      const { error } = await supabase
        .from('contract_products')
        .update(productData)
        .eq('id', editingProductId);

      if (error) {
        // Check if error is due to duplicate SKU constraint
        if (error.code === '23505' || error.message.includes('duplicate') || error.message.includes('unique')) {
          showNotification(`A product with SKU "${productData.sku}" already exists. Please use a different SKU.`, 'error');
          return;
        }
        throw error;
      }
      showNotification('Product updated', 'success');
    } else {
      const { error } = await supabase
        .from('contract_products')
        .insert(productData);

      if (error) {
        // Check if error is due to duplicate SKU constraint
        if (error.code === '23505' || error.message.includes('duplicate') || error.message.includes('unique')) {
          showNotification(`A product with SKU "${productData.sku}" already exists. Please use a different SKU.`, 'error');
          return;
        }
        throw error;
      }
      showNotification('Product created', 'success');
    }

    showProductModal = false;
    editingProductId = null;
    await loadContractProducts();
    renderPMTool();
  } catch (error) {
    console.error('Error saving product:', error);
    showNotification('Failed to save product: ' + error.message, 'error');
  }
};

// Archive product
window.archiveProduct = async function (productId) {
  if (!confirm('Are you sure you want to archive this product?')) return;

  try {
    const { error } = await supabase
      .from('contract_products')
      .update({ is_archived: true })
      .eq('id', productId);

    if (error) throw error;
    showNotification('Product archived', 'success');
    await loadContractProducts();
    renderPMTool();
  } catch (error) {
    console.error('Error archiving product:', error);
    showNotification('Failed to archive product', 'error');
  }
};

// =============================================================================
// CATEGORY MODAL FUNCTIONS
// =============================================================================

// Open category modal
window.openCategoryModal = function (categoryId = null) {
  editingCategoryId = categoryId;
  if (categoryId) {
    const category = productCategories.find(c => c.id === categoryId);
    if (category) {
      categoryFormData = {
        name: category.name,
        description: category.description || ''
      };
    }
  } else {
    categoryFormData = {
      name: '',
      description: ''
    };
  }
  window.categoryFormData = categoryFormData;
  showCategoryModal = true;
  renderPMTool();
};

// Close category modal
window.closeCategoryModal = function () {
  showCategoryModal = false;
  editingCategoryId = null;
  renderPMTool();
};

// Save category
window.saveCategory = async function () {
  if (!currentCompany?.id) {
    showNotification('No company context', 'error');
    return;
  }

  if (!categoryFormData.name) {
    showNotification('Category name is required', 'error');
    return;
  }

  try {
    const categoryData = {
      company_id: currentCompany.id,
      name: categoryFormData.name,
      description: categoryFormData.description || null
    };

    if (editingCategoryId) {
      // Update existing
      const { error } = await supabase
        .from('contract_product_categories')
        .update(categoryData)
        .eq('id', editingCategoryId);

      if (error) throw error;
      showNotification('Category updated', 'success');
    } else {
      // Create new
      categoryData.created_by = (await supabase.auth.getUser()).data.user?.id;
      const { error } = await supabase
        .from('contract_product_categories')
        .insert(categoryData);

      if (error) throw error;
      showNotification('Category created', 'success');
    }

    showCategoryModal = false;
    editingCategoryId = null;
    await loadProductCategories();
    renderPMTool();
  } catch (error) {
    console.error('Error saving category:', error);
    showNotification('Failed to save category: ' + error.message, 'error');
  }
};

// Archive category
window.archiveCategory = async function (categoryId) {
  if (!confirm('Are you sure you want to archive this category? Products in this category will become uncategorized.')) return;

  try {
    const { error } = await supabase
      .from('contract_product_categories')
      .update({ is_archived: true })
      .eq('id', categoryId);

    if (error) throw error;
    showNotification('Category archived', 'success');
    selectedCategoryId = null;
    await loadProductCategories();
    renderPMTool();
  } catch (error) {
    console.error('Error archiving category:', error);
    showNotification('Failed to archive category', 'error');
  }
};

// Select category to view products
window.selectCategory = function (categoryId) {
  selectedCategoryId = categoryId;
  renderPMTool();
};

// Go back to categories list
window.backToCategories = function () {
  selectedCategoryId = null;
  renderPMTool();
};

// Open product modal with category pre-selected
window.openProductModalWithCategory = function (categoryId) {
  editingProductId = null;
  productFormData = {
    name: '',
    sku: '',
    description: '',
    price: 0,
    cost: 0,
    is_recurring: false,
    recurring_interval: 'monthly',
    is_taxable: true,
    category_id: categoryId
  };
  window.productFormData = productFormData;
  showProductModal = true;
  renderPMTool();
};

// Open clause modal
window.openClauseModal = function (clauseId = null) {
  editingClauseId = clauseId;
  if (clauseId) {
    const clause = contractClauses.find(c => c.id === clauseId);
    if (clause) {
      clauseFormData = {
        title: clause.title,
        category: clause.category,
        body: clause.body,
        is_default: clause.is_default || false
      };
    }
  } else {
    clauseFormData = {
      title: '',
      category: 'other',
      body: '',
      is_default: false
    };
  }
  window.clauseFormData = clauseFormData;
  showClauseModal = true;
  renderPMTool();
};

// Close clause modal
window.closeClauseModal = function () {
  showClauseModal = false;
  editingClauseId = null;
  renderPMTool();
};

// Save clause
window.saveClause = async function () {
  if (!currentCompany?.id) {
    showNotification('No company context', 'error');
    return;
  }

  if (!clauseFormData.title || !clauseFormData.body) {
    showNotification('Title and body are required', 'error');
    return;
  }

  try {
    const clauseData = {
      company_id: currentCompany.id,
      title: clauseFormData.title,
      category: clauseFormData.category,
      body: clauseFormData.body,
      is_default: clauseFormData.is_default,
      created_by: currentProfile?.id
    };

    if (editingClauseId) {
      const { error } = await supabase
        .from('contract_clauses')
        .update(clauseData)
        .eq('id', editingClauseId);

      if (error) throw error;
      showNotification('Clause updated', 'success');
    } else {
      const { error } = await supabase
        .from('contract_clauses')
        .insert(clauseData);

      if (error) throw error;
      showNotification('Clause created', 'success');
    }

    showClauseModal = false;
    editingClauseId = null;
    await loadContractClauses();
    renderPMTool();
  } catch (error) {
    console.error('Error saving clause:', error);
    showNotification('Failed to save clause: ' + error.message, 'error');
  }
};

// Archive clause
window.archiveClause = async function (clauseId) {
  if (!confirm('Are you sure you want to archive this clause?')) return;

  try {
    const { error } = await supabase
      .from('contract_clauses')
      .update({ is_archived: true })
      .eq('id', clauseId);

    if (error) throw error;
    showNotification('Clause archived', 'success');
    await loadContractClauses();
    renderPMTool();
  } catch (error) {
    console.error('Error archiving clause:', error);
    showNotification('Failed to archive clause', 'error');
  }
};

// Copy signing link
window.copySigningLink = function (token) {
  const link = `${window.location.origin}/sign/${token}`;
  navigator.clipboard.writeText(link).then(() => {
    showNotification('Signing link copied to clipboard', 'success');
  }).catch(() => {
    showNotification('Failed to copy link', 'error');
  });
};

// Show contract link modal
function showContractLinkModal(link, contractName) {
  showContractLink = true;
  contractLinkData = { link, contractName };
  window.contractLinkData = contractLinkData;
  renderPMTool();
}

// Close contract link modal
window.closeContractLinkModal = function () {
  showContractLink = false;
  renderPMTool();
};

// Copy link from modal
window.copyContractLinkFromModal = function () {
  navigator.clipboard.writeText(contractLinkData.link).then(() => {
    showNotification('Signing link copied to clipboard!', 'success');
  }).catch(() => {
    // Fallback: select the input
    const input = document.getElementById('contract-link-input');
    if (input) {
      input.select();
      document.execCommand('copy');
      showNotification('Link copied!', 'success');
    }
  });
};

// Open tax rate modal (only for owners/managers)
window.openTaxRateModal = function () {
  // Check permissions - only owners and managers can change global tax rate
  const userRole = currentProfile?.company_role || currentProfile?.role || 'USER';
  if (userRole !== 'OWNER' && userRole !== 'MANAGER' && userRole !== 'ADMIN') {
    showNotification('Only owners and managers can change the global tax rate', 'error');
    return;
  }
  showTaxRateModal = true;
  renderPMTool();
};

// Close tax rate modal
window.closeTaxRateModal = function () {
  showTaxRateModal = false;
  renderPMTool();
};

// Save global tax rate to database
window.saveGlobalTaxRate = async function (rate) {
  // Check permissions
  const userRole = currentProfile?.company_role || currentProfile?.role || 'USER';
  if (userRole !== 'OWNER' && userRole !== 'MANAGER' && userRole !== 'ADMIN') {
    showNotification('Only owners and managers can change the global tax rate', 'error');
    return;
  }

  if (!currentCompany?.id) {
    showNotification('Company context missing', 'error');
    return;
  }

  const taxRate = parseFloat(rate) || 0;

  try {
    // Save to database
    const { error } = await supabase
      .from('companies')
      .update({ global_tax_rate: taxRate })
      .eq('id', currentCompany.id);

    if (error) throw error;

    // Update local state
    globalTaxRate = taxRate;
    currentCompany.global_tax_rate = taxRate;

    showNotification('Global tax rate updated to ' + taxRate + '%', 'success');
    showTaxRateModal = false;
    renderPMTool();
  } catch (error) {
    console.error('Error saving global tax rate:', error);
    showNotification('Failed to save tax rate: ' + (error.message || error), 'error');
  }
};

// Save tax rate from settings page with confirmation
window.saveSettingsTaxRate = function () {
  const input = document.getElementById('settings-tax-rate-input');
  if (!input) return;

  const newRate = parseFloat(input.value) || 0;
  const oldRate = globalTaxRate;

  if (newRate === oldRate) {
    showNotification('Tax rate unchanged', 'info');
    return;
  }

  if (newRate < 0 || newRate > 100) {
    showNotification('Tax rate must be between 0 and 100', 'error');
    return;
  }

  // Show confirmation
  settingsConfirmMessage = 'Are you sure you want to change the global tax rate from ' + oldRate + '% to ' + newRate + '%? This will affect all new contracts.';
  settingsConfirmAction = function () {
    saveGlobalTaxRate(newRate);
    closeSettingsConfirmModal();
  };
  showSettingsConfirmModal = true;
  renderPMTool();
};

// Handle logo upload
window.handleLogoUpload = async function (input) {
  if (!input.files || input.files.length === 0) return;

  const file = input.files[0];
  const maxSize = 5 * 1024 * 1024; // 5MB

  if (file.size > maxSize) {
    showNotification('Logo file size must be less than 5MB', 'error');
    return;
  }

  if (!currentCompany?.id) {
    showNotification('Company context missing', 'error');
    return;
  }

  try {
    // Show confirmation
    settingsConfirmMessage = 'Are you sure you want to upload this logo? It will be displayed on all contracts.';
    settingsConfirmAction = async function () {
      try {
        // Upload to Supabase storage
        const fileExt = file.name.split('.').pop();
        const fileName = `company-${currentCompany.id}-logo-${Date.now()}.${fileExt}`;
        const filePath = `contract-logos/${fileName}`;

        // Try to upload to contract-assets bucket, fallback to public bucket
        let bucketName = 'contract-assets';
        let { error: uploadError } = await supabase.storage
          .from(bucketName)
          .upload(filePath, file, {
            cacheControl: '3600',
            upsert: false
          });

        // If bucket doesn't exist, try public bucket
        if (uploadError && uploadError.message && uploadError.message.includes('Bucket not found')) {
          bucketName = 'public';
          const retryUpload = await supabase.storage
            .from(bucketName)
            .upload(filePath, file, {
              cacheControl: '3600',
              upsert: false
            });
          uploadError = retryUpload.error;
        }

        if (uploadError) {
          throw new Error('Storage error: ' + (uploadError.message || 'Failed to upload logo'));
        }

        // Get public URL
        const { data: urlData } = supabase.storage
          .from(bucketName)
          .getPublicUrl(filePath);

        if (!urlData?.publicUrl) {
          throw new Error('Failed to get logo URL');
        }

        // Save URL to company record
        const { error: updateError } = await supabase
          .from('companies')
          .update({ contract_logo_url: urlData.publicUrl })
          .eq('id', currentCompany.id);

        if (updateError) throw updateError;

        // Update local state
        companyLogoUrl = urlData.publicUrl;
        currentCompany.contract_logo_url = urlData.publicUrl;

        showNotification('Logo uploaded successfully', 'success');
        closeSettingsConfirmModal();
        renderPMTool();
      } catch (error) {
        console.error('Error uploading logo:', error);
        showNotification('Failed to upload logo: ' + (error.message || error), 'error');
        closeSettingsConfirmModal();
      }
    };
    showSettingsConfirmModal = true;
    renderPMTool();
  } catch (error) {
    console.error('Error handling logo upload:', error);
    showNotification('Failed to process logo: ' + (error.message || error), 'error');
  }
};

// Remove company logo
window.removeCompanyLogo = function () {
  if (!companyLogoUrl) return;

  settingsConfirmMessage = 'Are you sure you want to remove the company logo? It will no longer appear on contracts.';
  settingsConfirmAction = async function () {
    try {
      if (!currentCompany?.id) {
        showNotification('Company context missing', 'error');
        return;
      }

      // Remove from database
      const { error } = await supabase
        .from('companies')
        .update({ contract_logo_url: null })
        .eq('id', currentCompany.id);

      if (error) throw error;

      // Update local state
      companyLogoUrl = null;
      currentCompany.contract_logo_url = null;

      showNotification('Logo removed successfully', 'success');
      closeSettingsConfirmModal();
      renderPMTool();
    } catch (error) {
      console.error('Error removing logo:', error);
      showNotification('Failed to remove logo: ' + (error.message || error), 'error');
      closeSettingsConfirmModal();
    }
  };
  showSettingsConfirmModal = true;
  renderPMTool();
};

// Load company logo
async function loadCompanyLogo() {
  if (!currentCompany?.id) return;

  try {
    const { data, error } = await supabase
      .from('companies')
      .select('contract_logo_url')
      .eq('id', currentCompany.id)
      .single();

    if (!error && data) {
      companyLogoUrl = data.contract_logo_url || null;
      if (currentCompany) {
        currentCompany.contract_logo_url = companyLogoUrl;
      }
    }
  } catch (error) {
    console.error('Error loading company logo:', error);
  }
}

// Settings confirmation modal functions
window.closeSettingsConfirmModal = function () {
  showSettingsConfirmModal = false;
  settingsConfirmAction = null;
  settingsConfirmMessage = '';
  renderPMTool();
};

window.confirmSettingsAction = function () {
  if (settingsConfirmAction) {
    settingsConfirmAction();
  }
};

// Load global tax rate from database
async function loadGlobalTaxRate() {
  if (!currentCompany?.id) {
    // Fallback to localStorage if company not loaded yet
    const savedRate = localStorage.getItem('contracts_global_tax_rate');
    if (savedRate !== null) {
      globalTaxRate = parseFloat(savedRate) || 0;
    }
    return;
  }

  try {
    // Load from database
    const { data, error } = await supabase
      .from('companies')
      .select('global_tax_rate')
      .eq('id', currentCompany.id)
      .single();

    if (!error && data) {
      globalTaxRate = parseFloat(data.global_tax_rate || 0);
      // Also update currentCompany object
      if (currentCompany) {
        currentCompany.global_tax_rate = globalTaxRate;
      }
    } else {
      // Fallback to localStorage if database read fails
      const savedRate = localStorage.getItem('contracts_global_tax_rate');
      if (savedRate !== null) {
        globalTaxRate = parseFloat(savedRate) || 0;
      }
    }
  } catch (err) {
    console.error('Error loading global tax rate:', err);
    // Fallback to localStorage
    const savedRate = localStorage.getItem('contracts_global_tax_rate');
    if (savedRate !== null) {
      globalTaxRate = parseFloat(savedRate) || 0;
    }
  }
}

// Resend contract email
window.resendContractEmail = async function (contractId) {
  const contract = contractsList.find(c => c.id === contractId);
  if (!contract || !contract.signing_token) {
    showNotification('Contract not found or not sent yet', 'error');
    return;
  }

  try {
    const signingLink = `${window.location.origin}/sign/${contract.signing_token}`;

    const { error } = await supabase.functions.invoke('send-contract-email', {
      body: {
        contractId: contract.id,
        recipientEmail: contract.client_email,
        recipientName: contract.client_name,
        contractName: contract.name,
        signingLink: signingLink,
        senderName: `${currentProfile?.first_name || ''} ${currentProfile?.last_name || ''}`.trim(),
        companyName: currentCompany?.name || 'Our Company'
      }
    });

    if (error) {
      console.warn('Could not resend email:', error);
      showNotification('Could not send email - copy the signing link instead', 'error');
    } else {
      showNotification('Email resent to ' + contract.client_email, 'success');

      // Log activity
      await supabase.from('contract_activity_log').insert({
        contract_id: contract.id,
        action: 'email_resent',
        actor_id: currentProfile?.id,
        actor_name: `${currentProfile?.first_name || ''} ${currentProfile?.last_name || ''}`.trim()
      });
    }
  } catch (err) {
    console.error('Error resending email:', err);
    showNotification('Failed to resend email', 'error');
  }
};

// View contract detail
window.viewContractDetail = function (contractId) {
  selectedContractId = contractId;
  contractViewMode = 'detail';
  renderPMTool();
};

// Back to contracts list
window.backToContractsList = function () {
  selectedContractId = null;
  contractViewMode = 'list';
  renderPMTool();
};

// Save edited clause text for a specific contract
window.saveContractClauseText = async function (selectedClauseId, field, value) {
  if (!selectedClauseId) return;

  try {
    const updateData = {};
    if (field === 'title') {
      updateData.custom_title = value;
    } else if (field === 'body') {
      updateData.custom_body = value;
    }

    const { error } = await supabase
      .from('contract_selected_clauses')
      .update(updateData)
      .eq('id', selectedClauseId);

    if (error) {
      console.error('Error saving clause text:', error);
      showNotification('Failed to save changes', 'error');
    } else {
      showNotification('Changes saved', 'success');
    }
  } catch (err) {
    console.error('Error saving clause text:', err);
    showNotification('Failed to save changes', 'error');
  }
};

// Save edited line item text for a specific contract
window.saveContractLineItemText = async function (lineItemId, field, value) {
  if (!lineItemId) return;

  try {
    const updateData = {};
    updateData[field] = value;

    const { error } = await supabase
      .from('contract_line_items')
      .update(updateData)
      .eq('id', lineItemId);

    if (error) {
      console.error('Error saving line item text:', error);
      showNotification('Failed to save changes', 'error');
    } else {
      showNotification('Changes saved', 'success');
    }
  } catch (err) {
    console.error('Error saving line item text:', err);
    showNotification('Failed to save changes', 'error');
  }
};

// Handle blur on editable fields - auto-save
window.handleContractTextEdit = function (element, type, id, field) {
  const value = element.innerText.trim();
  if (type === 'clause') {
    saveContractClauseText(id, field, value);
  } else if (type === 'lineitem') {
    saveContractLineItemText(id, field, value);
  }
};

// Show void confirmation modal
window.showVoidConfirm = function (contractId) {
  if (!contractId) return;

  voidContractId = contractId;

  // Remove any existing modal
  const existingModal = document.getElementById('void-contract-modal');
  if (existingModal) {
    existingModal.remove();
  }

  const contract = contractsList.find(c => c.id === contractId);
  const contractName = contract ? contract.name || 'Untitled Contract' : 'this contract';

  const modal = document.createElement('div');
  modal.id = 'void-contract-modal';
  modal.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10001;
    animation: fadeIn 0.2s ease-out;
  `;

  modal.innerHTML = `
    <div style="
      background: white;
      border-radius: 1rem;
      padding: 0;
      max-width: 400px;
      width: 90%;
      box-shadow: 0 25px 50px rgba(0,0,0,0.25);
      animation: scaleIn 0.2s ease-out;
      overflow: hidden;
    ">
      <!-- Header -->
      <div style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1.25rem 1.5rem;
        border-bottom: 1px solid #E5E7EB;
      ">
        <div style="display: flex; align-items: center; gap: 0.75rem;">
          <span class="material-icons" style="color: #F59E0B; font-size: 24px;">warning</span>
          <h3 style="margin: 0; font-size: 1.125rem; font-weight: 600; color: #111827;">Void Contract</h3>
        </div>
        <button 
          onclick="closeVoidConfirm()"
          style="
            background: transparent;
            border: none;
            cursor: pointer;
            padding: 0.25rem;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 0.375rem;
            color: #6B7280;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#F3F4F6'; this.style.color='#111827';"
          onmouseout="this.style.background='transparent'; this.style.color='#6B7280';"
        >
          <span class="material-icons" style="font-size: 20px;">close</span>
        </button>
      </div>
      
      <!-- Body -->
      <div style="padding: 1.5rem;">
        <p style="margin: 0; color: #4B5563; font-size: 0.9375rem; line-height: 1.5;">
          Are you sure you want to void <strong>${contractName}</strong>? This action cannot be undone and the contract will be marked as voided.
        </p>
      </div>
      
      <!-- Footer -->
      <div style="
        display: flex;
        gap: 0.75rem;
        padding: 1rem 1.5rem;
        background: #F9FAFB;
        border-top: 1px solid #E5E7EB;
        justify-content: flex-end;
      ">
        <button 
          onclick="closeVoidConfirm()"
          style="
            padding: 0.75rem 1.5rem;
            background: white;
            border: 1px solid #D1D5DB;
            border-radius: 0.5rem;
            color: #374151;
            font-size: 0.9375rem;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#F9FAFB'; this.style.borderColor='#9CA3AF';"
          onmouseout="this.style.background='white'; this.style.borderColor='#D1D5DB';"
        >
          Cancel
        </button>
        <button 
          onclick="confirmVoidContract('${contractId}')"
          style="
            padding: 0.75rem 1.5rem;
            background: #F59E0B;
            border: none;
            border-radius: 0.5rem;
            color: white;
            font-size: 0.9375rem;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#D97706';"
          onmouseout="this.style.background='#F59E0B';"
        >
          Void Contract
        </button>
      </div>
    </div>
  `;

  // Add fadeIn and scaleIn animations if they don't exist
  if (!document.getElementById('void-contract-modal-styles')) {
    const style = document.createElement('style');
    style.id = 'void-contract-modal-styles';
    style.textContent = `
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      @keyframes scaleIn {
        from { transform: scale(0.95); opacity: 0; }
        to { transform: scale(1); opacity: 1; }
      }
    `;
    document.head.appendChild(style);
  }

  // Close on backdrop click
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      closeVoidConfirm();
    }
  });

  document.body.appendChild(modal);
};

// Close void confirmation modal
window.closeVoidConfirm = function () {
  const modal = document.getElementById('void-contract-modal');
  if (modal) {
    modal.style.opacity = '0';
    setTimeout(() => {
      modal.remove();
      voidContractId = null;
      showVoidConfirmModal = false;
    }, 200);
  } else {
    showVoidConfirmModal = false;
    voidContractId = null;
    renderPMTool();
  }
};

// Confirm void contract
window.confirmVoidContract = async function (contractId) {
  if (!contractId) contractId = voidContractId;
  if (!contractId) return;

  const voidBtn = document.querySelector('#void-contract-modal button[onclick*="confirmVoidContract"]');
  if (voidBtn) {
    voidBtn.disabled = true;
    voidBtn.innerHTML = '<span class="material-icons" style="font-size: 18px; animation: spin 1s linear infinite; display: inline-block;">refresh</span> Voiding...';
  }

  try {
    const { error } = await supabase
      .from('contracts')
      .update({ status: 'voided' })
      .eq('id', contractId);

    if (error) throw error;

    await supabase.from('contract_activity_log').insert({
      contract_id: contractId,
      action: 'voided',
      actor_id: currentProfile?.id,
      actor_name: `${currentProfile?.first_name || ''} ${currentProfile?.last_name || ''}`.trim()
    });

    closeVoidConfirm();
    showNotification('Contract voided successfully', 'success');

    await loadContracts();
    renderPMTool();
  } catch (error) {
    console.error('Error voiding contract:', error);
    closeVoidConfirm();
    showNotification('Failed to void contract', 'error');
  }
};

// Void contract (called after confirmation) - kept for backward compatibility
window.voidContract = async function (contractId) {
  confirmVoidContract(contractId);
};

// Show delete confirmation modal
window.showDeleteConfirm = function (contractId) {
  if (!contractId) return;

  deleteContractId = contractId;
  deleteConfirmText = '';

  // Remove any existing modal
  const existingModal = document.getElementById('delete-contract-modal');
  if (existingModal) {
    existingModal.remove();
  }

  const contract = contractsList.find(c => c.id === contractId);
  const contractName = contract ? contract.name || 'Untitled Contract' : 'this contract';

  const modal = document.createElement('div');
  modal.id = 'delete-contract-modal';
  modal.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10001;
    animation: fadeIn 0.2s ease-out;
  `;

  modal.innerHTML = `
    <div style="
      background: white;
      border-radius: 1rem;
      padding: 0;
      max-width: 480px;
      width: 90%;
      box-shadow: 0 25px 50px rgba(0,0,0,0.25);
      animation: scaleIn 0.2s ease-out;
      overflow: hidden;
    ">
      <!-- Header -->
      <div style="
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1.25rem 1.5rem;
        border-bottom: 1px solid #E5E7EB;
      ">
        <div style="display: flex; align-items: center; gap: 0.75rem;">
          <span class="material-icons" style="color: #EF4444; font-size: 24px;">warning</span>
          <h3 style="margin: 0; font-size: 1.125rem; font-weight: 600; color: #111827;">Delete Contract</h3>
        </div>
        <button 
          onclick="closeDeleteConfirm()"
          style="
            background: transparent;
            border: none;
            cursor: pointer;
            padding: 0.25rem;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 0.375rem;
            color: #6B7280;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#F3F4F6'; this.style.color='#111827';"
          onmouseout="this.style.background='transparent'; this.style.color='#6B7280';"
        >
          <span class="material-icons" style="font-size: 20px;">close</span>
        </button>
      </div>
      
      <!-- Body -->
      <div style="padding: 1.5rem;">
        <p style="margin: 0 0 1rem; color: #4B5563; font-size: 0.9375rem; line-height: 1.5;">
          Are you sure you want to permanently delete <strong>${contractName}</strong>? This action cannot be undone and all contract data will be permanently removed.
        </p>
        <div style="
          background: #FEF2F2;
          border: 1px solid #FECACA;
          border-radius: 0.5rem;
          padding: 0.75rem;
          margin-bottom: 1rem;
        ">
          <div style="display: flex; align-items: start; gap: 0.5rem;">
            <span class="material-icons" style="color: #DC2626; font-size: 18px; flex-shrink: 0;">info</span>
            <div style="font-size: 0.875rem; color: #991B1B;">
              <strong>Warning:</strong> Deleting a contract will permanently remove all associated data including line items, clauses, and activity logs. This cannot be reversed.
            </div>
          </div>
        </div>
        <div style="margin-bottom: 1rem;">
          <label style="display: block; font-weight: 500; margin-bottom: 0.5rem; color: #1E293B; font-size: 0.875rem;">
            Type <strong style="color: #DC2626;">DELETE</strong> to confirm:
          </label>
          <input 
            type="text" 
            id="delete-contract-confirm-input"
            value=""
            oninput="handleDeleteContractConfirmInput(this.value)"
            placeholder="Type DELETE here"
            style="
              width: 100%;
              padding: 0.75rem;
              border: 2px solid #E2E8F0;
              border-radius: 0.5rem;
              font-size: 1rem;
              font-weight: 600;
              color: #1E293B;
              box-sizing: border-box;
              transition: all 0.2s;
            "
          />
          <div id="delete-contract-confirm-message" style="margin-top: 0.5rem; font-size: 0.875rem; color: #6B7280;"></div>
        </div>
      </div>
      
      <!-- Footer -->
      <div style="
        display: flex;
        gap: 0.75rem;
        padding: 1rem 1.5rem;
        background: #F9FAFB;
        border-top: 1px solid #E5E7EB;
        justify-content: flex-end;
      ">
        <button 
          onclick="closeDeleteConfirm()"
          style="
            padding: 0.75rem 1.5rem;
            background: white;
            border: 1px solid #D1D5DB;
            border-radius: 0.5rem;
            color: #374151;
            font-size: 0.9375rem;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s;
          "
          onmouseover="this.style.background='#F9FAFB'; this.style.borderColor='#9CA3AF';"
          onmouseout="this.style.background='white'; this.style.borderColor='#D1D5DB';"
        >
          Cancel
        </button>
        <button 
          id="delete-contract-confirm-button"
          onclick="confirmDeleteContract()"
          style="
            padding: 0.75rem 1.5rem;
            background: #E5E7EB;
            border: none;
            border-radius: 0.5rem;
            color: #9CA3AF;
            font-size: 0.9375rem;
            font-weight: 500;
            cursor: not-allowed;
            transition: all 0.2s;
            opacity: 0.6;
          "
          disabled
        >
          Delete Contract
        </button>
      </div>
    </div>
  `;

  // Add fadeIn and scaleIn animations if they don't exist
  if (!document.getElementById('delete-contract-modal-styles')) {
    const style = document.createElement('style');
    style.id = 'delete-contract-modal-styles';
    style.textContent = `
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      @keyframes scaleIn {
        from { transform: scale(0.95); opacity: 0; }
        to { transform: scale(1); opacity: 1; }
      }
    `;
    document.head.appendChild(style);
  }

  // Close on backdrop click
  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      closeDeleteConfirm();
    }
  });

  document.body.appendChild(modal);

  // Focus the input
  setTimeout(() => {
    const input = document.getElementById('delete-contract-confirm-input');
    if (input) input.focus();
  }, 100);
};

// Handle delete contract confirmation input
window.handleDeleteContractConfirmInput = function (value) {
  deleteConfirmText = value.toUpperCase();

  const input = document.getElementById('delete-contract-confirm-input');
  const confirmMsg = document.getElementById('delete-contract-confirm-message');
  const deleteBtn = document.getElementById('delete-contract-confirm-button');

  const isConfirmed = deleteConfirmText === 'DELETE';

  if (input) {
    input.style.borderColor = isConfirmed ? '#10B981' : '#E2E8F0';
    input.style.color = isConfirmed ? '#10B981' : '#1E293B';
  }

  if (confirmMsg) {
    if (isConfirmed) {
      confirmMsg.innerHTML = `
        <div style="display: flex; align-items: center; gap: 0.5rem; color: #10B981; font-size: 0.875rem;">
          <span class="material-icons" style="font-size: 18px;">check_circle</span>
          <span>Confirmed. You can now delete the contract.</span>
        </div>
      `;
    } else {
      confirmMsg.innerHTML = '';
    }
  }

  if (deleteBtn) {
    deleteBtn.disabled = !isConfirmed;
    deleteBtn.style.background = isConfirmed ? '#EF4444' : '#E5E7EB';
    deleteBtn.style.color = isConfirmed ? 'white' : '#9CA3AF';
    deleteBtn.style.cursor = isConfirmed ? 'pointer' : 'not-allowed';
    deleteBtn.style.opacity = isConfirmed ? '1' : '0.6';
  }
};

// Close delete confirmation modal
window.closeDeleteConfirm = function () {
  const modal = document.getElementById('delete-contract-modal');
  if (modal) {
    modal.style.opacity = '0';
    setTimeout(() => {
      modal.remove();
      deleteContractId = null;
      deleteConfirmText = '';
      showDeleteConfirmModal = false;
    }, 200);
  } else {
    showDeleteConfirmModal = false;
    deleteContractId = null;
    deleteConfirmText = '';
    renderPMTool();
  }
};

// Handle delete confirmation text input
window.handleDeleteConfirmInput = function (value) {
  deleteConfirmText = value.toUpperCase();

  // Update the input value directly
  const input = document.getElementById('delete-confirm-input');
  if (input && input.value !== deleteConfirmText) {
    input.value = deleteConfirmText;
  }

  // Update visual state without full re-render
  const isConfirmed = deleteConfirmText === 'DELETE';

  // Update input border color
  if (input) {
    input.style.borderColor = isConfirmed ? '#10b981' : '#e2e8f0';
    input.style.color = isConfirmed ? '#10b981' : '#1e293b';
  }

  // Update confirmation message
  const confirmMsg = document.getElementById('delete-confirm-message');
  if (confirmMsg) {
    if (isConfirmed) {
      confirmMsg.innerHTML = `
        <div style="display: flex; align-items: center; gap: 0.5rem; margin-top: 0.5rem; color: #10b981; font-size: 0.875rem;">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
          Confirmation text matches
        </div>
      `;
    } else if (deleteConfirmText.length > 0) {
      confirmMsg.innerHTML = `
        <div style="margin-top: 0.5rem; color: #dc2626; font-size: 0.875rem;">
          Text does not match. Please type "DELETE" exactly.
        </div>
      `;
    } else {
      confirmMsg.innerHTML = '';
    }
  }

  // Update delete button state
  const deleteBtn = document.getElementById('delete-confirm-button');
  if (deleteBtn) {
    deleteBtn.disabled = !isConfirmed;
    deleteBtn.style.background = isConfirmed ? 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)' : '#e5e7eb';
    deleteBtn.style.color = isConfirmed ? 'white' : '#9ca3af';
    deleteBtn.style.cursor = isConfirmed ? 'pointer' : 'not-allowed';
    deleteBtn.style.opacity = isConfirmed ? '1' : '0.6';
  }
};

// Confirm delete contract
window.confirmDeleteContract = async function () {
  if (!deleteContractId) return;

  const input = document.getElementById('delete-contract-confirm-input');
  const confirmText = input ? input.value.trim().toUpperCase() : deleteConfirmText;

  if (confirmText !== 'DELETE') {
    showNotification('Please type DELETE to confirm', 'error');
    return;
  }

  const deleteBtn = document.getElementById('delete-contract-confirm-button');
  if (deleteBtn) {
    deleteBtn.disabled = true;
    deleteBtn.innerHTML = '<span class="material-icons" style="font-size: 18px; animation: spin 1s linear infinite; display: inline-block;">refresh</span> Deleting...';
  }

  try {
    // Delete related records first (due to foreign key constraints)
    await supabase
      .from('contract_activity_log')
      .delete()
      .eq('contract_id', deleteContractId);

    await supabase
      .from('contract_selected_clauses')
      .delete()
      .eq('contract_id', deleteContractId);

    await supabase
      .from('contract_line_items')
      .delete()
      .eq('contract_id', deleteContractId);

    // Delete the contract
    const { error } = await supabase
      .from('contracts')
      .delete()
      .eq('id', deleteContractId);

    if (error) throw error;

    const deletedContractId = deleteContractId;

    closeDeleteConfirm();
    showNotification('Contract deleted successfully', 'success');

    // If viewing the deleted contract, go back to list
    if (contractViewMode === 'detail' && selectedContractId === deletedContractId) {
      contractViewMode = 'list';
      selectedContractId = null;
    }

    await loadContracts();
    renderPMTool();
  } catch (error) {
    console.error('Error deleting contract:', error);
    closeDeleteConfirm();
    showNotification('Failed to delete contract: ' + (error.message || error), 'error');
  }
};

// Delete contract (called after confirmation) - kept for backward compatibility
window.deleteContract = async function () {
  confirmDeleteContract();
};

// Mark contract closed
window.markContractClosed = async function (contractId) {
  try {
    const { error } = await supabase
      .from('contracts')
      .update({ status: 'closed', closed_at: new Date().toISOString() })
      .eq('id', contractId);

    if (error) throw error;

    await supabase.from('contract_activity_log').insert({
      contract_id: contractId,
      action: 'closed',
      actor_id: currentProfile?.id,
      actor_name: `${currentProfile?.first_name || ''} ${currentProfile?.last_name || ''}`.trim()
    });

    showNotification('Contract marked as closed', 'success');
    await loadContracts();
    renderPMTool();
  } catch (error) {
    console.error('Error closing contract:', error);
    showNotification('Failed to close contract', 'error');
  }
};

// Create contract and get link (for drafts - generates token but keeps status as draft)
window.createContractAndGetLink = async function (contractId) {
  try {
    const contract = contractsList.find(c => c.id === contractId);
    if (!contract) {
      showNotification('Contract not found', 'error');
      return;
    }

    // Generate signing token (always generate new one or use existing)
    let signingToken = contract.signing_token;

    if (!signingToken) {
      // Generate signing token
      const tokenBytes = new Uint8Array(32);
      crypto.getRandomValues(tokenBytes);
      signingToken = Array.from(tokenBytes).map(b => b.toString(16).padStart(2, '0')).join('');
    }

    const { error } = await supabase
      .from('contracts')
      .update({
        status: 'sent',
        signing_token: signingToken,
        sent_at: new Date().toISOString(),
        expiry_date: new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toISOString() // 14 days
      })
      .eq('id', contractId);

    if (error) throw error;

    // Log activity
    await supabase.from('contract_activity_log').insert({
      contract_id: contractId,
      action: 'sent',
      actor_id: currentProfile?.id,
      actor_name: `${currentProfile?.first_name || ''} ${currentProfile?.last_name || ''}`.trim()
    }).catch(() => {
      // Activity log is optional, don't fail if it errors
    });

    // Generate signing link
    const signingLink = `${window.location.origin}/sign/${signingToken}`;

    // Copy to clipboard
    navigator.clipboard.writeText(signingLink).then(() => {
      showNotification('Contract sent! Signing link copied to clipboard.', 'success');

      // Navigate back to contracts list
      setTimeout(() => {
        currentScreen = 'contracts';
        renderPMTool();
      }, 500);
    }).catch(() => {
      // If clipboard fails, still show success and navigate
      showNotification('Signing link created: ' + signingLink, 'success');
      setTimeout(() => {
        currentScreen = 'contracts';
        renderPMTool();
      }, 500);
    });

    // Reload contracts
    await loadContracts();
  } catch (error) {
    console.error('Error creating contract link:', error);
    showNotification('Failed to create signing link: ' + (error.message || error), 'error');
  }
};

// Send draft contract (convert to sent and generate signing link)
window.sendDraftContract = async function (contractId) {
  try {
    // Generate signing token
    const tokenBytes = new Uint8Array(32);
    crypto.getRandomValues(tokenBytes);
    const signingToken = Array.from(tokenBytes).map(b => b.toString(16).padStart(2, '0')).join('');

    const { error } = await supabase
      .from('contracts')
      .update({
        status: 'sent',
        signing_token: signingToken,
        sent_at: new Date().toISOString(),
        expiry_date: new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toISOString() // 14 days
      })
      .eq('id', contractId);

    if (error) throw error;

    // Log activity
    await supabase.from('contract_activity_log').insert({
      contract_id: contractId,
      action: 'sent',
      actor_id: currentProfile?.id,
      actor_name: `${currentProfile?.first_name || ''} ${currentProfile?.last_name || ''}`.trim()
    });

    showNotification('Contract sent successfully!', 'success');

    // Reload contracts and refresh view
    await loadContracts();
    renderPMTool();

    // Show the signing link in a modal or copy to clipboard
    const signingLink = `${window.location.origin}/sign/${signingToken}`;
    navigator.clipboard.writeText(signingLink).then(() => {
      showNotification('Contract sent! Signing link copied to clipboard', 'success');
    }).catch(() => {
      // If clipboard fails, still show success
      showNotification('Contract sent! Signing link: ' + signingLink, 'success');
    });
  } catch (error) {
    console.error('Error sending contract:', error);
    showNotification('Failed to send contract: ' + (error.message || error), 'error');
  }
};

// Download contract as PDF
window.downloadContractPdf = async function (contractId) {
  const contract = contractsList.find(c => c.id === contractId);
  if (!contract) {
    showNotification('Contract not found', 'error');
    return;
  }

  if (contract.status !== 'signed' && contract.status !== 'closed') {
    showNotification('Only signed or closed contracts can be downloaded as PDF', 'error');
    return;
  }

  showNotification('Generating PDF...', 'info');

  try {
    // Load line items and clauses
    const { data: lineItems } = await supabase
      .from('contract_line_items')
      .select('*')
      .eq('contract_id', contractId)
      .order('sort_order');

    const { data: clauseLinks } = await supabase
      .from('contract_selected_clauses')
      .select('clause_id')
      .eq('contract_id', contractId);

    let selectedClauseData = [];
    if (clauseLinks && clauseLinks.length > 0) {
      const clauseIds = clauseLinks.map(cl => cl.clause_id);
      selectedClauseData = contractClauses.filter(c => clauseIds.includes(c.id));
    }

    // Replace [Company] and [Client] placeholders
    const clientCompanyName = contract.client_company_name || contract.client_name || 'Client';
    const clientFullName = contract.client_name || 'Client';
    const processedClauses = selectedClauseData.map(clause => {
      let processedBody = clause.body.replace(/\[company\]/gi, clientCompanyName);
      processedBody = processedBody.replace(/\[client\]/gi, clientFullName);
      return {
        ...clause,
        body: processedBody
      };
    });

    // Create printable HTML
    const printContent = `
      <!DOCTYPE html>
      <html>
      <head>
        <title>${contract.name || 'Contract'} - ${contract.contract_number || ''}</title>
        <style>
          * { margin: 0; padding: 0; box-sizing: border-box; }
          body { 
            font-family: 'Segoe UI', Arial, sans-serif; 
            font-size: 11pt; 
            line-height: 1.5; 
            color: #1e293b;
            padding: 0.5in;
          }
          .header { 
            text-align: center; 
            padding-bottom: 1rem; 
            margin-bottom: 1.5rem; 
            border-bottom: 2px solid #1e293b;
          }
          .header h1 { font-size: 18pt; margin-bottom: 0.25rem; }
          .header .contract-number { color: #64748b; font-size: 10pt; }
          .info-grid { 
            display: grid; 
            grid-template-columns: 1fr 1fr; 
            gap: 1rem; 
            margin-bottom: 1.5rem;
            padding: 1rem;
            background: #f8fafc;
            border-radius: 0.5rem;
          }
          .info-item label { 
            display: block; 
            font-size: 9pt; 
            color: #64748b; 
            text-transform: uppercase; 
            letter-spacing: 0.05em;
            margin-bottom: 0.25rem;
          }
          .section-title { 
            font-size: 12pt; 
            font-weight: 600; 
            margin: 1.5rem 0 0.75rem; 
            padding-bottom: 0.25rem;
            border-bottom: 2px solid #3b82f6;
            display: inline-block;
          }
          table { width: 100%; border-collapse: collapse; margin-bottom: 1rem; }
          th { 
            background: #f8fafc; 
            padding: 0.5rem; 
            text-align: left; 
            font-size: 9pt;
            text-transform: uppercase;
            color: #64748b;
            border-bottom: 1px solid #e2e8f0;
          }
          td { padding: 0.5rem; border-bottom: 1px solid #e2e8f0; }
          .amount { text-align: right; }
          .totals { 
            max-width: 250px; 
            margin-left: auto; 
            background: #f8fafc; 
            padding: 1rem; 
            border-radius: 0.5rem;
          }
          .totals-row { display: flex; justify-content: space-between; margin-bottom: 0.25rem; }
          .totals-row.grand { font-weight: 700; font-size: 14pt; border-top: 2px solid #1e293b; padding-top: 0.5rem; margin-top: 0.5rem; }
          .clause { 
            margin-bottom: 1rem; 
            padding: 0.75rem; 
            background: #f8fafc; 
            border-radius: 0.5rem;
            border-left: 3px solid #3b82f6;
          }
          .clause-title { font-weight: 600; margin-bottom: 0.5rem; }
          .clause-body { font-size: 10pt; color: #475569; white-space: pre-wrap; }
          .signature-section { 
            display: grid; 
            grid-template-columns: 1fr 1fr; 
            gap: 2rem; 
            margin-top: 2rem;
            page-break-inside: avoid;
          }
          .signature-block { padding: 1rem; border: 1px solid #e2e8f0; border-radius: 0.5rem; }
          .signature-block h4 { 
            font-size: 10pt; 
            text-transform: uppercase; 
            letter-spacing: 0.05em; 
            margin-bottom: 1rem;
            color: #1e293b;
          }
          .sig-row { margin-bottom: 0.75rem; }
          .sig-label { font-size: 9pt; color: #64748b; margin-bottom: 0.25rem; }
          .sig-value { font-weight: 500; }
          .sig-signature { 
            font-family: 'Brush Script MT', 'Segoe Script', cursive; 
            font-size: 20pt; 
            border-bottom: 2px solid #1e293b;
            padding-bottom: 0.25rem;
            min-height: 30px;
          }
          .signed-badge {
            display: inline-block;
            background: #dcfce7;
            color: #166534;
            padding: 0.25rem 0.5rem;
            border-radius: 0.25rem;
            font-size: 9pt;
            font-weight: 600;
          }
          .footer { 
            margin-top: 2rem; 
            padding-top: 1rem; 
            border-top: 1px solid #e2e8f0; 
            text-align: center; 
            font-size: 9pt; 
            color: #94a3b8;
          }
          @media print {
            body { padding: 0; }
            .no-print { display: none; }
          }
        </style>
      </head>
      <body>
        <div class="header">
          <h1>${contract.name || 'Service Agreement'}</h1>
          <div class="contract-number">${contract.contract_number || ''}</div>
          <div class="signed-badge">✓ SIGNED</div>
        </div>
        
        <div class="info-grid">
          <div class="info-item">
            <label>Prepared For</label>
            <div><strong>${contract.client_name || ''}</strong></div>
            <div>${contract.client_email || ''}</div>
            ${contract.client_company_name ? `<div>${contract.client_company_name}</div>` : ''}
          </div>
          <div class="info-item">
            <label>Prepared By</label>
            <div><strong>${contract.rep_name || 'Company Representative'}</strong></div>
            <div>${contract.rep_company_name || currentCompany?.name || ''}</div>
          </div>
          <div class="info-item">
            <label>Effective Date</label>
            <div>${contract.effective_date ? formatDateLocal(contract.effective_date) : 'Upon signature'}</div>
          </div>
          <div class="info-item">
            <label>Signed Date</label>
            <div>${formatDateLocal(contract.signed_at)}</div>
          </div>
        </div>
        
        ${(lineItems && lineItems.length > 0) ? `
          <h3 class="section-title">Services & Products</h3>
          <table>
            <thead>
              <tr>
                <th>Item</th>
                <th>Qty</th>
                <th class="amount">Price</th>
                <th class="amount">Total</th>
              </tr>
            </thead>
            <tbody>
              ${lineItems.map(item => `
                <tr>
                  <td>
                    <strong>${item.name}</strong>
                    ${item.description ? `<div style="font-size: 9pt; color: #64748b;">${item.description}</div>` : ''}
                    ${item.is_recurring ? `<span style="background: #dbeafe; color: #2563eb; padding: 0.125rem 0.5rem; border-radius: 0.25rem; font-size: 8pt;">${item.recurring_interval || 'monthly'}</span>` : ''}
                  </td>
                  <td>${item.quantity}</td>
                  <td class="amount">$${parseFloat(item.unit_price || 0).toFixed(2)}</td>
                  <td class="amount"><strong>$${parseFloat(item.total || 0).toFixed(2)}</strong></td>
                </tr>
              `).join('')}
            </tbody>
          </table>
          
          <!-- Items Initial -->
          <div style="margin-top: 1rem; margin-bottom: 1.5rem; padding: 0.75rem; background: #f0fdf4; border-radius: 0.5rem; border-left: 4px solid #22c55e; display: flex; align-items: center; gap: 1rem;">
            <span style="font-weight: 700; font-size: 12pt; min-width: 40px; text-align: center; border: 2px solid #16a34a; border-radius: 0.25rem; padding: 0.25rem;">${contract.metadata?.initials?.items || (contract.signer_name ? contract.signer_name.split(' ').map(n => n[0]).join('').toUpperCase() : '---')}</span>
            <span style="font-size: 9pt; color: #166534;">Items/services acknowledged</span>
          </div>
        ` : ''}
        
        <div class="totals">
          <div class="totals-row">
            <span>Subtotal</span>
            <span>$${parseFloat(contract.subtotal || 0).toFixed(2)}</span>
          </div>
          ${contract.discount_amount > 0 ? `
            <div class="totals-row" style="color: #10b981;">
              <span>Discount</span>
              <span>-$${parseFloat(contract.discount_amount || 0).toFixed(2)}</span>
            </div>
          ` : ''}
          ${contract.tax_amount > 0 ? `
            <div class="totals-row">
              <span>Tax (${contract.tax_rate}%)</span>
              <span>$${parseFloat(contract.tax_amount || 0).toFixed(2)}</span>
            </div>
          ` : ''}
          <div class="totals-row grand">
            <span>Total</span>
            <span>$${parseFloat(contract.total || 0).toFixed(2)}</span>
          </div>
          ${contract.monthly_recurring > 0 ? `
            <div class="totals-row" style="color: #64748b; font-size: 10pt; margin-top: 0.5rem;">
              <span>+ Monthly</span>
              <span>$${parseFloat(contract.monthly_recurring || 0).toFixed(2)}/mo</span>
            </div>
          ` : ''}
        </div>
        
        <!-- Pricing Initial -->
        <div style="margin-top: 1rem; padding: 0.75rem; background: #fef3c7; border-radius: 0.5rem; border-left: 4px solid #f59e0b; display: flex; align-items: center; gap: 1rem; max-width: 400px; margin-left: auto;">
          <span style="font-weight: 700; font-size: 12pt; min-width: 40px; text-align: center; border: 2px solid #d97706; border-radius: 0.25rem; padding: 0.25rem;">${contract.metadata?.initials?.pricing || contract.signer_initials || (contract.signer_name ? contract.signer_name.split(' ').map(n => n[0]).join('').toUpperCase() : '---')}</span>
          <span style="font-size: 9pt; color: #78350f;">Pricing acknowledged</span>
        </div>
        
        ${processedClauses.length > 0 ? `
          <h3 class="section-title">Terms & Conditions</h3>
          ${processedClauses.map(clause => `
            <div class="clause">
              <div class="clause-title">${clause.title}</div>
              <div class="clause-body">${clause.body}</div>
            </div>
          `).join('')}
          
          <!-- Terms Initial -->
          <div style="margin-top: 1rem; padding: 0.75rem; background: #dbeafe; border-radius: 0.5rem; border-left: 4px solid #3b82f6; display: flex; align-items: center; gap: 1rem;">
            <span style="font-weight: 700; font-size: 12pt; min-width: 40px; text-align: center; border: 2px solid #2563eb; border-radius: 0.25rem; padding: 0.25rem;">${contract.metadata?.initials?.terms || contract.signer_initials || (contract.signer_name ? contract.signer_name.split(' ').map(n => n[0]).join('').toUpperCase() : '---')}</span>
            <span style="font-size: 9pt; color: #1e40af;">Terms & Conditions acknowledged</span>
          </div>
        ` : ''}
        
        ${contract.custom_notes ? `
          <div class="clause" style="border-left-color: #f59e0b; background: #fef3c7;">
            <div class="clause-title" style="color: #92400e;">Additional Notes</div>
            <div class="clause-body" style="color: #78350f;">${contract.custom_notes}</div>
          </div>
        ` : ''}
        
        <div class="signature-section">
          <div class="signature-block" style="background: #f1f5f9;">
            <h4>${contract.rep_company_name || currentCompany?.name || 'Company'}</h4>
            <div class="sig-row">
              <div class="sig-label">Printed Name</div>
              <div class="sig-value">${contract.rep_name || 'Company Representative'}</div>
            </div>
            <div class="sig-row">
              <div class="sig-label">Title</div>
              <div class="sig-value">${contract.rep_title || 'Representative'}</div>
            </div>
            <div class="sig-row">
              <div class="sig-label">Signature</div>
              <div class="sig-signature">${contract.rep_signature || contract.rep_name || ''}</div>
            </div>
            <div class="sig-row">
              <div class="sig-label">Date</div>
              <div class="sig-value">${formatDateLocal(contract.rep_signed_at || contract.created_at)}</div>
            </div>
          </div>
          
          <div class="signature-block" style="background: #dcfce7;">
            <h4>${contract.client_company_name || contract.client_name || 'Client'}</h4>
            <div class="sig-row">
              <div class="sig-label">Printed Name</div>
              <div class="sig-value">${contract.signer_name || contract.client_name}</div>
            </div>
            <div class="sig-row">
              <div class="sig-label">Signature</div>
              <div class="sig-signature">${contract.signature_data || ''}</div>
            </div>
            <div class="sig-row">
              <div class="sig-label">Date</div>
              <div class="sig-value">${formatDateLocal(contract.signed_at)}</div>
            </div>
          </div>
        </div>
        
        <div class="footer">
          Document ID: ${contract.id}<br>
          Generated on ${formatDateLocal(new Date())}
        </div>
      </body>
      </html>
    `;

    // Open print window
    const printWindow = window.open('', '_blank');
    if (!printWindow) {
      showNotification('Please allow popups to download PDF', 'error');
      return;
    }

    printWindow.document.write(printContent);
    printWindow.document.close();

    // Wait for content to load then print
    printWindow.onload = function () {
      setTimeout(() => {
        printWindow.print();
      }, 250);
    };

    showNotification('PDF ready! Use "Save as PDF" in the print dialog', 'success');

  } catch (error) {
    console.error('Error generating PDF:', error);
    showNotification('Failed to generate PDF', 'error');
  }
};

// Render Contracts Screen
async function renderContractsScreen() {
  // Load data if not loaded
  if (contractsList.length === 0) await loadContracts();
  if (contractProducts.length === 0) await loadContractProducts();
  if (productCategories.length === 0) await loadProductCategories();
  if (contractClauses.length === 0) await loadContractClauses();
  await loadGlobalTaxRate(); // Load saved tax rate from database
  await loadCompanyLogo(); // Load company logo

  // If viewing a contract detail, render the detail view
  if (contractViewMode === 'detail' && selectedContractId) {
    return await renderContractDetailView();
  }

  const statusColors = {
    draft: '#6b7280',
    sent: '#ef4444',
    viewed: '#f59e0b',
    signed: '#10b981',
    expired: '#ef4444',
    closed: '#f97316',
    voided: '#6b7280'
  };

  const statusLabels = {
    draft: 'Draft',
    sent: 'Sent',
    viewed: 'Viewed',
    signed: 'Signed',
    expired: 'Expired',
    closed: 'Closed',
    voided: 'Voided'
  };

  // Filter contracts
  let filteredContracts = contractsList;
  if (contractsFilter !== 'all') {
    filteredContracts = filteredContracts.filter(c => c.status === contractsFilter);
  }
  if (contractsSearchQuery) {
    const query = contractsSearchQuery.toLowerCase();
    filteredContracts = filteredContracts.filter(c =>
      (c.name || '').toLowerCase().includes(query) ||
      (c.client_name || '').toLowerCase().includes(query) ||
      (c.client_email || '').toLowerCase().includes(query)
    );
  }

  return `
    <div style="padding: 1.5rem; max-width: 1400px; margin: 0 auto;">
      <!-- Header -->
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1.5rem; flex-wrap: wrap; gap: 1rem;">
        <h1 style="margin: 0; font-size: 1.5rem; font-weight: 600; color: #1e293b;">
          Contracts
        </h1>
        <div style="display: flex; gap: 0.75rem; align-items: center;">
          ${(() => {
      const userRole = currentProfile?.company_role || currentProfile?.role || 'USER';
      const canCreate = userRole === 'OWNER' || userRole === 'MANAGER' || userRole === 'ADMIN' || currentProfile?.is_hh_admin;
      return canCreate ? `
              <button onclick="openNewContractModal()" style="
                background: linear-gradient(135deg, #ef4444 0%, #f97316 100%);
                color: white;
                border: none;
                padding: 0.75rem 1.5rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-weight: 500;
                display: flex;
                align-items: center;
                gap: 0.5rem;
              ">
                <span style="font-size: 1.25rem;">+</span> New Contract
              </button>
            ` : '';
    })()}
        </div>
      </div>
      
      <!-- Tabs -->
      <div style="display: flex; gap: 0.5rem; margin-bottom: 1.5rem; border-bottom: 1px solid #e2e8f0; padding-bottom: 0.5rem;">
        <button onclick="switchContractsTab('inbox')" style="
          background: ${contractsTab === 'inbox' ? '#ef4444' : 'transparent'};
          color: ${contractsTab === 'inbox' ? 'white' : '#64748b'};
          border: none;
          padding: 0.5rem 1rem;
          border-radius: 0.375rem;
          cursor: pointer;
          font-weight: 500;
        ">Inbox</button>
        ${(() => {
      const userRole = currentProfile?.company_role || currentProfile?.role || 'USER';
      const canManage = userRole === 'OWNER' || userRole === 'MANAGER' || userRole === 'ADMIN' || currentProfile?.is_hh_admin;
      return canManage ? `
            <button onclick="switchContractsTab('categories')" style="
              background: ${contractsTab === 'categories' ? '#ef4444' : 'transparent'};
              color: ${contractsTab === 'categories' ? 'white' : '#64748b'};
              border: none;
              padding: 0.5rem 1rem;
              border-radius: 0.375rem;
              cursor: pointer;
              font-weight: 500;
            ">Categories</button>
            <button onclick="switchContractsTab('clauses')" style="
              background: ${contractsTab === 'clauses' ? '#ef4444' : 'transparent'};
              color: ${contractsTab === 'clauses' ? 'white' : '#64748b'};
              border: none;
              padding: 0.5rem 1rem;
              border-radius: 0.375rem;
              cursor: pointer;
              font-weight: 500;
            ">Clauses</button>
            <button onclick="switchContractsTab('settings')" style="
              background: ${contractsTab === 'settings' ? '#ef4444' : 'transparent'};
              color: ${contractsTab === 'settings' ? 'white' : '#64748b'};
              border: none;
              padding: 0.5rem 1rem;
              border-radius: 0.375rem;
              cursor: pointer;
              font-weight: 500;
            ">Settings</button>
          ` : '';
    })()}
      </div>
      
      ${contractsTab === 'inbox' ? `
        <!-- Filters -->
        <div style="display: flex; gap: 1rem; margin-bottom: 1rem; flex-wrap: wrap; align-items: center;">
          <div style="display: flex; gap: 0.25rem; flex-wrap: wrap;">
            ${['all', 'draft', 'sent', 'viewed', 'signed', 'expired', 'closed'].map(status => `
              <button onclick="setContractsFilter('${status}')" style="
                background: ${contractsFilter === status ? (statusColors[status] || '#ef4444') : '#f1f5f9'};
                color: ${contractsFilter === status ? 'white' : '#64748b'};
                border: none;
                padding: 0.375rem 0.75rem;
                border-radius: 0.375rem;
                cursor: pointer;
                font-size: 0.75rem;
                font-weight: 500;
              ">${status === 'all' ? 'All' : statusLabels[status]}</button>
            `).join('')}
          </div>
          <input 
            type="text" 
            placeholder="Search contracts..." 
            value="${contractsSearchQuery}"
            oninput="updateContractsSearch(this.value)"
            style="
              padding: 0.5rem 1rem;
              border: 1px solid #e2e8f0;
              border-radius: 0.375rem;
              flex: 1;
              min-width: 200px;
            "
          />
        </div>
        
        <!-- Contracts List -->
        <div style="background: white; border-radius: 0.75rem; box-shadow: 0 1px 3px rgba(0,0,0,0.1); overflow: hidden;">
          ${filteredContracts.length === 0 ? `
            <div style="padding: 3rem; text-align: center; color: #64748b;">
              <div style="font-size: 3rem; margin-bottom: 1rem;">📄</div>
              <p>No contracts found</p>
              <button onclick="openNewContractModal()" style="
                background: #ef4444;
                color: white;
                border: none;
                padding: 0.5rem 1rem;
                border-radius: 0.375rem;
                cursor: pointer;
                margin-top: 1rem;
              ">Create your first contract</button>
            </div>
          ` : `
            <table style="width: 100%; border-collapse: collapse;">
              <thead>
                <tr style="background: #f8fafc; border-bottom: 1px solid #e2e8f0;">
                  <th style="padding: 0.75rem 1rem; text-align: left; font-weight: 600; font-size: 0.75rem; color: #64748b; text-transform: uppercase;">Contract</th>
                  <th style="padding: 0.75rem 1rem; text-align: left; font-weight: 600; font-size: 0.75rem; color: #64748b; text-transform: uppercase;">Client</th>
                  <th style="padding: 0.75rem 1rem; text-align: left; font-weight: 600; font-size: 0.75rem; color: #64748b; text-transform: uppercase;">Status</th>
                  <th style="padding: 0.75rem 1rem; text-align: right; font-weight: 600; font-size: 0.75rem; color: #64748b; text-transform: uppercase;">Total</th>
                  <th style="padding: 0.75rem 1rem; text-align: left; font-weight: 600; font-size: 0.75rem; color: #64748b; text-transform: uppercase;">Created</th>
                  <th style="padding: 0.75rem 1rem; text-align: center; font-weight: 600; font-size: 0.75rem; color: #64748b; text-transform: uppercase;">Actions</th>
                </tr>
              </thead>
              <tbody>
                ${filteredContracts.map(contract => `
                  <tr style="border-bottom: 1px solid #e2e8f0;" onmouseover="this.style.background='#f8fafc'" onmouseout="this.style.background='white'">
                    <td style="padding: 0.75rem 1rem;">
                      <div style="font-weight: 500; color: #1e293b;">${contract.name || 'Untitled'}</div>
                      <div style="font-size: 0.75rem; color: #64748b;">${contract.contract_number || ''}</div>
                    </td>
                    <td style="padding: 0.75rem 1rem;">
                      <div style="color: #1e293b;">${contract.client_name || ''}</div>
                      <div style="font-size: 0.75rem; color: #64748b;">${contract.client_email || ''}</div>
                    </td>
                    <td style="padding: 0.75rem 1rem;">
                      <span style="
                        background: ${statusColors[contract.status] || '#6b7280'}20;
                        color: ${statusColors[contract.status] || '#6b7280'};
                        padding: 0.25rem 0.5rem;
                        border-radius: 0.25rem;
                        font-size: 0.75rem;
                        font-weight: 500;
                      ">${statusLabels[contract.status] || contract.status}</span>
                    </td>
                    <td style="padding: 0.75rem 1rem; text-align: right;">
                      <div style="font-weight: 600; color: #1e293b;">$${(contract.total || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}</div>
                      ${contract.monthly_recurring > 0 ? `<div style="font-size: 0.75rem; color: #64748b;">+$${contract.monthly_recurring.toLocaleString('en-US', { minimumFractionDigits: 2 })}/mo</div>` : ''}
                    </td>
                    <td style="padding: 0.75rem 1rem; font-size: 0.875rem; color: #64748b;">
                      ${formatDateLocal(contract.created_at)}
                    </td>
                    <td style="padding: 0.75rem 1rem; text-align: center;">
                      <div style="display: flex; gap: 0.5rem; justify-content: center;">
                        ${(() => {
        const userRole = currentProfile?.company_role || currentProfile?.role || 'USER';
        const canManage = userRole === 'OWNER' || userRole === 'MANAGER' || userRole === 'ADMIN' || currentProfile?.is_hh_admin;
        return `
                            <button onclick="viewContractDetail('${contract.id}')" title="View" style="
                              background: #f1f5f9;
                              border: none;
                              padding: 0.375rem 0.5rem;
                              border-radius: 0.25rem;
                              cursor: pointer;
                              display: flex;
                              align-items: center;
                              justify-content: center;
                            ">${'<svg width="16" height="16" viewBox="0 0 24 24" fill="#475569"><path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"></path></svg>'}</button>
                            ${canManage ? `
                              ${contract.status === 'sent' || contract.status === 'viewed' ? `
                                <button onclick="copySigningLink('${contract.signing_token}')" title="Copy Link" style="
                                  background: #dbeafe;
                                  border: none;
                                  padding: 0.375rem 0.5rem;
                                  border-radius: 0.25rem;
                                  cursor: pointer;
                                  display: flex;
                                  align-items: center;
                                  justify-content: center;
                                ">${'<svg width="16" height="16" viewBox="0 0 24 24" fill="#2563eb"><path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"></path></svg>'}</button>
                              ` : ''}
                              ${contract.status === 'signed' || contract.status === 'closed' ? `
                                <button onclick="downloadContractPdf('${contract.id}')" title="Download PDF" style="
                                  background: #e0e7ff;
                                  border: none;
                                  padding: 0.375rem 0.5rem;
                                  border-radius: 0.25rem;
                                  cursor: pointer;
                                  display: flex;
                                  align-items: center;
                                  justify-content: center;
                                ">${'<svg width="16" height="16" viewBox="0 0 24 24" fill="#4f46e5"><path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"></path></svg>'}</button>
                              ` : ''}
                              ${contract.status === 'signed' ? `
                                <button onclick="markContractClosed('${contract.id}')" title="Close" style="
                                  background: #dcfce7;
                                  border: none;
                                  padding: 0.375rem 0.5rem;
                                  border-radius: 0.25rem;
                                  cursor: pointer;
                                  display: flex;
                                  align-items: center;
                                  justify-content: center;
                                ">${'<svg width="16" height="16" viewBox="0 0 24 24" fill="#16a34a"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path></svg>'}</button>
                              ` : ''}
                              ${contract.status === 'draft' || contract.status === 'sent' ? `
                                <button onclick="showVoidConfirm('${contract.id}')" title="Void" style="
                                  background: #fee2e2;
                                  border: none;
                                  padding: 0.375rem 0.5rem;
                                  border-radius: 0.25rem;
                                  cursor: pointer;
                                  display: flex;
                                  align-items: center;
                                  justify-content: center;
                                ">${'<svg width="16" height="16" viewBox="0 0 24 24" fill="#dc2626"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></svg>'}</button>
                              ` : ''}
                              <button onclick="showDeleteConfirm('${contract.id}')" title="Delete" style="
                                background: #f3f4f6;
                                border: none;
                                padding: 0.375rem 0.5rem;
                                border-radius: 0.25rem;
                                cursor: pointer;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                              ">${'<svg width="16" height="16" viewBox="0 0 24 24" fill="#6b7280"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"></path></svg>'}</button>
                            ` : ''}
                          `;
      })()}
                      </div>
                    </td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
          `}
        </div>
      ` : ''}
      
      ${contractsTab === 'categories' ? `
        <!-- Categories Tab -->
        ${selectedCategoryId ? (() => {
        const selectedCategory = productCategories.find(c => c.id === selectedCategoryId);
        const categoryProducts = contractProducts.filter(p => p.category_id === selectedCategoryId);
        return `
            <!-- Category Detail View with Products -->
            <div style="margin-bottom: 1rem;">
              <button onclick="backToCategories()" style="
                background: transparent;
                border: none;
                padding: 0.5rem;
                cursor: pointer;
                display: flex;
                align-items: center;
                gap: 0.5rem;
                color: #64748b;
                font-weight: 500;
              ">
                ${'<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"></path></svg>'}
                Back to Categories
              </button>
            </div>
            
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1.5rem;">
              <div>
                <h2 style="margin: 0; font-size: 1.5rem; font-weight: 700; color: #1e293b;">${selectedCategory?.name || 'Category'}</h2>
                ${selectedCategory?.description ? `<p style="margin: 0.25rem 0 0 0; color: #64748b; font-size: 0.875rem;">${selectedCategory.description}</p>` : ''}
              </div>
              <div style="display: flex; gap: 0.5rem;">
                <button onclick="openProductModal(null, '${selectedCategoryId}')" style="
                  background: #f97316;
                  color: white;
                  border: none;
                  padding: 0.5rem 1rem;
                  border-radius: 0.375rem;
                  cursor: pointer;
                  font-weight: 500;
                ">+ Add Product</button>
                <button onclick="openCategoryModal('${selectedCategoryId}')" style="
                  background: #f1f5f9;
                  color: #475569;
                  border: none;
                  padding: 0.5rem 1rem;
                  border-radius: 0.375rem;
                  cursor: pointer;
                  font-weight: 500;
                ">Edit Category</button>
              </div>
            </div>
            
            <!-- Products List -->
            ${categoryProducts.length === 0 ? `
              <div style="padding: 3rem; text-align: center; color: #64748b; background: white; border-radius: 0.75rem;">
                <div style="font-size: 3rem; margin-bottom: 1rem;">📦</div>
                <p>No products in this category yet</p>
                <button onclick="openProductModal(null, '${selectedCategoryId}')" style="
                  background: #f97316;
                  color: white;
                  border: none;
                  padding: 0.5rem 1rem;
                  border-radius: 0.375rem;
                  cursor: pointer;
                  margin-top: 1rem;
                ">Add first product</button>
              </div>
            ` : `
              <div style="background: white; border-radius: 0.75rem; overflow: hidden; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
                <table style="width: 100%; border-collapse: collapse;">
                  <thead>
                    <tr style="background: #f8fafc; border-bottom: 1px solid #e2e8f0;">
                      <th style="padding: 0.75rem 1rem; text-align: left; font-weight: 600; color: #64748b; font-size: 0.75rem; text-transform: uppercase;">Product</th>
                      <th style="padding: 0.75rem 1rem; text-align: left; font-weight: 600; color: #64748b; font-size: 0.75rem; text-transform: uppercase;">SKU</th>
                      <th style="padding: 0.75rem 1rem; text-align: right; font-weight: 600; color: #64748b; font-size: 0.75rem; text-transform: uppercase;">Price</th>
                      <th style="padding: 0.75rem 1rem; text-align: center; font-weight: 600; color: #64748b; font-size: 0.75rem; text-transform: uppercase;">Type</th>
                      <th style="padding: 0.75rem 1rem; text-align: right; font-weight: 600; color: #64748b; font-size: 0.75rem; text-transform: uppercase;">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${categoryProducts.map(product => `
                      <tr style="border-bottom: 1px solid #e2e8f0;">
                        <td style="padding: 0.75rem 1rem;">
                          <div style="font-weight: 500; color: #1e293b;">${product.name}</div>
                          ${product.description ? `<div style="font-size: 0.75rem; color: #64748b; margin-top: 0.25rem;">${product.description.substring(0, 60)}${product.description.length > 60 ? '...' : ''}</div>` : ''}
                        </td>
                        <td style="padding: 0.75rem 1rem; color: #64748b; font-size: 0.875rem;">${product.sku || '-'}</td>
                        <td style="padding: 0.75rem 1rem; text-align: right; font-weight: 600; color: #1e293b;">$${parseFloat(product.price || 0).toFixed(2)}</td>
                        <td style="padding: 0.75rem 1rem; text-align: center;">
                          ${product.is_recurring ? `<span style="background: #dbeafe; color: #2563eb; padding: 0.25rem 0.5rem; border-radius: 0.25rem; font-size: 0.75rem;">${product.recurring_interval}</span>` : `<span style="background: #f1f5f9; color: #64748b; padding: 0.25rem 0.5rem; border-radius: 0.25rem; font-size: 0.75rem;">One-time</span>`}
                        </td>
                        <td style="padding: 0.75rem 1rem; text-align: right;">
                          <div style="display: flex; gap: 0.25rem; justify-content: flex-end;">
                            <button onclick="openProductModal('${product.id}')" style="background: #f1f5f9; border: none; padding: 0.25rem 0.5rem; border-radius: 0.25rem; cursor: pointer;">${'<svg width="14" height="14" viewBox="0 0 24 24" fill="#475569"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"></path></svg>'}</button>
                            <button onclick="archiveProduct('${product.id}')" style="background: #fee2e2; border: none; padding: 0.25rem 0.5rem; border-radius: 0.25rem; cursor: pointer;">${'<svg width="14" height="14" viewBox="0 0 24 24" fill="#dc2626"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"></path></svg>'}</button>
                          </div>
                        </td>
                      </tr>
                    `).join('')}
                  </tbody>
                </table>
              </div>
            `}
          `;
      })() : `
          <!-- Categories List View -->
          <div style="display: flex; justify-content: flex-end; margin-bottom: 1rem; gap: 0.5rem;">
            <button onclick="openCategoryModal()" style="
              background: #ef4444;
              color: white;
              border: none;
              padding: 0.5rem 1rem;
              border-radius: 0.375rem;
              cursor: pointer;
              font-weight: 500;
            ">+ Add Category</button>
            <button onclick="openProductModal()" style="
              background: #f97316;
              color: white;
              border: none;
              padding: 0.5rem 1rem;
              border-radius: 0.375rem;
              cursor: pointer;
              font-weight: 500;
            ">+ Add Product</button>
          </div>
          
          ${productCategories.length === 0 && contractProducts.length === 0 ? `
            <div style="padding: 3rem; text-align: center; color: #64748b; background: white; border-radius: 0.75rem;">
              <div style="font-size: 3rem; margin-bottom: 1rem;">📁</div>
              <p>No categories yet</p>
              <p style="font-size: 0.875rem; margin-top: 0.5rem;">Create categories to organize your products (e.g., "Websites", "Video", "Marketing")</p>
              <button onclick="openCategoryModal()" style="
                background: #ef4444;
                color: white;
                border: none;
                padding: 0.5rem 1rem;
                border-radius: 0.375rem;
                cursor: pointer;
                margin-top: 1rem;
              ">Add your first category</button>
            </div>
          ` : `
            <div style="display: flex; flex-direction: column; gap: 1rem;">
              ${productCategories.map(category => {
        const categoryProductCount = contractProducts.filter(p => p.category_id === category.id).length;
        return `
                  <div style="background: white; border-radius: 0.75rem; overflow: hidden; box-shadow: 0 1px 3px rgba(0,0,0,0.1); cursor: pointer; transition: box-shadow 0.2s;" onclick="selectCategory('${category.id}')" onmouseover="this.style.boxShadow='0 4px 6px rgba(0,0,0,0.1)'" onmouseout="this.style.boxShadow='0 1px 3px rgba(0,0,0,0.1)'">
                    <div style="padding: 1rem; display: flex; justify-content: space-between; align-items: center;">
                      <div style="display: flex; align-items: center; gap: 1rem;">
                        <div style="width: 48px; height: 48px; background: #f1f5f9; border-radius: 0.5rem; display: flex; align-items: center; justify-content: center;">
                          ${'<svg width="24" height="24" viewBox="0 0 24 24" fill="#8b5cf6"><path d="M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"></path></svg>'}
                        </div>
                        <div>
                          <h3 style="margin: 0; font-size: 1rem; font-weight: 600; color: #1e293b;">${category.name}</h3>
                          <div style="font-size: 0.875rem; color: #64748b;">${categoryProductCount} product${categoryProductCount !== 1 ? 's' : ''}</div>
                        </div>
                      </div>
                      <div style="display: flex; align-items: center; gap: 0.5rem;">
                        <button onclick="event.stopPropagation(); openCategoryModal('${category.id}')" style="background: #f1f5f9; border: none; padding: 0.5rem; border-radius: 0.25rem; cursor: pointer;">${'<svg width="16" height="16" viewBox="0 0 24 24" fill="#475569"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"></path></svg>'}</button>
                        <button onclick="event.stopPropagation(); archiveCategory('${category.id}')" style="background: #fee2e2; border: none; padding: 0.5rem; border-radius: 0.25rem; cursor: pointer;">${'<svg width="16" height="16" viewBox="0 0 24 24" fill="#dc2626"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"></path></svg>'}</button>
                        ${'<svg width="20" height="20" viewBox="0 0 24 24" fill="#94a3b8"><path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path></svg>'}
                      </div>
                    </div>
                  </div>
                `;
      }).join('')}
              
              ${(() => {
        const uncategorizedProducts = contractProducts.filter(p => !p.category_id);
        if (uncategorizedProducts.length === 0) return '';
        return `
                  <div style="margin-top: 1rem;">
                    <h3 style="margin: 0 0 0.75rem 0; font-size: 0.875rem; font-weight: 600; color: #64748b; text-transform: uppercase;">Uncategorized Products</h3>
                    <div style="background: white; border-radius: 0.75rem; overflow: hidden; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
                      <table style="width: 100%; border-collapse: collapse;">
                        <thead>
                          <tr style="background: #f8fafc; border-bottom: 1px solid #e2e8f0;">
                            <th style="padding: 0.75rem 1rem; text-align: left; font-weight: 600; color: #64748b; font-size: 0.75rem;">Product</th>
                            <th style="padding: 0.75rem 1rem; text-align: right; font-weight: 600; color: #64748b; font-size: 0.75rem;">Price</th>
                            <th style="padding: 0.75rem 1rem; text-align: right; font-weight: 600; color: #64748b; font-size: 0.75rem;">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          ${uncategorizedProducts.map(product => `
                            <tr style="border-bottom: 1px solid #e2e8f0;">
                              <td style="padding: 0.75rem 1rem;">
                                <div style="font-weight: 500; color: #1e293b;">${product.name}</div>
                                ${product.sku ? `<div style="font-size: 0.75rem; color: #64748b;">SKU: ${product.sku}</div>` : ''}
                              </td>
                              <td style="padding: 0.75rem 1rem; text-align: right; font-weight: 600; color: #1e293b;">$${parseFloat(product.price || 0).toFixed(2)}</td>
                              <td style="padding: 0.75rem 1rem; text-align: right;">
                                <div style="display: flex; gap: 0.25rem; justify-content: flex-end;">
                                  <button onclick="openProductModal('${product.id}')" style="background: #f1f5f9; border: none; padding: 0.25rem 0.5rem; border-radius: 0.25rem; cursor: pointer;">${'<svg width="14" height="14" viewBox="0 0 24 24" fill="#475569"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"></path></svg>'}</button>
                                  <button onclick="archiveProduct('${product.id}')" style="background: #fee2e2; border: none; padding: 0.25rem 0.5rem; border-radius: 0.25rem; cursor: pointer;">${'<svg width="14" height="14" viewBox="0 0 24 24" fill="#dc2626"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"></path></svg>'}</button>
                                </div>
                              </td>
                            </tr>
                          `).join('')}
                        </tbody>
                      </table>
                    </div>
                  </div>
                `;
      })()}
            </div>
          `}
        `}
      ` : ''}
      
      ${contractsTab === 'settings' ? `
        <!-- Settings Tab -->
        <div style="display: flex; flex-direction: column; gap: 2rem;">
          <!-- Company Logo Section -->
          <div style="background: white; border-radius: 0.75rem; padding: 1.5rem; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
            <h3 style="margin: 0 0 1rem 0; font-size: 1.125rem; font-weight: 600; color: #1e293b;">Company Logo</h3>
            <p style="margin: 0 0 1.5rem 0; color: #64748b; font-size: 0.875rem;">
              Upload your company logo to display on contracts. Recommended size: 200x50px. Supported formats: PNG, JPEG.
            </p>
            <div style="display: flex; align-items: center; gap: 1.5rem; flex-wrap: wrap;">
              ${companyLogoUrl ? `
                <div style="display: flex; align-items: center; gap: 1rem;">
                  <img src="${companyLogoUrl}" alt="Company Logo" style="max-height: 60px; max-width: 200px; object-fit: contain; border: 1px solid #e2e8f0; border-radius: 0.5rem; padding: 0.5rem; background: #f8fafc;" />
                  <button onclick="removeCompanyLogo()" style="
                    background: #fee2e2;
                    color: #dc2626;
                    border: none;
                    padding: 0.5rem 1rem;
                    border-radius: 0.5rem;
                    cursor: pointer;
                    font-weight: 500;
                    font-size: 0.875rem;
                  ">Remove Logo</button>
                </div>
              ` : `
                <div style="border: 2px dashed #d1d5db; border-radius: 0.5rem; padding: 2rem; text-align: center; background: #f8fafc; min-width: 200px;">
                  <p style="margin: 0; color: #64748b; font-size: 0.875rem;">No logo uploaded</p>
                </div>
              `}
              <div>
                <input type="file" id="logo-upload-input" accept="image/png,image/jpeg,image/jpg" style="display: none;" onchange="handleLogoUpload(this)" />
                <button onclick="document.getElementById('logo-upload-input').click()" style="
                  background: #ef4444;
                  color: white;
                  border: none;
                  padding: 0.75rem 1.5rem;
                  border-radius: 0.5rem;
                  cursor: pointer;
                  font-weight: 500;
                  display: flex;
                  align-items: center;
                  gap: 0.5rem;
                ">
                  ${companyLogoUrl ? 'Change Logo' : 'Upload Logo'}
                </button>
              </div>
            </div>
          </div>
          
          <!-- Global Tax Rate Section -->
          <div style="background: white; border-radius: 0.75rem; padding: 1.5rem; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
            <h3 style="margin: 0 0 1rem 0; font-size: 1.125rem; font-weight: 600; color: #1e293b;">Global Tax Rate</h3>
            <p style="margin: 0 0 1.5rem 0; color: #64748b; font-size: 0.875rem;">
              Set the default tax rate for all contracts. This rate will be automatically applied to new contracts unless overridden.
            </p>
            <div style="display: flex; align-items: center; gap: 1rem; flex-wrap: wrap;">
              <div style="display: flex; align-items: center; gap: 0.5rem; background: #f8fafc; padding: 0.75rem 1rem; border-radius: 0.5rem; border: 1px solid #e2e8f0;">
                <input 
                  type="number" 
                  id="settings-tax-rate-input"
                  value="${globalTaxRate}" 
                  step="0.01"
                  min="0"
                  max="100"
                  style="
                    width: 100px;
                    padding: 0.5rem;
                    border: 1px solid #d1d5db;
                    border-radius: 0.375rem;
                    font-size: 1rem;
                    text-align: center;
                    font-weight: 600;
                  "
                />
                <span style="color: #64748b; font-weight: 500;">%</span>
              </div>
              <button onclick="saveSettingsTaxRate()" style="
                background: #ef4444;
                color: white;
                border: none;
                padding: 0.75rem 1.5rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-weight: 500;
              ">
                Save Tax Rate
              </button>
            </div>
            ${(() => {
        const userRole = currentProfile?.company_role || currentProfile?.role || 'USER';
        const canEdit = userRole === 'OWNER' || userRole === 'MANAGER' || userRole === 'ADMIN';
        if (!canEdit) {
          return '<p style="margin: 1rem 0 0 0; color: #f59e0b; font-size: 0.875rem;">Only owners and managers can change the global tax rate</p>';
        }
        return '';
      })()}
          </div>
        </div>
      ` : ''}
      
      ${contractsTab === 'clauses' ? `
        <!-- Clauses Tab -->
        <div style="display: flex; justify-content: flex-end; margin-bottom: 1rem;">
          <button onclick="openClauseModal()" style="
            background: #ef4444;
            color: white;
            border: none;
            padding: 0.5rem 1rem;
            border-radius: 0.375rem;
            cursor: pointer;
            font-weight: 500;
          ">+ Add Clause</button>
        </div>
        
        ${contractClauses.length === 0 ? `
          <div style="padding: 3rem; text-align: center; color: #64748b; background: white; border-radius: 0.75rem;">
            <div style="font-size: 3rem; margin-bottom: 1rem;">📜</div>
            <p>No clauses yet</p>
            <button onclick="openClauseModal()" style="
              background: #ef4444;
              color: white;
              border: none;
              padding: 0.5rem 1rem;
              border-radius: 0.375rem;
              cursor: pointer;
              margin-top: 1rem;
            ">Add your first clause</button>
          </div>
        ` : `
          <div style="display: flex; flex-direction: column; gap: 1rem;">
            ${['payment', 'scope', 'timeline', 'tech', 'cancellation', 'legal', 'other'].map(category => {
        const categoryClauses = contractClauses.filter(c => c.category === category);
        if (categoryClauses.length === 0) return '';
        return `
                <div style="background: white; border-radius: 0.75rem; overflow: hidden; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">
                  <div style="background: #f8fafc; padding: 0.75rem 1rem; font-weight: 600; color: #1e293b; text-transform: capitalize; border-bottom: 1px solid #e2e8f0;">
                    ${category}
                  </div>
                  ${categoryClauses.map(clause => `
                    <div style="padding: 1rem; border-bottom: 1px solid #e2e8f0;">
                      <div style="display: flex; justify-content: space-between; align-items: start;">
                        <div style="flex: 1;">
                          <div style="font-weight: 500; color: #1e293b; margin-bottom: 0.25rem;">${clause.title}</div>
                          <div style="font-size: 0.875rem; color: #64748b; line-height: 1.5;">${(clause.body || '').substring(0, 200)}${(clause.body || '').length > 200 ? '...' : ''}</div>
                        </div>
                        <div style="display: flex; gap: 0.25rem; margin-left: 1rem;">
                          <button onclick="openClauseModal('${clause.id}')" style="background: #f1f5f9; border: none; padding: 0.25rem 0.5rem; border-radius: 0.25rem; cursor: pointer; display: flex; align-items: center;">${'<svg width="14" height="14" viewBox="0 0 24 24" fill="#475569"><path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"></path></svg>'}</button>
                          <button onclick="archiveClause('${clause.id}')" style="background: #fee2e2; border: none; padding: 0.25rem 0.5rem; border-radius: 0.25rem; cursor: pointer; display: flex; align-items: center;">${'<svg width="14" height="14" viewBox="0 0 24 24" fill="#dc2626"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"></path></svg>'}</button>
                        </div>
                      </div>
                    </div>
                  `).join('')}
                </div>
              `;
      }).join('')}
          </div>
        `}
      ` : ''}
    </div>
    
    ${renderNewContractModal()}
    ${renderProductModal()}
    ${renderCategoryModal()}
    ${renderClauseModal()}
    ${renderContractLinkModal()}
    ${renderTaxRateModal()}
    ${renderSettingsConfirmModal()}
    ${renderContractPreviewModal()}
    ${renderVoidConfirmModal()}
    ${renderDeleteConfirmModal()}
  `;
}

// Render Contract Detail View
async function renderContractDetailView() {
  const contract = contractsList.find(c => c.id === selectedContractId);
  if (!contract) {
    return `<div style="padding: 2rem; text-align: center;">Contract not found</div>`;
  }

  // Load line items, clauses, and company logo for this contract
  let lineItems = [];
  let selectedClauseData = [];
  let contractCompanyLogo = companyLogoUrl || null; // Use global companyLogoUrl if available
  const contractCompanyName = contract.rep_company_name || currentCompany?.name || 'Company';

  try {
    const { data: itemsData } = await supabase
      .from('contract_line_items')
      .select('*')
      .eq('contract_id', contract.id)
      .order('sort_order');
    lineItems = itemsData || [];

    const { data: clauseLinks } = await supabase
      .from('contract_selected_clauses')
      .select('id, clause_id, custom_title, custom_body, sort_order')
      .eq('contract_id', contract.id)
      .order('sort_order');

    if (clauseLinks && clauseLinks.length > 0) {
      // Map clauses with custom overrides
      selectedClauseData = clauseLinks.map(cl => {
        const originalClause = contractClauses.find(c => c.id === cl.clause_id);
        return {
          ...originalClause,
          selected_clause_id: cl.id, // ID in contract_selected_clauses table
          custom_title: cl.custom_title,
          custom_body: cl.custom_body,
          // Use custom values if set, otherwise use original
          display_title: cl.custom_title || originalClause?.title || '',
          display_body: cl.custom_body || originalClause?.body || ''
        };
      }).filter(c => c.id); // Filter out any that didn't match
    }
  } catch (err) {
    console.error('Error loading contract details:', err);
  }

  const statusColors = {
    draft: '#6b7280',
    sent: '#ef4444',
    viewed: '#f59e0b',
    signed: '#10b981',
    expired: '#ef4444',
    closed: '#f97316',
    voided: '#6b7280'
  };

  const statusLabels = {
    draft: 'Draft',
    sent: 'Sent',
    viewed: 'Viewed',
    signed: 'Signed',
    expired: 'Expired',
    closed: 'Closed',
    voided: 'Voided'
  };

  const signingLink = contract.signing_token ? `${window.location.origin}/sign/${contract.signing_token}` : null;

  return `
    <div style="padding: 1.5rem; max-width: 900px; margin: 0 auto;">
      <!-- Back button -->
      <button onclick="backToContractsList()" style="
        background: none;
        border: none;
        color: #3b82f6;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        font-size: 0.875rem;
        margin-bottom: 1rem;
        padding: 0;
      ">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>
        Back to Contracts
      </button>
      
      <!-- Contract Preview -->
      <div style="background: white; border-radius: 1rem; box-shadow: 0 4px 6px rgba(0,0,0,0.05); overflow: hidden;">
        <!-- Header with Logo -->
        <div style="background: linear-gradient(135deg, #1e293b 0%, #334155 100%); color: white; padding: 2rem; text-align: center;">
          ${contractCompanyLogo
      ? `<img src="${contractCompanyLogo}" alt="${contractCompanyName}" style="max-height: 50px; max-width: 180px; object-fit: contain; margin-bottom: 0.75rem; filter: brightness(0) invert(1);" onerror="this.style.display='none'" />`
      : `<div style="font-size: 1.125rem; font-weight: 600; letter-spacing: 0.025em; margin-bottom: 0.5rem;">${contractCompanyName}</div>`
    }
          <h1 style="margin: 0 0 0.5rem; font-size: 1.5rem;">${contract.name || 'Untitled Contract'}</h1>
          <div style="font-size: 0.875rem; opacity: 0.8;">${contract.contract_number || ''}</div>
          <div style="margin-top: 1rem;">
            <span style="
              background: ${statusColors[contract.status] || '#6b7280'};
              color: white;
              padding: 0.375rem 1rem;
              border-radius: 1rem;
              font-size: 0.75rem;
              font-weight: 600;
              text-transform: uppercase;
            ">${statusLabels[contract.status] || contract.status}</span>
          </div>
        </div>
        
        <!-- Body -->
        <div style="padding: 2rem;">
          <!-- Client Info -->
          <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1.5rem; margin-bottom: 2rem; padding-bottom: 1.5rem; border-bottom: 1px solid #e2e8f0;">
            <div>
              <div style="font-size: 0.75rem; color: #64748b; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 0.25rem;">Prepared For</div>
              <div style="font-weight: 600; color: #1e293b;">${contract.client_name || ''}</div>
              <div style="color: #64748b; font-size: 0.875rem;">${contract.client_email || ''}</div>
              ${contract.client_phone ? `<div style="color: #64748b; font-size: 0.875rem;">${contract.client_phone}</div>` : ''}
            </div>
            <div>
              <div style="font-size: 0.75rem; color: #64748b; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 0.25rem;">Dates</div>
              <div style="font-size: 0.875rem;"><strong>Created:</strong> ${formatDateLocal(contract.created_at)}</div>
              <div style="font-size: 0.875rem;"><strong>Effective:</strong> ${contract.effective_date ? formatDateLocal(contract.effective_date) : 'Upon signature'}</div>
              ${contract.close_date ? `<div style="font-size: 0.875rem;"><strong>Close Date:</strong> ${formatDateLocal(contract.close_date)}</div>` : ''}
            </div>
          </div>
          
          <!-- SECTION 1: Terms & Conditions (Clauses First) -->
          ${selectedClauseData.length > 0 ? `
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
              <h3 style="margin: 0; font-size: 1rem; font-weight: 600; color: #1e293b; border-bottom: 2px solid #3b82f6; display: inline-block; padding-bottom: 0.25rem;">Terms & Conditions</h3>
              ${contract.status === 'draft' ? '<span style="font-size: 0.75rem; color: #94a3b8; font-style: italic;">Click text to edit for this contract only</span>' : ''}
            </div>
            ${selectedClauseData.map(clause => {
      // Replace [Company] and [Client] placeholders
      const clientCompanyName = contract.client_company_name || contract.client_name || 'Client';
      const clientFullName = contract.client_name || 'Client';
      let displayBody = clause.display_body || clause.body || '';
      displayBody = displayBody.replace(/\[company\]/gi, clientCompanyName);
      displayBody = displayBody.replace(/\[client\]/gi, clientFullName);
      const displayTitle = clause.display_title || clause.title || '';
      const isEditable = contract.status === 'draft'; // Only allow editing drafts
      return `
              <div style="margin-bottom: 1rem; padding: 1rem; background: #f8fafc; border-radius: 0.5rem; border-left: 4px solid #3b82f6; ${isEditable ? 'cursor: text;' : ''}">
                <div 
                  ${isEditable ? `contenteditable="true" onblur="handleContractTextEdit(this, 'clause', '${clause.selected_clause_id}', 'title')"` : ''}
                  style="font-weight: 600; margin-bottom: 0.5rem; ${isEditable ? 'outline: none; border-radius: 0.25rem; padding: 0.125rem;' : ''}"
                  ${isEditable ? 'onfocus="this.style.background=\'#fff\'; this.style.boxShadow=\'0 0 0 2px #3b82f6\'" onblur="this.style.background=\'transparent\'; this.style.boxShadow=\'none\'; handleContractTextEdit(this, \'clause\', \'' + clause.selected_clause_id + '\', \'title\')"' : ''}
                >${displayTitle}</div>
                <div 
                  ${isEditable ? `contenteditable="true"` : ''}
                  style="font-size: 0.875rem; color: #475569; line-height: 1.6; white-space: pre-wrap; ${isEditable ? 'outline: none; border-radius: 0.25rem; padding: 0.25rem;' : ''}"
                  ${isEditable ? 'onfocus="this.style.background=\'#fff\'; this.style.boxShadow=\'0 0 0 2px #3b82f6\'" onblur="this.style.background=\'transparent\'; this.style.boxShadow=\'none\'; handleContractTextEdit(this, \'clause\', \'' + clause.selected_clause_id + '\', \'body\')"' : ''}
                >${displayBody}</div>
              </div>
            `}).join('')}
            ${(contract.status === 'signed' || contract.status === 'closed') && contract.signer_name ? `
              <div style="margin-top: 0.5rem; margin-bottom: 1.5rem; padding: 0.75rem; background: #dbeafe; border-radius: 0.5rem; border-left: 4px solid #3b82f6; display: flex; align-items: center; gap: 0.75rem;">
                <span style="font-weight: 700; font-size: 1rem; min-width: 40px; text-align: center; border: 2px solid #2563eb; border-radius: 0.25rem; padding: 0.25rem; background: white;">${contract.metadata?.initials?.terms || (contract.signer_name ? contract.signer_name.split(' ').map(n => n[0]).join('').toUpperCase() : '---')}</span>
                <span style="font-size: 0.75rem; color: #1e40af;">Terms acknowledged by ${contract.signer_name}</span>
              </div>
            ` : ''}
          ` : ''}
          
          <!-- Custom Notes (after clauses) -->
          ${contract.custom_notes ? `
            <div style="margin-bottom: 1.5rem; padding: 1rem; background: #fef3c7; border-radius: 0.5rem; border-left: 4px solid #f59e0b;">
              <div style="font-weight: 600; margin-bottom: 0.5rem; color: #92400e;">Additional Notes</div>
              <div style="font-size: 0.875rem; color: #78350f; line-height: 1.6; white-space: pre-wrap;">${contract.custom_notes}</div>
            </div>
          ` : ''}
          
          <!-- SECTION 2: Services & Products -->
          ${lineItems.length > 0 ? `
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
              <h3 style="margin: 0; font-size: 1rem; font-weight: 600; color: #1e293b; border-bottom: 2px solid #3b82f6; display: inline-block; padding-bottom: 0.25rem;">Services & Products</h3>
              ${contract.status === 'draft' ? '<span style="font-size: 0.75rem; color: #94a3b8; font-style: italic;">Click text to edit for this contract only</span>' : ''}
            </div>
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 1.5rem;">
              <thead>
                <tr style="background: #f8fafc;">
                  <th style="padding: 0.75rem; text-align: left; font-size: 0.75rem; text-transform: uppercase; color: #64748b; border-bottom: 1px solid #e2e8f0;">Item</th>
                  <th style="padding: 0.75rem; text-align: center; font-size: 0.75rem; text-transform: uppercase; color: #64748b; border-bottom: 1px solid #e2e8f0;">Qty</th>
                  <th style="padding: 0.75rem; text-align: right; font-size: 0.75rem; text-transform: uppercase; color: #64748b; border-bottom: 1px solid #e2e8f0;">Price</th>
                  <th style="padding: 0.75rem; text-align: right; font-size: 0.75rem; text-transform: uppercase; color: #64748b; border-bottom: 1px solid #e2e8f0;">Total</th>
                </tr>
              </thead>
              <tbody>
                ${lineItems.map(item => {
        const isEditable = contract.status === 'draft';
        return `
                  <tr>
                    <td style="padding: 0.75rem; border-bottom: 1px solid #e2e8f0;">
                      <div 
                        ${isEditable ? `contenteditable="true"` : ''}
                        style="font-weight: 500; ${isEditable ? 'outline: none; border-radius: 0.25rem; padding: 0.125rem;' : ''}"
                        ${isEditable ? `onfocus="this.style.background='#fff'; this.style.boxShadow='0 0 0 2px #3b82f6'" onblur="this.style.background='transparent'; this.style.boxShadow='none'; handleContractTextEdit(this, 'lineitem', '${item.id}', 'name')"` : ''}
                      >${item.name}</div>
                      <div 
                        ${isEditable ? `contenteditable="true"` : ''}
                        style="font-size: 0.75rem; color: #64748b; ${isEditable ? 'outline: none; border-radius: 0.25rem; padding: 0.125rem; min-height: 1rem;' : ''}"
                        ${isEditable ? `onfocus="this.style.background='#fff'; this.style.boxShadow='0 0 0 2px #3b82f6'" onblur="this.style.background='transparent'; this.style.boxShadow='none'; handleContractTextEdit(this, 'lineitem', '${item.id}', 'description')"` : ''}
                      >${item.description || (isEditable ? '<span style="color: #94a3b8; font-style: italic;">Add description...</span>' : '')}</div>
                      ${item.is_recurring ? '<span style="background: #dbeafe; color: #2563eb; padding: 0.125rem 0.5rem; border-radius: 0.25rem; font-size: 0.625rem; text-transform: uppercase;">' + item.recurring_interval + '</span>' : ''}
                    </td>
                    <td style="padding: 0.75rem; text-align: center; border-bottom: 1px solid #e2e8f0;">${item.quantity}</td>
                    <td style="padding: 0.75rem; text-align: right; border-bottom: 1px solid #e2e8f0;">$${parseFloat(item.unit_price || 0).toFixed(2)}</td>
                    <td style="padding: 0.75rem; text-align: right; border-bottom: 1px solid #e2e8f0; font-weight: 500;">$${parseFloat(item.total || 0).toFixed(2)}</td>
                  </tr>
                `}).join('')}
              </tbody>
            </table>
            ${(contract.status === 'signed' || contract.status === 'closed') && contract.signer_name ? `
              <div style="margin-bottom: 1.5rem; padding: 0.75rem; background: #f0fdf4; border-radius: 0.5rem; border-left: 4px solid #22c55e; display: flex; align-items: center; gap: 0.75rem;">
                <span style="font-weight: 700; font-size: 1rem; min-width: 40px; text-align: center; border: 2px solid #16a34a; border-radius: 0.25rem; padding: 0.25rem; background: white;">${contract.metadata?.initials?.items || (contract.signer_name ? contract.signer_name.split(' ').map(n => n[0]).join('').toUpperCase() : '---')}</span>
                <span style="font-size: 0.75rem; color: #166534;">Items/services acknowledged by ${contract.signer_name}</span>
              </div>
            ` : ''}
          ` : ''}
          
          <!-- SECTION 3: Pricing Summary (At the End) -->
          <h3 style="margin: 0 0 1rem; font-size: 1rem; font-weight: 600; color: #1e293b; border-bottom: 2px solid #3b82f6; display: inline-block; padding-bottom: 0.25rem;">Pricing Summary</h3>
          <div style="background: #f8fafc; padding: 1.5rem; border-radius: 0.5rem; margin-bottom: 1.5rem;">
            <div style="display: flex; justify-content: space-between; margin-bottom: 0.5rem;">
              <span style="color: #64748b;">Subtotal</span>
              <span>$${parseFloat(contract.subtotal || 0).toFixed(2)}</span>
            </div>
            ${contract.discount_amount > 0 ? `
              <div style="display: flex; justify-content: space-between; margin-bottom: 0.5rem; color: #10b981;">
                <span>Discount</span>
                <span>-$${parseFloat(contract.discount_amount || 0).toFixed(2)}</span>
              </div>
            ` : ''}
            ${contract.tax_amount > 0 ? `
              <div style="display: flex; justify-content: space-between; margin-bottom: 0.5rem;">
                <span style="color: #64748b;">Tax (${contract.tax_rate}%)</span>
                <span>$${parseFloat(contract.tax_amount || 0).toFixed(2)}</span>
              </div>
            ` : ''}
            <div style="display: flex; justify-content: space-between; font-size: 1.25rem; font-weight: 700; border-top: 2px solid #1e293b; padding-top: 0.75rem; margin-top: 0.5rem;">
              <span>Total Due</span>
              <span>$${parseFloat(contract.total || 0).toFixed(2)}</span>
            </div>
            ${contract.monthly_recurring > 0 ? `
              <div style="display: flex; justify-content: space-between; margin-top: 0.5rem; color: #64748b; font-size: 0.875rem;">
                <span>Monthly Recurring</span>
                <span>$${parseFloat(contract.monthly_recurring || 0).toFixed(2)}/mo</span>
              </div>
            ` : ''}
            ${(contract.status === 'signed' || contract.status === 'closed') && contract.signer_name ? `
              <div style="margin-top: 1rem; padding: 0.75rem; background: #fef3c7; border-radius: 0.5rem; border-left: 4px solid #f59e0b; display: flex; align-items: center; gap: 0.75rem;">
                <span style="font-weight: 700; font-size: 1rem; min-width: 40px; text-align: center; border: 2px solid #d97706; border-radius: 0.25rem; padding: 0.25rem; background: white;">${contract.metadata?.initials?.pricing || (contract.signer_name ? contract.signer_name.split(' ').map(n => n[0]).join('').toUpperCase() : '---')}</span>
                <span style="font-size: 0.75rem; color: #78350f;">Pricing acknowledged by ${contract.signer_name}</span>
              </div>
            ` : ''}
          </div>
          
          <!-- Signature Blocks -->
          <div style="margin-top: 2rem; display: grid; grid-template-columns: repeat(2, 1fr); gap: 1.5rem;">
            <!-- Company Representative Signature (Auto-filled) -->
            <div style="padding: 1.5rem; background: #f1f5f9; border-radius: 0.5rem; border: 1px solid #e2e8f0;">
              <h4 style="margin: 0 0 1rem; font-size: 0.875rem; font-weight: 700; color: #1e293b; text-transform: uppercase; letter-spacing: 0.05em;">
                ${contract.rep_company_name || currentCompany?.name || 'Company'}
              </h4>
              <div style="margin-bottom: 1rem;">
                <div style="font-size: 0.75rem; color: #64748b; margin-bottom: 0.25rem;">Printed Name</div>
                <div style="font-weight: 500; color: #1e293b;">${contract.rep_name || 'Company Representative'}</div>
              </div>
              <div style="margin-bottom: 1rem;">
                <div style="font-size: 0.75rem; color: #64748b; margin-bottom: 0.25rem;">Title</div>
                <div style="font-weight: 500; color: #1e293b;">${contract.rep_title || 'Representative'}</div>
              </div>
              <div style="margin-bottom: 1rem;">
                <div style="font-size: 0.75rem; color: #64748b; margin-bottom: 0.25rem;">Signature</div>
                <div style="font-family: 'Brush Script MT', 'Segoe Script', cursive; font-size: 1.5rem; color: #1e293b; border-bottom: 2px solid #1e293b; padding-bottom: 0.25rem; min-height: 36px;">
                  ${contract.rep_signature || contract.rep_name || ''}
                </div>
              </div>
              <div>
                <div style="font-size: 0.75rem; color: #64748b; margin-bottom: 0.25rem;">Date</div>
                <div style="font-weight: 500; color: #1e293b;">${formatDateLocal(contract.rep_signed_at || contract.created_at)}</div>
              </div>
            </div>
            
            <!-- Client Signature -->
            <div style="padding: 1.5rem; background: ${contract.status === 'signed' || contract.status === 'closed' ? '#dcfce7' : '#fef3c7'}; border-radius: 0.5rem; border: 1px solid ${contract.status === 'signed' || contract.status === 'closed' ? '#86efac' : '#fcd34d'};">
              <h4 style="margin: 0 0 1rem; font-size: 0.875rem; font-weight: 700; color: #1e293b; text-transform: uppercase; letter-spacing: 0.05em;">
                ${contract.client_company_name || contract.client_name || 'Client'}
              </h4>
              <div style="margin-bottom: 1rem;">
                <div style="font-size: 0.75rem; color: #64748b; margin-bottom: 0.25rem;">Printed Name</div>
                <div style="font-weight: 500; color: #1e293b;">${(contract.status === 'signed' || contract.status === 'closed') && contract.signer_name ? contract.signer_name : (contract.status === 'signed' || contract.status === 'closed') ? contract.client_name : '________________________'}</div>
              </div>
              <div style="margin-bottom: 1rem;">
                <div style="font-size: 0.75rem; color: #64748b; margin-bottom: 0.25rem;">Signature</div>
                <div style="font-family: 'Brush Script MT', 'Segoe Script', cursive; font-size: 1.5rem; color: #1e293b; border-bottom: 2px solid #1e293b; padding-bottom: 0.25rem; min-height: 36px;">
                  ${(contract.status === 'signed' || contract.status === 'closed') ? (contract.signature_data || contract.signer_name || '') : ''}
                </div>
              </div>
              <div>
                <div style="font-size: 0.75rem; color: #64748b; margin-bottom: 0.25rem;">Date</div>
                <div style="font-weight: 500; color: #1e293b;">${(contract.status === 'signed' || contract.status === 'closed') && contract.signed_at ? formatDateLocal(contract.signed_at) : '________________________'}</div>
              </div>
              ${contract.status !== 'signed' && contract.status !== 'closed' && contract.signed_at === null ? `
                <div style="margin-top: 1rem; padding: 0.75rem; background: rgba(245, 158, 11, 0.1); border-radius: 0.375rem; text-align: center;">
                  <span style="font-size: 0.75rem; color: #92400e;">⏳ Awaiting client signature</span>
                </div>
              ` : ''}
            </div>
          </div>
        </div>
        
        <!-- Actions Footer -->
        <div style="padding: 1.5rem; border-top: 1px solid #e2e8f0; background: #f8fafc; display: flex; gap: 0.75rem; flex-wrap: wrap; justify-content: flex-end;">
          ${contract.status === 'draft' ? `
            <button onclick="createContractAndGetLink('${contract.id}')" style="
              background: linear-gradient(135deg, #10b981 0%, #059669 100%);
              color: white;
              border: none;
              padding: 0.75rem 1.5rem;
              border-radius: 0.5rem;
              cursor: pointer;
              font-weight: 500;
              display: flex;
              align-items: center;
              gap: 0.5rem;
            ">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"/></svg>
              Create Contract & Get Link
            </button>
          ` : ''}
          ${signingLink && (contract.status === 'sent' || contract.status === 'viewed') ? `
            <button onclick="copySigningLink('${contract.signing_token}')" style="
              background: #dbeafe;
              color: #2563eb;
              border: none;
              padding: 0.75rem 1.25rem;
              border-radius: 0.5rem;
              cursor: pointer;
              font-weight: 500;
              display: flex;
              align-items: center;
              gap: 0.5rem;
            ">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"/></svg>
              Copy Signing Link
            </button>
          ` : ''}
          ${contract.status === 'signed' || contract.status === 'closed' ? `
            <button onclick="downloadContractPdf('${contract.id}')" style="
              background: #e0e7ff;
              color: #4f46e5;
              border: none;
              padding: 0.75rem 1.25rem;
              border-radius: 0.5rem;
              cursor: pointer;
              font-weight: 500;
              display: flex;
              align-items: center;
              gap: 0.5rem;
            ">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"/></svg>
              Download PDF
            </button>
          ` : ''}
          ${contract.status === 'signed' ? `
            <button onclick="markContractClosed('${contract.id}')" style="
              background: #dcfce7;
              color: #16a34a;
              border: none;
              padding: 0.75rem 1.25rem;
              border-radius: 0.5rem;
              cursor: pointer;
              font-weight: 500;
              display: flex;
              align-items: center;
              gap: 0.5rem;
            ">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
              Mark Closed
            </button>
          ` : ''}
          ${contract.status === 'draft' || contract.status === 'sent' ? `
            <button onclick="showVoidConfirm('${contract.id}')" style="
              background: #fee2e2;
              color: #dc2626;
              border: none;
              padding: 0.75rem 1.25rem;
              border-radius: 0.5rem;
              cursor: pointer;
              font-weight: 500;
              display: flex;
              align-items: center;
              gap: 0.5rem;
            ">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
              Void Contract
            </button>
          ` : ''}
          <button onclick="showDeleteConfirm('${contract.id}')" style="
            background: #f3f4f6;
            color: #6b7280;
            border: none;
            padding: 0.75rem 1.25rem;
            border-radius: 0.5rem;
            cursor: pointer;
            font-weight: 500;
            display: flex;
            align-items: center;
            gap: 0.5rem;
          ">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/></svg>
            Delete Contract
          </button>
        </div>
      </div>
    </div>
  `;
}

// Render Delete Confirmation Modal
function renderDeleteConfirmModal() {
  if (!showDeleteConfirmModal) return '';

  const contract = contractsList.find(c => c.id === deleteContractId);
  const contractName = contract ? contract.name || 'Untitled Contract' : 'this contract';
  const isConfirmed = deleteConfirmText === 'DELETE';

  return `
    <div style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,0.6);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1005;
      padding: 1rem;
    " onclick="closeDeleteConfirm()">
      <div style="
        background: white;
        border-radius: 1rem;
        width: 100%;
        max-width: 480px;
        box-shadow: 0 25px 50px rgba(0,0,0,0.3);
        animation: slideUp 0.2s ease-out;
      " onclick="event.stopPropagation()">
        <!-- Header -->
        <div style="padding: 1.5rem; border-bottom: 1px solid #e2e8f0; display: flex; align-items: center; gap: 0.75rem;">
          <div style="
            width: 48px;
            height: 48px;
            background: #fee2e2;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
          ">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="#dc2626"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/></svg>
          </div>
          <div style="flex: 1;">
            <h2 style="margin: 0; font-size: 1.25rem; font-weight: 600; color: #1e293b;">Delete Contract?</h2>
            <p style="margin: 0.25rem 0 0; font-size: 0.875rem; color: #64748b;">This action is permanent and cannot be undone</p>
          </div>
          <button onclick="closeDeleteConfirm()" style="
            background: none;
            border: none;
            font-size: 1.5rem;
            cursor: pointer;
            color: #64748b;
            padding: 0;
            width: 32px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 0.375rem;
            transition: background 0.2s;
          " onmouseover="this.style.background='#f1f5f9'" onmouseout="this.style.background='transparent'">&times;</button>
        </div>
        
        <!-- Body -->
        <div style="padding: 1.5rem;">
          <p style="margin: 0 0 1rem; color: #475569; line-height: 1.6;">
            Are you sure you want to permanently delete <strong>${contractName}</strong>? This action cannot be undone and all contract data will be permanently removed.
          </p>
          <div style="
            background: #fef2f2;
            border: 1px solid #fecaca;
            border-radius: 0.5rem;
            padding: 0.75rem;
            margin-bottom: 1.5rem;
          ">
            <div style="display: flex; align-items: start; gap: 0.5rem;">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="#dc2626" style="flex-shrink: 0; margin-top: 0.125rem;"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>
              <div style="font-size: 0.875rem; color: #991b1b;">
                <strong>Warning:</strong> Deleting a contract will permanently remove all associated data including line items, clauses, and activity logs. This cannot be reversed.
              </div>
            </div>
          </div>
          
          <div style="margin-bottom: 1rem;">
            <label style="display: block; font-weight: 500; margin-bottom: 0.5rem; color: #1e293b;">
              Type <strong style="color: #dc2626;">DELETE</strong> to confirm:
            </label>
            <input 
              type="text" 
              id="delete-confirm-input"
              value="${deleteConfirmText}"
              oninput="handleDeleteConfirmInput(this.value)"
              placeholder="Type DELETE here"
              style="
                width: 100%;
                padding: 0.75rem;
                border: 2px solid ${isConfirmed ? '#10b981' : '#e2e8f0'};
                border-radius: 0.5rem;
                font-size: 1rem;
                font-weight: 600;
                text-transform: uppercase;
                color: ${isConfirmed ? '#10b981' : '#1e293b'};
                transition: all 0.2s;
              "
              onfocus="this.style.borderColor='#3b82f6'; this.style.outline='none'"
              onblur="this.style.borderColor='${isConfirmed ? '#10b981' : '#e2e8f0'}'"
              autocomplete="off"
            />
            <div id="delete-confirm-message">
              ${isConfirmed ? `
                <div style="display: flex; align-items: center; gap: 0.5rem; margin-top: 0.5rem; color: #10b981; font-size: 0.875rem;">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
                  Confirmation text matches
                </div>
              ` : deleteConfirmText.length > 0 ? `
                <div style="margin-top: 0.5rem; color: #dc2626; font-size: 0.875rem;">
                  Text does not match. Please type "DELETE" exactly.
                </div>
              ` : ''}
            </div>
          </div>
        </div>
        
        <!-- Footer -->
        <div style="padding: 1rem 1.5rem; border-top: 1px solid #e2e8f0; display: flex; gap: 0.75rem; justify-content: flex-end;">
          <button onclick="closeDeleteConfirm()" style="
            background: #f1f5f9;
            color: #64748b;
            border: none;
            padding: 0.75rem 1.5rem;
            border-radius: 0.5rem;
            cursor: pointer;
            font-weight: 500;
            transition: all 0.2s;
          " onmouseover="this.style.background='#e2e8f0'" onmouseout="this.style.background='#f1f5f9'">Cancel</button>
          <button id="delete-confirm-button" onclick="deleteContract()" style="
            background: ${isConfirmed ? 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)' : '#e5e7eb'};
            color: ${isConfirmed ? 'white' : '#9ca3af'};
            border: none;
            padding: 0.75rem 1.5rem;
            border-radius: 0.5rem;
            cursor: ${isConfirmed ? 'pointer' : 'not-allowed'};
            font-weight: 500;
            transition: all 0.2s;
            display: flex;
            align-items: center;
            gap: 0.5rem;
            opacity: ${isConfirmed ? '1' : '0.6'};
          " ${isConfirmed ? '' : 'disabled'}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/></svg>
            Delete Contract
          </button>
        </div>
      </div>
    </div>
  `;
}

// Render New Contract Modal
function renderNewContractModal() {
  if (!showNewContractModal) return '';

  const totals = calculateContractTotals();

  return `
    <div style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1000;
      padding: 1rem;
    " onclick="closeNewContractModal()">
      <div style="
        background: white;
        border-radius: 1rem;
        width: 100%;
        max-width: 800px;
        max-height: 90vh;
        overflow-y: auto;
        box-shadow: 0 25px 50px rgba(0,0,0,0.25);
      " onclick="event.stopPropagation()">
        <!-- Header -->
        <div style="padding: 1.5rem; border-bottom: 1px solid #e2e8f0; display: flex; justify-content: space-between; align-items: center;">
          <h2 style="margin: 0; font-size: 1.25rem; font-weight: 600;">New Contract</h2>
          <button onclick="closeNewContractModal()" style="background: none; border: none; font-size: 1.5rem; cursor: pointer; color: #64748b;">&times;</button>
        </div>
        
        <!-- Steps indicator -->
        <div style="padding: 1rem 1.5rem; border-bottom: 1px solid #e2e8f0; display: flex; gap: 1rem;">
          ${[1, 2, 3, 4].map(step => `
            <div onclick="setContractStep(${step})" style="
              flex: 1;
              text-align: center;
              padding: 0.5rem;
              border-radius: 0.5rem;
              cursor: pointer;
              background: ${newContractStep === step ? '#ef4444' : newContractStep > step ? '#f97316' : '#f1f5f9'};
              color: ${newContractStep >= step ? 'white' : '#64748b'};
              font-weight: 500;
              font-size: 0.875rem;
            ">
              ${step === 1 ? 'Client' : step === 2 ? 'Products' : step === 3 ? 'Terms' : 'Review'}
            </div>
          `).join('')}
        </div>
        
        <!-- Content -->
        <div style="padding: 1.5rem;">
          ${newContractStep === 1 ? `
            <!-- Step 1: Client -->
            <div style="display: flex; flex-direction: column; gap: 1rem;">
              <div>
                <label style="display: block; margin-bottom: 0.5rem; font-weight: 500; color: #374151;">Contract Name *</label>
                <input type="text" id="contract-name-input" value="${newContractData.contractName}" oninput="handleContractNameInput(this.value)" onblur="renderPMTool()" placeholder="e.g., Website Development Agreement" style="width: 100%; padding: 0.75rem; border: 1px solid ${newContractData.contractName && newContractData.contractName.trim() ? '#22c55e' : '#d1d5db'}; border-radius: 0.5rem; box-sizing: border-box;" />
              </div>
              
              <div id="contact-search-container" style="position: relative;">
                <label style="display: block; margin-bottom: 0.5rem; font-weight: 500; color: #374151;">Search & Select Contact</label>
                <div style="position: relative;">
                  <input 
                    type="text" 
                    id="contact-search-input"
                    value="${newContractData.contactId ? contacts.find(c => c.id === newContractData.contactId)?.first_name + ' ' + contacts.find(c => c.id === newContractData.contactId)?.last_name : ''}"
                    oninput="handleContractContactSearch(this.value)"
                    onfocus="if(this.value) handleContractContactSearch(this.value)"
                    placeholder="Type to search contacts by name, email, or company..."
                    autocomplete="off"
                    style="width: 100%; padding: 0.75rem; padding-right: ${newContractData.contactId ? '2.5rem' : '0.75rem'}; border: 1px solid ${newContractData.contactId ? '#22c55e' : '#d1d5db'}; border-radius: 0.5rem; box-sizing: border-box; background: ${newContractData.contactId ? '#f0fdf4' : 'white'};"
                  />
                  ${newContractData.contactId ? `
                    <button onclick="clearContactSelection()" style="
                      position: absolute;
                      right: 0.5rem;
                      top: 50%;
                      transform: translateY(-50%);
                      background: #fee2e2;
                      border: none;
                      border-radius: 50%;
                      width: 24px;
                      height: 24px;
                      cursor: pointer;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      color: #dc2626;
                      font-size: 14px;
                    " title="Clear selection">✕</button>
                  ` : `
                    <svg style="position: absolute; right: 0.75rem; top: 50%; transform: translateY(-50%); pointer-events: none; color: #9ca3af;" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
                    </svg>
                  `}
                </div>
                <div id="contact-search-dropdown" style="
                  display: none;
                  position: absolute;
                  top: 100%;
                  left: 0;
                  right: 0;
                  background: white;
                  border: 1px solid #e2e8f0;
                  border-radius: 0.5rem;
                  box-shadow: 0 10px 25px rgba(0,0,0,0.15);
                  max-height: 300px;
                  overflow-y: auto;
                  z-index: 1000;
                  margin-top: 0.25rem;
                ">
                  <!-- Results will be populated by JS -->
                </div>
                ${newContractData.contactId ? `
                  <div style="margin-top: 0.5rem; padding: 0.5rem 0.75rem; background: #dcfce7; border-radius: 0.375rem; display: flex; align-items: center; gap: 0.5rem;">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="#16a34a"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
                    <span style="font-size: 0.875rem; color: #166534;">
                      <strong>${contacts.find(c => c.id === newContractData.contactId)?.first_name || ''} ${contacts.find(c => c.id === newContractData.contactId)?.last_name || ''}</strong> selected
                      ${contacts.find(c => c.id === newContractData.contactId)?.email ? ` (${contacts.find(c => c.id === newContractData.contactId)?.email})` : ''}
                    </span>
                  </div>
                ` : ''}
              </div>
              
              <div style="text-align: center; color: #64748b; font-size: 0.875rem;">— or enter manually —</div>
              
              <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem;">
                <div>
                  <label style="display: block; margin-bottom: 0.5rem; font-weight: 500; color: #374151;">Client Name *</label>
                  <input type="text" id="client-name-input" value="${newContractData.clientName}" oninput="handleClientNameInput(this.value)" onblur="renderPMTool()" placeholder="John Doe" style="width: 100%; padding: 0.75rem; border: 1px solid ${newContractData.contactId || (newContractData.clientName && newContractData.clientName.trim()) ? '#22c55e' : '#d1d5db'}; border-radius: 0.5rem; box-sizing: border-box;" />
                </div>
                <div>
                  <label style="display: block; margin-bottom: 0.5rem; font-weight: 500; color: #374151;">Client Email *</label>
                  <input type="email" id="client-email-input" value="${newContractData.clientEmail}" oninput="handleClientEmailInput(this.value)" onblur="renderPMTool()" placeholder="john@example.com" style="width: 100%; padding: 0.75rem; border: 1px solid ${newContractData.contactId || (newContractData.clientEmail && newContractData.clientEmail.trim()) ? '#22c55e' : '#d1d5db'}; border-radius: 0.5rem; box-sizing: border-box;" />
                </div>
              </div>
              
              <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem;">
                <div>
                  <label style="display: block; margin-bottom: 0.5rem; font-weight: 500; color: #374151;">Phone</label>
                  <input type="tel" value="${newContractData.clientPhone}" oninput="newContractData.clientPhone = this.value" placeholder="(555) 123-4567" style="width: 100%; padding: 0.75rem; border: 1px solid #d1d5db; border-radius: 0.5rem; box-sizing: border-box;" />
                </div>
                <div>
                  <label style="display: block; margin-bottom: 0.5rem; font-weight: 500; color: #374151;">Company Name</label>
                  <input type="text" value="${newContractData.clientCompanyName}" oninput="newContractData.clientCompanyName = this.value" placeholder="Acme Inc." style="width: 100%; padding: 0.75rem; border: 1px solid #d1d5db; border-radius: 0.5rem; box-sizing: border-box;" />
                </div>
              </div>
              
              <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem;">
                <div>
                  <label style="display: block; margin-bottom: 0.5rem; font-weight: 500; color: #374151;">Effective Date</label>
                  <input type="date" value="${newContractData.effectiveDate}" oninput="newContractData.effectiveDate = this.value" style="width: 100%; padding: 0.75rem; border: 1px solid #d1d5db; border-radius: 0.5rem; box-sizing: border-box;" />
                </div>
                <div>
                  <label style="display: block; margin-bottom: 0.5rem; font-weight: 500; color: #374151;">Close Date</label>
                  <input type="date" value="${newContractData.closeDate}" oninput="newContractData.closeDate = this.value" style="width: 100%; padding: 0.75rem; border: 1px solid #d1d5db; border-radius: 0.5rem; box-sizing: border-box;" />
                </div>
              </div>
            </div>
          ` : ''}
          
          ${newContractStep === 2 ? `
            <!-- Step 2: Products -->
            <div style="display: flex; flex-direction: column; gap: 1rem;">
              <div style="display: flex; flex-direction: column; gap: 0.75rem;">
                <div style="font-weight: 500; color: #374151; font-size: 0.875rem;">Select Products to Add:</div>
                <input type="text" 
                       id="product-search-input"
                       placeholder="Search products..." 
                       value="${productSearchQuery || ''}" 
                       oninput="handleProductSearchInput(this)" 
                       style="width: 100%; padding: 0.625rem 0.75rem; border: 1px solid #e2e8f0; border-radius: 0.5rem; font-size: 0.875rem; box-sizing: border-box;" />
                <div data-product-list-container style="display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 0.5rem; max-height: 200px; overflow-y: auto; padding: 0.75rem; border: 1px solid #e2e8f0; border-radius: 0.5rem; background: #f8fafc;">
                  ${(function () {
        // Filter and sort products
        var filteredProducts = contractProducts;

        // Apply search filter
        if (productSearchQuery && productSearchQuery.trim()) {
          var searchLower = productSearchQuery.toLowerCase().trim();
          filteredProducts = contractProducts.filter(function (p) {
            return p.name.toLowerCase().includes(searchLower) ||
              (p.sku && p.sku.toLowerCase().includes(searchLower)) ||
              (p.description && p.description.toLowerCase().includes(searchLower));
          });
        }

        // Sort alphabetically by name
        filteredProducts = filteredProducts.slice().sort(function (a, b) {
          var nameA = (a.name || '').toLowerCase();
          var nameB = (b.name || '').toLowerCase();
          return nameA.localeCompare(nameB);
        });

        if (filteredProducts.length === 0) {
          return '<div style="color: #64748b; font-size: 0.875rem; padding: 0.5rem; grid-column: 1 / -1;">' + (contractProducts.length === 0 ? 'No products available. Add products in the Products tab.' : 'No products match your search.') + '</div>';
        }

        return filteredProducts.map(function (p) {
          var isSelected = (window.selectedProductIds || []).includes(p.id);
          var borderColor = isSelected ? '#3b82f6' : '#e2e8f0';
          var bgColor = isSelected ? '#eff6ff' : 'white';
          return '<label style="display: flex; align-items: center; gap: 0.75rem; padding: 0.625rem 0.75rem; background: ' + bgColor + '; border: 1px solid ' + borderColor + '; border-radius: 0.375rem; cursor: pointer; transition: all 0.15s;" onmouseover="this.style.borderColor=\'#3b82f6\'" onmouseout="this.style.borderColor=\'' + borderColor + '\'"><input type="checkbox" id="product-check-' + p.id + '" ' + (isSelected ? 'checked' : '') + ' onchange="toggleProductSelection(\'' + p.id + '\')" style="width: 18px; height: 18px; cursor: pointer; accent-color: #3b82f6;" /><div style="flex: 1; min-width: 0;"><div style="font-weight: 500; color: #1e293b; font-size: 0.875rem; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">' + p.name + '</div><div style="font-size: 0.75rem; color: #64748b;">$' + parseFloat(p.price).toFixed(2) + (p.is_recurring ? ' / ' + (p.recurring_interval || 'month') : '') + '</div></div></label>';
        }).join('');
      })()}
                </div>
                <div style="display: flex; gap: 0.5rem; flex-wrap: wrap;">
                  <button id="add-selected-products-btn" onclick="addSelectedProductsToContract()" style="background: #3b82f6; color: white; border: none; padding: 0.75rem 1rem; border-radius: 0.5rem; cursor: pointer; font-weight: 500; opacity: ${(window.selectedProductIds || []).length > 0 ? '1' : '0.5'};">
                    ${(window.selectedProductIds || []).length > 0 ? `Add Selected (${(window.selectedProductIds || []).length})` : 'Add Selected'}
                  </button>
                  <button onclick="addMiscItemToContract()" style="background: #6b7280; color: white; border: none; padding: 0.75rem 1rem; border-radius: 0.5rem; cursor: pointer; font-weight: 500;">+ Custom Item</button>
                </div>
              </div>
              
              ${newContractData.lineItems.length === 0 ? `
                <div style="padding: 2rem; text-align: center; color: #dc2626; background: #fef2f2; border: 2px dashed #fca5a5; border-radius: 0.5rem;">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="#dc2626" style="margin: 0 auto 0.5rem;"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>
                  <div style="font-weight: 600; margin-bottom: 0.25rem;">At least one product or item is required</div>
                  <div style="font-size: 0.875rem; color: #991b1b;">Please add products or custom items above to continue</div>
                </div>
              ` : `
                <div style="border: 1px solid #e2e8f0; border-radius: 0.5rem; overflow: hidden;">
                  ${newContractData.lineItems.map((item, idx) => `
                    <div style="padding: 1rem; border-bottom: 1px solid #e2e8f0; ${idx % 2 === 1 ? 'background: #f8fafc;' : ''}">
                      <div style="display: flex; justify-content: space-between; align-items: start; margin-bottom: 0.5rem;">
                        <input type="text" value="${item.name}" onchange="updateContractLineItem('${item.id}', 'name', this.value)" style="font-weight: 500; border: 1px solid #e2e8f0; padding: 0.5rem; border-radius: 0.25rem; flex: 1; margin-right: 0.5rem;" />
                        <button onclick="removeContractLineItem('${item.id}')" style="background: #fee2e2; color: #dc2626; border: none; padding: 0.25rem 0.5rem; border-radius: 0.25rem; cursor: pointer;">✕</button>
                      </div>
                      <div style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 0.5rem; font-size: 0.875rem;">
                        <div>
                          <label style="display: block; font-size: 0.75rem; color: #64748b;">Qty</label>
                          <input type="number" value="${item.quantity}" onchange="updateContractLineItem('${item.id}', 'quantity', this.value); renderPMTool();" style="width: 100%; padding: 0.5rem; border: 1px solid #e2e8f0; border-radius: 0.25rem; box-sizing: border-box;" />
                        </div>
                        <div>
                          <label style="display: block; font-size: 0.75rem; color: #64748b;">Unit Price</label>
                          <input type="number" step="0.01" value="${item.unitPrice}" onchange="updateContractLineItem('${item.id}', 'unitPrice', this.value); renderPMTool();" style="width: 100%; padding: 0.5rem; border: 1px solid #e2e8f0; border-radius: 0.25rem; box-sizing: border-box;" />
                        </div>
                        <div>
                          <label style="display: block; font-size: 0.75rem; color: #64748b;">Recurring</label>
                          <select onchange="updateContractLineItem('${item.id}', 'isRecurring', this.value); renderPMTool();" style="width: 100%; padding: 0.5rem; border: 1px solid #e2e8f0; border-radius: 0.25rem;">
                            <option value="false" ${!item.isRecurring ? 'selected' : ''}>One-time</option>
                            <option value="true" ${item.isRecurring ? 'selected' : ''}>Monthly</option>
                          </select>
                        </div>
                        <div style="text-align: right;">
                          <label style="display: block; font-size: 0.75rem; color: #64748b;">Total</label>
                          <div style="padding: 0.5rem; font-weight: 600;">$${(item.quantity * item.unitPrice).toFixed(2)}</div>
                        </div>
                      </div>
                    </div>
                  `).join('')}
                </div>
              `}
              
              <!-- Discount & Tax -->
              <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; padding: 1rem; background: #f8fafc; border-radius: 0.5rem;">
                <div>
                  <label style="display: block; margin-bottom: 0.5rem; font-weight: 500; color: #374151;">Discount</label>
                  <div style="display: flex; gap: 0.5rem;">
                    <select onchange="newContractData.discountType = this.value || null; renderPMTool();" style="padding: 0.5rem; border: 1px solid #d1d5db; border-radius: 0.25rem;">
                      <option value="" ${!newContractData.discountType ? 'selected' : ''}>None</option>
                      <option value="percentage" ${newContractData.discountType === 'percentage' ? 'selected' : ''}>%</option>
                      <option value="fixed" ${newContractData.discountType === 'fixed' ? 'selected' : ''}>$</option>
                    </select>
                    <input type="number" step="0.01" value="${newContractData.discountValue}" onchange="newContractData.discountValue = parseFloat(this.value) || 0; renderPMTool();" placeholder="0" style="flex: 1; padding: 0.5rem; border: 1px solid #d1d5db; border-radius: 0.25rem;" />
                  </div>
                </div>
                <div>
                  <label style="display: block; margin-bottom: 0.5rem; font-weight: 500; color: #374151;">Tax Rate (%)</label>
                  <input type="number" step="0.01" value="${newContractData.taxRate}" onchange="newContractData.taxRate = parseFloat(this.value) || 0; renderPMTool();" placeholder="0" style="width: 100%; padding: 0.5rem; border: 1px solid #d1d5db; border-radius: 0.25rem; box-sizing: border-box;" />
                </div>
              </div>
              
              <!-- Totals -->
              <div style="padding: 1rem; background: #1e293b; color: white; border-radius: 0.5rem;">
                <div style="display: flex; justify-content: space-between; margin-bottom: 0.5rem;">
                  <span>Subtotal:</span>
                  <span>$${totals.subtotal.toFixed(2)}</span>
                </div>
                ${totals.discountAmount > 0 ? `
                  <div style="display: flex; justify-content: space-between; margin-bottom: 0.5rem; color: #10b981;">
                    <span>Discount:</span>
                    <span>-$${totals.discountAmount.toFixed(2)}</span>
                  </div>
                ` : ''}
                ${totals.taxAmount > 0 ? `
                  <div style="display: flex; justify-content: space-between; margin-bottom: 0.5rem;">
                    <span>Tax:</span>
                    <span>$${totals.taxAmount.toFixed(2)}</span>
                  </div>
                ` : ''}
                <div style="display: flex; justify-content: space-between; font-size: 1.25rem; font-weight: 600; border-top: 1px solid #334155; padding-top: 0.5rem; margin-top: 0.5rem;">
                  <span>Total:</span>
                  <span>$${totals.total.toFixed(2)}</span>
                </div>
                ${totals.monthlyRecurring > 0 ? `
                  <div style="display: flex; justify-content: space-between; margin-top: 0.5rem; color: #94a3b8;">
                    <span>Monthly Recurring:</span>
                    <span>$${totals.monthlyRecurring.toFixed(2)}/mo</span>
                  </div>
                ` : ''}
              </div>
            </div>
          ` : ''}
          
          ${newContractStep === 3 ? `
            <!-- Step 3: Terms/Clauses -->
            <div style="display: flex; flex-direction: column; gap: 1rem;">
              <p style="color: #64748b; margin: 0;">Select the terms and conditions to include in this contract:</p>
              
              ${['payment', 'scope', 'timeline', 'tech', 'cancellation', 'legal', 'other'].map(category => {
        const categoryClauses = contractClauses.filter(c => c.category === category);
        if (categoryClauses.length === 0) return '';
        return `
                  <div style="border: 1px solid #e2e8f0; border-radius: 0.5rem; overflow: hidden;">
                    <div style="background: #f8fafc; padding: 0.75rem 1rem; font-weight: 600; text-transform: capitalize; border-bottom: 1px solid #e2e8f0;">
                      ${category}
                    </div>
                    ${categoryClauses.map(clause => `
                      <label style="display: flex; align-items: start; gap: 0.75rem; padding: 0.75rem 1rem; cursor: pointer; border-bottom: 1px solid #e2e8f0;" onmouseover="this.style.background='#f8fafc'" onmouseout="this.style.background='white'">
                        <input type="checkbox" ${newContractData.selectedClauses.includes(clause.id) ? 'checked' : ''} onchange="toggleContractClause('${clause.id}')" style="margin-top: 0.25rem;" />
                        <div style="flex: 1;">
                          <div style="font-weight: 500; color: #1e293b;">${clause.title}</div>
                          <div style="font-size: 0.875rem; color: #64748b; line-height: 1.5;">${(clause.body || '').substring(0, 150)}${(clause.body || '').length > 150 ? '...' : ''}</div>
                        </div>
                      </label>
                    `).join('')}
                  </div>
                `;
      }).join('')}
              
              <div>
                <label style="display: block; margin-bottom: 0.5rem; font-weight: 500; color: #374151;">Additional Notes</label>
                <textarea 
                  oninput="newContractData.customNotes = this.value"
                  placeholder="Add any additional notes or terms specific to this contract..."
                  style="width: 100%; padding: 0.75rem; border: 1px solid #d1d5db; border-radius: 0.5rem; min-height: 100px; box-sizing: border-box; resize: vertical;"
                >${newContractData.customNotes || ''}</textarea>
              </div>
            </div>
          ` : ''}
          
          ${newContractStep === 4 ? `
            <!-- Step 4: Review -->
            <div style="display: flex; flex-direction: column; gap: 1.5rem;">
              <!-- Contract Summary -->
              <div style="background: #f8fafc; padding: 1.5rem; border-radius: 0.75rem;">
                <h3 style="margin: 0 0 1rem 0; font-size: 1.125rem;">Contract Summary</h3>
                <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem;">
                  <div>
                    <div style="font-size: 0.75rem; color: #64748b; text-transform: uppercase; margin-bottom: 0.25rem;">Contract Name</div>
                    <div style="font-weight: 500;">${newContractData.contractName || 'Untitled'}</div>
                  </div>
                  <div>
                    <div style="font-size: 0.75rem; color: #64748b; text-transform: uppercase; margin-bottom: 0.25rem;">Client</div>
                    <div style="font-weight: 500;">${newContractData.clientName}</div>
                    <div style="font-size: 0.875rem; color: #64748b;">${newContractData.clientEmail}</div>
                  </div>
                  <div>
                    <div style="font-size: 0.75rem; color: #64748b; text-transform: uppercase; margin-bottom: 0.25rem;">Effective Date</div>
                    <div style="font-weight: 500;">${newContractData.effectiveDate ? formatDateLocal(newContractData.effectiveDate) : 'Not set'}</div>
                  </div>
                  <div>
                    <div style="font-size: 0.75rem; color: #64748b; text-transform: uppercase; margin-bottom: 0.25rem;">Items</div>
                    <div style="font-weight: 500;">${newContractData.lineItems.length} line item(s)</div>
                  </div>
                </div>
              </div>
              
              <!-- Totals -->
              <div style="padding: 1.5rem; background: linear-gradient(135deg, #1e293b 0%, #334155 100%); color: white; border-radius: 0.75rem;">
                <div style="display: flex; justify-content: space-between; margin-bottom: 0.5rem;">
                  <span>Subtotal:</span>
                  <span>$${totals.subtotal.toFixed(2)}</span>
                </div>
                ${totals.discountAmount > 0 ? `
                  <div style="display: flex; justify-content: space-between; margin-bottom: 0.5rem; color: #10b981;">
                    <span>Discount:</span>
                    <span>-$${totals.discountAmount.toFixed(2)}</span>
                  </div>
                ` : ''}
                ${totals.taxAmount > 0 ? `
                  <div style="display: flex; justify-content: space-between; margin-bottom: 0.5rem;">
                    <span>Tax (${newContractData.taxRate}%):</span>
                    <span>$${totals.taxAmount.toFixed(2)}</span>
                  </div>
                ` : ''}
                <div style="display: flex; justify-content: space-between; font-size: 1.5rem; font-weight: 700; border-top: 1px solid #475569; padding-top: 0.75rem; margin-top: 0.5rem;">
                  <span>Total:</span>
                  <span>$${totals.total.toFixed(2)}</span>
                </div>
                ${totals.monthlyRecurring > 0 ? `
                  <div style="display: flex; justify-content: space-between; margin-top: 0.5rem; color: #94a3b8; font-size: 0.875rem;">
                    <span>+ Monthly Recurring:</span>
                    <span>$${totals.monthlyRecurring.toFixed(2)}/mo</span>
                  </div>
                ` : ''}
                ${totals.savings > 0 ? `
                  <div style="margin-top: 1rem; padding: 0.75rem; background: #10b98120; border-radius: 0.5rem; text-align: center;">
                    <span style="color: #10b981; font-weight: 600;">🎉 You saved $${totals.savings.toFixed(2)}!</span>
                  </div>
                ` : ''}
              </div>
              
              <!-- Selected Clauses -->
              <div>
                <div style="font-weight: 600; margin-bottom: 0.5rem;">Selected Terms (${newContractData.selectedClauses.length})</div>
                ${newContractData.selectedClauses.length === 0 ? `
                  <div style="color: #64748b; font-size: 0.875rem;">No terms selected</div>
                ` : `
                  <div style="display: flex; flex-wrap: wrap; gap: 0.5rem;">
                    ${newContractData.selectedClauses.map(id => {
        const clause = contractClauses.find(c => c.id === id);
        return clause ? `<span style="background: #e0e7ff; color: #4338ca; padding: 0.25rem 0.75rem; border-radius: 1rem; font-size: 0.75rem;">${clause.title}</span>` : '';
      }).join('')}
                  </div>
                `}
              </div>
            </div>
          ` : ''}
        </div>
        
        <!-- Footer -->
        <div style="padding: 1.5rem; border-top: 1px solid #e2e8f0; display: flex; justify-content: space-between;">
          <button onclick="${newContractStep === 1 ? 'closeNewContractModal()' : `setContractStep(${newContractStep - 1})`}" style="
            background: #f1f5f9;
            color: #64748b;
            border: none;
            padding: 0.75rem 1.5rem;
            border-radius: 0.5rem;
            cursor: pointer;
            font-weight: 500;
          ">${newContractStep === 1 ? 'Cancel' : 'Back'}</button>
          
          <div style="display: flex; gap: 0.5rem;">
            ${newContractStep === 4 ? `
              <button onclick="openContractPreview()" style="
                background: #e0e7ff;
                color: #4338ca;
                border: none;
                padding: 0.75rem 1.5rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-weight: 500;
                display: flex;
                align-items: center;
                gap: 0.5rem;
              ">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/></svg>
                Preview Contract
              </button>
              <button onclick="saveContract(false)" style="
                background: #6b7280;
                color: white;
                border: none;
                padding: 0.75rem 1.5rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-weight: 500;
              ">Save as Draft</button>
              <button onclick="saveContract(true)" style="
                background: linear-gradient(135deg, #10b981 0%, #059669 100%);
                color: white;
                border: none;
                padding: 0.75rem 1.5rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-weight: 500;
              ">Create & Get Link</button>
            ` : (() => {
      // Check if current step is valid
      let isValid = true;
      if (newContractStep === 1) {
        // Step 1: Contract name and client info required
        isValid = newContractData.contractName && newContractData.contractName.trim() !== '' &&
          (newContractData.contactId ||
            (newContractData.clientName && newContractData.clientName.trim() !== '' &&
              newContractData.clientEmail && newContractData.clientEmail.trim() !== ''));
      } else if (newContractStep === 2) {
        // Step 2: At least one product/item required
        isValid = newContractData.lineItems && newContractData.lineItems.length > 0;
      }

      return `
              <div style="display: flex; flex-direction: column; align-items: flex-end; gap: 0.5rem;">
                <button onclick="setContractStep(${newContractStep + 1})" style="
                  background: ${isValid ? 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)' : '#cbd5e1'};
                  color: white;
                  border: none;
                  padding: 0.75rem 1.5rem;
                  border-radius: 0.5rem;
                  cursor: ${isValid ? 'pointer' : 'not-allowed'};
                  font-weight: 500;
                  ${!isValid ? 'opacity: 0.6;' : ''}
                " ${!isValid ? 'disabled' : ''}>Next</button>
                ${!isValid ? `
                  <div style="font-size: 0.75rem; color: #dc2626; text-align: right;">
                    ${newContractStep === 1 ? 'Please fill in all required fields' : 'Please add at least one product or item'}
                  </div>
                ` : ''}
              </div>
            `;
    })()}
          </div>
        </div>
      </div>
    </div>
  `;
}

// Render Product Modal
function renderProductModal() {
  if (!showProductModal) return '';

  return `
    <div style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1001;
      padding: 1rem;
    " onclick="closeProductModal()">
      <div style="
        background: white;
        border-radius: 1rem;
        width: 100%;
        max-width: 500px;
        box-shadow: 0 25px 50px rgba(0,0,0,0.25);
      " onclick="event.stopPropagation()">
        <div style="padding: 1.5rem; border-bottom: 1px solid #e2e8f0; display: flex; justify-content: space-between; align-items: center;">
          <h2 style="margin: 0; font-size: 1.25rem; font-weight: 600;">${editingProductId ? 'Edit Product' : 'New Product'}</h2>
          <button onclick="closeProductModal()" style="background: none; border: none; font-size: 1.5rem; cursor: pointer; color: #64748b;">&times;</button>
        </div>
        
        <div style="padding: 1.5rem; display: flex; flex-direction: column; gap: 1rem;">
          <div>
            <label style="display: block; margin-bottom: 0.5rem; font-weight: 500;">Name *</label>
            <input type="text" value="${productFormData.name}" oninput="productFormData.name = this.value" style="width: 100%; padding: 0.75rem; border: 1px solid #d1d5db; border-radius: 0.5rem; box-sizing: border-box;" />
          </div>
          <div>
            <label style="display: block; margin-bottom: 0.5rem; font-weight: 500;">SKU</label>
            <input type="text" value="${productFormData.sku}" oninput="productFormData.sku = this.value" style="width: 100%; padding: 0.75rem; border: 1px solid #d1d5db; border-radius: 0.5rem; box-sizing: border-box;" />
          </div>
          <div>
            <label style="display: block; margin-bottom: 0.5rem; font-weight: 500;">Description</label>
            <textarea oninput="productFormData.description = this.value" style="width: 100%; padding: 0.75rem; border: 1px solid #d1d5db; border-radius: 0.5rem; min-height: 80px; box-sizing: border-box; resize: vertical;">${productFormData.description}</textarea>
          </div>
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem;">
            <div>
              <label style="display: block; margin-bottom: 0.5rem; font-weight: 500;">Price</label>
              <input type="number" step="0.01" value="${productFormData.price}" oninput="productFormData.price = this.value" style="width: 100%; padding: 0.75rem; border: 1px solid #d1d5db; border-radius: 0.5rem; box-sizing: border-box;" />
            </div>
            <div>
              <label style="display: block; margin-bottom: 0.5rem; font-weight: 500;">Cost</label>
              <input type="number" step="0.01" value="${productFormData.cost}" oninput="productFormData.cost = this.value" style="width: 100%; padding: 0.75rem; border: 1px solid #d1d5db; border-radius: 0.5rem; box-sizing: border-box;" />
            </div>
          </div>
          <div>
            <label style="display: block; margin-bottom: 0.5rem; font-weight: 500;">Category</label>
            <select onchange="productFormData.category_id = this.value || null" style="width: 100%; padding: 0.75rem; border: 1px solid #d1d5db; border-radius: 0.5rem; box-sizing: border-box;">
              <option value="">No Category</option>
              ${productCategories.map(cat => `
                <option value="${cat.id}" ${productFormData.category_id === cat.id ? 'selected' : ''}>${cat.name}</option>
              `).join('')}
            </select>
          </div>
          <div style="display: flex; align-items: center; gap: 1rem; flex-wrap: wrap;">
            <label style="display: flex; align-items: center; gap: 0.5rem; cursor: pointer;">
              <input type="checkbox" ${productFormData.is_recurring ? 'checked' : ''} onchange="productFormData.is_recurring = this.checked; renderPMTool();" />
              <span>Recurring</span>
            </label>
            ${productFormData.is_recurring ? `
              <select onchange="productFormData.recurring_interval = this.value" style="padding: 0.5rem; border: 1px solid #d1d5db; border-radius: 0.25rem;">
                <option value="weekly" ${productFormData.recurring_interval === 'weekly' ? 'selected' : ''}>Weekly</option>
                <option value="monthly" ${productFormData.recurring_interval === 'monthly' ? 'selected' : ''}>Monthly</option>
                <option value="quarterly" ${productFormData.recurring_interval === 'quarterly' ? 'selected' : ''}>Quarterly</option>
                <option value="yearly" ${productFormData.recurring_interval === 'yearly' ? 'selected' : ''}>Yearly</option>
              </select>
            ` : ''}
            <label style="display: flex; align-items: center; gap: 0.5rem; cursor: pointer;">
              <input type="checkbox" ${productFormData.is_taxable ? 'checked' : ''} onchange="productFormData.is_taxable = this.checked;" />
              <span>Taxable</span>
            </label>
          </div>
        </div>
        
        <div style="padding: 1.5rem; border-top: 1px solid #e2e8f0; display: flex; justify-content: flex-end; gap: 0.5rem;">
          <button onclick="closeProductModal()" style="background: #f1f5f9; color: #64748b; border: none; padding: 0.75rem 1.5rem; border-radius: 0.5rem; cursor: pointer;">Cancel</button>
          <button onclick="saveProduct()" style="background: #ef4444; color: white; border: none; padding: 0.75rem 1.5rem; border-radius: 0.5rem; cursor: pointer; font-weight: 500;">Save</button>
        </div>
      </div>
    </div>
  `;
}

// Render Category Modal
function renderCategoryModal() {
  if (!showCategoryModal) return '';

  return `
    <div style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1001;
      padding: 1rem;
    " onclick="closeCategoryModal()">
      <div style="
        background: white;
        border-radius: 1rem;
        width: 100%;
        max-width: 450px;
        box-shadow: 0 25px 50px rgba(0,0,0,0.25);
      " onclick="event.stopPropagation()">
        <div style="padding: 1.5rem; border-bottom: 1px solid #e2e8f0; display: flex; justify-content: space-between; align-items: center;">
          <h2 style="margin: 0; font-size: 1.25rem; font-weight: 600;">${editingCategoryId ? 'Edit Category' : 'New Category'}</h2>
          <button onclick="closeCategoryModal()" style="background: none; border: none; font-size: 1.5rem; cursor: pointer; color: #64748b;">&times;</button>
        </div>
        
        <div style="padding: 1.5rem; display: flex; flex-direction: column; gap: 1rem;">
          <div>
            <label style="display: block; margin-bottom: 0.5rem; font-weight: 500;">Category Name *</label>
            <input type="text" value="${categoryFormData.name}" oninput="categoryFormData.name = this.value" placeholder="e.g., Websites, Video, Marketing" style="width: 100%; padding: 0.75rem; border: 1px solid #d1d5db; border-radius: 0.5rem; box-sizing: border-box;" />
          </div>
          <div>
            <label style="display: block; margin-bottom: 0.5rem; font-weight: 500;">Description (optional)</label>
            <textarea oninput="categoryFormData.description = this.value" placeholder="Brief description of this category" style="width: 100%; padding: 0.75rem; border: 1px solid #d1d5db; border-radius: 0.5rem; min-height: 80px; box-sizing: border-box; resize: vertical;">${categoryFormData.description || ''}</textarea>
          </div>
        </div>
        
        <div style="padding: 1.5rem; border-top: 1px solid #e2e8f0; display: flex; justify-content: flex-end; gap: 0.5rem;">
          <button onclick="closeCategoryModal()" style="background: #f1f5f9; color: #64748b; border: none; padding: 0.75rem 1.5rem; border-radius: 0.5rem; cursor: pointer;">Cancel</button>
          <button onclick="saveCategory()" style="background: #ef4444; color: white; border: none; padding: 0.75rem 1.5rem; border-radius: 0.5rem; cursor: pointer; font-weight: 500;">Save</button>
        </div>
      </div>
    </div>
  `;
}

// Render Clause Modal
function renderClauseModal() {
  if (!showClauseModal) return '';

  return `
    <div style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1001;
      padding: 1rem;
    " onclick="closeClauseModal()">
      <div style="
        background: white;
        border-radius: 1rem;
        width: 100%;
        max-width: 600px;
        max-height: 90vh;
        overflow-y: auto;
        box-shadow: 0 25px 50px rgba(0,0,0,0.25);
      " onclick="event.stopPropagation()">
        <div style="padding: 1.5rem; border-bottom: 1px solid #e2e8f0; display: flex; justify-content: space-between; align-items: center;">
          <h2 style="margin: 0; font-size: 1.25rem; font-weight: 600;">${editingClauseId ? 'Edit Clause' : 'New Clause'}</h2>
          <button onclick="closeClauseModal()" style="background: none; border: none; font-size: 1.5rem; cursor: pointer; color: #64748b;">&times;</button>
        </div>
        
        <div style="padding: 1.5rem; display: flex; flex-direction: column; gap: 1rem;">
          <div>
            <label style="display: block; margin-bottom: 0.5rem; font-weight: 500;">Title *</label>
            <input type="text" value="${clauseFormData.title}" oninput="clauseFormData.title = this.value" style="width: 100%; padding: 0.75rem; border: 1px solid #d1d5db; border-radius: 0.5rem; box-sizing: border-box;" />
          </div>
          <div>
            <label style="display: block; margin-bottom: 0.5rem; font-weight: 500;">Category</label>
            <select onchange="clauseFormData.category = this.value" style="width: 100%; padding: 0.75rem; border: 1px solid #d1d5db; border-radius: 0.5rem;">
              <option value="payment" ${clauseFormData.category === 'payment' ? 'selected' : ''}>Payment</option>
              <option value="scope" ${clauseFormData.category === 'scope' ? 'selected' : ''}>Scope</option>
              <option value="timeline" ${clauseFormData.category === 'timeline' ? 'selected' : ''}>Timeline</option>
              <option value="tech" ${clauseFormData.category === 'tech' ? 'selected' : ''}>Tech</option>
              <option value="cancellation" ${clauseFormData.category === 'cancellation' ? 'selected' : ''}>Cancellation</option>
              <option value="legal" ${clauseFormData.category === 'legal' ? 'selected' : ''}>Legal</option>
              <option value="other" ${clauseFormData.category === 'other' ? 'selected' : ''}>Other</option>
            </select>
          </div>
          <div>
            <label style="display: block; margin-bottom: 0.5rem; font-weight: 500;">Body *</label>
            <textarea oninput="clauseFormData.body = this.value" placeholder="Enter the clause text..." style="width: 100%; padding: 0.75rem; border: 1px solid #d1d5db; border-radius: 0.5rem; min-height: 150px; box-sizing: border-box; resize: vertical;">${clauseFormData.body}</textarea>
            <div style="margin-top: 0.5rem; padding: 0.75rem; background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 0.5rem; font-size: 0.875rem; color: #1e40af;">
              <div style="font-weight: 600; margin-bottom: 0.25rem; display: flex; align-items: center; gap: 0.5rem;">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>
                Placeholder Variables
              </div>
              <div style="line-height: 1.6;">
                Use <strong>[company]</strong> to auto-populate the client's company name.<br>
                Use <strong>[client]</strong> to auto-populate the client's full name (first and last name).
              </div>
            </div>
          </div>
          <label style="display: flex; align-items: center; gap: 0.5rem; cursor: pointer;">
            <input type="checkbox" ${clauseFormData.is_default ? 'checked' : ''} onchange="clauseFormData.is_default = this.checked" />
            <span>Include by default in new contracts</span>
          </label>
        </div>
        
        <div style="padding: 1.5rem; border-top: 1px solid #e2e8f0; display: flex; justify-content: flex-end; gap: 0.5rem;">
          <button onclick="closeClauseModal()" style="background: #f1f5f9; color: #64748b; border: none; padding: 0.75rem 1.5rem; border-radius: 0.5rem; cursor: pointer;">Cancel</button>
          <button onclick="saveClause()" style="background: #ef4444; color: white; border: none; padding: 0.75rem 1.5rem; border-radius: 0.5rem; cursor: pointer; font-weight: 500;">Save</button>
        </div>
      </div>
    </div>
  `;
}

// Render Contract Link Modal
function renderContractLinkModal() {
  if (!showContractLink) return '';

  return `
    <div style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1002;
      padding: 1rem;
    " onclick="closeContractLinkModal()">
      <div style="
        background: white;
        border-radius: 1rem;
        width: 100%;
        max-width: 500px;
        box-shadow: 0 25px 50px rgba(0,0,0,0.25);
        animation: slideUp 0.2s ease-out;
      " onclick="event.stopPropagation()">
        <div style="padding: 2rem; text-align: center;">
          <div style="
            width: 64px;
            height: 64px;
            background: linear-gradient(135deg, #10b981 0%, #059669 100%);
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto 1.5rem;
          ">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="white"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
          </div>
          
          <h2 style="margin: 0 0 0.5rem; font-size: 1.5rem; font-weight: 600; color: #1e293b;">Contract Created!</h2>
          <p style="margin: 0 0 1.5rem; color: #64748b;">${contractLinkData.contractName}</p>
          
          <div style="margin-bottom: 1.5rem;">
            <label style="display: block; margin-bottom: 0.5rem; font-weight: 500; color: #374151; text-align: left;">Signing Link</label>
            <div style="display: flex; gap: 0.5rem;">
              <input 
                type="text" 
                id="contract-link-input"
                value="${contractLinkData.link}" 
                readonly 
                style="
                  flex: 1;
                  padding: 0.75rem;
                  border: 1px solid #d1d5db;
                  border-radius: 0.5rem;
                  font-size: 0.875rem;
                  background: #f8fafc;
                  color: #1e293b;
                "
                onclick="this.select()"
              />
              <button onclick="copyContractLinkFromModal()" style="
                background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
                color: white;
                border: none;
                padding: 0.75rem 1rem;
                border-radius: 0.5rem;
                cursor: pointer;
                font-weight: 500;
                display: flex;
                align-items: center;
                gap: 0.5rem;
                white-space: nowrap;
              ">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/></svg>
                Copy
              </button>
            </div>
          </div>
          
          <p style="margin: 0 0 1.5rem; font-size: 0.875rem; color: #64748b;">
            Share this link with your client to sign the contract. The link expires in 14 days.
          </p>
          
          <button onclick="closeContractLinkModal()" style="
            background: #10b981;
            color: white;
            border: none;
            padding: 0.75rem 2rem;
            border-radius: 0.5rem;
            cursor: pointer;
            font-weight: 500;
            font-size: 1rem;
          ">Done</button>
        </div>
      </div>
    </div>
  `;
}

// Render Settings Confirmation Modal
function renderSettingsConfirmModal() {
  if (!showSettingsConfirmModal) return '';

  return `
    <div style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1003;
      padding: 1rem;
    " onclick="closeSettingsConfirmModal()">
      <div style="
        background: white;
        border-radius: 1rem;
        width: 100%;
        max-width: 450px;
        box-shadow: 0 25px 50px rgba(0,0,0,0.25);
      " onclick="event.stopPropagation()">
        <div style="padding: 1.5rem; border-bottom: 1px solid #e2e8f0; display: flex; justify-content: space-between; align-items: center;">
          <h2 style="margin: 0; font-size: 1.25rem; font-weight: 600; color: #1e293b;">Confirm Changes</h2>
          <button onclick="closeSettingsConfirmModal()" style="background: none; border: none; font-size: 1.5rem; cursor: pointer; color: #64748b;">&times;</button>
        </div>
        
        <div style="padding: 1.5rem;">
          <p style="margin: 0 0 1.5rem; color: #64748b; font-size: 0.875rem; line-height: 1.5;">
            ${settingsConfirmMessage || 'Are you sure you want to make this change?'}
          </p>
          
          <div style="display: flex; gap: 0.5rem;">
            <button onclick="closeSettingsConfirmModal()" style="
              flex: 1;
              background: #f1f5f9;
              color: #64748b;
              border: none;
              padding: 0.75rem;
              border-radius: 0.5rem;
              cursor: pointer;
              font-weight: 500;
            ">Cancel</button>
            <button onclick="confirmSettingsAction()" style="
              flex: 1;
              background: #ef4444;
              color: white;
              border: none;
              padding: 0.75rem;
              border-radius: 0.5rem;
              cursor: pointer;
              font-weight: 500;
            ">Confirm</button>
          </div>
        </div>
      </div>
    </div>
  `;
}

// Render Tax Rate Modal
function renderTaxRateModal() {
  if (!showTaxRateModal) return '';

  return `
    <div style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,0.5);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1002;
      padding: 1rem;
    " onclick="closeTaxRateModal()">
      <div style="
        background: white;
        border-radius: 1rem;
        width: 100%;
        max-width: 400px;
        box-shadow: 0 25px 50px rgba(0,0,0,0.25);
      " onclick="event.stopPropagation()">
        <div style="padding: 1.5rem; border-bottom: 1px solid #e2e8f0; display: flex; justify-content: space-between; align-items: center;">
          <h2 style="margin: 0; font-size: 1.25rem; font-weight: 600;">Global Tax Rate</h2>
          <button onclick="closeTaxRateModal()" style="background: none; border: none; font-size: 1.5rem; cursor: pointer; color: #64748b;">&times;</button>
        </div>
        
        <div style="padding: 1.5rem;">
          <p style="margin: 0 0 1rem; color: #64748b; font-size: 0.875rem;">
            Set the global tax rate for your entire company. This rate will be automatically applied to all new contracts. Only owners and managers can change this setting.
          </p>
          
          <div style="margin-bottom: 1.5rem;">
            <label style="display: block; margin-bottom: 0.5rem; font-weight: 500;">Tax Rate (%)</label>
            <div style="display: flex; align-items: center; gap: 0.5rem;">
              <input 
                type="number" 
                id="global-tax-rate-input"
                value="${globalTaxRate}" 
                step="0.01"
                min="0"
                max="100"
                style="
                  flex: 1;
                  padding: 0.75rem;
                  border: 1px solid #d1d5db;
                  border-radius: 0.5rem;
                  font-size: 1.25rem;
                  text-align: center;
                "
              />
              <span style="font-size: 1.25rem; color: #64748b;">%</span>
            </div>
          </div>
          
          <div style="display: flex; gap: 0.5rem;">
            <button onclick="closeTaxRateModal()" style="
              flex: 1;
              background: #f1f5f9;
              color: #64748b;
              border: none;
              padding: 0.75rem;
              border-radius: 0.5rem;
              cursor: pointer;
              font-weight: 500;
            ">Cancel</button>
            <button onclick="saveGlobalTaxRate(document.getElementById('global-tax-rate-input').value)" style="
              flex: 1;
              background: #10b981;
              color: white;
              border: none;
              padding: 0.75rem;
              border-radius: 0.5rem;
              cursor: pointer;
              font-weight: 500;
            ">Save</button>
          </div>
        </div>
      </div>
    </div>
  `;
}

// Render Void Confirmation Modal
function renderVoidConfirmModal() {
  if (!showVoidConfirmModal) return '';

  const contract = contractsList.find(c => c.id === voidContractId);
  const contractName = contract ? contract.name || 'Untitled Contract' : 'this contract';

  return `
    <div style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,0.6);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1004;
      padding: 1rem;
    " onclick="closeVoidConfirm()">
      <div style="
        background: white;
        border-radius: 1rem;
        width: 100%;
        max-width: 420px;
        box-shadow: 0 25px 50px rgba(0,0,0,0.3);
        animation: slideUp 0.2s ease-out;
      " onclick="event.stopPropagation()">
        <!-- Header -->
        <div style="padding: 1.5rem; border-bottom: 1px solid #e2e8f0; display: flex; align-items: center; gap: 0.75rem;">
          <div style="
            width: 48px;
            height: 48px;
            background: #fee2e2;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
          ">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="#dc2626"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>
          </div>
          <div style="flex: 1;">
            <h2 style="margin: 0; font-size: 1.25rem; font-weight: 600; color: #1e293b;">Void Contract?</h2>
            <p style="margin: 0.25rem 0 0; font-size: 0.875rem; color: #64748b;">This action cannot be undone</p>
          </div>
          <button onclick="closeVoidConfirm()" style="
            background: none;
            border: none;
            font-size: 1.5rem;
            cursor: pointer;
            color: #64748b;
            padding: 0;
            width: 32px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 0.375rem;
            transition: background 0.2s;
          " onmouseover="this.style.background='#f1f5f9'" onmouseout="this.style.background='transparent'">&times;</button>
        </div>
        
        <!-- Body -->
        <div style="padding: 1.5rem;">
          <p style="margin: 0 0 1rem; color: #475569; line-height: 1.6;">
            Are you sure you want to void <strong>${contractName}</strong>? This action cannot be undone and the contract will be marked as voided.
          </p>
          <div style="
            background: #fef2f2;
            border: 1px solid #fecaca;
            border-radius: 0.5rem;
            padding: 0.75rem;
            margin-bottom: 1rem;
          ">
            <div style="display: flex; align-items: start; gap: 0.5rem;">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="#dc2626" style="flex-shrink: 0; margin-top: 0.125rem;"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/></svg>
              <div style="font-size: 0.875rem; color: #991b1b;">
                <strong>Warning:</strong> Voiding a contract is permanent and cannot be reversed.
              </div>
            </div>
          </div>
        </div>
        
        <!-- Footer -->
        <div style="padding: 1rem 1.5rem; border-top: 1px solid #e2e8f0; display: flex; gap: 0.75rem; justify-content: flex-end;">
          <button onclick="closeVoidConfirm()" style="
            background: #f1f5f9;
            color: #64748b;
            border: none;
            padding: 0.75rem 1.5rem;
            border-radius: 0.5rem;
            cursor: pointer;
            font-weight: 500;
            transition: all 0.2s;
          " onmouseover="this.style.background='#e2e8f0'" onmouseout="this.style.background='#f1f5f9'">Cancel</button>
          <button onclick="voidContract()" style="
            background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
            color: white;
            border: none;
            padding: 0.75rem 1.5rem;
            border-radius: 0.5rem;
            cursor: pointer;
            font-weight: 500;
            transition: all 0.2s;
            display: flex;
            align-items: center;
            gap: 0.5rem;
          " onmouseover="this.style.opacity='0.9'" onmouseout="this.style.opacity='1'">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
            Void Contract
          </button>
        </div>
      </div>
    </div>
  `;
}

// ============================================
// VAULT (DOCUMENTS) SCREEN
// ============================================

// State persistence
if (!window.vaultExpandedSections) window.vaultExpandedSections = new Set(['Projects']);
if (!window.vaultSearchQuery) window.vaultSearchQuery = '';

// Helper to update DOM directly avoids full re-render lag
window.refreshVaultUI = async function () {
  const container = document.getElementById('vault-main-container');
  if (container && container.parentNode) {
    try {
      const newContent = await window.renderVaultScreen();
      const temp = document.createElement('div');
      temp.innerHTML = newContent;
      const newContainer = temp.firstElementChild; // Assuming renderVaultScreen returns the wrapper
      if (newContainer && newContainer.id === 'vault-main-container') {
        // Use replaceChild for better compatibility
        container.parentNode.replaceChild(newContainer, container);
        // Force a small delay to ensure DOM is updated
        await new Promise(resolve => setTimeout(resolve, 0));
        // Remove root drop zone if present (e.g. cached or list view)
        const rootDrop = document.getElementById('vault-root-drop');
        if (rootDrop) rootDrop.remove();
        // Load image thumbnails after DOM is ready
        if (window.loadVaultImageThumbnails) {
          window.loadVaultImageThumbnails();
        }
        return;
      }
    } catch (e) {
      console.error("Error refreshing vault UI:", e);
      // Fallback to full render on error
      if (window.renderPMTool) window.renderPMTool();
    }
  } else {
    // Fallback to full render if container not found
    if (window.renderPMTool) window.renderPMTool();
  }
}

window.toggleVaultSection = function (section) {
  if (window.vaultExpandedSections.has(section)) {
    window.vaultExpandedSections.delete(section);
  } else {
    window.vaultExpandedSections.add(section);
  }
  window.refreshVaultUI();
}

// Debounce timer for search
window.vaultSearchTimeout = null;

window.setVaultSearch = function (query) {
  window.vaultSearchQuery = query;

  // Clear previous timeout
  if (window.vaultSearchTimeout) {
    clearTimeout(window.vaultSearchTimeout);
  }

  // Debounce: wait 300ms after user stops typing before refreshing
  window.vaultSearchTimeout = setTimeout(async () => {
    await window.refreshVaultUI();
    // Restore focus to search input after refresh
    const searchInput = document.querySelector('#vault-main-container input[placeholder*="Search"]');
    if (searchInput) {
      searchInput.focus();
      // Move cursor to end of input
      searchInput.setSelectionRange(searchInput.value.length, searchInput.value.length);
    }
  }, 300);
}

// Modern vault toast (bottom-right, auto-dismiss)
window.vaultToast = function (message, type) {
  type = type || 'success';
  const bg = type === 'success' ? '#10b981' : type === 'error' ? '#ef4444' : '#1f2937';
  const el = document.createElement('div');
  el.className = 'vault-toast';
  el.style.cssText = 'position:fixed; bottom:24px; right:24px; padding:14px 20px; border-radius:10px; color:#fff; font-size:14px; font-weight:500; z-index:10001; box-shadow:0 10px 40px rgba(0,0,0,0.15); display:flex; align-items:center; gap:10px; animation:vaultToastIn 0.25s ease;';
  el.style.background = bg;
  el.innerHTML = `<span>${String(message).replace(/</g, '&lt;')}</span>`;
  document.body.appendChild(el);
  setTimeout(function () { el.style.animation = 'vaultToastOut 0.2s ease forwards'; setTimeout(function () { el.remove(); }, 200); }, 3200);
};

// Modern vault confirm modal (replace confirm())
window.vaultConfirm = function (opts, onConfirm, onCancel) {
  const t = opts.title || 'Confirm';
  const msg = opts.message || '';
  const confirmText = opts.confirmText || 'Confirm';
  const cancelText = opts.cancelText || 'Cancel';
  const danger = opts.danger !== false;
  const overlay = document.createElement('div');
  overlay.id = 'vault-confirm-overlay';
  overlay.style.cssText = 'position:fixed; inset:0; background:rgba(0,0,0,0.45); z-index:10002; display:flex; align-items:center; justify-content:center; padding:16px;';
  overlay.innerHTML = `
    <div id="vault-confirm-dialog" style="background:#fff; border-radius:16px; max-width:400px; width:100%; padding:24px; box-shadow:0 25px 50px -12px rgba(0,0,0,0.25);" onclick="event.stopPropagation()">
      <div style="font-size:18px; font-weight:600; color:#111827; margin-bottom:12px;">${String(t).replace(/</g, '&lt;')}</div>
      <div style="font-size:14px; color:#6b7280; line-height:1.5; margin-bottom:24px;">${String(msg).replace(/</g, '&lt;').replace(/\n/g, '<br>')}</div>
      <div style="display:flex; gap:12px; justify-content:flex-end;">
        <button id="vault-confirm-cancel" style="padding:10px 18px; border:1px solid #e5e7eb; background:#fff; border-radius:8px; font-weight:500; color:#374151; cursor:pointer;">${String(cancelText).replace(/</g, '&lt;')}</button>
        <button id="vault-confirm-ok" style="padding:10px 18px; border:none; background:${danger ? '#ef4444' : '#f59e0b'}; color:#fff; border-radius:8px; font-weight:500; cursor:pointer;">${String(confirmText).replace(/</g, '&lt;')}</button>
      </div>
    </div>
  `;
  overlay.onclick = function (e) { if (e.target === overlay) { overlay.remove(); if (onCancel) onCancel(); } };
  document.body.appendChild(overlay);
  document.getElementById('vault-confirm-cancel').onclick = function () { overlay.remove(); if (onCancel) onCancel(); };
  document.getElementById('vault-confirm-ok').onclick = function () { overlay.remove(); if (onConfirm) onConfirm(); };
};

// Inject toast keyframes and spinner animation once
if (!document.getElementById('vault-toast-styles')) {
  const s = document.createElement('style');
  s.id = 'vault-toast-styles';
  s.textContent = '@keyframes vaultToastIn{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:translateY(0)}}@keyframes vaultToastOut{from{opacity:1;transform:translateY(0)}to{opacity:0;transform:translateY(8px)}}@keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}';
  document.head.appendChild(s);
}

// Load image thumbnails after vault renders
window.loadVaultImageThumbnails = async function () {
  const thumbContainers = document.querySelectorAll('.vault-file-thumb[data-is-image="true"]');
  for (const container of thumbContainers) {
    const storagePath = container.dataset.storagePath;
    if (!storagePath) continue;

    const img = container.querySelector('.vault-thumb-img');
    if (!img || img.src) continue; // Already loaded

    try {
      const url = await window.getVaultFileSignedUrl(storagePath);
      if (url && img) {
        img.src = url;
      }
    } catch (e) {
      console.error('Error loading thumbnail:', e);
    }
  }
};

// Main Render Function
window.renderVaultScreen = async function () {
  if (!currentCompany || !currentUser) {
    return `
      <div style="display: flex; align-items: center; justify-content: center; min-height: 400px; padding: 2rem;">
        <div style="text-align: center; color: #6b7280;">
          <p style="font-size: 1rem; margin-bottom: 0.5rem;">Unable to load documents.</p>
          <p style="font-size: 0.875rem;">Please refresh the page or try again later.</p>
        </div>
      </div>`;
  }

  // Ensure vault UI state exists so buildSidebar/template never throw
  if (!window.vaultExpandedSections) window.vaultExpandedSections = new Set(['Projects']);
  if (window.vaultSearchQuery === undefined) window.vaultSearchQuery = '';

  let vaultHtml;
  try {
    // 1. Load Data
    const userRole = currentProfile?.company_role || currentProfile?.role || 'USER';
    const isVaultClient = userRole === 'CLIENT';
    // Clients cannot use Trash or Shared views: force home
    if (isVaultClient && (vaultView === 'trash' || vaultView === 'shared')) {
      vaultView = 'home';
      vaultCurrentFolderId = null;
      vaultBreadcrumbs = [];
      window.vaultCurrentFolderId = null;
    }
    if (vaultView === 'home' && !vaultCurrentFolderId && !isVaultClient) {
      await loadVaultQuickStats();
    }

    // We need ALL folders for the sidebar tree structure (only when not in trash; in trash we hide the tree)
    // Also load user's folder permissions to filter by access
    const foldersPromise = supabase.from('vault_folders')
      .select('*')
      .eq('company_id', currentCompany.id)
      .order('name');

    // Load current user's folder permissions
    const permissionsPromise = supabase.from('vault_permissions')
      .select('item_id, permission_level')
      .eq('company_id', currentCompany.id)
      .eq('item_type', 'folder')
      .eq('user_id', currentUser?.id);

    const filesPromise = vaultView === 'trash'
      ? supabase.from('vault_files').select('*').eq('company_id', currentCompany.id).eq('is_deleted', true).order('name').then(r => r.data || [])
      : vaultView === 'recent'
        // Recent view: load ALL non-deleted files from ALL folders, ordered by created_at
        ? supabase.from('vault_files').select('*').eq('company_id', currentCompany.id).eq('is_deleted', false).order('created_at', { ascending: false }).limit(50).then(r => r.data || [])
        : loadVaultFiles(vaultCurrentFolderId, false);

    const deletedFoldersPromise = vaultView === 'trash'
      ? supabase.from('vault_folders').select('*').eq('company_id', currentCompany.id).eq('is_deleted', true).order('name').then(r => r.data || [])
      : Promise.resolve([]);

    const [foldersResult, permissionsResult, files, deletedFoldersTrash] = await Promise.all([foldersPromise, permissionsPromise, filesPromise, deletedFoldersPromise]);
    const allFolders = foldersResult.data || [];
    const userPermissions = permissionsResult.data || [];

    // Build a map of folder_id -> permission_level for quick lookup
    const permissionMap = {};
    userPermissions.forEach(p => {
      permissionMap[p.item_id] = p.permission_level;
    });

    // Filter folders: user sees only folders they created (owner) OR were given access via Manage access (vault_permissions)
    const folders = allFolders.map(f => ({
      ...f,
      userPermission: f.created_by === currentUser?.id ? 'owner' : (permissionMap[f.id] || null)
    })).filter(f => f.userPermission != null);

    let currentViewFiles = vaultView === 'trash' ? (files || []) : (files || []);
    const currentViewFoldersRaw = vaultView === 'trash' ? (deletedFoldersTrash || []) : null;

    // For recent view: filter files to only those from accessible folders
    if (vaultView === 'recent') {
      // Build set of accessible folder IDs (folders user created OR has permission for)
      const accessibleFolderIds = new Set(folders.map(f => f.id));
      // Clients: only files inside folders they have access to (no root files). Others: include root if owned.
      currentViewFiles = currentViewFiles.filter(f => {
        if (!f.folder_id) {
          if (isVaultClient) return false;
          return f.created_by === currentUser?.id;
        }
        return accessibleFolderIds.has(f.folder_id);
      });
    }

    // Current Folder Files/Subfolders (for home: by folder; for trash: already set above)
    let currentViewFolders = [];
    if (vaultView === 'trash') {
      currentViewFolders = currentViewFoldersRaw || [];
    } else if (vaultView === 'home') {
      if (vaultCurrentFolderId) {
        currentViewFolders = folders.filter(f => f.parent_id === vaultCurrentFolderId && !f.is_deleted);
      } else {
        currentViewFolders = folders.filter(f => !f.parent_id && !f.is_deleted);
      }
      // Clients never see root-level files (only files inside folders they have access to)
      if (isVaultClient && !vaultCurrentFolderId) currentViewFiles = [];
    } else if (vaultView === 'recent') {
      currentViewFolders = [];
    }
    // Clients in trash: only see trashed items from folders they have access to
    if (isVaultClient && vaultView === 'trash') {
      const accessibleFolderIds = new Set(folders.map(f => f.id));
      currentViewFiles = currentViewFiles.filter(f => f.folder_id && accessibleFolderIds.has(f.folder_id));
      currentViewFolders = (currentViewFolders || []).filter(f => permissionMap[f.id] != null);
    }

    // Apply search filter if there's a search query
    const searchQuery = (window.vaultSearchQuery || '').trim().toLowerCase();
    if (searchQuery) {
      // Filter files by name
      currentViewFiles = currentViewFiles.filter(f =>
        (f.name || '').toLowerCase().includes(searchQuery)
      );
      // Filter folders by name (only in home view where folders are shown)
      if (vaultView === 'home' || vaultView === 'trash') {
        currentViewFolders = currentViewFolders.filter(f =>
          (f.name || '').toLowerCase().includes(searchQuery)
        );
      }
    }

    // Apply sort (works for home, recent, trash, search)
    const sortCompare = (a, b, by, dir) => {
      let va, vb;
      if (by === 'name') {
        va = (a.name || '').toLowerCase();
        vb = (b.name || '').toLowerCase();
        return dir === 'asc' ? (va < vb ? -1 : va > vb ? 1 : 0) : (va > vb ? -1 : va < vb ? 1 : 0);
      }
      if (by === 'modified') {
        va = new Date(a.created_at || a.updated_at || 0).getTime();
        vb = new Date(b.created_at || b.updated_at || 0).getTime();
        return dir === 'desc' ? vb - va : va - vb;
      }
      if (by === 'size') {
        va = a.size_bytes != null ? a.size_bytes : 0;
        vb = b.size_bytes != null ? b.size_bytes : 0;
        return dir === 'desc' ? vb - va : va - vb;
      }
      return 0;
    };
    currentViewFolders = [...(currentViewFolders || [])].sort((a, b) => {
      if (vaultSortBy === 'size') return sortCompare(a, b, 'name', 'asc'); // Folders by name when sorting by size
      return sortCompare(a, b, vaultSortBy, vaultSortDir);
    });
    currentViewFiles = [...(currentViewFiles || [])].sort((a, b) => sortCompare(a, b, vaultSortBy, vaultSortDir));

    // Fetch creator names for "Uploaded by" display
    let vaultCreatorNames = {};
    const creatorIds = [...new Set((currentViewFiles || []).map(f => f.created_by).filter(Boolean))];
    if (creatorIds.length > 0) {
      try {
        const { data: profilesData } = await supabase.from('profiles').select('id, first_name, last_name').in('id', creatorIds);
        if (profilesData) {
          profilesData.forEach(p => {
            vaultCreatorNames[p.id] = { first_name: p.first_name || '', last_name: p.last_name || '' };
          });
        }
      } catch (e) {
        console.warn('Vault: could not load creator names', e);
      }
    }

    // Breadcrumbs
    if (vaultCurrentFolderId) {
      await loadVaultBreadcrumbs(vaultCurrentFolderId);
      // Auto-expand all parent folders in the breadcrumb path so the tree shows the current location
      vaultBreadcrumbs.forEach(function (b) {
        if (b.id !== vaultCurrentFolderId) {
          window.vaultExpandedSections.add(b.id);
        }
      });
    } else {
      vaultBreadcrumbs = [];
    }

    // 2. Build Sidebar
    const buildSidebar = () => {
      // Sidebar folder tree ALWAYS shows non-deleted folders (even when in trash view)
      const renderFolderTree = (parentId, level) => {
        if (parentId === undefined) parentId = null;
        if (level === undefined) level = 0;
        const children = folders.filter(f => f.parent_id === parentId && !f.is_deleted);
        if (children.length === 0) return '';

        return children.map(f => {
          const isExpanded = window.vaultExpandedSections.has(f.id);
          const isActive = vaultCurrentFolderId === f.id;
          const hasChildren = folders.some(sub => sub.parent_id === f.id && !sub.is_deleted);

          return (
            '<div class="vault-folder-block" style="margin-left: ' + (level * 16) + 'px; margin-bottom: 2px;">' +
            '<div class="vault-folder-row" style="display: flex; align-items: center; padding: 6px 8px; cursor: pointer; border-radius: 6px; color: ' + (isActive ? '#111827' : '#4b5563') + '; background: ' + (isActive ? '#f3f4f6' : 'transparent') + '; font-size: 14px;">' +
            (hasChildren
              ? '<div class="vault-folder-chevron" onclick="event.stopPropagation(); window.toggleVaultSection(\'' + f.id + '\')" style="min-width: 24px; height: 24px; margin-right: 4px; cursor: pointer; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">' +
              '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="transform: ' + (isExpanded ? 'rotate(90deg)' : 'rotate(0deg)') + '; transition: transform 0.2s;"><polyline points="9 18 15 12 9 6"></polyline></svg>' +
              '</div>'
              : '<div style="width: 24px; margin-right: 4px; flex-shrink: 0;"></div>') +
            '<div onclick="event.stopPropagation(); window.navigateVaultFolder(\'' + f.id + '\')" style="display: flex; align-items: center; flex: 1; min-width: 0;">' +
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-right: 8px; color: #f59e0b; flex-shrink: 0;"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>' +
            '<span style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">' + (f.name || '').replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</span>' +
            '</div>' +
            '</div>' +
            (isExpanded ? '<div class="vault-folder-children" style="display: block;">' + renderFolderTree(f.id, level + 1) + '</div>' : '') +
            '</div>'
          );
        }).join('');
      };

      return `
        <div style="width: 260px; background: #fff; border-right: 1px solid #e5e7eb; display: flex; flex-direction: column; height: 100%;">
            <div style="padding: 24px; padding-bottom: 12px;">
                <h1 style="font-size: 20px; font-weight: 700; margin: 0 0 16px 0; color: #111827;">Document Hub</h1>
                ${!isVaultClient ? `<button onclick="window.openDocWizard()" style="width: 100%; background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%); color: white; border: none; padding: 12px; border-radius: 8px; font-weight: 600; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 10px; transition: all 0.2s;" onmouseover="this.style.transform='translateY(-1px)'; this.style.boxShadow='0 4px 12px rgba(245,158,11,0.3)'" onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='none'">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="12" y1="18" x2="12" y2="12"></line><line x1="9" y1="15" x2="15" y2="15"></line></svg>
                    Generate Document
                    <span style="font-size: 10px; background: rgba(255,255,255,0.2); padding: 2px 6px; border-radius: 4px; font-weight: 600;">AI</span>
                </button>` : ''}
            </div>
            
            <div style="flex: 1; overflow-y: auto; padding: 0 12px;">
                <!-- Main Nav (clients: no "Shared with me") -->
                <div style="margin-bottom: 24px;">
                    ${[
          { id: 'home', icon: '<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>', label: 'Home' },
          { id: 'recent', icon: '<circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline>', label: 'Recent' },
          { id: 'shared', icon: '<circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>', label: 'Shared with me' }
        ].filter(item => !isVaultClient || item.id !== 'shared').map(item => `
                        <div onclick="window.switchVaultView('${item.id}')" 
                             style="display: flex; align-items: center; padding: 8px 12px; cursor: pointer; border-radius: 6px; margin-bottom: 4px; color: ${vaultView === item.id ? '#111827' : '#4b5563'}; background: ${vaultView === item.id ? '#f3f4f6' : 'transparent'}; font-weight: ${vaultView === item.id ? '600' : '400'};">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-right: 12px;">${item.icon}</svg>
                            ${item.label}
                        </div>
                    `).join('')}
                </div>

                <!-- Folders Tree: always show non-deleted folders regardless of view -->
                <div id="vault-folders-section" style="margin-bottom: 24px;">
                    <div style="display: flex; align-items: center; justify-content: space-between; padding: 0 12px; margin-bottom: 8px;">
                        <span style="font-size: 11px; font-weight: 600; color: #9ca3af; letter-spacing: 1px;">FOLDERS</span>
                        ${!isVaultClient ? `<svg onclick="window.showVaultNewFolderModal(null)" style="cursor: pointer; color: #9ca3af;" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>` : ''}
                    </div>
                    <div id="vault-folders-tree" style="display: flex; flex-direction: column; gap: 0;">
                        ${renderFolderTree(null)}
                    </div>
                </div>
            </div>

            <!-- Bottom Nav (Trash hidden for clients) -->
            ${!isVaultClient ? `
            <div style="padding: 16px 12px; border-top: 1px solid #e5e7eb;">
                <div onclick="window.switchVaultView('trash')" style="display: flex; align-items: center; padding: 8px 12px; cursor: pointer; border-radius: 6px; color: ${vaultView === 'trash' ? '#ef4444' : '#4b5563'}; background: ${vaultView === 'trash' ? '#fee2e2' : 'transparent'}; font-size: 14px;">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-right: 12px;"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                    Trash
                </div>
            </div>
            ` : ''}
        </div>`;
    };

    // 3. Build Main Content
    setTimeout(() => {
      if (window.loadVaultImageThumbnails) {
        window.loadVaultImageThumbnails();
      }
    }, 100);

    vaultHtml = `
    <div id="vault-main-container" style="display: flex; height: 100%; background: #f9fafb; overflow: hidden;">
        ${buildSidebar()}
        
        <div style="flex: 1; display: flex; flex-direction: column; overflow: hidden;">
            <!-- Top Bar -->
            <div style="height: 64px; border-bottom: 1px solid #e5e7eb; background: #fff; display: flex; align-items: center; justify-content: space-between; padding: 0 24px;">
                 <div style="position: relative; width: 400px;">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="2" style="position: absolute; left: 12px; top: 50%; transform: translateY(-50%); pointer-events: none;"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                    <input id="vault-search-input" type="text" placeholder="Search files and folders..." 
                           value="${(window.vaultSearchQuery || '').replace(/"/g, '&quot;')}"
                           oninput="window.setVaultSearch(this.value)"
                           style="width: 100%; padding: 10px ${searchQuery ? '36px' : '10px'} 10px 40px; border: 1px solid ${searchQuery ? '#f59e0b' : '#e5e7eb'}; border-radius: 8px; background: ${searchQuery ? '#fff' : '#f9fafb'}; outline: none; transition: border-color 0.2s;"
                           onfocus="this.style.borderColor='#f59e0b'; this.style.background='#fff'"
                           onblur="if(!window.vaultSearchQuery) { this.style.borderColor='#e5e7eb'; this.style.background='#f9fafb'; }" />
                    ${searchQuery ? `<button onclick="window.vaultSearchQuery=''; window.refreshVaultUI();" style="position: absolute; right: 8px; top: 50%; transform: translateY(-50%); background: #9ca3af; border: none; color: white; width: 20px; height: 20px; border-radius: 50%; cursor: pointer; font-size: 14px; display: flex; align-items: center; justify-content: center; line-height: 1;" title="Clear search">×</button>` : ''}
                 </div>
                 
                 <div style="display: flex; align-items: center; gap: 12px;">
                 </div>
            </div>

            <!-- Content -->
            <div style="flex: 1; overflow-y: auto; padding: 24px;">
                
                <!-- Breadcrumbs & Actions -->
                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 24px;">
                    <div>
                        ${searchQuery ? `
                        <div style="font-size: 14px; color: #6b7280; margin-bottom: 4px;">Search Results</div>
                        <div style="font-size: 24px; font-weight: 700; color: #111827;">
                            "${(window.vaultSearchQuery || '').replace(/</g, '&lt;')}"
                            <span style="font-size: 14px; font-weight: 400; color: #6b7280; margin-left: 8px;">${currentViewFolders.length + currentViewFiles.length} result${currentViewFolders.length + currentViewFiles.length !== 1 ? 's' : ''}</span>
                        </div>
                        ` : vaultView === 'trash' ? `
                        <div style="font-size: 14px; color: #6b7280; margin-bottom: 4px;">Trash</div>
                        <div style="font-size: 24px; font-weight: 700; color: #111827;">All deleted files and folders</div>
                        ` : vaultView === 'recent' ? `
                        <div style="font-size: 14px; color: #6b7280; margin-bottom: 4px;">Recent</div>
                        <div style="font-size: 24px; font-weight: 700; color: #111827;">Recently uploaded files</div>
                        ` : vaultView === 'shared' ? `
                        <div style="font-size: 14px; color: #6b7280; margin-bottom: 4px;">Shared</div>
                        <div style="font-size: 24px; font-weight: 700; color: #111827;">Files shared with me</div>
                        ` : `
                        <div style="font-size: 14px; color: #6b7280; margin-bottom: 4px;">My Files</div>
                        <div style="font-size: 24px; font-weight: 700; color: #111827; display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
                            ${vaultCurrentFolderId ? `
                            <button type="button" onclick="window.navigateVaultFolder(${vaultBreadcrumbs.length > 1 && vaultBreadcrumbs[vaultBreadcrumbs.length - 2] ? "'" + (vaultBreadcrumbs[vaultBreadcrumbs.length - 2].id || '') + "'" : 'null'})" style="display: inline-flex; align-items: center; gap: 6px; padding: 6px 12px; margin-right: 8px; background: #fef3c7; color: #b45309; border: 1px solid #f59e0b; border-radius: 8px; cursor: pointer; font-weight: 600; font-size: 14px;" onmouseover="this.style.background='#fde68a'" onmouseout="this.style.background='#fef3c7'" title="Back to parent folder">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>
                                Back
                            </button>
                            ` : ''}
                            <span onclick="window.navigateVaultFolder(null)" style="cursor: pointer; opacity: ${vaultCurrentFolderId ? '0.7' : '1'}; transition: opacity 0.2s;" onmouseover="this.style.opacity='1'">My Files</span>
                            ${(vaultBreadcrumbs || []).map(b => `
                                <span style="font-size: 18px; color: #9ca3af;">/</span>
                                <span onclick="window.navigateVaultFolder('${b?.id || ''}')" style="cursor: pointer;">${(b && b.name) || 'Folder'}</span>
                            `).join('')}
                        </div>
                        `}
                    </div>
                    <div style="display: flex; gap: 12px; align-items: center;">
                        ${!isVaultClient && vaultView === 'home' ? (vaultCurrentFolderId ? `
                        <button onclick="window.showVaultManageAccessModal('${vaultCurrentFolderId}')" style="padding: 8px 16px; border: 1px solid #d1d5db; background: #fff; border-radius: 6px; font-weight: 500; color: #374151; cursor: pointer; display: flex; align-items: center; gap: 8px;" title="Manage who can access this folder">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                            Manage Access
                        </button>
                        <button onclick="window.showVaultNewFolderModal('${vaultCurrentFolderId}')" style="padding: 8px 16px; border: 1px solid #d1d5db; background: #fff; border-radius: 6px; font-weight: 500; color: #374151; cursor: pointer; display: flex; align-items: center; gap: 8px;">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path><line x1="12" y1="11" x2="12" y2="17"></line><line x1="9" y1="14" x2="15" y2="14"></line></svg>
                            Create Subfolder
                        </button>
                        ` : `
                        <button onclick="window.showVaultNewFolderModal(null)" style="padding: 8px 16px; border: 1px solid #d1d5db; background: #fff; border-radius: 6px; font-weight: 500; color: #374151; cursor: pointer; display: flex; align-items: center; gap: 8px;">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path><line x1="12" y1="11" x2="12" y2="17"></line><line x1="9" y1="14" x2="15" y2="14"></line></svg>
                            New Folder
                        </button>
                        `) : ''}
                        <div style="display: flex; border: 1px solid #e5e7eb; border-radius: 6px; overflow: hidden; background: #fff;">
                            <button onclick="window.toggleVaultViewMode('grid')" style="padding: 8px 12px; border: none; background: ${vaultViewMode === 'grid' ? '#f59e0b' : '#fff'}; color: ${vaultViewMode === 'grid' ? '#fff' : '#6b7280'}; cursor: pointer; display: flex; align-items: center; gap: 6px; font-size: 14px; font-weight: ${vaultViewMode === 'grid' ? '500' : '400'};">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>
                                Grid
                            </button>
                            <button onclick="window.toggleVaultViewMode('list')" style="padding: 8px 12px; border: none; border-left: 1px solid #e5e7eb; background: ${vaultViewMode === 'list' ? '#f59e0b' : '#fff'}; color: ${vaultViewMode === 'list' ? '#fff' : '#6b7280'}; cursor: pointer; display: flex; align-items: center; gap: 6px; font-size: 14px; font-weight: ${vaultViewMode === 'list' ? '500' : '400'};">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line></svg>
                                List
                            </button>
                        </div>
                        ${(vaultView === 'home' && (!isVaultClient || (isVaultClient && vaultCurrentFolderId))) ? `<label onclick="window.vaultUploadTargetFolderId = window.vaultCurrentFolderId; console.log('📤 Upload clicked, captured folder:', window.vaultUploadTargetFolderId);" style="padding: 8px 16px; background: #1f2937; border-radius: 6px; font-weight: 500; color: white; cursor: pointer; display: flex; align-items: center; gap: 8px;">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
                            Upload
                            <input type="file" id="vault-upload-input" multiple style="display: none;" onchange="window.uploadVaultFiles(this.files); this.value = '';" />
                        </label>` : ''}
                    </div>
                </div>

                <!-- Quick Access (Only on Root Home; hidden for clients) -->
                ${(vaultView === 'home' && !vaultCurrentFolderId && !window.vaultSearchQuery && !isVaultClient) ? `
                <div style="margin-bottom: 32px;">
                    <div style="display: grid; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); gap: 16px;">
                        ${[
          {
            label: 'Recent uploads',
            count: vaultQuickStats.recent_uploads || 0,
            unit: vaultQuickStats.recent_uploads === 1 ? 'file' : 'files',
            icon: 'M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12',
            color: '#3b82f6',
            bg: '#eff6ff'
          },
          {
            label: 'Active Folders',
            count: vaultQuickStats.active_projects || 0,
            unit: vaultQuickStats.active_projects === 1 ? 'folder' : 'folders',
            icon: 'M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z',
            color: '#f59e0b',
            bg: '#fef3c7'
          },
          {
            label: 'Shared by me',
            count: vaultQuickStats.shared_by_me || 0,
            unit: vaultQuickStats.shared_by_me === 1 ? 'item' : 'items',
            icon: 'M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8',
            color: '#10b981',
            bg: '#d1fae5'
          }
        ].map(c => `
                            <div style="background: #fff; padding: 16px; border-radius: 12px; border: 1px solid #e5e7eb; display: flex; align-items: center; gap: 16px;">
                                <div style="width: 40px; height: 40px; background: ${c.bg}; color: ${c.color}; border-radius: 8px; display: flex; align-items: center; justify-content: center;">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="${c.icon}"></path></svg>
                                </div>
                                <div>
                                    <div style="font-weight: 600; color: #111827;">${c.label}</div>
                                    <div style="font-size: 12px; color: #6b7280;">${c.count} ${c.unit}</div>
                                </div>
                            </div>
                        `).join('')}
                    </div>
                </div>
                ` : ''}

                ${vaultView === 'trash' ? `
                <div style="margin-bottom: 24px; padding: 16px 20px; background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%); border: 1px solid #f59e0b; border-radius: 12px; display: flex; align-items: center; gap: 12px;">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#b45309" stroke-width="2" style="flex-shrink: 0;"><path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
                    <div>
                        <div style="font-weight: 600; color: #92400e; font-size: 14px; margin-bottom: 2px;">Trash</div>
                        <div style="font-size: 13px; color: #a16207;">Items will stay in trash for 15 days, then be permanently deleted.</div>
                    </div>
                </div>
                ` : ''}

                <!-- File List -->
                <div>
                     <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
                        <div style="font-size: 14px; font-weight: 600; color: #6b7280;">${vaultView === 'home' && vaultCurrentFolderId && vaultBreadcrumbs && vaultBreadcrumbs.length ? ((vaultBreadcrumbs[vaultBreadcrumbs.length - 1] && vaultBreadcrumbs[vaultBreadcrumbs.length - 1].name) || 'Files') : 'ALL FILES'}</div>
                        <select id="vault-sort-select" onchange="window.setVaultSort(this.value)" style="padding: 6px 10px; font-size: 12px; color: #374151; border: 1px solid #d1d5db; border-radius: 6px; background: #fff; cursor: pointer;">
                          <option value="modified" ${vaultSortBy === 'modified' ? 'selected' : ''}>Last modified</option>
                          <option value="size" ${vaultSortBy === 'size' ? 'selected' : ''}>File size</option>
                          <option value="name" ${vaultSortBy === 'name' ? 'selected' : ''}>Name</option>
                        </select>
                     </div>
                     ${(currentViewFolders.length === 0 && currentViewFiles.length === 0) ? `
                        <div style="text-align: center; padding: 48px; color: #9ca3af;">
                            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" style="margin-bottom: 16px;">${searchQuery ? '<circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line>' : '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>'}</svg>
                            <div style="font-size: 16px; margin-bottom: 8px;">${isVaultClient && !searchQuery && (folders.length === 0 || (vaultView === 'home' && !vaultCurrentFolderId)) ? 'No files are shared with you currently.' : searchQuery ? 'No results found' : vaultView === 'trash' ? 'Trash is empty' : 'No files found'}</div>
                            ${searchQuery ? '<div style="font-size: 14px;">Try a different search term</div>' : ''}
                            ${(!searchQuery && vaultView === 'home' && !isVaultClient) ? `
                            <div style="display: flex; gap: 12px; justify-content: center; flex-wrap: wrap; margin-top: 24px;">
                                <button type="button" onclick="window.vaultUploadTargetFolderId = window.vaultCurrentFolderId; var i = document.getElementById(\'vault-upload-input\'); if(i) i.click();" style="padding: 10px 20px; background: #1f2937; color: white; border: none; border-radius: 8px; font-weight: 500; cursor: pointer; display: inline-flex; align-items: center; gap: 8px;">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
                                    Add a new file
                                </button>
                                <button type="button" onclick="window.showVaultNewFolderModal(window.vaultCurrentFolderId || null)" style="padding: 10px 20px; background: #fff; color: #374151; border: 1px solid #d1d5db; border-radius: 8px; font-weight: 500; cursor: pointer; display: inline-flex; align-items: center; gap: 8px;">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                                    Add a new folder
                                </button>
                            </div>
                            ` : ''}
                        </div>
                     ` : `
                        <div style="${vaultViewMode === 'grid' ? 'display: grid; grid-template-columns: repeat(auto-fill, minmax(180px, 1fr)); gap: 16px;' : 'display: flex; flex-direction: column; gap: 8px;'}">
                             <!-- Folders -->
                             ${(currentViewFolders || []).map(f => `
                                <div style="${vaultViewMode === 'grid'
            ? 'background: #fff; border: 1px solid #e5e7eb; border-radius: 12px; padding: 16px; transition: all 0.2s; position: relative;'
            : 'background: #fff; border-bottom: 1px solid #e5e7eb; padding: 12px; display: flex; align-items: center; gap: 16px; position: relative;'}"
                                     onmouseover="this.style.borderColor='#f59e0b'; this.style.transform='translateY(-2px)'" 
                                     onmouseout="this.style.borderColor='#e5e7eb'; this.style.transform='translateY(0)'"
                                     ${vaultView !== 'trash' ? `ondragover="event.preventDefault(); event.stopPropagation(); this.style.borderColor='#f59e0b'; this.style.backgroundColor='#fffbeb'" ondragleave="event.stopPropagation(); this.style.borderColor=''; this.style.backgroundColor=''" ondrop="event.preventDefault(); event.stopPropagation(); this.style.borderColor=''; this.style.backgroundColor=''; window.vaultDropOnFolder(event, '${f.id}')"` : ''}>
                                    ${vaultView !== 'trash' ? `<div draggable="true" ondragstart="event.stopPropagation(); window.vaultDragStart(event, 'folder', '${f.id}')" style="position: absolute; bottom: 8px; right: 8px; width: 20px; height: 20px; cursor: grab; display: flex; align-items: center; justify-content: center; color: #9ca3af; z-index: 2;" title="Drag and drop" onmousedown="event.stopPropagation()"><svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><circle cx="9" cy="6" r="1.5"/><circle cx="15" cy="6" r="1.5"/><circle cx="9" cy="12" r="1.5"/><circle cx="15" cy="12" r="1.5"/><circle cx="9" cy="18" r="1.5"/><circle cx="15" cy="18" r="1.5"/></svg></div>` : ''}
                                    <div onclick="event.stopPropagation(); window.navigateVaultFolder('${f.id}')" style="${vaultViewMode === 'grid' ? 'cursor: pointer;' : 'display: flex; align-items: center; gap: 16px; flex: 1; cursor: pointer;'} min-width: 0;">
                                        <div style="${vaultViewMode === 'grid' ? 'margin-bottom: 12px;' : 'width: 40px; height: 40px; display: flex; align-items: center; justify-content: center;'}">
                                            <svg width="${vaultViewMode === 'grid' ? '40' : '24'}" height="${vaultViewMode === 'grid' ? '40' : '24'}" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" stroke-width="1.5" style="fill: #fef3c7;"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path></svg>
                                        </div>
                                        
                                        <div style="flex: 1;">
                                            <div style="font-weight: 500; color: #111827; font-size: 14px; margin-bottom: 4px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${(f.name || '').replace(/</g, '&lt;').replace(/>/g, '&gt;')}</div>
                                            <div style="font-size: 12px; color: #6b7280;">${new Date(f.created_at).toLocaleDateString()}</div>
                                        </div>
                                        
                                        ${vaultViewMode === 'list' ? `<div style="font-size: 12px; color: #9ca3af;">Folder</div>` : ''}
                                    </div>
                                    
                                    ${vaultView === 'trash' ? `
                                        <button onclick="event.stopPropagation(); window.restoreVaultItem('folder', '${f.id}')" style="position: ${vaultViewMode === 'grid' ? 'absolute; top: 8px; right: 8px;' : 'static; margin-left: auto;'} padding: 6px 12px; background: #10b981; color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 12px; font-weight: 500; display: flex; align-items: center; gap: 4px;" title="Restore">
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"></path><path d="M21 3v5h-5"></path><path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"></path><path d="M3 21v-5h5"></path></svg>
                                            Restore
                                        </button>
                                        <button onclick="event.stopPropagation(); window.deleteVaultItemPermanently('folder', '${f.id}')" style="position: ${vaultViewMode === 'grid' ? 'absolute; top: 8px; right: 8px; margin-top: 32px;' : 'static; margin-left: 8px;'} padding: 6px 12px; background: #ef4444; color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 12px; font-weight: 500; display: flex; align-items: center; gap: 4px;" title="Delete Forever">
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                                            Delete
                                        </button>
                                    ` : `
                                        <!-- Folder 3-dot menu -->
                                        <div style="${vaultViewMode === 'grid' ? 'position: absolute; top: 8px; right: 8px;' : 'position: relative; margin-left: auto;'}">
                                            <button onclick="event.stopPropagation(); window.toggleVaultFolderMenu('${f.id}')" style="padding: 6px 8px; background: transparent; border: 1px solid #e5e7eb; border-radius: 6px; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: all 0.2s;" onmouseover="this.style.background='#f3f4f6'; this.style.borderColor='#d1d5db'" onmouseout="this.style.background='transparent'; this.style.borderColor='#e5e7eb'" title="View settings">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6b7280" stroke-width="2"><circle cx="12" cy="12" r="1"></circle><circle cx="12" cy="5" r="1"></circle><circle cx="12" cy="19" r="1"></circle></svg>
                                            </button>
                                            <div id="vault-folder-menu-${f.id}" style="display: none; position: absolute; top: 100%; right: 0; margin-top: 4px; background: white; border: 1px solid #e5e7eb; border-radius: 8px; box-shadow: 0 10px 25px -5px rgba(0,0,0,0.1); min-width: 160px; z-index: 9999; overflow: hidden;">
                                                ${f.userPermission === 'owner' ? `
                                                <div onclick="event.stopPropagation(); window.hideVaultFolderMenu(); window.showVaultManageAccessModal('${f.id}')" style="padding: 10px 14px; cursor: pointer; display: flex; align-items: center; gap: 10px; font-size: 14px; color: #374151; transition: background 0.15s;" onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='transparent'">
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                                                    Manage Access
                                                </div>
                                                ` : ''}
                                                ${f.userPermission === 'owner' || f.userPermission === 'edit' ? `
                                                <div onclick="event.stopPropagation(); window.hideVaultFolderMenu(); window.showVaultRenameFolderModal('${f.id}', '${(f.name || '').replace(/'/g, "\\'")}')" style="padding: 10px 14px; cursor: pointer; display: flex; align-items: center; gap: 10px; font-size: 14px; color: #374151; transition: background 0.15s;" onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='transparent'">
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
                                                    Rename
                                                </div>
                                                ` : ''}
                                                ${f.userPermission === 'owner' ? `
                                                <div style="height: 1px; background: #e5e7eb; margin: 4px 0;"></div>
                                                <div onclick="event.stopPropagation(); window.hideVaultFolderMenu(); window.deleteVaultItem('folder', '${f.id}')" style="padding: 10px 14px; cursor: pointer; display: flex; align-items: center; gap: 10px; font-size: 14px; color: #ef4444; transition: background 0.15s;" onmouseover="this.style.background='#fef2f2'" onmouseout="this.style.background='transparent'">
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                                                    Delete Folder
                                                </div>
                                                ` : ''}
                                                ${f.userPermission === 'view' ? `
                                                <div style="padding: 10px 14px; font-size: 13px; color: #9ca3af; text-align: center;">View only</div>
                                                ` : ''}
                                            </div>
                                        </div>
                                    `}
                                </div>
                             `).join('')}

                             <!-- Files -->
                             ${(currentViewFiles || []).map(f => {
              const isImage = window.isVaultImageFile ? window.isVaultImageFile(f.mime_type) : (f.mime_type && f.mime_type.startsWith('image/'));
              const isPdf = window.isVaultPdfFile ? window.isVaultPdfFile(f.mime_type) : (f.mime_type && f.mime_type.includes('pdf'));
              const isWord = window.isVaultWordFile ? window.isVaultWordFile(f.mime_type, f.name) : false;
              const fileDataStr = JSON.stringify(f).replace(/"/g, '&quot;');
              return `
                                <div style="${vaultViewMode === 'grid'
                  ? 'background: #fff; border: 1px solid #e5e7eb; border-radius: 12px; padding: 16px; transition: all 0.2s; position: relative;'
                  : 'background: #fff; border-bottom: 1px solid #e5e7eb; padding: 12px; display: flex; align-items: center; gap: 16px; position: relative;'}"
                                     onmouseover="this.style.borderColor='#f59e0b'; this.style.transform='translateY(-2px)'" 
                                     onmouseout="this.style.borderColor='#e5e7eb'; this.style.transform='translateY(0)'"
                                     ${isPdf && f.storage_path ? 'onmouseenter="window.prefetchVaultPdfUrl && window.prefetchVaultPdfUrl(\'' + (f.storage_path || '').replace(/\\/g, '\\\\').replace(/'/g, "\\'") + '\')"' : ''}
                                     ${vaultView !== 'trash' ? `draggable="true" ondragstart="event.stopPropagation(); window.vaultDragStart(event, 'file', '${f.id}')"` : ''}>
                                    
                                    <div onclick="window.showVaultFilePreview(${fileDataStr})" style="${vaultViewMode === 'grid' ? '' : 'display: flex; align-items: center; gap: 16px; flex: 1;'} cursor: pointer;">
                                        <div class="vault-file-thumb" data-storage-path="${isImage ? (f.storage_path || '').replace(/"/g, '&quot;') : ''}" data-is-image="${isImage}" style="${vaultViewMode === 'grid' ? 'margin-bottom: 12px; display: flex; align-items: center; justify-content: center; min-height: 80px;' : 'width: 50px; height: 50px; display: flex; align-items: center; justify-content: center; flex-shrink: 0;'}">
                                            ${isImage
                  ? `<div class="vault-thumb-loading" style="display: flex; align-items: center; justify-content: center;"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#8b5cf6" stroke-width="2" class="vault-thumb-spinner" style="animation: spin 1s linear infinite;"><circle cx="12" cy="12" r="10" stroke-opacity="0.3"></circle><path d="M12 2a10 10 0 0 1 10 10" stroke-linecap="round"></path></svg></div><img class="vault-thumb-img" style="display: none; ${vaultViewMode === 'grid' ? 'max-width: 100%; max-height: 100px; border-radius: 6px; object-fit: cover;' : 'width: 50px; height: 50px; border-radius: 6px; object-fit: cover;'}" alt="${(f.name || '').replace(/"/g, '&quot;')}" onerror="this.style.display='none'; this.previousElementSibling.innerHTML='<svg width=24 height=24 viewBox=0 0 24 24 fill=none stroke=#8b5cf6 stroke-width=2><rect x=3 y=3 width=18 height=18 rx=2 ry=2></rect><circle cx=8.5 cy=8.5 r=1.5></circle><polyline points=21 15 16 10 5 21></polyline></svg>'; this.previousElementSibling.style.display='flex';" onload="this.style.display='block'; this.previousElementSibling.style.display='none';" />`
                  : isPdf
                    ? '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="1.5"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><text x="7" y="16" font-size="5" fill="#ef4444" stroke="none" font-weight="bold">PDF</text></svg>'
                    : isWord
                      ? '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#2563eb" stroke-width="1.5"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><text x="6" y="16" font-size="4.5" fill="#2563eb" stroke="none" font-weight="bold">DOC</text></svg>'
                      : '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#6b7280" stroke-width="1.5"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line></svg>'}
                                        </div>
                                        
                                        <div style="flex: 1; min-width: 0;">
                                            <div style="font-weight: 500; color: #111827; font-size: 14px; margin-bottom: 4px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">${(f.name || '').replace(/</g, '&lt;').replace(/>/g, '&gt;')}</div>
                                            <div style="font-size: 12px; color: #6b7280;">${new Date(f.created_at).toLocaleDateString()}${f.deleted_at ? ' • Deleted ' + Math.floor((new Date() - new Date(f.deleted_at)) / (1000 * 60 * 60 * 24)) + ' days ago' : ''}</div>
                                            <div style="font-size: 12px; color: #9ca3af; margin-top: 2px;">Uploaded by ${(vaultCreatorNames[f.created_by] ? ((vaultCreatorNames[f.created_by].first_name || '') + ' ' + (vaultCreatorNames[f.created_by].last_name || '')).trim() : '') || 'Unknown'}</div>
                                        </div>
                                         ${vaultViewMode === 'list' ? `<div style="font-size: 12px; color: #9ca3af;">${window.formatVaultFileSize ? window.formatVaultFileSize(f.size_bytes) : ((f.size_bytes || 0) / 1024).toFixed(1) + ' KB'}</div>` : ''}
                                    </div>
                                    
                                    ${vaultView === 'trash' ? `
                                        <button onclick="event.stopPropagation(); window.restoreVaultItem('file', '${f.id}')" style="position: ${vaultViewMode === 'grid' ? 'absolute; top: 8px; right: 8px;' : 'static; margin-left: auto;'} padding: 6px 12px; background: #10b981; color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 12px; font-weight: 500; display: flex; align-items: center; gap: 4px;" title="Restore">
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"></path><path d="M21 3v5h-5"></path><path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"></path><path d="M3 21v-5h5"></path></svg>
                                            Restore
                                        </button>
                                        <button onclick="event.stopPropagation(); window.deleteVaultItemPermanently('file', '${f.id}')" style="position: ${vaultViewMode === 'grid' ? 'absolute; top: 8px; right: 8px; margin-top: 32px;' : 'static; margin-left: 8px;'} padding: 6px 12px; background: #ef4444; color: white; border: none; border-radius: 6px; cursor: pointer; font-size: 12px; font-weight: 500; display: flex; align-items: center; gap: 4px;" title="Delete Forever">
                                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                                            Delete
                                        </button>
                                    ` : `
                                        <!-- File 3-dot menu -->
                                        <div style="${vaultViewMode === 'grid' ? 'position: absolute; top: 8px; right: 8px;' : 'position: relative; margin-left: auto;'}">
                                            <button onclick="event.stopPropagation(); window.toggleVaultFileMenu('${f.id}')" style="padding: 6px 8px; background: transparent; border: 1px solid #e5e7eb; border-radius: 6px; cursor: pointer; display: flex; align-items: center; justify-content: center; transition: all 0.2s;" onmouseover="this.style.background='#f3f4f6'; this.style.borderColor='#d1d5db'" onmouseout="this.style.background='transparent'; this.style.borderColor='#e5e7eb'" title="More options">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6b7280" stroke-width="2"><circle cx="12" cy="12" r="1"></circle><circle cx="12" cy="5" r="1"></circle><circle cx="12" cy="19" r="1"></circle></svg>
                                            </button>
                                            <div id="vault-file-menu-${f.id}" style="display: none; position: absolute; top: 100%; right: 0; margin-top: 4px; background: white; border: 1px solid #e5e7eb; border-radius: 8px; box-shadow: 0 10px 25px -5px rgba(0,0,0,0.1); min-width: 160px; z-index: 9999; overflow: hidden;">
                                                <div onclick="event.stopPropagation(); window.hideVaultFileMenu(); window.showVaultFilePreview(${fileDataStr})" style="padding: 10px 14px; cursor: pointer; display: flex; align-items: center; gap: 10px; font-size: 14px; color: #374151; transition: background 0.15s;" onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='transparent'">
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line></svg>
                                                    View document
                                                </div>
                                                ${!isVaultClient ? `
                                                <div style="height: 1px; background: #e5e7eb; margin: 4px 0;"></div>
                                                <div onclick="event.stopPropagation(); window.hideVaultFileMenu(); window.showMoveFileModal('${f.id}', '${(f.name || '').replace(/'/g, "\\'")}')" style="padding: 10px 14px; cursor: pointer; display: flex; align-items: center; gap: 10px; font-size: 14px; color: #374151; transition: background 0.15s;" onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='transparent'">
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path><path d="M12 11v6"></path><path d="M9 14l3-3 3 3"></path></svg>
                                                    Move to Folder
                                                </div>
                                                <div style="height: 1px; background: #e5e7eb; margin: 4px 0;"></div>
                                                <div onclick="event.stopPropagation(); window.hideVaultFileMenu(); window.deleteVaultItem('file', '${f.id}')" style="padding: 10px 14px; cursor: pointer; display: flex; align-items: center; gap: 10px; font-size: 14px; color: #ef4444; transition: background 0.15s;" onmouseover="this.style.background='#fef2f2'" onmouseout="this.style.background='transparent'">
                                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                                                    Delete
                                                </div>
                                                ` : ''}
                                            </div>
                                        </div>
                                    `}
                                </div>
                             `;
            }).join('')}
                        </div>
                     `}
                </div>
            </div>
        </div>
    </div>`;
  } catch (error) {
    console.error('Error rendering vault screen:', error);
    vaultHtml = `
      <div style="display: flex; align-items: center; justify-content: center; min-height: 400px; padding: 2rem;">
        <div style="text-align: center; color: #b91c1c;">
          <p style="font-size: 1rem; margin-bottom: 0.5rem; font-weight: 600;">Could not load the document hub.</p>
          <p style="font-size: 0.875rem;">Please refresh and try again.</p>
        </div>
      </div>`;
  }
  return (typeof vaultHtml === 'string' && vaultHtml) ? vaultHtml : `
    <div style="display: flex; align-items: center; justify-content: center; min-height: 400px; padding: 2rem;">
      <div style="text-align: center; color: #6b7280;">
        <p style="font-size: 1rem; margin-bottom: 0.5rem;">Document Hub</p>
        <p style="font-size: 0.875rem;">Please refresh the page to load documents.</p>
      </div>
    </div>`;
};

// ============================================
// VAULT FOLDER PERMISSIONS SYSTEM
// ============================================

// State for folder creation with permissions
window.vaultNewFolderPermissions = window.vaultNewFolderPermissions || [];
window.vaultPermissionSearchQuery = '';

// Get available users for sharing (team members + clients with login, excluding current user)
window.getVaultShareableUsers = function () {
  const list = [...(teamMembers || []), ...(window.vaultManageAccessShareableClients || [])];
  return list.filter(m => m.id !== currentUser?.id);
};

// Load company clients (with login) into vaultManageAccessShareableClients so dropdowns show team + clients.
// Two sources: (1) company_members with role = CLIENT and same company_id, (2) companies where is_hh_client = true.
window.loadVaultShareableClientsOnce = async function () {
  var companyId = currentCompany?.id || (currentUser && currentUser.company_id);
  if (!companyId && currentUser && currentUser.id) {
    try {
      var memberRes = await supabase.from('company_members').select('company_id').eq('user_id', currentUser.id).limit(1).single();
      if (memberRes.data && memberRes.data.company_id) companyId = memberRes.data.company_id;
    } catch (_) { }
    if (!companyId) {
      try {
        var profileRes = await supabase.from('profiles').select('company_id').eq('id', currentUser.id).single();
        if (profileRes.data && profileRes.data.company_id) companyId = profileRes.data.company_id;
      } catch (_) { }
    }
  }
  if (!companyId) {
    window.vaultManageAccessShareableClients = window.vaultManageAccessShareableClients || [];
    return;
  }
  var list = [];
  try {
    // 1) Clients from company_members: same company_id, role = 'CLIENT'
    var cmRes = await supabase
      .from('company_members')
      .select('user_id, profiles!company_members_user_id_fkey(id, first_name, last_name, email)')
      .eq('company_id', companyId)
      .eq('role', 'CLIENT');
    if (cmRes.data && cmRes.data.length) {
      cmRes.data.forEach(function (row) {
        if (row.profiles && row.profiles.id) {
          list.push({
            id: row.profiles.id,
            first_name: row.profiles.first_name,
            last_name: row.profiles.last_name,
            email: row.profiles.email,
            company_role: 'CLIENT'
          });
        }
      });
    }
    // 2) HH client companies: companies where is_hh_client = true (exclude current company already in list)
    var compRes = await supabase.from('companies').select('id').eq('is_hh_client', true);
    if (compRes.data && compRes.data.length) {
      var hhCompanyIds = compRes.data.map(function (c) { return c.id; }).filter(function (id) { return id !== companyId; });
      if (hhCompanyIds.length > 0) {
        var hhRes = await supabase
          .from('company_members')
          .select('user_id, profiles!company_members_user_id_fkey(id, first_name, last_name, email)')
          .in('company_id', hhCompanyIds);
        if (hhRes.data && hhRes.data.length) {
          var seen = {};
          list.forEach(function (m) { seen[m.id] = true; });
          hhRes.data.forEach(function (row) {
            if (row.profiles && row.profiles.id && !seen[row.profiles.id]) {
              seen[row.profiles.id] = true;
              list.push({
                id: row.profiles.id,
                first_name: row.profiles.first_name,
                last_name: row.profiles.last_name,
                email: row.profiles.email,
                company_role: 'CLIENT'
              });
            }
          });
        }
      }
    }
    window.vaultManageAccessShareableClients = list;
  } catch (e) {
    console.warn('Could not load company clients for vault:', e);
    window.vaultManageAccessShareableClients = window.vaultManageAccessShareableClients || [];
  }
};

// Add user to folder permissions list
window.addVaultFolderPermission = function (userId, permissionLevel = 'view') {
  if (!userId) return;
  // Check if already added
  if (window.vaultNewFolderPermissions.some(p => p.userId === userId)) return;

  const user = (teamMembers || []).find(m => m.id === userId) || (window.vaultManageAccessShareableClients || []).find(m => m.id === userId);
  if (!user) return;

  window.vaultNewFolderPermissions.push({
    userId: userId,
    name: `${user.first_name || ''} ${user.last_name || ''}`.trim() || user.email || 'Unknown',
    permissionLevel: permissionLevel
  });

  window.updateVaultPermissionsDisplay();
  window.vaultPermissionSearchQuery = '';
  const searchInput = document.getElementById('vault-permission-search');
  if (searchInput) searchInput.value = '';
};

// Remove user from folder permissions list
window.removeVaultFolderPermission = function (userId) {
  window.vaultNewFolderPermissions = window.vaultNewFolderPermissions.filter(p => p.userId !== userId);
  window.updateVaultPermissionsDisplay();
};

// Change permission level for a user
window.changeVaultPermissionLevel = function (userId, newLevel) {
  const perm = window.vaultNewFolderPermissions.find(p => p.userId === userId);
  if (perm) perm.permissionLevel = newLevel;
  window.updateVaultPermissionsDisplay();
};

// Update the permissions display in the modal
window.updateVaultPermissionsDisplay = function () {
  const container = document.getElementById('vault-permissions-list');
  if (!container) return;

  if (window.vaultNewFolderPermissions.length === 0) {
    container.innerHTML = '<div style="color: #9ca3af; font-size: 13px; padding: 12px; text-align: center;">No one added yet. Only you will have access.</div>';
    return;
  }

  container.innerHTML = window.vaultNewFolderPermissions.map(p => `
    <div style="display: flex; align-items: center; justify-content: space-between; padding: 10px 12px; background: #f9fafb; border-radius: 8px; margin-bottom: 8px;">
      <div style="display: flex; align-items: center; gap: 10px;">
        <div style="width: 32px; height: 32px; border-radius: 50%; background: #f59e0b; color: white; display: flex; align-items: center; justify-content: center; font-weight: 600; font-size: 13px;">
          ${(p.name || 'U').charAt(0).toUpperCase()}
        </div>
        <span style="font-weight: 500; color: #111827; font-size: 14px;">${(p.name || '').replace(/</g, '&lt;')}</span>
      </div>
      <div style="display: flex; align-items: center; gap: 8px;">
        <select onchange="window.changeVaultPermissionLevel('${p.userId}', this.value)" style="padding: 6px 10px; border: 1px solid #d1d5db; border-radius: 6px; font-size: 13px; background: white; cursor: pointer;">
          <option value="view" ${p.permissionLevel === 'view' ? 'selected' : ''}>Can view</option>
          <option value="edit" ${p.permissionLevel === 'edit' ? 'selected' : ''}>Can edit</option>
        </select>
        <button onclick="window.removeVaultFolderPermission('${p.userId}')" style="width: 28px; height: 28px; border: none; background: #fee2e2; color: #ef4444; border-radius: 6px; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 16px;" title="Remove">×</button>
      </div>
    </div>
  `).join('');
};

// Show user search dropdown for permissions
window.showVaultPermissionDropdown = function (query) {
  const dropdown = document.getElementById('vault-permission-dropdown');
  if (!dropdown) return;

  query = (query || '').toLowerCase().trim();
  const addedIds = window.vaultNewFolderPermissions.map(p => p.userId);

  let available = window.getVaultShareableUsers().filter(m => !addedIds.includes(m.id));

  if (query) {
    available = available.filter(m => {
      const fullName = `${m.first_name || ''} ${m.last_name || ''}`.toLowerCase();
      return fullName.includes(query) || (m.email || '').toLowerCase().includes(query);
    });
  }

  if (available.length === 0) {
    dropdown.innerHTML = '<div style="padding: 12px; color: #9ca3af; font-size: 13px; text-align: center;">No users found</div>';
    dropdown.style.display = 'block';
    return;
  }

  dropdown.innerHTML = available.slice(0, 5).map(m => `
    <div onmousedown="window.addVaultFolderPermission('${m.id}', 'view')" style="padding: 10px 12px; cursor: pointer; display: flex; align-items: center; gap: 10px; transition: background 0.15s;" onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='transparent'">
      <div style="width: 32px; height: 32px; border-radius: 50%; background: #e5e7eb; color: #374151; display: flex; align-items: center; justify-content: center; font-weight: 600; font-size: 13px;">
        ${((m.first_name || 'U').charAt(0)).toUpperCase()}
      </div>
      <div>
        <div style="font-weight: 500; color: #111827; font-size: 14px;">${(m.first_name || '')} ${(m.last_name || '')}</div>
        <div style="font-size: 12px; color: #6b7280;">${m.company_role || 'Team member'}</div>
      </div>
    </div>
  `).join('');
  dropdown.style.display = 'block';
};

// Hide permission dropdown
window.hideVaultPermissionDropdown = function () {
  const dropdown = document.getElementById('vault-permission-dropdown');
  if (dropdown) dropdown.style.display = 'none';
};

// CRUD Operations
window.createVaultFolder = async function (name, parentId, permissions = []) {
  if (!name || !name.trim()) {
    if (window.vaultToast) window.vaultToast('Folder name required', 'error');
    return;
  }

  const createBtn = document.getElementById('vault-new-folder-create');
  if (createBtn) {
    createBtn.disabled = true;
    createBtn.textContent = 'Creating...';
  }

  try {
    // 1. Create the folder
    const { data: folderData, error: folderError } = await supabase
      .from('vault_folders')
      .insert({
        name: name.trim(),
        parent_id: parentId || null,
        company_id: currentCompany.id,
        created_by: currentUser.id
      })
      .select()
      .single();

    if (folderError) throw folderError;

    // 2. Create owner permission for creator
    await supabase.from('vault_permissions').insert({
      company_id: currentCompany.id,
      item_type: 'folder',
      item_id: folderData.id,
      user_id: currentUser.id,
      permission_level: 'owner',
      created_by: currentUser.id
    });

    // 3. Create permissions for shared users
    if (permissions && permissions.length > 0) {
      const permissionRecords = permissions.map(p => ({
        company_id: currentCompany.id,
        item_type: 'folder',
        item_id: folderData.id,
        user_id: p.userId,
        permission_level: p.permissionLevel,
        created_by: currentUser.id
      }));

      const { error: permError } = await supabase
        .from('vault_permissions')
        .insert(permissionRecords);

      if (permError) console.error('Error creating permissions:', permError);
    }

    if (parentId) window.vaultExpandedSections.add(parentId);
    window.showNewFolderModal = false;
    window.vaultNewFolderPermissions = []; // Reset permissions
    const overlay = document.getElementById('new-folder-modal-overlay');
    if (overlay) overlay.remove();
    await window.refreshVaultUI();

    const sharedCount = permissions?.length || 0;
    if (window.vaultToast) {
      window.vaultToast(sharedCount > 0
        ? `Folder created and shared with ${sharedCount} ${sharedCount === 1 ? 'person' : 'people'}`
        : (parentId ? 'Subfolder created' : 'Folder created'));
    }
  } catch (e) {
    console.error('Error creating folder:', e);
    if (window.vaultToast) window.vaultToast('Failed to create folder', 'error');
    if (createBtn) {
      createBtn.disabled = false;
      createBtn.textContent = 'Create';
    }
  }
};

// uploadVaultFiles is defined earlier (uses folderId in storage path and DB)

window.deleteVaultItem = async function (type, id) {
  const itemLabel = type === 'folder' ? 'folder' : 'file';
  const itemLabelCap = type === 'folder' ? 'Folder' : 'File';

  // Create custom delete dialog with both options
  const overlay = document.createElement('div');
  overlay.id = 'vault-delete-overlay';
  overlay.style.cssText = 'position:fixed; inset:0; background:rgba(0,0,0,0.5); z-index:10002; display:flex; align-items:center; justify-content:center; padding:16px;';
  overlay.onclick = function (e) { if (e.target === overlay) overlay.remove(); };

  overlay.innerHTML = `
    <div style="background:#fff; border-radius:16px; max-width:420px; width:100%; padding:24px; box-shadow:0 25px 50px -12px rgba(0,0,0,0.25);" onclick="event.stopPropagation()">
      <div style="display:flex; align-items:center; gap:12px; margin-bottom:16px;">
        <div style="width:48px; height:48px; background:#fef2f2; border-radius:12px; display:flex; align-items:center; justify-content:center;">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ef4444" stroke-width="2">
            <polyline points="3 6 5 6 21 6"></polyline>
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
          </svg>
        </div>
        <div>
          <h3 style="margin:0; font-size:18px; font-weight:600; color:#111827;">Delete ${itemLabelCap}</h3>
          <p style="margin:4px 0 0 0; font-size:14px; color:#6b7280;">Choose how to delete this ${itemLabel}</p>
        </div>
      </div>
      
      <div style="display:flex; flex-direction:column; gap:12px; margin-bottom:16px;">
        <!-- Move to Trash Option -->
        <button id="vault-delete-trash-btn" style="width:100%; padding:14px 16px; background:#fff; border:2px solid #e5e7eb; border-radius:10px; cursor:pointer; text-align:left; transition:all 0.2s;" onmouseover="this.style.borderColor='#f59e0b'; this.style.background='#fffbeb'" onmouseout="this.style.borderColor='#e5e7eb'; this.style.background='#fff'">
          <div style="display:flex; align-items:center; gap:12px;">
            <div style="width:40px; height:40px; background:#fef3c7; border-radius:8px; display:flex; align-items:center; justify-content:center; flex-shrink:0;">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#d97706" stroke-width="2">
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              </svg>
            </div>
            <div style="flex:1;">
              <div style="font-weight:600; color:#111827; font-size:15px;">Move to Trash</div>
              <div style="font-size:13px; color:#6b7280; margin-top:2px;">Kept for 15 days, then auto-deleted</div>
            </div>
          </div>
        </button>
        
        <!-- Permanently Delete Option -->
        <button id="vault-delete-permanent-btn" style="width:100%; padding:14px 16px; background:#fff; border:2px solid #e5e7eb; border-radius:10px; cursor:pointer; text-align:left; transition:all 0.2s;" onmouseover="this.style.borderColor='#ef4444'; this.style.background='#fef2f2'" onmouseout="this.style.borderColor='#e5e7eb'; this.style.background='#fff'">
          <div style="display:flex; align-items:center; gap:12px;">
            <div style="width:40px; height:40px; background:#fee2e2; border-radius:8px; display:flex; align-items:center; justify-content:center; flex-shrink:0;">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#dc2626" stroke-width="2">
                <path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
              </svg>
            </div>
            <div style="flex:1;">
              <div style="font-weight:600; color:#111827; font-size:15px;">Permanently Delete</div>
              <div style="font-size:13px; color:#6b7280; margin-top:2px;">Cannot be recovered</div>
            </div>
          </div>
        </button>
      </div>
      
      <!-- Disclaimer -->
      <div style="background:#fef3c7; border:1px solid #fcd34d; border-radius:8px; padding:12px; margin-bottom:20px;">
        <div style="display:flex; align-items:flex-start; gap:8px;">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d97706" stroke-width="2" style="flex-shrink:0; margin-top:2px;">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
          <p style="margin:0; font-size:13px; color:#92400e; line-height:1.4;">
            <strong>Note:</strong> Items moved to trash are visible to all team members with vault access until permanently deleted.
          </p>
        </div>
      </div>
      
      <!-- Cancel Button -->
      <button id="vault-delete-cancel-btn" style="width:100%; padding:12px; border:1px solid #e5e7eb; background:#fff; border-radius:8px; font-weight:500; color:#374151; cursor:pointer; transition:all 0.2s;" onmouseover="this.style.background='#f9fafb'" onmouseout="this.style.background='#fff'">
        Cancel
      </button>
    </div>
  `;

  document.body.appendChild(overlay);

  // Handle Move to Trash
  document.getElementById('vault-delete-trash-btn').onclick = async function () {
    this.disabled = true;
    this.style.opacity = '0.6';
    this.innerHTML = '<div style="text-align:center; color:#6b7280;">Moving to trash...</div>';

    try {
      const table = type === 'folder' ? 'vault_folders' : 'vault_files';
      const { error } = await supabase.from(table).update({
        is_deleted: true,
        deleted_at: new Date().toISOString(),
        deleted_by: currentUser?.id || null
      }).eq('id', id);
      if (error) throw error;
      overlay.remove();
      await window.refreshVaultUI();
      window.vaultToast('Moved to trash');
    } catch (e) {
      console.error('Error moving to trash:', e);
      window.vaultToast('Failed to move to trash', 'error');
      overlay.remove();
    }
  };

  // Handle Permanent Delete
  document.getElementById('vault-delete-permanent-btn').onclick = function () {
    // Show modern confirmation modal for permanent delete
    const confirmOverlay = document.createElement('div');
    confirmOverlay.id = 'vault-permanent-delete-confirm';
    confirmOverlay.style.cssText = 'position:fixed; inset:0; background:rgba(0,0,0,0.6); z-index:10003; display:flex; align-items:center; justify-content:center; padding:16px;';
    confirmOverlay.onclick = function (e) { if (e.target === confirmOverlay) confirmOverlay.remove(); };

    confirmOverlay.innerHTML = `
      <div style="background:#fff; border-radius:16px; max-width:400px; width:100%; padding:24px; box-shadow:0 25px 50px -12px rgba(0,0,0,0.25); animation: modalSlideIn 0.2s ease-out;" onclick="event.stopPropagation()">
        <div style="text-align:center; margin-bottom:20px;">
          <div style="width:64px; height:64px; background:#fee2e2; border-radius:50%; display:flex; align-items:center; justify-content:center; margin:0 auto 16px;">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#dc2626" stroke-width="2">
              <path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
            </svg>
          </div>
          <h3 style="margin:0 0 8px 0; font-size:20px; font-weight:600; color:#111827;">Permanently Delete?</h3>
          <p style="margin:0; font-size:14px; color:#6b7280; line-height:1.5;">
            This ${itemLabel} will be <strong style="color:#dc2626;">permanently deleted</strong> and cannot be recovered. This action is irreversible.
          </p>
        </div>
        
        <div style="background:#fef2f2; border:1px solid #fecaca; border-radius:8px; padding:12px; margin-bottom:20px;">
          <div style="display:flex; align-items:center; gap:8px;">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#dc2626" stroke-width="2" style="flex-shrink:0;">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="15" y1="9" x2="9" y2="15"></line>
              <line x1="9" y1="9" x2="15" y2="15"></line>
            </svg>
            <p style="margin:0; font-size:13px; color:#991b1b; font-weight:500;">
              This cannot be undone!
            </p>
          </div>
        </div>
        
        <div style="display:flex; gap:12px;">
          <button id="vault-perm-delete-cancel" style="flex:1; padding:12px 16px; border:1px solid #e5e7eb; background:#fff; border-radius:8px; font-weight:500; color:#374151; cursor:pointer; transition:all 0.2s;" onmouseover="this.style.background='#f9fafb'" onmouseout="this.style.background='#fff'">
            Cancel
          </button>
          <button id="vault-perm-delete-confirm" style="flex:1; padding:12px 16px; border:none; background:#dc2626; color:#fff; border-radius:8px; font-weight:600; cursor:pointer; transition:all 0.2s; display:flex; align-items:center; justify-content:center; gap:8px;" onmouseover="this.style.background='#b91c1c'" onmouseout="this.style.background='#dc2626'">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="3 6 5 6 21 6"></polyline>
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
            </svg>
            Delete Forever
          </button>
        </div>
      </div>
    `;

    document.body.appendChild(confirmOverlay);

    // Handle Cancel
    document.getElementById('vault-perm-delete-cancel').onclick = function () {
      confirmOverlay.remove();
    };

    // Handle Confirm Delete
    document.getElementById('vault-perm-delete-confirm').onclick = async function () {
      this.disabled = true;
      this.innerHTML = '<div style="display:flex; align-items:center; gap:8px;"><div style="width:16px; height:16px; border:2px solid #fff; border-top-color:transparent; border-radius:50%; animation:spin 1s linear infinite;"></div> Deleting...</div>';

      try {
        if (type === 'folder') {
          // Delete folder contents first
          const files = await loadVaultFiles(id, true);
          for (const file of files) {
            if (file.storage_path) { try { await supabase.storage.from('vault').remove([file.storage_path]); } catch (_) { } }
            await supabase.from('vault_files').delete().eq('id', file.id);
          }
          const subfolders = await loadVaultFolders(id, true);
          for (const subfolder of subfolders) {
            await window.deleteVaultItemPermanently('folder', subfolder.id);
          }
          await supabase.from('vault_folders').delete().eq('id', id);
        } else {
          const { data: file } = await supabase.from('vault_files').select('storage_path').eq('id', id).single();
          if (file?.storage_path) { try { await supabase.storage.from('vault').remove([file.storage_path]); } catch (_) { } }
          await supabase.from('vault_files').delete().eq('id', id);
        }
        confirmOverlay.remove();
        overlay.remove();
        await window.refreshVaultUI();
        window.vaultToast('Deleted permanently');
      } catch (e) {
        console.error('Error deleting permanently:', e);
        window.vaultToast('Failed to delete permanently', 'error');
        confirmOverlay.remove();
        overlay.remove();
      }
    };
  };

  // Handle Cancel
  document.getElementById('vault-delete-cancel-btn').onclick = function () {
    overlay.remove();
  };
};

window.restoreVaultItem = async function (type, id) {
  try {
    const table = type === 'folder' ? 'vault_folders' : 'vault_files';
    const { error } = await supabase.from(table).update({
      is_deleted: false,
      deleted_at: null,
      deleted_by: null
    }).eq('id', id);
    if (error) throw error;
    await window.refreshVaultUI();
    window.vaultToast('Restored');
  } catch (e) {
    console.error('Error restoring:', e);
    window.vaultToast('Failed to restore', 'error');
  }
};

window.showVaultNewFolderModal = async function (parentId) {
  parentId = parentId === undefined || parentId === null ? null : parentId;
  window.vaultNewFolderParentId = parentId;
  window.vaultNewFolderPermissions = []; // Reset permissions
  window.showNewFolderModal = true;
  await (window.loadVaultShareableClientsOnce && window.loadVaultShareableClientsOnce());

  const overlay = document.createElement('div');
  overlay.id = 'new-folder-modal-overlay';
  overlay.style.cssText = 'position:fixed; top:0; left:0; right:0; bottom:0; background:rgba(0,0,0,0.5); z-index:10000; display:flex; align-items:center; justify-content:center; padding: 20px;';
  overlay.onclick = function (e) { if (e.target === overlay) { overlay.remove(); window.showNewFolderModal = false; window.vaultNewFolderPermissions = []; } };

  const title = parentId ? 'Create Subfolder' : 'Create New Folder';
  const hasShareableUsers = window.getVaultShareableUsers && window.getVaultShareableUsers().length > 0;

  overlay.innerHTML = `
    <div style="background:white; padding:0; border-radius:16px; width:480px; max-width:95%; box-shadow:0 25px 50px -12px rgba(0,0,0,0.25); overflow:hidden;" onclick="event.stopPropagation();">
      <!-- Header -->
      <div style="padding: 20px 24px; border-bottom: 1px solid #e5e7eb;">
        <h3 style="margin:0; font-size:18px; font-weight:600; color: #111827;">${title}</h3>
        <p style="margin: 4px 0 0 0; font-size: 13px; color: #6b7280;">Create a folder and choose who can access it</p>
      </div>
      
      <!-- Content -->
      <div style="padding: 24px; max-height: 60vh; overflow-y: auto;">
        <!-- Folder Name -->
        <div style="margin-bottom: 20px;">
          <label style="display: block; font-size: 14px; font-weight: 500; color: #374151; margin-bottom: 6px;">Folder Name</label>
          <input id="new-folder-input" type="text" placeholder="Enter folder name" style="width:100%; padding:12px; border:1px solid #d1d5db; border-radius:8px; outline:none; font-size: 14px; transition: border-color 0.2s;" onfocus="this.style.borderColor='#f59e0b'" onblur="this.style.borderColor='#d1d5db'" />
        </div>
        
        <!-- Share With Section -->
        ${hasShareableUsers ? `
        <div style="margin-bottom: 8px;">
          <label style="display: block; font-size: 14px; font-weight: 500; color: #374151; margin-bottom: 6px;">
            Share with
            <span style="font-weight: 400; color: #9ca3af;">(optional)</span>
          </label>
          
          <!-- User Search -->
          <div style="position: relative; margin-bottom: 12px;">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="2" style="position: absolute; left: 12px; top: 50%; transform: translateY(-50%); pointer-events: none;"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
            <input id="vault-permission-search" type="text" placeholder="Search team members and clients..." 
                   style="width:100%; padding:10px 12px 10px 38px; border:1px solid #d1d5db; border-radius:8px; outline:none; font-size: 14px;"
                   oninput="window.showVaultPermissionDropdown(this.value)"
                   onfocus="window.showVaultPermissionDropdown(this.value)"
                   onblur="setTimeout(function(){ window.hideVaultPermissionDropdown(); }, 200)" />
            
            <!-- Dropdown -->
            <div id="vault-permission-dropdown" style="display: none; position: absolute; top: 100%; left: 0; right: 0; background: white; border: 1px solid #e5e7eb; border-radius: 8px; box-shadow: 0 10px 25px -5px rgba(0,0,0,0.1); margin-top: 4px; z-index: 10; max-height: 200px; overflow-y: auto;"></div>
          </div>
          
          <!-- Selected Users List -->
          <div id="vault-permissions-list" style="min-height: 50px;">
            <div style="color: #9ca3af; font-size: 13px; padding: 12px; text-align: center;">No one added yet. Only you will have access.</div>
          </div>
        </div>
        ` : `
        <div style="background: #f9fafb; border-radius: 8px; padding: 16px; margin-bottom: 8px;">
          <div style="display: flex; align-items: center; gap: 10px; color: #6b7280;">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
            <div>
              <div style="font-weight: 500; color: #374151; font-size: 14px;">Private folder</div>
              <div style="font-size: 13px;">Only you will have access to this folder</div>
            </div>
          </div>
        </div>
        `}
        
        <!-- Info Note -->
        <div style="display: flex; align-items: flex-start; gap: 8px; padding: 12px; background: #fef3c7; border-radius: 8px; margin-top: 16px;">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#d97706" stroke-width="2" style="flex-shrink: 0; margin-top: 1px;"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></svg>
          <div style="font-size: 12px; color: #92400e; line-height: 1.4;">
            <strong>Can view</strong> = View and download files only<br>
            <strong>Can edit</strong> = Upload, delete, and modify files
          </div>
        </div>
      </div>
      
      <!-- Footer -->
      <div style="padding: 16px 24px; border-top: 1px solid #e5e7eb; background: #f9fafb; display:flex; justify-content:flex-end; gap:12px;">
        <button onclick="document.getElementById('new-folder-modal-overlay').remove(); window.showNewFolderModal = false; window.vaultNewFolderPermissions = [];" style="padding:10px 20px; border:1px solid #d1d5db; background:white; border-radius:8px; cursor:pointer; font-weight: 500; color: #374151; transition: all 0.2s;" onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">Cancel</button>
        <button id="vault-new-folder-create" style="padding:10px 20px; background:#f59e0b; color:white; border:none; border-radius:8px; cursor:pointer; font-weight:600; transition: all 0.2s;" onmouseover="this.style.background='#d97706'" onmouseout="this.style.background='#f59e0b'">Create Folder</button>
      </div>
    </div>
  `;

  document.body.appendChild(overlay);

  document.getElementById('vault-new-folder-create').onclick = function () {
    var name = document.getElementById('new-folder-input').value;
    var pid = window.vaultNewFolderParentId;
    var permissions = window.vaultNewFolderPermissions || [];
    window.createVaultFolder(name, pid, permissions);
  };

  // Handle Enter key in folder name input
  document.getElementById('new-folder-input').onkeydown = function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      document.getElementById('vault-new-folder-create').click();
    }
  };

  setTimeout(function () { var i = document.getElementById('new-folder-input'); if (i) i.focus(); }, 50);
};

// ============================================
// MANAGE FOLDER ACCESS MODAL
// ============================================

// State for manage access modal
window.vaultManageAccessFolderId = null;
window.vaultManageAccessPermissions = [];
window.vaultManageAccessShareableClients = []; // Team + clients for Add people dropdown
window.vaultManageAccessFolderName = '';
window.vaultManageAccessSearchQuery = '';
window.vaultManageAccessIsOwner = false; // Track if current user is owner

// Load folder permissions from database
window.loadVaultFolderPermissions = async function (folderId) {
  if (!folderId) return [];

  try {
    const { data, error } = await supabase
      .from('vault_permissions')
      .select(`
        id,
        user_id,
        permission_level,
        profiles!vault_permissions_user_id_fkey(id, first_name, last_name, email)
      `)
      .eq('item_type', 'folder')
      .eq('item_id', folderId);

    if (error) throw error;
    return (data || []).map(p => ({
      id: p.id,
      userId: p.user_id,
      name: p.profiles ? `${p.profiles.first_name || ''} ${p.profiles.last_name || ''}`.trim() || p.profiles.email : 'Unknown',
      email: p.profiles?.email || '',
      permissionLevel: p.permission_level || 'view'
    }));
  } catch (e) {
    console.error('Error loading folder permissions:', e);
    return [];
  }
};

// Get folder details
window.getVaultFolderDetails = async function (folderId) {
  if (!folderId) return null;

  try {
    const { data, error } = await supabase
      .from('vault_folders')
      .select('id, name, created_by')
      .eq('id', folderId)
      .single();

    if (error) throw error;
    return data;
  } catch (e) {
    console.error('Error loading folder details:', e);
    return null;
  }
};

// Show Manage Access modal
window.showVaultManageAccessModal = async function (folderId) {
  if (!folderId) return;

  // Show loading
  const loadingOverlay = document.createElement('div');
  loadingOverlay.id = 'vault-manage-access-loading';
  loadingOverlay.style.cssText = 'position:fixed; top:0; left:0; right:0; bottom:0; background:rgba(0,0,0,0.5); z-index:10000; display:flex; align-items:center; justify-content:center;';
  loadingOverlay.innerHTML = '<div style="background:white; padding:24px 48px; border-radius:12px; font-size:14px; color:#374151;">Loading...</div>';
  document.body.appendChild(loadingOverlay);

  // Load company clients (with login) so dropdown shows team + clients
  await (window.loadVaultShareableClientsOnce && window.loadVaultShareableClientsOnce());

  const [folder, permissions] = await Promise.all([
    window.getVaultFolderDetails(folderId),
    window.loadVaultFolderPermissions(folderId)
  ]);

  loadingOverlay.remove();

  if (!folder) {
    if (window.vaultToast) window.vaultToast('Could not load folder', 'error');
    return;
  }

  window.vaultManageAccessFolderId = folderId;
  window.vaultManageAccessFolderName = folder.name;
  window.vaultManageAccessPermissions = permissions;
  window.vaultManageAccessIsOwner = folder.created_by === currentUser?.id; // Store owner status

  const isOwner = window.vaultManageAccessIsOwner;
  const shareableList = [...(teamMembers || []), ...(window.vaultManageAccessShareableClients || [])].filter(m => m.id !== currentUser?.id);
  const hasTeamMembers = shareableList.length > 0;

  const overlay = document.createElement('div');
  overlay.id = 'vault-manage-access-overlay';
  overlay.style.cssText = 'position:fixed; top:0; left:0; right:0; bottom:0; background:rgba(0,0,0,0.5); z-index:10000; display:flex; align-items:center; justify-content:center; padding: 20px;';
  overlay.onclick = function (e) { if (e.target === overlay) overlay.remove(); };

  overlay.innerHTML = `
    <div style="background:white; padding:0; border-radius:16px; width:500px; max-width:95%; box-shadow:0 25px 50px -12px rgba(0,0,0,0.25); overflow:hidden;" onclick="event.stopPropagation();">
      <!-- Header -->
      <div style="padding: 20px 24px; border-bottom: 1px solid #e5e7eb;">
        <div style="display: flex; align-items: center; gap: 12px;">
          <div style="width: 40px; height: 40px; background: #fef3c7; border-radius: 10px; display: flex; align-items: center; justify-content: center;">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" stroke-width="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
          </div>
          <div>
            <h3 style="margin:0; font-size:18px; font-weight:600; color: #111827;">Manage Access</h3>
            <p style="margin: 2px 0 0 0; font-size: 13px; color: #6b7280;">${(folder.name || '').replace(/</g, '&lt;')}</p>
          </div>
        </div>
      </div>
      
      <!-- Content -->
      <div style="padding: 24px; max-height: 55vh; overflow-y: auto;">
        <!-- Owner Info -->
        <div style="display: flex; align-items: center; justify-content: space-between; padding: 12px 14px; background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 10px; margin-bottom: 20px;">
          <div style="display: flex; align-items: center; gap: 10px;">
            <div style="width: 36px; height: 36px; border-radius: 50%; background: #22c55e; color: white; display: flex; align-items: center; justify-content: center; font-weight: 600; font-size: 14px;">
              ${((currentUser?.first_name || 'Y').charAt(0)).toUpperCase()}
            </div>
            <div>
              <div style="font-weight: 500; color: #111827; font-size: 14px;">${isOwner ? 'You' : 'Owner'}</div>
              <div style="font-size: 12px; color: #16a34a;">Owner</div>
            </div>
          </div>
          <div style="font-size: 12px; color: #16a34a; font-weight: 500; background: #dcfce7; padding: 4px 10px; border-radius: 20px;">Full access</div>
        </div>
        
        ${hasTeamMembers && isOwner ? `
        <!-- Add People Section -->
        <div style="margin-bottom: 20px;">
          <label style="display: block; font-size: 14px; font-weight: 500; color: #374151; margin-bottom: 8px;">Add people</label>
          <div style="position: relative;">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="2" style="position: absolute; left: 12px; top: 50%; transform: translateY(-50%); pointer-events: none;"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
            <input id="vault-manage-access-search" type="text" placeholder="Search team members and clients..." 
                   style="width:100%; padding:10px 12px 10px 38px; border:1px solid #d1d5db; border-radius:8px; outline:none; font-size: 14px;"
                   oninput="window.showVaultManageAccessDropdown(this.value)"
                   onfocus="window.showVaultManageAccessDropdown(this.value)"
                   onblur="setTimeout(function(){ window.hideVaultManageAccessDropdown(); }, 200)" />
            
            <!-- Dropdown -->
            <div id="vault-manage-access-dropdown" style="display: none; position: absolute; top: 100%; left: 0; right: 0; background: white; border: 1px solid #e5e7eb; border-radius: 8px; box-shadow: 0 10px 25px -5px rgba(0,0,0,0.1); margin-top: 4px; z-index: 10; max-height: 180px; overflow-y: auto;"></div>
          </div>
        </div>
        ` : ''}
        
        <!-- People with access -->
        <div>
          <label style="display: block; font-size: 14px; font-weight: 500; color: #374151; margin-bottom: 8px;">People with access</label>
          <div id="vault-manage-access-list">
            ${window.renderVaultManageAccessList(permissions, isOwner)}
          </div>
        </div>
      </div>
      
      <!-- Footer -->
      <div style="padding: 16px 24px; border-top: 1px solid #e5e7eb; background: #f9fafb; display:flex; justify-content:flex-end;">
        <button onclick="document.getElementById('vault-manage-access-overlay').remove();" style="padding:10px 24px; background:#1f2937; color:white; border:none; border-radius:8px; cursor:pointer; font-weight:600; transition: all 0.2s;" onmouseover="this.style.background='#374151'" onmouseout="this.style.background='#1f2937'">Done</button>
      </div>
    </div>
  `;

  document.body.appendChild(overlay);
};

// Render the access list
window.renderVaultManageAccessList = function (permissions, isOwner) {
  const nonOwnerPerms = (permissions || []).filter(p => p.permissionLevel !== 'owner');

  if (nonOwnerPerms.length === 0) {
    return '<div style="color: #9ca3af; font-size: 13px; padding: 16px; text-align: center; background: #f9fafb; border-radius: 8px;">No one else has access to this folder</div>';
  }

  return nonOwnerPerms.map(p => `
    <div style="display: flex; align-items: center; justify-content: space-between; padding: 12px 14px; background: #f9fafb; border-radius: 10px; margin-bottom: 8px;">
      <div style="display: flex; align-items: center; gap: 10px;">
        <div style="width: 36px; height: 36px; border-radius: 50%; background: #f59e0b; color: white; display: flex; align-items: center; justify-content: center; font-weight: 600; font-size: 14px;">
          ${(p.name || 'U').charAt(0).toUpperCase()}
        </div>
        <div>
          <div style="font-weight: 500; color: #111827; font-size: 14px;">${(p.name || '').replace(/</g, '&lt;')}</div>
          <div style="font-size: 12px; color: #6b7280;">${p.permissionLevel === 'edit' ? 'Can edit' : 'Can view'}</div>
        </div>
      </div>
      ${isOwner ? `
      <div style="display: flex; align-items: center; gap: 8px;">
        <select onchange="window.updateVaultFolderPermission('${p.id}', this.value)" style="padding: 6px 10px; border: 1px solid #d1d5db; border-radius: 6px; font-size: 13px; background: white; cursor: pointer;">
          <option value="view" ${p.permissionLevel === 'view' ? 'selected' : ''}>Can view</option>
          <option value="edit" ${p.permissionLevel === 'edit' ? 'selected' : ''}>Can edit</option>
        </select>
        <button onclick="window.removeVaultFolderAccess('${p.id}')" style="width: 32px; height: 32px; border: none; background: #fee2e2; color: #ef4444; border-radius: 6px; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 18px;" title="Remove access">×</button>
      </div>
      ` : `
      <div style="font-size: 12px; color: #6b7280; padding: 4px 10px; background: #e5e7eb; border-radius: 20px;">${p.permissionLevel === 'edit' ? 'Can edit' : 'Can view'}</div>
      `}
    </div>
  `).join('');
};

// Update the manage access list display
window.updateVaultManageAccessDisplay = function () {
  const container = document.getElementById('vault-manage-access-list');
  if (!container) return;

  // Use the stored owner status from when the modal was opened
  const isOwner = window.vaultManageAccessIsOwner;

  container.innerHTML = window.renderVaultManageAccessList(window.vaultManageAccessPermissions, isOwner);
};

// Show dropdown for adding users in manage access modal (loads clients when opened so web always has them)
window.showVaultManageAccessDropdown = async function (query) {
  const dropdown = document.getElementById('vault-manage-access-dropdown');
  if (!dropdown) return;
  dropdown.innerHTML = '<div style="padding: 12px; color: #6b7280; font-size: 13px; text-align: center;">Loading...</div>';
  dropdown.style.display = 'block';
  await (window.loadVaultShareableClientsOnce && window.loadVaultShareableClientsOnce());
  query = (query || '').toLowerCase().trim();
  const addedIds = (window.vaultManageAccessPermissions || []).map(function (p) { return p.userId; });
  var available = (window.getVaultShareableUsers && window.getVaultShareableUsers()) || [];
  available = available.filter(function (m) { return !addedIds.includes(m.id); });
  if (query) {
    available = available.filter(function (m) {
      var fullName = ((m.first_name || '') + ' ' + (m.last_name || '')).toLowerCase();
      return fullName.indexOf(query) !== -1 || ((m.email || '').toLowerCase().indexOf(query) !== -1);
    });
  }
  if (available.length === 0) {
    dropdown.innerHTML = '<div style="padding: 12px; color: #9ca3af; font-size: 13px; text-align: center;">No users found</div>';
    dropdown.style.display = 'block';
    return;
  }
  dropdown.innerHTML = available.slice(0, 8).map(function (m) {
    var initial = ((m.first_name || 'U').charAt(0)).toUpperCase();
    var name = (m.first_name || '') + ' ' + (m.last_name || '');
    var role = m.company_role || 'Team member';
    return '<div onmousedown="window.addVaultFolderAccess(\'' + m.id + '\', \'view\')" style="padding: 10px 12px; cursor: pointer; display: flex; align-items: center; gap: 10px; transition: background 0.15s;" onmouseover="this.style.background=\'#f3f4f6\'" onmouseout="this.style.background=\'transparent\'">' +
      '<div style="width: 32px; height: 32px; border-radius: 50%; background: #e5e7eb; color: #374151; display: flex; align-items: center; justify-content: center; font-weight: 600; font-size: 13px;">' + initial + '</div>' +
      '<div><div style="font-weight: 500; color: #111827; font-size: 14px;">' + (name || 'User').replace(/</g, '&lt;') + '</div>' +
      '<div style="font-size: 12px; color: #6b7280;">' + (role || 'Team member').replace(/</g, '&lt;') + '</div></div></div>';
  }).join('');
  dropdown.style.display = 'block';
};

// Hide manage access dropdown
window.hideVaultManageAccessDropdown = function () {
  const dropdown = document.getElementById('vault-manage-access-dropdown');
  if (dropdown) dropdown.style.display = 'none';
};

// Helper: Grant view access to all parent folders for a user
window.grantVaultParentFolderAccess = async function (folderId, userId) {
  if (!folderId || !userId || !currentCompany) return;

  try {
    // Get the folder to find its parent
    const { data: folder, error: folderError } = await supabase
      .from('vault_folders')
      .select('parent_id')
      .eq('id', folderId)
      .single();

    if (folderError || !folder || !folder.parent_id) return;

    const parentId = folder.parent_id;

    // Check if user already has access to parent
    const { data: existingPerm } = await supabase
      .from('vault_permissions')
      .select('id')
      .eq('item_type', 'folder')
      .eq('item_id', parentId)
      .eq('user_id', userId)
      .single();

    // Also check if user is the parent folder creator (they don't need permission)
    const { data: parentFolder } = await supabase
      .from('vault_folders')
      .select('created_by')
      .eq('id', parentId)
      .single();

    if (!existingPerm && parentFolder?.created_by !== userId) {
      // Grant view access to parent
      await supabase
        .from('vault_permissions')
        .insert({
          company_id: currentCompany.id,
          item_type: 'folder',
          item_id: parentId,
          user_id: userId,
          permission_level: 'view',
          created_by: currentUser.id
        });
    }

    // Recursively grant access to grandparent, etc.
    await window.grantVaultParentFolderAccess(parentId, userId);
  } catch (e) {
    console.error('Error granting parent folder access:', e);
  }
};

// Add user access to folder (in manage modal)
window.addVaultFolderAccess = async function (userId, permissionLevel = 'view') {
  if (!userId || !window.vaultManageAccessFolderId) return;

  const user = (teamMembers || []).find(m => m.id === userId) || (window.vaultManageAccessShareableClients || []).find(m => m.id === userId);
  if (!user) return;

  try {
    const { data, error } = await supabase
      .from('vault_permissions')
      .insert({
        company_id: currentCompany.id,
        item_type: 'folder',
        item_id: window.vaultManageAccessFolderId,
        user_id: userId,
        permission_level: permissionLevel,
        created_by: currentUser.id
      })
      .select()
      .single();

    if (error) throw error;

    // Auto-grant view access to all parent folders
    await window.grantVaultParentFolderAccess(window.vaultManageAccessFolderId, userId);

    // Update local state
    window.vaultManageAccessPermissions.push({
      id: data.id,
      userId: userId,
      name: `${user.first_name || ''} ${user.last_name || ''}`.trim() || user.email || 'Unknown',
      email: user.email || '',
      permissionLevel: permissionLevel
    });

    window.updateVaultManageAccessDisplay();

    // Clear search
    const searchInput = document.getElementById('vault-manage-access-search');
    if (searchInput) searchInput.value = '';
    window.hideVaultManageAccessDropdown();

    if (window.vaultToast) window.vaultToast('Access granted');
  } catch (e) {
    console.error('Error adding access:', e);
    if (window.vaultToast) window.vaultToast('Failed to add access', 'error');
  }
};

// Update permission level (in manage modal)
window.updateVaultFolderPermission = async function (permissionId, newLevel) {
  if (!permissionId) return;

  try {
    const { error } = await supabase
      .from('vault_permissions')
      .update({ permission_level: newLevel })
      .eq('id', permissionId);

    if (error) throw error;

    // Update local state
    const perm = window.vaultManageAccessPermissions.find(p => p.id === permissionId);
    if (perm) perm.permissionLevel = newLevel;

    if (window.vaultToast) window.vaultToast('Permission updated');
  } catch (e) {
    console.error('Error updating permission:', e);
    if (window.vaultToast) window.vaultToast('Failed to update', 'error');
  }
};

// Remove user access (in manage modal)
window.removeVaultFolderAccess = async function (permissionId) {
  if (!permissionId) return;

  try {
    const { error } = await supabase
      .from('vault_permissions')
      .delete()
      .eq('id', permissionId);

    if (error) throw error;

    // Update local state
    window.vaultManageAccessPermissions = window.vaultManageAccessPermissions.filter(p => p.id !== permissionId);
    window.updateVaultManageAccessDisplay();

    if (window.vaultToast) window.vaultToast('Access removed');
  } catch (e) {
    console.error('Error removing access:', e);
    if (window.vaultToast) window.vaultToast('Failed to remove', 'error');
  }
};

// Check if current user can manage a folder (is owner)
window.canManageVaultFolder = function (folder) {
  if (!folder || !currentUser) return false;
  return folder.created_by === currentUser.id;
};

// Check user's permission level for a folder
window.getUserVaultFolderPermission = async function (folderId) {
  if (!folderId || !currentUser) return null;

  try {
    // First check if user is the creator
    const { data: folder } = await supabase
      .from('vault_folders')
      .select('created_by')
      .eq('id', folderId)
      .single();

    if (folder?.created_by === currentUser.id) return 'owner';

    // Check permission record
    const { data: perm } = await supabase
      .from('vault_permissions')
      .select('permission_level')
      .eq('item_type', 'folder')
      .eq('item_id', folderId)
      .eq('user_id', currentUser.id)
      .single();

    return perm?.permission_level || null;
  } catch (e) {
    return null;
  }
};

// ============================================
// FOLDER CONTEXT MENU FUNCTIONS
// ============================================

// Track currently open folder menu (portal: menu moved to body when open)
window.vaultOpenFolderMenuId = null;
window.vaultFolderMenuParent = null;

// Toggle folder context menu
window.toggleVaultFolderMenu = function (folderId) {
  const menu = document.getElementById('vault-folder-menu-' + folderId);
  if (!menu) return;

  // Close any other open menus first
  window.hideVaultFolderMenu();
  window.hideVaultFileMenu();

  // Toggle this menu
  if (window.vaultOpenFolderMenuId === folderId) {
    window.vaultOpenFolderMenuId = null;
  } else {
    // Trigger button is the previous sibling of the menu
    const button = menu.previousElementSibling;
    const rect = button ? button.getBoundingClientRect() : null;

    // Move menu to body with position:fixed so it's never clipped by overflow (list view)
    window.vaultFolderMenuParent = menu.parentNode;
    document.body.appendChild(menu);

    menu.style.display = 'block';
    menu.style.position = 'fixed';
    menu.style.zIndex = '10001';
    if (rect) {
      const left = Math.max(8, Math.min(rect.right - menu.offsetWidth, window.innerWidth - menu.offsetWidth - 8));
      const top = Math.min(rect.bottom + 4, window.innerHeight - menu.offsetHeight - 8);
      menu.style.top = top + 'px';
      menu.style.left = left + 'px';
    } else {
      menu.style.top = '0';
      menu.style.left = '0';
    }
    menu.style.right = 'auto';
    menu.style.marginTop = '0';

    window.vaultOpenFolderMenuId = folderId;
  }
};

// Hide all folder menus
window.hideVaultFolderMenu = function () {
  if (window.vaultOpenFolderMenuId) {
    const menu = document.getElementById('vault-folder-menu-' + window.vaultOpenFolderMenuId);
    if (menu && menu.parentNode === document.body && window.vaultFolderMenuParent) {
      menu.style.display = 'none';
      menu.style.position = '';
      menu.style.top = '';
      menu.style.left = '';
      menu.style.right = '';
      menu.style.zIndex = '';
      menu.style.marginTop = '';
      window.vaultFolderMenuParent.appendChild(menu);
    } else if (menu) {
      menu.style.display = 'none';
    }
    window.vaultOpenFolderMenuId = null;
    window.vaultFolderMenuParent = null;
  }
};

// Close folder menu when clicking outside
document.addEventListener('click', function (e) {
  if (window.vaultOpenFolderMenuId && !e.target.closest('[id^="vault-folder-menu-"]') && !e.target.closest('button[onclick*="toggleVaultFolderMenu"]')) {
    window.hideVaultFolderMenu();
  }
  // Also close the "New" menu when clicking outside
  if (!e.target.closest('#vault-new-menu-dropdown') && !e.target.closest('#vault-new-menu-btn')) {
    window.hideVaultNewMenu();
  }
});

// ============================================
// VAULT "NEW" MENU FUNCTIONS
// ============================================

// Track if new menu is open
window.vaultNewMenuOpen = false;

// Toggle the "New" dropdown menu
window.toggleVaultNewMenu = function () {
  const dropdown = document.getElementById('vault-new-menu-dropdown');
  if (!dropdown) return;

  window.vaultNewMenuOpen = !window.vaultNewMenuOpen;
  dropdown.style.display = window.vaultNewMenuOpen ? 'block' : 'none';
};

// Hide the "New" dropdown menu
window.hideVaultNewMenu = function () {
  const dropdown = document.getElementById('vault-new-menu-dropdown');
  if (dropdown) dropdown.style.display = 'none';
  window.vaultNewMenuOpen = false;
};

// ============================================
// FILE CONTEXT MENU FUNCTIONS
// ============================================

// Track currently open file menu (portal: menu moved to body when open)
window.vaultOpenFileMenuId = null;
window.vaultFileMenuParent = null;

// Toggle file context menu
window.toggleVaultFileMenu = function (fileId) {
  const menu = document.getElementById('vault-file-menu-' + fileId);
  if (!menu) return;

  // Close any other open menus first
  window.hideVaultFileMenu();
  window.hideVaultFolderMenu();

  // Toggle this menu
  if (window.vaultOpenFileMenuId === fileId) {
    window.vaultOpenFileMenuId = null;
  } else {
    // Trigger button is the previous sibling of the menu
    const button = menu.previousElementSibling;
    const rect = button ? button.getBoundingClientRect() : null;

    // Move menu to body with position:fixed so it's never clipped by overflow (list view)
    window.vaultFileMenuParent = menu.parentNode;
    document.body.appendChild(menu);

    menu.style.display = 'block';
    menu.style.position = 'fixed';
    menu.style.zIndex = '10001';
    if (rect) {
      const left = Math.max(8, Math.min(rect.right - menu.offsetWidth, window.innerWidth - menu.offsetWidth - 8));
      const top = Math.min(rect.bottom + 4, window.innerHeight - menu.offsetHeight - 8);
      menu.style.top = top + 'px';
      menu.style.left = left + 'px';
    } else {
      menu.style.top = '0';
      menu.style.left = '0';
    }
    menu.style.right = 'auto';
    menu.style.marginTop = '0';

    window.vaultOpenFileMenuId = fileId;
  }
};

// Hide all file menus
window.hideVaultFileMenu = function () {
  if (window.vaultOpenFileMenuId) {
    const menu = document.getElementById('vault-file-menu-' + window.vaultOpenFileMenuId);
    if (menu && menu.parentNode === document.body && window.vaultFileMenuParent) {
      menu.style.display = 'none';
      menu.style.position = '';
      menu.style.top = '';
      menu.style.left = '';
      menu.style.right = '';
      menu.style.zIndex = '';
      menu.style.marginTop = '';
      window.vaultFileMenuParent.appendChild(menu);
    } else if (menu) {
      menu.style.display = 'none';
    }
    window.vaultOpenFileMenuId = null;
    window.vaultFileMenuParent = null;
  }
};

// Close file menu when clicking outside
document.addEventListener('click', function (e) {
  if (window.vaultOpenFileMenuId && !e.target.closest('[id^="vault-file-menu-"]') && !e.target.closest('button[onclick*="toggleVaultFileMenu"]')) {
    window.hideVaultFileMenu();
  }
});

// Show move file modal
window.showMoveFileModal = async function (fileId, fileName) {
  // Show loading overlay first
  const overlay = document.createElement('div');
  overlay.id = 'vault-move-file-overlay';
  overlay.style.cssText = 'position:fixed; top:0; left:0; right:0; bottom:0; background:rgba(0,0,0,0.5); z-index:10000; display:flex; align-items:center; justify-content:center; padding: 20px;';
  overlay.onclick = function (e) { if (e.target === overlay) overlay.remove(); };

  overlay.innerHTML = `
    <div style="background:white; padding:24px; border-radius:12px; width:420px; max-width:95%; box-shadow:0 25px 50px -12px rgba(0,0,0,0.25); text-align:center;" onclick="event.stopPropagation();">
      <div style="width:40px; height:40px; border:3px solid #e5e7eb; border-top-color:#f59e0b; border-radius:50%; animation:spin 1s linear infinite; margin:0 auto 16px;"></div>
      <p style="margin:0; color:#6b7280;">Loading folders...</p>
    </div>
  `;
  document.body.appendChild(overlay);

  // Get company ID - try multiple sources
  const companyId = currentCompany?.id || window.currentCompanyId || localStorage.getItem('selectedCompanyId');
  const userId = currentUser?.id;
  console.log('Move file modal - Company ID:', companyId, 'User ID:', userId);

  // Fetch all folders AND user's permissions to filter by access
  let accessibleFolders = [];
  try {
    // Load folders and user's folder permissions in parallel
    const [foldersResult, permissionsResult] = await Promise.all([
      supabase
        .from('vault_folders')
        .select('*')
        .eq('company_id', companyId)
        .eq('is_deleted', false)
        .order('name'),
      supabase
        .from('vault_permissions')
        .select('item_id, permission_level')
        .eq('company_id', companyId)
        .eq('item_type', 'folder')
        .eq('user_id', userId)
    ]);

    if (foldersResult.error) {
      console.error('Supabase error fetching folders:', foldersResult.error);
    }
    if (permissionsResult.error) {
      console.error('Supabase error fetching permissions:', permissionsResult.error);
    }

    const allFolders = foldersResult.data || [];
    const userPermissions = permissionsResult.data || [];

    // Build permission map for quick lookup
    const permissionMap = {};
    userPermissions.forEach(p => {
      permissionMap[p.item_id] = p.permission_level;
    });

    // Filter folders: user can see folder if they created it OR have a permission record
    accessibleFolders = allFolders.filter(f => {
      const isOwner = f.created_by === userId;
      const hasPermission = permissionMap[f.id] !== undefined;
      return isOwner || hasPermission;
    });

    console.log('Fetched folders for move:', allFolders.length, 'Accessible:', accessibleFolders.length);
  } catch (e) {
    console.error('Error fetching folders for move:', e);
    // Fallback to cached folders (already filtered in main UI)
    accessibleFolders = (vaultFolders || []).filter(f => !f.is_deleted);
    console.log('Using cached folders:', accessibleFolders.length);
  }

  // Build folder hierarchy with indentation
  const buildFolderOptions = (folders, parentId = null, depth = 0) => {
    let options = '';
    const children = folders.filter(f => f.parent_id === parentId);
    for (const folder of children) {
      const indent = '─'.repeat(depth);
      options += `<option value="${folder.id}">${indent}${depth > 0 ? ' ' : ''}${(folder.name || '').replace(/</g, '&lt;')}</option>`;
      options += buildFolderOptions(folders, folder.id, depth + 1);
    }
    return options;
  };

  const folderOptions = buildFolderOptions(accessibleFolders);
  console.log('Move modal - Folder options generated:', folderOptions.length > 0 ? 'yes' : 'no');

  // Update overlay with actual content
  overlay.innerHTML = `
    <div style="background:white; padding:24px; border-radius:12px; width:420px; max-width:95%; box-shadow:0 25px 50px -12px rgba(0,0,0,0.25);" onclick="event.stopPropagation();">
      <h3 style="margin:0 0 8px 0; font-size:18px; font-weight:600; color: #111827;">Move File</h3>
      <p style="margin:0 0 20px 0; font-size:14px; color:#6b7280;">Select a destination folder for "<strong>${(fileName || '').replace(/</g, '&lt;')}</strong>"</p>
      
      <div style="margin-bottom:20px;">
        <label style="display:block; font-size:13px; font-weight:600; color:#374151; margin-bottom:8px;">Destination Folder</label>
        <select id="vault-move-file-folder" style="width:100%; padding:12px; border:1px solid #d1d5db; border-radius:8px; font-size:14px; background:#fff;">
          <option value="">Root (My Files)</option>
          ${folderOptions}
        </select>
        ${accessibleFolders.length === 0 ? '<p style="margin:8px 0 0 0; font-size:12px; color:#9ca3af;">No folders found. Create a folder first.</p>' : ''}
      </div>
      
      <div style="display:flex; justify-content:flex-end; gap:12px;">
        <button onclick="document.getElementById('vault-move-file-overlay').remove();" style="padding:10px 20px; border:1px solid #d1d5db; background:white; border-radius:8px; cursor:pointer; font-weight: 500; color: #374151;">Cancel</button>
        <button id="vault-move-file-save" style="padding:10px 20px; background:#f59e0b; color:white; border:none; border-radius:8px; cursor:pointer; font-weight:600;">Move</button>
      </div>
    </div>
  `;

  document.body.appendChild(overlay);

  // Handle save
  document.getElementById('vault-move-file-save').onclick = async function () {
    const newFolderId = document.getElementById('vault-move-file-folder').value || null;

    this.disabled = true;
    this.textContent = 'Moving...';

    try {
      const { error } = await supabase
        .from('vault_files')
        .update({ folder_id: newFolderId })
        .eq('id', fileId);

      if (error) throw error;

      overlay.remove();
      await window.refreshVaultUI();
      if (window.vaultToast) window.vaultToast('File moved successfully');
    } catch (e) {
      console.error('Error moving file:', e);
      if (window.vaultToast) window.vaultToast('Failed to move file', 'error');
      this.disabled = false;
      this.textContent = 'Move';
    }
  };
};

// Show rename folder modal
window.showVaultRenameFolderModal = function (folderId, currentName) {
  const overlay = document.createElement('div');
  overlay.id = 'vault-rename-folder-overlay';
  overlay.style.cssText = 'position:fixed; top:0; left:0; right:0; bottom:0; background:rgba(0,0,0,0.5); z-index:10000; display:flex; align-items:center; justify-content:center; padding: 20px;';
  overlay.onclick = function (e) { if (e.target === overlay) overlay.remove(); };

  overlay.innerHTML = `
    <div style="background:white; padding:24px; border-radius:12px; width:400px; max-width:95%; box-shadow:0 25px 50px -12px rgba(0,0,0,0.25);" onclick="event.stopPropagation();">
      <h3 style="margin:0 0 16px 0; font-size:18px; font-weight:600; color: #111827;">Rename Folder</h3>
      <input id="vault-rename-folder-input" type="text" value="${(currentName || '').replace(/"/g, '&quot;')}" placeholder="Folder name" style="width:100%; padding:12px; border:1px solid #d1d5db; border-radius:8px; margin-bottom:20px; outline:none; font-size: 14px;" onfocus="this.select()" />
      <div style="display:flex; justify-content:flex-end; gap:12px;">
        <button onclick="document.getElementById('vault-rename-folder-overlay').remove();" style="padding:10px 20px; border:1px solid #d1d5db; background:white; border-radius:8px; cursor:pointer; font-weight: 500; color: #374151;">Cancel</button>
        <button id="vault-rename-folder-save" style="padding:10px 20px; background:#f59e0b; color:white; border:none; border-radius:8px; cursor:pointer; font-weight:600;">Rename</button>
      </div>
    </div>
  `;

  document.body.appendChild(overlay);

  // Focus and select input
  setTimeout(function () {
    const input = document.getElementById('vault-rename-folder-input');
    if (input) {
      input.focus();
      input.select();
    }
  }, 50);

  // Handle save
  document.getElementById('vault-rename-folder-save').onclick = async function () {
    const newName = document.getElementById('vault-rename-folder-input').value.trim();
    if (!newName) {
      if (window.vaultToast) window.vaultToast('Please enter a folder name', 'error');
      return;
    }

    this.disabled = true;
    this.textContent = 'Saving...';

    try {
      const { error } = await supabase
        .from('vault_folders')
        .update({ name: newName })
        .eq('id', folderId);

      if (error) throw error;

      overlay.remove();
      await window.refreshVaultUI();
      if (window.vaultToast) window.vaultToast('Folder renamed');
    } catch (e) {
      console.error('Error renaming folder:', e);
      if (window.vaultToast) window.vaultToast('Failed to rename folder', 'error');
      this.disabled = false;
      this.textContent = 'Rename';
    }
  };

  // Handle Enter key
  document.getElementById('vault-rename-folder-input').onkeydown = function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      document.getElementById('vault-rename-folder-save').click();
    }
  };
};

// Duplicate removed - using the definition at line 1980

// ============================================
// DOCUMENT WIZARD FUNCTIONS
// ============================================

// Open Document Wizard
window.openDocWizard = function () {
  docWizardOpen = true;
  docWizardStep = 1;
  docWizardData = {
    outputFormat: null,
    templateCategory: null,
    templateType: null,
    templateName: null,
    audience: 'Internal Staff',
    tone: 'Formal',
    length: '2-3 pages',
    region: 'US',
    details: {},
    chatMessages: [],
    uploadedContent: null,
    uploadedFileName: null,
    generatedOutline: null,
    generatedContent: null,
    tags: '',
    versionNote: `v1 generated on ${new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}`
  };
  docWizardLoading = false;
  docWizardExpandedCategories = { operations: true };
  window.renderDocWizardPanel();
};

// Close Document Wizard
window.closeDocWizard = function (force = false) {
  if (!force && docWizardStep > 1) {
    // Show modern confirmation modal
    window.showDocWizardCloseConfirm();
    return;
  }
  window.performDocWizardClose();
};

// Actually close the wizard
window.performDocWizardClose = function () {
  docWizardOpen = false;
  window.docWizardFolders = null; // Clear cached folders
  const panel = document.getElementById('doc-wizard-panel');
  if (panel) {
    panel.style.transform = 'translateX(100%)';
    setTimeout(() => panel.remove(), 300);
  }
  // Remove confirm modal if exists
  const confirmModal = document.getElementById('doc-wizard-close-confirm');
  if (confirmModal) confirmModal.remove();
};

// Show modern close confirmation modal
window.showDocWizardCloseConfirm = function () {
  // Remove existing modal if any
  const existing = document.getElementById('doc-wizard-close-confirm');
  if (existing) existing.remove();

  const overlay = document.createElement('div');
  overlay.id = 'doc-wizard-close-confirm';
  overlay.style.cssText = 'position:fixed; top:0; left:0; right:0; bottom:0; background:rgba(0,0,0,0.5); z-index:100001; display:flex; align-items:center; justify-content:center; padding:20px; animation: fadeIn 0.2s ease;';

  overlay.innerHTML = `
    <div style="background:white; padding:0; border-radius:16px; width:400px; max-width:95%; box-shadow:0 25px 50px -12px rgba(0,0,0,0.25); overflow:hidden; animation: slideUp 0.3s ease;" onclick="event.stopPropagation();">
      <!-- Warning Icon Header -->
      <div style="background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%); padding: 24px; text-align: center;">
        <div style="width: 64px; height: 64px; background: #f59e0b; border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 16px; box-shadow: 0 4px 14px rgba(245, 158, 11, 0.4);">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
            <line x1="12" y1="9" x2="12" y2="13"></line>
            <line x1="12" y1="17" x2="12.01" y2="17"></line>
          </svg>
        </div>
        <h3 style="margin: 0; font-size: 20px; font-weight: 700; color: #92400e;">Close Document Wizard?</h3>
      </div>
      
      <!-- Content -->
      <div style="padding: 24px;">
        <p style="margin: 0 0 8px 0; font-size: 15px; color: #374151; text-align: center; line-height: 1.6;">
          All your progress will be <strong>permanently lost</strong> and you'll have to start over from the beginning.
        </p>
        <p style="margin: 0; font-size: 13px; color: #6b7280; text-align: center;">
          You're currently on step ${docWizardStep} of 6
        </p>
      </div>
      
      <!-- Buttons -->
      <div style="padding: 0 24px 24px; display: flex; gap: 12px;">
        <button onclick="document.getElementById('doc-wizard-close-confirm').remove();" style="flex: 1; padding: 14px 20px; border: 1px solid #d1d5db; background: white; border-radius: 10px; cursor: pointer; font-weight: 600; font-size: 14px; color: #374151; transition: all 0.2s;" onmouseover="this.style.background='#f9fafb'; this.style.borderColor='#9ca3af'" onmouseout="this.style.background='white'; this.style.borderColor='#d1d5db'">
          Keep Working
        </button>
        <button onclick="window.performDocWizardClose();" style="flex: 1; padding: 14px 20px; background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%); border: none; border-radius: 10px; cursor: pointer; font-weight: 600; font-size: 14px; color: white; transition: all 0.2s; box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);" onmouseover="this.style.transform='translateY(-1px)'; this.style.boxShadow='0 4px 12px rgba(239,68,68,0.4)'" onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='0 2px 8px rgba(239,68,68,0.3)'">
          Close & Discard
        </button>
      </div>
    </div>
  `;

  // Close on background click
  overlay.onclick = function (e) {
    if (e.target === overlay) overlay.remove();
  };

  document.body.appendChild(overlay);
};

// Navigate wizard steps
window.docWizardNextStep = function () {
  // Validate current step before advancing
  if (docWizardStep === 1 && !docWizardData.outputFormat) {
    if (window.vaultToast) window.vaultToast('Please select an output format', 'error');
    return;
  }
  if (docWizardStep === 2 && !docWizardData.templateType) {
    if (window.vaultToast) window.vaultToast('Please select a template type', 'error');
    return;
  }
  if (docWizardStep === 4) {
    // Custom chat flow: no "Continue" here—user clicks "Generate document from conversation" in footer
    if (docWizardData.templateType === 'custom_chat') return;
    // Check if at least one required field is filled
    const fields = docWizardTemplateFields[docWizardData.templateType] || [];
    const requiredFields = fields.filter(f => f.required);
    const missingRequired = requiredFields.some(f => !docWizardData.details[f.id]?.trim());
    if (missingRequired) {
      if (window.vaultToast) window.vaultToast('Please fill in the required fields', 'error');
      return;
    }
    // Auto-advance to generate outline
    window.docWizardGenerateOutline();
    return;
  }

  docWizardStep = Math.min(docWizardStep + 1, 6);
  window.renderDocWizardPanel();
};

window.docWizardPrevStep = function () {
  docWizardStep = Math.max(docWizardStep - 1, 1);
  window.renderDocWizardPanel();
};

// Select output format
window.docWizardSelectFormat = function (format) {
  docWizardData.outputFormat = format;
  window.renderDocWizardPanel();
};

// Toggle template category
window.docWizardToggleCategory = function (categoryId) {
  docWizardExpandedCategories[categoryId] = !docWizardExpandedCategories[categoryId];
  window.renderDocWizardPanel();
};

// Select template
window.docWizardSelectTemplate = function (categoryId, templateId, templateName) {
  docWizardData.templateCategory = categoryId;
  docWizardData.templateType = templateId;
  docWizardData.templateName = templateName;
  docWizardData.details = {};
  if (templateId === 'custom_chat') {
    docWizardData.chatMessages = [
      { role: 'assistant', content: "You want to make a custom document. What do you want to write about? You can ask for help—for example: \"I need a job application but don't know where to start\" or \"I want to create a larger policy document\"—and I'll suggest what to include and ask questions to shape it. Just tell me what you need." }
    ];
    if (currentCompany && currentCompany.name) docWizardData.details['business_name'] = currentCompany.name;
  } else {
    docWizardData.chatMessages = [];
  }
  window.renderDocWizardPanel();
};

// Update style option
window.docWizardSetStyle = function (option, value) {
  docWizardData[option] = value;
  window.renderDocWizardPanel();
};

// Update detail field
window.docWizardUpdateDetail = function (fieldId, value) {
  docWizardData.details[fieldId] = value;
};

// Show example prompt
window.docWizardShowExample = function () {
  const example = docWizardExamplePrompts[docWizardData.templateType];
  if (!example) {
    if (window.vaultToast) window.vaultToast('No example available for this template', 'error');
    return;
  }

  // Fill in the details with example data
  docWizardData.details = { ...example };
  window.renderDocWizardPanel();
  if (window.vaultToast) window.vaultToast('Example loaded! Feel free to modify.');
};

// Upload existing document
window.docWizardUploadExisting = function () {
  const input = document.createElement('input');
  input.type = 'file';
  input.accept = '.txt,.doc,.docx,.pdf';
  input.onchange = async function (e) {
    const file = e.target.files[0];
    if (!file) return;

    docWizardData.uploadedFileName = file.name;

    // For text files, read directly
    if (file.name.endsWith('.txt')) {
      const reader = new FileReader();
      reader.onload = function (e) {
        docWizardData.uploadedContent = e.target.result;
        window.renderDocWizardPanel();
        if (window.vaultToast) window.vaultToast('Document loaded! Content will be used to improve/rewrite.');
      };
      reader.readAsText(file);
    } else {
      // For other formats, we'll extract text later or use the AI to interpret
      docWizardData.uploadedContent = `[Uploaded file: ${file.name}]`;
      window.renderDocWizardPanel();
      if (window.vaultToast) window.vaultToast('Document attached! Note: For best results with Word/PDF, copy-paste the text content into the details fields.');
    }
  };
  input.click();
};

// Remove uploaded document
window.docWizardRemoveUpload = function () {
  docWizardData.uploadedContent = null;
  docWizardData.uploadedFileName = null;
  window.renderDocWizardPanel();
};

// Generate outline (quick AI call)
window.docWizardGenerateOutline = async function () {
  docWizardLoading = true;
  docWizardStep = 5;
  window.renderDocWizardPanel();

  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) throw new Error('Please log in to generate documents');

    const templateName = docWizardData.templateName || docWizardData.templateType;
    const detailsText = Object.entries(docWizardData.details)
      .filter(([k, v]) => v && v.trim())
      .map(([k, v]) => `${k.replace(/_/g, ' ')}: ${v}`)
      .join('\n');

    const outlinePrompt = `Generate a brief outline for a ${templateName} document. The document should be in ${docWizardData.tone} tone, for ${docWizardData.audience}, with ${docWizardData.length} length.

Here are the details provided:
${detailsText}

${docWizardData.uploadedContent ? `The user has also uploaded an existing document to improve/rewrite: ${docWizardData.uploadedContent}` : ''}

Return ONLY a bullet-point outline showing the main sections and key points that will be covered. Use - for each bullet point. Keep it concise (5-10 bullets max).`;

    const response = await fetch(`${SUPABASE_URL}/functions/v1/ai-chat`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${session.access_token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        messages: [{ role: 'user', content: outlinePrompt }],
        systemPrompt: 'You are a professional document outline generator. Return only bullet points, no explanations or extra text. Be concise and clear.'
      })
    });

    if (!response.ok) throw new Error('Failed to generate outline');

    const data = await response.json();
    docWizardData.generatedOutline = data.message;

  } catch (error) {
    console.error('Error generating outline:', error);
    if (window.vaultToast) window.vaultToast('Failed to generate outline: ' + error.message, 'error');
    docWizardData.generatedOutline = '- Error generating outline. Please try again.';
  }

  docWizardLoading = false;
  window.renderDocWizardPanel();
};

// Generate full document
window.docWizardGenerateDocument = async function () {
  docWizardLoading = true;
  docWizardStep = 6;
  window.renderDocWizardPanel();

  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) throw new Error('Please log in to generate documents');

    const templateName = docWizardData.templateName || docWizardData.templateType;
    const detailsText = Object.entries(docWizardData.details)
      .filter(([k, v]) => v && v.trim())
      .map(([k, v]) => `${k.replace(/_/g, ' ')}: ${v}`)
      .join('\n');

    const generatePrompt = `Create a professional ${templateName} document with the following specifications:

**Format:** ${docWizardData.outputFormat === 'docx' ? 'Word Document (editable)' : 'PDF (final)'}
**Tone:** ${docWizardData.tone}
**Audience:** ${docWizardData.audience}
**Length:** ${docWizardData.length}
**Region:** ${docWizardData.region}

**Details provided:**
${detailsText}

${docWizardData.uploadedContent ? `**Existing content to improve/rewrite:**
${docWizardData.uploadedContent}` : ''}

**Instructions:**
1. Create a well-structured, professional document
2. Use clear headings and sections
3. Include all relevant information from the details provided
4. Use appropriate formatting (bullet points, numbered lists where applicable)
5. Match the specified tone and audience
6. For ${docWizardData.region} region standards if relevant

Format your response as clean document content that can be converted to ${docWizardData.outputFormat === 'docx' ? 'Word' : 'PDF'}. Use markdown formatting:
- # for main title
- ## for section headings
- ### for subsections
- **bold** for emphasis
- - for bullet points
- 1. for numbered lists`;

    const response = await fetch(`${SUPABASE_URL}/functions/v1/ai-chat`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${session.access_token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        messages: [{ role: 'user', content: generatePrompt }],
        systemPrompt: 'You are a professional document writer. Create complete, well-formatted documents. Output only the document content as raw markdown—do not wrap in ```markdown or code blocks. Write the actual document content directly with no fences or meta-commentary.'
      })
    });

    if (!response.ok) throw new Error('Failed to generate document');

    const data = await response.json();
    docWizardData.generatedContent = window.stripDocMarkdownFences(data.message || '');

  } catch (error) {
    console.error('Error generating document:', error);
    if (window.vaultToast) window.vaultToast('Failed to generate document: ' + error.message, 'error');
    docWizardData.generatedContent = 'Error generating document. Please try again.';
  }

  docWizardLoading = false;
  window.renderDocWizardPanel();
};

// Chat: send user message and get AI reply (custom document flow)
window.docWizardChatSend = async function () {
  const input = document.getElementById('doc-wizard-chat-input');
  if (!input) return;
  const text = (input.value || '').trim();
  if (!text) return;

  docWizardData.chatMessages = docWizardData.chatMessages || [];
  docWizardData.chatMessages.push({ role: 'user', content: text });
  docWizardData.chatMessages.push({ role: 'assistant', content: '__THINKING__' });
  input.value = '';

  const sendBtn = document.getElementById('doc-wizard-chat-send');
  if (sendBtn) { sendBtn.disabled = true; sendBtn.textContent = '...'; }

  window.renderDocWizardPanel();

  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) throw new Error('Please log in');

    const companyName = docWizardData.details['business_name'] || currentCompany?.name || 'the company';
    const systemPrompt = `You are a document-creation assistant. Your ONLY purpose is to help the user create a written document (policy, job application, guide, etc.). Company name: ${companyName}. Style: ${docWizardData.tone} tone, for ${docWizardData.audience}, approximately ${docWizardData.length}. Suggest what to include, ask clarifying questions, or help them figure out what they need. Do not write the full document yet—this is a chat to shape the document. Keep replies concise. If the user asks about anything other than creating a document (e.g. images, code, general questions), politely say you can only help with creating documents and ask what document they'd like to create.`;

    const messages = docWizardData.chatMessages.filter(m => m.content !== '__THINKING__').map(m => ({ role: m.role, content: m.content }));

    const response = await fetch(`${SUPABASE_URL}/functions/v1/ai-chat`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${session.access_token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ messages, systemPrompt })
    });

    if (!response.ok) throw new Error('Failed to get reply');
    const data = await response.json();
    docWizardData.chatMessages = docWizardData.chatMessages.filter(m => m.content !== '__THINKING__');
    docWizardData.chatMessages.push({ role: 'assistant', content: data.message || '' });
  } catch (error) {
    console.error('Chat error:', error);
    docWizardData.chatMessages = docWizardData.chatMessages.filter(m => m.content !== '__THINKING__');
    docWizardData.chatMessages.push({ role: 'assistant', content: 'Sorry, I could not reply right now. Please try again.' });
    if (window.vaultToast) window.vaultToast('Chat error: ' + (error.message || 'Try again'), 'error');
  }

  if (sendBtn) { sendBtn.disabled = false; sendBtn.textContent = 'Send'; }
  window.renderDocWizardPanel();

  const msgEl = document.getElementById('doc-wizard-chat-messages');
  if (msgEl) msgEl.scrollTop = msgEl.scrollHeight;
};

// Generate document from chat conversation (custom document flow)
window.docWizardGenerateFromChat = async function () {
  docWizardLoading = true;
  docWizardStep = 6;
  window.renderDocWizardPanel();

  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) throw new Error('Please log in to generate documents');

    const companyName = docWizardData.details['business_name'] || currentCompany?.name || 'the company';
    const convoText = (docWizardData.chatMessages || []).map(m => `${m.role === 'user' ? 'User' : 'Assistant'}: ${m.content}`).join('\n\n');

    const generatePrompt = `Create a professional document based on this conversation. Company name: ${companyName}.

**Conversation:**
${convoText}

**Format:** ${docWizardData.outputFormat === 'docx' ? 'Word Document' : 'PDF'}
**Tone:** ${docWizardData.tone}
**Audience:** ${docWizardData.audience}
**Length:** ${docWizardData.length}
**Region:** ${docWizardData.region}

Write the complete document content. Use markdown: # for main title, ## for sections, ### for subsections, **bold**, - for bullets, 1. for numbered lists. Do not add meta-commentary—output only the document content. Do NOT wrap the output in \`\`\`markdown or any code fences—output raw markdown text only.`;

    const response = await fetch(`${SUPABASE_URL}/functions/v1/ai-chat`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${session.access_token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        messages: [{ role: 'user', content: generatePrompt }],
        systemPrompt: 'You are a professional document writer. Output only the document content as raw markdown. Do not wrap in ```markdown or code blocks—output the markdown directly with no fences.'
      })
    });

    if (!response.ok) throw new Error('Failed to generate document');
    const data = await response.json();
    docWizardData.generatedContent = window.stripDocMarkdownFences(data.message || '');
    docWizardData.generatedOutline = 'Custom document from conversation';
  } catch (error) {
    console.error('Error generating from chat:', error);
    if (window.vaultToast) window.vaultToast('Failed to generate: ' + error.message, 'error');
    docWizardData.generatedContent = 'Error generating document. Please try again.';
  }

  docWizardLoading = false;
  window.renderDocWizardPanel();
};

// Strip ```markdown or ``` code fences from AI-generated document content
window.stripDocMarkdownFences = function (text) {
  if (!text || typeof text !== 'string') return text;
  let s = text.trim();
  const openMatch = s.match(/^```(?:markdown|md)?\s*\n?/i);
  if (openMatch) s = s.slice(openMatch[0].length);
  const closeMatch = s.match(/\n?```\s*$/);
  if (closeMatch) s = s.slice(0, -closeMatch[0].length);
  return s.trim();
};

// Update generated content (for manual edits)
window.docWizardUpdateContent = function (content) {
  docWizardData.generatedContent = content;
};

// Download as Word document
window.docWizardDownloadWord = async function () {
  if (!docWizardData.generatedContent) return;

  // Check if docx library is loaded
  if (typeof docx === 'undefined') {
    if (window.vaultToast) window.vaultToast('Document library not loaded. Please refresh the page and try again.', 'error');
    console.error('docx library not loaded. Make sure the CDN script is included.');
    return;
  }

  try {
    // Parse the markdown content into structured sections
    const content = docWizardData.generatedContent;
    const lines = content.split('\n');

    const children = [];

    for (const line of lines) {
      const trimmed = line.trim();
      if (!trimmed) continue;

      if (trimmed.startsWith('# ')) {
        // Main title
        children.push(new docx.Paragraph({
          children: [new docx.TextRun({ text: trimmed.slice(2), bold: true, size: 48 })],
          spacing: { after: 400 }
        }));
      } else if (trimmed.startsWith('## ')) {
        // Section heading
        children.push(new docx.Paragraph({
          children: [new docx.TextRun({ text: trimmed.slice(3), bold: true, size: 32 })],
          spacing: { before: 400, after: 200 }
        }));
      } else if (trimmed.startsWith('### ')) {
        // Subsection heading
        children.push(new docx.Paragraph({
          children: [new docx.TextRun({ text: trimmed.slice(4), bold: true, size: 26 })],
          spacing: { before: 300, after: 150 }
        }));
      } else if (trimmed.startsWith('- ') || trimmed.startsWith('* ')) {
        // Bullet point
        children.push(new docx.Paragraph({
          children: [new docx.TextRun({ text: trimmed.slice(2) })],
          bullet: { level: 0 },
          spacing: { after: 100 }
        }));
      } else if (/^\d+\.\s/.test(trimmed)) {
        // Numbered list
        children.push(new docx.Paragraph({
          children: [new docx.TextRun({ text: trimmed.replace(/^\d+\.\s/, '') })],
          numbering: { reference: 'default-numbering', level: 0 },
          spacing: { after: 100 }
        }));
      } else {
        // Regular paragraph - handle bold text
        const textRuns = [];
        let remaining = trimmed;
        const boldRegex = /\*\*([^*]+)\*\*/g;
        let lastIndex = 0;
        let match;

        while ((match = boldRegex.exec(remaining)) !== null) {
          if (match.index > lastIndex) {
            textRuns.push(new docx.TextRun({ text: remaining.slice(lastIndex, match.index) }));
          }
          textRuns.push(new docx.TextRun({ text: match[1], bold: true }));
          lastIndex = match.index + match[0].length;
        }
        if (lastIndex < remaining.length) {
          textRuns.push(new docx.TextRun({ text: remaining.slice(lastIndex) }));
        }
        if (textRuns.length === 0) {
          textRuns.push(new docx.TextRun({ text: trimmed }));
        }

        children.push(new docx.Paragraph({
          children: textRuns,
          spacing: { after: 200 }
        }));
      }
    }

    const doc = new docx.Document({
      numbering: {
        config: [{
          reference: 'default-numbering',
          levels: [{
            level: 0,
            format: docx.LevelFormat.DECIMAL,
            text: '%1.',
            alignment: docx.AlignmentType.START,
          }]
        }]
      },
      sections: [{
        properties: {},
        children: children
      }]
    });

    const blob = await docx.Packer.toBlob(doc);
    const fileName = `${docWizardData.templateName || 'document'}_${new Date().toISOString().split('T')[0]}.docx`;
    saveAs(blob, fileName);

    if (window.vaultToast) window.vaultToast('Word document downloaded!');
  } catch (error) {
    console.error('Error creating Word document:', error);
    if (window.vaultToast) window.vaultToast('Failed to create Word document', 'error');
  }
};

// Download as PDF
window.docWizardDownloadPdf = function () {
  if (!docWizardData.generatedContent) return;

  // Try multiple ways to access jsPDF (different builds export differently)
  let jsPDFClass = null;
  if (window.jspdf && window.jspdf.jsPDF) {
    jsPDFClass = window.jspdf.jsPDF;
  } else if (window.jsPDF) {
    jsPDFClass = window.jsPDF;
  } else if (typeof jsPDF !== 'undefined') {
    jsPDFClass = jsPDF;
  }

  if (!jsPDFClass) {
    console.error('jsPDF library not found. Checked: window.jspdf.jsPDF, window.jsPDF, jsPDF');
    if (window.vaultToast) window.vaultToast('PDF library not loaded. Please refresh the page.', 'error');
    return;
  }

  try {
    const doc = new jsPDFClass();

    const content = docWizardData.generatedContent;
    const lines = content.split('\n');

    let y = 20;
    const pageHeight = doc.internal.pageSize.height;
    const margin = 20;
    const lineHeight = 7;
    const maxWidth = doc.internal.pageSize.width - (margin * 2);

    for (const line of lines) {
      const trimmed = line.trim();
      if (!trimmed) {
        y += 5;
        continue;
      }

      // Check if we need a new page
      if (y > pageHeight - 30) {
        doc.addPage();
        y = 20;
      }

      if (trimmed.startsWith('# ')) {
        doc.setFontSize(20);
        doc.setFont(undefined, 'bold');
        const titleLines = doc.splitTextToSize(trimmed.slice(2), maxWidth);
        titleLines.forEach(t => {
          if (y > pageHeight - 30) { doc.addPage(); y = 20; }
          doc.text(t, margin, y);
          y += 12;
        });
      } else if (trimmed.startsWith('## ')) {
        doc.setFontSize(16);
        doc.setFont(undefined, 'bold');
        const subLines = doc.splitTextToSize(trimmed.slice(3), maxWidth);
        subLines.forEach(t => {
          if (y > pageHeight - 30) { doc.addPage(); y = 20; }
          doc.text(t, margin, y);
          y += 10;
        });
      } else if (trimmed.startsWith('### ')) {
        doc.setFontSize(14);
        doc.setFont(undefined, 'bold');
        const h3Lines = doc.splitTextToSize(trimmed.slice(4), maxWidth);
        h3Lines.forEach(t => {
          if (y > pageHeight - 30) { doc.addPage(); y = 20; }
          doc.text(t, margin, y);
          y += 9;
        });
      } else if (trimmed.startsWith('- ') || trimmed.startsWith('* ')) {
        doc.setFontSize(11);
        doc.setFont(undefined, 'normal');
        const text = '• ' + trimmed.slice(2);
        const splitText = doc.splitTextToSize(text, maxWidth - 10);
        splitText.forEach(t => {
          if (y > pageHeight - 30) { doc.addPage(); y = 20; }
          doc.text(t, margin + 5, y);
          y += lineHeight;
        });
      } else if (/^\d+\.\s/.test(trimmed)) {
        doc.setFontSize(11);
        doc.setFont(undefined, 'normal');
        const splitText = doc.splitTextToSize(trimmed, maxWidth - 10);
        splitText.forEach(t => {
          if (y > pageHeight - 30) { doc.addPage(); y = 20; }
          doc.text(t, margin + 5, y);
          y += lineHeight;
        });
      } else {
        doc.setFontSize(11);
        doc.setFont(undefined, 'normal');
        // Remove markdown bold markers for PDF
        const cleanText = trimmed.replace(/\*\*([^*]+)\*\*/g, '$1');
        const splitText = doc.splitTextToSize(cleanText, maxWidth);
        splitText.forEach(t => {
          if (y > pageHeight - 30) { doc.addPage(); y = 20; }
          doc.text(t, margin, y);
          y += lineHeight;
        });
      }
    }

    const fileName = `${docWizardData.templateName || 'document'}_${new Date().toISOString().split('T')[0]}.pdf`;
    doc.save(fileName);

    if (window.vaultToast) window.vaultToast('PDF downloaded!');
  } catch (error) {
    console.error('Error creating PDF:', error);
    if (window.vaultToast) window.vaultToast('Failed to create PDF', 'error');
  }
};

// Save to vault
window.docWizardSaveToVault = async function () {
  if (!docWizardData.generatedContent) return;

  // Check if required libraries are loaded
  if (docWizardData.outputFormat === 'docx' && typeof docx === 'undefined') {
    if (window.vaultToast) window.vaultToast('Document library not loaded. Please refresh the page and try again.', 'error');
    return;
  }

  // Try multiple ways to access jsPDF
  let jsPDFClass = null;
  if (window.jspdf && window.jspdf.jsPDF) {
    jsPDFClass = window.jspdf.jsPDF;
  } else if (window.jsPDF) {
    jsPDFClass = window.jsPDF;
  } else if (typeof jsPDF !== 'undefined') {
    jsPDFClass = jsPDF;
  }

  if (docWizardData.outputFormat === 'pdf' && !jsPDFClass) {
    console.error('jsPDF library not found for save. Checked: window.jspdf.jsPDF, window.jsPDF, jsPDF');
    if (window.vaultToast) window.vaultToast('PDF library not loaded. Please refresh the page.', 'error');
    return;
  }

  const folderId = document.getElementById('doc-wizard-save-folder')?.value || null;

  try {
    // Create the file based on output format
    let blob, fileName, mimeType;

    if (docWizardData.outputFormat === 'docx') {
      // Create Word document blob
      const content = docWizardData.generatedContent;
      const lines = content.split('\n');
      const children = [];

      for (const line of lines) {
        const trimmed = line.trim();
        if (!trimmed) continue;

        if (trimmed.startsWith('# ')) {
          children.push(new docx.Paragraph({
            children: [new docx.TextRun({ text: trimmed.slice(2), bold: true, size: 48 })],
            spacing: { after: 400 }
          }));
        } else if (trimmed.startsWith('## ')) {
          children.push(new docx.Paragraph({
            children: [new docx.TextRun({ text: trimmed.slice(3), bold: true, size: 32 })],
            spacing: { before: 400, after: 200 }
          }));
        } else if (trimmed.startsWith('### ')) {
          children.push(new docx.Paragraph({
            children: [new docx.TextRun({ text: trimmed.slice(4), bold: true, size: 26 })],
            spacing: { before: 300, after: 150 }
          }));
        } else if (trimmed.startsWith('- ') || trimmed.startsWith('* ')) {
          children.push(new docx.Paragraph({
            children: [new docx.TextRun({ text: trimmed.slice(2) })],
            bullet: { level: 0 },
            spacing: { after: 100 }
          }));
        } else {
          children.push(new docx.Paragraph({
            children: [new docx.TextRun({ text: trimmed.replace(/\*\*([^*]+)\*\*/g, '$1') })],
            spacing: { after: 200 }
          }));
        }
      }

      const doc = new docx.Document({
        sections: [{ properties: {}, children: children }]
      });

      blob = await docx.Packer.toBlob(doc);
      fileName = `${docWizardData.templateName || 'document'}_${new Date().toISOString().split('T')[0]}.docx`;
      mimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    } else {
      // Create PDF blob
      const pdfDoc = new jsPDFClass();

      const content = docWizardData.generatedContent;
      const lines = content.split('\n');
      let y = 20;
      const pageHeight = pdfDoc.internal.pageSize.height;
      const margin = 20;
      const lineHeight = 7;
      const maxWidth = pdfDoc.internal.pageSize.width - (margin * 2);

      for (const line of lines) {
        const trimmed = line.trim();
        if (!trimmed) { y += 5; continue; }
        if (y > pageHeight - 30) { pdfDoc.addPage(); y = 20; }

        if (trimmed.startsWith('# ')) {
          pdfDoc.setFontSize(20);
          pdfDoc.setFont(undefined, 'bold');
          const titleLines = pdfDoc.splitTextToSize(trimmed.slice(2), maxWidth);
          titleLines.forEach(t => {
            if (y > pageHeight - 30) { pdfDoc.addPage(); y = 20; }
            pdfDoc.text(t, margin, y);
            y += 12;
          });
        } else if (trimmed.startsWith('## ')) {
          pdfDoc.setFontSize(16);
          pdfDoc.setFont(undefined, 'bold');
          const subLines = pdfDoc.splitTextToSize(trimmed.slice(3), maxWidth);
          subLines.forEach(t => {
            if (y > pageHeight - 30) { pdfDoc.addPage(); y = 20; }
            pdfDoc.text(t, margin, y);
            y += 10;
          });
        } else if (trimmed.startsWith('### ')) {
          pdfDoc.setFontSize(14);
          pdfDoc.setFont(undefined, 'bold');
          const h3Lines = pdfDoc.splitTextToSize(trimmed.slice(4), maxWidth);
          h3Lines.forEach(t => {
            if (y > pageHeight - 30) { pdfDoc.addPage(); y = 20; }
            pdfDoc.text(t, margin, y);
            y += 9;
          });
        } else {
          pdfDoc.setFontSize(11);
          pdfDoc.setFont(undefined, 'normal');
          const cleanText = trimmed.replace(/\*\*([^*]+)\*\*/g, '$1').replace(/^[-*]\s/, '• ');
          const splitText = pdfDoc.splitTextToSize(cleanText, maxWidth);
          splitText.forEach(t => {
            if (y > pageHeight - 30) { pdfDoc.addPage(); y = 20; }
            pdfDoc.text(t, margin, y);
            y += lineHeight;
          });
        }
      }

      blob = pdfDoc.output('blob');
      fileName = `${docWizardData.templateName || 'document'}_${new Date().toISOString().split('T')[0]}.pdf`;
      mimeType = 'application/pdf';
    }

    // Upload to Supabase storage
    const storagePath = `${currentCompany.id}/${folderId || 'root'}/${Date.now()}_${fileName}`;

    const { error: uploadError } = await supabase.storage
      .from('vault')
      .upload(storagePath, blob, { contentType: mimeType });

    if (uploadError) throw uploadError;

    // Create file record (matching vault_files schema)
    const { error: dbError } = await supabase.from('vault_files').insert({
      company_id: currentCompany.id,
      folder_id: folderId || null,
      name: fileName,
      storage_path: storagePath,
      mime_type: mimeType,
      size_bytes: blob.size,
      created_by: currentUser.id
    });

    if (dbError) throw dbError;

    if (window.vaultToast) window.vaultToast('Document saved to vault!');
    window.closeDocWizard(true);
    await window.refreshVaultUI();

  } catch (error) {
    console.error('Error saving to vault:', error);
    if (window.vaultToast) window.vaultToast('Failed to save: ' + error.message, 'error');
  }
};

// Render the Document Wizard Panel
window.renderDocWizardPanel = function () {
  // Remove existing panel if any
  let panel = document.getElementById('doc-wizard-panel');
  if (!docWizardOpen) {
    if (panel) panel.remove();
    return;
  }

  if (!panel) {
    panel = document.createElement('div');
    panel.id = 'doc-wizard-panel';
    document.body.appendChild(panel);
  }

  const stepTitles = [
    'Output Format',
    'Document Type',
    'Style Options',
    'Document Details',
    'Preview Outline',
    'Generate & Save'
  ];

  panel.style.cssText = `
    position: fixed;
    top: 0;
    right: 0;
    width: 520px;
    max-width: 100vw;
    height: 100vh;
    background: #fff;
    box-shadow: -10px 0 40px rgba(0,0,0,0.15);
    z-index: 10001;
    display: flex;
    flex-direction: column;
    transform: translateX(0);
    transition: transform 0.3s ease;
  `;

  panel.innerHTML = `
    <!-- Header -->
    <div style="padding: 20px 24px; border-bottom: 1px solid #e5e7eb; flex-shrink: 0;">
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
        <h2 style="margin: 0; font-size: 18px; font-weight: 700; color: #111827;">Document Wizard</h2>
        <button onclick="window.closeDocWizard()" style="width: 32px; height: 32px; border: none; background: #f3f4f6; border-radius: 6px; cursor: pointer; display: flex; align-items: center; justify-content: center; color: #6b7280; transition: all 0.2s;" onmouseover="this.style.background='#e5e7eb'" onmouseout="this.style.background='#f3f4f6'">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
      </div>
      
      <!-- Progress Bar -->
      <div style="display: flex; align-items: center; gap: 8px;">
        <div style="font-size: 13px; color: #6b7280; white-space: nowrap;">Step ${docWizardStep}/6</div>
        <div style="flex: 1; height: 6px; background: #e5e7eb; border-radius: 3px; overflow: hidden;">
          <div style="width: ${(docWizardStep / 6) * 100}%; height: 100%; background: linear-gradient(90deg, #f59e0b, #d97706); border-radius: 3px; transition: width 0.3s;"></div>
        </div>
        <div style="font-size: 13px; color: #374151; font-weight: 500; white-space: nowrap;">${stepTitles[docWizardStep - 1]}</div>
      </div>
    </div>
    
    <!-- Content Area -->
    <div style="flex: 1; overflow-y: auto; padding: 24px;">
      ${window.renderDocWizardStep()}
    </div>
    
    <!-- Footer Navigation -->
    <div style="padding: 16px 24px; border-top: 1px solid #e5e7eb; display: flex; justify-content: space-between; gap: 12px; flex-shrink: 0; background: #fafafa;">
      ${docWizardStep > 1 ? `
        <button onclick="window.docWizardPrevStep()" style="padding: 10px 20px; border: 1px solid #d1d5db; background: #fff; border-radius: 8px; font-weight: 500; color: #374151; cursor: pointer; display: flex; align-items: center; gap: 6px;">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="15 18 9 12 15 6"></polyline></svg>
          Back
        </button>
      ` : '<div></div>'}
      
      ${docWizardStep < 5 ? `
        ${docWizardStep === 4 && docWizardData.templateType === 'custom_chat' ? `
        <button onclick="window.docWizardGenerateFromChat()" ${docWizardLoading ? 'disabled' : ''} style="padding: 10px 24px; background: ${docWizardLoading ? '#d1d5db' : 'linear-gradient(135deg, #10b981 0%, #059669 100%)'}; border: none; border-radius: 8px; font-weight: 600; color: white; cursor: ${docWizardLoading ? 'not-allowed' : 'pointer'}; display: flex; align-items: center; gap: 6px;">
          ${docWizardLoading ? 'Generating...' : 'Generate document from conversation'}
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"></path><polyline points="14 2 14 8 20 8"></polyline></svg>
        </button>
        ` : `
        <button onclick="window.docWizardNextStep()" ${docWizardLoading ? 'disabled' : ''} style="padding: 10px 24px; background: ${docWizardLoading ? '#d1d5db' : 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)'}; border: none; border-radius: 8px; font-weight: 600; color: white; cursor: ${docWizardLoading ? 'not-allowed' : 'pointer'}; display: flex; align-items: center; gap: 6px;">
          Continue
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"></polyline></svg>
        </button>
        `}
      ` : docWizardStep === 5 ? `
        <button onclick="window.docWizardGenerateDocument()" ${docWizardLoading ? 'disabled' : ''} style="padding: 10px 24px; background: ${docWizardLoading ? '#d1d5db' : 'linear-gradient(135deg, #10b981 0%, #059669 100%)'}; border: none; border-radius: 8px; font-weight: 600; color: white; cursor: ${docWizardLoading ? 'not-allowed' : 'pointer'}; display: flex; align-items: center; gap: 6px;">
          ${docWizardLoading ? 'Generating...' : 'Generate Document'}
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"></path><polyline points="14 2 14 8 20 8"></polyline></svg>
        </button>
      ` : ''}
    </div>
  `;
};

// Render current wizard step content
window.renderDocWizardStep = function () {
  switch (docWizardStep) {
    case 1:
      return window.renderDocWizardStep1();
    case 2:
      return window.renderDocWizardStep2();
    case 3:
      return window.renderDocWizardStep3();
    case 4:
      return window.renderDocWizardStep4();
    case 5:
      return window.renderDocWizardStep5();
    case 6:
      return window.renderDocWizardStep6();
    default:
      return '';
  }
};

// Step 1: Output Format
window.renderDocWizardStep1 = function () {
  const formats = [
    {
      id: 'docx',
      label: 'Word Document',
      ext: '.docx',
      hint: 'Editable - can be modified after download',
      icon: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z M14 2v6h6 M16 13H8 M16 17H8 M10 9H8',
      color: '#2563eb'
    },
    {
      id: 'pdf',
      label: 'PDF Document',
      ext: '.pdf',
      hint: 'Final/Locked - best for distribution',
      icon: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z M14 2v6h6',
      color: '#dc2626'
    }
  ];

  return `
    <div style="margin-bottom: 24px;">
      <h3 style="margin: 0 0 8px 0; font-size: 20px; font-weight: 600; color: #111827;">What do you want to generate?</h3>
      <p style="margin: 0; color: #6b7280; font-size: 14px;">Choose the output format for your document.</p>
    </div>
    
    <div style="display: flex; flex-direction: column; gap: 16px;">
      ${formats.map(f => `
        <div onclick="window.docWizardSelectFormat('${f.id}')" style="
          padding: 20px;
          border: 2px solid ${docWizardData.outputFormat === f.id ? f.color : '#e5e7eb'};
          border-radius: 12px;
          cursor: pointer;
          transition: all 0.2s;
          background: ${docWizardData.outputFormat === f.id ? (f.id === 'docx' ? '#eff6ff' : '#fef2f2') : '#fff'};
          display: flex;
          align-items: center;
          gap: 16px;
        " onmouseover="if('${docWizardData.outputFormat}' !== '${f.id}') this.style.borderColor='#d1d5db'" onmouseout="if('${docWizardData.outputFormat}' !== '${f.id}') this.style.borderColor='#e5e7eb'">
          <div style="width: 56px; height: 56px; border-radius: 12px; background: ${f.id === 'docx' ? '#dbeafe' : '#fee2e2'}; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="${f.color}" stroke-width="1.5">${f.icon.split(' M').map((p, i) => i === 0 ? `<path d="${p}"></path>` : `<path d="M${p}"></path>`).join('')}</svg>
          </div>
          <div style="flex: 1;">
            <div style="font-size: 16px; font-weight: 600; color: #111827; margin-bottom: 4px;">${f.label} <span style="color: #9ca3af; font-weight: 400;">${f.ext}</span></div>
            <div style="font-size: 13px; color: #6b7280;">${f.hint}</div>
          </div>
          ${docWizardData.outputFormat === f.id ? `
            <div style="width: 24px; height: 24px; background: ${f.color}; border-radius: 50%; display: flex; align-items: center; justify-content: center;">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
            </div>
          ` : ''}
        </div>
      `).join('')}
    </div>
  `;
};

// Step 2: Template Type
window.renderDocWizardStep2 = function () {
  return `
    <div style="margin-bottom: 24px;">
      <h3 style="margin: 0 0 8px 0; font-size: 20px; font-weight: 600; color: #111827;">Choose a template type</h3>
      <p style="margin: 0; color: #6b7280; font-size: 14px;">Select the type of document you want to create.</p>
    </div>
    
    <div style="display: flex; flex-direction: column; gap: 8px;">
      ${Object.entries(docWizardTemplateCategories).map(([catId, cat]) => `
        <div style="border: 1px solid #e5e7eb; border-radius: 12px; overflow: hidden;">
          <!-- Category Header -->
          <div onclick="window.docWizardToggleCategory('${catId}')" style="padding: 14px 16px; background: #f9fafb; cursor: pointer; display: flex; align-items: center; gap: 12px; transition: background 0.2s;" onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='#f9fafb'">
            <div style="width: 36px; height: 36px; background: #fff; border: 1px solid #e5e7eb; border-radius: 8px; display: flex; align-items: center; justify-content: center;">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" stroke-width="2"><path d="${cat.icon}"></path></svg>
            </div>
            <div style="flex: 1; font-weight: 600; color: #111827;">${cat.label}</div>
            <div style="color: #9ca3af; font-size: 12px;">${cat.templates.length} templates</div>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" stroke-width="2" style="transform: rotate(${docWizardExpandedCategories[catId] ? '180deg' : '0'}); transition: transform 0.2s;"><polyline points="6 9 12 15 18 9"></polyline></svg>
          </div>
          
          <!-- Templates List -->
          ${docWizardExpandedCategories[catId] ? `
            <div style="padding: 8px; display: flex; flex-direction: column; gap: 4px;">
              ${cat.templates.map(t => `
                <div onclick="window.docWizardSelectTemplate('${catId}', '${t.id}', '${t.name.replace(/'/g, "\\'")}')" style="
                  padding: 12px 14px;
                  border-radius: 8px;
                  cursor: pointer;
                  transition: all 0.15s;
                  background: ${docWizardData.templateType === t.id ? '#fef3c7' : 'transparent'};
                  border: 1px solid ${docWizardData.templateType === t.id ? '#f59e0b' : 'transparent'};
                " onmouseover="if('${docWizardData.templateType}' !== '${t.id}') this.style.background='#f9fafb'" onmouseout="if('${docWizardData.templateType}' !== '${t.id}') this.style.background='transparent'">
                  <div style="display: flex; align-items: center; justify-content: space-between;">
                    <div>
                      <div style="font-weight: 500; color: #111827; font-size: 14px; margin-bottom: 2px;">${t.name}</div>
                      <div style="font-size: 12px; color: #6b7280;">${t.description}</div>
                    </div>
                    ${docWizardData.templateType === t.id ? `
                      <div style="width: 20px; height: 20px; background: #f59e0b; border-radius: 50%; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
                        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
                      </div>
                    ` : ''}
                  </div>
                </div>
              `).join('')}
            </div>
          ` : ''}
        </div>
      `).join('')}
    </div>
  `;
};

// Step 3: Style Options
window.renderDocWizardStep3 = function () {
  const options = [
    { id: 'audience', label: 'Audience', choices: ['Internal Staff', 'Customers'] },
    { id: 'tone', label: 'Tone', choices: ['Formal', 'Friendly', 'Strict'] },
    { id: 'length', label: 'Length', choices: ['1 page', '2-3 pages', 'Detailed'] },
    { id: 'region', label: 'Region (optional)', choices: ['US', 'Canada', 'Other'] }
  ];

  return `
    <div style="margin-bottom: 24px;">
      <h3 style="margin: 0 0 8px 0; font-size: 20px; font-weight: 600; color: #111827;">Style & Preferences</h3>
      <p style="margin: 0; color: #6b7280; font-size: 14px;">Customize how your document should read.</p>
    </div>
    
    <div style="display: flex; flex-direction: column; gap: 24px;">
      ${options.map(opt => `
        <div>
          <div style="font-size: 13px; font-weight: 600; color: #374151; margin-bottom: 10px; text-transform: uppercase; letter-spacing: 0.5px;">${opt.label}</div>
          <div style="display: flex; flex-wrap: wrap; gap: 8px;">
            ${opt.choices.map(choice => `
              <button onclick="window.docWizardSetStyle('${opt.id}', '${choice}')" style="
                padding: 10px 18px;
                border: 2px solid ${docWizardData[opt.id] === choice ? '#f59e0b' : '#e5e7eb'};
                background: ${docWizardData[opt.id] === choice ? '#fef3c7' : '#fff'};
                border-radius: 8px;
                font-size: 14px;
                font-weight: ${docWizardData[opt.id] === choice ? '600' : '400'};
                color: ${docWizardData[opt.id] === choice ? '#92400e' : '#374151'};
                cursor: pointer;
                transition: all 0.15s;
              " onmouseover="if('${docWizardData[opt.id]}' !== '${choice}') { this.style.borderColor='#d1d5db'; this.style.background='#f9fafb'; }" onmouseout="if('${docWizardData[opt.id]}' !== '${choice}') { this.style.borderColor='#e5e7eb'; this.style.background='#fff'; }">
                ${choice}
              </button>
            `).join('')}
          </div>
        </div>
      `).join('')}
    </div>
    
    <!-- Summary -->
    <div style="margin-top: 32px; padding: 16px; background: #f9fafb; border-radius: 10px; border: 1px solid #e5e7eb;">
      <div style="font-size: 12px; font-weight: 600; color: #6b7280; margin-bottom: 8px; text-transform: uppercase; letter-spacing: 0.5px;">Summary</div>
      <div style="font-size: 14px; color: #374151;">
        Creating a <strong>${docWizardData.templateName || 'document'}</strong> in <strong>${docWizardData.tone}</strong> tone for <strong>${docWizardData.audience}</strong>, approximately <strong>${docWizardData.length}</strong>.
      </div>
    </div>
  `;
};

// Step 4: Details Input (or Chat for Custom document)
window.renderDocWizardStep4 = function () {
  // Custom document: chat UI
  if (docWizardData.templateType === 'custom_chat') {
    const companyName = (docWizardData.details['business_name'] || currentCompany?.name || '').replace(/</g, '&lt;').replace(/"/g, '&quot;');
    const messages = (docWizardData.chatMessages || []).map(m => {
      const isThinking = m.content === '__THINKING__';
      const isUser = m.role === 'user';
      if (isThinking) {
        return `
        <div style="display: flex; justify-content: flex-start; margin-bottom: 12px;">
          <div style="max-width: 85%; padding: 12px 14px; border-radius: 12px; font-size: 14px; background: #f3f4f6; color: #6b7280; display: flex; align-items: center; gap: 8px;">
            <div style="width: 18px; height: 18px; border: 2px solid #d1d5db; border-top-color: #f59e0b; border-radius: 50%; animation: spin 0.8s linear infinite;"></div>
            <span>Thinking...</span>
          </div>
        </div>`;
      }
      const safeContent = (m.content || '').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\n/g, '<br>');
      return `
        <div style="display: flex; justify-content: ${isUser ? 'flex-end' : 'flex-start'}; margin-bottom: 12px;">
          <div style="max-width: 85%; padding: 12px 14px; border-radius: 12px; font-size: 14px; line-height: 1.5; ${isUser ? 'background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%); color: white;' : 'background: #f3f4f6; color: #111827;'}">
            ${safeContent}
          </div>
        </div>`;
    }).join('');
    return `
    <div style="display: flex; flex-direction: column; height: 100%; min-height: 320px;">
      <div style="margin-bottom: 12px; flex-shrink: 0;">
        <label style="font-size: 12px; font-weight: 600; color: #6b7280; margin-bottom: 4px; display: block;">Company name (used in document)</label>
        <input type="text" id="doc-wizard-chat-company" value="${companyName}" oninput="window.docWizardUpdateDetail('business_name', this.value)" placeholder="Your company name" style="width: 100%; padding: 8px 12px; border: 1px solid #e5e7eb; border-radius: 8px; font-size: 14px;" />
      </div>
      <div id="doc-wizard-chat-messages" style="flex: 1; overflow-y: auto; padding: 8px 0; margin-bottom: 12px; min-height: 200px;">
        ${messages}
      </div>
      <div style="display: flex; gap: 8px; flex-shrink: 0;">
        <input type="text" id="doc-wizard-chat-input" placeholder="Type your message... e.g. I need a job application but don't know where to start" style="flex: 1; padding: 12px 14px; border: 1px solid #e5e7eb; border-radius: 10px; font-size: 14px;" onkeydown="if(event.key==='Enter'){ event.preventDefault(); window.docWizardChatSend(); }" />
        <button type="button" onclick="window.docWizardChatSend()" id="doc-wizard-chat-send" style="padding: 12px 20px; background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%); color: white; border: none; border-radius: 10px; font-weight: 600; cursor: pointer; white-space: nowrap;">Send</button>
      </div>
    </div>`;
  }

  const fields = docWizardTemplateFields[docWizardData.templateType] || [];
  const hasExample = docWizardExamplePrompts[docWizardData.templateType];

  // Pre-fill business name from logged-in company (editable by user)
  if (fields.some(f => f.id === 'business_name') && !docWizardData.details['business_name'] && currentCompany && currentCompany.name) {
    docWizardData.details['business_name'] = currentCompany.name;
  }

  return `
    <div style="margin-bottom: 20px;">
      <h3 style="margin: 0 0 8px 0; font-size: 20px; font-weight: 600; color: #111827;">Document Details</h3>
      <p style="margin: 0; color: #6b7280; font-size: 14px;">Provide the information for your ${docWizardData.templateName || 'document'}.</p>
    </div>
    
    <!-- Power-up Buttons -->
    <div style="display: flex; gap: 10px; margin-bottom: 20px;">
      ${hasExample ? `
        <button onclick="window.docWizardShowExample()" style="padding: 8px 14px; background: #f0fdf4; border: 1px solid #86efac; border-radius: 6px; font-size: 13px; font-weight: 500; color: #166534; cursor: pointer; display: flex; align-items: center; gap: 6px; transition: all 0.2s;" onmouseover="this.style.background='#dcfce7'" onmouseout="this.style.background='#f0fdf4'">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
          Show Example
        </button>
      ` : ''}
      <button onclick="window.docWizardUploadExisting()" style="padding: 8px 14px; background: #faf5ff; border: 1px solid #d8b4fe; border-radius: 6px; font-size: 13px; font-weight: 500; color: #7c3aed; cursor: pointer; display: flex; align-items: center; gap: 6px; transition: all 0.2s;" onmouseover="this.style.background='#f3e8ff'" onmouseout="this.style.background='#faf5ff'">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
        Upload Existing Doc
      </button>
    </div>
    
    ${docWizardData.uploadedFileName ? `
      <div style="padding: 12px 14px; background: #faf5ff; border: 1px solid #d8b4fe; border-radius: 8px; margin-bottom: 20px; display: flex; align-items: center; justify-content: space-between;">
        <div style="display: flex; align-items: center; gap: 10px;">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#7c3aed" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline></svg>
          <span style="font-size: 13px; color: #6b21a8; font-weight: 500;">${docWizardData.uploadedFileName}</span>
        </div>
        <button onclick="window.docWizardRemoveUpload()" style="padding: 4px 8px; background: none; border: none; color: #9ca3af; cursor: pointer; font-size: 18px;" title="Remove">&times;</button>
      </div>
    ` : ''}
    
    <!-- Fields -->
    <div style="display: flex; flex-direction: column; gap: 16px;">
      ${fields.map(field => `
        <div>
          <label style="display: block; font-size: 13px; font-weight: 600; color: #374151; margin-bottom: 6px;">
            ${field.label}
            ${field.required ? '<span style="color: #ef4444;">*</span>' : ''}
          </label>
          ${field.type === 'textarea' ? `
            <textarea 
              oninput="window.docWizardUpdateDetail('${field.id}', this.value)" 
              placeholder="${field.placeholder || ''}"
              style="width: 100%; padding: 10px 12px; border: 1px solid #d1d5db; border-radius: 8px; font-size: 14px; font-family: inherit; resize: vertical; min-height: 80px; transition: border-color 0.2s;"
              onfocus="this.style.borderColor='#f59e0b'; this.style.outline='none'; this.style.boxShadow='0 0 0 3px rgba(245,158,11,0.1)'"
              onblur="this.style.borderColor='#d1d5db'; this.style.boxShadow='none'"
            >${docWizardData.details[field.id] || ''}</textarea>
          ` : `
            <input 
              type="text"
              oninput="window.docWizardUpdateDetail('${field.id}', this.value)"
              value="${(docWizardData.details[field.id] || '').replace(/"/g, '&quot;')}"
              placeholder="${field.placeholder || ''}"
              style="width: 100%; padding: 10px 12px; border: 1px solid #d1d5db; border-radius: 8px; font-size: 14px; transition: border-color 0.2s;"
              onfocus="this.style.borderColor='#f59e0b'; this.style.outline='none'; this.style.boxShadow='0 0 0 3px rgba(245,158,11,0.1)'"
              onblur="this.style.borderColor='#d1d5db'; this.style.boxShadow='none'"
            />
          `}
        </div>
      `).join('')}
    </div>
  `;
};

// Step 5: Preview Outline
window.renderDocWizardStep5 = function () {
  if (docWizardLoading) {
    return `
      <div style="text-align: center; padding: 60px 20px;">
        <div style="width: 48px; height: 48px; border: 3px solid #e5e7eb; border-top-color: #f59e0b; border-radius: 50%; animation: spin 1s linear infinite; margin: 0 auto 20px;"></div>
        <div style="font-size: 16px; font-weight: 500; color: #374151; margin-bottom: 8px;">Generating outline...</div>
        <div style="font-size: 14px; color: #6b7280;">This usually takes a few seconds</div>
      </div>
    `;
  }

  // Parse outline into bullet points
  const outlineLines = (docWizardData.generatedOutline || '').split('\n').filter(line => line.trim());

  return `
    <div style="margin-bottom: 24px;">
      <h3 style="margin: 0 0 8px 0; font-size: 20px; font-weight: 600; color: #111827;">Preview Outline</h3>
      <p style="margin: 0; color: #6b7280; font-size: 14px;">Review what will be included in your document.</p>
    </div>
    
    <!-- Outline Preview -->
    <div style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 12px; padding: 20px; margin-bottom: 24px;">
      <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 16px;">
        <div style="width: 32px; height: 32px; background: #fef3c7; border-radius: 8px; display: flex; align-items: center; justify-content: center;">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline></svg>
        </div>
        <div>
          <div style="font-weight: 600; color: #111827;">${docWizardData.templateName}</div>
          <div style="font-size: 12px; color: #6b7280;">${docWizardData.outputFormat === 'docx' ? 'Word Document' : 'PDF'} • ${docWizardData.length}</div>
        </div>
      </div>
      
      <div style="display: flex; flex-direction: column; gap: 8px;">
        ${outlineLines.map(line => {
    const text = line.replace(/^[-*•]\s*/, '').trim();
    return `
            <div style="display: flex; align-items: flex-start; gap: 10px; padding: 8px 0;">
              <div style="width: 20px; height: 20px; background: #d1fae5; border-radius: 50%; display: flex; align-items: center; justify-content: center; flex-shrink: 0; margin-top: 1px;">
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#059669" stroke-width="3"><polyline points="20 6 9 17 4 12"></polyline></svg>
              </div>
              <div style="font-size: 14px; color: #374151;">${text}</div>
            </div>
          `;
  }).join('')}
      </div>
    </div>
    
    <!-- Edit Details Button -->
    <div style="text-align: center;">
      <button onclick="window.docWizardPrevStep()" style="padding: 10px 20px; background: none; border: 1px solid #d1d5db; border-radius: 8px; font-size: 14px; color: #6b7280; cursor: pointer; transition: all 0.2s;" onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='none'">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="vertical-align: middle; margin-right: 6px;"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>
        Edit Details
      </button>
    </div>
  `;
};

// Step 6: Generate & Save
window.renderDocWizardStep6 = function () {
  if (docWizardLoading) {
    return `
      <div style="text-align: center; padding: 60px 20px;">
        <div style="width: 56px; height: 56px; border: 4px solid #e5e7eb; border-top-color: #10b981; border-radius: 50%; animation: spin 1s linear infinite; margin: 0 auto 20px;"></div>
        <div style="font-size: 18px; font-weight: 600; color: #374151; margin-bottom: 8px;">Creating your document...</div>
        <div style="font-size: 14px; color: #6b7280;">This may take 10-20 seconds</div>
      </div>
    `;
  }

  // Get accessible folders for the dropdown - use cached or empty, will load async
  const accessibleFolders = (window.docWizardFolders || vaultFolders || []).filter(f => !f.is_deleted);

  // Build folder hierarchy with indentation
  const buildFolderOptions = (folders, parentId = null, depth = 0) => {
    let options = '';
    const children = folders.filter(f => f.parent_id === parentId);
    for (const folder of children) {
      const indent = '─'.repeat(depth);
      options += `<option value="${folder.id}">${indent}${depth > 0 ? ' ' : ''}${(folder.name || '').replace(/</g, '&lt;')}</option>`;
      options += buildFolderOptions(folders, folder.id, depth + 1);
    }
    return options;
  };

  // Async load folders if not already loaded
  if (!window.docWizardFolders) {
    setTimeout(async () => {
      try {
        // Get company ID and user ID - try multiple sources
        const companyId = currentCompany?.id || window.currentCompanyId || localStorage.getItem('selectedCompanyId');
        const userId = currentUser?.id;
        console.log('Doc Wizard - Loading folders for company:', companyId, 'User ID:', userId);

        // Load folders and user's folder permissions in parallel
        const [foldersResult, permissionsResult] = await Promise.all([
          supabase
            .from('vault_folders')
            .select('*')
            .eq('company_id', companyId)
            .eq('is_deleted', false)
            .order('name'),
          supabase
            .from('vault_permissions')
            .select('item_id, permission_level')
            .eq('company_id', companyId)
            .eq('item_type', 'folder')
            .eq('user_id', userId)
        ]);

        if (foldersResult.error) {
          console.error('Supabase error loading wizard folders:', foldersResult.error);
        }
        if (permissionsResult.error) {
          console.error('Supabase error loading wizard permissions:', permissionsResult.error);
        }

        const allFolders = foldersResult.data || [];
        const userPermissions = permissionsResult.data || [];

        // Build permission map for quick lookup
        const permissionMap = {};
        userPermissions.forEach(p => {
          permissionMap[p.item_id] = p.permission_level;
        });

        // Filter folders: user can see folder if they created it OR have a permission record
        window.docWizardFolders = allFolders.filter(f => {
          const isOwner = f.created_by === userId;
          const hasPermission = permissionMap[f.id] !== undefined;
          return isOwner || hasPermission;
        });
        console.log('Doc Wizard - Loaded folders:', window.docWizardFolders.length);

        // Update the dropdown
        const select = document.getElementById('doc-wizard-save-folder');
        if (select && window.docWizardFolders.length > 0) {
          select.innerHTML = '<option value="">Root (My Files)</option>' + buildFolderOptions(window.docWizardFolders);
        }
      } catch (e) {
        console.error('Error loading folders for wizard:', e);
      }
    }, 100);
  }

  const folderOptions = buildFolderOptions(accessibleFolders);

  return `
    <div style="margin-bottom: 20px;">
      <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 16px;">
        <div style="width: 48px; height: 48px; background: #d1fae5; border-radius: 12px; display: flex; align-items: center; justify-content: center;">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#059669" stroke-width="2"><polyline points="20 6 9 17 4 12"></polyline></svg>
        </div>
        <div>
          <h3 style="margin: 0; font-size: 20px; font-weight: 600; color: #111827;">Document Ready!</h3>
          <p style="margin: 4px 0 0 0; color: #6b7280; font-size: 14px;">Your ${docWizardData.templateName} has been generated.</p>
        </div>
      </div>
    </div>
    
    <!-- Preview Content -->
    <div style="margin-bottom: 20px;">
      <div style="font-size: 13px; font-weight: 600; color: #374151; margin-bottom: 8px;">Preview</div>
      <div style="background: #fff; border: 1px solid #e5e7eb; border-radius: 10px; max-height: 250px; overflow-y: auto;">
        <textarea 
          id="doc-wizard-content-edit"
          oninput="window.docWizardUpdateContent(this.value)"
          style="width: 100%; min-height: 200px; padding: 16px; border: none; border-radius: 10px; font-size: 13px; font-family: 'Monaco', 'Menlo', monospace; line-height: 1.6; resize: none;"
        >${(docWizardData.generatedContent || '').replace(/</g, '&lt;').replace(/>/g, '&gt;')}</textarea>
      </div>
      <div style="font-size: 12px; color: #9ca3af; margin-top: 6px;">You can edit the content above before downloading.</div>
    </div>
    
    <!-- Download Buttons -->
    <div style="display: flex; gap: 12px; margin-bottom: 24px;">
      <button onclick="window.docWizardDownloadWord()" style="flex: 1; padding: 14px; background: ${docWizardData.outputFormat === 'docx' ? 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)' : '#fff'}; border: ${docWizardData.outputFormat === 'docx' ? 'none' : '1px solid #d1d5db'}; border-radius: 10px; font-weight: 600; color: ${docWizardData.outputFormat === 'docx' ? '#fff' : '#374151'}; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 8px; transition: all 0.2s;">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
        Download Word
      </button>
      <button onclick="window.docWizardDownloadPdf()" style="flex: 1; padding: 14px; background: ${docWizardData.outputFormat === 'pdf' ? 'linear-gradient(135deg, #dc2626 0%, #b91c1c 100%)' : '#fff'}; border: ${docWizardData.outputFormat === 'pdf' ? 'none' : '1px solid #d1d5db'}; border-radius: 10px; font-weight: 600; color: ${docWizardData.outputFormat === 'pdf' ? '#fff' : '#374151'}; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 8px; transition: all 0.2s;">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
        Download PDF
      </button>
    </div>
    
    <!-- Divider -->
    <div style="display: flex; align-items: center; gap: 16px; margin-bottom: 20px;">
      <div style="flex: 1; height: 1px; background: #e5e7eb;"></div>
      <div style="font-size: 12px; color: #9ca3af; text-transform: uppercase; letter-spacing: 1px;">Or save to vault</div>
      <div style="flex: 1; height: 1px; background: #e5e7eb;"></div>
    </div>
    
    <!-- Save to Vault -->
    <div style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 12px; padding: 16px;">
      <div style="margin-bottom: 14px;">
        <label style="display: block; font-size: 13px; font-weight: 600; color: #374151; margin-bottom: 6px;">Save to Folder</label>
        <select id="doc-wizard-save-folder" style="width: 100%; padding: 10px 12px; border: 1px solid #d1d5db; border-radius: 8px; font-size: 14px; background: #fff;">
          <option value="">Root (My Files)</option>
          ${folderOptions}
        </select>
      </div>
      
      <div style="margin-bottom: 16px;">
        <label style="display: block; font-size: 13px; font-weight: 600; color: #374151; margin-bottom: 6px;">Version Note</label>
        <input 
          type="text"
          value="${(docWizardData.versionNote || '').replace(/"/g, '&quot;')}"
          oninput="docWizardData.versionNote = this.value"
          placeholder="e.g., Initial draft"
          style="width: 100%; padding: 10px 12px; border: 1px solid #d1d5db; border-radius: 8px; font-size: 14px;"
        />
      </div>
      
      <button onclick="window.docWizardSaveToVault()" style="width: 100%; padding: 14px; background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%); border: none; border-radius: 10px; font-weight: 600; color: white; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 8px; transition: all 0.2s;" onmouseover="this.style.transform='translateY(-1px)'; this.style.boxShadow='0 4px 12px rgba(245,158,11,0.3)'" onmouseout="this.style.transform='translateY(0)'; this.style.boxShadow='none'">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path><polyline points="17 21 17 13 7 13 7 21"></polyline><polyline points="7 3 7 8 15 8"></polyline></svg>
        Save to Vault
      </button>
    </div>
    
    <!-- Edit Feedback -->
    <div style="margin-top: 20px; padding: 14px 16px; background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 10px; display: flex; align-items: flex-start; gap: 12px;">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2563eb" stroke-width="2" style="flex-shrink: 0; margin-top: 2px;"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
      <div style="font-size: 13px; color: #1e40af;">
        <strong>Want to edit this document further?</strong><br>
        Download the Word version for full editing capabilities in Microsoft Word or Google Docs.
      </div>
    </div>
  `;
};



// Open Contract Preview Modal
window.openContractPreview = function () {
  showContractPreview = true;
  renderPMTool();
};

// Close Contract Preview Modal
window.closeContractPreview = function () {
  showContractPreview = false;
  renderPMTool();
};

// Render Contract Preview Modal - shows how the contract will look before creating
function renderContractPreviewModal() {
  if (!showContractPreview) return '';

  // Calculate totals
  let subtotal = 0;
  let monthlyRecurring = 0;
  newContractData.lineItems.forEach(item => {
    const lineTotal = item.quantity * item.price;
    if (item.isRecurring) {
      monthlyRecurring += lineTotal;
    } else {
      subtotal += lineTotal;
    }
  });

  // Calculate taxable subtotal (only for taxable items)
  let taxableSubtotal = 0;
  newContractData.lineItems.forEach(item => {
    if (!item.isRecurring && item.isTaxable !== false) {
      taxableSubtotal += item.quantity * item.price;
    }
  });

  const discountAmount = newContractData.discountType === 'percent'
    ? (subtotal * (newContractData.discountValue || 0) / 100)
    : (newContractData.discountValue || 0);
  const afterDiscount = subtotal - discountAmount;
  const taxableAfterDiscount = Math.max(0, taxableSubtotal - discountAmount);
  const taxAmount = taxableAfterDiscount * (newContractData.taxRate || 0) / 100;
  const total = afterDiscount + taxAmount;

  // Get selected clauses
  const selectedClauseData = contractClauses.filter(c => newContractData.selectedClauses.includes(c.id));

  // Group clauses by category
  const clausesByCategory = {};
  selectedClauseData.forEach(clause => {
    const cat = clause.category || 'General';
    if (!clausesByCategory[cat]) clausesByCategory[cat] = [];
    clausesByCategory[cat].push(clause);
  });

  return `
    <div style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,0.7);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1003;
      padding: 1rem;
    " onclick="closeContractPreview()">
      <div style="
        background: white;
        border-radius: 1rem;
        width: 100%;
        max-width: 800px;
        max-height: 90vh;
        overflow-y: auto;
        box-shadow: 0 25px 50px rgba(0,0,0,0.3);
      " onclick="event.stopPropagation()">
        <!-- Header -->
        <div style="padding: 1rem 1.5rem; border-bottom: 1px solid #e2e8f0; display: flex; justify-content: space-between; align-items: center; position: sticky; top: 0; background: white; z-index: 1;">
          <div style="display: flex; align-items: center; gap: 0.75rem;">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="#3b82f6"><path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"/></svg>
            <h2 style="margin: 0; font-size: 1.125rem; font-weight: 600;">Contract Preview</h2>
          </div>
          <button onclick="closeContractPreview()" style="background: none; border: none; font-size: 1.5rem; cursor: pointer; color: #64748b; line-height: 1;">&times;</button>
        </div>
        
        <!-- Contract Preview Content -->
        <div style="background: #f8fafc; padding: 1.5rem;">
          <div style="background: white; border-radius: 0.5rem; box-shadow: 0 2px 8px rgba(0,0,0,0.08); overflow: hidden;">
            <!-- Contract Header -->
            <div style="background: linear-gradient(135deg, #1e293b 0%, #334155 100%); color: white; padding: 2rem; text-align: center;">
              <h1 style="margin: 0 0 0.5rem; font-size: 1.5rem; font-weight: 600;">${newContractData.contractName || 'Service Agreement'}</h1>
              <div style="font-size: 0.875rem; opacity: 0.8;">Contract</div>
            </div>
            
            <!-- Client Info -->
            <div style="padding: 1.5rem; border-bottom: 1px solid #e2e8f0;">
              <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1.5rem;">
                <div>
                  <div style="font-size: 0.75rem; color: #64748b; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 0.25rem;">Prepared For</div>
                  <div style="font-weight: 600; color: #1e293b;">${newContractData.clientName || 'Client Name'}</div>
                  <div style="color: #64748b; font-size: 0.875rem;">${newContractData.clientEmail || 'client@email.com'}</div>
                </div>
                <div>
                  <div style="font-size: 0.75rem; color: #64748b; text-transform: uppercase; letter-spacing: 0.05em; margin-bottom: 0.25rem;">Dates</div>
                  <div style="font-size: 0.875rem;"><strong>Created:</strong> ${formatDateLocal(new Date())}</div>
                  <div style="font-size: 0.875rem;"><strong>Effective:</strong> ${newContractData.effectiveDate ? formatDateLocal(newContractData.effectiveDate) : 'Upon signature'}</div>
                </div>
              </div>
            </div>
            
            ${newContractData.lineItems.length > 0 ? `
              <!-- Line Items -->
              <div style="padding: 1.5rem; border-bottom: 1px solid #e2e8f0;">
                <h3 style="margin: 0 0 1rem; font-size: 1rem; font-weight: 600; color: #1e293b; border-bottom: 2px solid #3b82f6; display: inline-block; padding-bottom: 0.25rem;">Services & Products</h3>
                <table style="width: 100%; border-collapse: collapse;">
                  <thead>
                    <tr style="background: #f8fafc;">
                      <th style="padding: 0.75rem; text-align: left; font-size: 0.75rem; text-transform: uppercase; color: #64748b; border-bottom: 1px solid #e2e8f0;">Item</th>
                      <th style="padding: 0.75rem; text-align: center; font-size: 0.75rem; text-transform: uppercase; color: #64748b; border-bottom: 1px solid #e2e8f0;">Qty</th>
                      <th style="padding: 0.75rem; text-align: right; font-size: 0.75rem; text-transform: uppercase; color: #64748b; border-bottom: 1px solid #e2e8f0;">Price</th>
                      <th style="padding: 0.75rem; text-align: right; font-size: 0.75rem; text-transform: uppercase; color: #64748b; border-bottom: 1px solid #e2e8f0;">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${newContractData.lineItems.map(item => `
                      <tr>
                        <td style="padding: 0.75rem; border-bottom: 1px solid #e2e8f0;">
                          <div style="font-weight: 500;">${item.name}</div>
                          ${item.description ? `<div style="font-size: 0.75rem; color: #64748b;">${item.description}</div>` : ''}
                          ${item.isRecurring ? `<span style="background: #dbeafe; color: #2563eb; padding: 0.125rem 0.5rem; border-radius: 0.25rem; font-size: 0.625rem; text-transform: uppercase;">${item.recurringInterval || 'monthly'}</span>` : ''}
                        </td>
                        <td style="padding: 0.75rem; text-align: center; border-bottom: 1px solid #e2e8f0;">${item.quantity}</td>
                        <td style="padding: 0.75rem; text-align: right; border-bottom: 1px solid #e2e8f0;">$${parseFloat(item.price || 0).toFixed(2)}</td>
                        <td style="padding: 0.75rem; text-align: right; border-bottom: 1px solid #e2e8f0; font-weight: 500;">$${(item.quantity * item.price).toFixed(2)}</td>
                      </tr>
                    `).join('')}
                  </tbody>
                </table>
              </div>
            ` : ''}
            
            <!-- Totals -->
            <div style="padding: 1.5rem; border-bottom: 1px solid #e2e8f0;">
              <div style="background: #f8fafc; padding: 1.25rem; border-radius: 0.5rem; max-width: 300px; margin-left: auto;">
                <div style="display: flex; justify-content: space-between; margin-bottom: 0.5rem;">
                  <span style="color: #64748b;">Subtotal</span>
                  <span>$${subtotal.toFixed(2)}</span>
                </div>
                ${discountAmount > 0 ? `
                  <div style="display: flex; justify-content: space-between; margin-bottom: 0.5rem; color: #10b981;">
                    <span>Discount</span>
                    <span>-$${discountAmount.toFixed(2)}</span>
                  </div>
                ` : ''}
                ${taxAmount > 0 ? `
                  <div style="display: flex; justify-content: space-between; margin-bottom: 0.5rem;">
                    <span style="color: #64748b;">Tax (${newContractData.taxRate}%)</span>
                    <span>$${taxAmount.toFixed(2)}</span>
                  </div>
                ` : ''}
                <div style="display: flex; justify-content: space-between; font-size: 1.125rem; font-weight: 700; border-top: 2px solid #1e293b; padding-top: 0.75rem; margin-top: 0.5rem;">
                  <span>Total</span>
                  <span>$${total.toFixed(2)}</span>
                </div>
                ${monthlyRecurring > 0 ? `
                  <div style="display: flex; justify-content: space-between; margin-top: 0.5rem; color: #64748b; font-size: 0.875rem;">
                    <span>Monthly Recurring</span>
                    <span>$${monthlyRecurring.toFixed(2)}/mo</span>
                  </div>
                ` : ''}
              </div>
            </div>
            
            ${selectedClauseData.length > 0 ? `
              <!-- Terms & Conditions -->
              <div style="padding: 1.5rem; border-bottom: 1px solid #e2e8f0;">
                <h3 style="margin: 0 0 1rem; font-size: 1rem; font-weight: 600; color: #1e293b; border-bottom: 2px solid #3b82f6; display: inline-block; padding-bottom: 0.25rem;">Terms & Conditions</h3>
                ${Object.entries(clausesByCategory).map(([category, clauses]) => `
                  ${clauses.map(clause => {
    // Replace [Company] and [Client] placeholders
    const clientCompanyName = newContractData.clientCompanyName || newContractData.clientName || 'Client';
    const clientFullName = newContractData.clientName || 'Client';
    let processedBody = clause.body.replace(/\[company\]/gi, clientCompanyName);
    processedBody = processedBody.replace(/\[client\]/gi, clientFullName);
    return `
                    <div style="margin-bottom: 1rem; padding: 1rem; background: #f8fafc; border-radius: 0.5rem; border-left: 4px solid #3b82f6;">
                      <div style="font-weight: 600; margin-bottom: 0.5rem;">${clause.title}</div>
                      <div style="font-size: 0.875rem; color: #475569; line-height: 1.6; white-space: pre-wrap;">${processedBody}</div>
                    </div>
                  `}).join('')}
                `).join('')}
              </div>
            ` : ''}
            
            ${newContractData.customNotes ? `
              <div style="padding: 1.5rem; border-bottom: 1px solid #e2e8f0;">
                <div style="padding: 1rem; background: #fef3c7; border-radius: 0.5rem; border-left: 4px solid #f59e0b;">
                  <div style="font-weight: 600; margin-bottom: 0.5rem; color: #92400e;">Additional Notes</div>
                  <div style="font-size: 0.875rem; color: #78350f; line-height: 1.6; white-space: pre-wrap;">${newContractData.customNotes}</div>
                </div>
              </div>
            ` : ''}
            
            <!-- Signature Section Preview -->
            <div style="padding: 1.5rem;">
              <h3 style="margin: 0 0 1rem; font-size: 1rem; font-weight: 600; color: #1e293b; border-bottom: 2px solid #3b82f6; display: inline-block; padding-bottom: 0.25rem;">Signatures</h3>
              
              <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 1rem; margin-bottom: 1.5rem;">
                <div style="text-align: center; padding: 1rem; border: 2px dashed #d1d5db; border-radius: 0.5rem;">
                  <div style="font-size: 0.75rem; color: #64748b; text-transform: uppercase; margin-bottom: 0.5rem;">Scope Acceptance</div>
                  <div style="font-family: 'Brush Script MT', cursive; font-size: 1.25rem; color: #9ca3af;">Initials</div>
                </div>
                <div style="text-align: center; padding: 1rem; border: 2px dashed #d1d5db; border-radius: 0.5rem;">
                  <div style="font-size: 0.75rem; color: #64748b; text-transform: uppercase; margin-bottom: 0.5rem;">Payment Terms</div>
                  <div style="font-family: 'Brush Script MT', cursive; font-size: 1.25rem; color: #9ca3af;">Initials</div>
                </div>
                <div style="text-align: center; padding: 1rem; border: 2px dashed #d1d5db; border-radius: 0.5rem;">
                  <div style="font-size: 0.75rem; color: #64748b; text-transform: uppercase; margin-bottom: 0.5rem;">Cancellation Policy</div>
                  <div style="font-family: 'Brush Script MT', cursive; font-size: 1.25rem; color: #9ca3af;">Initials</div>
                </div>
              </div>
              
              <!-- Two Signature Blocks Side by Side -->
              <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 1.5rem;">
                <!-- Company Representative Signature (Auto-filled) -->
                <div style="padding: 1.5rem; background: #f1f5f9; border-radius: 0.5rem; border: 1px solid #e2e8f0;">
                  <h4 style="margin: 0 0 1rem; font-size: 0.75rem; font-weight: 700; color: #1e293b; text-transform: uppercase; letter-spacing: 0.05em;">
                    ${currentCompany?.name || 'Company'}
                  </h4>
                  <div style="margin-bottom: 1rem;">
                    <div style="font-size: 0.75rem; color: #64748b; margin-bottom: 0.25rem;">Printed Name</div>
                    <div style="font-weight: 500; color: #1e293b;">${`${currentProfile?.first_name || ''} ${currentProfile?.last_name || ''}`.trim() || 'Company Representative'}</div>
                  </div>
                  <div style="margin-bottom: 1rem;">
                    <div style="font-size: 0.75rem; color: #64748b; margin-bottom: 0.25rem;">Title</div>
                    <div style="font-weight: 500; color: #1e293b;">${currentProfile?.company_role || 'Representative'}</div>
                  </div>
                  <div style="margin-bottom: 1rem;">
                    <div style="font-size: 0.75rem; color: #64748b; margin-bottom: 0.25rem;">Signature</div>
                    <div style="font-family: 'Brush Script MT', 'Segoe Script', cursive; font-size: 1.5rem; color: #1e293b; border-bottom: 2px solid #1e293b; padding-bottom: 0.25rem; min-height: 36px;">
                      ${`${currentProfile?.first_name || ''} ${currentProfile?.last_name || ''}`.trim() || 'Signature'}
                    </div>
                  </div>
                  <div>
                    <div style="font-size: 0.75rem; color: #64748b; margin-bottom: 0.25rem;">Date</div>
                    <div style="font-weight: 500; color: #1e293b;">${formatDateLocal(new Date())}</div>
                  </div>
                </div>
                
                <!-- Client Signature (To be filled) -->
                <div style="padding: 1.5rem; background: #fef3c7; border-radius: 0.5rem; border: 1px solid #fcd34d;">
                  <h4 style="margin: 0 0 1rem; font-size: 0.75rem; font-weight: 700; color: #1e293b; text-transform: uppercase; letter-spacing: 0.05em;">
                    ${newContractData.clientCompanyName || newContractData.clientName || 'Client'}
                  </h4>
                  <div style="margin-bottom: 1rem;">
                    <div style="font-size: 0.75rem; color: #64748b; margin-bottom: 0.25rem;">Printed Name</div>
                    <div style="font-weight: 500; color: #9ca3af; border-bottom: 1px dashed #d1d5db; padding-bottom: 0.25rem; min-height: 24px;">
                      ${newContractData.clientName || '________________________'}
                    </div>
                  </div>
                  <div style="margin-bottom: 1rem;">
                    <div style="font-size: 0.75rem; color: #64748b; margin-bottom: 0.25rem;">Signature</div>
                    <div style="font-family: 'Brush Script MT', 'Segoe Script', cursive; font-size: 1.5rem; color: #9ca3af; border-bottom: 2px solid #d1d5db; padding-bottom: 0.25rem; min-height: 36px;">
                    </div>
                  </div>
                  <div>
                    <div style="font-size: 0.75rem; color: #64748b; margin-bottom: 0.25rem;">Date</div>
                    <div style="font-weight: 500; color: #9ca3af;">________________________</div>
                  </div>
                  <div style="margin-top: 1rem; padding: 0.75rem; background: rgba(245, 158, 11, 0.1); border-radius: 0.375rem; text-align: center;">
                    <span style="font-size: 0.75rem; color: #92400e;">⏳ Awaiting client signature</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Footer -->
        <div style="padding: 1rem 1.5rem; border-top: 1px solid #e2e8f0; display: flex; justify-content: flex-end; position: sticky; bottom: 0; background: white;">
          <button onclick="closeContractPreview()" style="
            background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
            color: white;
            border: none;
            padding: 0.75rem 1.5rem;
            border-radius: 0.5rem;
            cursor: pointer;
            font-weight: 500;
          ">Close Preview</button>
        </div>
      </div>
    </div>
  `;
}

